import {
  getKClass3t8tygqu4lcxf as getKClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  LazyThreadSafetyMode_PUBLICATION_getInstance20ynwq7b0awd8 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString_0,
  emptySetcxexqki71qfa as emptySet,
  setOf1u3mizs95ngxo as setOf,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  ArrayList3it5z8td81qkl as ArrayList,
  toSet2orjxp16sotqu as toSet,
  plus1ogy4liedzq5j as plus,
  getValue48kllevslyh6 as getValue,
  setOf45ia9pnfhe90 as setOf_0,
  singleo93pzdgfc557 as single,
  to2cs3ny02qtbcb as to,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  firstOrNull1982767dljvdy as firstOrNull,
  listOfvhqybd2zx248 as listOf,
  mapOf1xd03cq9cnmy8 as mapOf,
  linkedSetOfc26mcux8rklw as linkedSetOf,
  plus18eogev54fmsa as plus_0,
  plus20p0vtfmu0596 as plus_1,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  emptyList1g2z5xcrvp2zy as emptyList,
  emptyMapr06gerzljqtm as emptyMap,
  listOf1jh22dvmctj1r as listOf_0,
  plus310ted5e4i90h as plus_2,
  toMapcf6xfku344cz as toMap,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  toList3jhuyej2anx2q as toList,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  drop3na99dw9feawf as drop,
  addAll1k27qatfgp3k5 as addAll,
  eachCount1imd75z0wkpbt as eachCount,
  Enum3alwj03lh1n41 as Enum,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  CancellationException3b36o9qz53rgr as CancellationException,
  constructCallableReference23y65rf941mch as constructCallableReference,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  singleOrNullrknfaxokm1sl as singleOrNull,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  enumEntries20mr21zbe3az4 as enumEntries,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  mutableSetOf3lxrr4fe5z3v8 as mutableSetOf,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  plus2lr02ok6jhhxu as plus_3,
  minus1f3bieyodk5vw as minus,
  flatten2dh4kibw1u0qq as flatten,
  contains2gm06f5aa19ov as contains,
  KtMap140uvy3s5zad8 as KtMap,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  indexOf382xk9sq5x0r4 as indexOf,
  sortedWith2csnbbb21k0lg as sortedWith,
  last1vo29oleiqj36 as last,
  first58ocm7j58k3q as first,
  dropLast1vpiyky649o34 as dropLast,
  minus27abgkurcn6u0 as minus_0,
  plus2m1vv33moko5t as plus_4,
  minus165a8u1e0x1lu as minus_1,
  Paire9pteg33gng7 as Pair,
  toMap1vec9topfei08 as toMap_0,
  println2shhhgwwt4c61 as println,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  toCollection2m9l1tsz2ecpm as toCollection,
  sum1ib1hqt64m6qf as sum,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  Long2qws0ah9gnpki as Long,
  equalsLong28bsrfhwvd686 as equalsLong,
  Companion_getInstance10dt578q09swj as Companion_getInstance,
  subtract16cg4lfi29fq9 as subtract,
  fromInt1lka3ktyu79a4 as fromInt,
  divide3tol6kxdi8xn6 as divide,
  modulo3mmbfwxzpcw3a as modulo,
  add85si75olwt6n as add,
  compare2uud5j30pw5xc as compare,
  joinToString1cxrrlmo0chqs as joinToString,
  mapOf2zpbbmyqk8xpf as mapOf_0,
  toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull,
  HashSet2dzve9y63nf0v as HashSet,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  toMutableList20rdgwi7d3cwi as toMutableList,
  removeLast3759euu1xvfa3 as removeLast,
  getOrNull1go7ef9ldk0df as getOrNull,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  count2ctzg572d5xrz as count,
  singleOrNull21olsob387p54 as singleOrNull_0,
  single3ds7xj9roxi5z as single_0,
  asList2ho2pewtsfvv as asList,
  Regexxgw0gjiagf4z as Regex,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ObjectSerializer2kjkucmygguwd as ObjectSerializer,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  BooleanSerializer_getInstance3sa31xxwvx0ks as BooleanSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  IntSerializer_getInstance3hkg1llvt1c0z as IntSerializer_getInstance,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  get_nullable197rfua9r7fsz as get_nullable,
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
  SerializableWithd2dap36updxd as SerializableWith,
  InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  PolymorphicSerializer3p3fzpdobi8hh as PolymorphicSerializer,
  StringSerializer_getInstancerxlnwnlbnwri as StringSerializer_getInstance,
  throwArrayMissingFieldExceptionbk1mj238w44a as throwArrayMissingFieldException,
  LongSerializer_getInstance1q1voa3zes72d as LongSerializer_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  NonCancellable_getInstance245ec57g3sl0k as NonCancellable_getInstance,
  withContextqz5k6d9p9xx5 as withContext,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  CoroutineStart_LAZY_getInstanceyyljs516jwiz as CoroutineStart_LAZY_getInstance,
  launch1c91vkjzdi9sd as launch,
  cancel$default2xpiixsrbjcxw as cancel$default,
  invokeOnCompletion$default3ce018mbgf2ad as invokeOnCompletion$default,
  Deferred6wjx2us769ee as Deferred,
  CompletableDeferred10t3vc1asgghx as CompletableDeferred_0,
  coroutineScope39ukucf23mhsm as coroutineScope,
} from './kotlinx-coroutines-core.mjs';
import { Jsonsmkyu9xjl7fv as Json } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  a2g() {
    var tmp = getKClass(ActionStatement);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AbruptAssembleStatement), getKClass(AbruptDecayActionStatement), getKClass(AbyssalBeastStatement), getKClass(AbyssalHellFireStatement), getKClass(AbyssalPullStatement), getKClass(ActivateSnareStatement), getKClass(ActivateSummonsStatement), getKClass(ActivateTrapStatement), getKClass(AllureKillSoulBonusStatement), getKClass(AllureStatement), getKClass(AmassTransformationStatement), getKClass(BindingHuntReactionStatement), getKClass(BleatCardTriggerStatement), getKClass(DraugBerserkReactionStatement), getKClass(DreamerMaskReactionStatement), getKClass(EsmeriasStrandReactionStatement), getKClass(FlareReactionStatement), getKClass(IntuitionReactionStatement), getKClass(MistShroudReactionStatement), getKClass(PlayCardAsReactionStatement), getKClass(SmokebombReactionStatement), getKClass(SuddenMistReactionStatement), getKClass(WorldShiftReactionStatement), getKClass(ArrivalOfTheTitanHuntersTeamBonusMoveStatement), getKClass(AshfallAttackOrSummonFromRuinStatement), getKClass(AshfallEachBeastAndSummonMoves), getKClass(AttackBySheepStatement), getKClass(AttackOrSummonFromRuinStatement), getKClass(AttackStatement), getKClass(BeastlyTongueStatement), getKClass(BeholdStatement), getKClass(BeyondTheVeilPreventYeltrDamageStatement), getKClass(BindingHuntStatement), getKClass(BlackStarStatement), getKClass(BloodHuntStatement), getKClass(BloodTrackStatement), getKClass(BoltAndRecallStatement), getKClass(BramWardBarrierStatement), getKClass(BroodswellStatement), getKClass(BurstStatement), getKClass(CannotBePlayedStatement), getKClass(ChainGrapnelStatement), getKClass(ChargeUpgradeStatement), getKClass(ChiefsCommandStatement), getKClass(MoveAllSettlersAndHuntersByVarja), getKClass(ChooseAndPlayOneCard), getKClass(ChooseMesmeriseTargetStatement), getKClass(ClaimRuinStatement), getKClass(CommandCardStatement), getKClass(ChooseOneOfStatement), getKClass(OptionalStatement), getKClass(SummonSignStatement), getKClass(InAnyOrderStatement), getKClass(ThenActionStatement), getKClass(CopyCardStatement), getKClass(DealDamageToSummonsStatement), getKClass(DeceiveStatement), getKClass(DefenderWithChoiceAction), getKClass(DevotionStatement), getKClass(DiscardCardsStatement), getKClass(DiscardHunterItemFromArsenalStatement), getKClass(DiscardPlacedTrapStatement), getKClass(DischargeStatement), getKClass(DismemberStatement), getKClass(DisplaceTransformLocationsStatement), getKClass(EachBeastAndSummonMoves), getKClass(EludeStatement), getKClass(EmptyStatement), getKClass(EnsnareStatement), getKClass(EruptionEffectStatement), getKClass(ExtractStatement), getKClass(FlameRapierStatement), getKClass(FlourishStatement), getKClass(FylgjaFlightStatement), getKClass(GainAncientPowerStatement), getKClass(GainBeastlyTalentStatement), getKClass(GainDraugCorruptionStatement), getKClass(GainGrudgeStatement), getKClass(GainRandomUnusedDraftActionCardStatement), getKClass(GlimpsBeastsStatement), getKClass(GlipsHuntersStatement), getKClass(GrapnelStatement), getKClass(GreatHowlStatement), getKClass(HatchEggStatement), getKClass(HauntStatement), getKClass(HazeStatement), getKClass(HealNearHunterStatement), getKClass(HealNearbyHuntersAndSettlersStatement), getKClass(HerdStatement), getKClass(HeroicSpeechStatement), getKClass(IncinerateHoardStatement), getKClass(IncinerateStatement), getKClass(InfusionUpgradeStatement), getKClass(LureStatement), getKClass(MountStatement), getKClass(MoveAnimalStatement), getKClass(MoveEverySummonStatement), getKClass(MoveWithAnimalStatement), getKClass(BeastMovesDependingOnHuntersStatement), getKClass(BeastMovesDependingOnSummonsNumberStatement), getKClass(BeastMovesSameZoneStatement), getKClass(FixedDirectionBeastMovementStatement), getKClass(LeapStatement), getKClass(RaagaSlitherStatement), getKClass(SimpleBeastMovementStatement), getKClass(UpriseUpgradedStatement), getKClass(VoidStatement), getKClass(MovementUptoFixedStepsStatement), getKClass(OverloadedFlameRapierMovementStatement), getKClass(RunFromFireStatement), getKClass(TrackStatement), getKClass(WarhogsTuskStatement), getKClass(RelocationInRangeStatement), getKClass(OverloadedShatterStatement), getKClass(OvipunctureStatement), getKClass(AvariceCardHuntersStatement), getKClass(GainHunterItemStatement), getKClass(MoveSeveralHuntersStatement), getKClass(RecoveryTestForEachHunterStatement), getKClass(RetrieveDiscardedAbilitiesStatement), getKClass(PlaceBarrierInSameZoneStatement), getKClass(PlaceBarrierOnLocationsStatement), getKClass(PlaceFireTokenOnNearbyStatement), getKClass(PlaceFireTokensStatement), getKClass(PlaceHatchlingAfterEggStatement), getKClass(PlaceLivingWebNearbyStatement), getKClass(PlaceNewSummonNearbyStatement), getKClass(PlaceNewSummonOnLocationsStatement), getKClass(PlaceNewSummonStatement), getKClass(PlaceOutpostStatement), getKClass(PlaceSnareStatement), getKClass(PlaceUrgullEggOnOwnLocationStatement), getKClass(PlayAshRuinStatement), getKClass(PrimalInstinctsStatement), getKClass(PushStatement), getKClass(RaagaHydraStatement), getKClass(RamAnotherTargetStatement), getKClass(ReapStatement), getKClass(ReceiveSelfDamageStatement), getKClass(RecoveryTestStatement), getKClass(RedirectDamageToDreamerStatement), getKClass(RelocateOneHunterToAnother), getKClass(RelocateToBansheeAndRevealStatement), getKClass(RelocationToSettlementStatement), getKClass(RelocationToWatchtowerStatement), getKClass(ResonanceChooseStatement), getKClass(ResourcefulnessUpgradeStatement), getKClass(ResurrectionStatement), getKClass(RetrieveDiscardedAbilityStatement), getKClass(RetrieveDiscardedDraftActionCardStatement), getKClass(RetrieveUnusedCardStatement), getKClass(RevealLastMovementsStatement), getKClass(RevealToMoveStatement), getKClass(RevengeOfTheSheepStatement), getKClass(RhagnerAdjustHoardStatement), getKClass(RiseHoardStatement), getKClass(RiseStatement), getKClass(SacrificeToPlayDoubleDarkStatement), getKClass(ScorchedEarthHoardStatement), getKClass(ScorchedEarthStatement), getKClass(ScoutStatement), getKClass(SearchForBeastStatement), getKClass(SetTrapStatement), getKClass(ShipwreckSettlerMovementStatement), getKClass(SigridAttackAllNearbyLocationsStatement), getKClass(SigridCreatureLungeStatement), getKClass(SigridPactReversalStatement), getKClass(SigridSearchAllNearbyLocationsStatement), getKClass(SoulReapStatement), getKClass(SoulStealStatement), getKClass(StealGrudgeFromNearbyHunterStatement), getKClass(StrideHuntersStatement), getKClass(SuddenShockStatement), getKClass(SummonAdmirerStatement), getKClass(SummonCreatureStatement), getKClass(SummonFylgjaStatement), getKClass(SummonLindwyrmHoardStatement), getKClass(SummonLindwyrmStatement), getKClass(SummonMovesStatement), getKClass(SummonYeltrStatement), getKClass(SwarmAttackStatement), getKClass(ToothAndSeverStatement), getKClass(TransformAllNearbyStatement), getKClass(TransformLocationsStatement), getKClass(TrapmasterStatement), getKClass(UnnaturalResolveStatement), getKClass(UpgradeStatement), getKClass(VanishStatement), getKClass(VoidCallStatement), getKClass(WardStatement)];
    var tmp_1 = $serializer_getInstance_107();
    var tmp_2 = AbruptDecayActionStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_3 = ObjectSerializer.l1c('AbruptDecayActionStatement', tmp_2, tmp$ret$3);
    var tmp_4 = AbyssalBeastStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_5 = ObjectSerializer.l1c('AbyssalBeastStatement', tmp_4, tmp$ret$6);
    var tmp_6 = $serializer_getInstance_382();
    var tmp_7 = $serializer_getInstance_68();
    var tmp_8 = $serializer_getInstance_363();
    var tmp_9 = $serializer_getInstance_12();
    var tmp_10 = $serializer_getInstance_13();
    var tmp_11 = $serializer_getInstance_421();
    var tmp_12 = $serializer_getInstance_422();
    var tmp_13 = $serializer_getInstance_324();
    var tmp_14 = $serializer_getInstance_111();
    var tmp_15 = $serializer_getInstance_404();
    var tmp_16 = $serializer_getInstance_128();
    var tmp_17 = $serializer_getInstance_14();
    var tmp_18 = $serializer_getInstance_15();
    var tmp_19 = $serializer_getInstance_16();
    var tmp_20 = $serializer_getInstance_17();
    var tmp_21 = $serializer_getInstance_364();
    var tmp_22 = $serializer_getInstance_18();
    var tmp_23 = $serializer_getInstance_19();
    var tmp_24 = $serializer_getInstance_20();
    var tmp_25 = $serializer_getInstance_21();
    var tmp_26 = $serializer_getInstance_72();
    var tmp_27 = $serializer_getInstance_76();
    var tmp_28 = $serializer_getInstance_77();
    var tmp_29 = $serializer_getInstance_356();
    var tmp_30 = $serializer_getInstance_411();
    var tmp_31 = $serializer_getInstance_5();
    var tmp_32 = $serializer_getInstance_105();
    var tmp_33 = $serializer_getInstance_423();
    var tmp_34 = $serializer_getInstance_346();
    var tmp_35 = $serializer_getInstance_109();
    var tmp_36 = BlackStarStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_37 = ObjectSerializer.l1c('BlackStarStatement', tmp_36, tmp$ret$9);
    var tmp_38 = $serializer_getInstance_429();
    var tmp_39 = $serializer_getInstance_430();
    var tmp_40 = $serializer_getInstance_347();
    var tmp_41 = $serializer_getInstance_112();
    var tmp_42 = $serializer_getInstance_414();
    var tmp_43 = $serializer_getInstance_104();
    var tmp_44 = CannotBePlayedStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_45 = ObjectSerializer.l1c('CannotBePlayedStatement', tmp_44, tmp$ret$12);
    var tmp_46 = $serializer_getInstance_22();
    var tmp_47 = $serializer_getInstance_23();
    var tmp_48 = ChiefsCommandStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_49 = ObjectSerializer.l1c('ChiefsCommandStatement', tmp_48, tmp$ret$15);
    var tmp_50 = MoveAllSettlersAndHuntersByVarja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_51 = ObjectSerializer.l1c('MoveAllSettlersAndHuntersByVarja', tmp_50, tmp$ret$18);
    var tmp_52 = $serializer_getInstance_24();
    var tmp_53 = ChooseMesmeriseTargetStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_54 = ObjectSerializer.l1c('ChooseMesmeriseTargetStatement', tmp_53, tmp$ret$21);
    var tmp_55 = $serializer_getInstance_25();
    var tmp_56 = $serializer_getInstance_433();
    var tmp_57 = $serializer_getInstance_6();
    var tmp_58 = $serializer_getInstance_26();
    var tmp_59 = $serializer_getInstance_27();
    var tmp_60 = $serializer_getInstance();
    var tmp_61 = $serializer_getInstance_2();
    var tmp_62 = $serializer_getInstance_28();
    var tmp_63 = $serializer_getInstance_29();
    var tmp_64 = $serializer_getInstance_138();
    var tmp_65 = $serializer_getInstance_322();
    var tmp_66 = $serializer_getInstance_144();
    var tmp_67 = $serializer_getInstance_30();
    var tmp_68 = $serializer_getInstance_365();
    var tmp_69 = DiscardPlacedTrapStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_70 = ObjectSerializer.l1c('DiscardPlacedTrapStatement', tmp_69, tmp$ret$24);
    var tmp_71 = $serializer_getInstance_405();
    var tmp_72 = $serializer_getInstance_366();
    var tmp_73 = $serializer_getInstance_31();
    var tmp_74 = $serializer_getInstance_412();
    var tmp_75 = $serializer_getInstance_424();
    var tmp_76 = EmptyStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_77 = ObjectSerializer.l1c('EmptyStatement', tmp_76, tmp$ret$27);
    var tmp_78 = $serializer_getInstance_32();
    var tmp_79 = EruptionEffectStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_80 = ObjectSerializer.l1c('EruptionEffectStatement', tmp_79, tmp$ret$30);
    var tmp_81 = ExtractStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_82 = ObjectSerializer.l1c('ExtractStatement', tmp_81, tmp$ret$33);
    var tmp_83 = $serializer_getInstance_142();
    var tmp_84 = $serializer_getInstance_33();
    var tmp_85 = $serializer_getInstance_134();
    var tmp_86 = $serializer_getInstance_34();
    var tmp_87 = $serializer_getInstance_35();
    var tmp_88 = $serializer_getInstance_129();
    var tmp_89 = $serializer_getInstance_36();
    var tmp_90 = $serializer_getInstance_37();
    var tmp_91 = $serializer_getInstance_38();
    var tmp_92 = $serializer_getInstance_39();
    var tmp_93 = $serializer_getInstance_7();
    var tmp_94 = GreatHowlStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_95 = ObjectSerializer.l1c('GreatHowlStatement', tmp_94, tmp$ret$36);
    var tmp_96 = $serializer_getInstance_415();
    var tmp_97 = $serializer_getInstance_137();
    var tmp_98 = $serializer_getInstance_367();
    var tmp_99 = $serializer_getInstance_40();
    var tmp_100 = $serializer_getInstance_41();
    var tmp_101 = $serializer_getInstance_357();
    var tmp_102 = HeroicSpeechStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_103 = ObjectSerializer.l1c('HeroicSpeechStatement', tmp_102, tmp$ret$39);
    var tmp_104 = $serializer_getInstance_383();
    var tmp_105 = $serializer_getInstance_384();
    var tmp_106 = InfusionUpgradeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_107 = ObjectSerializer.l1c('InfusionUpgradeStatement', tmp_106, tmp$ret$42);
    var tmp_108 = $serializer_getInstance_42();
    var tmp_109 = $serializer_getInstance_358();
    var tmp_110 = $serializer_getInstance_43();
    var tmp_111 = $serializer_getInstance_11();
    var tmp_112 = $serializer_getInstance_359();
    var tmp_113 = $serializer_getInstance_44();
    var tmp_114 = $serializer_getInstance_45();
    var tmp_115 = $serializer_getInstance_46();
    var tmp_116 = $serializer_getInstance_47();
    var tmp_117 = $serializer_getInstance_106();
    var tmp_118 = $serializer_getInstance_372();
    var tmp_119 = $serializer_getInstance_4();
    var tmp_120 = $serializer_getInstance_146();
    var tmp_121 = $serializer_getInstance_69();
    var tmp_122 = $serializer_getInstance_0();
    var tmp_123 = $serializer_getInstance_143();
    var tmp_124 = $serializer_getInstance_385();
    var tmp_125 = $serializer_getInstance_48();
    var tmp_126 = $serializer_getInstance_49();
    var tmp_127 = $serializer_getInstance_50();
    var tmp_128 = $serializer_getInstance_51();
    var tmp_129 = $serializer_getInstance_416();
    var tmp_130 = $serializer_getInstance_52();
    var tmp_131 = $serializer_getInstance_1();
    var tmp_132 = $serializer_getInstance_10();
    var tmp_133 = $serializer_getInstance_375();
    var tmp_134 = $serializer_getInstance_53();
    var tmp_135 = $serializer_getInstance_113();
    var tmp_136 = $serializer_getInstance_114();
    var tmp_137 = $serializer_getInstance_386();
    var tmp_138 = $serializer_getInstance_387();
    var tmp_139 = $serializer_getInstance_417();
    var tmp_140 = $serializer_getInstance_418();
    var tmp_141 = $serializer_getInstance_54();
    var tmp_142 = $serializer_getInstance_55();
    var tmp_143 = $serializer_getInstance_56();
    var tmp_144 = $serializer_getInstance_57();
    var tmp_145 = $serializer_getInstance_368();
    var tmp_146 = $serializer_getInstance_419();
    var tmp_147 = $serializer_getInstance_73();
    var tmp_148 = PrimalInstinctsStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_149 = ObjectSerializer.l1c('PrimalInstinctsStatement', tmp_148, tmp$ret$45);
    var tmp_150 = $serializer_getInstance_325();
    var tmp_151 = $serializer_getInstance_373();
    var tmp_152 = $serializer_getInstance_406();
    var tmp_153 = $serializer_getInstance_348();
    var tmp_154 = $serializer_getInstance_58();
    var tmp_155 = $serializer_getInstance_376();
    var tmp_156 = RedirectDamageToDreamerStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_157 = ObjectSerializer.l1c('RedirectDamageToDreamerStatement', tmp_156, tmp$ret$48);
    var tmp_158 = RelocateOneHunterToAnother_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_159 = ObjectSerializer.l1c('RelocateOneHunterToAnother', tmp_158, tmp$ret$51);
    var tmp_160 = $serializer_getInstance_354();
    var tmp_161 = $serializer_getInstance_59();
    var tmp_162 = $serializer_getInstance_323();
    var tmp_163 = ResonanceChooseStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_164 = ObjectSerializer.l1c('ResonanceChooseStatement', tmp_163, tmp$ret$54);
    var tmp_165 = ResourcefulnessUpgradeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_166 = ObjectSerializer.l1c('ResourcefulnessUpgradeStatement', tmp_165, tmp$ret$57);
    var tmp_167 = ResurrectionStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_168 = ObjectSerializer.l1c('ResurrectionStatement', tmp_167, tmp$ret$60);
    var tmp_169 = $serializer_getInstance_8();
    var tmp_170 = $serializer_getInstance_60();
    var tmp_171 = $serializer_getInstance_61();
    var tmp_172 = $serializer_getInstance_62();
    var tmp_173 = $serializer_getInstance_407();
    var tmp_174 = $serializer_getInstance_360();
    var tmp_175 = $serializer_getInstance_388();
    var tmp_176 = $serializer_getInstance_389();
    var tmp_177 = $serializer_getInstance_390();
    var tmp_178 = $serializer_getInstance_147();
    var tmp_179 = $serializer_getInstance_391();
    var tmp_180 = $serializer_getInstance_392();
    var tmp_181 = $serializer_getInstance_78();
    var tmp_182 = $serializer_getInstance_63();
    var tmp_183 = $serializer_getInstance_64();
    var tmp_184 = ShipwreckSettlerMovementStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_185 = ObjectSerializer.l1c('ShipwreckSettlerMovementStatement', tmp_184, tmp$ret$63);
    var tmp_186 = $serializer_getInstance_400();
    var tmp_187 = SigridCreatureLungeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_188 = ObjectSerializer.l1c('SigridCreatureLungeStatement', tmp_187, tmp$ret$66);
    var tmp_189 = SigridPactReversalStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_190 = ObjectSerializer.l1c('SigridPactReversalStatement', tmp_189, tmp$ret$69);
    var tmp_191 = $serializer_getInstance_401();
    var tmp_192 = $serializer_getInstance_349();
    var tmp_193 = $serializer_getInstance_425();
    var tmp_194 = $serializer_getInstance_145();
    var tmp_195 = $serializer_getInstance_65();
    var tmp_196 = $serializer_getInstance_408();
    var tmp_197 = $serializer_getInstance_426();
    var tmp_198 = SummonCreatureStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_199 = ObjectSerializer.l1c('SummonCreatureStatement', tmp_198, tmp$ret$72);
    var tmp_200 = SummonFylgjaStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_201 = ObjectSerializer.l1c('SummonFylgjaStatement', tmp_200, tmp$ret$75);
    var tmp_202 = $serializer_getInstance_393();
    var tmp_203 = $serializer_getInstance_394();
    var tmp_204 = $serializer_getInstance_66();
    var tmp_205 = $serializer_getInstance_350();
    var tmp_206 = SwarmAttackStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_207 = ObjectSerializer.l1c('SwarmAttackStatement', tmp_206, tmp$ret$78);
    var tmp_208 = $serializer_getInstance_351();
    var tmp_209 = $serializer_getInstance_3();
    var tmp_210 = $serializer_getInstance_9();
    var tmp_211 = $serializer_getInstance_344();
    var tmp_212 = $serializer_getInstance_140();
    var tmp_213 = $serializer_getInstance_67();
    var tmp_214 = $serializer_getInstance_355();
    var tmp_215 = VoidCallStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_216 = [tmp_1, tmp_3, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_45, tmp_46, tmp_47, tmp_49, tmp_51, tmp_52, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, tmp_64, tmp_65, tmp_66, tmp_67, tmp_68, tmp_70, tmp_71, tmp_72, tmp_73, tmp_74, tmp_75, tmp_77, tmp_78, tmp_80, tmp_82, tmp_83, tmp_84, tmp_85, tmp_86, tmp_87, tmp_88, tmp_89, tmp_90, tmp_91, tmp_92, tmp_93, tmp_95, tmp_96, tmp_97, tmp_98, tmp_99, tmp_100, tmp_101, tmp_103, tmp_104, tmp_105, tmp_107, tmp_108, tmp_109, tmp_110, tmp_111, tmp_112, tmp_113, tmp_114, tmp_115, tmp_116, tmp_117, tmp_118, tmp_119, tmp_120, tmp_121, tmp_122, tmp_123, tmp_124, tmp_125, tmp_126, tmp_127, tmp_128, tmp_129, tmp_130, tmp_131, tmp_132, tmp_133, tmp_134, tmp_135, tmp_136, tmp_137, tmp_138, tmp_139, tmp_140, tmp_141, tmp_142, tmp_143, tmp_144, tmp_145, tmp_146, tmp_147, tmp_149, tmp_150, tmp_151, tmp_152, tmp_153, tmp_154, tmp_155, tmp_157, tmp_159, tmp_160, tmp_161, tmp_162, tmp_164, tmp_166, tmp_168, tmp_169, tmp_170, tmp_171, tmp_172, tmp_173, tmp_174, tmp_175, tmp_176, tmp_177, tmp_178, tmp_179, tmp_180, tmp_181, tmp_182, tmp_183, tmp_185, tmp_186, tmp_188, tmp_190, tmp_191, tmp_192, tmp_193, tmp_194, tmp_195, tmp_196, tmp_197, tmp_199, tmp_201, tmp_202, tmp_203, tmp_204, tmp_205, tmp_207, tmp_208, tmp_209, tmp_210, tmp_211, tmp_212, tmp_213, tmp_214, ObjectSerializer.l1c('VoidCallStatement', tmp_215, tmp$ret$81), $serializer_getInstance_108()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    return SealedClassSerializer.i10('steelart.beast.ActionStatement', tmp, tmp_0, tmp_216, tmp$ret$87);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class TurnVariant {}
class GameScope {}
class ItselfGameScope {}
class ActionStatement {}
function canBeApplied($context_GameStateRuntime_604ce3) {
  return true;
}
function canBeAppliedAndHaveEffect($context_GameStateRuntime_604ce3) {
  return this.n2o($context_GameStateRuntime_604ce3);
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p2o_1 = [lazy(tmp_0, InAnyOrderStatement$Companion$$childSerializers$_anonymous__q3varm), null];
  }
}
class $serializer {
  constructor() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('InAnyOrderStatement', this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('needFakeAsk', true);
    this.q2o_1 = tmp0_serialDesc;
  }
  r2o(encoder, value) {
    var tmp0_desc = this.q2o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().p2o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s2o_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.t2o_1 === false)) {
      tmp1_output.w14(tmp0_desc, 1, value.t2o_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r2o(encoder, value instanceof InAnyOrderStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_1().p2o_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return InAnyOrderStatement.u2o(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.q2o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_1().p2o_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class InAnyOrderStatement {
  constructor(variants, needFakeAsk) {
    Companion_getInstance_1();
    needFakeAsk = needFakeAsk === VOID ? false : needFakeAsk;
    this.s2o_1 = variants;
    this.t2o_1 = needFakeAsk;
  }
  v2o($context_GameState_t6qee5) {
    return this.s2o_1;
  }
  o2o($context_GameStateRuntime_604ce3) {
    var tmp0 = this.v2o($context_GameStateRuntime_604ce3);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.o2o($context_GameStateRuntime_604ce3)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  toString() {
    return 'InAnyOrderStatement(variants=' + toString(this.s2o_1) + ', needFakeAsk=' + this.t2o_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.s2o_1);
    result = imul(result, 31) + getBooleanHashCode(this.t2o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InAnyOrderStatement))
      return false;
    if (!equals(this.s2o_1, other.s2o_1))
      return false;
    if (!(this.t2o_1 === other.t2o_1))
      return false;
    return true;
  }
  static u2o(seen0, variants, needFakeAsk, serializationConstructorMarker) {
    Companion_getInstance_1();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance().q2o_1);
    }
    var $this = createThis(this);
    $this.s2o_1 = variants;
    if (0 === (seen0 & 2))
      $this.t2o_1 = false;
    else
      $this.t2o_1 = needFakeAsk;
    return $this;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z2o_1 = [lazy(tmp_0, MovementUptoFixedStepsStatement$Companion$$childSerializers$_anonymous__h5ce5v), null];
  }
}
class $serializer_0 {
  constructor() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MovementUptoFixedStepsStatement', this, 2);
    tmp0_serialDesc.h1b('movingObject', false);
    tmp0_serialDesc.h1b('maxSteps', false);
    this.a2p_1 = tmp0_serialDesc;
  }
  b2p(encoder, value) {
    var tmp0_desc = this.a2p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().z2o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c2p_1);
    tmp1_output.z14(tmp0_desc, 1, value.d2p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b2p(encoder, value instanceof MovementUptoFixedStepsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_2().z2o_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return MovementUptoFixedStepsStatement.e2p(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.a2p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_2().z2o_1[0].k3(), IntSerializer_getInstance()];
  }
}
class ObjectMovementStatement {}
class MovementStepByStepStatement {
  constructor() {
    Companion_getInstance_15();
  }
  static g2p(seen0, serializationConstructorMarker) {
    Companion_getInstance_15();
    return createThis(this);
  }
}
class MovementUptoFixedStepsStatement extends MovementStepByStepStatement {
  constructor(movingObject, maxSteps) {
    Companion_getInstance_2();
    super();
    this.c2p_1 = movingObject;
    this.d2p_1 = maxSteps;
  }
  f2p() {
    return this.c2p_1;
  }
  toString() {
    return 'MovementUptoFixedStepsStatement(movingObject=' + this.c2p_1.toString() + ', maxSteps=' + this.d2p_1 + ')';
  }
  hashCode() {
    var result = this.c2p_1.hashCode();
    result = imul(result, 31) + this.d2p_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MovementUptoFixedStepsStatement))
      return false;
    if (!this.c2p_1.equals(other.c2p_1))
      return false;
    if (!(this.d2p_1 === other.d2p_1))
      return false;
    return true;
  }
  static e2p(seen0, movingObject, maxSteps, serializationConstructorMarker) {
    Companion_getInstance_2();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_0().a2p_1);
    }
    var $this = this.g2p(seen0, serializationConstructorMarker);
    $this.c2p_1 = movingObject;
    $this.d2p_1 = maxSteps;
    return $this;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_2 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h2p_1 = [lazy(tmp_0, GainHunterItemStatement$Companion$$childSerializers$_anonymous__l0333h)];
  }
}
class $serializer_1 {
  constructor() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainHunterItemStatement', this, 1);
    tmp0_serialDesc.h1b('hunters', false);
    this.i2p_1 = tmp0_serialDesc;
  }
  j2p(encoder, value) {
    var tmp0_desc = this.i2p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_3().h2p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k2p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j2p(encoder, value instanceof GainHunterItemStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_3().h2p_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GainHunterItemStatement.l2p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.i2p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_3().h2p_1[0].k3()];
  }
}
class PerformForEachHunter {
  constructor() {
    Companion_getInstance_74();
  }
  o2o($context_GameStateRuntime_604ce3) {
    return this.m2p($context_GameStateRuntime_604ce3, emptySet());
  }
  m2p($context_GameState_t6qee5, completed) {
    return true;
  }
  static n2p(seen0, serializationConstructorMarker) {
    Companion_getInstance_74();
    return createThis(this);
  }
}
class GainHunterItemStatement extends PerformForEachHunter {
  constructor(hunters) {
    Companion_getInstance_3();
    super();
    this.k2p_1 = hunters;
  }
  m2p($context_GameState_t6qee5, completed) {
    return !noAvailableArsenalCards(get_hunterItems($context_GameState_t6qee5));
  }
  toString() {
    return 'GainHunterItemStatement(hunters=' + toString(this.k2p_1) + ')';
  }
  hashCode() {
    return hashCode(this.k2p_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainHunterItemStatement))
      return false;
    if (!equals(this.k2p_1, other.k2p_1))
      return false;
    return true;
  }
  static l2p(seen0, hunters, serializationConstructorMarker) {
    Companion_getInstance_3();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().i2p_1);
    }
    var $this = this.n2p(seen0, serializationConstructorMarker);
    $this.k2p_1 = hunters;
    return $this;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o2p_1 = [lazy(tmp_0, ThenActionStatement$Companion$$childSerializers$_anonymous__dmyr9u)];
  }
}
class $serializer_2 {
  constructor() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ThenActionStatement', this, 1);
    tmp0_serialDesc.h1b('parts', false);
    this.p2p_1 = tmp0_serialDesc;
  }
  q2p(encoder, value) {
    var tmp0_desc = this.p2p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().o2p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r2p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q2p(encoder, value instanceof ThenActionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_4().o2p_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ThenActionStatement.s2p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.p2p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_4().o2p_1[0].k3()];
  }
}
class ThenActionStatement {
  constructor(parts) {
    Companion_getInstance_4();
    this.r2p_1 = parts;
  }
  v2o($context_GameState_t6qee5) {
    return this.r2p_1;
  }
  n2o($context_GameStateRuntime_604ce3) {
    return this.v2o($context_GameStateRuntime_604ce3).u2(0).n2o($context_GameStateRuntime_604ce3);
  }
  o2o($context_GameStateRuntime_604ce3) {
    return this.v2o($context_GameStateRuntime_604ce3).u2(0).o2o($context_GameStateRuntime_604ce3);
  }
  toString() {
    return 'ThenActionStatement(parts=' + toString(this.r2p_1) + ')';
  }
  hashCode() {
    return hashCode(this.r2p_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ThenActionStatement))
      return false;
    if (!equals(this.r2p_1, other.r2p_1))
      return false;
    return true;
  }
  static s2p(seen0, parts, serializationConstructorMarker) {
    Companion_getInstance_4();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_2().p2p_1);
    }
    var $this = createThis(this);
    $this.r2p_1 = parts;
    return $this;
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t2p_1 = [lazy(tmp_0, TransformAllNearbyStatement$Companion$$childSerializers$_anonymous__5qkvtb)];
  }
}
class $serializer_3 {
  constructor() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TransformAllNearbyStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.u2p_1 = tmp0_serialDesc;
  }
  v2p(encoder, value) {
    var tmp0_desc = this.u2p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_5().t2p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w2p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v2p(encoder, value instanceof TransformAllNearbyStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_5().t2p_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return TransformAllNearbyStatement.x2p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.u2p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_5().t2p_1[0].k3()];
  }
}
class TransformAllNearbyStatement {
  constructor(beast) {
    Companion_getInstance_5();
    this.w2p_1 = beast;
  }
  toString() {
    return 'TransformAllNearbyStatement(beast=' + this.w2p_1.toString() + ')';
  }
  hashCode() {
    return this.w2p_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TransformAllNearbyStatement))
      return false;
    if (!this.w2p_1.equals(other.w2p_1))
      return false;
    return true;
  }
  static x2p(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_5();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_3().u2p_1);
    }
    var $this = createThis(this);
    $this.w2p_1 = beast;
    return $this;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y2p_1 = [lazy(tmp_0, SimpleBeastMovementStatement$Companion$$childSerializers$_anonymous__uv80zt), null, null];
  }
}
class $serializer_4 {
  constructor() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SimpleBeastMovementStatement', this, 3);
    tmp0_serialDesc.h1b('movingObject', false);
    tmp0_serialDesc.h1b('stepsNumber', false);
    tmp0_serialDesc.h1b('falseMovementsShouldBePlaced', true);
    this.z2p_1 = tmp0_serialDesc;
  }
  a2q(encoder, value) {
    var tmp0_desc = this.z2p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_6().y2p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.b2q_1);
    tmp1_output.z14(tmp0_desc, 1, value.c2q_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.d2q_1 === 0)) {
      tmp1_output.z14(tmp0_desc, 2, value.d2q_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a2q(encoder, value instanceof SimpleBeastMovementStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_6().y2p_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return SimpleBeastMovementStatement.e2q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.z2p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_6().y2p_1[0].k3(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class BeastMovementStatement {
  constructor() {
    Companion_getInstance_8();
  }
  static f2q(seen0, serializationConstructorMarker) {
    Companion_getInstance_8();
    return createThis(this);
  }
}
class SimpleBeastMovementStatement extends BeastMovementStatement {
  constructor(movingObject, stepsNumber, falseMovementsShouldBePlaced) {
    Companion_getInstance_6();
    falseMovementsShouldBePlaced = falseMovementsShouldBePlaced === VOID ? 0 : falseMovementsShouldBePlaced;
    super();
    this.b2q_1 = movingObject;
    this.c2q_1 = stepsNumber;
    this.d2q_1 = falseMovementsShouldBePlaced;
  }
  f2p() {
    return this.b2q_1;
  }
  toString() {
    return 'SimpleBeastMovementStatement(movingObject=' + this.b2q_1.toString() + ', stepsNumber=' + this.c2q_1 + ', falseMovementsShouldBePlaced=' + this.d2q_1 + ')';
  }
  hashCode() {
    var result = this.b2q_1.hashCode();
    result = imul(result, 31) + this.c2q_1 | 0;
    result = imul(result, 31) + this.d2q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SimpleBeastMovementStatement))
      return false;
    if (!this.b2q_1.equals(other.b2q_1))
      return false;
    if (!(this.c2q_1 === other.c2q_1))
      return false;
    if (!(this.d2q_1 === other.d2q_1))
      return false;
    return true;
  }
  static e2q(seen0, movingObject, stepsNumber, falseMovementsShouldBePlaced, serializationConstructorMarker) {
    Companion_getInstance_6();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_4().z2p_1);
    }
    var $this = this.f2q(seen0, serializationConstructorMarker);
    $this.b2q_1 = movingObject;
    $this.c2q_1 = stepsNumber;
    if (0 === (seen0 & 4))
      $this.d2q_1 = 0;
    else
      $this.d2q_1 = falseMovementsShouldBePlaced;
    return $this;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, AttackStatement$Companion$$childSerializers$_anonymous__temil9);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, AttackStatement$Companion$$childSerializers$_anonymous__temil9_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g2q_1 = [tmp_1, tmp_3, lazy(tmp_4, AttackStatement$Companion$$childSerializers$_anonymous__temil9_1)];
  }
}
class $serializer_5 {
  constructor() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AttackStatement', this, 3);
    tmp0_serialDesc.h1b('damageSource', false);
    tmp0_serialDesc.h1b('attacker', false);
    tmp0_serialDesc.h1b('attackModifier', true);
    this.h2q_1 = tmp0_serialDesc;
  }
  i2q(encoder, value) {
    var tmp0_desc = this.h2q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_7().g2q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.j2q_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.k2q_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.l2q_1 == null)) {
      tmp1_output.i15(tmp0_desc, 2, tmp2_cached[2].k3(), value.l2q_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i2q(encoder, value instanceof AttackStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_7().g2q_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.d14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.d14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return AttackStatement.m2q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.h2q_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_7().g2q_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), get_nullable(tmp0_cached[2].k3())];
  }
}
class AttackStatement {
  constructor(damageSource, attacker, attackModifier) {
    Companion_getInstance_7();
    attackModifier = attackModifier === VOID ? null : attackModifier;
    this.j2q_1 = damageSource;
    this.k2q_1 = attacker;
    this.l2q_1 = attackModifier;
  }
  o2o($context_GameStateRuntime_604ce3) {
    var tmp;
    var tmp2 = this.k2q_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp_0 = get_objectType($context_GameStateRuntime_604ce3, tmp2);
      if (isInterface(tmp_0, BeastCharacter)) {
        tmp$ret$0 = tmp2 instanceof ObjectOnBoard ? tmp2 : THROW_CCE();
        break $l$block;
      }
      tmp$ret$0 = null;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    if ((tmp0_safe_receiver == null ? null : get_isHidden($context_GameStateRuntime_604ce3, tmp0_safe_receiver)) === true) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !get_gameRules($context_GameStateRuntime_604ce3).n2q($context_GameStateRuntime_604ce3, this.k2q_1, this.l2q_1).n1();
    }
    return tmp;
  }
  toString() {
    return 'AttackStatement(damageSource=' + toString(this.j2q_1) + ', attacker=' + this.k2q_1.toString() + ', attackModifier=' + toString_0(this.l2q_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.j2q_1);
    result = imul(result, 31) + this.k2q_1.hashCode() | 0;
    result = imul(result, 31) + (this.l2q_1 == null ? 0 : hashCode(this.l2q_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AttackStatement))
      return false;
    if (!equals(this.j2q_1, other.j2q_1))
      return false;
    if (!this.k2q_1.equals(other.k2q_1))
      return false;
    if (!equals(this.l2q_1, other.l2q_1))
      return false;
    return true;
  }
  static m2q(seen0, damageSource, attacker, attackModifier, serializationConstructorMarker) {
    Companion_getInstance_7();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_5().h2q_1);
    }
    var $this = createThis(this);
    $this.j2q_1 = damageSource;
    $this.k2q_1 = attacker;
    if (0 === (seen0 & 4))
      $this.l2q_1 = null;
    else
      $this.l2q_1 = attackModifier;
    return $this;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o2q_1 = lazy(tmp_0, BeastMovementStatement$Companion$_anonymous__uuy8vi);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p2q_1 = [lazy(tmp_0, ChooseOneOfStatement$Companion$$childSerializers$_anonymous__bwv5cv), null];
  }
}
class $serializer_6 {
  constructor() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChooseOneOfStatement', this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('haveToChooseOne', true);
    this.q2q_1 = tmp0_serialDesc;
  }
  r2q(encoder, value) {
    var tmp0_desc = this.q2q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().p2q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s2q_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.t2q_1 === false)) {
      tmp1_output.w14(tmp0_desc, 1, value.t2q_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r2q(encoder, value instanceof ChooseOneOfStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_9().p2q_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ChooseOneOfStatement.u2q(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.q2q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_9().p2q_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class ChooseOneOfStatementBase {}
function canBeApplied_0($context_GameStateRuntime_604ce3) {
  var tmp;
  if (!this.v2q()) {
    tmp = true;
  } else {
    var tmp0 = this.v2o($context_GameStateRuntime_604ce3);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.n1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.n2o($context_GameStateRuntime_604ce3)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
function canBeAppliedAndHaveEffect_0($context_GameStateRuntime_604ce3) {
  var tmp0 = this.v2o($context_GameStateRuntime_604ce3);
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (element.o2o($context_GameStateRuntime_604ce3)) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
class ChooseOneOfStatement {
  constructor(variants, haveToChooseOne) {
    Companion_getInstance_9();
    haveToChooseOne = haveToChooseOne === VOID ? false : haveToChooseOne;
    this.s2q_1 = variants;
    this.t2q_1 = haveToChooseOne;
  }
  v2q() {
    return this.t2q_1;
  }
  v2o($context_GameState_t6qee5) {
    return this.s2q_1;
  }
  toString() {
    return 'ChooseOneOfStatement(variants=' + toString(this.s2q_1) + ', haveToChooseOne=' + this.t2q_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.s2q_1);
    result = imul(result, 31) + getBooleanHashCode(this.t2q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChooseOneOfStatement))
      return false;
    if (!equals(this.s2q_1, other.s2q_1))
      return false;
    if (!(this.t2q_1 === other.t2q_1))
      return false;
    return true;
  }
  static u2q(seen0, variants, haveToChooseOne, serializationConstructorMarker) {
    Companion_getInstance_9();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_6().q2q_1);
    }
    var $this = createThis(this);
    $this.s2q_1 = variants;
    if (0 === (seen0 & 2))
      $this.t2q_1 = false;
    else
      $this.t2q_1 = haveToChooseOne;
    return $this;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w2q_1 = [lazy(tmp_0, GrapnelStatement$Companion$$childSerializers$_anonymous__mgwgi2), null];
  }
}
class $serializer_7 {
  constructor() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GrapnelStatement', this, 2);
    tmp0_serialDesc.h1b('hunter', false);
    tmp0_serialDesc.h1b('grapnelDistance', false);
    this.x2q_1 = tmp0_serialDesc;
  }
  y2q(encoder, value) {
    var tmp0_desc = this.x2q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().w2q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.z2q_1);
    tmp1_output.z14(tmp0_desc, 1, value.a2r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y2q(encoder, value instanceof GrapnelStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_10().w2q_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GrapnelStatement.b2r(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.x2q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_10().w2q_1[0].k3(), IntSerializer_getInstance()];
  }
}
class GrapnelStatement {
  constructor(hunter, grapnelDistance) {
    Companion_getInstance_10();
    this.z2q_1 = hunter;
    this.a2r_1 = grapnelDistance;
  }
  toString() {
    return 'GrapnelStatement(hunter=' + this.z2q_1.toString() + ', grapnelDistance=' + this.a2r_1 + ')';
  }
  hashCode() {
    var result = this.z2q_1.hashCode();
    result = imul(result, 31) + this.a2r_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GrapnelStatement))
      return false;
    if (!this.z2q_1.equals(other.z2q_1))
      return false;
    if (!(this.a2r_1 === other.a2r_1))
      return false;
    return true;
  }
  static b2r(seen0, hunter, grapnelDistance, serializationConstructorMarker) {
    Companion_getInstance_10();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_7().x2q_1);
    }
    var $this = createThis(this);
    $this.z2q_1 = hunter;
    $this.a2r_1 = grapnelDistance;
    return $this;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RetrieveDiscardedAbilityStatement$Companion$$childSerializers$_anonymous__mn6gos);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c2r_1 = [tmp_1, lazy(tmp_2, RetrieveDiscardedAbilityStatement$Companion$$childSerializers$_anonymous__mn6gos_0)];
  }
}
class $serializer_8 {
  constructor() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RetrieveDiscardedAbilityStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('particularCard', true);
    this.d2r_1 = tmp0_serialDesc;
  }
  e2r(encoder, value) {
    var tmp0_desc = this.d2r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_11().c2r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f2r_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.g2r_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.g2r_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e2r(encoder, value instanceof RetrieveDiscardedAbilityStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_11().c2r_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RetrieveDiscardedAbilityStatement.h2r(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d2r_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_11().c2r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), get_nullable(tmp0_cached[1].k3())];
  }
}
class RetrieveDiscardedAbilityStatement {
  constructor(characterObject, particularCard) {
    Companion_getInstance_11();
    particularCard = particularCard === VOID ? null : particularCard;
    this.f2r_1 = characterObject;
    this.g2r_1 = particularCard;
  }
  o2o($context_GameStateRuntime_604ce3) {
    var tmp;
    if (!(this.g2r_1 == null)) {
      tmp = get_discardedAbilityCards($context_GameStateRuntime_604ce3, this.f2r_1).w2(this.g2r_1);
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !get_discardedAbilityCards($context_GameStateRuntime_604ce3, this.f2r_1).n1();
    }
    return tmp;
  }
  toString() {
    return 'RetrieveDiscardedAbilityStatement(characterObject=' + this.f2r_1.toString() + ', particularCard=' + toString_0(this.g2r_1) + ')';
  }
  hashCode() {
    var result = this.f2r_1.hashCode();
    result = imul(result, 31) + (this.g2r_1 == null ? 0 : hashCode(this.g2r_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RetrieveDiscardedAbilityStatement))
      return false;
    if (!this.f2r_1.equals(other.f2r_1))
      return false;
    if (!equals(this.g2r_1, other.g2r_1))
      return false;
    return true;
  }
  static h2r(seen0, characterObject, particularCard, serializationConstructorMarker) {
    Companion_getInstance_11();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_8().d2r_1);
    }
    var $this = createThis(this);
    $this.f2r_1 = characterObject;
    if (0 === (seen0 & 2))
      $this.g2r_1 = null;
    else
      $this.g2r_1 = particularCard;
    return $this;
  }
}
class DiscardPlacedTrapStatement {
  constructor() {
    DiscardPlacedTrapStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i2r_1 = lazy(tmp_0, DiscardPlacedTrapStatement$_anonymous__a3c5v4);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_0(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DiscardPlacedTrapStatement';
  }
  hashCode() {
    return -1223581556;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardPlacedTrapStatement))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, TransformLocationsStatement$Companion$$childSerializers$_anonymous__opeymr);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, TransformLocationsStatement$Companion$$childSerializers$_anonymous__opeymr_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j2r_1 = [null, null, null, null, tmp_1, tmp_3, lazy(tmp_4, TransformLocationsStatement$Companion$$childSerializers$_anonymous__opeymr_1)];
  }
}
class $serializer_9 {
  constructor() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TransformLocationsStatement', this, 7);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('distance', false);
    tmp0_serialDesc.h1b('maxTransformations', false);
    tmp0_serialDesc.h1b('mayNothing', false);
    tmp0_serialDesc.h1b('newLocationType', false);
    tmp0_serialDesc.h1b('possibleToTransform', true);
    tmp0_serialDesc.h1b('excludedPositions', true);
    this.k2r_1 = tmp0_serialDesc;
  }
  l2r(encoder, value) {
    var tmp0_desc = this.k2r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_12().j2r_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_364.y2o(Companion_instance_420.a2g()), value.m2r_1);
    tmp1_output.z14(tmp0_desc, 1, value.n2r_1);
    tmp1_output.z14(tmp0_desc, 2, value.o2r_1);
    tmp1_output.w14(tmp0_desc, 3, value.p2r_1);
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.q2r_1);
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !(value.r2r_1 == null)) {
      tmp1_output.i15(tmp0_desc, 5, tmp2_cached[5].k3(), value.r2r_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !equals(value.s2r_1, emptySet())) {
      tmp1_output.g15(tmp0_desc, 6, tmp2_cached[6].k3(), value.s2r_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l2r(encoder, value instanceof TransformLocationsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = false;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.p13(tmp0_desc);
    var tmp12_cached = Companion_getInstance_12().j2r_1;
    if (tmp11_input.e14()) {
      tmp4_local0 = tmp11_input.b14(tmp0_desc, 0, $serializer_364.y2o(Companion_instance_420.a2g()), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.r13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.b14(tmp0_desc, 4, tmp12_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.d14(tmp0_desc, 5, tmp12_cached[5].k3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.b14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.b14(tmp0_desc, 0, $serializer_364.y2o(Companion_instance_420.a2g()), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.r13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.b14(tmp0_desc, 4, tmp12_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.d14(tmp0_desc, 5, tmp12_cached[5].k3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.b14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp11_input.q13(tmp0_desc);
    return TransformLocationsStatement.t2r(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  dz() {
    return this.k2r_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_12().j2r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_364.y2o(Companion_instance_420.a2g()), IntSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[4].k3(), get_nullable(tmp0_cached[5].k3()), tmp0_cached[6].k3()];
  }
}
class TransformLocationsStatement {
  constructor(actor, distance, maxTransformations, mayNothing, newLocationType, possibleToTransform, excludedPositions) {
    Companion_getInstance_12();
    possibleToTransform = possibleToTransform === VOID ? null : possibleToTransform;
    excludedPositions = excludedPositions === VOID ? emptySet() : excludedPositions;
    this.m2r_1 = actor;
    this.n2r_1 = distance;
    this.o2r_1 = maxTransformations;
    this.p2r_1 = mayNothing;
    this.q2r_1 = newLocationType;
    this.r2r_1 = possibleToTransform;
    this.s2r_1 = excludedPositions;
  }
  toString() {
    return 'TransformLocationsStatement(actor=' + this.m2r_1.toString() + ', distance=' + this.n2r_1 + ', maxTransformations=' + this.o2r_1 + ', mayNothing=' + this.p2r_1 + ', newLocationType=' + this.q2r_1.toString() + ', possibleToTransform=' + toString_0(this.r2r_1) + ', excludedPositions=' + toString(this.s2r_1) + ')';
  }
  hashCode() {
    var result = this.m2r_1.hashCode();
    result = imul(result, 31) + this.n2r_1 | 0;
    result = imul(result, 31) + this.o2r_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p2r_1) | 0;
    result = imul(result, 31) + this.q2r_1.hashCode() | 0;
    result = imul(result, 31) + (this.r2r_1 == null ? 0 : this.r2r_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.s2r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TransformLocationsStatement))
      return false;
    if (!this.m2r_1.equals(other.m2r_1))
      return false;
    if (!(this.n2r_1 === other.n2r_1))
      return false;
    if (!(this.o2r_1 === other.o2r_1))
      return false;
    if (!(this.p2r_1 === other.p2r_1))
      return false;
    if (!this.q2r_1.equals(other.q2r_1))
      return false;
    if (!equals(this.r2r_1, other.r2r_1))
      return false;
    if (!equals(this.s2r_1, other.s2r_1))
      return false;
    return true;
  }
  static t2r(seen0, actor, distance, maxTransformations, mayNothing, newLocationType, possibleToTransform, excludedPositions, serializationConstructorMarker) {
    Companion_getInstance_12();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_9().k2r_1);
    }
    var $this = createThis(this);
    $this.m2r_1 = actor;
    $this.n2r_1 = distance;
    $this.o2r_1 = maxTransformations;
    $this.p2r_1 = mayNothing;
    $this.q2r_1 = newLocationType;
    if (0 === (seen0 & 32))
      $this.r2r_1 = null;
    else
      $this.r2r_1 = possibleToTransform;
    if (0 === (seen0 & 64))
      $this.s2r_1 = emptySet();
    else
      $this.s2r_1 = excludedPositions;
    return $this;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_12 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u2r_1 = [lazy(tmp_0, MoveSeveralHuntersStatement$Companion$$childSerializers$_anonymous__4q92sd), null, null];
  }
}
class $serializer_10 {
  constructor() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MoveSeveralHuntersStatement', this, 3);
    tmp0_serialDesc.h1b('hunters', false);
    tmp0_serialDesc.h1b('mayMoved', true);
    tmp0_serialDesc.h1b('maxSteps', true);
    this.v2r_1 = tmp0_serialDesc;
  }
  w2r(encoder, value) {
    var tmp0_desc = this.v2r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_13().u2r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x2r_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.y2r_1 === -1)) {
      tmp1_output.z14(tmp0_desc, 1, value.y2r_1);
    }
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.z2r_1 === 1)) {
      tmp1_output.z14(tmp0_desc, 2, value.z2r_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w2r(encoder, value instanceof MoveSeveralHuntersStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_13().u2r_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return MoveSeveralHuntersStatement.a2s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.v2r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_13().u2r_1[0].k3(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class MoveSeveralHuntersStatement extends PerformForEachHunter {
  constructor(hunters, mayMoved, maxSteps) {
    Companion_getInstance_13();
    mayMoved = mayMoved === VOID ? -1 : mayMoved;
    maxSteps = maxSteps === VOID ? 1 : maxSteps;
    super();
    this.x2r_1 = hunters;
    this.y2r_1 = mayMoved;
    this.z2r_1 = maxSteps;
  }
  m2p($context_GameState_t6qee5, completed) {
    if (!(this.y2r_1 === -1))
      return completed.s2() < this.y2r_1;
    return super.m2p($context_GameState_t6qee5, completed);
  }
  toString() {
    return 'MoveSeveralHuntersStatement(hunters=' + toString(this.x2r_1) + ', mayMoved=' + this.y2r_1 + ', maxSteps=' + this.z2r_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x2r_1);
    result = imul(result, 31) + this.y2r_1 | 0;
    result = imul(result, 31) + this.z2r_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MoveSeveralHuntersStatement))
      return false;
    if (!equals(this.x2r_1, other.x2r_1))
      return false;
    if (!(this.y2r_1 === other.y2r_1))
      return false;
    if (!(this.z2r_1 === other.z2r_1))
      return false;
    return true;
  }
  static a2s(seen0, hunters, mayMoved, maxSteps, serializationConstructorMarker) {
    Companion_getInstance_13();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_10().v2r_1);
    }
    var $this = this.n2p(seen0, serializationConstructorMarker);
    $this.x2r_1 = hunters;
    if (0 === (seen0 & 2))
      $this.y2r_1 = -1;
    else
      $this.y2r_1 = mayMoved;
    if (0 === (seen0 & 4))
      $this.z2r_1 = 1;
    else
      $this.z2r_1 = maxSteps;
    return $this;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, MoveEverySummonStatement$Companion$$childSerializers$_anonymous__w300u2);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b2s_1 = [tmp_1, null, lazy(tmp_2, MoveEverySummonStatement$Companion$$childSerializers$_anonymous__w300u2_0)];
  }
}
class $serializer_11 {
  constructor() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MoveEverySummonStatement', this, 3);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('isInZone', false);
    tmp0_serialDesc.h1b('summonType', false);
    this.c2s_1 = tmp0_serialDesc;
  }
  d2s(encoder, value) {
    var tmp0_desc = this.c2s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_14().b2s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.e2s_1);
    tmp1_output.w14(tmp0_desc, 1, value.f2s_1);
    tmp1_output.i15(tmp0_desc, 2, tmp2_cached[2].k3(), value.g2s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d2s(encoder, value instanceof MoveEverySummonStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_14().b2s_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.d14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.d14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return MoveEverySummonStatement.h2s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.c2s_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_14().b2s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[2].k3())];
  }
}
class MoveEverySummonStatement {
  constructor(beast, isInZone, summonType) {
    Companion_getInstance_14();
    this.e2s_1 = beast;
    this.f2s_1 = isInZone;
    this.g2s_1 = summonType;
  }
  toString() {
    return 'MoveEverySummonStatement(beast=' + this.e2s_1.toString() + ', isInZone=' + this.f2s_1 + ', summonType=' + toString_0(this.g2s_1) + ')';
  }
  hashCode() {
    var result = this.e2s_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.f2s_1) | 0;
    result = imul(result, 31) + (this.g2s_1 == null ? 0 : hashCode(this.g2s_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MoveEverySummonStatement))
      return false;
    if (!this.e2s_1.equals(other.e2s_1))
      return false;
    if (!(this.f2s_1 === other.f2s_1))
      return false;
    if (!equals(this.g2s_1, other.g2s_1))
      return false;
    return true;
  }
  static h2s(seen0, beast, isInZone, summonType, serializationConstructorMarker) {
    Companion_getInstance_14();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_11().c2s_1);
    }
    var $this = createThis(this);
    $this.e2s_1 = beast;
    $this.f2s_1 = isInZone;
    $this.g2s_1 = summonType;
    return $this;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i2s_1 = lazy(tmp_0, MovementStepByStepStatement$Companion$_anonymous__froa0y);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_1(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class AbruptDecayActionStatement {
  constructor() {
    AbruptDecayActionStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j2s_1 = lazy(tmp_0, AbruptDecayActionStatement$_anonymous__g66d74);
  }
  o2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !get_placedTrapsCardsInfo($context_GameStateRuntime_604ce3).n1();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_2(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AbruptDecayActionStatement';
  }
  hashCode() {
    return -248111476;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbruptDecayActionStatement))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k2s_1 = [lazy(tmp_0, ActivateSummonsStatement$Companion$$childSerializers$_anonymous__ljgerq), null];
  }
}
class $serializer_12 {
  constructor() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ActivateSummonsStatement', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('maxSummonsNumber', true);
    this.l2s_1 = tmp0_serialDesc;
  }
  m2s(encoder, value) {
    var tmp0_desc = this.l2s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_16().k2s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n2s_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.o2s_1 === -1)) {
      tmp1_output.z14(tmp0_desc, 1, value.o2s_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m2s(encoder, value instanceof ActivateSummonsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_16().k2s_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ActivateSummonsStatement.p2s(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.l2s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_16().k2s_1[0].k3(), IntSerializer_getInstance()];
  }
}
class ActivateSummonsStatement {
  constructor(beast, maxSummonsNumber) {
    Companion_getInstance_16();
    maxSummonsNumber = maxSummonsNumber === VOID ? -1 : maxSummonsNumber;
    this.n2s_1 = beast;
    this.o2s_1 = maxSummonsNumber;
  }
  n2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !get_objectType($context_GameStateRuntime_604ce3, this.n2s_1).q2s($context_GameStateRuntime_604ce3).n1();
  }
  toString() {
    return 'ActivateSummonsStatement(beast=' + this.n2s_1.toString() + ', maxSummonsNumber=' + this.o2s_1 + ')';
  }
  hashCode() {
    var result = this.n2s_1.hashCode();
    result = imul(result, 31) + this.o2s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ActivateSummonsStatement))
      return false;
    if (!this.n2s_1.equals(other.n2s_1))
      return false;
    if (!(this.o2s_1 === other.o2s_1))
      return false;
    return true;
  }
  static p2s(seen0, beast, maxSummonsNumber, serializationConstructorMarker) {
    Companion_getInstance_16();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_12().l2s_1);
    }
    var $this = createThis(this);
    $this.n2s_1 = beast;
    if (0 === (seen0 & 2))
      $this.o2s_1 = -1;
    else
      $this.o2s_1 = maxSummonsNumber;
    return $this;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, ActivateTrapStatement$Companion$$childSerializers$_anonymous__xsffff);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r2s_1 = [tmp_1, lazy(tmp_2, ActivateTrapStatement$Companion$$childSerializers$_anonymous__xsffff_0)];
  }
}
class $serializer_13 {
  constructor() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ActivateTrapStatement', this, 2);
    tmp0_serialDesc.h1b('target', false);
    tmp0_serialDesc.h1b('trapCard', false);
    this.s2s_1 = tmp0_serialDesc;
  }
  t2s(encoder, value) {
    var tmp0_desc = this.s2s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_17().r2s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u2s_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.v2s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t2s(encoder, value instanceof ActivateTrapStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_17().r2s_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ActivateTrapStatement.w2s(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.s2s_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_17().r2s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class ActivateTrapStatement {
  constructor(target, trapCard) {
    Companion_getInstance_17();
    this.u2s_1 = target;
    this.v2s_1 = trapCard;
  }
  toString() {
    return 'ActivateTrapStatement(target=' + this.u2s_1.toString() + ', trapCard=' + toString(this.v2s_1) + ')';
  }
  hashCode() {
    var result = this.u2s_1.hashCode();
    result = imul(result, 31) + hashCode(this.v2s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ActivateTrapStatement))
      return false;
    if (!this.u2s_1.equals(other.u2s_1))
      return false;
    if (!equals(this.v2s_1, other.v2s_1))
      return false;
    return true;
  }
  static w2s(seen0, target, trapCard, serializationConstructorMarker) {
    Companion_getInstance_17();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_13().s2s_1);
    }
    var $this = createThis(this);
    $this.u2s_1 = target;
    $this.v2s_1 = trapCard;
    return $this;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x2s_1 = [lazy(tmp_0, DreamerMaskReactionStatement$Companion$$childSerializers$_anonymous__hfgqdc), null];
  }
}
class $serializer_14 {
  constructor() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DreamerMaskReactionStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('reactionCard', false);
    this.y2s_1 = tmp0_serialDesc;
  }
  z2s(encoder, value) {
    var tmp0_desc = this.y2s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_18().x2s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a2t_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_329(), value.b2t_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z2s(encoder, value instanceof DreamerMaskReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_18().x2s_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_329(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_329(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return DreamerMaskReactionStatement.c2t(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.y2s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_18().x2s_1[0].k3(), $serializer_getInstance_329()];
  }
}
class ApplyingReactionStatement {}
class DreamerMaskReactionStatement {
  constructor(characterObject, reactionCard) {
    Companion_getInstance_18();
    this.a2t_1 = characterObject;
    this.b2t_1 = reactionCard;
  }
  d2t() {
    return this.b2t_1;
  }
  toString() {
    return 'DreamerMaskReactionStatement(characterObject=' + this.a2t_1.toString() + ', reactionCard=' + this.b2t_1.toString() + ')';
  }
  hashCode() {
    var result = this.a2t_1.hashCode();
    result = imul(result, 31) + this.b2t_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DreamerMaskReactionStatement))
      return false;
    if (!this.a2t_1.equals(other.a2t_1))
      return false;
    if (!this.b2t_1.equals(other.b2t_1))
      return false;
    return true;
  }
  static c2t(seen0, characterObject, reactionCard, serializationConstructorMarker) {
    Companion_getInstance_18();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_14().y2s_1);
    }
    var $this = createThis(this);
    $this.a2t_1 = characterObject;
    $this.b2t_1 = reactionCard;
    return $this;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, EsmeriasStrandReactionStatement$Companion$$childSerializers$_anonymous__pppkp3);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, EsmeriasStrandReactionStatement$Companion$$childSerializers$_anonymous__pppkp3_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e2t_1 = [tmp_1, tmp_3, lazy(tmp_4, EsmeriasStrandReactionStatement$Companion$$childSerializers$_anonymous__pppkp3_1)];
  }
}
class $serializer_15 {
  constructor() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EsmeriasStrandReactionStatement', this, 3);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('reactionCard', false);
    tmp0_serialDesc.h1b('cardToCopy', false);
    this.f2t_1 = tmp0_serialDesc;
  }
  g2t(encoder, value) {
    var tmp0_desc = this.f2t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_19().e2t_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h2t_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.i2t_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.j2t_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g2t(encoder, value instanceof EsmeriasStrandReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_19().e2t_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return EsmeriasStrandReactionStatement.k2t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.f2t_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_19().e2t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class EsmeriasStrandReactionStatement {
  constructor(characterObject, reactionCard, cardToCopy) {
    Companion_getInstance_19();
    this.h2t_1 = characterObject;
    this.i2t_1 = reactionCard;
    this.j2t_1 = cardToCopy;
  }
  d2t() {
    return this.i2t_1;
  }
  toString() {
    return 'EsmeriasStrandReactionStatement(characterObject=' + this.h2t_1.toString() + ', reactionCard=' + this.i2t_1.toString() + ', cardToCopy=' + toString(this.j2t_1) + ')';
  }
  hashCode() {
    var result = this.h2t_1.hashCode();
    result = imul(result, 31) + this.i2t_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.j2t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EsmeriasStrandReactionStatement))
      return false;
    if (!this.h2t_1.equals(other.h2t_1))
      return false;
    if (!this.i2t_1.equals(other.i2t_1))
      return false;
    if (!equals(this.j2t_1, other.j2t_1))
      return false;
    return true;
  }
  static k2t(seen0, characterObject, reactionCard, cardToCopy, serializationConstructorMarker) {
    Companion_getInstance_19();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_15().f2t_1);
    }
    var $this = createThis(this);
    $this.h2t_1 = characterObject;
    $this.i2t_1 = reactionCard;
    $this.j2t_1 = cardToCopy;
    return $this;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l2t_1 = [lazy(tmp_0, FlareReactionStatement$Companion$$childSerializers$_anonymous__m1o9ny), null];
  }
}
class $serializer_16 {
  constructor() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FlareReactionStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('reactionCard', false);
    this.m2t_1 = tmp0_serialDesc;
  }
  n2t(encoder, value) {
    var tmp0_desc = this.m2t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_20().l2t_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o2t_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_330(), value.p2t_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n2t(encoder, value instanceof FlareReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_20().l2t_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_330(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_330(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return FlareReactionStatement.q2t(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.m2t_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_20().l2t_1[0].k3(), $serializer_getInstance_330()];
  }
}
class FlareReactionStatement {
  constructor(characterObject, reactionCard) {
    Companion_getInstance_20();
    this.o2t_1 = characterObject;
    this.p2t_1 = reactionCard;
  }
  d2t() {
    return this.p2t_1;
  }
  toString() {
    return 'FlareReactionStatement(characterObject=' + this.o2t_1.toString() + ', reactionCard=' + this.p2t_1.toString() + ')';
  }
  hashCode() {
    var result = this.o2t_1.hashCode();
    result = imul(result, 31) + this.p2t_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FlareReactionStatement))
      return false;
    if (!this.o2t_1.equals(other.o2t_1))
      return false;
    if (!this.p2t_1.equals(other.p2t_1))
      return false;
    return true;
  }
  static q2t(seen0, characterObject, reactionCard, serializationConstructorMarker) {
    Companion_getInstance_20();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_16().m2t_1);
    }
    var $this = createThis(this);
    $this.o2t_1 = characterObject;
    $this.p2t_1 = reactionCard;
    return $this;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r2t_1 = [lazy(tmp_0, IntuitionReactionStatement$Companion$$childSerializers$_anonymous__r37am3), null];
  }
}
class $serializer_17 {
  constructor() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('IntuitionReactionStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('reactionCard', false);
    this.s2t_1 = tmp0_serialDesc;
  }
  t2t(encoder, value) {
    var tmp0_desc = this.s2t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_21().r2t_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u2t_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_84(), value.v2t_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t2t(encoder, value instanceof IntuitionReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_21().r2t_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_84(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_84(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return IntuitionReactionStatement.w2t(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.s2t_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_21().r2t_1[0].k3(), $serializer_getInstance_84()];
  }
}
class IntuitionReactionStatement {
  constructor(characterObject, reactionCard) {
    Companion_getInstance_21();
    this.u2t_1 = characterObject;
    this.v2t_1 = reactionCard;
  }
  d2t() {
    return this.v2t_1;
  }
  toString() {
    return 'IntuitionReactionStatement(characterObject=' + this.u2t_1.toString() + ', reactionCard=' + this.v2t_1.toString() + ')';
  }
  hashCode() {
    var result = this.u2t_1.hashCode();
    result = imul(result, 31) + this.v2t_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IntuitionReactionStatement))
      return false;
    if (!this.u2t_1.equals(other.u2t_1))
      return false;
    if (!this.v2t_1.equals(other.v2t_1))
      return false;
    return true;
  }
  static w2t(seen0, characterObject, reactionCard, serializationConstructorMarker) {
    Companion_getInstance_21();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_17().s2t_1);
    }
    var $this = createThis(this);
    $this.u2t_1 = characterObject;
    $this.v2t_1 = reactionCard;
    return $this;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_21 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, PlayCardAsReactionStatement$Companion$$childSerializers$_anonymous__li1q6e);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x2t_1 = [tmp_1, lazy(tmp_2, PlayCardAsReactionStatement$Companion$$childSerializers$_anonymous__li1q6e_0)];
  }
}
class $serializer_18 {
  constructor() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayCardAsReactionStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('reactionCard', false);
    this.y2t_1 = tmp0_serialDesc;
  }
  z2t(encoder, value) {
    var tmp0_desc = this.y2t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_22().x2t_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a2u_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.b2u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z2t(encoder, value instanceof PlayCardAsReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_22().x2t_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlayCardAsReactionStatement.c2u(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.y2t_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_22().x2t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class PlayCardAsReactionStatement {
  constructor(characterObject, reactionCard) {
    Companion_getInstance_22();
    this.a2u_1 = characterObject;
    this.b2u_1 = reactionCard;
  }
  d2t() {
    return this.b2u_1;
  }
  toString() {
    return 'PlayCardAsReactionStatement(characterObject=' + this.a2u_1.toString() + ', reactionCard=' + toString(this.b2u_1) + ')';
  }
  hashCode() {
    var result = this.a2u_1.hashCode();
    result = imul(result, 31) + hashCode(this.b2u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayCardAsReactionStatement))
      return false;
    if (!this.a2u_1.equals(other.a2u_1))
      return false;
    if (!equals(this.b2u_1, other.b2u_1))
      return false;
    return true;
  }
  static c2u(seen0, characterObject, reactionCard, serializationConstructorMarker) {
    Companion_getInstance_22();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_18().y2t_1);
    }
    var $this = createThis(this);
    $this.a2u_1 = characterObject;
    $this.b2u_1 = reactionCard;
    return $this;
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_22 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d2u_1 = [lazy(tmp_0, SmokebombReactionStatement$Companion$$childSerializers$_anonymous__wjjfkb), null, null];
  }
}
class $serializer_19 {
  constructor() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SmokebombReactionStatement', this, 3);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('reactionCard', false);
    tmp0_serialDesc.h1b('damageComing', false);
    this.e2u_1 = tmp0_serialDesc;
  }
  f2u(encoder, value) {
    var tmp0_desc = this.e2u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_23().d2u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g2u_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_331(), value.h2u_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_123(), value.i2u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f2u(encoder, value instanceof SmokebombReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_23().d2u_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, $serializer_getInstance_331(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, $serializer_getInstance_123(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, $serializer_getInstance_331(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, $serializer_getInstance_123(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return SmokebombReactionStatement.j2u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.e2u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_23().d2u_1[0].k3(), $serializer_getInstance_331(), $serializer_getInstance_123()];
  }
}
class SmokebombReactionStatement {
  constructor(characterObject, reactionCard, damageComing) {
    Companion_getInstance_23();
    this.g2u_1 = characterObject;
    this.h2u_1 = reactionCard;
    this.i2u_1 = damageComing;
  }
  d2t() {
    return this.h2u_1;
  }
  toString() {
    return 'SmokebombReactionStatement(characterObject=' + this.g2u_1.toString() + ', reactionCard=' + this.h2u_1.toString() + ', damageComing=' + this.i2u_1.toString() + ')';
  }
  hashCode() {
    var result = this.g2u_1.hashCode();
    result = imul(result, 31) + this.h2u_1.hashCode() | 0;
    result = imul(result, 31) + this.i2u_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SmokebombReactionStatement))
      return false;
    if (!this.g2u_1.equals(other.g2u_1))
      return false;
    if (!this.h2u_1.equals(other.h2u_1))
      return false;
    if (!this.i2u_1.equals(other.i2u_1))
      return false;
    return true;
  }
  static j2u(seen0, characterObject, reactionCard, damageComing, serializationConstructorMarker) {
    Companion_getInstance_23();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_19().e2u_1);
    }
    var $this = createThis(this);
    $this.g2u_1 = characterObject;
    $this.h2u_1 = reactionCard;
    $this.i2u_1 = damageComing;
    return $this;
  }
}
class Companion_23 {
  constructor() {
    Companion_instance_23 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, SuddenMistReactionStatement$Companion$$childSerializers$_anonymous__yib2s);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k2u_1 = [tmp_1, lazy(tmp_2, SuddenMistReactionStatement$Companion$$childSerializers$_anonymous__yib2s_0)];
  }
}
class $serializer_20 {
  constructor() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SuddenMistReactionStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('reactionCard', false);
    this.l2u_1 = tmp0_serialDesc;
  }
  m2u(encoder, value) {
    var tmp0_desc = this.l2u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_24().k2u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n2u_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.o2u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m2u(encoder, value instanceof SuddenMistReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_24().k2u_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SuddenMistReactionStatement.p2u(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.l2u_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_24().k2u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class SuddenMistReactionStatement {
  constructor(characterObject, reactionCard) {
    Companion_getInstance_24();
    this.n2u_1 = characterObject;
    this.o2u_1 = reactionCard;
  }
  d2t() {
    return this.o2u_1;
  }
  toString() {
    return 'SuddenMistReactionStatement(characterObject=' + this.n2u_1.toString() + ', reactionCard=' + this.o2u_1.toString() + ')';
  }
  hashCode() {
    var result = this.n2u_1.hashCode();
    result = imul(result, 31) + this.o2u_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SuddenMistReactionStatement))
      return false;
    if (!this.n2u_1.equals(other.n2u_1))
      return false;
    if (!this.o2u_1.equals(other.o2u_1))
      return false;
    return true;
  }
  static p2u(seen0, characterObject, reactionCard, serializationConstructorMarker) {
    Companion_getInstance_24();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_20().l2u_1);
    }
    var $this = createThis(this);
    $this.n2u_1 = characterObject;
    $this.o2u_1 = reactionCard;
    return $this;
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_24 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q2u_1 = [lazy(tmp_0, WorldShiftReactionStatement$Companion$$childSerializers$_anonymous__rptl7w), null];
  }
}
class $serializer_21 {
  constructor() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('WorldShiftReactionStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('reactionCard', false);
    this.r2u_1 = tmp0_serialDesc;
  }
  s2u(encoder, value) {
    var tmp0_desc = this.r2u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_25().q2u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t2u_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_85(), value.u2u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s2u(encoder, value instanceof WorldShiftReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_25().q2u_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_85(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_85(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return WorldShiftReactionStatement.v2u(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r2u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_25().q2u_1[0].k3(), $serializer_getInstance_85()];
  }
}
class WorldShiftReactionStatement {
  constructor(characterObject, reactionCard) {
    Companion_getInstance_25();
    this.t2u_1 = characterObject;
    this.u2u_1 = reactionCard;
  }
  d2t() {
    return this.u2u_1;
  }
  toString() {
    return 'WorldShiftReactionStatement(characterObject=' + this.t2u_1.toString() + ', reactionCard=' + this.u2u_1.toString() + ')';
  }
  hashCode() {
    var result = this.t2u_1.hashCode();
    result = imul(result, 31) + this.u2u_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WorldShiftReactionStatement))
      return false;
    if (!this.t2u_1.equals(other.t2u_1))
      return false;
    if (!this.u2u_1.equals(other.u2u_1))
      return false;
    return true;
  }
  static v2u(seen0, characterObject, reactionCard, serializationConstructorMarker) {
    Companion_getInstance_25();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_21().r2u_1);
    }
    var $this = createThis(this);
    $this.t2u_1 = characterObject;
    $this.u2u_1 = reactionCard;
    return $this;
  }
}
class CannotBePlayedStatement {
  constructor() {
    CannotBePlayedStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w2u_1 = lazy(tmp_0, CannotBePlayedStatement$_anonymous__ho92v5);
  }
  n2o($context_GameStateRuntime_604ce3) {
    return false;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_3(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CannotBePlayedStatement';
  }
  hashCode() {
    return 962569713;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CannotBePlayedStatement))
      return false;
    return true;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_25 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x2u_1 = [lazy(tmp_0, ChainGrapnelStatement$Companion$$childSerializers$_anonymous__bd2qqd)];
  }
}
class $serializer_22 {
  constructor() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChainGrapnelStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.y2u_1 = tmp0_serialDesc;
  }
  z2u(encoder, value) {
    var tmp0_desc = this.y2u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_26().x2u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a2v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z2u(encoder, value instanceof ChainGrapnelStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_26().x2u_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ChainGrapnelStatement.b2v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y2u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_26().x2u_1[0].k3()];
  }
}
class ChainGrapnelStatement {
  constructor(hunter) {
    Companion_getInstance_26();
    this.a2v_1 = hunter;
  }
  toString() {
    return 'ChainGrapnelStatement(hunter=' + this.a2v_1.toString() + ')';
  }
  hashCode() {
    return this.a2v_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChainGrapnelStatement))
      return false;
    if (!this.a2v_1.equals(other.a2v_1))
      return false;
    return true;
  }
  static b2v(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_26();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_22().y2u_1);
    }
    var $this = createThis(this);
    $this.a2v_1 = hunter;
    return $this;
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c2v_1 = [lazy(tmp_0, ChargeUpgradeStatement$Companion$$childSerializers$_anonymous__q89kd9)];
  }
}
class $serializer_23 {
  constructor() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChargeUpgradeStatement', this, 1);
    tmp0_serialDesc.h1b('upgrade', false);
    this.d2v_1 = tmp0_serialDesc;
  }
  e2v(encoder, value) {
    var tmp0_desc = this.d2v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_27().c2v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f2v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e2v(encoder, value instanceof ChargeUpgradeStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_27().c2v_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ChargeUpgradeStatement.g2v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d2v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_27().c2v_1[0].k3()];
  }
}
class ChargeUpgradeStatement {
  constructor(upgrade) {
    Companion_getInstance_27();
    this.f2v_1 = upgrade;
  }
  toString() {
    return 'ChargeUpgradeStatement(upgrade=' + toString(this.f2v_1) + ')';
  }
  hashCode() {
    return hashCode(this.f2v_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChargeUpgradeStatement))
      return false;
    if (!equals(this.f2v_1, other.f2v_1))
      return false;
    return true;
  }
  static g2v(seen0, upgrade, serializationConstructorMarker) {
    Companion_getInstance_27();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_23().d2v_1);
    }
    var $this = createThis(this);
    $this.f2v_1 = upgrade;
    return $this;
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_27 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h2v_1 = [lazy(tmp_0, ChooseAndPlayOneCard$Companion$$childSerializers$_anonymous__hroq14)];
  }
}
class $serializer_24 {
  constructor() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChooseAndPlayOneCard', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.i2v_1 = tmp0_serialDesc;
  }
  j2v(encoder, value) {
    var tmp0_desc = this.i2v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_28().h2v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k2v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j2v(encoder, value instanceof ChooseAndPlayOneCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_28().h2v_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ChooseAndPlayOneCard.l2v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.i2v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_28().h2v_1[0].k3()];
  }
}
class ChooseAndPlayOneCard {
  constructor(characterObject) {
    Companion_getInstance_28();
    this.k2v_1 = characterObject;
  }
  toString() {
    return 'ChooseAndPlayOneCard(characterObject=' + this.k2v_1.toString() + ')';
  }
  hashCode() {
    return this.k2v_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChooseAndPlayOneCard))
      return false;
    if (!this.k2v_1.equals(other.k2v_1))
      return false;
    return true;
  }
  static l2v(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_28();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_24().i2v_1);
    }
    var $this = createThis(this);
    $this.k2v_1 = characterObject;
    return $this;
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_28 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m2v_1 = [lazy(tmp_0, ClaimRuinStatement$Companion$$childSerializers$_anonymous__sw4m73), null];
  }
}
class $serializer_25 {
  constructor() {
    $serializer_instance_25 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ClaimRuinStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('ruinPosition', false);
    this.n2v_1 = tmp0_serialDesc;
  }
  o2v(encoder, value) {
    var tmp0_desc = this.n2v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_29().m2v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p2v_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_100(), new BoardPosition(value.q2v_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o2v(encoder, value instanceof ClaimRuinStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_29().m2v_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ClaimRuinStatement.s2v(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.n2v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_29().m2v_1[0].k3(), $serializer_getInstance_100()];
  }
}
class ClaimRuinStatement {
  constructor(characterObject, ruinPosition) {
    Companion_getInstance_29();
    this.p2v_1 = characterObject;
    this.q2v_1 = ruinPosition;
  }
  toString() {
    return 'ClaimRuinStatement(characterObject=' + this.p2v_1.toString() + ', ruinPosition=' + BoardPosition__toString_impl_v4mn82(this.q2v_1) + ')';
  }
  hashCode() {
    var result = this.p2v_1.hashCode();
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.q2v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClaimRuinStatement))
      return false;
    if (!this.p2v_1.equals(other.p2v_1))
      return false;
    if (!(this.q2v_1 === other.q2v_1))
      return false;
    return true;
  }
  static s2v(seen0, characterObject, ruinPosition, serializationConstructorMarker) {
    Companion_getInstance_29();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_25().n2v_1);
    }
    var $this = createThis(this);
    $this.p2v_1 = characterObject;
    $this.q2v_1 = ruinPosition;
    return $this;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_29 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t2v_1 = [lazy(tmp_0, OptionalStatement$Companion$$childSerializers$_anonymous__po5rwb)];
  }
}
class $serializer_26 {
  constructor() {
    $serializer_instance_26 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OptionalStatement', this, 1);
    tmp0_serialDesc.h1b('statement', false);
    this.u2v_1 = tmp0_serialDesc;
  }
  v2v(encoder, value) {
    var tmp0_desc = this.u2v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_30().t2v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w2v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v2v(encoder, value instanceof OptionalStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_30().t2v_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return OptionalStatement.x2v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.u2v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_30().t2v_1[0].k3()];
  }
}
class OptionalStatement {
  constructor(statement) {
    Companion_getInstance_30();
    this.w2v_1 = statement;
  }
  v2o($context_GameState_t6qee5) {
    return setOf(this.w2v_1);
  }
  v2q() {
    return false;
  }
  o2o($context_GameStateRuntime_604ce3) {
    return this.w2v_1.o2o($context_GameStateRuntime_604ce3);
  }
  toString() {
    return 'OptionalStatement(statement=' + toString(this.w2v_1) + ')';
  }
  hashCode() {
    return hashCode(this.w2v_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OptionalStatement))
      return false;
    if (!equals(this.w2v_1, other.w2v_1))
      return false;
    return true;
  }
  static x2v(seen0, statement, serializationConstructorMarker) {
    Companion_getInstance_30();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_26().u2v_1);
    }
    var $this = createThis(this);
    $this.w2v_1 = statement;
    return $this;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_30 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y2v_1 = [lazy(tmp_0, SummonSignStatement$Companion$$childSerializers$_anonymous__mdx2ft), null];
  }
}
class $serializer_27 {
  constructor() {
    $serializer_instance_27 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SummonSignStatement', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('haveToChooseOne', true);
    this.z2v_1 = tmp0_serialDesc;
  }
  a2w(encoder, value) {
    var tmp0_desc = this.z2v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_31().y2v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.b2w_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.c2w_1 === true)) {
      tmp1_output.w14(tmp0_desc, 1, value.c2w_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a2w(encoder, value instanceof SummonSignStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_31().y2v_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SummonSignStatement.d2w(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.z2v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_31().y2v_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class SummonSignStatement {
  constructor(beast) {
    Companion_getInstance_31();
    this.b2w_1 = beast;
    this.c2w_1 = true;
  }
  v2o($context_GameState_t6qee5) {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet.v2();
    this_0.d2(new PlaceNewSummonStatement(this.b2w_1));
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!get_objectType($context_GameState_t6qee5, this.b2w_1).q2s($context_GameState_t6qee5).n1()) {
      this_0.d2(new ActivateSummonsStatement(this.b2w_1));
    }
    return this_0.g9();
  }
  v2q() {
    return this.c2w_1;
  }
  toString() {
    return 'SummonSignStatement(beast=' + this.b2w_1.toString() + ')';
  }
  hashCode() {
    return this.b2w_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonSignStatement))
      return false;
    if (!this.b2w_1.equals(other.b2w_1))
      return false;
    return true;
  }
  static d2w(seen0, beast, haveToChooseOne, serializationConstructorMarker) {
    Companion_getInstance_31();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_27().z2v_1);
    }
    var $this = createThis(this);
    $this.b2w_1 = beast;
    if (0 === (seen0 & 2))
      $this.c2w_1 = true;
    else
      $this.c2w_1 = haveToChooseOne;
    return $this;
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, CopyCardStatement$Companion$$childSerializers$_anonymous__dh8h28);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e2w_1 = [tmp_1, lazy(tmp_2, CopyCardStatement$Companion$$childSerializers$_anonymous__dh8h28_0)];
  }
}
class $serializer_28 {
  constructor() {
    $serializer_instance_28 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CopyCardStatement', this, 2);
    tmp0_serialDesc.h1b('playingCard', false);
    tmp0_serialDesc.h1b('actor', false);
    this.f2w_1 = tmp0_serialDesc;
  }
  g2w(encoder, value) {
    var tmp0_desc = this.f2w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_32().e2w_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h2w_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.i2w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g2w(encoder, value instanceof CopyCardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_32().e2w_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return CopyCardStatement.j2w(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.f2w_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_32().e2w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class CopyCardStatement {
  constructor(playingCard, actor) {
    Companion_getInstance_32();
    this.h2w_1 = playingCard;
    this.i2w_1 = actor;
  }
  toString() {
    return 'CopyCardStatement(playingCard=' + toString(this.h2w_1) + ', actor=' + this.i2w_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.h2w_1);
    result = imul(result, 31) + this.i2w_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CopyCardStatement))
      return false;
    if (!equals(this.h2w_1, other.h2w_1))
      return false;
    if (!this.i2w_1.equals(other.i2w_1))
      return false;
    return true;
  }
  static j2w(seen0, playingCard, actor, serializationConstructorMarker) {
    Companion_getInstance_32();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_28().f2w_1);
    }
    var $this = createThis(this);
    $this.h2w_1 = playingCard;
    $this.i2w_1 = actor;
    return $this;
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_32 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, DealDamageToSummonsStatement$Companion$$childSerializers$_anonymous__3fixt5);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k2w_1 = [tmp_1, lazy(tmp_2, DealDamageToSummonsStatement$Companion$$childSerializers$_anonymous__3fixt5_0)];
  }
}
class $serializer_29 {
  constructor() {
    $serializer_instance_29 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DealDamageToSummonsStatement', this, 2);
    tmp0_serialDesc.h1b('damageSource', false);
    tmp0_serialDesc.h1b('attacker', false);
    this.l2w_1 = tmp0_serialDesc;
  }
  m2w(encoder, value) {
    var tmp0_desc = this.l2w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_33().k2w_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n2w_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.o2w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m2w(encoder, value instanceof DealDamageToSummonsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_33().k2w_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return DealDamageToSummonsStatement.p2w(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.l2w_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_33().k2w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class DealDamageToSummonsStatement {
  constructor(damageSource, attacker) {
    Companion_getInstance_33();
    this.n2w_1 = damageSource;
    this.o2w_1 = attacker;
  }
  o2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.q2w($context_GameStateRuntime_604ce3, get_allObjectOnBoard($context_GameStateRuntime_604ce3)).n1();
  }
  q2w($context_GameState_t6qee5, allObjectOnBoard) {
    var nearbyPositions = get_nearbyPositions($context_GameState_t6qee5, this.o2w_1);
    // Inline function 'steelart.beast.castFilter' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = allObjectOnBoard.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$6;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp = get_objectType($context_GameState_t6qee5, element);
        if (isInterface(tmp, SummonType)) {
          tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
          break $l$block;
        }
        tmp$ret$6 = null;
      }
      var tmp0_safe_receiver = tmp$ret$6;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.d2(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = destination.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (nearbyPositions.w2(new BoardPosition(element_0.s2w($context_GameState_t6qee5)))) {
        destination_0.d2(element_0);
      }
    }
    var nearbySummons = destination_0;
    return toSet(nearbySummons);
  }
  toString() {
    return 'DealDamageToSummonsStatement(damageSource=' + toString(this.n2w_1) + ', attacker=' + this.o2w_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.n2w_1);
    result = imul(result, 31) + this.o2w_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DealDamageToSummonsStatement))
      return false;
    if (!equals(this.n2w_1, other.n2w_1))
      return false;
    if (!this.o2w_1.equals(other.o2w_1))
      return false;
    return true;
  }
  static p2w(seen0, damageSource, attacker, serializationConstructorMarker) {
    Companion_getInstance_33();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_29().l2w_1);
    }
    var $this = createThis(this);
    $this.n2w_1 = damageSource;
    $this.o2w_1 = attacker;
    return $this;
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_33 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t2w_1 = [lazy(tmp_0, DiscardCardsStatement$Companion$$childSerializers$_anonymous__fyyfc0), null];
  }
}
class $serializer_30 {
  constructor() {
    $serializer_instance_30 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DiscardCardsStatement', this, 2);
    tmp0_serialDesc.h1b('target', false);
    tmp0_serialDesc.h1b('cardsNumber', false);
    this.u2w_1 = tmp0_serialDesc;
  }
  v2w(encoder, value) {
    var tmp0_desc = this.u2w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_34().t2w_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w2w_1);
    tmp1_output.z14(tmp0_desc, 1, value.x2w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v2w(encoder, value instanceof DiscardCardsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_34().t2w_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return DiscardCardsStatement.y2w(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.u2w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_34().t2w_1[0].k3(), IntSerializer_getInstance()];
  }
}
class DiscardCardsStatement {
  constructor(target, cardsNumber) {
    Companion_getInstance_34();
    this.w2w_1 = target;
    this.x2w_1 = cardsNumber;
  }
  toString() {
    return 'DiscardCardsStatement(target=' + this.w2w_1.toString() + ', cardsNumber=' + this.x2w_1 + ')';
  }
  hashCode() {
    var result = this.w2w_1.hashCode();
    result = imul(result, 31) + this.x2w_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardCardsStatement))
      return false;
    if (!this.w2w_1.equals(other.w2w_1))
      return false;
    if (!(this.x2w_1 === other.x2w_1))
      return false;
    return true;
  }
  static y2w(seen0, target, cardsNumber, serializationConstructorMarker) {
    Companion_getInstance_34();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_30().u2w_1);
    }
    var $this = createThis(this);
    $this.w2w_1 = target;
    $this.x2w_1 = cardsNumber;
    return $this;
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_34 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z2w_1 = [lazy(tmp_0, DisplaceTransformLocationsStatement$Companion$$childSerializers$_anonymous__gmpvza)];
  }
}
class $serializer_31 {
  constructor() {
    $serializer_instance_31 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DisplaceTransformLocationsStatement', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.a2x_1 = tmp0_serialDesc;
  }
  b2x(encoder, value) {
    var tmp0_desc = this.a2x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_35().z2w_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c2x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b2x(encoder, value instanceof DisplaceTransformLocationsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_35().z2w_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DisplaceTransformLocationsStatement.d2x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a2x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_35().z2w_1[0].k3()];
  }
}
class DisplaceTransformLocationsStatement {
  constructor(characterObject) {
    Companion_getInstance_35();
    this.c2x_1 = characterObject;
  }
  toString() {
    return 'DisplaceTransformLocationsStatement(characterObject=' + this.c2x_1.toString() + ')';
  }
  hashCode() {
    return this.c2x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DisplaceTransformLocationsStatement))
      return false;
    if (!this.c2x_1.equals(other.c2x_1))
      return false;
    return true;
  }
  static d2x(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_35();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_31().a2x_1);
    }
    var $this = createThis(this);
    $this.c2x_1 = characterObject;
    return $this;
  }
}
class EmptyStatement {
  constructor() {
    EmptyStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e2x_1 = lazy(tmp_0, EmptyStatement$_anonymous__u3n6lx);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_4(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EmptyStatement';
  }
  hashCode() {
    return 562614439;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EmptyStatement))
      return false;
    return true;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_35 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f2x_1 = [lazy(tmp_0, EnsnareStatement$Companion$$childSerializers$_anonymous__809r6z)];
  }
}
class $serializer_32 {
  constructor() {
    $serializer_instance_32 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EnsnareStatement', this, 1);
    tmp0_serialDesc.h1b('player', false);
    this.g2x_1 = tmp0_serialDesc;
  }
  h2x(encoder, value) {
    var tmp0_desc = this.g2x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_36().f2x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i2x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h2x(encoder, value instanceof EnsnareStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_36().f2x_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return EnsnareStatement.j2x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g2x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_36().f2x_1[0].k3()];
  }
}
class EnsnareStatement {
  constructor(player) {
    Companion_getInstance_36();
    this.i2x_1 = player;
  }
  toString() {
    return 'EnsnareStatement(player=' + this.i2x_1.toString() + ')';
  }
  hashCode() {
    return this.i2x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EnsnareStatement))
      return false;
    if (!this.i2x_1.equals(other.i2x_1))
      return false;
    return true;
  }
  static j2x(seen0, player, serializationConstructorMarker) {
    Companion_getInstance_36();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_32().g2x_1);
    }
    var $this = createThis(this);
    $this.i2x_1 = player;
    return $this;
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_36 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k2x_1 = [lazy(tmp_0, FlourishStatement$Companion$$childSerializers$_anonymous__vt9p0t)];
  }
}
class $serializer_33 {
  constructor() {
    $serializer_instance_33 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FlourishStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.l2x_1 = tmp0_serialDesc;
  }
  m2x(encoder, value) {
    var tmp0_desc = this.l2x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_37().k2x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n2x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m2x(encoder, value instanceof FlourishStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_37().k2x_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return FlourishStatement.o2x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l2x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_37().k2x_1[0].k3()];
  }
}
class FlourishStatement {
  constructor(beast) {
    Companion_getInstance_37();
    this.n2x_1 = beast;
  }
  toString() {
    return 'FlourishStatement(beast=' + this.n2x_1.toString() + ')';
  }
  hashCode() {
    return this.n2x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FlourishStatement))
      return false;
    if (!this.n2x_1.equals(other.n2x_1))
      return false;
    return true;
  }
  static o2x(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_37();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_33().l2x_1);
    }
    var $this = createThis(this);
    $this.n2x_1 = beast;
    return $this;
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_37 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p2x_1 = [lazy(tmp_0, GainAncientPowerStatement$Companion$$childSerializers$_anonymous__8r2jfr), null];
  }
}
class $serializer_34 {
  constructor() {
    $serializer_instance_34 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainAncientPowerStatement', this, 2);
    tmp0_serialDesc.h1b('character', false);
    tmp0_serialDesc.h1b('fastApply', true);
    this.q2x_1 = tmp0_serialDesc;
  }
  r2x(encoder, value) {
    var tmp0_desc = this.q2x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_38().p2x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s2x_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.t2x_1 === true)) {
      tmp1_output.w14(tmp0_desc, 1, value.t2x_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r2x(encoder, value instanceof GainAncientPowerStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_38().p2x_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GainAncientPowerStatement.u2x(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.q2x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_38().p2x_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class GainAncientPowerStatement {
  constructor(character) {
    Companion_getInstance_38();
    this.s2x_1 = character;
    this.t2x_1 = true;
  }
  toString() {
    return 'GainAncientPowerStatement(character=' + this.s2x_1.toString() + ')';
  }
  hashCode() {
    return this.s2x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainAncientPowerStatement))
      return false;
    if (!this.s2x_1.equals(other.s2x_1))
      return false;
    return true;
  }
  static u2x(seen0, character, fastApply, serializationConstructorMarker) {
    Companion_getInstance_38();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_34().q2x_1);
    }
    var $this = createThis(this);
    $this.s2x_1 = character;
    if (0 === (seen0 & 2))
      $this.t2x_1 = true;
    else
      $this.t2x_1 = fastApply;
    return $this;
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_38 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v2x_1 = [lazy(tmp_0, GainBeastlyTalentStatement$Companion$$childSerializers$_anonymous__z93gp8), null];
  }
}
class $serializer_35 {
  constructor() {
    $serializer_instance_35 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainBeastlyTalentStatement', this, 2);
    tmp0_serialDesc.h1b('beasts', false);
    tmp0_serialDesc.h1b('talentsNumber', false);
    this.w2x_1 = tmp0_serialDesc;
  }
  x2x(encoder, value) {
    var tmp0_desc = this.w2x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_39().v2x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y2x_1);
    tmp1_output.z14(tmp0_desc, 1, value.z2x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x2x(encoder, value instanceof GainBeastlyTalentStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_39().v2x_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GainBeastlyTalentStatement.a2y(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.w2x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_39().v2x_1[0].k3(), IntSerializer_getInstance()];
  }
}
class GainBeastlyTalentStatement {
  constructor(beasts, talentsNumber) {
    Companion_getInstance_39();
    this.y2x_1 = beasts;
    this.z2x_1 = talentsNumber;
  }
  o2o($context_GameStateRuntime_604ce3) {
    return !noAvailableArsenalCards(get_beastlyTalents($context_GameStateRuntime_604ce3));
  }
  toString() {
    return 'GainBeastlyTalentStatement(beasts=' + toString(this.y2x_1) + ', talentsNumber=' + this.z2x_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.y2x_1);
    result = imul(result, 31) + this.z2x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainBeastlyTalentStatement))
      return false;
    if (!equals(this.y2x_1, other.y2x_1))
      return false;
    if (!(this.z2x_1 === other.z2x_1))
      return false;
    return true;
  }
  static a2y(seen0, beasts, talentsNumber, serializationConstructorMarker) {
    Companion_getInstance_39();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_35().w2x_1);
    }
    var $this = createThis(this);
    $this.y2x_1 = beasts;
    $this.z2x_1 = talentsNumber;
    return $this;
  }
}
class Companion_39 {
  constructor() {
    Companion_instance_39 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b2y_1 = [lazy(tmp_0, GainGrudgeStatement$Companion$$childSerializers$_anonymous__qmo3w2), null, null];
  }
}
class $serializer_36 {
  constructor() {
    $serializer_instance_36 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainGrudgeStatement', this, 3);
    tmp0_serialDesc.h1b('characters', false);
    tmp0_serialDesc.h1b('grudgesNumber', false);
    tmp0_serialDesc.h1b('fastApply', true);
    this.c2y_1 = tmp0_serialDesc;
  }
  d2y(encoder, value) {
    var tmp0_desc = this.c2y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_40().b2y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.e2y_1);
    tmp1_output.z14(tmp0_desc, 1, value.f2y_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.g2y_1 === true)) {
      tmp1_output.w14(tmp0_desc, 2, value.g2y_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d2y(encoder, value instanceof GainGrudgeStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c2y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_40().b2y_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return GainGrudgeStatement.h2y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.c2y_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_40().b2y_1[0].k3(), IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class GainGrudgeStatement {
  constructor(characters, grudgesNumber) {
    Companion_getInstance_40();
    this.e2y_1 = characters;
    this.f2y_1 = grudgesNumber;
    this.g2y_1 = true;
  }
  toString() {
    return 'GainGrudgeStatement(characters=' + toString(this.e2y_1) + ', grudgesNumber=' + this.f2y_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.e2y_1);
    result = imul(result, 31) + this.f2y_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainGrudgeStatement))
      return false;
    if (!equals(this.e2y_1, other.e2y_1))
      return false;
    if (!(this.f2y_1 === other.f2y_1))
      return false;
    return true;
  }
  static h2y(seen0, characters, grudgesNumber, fastApply, serializationConstructorMarker) {
    Companion_getInstance_40();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_36().c2y_1);
    }
    var $this = createThis(this);
    $this.e2y_1 = characters;
    $this.f2y_1 = grudgesNumber;
    if (0 === (seen0 & 4))
      $this.g2y_1 = true;
    else
      $this.g2y_1 = fastApply;
    return $this;
  }
}
class Companion_40 {
  constructor() {
    Companion_instance_40 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i2y_1 = [lazy(tmp_0, GainRandomUnusedDraftActionCardStatement$Companion$$childSerializers$_anonymous__2sczx2)];
  }
}
class $serializer_37 {
  constructor() {
    $serializer_instance_37 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainRandomUnusedDraftActionCardStatement', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.j2y_1 = tmp0_serialDesc;
  }
  k2y(encoder, value) {
    var tmp0_desc = this.j2y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_41().i2y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l2y_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k2y(encoder, value instanceof GainRandomUnusedDraftActionCardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j2y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_41().i2y_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GainRandomUnusedDraftActionCardStatement.m2y(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.j2y_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_41().i2y_1[0].k3()];
  }
}
class GainRandomUnusedDraftActionCardStatement {
  constructor(characterObject) {
    Companion_getInstance_41();
    this.l2y_1 = characterObject;
  }
  toString() {
    return 'GainRandomUnusedDraftActionCardStatement(characterObject=' + this.l2y_1.toString() + ')';
  }
  hashCode() {
    return this.l2y_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainRandomUnusedDraftActionCardStatement))
      return false;
    if (!this.l2y_1.equals(other.l2y_1))
      return false;
    return true;
  }
  static m2y(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_41();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_37().j2y_1);
    }
    var $this = createThis(this);
    $this.l2y_1 = characterObject;
    return $this;
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_41 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n2y_1 = [lazy(tmp_0, GlimpsBeastsStatement$Companion$$childSerializers$_anonymous__5tjs1n)];
  }
}
class $serializer_38 {
  constructor() {
    $serializer_instance_38 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GlimpsBeastsStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.o2y_1 = tmp0_serialDesc;
  }
  p2y(encoder, value) {
    var tmp0_desc = this.o2y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_42().n2y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q2y_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p2y(encoder, value instanceof GlimpsBeastsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o2y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_42().n2y_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GlimpsBeastsStatement.r2y(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.o2y_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_42().n2y_1[0].k3()];
  }
}
class GlimpsBeastsStatement {
  constructor(beast) {
    Companion_getInstance_42();
    this.q2y_1 = beast;
  }
  n2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.s2y($context_GameStateRuntime_604ce3).n1();
  }
  s2y($context_GameState_t6qee5) {
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = get_beastlyTalents($context_GameState_t6qee5).u2y_1;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(element == null) ? isInterface(element, PlayableInTurnCard) : false) {
        destination.d2(element);
      }
    }
    return destination;
  }
  toString() {
    return 'GlimpsBeastsStatement(beast=' + this.q2y_1.toString() + ')';
  }
  hashCode() {
    return this.q2y_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlimpsBeastsStatement))
      return false;
    if (!this.q2y_1.equals(other.q2y_1))
      return false;
    return true;
  }
  static r2y(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_42();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_38().o2y_1);
    }
    var $this = createThis(this);
    $this.q2y_1 = beast;
    return $this;
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_42 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x2y_1 = [lazy(tmp_0, GlipsHuntersStatement$Companion$$childSerializers$_anonymous__squba1)];
  }
}
class $serializer_39 {
  constructor() {
    $serializer_instance_39 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GlipsHuntersStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.y2y_1 = tmp0_serialDesc;
  }
  z2y(encoder, value) {
    var tmp0_desc = this.y2y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_43().x2y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a2z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z2y(encoder, value instanceof GlipsHuntersStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y2y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_43().x2y_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GlipsHuntersStatement.b2z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y2y_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_43().x2y_1[0].k3()];
  }
}
class GlipsHuntersStatement {
  constructor(hunter) {
    Companion_getInstance_43();
    this.a2z_1 = hunter;
  }
  toString() {
    return 'GlipsHuntersStatement(hunter=' + this.a2z_1.toString() + ')';
  }
  hashCode() {
    return this.a2z_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlipsHuntersStatement))
      return false;
    if (!this.a2z_1.equals(other.a2z_1))
      return false;
    return true;
  }
  static b2z(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_43();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_39().y2y_1);
    }
    var $this = createThis(this);
    $this.a2z_1 = hunter;
    return $this;
  }
}
class Companion_43 {
  constructor() {
    Companion_instance_43 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c2z_1 = [lazy(tmp_0, HealNearHunterStatement$Companion$$childSerializers$_anonymous__y2l1ij)];
  }
}
class $serializer_40 {
  constructor() {
    $serializer_instance_40 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HealNearHunterStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.d2z_1 = tmp0_serialDesc;
  }
  e2z(encoder, value) {
    var tmp0_desc = this.d2z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_44().c2z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f2z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e2z(encoder, value instanceof HealNearHunterStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_44().c2z_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return HealNearHunterStatement.g2z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d2z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_44().c2z_1[0].k3()];
  }
}
class HealNearHunterStatement {
  constructor(hunter) {
    Companion_getInstance_44();
    this.f2z_1 = hunter;
  }
  toString() {
    return 'HealNearHunterStatement(hunter=' + this.f2z_1.toString() + ')';
  }
  hashCode() {
    return this.f2z_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HealNearHunterStatement))
      return false;
    if (!this.f2z_1.equals(other.f2z_1))
      return false;
    return true;
  }
  static g2z(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_44();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_40().d2z_1);
    }
    var $this = createThis(this);
    $this.f2z_1 = hunter;
    return $this;
  }
}
class Companion_44 {
  constructor() {
    Companion_instance_44 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h2z_1 = [lazy(tmp_0, HealNearbyHuntersAndSettlersStatement$Companion$$childSerializers$_anonymous__uqp88i)];
  }
}
class $serializer_41 {
  constructor() {
    $serializer_instance_41 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HealNearbyHuntersAndSettlersStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.i2z_1 = tmp0_serialDesc;
  }
  j2z(encoder, value) {
    var tmp0_desc = this.i2z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_45().h2z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k2z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j2z(encoder, value instanceof HealNearbyHuntersAndSettlersStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_45().h2z_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return HealNearbyHuntersAndSettlersStatement.l2z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.i2z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_45().h2z_1[0].k3()];
  }
}
class HealNearbyHuntersAndSettlersStatement {
  constructor(hunter) {
    Companion_getInstance_45();
    this.k2z_1 = hunter;
  }
  o2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.m2z($context_GameStateRuntime_604ce3).n1();
  }
  m2z($context_GameState_t6qee5) {
    var nearbyPositions = get_nearbyPositions($context_GameState_t6qee5, this.k2z_1);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp;
      var tmp_0 = get_objectType($context_GameState_t6qee5, element);
      if (isInterface(tmp_0, SettlerType)) {
        tmp = true;
      } else {
        var tmp_1 = get_objectType($context_GameState_t6qee5, element);
        tmp = isInterface(tmp_1, HunterCharacter);
      }
      if (tmp) {
        destination.d2(element);
      }
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = destination.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (nearbyPositions.w2(new BoardPosition(element_0.s2w($context_GameState_t6qee5))) && get_hp($context_GameState_t6qee5, element_0) < get_objectType($context_GameState_t6qee5, element_0).n2z($context_GameState_t6qee5)) {
        destination_0.d2(element_0);
      }
    }
    var targets = toSet(destination_0);
    return targets;
  }
  toString() {
    return 'HealNearbyHuntersAndSettlersStatement(hunter=' + this.k2z_1.toString() + ')';
  }
  hashCode() {
    return this.k2z_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HealNearbyHuntersAndSettlersStatement))
      return false;
    if (!this.k2z_1.equals(other.k2z_1))
      return false;
    return true;
  }
  static l2z(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_45();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_41().i2z_1);
    }
    var $this = createThis(this);
    $this.k2z_1 = hunter;
    return $this;
  }
}
class Companion_45 {
  constructor() {
    Companion_instance_45 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o2z_1 = [lazy(tmp_0, LureStatement$Companion$$childSerializers$_anonymous__77c07r), null];
  }
}
class $serializer_42 {
  constructor() {
    $serializer_instance_42 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LureStatement', this, 2);
    tmp0_serialDesc.h1b('luringObject', false);
    tmp0_serialDesc.h1b('affectsAllBeings', false);
    this.p2z_1 = tmp0_serialDesc;
  }
  q2z(encoder, value) {
    var tmp0_desc = this.p2z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_46().o2z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r2z_1);
    tmp1_output.w14(tmp0_desc, 1, value.s2z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q2z(encoder, value instanceof LureStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_46().o2z_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return LureStatement.t2z(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.p2z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_46().o2z_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class LureStatement {
  constructor(luringObject, affectsAllBeings) {
    Companion_getInstance_46();
    this.r2z_1 = luringObject;
    this.s2z_1 = affectsAllBeings;
  }
  toString() {
    return 'LureStatement(luringObject=' + this.r2z_1.toString() + ', affectsAllBeings=' + this.s2z_1 + ')';
  }
  hashCode() {
    var result = this.r2z_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.s2z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LureStatement))
      return false;
    if (!this.r2z_1.equals(other.r2z_1))
      return false;
    if (!(this.s2z_1 === other.s2z_1))
      return false;
    return true;
  }
  static t2z(seen0, luringObject, affectsAllBeings, serializationConstructorMarker) {
    Companion_getInstance_46();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_42().p2z_1);
    }
    var $this = createThis(this);
    $this.r2z_1 = luringObject;
    $this.s2z_1 = affectsAllBeings;
    return $this;
  }
}
class Companion_46 {
  constructor() {
    Companion_instance_46 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u2z_1 = [lazy(tmp_0, MoveAnimalStatement$Companion$$childSerializers$_anonymous__gaadlk), null];
  }
}
class $serializer_43 {
  constructor() {
    $serializer_instance_43 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MoveAnimalStatement', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('isInZone', false);
    this.v2z_1 = tmp0_serialDesc;
  }
  w2z(encoder, value) {
    var tmp0_desc = this.v2z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_47().u2z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x2z_1);
    tmp1_output.w14(tmp0_desc, 1, value.y2z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w2z(encoder, value instanceof MoveAnimalStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_47().u2z_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return MoveAnimalStatement.z2z(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.v2z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_47().u2z_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class MoveAnimalStatement {
  constructor(beast, isInZone) {
    Companion_getInstance_47();
    this.x2z_1 = beast;
    this.y2z_1 = isInZone;
  }
  toString() {
    return 'MoveAnimalStatement(beast=' + this.x2z_1.toString() + ', isInZone=' + this.y2z_1 + ')';
  }
  hashCode() {
    var result = this.x2z_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.y2z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MoveAnimalStatement))
      return false;
    if (!this.x2z_1.equals(other.x2z_1))
      return false;
    if (!(this.y2z_1 === other.y2z_1))
      return false;
    return true;
  }
  static z2z(seen0, beast, isInZone, serializationConstructorMarker) {
    Companion_getInstance_47();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_43().v2z_1);
    }
    var $this = createThis(this);
    $this.x2z_1 = beast;
    $this.y2z_1 = isInZone;
    return $this;
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_47 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a30_1 = [lazy(tmp_0, BeastMovesDependingOnHuntersStatement$Companion$$childSerializers$_anonymous__ev3k90)];
  }
}
class $serializer_44 {
  constructor() {
    $serializer_instance_44 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeastMovesDependingOnHuntersStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.b30_1 = tmp0_serialDesc;
  }
  c30(encoder, value) {
    var tmp0_desc = this.b30_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_48().a30_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d30_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c30(encoder, value instanceof BeastMovesDependingOnHuntersStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_48().a30_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BeastMovesDependingOnHuntersStatement.e30(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b30_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_48().a30_1[0].k3()];
  }
}
class BeastMovesDependingOnHuntersStatement extends BeastMovementStatement {
  constructor(movingObject) {
    Companion_getInstance_48();
    super();
    this.d30_1 = movingObject;
  }
  f2p() {
    return this.d30_1;
  }
  toString() {
    return 'BeastMovesDependingOnHuntersStatement(movingObject=' + this.d30_1.toString() + ')';
  }
  hashCode() {
    return this.d30_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastMovesDependingOnHuntersStatement))
      return false;
    if (!this.d30_1.equals(other.d30_1))
      return false;
    return true;
  }
  static e30(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_48();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_44().b30_1);
    }
    var $this = this.f2q(seen0, serializationConstructorMarker);
    $this.d30_1 = movingObject;
    return $this;
  }
}
class Companion_48 {
  constructor() {
    Companion_instance_48 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f30_1 = [lazy(tmp_0, BeastMovesDependingOnSummonsNumberStatement$Companion$$childSerializers$_anonymous__qplm90)];
  }
}
class $serializer_45 {
  constructor() {
    $serializer_instance_45 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeastMovesDependingOnSummonsNumberStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.g30_1 = tmp0_serialDesc;
  }
  h30(encoder, value) {
    var tmp0_desc = this.g30_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_49().f30_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i30_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h30(encoder, value instanceof BeastMovesDependingOnSummonsNumberStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_49().f30_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BeastMovesDependingOnSummonsNumberStatement.j30(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g30_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_49().f30_1[0].k3()];
  }
}
class BeastMovesDependingOnSummonsNumberStatement extends BeastMovementStatement {
  constructor(movingObject) {
    Companion_getInstance_49();
    super();
    this.i30_1 = movingObject;
  }
  f2p() {
    return this.i30_1;
  }
  toString() {
    return 'BeastMovesDependingOnSummonsNumberStatement(movingObject=' + this.i30_1.toString() + ')';
  }
  hashCode() {
    return this.i30_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastMovesDependingOnSummonsNumberStatement))
      return false;
    if (!this.i30_1.equals(other.i30_1))
      return false;
    return true;
  }
  static j30(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_49();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_45().g30_1);
    }
    var $this = this.f2q(seen0, serializationConstructorMarker);
    $this.i30_1 = movingObject;
    return $this;
  }
}
class Companion_49 {
  constructor() {
    Companion_instance_49 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k30_1 = [lazy(tmp_0, BeastMovesSameZoneStatement$Companion$$childSerializers$_anonymous__k82g7k)];
  }
}
class $serializer_46 {
  constructor() {
    $serializer_instance_46 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeastMovesSameZoneStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.l30_1 = tmp0_serialDesc;
  }
  m30(encoder, value) {
    var tmp0_desc = this.l30_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_50().k30_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n30_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m30(encoder, value instanceof BeastMovesSameZoneStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_50().k30_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BeastMovesSameZoneStatement.o30(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l30_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_50().k30_1[0].k3()];
  }
}
class BeastMovesSameZoneStatement extends BeastMovementStatement {
  constructor(movingObject) {
    Companion_getInstance_50();
    super();
    this.n30_1 = movingObject;
  }
  f2p() {
    return this.n30_1;
  }
  toString() {
    return 'BeastMovesSameZoneStatement(movingObject=' + this.n30_1.toString() + ')';
  }
  hashCode() {
    return this.n30_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastMovesSameZoneStatement))
      return false;
    if (!this.n30_1.equals(other.n30_1))
      return false;
    return true;
  }
  static o30(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_50();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_46().l30_1);
    }
    var $this = this.f2q(seen0, serializationConstructorMarker);
    $this.n30_1 = movingObject;
    return $this;
  }
}
class Companion_50 {
  constructor() {
    Companion_instance_50 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p30_1 = [lazy(tmp_0, FixedDirectionBeastMovementStatement$Companion$$childSerializers$_anonymous__n3n3lu), null, null];
  }
}
class $serializer_47 {
  constructor() {
    $serializer_instance_47 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FixedDirectionBeastMovementStatement', this, 3);
    tmp0_serialDesc.h1b('movingObject', false);
    tmp0_serialDesc.h1b('maxSteps', false);
    tmp0_serialDesc.h1b('stopEarlier', true);
    this.q30_1 = tmp0_serialDesc;
  }
  r30(encoder, value) {
    var tmp0_desc = this.q30_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_51().p30_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s30_1);
    tmp1_output.z14(tmp0_desc, 1, value.t30_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.u30_1 === false)) {
      tmp1_output.w14(tmp0_desc, 2, value.u30_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r30(encoder, value instanceof FixedDirectionBeastMovementStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_51().p30_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return FixedDirectionBeastMovementStatement.v30(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.q30_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_51().p30_1[0].k3(), IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class FixedDirectionBeastMovementStatement extends BeastMovementStatement {
  constructor(movingObject, maxSteps, stopEarlier) {
    Companion_getInstance_51();
    stopEarlier = stopEarlier === VOID ? false : stopEarlier;
    super();
    this.s30_1 = movingObject;
    this.t30_1 = maxSteps;
    this.u30_1 = stopEarlier;
  }
  f2p() {
    return this.s30_1;
  }
  toString() {
    return 'FixedDirectionBeastMovementStatement(movingObject=' + this.s30_1.toString() + ', maxSteps=' + this.t30_1 + ', stopEarlier=' + this.u30_1 + ')';
  }
  hashCode() {
    var result = this.s30_1.hashCode();
    result = imul(result, 31) + this.t30_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u30_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FixedDirectionBeastMovementStatement))
      return false;
    if (!this.s30_1.equals(other.s30_1))
      return false;
    if (!(this.t30_1 === other.t30_1))
      return false;
    if (!(this.u30_1 === other.u30_1))
      return false;
    return true;
  }
  static v30(seen0, movingObject, maxSteps, stopEarlier, serializationConstructorMarker) {
    Companion_getInstance_51();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_47().q30_1);
    }
    var $this = this.f2q(seen0, serializationConstructorMarker);
    $this.s30_1 = movingObject;
    $this.t30_1 = maxSteps;
    if (0 === (seen0 & 4))
      $this.u30_1 = false;
    else
      $this.u30_1 = stopEarlier;
    return $this;
  }
}
class Companion_51 {
  constructor() {
    Companion_instance_51 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w30_1 = [lazy(tmp_0, TrackStatement$Companion$$childSerializers$_anonymous__vpyxfq), null, null];
  }
}
class $serializer_48 {
  constructor() {
    $serializer_instance_48 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TrackStatement', this, 3);
    tmp0_serialDesc.h1b('movingObject', false);
    tmp0_serialDesc.h1b('maxSteps', false);
    tmp0_serialDesc.h1b('onlyInSameZone', true);
    this.x30_1 = tmp0_serialDesc;
  }
  y30(encoder, value) {
    var tmp0_desc = this.x30_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_52().w30_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.z30_1);
    tmp1_output.i15(tmp0_desc, 1, IntSerializer_getInstance(), value.a31_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.b31_1 === false)) {
      tmp1_output.w14(tmp0_desc, 2, value.b31_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y30(encoder, value instanceof TrackStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_52().w30_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return TrackStatement.c31(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.x30_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_52().w30_1[0].k3(), get_nullable(IntSerializer_getInstance()), BooleanSerializer_getInstance()];
  }
}
class TrackStatement extends MovementStepByStepStatement {
  constructor(movingObject, maxSteps, onlyInSameZone) {
    Companion_getInstance_52();
    onlyInSameZone = onlyInSameZone === VOID ? false : onlyInSameZone;
    super();
    this.z30_1 = movingObject;
    this.a31_1 = maxSteps;
    this.b31_1 = onlyInSameZone;
  }
  f2p() {
    return this.z30_1;
  }
  toString() {
    return 'TrackStatement(movingObject=' + this.z30_1.toString() + ', maxSteps=' + this.a31_1 + ', onlyInSameZone=' + this.b31_1 + ')';
  }
  hashCode() {
    var result = this.z30_1.hashCode();
    result = imul(result, 31) + (this.a31_1 == null ? 0 : this.a31_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b31_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrackStatement))
      return false;
    if (!this.z30_1.equals(other.z30_1))
      return false;
    if (!(this.a31_1 == other.a31_1))
      return false;
    if (!(this.b31_1 === other.b31_1))
      return false;
    return true;
  }
  static c31(seen0, movingObject, maxSteps, onlyInSameZone, serializationConstructorMarker) {
    Companion_getInstance_52();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_48().x30_1);
    }
    var $this = this.g2p(seen0, serializationConstructorMarker);
    $this.z30_1 = movingObject;
    $this.a31_1 = maxSteps;
    if (0 === (seen0 & 4))
      $this.b31_1 = false;
    else
      $this.b31_1 = onlyInSameZone;
    return $this;
  }
}
class Companion_52 {
  constructor() {
    Companion_instance_52 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d31_1 = [lazy(tmp_0, WarhogsTuskStatement$Companion$$childSerializers$_anonymous__y3eo4v)];
  }
}
class $serializer_49 {
  constructor() {
    $serializer_instance_49 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('WarhogsTuskStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.e31_1 = tmp0_serialDesc;
  }
  f31(encoder, value) {
    var tmp0_desc = this.e31_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_53().d31_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g31_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f31(encoder, value instanceof WarhogsTuskStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_53().d31_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return WarhogsTuskStatement.h31(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e31_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_53().d31_1[0].k3()];
  }
}
class WarhogsTuskStatement extends MovementStepByStepStatement {
  constructor(movingObject) {
    Companion_getInstance_53();
    super();
    this.g31_1 = movingObject;
  }
  f2p() {
    return this.g31_1;
  }
  toString() {
    return 'WarhogsTuskStatement(movingObject=' + this.g31_1.toString() + ')';
  }
  hashCode() {
    return this.g31_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WarhogsTuskStatement))
      return false;
    if (!this.g31_1.equals(other.g31_1))
      return false;
    return true;
  }
  static h31(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_53();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_49().e31_1);
    }
    var $this = this.g2p(seen0, serializationConstructorMarker);
    $this.g31_1 = movingObject;
    return $this;
  }
}
class Companion_53 {
  constructor() {
    Companion_instance_53 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i31_1 = [lazy(tmp_0, RelocationInRangeStatement$Companion$$childSerializers$_anonymous__f7k6qd), null];
  }
}
class $serializer_50 {
  constructor() {
    $serializer_instance_50 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RelocationInRangeStatement', this, 2);
    tmp0_serialDesc.h1b('movingObject', false);
    tmp0_serialDesc.h1b('range', false);
    this.j31_1 = tmp0_serialDesc;
  }
  k31(encoder, value) {
    var tmp0_desc = this.j31_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_54().i31_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l31_1);
    tmp1_output.z14(tmp0_desc, 1, value.m31_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k31(encoder, value instanceof RelocationInRangeStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_54().i31_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RelocationInRangeStatement.n31(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.j31_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_54().i31_1[0].k3(), IntSerializer_getInstance()];
  }
}
class RelocationInRangeStatement {
  constructor(movingObject, range) {
    Companion_getInstance_54();
    this.l31_1 = movingObject;
    this.m31_1 = range;
  }
  f2p() {
    return this.l31_1;
  }
  toString() {
    return 'RelocationInRangeStatement(movingObject=' + this.l31_1.toString() + ', range=' + this.m31_1 + ')';
  }
  hashCode() {
    var result = this.l31_1.hashCode();
    result = imul(result, 31) + this.m31_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RelocationInRangeStatement))
      return false;
    if (!this.l31_1.equals(other.l31_1))
      return false;
    if (!(this.m31_1 === other.m31_1))
      return false;
    return true;
  }
  static n31(seen0, movingObject, range, serializationConstructorMarker) {
    Companion_getInstance_54();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_50().j31_1);
    }
    var $this = createThis(this);
    $this.l31_1 = movingObject;
    $this.m31_1 = range;
    return $this;
  }
}
class Companion_54 {
  constructor() {
    Companion_instance_54 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o31_1 = [lazy(tmp_0, OverloadedShatterStatement$Companion$$childSerializers$_anonymous__7cfp7p)];
  }
}
class $serializer_51 {
  constructor() {
    $serializer_instance_51 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OverloadedShatterStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.p31_1 = tmp0_serialDesc;
  }
  q31(encoder, value) {
    var tmp0_desc = this.p31_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_55().o31_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r31_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q31(encoder, value instanceof OverloadedShatterStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_55().o31_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return OverloadedShatterStatement.s31(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.p31_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_55().o31_1[0].k3()];
  }
}
class OverloadedShatterStatement {
  constructor(beast) {
    Companion_getInstance_55();
    this.r31_1 = beast;
  }
  toString() {
    return 'OverloadedShatterStatement(beast=' + this.r31_1.toString() + ')';
  }
  hashCode() {
    return this.r31_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OverloadedShatterStatement))
      return false;
    if (!this.r31_1.equals(other.r31_1))
      return false;
    return true;
  }
  static s31(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_55();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_51().p31_1);
    }
    var $this = createThis(this);
    $this.r31_1 = beast;
    return $this;
  }
}
class Companion_55 {
  constructor() {
    Companion_instance_55 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, AvariceCardHuntersStatement$Companion$$childSerializers$_anonymous__qnmhmv);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t31_1 = [tmp_1, lazy(tmp_2, AvariceCardHuntersStatement$Companion$$childSerializers$_anonymous__qnmhmv_0)];
  }
}
class $serializer_52 {
  constructor() {
    $serializer_instance_52 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AvariceCardHuntersStatement', this, 2);
    tmp0_serialDesc.h1b('card', false);
    tmp0_serialDesc.h1b('hunters', false);
    this.u31_1 = tmp0_serialDesc;
  }
  v31(encoder, value) {
    var tmp0_desc = this.u31_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_56().t31_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w31_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.x31_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v31(encoder, value instanceof AvariceCardHuntersStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_56().t31_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return AvariceCardHuntersStatement.y31(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.u31_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_56().t31_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class AvariceCardHuntersStatement extends PerformForEachHunter {
  constructor(card, hunters) {
    Companion_getInstance_56();
    super();
    this.w31_1 = card;
    this.x31_1 = hunters;
  }
  toString() {
    return 'AvariceCardHuntersStatement(card=' + toString(this.w31_1) + ', hunters=' + toString(this.x31_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.w31_1);
    result = imul(result, 31) + hashCode(this.x31_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AvariceCardHuntersStatement))
      return false;
    if (!equals(this.w31_1, other.w31_1))
      return false;
    if (!equals(this.x31_1, other.x31_1))
      return false;
    return true;
  }
  static y31(seen0, card, hunters, serializationConstructorMarker) {
    Companion_getInstance_56();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_52().u31_1);
    }
    var $this = this.n2p(seen0, serializationConstructorMarker);
    $this.w31_1 = card;
    $this.x31_1 = hunters;
    return $this;
  }
}
class Companion_56 {
  constructor() {
    Companion_instance_56 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z31_1 = [lazy(tmp_0, RetrieveDiscardedAbilitiesStatement$Companion$$childSerializers$_anonymous__4hx0gy)];
  }
}
class $serializer_53 {
  constructor() {
    $serializer_instance_53 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RetrieveDiscardedAbilitiesStatement', this, 1);
    tmp0_serialDesc.h1b('hunters', false);
    this.a32_1 = tmp0_serialDesc;
  }
  b32(encoder, value) {
    var tmp0_desc = this.a32_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_57().z31_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c32_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b32(encoder, value instanceof RetrieveDiscardedAbilitiesStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_57().z31_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RetrieveDiscardedAbilitiesStatement.d32(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a32_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_57().z31_1[0].k3()];
  }
}
class RetrieveDiscardedAbilitiesStatement extends PerformForEachHunter {
  constructor(hunters) {
    Companion_getInstance_57();
    super();
    this.c32_1 = hunters;
  }
  toString() {
    return 'RetrieveDiscardedAbilitiesStatement(hunters=' + toString(this.c32_1) + ')';
  }
  hashCode() {
    return hashCode(this.c32_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RetrieveDiscardedAbilitiesStatement))
      return false;
    if (!equals(this.c32_1, other.c32_1))
      return false;
    return true;
  }
  static d32(seen0, hunters, serializationConstructorMarker) {
    Companion_getInstance_57();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_53().a32_1);
    }
    var $this = this.n2p(seen0, serializationConstructorMarker);
    $this.c32_1 = hunters;
    return $this;
  }
}
class Companion_57 {
  constructor() {
    Companion_instance_57 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e32_1 = [lazy(tmp_0, PlaceNewSummonNearbyStatement$Companion$$childSerializers$_anonymous__vrqgdw), null];
  }
}
class $serializer_54 {
  constructor() {
    $serializer_instance_54 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceNewSummonNearbyStatement', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('isOnlyOnHisLocation', false);
    this.f32_1 = tmp0_serialDesc;
  }
  g32(encoder, value) {
    var tmp0_desc = this.f32_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_58().e32_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h32_1);
    tmp1_output.w14(tmp0_desc, 1, value.i32_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g32(encoder, value instanceof PlaceNewSummonNearbyStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_58().e32_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlaceNewSummonNearbyStatement.j32(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.f32_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_58().e32_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class PlaceNewSummonBaseStatement {
  constructor() {
    Companion_getInstance_76();
  }
  n2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.k32($context_GameStateRuntime_604ce3).n1();
  }
  static q32(seen0, serializationConstructorMarker) {
    Companion_getInstance_76();
    return createThis(this);
  }
}
class PlaceNewSummonNearbyStatement extends PlaceNewSummonBaseStatement {
  constructor(beast, isOnlyOnHisLocation) {
    Companion_getInstance_58();
    super();
    this.h32_1 = beast;
    this.i32_1 = isOnlyOnHisLocation;
  }
  k32($context_GameState_t6qee5) {
    var tmp;
    if (this.i32_1) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_nearbyPositions($context_GameState_t6qee5, this.h32_1);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var it = element.r2v_1;
        if (get_locationType($context_GameState_t6qee5, it).p32(this.h32_1.l32($context_GameState_t6qee5))) {
          destination.d2(element);
        }
      }
      tmp = toSet(destination);
    } else {
      tmp = get_nearbyPositions($context_GameState_t6qee5, this.h32_1);
    }
    return tmp;
  }
  toString() {
    return 'PlaceNewSummonNearbyStatement(beast=' + this.h32_1.toString() + ', isOnlyOnHisLocation=' + this.i32_1 + ')';
  }
  hashCode() {
    var result = this.h32_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.i32_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceNewSummonNearbyStatement))
      return false;
    if (!this.h32_1.equals(other.h32_1))
      return false;
    if (!(this.i32_1 === other.i32_1))
      return false;
    return true;
  }
  static j32(seen0, beast, isOnlyOnHisLocation, serializationConstructorMarker) {
    Companion_getInstance_58();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_54().f32_1);
    }
    var $this = this.q32(seen0, serializationConstructorMarker);
    $this.h32_1 = beast;
    $this.i32_1 = isOnlyOnHisLocation;
    return $this;
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_58 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, PlaceNewSummonOnLocationsStatement$Companion$$childSerializers$_anonymous__j7116o);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r32_1 = [tmp_1, lazy(tmp_2, PlaceNewSummonOnLocationsStatement$Companion$$childSerializers$_anonymous__j7116o_0)];
  }
}
class $serializer_55 {
  constructor() {
    $serializer_instance_55 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceNewSummonOnLocationsStatement', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('positions', false);
    this.s32_1 = tmp0_serialDesc;
  }
  t32(encoder, value) {
    var tmp0_desc = this.s32_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_59().r32_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u32_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.v32_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t32(encoder, value instanceof PlaceNewSummonOnLocationsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_59().r32_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlaceNewSummonOnLocationsStatement.w32(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.s32_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_59().r32_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class PlaceNewSummonOnLocationsStatement extends PlaceNewSummonBaseStatement {
  constructor(beast, positions) {
    Companion_getInstance_59();
    super();
    this.u32_1 = beast;
    this.v32_1 = positions;
  }
  k32($context_GameState_t6qee5) {
    return this.v32_1;
  }
  toString() {
    return 'PlaceNewSummonOnLocationsStatement(beast=' + this.u32_1.toString() + ', positions=' + toString(this.v32_1) + ')';
  }
  hashCode() {
    var result = this.u32_1.hashCode();
    result = imul(result, 31) + hashCode(this.v32_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceNewSummonOnLocationsStatement))
      return false;
    if (!this.u32_1.equals(other.u32_1))
      return false;
    if (!equals(this.v32_1, other.v32_1))
      return false;
    return true;
  }
  static w32(seen0, beast, positions, serializationConstructorMarker) {
    Companion_getInstance_59();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_55().s32_1);
    }
    var $this = this.q32(seen0, serializationConstructorMarker);
    $this.u32_1 = beast;
    $this.v32_1 = positions;
    return $this;
  }
}
class Companion_59 {
  constructor() {
    Companion_instance_59 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x32_1 = [lazy(tmp_0, PlaceNewSummonStatement$Companion$$childSerializers$_anonymous__iaholn)];
  }
}
class $serializer_56 {
  constructor() {
    $serializer_instance_56 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceNewSummonStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.y32_1 = tmp0_serialDesc;
  }
  z32(encoder, value) {
    var tmp0_desc = this.y32_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_60().x32_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a33_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z32(encoder, value instanceof PlaceNewSummonStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_60().x32_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlaceNewSummonStatement.b33(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y32_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_60().x32_1[0].k3()];
  }
}
class PlaceNewSummonStatement extends PlaceNewSummonBaseStatement {
  constructor(beast) {
    Companion_getInstance_60();
    super();
    this.a33_1 = beast;
  }
  k32($context_GameState_t6qee5) {
    var tmp;
    if (equals(get_objectType($context_GameState_t6qee5, this.a33_1), Lydan_getInstance())) {
      tmp = plus(possibleLocationsWithBeastType($context_GameState_t6qee5, this.a33_1), get_nearbyPositions($context_GameState_t6qee5, this.a33_1));
    } else {
      tmp = possibleLocationsWithBeastType($context_GameState_t6qee5, this.a33_1);
    }
    return tmp;
  }
  toString() {
    return 'PlaceNewSummonStatement(beast=' + this.a33_1.toString() + ')';
  }
  hashCode() {
    return this.a33_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceNewSummonStatement))
      return false;
    if (!this.a33_1.equals(other.a33_1))
      return false;
    return true;
  }
  static b33(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_60();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_56().y32_1);
    }
    var $this = this.q32(seen0, serializationConstructorMarker);
    $this.a33_1 = beast;
    return $this;
  }
}
class Companion_60 {
  constructor() {
    Companion_instance_60 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c33_1 = [lazy(tmp_0, PlaceOutpostStatement$Companion$$childSerializers$_anonymous__nx14wy), null];
  }
}
class $serializer_57 {
  constructor() {
    $serializer_instance_57 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceOutpostStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('fastApply', true);
    this.d33_1 = tmp0_serialDesc;
  }
  e33(encoder, value) {
    var tmp0_desc = this.d33_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_61().c33_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f33_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.g33_1 === true)) {
      tmp1_output.w14(tmp0_desc, 1, value.g33_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e33(encoder, value instanceof PlaceOutpostStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d33_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_61().c33_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlaceOutpostStatement.h33(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d33_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_61().c33_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class PlaceOutpostStatement {
  constructor(characterObject) {
    Companion_getInstance_61();
    this.f33_1 = characterObject;
    this.g33_1 = true;
  }
  toString() {
    return 'PlaceOutpostStatement(characterObject=' + this.f33_1.toString() + ')';
  }
  hashCode() {
    return this.f33_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceOutpostStatement))
      return false;
    if (!this.f33_1.equals(other.f33_1))
      return false;
    return true;
  }
  static h33(seen0, characterObject, fastApply, serializationConstructorMarker) {
    Companion_getInstance_61();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_57().d33_1);
    }
    var $this = createThis(this);
    $this.f33_1 = characterObject;
    if (0 === (seen0 & 2))
      $this.g33_1 = true;
    else
      $this.g33_1 = fastApply;
    return $this;
  }
}
class Companion_61 {
  constructor() {
    Companion_instance_61 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, ReceiveSelfDamageStatement$Companion$$childSerializers$_anonymous__r3l9h5);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i33_1 = [tmp_1, lazy(tmp_2, ReceiveSelfDamageStatement$Companion$$childSerializers$_anonymous__r3l9h5_0), null];
  }
}
class $serializer_58 {
  constructor() {
    $serializer_instance_58 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ReceiveSelfDamageStatement', this, 3);
    tmp0_serialDesc.h1b('damageSource', false);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('selfDamage', true);
    this.j33_1 = tmp0_serialDesc;
  }
  k33(encoder, value) {
    var tmp0_desc = this.j33_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_62().i33_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l33_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.m33_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.n33_1 === 1)) {
      tmp1_output.z14(tmp0_desc, 2, value.n33_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k33(encoder, value instanceof ReceiveSelfDamageStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j33_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_62().i33_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return ReceiveSelfDamageStatement.o33(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.j33_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_62().i33_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), IntSerializer_getInstance()];
  }
}
class ReceiveSelfDamageStatement {
  constructor(damageSource, characterObject, selfDamage) {
    Companion_getInstance_62();
    selfDamage = selfDamage === VOID ? 1 : selfDamage;
    this.l33_1 = damageSource;
    this.m33_1 = characterObject;
    this.n33_1 = selfDamage;
  }
  toString() {
    return 'ReceiveSelfDamageStatement(damageSource=' + toString(this.l33_1) + ', characterObject=' + this.m33_1.toString() + ', selfDamage=' + this.n33_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.l33_1);
    result = imul(result, 31) + this.m33_1.hashCode() | 0;
    result = imul(result, 31) + this.n33_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReceiveSelfDamageStatement))
      return false;
    if (!equals(this.l33_1, other.l33_1))
      return false;
    if (!this.m33_1.equals(other.m33_1))
      return false;
    if (!(this.n33_1 === other.n33_1))
      return false;
    return true;
  }
  static o33(seen0, damageSource, characterObject, selfDamage, serializationConstructorMarker) {
    Companion_getInstance_62();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_58().j33_1);
    }
    var $this = createThis(this);
    $this.l33_1 = damageSource;
    $this.m33_1 = characterObject;
    if (0 === (seen0 & 4))
      $this.n33_1 = 1;
    else
      $this.n33_1 = selfDamage;
    return $this;
  }
}
class RelocateOneHunterToAnother {
  constructor() {
    RelocateOneHunterToAnother_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p33_1 = lazy(tmp_0, RelocateOneHunterToAnother$_anonymous__4f9muo);
  }
  o2o($context_GameStateRuntime_604ce3) {
    return get_aliveHunters_0($context_GameStateRuntime_604ce3).s2() > 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_5(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RelocateOneHunterToAnother';
  }
  hashCode() {
    return -1160484916;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RelocateOneHunterToAnother))
      return false;
    return true;
  }
}
class Companion_62 {
  constructor() {
    Companion_instance_62 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q33_1 = [lazy(tmp_0, RelocationToSettlementStatement$Companion$$childSerializers$_anonymous__7ubvzb)];
  }
}
class $serializer_59 {
  constructor() {
    $serializer_instance_59 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RelocationToSettlementStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.r33_1 = tmp0_serialDesc;
  }
  s33(encoder, value) {
    var tmp0_desc = this.r33_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_63().q33_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t33_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s33(encoder, value instanceof RelocationToSettlementStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r33_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_63().q33_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RelocationToSettlementStatement.u33(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r33_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_63().q33_1[0].k3()];
  }
}
class RelocationToSettlementStatement {
  constructor(hunter) {
    Companion_getInstance_63();
    this.t33_1 = hunter;
  }
  o2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !get_settlements_0($context_GameStateRuntime_604ce3).n1();
  }
  toString() {
    return 'RelocationToSettlementStatement(hunter=' + this.t33_1.toString() + ')';
  }
  hashCode() {
    return this.t33_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RelocationToSettlementStatement))
      return false;
    if (!this.t33_1.equals(other.t33_1))
      return false;
    return true;
  }
  static u33(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_63();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_59().r33_1);
    }
    var $this = createThis(this);
    $this.t33_1 = hunter;
    return $this;
  }
}
class Companion_63 {
  constructor() {
    Companion_instance_63 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v33_1 = [lazy(tmp_0, RetrieveDiscardedDraftActionCardStatement$Companion$$childSerializers$_anonymous__6vsr8f)];
  }
}
class $serializer_60 {
  constructor() {
    $serializer_instance_60 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RetrieveDiscardedDraftActionCardStatement', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.w33_1 = tmp0_serialDesc;
  }
  x33(encoder, value) {
    var tmp0_desc = this.w33_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_64().v33_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y33_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x33(encoder, value instanceof RetrieveDiscardedDraftActionCardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w33_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_64().v33_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RetrieveDiscardedDraftActionCardStatement.z33(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w33_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_64().v33_1[0].k3()];
  }
}
class RetrieveDiscardedDraftActionCardStatement {
  constructor(characterObject) {
    Companion_getInstance_64();
    this.y33_1 = characterObject;
  }
  toString() {
    return 'RetrieveDiscardedDraftActionCardStatement(characterObject=' + this.y33_1.toString() + ')';
  }
  hashCode() {
    return this.y33_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RetrieveDiscardedDraftActionCardStatement))
      return false;
    if (!this.y33_1.equals(other.y33_1))
      return false;
    return true;
  }
  static z33(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_64();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_60().w33_1);
    }
    var $this = createThis(this);
    $this.y33_1 = characterObject;
    return $this;
  }
}
class Companion_64 {
  constructor() {
    Companion_instance_64 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a34_1 = [lazy(tmp_0, RetrieveUnusedCardStatement$Companion$$childSerializers$_anonymous__g9cnnn)];
  }
}
class $serializer_61 {
  constructor() {
    $serializer_instance_61 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RetrieveUnusedCardStatement', this, 1);
    tmp0_serialDesc.h1b('receiver', false);
    this.b34_1 = tmp0_serialDesc;
  }
  c34(encoder, value) {
    var tmp0_desc = this.b34_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_65().a34_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d34_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c34(encoder, value instanceof RetrieveUnusedCardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_65().a34_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RetrieveUnusedCardStatement.e34(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b34_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_65().a34_1[0].k3()];
  }
}
class RetrieveUnusedCardStatement {
  constructor(receiver) {
    Companion_getInstance_65();
    this.d34_1 = receiver;
  }
  toString() {
    return 'RetrieveUnusedCardStatement(receiver=' + this.d34_1.toString() + ')';
  }
  hashCode() {
    return this.d34_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RetrieveUnusedCardStatement))
      return false;
    if (!this.d34_1.equals(other.d34_1))
      return false;
    return true;
  }
  static e34(seen0, receiver, serializationConstructorMarker) {
    Companion_getInstance_65();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_61().b34_1);
    }
    var $this = createThis(this);
    $this.d34_1 = receiver;
    return $this;
  }
}
class Companion_65 {
  constructor() {
    Companion_instance_65 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f34_1 = [null, lazy(tmp_0, RevealLastMovementsStatement$Companion$$childSerializers$_anonymous__bb62zg)];
  }
}
class $serializer_62 {
  constructor() {
    $serializer_instance_62 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevealLastMovementsStatement', this, 2);
    tmp0_serialDesc.h1b('movementsNumber', false);
    tmp0_serialDesc.h1b('beast', true);
    this.g34_1 = tmp0_serialDesc;
  }
  h34(encoder, value) {
    var tmp0_desc = this.g34_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_66().f34_1;
    tmp1_output.z14(tmp0_desc, 0, value.i34_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.j34_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.j34_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h34(encoder, value instanceof RevealLastMovementsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_66().f34_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RevealLastMovementsStatement.k34(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.g34_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_66().f34_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), get_nullable(tmp0_cached[1].k3())];
  }
}
class RevealLastMovementsStatement {
  constructor(movementsNumber, beast) {
    Companion_getInstance_66();
    beast = beast === VOID ? null : beast;
    this.i34_1 = movementsNumber;
    this.j34_1 = beast;
  }
  toString() {
    return 'RevealLastMovementsStatement(movementsNumber=' + this.i34_1 + ', beast=' + toString_0(this.j34_1) + ')';
  }
  hashCode() {
    var result = this.i34_1;
    result = imul(result, 31) + (this.j34_1 == null ? 0 : this.j34_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealLastMovementsStatement))
      return false;
    if (!(this.i34_1 === other.i34_1))
      return false;
    if (!equals(this.j34_1, other.j34_1))
      return false;
    return true;
  }
  static k34(seen0, movementsNumber, beast, serializationConstructorMarker) {
    Companion_getInstance_66();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_62().g34_1);
    }
    var $this = createThis(this);
    $this.i34_1 = movementsNumber;
    if (0 === (seen0 & 2))
      $this.j34_1 = null;
    else
      $this.j34_1 = beast;
    return $this;
  }
}
class Companion_66 {
  constructor() {
    Companion_instance_66 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l34_1 = [lazy(tmp_0, SearchForBeastStatement$Companion$$childSerializers$_anonymous__2hdagp), null];
  }
}
class $serializer_63 {
  constructor() {
    $serializer_instance_63 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SearchForBeastStatement', this, 2);
    tmp0_serialDesc.h1b('searcher', false);
    tmp0_serialDesc.h1b('searchDistance', true);
    this.m34_1 = tmp0_serialDesc;
  }
  n34(encoder, value) {
    var tmp0_desc = this.m34_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_67().l34_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o34_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.p34_1 === 0)) {
      tmp1_output.z14(tmp0_desc, 1, value.p34_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n34(encoder, value instanceof SearchForBeastStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_67().l34_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SearchForBeastStatement.q34(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.m34_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_67().l34_1[0].k3(), IntSerializer_getInstance()];
  }
}
class SearchForBeastStatement {
  constructor(searcher, searchDistance) {
    Companion_getInstance_67();
    searchDistance = searchDistance === VOID ? 0 : searchDistance;
    this.o34_1 = searcher;
    this.p34_1 = searchDistance;
  }
  o2o($context_GameStateRuntime_604ce3) {
    var tmp0 = get_aliveBeasts_0($context_GameStateRuntime_604ce3);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (!get_isRevealed($context_GameStateRuntime_604ce3, element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0)
      return false;
    if (this.p34_1 > 0)
      return true;
    var searchPosition = this.o34_1.s2w($context_GameStateRuntime_604ce3);
    var needProposeSearch = get_hazePositions($context_GameStateRuntime_604ce3).w2(new BoardPosition(searchPosition));
    var tmp_0;
    if (needProposeSearch) {
      tmp_0 = true;
    } else {
      var tmp0_0 = get_aliveBeasts_0($context_GameStateRuntime_604ce3);
      var tmp$ret$2;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(tmp0_0, Collection)) {
          tmp_1 = tmp0_0.n1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$2 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = tmp0_0.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (get_positionsWithTrailsOrStandee($context_GameStateRuntime_604ce3, element_0).w2(new BoardPosition(searchPosition))) {
            tmp$ret$2 = true;
            break $l$block_2;
          }
        }
        tmp$ret$2 = false;
      }
      tmp_0 = tmp$ret$2;
    }
    return tmp_0;
  }
  toString() {
    return 'SearchForBeastStatement(searcher=' + this.o34_1.toString() + ', searchDistance=' + this.p34_1 + ')';
  }
  hashCode() {
    var result = this.o34_1.hashCode();
    result = imul(result, 31) + this.p34_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SearchForBeastStatement))
      return false;
    if (!this.o34_1.equals(other.o34_1))
      return false;
    if (!(this.p34_1 === other.p34_1))
      return false;
    return true;
  }
  static q34(seen0, searcher, searchDistance, serializationConstructorMarker) {
    Companion_getInstance_67();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_63().m34_1);
    }
    var $this = createThis(this);
    $this.o34_1 = searcher;
    if (0 === (seen0 & 2))
      $this.p34_1 = 0;
    else
      $this.p34_1 = searchDistance;
    return $this;
  }
}
class Companion_67 {
  constructor() {
    Companion_instance_67 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, SetTrapStatement$Companion$$childSerializers$_anonymous__ecp1li);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, SetTrapStatement$Companion$$childSerializers$_anonymous__ecp1li_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r34_1 = [tmp_1, tmp_3, lazy(tmp_4, SetTrapStatement$Companion$$childSerializers$_anonymous__ecp1li_1)];
  }
}
class $serializer_64 {
  constructor() {
    $serializer_instance_64 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetTrapStatement', this, 3);
    tmp0_serialDesc.h1b('owner', false);
    tmp0_serialDesc.h1b('trapCard', false);
    tmp0_serialDesc.h1b('zoneRestriction', true);
    this.s34_1 = tmp0_serialDesc;
  }
  t34(encoder, value) {
    var tmp0_desc = this.s34_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_68().r34_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u34_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.v34_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.w34_1 == null)) {
      tmp1_output.i15(tmp0_desc, 2, tmp2_cached[2].k3(), value.w34_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t34(encoder, value instanceof SetTrapStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_68().r34_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.d14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.d14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return SetTrapStatement.x34(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.s34_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_68().r34_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), get_nullable(tmp0_cached[2].k3())];
  }
}
class SetTrapStatement {
  constructor(owner, trapCard, zoneRestriction) {
    Companion_getInstance_68();
    zoneRestriction = zoneRestriction === VOID ? null : zoneRestriction;
    this.u34_1 = owner;
    this.v34_1 = trapCard;
    this.w34_1 = zoneRestriction;
  }
  n2o($context_GameStateRuntime_604ce3) {
    if (!equals(get_placedTrapsCardsInfo($context_GameStateRuntime_604ce3).x4(), toSet(get_gameMap_1($context_GameStateRuntime_604ce3).y34()))) {
      reportWarning($context_GameStateRuntime_604ce3, 'Cannot set ' + toString(this.v34_1) + ': trap zones do not match the game map');
      return false;
    }
    if (!(this.w34_1 == null) && !get_gameMap_1($context_GameStateRuntime_604ce3).y34().w2(this.w34_1)) {
      reportWarning($context_GameStateRuntime_604ce3, 'Cannot set ' + toString(this.v34_1) + ': restricted zone ' + this.w34_1.toString() + ' is not on the game map');
      return false;
    }
    var tmp0_safe_receiver = this.w34_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = getValue(get_placedTrapsCardsInfo($context_GameStateRuntime_604ce3), tmp0_safe_receiver).s2() < get_maxTrapsInZone($context_GameStateRuntime_604ce3);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp0 = get_placedTrapsCardsInfo($context_GameStateRuntime_604ce3).y4();
      var tmp$ret$2;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(tmp0, Collection)) {
          tmp_1 = tmp0.n1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$2 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (element.s2() < get_maxTrapsInZone($context_GameStateRuntime_604ce3)) {
            tmp$ret$2 = true;
            break $l$block_0;
          }
        }
        tmp$ret$2 = false;
      }
      tmp_0 = tmp$ret$2;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  toString() {
    return 'SetTrapStatement(owner=' + this.u34_1.toString() + ', trapCard=' + toString(this.v34_1) + ', zoneRestriction=' + toString_0(this.w34_1) + ')';
  }
  hashCode() {
    var result = this.u34_1.hashCode();
    result = imul(result, 31) + hashCode(this.v34_1) | 0;
    result = imul(result, 31) + (this.w34_1 == null ? 0 : this.w34_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetTrapStatement))
      return false;
    if (!this.u34_1.equals(other.u34_1))
      return false;
    if (!equals(this.v34_1, other.v34_1))
      return false;
    if (!equals(this.w34_1, other.w34_1))
      return false;
    return true;
  }
  static x34(seen0, owner, trapCard, zoneRestriction, serializationConstructorMarker) {
    Companion_getInstance_68();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_64().s34_1);
    }
    var $this = createThis(this);
    $this.u34_1 = owner;
    $this.v34_1 = trapCard;
    if (0 === (seen0 & 4))
      $this.w34_1 = null;
    else
      $this.w34_1 = zoneRestriction;
    return $this;
  }
}
class Companion_68 {
  constructor() {
    Companion_instance_68 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z34_1 = [lazy(tmp_0, StrideHuntersStatement$Companion$$childSerializers$_anonymous__jl78tx)];
  }
}
class $serializer_65 {
  constructor() {
    $serializer_instance_65 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('StrideHuntersStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.a35_1 = tmp0_serialDesc;
  }
  b35(encoder, value) {
    var tmp0_desc = this.a35_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_69().z34_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c35_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b35(encoder, value instanceof StrideHuntersStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_69().z34_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return StrideHuntersStatement.d35(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a35_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_69().z34_1[0].k3()];
  }
}
class StrideHuntersStatement {
  constructor(hunter) {
    Companion_getInstance_69();
    this.c35_1 = hunter;
  }
  n2o($context_GameStateRuntime_604ce3) {
    return !noAvailableArsenalCards(get_hunterItems($context_GameStateRuntime_604ce3));
  }
  toString() {
    return 'StrideHuntersStatement(hunter=' + this.c35_1.toString() + ')';
  }
  hashCode() {
    return this.c35_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StrideHuntersStatement))
      return false;
    if (!this.c35_1.equals(other.c35_1))
      return false;
    return true;
  }
  static d35(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_69();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_65().a35_1);
    }
    var $this = createThis(this);
    $this.c35_1 = hunter;
    return $this;
  }
}
class Companion_69 {
  constructor() {
    Companion_instance_69 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e35_1 = [lazy(tmp_0, SummonMovesStatement$Companion$$childSerializers$_anonymous__72wvfg), null, null];
  }
}
class $serializer_66 {
  constructor() {
    $serializer_instance_66 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SummonMovesStatement', this, 3);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('summonsLimit', true);
    tmp0_serialDesc.h1b('maxSteps', true);
    this.f35_1 = tmp0_serialDesc;
  }
  g35(encoder, value) {
    var tmp0_desc = this.f35_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_70().e35_1;
    tmp1_output.i15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h35_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.i35_1 === -1)) {
      tmp1_output.z14(tmp0_desc, 1, value.i35_1);
    }
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.j35_1 === 1)) {
      tmp1_output.z14(tmp0_desc, 2, value.j35_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g35(encoder, value instanceof SummonMovesStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_70().e35_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.d14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.d14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return SummonMovesStatement.k35(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.f35_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_70().e35_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0].k3()), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class SummonMovesStatement {
  constructor(beast, summonsLimit, maxSteps) {
    Companion_getInstance_70();
    summonsLimit = summonsLimit === VOID ? -1 : summonsLimit;
    maxSteps = maxSteps === VOID ? 1 : maxSteps;
    this.h35_1 = beast;
    this.i35_1 = summonsLimit;
    this.j35_1 = maxSteps;
  }
  toString() {
    return 'SummonMovesStatement(beast=' + toString_0(this.h35_1) + ', summonsLimit=' + this.i35_1 + ', maxSteps=' + this.j35_1 + ')';
  }
  hashCode() {
    var result = this.h35_1 == null ? 0 : this.h35_1.hashCode();
    result = imul(result, 31) + this.i35_1 | 0;
    result = imul(result, 31) + this.j35_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonMovesStatement))
      return false;
    if (!equals(this.h35_1, other.h35_1))
      return false;
    if (!(this.i35_1 === other.i35_1))
      return false;
    if (!(this.j35_1 === other.j35_1))
      return false;
    return true;
  }
  static k35(seen0, beast, summonsLimit, maxSteps, serializationConstructorMarker) {
    Companion_getInstance_70();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_66().f35_1);
    }
    var $this = createThis(this);
    $this.h35_1 = beast;
    if (0 === (seen0 & 2))
      $this.i35_1 = -1;
    else
      $this.i35_1 = summonsLimit;
    if (0 === (seen0 & 4))
      $this.j35_1 = 1;
    else
      $this.j35_1 = maxSteps;
    return $this;
  }
}
class SwarmAttackStatement {
  constructor() {
    SwarmAttackStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l35_1 = lazy(tmp_0, SwarmAttackStatement$_anonymous__6sg6jc);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_6(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SwarmAttackStatement';
  }
  hashCode() {
    return 125727156;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SwarmAttackStatement))
      return false;
    return true;
  }
}
class Companion_70 {
  constructor() {
    Companion_instance_70 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m35_1 = [lazy(tmp_0, UpgradeStatement$Companion$$childSerializers$_anonymous__u6mi5z), null];
  }
}
class $serializer_67 {
  constructor() {
    $serializer_instance_67 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UpgradeStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('discount', true);
    this.n35_1 = tmp0_serialDesc;
  }
  o35(encoder, value) {
    var tmp0_desc = this.n35_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_71().m35_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p35_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.q35_1 === 0)) {
      tmp1_output.z14(tmp0_desc, 1, value.q35_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o35(encoder, value instanceof UpgradeStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_71().m35_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return UpgradeStatement.r35(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.n35_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_71().m35_1[0].k3(), IntSerializer_getInstance()];
  }
}
class UpgradeStatement {
  constructor(characterObject, discount) {
    Companion_getInstance_71();
    discount = discount === VOID ? 0 : discount;
    this.p35_1 = characterObject;
    this.q35_1 = discount;
  }
  n2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.s35($context_GameStateRuntime_604ce3).n1();
  }
  s35($context_GameState_t6qee5) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_objectType($context_GameState_t6qee5, this.p35_1).t35();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (element.u35($context_GameState_t6qee5) && !get_pumpedUpgrades($context_GameState_t6qee5).w2(element)) {
        destination.d2(element);
      }
    }
    var nonUpgraded = destination;
    if (this.q35_1 === -1)
      return nonUpgraded;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = nonUpgraded.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      var cost = element_0.v35($context_GameState_t6qee5) - this.q35_1 | 0;
      var tmp;
      if (equals(get_objectType($context_GameState_t6qee5, this.p35_1), Draug_getInstance())) {
        tmp = cost <= get_draugCorruptionLevel($context_GameState_t6qee5, get_draugHunter($context_GameState_t6qee5));
      } else {
        tmp = cost <= get_grudgesNumber($context_GameState_t6qee5, this.p35_1);
      }
      if (tmp) {
        destination_0.d2(element_0);
      }
    }
    return destination_0;
  }
  toString() {
    return 'UpgradeStatement(characterObject=' + this.p35_1.toString() + ', discount=' + this.q35_1 + ')';
  }
  hashCode() {
    var result = this.p35_1.hashCode();
    result = imul(result, 31) + this.q35_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UpgradeStatement))
      return false;
    if (!this.p35_1.equals(other.p35_1))
      return false;
    if (!(this.q35_1 === other.q35_1))
      return false;
    return true;
  }
  static r35(seen0, characterObject, discount, serializationConstructorMarker) {
    Companion_getInstance_71();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_67().n35_1);
    }
    var $this = createThis(this);
    $this.p35_1 = characterObject;
    if (0 === (seen0 & 2))
      $this.q35_1 = 0;
    else
      $this.q35_1 = discount;
    return $this;
  }
}
class Companion_71 {
  a2g() {
    var tmp = getKClass(AttackModifier);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AngerIncinerateAttackModifier), getKClass(BonusDamageAttackModifier), getKClass(FeastCardAttackModifier), getKClass(JustNearbyAttackModifier), getKClass(NearSummonsAndBeastAttackModifier), getKClass(OnlyAnimalsAttackModifier), getKClass(OnlyNearSummonsAttackModifier), getKClass(PetrifyAttackModifier)];
    var tmp_1 = $serializer_getInstance_396();
    var tmp_2 = BonusDamageAttackModifier_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_3 = ObjectSerializer.l1c('BonusDamageAttackModifier', tmp_2, tmp$ret$3);
    var tmp_4 = FeastCardAttackModifier_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_5 = ObjectSerializer.l1c('FeastCardAttackModifier', tmp_4, tmp$ret$6);
    var tmp_6 = JustNearbyAttackModifier_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_7 = ObjectSerializer.l1c('JustNearbyAttackModifier', tmp_6, tmp$ret$9);
    var tmp_8 = NearSummonsAndBeastAttackModifier_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_9 = ObjectSerializer.l1c('NearSummonsAndBeastAttackModifier', tmp_8, tmp$ret$12);
    var tmp_10 = OnlyAnimalsAttackModifier_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_11 = ObjectSerializer.l1c('OnlyAnimalsAttackModifier', tmp_10, tmp$ret$15);
    var tmp_12 = OnlyNearSummonsAttackModifier_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_13 = ObjectSerializer.l1c('OnlyNearSummonsAttackModifier', tmp_12, tmp$ret$18);
    var tmp_14 = PetrifyAttackModifier_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_15 = [tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, tmp_13, ObjectSerializer.l1c('PetrifyAttackModifier', tmp_14, tmp$ret$21)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    return SealedClassSerializer.i10('steelart.beast.AttackModifier', tmp, tmp_0, tmp_15, tmp$ret$27);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class AttackModifier {}
class ChooseSettlerForFlareScope {
  constructor() {
    ChooseSettlerForFlareScope_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y35_1 = lazy(tmp_0, ChooseSettlerForFlareScope$_anonymous__sy4umw);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_7(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ChooseSettlerForFlareScope';
  }
  hashCode() {
    return 1311406788;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChooseSettlerForFlareScope))
      return false;
    return true;
  }
}
class BonusDamageAttackModifier {
  constructor() {
    BonusDamageAttackModifier_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z35_1 = lazy(tmp_0, BonusDamageAttackModifier$_anonymous__hx4rli);
  }
  w35($context_GameState_t6qee5, target) {
    return null;
  }
  x35($context_GameState_t6qee5, target) {
    return 0;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_8(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BonusDamageAttackModifier';
  }
  hashCode() {
    return 1842272808;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BonusDamageAttackModifier))
      return false;
    return true;
  }
}
class OnlyNearSummonsAttackModifier {
  constructor() {
    OnlyNearSummonsAttackModifier_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a36_1 = lazy(tmp_0, OnlyNearSummonsAttackModifier$_anonymous__r6ekyi);
  }
  w35($context_GameState_t6qee5, target) {
    var tmp = get_objectType($context_GameState_t6qee5, target);
    return isInterface(tmp, SummonType);
  }
  x35($context_GameState_t6qee5, target) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_9(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OnlyNearSummonsAttackModifier';
  }
  hashCode() {
    return -221843624;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OnlyNearSummonsAttackModifier))
      return false;
    return true;
  }
}
class Companion_72 {
  a2g() {
    var tmp = getKClass(ApplyingReactionStatement);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BindingHuntReactionStatement), getKClass(BleatCardTriggerStatement), getKClass(DraugBerserkReactionStatement), getKClass(DreamerMaskReactionStatement), getKClass(EsmeriasStrandReactionStatement), getKClass(FlareReactionStatement), getKClass(IntuitionReactionStatement), getKClass(MistShroudReactionStatement), getKClass(PlayCardAsReactionStatement), getKClass(SmokebombReactionStatement), getKClass(SuddenMistReactionStatement), getKClass(WorldShiftReactionStatement)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_111(), $serializer_getInstance_404(), $serializer_getInstance_128(), $serializer_getInstance_14(), $serializer_getInstance_15(), $serializer_getInstance_16(), $serializer_getInstance_17(), $serializer_getInstance_364(), $serializer_getInstance_18(), $serializer_getInstance_19(), $serializer_getInstance_20(), $serializer_getInstance_21()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.ApplyingReactionStatement', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_73 {
  constructor() {
    Companion_instance_73 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b36_1 = lazy(tmp_0, PerformForEachHunter$Companion$_anonymous__qfzihm);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_10(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class JustNearbyAttackModifier {
  constructor() {
    JustNearbyAttackModifier_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c36_1 = lazy(tmp_0, JustNearbyAttackModifier$_anonymous__obvidv);
  }
  w35($context_GameState_t6qee5, target) {
    return null;
  }
  x35($context_GameState_t6qee5, target) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_11(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'JustNearbyAttackModifier';
  }
  hashCode() {
    return -1356294033;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JustNearbyAttackModifier))
      return false;
    return true;
  }
}
class Companion_74 {
  a2g() {
    var tmp = getKClass(ObjectMovementStatement);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BeastMovesDependingOnHuntersStatement), getKClass(BeastMovesDependingOnSummonsNumberStatement), getKClass(BeastMovesSameZoneStatement), getKClass(FixedDirectionBeastMovementStatement), getKClass(LeapStatement), getKClass(RaagaSlitherStatement), getKClass(SimpleBeastMovementStatement), getKClass(UpriseUpgradedStatement), getKClass(VoidStatement), getKClass(MovementUptoFixedStepsStatement), getKClass(OverloadedFlameRapierMovementStatement), getKClass(RunFromFireStatement), getKClass(TrackStatement), getKClass(WarhogsTuskStatement), getKClass(RelocationInRangeStatement)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_44(), $serializer_getInstance_45(), $serializer_getInstance_46(), $serializer_getInstance_47(), $serializer_getInstance_106(), $serializer_getInstance_372(), $serializer_getInstance_4(), $serializer_getInstance_146(), $serializer_getInstance_69(), $serializer_getInstance_0(), $serializer_getInstance_143(), $serializer_getInstance_385(), $serializer_getInstance_48(), $serializer_getInstance_49(), $serializer_getInstance_50()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.ObjectMovementStatement', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_75 {
  constructor() {
    Companion_instance_75 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f36_1 = lazy(tmp_0, PlaceNewSummonBaseStatement$Companion$_anonymous__ieiesr);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_12(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class EffectSource {}
class CharacterUpgrade {}
function get_mayBeUpgraded($context_GameState_t6qee5) {
  return true;
}
class VoidCallUpgrade {
  constructor() {
    VoidCallUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g36_1 = lazy(tmp_0, VoidCallUpgrade$_anonymous__vh33vx);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_13(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'VoidCallUpgrade';
  }
  hashCode() {
    return 1024761413;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VoidCallUpgrade))
      return false;
    return true;
  }
}
class AbyssalBeastUpgrade {
  constructor() {
    AbyssalBeastUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h36_1 = lazy(tmp_0, AbyssalBeastUpgrade$_anonymous__im3hyv);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_14(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AbyssalBeastUpgrade';
  }
  hashCode() {
    return -1575087749;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbyssalBeastUpgrade))
      return false;
    return true;
  }
}
class EchoUpgrade {
  constructor() {
    EchoUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i36_1 = lazy(tmp_0, EchoUpgrade$_anonymous__ns4tc);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_15(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EchoUpgrade';
  }
  hashCode() {
    return -1440947118;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EchoUpgrade))
      return false;
    return true;
  }
}
class EternityUpgrade {
  constructor() {
    EternityUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j36_1 = lazy(tmp_0, EternityUpgrade$_anonymous__n3p3k9);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_16(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EternityUpgrade';
  }
  hashCode() {
    return -305479685;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EternityUpgrade))
      return false;
    return true;
  }
}
class VoidStepUpgrade {
  constructor() {
    VoidStepUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k36_1 = lazy(tmp_0, VoidStepUpgrade$_anonymous__w61g11);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_17(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'VoidStepUpgrade';
  }
  hashCode() {
    return 1048107543;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VoidStepUpgrade))
      return false;
    return true;
  }
}
class DarkSpawnUpgrade {
  constructor() {
    DarkSpawnUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l36_1 = lazy(tmp_0, DarkSpawnUpgrade$_anonymous__ldo61s);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_18(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DarkSpawnUpgrade';
  }
  hashCode() {
    return -916051588;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DarkSpawnUpgrade))
      return false;
    return true;
  }
}
class VoidCallStatement {
  constructor() {
    VoidCallStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m36_1 = lazy(tmp_0, VoidCallStatement$_anonymous__1y95y);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_19(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'VoidCallStatement';
  }
  hashCode() {
    return -2019375272;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VoidCallStatement))
      return false;
    return true;
  }
}
class AbyssalBeastStatement {
  constructor() {
    AbyssalBeastStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n36_1 = lazy(tmp_0, AbyssalBeastStatement$_anonymous__33750);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_20(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AbyssalBeastStatement';
  }
  hashCode() {
    return -803453682;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbyssalBeastStatement))
      return false;
    return true;
  }
}
class GeneralObjectProperty {}
class ObjectOnBoardType {}
function get_preferredLocation($context_GameState_t6qee5) {
  return LocationType_None_getInstance();
}
function getInitList($context_GameState_t6qee5, position) {
  return listOf_0([init(get_objectTypeKey(), this), init(get_positionKey(), new BoardPositionWrapper(position)), init_0(get_woundKey(), 0), init_0(get_armorKey(), 0), init_0(get_destroyRecordIndexKey(), -1), init(get_isAliveKey(), new BooleanWrapper(true)), init(get_initialPositionKey(), new BoardPositionWrapper(position))]);
}
class Character {}
function modificationNumber(gameState) {
  return null;
}
function getInitList_0($context_GameState_t6qee5, position) {
  return plus_2(getInitList.call(this, $context_GameState_t6qee5, position), listOf_0([init_0(get_grudgesNumberKey(), 0), init_0(get_ancientPowerNumberKey(), 0), init(get_handKey(), new PlayableCardSetWrapper(emptySet())), init(get_discardedAbilityCardsKey(), new PlayableCardSetWrapper(emptySet()))]));
}
class BeastCharacter {}
function get_summonTypes() {
  return setOf(this.q36());
}
function get_summonLimit() {
  return 2;
}
function get_activatableSummonsOnMap($context_GameState_t6qee5) {
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (isInterface(tmp, SummonType)) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (this.t36().w2(get_objectType($context_GameState_t6qee5, element_0)) && get_isAlive($context_GameState_t6qee5, element_0)) {
      destination_0.d2(element_0);
    }
  }
  return toSet(destination_0);
}
function getInitList_1($context_GameState_t6qee5, position) {
  var tmp = getInitList_0.call(this, $context_GameState_t6qee5, position);
  var tmp_0 = init(get_lastSeenPositionKey(), new BoardPositionWrapper(position));
  var tmp_1 = get_beastPathKey();
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  var tmp_2 = init(tmp_1, new BeastPathStepListWrapper(tmp$ret$0));
  var tmp_3 = get_beastMovementsKey();
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$1 = emptyList();
  var tmp_4 = init(tmp_3, new MovementAndStateListWrapper(tmp$ret$1));
  var tmp_5 = get_foundTrailsKey();
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$2 = emptyMap();
  return plus_2(tmp, listOf_0([tmp_0, tmp_2, tmp_4, init(tmp_5, new BoardPositionToIntMapWrapper(tmp$ret$2))]));
}
class Akkeron {
  constructor() {
    Akkeron_instance = this;
    this.o36_1 = setOf_0([VoidCallUpgrade_getInstance(), AbyssalBeastUpgrade_getInstance(), EchoUpgrade_getInstance(), EternityUpgrade_getInstance(), VoidStepUpgrade_getInstance(), DarkSpawnUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p36_1 = lazy(tmp_0, Akkeron$_anonymous__qn399y);
  }
  q36() {
    return AbominationType_getInstance();
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Swamp_getInstance();
  }
  s36() {
    return setOf_0([DefileCard_getInstance(), ConsumeCard_getInstance(), CorruptCard_getInstance(), VoidCard_getInstance()]);
  }
  t35() {
    return this.o36_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_21(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Akkeron';
  }
  hashCode() {
    return 1813223912;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Akkeron))
      return false;
    return true;
  }
}
class Companion_76 {
  constructor() {
    Companion_instance_76 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x36_1 = [lazy(tmp_0, AbyssalPullStatement$Companion$$childSerializers$_anonymous__gt7kcj)];
  }
}
class $serializer_68 {
  constructor() {
    $serializer_instance_68 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AbyssalPullStatement', this, 1);
    tmp0_serialDesc.h1b('actor', false);
    this.y36_1 = tmp0_serialDesc;
  }
  z36(encoder, value) {
    var tmp0_desc = this.y36_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_77().x36_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a37_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z36(encoder, value instanceof AbyssalPullStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y36_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_77().x36_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AbyssalPullStatement.b37(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y36_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_77().x36_1[0].k3()];
  }
}
class AbyssalPullStatement {
  constructor(actor) {
    Companion_getInstance_77();
    this.a37_1 = actor;
  }
  toString() {
    return 'AbyssalPullStatement(actor=' + this.a37_1.toString() + ')';
  }
  hashCode() {
    return this.a37_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbyssalPullStatement))
      return false;
    if (!this.a37_1.equals(other.a37_1))
      return false;
    return true;
  }
  static b37(seen0, actor, serializationConstructorMarker) {
    Companion_getInstance_77();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_68().y36_1);
    }
    var $this = createThis(this);
    $this.a37_1 = actor;
    return $this;
  }
}
class Companion_77 {
  constructor() {
    Companion_instance_77 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c37_1 = [lazy(tmp_0, VoidStatement$Companion$$childSerializers$_anonymous__1kxo0h)];
  }
}
class $serializer_69 {
  constructor() {
    $serializer_instance_69 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('VoidStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.d37_1 = tmp0_serialDesc;
  }
  e37(encoder, value) {
    var tmp0_desc = this.d37_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_78().c37_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f37_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e37(encoder, value instanceof VoidStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d37_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_78().c37_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return VoidStatement.g37(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d37_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_78().c37_1[0].k3()];
  }
}
class VoidStatement extends BeastMovementStatement {
  constructor(movingObject) {
    Companion_getInstance_78();
    super();
    this.f37_1 = movingObject;
  }
  f2p() {
    return this.f37_1;
  }
  toString() {
    return 'VoidStatement(movingObject=' + this.f37_1.toString() + ')';
  }
  hashCode() {
    return this.f37_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VoidStatement))
      return false;
    if (!this.f37_1.equals(other.f37_1))
      return false;
    return true;
  }
  static g37(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_78();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_69().d37_1);
    }
    var $this = this.f2q(seen0, serializationConstructorMarker);
    $this.f37_1 = movingObject;
    return $this;
  }
}
class Companion_78 {
  constructor() {
    Companion_instance_78 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h37_1 = [lazy(tmp_0, AkkeronEternityTransformedPositionsChangeEvent$Companion$$childSerializers$_anonymous__307kqg)];
  }
}
class $serializer_70 {
  constructor() {
    $serializer_instance_70 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AkkeronEternityTransformedPositionsChangeEvent', this, 1);
    tmp0_serialDesc.h1b('positions', false);
    this.i37_1 = tmp0_serialDesc;
  }
  j37(encoder, value) {
    var tmp0_desc = this.i37_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_79().h37_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k37_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j37(encoder, value instanceof AkkeronEternityTransformedPositionsChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i37_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_79().h37_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AkkeronEternityTransformedPositionsChangeEvent.l37(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.i37_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_79().h37_1[0].k3()];
  }
}
class GameStateEvent {}
function stateChanges($context_GameStateRuntime_604ce3) {
  return emptyList();
}
class GameStateChange {}
class GameStateChangeEvent {}
function stateChanges_0($context_GameStateRuntime_604ce3) {
  return listOf(this);
}
class TechnicalGameStateChangeEvent {}
class AkkeronEternityTransformedPositionsChangeEvent {
  constructor(positions) {
    Companion_getInstance_79();
    this.k37_1 = positions;
  }
  m37(_this__u8e3s4) {
    set_akkeronEternityTransformedPositionsImpl(_this__u8e3s4, get_akkeronBeast(_this__u8e3s4), this.k37_1);
  }
  n37($context_GameState_t6qee5) {
    return new AkkeronEternityTransformedPositionsChangeEvent(get_akkeronEternityTransformedPositions($context_GameState_t6qee5, get_akkeronBeast($context_GameState_t6qee5)));
  }
  toString() {
    return 'AkkeronEternityTransformedPositionsChangeEvent(positions=' + toString(this.k37_1) + ')';
  }
  hashCode() {
    return hashCode(this.k37_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AkkeronEternityTransformedPositionsChangeEvent))
      return false;
    if (!equals(this.k37_1, other.k37_1))
      return false;
    return true;
  }
  static l37(seen0, positions, serializationConstructorMarker) {
    Companion_getInstance_79();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_70().i37_1);
    }
    var $this = createThis(this);
    $this.k37_1 = positions;
    return $this;
  }
}
class SimpleObjectType {}
class SummonType {}
function get_preferredLocation_0($context_GameState_t6qee5) {
  return this.r37().r36($context_GameState_t6qee5);
}
function get_maxHP($context_GameState_t6qee5) {
  return get_gameRules($context_GameState_t6qee5).e3b(ValueId_SummonHP_getInstance(), 1);
}
class AbominationType {
  constructor() {
    AbominationType_instance = this;
    this.p37_1 = Akkeron_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q37_1 = lazy(tmp_0, AbominationType$_anonymous__oemc2c);
  }
  r37() {
    return this.p37_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_22(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AbominationType';
  }
  hashCode() {
    return -997871674;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbominationType))
      return false;
    return true;
  }
}
class PlayableCard {}
function get_number() {
  return null;
}
class PlayableInTurnCard {}
class AbilityCard {}
class ConsumeCard {
  constructor() {
    ConsumeCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s37_1 = lazy(tmp_0, ConsumeCard$_anonymous__tbxdsl);
  }
  t37() {
    return Akkeron_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_23(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ConsumeCard';
  }
  hashCode() {
    return -1537512121;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ConsumeCard))
      return false;
    return true;
  }
}
class CorruptCard {
  constructor() {
    CorruptCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v37_1 = lazy(tmp_0, CorruptCard$_anonymous__itwqu2);
  }
  t37() {
    return Akkeron_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_24(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CorruptCard';
  }
  hashCode() {
    return -1820465448;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CorruptCard))
      return false;
    return true;
  }
}
class DefileCard {
  constructor() {
    DefileCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w37_1 = lazy(tmp_0, DefileCard$_anonymous__f87rxm);
  }
  t37() {
    return Akkeron_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_25(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DefileCard';
  }
  hashCode() {
    return 563868338;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DefileCard))
      return false;
    return true;
  }
}
class VoidCard {
  constructor() {
    VoidCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x37_1 = lazy(tmp_0, VoidCard$_anonymous__dnwx77);
  }
  t37() {
    return Akkeron_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_26(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'VoidCard';
  }
  hashCode() {
    return 1810097289;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VoidCard))
      return false;
    return true;
  }
}
class Companion_79 {}
class $serializer_71 {
  constructor() {
    $serializer_instance_71 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ArrivalOfTheTitanContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.m39_1 = tmp0_serialDesc;
  }
  n39(encoder, value) {
    var tmp0_desc = this.m39_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.r39_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.s39_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 2, value.s39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.t39_1 === 2)) {
      tmp1_output.z14(tmp0_desc, 3, value.t39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.u39_1.equals(Companion_getInstance_220().x39_1)) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.u39_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n39(encoder, value instanceof ArrivalOfTheTitanContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m39_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return ArrivalOfTheTitanContract.y39(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.m39_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class GameRules {}
function value(id, default_0) {
  return default_0;
}
function canTransformLocation($context_GameState_t6qee5, position) {
  return true;
}
class ClassicGameRules {
  constructor() {
    return new.target.o4f();
  }
  static o4f() {
    Companion_getInstance_216();
    var $this = createThis(this);
    $this.o39_1 = 6;
    return $this;
  }
  p39() {
    return this.o39_1;
  }
  y3a() {
    return getHunterItemCardDeck(get_gameContentVersion(this).p4f());
  }
  z3a() {
    return getBeastTalentCardDeck(get_gameContentVersion(this).p4f());
  }
  a3b() {
    return get_usesAshfallMapFeatures(this) ? toList(get_allAshRuins()) : emptyList();
  }
  b3b() {
    return getDraftActionCardDeck(get_gameContentVersion(this).p4f());
  }
  n2q($context_GameState_t6qee5, attacker, attackModifier) {
    if (equals(get_objectType($context_GameState_t6qee5, attacker), EggType_getInstance()))
      return emptySet();
    var tmp1_elvis_lhs = attackModifier == null ? null : attackModifier.x35($context_GameState_t6qee5, attacker);
    var positions = positionsUpToDistance($context_GameState_t6qee5, attacker, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (positions.w2(new BoardPosition(element.s2w($context_GameState_t6qee5)))) {
        destination.d2(element);
      }
    }
    var objectsInRange = destination;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = objectsInRange.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      var tmp;
      if (attacker.equals(get_mesmerizedHunter($context_GameState_t6qee5))) {
        var tmp_0;
        var tmp_1 = get_objectType($context_GameState_t6qee5, element_0);
        if (isInterface(tmp_1, HunterCharacter)) {
          tmp_0 = true;
        } else {
          var tmp_2 = get_objectType($context_GameState_t6qee5, element_0);
          tmp_0 = isInterface(tmp_2, SettlerType);
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      var additionalPossible = tmp;
      var tmp_3;
      if (additionalPossible) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs_0 = attackModifier == null ? null : attackModifier.w35($context_GameState_t6qee5, element_0);
        var tmp_4;
        if (tmp1_elvis_lhs_0 == null) {
          var tmp_5;
          var tmp_6 = get_objectType($context_GameState_t6qee5, attacker);
          if (isInterface(tmp_6, HunterCharacter)) {
            var tmp_7;
            var tmp_8;
            var tmp_9;
            var tmp_10;
            var tmp$ret$6;
            $l$block: {
              // Inline function 'steelart.beast.cast' call
              var tmp_11 = get_objectType($context_GameState_t6qee5, element_0);
              if (isInterface(tmp_11, BeastCharacter)) {
                tmp$ret$6 = element_0 instanceof ObjectOnBoard ? element_0 : THROW_CCE();
                break $l$block;
              }
              tmp$ret$6 = null;
            }
            var tmp2_safe_receiver = tmp$ret$6;
            if ((tmp2_safe_receiver == null ? null : get_isRevealed($context_GameState_t6qee5, tmp2_safe_receiver)) === true) {
              tmp_10 = true;
            } else {
              var tmp_12 = get_objectType($context_GameState_t6qee5, element_0);
              tmp_10 = isInterface(tmp_12, SummonType);
            }
            if (tmp_10) {
              tmp_9 = true;
            } else {
              var tmp_13 = get_objectType($context_GameState_t6qee5, element_0);
              tmp_9 = tmp_13 instanceof BarrierSideType;
            }
            if (tmp_9) {
              tmp_8 = true;
            } else {
              var tmp_14 = get_objectType($context_GameState_t6qee5, element_0);
              tmp_8 = tmp_14 instanceof SnareTokenType;
            }
            if (tmp_8) {
              tmp_7 = true;
            } else {
              var tmp_15;
              var tmp_16 = get_objectType($context_GameState_t6qee5, attacker);
              if (tmp_16 instanceof Valdi) {
                var tmp_17 = get_objectType($context_GameState_t6qee5, element_0);
                tmp_15 = isInterface(tmp_17, AnimalType);
              } else {
                tmp_15 = false;
              }
              tmp_7 = tmp_15;
            }
            tmp_5 = tmp_7;
          } else {
            // Inline function 'kotlin.let' call
            var it = get_objectType($context_GameState_t6qee5, attacker);
            var tmp_18;
            if (isInterface(it, SummonType)) {
              tmp_18 = true;
            } else {
              tmp_18 = isInterface(it, BeastCharacter);
            }
            if (tmp_18) {
              tmp_5 = get_isValidBeastAttackTarget($context_GameState_t6qee5, element_0);
            } else {
              // Inline function 'kotlin.error' call
              var message = 'No rules how ' + attacker.toString() + ' can attack';
              throw IllegalStateException.o(toString(message));
            }
          }
          tmp_4 = tmp_5;
        } else {
          tmp_4 = tmp1_elvis_lhs_0;
        }
        tmp_3 = tmp_4;
      }
      if (tmp_3) {
        destination_0.d2(element_0);
      }
    }
    var targets = destination_0;
    return toSet(targets);
  }
  c3b($context_GameState_t6qee5, objectOnBoard) {
    var tmp0_subject = get_objectType($context_GameState_t6qee5, objectOnBoard);
    var tmp;
    var tmp_0;
    if (isInterface(tmp0_subject, BeastCharacter)) {
      tmp_0 = true;
    } else {
      var tmp_1;
      if (isInterface(tmp0_subject, SummonType)) {
        tmp_1 = true;
      } else {
        tmp_1 = tmp0_subject instanceof SnareTokenType;
      }
      tmp_0 = tmp_1;
    }
    if (tmp_0) {
      tmp = get_beastsGameTeam();
    } else {
      var tmp_2;
      if (isInterface(tmp0_subject, HunterCharacter)) {
        tmp_2 = true;
      } else {
        var tmp_3;
        if (isInterface(tmp0_subject, SettlerType)) {
          tmp_3 = true;
        } else {
          tmp_3 = isInterface(tmp0_subject, HunterCompanionType);
        }
        tmp_2 = tmp_3;
      }
      if (tmp_2) {
        tmp = get_huntersGameTeam();
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  d3b($context_GameState_t6qee5, position, direction, locationType) {
    var tmp0_elvis_lhs = get_locationTypes($context_GameState_t6qee5).w4(new BoardPosition(position));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var typeOfStartingLocation = tmp;
    var nearLocationPosition = get_gameMap_0(this).c45(position, direction, typeOfStartingLocation.p32(locationType));
    // Inline function 'steelart.beast.castFilter' call
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$6;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp_0 = get_objectType($context_GameState_t6qee5, element);
        if (tmp_0 instanceof BarrierSideType) {
          tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
          break $l$block;
        }
        tmp$ret$6 = null;
      }
      var tmp0_safe_receiver = tmp$ret$6;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.d2(tmp0_safe_receiver);
      }
    }
    var barriers = destination;
    var tmp_1;
    var tmp$ret$9;
    $l$block_1: {
      // Inline function 'kotlin.collections.any' call
      var tmp_2;
      if (isInterface(barriers, Collection)) {
        tmp_2 = barriers.n1();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$9 = false;
        break $l$block_1;
      }
      var _iterator__ex2g4s_0 = barriers.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        if (element_0.s2w($context_GameState_t6qee5) === position && get_objectType($context_GameState_t6qee5, element_0).q4f_1.equals(direction)) {
          tmp$ret$9 = true;
          break $l$block_1;
        }
      }
      tmp$ret$9 = false;
    }
    if (tmp$ret$9) {
      tmp_1 = true;
    } else {
      var tmp$ret$11;
      $l$block_3: {
        // Inline function 'kotlin.collections.any' call
        var tmp_3;
        if (isInterface(barriers, Collection)) {
          tmp_3 = barriers.n1();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$11 = false;
          break $l$block_3;
        }
        var _iterator__ex2g4s_1 = barriers.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var element_1 = _iterator__ex2g4s_1.r1();
          var tmp_4;
          var tmp_5 = element_1.s2w($context_GameState_t6qee5);
          var tmp_6 = nearLocationPosition;
          if (equals(new BoardPosition(tmp_5), tmp_6 == null ? null : new BoardPosition(tmp_6))) {
            tmp_4 = get_objectType($context_GameState_t6qee5, element_1).q4f_1.equals(direction_0($context_GameState_t6qee5, nearLocationPosition, position));
          } else {
            tmp_4 = false;
          }
          if (tmp_4) {
            tmp$ret$11 = true;
            break $l$block_3;
          }
        }
        tmp$ret$11 = false;
      }
      tmp_1 = tmp$ret$11;
    }
    if (tmp_1) {
      return null;
    }
    return nearLocationPosition;
  }
  static r4f(seen0, maxWatchtowersOnBoard, serializationConstructorMarker) {
    Companion_getInstance_216();
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.o39_1 = 6;
    else
      $this.o39_1 = maxWatchtowersOnBoard;
    return $this;
  }
}
class KillingSettlersClassicGameRules extends ClassicGameRules {
  constructor() {
    return new.target.b3a();
  }
  static b3a() {
    Companion_getInstance_218();
    return this.o4f();
  }
  static x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker) {
    Companion_getInstance_218();
    return this.r4f(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
  }
}
class ArrivalOfTheTitanContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.z39(rulesParameters);
  }
  static z39(rulesParameters) {
    var $this = this.b3a();
    $this.r39_1 = rulesParameters;
    $this.s39_1 = 3;
    $this.t39_1 = 2;
    $this.u39_1 = Companion_getInstance_220().x39_1;
    return $this;
  }
  c3a() {
    return this.r39_1;
  }
  static d3a(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    balanceVersion = balanceVersion === VOID ? Companion_getInstance_217().e3a_1 : balanceVersion;
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().x39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.z39(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(2, 1);
  }
  h3a() {
    return GameMapId_LowerShatteredIsles_getInstance();
  }
  i3a() {
    return this.s39_1;
  }
  j3a() {
    return 2;
  }
  k3a() {
    return 3;
  }
  l3a() {
    return this.t39_1;
  }
  m3a() {
    return ArrivalOfTheTitanInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      var tmp0 = get_destroyRecords($context_GameState_t6qee5);
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.count' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.n1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = 0;
          break $l$block;
        }
        var count = 0;
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (element.p3a_1 === get_beastsGameTeam() && equals(get_objectType($context_GameState_t6qee5, element.o3a_1), SheepType_getInstance())) {
            count = count + 1 | 0;
            checkCountOverflow(count);
          }
        }
        tmp$ret$0 = count;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp$ret$0 >= 3);
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = expectedOrNotGainedRewardStatus(get_arrivalOfTheTitanHabitatTokensPlaced($context_GameState_t6qee5) >= 1);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      var tmp0_0 = get_destroyedObjects($context_GameState_t6qee5);
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(tmp0_0, Collection)) {
          tmp_1 = tmp0_0.n1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$2 = false;
          break $l$block_1;
        }
        var _iterator__ex2g4s_0 = tmp0_0.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          var tmp_2 = get_objectType($context_GameState_t6qee5, element_0);
          if (isInterface(tmp_2, SettlerType)) {
            tmp$ret$2 = true;
            break $l$block_1;
          }
        }
        tmp$ret$2 = false;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp$ret$2);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      tmp = expectedOrNotGainedRewardStatus(get_arrivalOfTheTitanHabitatTokensPlaced($context_GameState_t6qee5) >= 2);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  t3a($context_GameState_t6qee5, position) {
    if (ArrivalOfTheTitanInitialPhase_getInstance().equals(firstOrNull(get_gameScopes($context_GameState_t6qee5)))) {
      return super.t3a($context_GameState_t6qee5, position);
    }
    if (get_arrivalOfTheTitanHabitatLocations().w2(new BoardPosition(position))) {
      var firstAliveHunter = firstOrNull(get_aliveHunters_0($context_GameState_t6qee5));
      var tmp;
      if (!(firstAliveHunter == null) && equals(listOf(new PlayerTurnPhase(firstAliveHunter, false)), get_gameScopes($context_GameState_t6qee5))) {
        var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp0, Collection)) {
            tmp_0 = tmp0.n1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            var tmp_1;
            if (element.s2w($context_GameState_t6qee5) === position) {
              var tmp_2 = get_objectType($context_GameState_t6qee5, element);
              tmp_1 = isInterface(tmp_2, SettlerType);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        tmp = false;
      }
      if (tmp) {
        return true;
      }
      return false;
    }
    return super.t3a($context_GameState_t6qee5, position);
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.u39_1;
  }
  v3a(rulesParameters) {
    return ArrivalOfTheTitanContract.z39(rulesParameters);
  }
  toString() {
    return 'ArrivalOfTheTitanContract(rulesParameters=' + this.r39_1.toString() + ')';
  }
  hashCode() {
    return this.r39_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ArrivalOfTheTitanContract))
      return false;
    if (!this.r39_1.equals(other.r39_1))
      return false;
    return true;
  }
  static y39(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_71().m39_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.r39_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.s39_1 = 3;
    else
      $this.s39_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.t39_1 = 2;
    else
      $this.t39_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.u39_1 = Companion_getInstance_220().x39_1;
    else
      $this.u39_1 = requiredVersion;
    return $this;
  }
}
class GamePhase {}
class ContractInitPhase {}
class ArrivalOfTheTitanInitialPhase {
  constructor() {
    ArrivalOfTheTitanInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f3b_1 = lazy(tmp_0, ArrivalOfTheTitanInitialPhase$_anonymous__x4l9mz);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_27(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ArrivalOfTheTitanInitialPhase';
  }
  hashCode() {
    return -370295171;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ArrivalOfTheTitanInitialPhase))
      return false;
    return true;
  }
}
class ArrivalOfTheTitanSettlementClaimingSource {
  constructor() {
    ArrivalOfTheTitanSettlementClaimingSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g3b_1 = lazy(tmp_0, ArrivalOfTheTitanSettlementClaimingSource$_anonymous__u7thr6);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_28(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ArrivalOfTheTitanSettlementClaimingSource';
  }
  hashCode() {
    return -421865392;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ArrivalOfTheTitanSettlementClaimingSource))
      return false;
    return true;
  }
}
class ArrivalOfTheTitanSettlerMoveEffectSource {
  constructor() {
    ArrivalOfTheTitanSettlerMoveEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h3b_1 = lazy(tmp_0, ArrivalOfTheTitanSettlerMoveEffectSource$_anonymous__46kk82);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_29(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ArrivalOfTheTitanSettlerMoveEffectSource';
  }
  hashCode() {
    return 1968802942;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ArrivalOfTheTitanSettlerMoveEffectSource))
      return false;
    return true;
  }
}
class Companion_80 {}
class $serializer_72 {
  constructor() {
    $serializer_instance_72 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ArrivalOfTheTitanHuntersTeamBonusMoveStatement', this, 3);
    tmp0_serialDesc.h1b('maxSteps', false);
    tmp0_serialDesc.h1b('includeHunters', false);
    tmp0_serialDesc.h1b('includeSettlers', false);
    this.i3b_1 = tmp0_serialDesc;
  }
  j3b(encoder, value) {
    var tmp0_desc = this.i3b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.k3b_1);
    tmp1_output.w14(tmp0_desc, 1, value.l3b_1);
    tmp1_output.w14(tmp0_desc, 2, value.m3b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j3b(encoder, value instanceof ArrivalOfTheTitanHuntersTeamBonusMoveStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i3b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = false;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return ArrivalOfTheTitanHuntersTeamBonusMoveStatement.n3b(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.i3b_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class ArrivalOfTheTitanHuntersTeamBonusMoveStatement {
  constructor(maxSteps, includeHunters, includeSettlers) {
    this.k3b_1 = maxSteps;
    this.l3b_1 = includeHunters;
    this.m3b_1 = includeSettlers;
  }
  toString() {
    return 'ArrivalOfTheTitanHuntersTeamBonusMoveStatement(maxSteps=' + this.k3b_1 + ', includeHunters=' + this.l3b_1 + ', includeSettlers=' + this.m3b_1 + ')';
  }
  hashCode() {
    var result = this.k3b_1;
    result = imul(result, 31) + getBooleanHashCode(this.l3b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m3b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ArrivalOfTheTitanHuntersTeamBonusMoveStatement))
      return false;
    if (!(this.k3b_1 === other.k3b_1))
      return false;
    if (!(this.l3b_1 === other.l3b_1))
      return false;
    if (!(this.m3b_1 === other.m3b_1))
      return false;
    return true;
  }
  static n3b(seen0, maxSteps, includeHunters, includeSettlers, serializationConstructorMarker) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_72().i3b_1);
    }
    var $this = createThis(this);
    $this.k3b_1 = maxSteps;
    $this.l3b_1 = includeHunters;
    $this.m3b_1 = includeSettlers;
    return $this;
  }
}
class Companion_81 {
  a2g() {
    var tmp = getKClass(AshRuin);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Ruin1), getKClass(Ruin10), getKClass(Ruin11), getKClass(Ruin12), getKClass(Ruin2), getKClass(Ruin3), getKClass(Ruin4), getKClass(Ruin5), getKClass(Ruin6), getKClass(Ruin7), getKClass(Ruin8), getKClass(Ruin9)];
    var tmp_1 = Ruin1_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Ruin1', tmp_1, tmp$ret$3);
    var tmp_3 = Ruin10_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('Ruin10', tmp_3, tmp$ret$6);
    var tmp_5 = Ruin11_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('Ruin11', tmp_5, tmp$ret$9);
    var tmp_7 = Ruin12_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Ruin12', tmp_7, tmp$ret$12);
    var tmp_9 = Ruin2_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('Ruin2', tmp_9, tmp$ret$15);
    var tmp_11 = Ruin3_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('Ruin3', tmp_11, tmp$ret$18);
    var tmp_13 = Ruin4_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('Ruin4', tmp_13, tmp$ret$21);
    var tmp_15 = Ruin5_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('Ruin5', tmp_15, tmp$ret$24);
    var tmp_17 = Ruin6_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('Ruin6', tmp_17, tmp$ret$27);
    var tmp_19 = Ruin7_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('Ruin7', tmp_19, tmp$ret$30);
    var tmp_21 = Ruin8_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('Ruin8', tmp_21, tmp$ret$33);
    var tmp_23 = Ruin9_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_24 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, ObjectSerializer.l1c('Ruin9', tmp_23, tmp$ret$36)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    return SealedClassSerializer.i10('steelart.beast.AshRuin', tmp, tmp_0, tmp_24, tmp$ret$42);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class ArsenalCard {}
class AshRuinCard {}
class AshRuin {}
class Ruin1 {
  constructor() {
    Ruin1_instance = this;
    this.t3b_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u3b_1 = lazy(tmp_0, Ruin1$_anonymous__oa3lde);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_30(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin1';
  }
  hashCode() {
    return 1667043044;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin1))
      return false;
    return true;
  }
}
class Ruin2 {
  constructor() {
    Ruin2_instance = this;
    this.v3b_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w3b_1 = lazy(tmp_0, Ruin2$_anonymous__jfey5v);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_31(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin2';
  }
  hashCode() {
    return 1667043045;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin2))
      return false;
    return true;
  }
}
class Ruin3 {
  constructor() {
    Ruin3_instance = this;
    this.x3b_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y3b_1 = lazy(tmp_0, Ruin3$_anonymous__ekqayc);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_32(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin3';
  }
  hashCode() {
    return 1667043046;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin3))
      return false;
    return true;
  }
}
class Ruin4 {
  constructor() {
    Ruin4_instance = this;
    this.z3b_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a3c_1 = lazy(tmp_0, Ruin4$_anonymous__9q1nqt);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_33(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin4';
  }
  hashCode() {
    return 1667043047;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin4))
      return false;
    return true;
  }
}
class Ruin5 {
  constructor() {
    Ruin5_instance = this;
    this.b3c_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c3c_1 = lazy(tmp_0, Ruin5$_anonymous__4vd0ja);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_34(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin5';
  }
  hashCode() {
    return 1667043048;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin5))
      return false;
    return true;
  }
}
class Ruin6 {
  constructor() {
    Ruin6_instance = this;
    this.d3c_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e3c_1 = lazy(tmp_0, Ruin6$_anonymous__odbr);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_35(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin6';
  }
  hashCode() {
    return 1667043049;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin6))
      return false;
    return true;
  }
}
class Ruin7 {
  constructor() {
    Ruin7_instance = this;
    this.f3c_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g3c_1 = lazy(tmp_0, Ruin7$_anonymous__4u09vs);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_36(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin7';
  }
  hashCode() {
    return 1667043050;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin7))
      return false;
    return true;
  }
}
class Ruin8 {
  constructor() {
    Ruin8_instance = this;
    this.h3c_1 = Split_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i3c_1 = lazy(tmp_0, Ruin8$_anonymous__9oox3b);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_37(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin8';
  }
  hashCode() {
    return 1667043051;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin8))
      return false;
    return true;
  }
}
class Ruin9 {
  constructor() {
    Ruin9_instance = this;
    this.j3c_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k3c_1 = lazy(tmp_0, Ruin9$_anonymous__ejdkau);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_38(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin9';
  }
  hashCode() {
    return 1667043052;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin9))
      return false;
    return true;
  }
}
class Ruin10 {
  constructor() {
    Ruin10_instance = this;
    this.l3c_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m3c_1 = lazy(tmp_0, Ruin10$_anonymous__grtpxs);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_39(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin10';
  }
  hashCode() {
    return 138726860;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin10))
      return false;
    return true;
  }
}
class Ruin11 {
  constructor() {
    Ruin11_instance = this;
    this.n3c_1 = Split_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o3c_1 = lazy(tmp_0, Ruin11$_anonymous__lmid5b);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_40(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin11';
  }
  hashCode() {
    return 138726861;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin11))
      return false;
    return true;
  }
}
class Ruin12 {
  constructor() {
    Ruin12_instance = this;
    this.p3c_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q3c_1 = lazy(tmp_0, Ruin12$_anonymous__qh70cu);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_41(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Ruin12';
  }
  hashCode() {
    return 138726862;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ruin12))
      return false;
    return true;
  }
}
class Companion_82 {
  a2g() {
    var tmp = getKClass(AshRuinCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Ruin1), getKClass(Ruin10), getKClass(Ruin11), getKClass(Ruin12), getKClass(Ruin2), getKClass(Ruin3), getKClass(Ruin4), getKClass(Ruin5), getKClass(Ruin6), getKClass(Ruin7), getKClass(Ruin8), getKClass(Ruin9), getKClass(UnknownAshRuinCard)];
    var tmp_1 = Ruin1_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Ruin1', tmp_1, tmp$ret$3);
    var tmp_3 = Ruin10_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('Ruin10', tmp_3, tmp$ret$6);
    var tmp_5 = Ruin11_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('Ruin11', tmp_5, tmp$ret$9);
    var tmp_7 = Ruin12_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Ruin12', tmp_7, tmp$ret$12);
    var tmp_9 = Ruin2_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('Ruin2', tmp_9, tmp$ret$15);
    var tmp_11 = Ruin3_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('Ruin3', tmp_11, tmp$ret$18);
    var tmp_13 = Ruin4_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('Ruin4', tmp_13, tmp$ret$21);
    var tmp_15 = Ruin5_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('Ruin5', tmp_15, tmp$ret$24);
    var tmp_17 = Ruin6_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('Ruin6', tmp_17, tmp$ret$27);
    var tmp_19 = Ruin7_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('Ruin7', tmp_19, tmp$ret$30);
    var tmp_21 = Ruin8_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('Ruin8', tmp_21, tmp$ret$33);
    var tmp_23 = Ruin9_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_24 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, ObjectSerializer.l1c('Ruin9', tmp_23, tmp$ret$36), $serializer_getInstance_74()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    return SealedClassSerializer.i10('steelart.beast.AshRuinCard', tmp, tmp_0, tmp_24, tmp$ret$42);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_83 {
  constructor() {
    Companion_instance_83 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, PlayAshRuinStatement$Companion$$childSerializers$_anonymous__77i2h1);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r3c_1 = [tmp_1, lazy(tmp_2, PlayAshRuinStatement$Companion$$childSerializers$_anonymous__77i2h1_0)];
  }
}
class $serializer_73 {
  constructor() {
    $serializer_instance_73 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayAshRuinStatement', this, 2);
    tmp0_serialDesc.h1b('ashRuin', false);
    tmp0_serialDesc.h1b('characterObject', false);
    this.s3c_1 = tmp0_serialDesc;
  }
  t3c(encoder, value) {
    var tmp0_desc = this.s3c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_84().r3c_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u3c_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.v3c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t3c(encoder, value instanceof PlayAshRuinStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s3c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_84().r3c_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlayAshRuinStatement.w3c(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.s3c_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_84().r3c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class PlayAshRuinStatement {
  constructor(ashRuin, characterObject) {
    Companion_getInstance_84();
    this.u3c_1 = ashRuin;
    this.v3c_1 = characterObject;
  }
  toString() {
    return 'PlayAshRuinStatement(ashRuin=' + toString(this.u3c_1) + ', characterObject=' + this.v3c_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.u3c_1);
    result = imul(result, 31) + this.v3c_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayAshRuinStatement))
      return false;
    if (!equals(this.u3c_1, other.u3c_1))
      return false;
    if (!this.v3c_1.equals(other.v3c_1))
      return false;
    return true;
  }
  static w3c(seen0, ashRuin, characterObject, serializationConstructorMarker) {
    Companion_getInstance_84();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_73().s3c_1);
    }
    var $this = createThis(this);
    $this.u3c_1 = ashRuin;
    $this.v3c_1 = characterObject;
    return $this;
  }
}
class Companion_84 {}
class $serializer_74 {
  constructor() {
    $serializer_instance_74 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UnknownAshRuinCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.x3c_1 = tmp0_serialDesc;
  }
  y3c(encoder, value) {
    var tmp0_desc = this.x3c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.z3c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y3c(encoder, value instanceof UnknownAshRuinCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x3c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UnknownAshRuinCard.a3d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x3c_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class UnknownCard {}
class UnknownAshRuinCard {
  constructor(number) {
    this.z3c_1 = number;
  }
  u37() {
    return this.z3c_1;
  }
  toString() {
    return 'UnknownAshRuinCard(number=' + this.z3c_1 + ')';
  }
  hashCode() {
    return this.z3c_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnknownAshRuinCard))
      return false;
    if (!(this.z3c_1 === other.z3c_1))
      return false;
    return true;
  }
  static a3d(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_74().x3c_1);
    }
    var $this = createThis(this);
    $this.z3c_1 = number;
    return $this;
  }
}
class QuestionContext {}
class CardQuestionContext {}
class HunterItemToExchangeByRuinQuestionContext {
  constructor() {
    HunterItemToExchangeByRuinQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b3d_1 = lazy(tmp_0, HunterItemToExchangeByRuinQuestionContext$_anonymous__c7yogy);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_42(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterItemToExchangeByRuinQuestionContext';
  }
  hashCode() {
    return -910728236;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterItemToExchangeByRuinQuestionContext))
      return false;
    return true;
  }
}
class HunterItemToGiveByRuinQuestionContext {
  constructor() {
    HunterItemToGiveByRuinQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c3d_1 = lazy(tmp_0, HunterItemToGiveByRuinQuestionContext$_anonymous__ig0md0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_43(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterItemToGiveByRuinQuestionContext';
  }
  hashCode() {
    return 1360070182;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterItemToGiveByRuinQuestionContext))
      return false;
    return true;
  }
}
class LocationQuestionContext {}
class LocationsToCheckForBeastByRuinQuestionContext {
  constructor() {
    LocationsToCheckForBeastByRuinQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d3d_1 = lazy(tmp_0, LocationsToCheckForBeastByRuinQuestionContext$_anonymous__i7u3ce);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_44(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LocationsToCheckForBeastByRuinQuestionContext';
  }
  hashCode() {
    return -556092320;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LocationsToCheckForBeastByRuinQuestionContext))
      return false;
    return true;
  }
}
class SameHabitatRelocationByRuinQuestionContext {
  constructor() {
    SameHabitatRelocationByRuinQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e3d_1 = lazy(tmp_0, SameHabitatRelocationByRuinQuestionContext$_anonymous__hrfway);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_45(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SameHabitatRelocationByRuinQuestionContext';
  }
  hashCode() {
    return -1468462554;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SameHabitatRelocationByRuinQuestionContext))
      return false;
    return true;
  }
}
class TargetQuestionContext {}
class HunterToGiveItemByRuinQuestionContext {
  constructor() {
    HunterToGiveItemByRuinQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f3d_1 = lazy(tmp_0, HunterToGiveItemByRuinQuestionContext$_anonymous__hnaxv8);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_46(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToGiveItemByRuinQuestionContext';
  }
  hashCode() {
    return 1185726950;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToGiveItemByRuinQuestionContext))
      return false;
    return true;
  }
}
class HunterToReceiveItemByRuinQuestionContext {
  constructor() {
    HunterToReceiveItemByRuinQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g3d_1 = lazy(tmp_0, HunterToReceiveItemByRuinQuestionContext$_anonymous__b32qiw);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_47(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToReceiveItemByRuinQuestionContext';
  }
  hashCode() {
    return -638401964;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToReceiveItemByRuinQuestionContext))
      return false;
    return true;
  }
}
class Companion_85 {}
class $serializer_75 {
  constructor() {
    $serializer_instance_75 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AshfallUnlikelyAllianceContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.j3d_1 = tmp0_serialDesc;
  }
  k3d(encoder, value) {
    var tmp0_desc = this.j3d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.m3d_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.n3d_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 2, value.n3d_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.o3d_1 === 2)) {
      tmp1_output.z14(tmp0_desc, 3, value.o3d_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.p3d_1.equals(GameContentVersion.r3d(BeastGameExpansions_Ashfall_getInstance()))) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.p3d_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k3d(encoder, value instanceof AshfallUnlikelyAllianceContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j3d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return AshfallUnlikelyAllianceContract.s3d(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.j3d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class AshfallUnlikelyAllianceContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.t3d(rulesParameters);
  }
  static t3d(rulesParameters) {
    var $this = this.b3a();
    $this.m3d_1 = rulesParameters;
    $this.n3d_1 = 3;
    $this.o3d_1 = 2;
    $this.p3d_1 = GameContentVersion.r3d(BeastGameExpansions_Ashfall_getInstance());
    return $this;
  }
  c3a() {
    return this.m3d_1;
  }
  static u3d(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    balanceVersion = balanceVersion === VOID ? Companion_getInstance_217().e3a_1 : balanceVersion;
    gameContentVersion = gameContentVersion === VOID ? GameContentVersion.v3d(setOf_0([BeastGameExpansions_Ashfall_getInstance(), BeastGameExpansions_ShatteredIsles_getInstance()])) : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.t3d(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(1, 1);
  }
  h3a() {
    return GameMapId_DrenchedLands_getInstance();
  }
  i3a() {
    return this.n3d_1;
  }
  j3a() {
    return 2;
  }
  k3a() {
    return 3;
  }
  l3a() {
    return this.o3d_1;
  }
  m3a() {
    return AshfallUnlikelyAllianceInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_destroyRecords($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp0_safe_receiver = element.q3a_1;
        var tmp_0 = tmp0_safe_receiver == null ? null : get_objectType($context_GameState_t6qee5, tmp0_safe_receiver);
        if (!(!(tmp_0 == null) ? isInterface(tmp_0, HunterCharacter) : false)) {
          destination.d2(element);
        }
      }
      var killings = destination;
      var tmp_1;
      var tmp_2;
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.count' call
        var tmp_3;
        if (isInterface(killings, Collection)) {
          tmp_3 = killings.n1();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$3 = 0;
          break $l$block;
        }
        var count = 0;
        var _iterator__ex2g4s_0 = killings.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (equals(get_objectType($context_GameState_t6qee5, element_0.o3a_1), SheepType_getInstance())) {
            count = count + 1 | 0;
            checkCountOverflow(count);
          }
        }
        tmp$ret$3 = count;
      }
      if (tmp$ret$3 >= 4) {
        tmp_2 = true;
      } else {
        var tmp_4;
        var tmp$ret$5;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_5;
          if (isInterface(killings, Collection)) {
            tmp_5 = killings.n1();
          } else {
            tmp_5 = false;
          }
          if (tmp_5) {
            tmp$ret$5 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_1 = killings.p1();
          while (_iterator__ex2g4s_1.q1()) {
            var element_1 = _iterator__ex2g4s_1.r1();
            if (equals(get_objectType($context_GameState_t6qee5, element_1.o3a_1), BoarType_getInstance())) {
              tmp$ret$5 = true;
              break $l$block_1;
            }
          }
          tmp$ret$5 = false;
        }
        if (tmp$ret$5) {
          var tmp$ret$7;
          $l$block_2: {
            // Inline function 'kotlin.collections.count' call
            var tmp_6;
            if (isInterface(killings, Collection)) {
              tmp_6 = killings.n1();
            } else {
              tmp_6 = false;
            }
            if (tmp_6) {
              tmp$ret$7 = 0;
              break $l$block_2;
            }
            var count_0 = 0;
            var _iterator__ex2g4s_2 = killings.p1();
            while (_iterator__ex2g4s_2.q1()) {
              var element_2 = _iterator__ex2g4s_2.r1();
              if (equals(get_objectType($context_GameState_t6qee5, element_2.o3a_1), SheepType_getInstance())) {
                count_0 = count_0 + 1 | 0;
                checkCountOverflow(count_0);
              }
            }
            tmp$ret$7 = count_0;
          }
          tmp_4 = tmp$ret$7 >= 2;
        } else {
          tmp_4 = false;
        }
        tmp_2 = tmp_4;
      }
      if (tmp_2) {
        tmp_1 = true;
      } else {
        var tmp_7;
        var tmp$ret$9;
        $l$block_4: {
          // Inline function 'kotlin.collections.any' call
          var tmp_8;
          if (isInterface(killings, Collection)) {
            tmp_8 = killings.n1();
          } else {
            tmp_8 = false;
          }
          if (tmp_8) {
            tmp$ret$9 = false;
            break $l$block_4;
          }
          var _iterator__ex2g4s_3 = killings.p1();
          while (_iterator__ex2g4s_3.q1()) {
            var element_3 = _iterator__ex2g4s_3.r1();
            if (equals(get_objectType($context_GameState_t6qee5, element_3.o3a_1), SheepType_getInstance())) {
              tmp$ret$9 = true;
              break $l$block_4;
            }
          }
          tmp$ret$9 = false;
        }
        if (tmp$ret$9) {
          var tmp$ret$11;
          $l$block_6: {
            // Inline function 'kotlin.collections.any' call
            var tmp_9;
            if (isInterface(killings, Collection)) {
              tmp_9 = killings.n1();
            } else {
              tmp_9 = false;
            }
            if (tmp_9) {
              tmp$ret$11 = false;
              break $l$block_6;
            }
            var _iterator__ex2g4s_4 = killings.p1();
            while (_iterator__ex2g4s_4.q1()) {
              var element_4 = _iterator__ex2g4s_4.r1();
              if (equals(get_objectType($context_GameState_t6qee5, element_4.o3a_1), TigerType_getInstance())) {
                tmp$ret$11 = true;
                break $l$block_6;
              }
            }
            tmp$ret$11 = false;
          }
          tmp_7 = tmp$ret$11;
        } else {
          tmp_7 = false;
        }
        tmp_1 = tmp_7;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp_1);
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredExpectedOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) > 0, ruinsControlled_0($context_GameState_t6qee5, get_huntersGameTeam()) >= 2);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      var tmp0_0 = get_destroyedObjects($context_GameState_t6qee5);
      var tmp$ret$13;
      $l$block_8: {
        // Inline function 'kotlin.collections.any' call
        var tmp_10;
        if (isInterface(tmp0_0, Collection)) {
          tmp_10 = tmp0_0.n1();
        } else {
          tmp_10 = false;
        }
        if (tmp_10) {
          tmp$ret$13 = false;
          break $l$block_8;
        }
        var _iterator__ex2g4s_5 = tmp0_0.p1();
        while (_iterator__ex2g4s_5.q1()) {
          var element_5 = _iterator__ex2g4s_5.r1();
          var tmp_11 = get_objectType($context_GameState_t6qee5, element_5);
          if (isInterface(tmp_11, SettlerType)) {
            tmp$ret$13 = true;
            break $l$block_8;
          }
        }
        tmp$ret$13 = false;
      }
      tmp = ensuredExpectedOrNotGainedRewardStatus(tmp$ret$13, ruinsControlled_0($context_GameState_t6qee5, get_beastsGameTeam()) >= 2);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) >= 2);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.p3d_1;
  }
  v3a(rulesParameters) {
    return AshfallUnlikelyAllianceContract.t3d(rulesParameters);
  }
  toString() {
    return 'AshfallUnlikelyAllianceContract(rulesParameters=' + this.m3d_1.toString() + ')';
  }
  hashCode() {
    return this.m3d_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AshfallUnlikelyAllianceContract))
      return false;
    if (!this.m3d_1.equals(other.m3d_1))
      return false;
    return true;
  }
  static s3d(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_75().j3d_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.m3d_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.n3d_1 = 3;
    else
      $this.n3d_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.o3d_1 = 2;
    else
      $this.o3d_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.p3d_1 = GameContentVersion.r3d(BeastGameExpansions_Ashfall_getInstance());
    else
      $this.p3d_1 = requiredVersion;
    return $this;
  }
}
class AshfallUnlikelyAllianceInitialPhase {
  constructor() {
    AshfallUnlikelyAllianceInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w3d_1 = lazy(tmp_0, AshfallUnlikelyAllianceInitialPhase$_anonymous__3ku9tn);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_48(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AshfallUnlikelyAllianceInitialPhase';
  }
  hashCode() {
    return -998317065;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AshfallUnlikelyAllianceInitialPhase))
      return false;
    return true;
  }
}
class Companion_86 {}
class $serializer_76 {
  constructor() {
    $serializer_instance_76 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AshfallAttackOrSummonFromRuinStatement', this, 1);
    tmp0_serialDesc.h1b('ruinPosition', false);
    this.x3d_1 = tmp0_serialDesc;
  }
  y3d(encoder, value) {
    var tmp0_desc = this.x3d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.z3d_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y3d(encoder, value instanceof AshfallAttackOrSummonFromRuinStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x3d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AshfallAttackOrSummonFromRuinStatement.a3e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x3d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100()];
  }
}
class AshfallAttackOrSummonFromRuinStatement {
  constructor(ruinPosition) {
    this.z3d_1 = ruinPosition;
  }
  toString() {
    return 'AshfallAttackOrSummonFromRuinStatement(ruinPosition=' + BoardPosition__toString_impl_v4mn82(this.z3d_1) + ')';
  }
  hashCode() {
    return BoardPosition__hashCode_impl_9dgqf7(this.z3d_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AshfallAttackOrSummonFromRuinStatement))
      return false;
    if (!(this.z3d_1 === other.z3d_1))
      return false;
    return true;
  }
  static a3e(seen0, ruinPosition, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_76().x3d_1);
    }
    var $this = createThis(this);
    $this.z3d_1 = ruinPosition;
    return $this;
  }
}
class Companion_87 {}
class $serializer_77 {
  constructor() {
    $serializer_instance_77 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AshfallEachBeastAndSummonMoves', this, 2);
    tmp0_serialDesc.h1b('isOnlyBeasts', false);
    tmp0_serialDesc.h1b('distance', false);
    this.b3e_1 = tmp0_serialDesc;
  }
  c3e(encoder, value) {
    var tmp0_desc = this.b3e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.w14(tmp0_desc, 0, value.d3e_1);
    tmp1_output.z14(tmp0_desc, 1, value.e3e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c3e(encoder, value instanceof AshfallEachBeastAndSummonMoves ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b3e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return AshfallEachBeastAndSummonMoves.f3e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.b3e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class AshfallEachBeastAndSummonMoves {
  constructor(isOnlyBeasts, distance) {
    this.d3e_1 = isOnlyBeasts;
    this.e3e_1 = distance;
  }
  toString() {
    return 'AshfallEachBeastAndSummonMoves(isOnlyBeasts=' + this.d3e_1 + ', distance=' + this.e3e_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.d3e_1);
    result = imul(result, 31) + this.e3e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AshfallEachBeastAndSummonMoves))
      return false;
    if (!(this.d3e_1 === other.d3e_1))
      return false;
    if (!(this.e3e_1 === other.e3e_1))
      return false;
    return true;
  }
  static f3e(seen0, isOnlyBeasts, distance, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_77().b3e_1);
    }
    var $this = createThis(this);
    $this.d3e_1 = isOnlyBeasts;
    $this.e3e_1 = distance;
    return $this;
  }
}
class HumanKindType {}
function get_preferredLocation_1($context_GameState_t6qee5) {
  return LocationType_Settlement_getInstance();
}
class HunterCharacter {}
function get_abilityCards() {
  return setOf_0([new HuntCard(this), new TrackCard(this)]);
}
function get_hunterCompanionType() {
  return null;
}
class Assar {
  constructor() {
    Assar_instance = this;
    this.g3e_1 = setOf_0([ResonanceUpgrade_getInstance(), ExceptionalTrackerUpgrade_getInstance(), SeekerUpgrade_getInstance(), ExploreUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h3e_1 = lazy(tmp_0, Assar$_anonymous__cku3dx);
  }
  s36() {
    return plus_0(get_abilityCards.call(this), ScoutCard_getInstance());
  }
  t35() {
    return this.g3e_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  v36($context_GameState_t6qee5, position) {
    return plus_1(getInitList_0.call(this, $context_GameState_t6qee5, position), init(get_assarWillCopyCardOfKey(), new ObjectOnBoardWrapper(null)));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_49(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Assar';
  }
  hashCode() {
    return 1651292877;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Assar))
      return false;
    return true;
  }
}
class ResonanceUpgrade {
  constructor() {
    ResonanceUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j3e_1 = lazy(tmp_0, ResonanceUpgrade$_anonymous__g6rrop);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_50(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ResonanceUpgrade';
  }
  hashCode() {
    return 1686458035;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResonanceUpgrade))
      return false;
    return true;
  }
}
class ExceptionalTrackerUpgrade {
  constructor() {
    ExceptionalTrackerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k3e_1 = lazy(tmp_0, ExceptionalTrackerUpgrade$_anonymous__6r143d);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_51(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ExceptionalTrackerUpgrade';
  }
  hashCode() {
    return 544302073;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExceptionalTrackerUpgrade))
      return false;
    return true;
  }
}
class SeekerUpgrade {
  constructor() {
    SeekerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l3e_1 = lazy(tmp_0, SeekerUpgrade$_anonymous__mkuly8);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_52(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SeekerUpgrade';
  }
  hashCode() {
    return 2046375570;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SeekerUpgrade))
      return false;
    return true;
  }
}
class ExploreUpgrade {
  constructor() {
    ExploreUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m3e_1 = lazy(tmp_0, ExploreUpgrade$_anonymous__h7ch8u);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_53(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ExploreUpgrade';
  }
  hashCode() {
    return -1950473714;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExploreUpgrade))
      return false;
    return true;
  }
}
class ScoutCard {
  constructor() {
    ScoutCard_instance = this;
    this.n3e_1 = Red_getInstance();
    this.o3e_1 = Assar_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p3e_1 = lazy(tmp_0, ScoutCard$_anonymous__6dk0rt);
  }
  t37() {
    return this.o3e_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_54(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ScoutCard';
  }
  hashCode() {
    return -766924279;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScoutCard))
      return false;
    return true;
  }
}
class ResonanceChooseStatement {
  constructor() {
    ResonanceChooseStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q3e_1 = lazy(tmp_0, ResonanceChooseStatement$_anonymous__qaisq5);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_55(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ResonanceChooseStatement';
  }
  hashCode() {
    return 2053106351;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResonanceChooseStatement))
      return false;
    return true;
  }
}
class Companion_88 {
  constructor() {
    Companion_instance_88 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r3e_1 = [lazy(tmp_0, ScoutStatement$Companion$$childSerializers$_anonymous__52ls7t)];
  }
}
class $serializer_78 {
  constructor() {
    $serializer_instance_78 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ScoutStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.s3e_1 = tmp0_serialDesc;
  }
  t3e(encoder, value) {
    var tmp0_desc = this.s3e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_89().r3e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u3e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t3e(encoder, value instanceof ScoutStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s3e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_89().r3e_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ScoutStatement.v3e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s3e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_89().r3e_1[0].k3()];
  }
}
class ScoutStatement {
  constructor(hunter) {
    Companion_getInstance_89();
    this.u3e_1 = hunter;
  }
  toString() {
    return 'ScoutStatement(hunter=' + this.u3e_1.toString() + ')';
  }
  hashCode() {
    return this.u3e_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScoutStatement))
      return false;
    if (!this.u3e_1.equals(other.u3e_1))
      return false;
    return true;
  }
  static v3e(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_89();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_78().s3e_1);
    }
    var $this = createThis(this);
    $this.u3e_1 = hunter;
    return $this;
  }
}
class HunterToCopyFirstRedCardQuestionContext {
  constructor() {
    HunterToCopyFirstRedCardQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w3e_1 = lazy(tmp_0, HunterToCopyFirstRedCardQuestionContext$_anonymous__5ybt4f);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_56(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToCopyFirstRedCardQuestionContext';
  }
  hashCode() {
    return -1995370621;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToCopyFirstRedCardQuestionContext))
      return false;
    return true;
  }
}
class Companion_89 {
  constructor() {
    Companion_instance_89 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x3e_1 = [lazy(tmp_0, ChangeRedDraftActionCardWasPlayedStatusEvent$Companion$$childSerializers$_anonymous__21p2p4), null];
  }
}
class $serializer_79 {
  constructor() {
    $serializer_instance_79 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChangeRedDraftActionCardWasPlayedStatusEvent', this, 2);
    tmp0_serialDesc.h1b('hunters', false);
    tmp0_serialDesc.h1b('newStatus', false);
    this.y3e_1 = tmp0_serialDesc;
  }
  z3e(encoder, value) {
    var tmp0_desc = this.y3e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_90().x3e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a3f_1);
    tmp1_output.w14(tmp0_desc, 1, value.b3f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z3e(encoder, value instanceof ChangeRedDraftActionCardWasPlayedStatusEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y3e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_90().x3e_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ChangeRedDraftActionCardWasPlayedStatusEvent.c3f(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.y3e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_90().x3e_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class ChangeRedDraftActionCardWasPlayedStatusEvent {
  constructor(hunters, newStatus) {
    Companion_getInstance_90();
    this.a3f_1 = hunters;
    this.b3f_1 = newStatus;
  }
  m37(_this__u8e3s4) {
    var _iterator__ex2g4s = this.a3f_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var hunter = _iterator__ex2g4s.r1();
      set_redDraftActionCardWasPlayedImpl(_this__u8e3s4, hunter, this.b3f_1);
    }
  }
  n37($context_GameState_t6qee5) {
    return new ChangeRedDraftActionCardWasPlayedStatusEvent(this.a3f_1, !this.b3f_1);
  }
  toString() {
    return 'ChangeRedDraftActionCardWasPlayedStatusEvent(hunters=' + toString(this.a3f_1) + ', newStatus=' + this.b3f_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.a3f_1);
    result = imul(result, 31) + getBooleanHashCode(this.b3f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangeRedDraftActionCardWasPlayedStatusEvent))
      return false;
    if (!equals(this.a3f_1, other.a3f_1))
      return false;
    if (!(this.b3f_1 === other.b3f_1))
      return false;
    return true;
  }
  static c3f(seen0, hunters, newStatus, serializationConstructorMarker) {
    Companion_getInstance_90();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_79().y3e_1);
    }
    var $this = createThis(this);
    $this.a3f_1 = hunters;
    $this.b3f_1 = newStatus;
    return $this;
  }
}
class Companion_90 {
  constructor() {
    Companion_instance_90 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d3f_1 = [lazy(tmp_0, ResonanceChooseEvent$Companion$$childSerializers$_anonymous__t3dvu3)];
  }
}
class $serializer_80 {
  constructor() {
    $serializer_instance_80 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ResonanceChooseEvent', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.e3f_1 = tmp0_serialDesc;
  }
  f3f(encoder, value) {
    var tmp0_desc = this.e3f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_91().d3f_1;
    tmp1_output.i15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g3f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f3f(encoder, value instanceof ResonanceChooseEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_91().d3f_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ResonanceChooseEvent.h3f(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e3f_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_91().d3f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0].k3())];
  }
}
class ResonanceChooseEvent {
  constructor(hunter) {
    Companion_getInstance_91();
    this.g3f_1 = hunter;
  }
  m37(_this__u8e3s4) {
    set_assarWillCopyCardOfImpl(_this__u8e3s4, get_assarHunter(_this__u8e3s4), this.g3f_1);
  }
  n37($context_GameState_t6qee5) {
    return new ResonanceChooseEvent(get_assarWillCopyCardOf($context_GameState_t6qee5, get_assarHunter($context_GameState_t6qee5)));
  }
  toString() {
    return 'ResonanceChooseEvent(hunter=' + toString_0(this.g3f_1) + ')';
  }
  hashCode() {
    return this.g3f_1 == null ? 0 : this.g3f_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResonanceChooseEvent))
      return false;
    if (!equals(this.g3f_1, other.g3f_1))
      return false;
    return true;
  }
  static h3f(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_91();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_80().e3f_1);
    }
    var $this = createThis(this);
    $this.g3f_1 = hunter;
    return $this;
  }
}
class Companion_91 {}
class $serializer_81 {
  constructor() {
    $serializer_instance_81 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AttackOnTheNorthernSettlementsContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.j3f_1 = tmp0_serialDesc;
  }
  k3f(encoder, value) {
    var tmp0_desc = this.j3f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.m3f_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.n3f_1 === 4)) {
      tmp1_output.z14(tmp0_desc, 2, value.n3f_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.o3f_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 3, value.o3f_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.p3f_1.equals(Companion_getInstance_220().w39_1)) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.p3f_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k3f(encoder, value instanceof AttackOnTheNorthernSettlementsContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return AttackOnTheNorthernSettlementsContract.q3f(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.j3f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class AttackOnTheNorthernSettlementsContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.r3f(rulesParameters);
  }
  static r3f(rulesParameters) {
    var $this = this.b3a();
    $this.m3f_1 = rulesParameters;
    $this.n3f_1 = 4;
    $this.o3f_1 = 3;
    $this.p3f_1 = Companion_getInstance_220().w39_1;
    return $this;
  }
  c3a() {
    return this.m3f_1;
  }
  static s3f(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().w39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.r3f(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(2, 1, 2);
  }
  h3a() {
    return GameMapId_NorthernExpanse_getInstance();
  }
  i3a() {
    return this.n3f_1;
  }
  j3a() {
    return 1;
  }
  k3a() {
    return 3;
  }
  l3a() {
    return this.o3f_1;
  }
  m3a() {
    return AttackOnTheNorthernSettlementsInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_isClassicTwoSheepOrBoarCompleted_0($context_GameState_t6qee5));
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) > 0);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_destroyRecords($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp0_safe_receiver = element.q3a_1;
        var tmp_0 = tmp0_safe_receiver == null ? null : get_objectType($context_GameState_t6qee5, tmp0_safe_receiver);
        if (!(!(tmp_0 == null) ? isInterface(tmp_0, HunterCharacter) : false)) {
          destination.d2(element);
        }
      }
      var killings = destination;
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_0 = get_destroyedObjects($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = tmp0_0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        var tmp$ret$9;
        $l$block: {
          // Inline function 'steelart.beast.cast' call
          var tmp_1 = get_objectType($context_GameState_t6qee5, element_0);
          if (isInterface(tmp_1, SettlerType)) {
            tmp$ret$9 = element_0 instanceof ObjectOnBoard ? element_0 : THROW_CCE();
            break $l$block;
          }
          tmp$ret$9 = null;
        }
        var tmp0_safe_receiver_0 = tmp$ret$9;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_0.d2(tmp0_safe_receiver_0);
        }
      }
      var deadSettlers = destination_0;
      var tmp_2;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!deadSettlers.n1()) {
        tmp_2 = true;
      } else {
        var tmp$ret$13;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(killings, Collection)) {
            tmp_3 = killings.n1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$13 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_1 = killings.p1();
          while (_iterator__ex2g4s_1.q1()) {
            var element_1 = _iterator__ex2g4s_1.r1();
            var tmp_4 = get_objectType($context_GameState_t6qee5, element_1.o3a_1);
            if (tmp_4 instanceof BoarType) {
              tmp$ret$13 = true;
              break $l$block_1;
            }
          }
          tmp$ret$13 = false;
        }
        tmp_2 = tmp$ret$13;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp_2);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_1 = get_destroyedObjects($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_1 = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_2 = tmp0_1.p1();
      while (_iterator__ex2g4s_2.q1()) {
        var element_2 = _iterator__ex2g4s_2.r1();
        var tmp$ret$21;
        $l$block_2: {
          // Inline function 'steelart.beast.cast' call
          var tmp_5 = get_objectType($context_GameState_t6qee5, element_2);
          if (isInterface(tmp_5, SettlerType)) {
            tmp$ret$21 = element_2 instanceof ObjectOnBoard ? element_2 : THROW_CCE();
            break $l$block_2;
          }
          tmp$ret$21 = null;
        }
        var tmp0_safe_receiver_1 = tmp$ret$21;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_1.d2(tmp0_safe_receiver_1);
        }
      }
      var tmp$ret$24;
      $l$block_4: {
        // Inline function 'kotlin.collections.none' call
        var tmp_6;
        if (isInterface(destination_1, Collection)) {
          tmp_6 = destination_1.n1();
        } else {
          tmp_6 = false;
        }
        if (tmp_6) {
          tmp$ret$24 = true;
          break $l$block_4;
        }
        var _iterator__ex2g4s_3 = destination_1.p1();
        while (_iterator__ex2g4s_3.q1()) {
          var element_3 = _iterator__ex2g4s_3.r1();
          if (get_initialPosition($context_GameState_t6qee5, element_3) === _BoardPosition___init__impl__1nizgq_0(-2, 2)) {
            tmp$ret$24 = false;
            break $l$block_4;
          }
        }
        tmp$ret$24 = true;
      }
      tmp = expectedOrFailedRewardStatus(tmp$ret$24);
    } else if (tmp0_subject.equals(to(3, new GameTeam(get_beastsGameTeam())))) {
      var tmp_7;
      // Inline function 'steelart.beast.destroyObjectsOfType' call
      var causedTeam = get_beastsGameTeam();
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_2 = get_destroyedObjects($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_2 = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_4 = tmp0_2.p1();
      while (_iterator__ex2g4s_4.q1()) {
        var element_4 = _iterator__ex2g4s_4.r1();
        var tmp$ret$33;
        $l$block_5: {
          // Inline function 'steelart.beast.cast' call
          var tmp_8 = get_objectType($context_GameState_t6qee5, element_4);
          if (tmp_8 instanceof SheepType) {
            tmp$ret$33 = element_4 instanceof ObjectOnBoard ? element_4 : THROW_CCE();
            break $l$block_5;
          }
          tmp$ret$33 = null;
        }
        var tmp0_safe_receiver_2 = tmp$ret$33;
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_2.d2(tmp0_safe_receiver_2);
        }
      }
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_3 = ArrayList.p2();
      var _iterator__ex2g4s_5 = destination_2.p1();
      while (_iterator__ex2g4s_5.q1()) {
        var element_5 = _iterator__ex2g4s_5.r1();
        if (ensureNotNull(get_destroyRecord($context_GameState_t6qee5, element_5)).p3a_1 === causedTeam) {
          destination_3.d2(element_5);
        }
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!destination_3.n1()) {
        tmp_7 = true;
      } else {
        // Inline function 'steelart.beast.destroyObjectsOfType' call
        var causedTeam_0 = get_beastsGameTeam();
        // Inline function 'steelart.beast.castFilter' call
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0_3 = get_destroyedObjects($context_GameState_t6qee5);
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination_4 = ArrayList.p2();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_6 = tmp0_3.p1();
        while (_iterator__ex2g4s_6.q1()) {
          var element_6 = _iterator__ex2g4s_6.r1();
          var tmp$ret$47;
          $l$block_6: {
            // Inline function 'steelart.beast.cast' call
            var tmp_9 = get_objectType($context_GameState_t6qee5, element_6);
            if (tmp_9 instanceof BoarType) {
              tmp$ret$47 = element_6 instanceof ObjectOnBoard ? element_6 : THROW_CCE();
              break $l$block_6;
            }
            tmp$ret$47 = null;
          }
          var tmp0_safe_receiver_3 = tmp$ret$47;
          if (tmp0_safe_receiver_3 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_4.d2(tmp0_safe_receiver_3);
          }
        }
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_5 = ArrayList.p2();
        var _iterator__ex2g4s_7 = destination_4.p1();
        while (_iterator__ex2g4s_7.q1()) {
          var element_7 = _iterator__ex2g4s_7.r1();
          if (ensureNotNull(get_destroyRecord($context_GameState_t6qee5, element_7)).p3a_1 === causedTeam_0) {
            destination_5.d2(element_7);
          }
        }
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_7 = !destination_5.n1();
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp_7);
    } else if (tmp0_subject.equals(to(3, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) >= 3);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.p3f_1;
  }
  v3a(rulesParameters) {
    return AttackOnTheNorthernSettlementsContract.r3f(rulesParameters);
  }
  toString() {
    return 'AttackOnTheNorthernSettlementsContract(rulesParameters=' + this.m3f_1.toString() + ')';
  }
  hashCode() {
    return this.m3f_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AttackOnTheNorthernSettlementsContract))
      return false;
    if (!this.m3f_1.equals(other.m3f_1))
      return false;
    return true;
  }
  static q3f(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_81().j3f_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.m3f_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.n3f_1 = 4;
    else
      $this.n3f_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.o3f_1 = 3;
    else
      $this.o3f_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.p3f_1 = Companion_getInstance_220().w39_1;
    else
      $this.p3f_1 = requiredVersion;
    return $this;
  }
}
class AttackOnTheNorthernSettlementsInitialPhase {
  constructor() {
    AttackOnTheNorthernSettlementsInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t3f_1 = lazy(tmp_0, AttackOnTheNorthernSettlementsInitialPhase$_anonymous__u3xjx8);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_57(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AttackOnTheNorthernSettlementsInitialPhase';
  }
  hashCode() {
    return 482013888;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AttackOnTheNorthernSettlementsInitialPhase))
      return false;
    return true;
  }
}
class Companion_92 {
  a2g() {
    var tmp = getKClass(BeastCharacter);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Akkeron), getKClass(Bolgin), getKClass(EsmeriaBeast), getKClass(Fangrir), getKClass(FeatheredKing), getKClass(Hogbad), getKClass(Lydan), getKClass(Mara), getKClass(Omma), getKClass(Raaga), getKClass(Rhagner), getKClass(Thalduk), getKClass(Urgull), getKClass(Vacker)];
    var tmp_1 = Akkeron_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Akkeron', tmp_1, tmp$ret$3);
    var tmp_3 = Bolgin_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('Bolgin', tmp_3, tmp$ret$6);
    var tmp_5 = EsmeriaBeast_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('EsmeriaBeast', tmp_5, tmp$ret$9);
    var tmp_7 = Fangrir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Fangrir', tmp_7, tmp$ret$12);
    var tmp_9 = FeatheredKing_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('FeatheredKing', tmp_9, tmp$ret$15);
    var tmp_11 = Hogbad_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('Hogbad', tmp_11, tmp$ret$18);
    var tmp_13 = Lydan_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('Lydan', tmp_13, tmp$ret$21);
    var tmp_15 = Mara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('Mara', tmp_15, tmp$ret$24);
    var tmp_17 = Omma_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('Omma', tmp_17, tmp$ret$27);
    var tmp_19 = Raaga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('Raaga', tmp_19, tmp$ret$30);
    var tmp_21 = Rhagner_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('Rhagner', tmp_21, tmp$ret$33);
    var tmp_23 = Thalduk_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('Thalduk', tmp_23, tmp$ret$36);
    var tmp_25 = Urgull_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('Urgull', tmp_25, tmp$ret$39);
    var tmp_27 = Vacker_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_28 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, ObjectSerializer.l1c('Vacker', tmp_27, tmp$ret$42)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    return SealedClassSerializer.i10('steelart.beast.BeastCharacter', tmp, tmp_0, tmp_28, tmp$ret$48);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_93 {
  constructor() {
    Companion_instance_93 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, BeastPathStep$Companion$$childSerializers$_anonymous__3n7h5y);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u3f_1 = [tmp_1, lazy(tmp_2, BeastPathStep$Companion$$childSerializers$_anonymous__3n7h5y_0)];
  }
}
class $serializer_82 {
  constructor() {
    $serializer_instance_82 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.BeastPathStep', this, 2);
    tmp0_serialDesc.h1b('movementList', false);
    tmp0_serialDesc.h1b('moveWasFromLocationType', true);
    this.v3f_1 = tmp0_serialDesc;
  }
  w3f(encoder, value) {
    var tmp0_desc = this.v3f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_94().u3f_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x3f_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.y3f_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.y3f_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w3f(encoder, value instanceof BeastPathStep ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_94().u3f_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BeastPathStep.z3f(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.v3f_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_94().u3f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), get_nullable(tmp0_cached[1].k3())];
  }
}
class BeastPathStep {
  constructor(movementList, moveWasFromLocationType) {
    return new.target.a3g(movementList, moveWasFromLocationType);
  }
  static a3g(movementList, moveWasFromLocationType) {
    Companion_getInstance_94();
    moveWasFromLocationType = moveWasFromLocationType === VOID ? null : moveWasFromLocationType;
    var $this = createThis(this);
    $this.x3f_1 = movementList;
    $this.y3f_1 = moveWasFromLocationType;
    return $this;
  }
  static b3g(position) {
    Companion_getInstance_94();
    return this.a3g(listOf(new MovementToLocation(position, MovementType_SimpleMovement_getInstance())));
  }
  c3g() {
    return this.x3f_1.u2(0);
  }
  d3g(movementList, moveWasFromLocationType) {
    return BeastPathStep.a3g(movementList, moveWasFromLocationType);
  }
  e3g(movementList, moveWasFromLocationType, $super) {
    movementList = movementList === VOID ? this.x3f_1 : movementList;
    moveWasFromLocationType = moveWasFromLocationType === VOID ? this.y3f_1 : moveWasFromLocationType;
    return $super === VOID ? this.d3g(movementList, moveWasFromLocationType) : $super.d3g.call(this, movementList, moveWasFromLocationType);
  }
  toString() {
    return 'BeastPathStep(movementList=' + toString(this.x3f_1) + ', moveWasFromLocationType=' + toString_0(this.y3f_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.x3f_1);
    result = imul(result, 31) + (this.y3f_1 == null ? 0 : this.y3f_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastPathStep))
      return false;
    if (!equals(this.x3f_1, other.x3f_1))
      return false;
    if (!equals(this.y3f_1, other.y3f_1))
      return false;
    return true;
  }
  static z3f(seen0, movementList, moveWasFromLocationType, serializationConstructorMarker) {
    Companion_getInstance_94();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_82().v3f_1);
    }
    var $this = createThis(this);
    $this.x3f_1 = movementList;
    if (0 === (seen0 & 2))
      $this.y3f_1 = null;
    else
      $this.y3f_1 = moveWasFromLocationType;
    return $this;
  }
}
class Companion_94 {
  constructor() {
    Companion_instance_94 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, MovementAndState$Companion$$childSerializers$_anonymous__hybmvz);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f3g_1 = [tmp_1, lazy(tmp_2, MovementAndState$Companion$$childSerializers$_anonymous__hybmvz_0), null];
  }
}
class $serializer_83 {
  constructor() {
    $serializer_instance_83 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MovementAndState', this, 3);
    tmp0_serialDesc.h1b('movements', false);
    tmp0_serialDesc.h1b('leadToLocationType', true);
    tmp0_serialDesc.h1b('isOpen', true);
    this.g3g_1 = tmp0_serialDesc;
  }
  h3g(encoder, value) {
    var tmp0_desc = this.g3g_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_95().f3g_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i3g_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.j3g_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.j3g_1);
    }
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.k3g_1 === false)) {
      tmp1_output.w14(tmp0_desc, 2, value.k3g_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h3g(encoder, value instanceof MovementAndState ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g3g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_95().f3g_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return MovementAndState.l3g(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.g3g_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_95().f3g_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), get_nullable(tmp0_cached[1].k3()), BooleanSerializer_getInstance()];
  }
}
class MovementAndState {
  constructor(movements, leadToLocationType, isOpen) {
    Companion_getInstance_95();
    leadToLocationType = leadToLocationType === VOID ? null : leadToLocationType;
    isOpen = isOpen === VOID ? false : isOpen;
    this.i3g_1 = movements;
    this.j3g_1 = leadToLocationType;
    this.k3g_1 = isOpen;
  }
  m3g() {
    return !this.k3g_1;
  }
  n3g() {
    return this.i3g_1.u2(0);
  }
  o3g(movements, leadToLocationType, isOpen) {
    return new MovementAndState(movements, leadToLocationType, isOpen);
  }
  p3g(movements, leadToLocationType, isOpen, $super) {
    movements = movements === VOID ? this.i3g_1 : movements;
    leadToLocationType = leadToLocationType === VOID ? this.j3g_1 : leadToLocationType;
    isOpen = isOpen === VOID ? this.k3g_1 : isOpen;
    return $super === VOID ? this.o3g(movements, leadToLocationType, isOpen) : $super.o3g.call(this, movements, leadToLocationType, isOpen);
  }
  toString() {
    return 'MovementAndState(movements=' + toString(this.i3g_1) + ', leadToLocationType=' + toString_0(this.j3g_1) + ', isOpen=' + this.k3g_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.i3g_1);
    result = imul(result, 31) + (this.j3g_1 == null ? 0 : this.j3g_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k3g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MovementAndState))
      return false;
    if (!equals(this.i3g_1, other.i3g_1))
      return false;
    if (!equals(this.j3g_1, other.j3g_1))
      return false;
    if (!(this.k3g_1 === other.k3g_1))
      return false;
    return true;
  }
  static l3g(seen0, movements, leadToLocationType, isOpen, serializationConstructorMarker) {
    Companion_getInstance_95();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_83().g3g_1);
    }
    var $this = createThis(this);
    $this.i3g_1 = movements;
    if (0 === (seen0 & 2))
      $this.j3g_1 = null;
    else
      $this.j3g_1 = leadToLocationType;
    if (0 === (seen0 & 4))
      $this.k3g_1 = false;
    else
      $this.k3g_1 = isOpen;
    return $this;
  }
}
class possibleTrailMaxCounts$$inlined$groupingBy$1 {
  constructor($this) {
    this.u3g_1 = $this;
  }
  n7() {
    return this.u3g_1.p1();
  }
  f10(element) {
    return new BoardPosition(element.v3g_1);
  }
  o7(element) {
    return this.f10(element);
  }
}
class Companion_95 {}
class $serializer_84 {
  constructor() {
    $serializer_instance_84 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('IntuitionCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.x3g_1 = tmp0_serialDesc;
  }
  y3g(encoder, value) {
    var tmp0_desc = this.x3g_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.z3g_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y3g(encoder, value instanceof IntuitionCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x3g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return IntuitionCard.a3h(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x3g_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class BeastlyTalentCard {}
class IntuitionCard {
  constructor(number) {
    this.z3g_1 = number;
  }
  u37() {
    return this.z3g_1;
  }
  toString() {
    return 'IntuitionCard(number=' + this.z3g_1 + ')';
  }
  hashCode() {
    return this.z3g_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IntuitionCard))
      return false;
    if (!(this.z3g_1 === other.z3g_1))
      return false;
    return true;
  }
  static a3h(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_84().x3g_1);
    }
    var $this = createThis(this);
    $this.z3g_1 = number;
    return $this;
  }
}
class SuddenMistCard {
  constructor() {
    SuddenMistCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b3h_1 = lazy(tmp_0, SuddenMistCard$_anonymous__yihj7l);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_58(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SuddenMistCard';
  }
  hashCode() {
    return -1517460643;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SuddenMistCard))
      return false;
    return true;
  }
}
class Companion_96 {}
class $serializer_85 {
  constructor() {
    $serializer_instance_85 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('WorldShiftCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.c3h_1 = tmp0_serialDesc;
  }
  d3h(encoder, value) {
    var tmp0_desc = this.c3h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.e3h_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d3h(encoder, value instanceof WorldShiftCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c3h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return WorldShiftCard.f3h(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.c3h_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class WorldShiftCard {
  constructor(number) {
    this.e3h_1 = number;
  }
  u37() {
    return this.e3h_1;
  }
  toString() {
    return 'WorldShiftCard(number=' + this.e3h_1 + ')';
  }
  hashCode() {
    return this.e3h_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WorldShiftCard))
      return false;
    if (!(this.e3h_1 === other.e3h_1))
      return false;
    return true;
  }
  static f3h(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_85().c3h_1);
    }
    var $this = createThis(this);
    $this.e3h_1 = number;
    return $this;
  }
}
class Companion_97 {
  a2g() {
    var tmp = getKClass(BeastlyTalentCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(IntuitionCard), getKClass(AbruptDecayCard), getKClass(BrutalityCard), getKClass(DisappearCard), getKClass(DisperseCard), getKClass(EvolveCard), getKClass(FeastCard), getKClass(FlourishCard), getKClass(FuryCard), getKClass(HatredCard), getKClass(InsidiousGrowthCard), getKClass(MirrorStepCard), getKClass(OverloadedFuryCard), getKClass(OverloadedShatterCard), getKClass(RageCard), getKClass(RecoveryTestBeastCard), getKClass(RoamCard), getKClass(ShatterCard), getKClass(SprawlCard), getKClass(StrangeSummonsCard), getKClass(SwarmCard), getKClass(UnbendingWillCard), getKClass(RecoveryTestBeastReaction), getKClass(RecoveryTestNightlyRewardsFailureCard), getKClass(RecoveryTestPhaseFailureCard), getKClass(RecoveryTestTeamRewardFailureCard), getKClass(SuddenMistCard), getKClass(UnknownBeastlyTalentCard), getKClass(WorldShiftCard)];
    var tmp_1 = $serializer_getInstance_84();
    var tmp_2 = AbruptDecayCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_3 = ObjectSerializer.l1c('AbruptDecayCard', tmp_2, tmp$ret$3);
    var tmp_4 = $serializer_getInstance_88();
    var tmp_5 = DisappearCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_6 = ObjectSerializer.l1c('DisappearCard', tmp_5, tmp$ret$6);
    var tmp_7 = $serializer_getInstance_92();
    var tmp_8 = $serializer_getInstance_86();
    var tmp_9 = $serializer_getInstance_96();
    var tmp_10 = $serializer_getInstance_97();
    var tmp_11 = FuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_12 = ObjectSerializer.l1c('FuryCard', tmp_11, tmp$ret$9);
    var tmp_13 = $serializer_getInstance_91();
    var tmp_14 = $serializer_getInstance_93();
    var tmp_15 = $serializer_getInstance_98();
    var tmp_16 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_17 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_16, tmp$ret$12);
    var tmp_18 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_19 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_18, tmp$ret$15);
    var tmp_20 = $serializer_getInstance_89();
    var tmp_21 = $serializer_getInstance_378();
    var tmp_22 = $serializer_getInstance_94();
    var tmp_23 = ShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_24 = ObjectSerializer.l1c('ShatterCard', tmp_23, tmp$ret$18);
    var tmp_25 = $serializer_getInstance_95();
    var tmp_26 = $serializer_getInstance_90();
    var tmp_27 = SwarmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_28 = ObjectSerializer.l1c('SwarmCard', tmp_27, tmp$ret$21);
    var tmp_29 = $serializer_getInstance_87();
    var tmp_30 = RecoveryTestBeastReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_31 = ObjectSerializer.l1c('RecoveryTestBeastReaction', tmp_30, tmp$ret$24);
    var tmp_32 = RecoveryTestNightlyRewardsFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_33 = ObjectSerializer.l1c('RecoveryTestNightlyRewardsFailureCard', tmp_32, tmp$ret$27);
    var tmp_34 = RecoveryTestPhaseFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_35 = ObjectSerializer.l1c('RecoveryTestPhaseFailureCard', tmp_34, tmp$ret$30);
    var tmp_36 = RecoveryTestTeamRewardFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_37 = ObjectSerializer.l1c('RecoveryTestTeamRewardFailureCard', tmp_36, tmp$ret$33);
    var tmp_38 = SuddenMistCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_39 = [tmp_1, tmp_3, tmp_4, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_12, tmp_13, tmp_14, tmp_15, tmp_17, tmp_19, tmp_20, tmp_21, tmp_22, tmp_24, tmp_25, tmp_26, tmp_28, tmp_29, tmp_31, tmp_33, tmp_35, tmp_37, ObjectSerializer.l1c('SuddenMistCard', tmp_38, tmp$ret$36), $serializer_getInstance_99(), $serializer_getInstance_85()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    return SealedClassSerializer.i10('steelart.beast.BeastlyTalentCard', tmp, tmp_0, tmp_39, tmp$ret$42);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_98 {
  constructor() {
    Companion_instance_98 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g3h_1 = [null, lazy(tmp_0, EvolveCard$Companion$$childSerializers$_anonymous__e2t2wt)];
  }
}
class $serializer_86 {
  constructor() {
    $serializer_instance_86 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EvolveCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.h3h_1 = tmp0_serialDesc;
  }
  i3h(encoder, value) {
    var tmp0_desc = this.h3h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_99().g3h_1;
    tmp1_output.z14(tmp0_desc, 0, value.j3h_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.k3h_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.k3h_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i3h(encoder, value instanceof EvolveCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h3h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_99().g3h_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return EvolveCard.l3h(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.h3h_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_99().g3h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class EvolveCard {
  constructor(number) {
    Companion_getInstance_99();
    this.j3h_1 = number;
    this.k3h_1 = Blue_getInstance();
  }
  u37() {
    return this.j3h_1;
  }
  toString() {
    return 'EvolveCard(number=' + this.j3h_1 + ')';
  }
  hashCode() {
    return this.j3h_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EvolveCard))
      return false;
    if (!(this.j3h_1 === other.j3h_1))
      return false;
    return true;
  }
  static l3h(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_99();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_86().h3h_1);
    }
    var $this = createThis(this);
    $this.j3h_1 = number;
    if (0 === (seen0 & 2))
      $this.k3h_1 = Blue_getInstance();
    else
      $this.k3h_1 = playColor;
    return $this;
  }
}
class Companion_99 {
  constructor() {
    Companion_instance_99 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m3h_1 = [null, lazy(tmp_0, UnbendingWillCard$Companion$$childSerializers$_anonymous__9rfi14)];
  }
}
class $serializer_87 {
  constructor() {
    $serializer_instance_87 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UnbendingWillCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.n3h_1 = tmp0_serialDesc;
  }
  o3h(encoder, value) {
    var tmp0_desc = this.n3h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_100().m3h_1;
    tmp1_output.z14(tmp0_desc, 0, value.p3h_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.q3h_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.q3h_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o3h(encoder, value instanceof UnbendingWillCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n3h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_100().m3h_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return UnbendingWillCard.r3h(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.n3h_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_100().m3h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class UnbendingWillCard {
  constructor(number) {
    Companion_getInstance_100();
    this.p3h_1 = number;
    this.q3h_1 = Blue_getInstance();
  }
  u37() {
    return this.p3h_1;
  }
  toString() {
    return 'UnbendingWillCard(number=' + this.p3h_1 + ')';
  }
  hashCode() {
    return this.p3h_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnbendingWillCard))
      return false;
    if (!(this.p3h_1 === other.p3h_1))
      return false;
    return true;
  }
  static r3h(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_100();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_87().n3h_1);
    }
    var $this = createThis(this);
    $this.p3h_1 = number;
    if (0 === (seen0 & 2))
      $this.q3h_1 = Blue_getInstance();
    else
      $this.q3h_1 = playColor;
    return $this;
  }
}
class Companion_100 {
  constructor() {
    Companion_instance_100 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s3h_1 = [null, lazy(tmp_0, BrutalityCard$Companion$$childSerializers$_anonymous__y5p32y)];
  }
}
class $serializer_88 {
  constructor() {
    $serializer_instance_88 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BrutalityCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.t3h_1 = tmp0_serialDesc;
  }
  u3h(encoder, value) {
    var tmp0_desc = this.t3h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_101().s3h_1;
    tmp1_output.z14(tmp0_desc, 0, value.v3h_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.w3h_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.w3h_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u3h(encoder, value instanceof BrutalityCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t3h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_101().s3h_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BrutalityCard.x3h(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.t3h_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_101().s3h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class BrutalityCard {
  constructor(number) {
    Companion_getInstance_101();
    this.v3h_1 = number;
    this.w3h_1 = Red_getInstance();
  }
  u37() {
    return this.v3h_1;
  }
  toString() {
    return 'BrutalityCard(number=' + this.v3h_1 + ')';
  }
  hashCode() {
    return this.v3h_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BrutalityCard))
      return false;
    if (!(this.v3h_1 === other.v3h_1))
      return false;
    return true;
  }
  static x3h(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_101();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_88().t3h_1);
    }
    var $this = createThis(this);
    $this.v3h_1 = number;
    if (0 === (seen0 & 2))
      $this.w3h_1 = Red_getInstance();
    else
      $this.w3h_1 = playColor;
    return $this;
  }
}
class Companion_101 {
  constructor() {
    Companion_instance_101 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y3h_1 = [null, lazy(tmp_0, RageCard$Companion$$childSerializers$_anonymous__tnthar)];
  }
}
class $serializer_89 {
  constructor() {
    $serializer_instance_89 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RageCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.z3h_1 = tmp0_serialDesc;
  }
  a3i(encoder, value) {
    var tmp0_desc = this.z3h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_102().y3h_1;
    tmp1_output.z14(tmp0_desc, 0, value.b3i_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.c3i_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.c3i_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a3i(encoder, value instanceof RageCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z3h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_102().y3h_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RageCard.d3i(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.z3h_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_102().y3h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class RageCard {
  constructor(number) {
    Companion_getInstance_102();
    this.b3i_1 = number;
    this.c3i_1 = Red_getInstance();
  }
  u37() {
    return this.b3i_1;
  }
  toString() {
    return 'RageCard(number=' + this.b3i_1 + ')';
  }
  hashCode() {
    return this.b3i_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RageCard))
      return false;
    if (!(this.b3i_1 === other.b3i_1))
      return false;
    return true;
  }
  static d3i(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_102();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_89().z3h_1);
    }
    var $this = createThis(this);
    $this.b3i_1 = number;
    if (0 === (seen0 & 2))
      $this.c3i_1 = Red_getInstance();
    else
      $this.c3i_1 = playColor;
    return $this;
  }
}
class Companion_102 {
  constructor() {
    Companion_instance_102 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e3i_1 = [null, lazy(tmp_0, StrangeSummonsCard$Companion$$childSerializers$_anonymous__o2tiec)];
  }
}
class $serializer_90 {
  constructor() {
    $serializer_instance_90 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('StrangeSummonsCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.f3i_1 = tmp0_serialDesc;
  }
  g3i(encoder, value) {
    var tmp0_desc = this.f3i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_103().e3i_1;
    tmp1_output.z14(tmp0_desc, 0, value.h3i_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.i3i_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.i3i_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g3i(encoder, value instanceof StrangeSummonsCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f3i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_103().e3i_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return StrangeSummonsCard.j3i(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.f3i_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_103().e3i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class StrangeSummonsCard {
  constructor(number) {
    Companion_getInstance_103();
    this.h3i_1 = number;
    this.i3i_1 = Blue_getInstance();
  }
  u37() {
    return this.h3i_1;
  }
  toString() {
    return 'StrangeSummonsCard(number=' + this.h3i_1 + ')';
  }
  hashCode() {
    return this.h3i_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StrangeSummonsCard))
      return false;
    if (!(this.h3i_1 === other.h3i_1))
      return false;
    return true;
  }
  static j3i(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_103();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_90().f3i_1);
    }
    var $this = createThis(this);
    $this.h3i_1 = number;
    if (0 === (seen0 & 2))
      $this.i3i_1 = Blue_getInstance();
    else
      $this.i3i_1 = playColor;
    return $this;
  }
}
class Companion_103 {
  constructor() {
    Companion_instance_103 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k3i_1 = [null, lazy(tmp_0, HatredCard$Companion$$childSerializers$_anonymous__q0s6p0)];
  }
}
class $serializer_91 {
  constructor() {
    $serializer_instance_91 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HatredCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.l3i_1 = tmp0_serialDesc;
  }
  m3i(encoder, value) {
    var tmp0_desc = this.l3i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_104().k3i_1;
    tmp1_output.z14(tmp0_desc, 0, value.n3i_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.o3i_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.o3i_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m3i(encoder, value instanceof HatredCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l3i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_104().k3i_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return HatredCard.p3i(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.l3i_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_104().k3i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class HatredCard {
  constructor(number) {
    Companion_getInstance_104();
    this.n3i_1 = number;
    this.o3i_1 = Red_getInstance();
  }
  u37() {
    return this.n3i_1;
  }
  toString() {
    return 'HatredCard(number=' + this.n3i_1 + ')';
  }
  hashCode() {
    return this.n3i_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HatredCard))
      return false;
    if (!(this.n3i_1 === other.n3i_1))
      return false;
    return true;
  }
  static p3i(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_104();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_91().l3i_1);
    }
    var $this = createThis(this);
    $this.n3i_1 = number;
    if (0 === (seen0 & 2))
      $this.o3i_1 = Red_getInstance();
    else
      $this.o3i_1 = playColor;
    return $this;
  }
}
class Companion_104 {
  constructor() {
    Companion_instance_104 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q3i_1 = [null, lazy(tmp_0, DisperseCard$Companion$$childSerializers$_anonymous__v9ciqv)];
  }
}
class $serializer_92 {
  constructor() {
    $serializer_instance_92 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DisperseCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.r3i_1 = tmp0_serialDesc;
  }
  s3i(encoder, value) {
    var tmp0_desc = this.r3i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_105().q3i_1;
    tmp1_output.z14(tmp0_desc, 0, value.t3i_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.u3i_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.u3i_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s3i(encoder, value instanceof DisperseCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r3i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_105().q3i_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return DisperseCard.v3i(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r3i_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_105().q3i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class DisperseCard {
  constructor(number) {
    Companion_getInstance_105();
    this.t3i_1 = number;
    this.u3i_1 = Red_getInstance();
  }
  u37() {
    return this.t3i_1;
  }
  toString() {
    return 'DisperseCard(number=' + this.t3i_1 + ')';
  }
  hashCode() {
    return this.t3i_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DisperseCard))
      return false;
    if (!(this.t3i_1 === other.t3i_1))
      return false;
    return true;
  }
  static v3i(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_105();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_92().r3i_1);
    }
    var $this = createThis(this);
    $this.t3i_1 = number;
    if (0 === (seen0 & 2))
      $this.u3i_1 = Red_getInstance();
    else
      $this.u3i_1 = playColor;
    return $this;
  }
}
class Companion_105 {
  constructor() {
    Companion_instance_105 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w3i_1 = [null, lazy(tmp_0, InsidiousGrowthCard$Companion$$childSerializers$_anonymous__decta2)];
  }
}
class $serializer_93 {
  constructor() {
    $serializer_instance_93 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('InsidiousGrowthCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.x3i_1 = tmp0_serialDesc;
  }
  y3i(encoder, value) {
    var tmp0_desc = this.x3i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_106().w3i_1;
    tmp1_output.z14(tmp0_desc, 0, value.z3i_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.a3j_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.a3j_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y3i(encoder, value instanceof InsidiousGrowthCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x3i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_106().w3i_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return InsidiousGrowthCard.b3j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.x3i_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_106().w3i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class InsidiousGrowthCard {
  constructor(number) {
    Companion_getInstance_106();
    this.z3i_1 = number;
    this.a3j_1 = Blue_getInstance();
  }
  u37() {
    return this.z3i_1;
  }
  toString() {
    return 'InsidiousGrowthCard(number=' + this.z3i_1 + ')';
  }
  hashCode() {
    return this.z3i_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InsidiousGrowthCard))
      return false;
    if (!(this.z3i_1 === other.z3i_1))
      return false;
    return true;
  }
  static b3j(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_106();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_93().x3i_1);
    }
    var $this = createThis(this);
    $this.z3i_1 = number;
    if (0 === (seen0 & 2))
      $this.a3j_1 = Blue_getInstance();
    else
      $this.a3j_1 = playColor;
    return $this;
  }
}
class Companion_106 {
  constructor() {
    Companion_instance_106 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c3j_1 = [null, lazy(tmp_0, RoamCard$Companion$$childSerializers$_anonymous__n93hrj)];
  }
}
class $serializer_94 {
  constructor() {
    $serializer_instance_94 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RoamCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.d3j_1 = tmp0_serialDesc;
  }
  e3j(encoder, value) {
    var tmp0_desc = this.d3j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_107().c3j_1;
    tmp1_output.z14(tmp0_desc, 0, value.f3j_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.g3j_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.g3j_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e3j(encoder, value instanceof RoamCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_107().c3j_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RoamCard.h3j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d3j_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_107().c3j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class RoamCard {
  constructor(number) {
    Companion_getInstance_107();
    this.f3j_1 = number;
    this.g3j_1 = Red_getInstance();
  }
  u37() {
    return this.f3j_1;
  }
  toString() {
    return 'RoamCard(number=' + this.f3j_1 + ')';
  }
  hashCode() {
    return this.f3j_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RoamCard))
      return false;
    if (!(this.f3j_1 === other.f3j_1))
      return false;
    return true;
  }
  static h3j(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_107();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_94().d3j_1);
    }
    var $this = createThis(this);
    $this.f3j_1 = number;
    if (0 === (seen0 & 2))
      $this.g3j_1 = Red_getInstance();
    else
      $this.g3j_1 = playColor;
    return $this;
  }
}
class Companion_107 {
  constructor() {
    Companion_instance_107 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i3j_1 = [null, lazy(tmp_0, SprawlCard$Companion$$childSerializers$_anonymous__rnuamx)];
  }
}
class $serializer_95 {
  constructor() {
    $serializer_instance_95 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SprawlCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.j3j_1 = tmp0_serialDesc;
  }
  k3j(encoder, value) {
    var tmp0_desc = this.j3j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_108().i3j_1;
    tmp1_output.z14(tmp0_desc, 0, value.l3j_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.m3j_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.m3j_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k3j(encoder, value instanceof SprawlCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_108().i3j_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SprawlCard.n3j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.j3j_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_108().i3j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class SprawlCard {
  constructor(number) {
    Companion_getInstance_108();
    this.l3j_1 = number;
    this.m3j_1 = Red_getInstance();
  }
  u37() {
    return this.l3j_1;
  }
  toString() {
    return 'SprawlCard(number=' + this.l3j_1 + ')';
  }
  hashCode() {
    return this.l3j_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SprawlCard))
      return false;
    if (!(this.l3j_1 === other.l3j_1))
      return false;
    return true;
  }
  static n3j(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_108();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_95().j3j_1);
    }
    var $this = createThis(this);
    $this.l3j_1 = number;
    if (0 === (seen0 & 2))
      $this.m3j_1 = Red_getInstance();
    else
      $this.m3j_1 = playColor;
    return $this;
  }
}
class DisappearCard {
  constructor() {
    DisappearCard_instance = this;
    this.o3j_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p3j_1 = lazy(tmp_0, DisappearCard$_anonymous__adj3us);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_59(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DisappearCard';
  }
  hashCode() {
    return -46867794;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DisappearCard))
      return false;
    return true;
  }
}
class AbruptDecayCard {
  constructor() {
    AbruptDecayCard_instance = this;
    this.q3j_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r3j_1 = lazy(tmp_0, AbruptDecayCard$_anonymous__jkord7);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_60(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AbruptDecayCard';
  }
  hashCode() {
    return 1659696701;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbruptDecayCard))
      return false;
    return true;
  }
}
class Companion_108 {
  constructor() {
    Companion_instance_108 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s3j_1 = [null, lazy(tmp_0, FeastCard$Companion$$childSerializers$_anonymous__nqxuw9)];
  }
}
class $serializer_96 {
  constructor() {
    $serializer_instance_96 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FeastCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.t3j_1 = tmp0_serialDesc;
  }
  u3j(encoder, value) {
    var tmp0_desc = this.t3j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_109().s3j_1;
    tmp1_output.z14(tmp0_desc, 0, value.v3j_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.w3j_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.w3j_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u3j(encoder, value instanceof FeastCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_109().s3j_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return FeastCard.x3j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.t3j_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_109().s3j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class FeastCard {
  constructor(number) {
    Companion_getInstance_109();
    this.v3j_1 = number;
    this.w3j_1 = Red_getInstance();
  }
  u37() {
    return this.v3j_1;
  }
  toString() {
    return 'FeastCard(number=' + this.v3j_1 + ')';
  }
  hashCode() {
    return this.v3j_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FeastCard))
      return false;
    if (!(this.v3j_1 === other.v3j_1))
      return false;
    return true;
  }
  static x3j(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_109();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_96().t3j_1);
    }
    var $this = createThis(this);
    $this.v3j_1 = number;
    if (0 === (seen0 & 2))
      $this.w3j_1 = Red_getInstance();
    else
      $this.w3j_1 = playColor;
    return $this;
  }
}
class Companion_109 {
  constructor() {
    Companion_instance_109 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y3j_1 = [null, lazy(tmp_0, FlourishCard$Companion$$childSerializers$_anonymous__txsem6)];
  }
}
class $serializer_97 {
  constructor() {
    $serializer_instance_97 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FlourishCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.z3j_1 = tmp0_serialDesc;
  }
  a3k(encoder, value) {
    var tmp0_desc = this.z3j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_110().y3j_1;
    tmp1_output.z14(tmp0_desc, 0, value.b3k_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.c3k_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.c3k_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a3k(encoder, value instanceof FlourishCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_110().y3j_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return FlourishCard.d3k(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.z3j_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_110().y3j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class FlourishCard {
  constructor(number) {
    Companion_getInstance_110();
    this.b3k_1 = number;
    this.c3k_1 = Red_getInstance();
  }
  u37() {
    return this.b3k_1;
  }
  toString() {
    return 'FlourishCard(number=' + this.b3k_1 + ')';
  }
  hashCode() {
    return this.b3k_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FlourishCard))
      return false;
    if (!(this.b3k_1 === other.b3k_1))
      return false;
    return true;
  }
  static d3k(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_110();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_97().z3j_1);
    }
    var $this = createThis(this);
    $this.b3k_1 = number;
    if (0 === (seen0 & 2))
      $this.c3k_1 = Red_getInstance();
    else
      $this.c3k_1 = playColor;
    return $this;
  }
}
class Companion_110 {
  constructor() {
    Companion_instance_110 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e3k_1 = [null, lazy(tmp_0, MirrorStepCard$Companion$$childSerializers$_anonymous__sxzw6p)];
  }
}
class $serializer_98 {
  constructor() {
    $serializer_instance_98 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MirrorStepCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.f3k_1 = tmp0_serialDesc;
  }
  g3k(encoder, value) {
    var tmp0_desc = this.f3k_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_111().e3k_1;
    tmp1_output.z14(tmp0_desc, 0, value.h3k_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.i3k_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.i3k_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g3k(encoder, value instanceof MirrorStepCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_111().e3k_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return MirrorStepCard.j3k(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.f3k_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_111().e3k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class MirrorStepCard {
  constructor(number) {
    Companion_getInstance_111();
    this.h3k_1 = number;
    this.i3k_1 = Blue_getInstance();
  }
  u37() {
    return this.h3k_1;
  }
  toString() {
    return 'MirrorStepCard(number=' + this.h3k_1 + ')';
  }
  hashCode() {
    return this.h3k_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MirrorStepCard))
      return false;
    if (!(this.h3k_1 === other.h3k_1))
      return false;
    return true;
  }
  static j3k(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_111();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_98().f3k_1);
    }
    var $this = createThis(this);
    $this.h3k_1 = number;
    if (0 === (seen0 & 2))
      $this.i3k_1 = Blue_getInstance();
    else
      $this.i3k_1 = playColor;
    return $this;
  }
}
class FuryCard {
  constructor() {
    FuryCard_instance = this;
    this.k3k_1 = Red_getInstance();
    this.l3k_1 = OverloadedFuryCard_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m3k_1 = lazy(tmp_0, FuryCard$_anonymous__mu4imp);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_61(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FuryCard';
  }
  hashCode() {
    return 1002046795;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FuryCard))
      return false;
    return true;
  }
}
class ShatterCard {
  constructor() {
    ShatterCard_instance = this;
    this.n3k_1 = Red_getInstance();
    this.o3k_1 = OverloadedShatterCard_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p3k_1 = lazy(tmp_0, ShatterCard$_anonymous__f56232);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_62(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ShatterCard';
  }
  hashCode() {
    return -482984796;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShatterCard))
      return false;
    return true;
  }
}
class SwarmCard {
  constructor() {
    SwarmCard_instance = this;
    this.q3k_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r3k_1 = lazy(tmp_0, SwarmCard$_anonymous__hr6dg1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_63(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SwarmCard';
  }
  hashCode() {
    return 97042307;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SwarmCard))
      return false;
    return true;
  }
}
class Companion_111 {}
class $serializer_99 {
  constructor() {
    $serializer_instance_99 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UnknownBeastlyTalentCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.s3k_1 = tmp0_serialDesc;
  }
  t3k(encoder, value) {
    var tmp0_desc = this.s3k_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.u3k_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t3k(encoder, value instanceof UnknownBeastlyTalentCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UnknownBeastlyTalentCard.v3k(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s3k_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class UnknownBeastlyTalentCard {
  constructor(number) {
    this.u3k_1 = number;
  }
  u37() {
    return this.u3k_1;
  }
  toString() {
    return 'UnknownBeastlyTalentCard(number=' + this.u3k_1 + ')';
  }
  hashCode() {
    return this.u3k_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnknownBeastlyTalentCard))
      return false;
    if (!(this.u3k_1 === other.u3k_1))
      return false;
    return true;
  }
  static v3k(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_99().s3k_1);
    }
    var $this = createThis(this);
    $this.u3k_1 = number;
    return $this;
  }
}
class OverloadedCard {}
class OverloadedFuryCard {
  constructor() {
    OverloadedFuryCard_instance = this;
    this.w3k_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x3k_1 = lazy(tmp_0, OverloadedFuryCard$_anonymous__1iokyw);
  }
  y3k() {
    return FuryCard_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_64(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OverloadedFuryCard';
  }
  hashCode() {
    return 550521860;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OverloadedFuryCard))
      return false;
    return true;
  }
}
class OverloadedShatterCard {
  constructor() {
    OverloadedShatterCard_instance = this;
    this.z3k_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a3l_1 = lazy(tmp_0, OverloadedShatterCard$_anonymous__clou1z);
  }
  y3k() {
    return ShatterCard_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_65(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OverloadedShatterCard';
  }
  hashCode() {
    return -24752309;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OverloadedShatterCard))
      return false;
    return true;
  }
}
class FeastCardAttackModifier {
  constructor() {
    FeastCardAttackModifier_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b3l_1 = lazy(tmp_0, FeastCardAttackModifier$_anonymous__rnb4rp);
  }
  w35($context_GameState_t6qee5, target) {
    return null;
  }
  x35($context_GameState_t6qee5, target) {
    return 0;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_66(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FeastCardAttackModifier';
  }
  hashCode() {
    return -390737203;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FeastCardAttackModifier))
      return false;
    return true;
  }
}
class Companion_112 {}
class $serializer_100 {
  constructor() {
    $serializer_instance_100 = this;
    var tmp0_serialDesc = new InlineClassDescriptor('steelart.beast.BoardPosition', this);
    tmp0_serialDesc.h1b('value', false);
    this.c3l_1 = tmp0_serialDesc;
  }
  d3l(encoder, value) {
    var tmp0_inlineEncoder = encoder.v14(this.c3l_1);
    if (tmp0_inlineEncoder == null)
      null;
    else {
      tmp0_inlineEncoder.o14(_get_value__a43j40(value));
    }
  }
  ez(encoder, value) {
    return this.d3l(encoder, value instanceof BoardPosition ? value.r2v_1 : THROW_CCE());
  }
  e3l(decoder) {
    return _BoardPosition___init__impl__1nizgq(decoder.m13(this.c3l_1).f13());
  }
  fz(decoder) {
    return new BoardPosition(this.e3l(decoder));
  }
  dz() {
    return this.c3l_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class BoardPosition {
  constructor(value) {
    this.r2v_1 = value;
  }
  toString() {
    return BoardPosition__toString_impl_v4mn82(this.r2v_1);
  }
  hashCode() {
    return BoardPosition__hashCode_impl_9dgqf7(this.r2v_1);
  }
  equals(other) {
    return BoardPosition__equals_impl_yrjbvj(this.r2v_1, other);
  }
}
class Companion_113 {
  constructor() {
    Companion_instance_113 = this;
    this.f3l_1 = new Direction(0, -1);
    this.g3l_1 = new Direction(1, 0);
    this.h3l_1 = new Direction(0, 1);
    this.i3l_1 = new Direction(-1, 0);
    this.j3l_1 = setOf_0([this.f3l_1, this.g3l_1, this.h3l_1, this.i3l_1]);
  }
}
class $serializer_101 {
  constructor() {
    $serializer_instance_101 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Direction', this, 2);
    tmp0_serialDesc.h1b('dx', false);
    tmp0_serialDesc.h1b('dy', false);
    this.k3l_1 = tmp0_serialDesc;
  }
  l3l(encoder, value) {
    var tmp0_desc = this.k3l_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.m3l_1);
    tmp1_output.z14(tmp0_desc, 1, value.n3l_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l3l(encoder, value instanceof Direction ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k3l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return Direction.o3l(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.k3l_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class StepMovement {}
class Direction {
  constructor(dx, dy) {
    Companion_getInstance_114();
    this.m3l_1 = dx;
    this.n3l_1 = dy;
  }
  toString() {
    return 'Direction(dx=' + this.m3l_1 + ', dy=' + this.n3l_1 + ')';
  }
  hashCode() {
    var result = this.m3l_1;
    result = imul(result, 31) + this.n3l_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Direction))
      return false;
    if (!(this.m3l_1 === other.m3l_1))
      return false;
    if (!(this.n3l_1 === other.n3l_1))
      return false;
    return true;
  }
  static o3l(seen0, dx, dy, serializationConstructorMarker) {
    Companion_getInstance_114();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_101().k3l_1);
    }
    var $this = createThis(this);
    $this.m3l_1 = dx;
    $this.n3l_1 = dy;
    return $this;
  }
}
class Companion_114 {
  constructor() {
    Companion_instance_114 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p3l_1 = [null, lazy(tmp_0, MovementToLocation$Companion$$childSerializers$_anonymous__bo7j63)];
  }
}
class $serializer_102 {
  constructor() {
    $serializer_instance_102 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MovementToLocation', this, 2);
    tmp0_serialDesc.h1b('destination', false);
    tmp0_serialDesc.h1b('movementType', false);
    this.q3l_1 = tmp0_serialDesc;
  }
  r3l(encoder, value) {
    var tmp0_desc = this.q3l_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_115().p3l_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.v3g_1));
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.w3g_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r3l(encoder, value instanceof MovementToLocation ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q3l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_115().p3l_1;
    if (tmp6_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return MovementToLocation.s3l(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.q3l_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_115().p3l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100(), tmp0_cached[1].k3()];
  }
}
class MovementToLocation {
  constructor(destination, movementType) {
    Companion_getInstance_115();
    this.v3g_1 = destination;
    this.w3g_1 = movementType;
  }
  toString() {
    return 'MovementToLocation(destination=' + BoardPosition__toString_impl_v4mn82(this.v3g_1) + ', movementType=' + this.w3g_1.toString() + ')';
  }
  hashCode() {
    var result = BoardPosition__hashCode_impl_9dgqf7(this.v3g_1);
    result = imul(result, 31) + this.w3g_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MovementToLocation))
      return false;
    if (!(this.v3g_1 === other.v3g_1))
      return false;
    if (!this.w3g_1.equals(other.w3g_1))
      return false;
    return true;
  }
  static s3l(seen0, destination, movementType, serializationConstructorMarker) {
    Companion_getInstance_115();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_102().q3l_1);
    }
    var $this = createThis(this);
    $this.v3g_1 = destination;
    $this.w3g_1 = movementType;
    return $this;
  }
}
class MovementType extends Enum {}
class Companion_115 {
  a2g() {
    var tmp = getKClass(StepMovement);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Direction), getKClass(NoMovement), getKClass(RelocationStep)];
    var tmp_1 = $serializer_getInstance_101();
    var tmp_2 = NoMovement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_3 = [tmp_1, ObjectSerializer.l1c('NoMovement', tmp_2, tmp$ret$3), $serializer_getInstance_103()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    return SealedClassSerializer.i10('steelart.beast.StepMovement', tmp, tmp_0, tmp_3, tmp$ret$9);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class NoMovement {
  constructor() {
    NoMovement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t3l_1 = lazy(tmp_0, NoMovement$_anonymous__e8a4l5);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_67(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NoMovement';
  }
  hashCode() {
    return -1598926315;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NoMovement))
      return false;
    return true;
  }
}
class Companion_116 {}
class $serializer_103 {
  constructor() {
    $serializer_instance_103 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RelocationStep', this, 1);
    tmp0_serialDesc.h1b('destination', false);
    this.u3l_1 = tmp0_serialDesc;
  }
  v3l(encoder, value) {
    var tmp0_desc = this.u3l_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.w3l_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v3l(encoder, value instanceof RelocationStep ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u3l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RelocationStep.x3l(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.u3l_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100()];
  }
}
class RelocationStep {
  constructor(destination) {
    this.w3l_1 = destination;
  }
  toString() {
    return 'RelocationStep(destination=' + BoardPosition__toString_impl_v4mn82(this.w3l_1) + ')';
  }
  hashCode() {
    return BoardPosition__hashCode_impl_9dgqf7(this.w3l_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RelocationStep))
      return false;
    if (!(this.w3l_1 === other.w3l_1))
      return false;
    return true;
  }
  static x3l(seen0, destination, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_103().u3l_1);
    }
    var $this = createThis(this);
    $this.w3l_1 = destination;
    return $this;
  }
}
class InfestationUpgrade {
  constructor() {
    InfestationUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y3l_1 = lazy(tmp_0, InfestationUpgrade$_anonymous__56bd9n);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_68(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'InfestationUpgrade';
  }
  hashCode() {
    return 1067089777;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InfestationUpgrade))
      return false;
    return true;
  }
}
class WitheringMawUpgrade {
  constructor() {
    WitheringMawUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z3l_1 = lazy(tmp_0, WitheringMawUpgrade$_anonymous__3knq1d);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_69(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WitheringMawUpgrade';
  }
  hashCode() {
    return -440140605;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WitheringMawUpgrade))
      return false;
    return true;
  }
}
class UnendingHungerUpgrade {
  constructor() {
    UnendingHungerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a3m_1 = lazy(tmp_0, UnendingHungerUpgrade$_anonymous__1alb1u);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_70(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UnendingHungerUpgrade';
  }
  hashCode() {
    return -884934364;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnendingHungerUpgrade))
      return false;
    return true;
  }
}
class BlightUpgrade {
  constructor() {
    BlightUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b3m_1 = lazy(tmp_0, BlightUpgrade$_anonymous__vm99bl);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_71(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BlightUpgrade';
  }
  hashCode() {
    return -400688413;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BlightUpgrade))
      return false;
    return true;
  }
}
class ExpandTheMarshUpgrade {
  constructor() {
    ExpandTheMarshUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c3m_1 = lazy(tmp_0, ExpandTheMarshUpgrade$_anonymous__mckexj);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_72(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ExpandTheMarshUpgrade';
  }
  hashCode() {
    return 920587739;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExpandTheMarshUpgrade))
      return false;
    return true;
  }
}
class LurkingDeadUpgrade {
  constructor() {
    LurkingDeadUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d3m_1 = lazy(tmp_0, LurkingDeadUpgrade$_anonymous__ml5iin);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_73(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LurkingDeadUpgrade';
  }
  hashCode() {
    return 1305270621;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LurkingDeadUpgrade))
      return false;
    return true;
  }
}
class CascadeUpgrade {
  constructor() {
    CascadeUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e3m_1 = lazy(tmp_0, CascadeUpgrade$_anonymous__bt2a5t);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_74(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CascadeUpgrade';
  }
  hashCode() {
    return -1115332915;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CascadeUpgrade))
      return false;
    return true;
  }
}
class Bolgin {
  constructor() {
    Bolgin_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f3m_1 = lazy(tmp_0, Bolgin$_anonymous__3rrbfu);
  }
  q36() {
    return PolypType_getInstance();
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Swamp_getInstance();
  }
  u36() {
    return 3;
  }
  s36() {
    return setOf_0([SummonPolypCard_getInstance(), BeastlyTongueCard_getInstance(), EngorgeCard_getInstance(), LeapCard_getInstance()]);
  }
  t35() {
    return setOf_0([InfestationUpgrade_getInstance(), WitheringMawUpgrade_getInstance(), UnendingHungerUpgrade_getInstance(), BlightUpgrade_getInstance(), ExpandTheMarshUpgrade_getInstance(), LurkingDeadUpgrade_getInstance(), CascadeUpgrade_getInstance()]);
  }
  n2z($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_75(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Bolgin';
  }
  hashCode() {
    return -324796238;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Bolgin))
      return false;
    return true;
  }
}
class PolypType {
  constructor() {
    PolypType_instance = this;
    this.g3m_1 = Bolgin_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h3m_1 = lazy(tmp_0, PolypType$_anonymous__t021sp);
  }
  r37() {
    return this.g3m_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_76(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PolypType';
  }
  hashCode() {
    return 1543167577;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolypType))
      return false;
    return true;
  }
}
class SummonPolypCard {
  constructor() {
    SummonPolypCard_instance = this;
    this.i3m_1 = Bolgin_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j3m_1 = lazy(tmp_0, SummonPolypCard$_anonymous__cfdng);
  }
  t37() {
    return this.i3m_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_77(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonPolypCard';
  }
  hashCode() {
    return 1235568142;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonPolypCard))
      return false;
    return true;
  }
}
class BeastlyTongueCard {
  constructor() {
    BeastlyTongueCard_instance = this;
    this.k3m_1 = Bolgin_getInstance();
    this.l3m_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m3m_1 = lazy(tmp_0, BeastlyTongueCard$_anonymous__k26tnb);
  }
  t37() {
    return this.k3m_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_78(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeastlyTongueCard';
  }
  hashCode() {
    return -2089074085;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastlyTongueCard))
      return false;
    return true;
  }
}
class EngorgeCard {
  constructor() {
    EngorgeCard_instance = this;
    this.n3m_1 = Bolgin_getInstance();
    this.o3m_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p3m_1 = lazy(tmp_0, EngorgeCard$_anonymous__yj3i0o);
  }
  t37() {
    return this.n3m_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_79(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EngorgeCard';
  }
  hashCode() {
    return -2088247382;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EngorgeCard))
      return false;
    return true;
  }
}
class LeapCard {
  constructor() {
    LeapCard_instance = this;
    this.q3m_1 = Bolgin_getInstance();
    this.r3m_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s3m_1 = lazy(tmp_0, LeapCard$_anonymous__puqqip);
  }
  t37() {
    return this.q3m_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_80(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LeapCard';
  }
  hashCode() {
    return 1058809949;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LeapCard))
      return false;
    return true;
  }
}
class Companion_117 {
  constructor() {
    Companion_instance_117 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t3m_1 = [lazy(tmp_0, BurstStatement$Companion$$childSerializers$_anonymous__9kbpj9)];
  }
}
class $serializer_104 {
  constructor() {
    $serializer_instance_104 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BurstStatement', this, 1);
    tmp0_serialDesc.h1b('actor', false);
    this.u3m_1 = tmp0_serialDesc;
  }
  v3m(encoder, value) {
    var tmp0_desc = this.u3m_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_118().t3m_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w3m_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v3m(encoder, value instanceof BurstStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u3m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_118().t3m_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BurstStatement.x3m(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.u3m_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_118().t3m_1[0].k3()];
  }
}
class BurstStatement {
  constructor(actor) {
    Companion_getInstance_118();
    this.w3m_1 = actor;
  }
  toString() {
    return 'BurstStatement(actor=' + this.w3m_1.toString() + ')';
  }
  hashCode() {
    return this.w3m_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BurstStatement))
      return false;
    if (!this.w3m_1.equals(other.w3m_1))
      return false;
    return true;
  }
  static x3m(seen0, actor, serializationConstructorMarker) {
    Companion_getInstance_118();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_104().u3m_1);
    }
    var $this = createThis(this);
    $this.w3m_1 = actor;
    return $this;
  }
}
class Companion_118 {
  constructor() {
    Companion_instance_118 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y3m_1 = [lazy(tmp_0, BeastlyTongueStatement$Companion$$childSerializers$_anonymous__n78xez)];
  }
}
class $serializer_105 {
  constructor() {
    $serializer_instance_105 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeastlyTongueStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.z3m_1 = tmp0_serialDesc;
  }
  a3n(encoder, value) {
    var tmp0_desc = this.z3m_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_119().y3m_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.b3n_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a3n(encoder, value instanceof BeastlyTongueStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z3m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_119().y3m_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BeastlyTongueStatement.c3n(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.z3m_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_119().y3m_1[0].k3()];
  }
}
class BeastlyTongueStatement {
  constructor(beast) {
    Companion_getInstance_119();
    this.b3n_1 = beast;
  }
  toString() {
    return 'BeastlyTongueStatement(beast=' + this.b3n_1.toString() + ')';
  }
  hashCode() {
    return this.b3n_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastlyTongueStatement))
      return false;
    if (!this.b3n_1.equals(other.b3n_1))
      return false;
    return true;
  }
  static c3n(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_119();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_105().z3m_1);
    }
    var $this = createThis(this);
    $this.b3n_1 = beast;
    return $this;
  }
}
class Companion_119 {
  constructor() {
    Companion_instance_119 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d3n_1 = [lazy(tmp_0, LeapStatement$Companion$$childSerializers$_anonymous__4uairn)];
  }
}
class $serializer_106 {
  constructor() {
    $serializer_instance_106 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LeapStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.e3n_1 = tmp0_serialDesc;
  }
  f3n(encoder, value) {
    var tmp0_desc = this.e3n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_120().d3n_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g3n_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f3n(encoder, value instanceof LeapStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e3n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_120().d3n_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return LeapStatement.h3n(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e3n_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_120().d3n_1[0].k3()];
  }
}
class LeapStatement extends BeastMovementStatement {
  constructor(movingObject) {
    Companion_getInstance_120();
    super();
    this.g3n_1 = movingObject;
  }
  f2p() {
    return this.g3n_1;
  }
  toString() {
    return 'LeapStatement(movingObject=' + this.g3n_1.toString() + ')';
  }
  hashCode() {
    return this.g3n_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LeapStatement))
      return false;
    if (!this.g3n_1.equals(other.g3n_1))
      return false;
    return true;
  }
  static h3n(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_120();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_106().e3n_1);
    }
    var $this = this.f2q(seen0, serializationConstructorMarker);
    $this.g3n_1 = movingObject;
    return $this;
  }
}
class BurstEffectSource {
  constructor() {
    BurstEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i3n_1 = lazy(tmp_0, BurstEffectSource$_anonymous__75ski3);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_81(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BurstEffectSource';
  }
  hashCode() {
    return -1119712729;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BurstEffectSource))
      return false;
    return true;
  }
}
class Bram {
  constructor() {
    Bram_instance = this;
    this.j3n_1 = setOf_0([AbruptAssembleUpgrade_getInstance(), MassProductionUpgrade_getInstance(), LivingBlockadeUpgrade_getInstance(), TacticalInsightUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k3n_1 = lazy(tmp_0, Bram$_anonymous__b5jaud);
  }
  s36() {
    return setOf_0([WardCard_getInstance(), new TrackCard(this), BindingHuntCard_getInstance()]);
  }
  t35() {
    return this.j3n_1;
  }
  n2z($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_82(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Bram';
  }
  hashCode() {
    return 607485121;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Bram))
      return false;
    return true;
  }
}
class AbruptAssembleUpgrade {
  constructor() {
    AbruptAssembleUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l3n_1 = lazy(tmp_0, AbruptAssembleUpgrade$_anonymous__l2fn2j);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_83(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AbruptAssembleUpgrade';
  }
  hashCode() {
    return 191772157;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbruptAssembleUpgrade))
      return false;
    return true;
  }
}
class MassProductionUpgrade {
  constructor() {
    MassProductionUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m3n_1 = lazy(tmp_0, MassProductionUpgrade$_anonymous__3qzci0);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_84(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'MassProductionUpgrade';
  }
  hashCode() {
    return 36366570;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MassProductionUpgrade))
      return false;
    return true;
  }
}
class LivingBlockadeUpgrade {
  constructor() {
    LivingBlockadeUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n3n_1 = lazy(tmp_0, LivingBlockadeUpgrade$_anonymous__de1ymx);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_85(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LivingBlockadeUpgrade';
  }
  hashCode() {
    return 2024390617;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LivingBlockadeUpgrade))
      return false;
    return true;
  }
}
class TacticalInsightUpgrade {
  constructor() {
    TacticalInsightUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o3n_1 = lazy(tmp_0, TacticalInsightUpgrade$_anonymous__a6j3o0);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_86(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TacticalInsightUpgrade';
  }
  hashCode() {
    return -1908220244;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TacticalInsightUpgrade))
      return false;
    return true;
  }
}
class WardCard {
  constructor() {
    WardCard_instance = this;
    this.p3n_1 = Red_getInstance();
    this.q3n_1 = Bram_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r3n_1 = lazy(tmp_0, WardCard$_anonymous__qovjrp);
  }
  t37() {
    return this.q3n_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_87(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WardCard';
  }
  hashCode() {
    return -24546959;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WardCard))
      return false;
    return true;
  }
}
class BindingHuntCard {
  constructor() {
    BindingHuntCard_instance = this;
    this.s3n_1 = Blue_getInstance();
    this.t3n_1 = Bram_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u3n_1 = lazy(tmp_0, BindingHuntCard$_anonymous__5soh7z);
  }
  t37() {
    return this.t3n_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_88(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BindingHuntCard';
  }
  hashCode() {
    return 804852099;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BindingHuntCard))
      return false;
    return true;
  }
}
class Companion_120 {
  constructor() {
    Companion_instance_120 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v3n_1 = [lazy(tmp_0, AbruptAssembleStatement$Companion$$childSerializers$_anonymous__rmqprp)];
  }
}
class $serializer_107 {
  constructor() {
    $serializer_instance_107 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AbruptAssembleStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.w3n_1 = tmp0_serialDesc;
  }
  x3n(encoder, value) {
    var tmp0_desc = this.w3n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_121().v3n_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y3n_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x3n(encoder, value instanceof AbruptAssembleStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w3n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_121().v3n_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AbruptAssembleStatement.z3n(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w3n_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_121().v3n_1[0].k3()];
  }
}
class AbruptAssembleStatement {
  constructor(hunter) {
    Companion_getInstance_121();
    this.y3n_1 = hunter;
  }
  toString() {
    return 'AbruptAssembleStatement(hunter=' + this.y3n_1.toString() + ')';
  }
  hashCode() {
    return this.y3n_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbruptAssembleStatement))
      return false;
    if (!this.y3n_1.equals(other.y3n_1))
      return false;
    return true;
  }
  static z3n(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_121();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_107().w3n_1);
    }
    var $this = createThis(this);
    $this.y3n_1 = hunter;
    return $this;
  }
}
class Companion_121 {
  constructor() {
    Companion_instance_121 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a3o_1 = [lazy(tmp_0, WardStatement$Companion$$childSerializers$_anonymous__vcgyqx)];
  }
}
class $serializer_108 {
  constructor() {
    $serializer_instance_108 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('WardStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.b3o_1 = tmp0_serialDesc;
  }
  c3o(encoder, value) {
    var tmp0_desc = this.b3o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_122().a3o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d3o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c3o(encoder, value instanceof WardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b3o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_122().a3o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return WardStatement.e3o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b3o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_122().a3o_1[0].k3()];
  }
}
class WardStatement {
  constructor(hunter) {
    Companion_getInstance_122();
    this.d3o_1 = hunter;
  }
  toString() {
    return 'WardStatement(hunter=' + this.d3o_1.toString() + ')';
  }
  hashCode() {
    return this.d3o_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WardStatement))
      return false;
    if (!this.d3o_1.equals(other.d3o_1))
      return false;
    return true;
  }
  static e3o(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_122();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_108().b3o_1);
    }
    var $this = createThis(this);
    $this.d3o_1 = hunter;
    return $this;
  }
}
class Companion_122 {
  constructor() {
    Companion_instance_122 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f3o_1 = [lazy(tmp_0, BindingHuntStatement$Companion$$childSerializers$_anonymous__dskg31)];
  }
}
class $serializer_109 {
  constructor() {
    $serializer_instance_109 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BindingHuntStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.g3o_1 = tmp0_serialDesc;
  }
  h3o(encoder, value) {
    var tmp0_desc = this.g3o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_123().f3o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i3o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h3o(encoder, value instanceof BindingHuntStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g3o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_123().f3o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BindingHuntStatement.j3o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g3o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_123().f3o_1[0].k3()];
  }
}
class BindingHuntStatement {
  constructor(hunter) {
    Companion_getInstance_123();
    this.i3o_1 = hunter;
  }
  toString() {
    return 'BindingHuntStatement(hunter=' + this.i3o_1.toString() + ')';
  }
  hashCode() {
    return this.i3o_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BindingHuntStatement))
      return false;
    if (!this.i3o_1.equals(other.i3o_1))
      return false;
    return true;
  }
  static j3o(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_123();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_109().g3o_1);
    }
    var $this = createThis(this);
    $this.i3o_1 = hunter;
    return $this;
  }
}
class BramBarrierCleanupEffectSource {
  constructor() {
    BramBarrierCleanupEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k3o_1 = lazy(tmp_0, BramBarrierCleanupEffectSource$_anonymous__9ljx0e);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_89(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BramBarrierCleanupEffectSource';
  }
  hashCode() {
    return 1670704698;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BramBarrierCleanupEffectSource))
      return false;
    return true;
  }
}
class PossibleBindingHuntEffectSource {
  constructor() {
    PossibleBindingHuntEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l3o_1 = lazy(tmp_0, PossibleBindingHuntEffectSource$_anonymous__6khwtg);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_90(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleBindingHuntEffectSource';
  }
  hashCode() {
    return -711727922;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleBindingHuntEffectSource))
      return false;
    return true;
  }
}
class Companion_123 {
  constructor() {
    Companion_instance_123 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m3o_1 = [lazy(tmp_0, BarrierConnectedLocationQuestion$Companion$$childSerializers$_anonymous__3ospfn), null];
  }
}
class $serializer_110 {
  constructor() {
    $serializer_instance_110 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BarrierConnectedLocationQuestion', this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('barrierPosition', false);
    this.n3o_1 = tmp0_serialDesc;
  }
  o3o(encoder, value) {
    var tmp0_desc = this.n3o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_124().m3o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p3o_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_100(), new BoardPosition(value.q3o_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o3o(encoder, value instanceof BarrierConnectedLocationQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n3o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_124().m3o_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BarrierConnectedLocationQuestion.r3o(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.n3o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_124().m3o_1[0].k3(), $serializer_getInstance_100()];
  }
}
class GameQuestionBase {}
function get_questionContext() {
  return null;
}
class GameQuestion {}
class LocationQuestionBase {}
class BarrierConnectedLocationQuestion {
  constructor(variants, barrierPosition) {
    Companion_getInstance_124();
    this.p3o_1 = variants;
    this.q3o_1 = barrierPosition;
  }
  s3o() {
    return this.p3o_1;
  }
  toString() {
    return 'BarrierConnectedLocationQuestion(variants=' + this.p3o_1.toString() + ', barrierPosition=' + BoardPosition__toString_impl_v4mn82(this.q3o_1) + ')';
  }
  hashCode() {
    var result = this.p3o_1.hashCode();
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.q3o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BarrierConnectedLocationQuestion))
      return false;
    if (!this.p3o_1.equals(other.p3o_1))
      return false;
    if (!(this.q3o_1 === other.q3o_1))
      return false;
    return true;
  }
  static r3o(seen0, variants, barrierPosition, serializationConstructorMarker) {
    Companion_getInstance_124();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_110().n3o_1);
    }
    var $this = createThis(this);
    $this.p3o_1 = variants;
    $this.q3o_1 = barrierPosition;
    return $this;
  }
}
class BarrierFirstPositionQuestionContext {
  constructor() {
    BarrierFirstPositionQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u3o_1 = lazy(tmp_0, BarrierFirstPositionQuestionContext$_anonymous__qw8dio);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_91(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BarrierFirstPositionQuestionContext';
  }
  hashCode() {
    return -507537374;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BarrierFirstPositionQuestionContext))
      return false;
    return true;
  }
}
class Companion_124 {
  constructor() {
    Companion_instance_124 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, BindingHuntReactionStatement$Companion$$childSerializers$_anonymous__r9vpoc);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v3o_1 = [tmp_1, lazy(tmp_2, BindingHuntReactionStatement$Companion$$childSerializers$_anonymous__r9vpoc_0)];
  }
}
class $serializer_111 {
  constructor() {
    $serializer_instance_111 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BindingHuntReactionStatement', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('beast', false);
    this.w3o_1 = tmp0_serialDesc;
  }
  x3o(encoder, value) {
    var tmp0_desc = this.w3o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_125().v3o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y3o_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.z3o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x3o(encoder, value instanceof BindingHuntReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w3o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_125().v3o_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BindingHuntReactionStatement.a3p(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.w3o_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_125().v3o_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class BindingHuntReactionStatement {
  constructor(characterObject, beast) {
    Companion_getInstance_125();
    this.y3o_1 = characterObject;
    this.z3o_1 = beast;
  }
  d2t() {
    return BindingHuntCard_getInstance();
  }
  toString() {
    return 'BindingHuntReactionStatement(characterObject=' + this.y3o_1.toString() + ', beast=' + this.z3o_1.toString() + ')';
  }
  hashCode() {
    var result = this.y3o_1.hashCode();
    result = imul(result, 31) + this.z3o_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BindingHuntReactionStatement))
      return false;
    if (!this.y3o_1.equals(other.y3o_1))
      return false;
    if (!this.z3o_1.equals(other.z3o_1))
      return false;
    return true;
  }
  static a3p(seen0, characterObject, beast, serializationConstructorMarker) {
    Companion_getInstance_125();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_111().w3o_1);
    }
    var $this = createThis(this);
    $this.y3o_1 = characterObject;
    $this.z3o_1 = beast;
    return $this;
  }
}
class Companion_125 {
  constructor() {
    Companion_instance_125 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b3p_1 = [lazy(tmp_0, BramWardBarrierStatement$Companion$$childSerializers$_anonymous__umtunu)];
  }
}
class $serializer_112 {
  constructor() {
    $serializer_instance_112 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BramWardBarrierStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.c3p_1 = tmp0_serialDesc;
  }
  d3p(encoder, value) {
    var tmp0_desc = this.c3p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_126().b3p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.e3p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d3p(encoder, value instanceof BramWardBarrierStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c3p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_126().b3p_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BramWardBarrierStatement.f3p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.c3p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_126().b3p_1[0].k3()];
  }
}
class BramWardBarrierStatement {
  constructor(hunter) {
    Companion_getInstance_126();
    this.e3p_1 = hunter;
  }
  toString() {
    return 'BramWardBarrierStatement(hunter=' + this.e3p_1.toString() + ')';
  }
  hashCode() {
    return this.e3p_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BramWardBarrierStatement))
      return false;
    if (!this.e3p_1.equals(other.e3p_1))
      return false;
    return true;
  }
  static f3p(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_126();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_112().c3p_1);
    }
    var $this = createThis(this);
    $this.e3p_1 = hunter;
    return $this;
  }
}
class Companion_126 {
  constructor() {
    Companion_instance_126 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g3p_1 = [lazy(tmp_0, PlaceBarrierInSameZoneStatement$Companion$$childSerializers$_anonymous__t794zm)];
  }
}
class $serializer_113 {
  constructor() {
    $serializer_instance_113 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceBarrierInSameZoneStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.h3p_1 = tmp0_serialDesc;
  }
  i3p(encoder, value) {
    var tmp0_desc = this.h3p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_127().g3p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.j3p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i3p(encoder, value instanceof PlaceBarrierInSameZoneStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h3p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_127().g3p_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlaceBarrierInSameZoneStatement.k3p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.h3p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_127().g3p_1[0].k3()];
  }
}
class PlaceBarrierInSameZoneStatement {
  constructor(hunter) {
    Companion_getInstance_127();
    this.j3p_1 = hunter;
  }
  toString() {
    return 'PlaceBarrierInSameZoneStatement(hunter=' + this.j3p_1.toString() + ')';
  }
  hashCode() {
    return this.j3p_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceBarrierInSameZoneStatement))
      return false;
    if (!this.j3p_1.equals(other.j3p_1))
      return false;
    return true;
  }
  static k3p(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_127();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_113().h3p_1);
    }
    var $this = createThis(this);
    $this.j3p_1 = hunter;
    return $this;
  }
}
class Companion_127 {
  constructor() {
    Companion_instance_127 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, PlaceBarrierOnLocationsStatement$Companion$$childSerializers$_anonymous__wqbmom);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l3p_1 = [tmp_1, lazy(tmp_2, PlaceBarrierOnLocationsStatement$Companion$$childSerializers$_anonymous__wqbmom_0)];
  }
}
class $serializer_114 {
  constructor() {
    $serializer_instance_114 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceBarrierOnLocationsStatement', this, 2);
    tmp0_serialDesc.h1b('hunter', false);
    tmp0_serialDesc.h1b('positions', false);
    this.m3p_1 = tmp0_serialDesc;
  }
  n3p(encoder, value) {
    var tmp0_desc = this.m3p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_128().l3p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o3p_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.p3p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n3p(encoder, value instanceof PlaceBarrierOnLocationsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m3p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_128().l3p_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlaceBarrierOnLocationsStatement.q3p(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.m3p_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_128().l3p_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class PlaceBarrierOnLocationsStatement {
  constructor(hunter, positions) {
    Companion_getInstance_128();
    this.o3p_1 = hunter;
    this.p3p_1 = positions;
  }
  toString() {
    return 'PlaceBarrierOnLocationsStatement(hunter=' + this.o3p_1.toString() + ', positions=' + toString(this.p3p_1) + ')';
  }
  hashCode() {
    var result = this.o3p_1.hashCode();
    result = imul(result, 31) + hashCode(this.p3p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceBarrierOnLocationsStatement))
      return false;
    if (!this.o3p_1.equals(other.o3p_1))
      return false;
    if (!equals(this.p3p_1, other.p3p_1))
      return false;
    return true;
  }
  static q3p(seen0, hunter, positions, serializationConstructorMarker) {
    Companion_getInstance_128();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_114().m3p_1);
    }
    var $this = createThis(this);
    $this.o3p_1 = hunter;
    $this.p3p_1 = positions;
    return $this;
  }
}
class Companion_128 {
  a2g() {
    var tmp = getKClass(Character);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Akkeron), getKClass(Bolgin), getKClass(EsmeriaBeast), getKClass(Fangrir), getKClass(FeatheredKing), getKClass(Hogbad), getKClass(Lydan), getKClass(Mara), getKClass(Omma), getKClass(Raaga), getKClass(Rhagner), getKClass(Thalduk), getKClass(Urgull), getKClass(Vacker), getKClass(Assar), getKClass(Bram), getKClass(Draug), getKClass(Eivind), getKClass(EsmeriaHuntress), getKClass(Fara), getKClass(Grimgeir), getKClass(Helga), getKClass(Iona), getKClass(Krim), getKClass(Nora), getKClass(Sigrid), getKClass(Valdi), getKClass(Varja)];
    var tmp_1 = Akkeron_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Akkeron', tmp_1, tmp$ret$3);
    var tmp_3 = Bolgin_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('Bolgin', tmp_3, tmp$ret$6);
    var tmp_5 = EsmeriaBeast_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('EsmeriaBeast', tmp_5, tmp$ret$9);
    var tmp_7 = Fangrir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Fangrir', tmp_7, tmp$ret$12);
    var tmp_9 = FeatheredKing_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('FeatheredKing', tmp_9, tmp$ret$15);
    var tmp_11 = Hogbad_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('Hogbad', tmp_11, tmp$ret$18);
    var tmp_13 = Lydan_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('Lydan', tmp_13, tmp$ret$21);
    var tmp_15 = Mara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('Mara', tmp_15, tmp$ret$24);
    var tmp_17 = Omma_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('Omma', tmp_17, tmp$ret$27);
    var tmp_19 = Raaga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('Raaga', tmp_19, tmp$ret$30);
    var tmp_21 = Rhagner_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('Rhagner', tmp_21, tmp$ret$33);
    var tmp_23 = Thalduk_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('Thalduk', tmp_23, tmp$ret$36);
    var tmp_25 = Urgull_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('Urgull', tmp_25, tmp$ret$39);
    var tmp_27 = Vacker_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('Vacker', tmp_27, tmp$ret$42);
    var tmp_29 = Assar_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('Assar', tmp_29, tmp$ret$45);
    var tmp_31 = Bram_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('Bram', tmp_31, tmp$ret$48);
    var tmp_33 = Draug_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('Draug', tmp_33, tmp$ret$51);
    var tmp_35 = Eivind_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_36 = ObjectSerializer.l1c('Eivind', tmp_35, tmp$ret$54);
    var tmp_37 = EsmeriaHuntress_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_38 = ObjectSerializer.l1c('EsmeriaHuntress', tmp_37, tmp$ret$57);
    var tmp_39 = Fara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_40 = ObjectSerializer.l1c('Fara', tmp_39, tmp$ret$60);
    var tmp_41 = Grimgeir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_42 = ObjectSerializer.l1c('Grimgeir', tmp_41, tmp$ret$63);
    var tmp_43 = Helga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_44 = ObjectSerializer.l1c('Helga', tmp_43, tmp$ret$66);
    var tmp_45 = Iona_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_46 = ObjectSerializer.l1c('Iona', tmp_45, tmp$ret$69);
    var tmp_47 = Krim_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_48 = ObjectSerializer.l1c('Krim', tmp_47, tmp$ret$72);
    var tmp_49 = Nora_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_50 = ObjectSerializer.l1c('Nora', tmp_49, tmp$ret$75);
    var tmp_51 = Sigrid_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_52 = ObjectSerializer.l1c('Sigrid', tmp_51, tmp$ret$78);
    var tmp_53 = Valdi_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_54 = ObjectSerializer.l1c('Valdi', tmp_53, tmp$ret$81);
    var tmp_55 = Varja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_56 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, ObjectSerializer.l1c('Varja', tmp_55, tmp$ret$84)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    return SealedClassSerializer.i10('steelart.beast.Character', tmp, tmp_0, tmp_56, tmp$ret$90);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_129 {
  a2g() {
    var tmp = getKClass(CharacterUpgrade);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AbruptAssembleUpgrade), getKClass(AbyssalBeastUpgrade), getKClass(AbyssalHellFireUpgrade), getKClass(AncientCallingUpgrade), getKClass(BlightUpgrade), getKClass(BroodswellUpgrade), getKClass(BlackStarUpgrade), getKClass(DefenderUpgrade), getKClass(MesmeriseUpgrade), getKClass(RebirthByFireUpgrade), getKClass(SoulCollectorUpgrade), getKClass(ChiefsCommandUpgrade), getKClass(DischargeUpgrade), getKClass(ExploreUpgrade), getKClass(HeroicSpeechUpgrade), getKClass(HuntingGroundsUpgrade), getKClass(InfusionUpgrade), getKClass(NightbindUpgrade), getKClass(PactReversalUpgrade), getKClass(ResonanceUpgrade), getKClass(ResourcefulnessUpgrade), getKClass(ResurrectionUpgrade), getKClass(RevengeOfTheSheepUpgrade), getKClass(RopePullUpgrade), getKClass(SinisterActUpgrade), getKClass(SongOfTemptationUpgrade), getKClass(SuddenShockUpgrade), getKClass(TacticalManouverUpgrade), getKClass(VanishUpgrade), getKClass(VoidCallUpgrade), getKClass(WildOdeUpgrade), getKClass(AbundanceUpgrade), getKClass(AccursedWrathUpgrade), getKClass(AmassUpgrade), getKClass(AncientBondUpgrade), getKClass(AngerUpgrade), getKClass(AwarenessUpgrade), getKClass(BallistaUpgrade), getKClass(BeastTongueUpgrade), getKClass(BehornedUpgrade), getKClass(BeyondTheVeilUpgrade), getKClass(BloodCraftUpgrade), getKClass(BloodLustUpgrade), getKClass(BloodlessFuryUpgrade), getKClass(BurnUpgrade), getKClass(CascadeUpgrade), getKClass(ClairvoyantUpgrade), getKClass(CloudShiftUpgrade), getKClass(CrepuscularUpgrade), getKClass(CullingUpgrade), getKClass(CursedLandUpgrade), getKClass(DarkFlameUpgrade), getKClass(DarkSpawnUpgrade), getKClass(DeathsLamentUpgrade), getKClass(DevourerUpgrade), getKClass(DissectionUpgrade), getKClass(DistractionUpgrade), getKClass(DoomCallUpgrade), getKClass(DoubleUpgrade), getKClass(DraconicBondsUpgrade), getKClass(DrownerUpgrade), getKClass(EchoUpgrade), getKClass(EcholocationUpgrade), getKClass(EndlessDreamUpgrade), getKClass(EndlessStruggleUpgrade), getKClass(EnragedUpgrade), getKClass(EntrancingUpgrade), getKClass(EruptionUpgrade), getKClass(EternityUpgrade), getKClass(ExceptionalTrackerUpgrade), getKClass(ExpandTheMarshUpgrade), getKClass(ExtractUpgrade), getKClass(FatalGazeUpgrade), getKClass(FearTheNightUpgrade), getKClass(FleshboundUpgrade), getKClass(FlingUpgrade), getKClass(GoldenBeakUpgrade), getKClass(GreatHowlUpgrade), getKClass(HordesMarchUpgrade), getKClass(HornOfValhUpgrade), getKClass(HuntersBaneUpgrade), getKClass(HuntmasterUpgrade), getKClass(IgniteUpgrade), getKClass(InfernalTusksUpgrade), getKClass(InfestUrgullUpgrade), getKClass(InfestationUpgrade), getKClass(JointEffortUpgrade), getKClass(KillingsSpreeUpgrade), getKClass(KinsPursuitUpgrade), getKClass(LairUpgrade), getKClass(LeviathanUpgrade), getKClass(LivingBlockadeUpgrade), getKClass(LurkingDeadUpgrade), getKClass(MartyrUpgrade), getKClass(MassProductionUpgrade), getKClass(MendrsFuryUpgrade), getKClass(MirrorBeastUpgrade), getKClass(NaturalInstinctUpgrade), getKClass(OverlordUpgrade), getKClass(PalebloodAxesUpgrade), getKClass(PandemoniumUpgrade), getKClass(PortableWorkshopUpgrade), getKClass(PredictUpgrade), getKClass(PrimalInstinctsUpgrade), getKClass(ProminenceUpgrade), getKClass(RampageousUpgrade), getKClass(ReachUpgrade), getKClass(RefugeUpgrade), getKClass(RegalUpgrade), getKClass(ReuniteUpgrade), getKClass(ReveranceUpgrade), getKClass(RuptureSeedsUpgrade), getKClass(ScavengerUpgrade), getKClass(SeekerUpgrade), getKClass(SharedMadnessUpgrade), getKClass(SkyMasterUpgrade), getKClass(SoothsayerUpgrade), getKClass(SoulHarvestUpgrade), getKClass(SoulHarvestVackerUpgrade), getKClass(SpiritboundUpgrade), getKClass(StarFallUpgrade), getKClass(StormBringerUpgrade), getKClass(SwapUpgrade), getKClass(SwiftKillUpgrade), getKClass(TacticalInsightUpgrade), getKClass(ThickMistUpgrade), getKClass(TormentingVisionsUpgrade), getKClass(TorrentialUpgrade), getKClass(TownswatchUpgrade), getKClass(TrapLauncherUpgrade), getKClass(TrueInstinctEsmeriaBeastUpgrade), getKClass(TrueInstinctEsmeriaHuntressUpgrade), getKClass(UnendingHungerUpgrade), getKClass(VoidPresenceUpgrade), getKClass(VoidStepUpgrade), getKClass(WatchtowerPassageUpgrade), getKClass(WildbondUpgrade), getKClass(WitheringMawUpgrade), getKClass(WorshipUpgrade), getKClass(WrathOfEirtirUpgrade)];
    var tmp_1 = AbruptAssembleUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('AbruptAssembleUpgrade', tmp_1, tmp$ret$3);
    var tmp_3 = AbyssalBeastUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('AbyssalBeastUpgrade', tmp_3, tmp$ret$6);
    var tmp_5 = AbyssalHellFireUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('AbyssalHellFireUpgrade', tmp_5, tmp$ret$9);
    var tmp_7 = AncientCallingUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('AncientCallingUpgrade', tmp_7, tmp$ret$12);
    var tmp_9 = BlightUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('BlightUpgrade', tmp_9, tmp$ret$15);
    var tmp_11 = BroodswellUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('BroodswellUpgrade', tmp_11, tmp$ret$18);
    var tmp_13 = BlackStarUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('BlackStarUpgrade', tmp_13, tmp$ret$21);
    var tmp_15 = DefenderUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('DefenderUpgrade', tmp_15, tmp$ret$24);
    var tmp_17 = MesmeriseUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('MesmeriseUpgrade', tmp_17, tmp$ret$27);
    var tmp_19 = RebirthByFireUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('RebirthByFireUpgrade', tmp_19, tmp$ret$30);
    var tmp_21 = SoulCollectorUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('SoulCollectorUpgrade', tmp_21, tmp$ret$33);
    var tmp_23 = ChiefsCommandUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('ChiefsCommandUpgrade', tmp_23, tmp$ret$36);
    var tmp_25 = DischargeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('DischargeUpgrade', tmp_25, tmp$ret$39);
    var tmp_27 = ExploreUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('ExploreUpgrade', tmp_27, tmp$ret$42);
    var tmp_29 = HeroicSpeechUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('HeroicSpeechUpgrade', tmp_29, tmp$ret$45);
    var tmp_31 = HuntingGroundsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('HuntingGroundsUpgrade', tmp_31, tmp$ret$48);
    var tmp_33 = InfusionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('InfusionUpgrade', tmp_33, tmp$ret$51);
    var tmp_35 = NightbindUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_36 = ObjectSerializer.l1c('NightbindUpgrade', tmp_35, tmp$ret$54);
    var tmp_37 = PactReversalUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_38 = ObjectSerializer.l1c('PactReversalUpgrade', tmp_37, tmp$ret$57);
    var tmp_39 = ResonanceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_40 = ObjectSerializer.l1c('ResonanceUpgrade', tmp_39, tmp$ret$60);
    var tmp_41 = ResourcefulnessUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_42 = ObjectSerializer.l1c('ResourcefulnessUpgrade', tmp_41, tmp$ret$63);
    var tmp_43 = ResurrectionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_44 = ObjectSerializer.l1c('ResurrectionUpgrade', tmp_43, tmp$ret$66);
    var tmp_45 = RevengeOfTheSheepUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_46 = ObjectSerializer.l1c('RevengeOfTheSheepUpgrade', tmp_45, tmp$ret$69);
    var tmp_47 = RopePullUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_48 = ObjectSerializer.l1c('RopePullUpgrade', tmp_47, tmp$ret$72);
    var tmp_49 = SinisterActUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_50 = ObjectSerializer.l1c('SinisterActUpgrade', tmp_49, tmp$ret$75);
    var tmp_51 = SongOfTemptationUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_52 = ObjectSerializer.l1c('SongOfTemptationUpgrade', tmp_51, tmp$ret$78);
    var tmp_53 = SuddenShockUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_54 = ObjectSerializer.l1c('SuddenShockUpgrade', tmp_53, tmp$ret$81);
    var tmp_55 = TacticalManouverUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_56 = ObjectSerializer.l1c('TacticalManouverUpgrade', tmp_55, tmp$ret$84);
    var tmp_57 = VanishUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_58 = ObjectSerializer.l1c('VanishUpgrade', tmp_57, tmp$ret$87);
    var tmp_59 = VoidCallUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_60 = ObjectSerializer.l1c('VoidCallUpgrade', tmp_59, tmp$ret$90);
    var tmp_61 = WildOdeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_62 = ObjectSerializer.l1c('WildOdeUpgrade', tmp_61, tmp$ret$93);
    var tmp_63 = AbundanceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_64 = ObjectSerializer.l1c('AbundanceUpgrade', tmp_63, tmp$ret$96);
    var tmp_65 = AccursedWrathUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_66 = ObjectSerializer.l1c('AccursedWrathUpgrade', tmp_65, tmp$ret$99);
    var tmp_67 = AmassUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_68 = ObjectSerializer.l1c('AmassUpgrade', tmp_67, tmp$ret$102);
    var tmp_69 = AncientBondUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_70 = ObjectSerializer.l1c('AncientBondUpgrade', tmp_69, tmp$ret$105);
    var tmp_71 = AngerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_72 = ObjectSerializer.l1c('AngerUpgrade', tmp_71, tmp$ret$108);
    var tmp_73 = AwarenessUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_74 = ObjectSerializer.l1c('AwarenessUpgrade', tmp_73, tmp$ret$111);
    var tmp_75 = BallistaUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_76 = ObjectSerializer.l1c('BallistaUpgrade', tmp_75, tmp$ret$114);
    var tmp_77 = BeastTongueUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_78 = ObjectSerializer.l1c('BeastTongueUpgrade', tmp_77, tmp$ret$117);
    var tmp_79 = BehornedUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_80 = ObjectSerializer.l1c('BehornedUpgrade', tmp_79, tmp$ret$120);
    var tmp_81 = BeyondTheVeilUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_82 = ObjectSerializer.l1c('BeyondTheVeilUpgrade', tmp_81, tmp$ret$123);
    var tmp_83 = BloodCraftUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_84 = ObjectSerializer.l1c('BloodCraftUpgrade', tmp_83, tmp$ret$126);
    var tmp_85 = BloodLustUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_86 = ObjectSerializer.l1c('BloodLustUpgrade', tmp_85, tmp$ret$129);
    var tmp_87 = BloodlessFuryUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_88 = ObjectSerializer.l1c('BloodlessFuryUpgrade', tmp_87, tmp$ret$132);
    var tmp_89 = BurnUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_90 = ObjectSerializer.l1c('BurnUpgrade', tmp_89, tmp$ret$135);
    var tmp_91 = CascadeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    var tmp_92 = ObjectSerializer.l1c('CascadeUpgrade', tmp_91, tmp$ret$138);
    var tmp_93 = ClairvoyantUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$141 = [];
    var tmp_94 = ObjectSerializer.l1c('ClairvoyantUpgrade', tmp_93, tmp$ret$141);
    var tmp_95 = CloudShiftUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    var tmp_96 = ObjectSerializer.l1c('CloudShiftUpgrade', tmp_95, tmp$ret$144);
    var tmp_97 = CrepuscularUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$147 = [];
    var tmp_98 = ObjectSerializer.l1c('CrepuscularUpgrade', tmp_97, tmp$ret$147);
    var tmp_99 = CullingUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$150 = [];
    var tmp_100 = ObjectSerializer.l1c('CullingUpgrade', tmp_99, tmp$ret$150);
    var tmp_101 = CursedLandUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$153 = [];
    var tmp_102 = ObjectSerializer.l1c('CursedLandUpgrade', tmp_101, tmp$ret$153);
    var tmp_103 = DarkFlameUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$156 = [];
    var tmp_104 = ObjectSerializer.l1c('DarkFlameUpgrade', tmp_103, tmp$ret$156);
    var tmp_105 = DarkSpawnUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$159 = [];
    var tmp_106 = ObjectSerializer.l1c('DarkSpawnUpgrade', tmp_105, tmp$ret$159);
    var tmp_107 = DeathsLamentUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$162 = [];
    var tmp_108 = ObjectSerializer.l1c('DeathsLamentUpgrade', tmp_107, tmp$ret$162);
    var tmp_109 = DevourerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$165 = [];
    var tmp_110 = ObjectSerializer.l1c('DevourerUpgrade', tmp_109, tmp$ret$165);
    var tmp_111 = DissectionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$168 = [];
    var tmp_112 = ObjectSerializer.l1c('DissectionUpgrade', tmp_111, tmp$ret$168);
    var tmp_113 = DistractionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$171 = [];
    var tmp_114 = ObjectSerializer.l1c('DistractionUpgrade', tmp_113, tmp$ret$171);
    var tmp_115 = DoomCallUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$174 = [];
    var tmp_116 = ObjectSerializer.l1c('DoomCallUpgrade', tmp_115, tmp$ret$174);
    var tmp_117 = DoubleUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$177 = [];
    var tmp_118 = ObjectSerializer.l1c('DoubleUpgrade', tmp_117, tmp$ret$177);
    var tmp_119 = DraconicBondsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$180 = [];
    var tmp_120 = ObjectSerializer.l1c('DraconicBondsUpgrade', tmp_119, tmp$ret$180);
    var tmp_121 = DrownerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$183 = [];
    var tmp_122 = ObjectSerializer.l1c('DrownerUpgrade', tmp_121, tmp$ret$183);
    var tmp_123 = EchoUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$186 = [];
    var tmp_124 = ObjectSerializer.l1c('EchoUpgrade', tmp_123, tmp$ret$186);
    var tmp_125 = EcholocationUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$189 = [];
    var tmp_126 = ObjectSerializer.l1c('EcholocationUpgrade', tmp_125, tmp$ret$189);
    var tmp_127 = EndlessDreamUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$192 = [];
    var tmp_128 = ObjectSerializer.l1c('EndlessDreamUpgrade', tmp_127, tmp$ret$192);
    var tmp_129 = EndlessStruggleUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$195 = [];
    var tmp_130 = ObjectSerializer.l1c('EndlessStruggleUpgrade', tmp_129, tmp$ret$195);
    var tmp_131 = EnragedUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$198 = [];
    var tmp_132 = ObjectSerializer.l1c('EnragedUpgrade', tmp_131, tmp$ret$198);
    var tmp_133 = EntrancingUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$201 = [];
    var tmp_134 = ObjectSerializer.l1c('EntrancingUpgrade', tmp_133, tmp$ret$201);
    var tmp_135 = EruptionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$204 = [];
    var tmp_136 = ObjectSerializer.l1c('EruptionUpgrade', tmp_135, tmp$ret$204);
    var tmp_137 = EternityUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$207 = [];
    var tmp_138 = ObjectSerializer.l1c('EternityUpgrade', tmp_137, tmp$ret$207);
    var tmp_139 = ExceptionalTrackerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$210 = [];
    var tmp_140 = ObjectSerializer.l1c('ExceptionalTrackerUpgrade', tmp_139, tmp$ret$210);
    var tmp_141 = ExpandTheMarshUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$213 = [];
    var tmp_142 = ObjectSerializer.l1c('ExpandTheMarshUpgrade', tmp_141, tmp$ret$213);
    var tmp_143 = ExtractUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$216 = [];
    var tmp_144 = ObjectSerializer.l1c('ExtractUpgrade', tmp_143, tmp$ret$216);
    var tmp_145 = FatalGazeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$219 = [];
    var tmp_146 = ObjectSerializer.l1c('FatalGazeUpgrade', tmp_145, tmp$ret$219);
    var tmp_147 = FearTheNightUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$222 = [];
    var tmp_148 = ObjectSerializer.l1c('FearTheNightUpgrade', tmp_147, tmp$ret$222);
    var tmp_149 = FleshboundUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$225 = [];
    var tmp_150 = ObjectSerializer.l1c('FleshboundUpgrade', tmp_149, tmp$ret$225);
    var tmp_151 = FlingUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$228 = [];
    var tmp_152 = ObjectSerializer.l1c('FlingUpgrade', tmp_151, tmp$ret$228);
    var tmp_153 = GoldenBeakUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$231 = [];
    var tmp_154 = ObjectSerializer.l1c('GoldenBeakUpgrade', tmp_153, tmp$ret$231);
    var tmp_155 = GreatHowlUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$234 = [];
    var tmp_156 = ObjectSerializer.l1c('GreatHowlUpgrade', tmp_155, tmp$ret$234);
    var tmp_157 = HordesMarchUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$237 = [];
    var tmp_158 = ObjectSerializer.l1c('HordesMarchUpgrade', tmp_157, tmp$ret$237);
    var tmp_159 = HornOfValhUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$240 = [];
    var tmp_160 = ObjectSerializer.l1c('HornOfValhUpgrade', tmp_159, tmp$ret$240);
    var tmp_161 = HuntersBaneUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$243 = [];
    var tmp_162 = ObjectSerializer.l1c('HuntersBaneUpgrade', tmp_161, tmp$ret$243);
    var tmp_163 = HuntmasterUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$246 = [];
    var tmp_164 = ObjectSerializer.l1c('HuntmasterUpgrade', tmp_163, tmp$ret$246);
    var tmp_165 = IgniteUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$249 = [];
    var tmp_166 = ObjectSerializer.l1c('IgniteUpgrade', tmp_165, tmp$ret$249);
    var tmp_167 = InfernalTusksUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$252 = [];
    var tmp_168 = ObjectSerializer.l1c('InfernalTusksUpgrade', tmp_167, tmp$ret$252);
    var tmp_169 = InfestUrgullUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$255 = [];
    var tmp_170 = ObjectSerializer.l1c('InfestUrgullUpgrade', tmp_169, tmp$ret$255);
    var tmp_171 = InfestationUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$258 = [];
    var tmp_172 = ObjectSerializer.l1c('InfestationUpgrade', tmp_171, tmp$ret$258);
    var tmp_173 = JointEffortUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$261 = [];
    var tmp_174 = ObjectSerializer.l1c('JointEffortUpgrade', tmp_173, tmp$ret$261);
    var tmp_175 = KillingsSpreeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$264 = [];
    var tmp_176 = ObjectSerializer.l1c('KillingsSpreeUpgrade', tmp_175, tmp$ret$264);
    var tmp_177 = KinsPursuitUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$267 = [];
    var tmp_178 = ObjectSerializer.l1c('KinsPursuitUpgrade', tmp_177, tmp$ret$267);
    var tmp_179 = LairUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$270 = [];
    var tmp_180 = ObjectSerializer.l1c('LairUpgrade', tmp_179, tmp$ret$270);
    var tmp_181 = LeviathanUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$273 = [];
    var tmp_182 = ObjectSerializer.l1c('LeviathanUpgrade', tmp_181, tmp$ret$273);
    var tmp_183 = LivingBlockadeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$276 = [];
    var tmp_184 = ObjectSerializer.l1c('LivingBlockadeUpgrade', tmp_183, tmp$ret$276);
    var tmp_185 = LurkingDeadUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$279 = [];
    var tmp_186 = ObjectSerializer.l1c('LurkingDeadUpgrade', tmp_185, tmp$ret$279);
    var tmp_187 = MartyrUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$282 = [];
    var tmp_188 = ObjectSerializer.l1c('MartyrUpgrade', tmp_187, tmp$ret$282);
    var tmp_189 = MassProductionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$285 = [];
    var tmp_190 = ObjectSerializer.l1c('MassProductionUpgrade', tmp_189, tmp$ret$285);
    var tmp_191 = MendrsFuryUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$288 = [];
    var tmp_192 = ObjectSerializer.l1c('MendrsFuryUpgrade', tmp_191, tmp$ret$288);
    var tmp_193 = MirrorBeastUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$291 = [];
    var tmp_194 = ObjectSerializer.l1c('MirrorBeastUpgrade', tmp_193, tmp$ret$291);
    var tmp_195 = NaturalInstinctUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$294 = [];
    var tmp_196 = ObjectSerializer.l1c('NaturalInstinctUpgrade', tmp_195, tmp$ret$294);
    var tmp_197 = OverlordUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$297 = [];
    var tmp_198 = ObjectSerializer.l1c('OverlordUpgrade', tmp_197, tmp$ret$297);
    var tmp_199 = PalebloodAxesUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$300 = [];
    var tmp_200 = ObjectSerializer.l1c('PalebloodAxesUpgrade', tmp_199, tmp$ret$300);
    var tmp_201 = PandemoniumUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$303 = [];
    var tmp_202 = ObjectSerializer.l1c('PandemoniumUpgrade', tmp_201, tmp$ret$303);
    var tmp_203 = PortableWorkshopUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$306 = [];
    var tmp_204 = ObjectSerializer.l1c('PortableWorkshopUpgrade', tmp_203, tmp$ret$306);
    var tmp_205 = PredictUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$309 = [];
    var tmp_206 = ObjectSerializer.l1c('PredictUpgrade', tmp_205, tmp$ret$309);
    var tmp_207 = PrimalInstinctsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$312 = [];
    var tmp_208 = ObjectSerializer.l1c('PrimalInstinctsUpgrade', tmp_207, tmp$ret$312);
    var tmp_209 = ProminenceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$315 = [];
    var tmp_210 = ObjectSerializer.l1c('ProminenceUpgrade', tmp_209, tmp$ret$315);
    var tmp_211 = RampageousUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$318 = [];
    var tmp_212 = ObjectSerializer.l1c('RampageousUpgrade', tmp_211, tmp$ret$318);
    var tmp_213 = ReachUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$321 = [];
    var tmp_214 = ObjectSerializer.l1c('ReachUpgrade', tmp_213, tmp$ret$321);
    var tmp_215 = RefugeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$324 = [];
    var tmp_216 = ObjectSerializer.l1c('RefugeUpgrade', tmp_215, tmp$ret$324);
    var tmp_217 = RegalUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$327 = [];
    var tmp_218 = ObjectSerializer.l1c('RegalUpgrade', tmp_217, tmp$ret$327);
    var tmp_219 = ReuniteUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$330 = [];
    var tmp_220 = ObjectSerializer.l1c('ReuniteUpgrade', tmp_219, tmp$ret$330);
    var tmp_221 = ReveranceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$333 = [];
    var tmp_222 = ObjectSerializer.l1c('ReveranceUpgrade', tmp_221, tmp$ret$333);
    var tmp_223 = RuptureSeedsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$336 = [];
    var tmp_224 = ObjectSerializer.l1c('RuptureSeedsUpgrade', tmp_223, tmp$ret$336);
    var tmp_225 = ScavengerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$339 = [];
    var tmp_226 = ObjectSerializer.l1c('ScavengerUpgrade', tmp_225, tmp$ret$339);
    var tmp_227 = SeekerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$342 = [];
    var tmp_228 = ObjectSerializer.l1c('SeekerUpgrade', tmp_227, tmp$ret$342);
    var tmp_229 = SharedMadnessUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$345 = [];
    var tmp_230 = ObjectSerializer.l1c('SharedMadnessUpgrade', tmp_229, tmp$ret$345);
    var tmp_231 = SkyMasterUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$348 = [];
    var tmp_232 = ObjectSerializer.l1c('SkyMasterUpgrade', tmp_231, tmp$ret$348);
    var tmp_233 = SoothsayerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$351 = [];
    var tmp_234 = ObjectSerializer.l1c('SoothsayerUpgrade', tmp_233, tmp$ret$351);
    var tmp_235 = SoulHarvestUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$354 = [];
    var tmp_236 = ObjectSerializer.l1c('SoulHarvestUpgrade', tmp_235, tmp$ret$354);
    var tmp_237 = SoulHarvestVackerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$357 = [];
    var tmp_238 = ObjectSerializer.l1c('SoulHarvestVackerUpgrade', tmp_237, tmp$ret$357);
    var tmp_239 = SpiritboundUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$360 = [];
    var tmp_240 = ObjectSerializer.l1c('SpiritboundUpgrade', tmp_239, tmp$ret$360);
    var tmp_241 = StarFallUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$363 = [];
    var tmp_242 = ObjectSerializer.l1c('StarFallUpgrade', tmp_241, tmp$ret$363);
    var tmp_243 = StormBringerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$366 = [];
    var tmp_244 = ObjectSerializer.l1c('StormBringerUpgrade', tmp_243, tmp$ret$366);
    var tmp_245 = SwapUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$369 = [];
    var tmp_246 = ObjectSerializer.l1c('SwapUpgrade', tmp_245, tmp$ret$369);
    var tmp_247 = SwiftKillUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$372 = [];
    var tmp_248 = ObjectSerializer.l1c('SwiftKillUpgrade', tmp_247, tmp$ret$372);
    var tmp_249 = TacticalInsightUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$375 = [];
    var tmp_250 = ObjectSerializer.l1c('TacticalInsightUpgrade', tmp_249, tmp$ret$375);
    var tmp_251 = ThickMistUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$378 = [];
    var tmp_252 = ObjectSerializer.l1c('ThickMistUpgrade', tmp_251, tmp$ret$378);
    var tmp_253 = TormentingVisionsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$381 = [];
    var tmp_254 = ObjectSerializer.l1c('TormentingVisionsUpgrade', tmp_253, tmp$ret$381);
    var tmp_255 = TorrentialUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$384 = [];
    var tmp_256 = ObjectSerializer.l1c('TorrentialUpgrade', tmp_255, tmp$ret$384);
    var tmp_257 = TownswatchUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$387 = [];
    var tmp_258 = ObjectSerializer.l1c('TownswatchUpgrade', tmp_257, tmp$ret$387);
    var tmp_259 = TrapLauncherUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$390 = [];
    var tmp_260 = ObjectSerializer.l1c('TrapLauncherUpgrade', tmp_259, tmp$ret$390);
    var tmp_261 = TrueInstinctEsmeriaBeastUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$393 = [];
    var tmp_262 = ObjectSerializer.l1c('TrueInstinctEsmeriaBeastUpgrade', tmp_261, tmp$ret$393);
    var tmp_263 = TrueInstinctEsmeriaHuntressUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$396 = [];
    var tmp_264 = ObjectSerializer.l1c('TrueInstinctEsmeriaHuntressUpgrade', tmp_263, tmp$ret$396);
    var tmp_265 = UnendingHungerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$399 = [];
    var tmp_266 = ObjectSerializer.l1c('UnendingHungerUpgrade', tmp_265, tmp$ret$399);
    var tmp_267 = VoidPresenceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$402 = [];
    var tmp_268 = ObjectSerializer.l1c('VoidPresenceUpgrade', tmp_267, tmp$ret$402);
    var tmp_269 = VoidStepUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$405 = [];
    var tmp_270 = ObjectSerializer.l1c('VoidStepUpgrade', tmp_269, tmp$ret$405);
    var tmp_271 = WatchtowerPassageUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$408 = [];
    var tmp_272 = ObjectSerializer.l1c('WatchtowerPassageUpgrade', tmp_271, tmp$ret$408);
    var tmp_273 = WildbondUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$411 = [];
    var tmp_274 = ObjectSerializer.l1c('WildbondUpgrade', tmp_273, tmp$ret$411);
    var tmp_275 = WitheringMawUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$414 = [];
    var tmp_276 = ObjectSerializer.l1c('WitheringMawUpgrade', tmp_275, tmp$ret$414);
    var tmp_277 = WorshipUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$417 = [];
    var tmp_278 = ObjectSerializer.l1c('WorshipUpgrade', tmp_277, tmp$ret$417);
    var tmp_279 = WrathOfEirtirUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$420 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_280 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_66, tmp_68, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_80, tmp_82, tmp_84, tmp_86, tmp_88, tmp_90, tmp_92, tmp_94, tmp_96, tmp_98, tmp_100, tmp_102, tmp_104, tmp_106, tmp_108, tmp_110, tmp_112, tmp_114, tmp_116, tmp_118, tmp_120, tmp_122, tmp_124, tmp_126, tmp_128, tmp_130, tmp_132, tmp_134, tmp_136, tmp_138, tmp_140, tmp_142, tmp_144, tmp_146, tmp_148, tmp_150, tmp_152, tmp_154, tmp_156, tmp_158, tmp_160, tmp_162, tmp_164, tmp_166, tmp_168, tmp_170, tmp_172, tmp_174, tmp_176, tmp_178, tmp_180, tmp_182, tmp_184, tmp_186, tmp_188, tmp_190, tmp_192, tmp_194, tmp_196, tmp_198, tmp_200, tmp_202, tmp_204, tmp_206, tmp_208, tmp_210, tmp_212, tmp_214, tmp_216, tmp_218, tmp_220, tmp_222, tmp_224, tmp_226, tmp_228, tmp_230, tmp_232, tmp_234, tmp_236, tmp_238, tmp_240, tmp_242, tmp_244, tmp_246, tmp_248, tmp_250, tmp_252, tmp_254, tmp_256, tmp_258, tmp_260, tmp_262, tmp_264, tmp_266, tmp_268, tmp_270, tmp_272, tmp_274, tmp_276, tmp_278, ObjectSerializer.l1c('WrathOfEirtirUpgrade', tmp_279, tmp$ret$420)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$426 = [];
    return SealedClassSerializer.i10('steelart.beast.CharacterUpgrade', tmp, tmp_0, tmp_280, tmp$ret$426);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_130 {
  a2g() {
    var tmp = getKClass(ChargingUpgrade);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BlackStarUpgrade), getKClass(DefenderUpgrade), getKClass(MesmeriseUpgrade), getKClass(RebirthByFireUpgrade), getKClass(SoulCollectorUpgrade)];
    var tmp_1 = BlackStarUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('BlackStarUpgrade', tmp_1, tmp$ret$3);
    var tmp_3 = DefenderUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('DefenderUpgrade', tmp_3, tmp$ret$6);
    var tmp_5 = MesmeriseUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('MesmeriseUpgrade', tmp_5, tmp$ret$9);
    var tmp_7 = RebirthByFireUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('RebirthByFireUpgrade', tmp_7, tmp$ret$12);
    var tmp_9 = SoulCollectorUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_10 = [tmp_2, tmp_4, tmp_6, tmp_8, ObjectSerializer.l1c('SoulCollectorUpgrade', tmp_9, tmp$ret$15)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    return SealedClassSerializer.i10('steelart.beast.ChargingUpgrade', tmp, tmp_0, tmp_10, tmp$ret$21);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class ChargingUpgrade {}
class Companion_131 {
  constructor() {
    Companion_instance_131 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u3p_1 = [lazy(tmp_0, GameNotification$Companion$$childSerializers$_anonymous__uialnx), null, null];
  }
}
class $serializer_115 {
  constructor() {
    $serializer_instance_115 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GameNotification', this, 3);
    tmp0_serialDesc.h1b('event', false);
    tmp0_serialDesc.h1b('checkInfo', false);
    tmp0_serialDesc.h1b('isMasterFixingEvent', true);
    this.v3p_1 = tmp0_serialDesc;
  }
  w3p(encoder, value) {
    var tmp0_desc = this.v3p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_132().u3p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x3p_1);
    tmp1_output.i15(tmp0_desc, 1, $serializer_getInstance_116(), value.y3p_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.z3p_1 === false)) {
      tmp1_output.w14(tmp0_desc, 2, value.z3p_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w3p(encoder, value instanceof GameNotification ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v3p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_132().u3p_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, $serializer_getInstance_116(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, $serializer_getInstance_116(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return GameNotification.a3q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.v3p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_132().u3p_1[0].k3(), get_nullable($serializer_getInstance_116()), BooleanSerializer_getInstance()];
  }
}
class GameNotification {
  constructor(event, checkInfo, isMasterFixingEvent) {
    Companion_getInstance_132();
    isMasterFixingEvent = isMasterFixingEvent === VOID ? false : isMasterFixingEvent;
    this.x3p_1 = event;
    this.y3p_1 = checkInfo;
    this.z3p_1 = isMasterFixingEvent;
  }
  toString() {
    return 'GameNotification(event=' + toString(this.x3p_1) + ', checkInfo=' + toString_0(this.y3p_1) + ', isMasterFixingEvent=' + this.z3p_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x3p_1);
    result = imul(result, 31) + (this.y3p_1 == null ? 0 : this.y3p_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z3p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameNotification))
      return false;
    if (!equals(this.x3p_1, other.x3p_1))
      return false;
    if (!equals(this.y3p_1, other.y3p_1))
      return false;
    if (!(this.z3p_1 === other.z3p_1))
      return false;
    return true;
  }
  static a3q(seen0, event, checkInfo, isMasterFixingEvent, serializationConstructorMarker) {
    Companion_getInstance_132();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_115().v3p_1);
    }
    var $this = createThis(this);
    $this.x3p_1 = event;
    $this.y3p_1 = checkInfo;
    if (0 === (seen0 & 4))
      $this.z3p_1 = false;
    else
      $this.z3p_1 = isMasterFixingEvent;
    return $this;
  }
}
class Companion_132 {}
class $serializer_116 {
  constructor() {
    $serializer_instance_116 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GameStateCheckInfo', this, 3);
    tmp0_serialDesc.h1b('oldRevision', false);
    tmp0_serialDesc.h1b('newRevision', false);
    tmp0_serialDesc.h1b('checkCode', false);
    this.b3q_1 = tmp0_serialDesc;
  }
  c3q(encoder, value) {
    var tmp0_desc = this.b3q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.d3q_1);
    tmp1_output.z14(tmp0_desc, 1, value.e3q_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_201(), value.f3q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c3q(encoder, value instanceof GameStateCheckInfo ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b3q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, $serializer_getInstance_201(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, $serializer_getInstance_201(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return GameStateCheckInfo.g3q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.b3q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_201()];
  }
}
class GameStateCheckInfo {
  constructor(oldRevision, newRevision, checkCode) {
    this.d3q_1 = oldRevision;
    this.e3q_1 = newRevision;
    this.f3q_1 = checkCode;
  }
  toString() {
    return 'GameStateCheckInfo(oldRevision=' + this.d3q_1 + ', newRevision=' + this.e3q_1 + ', checkCode=' + this.f3q_1.toString() + ')';
  }
  hashCode() {
    var result = this.d3q_1;
    result = imul(result, 31) + this.e3q_1 | 0;
    result = imul(result, 31) + this.f3q_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameStateCheckInfo))
      return false;
    if (!(this.d3q_1 === other.d3q_1))
      return false;
    if (!(this.e3q_1 === other.e3q_1))
      return false;
    if (!this.f3q_1.equals(other.f3q_1))
      return false;
    return true;
  }
  static g3q(seen0, oldRevision, newRevision, checkCode, serializationConstructorMarker) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_116().b3q_1);
    }
    var $this = createThis(this);
    $this.d3q_1 = oldRevision;
    $this.e3q_1 = newRevision;
    $this.f3q_1 = checkCode;
    return $this;
  }
}
class ReplayIsFinishedException extends Exception {
  constructor() {
    return new.target.j3q();
  }
  static j3q() {
    var $this = this.c6('Replay is finished');
    captureStack($this, $this.i3q_1);
    return $this;
  }
}
class Companion_133 {
  a2g() {
    var tmp = getKClass(ControllingActor);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ControllingByCharacter), getKClass(ControllingByTeam), getKClass(MesmerizedControlling), getKClass(ControllingByNothing)];
    var tmp_1 = $serializer_getInstance_117();
    var tmp_2 = $serializer_getInstance_118();
    var tmp_3 = $serializer_getInstance_119();
    var tmp_4 = ControllingByNothing_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_5 = [tmp_1, tmp_2, tmp_3, ObjectSerializer.l1c('ControllingByNothing', tmp_4, tmp$ret$3)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    return SealedClassSerializer.i10('steelart.beast.ControllingActor', tmp, tmp_0, tmp_5, tmp$ret$9);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class ControllingActor {}
class Companion_134 {
  a2g() {
    var tmp = getKClass(ControllingActorWithTeam);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ControllingByCharacter), getKClass(ControllingByTeam), getKClass(MesmerizedControlling)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_117(), $serializer_getInstance_118(), $serializer_getInstance_119()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.ControllingActorWithTeam', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class ControllingActorWithTeam {}
class Companion_135 {
  constructor() {
    Companion_instance_135 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l3q_1 = [lazy(tmp_0, ControllingByCharacter$Companion$$childSerializers$_anonymous__f6geaz), null];
  }
}
class $serializer_117 {
  constructor() {
    $serializer_instance_117 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ControllingByCharacter', this, 2);
    tmp0_serialDesc.h1b('character', false);
    tmp0_serialDesc.h1b('gameTeam', false);
    this.m3q_1 = tmp0_serialDesc;
  }
  n3q(encoder, value) {
    var tmp0_desc = this.m3q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_136().l3q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o3q_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_183(), new GameTeam(value.p3q_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n3q(encoder, value instanceof ControllingByCharacter ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m3q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_136().l3q_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ControllingByCharacter.q3q(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.m3q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_136().l3q_1[0].k3(), $serializer_getInstance_183()];
  }
}
class ControllingByCharacter {
  constructor(character, gameTeam) {
    Companion_getInstance_136();
    this.o3q_1 = character;
    this.p3q_1 = gameTeam;
  }
  k3q() {
    return this.p3q_1;
  }
  toString() {
    return 'ControllingByCharacter(character=' + this.o3q_1.toString() + ', gameTeam=' + GameTeam__toString_impl_wfw0a6(this.p3q_1) + ')';
  }
  hashCode() {
    var result = this.o3q_1.hashCode();
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.p3q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ControllingByCharacter))
      return false;
    if (!this.o3q_1.equals(other.o3q_1))
      return false;
    if (!(this.p3q_1 === other.p3q_1))
      return false;
    return true;
  }
  static q3q(seen0, character, gameTeam, serializationConstructorMarker) {
    Companion_getInstance_136();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_117().m3q_1);
    }
    var $this = createThis(this);
    $this.o3q_1 = character;
    $this.p3q_1 = gameTeam;
    return $this;
  }
}
class Companion_136 {}
class $serializer_118 {
  constructor() {
    $serializer_instance_118 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ControllingByTeam', this, 1);
    tmp0_serialDesc.h1b('gameTeam', false);
    this.r3q_1 = tmp0_serialDesc;
  }
  s3q(encoder, value) {
    var tmp0_desc = this.r3q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_183(), new GameTeam(value.t3q_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s3q(encoder, value instanceof ControllingByTeam ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r3q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ControllingByTeam.u3q(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r3q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_183()];
  }
}
class ControllingByTeam {
  constructor(gameTeam) {
    this.t3q_1 = gameTeam;
  }
  k3q() {
    return this.t3q_1;
  }
  toString() {
    return 'ControllingByTeam(gameTeam=' + GameTeam__toString_impl_wfw0a6(this.t3q_1) + ')';
  }
  hashCode() {
    return GameTeam__hashCode_impl_gu24w3(this.t3q_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ControllingByTeam))
      return false;
    if (!(this.t3q_1 === other.t3q_1))
      return false;
    return true;
  }
  static u3q(seen0, gameTeam, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_118().r3q_1);
    }
    var $this = createThis(this);
    $this.t3q_1 = gameTeam;
    return $this;
  }
}
class Companion_137 {
  constructor() {
    Companion_instance_137 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v3q_1 = [lazy(tmp_0, MesmerizedControlling$Companion$$childSerializers$_anonymous__vvqjei), null];
  }
}
class $serializer_119 {
  constructor() {
    $serializer_instance_119 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MesmerizedControlling', this, 2);
    tmp0_serialDesc.h1b('victim', false);
    tmp0_serialDesc.h1b('gameTeam', false);
    this.w3q_1 = tmp0_serialDesc;
  }
  x3q(encoder, value) {
    var tmp0_desc = this.w3q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_138().v3q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y3q_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_183(), new GameTeam(value.z3q_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x3q(encoder, value instanceof MesmerizedControlling ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w3q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_138().v3q_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return MesmerizedControlling.a3r(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.w3q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_138().v3q_1[0].k3(), $serializer_getInstance_183()];
  }
}
class MesmerizedControlling {
  constructor(victim, gameTeam) {
    Companion_getInstance_138();
    this.y3q_1 = victim;
    this.z3q_1 = gameTeam;
  }
  k3q() {
    return this.z3q_1;
  }
  toString() {
    return 'MesmerizedControlling(victim=' + this.y3q_1.toString() + ', gameTeam=' + GameTeam__toString_impl_wfw0a6(this.z3q_1) + ')';
  }
  hashCode() {
    var result = this.y3q_1.hashCode();
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.z3q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MesmerizedControlling))
      return false;
    if (!this.y3q_1.equals(other.y3q_1))
      return false;
    if (!(this.z3q_1 === other.z3q_1))
      return false;
    return true;
  }
  static a3r(seen0, victim, gameTeam, serializationConstructorMarker) {
    Companion_getInstance_138();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_119().w3q_1);
    }
    var $this = createThis(this);
    $this.y3q_1 = victim;
    $this.z3q_1 = gameTeam;
    return $this;
  }
}
class ControllingByNothing {
  constructor() {
    ControllingByNothing_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b3r_1 = lazy(tmp_0, ControllingByNothing$_anonymous__if9hu4);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_92(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ControllingByNothing';
  }
  hashCode() {
    return -749584344;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ControllingByNothing))
      return false;
    return true;
  }
}
class Companion_138 {
  a2g() {
    var tmp = getKClass(DamageSource);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AbyssalSwampRelocationDamage), getKClass(AllureSoulChangedDamageSource), getKClass(CardDamageSourceImpl), getKClass(ContractReward), getKClass(DevotionStatement), getKClass(DraugCardWoundEffectSource), getKClass(RuinActivation), getKClass(SandboxDamage), getKClass(SigridCreatureDeathEffectSource), getKClass(SummonActivation), getKClass(TrapActivation), getKClass(UpgradeDamageSource), getKClass(UrgullHatchDamageSource), getKClass(YeltrDeathDamageSource), getKClass(YeltrReapDamageSource)];
    var tmp_1 = AbyssalSwampRelocationDamage_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('AbyssalSwampRelocationDamage', tmp_1, tmp$ret$3);
    var tmp_3 = AllureSoulChangedDamageSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('AllureSoulChangedDamageSource', tmp_3, tmp$ret$6);
    var tmp_5 = $serializer_getInstance_120();
    var tmp_6 = ContractReward_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_7 = ObjectSerializer.l1c('ContractReward', tmp_6, tmp$ret$9);
    var tmp_8 = $serializer_getInstance_144();
    var tmp_9 = DraugCardWoundEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_10 = ObjectSerializer.l1c('DraugCardWoundEffectSource', tmp_9, tmp$ret$12);
    var tmp_11 = $serializer_getInstance_121();
    var tmp_12 = SandboxDamage_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_13 = ObjectSerializer.l1c('SandboxDamage', tmp_12, tmp$ret$15);
    var tmp_14 = SigridCreatureDeathEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_15 = ObjectSerializer.l1c('SigridCreatureDeathEffectSource', tmp_14, tmp$ret$18);
    var tmp_16 = SummonActivation_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_17 = ObjectSerializer.l1c('SummonActivation', tmp_16, tmp$ret$21);
    var tmp_18 = TrapActivation_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_19 = ObjectSerializer.l1c('TrapActivation', tmp_18, tmp$ret$24);
    var tmp_20 = $serializer_getInstance_122();
    var tmp_21 = UrgullHatchDamageSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_22 = ObjectSerializer.l1c('UrgullHatchDamageSource', tmp_21, tmp$ret$27);
    var tmp_23 = YeltrDeathDamageSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_24 = ObjectSerializer.l1c('YeltrDeathDamageSource', tmp_23, tmp$ret$30);
    var tmp_25 = YeltrReapDamageSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_26 = [tmp_2, tmp_4, tmp_5, tmp_7, tmp_8, tmp_10, tmp_11, tmp_13, tmp_15, tmp_17, tmp_19, tmp_20, tmp_22, tmp_24, ObjectSerializer.l1c('YeltrReapDamageSource', tmp_25, tmp$ret$33)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    return SealedClassSerializer.i10('steelart.beast.DamageSource', tmp, tmp_0, tmp_26, tmp$ret$39);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class DamageSource {}
class Companion_139 {
  constructor() {
    Companion_instance_139 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e3r_1 = [lazy(tmp_0, CardDamageSourceImpl$Companion$$childSerializers$_anonymous__4zo0j4)];
  }
}
class $serializer_120 {
  constructor() {
    $serializer_instance_120 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CardDamageSourceImpl', this, 1);
    tmp0_serialDesc.h1b('card', false);
    this.f3r_1 = tmp0_serialDesc;
  }
  g3r(encoder, value) {
    var tmp0_desc = this.f3r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_140().e3r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h3r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g3r(encoder, value instanceof CardDamageSourceImpl ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f3r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_140().e3r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return CardDamageSourceImpl.i3r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.f3r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_140().e3r_1[0].k3()];
  }
}
class CardDamageSourceImpl {
  constructor(card) {
    Companion_getInstance_140();
    this.h3r_1 = card;
  }
  toString() {
    return 'CardDamageSourceImpl(card=' + toString(this.h3r_1) + ')';
  }
  hashCode() {
    return hashCode(this.h3r_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardDamageSourceImpl))
      return false;
    if (!equals(this.h3r_1, other.h3r_1))
      return false;
    return true;
  }
  static i3r(seen0, card, serializationConstructorMarker) {
    Companion_getInstance_140();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_120().f3r_1);
    }
    var $this = createThis(this);
    $this.h3r_1 = card;
    return $this;
  }
}
class AbyssalSwampRelocationDamage {
  constructor() {
    AbyssalSwampRelocationDamage_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j3r_1 = lazy(tmp_0, AbyssalSwampRelocationDamage$_anonymous__lh850d);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_93(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AbyssalSwampRelocationDamage';
  }
  hashCode() {
    return 767914873;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbyssalSwampRelocationDamage))
      return false;
    return true;
  }
}
class ContractReward {
  constructor() {
    ContractReward_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k3r_1 = lazy(tmp_0, ContractReward$_anonymous__vcb2iy);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_94(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ContractReward';
  }
  hashCode() {
    return 1716395238;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ContractReward))
      return false;
    return true;
  }
}
class Companion_140 {}
class $serializer_121 {
  constructor() {
    $serializer_instance_121 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RuinActivation', this, 1);
    tmp0_serialDesc.h1b('ruinPosition', false);
    this.l3r_1 = tmp0_serialDesc;
  }
  m3r(encoder, value) {
    var tmp0_desc = this.l3r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.n3r_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m3r(encoder, value instanceof RuinActivation ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l3r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RuinActivation.o3r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l3r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100()];
  }
}
class RuinActivation {
  constructor(ruinPosition) {
    this.n3r_1 = ruinPosition;
  }
  toString() {
    return 'RuinActivation(ruinPosition=' + BoardPosition__toString_impl_v4mn82(this.n3r_1) + ')';
  }
  hashCode() {
    return BoardPosition__hashCode_impl_9dgqf7(this.n3r_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RuinActivation))
      return false;
    if (!(this.n3r_1 === other.n3r_1))
      return false;
    return true;
  }
  static o3r(seen0, ruinPosition, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_121().l3r_1);
    }
    var $this = createThis(this);
    $this.n3r_1 = ruinPosition;
    return $this;
  }
}
class SandboxDamage {
  constructor() {
    SandboxDamage_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p3r_1 = lazy(tmp_0, SandboxDamage$_anonymous__9d0pvj);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_95(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SandboxDamage';
  }
  hashCode() {
    return -455603599;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxDamage))
      return false;
    return true;
  }
}
class SummonActivation {
  constructor() {
    SummonActivation_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q3r_1 = lazy(tmp_0, SummonActivation$_anonymous__o9ixds);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_96(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonActivation';
  }
  hashCode() {
    return -1542278756;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonActivation))
      return false;
    return true;
  }
}
class TrapActivation {
  constructor() {
    TrapActivation_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r3r_1 = lazy(tmp_0, TrapActivation$_anonymous__j1raoc);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_97(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TrapActivation';
  }
  hashCode() {
    return -1112022488;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrapActivation))
      return false;
    return true;
  }
}
class Companion_141 {
  constructor() {
    Companion_instance_141 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s3r_1 = [lazy(tmp_0, UpgradeDamageSource$Companion$$childSerializers$_anonymous__82ofyc)];
  }
}
class $serializer_122 {
  constructor() {
    $serializer_instance_122 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UpgradeDamageSource', this, 1);
    tmp0_serialDesc.h1b('upgrade', false);
    this.t3r_1 = tmp0_serialDesc;
  }
  u3r(encoder, value) {
    var tmp0_desc = this.t3r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_142().s3r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.v3r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u3r(encoder, value instanceof UpgradeDamageSource ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t3r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_142().s3r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UpgradeDamageSource.w3r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.t3r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_142().s3r_1[0].k3()];
  }
}
class UpgradeDamageSource {
  constructor(upgrade) {
    Companion_getInstance_142();
    this.v3r_1 = upgrade;
  }
  toString() {
    return 'UpgradeDamageSource(upgrade=' + toString(this.v3r_1) + ')';
  }
  hashCode() {
    return hashCode(this.v3r_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UpgradeDamageSource))
      return false;
    if (!equals(this.v3r_1, other.v3r_1))
      return false;
    return true;
  }
  static w3r(seen0, upgrade, serializationConstructorMarker) {
    Companion_getInstance_142();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_122().t3r_1);
    }
    var $this = createThis(this);
    $this.v3r_1 = upgrade;
    return $this;
  }
}
class Companion_142 {
  constructor() {
    Companion_instance_142 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, DealingDamage$Companion$$childSerializers$_anonymous__82ndd1);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, DealingDamage$Companion$$childSerializers$_anonymous__82ndd1_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, DealingDamage$Companion$$childSerializers$_anonymous__82ndd1_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_7 = lazy(tmp_6, DealingDamage$Companion$$childSerializers$_anonymous__82ndd1_2);
    var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x3r_1 = [tmp_1, tmp_3, tmp_5, tmp_7, lazy(tmp_8, DealingDamage$Companion$$childSerializers$_anonymous__82ndd1_3)];
  }
}
class $serializer_123 {
  constructor() {
    $serializer_instance_123 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.DealingDamage', this, 5);
    tmp0_serialDesc.h1b('actionStatement', false);
    tmp0_serialDesc.h1b('damageSource', false);
    tmp0_serialDesc.h1b('damageKind', false);
    tmp0_serialDesc.h1b('cause', false);
    tmp0_serialDesc.h1b('instances', false);
    this.y3r_1 = tmp0_serialDesc;
  }
  z3r(encoder, value) {
    var tmp0_desc = this.y3r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_143().x3r_1;
    tmp1_output.i15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a3s_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.b3s_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.c3s_1);
    tmp1_output.i15(tmp0_desc, 3, tmp2_cached[3].k3(), value.d3s_1);
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.e3s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z3r(encoder, value instanceof DealingDamage ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y3r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_143().x3r_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.d14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.d14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, tmp10_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.d14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.d14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, tmp10_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return DealingDamage.f3s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.y3r_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_143().x3r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0].k3()), tmp0_cached[1].k3(), tmp0_cached[2].k3(), get_nullable(tmp0_cached[3].k3()), tmp0_cached[4].k3()];
  }
}
class DealingDamage {
  constructor(actionStatement, damageSource, damageKind, cause, instances) {
    Companion_getInstance_143();
    this.a3s_1 = actionStatement;
    this.b3s_1 = damageSource;
    this.c3s_1 = damageKind;
    this.d3s_1 = cause;
    this.e3s_1 = instances;
  }
  g3s(actionStatement, damageSource, damageKind, cause, instances) {
    return new DealingDamage(actionStatement, damageSource, damageKind, cause, instances);
  }
  h3s(actionStatement, damageSource, damageKind, cause, instances, $super) {
    actionStatement = actionStatement === VOID ? this.a3s_1 : actionStatement;
    damageSource = damageSource === VOID ? this.b3s_1 : damageSource;
    damageKind = damageKind === VOID ? this.c3s_1 : damageKind;
    cause = cause === VOID ? this.d3s_1 : cause;
    instances = instances === VOID ? this.e3s_1 : instances;
    return $super === VOID ? this.g3s(actionStatement, damageSource, damageKind, cause, instances) : $super.g3s.call(this, actionStatement, damageSource, damageKind, cause, instances);
  }
  toString() {
    return 'DealingDamage(actionStatement=' + toString_0(this.a3s_1) + ', damageSource=' + toString(this.b3s_1) + ', damageKind=' + this.c3s_1.toString() + ', cause=' + toString_0(this.d3s_1) + ', instances=' + toString(this.e3s_1) + ')';
  }
  hashCode() {
    var result = this.a3s_1 == null ? 0 : hashCode(this.a3s_1);
    result = imul(result, 31) + hashCode(this.b3s_1) | 0;
    result = imul(result, 31) + this.c3s_1.hashCode() | 0;
    result = imul(result, 31) + (this.d3s_1 == null ? 0 : this.d3s_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.e3s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DealingDamage))
      return false;
    if (!equals(this.a3s_1, other.a3s_1))
      return false;
    if (!equals(this.b3s_1, other.b3s_1))
      return false;
    if (!this.c3s_1.equals(other.c3s_1))
      return false;
    if (!equals(this.d3s_1, other.d3s_1))
      return false;
    if (!equals(this.e3s_1, other.e3s_1))
      return false;
    return true;
  }
  static f3s(seen0, actionStatement, damageSource, damageKind, cause, instances, serializationConstructorMarker) {
    Companion_getInstance_143();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_123().y3r_1);
    }
    var $this = createThis(this);
    $this.a3s_1 = actionStatement;
    $this.b3s_1 = damageSource;
    $this.c3s_1 = damageKind;
    $this.d3s_1 = cause;
    $this.e3s_1 = instances;
    return $this;
  }
}
class Companion_143 {
  constructor() {
    Companion_instance_143 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i3s_1 = [lazy(tmp_0, DamageBlock$Companion$$childSerializers$_anonymous__vr37qs), null];
  }
}
class $serializer_124 {
  constructor() {
    $serializer_instance_124 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.DamageBlock', this, 2);
    tmp0_serialDesc.h1b('target', false);
    tmp0_serialDesc.h1b('damageBlocked', true);
    this.j3s_1 = tmp0_serialDesc;
  }
  k3s(encoder, value) {
    var tmp0_desc = this.j3s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_144().i3s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l3s_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.m3s_1 === 1)) {
      tmp1_output.z14(tmp0_desc, 1, value.m3s_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k3s(encoder, value instanceof DamageBlock ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j3s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_144().i3s_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return DamageBlock.n3s(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.j3s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_144().i3s_1[0].k3(), IntSerializer_getInstance()];
  }
}
class DamageBlock {
  constructor(target, damageBlocked) {
    Companion_getInstance_144();
    damageBlocked = damageBlocked === VOID ? 1 : damageBlocked;
    this.l3s_1 = target;
    this.m3s_1 = damageBlocked;
  }
  toString() {
    return 'DamageBlock(target=' + this.l3s_1.toString() + ', damageBlocked=' + this.m3s_1 + ')';
  }
  hashCode() {
    var result = this.l3s_1.hashCode();
    result = imul(result, 31) + this.m3s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DamageBlock))
      return false;
    if (!this.l3s_1.equals(other.l3s_1))
      return false;
    if (!(this.m3s_1 === other.m3s_1))
      return false;
    return true;
  }
  static n3s(seen0, target, damageBlocked, serializationConstructorMarker) {
    Companion_getInstance_144();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_124().j3s_1);
    }
    var $this = createThis(this);
    $this.l3s_1 = target;
    if (0 === (seen0 & 2))
      $this.m3s_1 = 1;
    else
      $this.m3s_1 = damageBlocked;
    return $this;
  }
}
class Companion_144 {
  constructor() {
    Companion_instance_144 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o3s_1 = [lazy(tmp_0, DamageToTarget$Companion$$childSerializers$_anonymous__kzafyp), null, null];
  }
}
class $serializer_125 {
  constructor() {
    $serializer_instance_125 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.DamageToTarget', this, 3);
    tmp0_serialDesc.h1b('target', false);
    tmp0_serialDesc.h1b('damage', false);
    tmp0_serialDesc.h1b('position', true);
    this.p3s_1 = tmp0_serialDesc;
  }
  q3s(encoder, value) {
    var tmp0_desc = this.p3s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_145().o3s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r3s_1);
    tmp1_output.z14(tmp0_desc, 1, value.s3s_1);
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 2)) {
      tmp = true;
    } else {
      var tmp_0 = value.t3s_1;
      tmp = !((tmp_0 == null ? null : new BoardPosition(tmp_0)) == null);
    }
    if (tmp) {
      var tmp_1 = $serializer_getInstance_100();
      var tmp_2 = value.t3s_1;
      tmp1_output.i15(tmp0_desc, 2, tmp_1, tmp_2 == null ? null : new BoardPosition(tmp_2));
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q3s(encoder, value instanceof DamageToTarget ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p3s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_145().o3s_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp7_input.d14(tmp0_desc, 2, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp6_local2;
            var tmp_4 = tmp7_input.d14(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp6_local2 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return DamageToTarget.u3s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.p3s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_145().o3s_1[0].k3(), IntSerializer_getInstance(), get_nullable($serializer_getInstance_100())];
  }
}
class DamageToTarget {
  constructor(target, damage, position) {
    Companion_getInstance_145();
    position = position === VOID ? null : position;
    this.r3s_1 = target;
    this.s3s_1 = damage;
    this.t3s_1 = position;
  }
  toString() {
    var tmp = this.r3s_1.toString();
    var tmp_0 = this.t3s_1;
    return 'DamageToTarget(target=' + tmp + ', damage=' + this.s3s_1 + ', position=' + toString_0(tmp_0 == null ? null : new BoardPosition(tmp_0)) + ')';
  }
  hashCode() {
    var result = this.r3s_1.hashCode();
    result = imul(result, 31) + this.s3s_1 | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.t3s_1;
    if ((tmp_1 == null ? null : new BoardPosition(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = BoardPosition__hashCode_impl_9dgqf7(this.t3s_1);
    }
    result = tmp + tmp_0 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DamageToTarget))
      return false;
    if (!this.r3s_1.equals(other.r3s_1))
      return false;
    if (!(this.s3s_1 === other.s3s_1))
      return false;
    var tmp = this.t3s_1;
    var tmp_0 = tmp == null ? null : new BoardPosition(tmp);
    var tmp_1 = other.t3s_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new BoardPosition(tmp_1)))
      return false;
    return true;
  }
  static u3s(seen0, target, damage, position, serializationConstructorMarker) {
    Companion_getInstance_145();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_125().p3s_1);
    }
    var $this = createThis(this);
    $this.r3s_1 = target;
    $this.s3s_1 = damage;
    if (0 === (seen0 & 4))
      $this.t3s_1 = null;
    else
      $this.t3s_1 = position;
    return $this;
  }
}
class DamageKind extends Enum {}
class installAnswer$5 {
  constructor($result, $worker) {
    this.w3s_1 = $worker;
    this.v3s_1 = $result;
  }
  *k1n($completion) {
    yield* this.w3s_1.k1n($completion);
    return Unit_instance;
  }
  *m1q($completion) {
    return yield* this.v3s_1.m1q($completion);
  }
  z1o() {
    return this.v3s_1.z1o();
  }
  d1n() {
    return this.v3s_1.d1n();
  }
  b1n() {
    return this.v3s_1.b1n();
  }
  n1n(cause) {
    this.v3s_1.n1n(cause);
  }
  x1n(child) {
    return this.v3s_1.x1n(child);
  }
  g1n(handler) {
    return this.v3s_1.g1n(handler);
  }
  h1n(onCancelling, invokeImmediately, handler) {
    return this.v3s_1.h1n(onCancelling, invokeImmediately, handler);
  }
  ep(context) {
    return this.v3s_1.ep(context);
  }
  e1m() {
    return this.v3s_1.e1m();
  }
  z1m() {
    return this.v3s_1.z1m();
  }
  a1n() {
    return this.v3s_1.a1n();
  }
  w1n() {
    return this.v3s_1.w1n();
  }
  ae(key) {
    return this.v3s_1.ae(key);
  }
  dp(initial, operation) {
    return this.v3s_1.dp(initial, operation);
  }
  cp(key) {
    return this.v3s_1.cp(key);
  }
  j3() {
    return this.v3s_1.j3();
  }
}
class Companion_145 {}
class $serializer_126 {
  constructor() {
    $serializer_instance_126 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DisturbanceOfTheNorthernGodsContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.x3s_1 = tmp0_serialDesc;
  }
  y3s(encoder, value) {
    var tmp0_desc = this.x3s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.a3t_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.b3t_1 === 4)) {
      tmp1_output.z14(tmp0_desc, 2, value.b3t_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.c3t_1 === 4)) {
      tmp1_output.z14(tmp0_desc, 3, value.c3t_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.d3t_1.equals(Companion_getInstance_220().w39_1)) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.d3t_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y3s(encoder, value instanceof DisturbanceOfTheNorthernGodsContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x3s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return DisturbanceOfTheNorthernGodsContract.e3t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.x3s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class DisturbanceOfTheNorthernGodsContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.f3t(rulesParameters);
  }
  static f3t(rulesParameters) {
    var $this = this.b3a();
    $this.a3t_1 = rulesParameters;
    $this.b3t_1 = 4;
    $this.c3t_1 = 4;
    $this.d3t_1 = Companion_getInstance_220().w39_1;
    return $this;
  }
  c3a() {
    return this.a3t_1;
  }
  static g3t(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().w39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.f3t(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(4, 1);
  }
  h3a() {
    return GameMapId_NorthernExpanse_getInstance();
  }
  i3a() {
    return this.b3t_1;
  }
  j3a() {
    return 1;
  }
  k3a() {
    return 3;
  }
  l3a() {
    return this.c3t_1;
  }
  m3a() {
    return DisturbanceOfTheNorthernGodsInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_isClassicTwoSheepOrBoarCompleted_0($context_GameState_t6qee5));
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) > 0);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0 = get_destroyedObjects($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp$ret$6;
        $l$block: {
          // Inline function 'steelart.beast.cast' call
          var tmp_0 = get_objectType($context_GameState_t6qee5, element);
          if (isInterface(tmp_0, SettlerType)) {
            tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
            break $l$block;
          }
          tmp$ret$6 = null;
        }
        var tmp0_safe_receiver = tmp$ret$6;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.d2(tmp0_safe_receiver);
        }
      }
      var tmp$ret$9;
      $l$block_1: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(destination, Collection)) {
          tmp_1 = destination.n1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$9 = false;
          break $l$block_1;
        }
        var _iterator__ex2g4s_0 = destination.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (equals(get_gameMap_0(this).h3t(get_initialPosition($context_GameState_t6qee5, element_0)), Zone_Jarlland_getInstance())) {
            tmp$ret$9 = true;
            break $l$block_1;
          }
        }
        tmp$ret$9 = false;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp$ret$9);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_0 = get_destroyedObjects($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_1 = tmp0_0.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        var tmp$ret$17;
        $l$block_2: {
          // Inline function 'steelart.beast.cast' call
          var tmp_2 = get_objectType($context_GameState_t6qee5, element_1);
          if (isInterface(tmp_2, SettlerType)) {
            tmp$ret$17 = element_1 instanceof ObjectOnBoard ? element_1 : THROW_CCE();
            break $l$block_2;
          }
          tmp$ret$17 = null;
        }
        var tmp0_safe_receiver_0 = tmp$ret$17;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_0.d2(tmp0_safe_receiver_0);
        }
      }
      var tmp$ret$20;
      $l$block_4: {
        // Inline function 'kotlin.collections.none' call
        var tmp_3;
        if (isInterface(destination_0, Collection)) {
          tmp_3 = destination_0.n1();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$20 = true;
          break $l$block_4;
        }
        var _iterator__ex2g4s_2 = destination_0.p1();
        while (_iterator__ex2g4s_2.q1()) {
          var element_2 = _iterator__ex2g4s_2.r1();
          if (_BoardPosition___get_y__impl__tale2e(get_initialPosition($context_GameState_t6qee5, element_2)) === -3) {
            tmp$ret$20 = false;
            break $l$block_4;
          }
        }
        tmp$ret$20 = true;
      }
      tmp = expectedOrFailedRewardStatus(tmp$ret$20);
    } else if (tmp0_subject.equals(to(3, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_1 = get_destroyedObjects($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_1 = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_3 = tmp0_1.p1();
      while (_iterator__ex2g4s_3.q1()) {
        var element_3 = _iterator__ex2g4s_3.r1();
        var tmp$ret$28;
        $l$block_5: {
          // Inline function 'steelart.beast.cast' call
          var tmp_4 = get_objectType($context_GameState_t6qee5, element_3);
          if (isInterface(tmp_4, SettlerType)) {
            tmp$ret$28 = element_3 instanceof ObjectOnBoard ? element_3 : THROW_CCE();
            break $l$block_5;
          }
          tmp$ret$28 = null;
        }
        var tmp0_safe_receiver_1 = tmp$ret$28;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_1.d2(tmp0_safe_receiver_1);
        }
      }
      var tmp$ret$31;
      $l$block_7: {
        // Inline function 'kotlin.collections.any' call
        var tmp_5;
        if (isInterface(destination_1, Collection)) {
          tmp_5 = destination_1.n1();
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          tmp$ret$31 = false;
          break $l$block_7;
        }
        var _iterator__ex2g4s_4 = destination_1.p1();
        while (_iterator__ex2g4s_4.q1()) {
          var element_4 = _iterator__ex2g4s_4.r1();
          if (equals(get_gameMap_0(this).h3t(get_initialPosition($context_GameState_t6qee5, element_4)), Zone_NewElda_getInstance())) {
            tmp$ret$31 = true;
            break $l$block_7;
          }
        }
        tmp$ret$31 = false;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp$ret$31);
    } else if (tmp0_subject.equals(to(3, new GameTeam(get_huntersGameTeam())))) {
      var tmp0_2 = get_destroyRecords($context_GameState_t6qee5);
      var tmp$ret$33;
      $l$block_9: {
        // Inline function 'kotlin.collections.none' call
        var tmp_6;
        if (isInterface(tmp0_2, Collection)) {
          tmp_6 = tmp0_2.n1();
        } else {
          tmp_6 = false;
        }
        if (tmp_6) {
          tmp$ret$33 = true;
          break $l$block_9;
        }
        var _iterator__ex2g4s_5 = tmp0_2.p1();
        while (_iterator__ex2g4s_5.q1()) {
          var element_5 = _iterator__ex2g4s_5.r1();
          var tmp_7 = get_objectType($context_GameState_t6qee5, element_5.o3a_1);
          if (isInterface(tmp_7, HunterCharacter)) {
            tmp$ret$33 = false;
            break $l$block_9;
          }
        }
        tmp$ret$33 = true;
      }
      tmp = expectedOrFailedRewardStatus(tmp$ret$33);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.d3t_1;
  }
  v3a(rulesParameters) {
    return DisturbanceOfTheNorthernGodsContract.f3t(rulesParameters);
  }
  toString() {
    return 'DisturbanceOfTheNorthernGodsContract(rulesParameters=' + this.a3t_1.toString() + ')';
  }
  hashCode() {
    return this.a3t_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DisturbanceOfTheNorthernGodsContract))
      return false;
    if (!this.a3t_1.equals(other.a3t_1))
      return false;
    return true;
  }
  static e3t(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_126().x3s_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.a3t_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.b3t_1 = 4;
    else
      $this.b3t_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.c3t_1 = 4;
    else
      $this.c3t_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.d3t_1 = Companion_getInstance_220().w39_1;
    else
      $this.d3t_1 = requiredVersion;
    return $this;
  }
}
class DisturbanceOfTheNorthernGodsInitialPhase {
  constructor() {
    DisturbanceOfTheNorthernGodsInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i3t_1 = lazy(tmp_0, DisturbanceOfTheNorthernGodsInitialPhase$_anonymous__oq6doh);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_98(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DisturbanceOfTheNorthernGodsInitialPhase';
  }
  hashCode() {
    return 683569627;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DisturbanceOfTheNorthernGodsInitialPhase))
      return false;
    return true;
  }
}
class DraftActionCard {}
class AvariceCard {
  constructor() {
    AvariceCard_instance = this;
    this.j3t_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k3t_1 = lazy(tmp_0, AvariceCard$_anonymous__p00r42);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_99(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AvariceCard';
  }
  hashCode() {
    return -1386343824;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AvariceCard))
      return false;
    return true;
  }
}
class DraftDarkActionCard {}
class DarkOfferingsCard {
  constructor() {
    DarkOfferingsCard_instance = this;
    this.l3t_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m3t_1 = lazy(tmp_0, DarkOfferingsCard$_anonymous__otbots);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_100(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DarkOfferingsCard';
  }
  hashCode() {
    return 479015394;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DarkOfferingsCard))
      return false;
    return true;
  }
}
class Companion_146 {
  a2g() {
    var tmp = getKClass(DraftActionCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AdaptCard), getKClass(AnimateCard), getKClass(AvariceCard), getKClass(BolsterCard), getKClass(ChargeCard), getKClass(DashCard), getKClass(DisplaceCard), getKClass(DarkDealingsCard), getKClass(DarkOfferingsCard), getKClass(DarkRitualsCard), getKClass(EnsnareCard), getKClass(GlimpseCard), getKClass(HasteCard), getKClass(HiddenPassageCard), getKClass(InciteCard), getKClass(ProwlCard), getKClass(PursuitCard), getKClass(RushCard), getKClass(StrideCard), getKClass(UnearthCard), getKClass(UnknownDraftActionCard)];
    var tmp_1 = AdaptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('AdaptCard', tmp_1, tmp$ret$3);
    var tmp_3 = AnimateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('AnimateCard', tmp_3, tmp$ret$6);
    var tmp_5 = AvariceCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('AvariceCard', tmp_5, tmp$ret$9);
    var tmp_7 = BolsterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('BolsterCard', tmp_7, tmp$ret$12);
    var tmp_9 = ChargeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('ChargeCard', tmp_9, tmp$ret$15);
    var tmp_11 = DashCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('DashCard', tmp_11, tmp$ret$18);
    var tmp_13 = DisplaceCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('DisplaceCard', tmp_13, tmp$ret$21);
    var tmp_15 = DarkDealingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('DarkDealingsCard', tmp_15, tmp$ret$24);
    var tmp_17 = DarkOfferingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('DarkOfferingsCard', tmp_17, tmp$ret$27);
    var tmp_19 = DarkRitualsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('DarkRitualsCard', tmp_19, tmp$ret$30);
    var tmp_21 = EnsnareCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('EnsnareCard', tmp_21, tmp$ret$33);
    var tmp_23 = GlimpseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('GlimpseCard', tmp_23, tmp$ret$36);
    var tmp_25 = HasteCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('HasteCard', tmp_25, tmp$ret$39);
    var tmp_27 = HiddenPassageCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('HiddenPassageCard', tmp_27, tmp$ret$42);
    var tmp_29 = InciteCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('InciteCard', tmp_29, tmp$ret$45);
    var tmp_31 = ProwlCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('ProwlCard', tmp_31, tmp$ret$48);
    var tmp_33 = PursuitCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('PursuitCard', tmp_33, tmp$ret$51);
    var tmp_35 = RushCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_36 = ObjectSerializer.l1c('RushCard', tmp_35, tmp$ret$54);
    var tmp_37 = StrideCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_38 = ObjectSerializer.l1c('StrideCard', tmp_37, tmp$ret$57);
    var tmp_39 = UnearthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_40 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, ObjectSerializer.l1c('UnearthCard', tmp_39, tmp$ret$60), $serializer_getInstance_127()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    return SealedClassSerializer.i10('steelart.beast.DraftActionCard', tmp, tmp_0, tmp_40, tmp$ret$66);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class RushCard {
  constructor() {
    RushCard_instance = this;
    this.n3t_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o3t_1 = lazy(tmp_0, RushCard$_anonymous__3q57tb);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_101(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RushCard';
  }
  hashCode() {
    return 453863629;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RushCard))
      return false;
    return true;
  }
}
class DashCard {
  constructor() {
    DashCard_instance = this;
    this.p3t_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q3t_1 = lazy(tmp_0, DashCard$_anonymous__f3h2p7);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_102(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DashCard';
  }
  hashCode() {
    return 1254118279;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DashCard))
      return false;
    return true;
  }
}
class AnimateCard {
  constructor() {
    AnimateCard_instance = this;
    this.r3t_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s3t_1 = lazy(tmp_0, AnimateCard$_anonymous__48tzba);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_103(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AnimateCard';
  }
  hashCode() {
    return 463514028;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AnimateCard))
      return false;
    return true;
  }
}
class EnsnareCard {
  constructor() {
    EnsnareCard_instance = this;
    this.t3t_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u3t_1 = lazy(tmp_0, EnsnareCard$_anonymous__2sgudz);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_104(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EnsnareCard';
  }
  hashCode() {
    return -1638447525;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EnsnareCard))
      return false;
    return true;
  }
}
class BolsterCard {
  constructor() {
    BolsterCard_instance = this;
    this.v3t_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w3t_1 = lazy(tmp_0, BolsterCard$_anonymous__ceqsrq);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_105(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BolsterCard';
  }
  hashCode() {
    return -1525150248;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BolsterCard))
      return false;
    return true;
  }
}
class PursuitCard {
  constructor() {
    PursuitCard_instance = this;
    this.x3t_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y3t_1 = lazy(tmp_0, PursuitCard$_anonymous__d5r1rn);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_106(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PursuitCard';
  }
  hashCode() {
    return 952295909;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PursuitCard))
      return false;
    return true;
  }
}
class AdaptCard {
  constructor() {
    AdaptCard_instance = this;
    this.z3t_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a3u_1 = lazy(tmp_0, AdaptCard$_anonymous__b69br9);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_107(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AdaptCard';
  }
  hashCode() {
    return -532967379;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AdaptCard))
      return false;
    return true;
  }
}
class HiddenPassageCard {
  constructor() {
    HiddenPassageCard_instance = this;
    this.b3u_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c3u_1 = lazy(tmp_0, HiddenPassageCard$_anonymous__nrnyhp);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_108(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HiddenPassageCard';
  }
  hashCode() {
    return 1733280591;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HiddenPassageCard))
      return false;
    return true;
  }
}
class HasteCard {
  constructor() {
    HasteCard_instance = this;
    this.d3u_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e3u_1 = lazy(tmp_0, HasteCard$_anonymous__jsejs4);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_109(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HasteCard';
  }
  hashCode() {
    return 1957117718;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HasteCard))
      return false;
    return true;
  }
}
class DarkDealingsCard {
  constructor() {
    DarkDealingsCard_instance = this;
    this.f3u_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g3u_1 = lazy(tmp_0, DarkDealingsCard$_anonymous__pfyuhg);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_110(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DarkDealingsCard';
  }
  hashCode() {
    return -1517875384;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DarkDealingsCard))
      return false;
    return true;
  }
}
class ProwlCard {
  constructor() {
    ProwlCard_instance = this;
    this.h3u_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i3u_1 = lazy(tmp_0, ProwlCard$_anonymous__oue1jv);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_111(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ProwlCard';
  }
  hashCode() {
    return 782693197;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProwlCard))
      return false;
    return true;
  }
}
class DarkRitualsCard {
  constructor() {
    DarkRitualsCard_instance = this;
    this.j3u_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k3u_1 = lazy(tmp_0, DarkRitualsCard$_anonymous__t2mir7);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_112(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DarkRitualsCard';
  }
  hashCode() {
    return 1128796197;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DarkRitualsCard))
      return false;
    return true;
  }
}
class InciteCard {
  constructor() {
    InciteCard_instance = this;
    this.l3u_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m3u_1 = lazy(tmp_0, InciteCard$_anonymous__k6uzx1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_113(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'InciteCard';
  }
  hashCode() {
    return -210350671;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InciteCard))
      return false;
    return true;
  }
}
class UnearthCard {
  constructor() {
    UnearthCard_instance = this;
    this.n3u_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o3u_1 = lazy(tmp_0, UnearthCard$_anonymous__k87l2i);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_114(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UnearthCard';
  }
  hashCode() {
    return 290652188;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnearthCard))
      return false;
    return true;
  }
}
class ChargeCard {
  constructor() {
    ChargeCard_instance = this;
    this.p3u_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q3u_1 = lazy(tmp_0, ChargeCard$_anonymous__jivcb1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_115(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ChargeCard';
  }
  hashCode() {
    return -1236678551;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChargeCard))
      return false;
    return true;
  }
}
class DisplaceCard {
  constructor() {
    DisplaceCard_instance = this;
    this.r3u_1 = Split_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s3u_1 = lazy(tmp_0, DisplaceCard$_anonymous__yhz3pu);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_116(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DisplaceCard';
  }
  hashCode() {
    return 1455147822;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DisplaceCard))
      return false;
    return true;
  }
}
class GlimpseCard {
  constructor() {
    GlimpseCard_instance = this;
    this.t3u_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u3u_1 = lazy(tmp_0, GlimpseCard$_anonymous__6bfq8e);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_117(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'GlimpseCard';
  }
  hashCode() {
    return -936208348;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlimpseCard))
      return false;
    return true;
  }
}
class StrideCard {
  constructor() {
    StrideCard_instance = this;
    this.v3u_1 = Split_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w3u_1 = lazy(tmp_0, StrideCard$_anonymous__8l2ipe);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_118(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'StrideCard';
  }
  hashCode() {
    return -221025778;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StrideCard))
      return false;
    return true;
  }
}
class Companion_147 {}
class $serializer_127 {
  constructor() {
    $serializer_instance_127 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UnknownDraftActionCard', this, 1);
    tmp0_serialDesc.h1b('unknownId', false);
    this.x3u_1 = tmp0_serialDesc;
  }
  y3u(encoder, value) {
    var tmp0_desc = this.x3u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.z3u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y3u(encoder, value instanceof UnknownDraftActionCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x3u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UnknownDraftActionCard.a3v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x3u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class UnknownDraftActionCard {
  constructor(unknownId) {
    this.z3u_1 = unknownId;
  }
  toString() {
    return 'UnknownDraftActionCard(unknownId=' + this.z3u_1 + ')';
  }
  hashCode() {
    return this.z3u_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnknownDraftActionCard))
      return false;
    if (!(this.z3u_1 === other.z3u_1))
      return false;
    return true;
  }
  static a3v(seen0, unknownId, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_127().x3u_1);
    }
    var $this = createThis(this);
    $this.z3u_1 = unknownId;
    return $this;
  }
}
class Companion_148 {
  a2g() {
    var tmp = getKClass(DraftDarkActionCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(DarkDealingsCard), getKClass(DarkOfferingsCard), getKClass(DarkRitualsCard)];
    var tmp_1 = DarkDealingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('DarkDealingsCard', tmp_1, tmp$ret$3);
    var tmp_3 = DarkOfferingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('DarkOfferingsCard', tmp_3, tmp$ret$6);
    var tmp_5 = DarkRitualsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_6 = [tmp_2, tmp_4, ObjectSerializer.l1c('DarkRitualsCard', tmp_5, tmp$ret$9)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    return SealedClassSerializer.i10('steelart.beast.DraftDarkActionCard', tmp, tmp_0, tmp_6, tmp$ret$15);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Draug {
  constructor() {
    Draug_instance = this;
    this.b3v_1 = setOf_0([BloodlessFuryUpgrade_getInstance(), PalebloodAxesUpgrade_getInstance(), SharedMadnessUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c3v_1 = lazy(tmp_0, Draug$_anonymous__2ecgfm);
  }
  s36() {
    return plus_0(get_abilityCards.call(this), BerserkCard_getInstance());
  }
  t35() {
    return this.b3v_1;
  }
  n2z($context_GameState_t6qee5) {
    return 2;
  }
  v36($context_GameState_t6qee5, position) {
    return plus_2(getInitList_0.call(this, $context_GameState_t6qee5, position), listOf_0([init_0(get_draugCorruptionLevelKey(), 0), init(get_draugWillRespawnKey(), new BooleanWrapper(false))]));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_119(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Draug';
  }
  hashCode() {
    return 1654016960;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Draug))
      return false;
    return true;
  }
}
class BloodlessFuryUpgrade {
  constructor() {
    BloodlessFuryUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d3v_1 = lazy(tmp_0, BloodlessFuryUpgrade$_anonymous__17ds78);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_120(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BloodlessFuryUpgrade';
  }
  hashCode() {
    return 1313166232;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BloodlessFuryUpgrade))
      return false;
    return true;
  }
}
class PalebloodAxesUpgrade {
  constructor() {
    PalebloodAxesUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e3v_1 = lazy(tmp_0, PalebloodAxesUpgrade$_anonymous__nd0pf4);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_121(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PalebloodAxesUpgrade';
  }
  hashCode() {
    return -1909848500;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PalebloodAxesUpgrade))
      return false;
    return true;
  }
}
class SharedMadnessUpgrade {
  constructor() {
    SharedMadnessUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f3v_1 = lazy(tmp_0, SharedMadnessUpgrade$_anonymous__9c9tp9);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_122(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SharedMadnessUpgrade';
  }
  hashCode() {
    return 2093810303;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SharedMadnessUpgrade))
      return false;
    return true;
  }
}
class DraugCardWoundEffectSource {
  constructor() {
    DraugCardWoundEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g3v_1 = lazy(tmp_0, DraugCardWoundEffectSource$_anonymous__qvizwz);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_123(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DraugCardWoundEffectSource';
  }
  hashCode() {
    return 750089903;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraugCardWoundEffectSource))
      return false;
    return true;
  }
}
class BerserkCard {
  constructor() {
    BerserkCard_instance = this;
    this.h3v_1 = Red_getInstance();
    this.i3v_1 = Draug_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j3v_1 = lazy(tmp_0, BerserkCard$_anonymous__47628d);
  }
  t37() {
    return this.i3v_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_124(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BerserkCard';
  }
  hashCode() {
    return -1876746395;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BerserkCard))
      return false;
    return true;
  }
}
class Companion_149 {
  constructor() {
    Companion_instance_149 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k3v_1 = [lazy(tmp_0, DraugBerserkReactionStatement$Companion$$childSerializers$_anonymous__ebqcgp)];
  }
}
class $serializer_128 {
  constructor() {
    $serializer_instance_128 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DraugBerserkReactionStatement', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.l3v_1 = tmp0_serialDesc;
  }
  m3v(encoder, value) {
    var tmp0_desc = this.l3v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_150().k3v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n3v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m3v(encoder, value instanceof DraugBerserkReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l3v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_150().k3v_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DraugBerserkReactionStatement.o3v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l3v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_150().k3v_1[0].k3()];
  }
}
class DraugBerserkReactionStatement {
  constructor(characterObject) {
    Companion_getInstance_150();
    this.n3v_1 = characterObject;
  }
  d2t() {
    return BerserkCard_getInstance();
  }
  toString() {
    return 'DraugBerserkReactionStatement(characterObject=' + this.n3v_1.toString() + ')';
  }
  hashCode() {
    return this.n3v_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraugBerserkReactionStatement))
      return false;
    if (!this.n3v_1.equals(other.n3v_1))
      return false;
    return true;
  }
  static o3v(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_150();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_128().l3v_1);
    }
    var $this = createThis(this);
    $this.n3v_1 = characterObject;
    return $this;
  }
}
class Companion_150 {
  constructor() {
    Companion_instance_150 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p3v_1 = [lazy(tmp_0, GainDraugCorruptionStatement$Companion$$childSerializers$_anonymous__2eib38), null];
  }
}
class $serializer_129 {
  constructor() {
    $serializer_instance_129 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainDraugCorruptionStatement', this, 2);
    tmp0_serialDesc.h1b('hunter', false);
    tmp0_serialDesc.h1b('corruptionChange', true);
    this.q3v_1 = tmp0_serialDesc;
  }
  r3v(encoder, value) {
    var tmp0_desc = this.q3v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_151().p3v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s3v_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.t3v_1 === 1)) {
      tmp1_output.z14(tmp0_desc, 1, value.t3v_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r3v(encoder, value instanceof GainDraugCorruptionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q3v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_151().p3v_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GainDraugCorruptionStatement.u3v(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.q3v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_151().p3v_1[0].k3(), IntSerializer_getInstance()];
  }
}
class GainDraugCorruptionStatement {
  constructor(hunter, corruptionChange) {
    Companion_getInstance_151();
    corruptionChange = corruptionChange === VOID ? 1 : corruptionChange;
    this.s3v_1 = hunter;
    this.t3v_1 = corruptionChange;
  }
  toString() {
    return 'GainDraugCorruptionStatement(hunter=' + this.s3v_1.toString() + ', corruptionChange=' + this.t3v_1 + ')';
  }
  hashCode() {
    var result = this.s3v_1.hashCode();
    result = imul(result, 31) + this.t3v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainDraugCorruptionStatement))
      return false;
    if (!this.s3v_1.equals(other.s3v_1))
      return false;
    if (!(this.t3v_1 === other.t3v_1))
      return false;
    return true;
  }
  static u3v(seen0, hunter, corruptionChange, serializationConstructorMarker) {
    Companion_getInstance_151();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_129().q3v_1);
    }
    var $this = createThis(this);
    $this.s3v_1 = hunter;
    if (0 === (seen0 & 2))
      $this.t3v_1 = 1;
    else
      $this.t3v_1 = corruptionChange;
    return $this;
  }
}
class DraugRespawnEvent {
  constructor() {
    DraugRespawnEvent_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v3v_1 = lazy(tmp_0, DraugRespawnEvent$_anonymous__920qio);
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf_0([new ResurrectObjectChange(get_draugHunter($context_GameStateRuntime_604ce3)), new HpChange(get_draugHunter($context_GameStateRuntime_604ce3), get_wounds($context_GameStateRuntime_604ce3, get_draugHunter($context_GameStateRuntime_604ce3))), new DraugRespawnStateChangeEvent(false)]);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_125(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DraugRespawnEvent';
  }
  hashCode() {
    return -102584782;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraugRespawnEvent))
      return false;
    return true;
  }
}
class Companion_151 {}
class $serializer_130 {
  constructor() {
    $serializer_instance_130 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainDraugCorruptionEvent', this, 1);
    tmp0_serialDesc.h1b('corruptionGain', false);
    this.w3v_1 = tmp0_serialDesc;
  }
  x3v(encoder, value) {
    var tmp0_desc = this.w3v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.y3v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x3v(encoder, value instanceof GainDraugCorruptionEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w3v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GainDraugCorruptionEvent.z3v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w3v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class GainDraugCorruptionEvent {
  constructor(corruptionGain) {
    this.y3v_1 = corruptionGain;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.require' call
    if (!(this.y3v_1 >= 0)) {
      var message = 'Draug corruption gain cannot be negative';
      throw IllegalArgumentException.h2(toString(message));
    }
    return listOf(new DraugCorruptionChangeEvent(this.y3v_1));
  }
  toString() {
    return 'GainDraugCorruptionEvent(corruptionGain=' + this.y3v_1 + ')';
  }
  hashCode() {
    return this.y3v_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainDraugCorruptionEvent))
      return false;
    if (!(this.y3v_1 === other.y3v_1))
      return false;
    return true;
  }
  static z3v(seen0, corruptionGain, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_130().w3v_1);
    }
    var $this = createThis(this);
    $this.y3v_1 = corruptionGain;
    return $this;
  }
}
class Companion_152 {}
class $serializer_131 {
  constructor() {
    $serializer_instance_131 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DraugCorruptionChangeEvent', this, 1);
    tmp0_serialDesc.h1b('corruptionChange', false);
    this.a3w_1 = tmp0_serialDesc;
  }
  b3w(encoder, value) {
    var tmp0_desc = this.a3w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.c3w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b3w(encoder, value instanceof DraugCorruptionChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a3w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DraugCorruptionChangeEvent.d3w(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a3w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class DraugCorruptionChangeEvent {
  constructor(corruptionChange) {
    this.c3w_1 = corruptionChange;
  }
  m37(_this__u8e3s4) {
    var _receiver__tnumb7 = get_draugHunter(_this__u8e3s4);
    set_draugCorruptionLevelImpl(_this__u8e3s4, _receiver__tnumb7, get_draugCorruptionLevelImpl(_this__u8e3s4, _receiver__tnumb7) + this.c3w_1 | 0);
  }
  n37($context_GameState_t6qee5) {
    return new DraugCorruptionChangeEvent(-this.c3w_1 | 0);
  }
  toString() {
    return 'DraugCorruptionChangeEvent(corruptionChange=' + this.c3w_1 + ')';
  }
  hashCode() {
    return this.c3w_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraugCorruptionChangeEvent))
      return false;
    if (!(this.c3w_1 === other.c3w_1))
      return false;
    return true;
  }
  static d3w(seen0, corruptionChange, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_131().a3w_1);
    }
    var $this = createThis(this);
    $this.c3w_1 = corruptionChange;
    return $this;
  }
}
class Companion_153 {}
class $serializer_132 {
  constructor() {
    $serializer_instance_132 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DraugRespawnStateChangeEvent', this, 1);
    tmp0_serialDesc.h1b('willRespawn', false);
    this.e3w_1 = tmp0_serialDesc;
  }
  f3w(encoder, value) {
    var tmp0_desc = this.e3w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.w14(tmp0_desc, 0, value.g3w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f3w(encoder, value instanceof DraugRespawnStateChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e3w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DraugRespawnStateChangeEvent.h3w(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e3w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance()];
  }
}
class DraugRespawnStateChangeEvent {
  constructor(willRespawn) {
    this.g3w_1 = willRespawn;
  }
  m37(_this__u8e3s4) {
    set_draugWillRespawnImpl(_this__u8e3s4, get_draugHunter(_this__u8e3s4), this.g3w_1);
  }
  n37($context_GameState_t6qee5) {
    return new DraugRespawnStateChangeEvent(get_draugWillRespawn($context_GameState_t6qee5, get_draugHunter($context_GameState_t6qee5)));
  }
  toString() {
    return 'DraugRespawnStateChangeEvent(willRespawn=' + this.g3w_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.g3w_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraugRespawnStateChangeEvent))
      return false;
    if (!(this.g3w_1 === other.g3w_1))
      return false;
    return true;
  }
  static h3w(seen0, willRespawn, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_132().e3w_1);
    }
    var $this = createThis(this);
    $this.g3w_1 = willRespawn;
    return $this;
  }
}
class PrepareDraugRespawnEvent {
  constructor() {
    PrepareDraugRespawnEvent_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i3w_1 = lazy(tmp_0, PrepareDraugRespawnEvent$_anonymous__ov7g3d);
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf_0([new GrudgesChange(get_draugHunter($context_GameStateRuntime_604ce3), -1), new DraugCorruptionChangeEvent(1), new DraugRespawnStateChangeEvent(true)]);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_126(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PrepareDraugRespawnEvent';
  }
  hashCode() {
    return 504624085;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PrepareDraugRespawnEvent))
      return false;
    return true;
  }
}
class Companion_154 {
  a2g() {
    var tmp = getKClass(EffectSource);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AvariceCard), getKClass(AbruptAssembleUpgrade), getKClass(AbyssalBeastUpgrade), getKClass(AbyssalHellFireUpgrade), getKClass(AncientCallingUpgrade), getKClass(BlightUpgrade), getKClass(BroodswellUpgrade), getKClass(BlackStarUpgrade), getKClass(DefenderUpgrade), getKClass(MesmeriseUpgrade), getKClass(RebirthByFireUpgrade), getKClass(SoulCollectorUpgrade), getKClass(ChiefsCommandUpgrade), getKClass(DischargeUpgrade), getKClass(ExploreUpgrade), getKClass(HeroicSpeechUpgrade), getKClass(HuntingGroundsUpgrade), getKClass(InfusionUpgrade), getKClass(NightbindUpgrade), getKClass(PactReversalUpgrade), getKClass(ResonanceUpgrade), getKClass(ResourcefulnessUpgrade), getKClass(ResurrectionUpgrade), getKClass(RevengeOfTheSheepUpgrade), getKClass(RopePullUpgrade), getKClass(SinisterActUpgrade), getKClass(SongOfTemptationUpgrade), getKClass(SuddenShockUpgrade), getKClass(TacticalManouverUpgrade), getKClass(VanishUpgrade), getKClass(VoidCallUpgrade), getKClass(WildOdeUpgrade), getKClass(AbundanceUpgrade), getKClass(AccursedWrathUpgrade), getKClass(AmassUpgrade), getKClass(AncientBondUpgrade), getKClass(AngerUpgrade), getKClass(AwarenessUpgrade), getKClass(BallistaUpgrade), getKClass(BeastTongueUpgrade), getKClass(BehornedUpgrade), getKClass(BeyondTheVeilUpgrade), getKClass(BloodCraftUpgrade), getKClass(BloodLustUpgrade), getKClass(BloodlessFuryUpgrade), getKClass(BurnUpgrade), getKClass(CascadeUpgrade), getKClass(ClairvoyantUpgrade), getKClass(CloudShiftUpgrade), getKClass(CrepuscularUpgrade), getKClass(CullingUpgrade), getKClass(CursedLandUpgrade), getKClass(DarkFlameUpgrade), getKClass(DarkSpawnUpgrade), getKClass(DeathsLamentUpgrade), getKClass(DevourerUpgrade), getKClass(DissectionUpgrade), getKClass(DistractionUpgrade), getKClass(DoomCallUpgrade), getKClass(DoubleUpgrade), getKClass(DraconicBondsUpgrade), getKClass(DrownerUpgrade), getKClass(EchoUpgrade), getKClass(EcholocationUpgrade), getKClass(EndlessDreamUpgrade), getKClass(EndlessStruggleUpgrade), getKClass(EnragedUpgrade), getKClass(EntrancingUpgrade), getKClass(EruptionUpgrade), getKClass(EternityUpgrade), getKClass(ExceptionalTrackerUpgrade), getKClass(ExpandTheMarshUpgrade), getKClass(ExtractUpgrade), getKClass(FatalGazeUpgrade), getKClass(FearTheNightUpgrade), getKClass(FleshboundUpgrade), getKClass(FlingUpgrade), getKClass(GoldenBeakUpgrade), getKClass(GreatHowlUpgrade), getKClass(HordesMarchUpgrade), getKClass(HornOfValhUpgrade), getKClass(HuntersBaneUpgrade), getKClass(HuntmasterUpgrade), getKClass(IgniteUpgrade), getKClass(InfernalTusksUpgrade), getKClass(InfestUrgullUpgrade), getKClass(InfestationUpgrade), getKClass(JointEffortUpgrade), getKClass(KillingsSpreeUpgrade), getKClass(KinsPursuitUpgrade), getKClass(LairUpgrade), getKClass(LeviathanUpgrade), getKClass(LivingBlockadeUpgrade), getKClass(LurkingDeadUpgrade), getKClass(MartyrUpgrade), getKClass(MassProductionUpgrade), getKClass(MendrsFuryUpgrade), getKClass(MirrorBeastUpgrade), getKClass(NaturalInstinctUpgrade), getKClass(OverlordUpgrade), getKClass(PalebloodAxesUpgrade), getKClass(PandemoniumUpgrade), getKClass(PortableWorkshopUpgrade), getKClass(PredictUpgrade), getKClass(PrimalInstinctsUpgrade), getKClass(ProminenceUpgrade), getKClass(RampageousUpgrade), getKClass(ReachUpgrade), getKClass(RefugeUpgrade), getKClass(RegalUpgrade), getKClass(ReuniteUpgrade), getKClass(ReveranceUpgrade), getKClass(RuptureSeedsUpgrade), getKClass(ScavengerUpgrade), getKClass(SeekerUpgrade), getKClass(SharedMadnessUpgrade), getKClass(SkyMasterUpgrade), getKClass(SoothsayerUpgrade), getKClass(SoulHarvestUpgrade), getKClass(SoulHarvestVackerUpgrade), getKClass(SpiritboundUpgrade), getKClass(StarFallUpgrade), getKClass(StormBringerUpgrade), getKClass(SwapUpgrade), getKClass(SwiftKillUpgrade), getKClass(TacticalInsightUpgrade), getKClass(ThickMistUpgrade), getKClass(TormentingVisionsUpgrade), getKClass(TorrentialUpgrade), getKClass(TownswatchUpgrade), getKClass(TrapLauncherUpgrade), getKClass(TrueInstinctEsmeriaBeastUpgrade), getKClass(TrueInstinctEsmeriaHuntressUpgrade), getKClass(UnendingHungerUpgrade), getKClass(VoidPresenceUpgrade), getKClass(VoidStepUpgrade), getKClass(WatchtowerPassageUpgrade), getKClass(WildbondUpgrade), getKClass(WitheringMawUpgrade), getKClass(WorshipUpgrade), getKClass(WrathOfEirtirUpgrade), getKClass(DarkOfferingsCard), getKClass(EventItselfSource), getKClass(FeedCard), getKClass(AllureKillEffectSource), getKClass(ArrivalOfTheTitanSettlementClaimingSource), getKClass(ArrivalOfTheTitanSettlerMoveEffectSource), getKClass(BramBarrierCleanupEffectSource), getKClass(BurstEffectSource), getKClass(ClaimRuinEffectSource), getKClass(DraugCardWoundEffectSource), getKClass(FylgjaFlightEffectSource), getKClass(LydanInitialHarvestEffectSource), getKClass(PossibleBindingHuntEffectSource), getKClass(PossibleBleatEffectSource), getKClass(PossibleMistShroudEffectSource), getKClass(PossibleSnareEffectSource), getKClass(PossibleTrapEffectSource), getKClass(PossibleDreamerMaskEffectSource), getKClass(PossibleEsmeriasStrandEffectSource), getKClass(PossibleFlareEffectSource), getKClass(PossibleIntuitionEffectSource), getKClass(PossibleSmokeBombEffectSource), getKClass(PossibleSuddenMistEffectSource), getKClass(PossibleWorldShiftEffectSource), getKClass(RhagnerGainHoardEffectSource), getKClass(RhagnerReduceHoardEffectSource), getKClass(ShipwreckRedDraftActionCardEffectSource), getKClass(SigridCreatureDeathEffectSource), getKClass(SigridCreatureLungeEffectSource), getKClass(SigridSummonCreatureEffectSource), getKClass(SoulsChangeSource), getKClass(SummonFylgjaEffectSource), getKClass(UrgullHatchDamageSource), getKClass(UrgullMoltRewardEffectSource), getKClass(ValdiBloodKillSource), getKClass(ShriekerTrapCard)];
    var tmp_1 = AvariceCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('AvariceCard', tmp_1, tmp$ret$3);
    var tmp_3 = AbruptAssembleUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('AbruptAssembleUpgrade', tmp_3, tmp$ret$6);
    var tmp_5 = AbyssalBeastUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('AbyssalBeastUpgrade', tmp_5, tmp$ret$9);
    var tmp_7 = AbyssalHellFireUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('AbyssalHellFireUpgrade', tmp_7, tmp$ret$12);
    var tmp_9 = AncientCallingUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('AncientCallingUpgrade', tmp_9, tmp$ret$15);
    var tmp_11 = BlightUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('BlightUpgrade', tmp_11, tmp$ret$18);
    var tmp_13 = BroodswellUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('BroodswellUpgrade', tmp_13, tmp$ret$21);
    var tmp_15 = BlackStarUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('BlackStarUpgrade', tmp_15, tmp$ret$24);
    var tmp_17 = DefenderUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('DefenderUpgrade', tmp_17, tmp$ret$27);
    var tmp_19 = MesmeriseUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('MesmeriseUpgrade', tmp_19, tmp$ret$30);
    var tmp_21 = RebirthByFireUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('RebirthByFireUpgrade', tmp_21, tmp$ret$33);
    var tmp_23 = SoulCollectorUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('SoulCollectorUpgrade', tmp_23, tmp$ret$36);
    var tmp_25 = ChiefsCommandUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('ChiefsCommandUpgrade', tmp_25, tmp$ret$39);
    var tmp_27 = DischargeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('DischargeUpgrade', tmp_27, tmp$ret$42);
    var tmp_29 = ExploreUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('ExploreUpgrade', tmp_29, tmp$ret$45);
    var tmp_31 = HeroicSpeechUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('HeroicSpeechUpgrade', tmp_31, tmp$ret$48);
    var tmp_33 = HuntingGroundsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('HuntingGroundsUpgrade', tmp_33, tmp$ret$51);
    var tmp_35 = InfusionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_36 = ObjectSerializer.l1c('InfusionUpgrade', tmp_35, tmp$ret$54);
    var tmp_37 = NightbindUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_38 = ObjectSerializer.l1c('NightbindUpgrade', tmp_37, tmp$ret$57);
    var tmp_39 = PactReversalUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_40 = ObjectSerializer.l1c('PactReversalUpgrade', tmp_39, tmp$ret$60);
    var tmp_41 = ResonanceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_42 = ObjectSerializer.l1c('ResonanceUpgrade', tmp_41, tmp$ret$63);
    var tmp_43 = ResourcefulnessUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_44 = ObjectSerializer.l1c('ResourcefulnessUpgrade', tmp_43, tmp$ret$66);
    var tmp_45 = ResurrectionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_46 = ObjectSerializer.l1c('ResurrectionUpgrade', tmp_45, tmp$ret$69);
    var tmp_47 = RevengeOfTheSheepUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_48 = ObjectSerializer.l1c('RevengeOfTheSheepUpgrade', tmp_47, tmp$ret$72);
    var tmp_49 = RopePullUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_50 = ObjectSerializer.l1c('RopePullUpgrade', tmp_49, tmp$ret$75);
    var tmp_51 = SinisterActUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_52 = ObjectSerializer.l1c('SinisterActUpgrade', tmp_51, tmp$ret$78);
    var tmp_53 = SongOfTemptationUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_54 = ObjectSerializer.l1c('SongOfTemptationUpgrade', tmp_53, tmp$ret$81);
    var tmp_55 = SuddenShockUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_56 = ObjectSerializer.l1c('SuddenShockUpgrade', tmp_55, tmp$ret$84);
    var tmp_57 = TacticalManouverUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_58 = ObjectSerializer.l1c('TacticalManouverUpgrade', tmp_57, tmp$ret$87);
    var tmp_59 = VanishUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_60 = ObjectSerializer.l1c('VanishUpgrade', tmp_59, tmp$ret$90);
    var tmp_61 = VoidCallUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_62 = ObjectSerializer.l1c('VoidCallUpgrade', tmp_61, tmp$ret$93);
    var tmp_63 = WildOdeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_64 = ObjectSerializer.l1c('WildOdeUpgrade', tmp_63, tmp$ret$96);
    var tmp_65 = AbundanceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_66 = ObjectSerializer.l1c('AbundanceUpgrade', tmp_65, tmp$ret$99);
    var tmp_67 = AccursedWrathUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_68 = ObjectSerializer.l1c('AccursedWrathUpgrade', tmp_67, tmp$ret$102);
    var tmp_69 = AmassUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_70 = ObjectSerializer.l1c('AmassUpgrade', tmp_69, tmp$ret$105);
    var tmp_71 = AncientBondUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_72 = ObjectSerializer.l1c('AncientBondUpgrade', tmp_71, tmp$ret$108);
    var tmp_73 = AngerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_74 = ObjectSerializer.l1c('AngerUpgrade', tmp_73, tmp$ret$111);
    var tmp_75 = AwarenessUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_76 = ObjectSerializer.l1c('AwarenessUpgrade', tmp_75, tmp$ret$114);
    var tmp_77 = BallistaUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_78 = ObjectSerializer.l1c('BallistaUpgrade', tmp_77, tmp$ret$117);
    var tmp_79 = BeastTongueUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_80 = ObjectSerializer.l1c('BeastTongueUpgrade', tmp_79, tmp$ret$120);
    var tmp_81 = BehornedUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_82 = ObjectSerializer.l1c('BehornedUpgrade', tmp_81, tmp$ret$123);
    var tmp_83 = BeyondTheVeilUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_84 = ObjectSerializer.l1c('BeyondTheVeilUpgrade', tmp_83, tmp$ret$126);
    var tmp_85 = BloodCraftUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_86 = ObjectSerializer.l1c('BloodCraftUpgrade', tmp_85, tmp$ret$129);
    var tmp_87 = BloodLustUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_88 = ObjectSerializer.l1c('BloodLustUpgrade', tmp_87, tmp$ret$132);
    var tmp_89 = BloodlessFuryUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_90 = ObjectSerializer.l1c('BloodlessFuryUpgrade', tmp_89, tmp$ret$135);
    var tmp_91 = BurnUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    var tmp_92 = ObjectSerializer.l1c('BurnUpgrade', tmp_91, tmp$ret$138);
    var tmp_93 = CascadeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$141 = [];
    var tmp_94 = ObjectSerializer.l1c('CascadeUpgrade', tmp_93, tmp$ret$141);
    var tmp_95 = ClairvoyantUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    var tmp_96 = ObjectSerializer.l1c('ClairvoyantUpgrade', tmp_95, tmp$ret$144);
    var tmp_97 = CloudShiftUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$147 = [];
    var tmp_98 = ObjectSerializer.l1c('CloudShiftUpgrade', tmp_97, tmp$ret$147);
    var tmp_99 = CrepuscularUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$150 = [];
    var tmp_100 = ObjectSerializer.l1c('CrepuscularUpgrade', tmp_99, tmp$ret$150);
    var tmp_101 = CullingUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$153 = [];
    var tmp_102 = ObjectSerializer.l1c('CullingUpgrade', tmp_101, tmp$ret$153);
    var tmp_103 = CursedLandUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$156 = [];
    var tmp_104 = ObjectSerializer.l1c('CursedLandUpgrade', tmp_103, tmp$ret$156);
    var tmp_105 = DarkFlameUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$159 = [];
    var tmp_106 = ObjectSerializer.l1c('DarkFlameUpgrade', tmp_105, tmp$ret$159);
    var tmp_107 = DarkSpawnUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$162 = [];
    var tmp_108 = ObjectSerializer.l1c('DarkSpawnUpgrade', tmp_107, tmp$ret$162);
    var tmp_109 = DeathsLamentUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$165 = [];
    var tmp_110 = ObjectSerializer.l1c('DeathsLamentUpgrade', tmp_109, tmp$ret$165);
    var tmp_111 = DevourerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$168 = [];
    var tmp_112 = ObjectSerializer.l1c('DevourerUpgrade', tmp_111, tmp$ret$168);
    var tmp_113 = DissectionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$171 = [];
    var tmp_114 = ObjectSerializer.l1c('DissectionUpgrade', tmp_113, tmp$ret$171);
    var tmp_115 = DistractionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$174 = [];
    var tmp_116 = ObjectSerializer.l1c('DistractionUpgrade', tmp_115, tmp$ret$174);
    var tmp_117 = DoomCallUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$177 = [];
    var tmp_118 = ObjectSerializer.l1c('DoomCallUpgrade', tmp_117, tmp$ret$177);
    var tmp_119 = DoubleUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$180 = [];
    var tmp_120 = ObjectSerializer.l1c('DoubleUpgrade', tmp_119, tmp$ret$180);
    var tmp_121 = DraconicBondsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$183 = [];
    var tmp_122 = ObjectSerializer.l1c('DraconicBondsUpgrade', tmp_121, tmp$ret$183);
    var tmp_123 = DrownerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$186 = [];
    var tmp_124 = ObjectSerializer.l1c('DrownerUpgrade', tmp_123, tmp$ret$186);
    var tmp_125 = EchoUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$189 = [];
    var tmp_126 = ObjectSerializer.l1c('EchoUpgrade', tmp_125, tmp$ret$189);
    var tmp_127 = EcholocationUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$192 = [];
    var tmp_128 = ObjectSerializer.l1c('EcholocationUpgrade', tmp_127, tmp$ret$192);
    var tmp_129 = EndlessDreamUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$195 = [];
    var tmp_130 = ObjectSerializer.l1c('EndlessDreamUpgrade', tmp_129, tmp$ret$195);
    var tmp_131 = EndlessStruggleUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$198 = [];
    var tmp_132 = ObjectSerializer.l1c('EndlessStruggleUpgrade', tmp_131, tmp$ret$198);
    var tmp_133 = EnragedUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$201 = [];
    var tmp_134 = ObjectSerializer.l1c('EnragedUpgrade', tmp_133, tmp$ret$201);
    var tmp_135 = EntrancingUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$204 = [];
    var tmp_136 = ObjectSerializer.l1c('EntrancingUpgrade', tmp_135, tmp$ret$204);
    var tmp_137 = EruptionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$207 = [];
    var tmp_138 = ObjectSerializer.l1c('EruptionUpgrade', tmp_137, tmp$ret$207);
    var tmp_139 = EternityUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$210 = [];
    var tmp_140 = ObjectSerializer.l1c('EternityUpgrade', tmp_139, tmp$ret$210);
    var tmp_141 = ExceptionalTrackerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$213 = [];
    var tmp_142 = ObjectSerializer.l1c('ExceptionalTrackerUpgrade', tmp_141, tmp$ret$213);
    var tmp_143 = ExpandTheMarshUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$216 = [];
    var tmp_144 = ObjectSerializer.l1c('ExpandTheMarshUpgrade', tmp_143, tmp$ret$216);
    var tmp_145 = ExtractUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$219 = [];
    var tmp_146 = ObjectSerializer.l1c('ExtractUpgrade', tmp_145, tmp$ret$219);
    var tmp_147 = FatalGazeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$222 = [];
    var tmp_148 = ObjectSerializer.l1c('FatalGazeUpgrade', tmp_147, tmp$ret$222);
    var tmp_149 = FearTheNightUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$225 = [];
    var tmp_150 = ObjectSerializer.l1c('FearTheNightUpgrade', tmp_149, tmp$ret$225);
    var tmp_151 = FleshboundUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$228 = [];
    var tmp_152 = ObjectSerializer.l1c('FleshboundUpgrade', tmp_151, tmp$ret$228);
    var tmp_153 = FlingUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$231 = [];
    var tmp_154 = ObjectSerializer.l1c('FlingUpgrade', tmp_153, tmp$ret$231);
    var tmp_155 = GoldenBeakUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$234 = [];
    var tmp_156 = ObjectSerializer.l1c('GoldenBeakUpgrade', tmp_155, tmp$ret$234);
    var tmp_157 = GreatHowlUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$237 = [];
    var tmp_158 = ObjectSerializer.l1c('GreatHowlUpgrade', tmp_157, tmp$ret$237);
    var tmp_159 = HordesMarchUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$240 = [];
    var tmp_160 = ObjectSerializer.l1c('HordesMarchUpgrade', tmp_159, tmp$ret$240);
    var tmp_161 = HornOfValhUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$243 = [];
    var tmp_162 = ObjectSerializer.l1c('HornOfValhUpgrade', tmp_161, tmp$ret$243);
    var tmp_163 = HuntersBaneUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$246 = [];
    var tmp_164 = ObjectSerializer.l1c('HuntersBaneUpgrade', tmp_163, tmp$ret$246);
    var tmp_165 = HuntmasterUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$249 = [];
    var tmp_166 = ObjectSerializer.l1c('HuntmasterUpgrade', tmp_165, tmp$ret$249);
    var tmp_167 = IgniteUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$252 = [];
    var tmp_168 = ObjectSerializer.l1c('IgniteUpgrade', tmp_167, tmp$ret$252);
    var tmp_169 = InfernalTusksUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$255 = [];
    var tmp_170 = ObjectSerializer.l1c('InfernalTusksUpgrade', tmp_169, tmp$ret$255);
    var tmp_171 = InfestUrgullUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$258 = [];
    var tmp_172 = ObjectSerializer.l1c('InfestUrgullUpgrade', tmp_171, tmp$ret$258);
    var tmp_173 = InfestationUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$261 = [];
    var tmp_174 = ObjectSerializer.l1c('InfestationUpgrade', tmp_173, tmp$ret$261);
    var tmp_175 = JointEffortUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$264 = [];
    var tmp_176 = ObjectSerializer.l1c('JointEffortUpgrade', tmp_175, tmp$ret$264);
    var tmp_177 = KillingsSpreeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$267 = [];
    var tmp_178 = ObjectSerializer.l1c('KillingsSpreeUpgrade', tmp_177, tmp$ret$267);
    var tmp_179 = KinsPursuitUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$270 = [];
    var tmp_180 = ObjectSerializer.l1c('KinsPursuitUpgrade', tmp_179, tmp$ret$270);
    var tmp_181 = LairUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$273 = [];
    var tmp_182 = ObjectSerializer.l1c('LairUpgrade', tmp_181, tmp$ret$273);
    var tmp_183 = LeviathanUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$276 = [];
    var tmp_184 = ObjectSerializer.l1c('LeviathanUpgrade', tmp_183, tmp$ret$276);
    var tmp_185 = LivingBlockadeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$279 = [];
    var tmp_186 = ObjectSerializer.l1c('LivingBlockadeUpgrade', tmp_185, tmp$ret$279);
    var tmp_187 = LurkingDeadUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$282 = [];
    var tmp_188 = ObjectSerializer.l1c('LurkingDeadUpgrade', tmp_187, tmp$ret$282);
    var tmp_189 = MartyrUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$285 = [];
    var tmp_190 = ObjectSerializer.l1c('MartyrUpgrade', tmp_189, tmp$ret$285);
    var tmp_191 = MassProductionUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$288 = [];
    var tmp_192 = ObjectSerializer.l1c('MassProductionUpgrade', tmp_191, tmp$ret$288);
    var tmp_193 = MendrsFuryUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$291 = [];
    var tmp_194 = ObjectSerializer.l1c('MendrsFuryUpgrade', tmp_193, tmp$ret$291);
    var tmp_195 = MirrorBeastUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$294 = [];
    var tmp_196 = ObjectSerializer.l1c('MirrorBeastUpgrade', tmp_195, tmp$ret$294);
    var tmp_197 = NaturalInstinctUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$297 = [];
    var tmp_198 = ObjectSerializer.l1c('NaturalInstinctUpgrade', tmp_197, tmp$ret$297);
    var tmp_199 = OverlordUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$300 = [];
    var tmp_200 = ObjectSerializer.l1c('OverlordUpgrade', tmp_199, tmp$ret$300);
    var tmp_201 = PalebloodAxesUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$303 = [];
    var tmp_202 = ObjectSerializer.l1c('PalebloodAxesUpgrade', tmp_201, tmp$ret$303);
    var tmp_203 = PandemoniumUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$306 = [];
    var tmp_204 = ObjectSerializer.l1c('PandemoniumUpgrade', tmp_203, tmp$ret$306);
    var tmp_205 = PortableWorkshopUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$309 = [];
    var tmp_206 = ObjectSerializer.l1c('PortableWorkshopUpgrade', tmp_205, tmp$ret$309);
    var tmp_207 = PredictUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$312 = [];
    var tmp_208 = ObjectSerializer.l1c('PredictUpgrade', tmp_207, tmp$ret$312);
    var tmp_209 = PrimalInstinctsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$315 = [];
    var tmp_210 = ObjectSerializer.l1c('PrimalInstinctsUpgrade', tmp_209, tmp$ret$315);
    var tmp_211 = ProminenceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$318 = [];
    var tmp_212 = ObjectSerializer.l1c('ProminenceUpgrade', tmp_211, tmp$ret$318);
    var tmp_213 = RampageousUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$321 = [];
    var tmp_214 = ObjectSerializer.l1c('RampageousUpgrade', tmp_213, tmp$ret$321);
    var tmp_215 = ReachUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$324 = [];
    var tmp_216 = ObjectSerializer.l1c('ReachUpgrade', tmp_215, tmp$ret$324);
    var tmp_217 = RefugeUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$327 = [];
    var tmp_218 = ObjectSerializer.l1c('RefugeUpgrade', tmp_217, tmp$ret$327);
    var tmp_219 = RegalUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$330 = [];
    var tmp_220 = ObjectSerializer.l1c('RegalUpgrade', tmp_219, tmp$ret$330);
    var tmp_221 = ReuniteUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$333 = [];
    var tmp_222 = ObjectSerializer.l1c('ReuniteUpgrade', tmp_221, tmp$ret$333);
    var tmp_223 = ReveranceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$336 = [];
    var tmp_224 = ObjectSerializer.l1c('ReveranceUpgrade', tmp_223, tmp$ret$336);
    var tmp_225 = RuptureSeedsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$339 = [];
    var tmp_226 = ObjectSerializer.l1c('RuptureSeedsUpgrade', tmp_225, tmp$ret$339);
    var tmp_227 = ScavengerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$342 = [];
    var tmp_228 = ObjectSerializer.l1c('ScavengerUpgrade', tmp_227, tmp$ret$342);
    var tmp_229 = SeekerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$345 = [];
    var tmp_230 = ObjectSerializer.l1c('SeekerUpgrade', tmp_229, tmp$ret$345);
    var tmp_231 = SharedMadnessUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$348 = [];
    var tmp_232 = ObjectSerializer.l1c('SharedMadnessUpgrade', tmp_231, tmp$ret$348);
    var tmp_233 = SkyMasterUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$351 = [];
    var tmp_234 = ObjectSerializer.l1c('SkyMasterUpgrade', tmp_233, tmp$ret$351);
    var tmp_235 = SoothsayerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$354 = [];
    var tmp_236 = ObjectSerializer.l1c('SoothsayerUpgrade', tmp_235, tmp$ret$354);
    var tmp_237 = SoulHarvestUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$357 = [];
    var tmp_238 = ObjectSerializer.l1c('SoulHarvestUpgrade', tmp_237, tmp$ret$357);
    var tmp_239 = SoulHarvestVackerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$360 = [];
    var tmp_240 = ObjectSerializer.l1c('SoulHarvestVackerUpgrade', tmp_239, tmp$ret$360);
    var tmp_241 = SpiritboundUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$363 = [];
    var tmp_242 = ObjectSerializer.l1c('SpiritboundUpgrade', tmp_241, tmp$ret$363);
    var tmp_243 = StarFallUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$366 = [];
    var tmp_244 = ObjectSerializer.l1c('StarFallUpgrade', tmp_243, tmp$ret$366);
    var tmp_245 = StormBringerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$369 = [];
    var tmp_246 = ObjectSerializer.l1c('StormBringerUpgrade', tmp_245, tmp$ret$369);
    var tmp_247 = SwapUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$372 = [];
    var tmp_248 = ObjectSerializer.l1c('SwapUpgrade', tmp_247, tmp$ret$372);
    var tmp_249 = SwiftKillUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$375 = [];
    var tmp_250 = ObjectSerializer.l1c('SwiftKillUpgrade', tmp_249, tmp$ret$375);
    var tmp_251 = TacticalInsightUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$378 = [];
    var tmp_252 = ObjectSerializer.l1c('TacticalInsightUpgrade', tmp_251, tmp$ret$378);
    var tmp_253 = ThickMistUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$381 = [];
    var tmp_254 = ObjectSerializer.l1c('ThickMistUpgrade', tmp_253, tmp$ret$381);
    var tmp_255 = TormentingVisionsUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$384 = [];
    var tmp_256 = ObjectSerializer.l1c('TormentingVisionsUpgrade', tmp_255, tmp$ret$384);
    var tmp_257 = TorrentialUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$387 = [];
    var tmp_258 = ObjectSerializer.l1c('TorrentialUpgrade', tmp_257, tmp$ret$387);
    var tmp_259 = TownswatchUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$390 = [];
    var tmp_260 = ObjectSerializer.l1c('TownswatchUpgrade', tmp_259, tmp$ret$390);
    var tmp_261 = TrapLauncherUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$393 = [];
    var tmp_262 = ObjectSerializer.l1c('TrapLauncherUpgrade', tmp_261, tmp$ret$393);
    var tmp_263 = TrueInstinctEsmeriaBeastUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$396 = [];
    var tmp_264 = ObjectSerializer.l1c('TrueInstinctEsmeriaBeastUpgrade', tmp_263, tmp$ret$396);
    var tmp_265 = TrueInstinctEsmeriaHuntressUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$399 = [];
    var tmp_266 = ObjectSerializer.l1c('TrueInstinctEsmeriaHuntressUpgrade', tmp_265, tmp$ret$399);
    var tmp_267 = UnendingHungerUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$402 = [];
    var tmp_268 = ObjectSerializer.l1c('UnendingHungerUpgrade', tmp_267, tmp$ret$402);
    var tmp_269 = VoidPresenceUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$405 = [];
    var tmp_270 = ObjectSerializer.l1c('VoidPresenceUpgrade', tmp_269, tmp$ret$405);
    var tmp_271 = VoidStepUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$408 = [];
    var tmp_272 = ObjectSerializer.l1c('VoidStepUpgrade', tmp_271, tmp$ret$408);
    var tmp_273 = WatchtowerPassageUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$411 = [];
    var tmp_274 = ObjectSerializer.l1c('WatchtowerPassageUpgrade', tmp_273, tmp$ret$411);
    var tmp_275 = WildbondUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$414 = [];
    var tmp_276 = ObjectSerializer.l1c('WildbondUpgrade', tmp_275, tmp$ret$414);
    var tmp_277 = WitheringMawUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$417 = [];
    var tmp_278 = ObjectSerializer.l1c('WitheringMawUpgrade', tmp_277, tmp$ret$417);
    var tmp_279 = WorshipUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$420 = [];
    var tmp_280 = ObjectSerializer.l1c('WorshipUpgrade', tmp_279, tmp$ret$420);
    var tmp_281 = WrathOfEirtirUpgrade_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$423 = [];
    var tmp_282 = ObjectSerializer.l1c('WrathOfEirtirUpgrade', tmp_281, tmp$ret$423);
    var tmp_283 = DarkOfferingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$426 = [];
    var tmp_284 = ObjectSerializer.l1c('DarkOfferingsCard', tmp_283, tmp$ret$426);
    var tmp_285 = $serializer_getInstance_133();
    var tmp_286 = FeedCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$429 = [];
    var tmp_287 = ObjectSerializer.l1c('FeedCard', tmp_286, tmp$ret$429);
    var tmp_288 = AllureKillEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$432 = [];
    var tmp_289 = ObjectSerializer.l1c('AllureKillEffectSource', tmp_288, tmp$ret$432);
    var tmp_290 = ArrivalOfTheTitanSettlementClaimingSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$435 = [];
    var tmp_291 = ObjectSerializer.l1c('ArrivalOfTheTitanSettlementClaimingSource', tmp_290, tmp$ret$435);
    var tmp_292 = ArrivalOfTheTitanSettlerMoveEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$438 = [];
    var tmp_293 = ObjectSerializer.l1c('ArrivalOfTheTitanSettlerMoveEffectSource', tmp_292, tmp$ret$438);
    var tmp_294 = BramBarrierCleanupEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$441 = [];
    var tmp_295 = ObjectSerializer.l1c('BramBarrierCleanupEffectSource', tmp_294, tmp$ret$441);
    var tmp_296 = BurstEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$444 = [];
    var tmp_297 = ObjectSerializer.l1c('BurstEffectSource', tmp_296, tmp$ret$444);
    var tmp_298 = ClaimRuinEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$447 = [];
    var tmp_299 = ObjectSerializer.l1c('ClaimRuinEffectSource', tmp_298, tmp$ret$447);
    var tmp_300 = DraugCardWoundEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$450 = [];
    var tmp_301 = ObjectSerializer.l1c('DraugCardWoundEffectSource', tmp_300, tmp$ret$450);
    var tmp_302 = FylgjaFlightEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$453 = [];
    var tmp_303 = ObjectSerializer.l1c('FylgjaFlightEffectSource', tmp_302, tmp$ret$453);
    var tmp_304 = LydanInitialHarvestEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$456 = [];
    var tmp_305 = ObjectSerializer.l1c('LydanInitialHarvestEffectSource', tmp_304, tmp$ret$456);
    var tmp_306 = PossibleBindingHuntEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$459 = [];
    var tmp_307 = ObjectSerializer.l1c('PossibleBindingHuntEffectSource', tmp_306, tmp$ret$459);
    var tmp_308 = PossibleBleatEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$462 = [];
    var tmp_309 = ObjectSerializer.l1c('PossibleBleatEffectSource', tmp_308, tmp$ret$462);
    var tmp_310 = PossibleMistShroudEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$465 = [];
    var tmp_311 = ObjectSerializer.l1c('PossibleMistShroudEffectSource', tmp_310, tmp$ret$465);
    var tmp_312 = PossibleSnareEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$468 = [];
    var tmp_313 = ObjectSerializer.l1c('PossibleSnareEffectSource', tmp_312, tmp$ret$468);
    var tmp_314 = PossibleTrapEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$471 = [];
    var tmp_315 = ObjectSerializer.l1c('PossibleTrapEffectSource', tmp_314, tmp$ret$471);
    var tmp_316 = PossibleDreamerMaskEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$474 = [];
    var tmp_317 = ObjectSerializer.l1c('PossibleDreamerMaskEffectSource', tmp_316, tmp$ret$474);
    var tmp_318 = PossibleEsmeriasStrandEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$477 = [];
    var tmp_319 = ObjectSerializer.l1c('PossibleEsmeriasStrandEffectSource', tmp_318, tmp$ret$477);
    var tmp_320 = PossibleFlareEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$480 = [];
    var tmp_321 = ObjectSerializer.l1c('PossibleFlareEffectSource', tmp_320, tmp$ret$480);
    var tmp_322 = PossibleIntuitionEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$483 = [];
    var tmp_323 = ObjectSerializer.l1c('PossibleIntuitionEffectSource', tmp_322, tmp$ret$483);
    var tmp_324 = PossibleSmokeBombEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$486 = [];
    var tmp_325 = ObjectSerializer.l1c('PossibleSmokeBombEffectSource', tmp_324, tmp$ret$486);
    var tmp_326 = PossibleSuddenMistEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$489 = [];
    var tmp_327 = ObjectSerializer.l1c('PossibleSuddenMistEffectSource', tmp_326, tmp$ret$489);
    var tmp_328 = PossibleWorldShiftEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$492 = [];
    var tmp_329 = ObjectSerializer.l1c('PossibleWorldShiftEffectSource', tmp_328, tmp$ret$492);
    var tmp_330 = RhagnerGainHoardEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$495 = [];
    var tmp_331 = ObjectSerializer.l1c('RhagnerGainHoardEffectSource', tmp_330, tmp$ret$495);
    var tmp_332 = RhagnerReduceHoardEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$498 = [];
    var tmp_333 = ObjectSerializer.l1c('RhagnerReduceHoardEffectSource', tmp_332, tmp$ret$498);
    var tmp_334 = ShipwreckRedDraftActionCardEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$501 = [];
    var tmp_335 = ObjectSerializer.l1c('ShipwreckRedDraftActionCardEffectSource', tmp_334, tmp$ret$501);
    var tmp_336 = SigridCreatureDeathEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$504 = [];
    var tmp_337 = ObjectSerializer.l1c('SigridCreatureDeathEffectSource', tmp_336, tmp$ret$504);
    var tmp_338 = SigridCreatureLungeEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$507 = [];
    var tmp_339 = ObjectSerializer.l1c('SigridCreatureLungeEffectSource', tmp_338, tmp$ret$507);
    var tmp_340 = SigridSummonCreatureEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$510 = [];
    var tmp_341 = ObjectSerializer.l1c('SigridSummonCreatureEffectSource', tmp_340, tmp$ret$510);
    var tmp_342 = SoulsChangeSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$513 = [];
    var tmp_343 = ObjectSerializer.l1c('SoulsChangeSource', tmp_342, tmp$ret$513);
    var tmp_344 = SummonFylgjaEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$516 = [];
    var tmp_345 = ObjectSerializer.l1c('SummonFylgjaEffectSource', tmp_344, tmp$ret$516);
    var tmp_346 = UrgullHatchDamageSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$519 = [];
    var tmp_347 = ObjectSerializer.l1c('UrgullHatchDamageSource', tmp_346, tmp$ret$519);
    var tmp_348 = UrgullMoltRewardEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$522 = [];
    var tmp_349 = ObjectSerializer.l1c('UrgullMoltRewardEffectSource', tmp_348, tmp$ret$522);
    var tmp_350 = ValdiBloodKillSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$525 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_351 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_66, tmp_68, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_80, tmp_82, tmp_84, tmp_86, tmp_88, tmp_90, tmp_92, tmp_94, tmp_96, tmp_98, tmp_100, tmp_102, tmp_104, tmp_106, tmp_108, tmp_110, tmp_112, tmp_114, tmp_116, tmp_118, tmp_120, tmp_122, tmp_124, tmp_126, tmp_128, tmp_130, tmp_132, tmp_134, tmp_136, tmp_138, tmp_140, tmp_142, tmp_144, tmp_146, tmp_148, tmp_150, tmp_152, tmp_154, tmp_156, tmp_158, tmp_160, tmp_162, tmp_164, tmp_166, tmp_168, tmp_170, tmp_172, tmp_174, tmp_176, tmp_178, tmp_180, tmp_182, tmp_184, tmp_186, tmp_188, tmp_190, tmp_192, tmp_194, tmp_196, tmp_198, tmp_200, tmp_202, tmp_204, tmp_206, tmp_208, tmp_210, tmp_212, tmp_214, tmp_216, tmp_218, tmp_220, tmp_222, tmp_224, tmp_226, tmp_228, tmp_230, tmp_232, tmp_234, tmp_236, tmp_238, tmp_240, tmp_242, tmp_244, tmp_246, tmp_248, tmp_250, tmp_252, tmp_254, tmp_256, tmp_258, tmp_260, tmp_262, tmp_264, tmp_266, tmp_268, tmp_270, tmp_272, tmp_274, tmp_276, tmp_278, tmp_280, tmp_282, tmp_284, tmp_285, tmp_287, tmp_289, tmp_291, tmp_293, tmp_295, tmp_297, tmp_299, tmp_301, tmp_303, tmp_305, tmp_307, tmp_309, tmp_311, tmp_313, tmp_315, tmp_317, tmp_319, tmp_321, tmp_323, tmp_325, tmp_327, tmp_329, tmp_331, tmp_333, tmp_335, tmp_337, tmp_339, tmp_341, tmp_343, tmp_345, tmp_347, tmp_349, ObjectSerializer.l1c('ValdiBloodKillSource', tmp_350, tmp$ret$525), $serializer_getInstance_328()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$531 = [];
    return SealedClassSerializer.i10('steelart.beast.EffectSource', tmp, tmp_0, tmp_351, tmp$ret$531);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_155 {
  constructor() {
    Companion_instance_155 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k3w_1 = [lazy(tmp_0, EventItselfSource$Companion$$childSerializers$_anonymous__dvzqv2)];
  }
}
class $serializer_133 {
  constructor() {
    $serializer_instance_133 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EventItselfSource', this, 1);
    tmp0_serialDesc.h1b('event', false);
    this.l3w_1 = tmp0_serialDesc;
  }
  m3w(encoder, value) {
    var tmp0_desc = this.l3w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_156().k3w_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n3w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m3w(encoder, value instanceof EventItselfSource ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l3w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_156().k3w_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return EventItselfSource.o3w(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l3w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_156().k3w_1[0].k3()];
  }
}
class EventItselfSource {
  constructor(event) {
    Companion_getInstance_156();
    this.n3w_1 = event;
  }
  toString() {
    return 'EventItselfSource(event=' + toString(this.n3w_1) + ')';
  }
  hashCode() {
    return hashCode(this.n3w_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventItselfSource))
      return false;
    if (!equals(this.n3w_1, other.n3w_1))
      return false;
    return true;
  }
  static o3w(seen0, event, serializationConstructorMarker) {
    Companion_getInstance_156();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_133().l3w_1);
    }
    var $this = createThis(this);
    $this.n3w_1 = event;
    return $this;
  }
}
class ClaimRuinEffectSource {
  constructor() {
    ClaimRuinEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p3w_1 = lazy(tmp_0, ClaimRuinEffectSource$_anonymous__c0lcp);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_127(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ClaimRuinEffectSource';
  }
  hashCode() {
    return 1370274443;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClaimRuinEffectSource))
      return false;
    return true;
  }
}
class PossibleTrapEffectSource {
  constructor() {
    PossibleTrapEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q3w_1 = lazy(tmp_0, PossibleTrapEffectSource$_anonymous__q0xzf7);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_128(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleTrapEffectSource';
  }
  hashCode() {
    return -1641588689;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleTrapEffectSource))
      return false;
    return true;
  }
}
class ReactionCardTriggerEffectSource {}
class PossibleDreamerMaskEffectSource {
  constructor() {
    PossibleDreamerMaskEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r3w_1 = lazy(tmp_0, PossibleDreamerMaskEffectSource$_anonymous__x7usyo);
  }
  s3w() {
    return new DreamerMaskCard(0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_129(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleDreamerMaskEffectSource';
  }
  hashCode() {
    return 715677202;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleDreamerMaskEffectSource))
      return false;
    return true;
  }
}
class PossibleEsmeriasStrandEffectSource {
  constructor() {
    PossibleEsmeriasStrandEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t3w_1 = lazy(tmp_0, PossibleEsmeriasStrandEffectSource$_anonymous__lfma2t);
  }
  s3w() {
    return EsmeriasStrandCard_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_130(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleEsmeriasStrandEffectSource';
  }
  hashCode() {
    return -105623337;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleEsmeriasStrandEffectSource))
      return false;
    return true;
  }
}
class PossibleFlareEffectSource {
  constructor() {
    PossibleFlareEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u3w_1 = lazy(tmp_0, PossibleFlareEffectSource$_anonymous__v4ngge);
  }
  s3w() {
    return new FlareCard(0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_131(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleFlareEffectSource';
  }
  hashCode() {
    return -491407516;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleFlareEffectSource))
      return false;
    return true;
  }
}
class PossibleIntuitionEffectSource {
  constructor() {
    PossibleIntuitionEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v3w_1 = lazy(tmp_0, PossibleIntuitionEffectSource$_anonymous__6rrawr);
  }
  s3w() {
    return new IntuitionCard(0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_132(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleIntuitionEffectSource';
  }
  hashCode() {
    return 2033655149;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleIntuitionEffectSource))
      return false;
    return true;
  }
}
class PossibleSmokeBombEffectSource {
  constructor() {
    PossibleSmokeBombEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w3w_1 = lazy(tmp_0, PossibleSmokeBombEffectSource$_anonymous__zaphzp);
  }
  s3w() {
    return new SmokeBombCard(0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_133(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleSmokeBombEffectSource';
  }
  hashCode() {
    return 900198087;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleSmokeBombEffectSource))
      return false;
    return true;
  }
}
class PossibleSuddenMistEffectSource {
  constructor() {
    PossibleSuddenMistEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x3w_1 = lazy(tmp_0, PossibleSuddenMistEffectSource$_anonymous__6sklou);
  }
  s3w() {
    return SuddenMistCard_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_134(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleSuddenMistEffectSource';
  }
  hashCode() {
    return 1966689834;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleSuddenMistEffectSource))
      return false;
    return true;
  }
}
class PossibleWorldShiftEffectSource {
  constructor() {
    PossibleWorldShiftEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y3w_1 = lazy(tmp_0, PossibleWorldShiftEffectSource$_anonymous__ah1pkm);
  }
  s3w() {
    return new WorldShiftCard(0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_135(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleWorldShiftEffectSource';
  }
  hashCode() {
    return 1737104402;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleWorldShiftEffectSource))
      return false;
    return true;
  }
}
class Companion_156 {
  a2g() {
    var tmp = getKClass(ReactionCardTriggerEffectSource);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(PossibleDreamerMaskEffectSource), getKClass(PossibleEsmeriasStrandEffectSource), getKClass(PossibleFlareEffectSource), getKClass(PossibleIntuitionEffectSource), getKClass(PossibleSmokeBombEffectSource), getKClass(PossibleSuddenMistEffectSource), getKClass(PossibleWorldShiftEffectSource)];
    var tmp_1 = PossibleDreamerMaskEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('PossibleDreamerMaskEffectSource', tmp_1, tmp$ret$3);
    var tmp_3 = PossibleEsmeriasStrandEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('PossibleEsmeriasStrandEffectSource', tmp_3, tmp$ret$6);
    var tmp_5 = PossibleFlareEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('PossibleFlareEffectSource', tmp_5, tmp$ret$9);
    var tmp_7 = PossibleIntuitionEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('PossibleIntuitionEffectSource', tmp_7, tmp$ret$12);
    var tmp_9 = PossibleSmokeBombEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('PossibleSmokeBombEffectSource', tmp_9, tmp$ret$15);
    var tmp_11 = PossibleSuddenMistEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('PossibleSuddenMistEffectSource', tmp_11, tmp$ret$18);
    var tmp_13 = PossibleWorldShiftEffectSource_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_14 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, ObjectSerializer.l1c('PossibleWorldShiftEffectSource', tmp_13, tmp$ret$21)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    return SealedClassSerializer.i10('steelart.beast.ReactionCardTriggerEffectSource', tmp, tmp_0, tmp_14, tmp$ret$27);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Eivind {
  constructor() {
    Eivind_instance = this;
    this.z3w_1 = setOf_0([SkyMasterUpgrade_getInstance(), RopePullUpgrade_getInstance(), ReachUpgrade_getInstance()]);
    this.a3x_1 = Fylgja_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b3x_1 = lazy(tmp_0, Eivind$_anonymous__2aa1oq);
  }
  s36() {
    return setOf_0([new HuntCard(this), GrapplingHookCard_getInstance(), AviationCard_getInstance()]);
  }
  t35() {
    return this.z3w_1;
  }
  n2z($context_GameState_t6qee5) {
    return 3;
  }
  i3e() {
    return this.a3x_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_136(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Eivind';
  }
  hashCode() {
    return -244149934;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Eivind))
      return false;
    return true;
  }
}
class SkyMasterUpgrade {
  constructor() {
    SkyMasterUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c3x_1 = lazy(tmp_0, SkyMasterUpgrade$_anonymous__1nuopq);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_137(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SkyMasterUpgrade';
  }
  hashCode() {
    return 1002929790;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SkyMasterUpgrade))
      return false;
    return true;
  }
}
class RopePullUpgrade {
  constructor() {
    RopePullUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d3x_1 = lazy(tmp_0, RopePullUpgrade$_anonymous__wurkr6);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_138(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RopePullUpgrade';
  }
  hashCode() {
    return 138916448;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RopePullUpgrade))
      return false;
    return true;
  }
}
class ReachUpgrade {
  constructor() {
    ReachUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e3x_1 = lazy(tmp_0, ReachUpgrade$_anonymous__p7kx5e);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_139(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ReachUpgrade';
  }
  hashCode() {
    return -1236433810;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReachUpgrade))
      return false;
    return true;
  }
}
class FylgjaFlightEffectSource {
  constructor() {
    FylgjaFlightEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f3x_1 = lazy(tmp_0, FylgjaFlightEffectSource$_anonymous__bdmycq);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_140(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FylgjaFlightEffectSource';
  }
  hashCode() {
    return 332355974;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FylgjaFlightEffectSource))
      return false;
    return true;
  }
}
class SummonFylgjaEffectSource {
  constructor() {
    SummonFylgjaEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g3x_1 = lazy(tmp_0, SummonFylgjaEffectSource$_anonymous__ysk0rf);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_141(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonFylgjaEffectSource';
  }
  hashCode() {
    return 1314967415;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonFylgjaEffectSource))
      return false;
    return true;
  }
}
class GrapplingHookCard {
  constructor() {
    GrapplingHookCard_instance = this;
    this.h3x_1 = Red_getInstance();
    this.i3x_1 = Eivind_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j3x_1 = lazy(tmp_0, GrapplingHookCard$_anonymous__qlj1w8);
  }
  t37() {
    return this.i3x_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_142(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'GrapplingHookCard';
  }
  hashCode() {
    return 1014163738;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GrapplingHookCard))
      return false;
    return true;
  }
}
class AviationCard {
  constructor() {
    AviationCard_instance = this;
    this.k3x_1 = Split_getInstance();
    this.l3x_1 = Eivind_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m3x_1 = lazy(tmp_0, AviationCard$_anonymous__1mdgca);
  }
  t37() {
    return this.l3x_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_143(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AviationCard';
  }
  hashCode() {
    return -1885913450;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AviationCard))
      return false;
    return true;
  }
}
class HunterCompanionType {}
function get_maxHP_0($context_GameState_t6qee5) {
  return 1;
}
class Fylgja {
  constructor() {
    Fylgja_instance = this;
    this.n3x_1 = Eivind_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o3x_1 = lazy(tmp_0, Fylgja$_anonymous__4agmj6);
  }
  p3x() {
    return this.n3x_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_144(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Fylgja';
  }
  hashCode() {
    return -201044406;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fylgja))
      return false;
    return true;
  }
}
class Companion_157 {
  constructor() {
    Companion_instance_157 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q3x_1 = [lazy(tmp_0, FylgjaFlightStatement$Companion$$childSerializers$_anonymous__ci6ids)];
  }
}
class $serializer_134 {
  constructor() {
    $serializer_instance_134 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FylgjaFlightStatement', this, 1);
    tmp0_serialDesc.h1b('fylgja', false);
    this.r3x_1 = tmp0_serialDesc;
  }
  s3x(encoder, value) {
    var tmp0_desc = this.r3x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_158().q3x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t3x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s3x(encoder, value instanceof FylgjaFlightStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r3x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_158().q3x_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return FylgjaFlightStatement.u3x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r3x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_158().q3x_1[0].k3()];
  }
}
class FylgjaFlightStatement {
  constructor(fylgja) {
    Companion_getInstance_158();
    this.t3x_1 = fylgja;
  }
  toString() {
    return 'FylgjaFlightStatement(fylgja=' + this.t3x_1.toString() + ')';
  }
  hashCode() {
    return this.t3x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FylgjaFlightStatement))
      return false;
    if (!this.t3x_1.equals(other.t3x_1))
      return false;
    return true;
  }
  static u3x(seen0, fylgja, serializationConstructorMarker) {
    Companion_getInstance_158();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_134().r3x_1);
    }
    var $this = createThis(this);
    $this.t3x_1 = fylgja;
    return $this;
  }
}
class SummonFylgjaStatement {
  constructor() {
    SummonFylgjaStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v3x_1 = lazy(tmp_0, SummonFylgjaStatement$_anonymous__pkwkc2);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_145(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonFylgjaStatement';
  }
  hashCode() {
    return 1552893668;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonFylgjaStatement))
      return false;
    return true;
  }
}
class Companion_158 {}
class $serializer_135 {
  constructor() {
    $serializer_instance_135 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChangeFylgjaFlightWasUsedThisTurnEvent', this, 1);
    tmp0_serialDesc.h1b('newStatus', false);
    this.w3x_1 = tmp0_serialDesc;
  }
  x3x(encoder, value) {
    var tmp0_desc = this.w3x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.w14(tmp0_desc, 0, value.y3x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x3x(encoder, value instanceof ChangeFylgjaFlightWasUsedThisTurnEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w3x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ChangeFylgjaFlightWasUsedThisTurnEvent.z3x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w3x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance()];
  }
}
class ChangeFylgjaFlightWasUsedThisTurnEvent {
  constructor(newStatus) {
    this.y3x_1 = newStatus;
  }
  m37(_this__u8e3s4) {
    set_fylgjaFlightWasUsedThisTurnImpl(_this__u8e3s4, get_eivindHunter(_this__u8e3s4), this.y3x_1);
  }
  n37($context_GameState_t6qee5) {
    return new ChangeFylgjaFlightWasUsedThisTurnEvent(!this.y3x_1);
  }
  toString() {
    return 'ChangeFylgjaFlightWasUsedThisTurnEvent(newStatus=' + this.y3x_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.y3x_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangeFylgjaFlightWasUsedThisTurnEvent))
      return false;
    if (!(this.y3x_1 === other.y3x_1))
      return false;
    return true;
  }
  static z3x(seen0, newStatus, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_135().w3x_1);
    }
    var $this = createThis(this);
    $this.y3x_1 = newStatus;
    return $this;
  }
}
class Companion_159 {}
class $serializer_136 {
  constructor() {
    $serializer_instance_136 = this;
    var tmp0_serialDesc = new InlineClassDescriptor('steelart.beast.EntityId', this);
    tmp0_serialDesc.h1b('id', false);
    this.a3y_1 = tmp0_serialDesc;
  }
  b3y(encoder, value) {
    var tmp0_inlineEncoder = encoder.v14(this.a3y_1);
    if (tmp0_inlineEncoder == null)
      null;
    else {
      tmp0_inlineEncoder.o14(_EntityId___get_id__impl__v6colh(value));
    }
  }
  ez(encoder, value) {
    return this.b3y(encoder, value instanceof EntityId ? value.c3y_1 : THROW_CCE());
  }
  d3y(decoder) {
    return _EntityId___init__impl__cq1mhp(decoder.m13(this.a3y_1).f13());
  }
  fz(decoder) {
    return new EntityId(this.d3y(decoder));
  }
  dz() {
    return this.a3y_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class EntityId {
  constructor(id) {
    this.c3y_1 = id;
  }
  toString() {
    return EntityId__toString_impl_njecar(this.c3y_1);
  }
  hashCode() {
    return EntityId__hashCode_impl_1s8fhw(this.c3y_1);
  }
  equals(other) {
    return EntityId__equals_impl_5w8h0w(this.c3y_1, other);
  }
}
class EndlessStruggleUpgrade {
  constructor() {
    EndlessStruggleUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e3y_1 = lazy(tmp_0, EndlessStruggleUpgrade$_anonymous__91bmb8);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_146(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EndlessStruggleUpgrade';
  }
  hashCode() {
    return -1552828400;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EndlessStruggleUpgrade))
      return false;
    return true;
  }
}
class AccursedWrathUpgrade {
  constructor() {
    AccursedWrathUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f3y_1 = lazy(tmp_0, AccursedWrathUpgrade$_anonymous__2u8onz);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_147(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AccursedWrathUpgrade';
  }
  hashCode() {
    return -1764753413;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AccursedWrathUpgrade))
      return false;
    return true;
  }
}
class KillingsSpreeUpgrade {
  constructor() {
    KillingsSpreeUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g3y_1 = lazy(tmp_0, KillingsSpreeUpgrade$_anonymous__vcafup);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_148(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'KillingsSpreeUpgrade';
  }
  hashCode() {
    return -1628281765;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KillingsSpreeUpgrade))
      return false;
    return true;
  }
}
class SinisterActUpgrade {
  constructor() {
    SinisterActUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h3y_1 = lazy(tmp_0, SinisterActUpgrade$_anonymous__i4b3e6);
  }
  v35($context_GameState_t6qee5) {
    return 0;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_149(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SinisterActUpgrade';
  }
  hashCode() {
    return 328069870;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SinisterActUpgrade))
      return false;
    return true;
  }
}
class MesmeriseUpgrade {
  constructor() {
    MesmeriseUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i3y_1 = lazy(tmp_0, MesmeriseUpgrade$_anonymous__ip2w89);
  }
  v35($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_150(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'MesmeriseUpgrade';
  }
  hashCode() {
    return 1013888325;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MesmeriseUpgrade))
      return false;
    return true;
  }
}
class TrueInstinctEsmeriaBeastUpgrade {
  constructor() {
    TrueInstinctEsmeriaBeastUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j3y_1 = lazy(tmp_0, TrueInstinctEsmeriaBeastUpgrade$_anonymous__fow6ow);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_151(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TrueInstinctEsmeriaBeastUpgrade';
  }
  hashCode() {
    return 147986770;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrueInstinctEsmeriaBeastUpgrade))
      return false;
    return true;
  }
}
class EsmeriaBeast {
  constructor() {
    EsmeriaBeast_instance = this;
    this.k3y_1 = setOf_0([EndlessStruggleUpgrade_getInstance(), AccursedWrathUpgrade_getInstance(), KillingsSpreeUpgrade_getInstance(), SinisterActUpgrade_getInstance(), MesmeriseUpgrade_getInstance(), TrueInstinctEsmeriaBeastUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l3y_1 = lazy(tmp_0, EsmeriaBeast$_anonymous__kbluzg);
  }
  q36() {
    return ChangelingType_getInstance();
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Cave_getInstance();
  }
  s36() {
    return setOf_0([SummonChangelingCard_getInstance(), MurderCard_getInstance(), StalkCard_getInstance(), DeceiveCard_getInstance()]);
  }
  t35() {
    return this.k3y_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_152(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EsmeriaBeast';
  }
  hashCode() {
    return 669283456;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EsmeriaBeast))
      return false;
    return true;
  }
}
class ChangelingType {
  constructor() {
    ChangelingType_instance = this;
    this.m3y_1 = EsmeriaBeast_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n3y_1 = lazy(tmp_0, ChangelingType$_anonymous__7gpviv);
  }
  r37() {
    return this.m3y_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_153(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ChangelingType';
  }
  hashCode() {
    return 1645974021;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangelingType))
      return false;
    return true;
  }
}
class SummonChangelingCard {
  constructor() {
    SummonChangelingCard_instance = this;
    this.o3y_1 = EsmeriaBeast_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p3y_1 = lazy(tmp_0, SummonChangelingCard$_anonymous__30wl6o);
  }
  t37() {
    return this.o3y_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_154(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonChangelingCard';
  }
  hashCode() {
    return -1807837860;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonChangelingCard))
      return false;
    return true;
  }
}
class MurderCard {
  constructor() {
    MurderCard_instance = this;
    this.q3y_1 = Red_getInstance();
    this.r3y_1 = EsmeriaBeast_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s3y_1 = lazy(tmp_0, MurderCard$_anonymous__9mviqo);
  }
  t37() {
    return this.r3y_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_155(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'MurderCard';
  }
  hashCode() {
    return -951315396;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MurderCard))
      return false;
    return true;
  }
}
class StalkCard {
  constructor() {
    StalkCard_instance = this;
    this.t3y_1 = Red_getInstance();
    this.u3y_1 = EsmeriaBeast_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v3y_1 = lazy(tmp_0, StalkCard$_anonymous__l6lyns);
  }
  t37() {
    return this.u3y_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_156(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'StalkCard';
  }
  hashCode() {
    return -1010043350;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StalkCard))
      return false;
    return true;
  }
}
class DeceiveCard {
  constructor() {
    DeceiveCard_instance = this;
    this.w3y_1 = Blue_getInstance();
    this.x3y_1 = EsmeriaBeast_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y3y_1 = lazy(tmp_0, DeceiveCard$_anonymous__yukmmq);
  }
  t37() {
    return this.x3y_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_157(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DeceiveCard';
  }
  hashCode() {
    return 900813344;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DeceiveCard))
      return false;
    return true;
  }
}
class Companion_160 {
  constructor() {
    Companion_instance_160 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z3y_1 = [lazy(tmp_0, HauntStatement$Companion$$childSerializers$_anonymous__4wa9dp)];
  }
}
class $serializer_137 {
  constructor() {
    $serializer_instance_137 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HauntStatement', this, 1);
    tmp0_serialDesc.h1b('changeling', false);
    this.a3z_1 = tmp0_serialDesc;
  }
  b3z(encoder, value) {
    var tmp0_desc = this.a3z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_161().z3y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c3z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b3z(encoder, value instanceof HauntStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_161().z3y_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return HauntStatement.d3z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a3z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_161().z3y_1[0].k3()];
  }
}
class HauntStatement {
  constructor(changeling) {
    Companion_getInstance_161();
    this.c3z_1 = changeling;
  }
  n2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !get_aliveHunters_0($context_GameStateRuntime_604ce3).n1();
  }
  toString() {
    return 'HauntStatement(changeling=' + this.c3z_1.toString() + ')';
  }
  hashCode() {
    return this.c3z_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HauntStatement))
      return false;
    if (!this.c3z_1.equals(other.c3z_1))
      return false;
    return true;
  }
  static d3z(seen0, changeling, serializationConstructorMarker) {
    Companion_getInstance_161();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_137().a3z_1);
    }
    var $this = createThis(this);
    $this.c3z_1 = changeling;
    return $this;
  }
}
class Companion_161 {
  constructor() {
    Companion_instance_161 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e3z_1 = [lazy(tmp_0, DeceiveStatement$Companion$$childSerializers$_anonymous__msbals)];
  }
}
class $serializer_138 {
  constructor() {
    $serializer_instance_138 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DeceiveStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.f3z_1 = tmp0_serialDesc;
  }
  g3z(encoder, value) {
    var tmp0_desc = this.f3z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_162().e3z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h3z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g3z(encoder, value instanceof DeceiveStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_162().e3z_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DeceiveStatement.i3z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.f3z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_162().e3z_1[0].k3()];
  }
}
class DeceiveStatement {
  constructor(beast) {
    Companion_getInstance_162();
    this.h3z_1 = beast;
  }
  toString() {
    return 'DeceiveStatement(beast=' + this.h3z_1.toString() + ')';
  }
  hashCode() {
    return this.h3z_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DeceiveStatement))
      return false;
    if (!this.h3z_1.equals(other.h3z_1))
      return false;
    return true;
  }
  static i3z(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_162();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_138().f3z_1);
    }
    var $this = createThis(this);
    $this.h3z_1 = beast;
    return $this;
  }
}
class CardToCopyForDeceiveQuestionContext {
  constructor() {
    CardToCopyForDeceiveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j3z_1 = lazy(tmp_0, CardToCopyForDeceiveQuestionContext$_anonymous__16pb3u);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_158(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CardToCopyForDeceiveQuestionContext';
  }
  hashCode() {
    return -192029640;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardToCopyForDeceiveQuestionContext))
      return false;
    return true;
  }
}
class ChooseMesmeriseTargetStatement {
  constructor() {
    ChooseMesmeriseTargetStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k3z_1 = lazy(tmp_0, ChooseMesmeriseTargetStatement$_anonymous__ivvwgy);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_159(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ChooseMesmeriseTargetStatement';
  }
  hashCode() {
    return -1901475202;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChooseMesmeriseTargetStatement))
      return false;
    return true;
  }
}
class Companion_162 {
  constructor() {
    Companion_instance_162 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l3z_1 = [lazy(tmp_0, MesmeriseChooseEvent$Companion$$childSerializers$_anonymous__18fgfx)];
  }
}
class $serializer_139 {
  constructor() {
    $serializer_instance_139 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MesmeriseChooseEvent', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.m3z_1 = tmp0_serialDesc;
  }
  n3z(encoder, value) {
    var tmp0_desc = this.m3z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_163().l3z_1;
    tmp1_output.i15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o3z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n3z(encoder, value instanceof MesmeriseChooseEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_163().l3z_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return MesmeriseChooseEvent.p3z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m3z_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_163().l3z_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0].k3())];
  }
}
class MesmeriseChooseEvent {
  constructor(hunter) {
    Companion_getInstance_163();
    this.o3z_1 = hunter;
  }
  m37(_this__u8e3s4) {
    set_esmeriaMesmeriseTargetImpl(_this__u8e3s4, get_esmeriaBeast(_this__u8e3s4), this.o3z_1);
  }
  n37($context_GameState_t6qee5) {
    return new MesmeriseChooseEvent(get_esmeriaMesmeriseTarget($context_GameState_t6qee5, get_esmeriaBeast($context_GameState_t6qee5)));
  }
  toString() {
    return 'MesmeriseChooseEvent(hunter=' + toString_0(this.o3z_1) + ')';
  }
  hashCode() {
    return this.o3z_1 == null ? 0 : this.o3z_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MesmeriseChooseEvent))
      return false;
    if (!equals(this.o3z_1, other.o3z_1))
      return false;
    return true;
  }
  static p3z(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_163();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_139().m3z_1);
    }
    var $this = createThis(this);
    $this.o3z_1 = hunter;
    return $this;
  }
}
class EsmeriaHuntress {
  constructor() {
    EsmeriaHuntress_instance = this;
    this.q3z_1 = setOf_0([HuntmasterUpgrade_getInstance(), BlackStarUpgrade_getInstance(), PredictUpgrade_getInstance(), TrueInstinctEsmeriaHuntressUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r3z_1 = lazy(tmp_0, EsmeriaHuntress$_anonymous__yv822b);
  }
  s36() {
    return setOf_0([UnnaturalResolveCard_getInstance(), DelegateCard_getInstance(), new HuntCard(this)]);
  }
  t35() {
    return this.q3z_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_160(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EsmeriaHuntress';
  }
  hashCode() {
    return 645510437;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EsmeriaHuntress))
      return false;
    return true;
  }
}
class HuntmasterUpgrade {
  constructor() {
    HuntmasterUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s3z_1 = lazy(tmp_0, HuntmasterUpgrade$_anonymous__ilf4kw);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_161(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HuntmasterUpgrade';
  }
  hashCode() {
    return 948088962;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HuntmasterUpgrade))
      return false;
    return true;
  }
}
class BlackStarUpgrade {
  constructor() {
    BlackStarUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t3z_1 = lazy(tmp_0, BlackStarUpgrade$_anonymous__ggeyjw);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_162(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BlackStarUpgrade';
  }
  hashCode() {
    return 1286813360;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BlackStarUpgrade))
      return false;
    return true;
  }
}
class PredictUpgrade {
  constructor() {
    PredictUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u3z_1 = lazy(tmp_0, PredictUpgrade$_anonymous__jewzos);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_163(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PredictUpgrade';
  }
  hashCode() {
    return 1508011272;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PredictUpgrade))
      return false;
    return true;
  }
}
class TrueInstinctEsmeriaHuntressUpgrade {
  constructor() {
    TrueInstinctEsmeriaHuntressUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v3z_1 = lazy(tmp_0, TrueInstinctEsmeriaHuntressUpgrade$_anonymous__amlkmz);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_164(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TrueInstinctEsmeriaHuntressUpgrade';
  }
  hashCode() {
    return -1465297503;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrueInstinctEsmeriaHuntressUpgrade))
      return false;
    return true;
  }
}
class UnnaturalResolveCard {
  constructor() {
    UnnaturalResolveCard_instance = this;
    this.w3z_1 = Red_getInstance();
    this.x3z_1 = EsmeriaHuntress_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y3z_1 = lazy(tmp_0, UnnaturalResolveCard$_anonymous__ziiouj);
  }
  t37() {
    return this.x3z_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_165(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UnnaturalResolveCard';
  }
  hashCode() {
    return -1306808367;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnnaturalResolveCard))
      return false;
    return true;
  }
}
class DelegateCard {
  constructor() {
    DelegateCard_instance = this;
    this.z3z_1 = Blue_getInstance();
    this.a40_1 = EsmeriaHuntress_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b40_1 = lazy(tmp_0, DelegateCard$_anonymous__pucgma);
  }
  t37() {
    return this.a40_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_166(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DelegateCard';
  }
  hashCode() {
    return 198354298;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DelegateCard))
      return false;
    return true;
  }
}
class Companion_163 {
  constructor() {
    Companion_instance_163 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c40_1 = [lazy(tmp_0, UnnaturalResolveStatement$Companion$$childSerializers$_anonymous__3qrqpj)];
  }
}
class $serializer_140 {
  constructor() {
    $serializer_instance_140 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UnnaturalResolveStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.d40_1 = tmp0_serialDesc;
  }
  e40(encoder, value) {
    var tmp0_desc = this.d40_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_164().c40_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f40_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e40(encoder, value instanceof UnnaturalResolveStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d40_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_164().c40_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UnnaturalResolveStatement.g40(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d40_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_164().c40_1[0].k3()];
  }
}
class UnnaturalResolveStatement {
  constructor(hunter) {
    Companion_getInstance_164();
    this.f40_1 = hunter;
  }
  toString() {
    return 'UnnaturalResolveStatement(hunter=' + this.f40_1.toString() + ')';
  }
  hashCode() {
    return this.f40_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnnaturalResolveStatement))
      return false;
    if (!this.f40_1.equals(other.f40_1))
      return false;
    return true;
  }
  static g40(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_164();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_140().d40_1);
    }
    var $this = createThis(this);
    $this.f40_1 = hunter;
    return $this;
  }
}
class BlackStarStatement {
  constructor() {
    BlackStarStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h40_1 = lazy(tmp_0, BlackStarStatement$_anonymous__dopi93);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_167(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BlackStarStatement';
  }
  hashCode() {
    return 704442627;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BlackStarStatement))
      return false;
    return true;
  }
}
class Companion_164 {
  constructor() {
    Companion_instance_164 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i40_1 = [lazy(tmp_0, ChangeBlueDraftActionCardWasPlayedStatusEvent$Companion$$childSerializers$_anonymous__pk1odb), null];
  }
}
class $serializer_141 {
  constructor() {
    $serializer_instance_141 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChangeBlueDraftActionCardWasPlayedStatusEvent', this, 2);
    tmp0_serialDesc.h1b('beasts', false);
    tmp0_serialDesc.h1b('newStatus', false);
    this.j40_1 = tmp0_serialDesc;
  }
  k40(encoder, value) {
    var tmp0_desc = this.j40_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_165().i40_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l40_1);
    tmp1_output.w14(tmp0_desc, 1, value.m40_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k40(encoder, value instanceof ChangeBlueDraftActionCardWasPlayedStatusEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j40_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_165().i40_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ChangeBlueDraftActionCardWasPlayedStatusEvent.n40(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.j40_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_165().i40_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class ChangeBlueDraftActionCardWasPlayedStatusEvent {
  constructor(beasts, newStatus) {
    Companion_getInstance_165();
    this.l40_1 = beasts;
    this.m40_1 = newStatus;
  }
  m37(_this__u8e3s4) {
    var _iterator__ex2g4s = this.l40_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var beast = _iterator__ex2g4s.r1();
      set_blueDraftActionCardWasPlayedImpl(_this__u8e3s4, beast, this.m40_1);
    }
  }
  n37($context_GameState_t6qee5) {
    return new ChangeBlueDraftActionCardWasPlayedStatusEvent(this.l40_1, !this.m40_1);
  }
  toString() {
    return 'ChangeBlueDraftActionCardWasPlayedStatusEvent(beasts=' + toString(this.l40_1) + ', newStatus=' + this.m40_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.l40_1);
    result = imul(result, 31) + getBooleanHashCode(this.m40_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangeBlueDraftActionCardWasPlayedStatusEvent))
      return false;
    if (!equals(this.l40_1, other.l40_1))
      return false;
    if (!(this.m40_1 === other.m40_1))
      return false;
    return true;
  }
  static n40(seen0, beasts, newStatus, serializationConstructorMarker) {
    Companion_getInstance_165();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_141().j40_1);
    }
    var $this = createThis(this);
    $this.l40_1 = beasts;
    $this.m40_1 = newStatus;
    return $this;
  }
}
class BloodLustUpgrade {
  constructor() {
    BloodLustUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o40_1 = lazy(tmp_0, BloodLustUpgrade$_anonymous__q2rvmp);
  }
  v35($context_GameState_t6qee5) {
    return get_balanceVersion(get_gameRules($context_GameState_t6qee5)).equals(BeastBalanceVersion_OfficialV2_getInstance()) ? 3 : 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_168(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BloodLustUpgrade';
  }
  hashCode() {
    return -1112032387;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BloodLustUpgrade))
      return false;
    return true;
  }
}
class EnragedUpgrade {
  constructor() {
    EnragedUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p40_1 = lazy(tmp_0, EnragedUpgrade$_anonymous__qit8i1);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_169(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EnragedUpgrade';
  }
  hashCode() {
    return 1384719507;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EnragedUpgrade))
      return false;
    return true;
  }
}
class GreatHowlUpgrade {
  constructor() {
    GreatHowlUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q40_1 = lazy(tmp_0, GreatHowlUpgrade$_anonymous__yv0tl0);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_170(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'GreatHowlUpgrade';
  }
  hashCode() {
    return -491221928;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GreatHowlUpgrade))
      return false;
    return true;
  }
}
class HuntingGroundsUpgrade {
  constructor() {
    HuntingGroundsUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r40_1 = lazy(tmp_0, HuntingGroundsUpgrade$_anonymous__b83iaw);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_171(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HuntingGroundsUpgrade';
  }
  hashCode() {
    return 620270682;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HuntingGroundsUpgrade))
      return false;
    return true;
  }
}
class KinsPursuitUpgrade {
  constructor() {
    KinsPursuitUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s40_1 = lazy(tmp_0, KinsPursuitUpgrade$_anonymous__4q60tu);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_172(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'KinsPursuitUpgrade';
  }
  hashCode() {
    return -1875825878;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KinsPursuitUpgrade))
      return false;
    return true;
  }
}
class NaturalInstinctUpgrade {
  constructor() {
    NaturalInstinctUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t40_1 = lazy(tmp_0, NaturalInstinctUpgrade$_anonymous__mbgnc0);
  }
  v35($context_GameState_t6qee5) {
    return get_balanceVersion(get_gameRules($context_GameState_t6qee5)).equals(BeastBalanceVersion_OfficialV2_getInstance()) ? 2 : 0;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_173(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NaturalInstinctUpgrade';
  }
  hashCode() {
    return 1687628924;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NaturalInstinctUpgrade))
      return false;
    return true;
  }
}
class CullingUpgrade {
  constructor() {
    CullingUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u40_1 = lazy(tmp_0, CullingUpgrade$_anonymous__k4piq3);
  }
  v35($context_GameState_t6qee5) {
    return 0;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_174(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CullingUpgrade';
  }
  hashCode() {
    return -1565860655;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CullingUpgrade))
      return false;
    return true;
  }
}
class Fangrir {
  constructor() {
    Fangrir_instance = this;
    this.v40_1 = setOf_0([BloodLustUpgrade_getInstance(), EnragedUpgrade_getInstance(), GreatHowlUpgrade_getInstance(), HuntingGroundsUpgrade_getInstance(), KinsPursuitUpgrade_getInstance(), NaturalInstinctUpgrade_getInstance(), CullingUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w40_1 = lazy(tmp_0, Fangrir$_anonymous__adbi5s);
  }
  w36(gameState) {
    var tmp1_safe_receiver = gameState == null ? null : gameState.x40();
    var tmp2_subject = tmp1_safe_receiver == null ? null : get_balanceVersion(tmp1_safe_receiver);
    var tmp;
    switch (tmp2_subject == null ? -1 : tmp2_subject.w1_1) {
      case 0:
        tmp = 1;
        break;
      case 1:
      case -1:
        tmp = 2;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  q36() {
    return WolfType_getInstance();
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Forest_getInstance();
  }
  s36() {
    return setOf_0([SummonWolfCard_getInstance(), LurkCard_getInstance(), PreyUponCard_getInstance(), GatherThePackCard_getInstance()]);
  }
  t35() {
    return this.v40_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_175(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Fangrir';
  }
  hashCode() {
    return 1672313474;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fangrir))
      return false;
    return true;
  }
}
class WolfType {
  constructor() {
    WolfType_instance = this;
    this.y40_1 = Fangrir_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z40_1 = lazy(tmp_0, WolfType$_anonymous__fdy7dh);
  }
  r37() {
    return this.y40_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_176(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WolfType';
  }
  hashCode() {
    return -653795727;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WolfType))
      return false;
    return true;
  }
}
class SummonWolfCard {
  constructor() {
    SummonWolfCard_instance = this;
    this.a41_1 = Fangrir_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b41_1 = lazy(tmp_0, SummonWolfCard$_anonymous__knmyp8);
  }
  t37() {
    return this.a41_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_177(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonWolfCard';
  }
  hashCode() {
    return -248588664;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonWolfCard))
      return false;
    return true;
  }
}
class LurkCard {
  constructor() {
    LurkCard_instance = this;
    this.c41_1 = Red_getInstance();
    this.d41_1 = Fangrir_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e41_1 = lazy(tmp_0, LurkCard$_anonymous__ll53qd);
  }
  t37() {
    return this.d41_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_178(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LurkCard';
  }
  hashCode() {
    return -1438922377;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LurkCard))
      return false;
    return true;
  }
}
class PreyUponCard {
  constructor() {
    PreyUponCard_instance = this;
    this.f41_1 = Red_getInstance();
    this.g41_1 = Fangrir_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h41_1 = lazy(tmp_0, PreyUponCard$_anonymous__k3wig9);
  }
  t37() {
    return this.g41_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_179(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PreyUponCard';
  }
  hashCode() {
    return -1564936315;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreyUponCard))
      return false;
    return true;
  }
}
class GatherThePackCard {
  constructor() {
    GatherThePackCard_instance = this;
    this.i41_1 = Blue_getInstance();
    this.j41_1 = Fangrir_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k41_1 = lazy(tmp_0, GatherThePackCard$_anonymous__z81ozs);
  }
  t37() {
    return this.j41_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_180(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'GatherThePackCard';
  }
  hashCode() {
    return -107335878;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GatherThePackCard))
      return false;
    return true;
  }
}
class GreatHowlStatement {
  constructor() {
    GreatHowlStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l41_1 = lazy(tmp_0, GreatHowlStatement$_anonymous__cg5tfz);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_181(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'GreatHowlStatement';
  }
  hashCode() {
    return 1409514667;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GreatHowlStatement))
      return false;
    return true;
  }
}
class Fara {
  constructor() {
    Fara_instance = this;
    this.m41_1 = setOf_0([IgniteUpgrade_getInstance(), FlingUpgrade_getInstance(), DarkFlameUpgrade_getInstance(), RebirthByFireUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n41_1 = lazy(tmp_0, Fara$_anonymous__x5porx);
  }
  s36() {
    return plus_0(get_abilityCards.call(this), FlameRapierCard_getInstance());
  }
  t35() {
    return this.m41_1;
  }
  n2z($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_182(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Fara';
  }
  hashCode() {
    return 607588463;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fara))
      return false;
    return true;
  }
}
class IgniteUpgrade {
  constructor() {
    IgniteUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o41_1 = lazy(tmp_0, IgniteUpgrade$_anonymous__ofjxlx);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_183(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'IgniteUpgrade';
  }
  hashCode() {
    return -179773299;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IgniteUpgrade))
      return false;
    return true;
  }
}
class FlingUpgrade {
  constructor() {
    FlingUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p41_1 = lazy(tmp_0, FlingUpgrade$_anonymous__t7fyvd);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_184(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FlingUpgrade';
  }
  hashCode() {
    return 93702245;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FlingUpgrade))
      return false;
    return true;
  }
}
class DarkFlameUpgrade {
  constructor() {
    DarkFlameUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q41_1 = lazy(tmp_0, DarkFlameUpgrade$_anonymous__7lyox4);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_185(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DarkFlameUpgrade';
  }
  hashCode() {
    return -1607004476;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DarkFlameUpgrade))
      return false;
    return true;
  }
}
class RebirthByFireUpgrade {
  constructor() {
    RebirthByFireUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r41_1 = lazy(tmp_0, RebirthByFireUpgrade$_anonymous__7i9jv0);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_186(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RebirthByFireUpgrade';
  }
  hashCode() {
    return 164757864;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RebirthByFireUpgrade))
      return false;
    return true;
  }
}
class FlameRapierCard {
  constructor() {
    FlameRapierCard_instance = this;
    this.s41_1 = Red_getInstance();
    this.t41_1 = Fara_getInstance();
    this.u41_1 = OverloadedFlameRapierCard_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v41_1 = lazy(tmp_0, FlameRapierCard$_anonymous__cdodrz);
  }
  t37() {
    return this.t41_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_187(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FlameRapierCard';
  }
  hashCode() {
    return -1857143309;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FlameRapierCard))
      return false;
    return true;
  }
}
class OverloadedFlameRapierCard {
  constructor() {
    OverloadedFlameRapierCard_instance = this;
    this.w41_1 = Blue_getInstance();
    this.x41_1 = Fara_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y41_1 = lazy(tmp_0, OverloadedFlameRapierCard$_anonymous__2klavs);
  }
  y3k() {
    return FlameRapierCard_getInstance();
  }
  t37() {
    return this.x41_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_188(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OverloadedFlameRapierCard';
  }
  hashCode() {
    return -1955158758;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OverloadedFlameRapierCard))
      return false;
    return true;
  }
}
class Companion_165 {
  constructor() {
    Companion_instance_165 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z41_1 = [lazy(tmp_0, FlameRapierStatement$Companion$$childSerializers$_anonymous__av2n0d)];
  }
}
class $serializer_142 {
  constructor() {
    $serializer_instance_142 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FlameRapierStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.a42_1 = tmp0_serialDesc;
  }
  b42(encoder, value) {
    var tmp0_desc = this.a42_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_166().z41_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c42_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b42(encoder, value instanceof FlameRapierStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a42_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_166().z41_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return FlameRapierStatement.d42(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a42_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_166().z41_1[0].k3()];
  }
}
class FlameRapierStatement {
  constructor(hunter) {
    Companion_getInstance_166();
    this.c42_1 = hunter;
  }
  toString() {
    return 'FlameRapierStatement(hunter=' + this.c42_1.toString() + ')';
  }
  hashCode() {
    return this.c42_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FlameRapierStatement))
      return false;
    if (!this.c42_1.equals(other.c42_1))
      return false;
    return true;
  }
  static d42(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_166();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_142().a42_1);
    }
    var $this = createThis(this);
    $this.c42_1 = hunter;
    return $this;
  }
}
class Companion_166 {
  constructor() {
    Companion_instance_166 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e42_1 = [lazy(tmp_0, OverloadedFlameRapierMovementStatement$Companion$$childSerializers$_anonymous__gczn9j)];
  }
}
class $serializer_143 {
  constructor() {
    $serializer_instance_143 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OverloadedFlameRapierMovementStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.f42_1 = tmp0_serialDesc;
  }
  g42(encoder, value) {
    var tmp0_desc = this.f42_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_167().e42_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h42_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g42(encoder, value instanceof OverloadedFlameRapierMovementStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f42_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_167().e42_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return OverloadedFlameRapierMovementStatement.i42(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.f42_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_167().e42_1[0].k3()];
  }
}
class OverloadedFlameRapierMovementStatement extends MovementStepByStepStatement {
  constructor(movingObject) {
    Companion_getInstance_167();
    super();
    this.h42_1 = movingObject;
  }
  f2p() {
    return this.h42_1;
  }
  toString() {
    return 'OverloadedFlameRapierMovementStatement(movingObject=' + this.h42_1.toString() + ')';
  }
  hashCode() {
    return this.h42_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OverloadedFlameRapierMovementStatement))
      return false;
    if (!this.h42_1.equals(other.h42_1))
      return false;
    return true;
  }
  static i42(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_167();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_143().f42_1);
    }
    var $this = this.g2p(seen0, serializationConstructorMarker);
    $this.h42_1 = movingObject;
    return $this;
  }
}
class ResurrectionUpgrade {
  constructor() {
    ResurrectionUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j42_1 = lazy(tmp_0, ResurrectionUpgrade$_anonymous__iappvm);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  u35($context_GameState_t6qee5) {
    var tmp0 = get_destroyRecords($context_GameState_t6qee5);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp_0;
        if (element.p3a_1 === get_beastsGameTeam()) {
          var tmp_1 = get_objectType($context_GameState_t6qee5, element.o3a_1);
          tmp_0 = isInterface(tmp_1, AnimalType);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$0 = count;
    }
    var animalsKilled = tmp$ret$0;
    return animalsKilled >= 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_189(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ResurrectionUpgrade';
  }
  hashCode() {
    return 819336048;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResurrectionUpgrade))
      return false;
    return true;
  }
}
class OverlordUpgrade {
  constructor() {
    OverlordUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k42_1 = lazy(tmp_0, OverlordUpgrade$_anonymous__3pw22k);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  u35($context_GameState_t6qee5) {
    return get_isReborn($context_GameState_t6qee5, get_featheredKingBeast($context_GameState_t6qee5));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_190(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OverlordUpgrade';
  }
  hashCode() {
    return 369503918;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OverlordUpgrade))
      return false;
    return true;
  }
}
class RegalUpgrade {
  constructor() {
    RegalUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l42_1 = lazy(tmp_0, RegalUpgrade$_anonymous__217bba);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  u35($context_GameState_t6qee5) {
    return get_isReborn($context_GameState_t6qee5, get_featheredKingBeast($context_GameState_t6qee5));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_191(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RegalUpgrade';
  }
  hashCode() {
    return -419299166;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RegalUpgrade))
      return false;
    return true;
  }
}
class ProminenceUpgrade {
  constructor() {
    ProminenceUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m42_1 = lazy(tmp_0, ProminenceUpgrade$_anonymous__2wk9hx);
  }
  v35($context_GameState_t6qee5) {
    return 0;
  }
  u35($context_GameState_t6qee5) {
    return get_isReborn($context_GameState_t6qee5, get_featheredKingBeast($context_GameState_t6qee5));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_192(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ProminenceUpgrade';
  }
  hashCode() {
    return -1565677817;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProminenceUpgrade))
      return false;
    return true;
  }
}
class EndlessDreamUpgrade {
  constructor() {
    EndlessDreamUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n42_1 = lazy(tmp_0, EndlessDreamUpgrade$_anonymous__oytyxi);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  u35($context_GameState_t6qee5) {
    return get_isReborn($context_GameState_t6qee5, get_featheredKingBeast($context_GameState_t6qee5));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_193(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EndlessDreamUpgrade';
  }
  hashCode() {
    return -267546424;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EndlessDreamUpgrade))
      return false;
    return true;
  }
}
class WorshipUpgrade {
  constructor() {
    WorshipUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o42_1 = lazy(tmp_0, WorshipUpgrade$_anonymous__4ygknj);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  u35($context_GameState_t6qee5) {
    return get_isReborn($context_GameState_t6qee5, get_featheredKingBeast($context_GameState_t6qee5));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_194(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WorshipUpgrade';
  }
  hashCode() {
    return -1096666773;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WorshipUpgrade))
      return false;
    return true;
  }
}
class MartyrUpgrade {
  constructor() {
    MartyrUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p42_1 = lazy(tmp_0, MartyrUpgrade$_anonymous__gteu3u);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  u35($context_GameState_t6qee5) {
    return get_isReborn($context_GameState_t6qee5, get_featheredKingBeast($context_GameState_t6qee5));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_195(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'MartyrUpgrade';
  }
  hashCode() {
    return 2141926408;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MartyrUpgrade))
      return false;
    return true;
  }
}
class SoulCollectorUpgrade {
  constructor() {
    SoulCollectorUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q42_1 = lazy(tmp_0, SoulCollectorUpgrade$_anonymous__yfslcb);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  u35($context_GameState_t6qee5) {
    return get_isReborn($context_GameState_t6qee5, get_featheredKingBeast($context_GameState_t6qee5));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_196(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SoulCollectorUpgrade';
  }
  hashCode() {
    return 1302568743;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoulCollectorUpgrade))
      return false;
    return true;
  }
}
class FeatheredKing {
  constructor() {
    FeatheredKing_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r42_1 = lazy(tmp_0, FeatheredKing$_anonymous__smy5i6);
  }
  q36() {
    return DreamerType_getInstance();
  }
  u36() {
    return 3;
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Cave_getInstance();
  }
  s36() {
    return setOf_0([SummonDreamerCard_getInstance(), UnwillingSacrificeCard_getInstance(), UnburdenCard_getInstance(), UpriseCard_getInstance()]);
  }
  t35() {
    return setOf_0([ResurrectionUpgrade_getInstance(), OverlordUpgrade_getInstance(), RegalUpgrade_getInstance(), ProminenceUpgrade_getInstance(), EndlessDreamUpgrade_getInstance(), WorshipUpgrade_getInstance(), MartyrUpgrade_getInstance(), SoulCollectorUpgrade_getInstance()]);
  }
  n2z($context_GameState_t6qee5) {
    return get_isReborn($context_GameState_t6qee5, get_featheredKingBeast($context_GameState_t6qee5)) ? 4 : 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_197(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FeatheredKing';
  }
  hashCode() {
    return 29727892;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FeatheredKing))
      return false;
    return true;
  }
}
class Companion_167 {
  constructor() {
    Companion_instance_167 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s42_1 = [lazy(tmp_0, DevotionStatement$Companion$$childSerializers$_anonymous__oycrdj)];
  }
}
class $serializer_144 {
  constructor() {
    $serializer_instance_144 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DevotionStatement', this, 1);
    tmp0_serialDesc.h1b('dreamer', false);
    this.t42_1 = tmp0_serialDesc;
  }
  u42(encoder, value) {
    var tmp0_desc = this.t42_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_168().s42_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.v42_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u42(encoder, value instanceof DevotionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t42_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_168().s42_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DevotionStatement.w42(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.t42_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_168().s42_1[0].k3()];
  }
}
class DevotionStatement {
  constructor(dreamer) {
    Companion_getInstance_168();
    this.v42_1 = dreamer;
  }
  toString() {
    return 'DevotionStatement(dreamer=' + this.v42_1.toString() + ')';
  }
  hashCode() {
    return this.v42_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DevotionStatement))
      return false;
    if (!this.v42_1.equals(other.v42_1))
      return false;
    return true;
  }
  static w42(seen0, dreamer, serializationConstructorMarker) {
    Companion_getInstance_168();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_144().t42_1);
    }
    var $this = createThis(this);
    $this.v42_1 = dreamer;
    return $this;
  }
}
class ResurrectionStatement {
  constructor() {
    ResurrectionStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x42_1 = lazy(tmp_0, ResurrectionStatement$_anonymous__jnbfpt);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_198(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ResurrectionStatement';
  }
  hashCode() {
    return -1864655421;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResurrectionStatement))
      return false;
    return true;
  }
}
class DreamerType {
  constructor() {
    DreamerType_instance = this;
    this.y42_1 = FeatheredKing_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z42_1 = lazy(tmp_0, DreamerType$_anonymous__p415u5);
  }
  r37() {
    return this.y42_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_199(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DreamerType';
  }
  hashCode() {
    return -574223515;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DreamerType))
      return false;
    return true;
  }
}
class SummonDreamerCard {
  constructor() {
    SummonDreamerCard_instance = this;
    this.a43_1 = FeatheredKing_getInstance();
    this.b43_1 = Split_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c43_1 = lazy(tmp_0, SummonDreamerCard$_anonymous__mwmiug);
  }
  t37() {
    return this.a43_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_200(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonDreamerCard';
  }
  hashCode() {
    return 683734874;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonDreamerCard))
      return false;
    return true;
  }
}
class UnwillingSacrificeCard {
  constructor() {
    UnwillingSacrificeCard_instance = this;
    this.d43_1 = Red_getInstance();
    this.e43_1 = FeatheredKing_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f43_1 = lazy(tmp_0, UnwillingSacrificeCard$_anonymous__rmc6k3);
  }
  t37() {
    return this.e43_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_201(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UnwillingSacrificeCard';
  }
  hashCode() {
    return -1747066353;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnwillingSacrificeCard))
      return false;
    return true;
  }
}
class UnburdenCard {
  constructor() {
    UnburdenCard_instance = this;
    this.g43_1 = Blue_getInstance();
    this.h43_1 = FeatheredKing_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i43_1 = lazy(tmp_0, UnburdenCard$_anonymous__dpmixs);
  }
  t37() {
    return this.h43_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_202(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UnburdenCard';
  }
  hashCode() {
    return -2141769732;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnburdenCard))
      return false;
    return true;
  }
}
class UpriseCard {
  constructor() {
    UpriseCard_instance = this;
    this.j43_1 = Split_getInstance();
    this.k43_1 = FeatheredKing_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l43_1 = lazy(tmp_0, UpriseCard$_anonymous__z00t31);
  }
  t37() {
    return this.k43_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_203(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UpriseCard';
  }
  hashCode() {
    return -1544732263;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UpriseCard))
      return false;
    return true;
  }
}
class Companion_168 {
  constructor() {
    Companion_instance_168 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m43_1 = [lazy(tmp_0, StealGrudgeFromNearbyHunterStatement$Companion$$childSerializers$_anonymous__5294ph)];
  }
}
class $serializer_145 {
  constructor() {
    $serializer_instance_145 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('StealGrudgeFromNearbyHunterStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.n43_1 = tmp0_serialDesc;
  }
  o43(encoder, value) {
    var tmp0_desc = this.n43_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_169().m43_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p43_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o43(encoder, value instanceof StealGrudgeFromNearbyHunterStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_169().m43_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return StealGrudgeFromNearbyHunterStatement.q43(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.n43_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_169().m43_1[0].k3()];
  }
}
class StealGrudgeFromNearbyHunterStatement {
  constructor(beast) {
    Companion_getInstance_169();
    this.p43_1 = beast;
  }
  toString() {
    return 'StealGrudgeFromNearbyHunterStatement(beast=' + this.p43_1.toString() + ')';
  }
  hashCode() {
    return this.p43_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StealGrudgeFromNearbyHunterStatement))
      return false;
    if (!this.p43_1.equals(other.p43_1))
      return false;
    return true;
  }
  static q43(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_169();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_145().n43_1);
    }
    var $this = createThis(this);
    $this.p43_1 = beast;
    return $this;
  }
}
class Companion_169 {
  constructor() {
    Companion_instance_169 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r43_1 = [lazy(tmp_0, UpriseUpgradedStatement$Companion$$childSerializers$_anonymous__o5jsrr)];
  }
}
class $serializer_146 {
  constructor() {
    $serializer_instance_146 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UpriseUpgradedStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.s43_1 = tmp0_serialDesc;
  }
  t43(encoder, value) {
    var tmp0_desc = this.s43_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_170().r43_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u43_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t43(encoder, value instanceof UpriseUpgradedStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_170().r43_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UpriseUpgradedStatement.v43(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s43_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_170().r43_1[0].k3()];
  }
}
class UpriseUpgradedStatement extends BeastMovementStatement {
  constructor(movingObject) {
    Companion_getInstance_170();
    super();
    this.u43_1 = movingObject;
  }
  f2p() {
    return this.u43_1;
  }
  toString() {
    return 'UpriseUpgradedStatement(movingObject=' + this.u43_1.toString() + ')';
  }
  hashCode() {
    return this.u43_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UpriseUpgradedStatement))
      return false;
    if (!this.u43_1.equals(other.u43_1))
      return false;
    return true;
  }
  static v43(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_170();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_146().s43_1);
    }
    var $this = this.f2q(seen0, serializationConstructorMarker);
    $this.u43_1 = movingObject;
    return $this;
  }
}
class DreamerToSacrificeQuestionContext {
  constructor() {
    DreamerToSacrificeQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w43_1 = lazy(tmp_0, DreamerToSacrificeQuestionContext$_anonymous__usf98s);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_204(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DreamerToSacrificeQuestionContext';
  }
  hashCode() {
    return -64461058;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DreamerToSacrificeQuestionContext))
      return false;
    return true;
  }
}
class HunterToStealGrudgeQuestionContext {
  constructor() {
    HunterToStealGrudgeQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x43_1 = lazy(tmp_0, HunterToStealGrudgeQuestionContext$_anonymous__9mnjra);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_205(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToStealGrudgeQuestionContext';
  }
  hashCode() {
    return 491374242;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToStealGrudgeQuestionContext))
      return false;
    return true;
  }
}
class RedirectDamageToDreamerStatement {
  constructor() {
    RedirectDamageToDreamerStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y43_1 = lazy(tmp_0, RedirectDamageToDreamerStatement$_anonymous__3p47te);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_206(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RedirectDamageToDreamerStatement';
  }
  hashCode() {
    return -1360948086;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RedirectDamageToDreamerStatement))
      return false;
    return true;
  }
}
class Companion_170 {
  constructor() {
    Companion_instance_170 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z43_1 = [lazy(tmp_0, SacrificeToPlayDoubleDarkStatement$Companion$$childSerializers$_anonymous__69lnm)];
  }
}
class $serializer_147 {
  constructor() {
    $serializer_instance_147 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SacrificeToPlayDoubleDarkStatement', this, 1);
    tmp0_serialDesc.h1b('darkCard', false);
    this.a44_1 = tmp0_serialDesc;
  }
  b44(encoder, value) {
    var tmp0_desc = this.a44_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_171().z43_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c44_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b44(encoder, value instanceof SacrificeToPlayDoubleDarkStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a44_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_171().z43_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SacrificeToPlayDoubleDarkStatement.d44(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a44_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_171().z43_1[0].k3()];
  }
}
class SacrificeToPlayDoubleDarkStatement {
  constructor(darkCard) {
    Companion_getInstance_171();
    this.c44_1 = darkCard;
  }
  toString() {
    return 'SacrificeToPlayDoubleDarkStatement(darkCard=' + toString(this.c44_1) + ')';
  }
  hashCode() {
    return hashCode(this.c44_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SacrificeToPlayDoubleDarkStatement))
      return false;
    if (!equals(this.c44_1, other.c44_1))
      return false;
    return true;
  }
  static d44(seen0, darkCard, serializationConstructorMarker) {
    Companion_getInstance_171();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_147().a44_1);
    }
    var $this = createThis(this);
    $this.c44_1 = darkCard;
    return $this;
  }
}
class Companion_171 {}
class $serializer_148 {
  constructor() {
    $serializer_instance_148 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChangeFeatheredKingRebornStatusEvent', this, 1);
    tmp0_serialDesc.h1b('newStatus', false);
    this.e44_1 = tmp0_serialDesc;
  }
  f44(encoder, value) {
    var tmp0_desc = this.e44_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.w14(tmp0_desc, 0, value.g44_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f44(encoder, value instanceof ChangeFeatheredKingRebornStatusEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e44_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ChangeFeatheredKingRebornStatusEvent.h44(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e44_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance()];
  }
}
class ChangeFeatheredKingRebornStatusEvent {
  constructor(newStatus) {
    this.g44_1 = newStatus;
  }
  m37(_this__u8e3s4) {
    set_isRebornImpl(_this__u8e3s4, get_featheredKingBeast(_this__u8e3s4), this.g44_1);
  }
  n37($context_GameState_t6qee5) {
    return new ChangeFeatheredKingRebornStatusEvent(!this.g44_1);
  }
  toString() {
    return 'ChangeFeatheredKingRebornStatusEvent(newStatus=' + this.g44_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.g44_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangeFeatheredKingRebornStatusEvent))
      return false;
    if (!(this.g44_1 === other.g44_1))
      return false;
    return true;
  }
  static h44(seen0, newStatus, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_148().e44_1);
    }
    var $this = createThis(this);
    $this.g44_1 = newStatus;
    return $this;
  }
}
class Zone extends Enum {}
class Companion_172 {
  constructor() {
    Companion_instance_172 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_7 = lazy(tmp_6, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_2);
    var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_9 = lazy(tmp_8, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_3);
    var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_11 = lazy(tmp_10, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_4);
    var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_13 = lazy(tmp_12, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_5);
    var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_15 = lazy(tmp_14, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_6);
    var tmp_16 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_17 = lazy(tmp_16, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_7);
    var tmp_18 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i44_1 = [tmp_1, tmp_3, null, null, tmp_5, tmp_7, tmp_9, tmp_11, tmp_13, tmp_15, tmp_17, lazy(tmp_18, GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_8)];
  }
}
class $serializer_149 {
  constructor() {
    $serializer_instance_149 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GameMapImpl', this, 12);
    tmp0_serialDesc.h1b('mapId', false);
    tmp0_serialDesc.h1b('zones', false);
    tmp0_serialDesc.h1b('topLeft', false);
    tmp0_serialDesc.h1b('bottomRight', false);
    tmp0_serialDesc.h1b('locationsInit', false);
    tmp0_serialDesc.h1b('nonStandardConnections', false);
    tmp0_serialDesc.h1b('removedConnections', false);
    tmp0_serialDesc.h1b('zoneMap', false);
    tmp0_serialDesc.h1b('hiddenPathConnections', false);
    tmp0_serialDesc.h1b('namedSettlementPositions', false);
    tmp0_serialDesc.h1b('alternativeBeastStartPositions', false);
    tmp0_serialDesc.h1b('ruinPositions', false);
    this.j44_1 = tmp0_serialDesc;
  }
  k44(encoder, value) {
    var tmp0_desc = this.j44_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_173().i44_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l44_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.m44_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_100(), new BoardPosition(value.n44_1));
    tmp1_output.g15(tmp0_desc, 3, $serializer_getInstance_100(), new BoardPosition(value.o44_1));
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.p44_1);
    tmp1_output.g15(tmp0_desc, 5, tmp2_cached[5].k3(), value.q44_1);
    tmp1_output.g15(tmp0_desc, 6, tmp2_cached[6].k3(), value.r44_1);
    tmp1_output.g15(tmp0_desc, 7, tmp2_cached[7].k3(), value.s44_1);
    tmp1_output.g15(tmp0_desc, 8, tmp2_cached[8].k3(), value.t44_1);
    tmp1_output.g15(tmp0_desc, 9, tmp2_cached[9].k3(), value.u44_1);
    tmp1_output.g15(tmp0_desc, 10, tmp2_cached[10].k3(), value.v44_1);
    tmp1_output.g15(tmp0_desc, 11, tmp2_cached[11].k3(), value.w44_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k44(encoder, value instanceof GameMapImpl ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j44_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_input = decoder.p13(tmp0_desc);
    var tmp17_cached = Companion_getInstance_173().i44_1;
    if (tmp16_input.e14()) {
      tmp4_local0 = tmp16_input.b14(tmp0_desc, 0, tmp17_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.b14(tmp0_desc, 1, tmp17_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp16_input.b14(tmp0_desc, 2, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      var tmp_2 = $serializer_getInstance_100();
      var tmp_3 = tmp7_local3;
      var tmp_4 = tmp16_input.b14(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
      tmp7_local3 = tmp_4 == null ? null : tmp_4.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.b14(tmp0_desc, 4, tmp17_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.b14(tmp0_desc, 5, tmp17_cached[5].k3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.b14(tmp0_desc, 6, tmp17_cached[6].k3(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.b14(tmp0_desc, 7, tmp17_cached[7].k3(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.b14(tmp0_desc, 8, tmp17_cached[8].k3(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.b14(tmp0_desc, 9, tmp17_cached[9].k3(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.b14(tmp0_desc, 10, tmp17_cached[10].k3(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.b14(tmp0_desc, 11, tmp17_cached[11].k3(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.b14(tmp0_desc, 0, tmp17_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.b14(tmp0_desc, 1, tmp17_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_5 = $serializer_getInstance_100();
            var tmp_6 = tmp6_local2;
            var tmp_7 = tmp16_input.b14(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new BoardPosition(tmp_6));
            tmp6_local2 = tmp_7 == null ? null : tmp_7.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            var tmp_8 = $serializer_getInstance_100();
            var tmp_9 = tmp7_local3;
            var tmp_10 = tmp16_input.b14(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new BoardPosition(tmp_9));
            tmp7_local3 = tmp_10 == null ? null : tmp_10.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.b14(tmp0_desc, 4, tmp17_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.b14(tmp0_desc, 5, tmp17_cached[5].k3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.b14(tmp0_desc, 6, tmp17_cached[6].k3(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.b14(tmp0_desc, 7, tmp17_cached[7].k3(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.b14(tmp0_desc, 8, tmp17_cached[8].k3(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.b14(tmp0_desc, 9, tmp17_cached[9].k3(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.b14(tmp0_desc, 10, tmp17_cached[10].k3(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.b14(tmp0_desc, 11, tmp17_cached[11].k3(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp16_input.q13(tmp0_desc);
    return GameMapImpl.x44(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  }
  dz() {
    return this.j44_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_173().i44_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), $serializer_getInstance_100(), $serializer_getInstance_100(), tmp0_cached[4].k3(), tmp0_cached[5].k3(), tmp0_cached[6].k3(), tmp0_cached[7].k3(), tmp0_cached[8].k3(), tmp0_cached[9].k3(), tmp0_cached[10].k3(), tmp0_cached[11].k3()];
  }
}
class GameMap {}
function get_namedSettlementPositions() {
  return emptySet();
}
function get_alternativeBeastStartPositions() {
  return emptySet();
}
function get_ruinPositions() {
  return emptySet();
}
class GameMapImpl {
  constructor(mapId, zones, topLeft, bottomRight, locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, namedSettlementPositions, alternativeBeastStartPositions, ruinPositions) {
    Companion_getInstance_173();
    this.l44_1 = mapId;
    this.m44_1 = zones;
    this.n44_1 = topLeft;
    this.o44_1 = bottomRight;
    this.p44_1 = locationsInit;
    this.q44_1 = nonStandardConnections;
    this.r44_1 = removedConnections;
    this.s44_1 = zoneMap;
    this.t44_1 = hiddenPathConnections;
    this.u44_1 = namedSettlementPositions;
    this.v44_1 = alternativeBeastStartPositions;
    this.w44_1 = ruinPositions;
  }
  y44() {
    return this.l44_1;
  }
  y34() {
    return this.m44_1;
  }
  z44() {
    return this.u44_1;
  }
  a45() {
    return this.v44_1;
  }
  i3d() {
    return this.w44_1;
  }
  b45() {
    return this.p44_1.x4();
  }
  c45(position, direction, followHiddenPath) {
    if (followHiddenPath) {
      var tmp0_safe_receiver = this.t44_1.w4(new PositionAndDirection(position, direction));
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        return tmp0_safe_receiver.d45_1;
      }
    }
    var tmp1_safe_receiver = this.q44_1.w4(new PositionAndDirection(position, direction));
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp1_safe_receiver.d45_1;
    }
    if ((_BoardPosition___get_x__impl__gyx07(position) + direction.m3l_1 | 0) < _BoardPosition___get_x__impl__gyx07(this.n44_1)) {
      return null;
    }
    if ((_BoardPosition___get_x__impl__gyx07(position) + direction.m3l_1 | 0) > _BoardPosition___get_x__impl__gyx07(this.o44_1)) {
      return null;
    }
    if ((_BoardPosition___get_y__impl__tale2e(position) + direction.n3l_1 | 0) < _BoardPosition___get_y__impl__tale2e(this.n44_1)) {
      return null;
    }
    if ((_BoardPosition___get_y__impl__tale2e(position) + direction.n3l_1 | 0) > _BoardPosition___get_y__impl__tale2e(this.o44_1)) {
      return null;
    }
    var result = _BoardPosition___init__impl__1nizgq_0(_BoardPosition___get_x__impl__gyx07(position) + direction.m3l_1 | 0, _BoardPosition___get_y__impl__tale2e(position) + direction.n3l_1 | 0);
    if (this.p44_1.w4(new BoardPosition(result)) == null) {
      return null;
    }
    if (this.r44_1.w2(setOf_0([new BoardPosition(position), new BoardPosition(result)]))) {
      return null;
    }
    return result;
  }
  h3t(p) {
    return this.s44_1.w4(new BoardPosition(p));
  }
  f45(mapId, zones, topLeft, bottomRight, locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, namedSettlementPositions, alternativeBeastStartPositions, ruinPositions) {
    return new GameMapImpl(mapId, zones, topLeft, bottomRight, locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, namedSettlementPositions, alternativeBeastStartPositions, ruinPositions);
  }
  g45(mapId, zones, topLeft, bottomRight, locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, namedSettlementPositions, alternativeBeastStartPositions, ruinPositions, $super) {
    mapId = mapId === VOID ? this.l44_1 : mapId;
    zones = zones === VOID ? this.m44_1 : zones;
    topLeft = topLeft === VOID ? this.n44_1 : topLeft;
    bottomRight = bottomRight === VOID ? this.o44_1 : bottomRight;
    locationsInit = locationsInit === VOID ? this.p44_1 : locationsInit;
    nonStandardConnections = nonStandardConnections === VOID ? this.q44_1 : nonStandardConnections;
    removedConnections = removedConnections === VOID ? this.r44_1 : removedConnections;
    zoneMap = zoneMap === VOID ? this.s44_1 : zoneMap;
    hiddenPathConnections = hiddenPathConnections === VOID ? this.t44_1 : hiddenPathConnections;
    namedSettlementPositions = namedSettlementPositions === VOID ? this.u44_1 : namedSettlementPositions;
    alternativeBeastStartPositions = alternativeBeastStartPositions === VOID ? this.v44_1 : alternativeBeastStartPositions;
    ruinPositions = ruinPositions === VOID ? this.w44_1 : ruinPositions;
    return $super === VOID ? this.f45(mapId, zones, topLeft, bottomRight, locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, namedSettlementPositions, alternativeBeastStartPositions, ruinPositions) : $super.f45.call(this, mapId, zones, new BoardPosition(topLeft), new BoardPosition(bottomRight), locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, namedSettlementPositions, alternativeBeastStartPositions, ruinPositions);
  }
  toString() {
    return 'GameMapImpl(mapId=' + this.l44_1.toString() + ', zones=' + toString(this.m44_1) + ', topLeft=' + BoardPosition__toString_impl_v4mn82(this.n44_1) + ', bottomRight=' + BoardPosition__toString_impl_v4mn82(this.o44_1) + ', locationsInit=' + toString(this.p44_1) + ', nonStandardConnections=' + toString(this.q44_1) + ', removedConnections=' + toString(this.r44_1) + ', zoneMap=' + toString(this.s44_1) + ', hiddenPathConnections=' + toString(this.t44_1) + ', namedSettlementPositions=' + toString(this.u44_1) + ', alternativeBeastStartPositions=' + toString(this.v44_1) + ', ruinPositions=' + toString(this.w44_1) + ')';
  }
  hashCode() {
    var result = this.l44_1.hashCode();
    result = imul(result, 31) + hashCode(this.m44_1) | 0;
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.n44_1) | 0;
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.o44_1) | 0;
    result = imul(result, 31) + hashCode(this.p44_1) | 0;
    result = imul(result, 31) + hashCode(this.q44_1) | 0;
    result = imul(result, 31) + hashCode(this.r44_1) | 0;
    result = imul(result, 31) + hashCode(this.s44_1) | 0;
    result = imul(result, 31) + hashCode(this.t44_1) | 0;
    result = imul(result, 31) + hashCode(this.u44_1) | 0;
    result = imul(result, 31) + hashCode(this.v44_1) | 0;
    result = imul(result, 31) + hashCode(this.w44_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameMapImpl))
      return false;
    if (!this.l44_1.equals(other.l44_1))
      return false;
    if (!equals(this.m44_1, other.m44_1))
      return false;
    if (!(this.n44_1 === other.n44_1))
      return false;
    if (!(this.o44_1 === other.o44_1))
      return false;
    if (!equals(this.p44_1, other.p44_1))
      return false;
    if (!equals(this.q44_1, other.q44_1))
      return false;
    if (!equals(this.r44_1, other.r44_1))
      return false;
    if (!equals(this.s44_1, other.s44_1))
      return false;
    if (!equals(this.t44_1, other.t44_1))
      return false;
    if (!equals(this.u44_1, other.u44_1))
      return false;
    if (!equals(this.v44_1, other.v44_1))
      return false;
    if (!equals(this.w44_1, other.w44_1))
      return false;
    return true;
  }
  static x44(seen0, mapId, zones, topLeft, bottomRight, locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, namedSettlementPositions, alternativeBeastStartPositions, ruinPositions, serializationConstructorMarker) {
    Companion_getInstance_173();
    if (!(4095 === (4095 & seen0))) {
      throwMissingFieldException(seen0, 4095, $serializer_getInstance_149().j44_1);
    }
    var $this = createThis(this);
    $this.l44_1 = mapId;
    $this.m44_1 = zones;
    $this.n44_1 = topLeft;
    $this.o44_1 = bottomRight;
    $this.p44_1 = locationsInit;
    $this.q44_1 = nonStandardConnections;
    $this.r44_1 = removedConnections;
    $this.s44_1 = zoneMap;
    $this.t44_1 = hiddenPathConnections;
    $this.u44_1 = namedSettlementPositions;
    $this.v44_1 = alternativeBeastStartPositions;
    $this.w44_1 = ruinPositions;
    return $this;
  }
}
class Companion_173 {
  constructor() {
    Companion_instance_173 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, LocationInit$Companion$$childSerializers$_anonymous__66pi2t);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h45_1 = [tmp_1, lazy(tmp_2, LocationInit$Companion$$childSerializers$_anonymous__66pi2t_0)];
  }
}
class $serializer_150 {
  constructor() {
    $serializer_instance_150 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.LocationInit', this, 2);
    tmp0_serialDesc.h1b('locationType', false);
    tmp0_serialDesc.h1b('objects', false);
    this.i45_1 = tmp0_serialDesc;
  }
  j45(encoder, value) {
    var tmp0_desc = this.i45_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_174().h45_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k45_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.l45_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j45(encoder, value instanceof LocationInit ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i45_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_174().h45_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return LocationInit.m45(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.i45_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_174().h45_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class LocationInit {
  constructor(locationType, objects) {
    Companion_getInstance_174();
    this.k45_1 = locationType;
    this.l45_1 = objects;
  }
  toString() {
    return 'LocationInit(locationType=' + this.k45_1.toString() + ', objects=' + toString(this.l45_1) + ')';
  }
  hashCode() {
    var result = this.k45_1.hashCode();
    result = imul(result, 31) + hashCode(this.l45_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LocationInit))
      return false;
    if (!this.k45_1.equals(other.k45_1))
      return false;
    if (!equals(this.l45_1, other.l45_1))
      return false;
    return true;
  }
  static m45(seen0, locationType, objects, serializationConstructorMarker) {
    Companion_getInstance_174();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_150().i45_1);
    }
    var $this = createThis(this);
    $this.k45_1 = locationType;
    $this.l45_1 = objects;
    return $this;
  }
}
class LocationType extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.o32_1 = false;
  }
  q45() {
    return false;
  }
  p32(type) {
    return this.equals(type);
  }
  r45() {
    return this.o32_1;
  }
}
class LocationType$Settlement extends LocationType {
  constructor() {
    super('Settlement', 0);
    LocationType_Settlement_instance = this;
  }
  q45() {
    return true;
  }
}
class LocationType$Swamp extends LocationType {
  constructor() {
    super('Swamp', 1);
    LocationType_Swamp_instance = this;
  }
  q45() {
    return true;
  }
}
class LocationType$Forest extends LocationType {
  constructor() {
    super('Forest', 2);
    LocationType_Forest_instance = this;
  }
  q45() {
    return true;
  }
}
class LocationType$Cave extends LocationType {
  constructor() {
    super('Cave', 3);
    LocationType_Cave_instance = this;
  }
  q45() {
    return true;
  }
}
class LocationType$AbyssalSwamp extends LocationType {
  constructor() {
    super('AbyssalSwamp', 4);
    LocationType_AbyssalSwamp_instance = this;
  }
  p32(type) {
    return type.equals(this) || type.equals(LocationType_Swamp_getInstance());
  }
  r45() {
    return true;
  }
  q45() {
    return true;
  }
}
class LocationType$AbyssalForest extends LocationType {
  constructor() {
    super('AbyssalForest', 5);
    LocationType_AbyssalForest_instance = this;
  }
  p32(type) {
    return type.equals(this) || type.equals(LocationType_Forest_getInstance());
  }
  r45() {
    return true;
  }
  q45() {
    return true;
  }
}
class LocationType$AbyssalCave extends LocationType {
  constructor() {
    super('AbyssalCave', 6);
    LocationType_AbyssalCave_instance = this;
  }
  p32(type) {
    return type.equals(this) || type.equals(LocationType_Cave_getInstance());
  }
  r45() {
    return true;
  }
  q45() {
    return true;
  }
}
class LocationType$LivingWeb extends LocationType {
  constructor() {
    super('LivingWeb', 7);
    LocationType_LivingWeb_instance = this;
  }
  p32(type) {
    return type.equals(this) || type.equals(LocationType_Cave_getInstance());
  }
  q45() {
    return true;
  }
}
class LocationType$CaveAndForest extends LocationType {
  constructor() {
    super('CaveAndForest', 8);
    LocationType_CaveAndForest_instance = this;
  }
  p32(type) {
    return type.equals(this) || type.equals(LocationType_Forest_getInstance()) || type.equals(LocationType_Cave_getInstance());
  }
}
class LocationType$SwampAndForest extends LocationType {
  constructor() {
    super('SwampAndForest', 9);
    LocationType_SwampAndForest_instance = this;
  }
  p32(type) {
    return type.equals(this) || type.equals(LocationType_Swamp_getInstance()) || type.equals(LocationType_Forest_getInstance());
  }
}
class LocationType$SwampAndCave extends LocationType {
  constructor() {
    super('SwampAndCave', 10);
    LocationType_SwampAndCave_instance = this;
  }
  p32(type) {
    return type.equals(this) || type.equals(LocationType_Swamp_getInstance()) || type.equals(LocationType_Cave_getInstance());
  }
}
class LocationType$LairOfTheBeast extends LocationType {
  constructor() {
    super('LairOfTheBeast', 11);
    LocationType_LairOfTheBeast_instance = this;
  }
  p32(type) {
    return type.equals(this) || type.equals(LocationType_Swamp_getInstance()) || type.equals(LocationType_Forest_getInstance()) || type.equals(LocationType_Cave_getInstance());
  }
}
class LocationType$None extends LocationType {
  constructor() {
    super('None', 12);
    LocationType_None_instance = this;
  }
  p32(type) {
    return false;
  }
}
class GameMapId extends Enum {}
class Companion_174 {}
class $serializer_151 {
  constructor() {
    $serializer_instance_151 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.PositionAndDirection', this, 2);
    tmp0_serialDesc.h1b('position', false);
    tmp0_serialDesc.h1b('direction', false);
    this.c47_1 = tmp0_serialDesc;
  }
  d47(encoder, value) {
    var tmp0_desc = this.c47_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.d45_1));
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_101(), value.e45_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d47(encoder, value instanceof PositionAndDirection ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c47_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_101(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_101(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PositionAndDirection.e47(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.c47_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100(), $serializer_getInstance_101()];
  }
}
class PositionAndDirection {
  constructor(position, direction) {
    this.d45_1 = position;
    this.e45_1 = direction;
  }
  toString() {
    return 'PositionAndDirection(position=' + BoardPosition__toString_impl_v4mn82(this.d45_1) + ', direction=' + this.e45_1.toString() + ')';
  }
  hashCode() {
    var result = BoardPosition__hashCode_impl_9dgqf7(this.d45_1);
    result = imul(result, 31) + this.e45_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PositionAndDirection))
      return false;
    if (!(this.d45_1 === other.d45_1))
      return false;
    if (!this.e45_1.equals(other.e45_1))
      return false;
    return true;
  }
  static e47(seen0, position, direction, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_151().c47_1);
    }
    var $this = createThis(this);
    $this.d45_1 = position;
    $this.e45_1 = direction;
    return $this;
  }
}
class StaticNearbyAdjuster {
  constructor(p, type) {
    this.f47_1 = p;
    this.g47_1 = type;
  }
  s2w($context_GameState_t6qee5) {
    return this.f47_1;
  }
  l32($context_GameState_t6qee5) {
    return this.g47_1;
  }
}
class Companion_175 {
  i47(typeSerial0) {
    var tmp = getKClass(GameQuestion);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AncientPowerNumberQuestion), getKClass(BeastMovementCardQuestion), getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion), getKClass(CardPlayColorQuestion), getKClass(ChooseCardOnDraftQuestion), getKClass(ChooseCardsQuestion), getKClass(ChooseCharacterQuestion), getKClass(ContinueAfterRecoveryQuestion), getKClass(DestinationQuestion), getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion), getKClass(LocationTypeQuestion), getKClass(ObjectsGameQuestion), getKClass(PhaseRecoveryQuestion), getKClass(PlayCardInTurnQuestion), getKClass(SnareTypeQuestion), getKClass(StatementQuestion), getKClass(TrapByNumberQuestion), getKClass(TriggersQuestion), getKClass(UpgradeQuestion), getKClass(UrgullMoltEggsToReturnQuestion), getKClass(ZoneQuestion)];
    var tmp_1 = $serializer_getInstance_152();
    var tmp_2 = $serializer_getInstance_153();
    var tmp_3 = PlaceHatchlingWithInfestQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_4 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_3, tmp$ret$3);
    var tmp_5 = PlayOverloadedQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_6 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_5, tmp$ret$6);
    var tmp_7 = RevealToMoveQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_8 = ObjectSerializer.l1c('RevealToMoveQuestion', tmp_7, tmp$ret$9);
    var tmp_9 = $serializer_getInstance_345();
    var tmp_10 = $serializer_getInstance_428();
    var tmp_11 = $serializer_getInstance_154();
    var tmp_12 = CardPlayColorQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_13 = ObjectSerializer.l1c('CardPlayColorQuestion', tmp_12, tmp$ret$12);
    var tmp_14 = $serializer_getInstance_155();
    var tmp_15 = $serializer_getInstance_156();
    var tmp_16 = $serializer_getInstance_157();
    var tmp_17 = ContinueAfterRecoveryQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_18 = ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp_17, tmp$ret$15);
    var tmp_19 = $serializer_getInstance_158();
    var tmp_20 = $serializer_getInstance_110();
    var tmp_21 = $serializer_getInstance_159();
    var tmp_22 = $serializer_getInstance_160();
    var tmp_23 = $serializer_getInstance_161();
    var tmp_24 = $serializer_getInstance_162();
    var tmp_25 = $serializer_getInstance_163();
    var tmp_26 = $serializer_getInstance_164();
    var tmp_27 = getKClass(ObjectOnBoardType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_28 = [tmp_1, tmp_2, tmp_4, tmp_6, tmp_8, tmp_9, tmp_10, tmp_11, tmp_13, tmp_14, tmp_15, tmp_16, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, $serializer_165.l47(PolymorphicSerializer.vz(tmp_27, tmp$ret$18)), $serializer_getInstance_165(), $serializer_getInstance_166(), $serializer_getInstance_362(), $serializer_getInstance_167(), $serializer_getInstance_168(), $serializer_getInstance_169(), $serializer_getInstance_170(), $serializer_getInstance_413(), $serializer_getInstance_171()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    return SealedClassSerializer.i10('steelart.beast.GameQuestion', tmp, tmp_0, tmp_28, tmp$ret$24);
  }
  m1c(typeParamsSerializers) {
    return this.i47(typeParamsSerializers[0]);
  }
}
class Companion_176 {}
class $serializer_152 {
  constructor() {
    $serializer_instance_152 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AncientPowerNumberQuestion', this, 1);
    tmp0_serialDesc.h1b('ancientPowerNumber', false);
    this.m47_1 = tmp0_serialDesc;
  }
  n47(encoder, value) {
    var tmp0_desc = this.m47_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.o47_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n47(encoder, value instanceof AncientPowerNumberQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m47_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AncientPowerNumberQuestion.p47(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m47_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class AncientPowerNumberQuestion {
  constructor(ancientPowerNumber) {
    this.o47_1 = ancientPowerNumber;
  }
  s3o() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = numberRangeToNumber(0, this.o47_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.n3_1;
    var last = this_0.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$2 = item;
        destination.d2(tmp$ret$2);
      }
       while (!(item === last));
    return toLinkedSet(destination);
  }
  toString() {
    return 'AncientPowerNumberQuestion(ancientPowerNumber=' + this.o47_1 + ')';
  }
  hashCode() {
    return this.o47_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AncientPowerNumberQuestion))
      return false;
    if (!(this.o47_1 === other.o47_1))
      return false;
    return true;
  }
  static p47(seen0, ancientPowerNumber, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_152().m47_1);
    }
    var $this = createThis(this);
    $this.o47_1 = ancientPowerNumber;
    return $this;
  }
}
class Companion_177 {
  constructor() {
    Companion_instance_177 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, BeastMovementCardQuestion$Companion$$childSerializers$_anonymous__umuinu);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q47_1 = [tmp_1, lazy(tmp_2, BeastMovementCardQuestion$Companion$$childSerializers$_anonymous__umuinu_0)];
  }
}
class $serializer_153 {
  constructor() {
    $serializer_instance_153 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeastMovementCardQuestion', this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('questionContext', true);
    this.r47_1 = tmp0_serialDesc;
  }
  s47(encoder, value) {
    var tmp0_desc = this.r47_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_178().q47_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t47_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !equals(value.u47_1, BeastMovementCardQuestionContext_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.u47_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s47(encoder, value instanceof BeastMovementCardQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r47_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_178().q47_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BeastMovementCardQuestion.v47(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r47_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_178().q47_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class BeastMovementCardQuestion {
  constructor(variants, questionContext) {
    Companion_getInstance_178();
    questionContext = questionContext === VOID ? BeastMovementCardQuestionContext_getInstance() : questionContext;
    this.t47_1 = variants;
    this.u47_1 = questionContext;
  }
  s3o() {
    return this.t47_1;
  }
  t3o() {
    return this.u47_1;
  }
  toString() {
    return 'BeastMovementCardQuestion(variants=' + this.t47_1.toString() + ', questionContext=' + toString(this.u47_1) + ')';
  }
  hashCode() {
    var result = this.t47_1.hashCode();
    result = imul(result, 31) + hashCode(this.u47_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastMovementCardQuestion))
      return false;
    if (!this.t47_1.equals(other.t47_1))
      return false;
    if (!equals(this.u47_1, other.u47_1))
      return false;
    return true;
  }
  static v47(seen0, variants, questionContext, serializationConstructorMarker) {
    Companion_getInstance_178();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_153().r47_1);
    }
    var $this = createThis(this);
    $this.t47_1 = variants;
    if (0 === (seen0 & 2))
      $this.u47_1 = BeastMovementCardQuestionContext_getInstance();
    else
      $this.u47_1 = questionContext;
    return $this;
  }
}
class BooleanGameQuestion {}
function get_variants() {
  return LinkedHashSet.z2(setOf_0([true, false]));
}
class PlayOverloadedQuestion {
  constructor() {
    PlayOverloadedQuestion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w47_1 = lazy(tmp_0, PlayOverloadedQuestion$_anonymous__uokst8);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_207(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PlayOverloadedQuestion';
  }
  hashCode() {
    return 1428432952;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayOverloadedQuestion))
      return false;
    return true;
  }
}
class RevealToMoveQuestion {
  constructor() {
    RevealToMoveQuestion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x47_1 = lazy(tmp_0, RevealToMoveQuestion$_anonymous__dh7t1k);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_208(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RevealToMoveQuestion';
  }
  hashCode() {
    return 1948750948;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealToMoveQuestion))
      return false;
    return true;
  }
}
class Companion_178 {}
class $serializer_154 {
  constructor() {
    $serializer_instance_154 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UseVackerSoulsQuestion', this, 1);
    tmp0_serialDesc.h1b('soulsToBeSpend', false);
    this.y47_1 = tmp0_serialDesc;
  }
  z47(encoder, value) {
    var tmp0_desc = this.y47_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.a48_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z47(encoder, value instanceof UseVackerSoulsQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y47_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UseVackerSoulsQuestion.b48(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y47_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class UseVackerSoulsQuestion {
  constructor(soulsToBeSpend) {
    this.a48_1 = soulsToBeSpend;
  }
  toString() {
    return 'UseVackerSoulsQuestion(soulsToBeSpend=' + this.a48_1 + ')';
  }
  hashCode() {
    return this.a48_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UseVackerSoulsQuestion))
      return false;
    if (!(this.a48_1 === other.a48_1))
      return false;
    return true;
  }
  static b48(seen0, soulsToBeSpend, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_154().y47_1);
    }
    var $this = createThis(this);
    $this.a48_1 = soulsToBeSpend;
    return $this;
  }
}
class CardPlayColorQuestion {
  constructor() {
    CardPlayColorQuestion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c48_1 = lazy(tmp_0, CardPlayColorQuestion$_anonymous__jlung2);
  }
  s3o() {
    return LinkedHashSet.z2(setOf_0([Red_getInstance(), Blue_getInstance()]));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_209(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CardPlayColorQuestion';
  }
  hashCode() {
    return -502778176;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardPlayColorQuestion))
      return false;
    return true;
  }
}
class Companion_179 {
  constructor() {
    Companion_instance_179 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d48_1 = [lazy(tmp_0, ChooseCardOnDraftQuestion$Companion$$childSerializers$_anonymous__yd84yx)];
  }
}
class $serializer_155 {
  constructor() {
    $serializer_instance_155 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChooseCardOnDraftQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.e48_1 = tmp0_serialDesc;
  }
  f48(encoder, value) {
    var tmp0_desc = this.e48_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_180().d48_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g48_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f48(encoder, value instanceof ChooseCardOnDraftQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e48_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_180().d48_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ChooseCardOnDraftQuestion.h48(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e48_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_180().d48_1[0].k3()];
  }
}
class ChooseCardOnDraftQuestion {
  constructor(variants) {
    Companion_getInstance_180();
    this.g48_1 = variants;
  }
  s3o() {
    return this.g48_1;
  }
  toString() {
    return 'ChooseCardOnDraftQuestion(variants=' + this.g48_1.toString() + ')';
  }
  hashCode() {
    return this.g48_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChooseCardOnDraftQuestion))
      return false;
    if (!this.g48_1.equals(other.g48_1))
      return false;
    return true;
  }
  static h48(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_180();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_155().e48_1);
    }
    var $this = createThis(this);
    $this.g48_1 = variants;
    return $this;
  }
}
class Companion_180 {
  constructor() {
    Companion_instance_180 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, ChooseCardsQuestion$Companion$$childSerializers$_anonymous__c4ninc);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i48_1 = [tmp_1, lazy(tmp_2, ChooseCardsQuestion$Companion$$childSerializers$_anonymous__c4ninc_0)];
  }
}
class $serializer_156 {
  constructor() {
    $serializer_instance_156 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChooseCardsQuestion', this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('questionContext', false);
    this.j48_1 = tmp0_serialDesc;
  }
  k48(encoder, value) {
    var tmp0_desc = this.j48_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_181().i48_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l48_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.m48_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k48(encoder, value instanceof ChooseCardsQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j48_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_181().i48_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ChooseCardsQuestion.n48(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.j48_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_181().i48_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class ChooseCardsQuestion {
  constructor(variants, questionContext) {
    Companion_getInstance_181();
    this.l48_1 = variants;
    this.m48_1 = questionContext;
  }
  s3o() {
    return this.l48_1;
  }
  t3o() {
    return this.m48_1;
  }
  toString() {
    return 'ChooseCardsQuestion(variants=' + this.l48_1.toString() + ', questionContext=' + toString(this.m48_1) + ')';
  }
  hashCode() {
    var result = this.l48_1.hashCode();
    result = imul(result, 31) + hashCode(this.m48_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChooseCardsQuestion))
      return false;
    if (!this.l48_1.equals(other.l48_1))
      return false;
    if (!equals(this.m48_1, other.m48_1))
      return false;
    return true;
  }
  static n48(seen0, variants, questionContext, serializationConstructorMarker) {
    Companion_getInstance_181();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_156().j48_1);
    }
    var $this = createThis(this);
    $this.l48_1 = variants;
    $this.m48_1 = questionContext;
    return $this;
  }
}
class Companion_181 {
  constructor() {
    Companion_instance_181 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o48_1 = [lazy(tmp_0, ChooseCharacterQuestion$Companion$$childSerializers$_anonymous__rg1w8e)];
  }
}
class $serializer_157 {
  constructor() {
    $serializer_instance_157 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChooseCharacterQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.p48_1 = tmp0_serialDesc;
  }
  q48(encoder, value) {
    var tmp0_desc = this.p48_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_182().o48_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r48_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q48(encoder, value instanceof ChooseCharacterQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p48_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_182().o48_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ChooseCharacterQuestion.s48(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.p48_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_182().o48_1[0].k3()];
  }
}
class ChooseCharacterQuestion {
  constructor(variants) {
    Companion_getInstance_182();
    this.r48_1 = variants;
  }
  s3o() {
    return this.r48_1;
  }
  toString() {
    return 'ChooseCharacterQuestion(variants=' + this.r48_1.toString() + ')';
  }
  hashCode() {
    return this.r48_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChooseCharacterQuestion))
      return false;
    if (!this.r48_1.equals(other.r48_1))
      return false;
    return true;
  }
  static s48(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_182();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_157().p48_1);
    }
    var $this = createThis(this);
    $this.r48_1 = variants;
    return $this;
  }
}
class ContinueAfterRecoveryQuestion {
  constructor() {
    ContinueAfterRecoveryQuestion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t48_1 = lazy(tmp_0, ContinueAfterRecoveryQuestion$_anonymous__vcbvd);
  }
  s3o() {
    return linkedSetOf([true]);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_210(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ContinueAfterRecoveryQuestion';
  }
  hashCode() {
    return -2005377653;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ContinueAfterRecoveryQuestion))
      return false;
    return true;
  }
}
class Companion_182 {
  constructor() {
    Companion_instance_182 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, DestinationQuestion$Companion$$childSerializers$_anonymous__xe82wa);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, DestinationQuestion$Companion$$childSerializers$_anonymous__xe82wa_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u48_1 = [tmp_1, tmp_3, lazy(tmp_4, DestinationQuestion$Companion$$childSerializers$_anonymous__xe82wa_1), null];
  }
}
class $serializer_158 {
  constructor() {
    $serializer_instance_158 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DestinationQuestion', this, 4);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('movedObject', false);
    tmp0_serialDesc.h1b('pathByNow', false);
    tmp0_serialDesc.h1b('isFalseMovement', true);
    this.v48_1 = tmp0_serialDesc;
  }
  w48(encoder, value) {
    var tmp0_desc = this.v48_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_183().u48_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x48_1);
    tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.y48_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.z48_1);
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.a49_1 === false)) {
      tmp1_output.w14(tmp0_desc, 3, value.a49_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w48(encoder, value instanceof DestinationQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v48_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_183().u48_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.d14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.r13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.d14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.r13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return DestinationQuestion.b49(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.v48_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_183().u48_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), get_nullable(tmp0_cached[1].k3()), tmp0_cached[2].k3(), BooleanSerializer_getInstance()];
  }
}
class DestinationQuestion {
  constructor(variants, movedObject, pathByNow, isFalseMovement) {
    Companion_getInstance_183();
    isFalseMovement = isFalseMovement === VOID ? false : isFalseMovement;
    this.x48_1 = variants;
    this.y48_1 = movedObject;
    this.z48_1 = pathByNow;
    this.a49_1 = isFalseMovement;
  }
  s3o() {
    return this.x48_1;
  }
  toString() {
    return 'DestinationQuestion(variants=' + this.x48_1.toString() + ', movedObject=' + toString_0(this.y48_1) + ', pathByNow=' + toString(this.z48_1) + ', isFalseMovement=' + this.a49_1 + ')';
  }
  hashCode() {
    var result = this.x48_1.hashCode();
    result = imul(result, 31) + (this.y48_1 == null ? 0 : this.y48_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.z48_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a49_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DestinationQuestion))
      return false;
    if (!this.x48_1.equals(other.x48_1))
      return false;
    if (!equals(this.y48_1, other.y48_1))
      return false;
    if (!equals(this.z48_1, other.z48_1))
      return false;
    if (!(this.a49_1 === other.a49_1))
      return false;
    return true;
  }
  static b49(seen0, variants, movedObject, pathByNow, isFalseMovement, serializationConstructorMarker) {
    Companion_getInstance_183();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_158().v48_1);
    }
    var $this = createThis(this);
    $this.x48_1 = variants;
    $this.y48_1 = movedObject;
    $this.z48_1 = pathByNow;
    if (0 === (seen0 & 8))
      $this.a49_1 = false;
    else
      $this.a49_1 = isFalseMovement;
    return $this;
  }
}
class Companion_183 {
  constructor() {
    Companion_instance_183 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c49_1 = [lazy(tmp_0, GrapnelQuestion$Companion$$childSerializers$_anonymous__66h09j)];
  }
}
class $serializer_159 {
  constructor() {
    $serializer_instance_159 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GrapnelQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.d49_1 = tmp0_serialDesc;
  }
  e49(encoder, value) {
    var tmp0_desc = this.d49_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_184().c49_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f49_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e49(encoder, value instanceof GrapnelQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d49_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_184().c49_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GrapnelQuestion.g49(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d49_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_184().c49_1[0].k3()];
  }
}
class GrapnelQuestion {
  constructor(variants) {
    Companion_getInstance_184();
    this.f49_1 = variants;
  }
  s3o() {
    return this.f49_1;
  }
  toString() {
    return 'GrapnelQuestion(variants=' + this.f49_1.toString() + ')';
  }
  hashCode() {
    return this.f49_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GrapnelQuestion))
      return false;
    if (!this.f49_1.equals(other.f49_1))
      return false;
    return true;
  }
  static g49(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_184();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_159().d49_1);
    }
    var $this = createThis(this);
    $this.f49_1 = variants;
    return $this;
  }
}
class Companion_184 {
  constructor() {
    Companion_instance_184 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, LocationQuestion$Companion$$childSerializers$_anonymous__esqxld);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h49_1 = [tmp_1, lazy(tmp_2, LocationQuestion$Companion$$childSerializers$_anonymous__esqxld_0)];
  }
}
class $serializer_160 {
  constructor() {
    $serializer_instance_160 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LocationQuestion', this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('questionContext', false);
    this.i49_1 = tmp0_serialDesc;
  }
  j49(encoder, value) {
    var tmp0_desc = this.i49_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_185().h49_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k49_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.l49_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j49(encoder, value instanceof LocationQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i49_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_185().h49_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return LocationQuestion.m49(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.i49_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_185().h49_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class LocationQuestion {
  constructor(variants, questionContext) {
    Companion_getInstance_185();
    this.k49_1 = variants;
    this.l49_1 = questionContext;
  }
  s3o() {
    return this.k49_1;
  }
  t3o() {
    return this.l49_1;
  }
  toString() {
    return 'LocationQuestion(variants=' + this.k49_1.toString() + ', questionContext=' + toString(this.l49_1) + ')';
  }
  hashCode() {
    var result = this.k49_1.hashCode();
    result = imul(result, 31) + hashCode(this.l49_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LocationQuestion))
      return false;
    if (!this.k49_1.equals(other.k49_1))
      return false;
    if (!equals(this.l49_1, other.l49_1))
      return false;
    return true;
  }
  static m49(seen0, variants, questionContext, serializationConstructorMarker) {
    Companion_getInstance_185();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_160().i49_1);
    }
    var $this = createThis(this);
    $this.k49_1 = variants;
    $this.l49_1 = questionContext;
    return $this;
  }
}
class Companion_185 {
  constructor() {
    Companion_instance_185 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, PlaceNewObjectQuestion$Companion$$childSerializers$_anonymous__jk1a3w);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n49_1 = [tmp_1, lazy(tmp_2, PlaceNewObjectQuestion$Companion$$childSerializers$_anonymous__jk1a3w_0)];
  }
}
class $serializer_161 {
  constructor() {
    $serializer_instance_161 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceNewObjectQuestion', this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('newObjectType', false);
    this.o49_1 = tmp0_serialDesc;
  }
  p49(encoder, value) {
    var tmp0_desc = this.o49_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_186().n49_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q49_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.r49_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p49(encoder, value instanceof PlaceNewObjectQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o49_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_186().n49_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlaceNewObjectQuestion.s49(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.o49_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_186().n49_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class PlaceNewObjectQuestion {
  constructor(variants, newObjectType) {
    Companion_getInstance_186();
    this.q49_1 = variants;
    this.r49_1 = newObjectType;
  }
  s3o() {
    return this.q49_1;
  }
  toString() {
    return 'PlaceNewObjectQuestion(variants=' + this.q49_1.toString() + ', newObjectType=' + toString(this.r49_1) + ')';
  }
  hashCode() {
    var result = this.q49_1.hashCode();
    result = imul(result, 31) + hashCode(this.r49_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceNewObjectQuestion))
      return false;
    if (!this.q49_1.equals(other.q49_1))
      return false;
    if (!equals(this.r49_1, other.r49_1))
      return false;
    return true;
  }
  static s49(seen0, variants, newObjectType, serializationConstructorMarker) {
    Companion_getInstance_186();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_161().o49_1);
    }
    var $this = createThis(this);
    $this.q49_1 = variants;
    $this.r49_1 = newObjectType;
    return $this;
  }
}
class Companion_186 {
  constructor() {
    Companion_instance_186 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t49_1 = [lazy(tmp_0, SearchLocationQuestion$Companion$$childSerializers$_anonymous__mt5aop)];
  }
}
class $serializer_162 {
  constructor() {
    $serializer_instance_162 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SearchLocationQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.u49_1 = tmp0_serialDesc;
  }
  v49(encoder, value) {
    var tmp0_desc = this.u49_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_187().t49_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w49_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v49(encoder, value instanceof SearchLocationQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u49_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_187().t49_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SearchLocationQuestion.x49(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.u49_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_187().t49_1[0].k3()];
  }
}
class SearchLocationQuestion {
  constructor(variants) {
    Companion_getInstance_187();
    this.w49_1 = variants;
  }
  s3o() {
    return this.w49_1;
  }
  toString() {
    return 'SearchLocationQuestion(variants=' + this.w49_1.toString() + ')';
  }
  hashCode() {
    return this.w49_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SearchLocationQuestion))
      return false;
    if (!this.w49_1.equals(other.w49_1))
      return false;
    return true;
  }
  static x49(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_187();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_162().u49_1);
    }
    var $this = createThis(this);
    $this.w49_1 = variants;
    return $this;
  }
}
class Companion_187 {
  constructor() {
    Companion_instance_187 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y49_1 = [lazy(tmp_0, TransformLocationQuestion$Companion$$childSerializers$_anonymous__a36kf1)];
  }
}
class $serializer_163 {
  constructor() {
    $serializer_instance_163 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TransformLocationQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.z49_1 = tmp0_serialDesc;
  }
  a4a(encoder, value) {
    var tmp0_desc = this.z49_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_188().y49_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.b4a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a4a(encoder, value instanceof TransformLocationQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z49_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_188().y49_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return TransformLocationQuestion.c4a(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.z49_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_188().y49_1[0].k3()];
  }
}
class TransformLocationQuestion {
  constructor(variants) {
    Companion_getInstance_188();
    this.b4a_1 = variants;
  }
  s3o() {
    return this.b4a_1;
  }
  toString() {
    return 'TransformLocationQuestion(variants=' + this.b4a_1.toString() + ')';
  }
  hashCode() {
    return this.b4a_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TransformLocationQuestion))
      return false;
    if (!this.b4a_1.equals(other.b4a_1))
      return false;
    return true;
  }
  static c4a(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_188();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_163().z49_1);
    }
    var $this = createThis(this);
    $this.b4a_1 = variants;
    return $this;
  }
}
class Companion_188 {
  constructor() {
    Companion_instance_188 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d4a_1 = [lazy(tmp_0, LocationTypeQuestion$Companion$$childSerializers$_anonymous__34stpn)];
  }
}
class $serializer_164 {
  constructor() {
    $serializer_instance_164 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LocationTypeQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.e4a_1 = tmp0_serialDesc;
  }
  f4a(encoder, value) {
    var tmp0_desc = this.e4a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_189().d4a_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g4a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f4a(encoder, value instanceof LocationTypeQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e4a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_189().d4a_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return LocationTypeQuestion.h4a(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e4a_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_189().d4a_1[0].k3()];
  }
}
class LocationTypeQuestion {
  constructor(variants) {
    Companion_getInstance_189();
    this.g4a_1 = variants;
  }
  s3o() {
    return this.g4a_1;
  }
  toString() {
    return 'LocationTypeQuestion(variants=' + this.g4a_1.toString() + ')';
  }
  hashCode() {
    return this.g4a_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LocationTypeQuestion))
      return false;
    if (!this.g4a_1.equals(other.g4a_1))
      return false;
    return true;
  }
  static h4a(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_189();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_164().e4a_1);
    }
    var $this = createThis(this);
    $this.g4a_1 = variants;
    return $this;
  }
}
class Companion_189 {
  constructor() {
    Companion_instance_189 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i4a_1 = [null, lazy(tmp_0, ObjectsGameQuestion$Companion$$childSerializers$_anonymous__myxfem)];
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ObjectsGameQuestion', null, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('questionContext', false);
    this.j4a_1 = tmp0_serialDesc;
  }
  i47(typeSerial0) {
    return $serializer_165.l47(typeSerial0);
  }
  m1c(typeParamsSerializers) {
    return this.i47(typeParamsSerializers[0]);
  }
}
class $serializer_165 {
  constructor() {
    return new.target.k4a();
  }
  static k4a() {
    var $this = createThis(this);
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ObjectsGameQuestion', $this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('questionContext', false);
    $this.j47_1 = tmp0_serialDesc;
    return $this;
  }
  l4a(encoder, value) {
    var tmp0_desc = this.j47_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_190().i4a_1;
    tmp1_output.g15(tmp0_desc, 0, new LinkedHashSetSerializer($serializer_364.y2o(this.k47_1)), value.m4a_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.n4a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l4a(encoder, value instanceof ObjectsGameQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j47_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_190().i4a_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, new LinkedHashSetSerializer($serializer_364.y2o(this.k47_1)), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, new LinkedHashSetSerializer($serializer_364.y2o(this.k47_1)), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ObjectsGameQuestion.o4a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.j47_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_190().i4a_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new LinkedHashSetSerializer($serializer_364.y2o(this.k47_1)), tmp0_cached[1].k3()];
  }
  z1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.k47_1];
  }
  static l47(typeSerial0) {
    var $this = this.k4a();
    $this.k47_1 = typeSerial0;
    return $this;
  }
}
class ObjectsGameQuestion {
  constructor(variants, questionContext) {
    Companion_getInstance_190();
    this.m4a_1 = variants;
    this.n4a_1 = questionContext;
  }
  s3o() {
    return this.m4a_1;
  }
  t3o() {
    return this.n4a_1;
  }
  toString() {
    return 'ObjectsGameQuestion(variants=' + this.m4a_1.toString() + ', questionContext=' + toString(this.n4a_1) + ')';
  }
  hashCode() {
    var result = this.m4a_1.hashCode();
    result = imul(result, 31) + hashCode(this.n4a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ObjectsGameQuestion))
      return false;
    if (!this.m4a_1.equals(other.m4a_1))
      return false;
    if (!equals(this.n4a_1, other.n4a_1))
      return false;
    return true;
  }
  static o4a(seen0, variants, questionContext, serializationConstructorMarker) {
    Companion_getInstance_190();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, Companion_getInstance_190().j4a_1);
    }
    var $this = createThis(this);
    $this.m4a_1 = variants;
    $this.n4a_1 = questionContext;
    return $this;
  }
}
class Companion_190 {
  constructor() {
    Companion_instance_190 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p4a_1 = [lazy(tmp_0, PhaseRecoveryQuestion$Companion$$childSerializers$_anonymous__psknck)];
  }
}
class $serializer_166 {
  constructor() {
    $serializer_instance_165 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PhaseRecoveryQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.q4a_1 = tmp0_serialDesc;
  }
  r4a(encoder, value) {
    var tmp0_desc = this.q4a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_191().p4a_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s4a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r4a(encoder, value instanceof PhaseRecoveryQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q4a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_191().p4a_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PhaseRecoveryQuestion.t4a(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.q4a_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_191().p4a_1[0].k3()];
  }
}
class PhaseRecoveryQuestion {
  constructor(variants) {
    Companion_getInstance_191();
    this.s4a_1 = variants;
  }
  s3o() {
    return this.s4a_1;
  }
  toString() {
    return 'PhaseRecoveryQuestion(variants=' + this.s4a_1.toString() + ')';
  }
  hashCode() {
    return this.s4a_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PhaseRecoveryQuestion))
      return false;
    if (!this.s4a_1.equals(other.s4a_1))
      return false;
    return true;
  }
  static t4a(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_191();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_165().q4a_1);
    }
    var $this = createThis(this);
    $this.s4a_1 = variants;
    return $this;
  }
}
class Companion_191 {
  constructor() {
    Companion_instance_191 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, PlayCardInTurnQuestion$Companion$$childSerializers$_anonymous__m6osim);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u4a_1 = [tmp_1, lazy(tmp_2, PlayCardInTurnQuestion$Companion$$childSerializers$_anonymous__m6osim_0)];
  }
}
class $serializer_167 {
  constructor() {
    $serializer_instance_166 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayCardInTurnQuestion', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('variants', false);
    this.v4a_1 = tmp0_serialDesc;
  }
  w4a(encoder, value) {
    var tmp0_desc = this.v4a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_192().u4a_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x4a_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.y4a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w4a(encoder, value instanceof PlayCardInTurnQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v4a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_192().u4a_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlayCardInTurnQuestion.z4a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.v4a_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_192().u4a_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class PlayCardInTurnQuestion {
  constructor(characterObject, variants) {
    Companion_getInstance_192();
    this.x4a_1 = characterObject;
    this.y4a_1 = variants;
  }
  s3o() {
    return this.y4a_1;
  }
  toString() {
    return 'PlayCardInTurnQuestion(characterObject=' + this.x4a_1.toString() + ', variants=' + this.y4a_1.toString() + ')';
  }
  hashCode() {
    var result = this.x4a_1.hashCode();
    result = imul(result, 31) + this.y4a_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayCardInTurnQuestion))
      return false;
    if (!this.x4a_1.equals(other.x4a_1))
      return false;
    if (!this.y4a_1.equals(other.y4a_1))
      return false;
    return true;
  }
  static z4a(seen0, characterObject, variants, serializationConstructorMarker) {
    Companion_getInstance_192();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_166().v4a_1);
    }
    var $this = createThis(this);
    $this.x4a_1 = characterObject;
    $this.y4a_1 = variants;
    return $this;
  }
}
class Companion_192 {
  constructor() {
    Companion_instance_192 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a4b_1 = [lazy(tmp_0, StatementQuestion$Companion$$childSerializers$_anonymous__5u48l)];
  }
}
class $serializer_168 {
  constructor() {
    $serializer_instance_167 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('StatementQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.b4b_1 = tmp0_serialDesc;
  }
  c4b(encoder, value) {
    var tmp0_desc = this.b4b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_193().a4b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d4b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c4b(encoder, value instanceof StatementQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b4b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_193().a4b_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return StatementQuestion.e4b(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b4b_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_193().a4b_1[0].k3()];
  }
}
class StatementQuestion {
  constructor(variants) {
    Companion_getInstance_193();
    this.d4b_1 = variants;
  }
  s3o() {
    return this.d4b_1;
  }
  toString() {
    return 'StatementQuestion(variants=' + this.d4b_1.toString() + ')';
  }
  hashCode() {
    return this.d4b_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StatementQuestion))
      return false;
    if (!this.d4b_1.equals(other.d4b_1))
      return false;
    return true;
  }
  static e4b(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_193();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_167().b4b_1);
    }
    var $this = createThis(this);
    $this.d4b_1 = variants;
    return $this;
  }
}
class Companion_193 {}
class $serializer_169 {
  constructor() {
    $serializer_instance_168 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TrapByNumberQuestion', this, 1);
    tmp0_serialDesc.h1b('numberOfTrapsInZone', false);
    this.f4b_1 = tmp0_serialDesc;
  }
  g4b(encoder, value) {
    var tmp0_desc = this.f4b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.h4b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g4b(encoder, value instanceof TrapByNumberQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f4b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return TrapByNumberQuestion.i4b(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.f4b_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class TrapByNumberQuestion {
  constructor(numberOfTrapsInZone) {
    this.h4b_1 = numberOfTrapsInZone;
    // Inline function 'kotlin.require' call
    if (!(this.h4b_1 > 0)) {
      var message = 'Number of traps must be positive';
      throw IllegalArgumentException.h2(toString(message));
    }
  }
  s3o() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = numberRangeToNumber(1, this.h4b_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.n3_1;
    var last = this_0.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$2 = item;
        destination.d2(tmp$ret$2);
      }
       while (!(item === last));
    return toLinkedSet(destination);
  }
  toString() {
    return 'TrapByNumberQuestion(numberOfTrapsInZone=' + this.h4b_1 + ')';
  }
  hashCode() {
    return this.h4b_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrapByNumberQuestion))
      return false;
    if (!(this.h4b_1 === other.h4b_1))
      return false;
    return true;
  }
  static i4b(seen0, numberOfTrapsInZone, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_168().f4b_1);
    }
    var $this = createThis(this);
    $this.h4b_1 = numberOfTrapsInZone;
    // Inline function 'kotlin.require' call
    if (!($this.h4b_1 > 0)) {
      var message = 'Number of traps must be positive';
      throw IllegalArgumentException.h2(toString(message));
    }
    return $this;
  }
}
class Companion_194 {
  constructor() {
    Companion_instance_194 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, TriggersQuestion$Companion$$childSerializers$_anonymous__6j62s7);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j4b_1 = [tmp_1, lazy(tmp_2, TriggersQuestion$Companion$$childSerializers$_anonymous__6j62s7_0)];
  }
}
class $serializer_170 {
  constructor() {
    $serializer_instance_169 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TriggersQuestion', this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('theoreticalTriggers', false);
    this.k4b_1 = tmp0_serialDesc;
  }
  l4b(encoder, value) {
    var tmp0_desc = this.k4b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_195().j4b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.m4b_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.n4b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l4b(encoder, value instanceof TriggersQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k4b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_195().j4b_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return TriggersQuestion.o4b(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.k4b_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_195().j4b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class TriggersQuestion {
  constructor(variants, theoreticalTriggers) {
    Companion_getInstance_195();
    this.m4b_1 = variants;
    this.n4b_1 = theoreticalTriggers;
  }
  s3o() {
    return this.m4b_1;
  }
  toString() {
    return 'TriggersQuestion(variants=' + this.m4b_1.toString() + ', theoreticalTriggers=' + toString(this.n4b_1) + ')';
  }
  hashCode() {
    var result = this.m4b_1.hashCode();
    result = imul(result, 31) + hashCode(this.n4b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TriggersQuestion))
      return false;
    if (!this.m4b_1.equals(other.m4b_1))
      return false;
    if (!equals(this.n4b_1, other.n4b_1))
      return false;
    return true;
  }
  static o4b(seen0, variants, theoreticalTriggers, serializationConstructorMarker) {
    Companion_getInstance_195();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_169().k4b_1);
    }
    var $this = createThis(this);
    $this.m4b_1 = variants;
    $this.n4b_1 = theoreticalTriggers;
    return $this;
  }
}
class Companion_195 {
  constructor() {
    Companion_instance_195 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, UpgradeQuestion$Companion$$childSerializers$_anonymous__vz6coo);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p4b_1 = [tmp_1, lazy(tmp_2, UpgradeQuestion$Companion$$childSerializers$_anonymous__vz6coo_0)];
  }
}
class $serializer_171 {
  constructor() {
    $serializer_instance_170 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UpgradeQuestion', this, 2);
    tmp0_serialDesc.h1b('variants', false);
    tmp0_serialDesc.h1b('questionContext', false);
    this.q4b_1 = tmp0_serialDesc;
  }
  r4b(encoder, value) {
    var tmp0_desc = this.q4b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_196().p4b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s4b_1);
    tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.t4b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r4b(encoder, value instanceof UpgradeQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q4b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_196().p4b_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return UpgradeQuestion.u4b(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.q4b_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_196().p4b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), get_nullable(tmp0_cached[1].k3())];
  }
}
class UpgradeQuestion {
  constructor(variants, questionContext) {
    Companion_getInstance_196();
    this.s4b_1 = variants;
    this.t4b_1 = questionContext;
  }
  s3o() {
    return this.s4b_1;
  }
  t3o() {
    return this.t4b_1;
  }
  toString() {
    return 'UpgradeQuestion(variants=' + this.s4b_1.toString() + ', questionContext=' + toString_0(this.t4b_1) + ')';
  }
  hashCode() {
    var result = this.s4b_1.hashCode();
    result = imul(result, 31) + (this.t4b_1 == null ? 0 : hashCode(this.t4b_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UpgradeQuestion))
      return false;
    if (!this.s4b_1.equals(other.s4b_1))
      return false;
    if (!equals(this.t4b_1, other.t4b_1))
      return false;
    return true;
  }
  static u4b(seen0, variants, questionContext, serializationConstructorMarker) {
    Companion_getInstance_196();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_170().q4b_1);
    }
    var $this = createThis(this);
    $this.s4b_1 = variants;
    $this.t4b_1 = questionContext;
    return $this;
  }
}
class Companion_196 {
  constructor() {
    Companion_instance_196 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v4b_1 = [lazy(tmp_0, ZoneQuestion$Companion$$childSerializers$_anonymous__mme0zs)];
  }
}
class $serializer_172 {
  constructor() {
    $serializer_instance_171 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ZoneQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.w4b_1 = tmp0_serialDesc;
  }
  x4b(encoder, value) {
    var tmp0_desc = this.w4b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_197().v4b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y4b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x4b(encoder, value instanceof ZoneQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w4b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_197().v4b_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ZoneQuestion.z4b(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w4b_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_197().v4b_1[0].k3()];
  }
}
class ZoneQuestion {
  constructor(variants) {
    Companion_getInstance_197();
    this.y4b_1 = variants;
  }
  s3o() {
    return this.y4b_1;
  }
  toString() {
    return 'ZoneQuestion(variants=' + this.y4b_1.toString() + ')';
  }
  hashCode() {
    return this.y4b_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ZoneQuestion))
      return false;
    if (!this.y4b_1.equals(other.y4b_1))
      return false;
    return true;
  }
  static z4b(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_197();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_171().w4b_1);
    }
    var $this = createThis(this);
    $this.y4b_1 = variants;
    return $this;
  }
}
class Companion_197 {
  a2g() {
    var tmp = getKClass(QuestionContext);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BeastMovementCardQuestionContext), getKClass(ArsenalCardToGainQuestionContext), getKClass(BeastlyTalentToPlayQuestionContext), getKClass(CardToCopyForDeceiveQuestionContext), getKClass(CardToDiscardQuestionContext), getKClass(DiscardedAbilityCardToRetrieveQuestionContext), getKClass(DiscardedDraftActionCardToRetrieveQuestionContext), getKClass(HunterItemToDiscardFromArsenalQuestionContext), getKClass(HunterItemToExchangeByRuinQuestionContext), getKClass(HunterItemToGiveByRuinQuestionContext), getKClass(HunterItemToPlayQuestionContext), getKClass(RandomResultQuestionContext), getKClass(RhagnerCardGainHoardQuestionContext), getKClass(RhagnerCardLoseHoardQuestionContext), getKClass(SigridPactCardQuestionContext), getKClass(TrapToPlayForTrapmasterQuestionContext), getKClass(UnusedDraftActionCardToRetrieveQuestionContext), getKClass(AshRuinLocationQuestionContext), getKClass(BarrierFirstPositionQuestionContext), getKClass(LocationForFireQuestionContext), getKClass(LocationForLivingWebQuestionContext), getKClass(LocationToIncinerateQuestionContext), getKClass(LocationToTransformAndFireQuestionContext), getKClass(LocationsToCheckForBeastByRuinQuestionContext), getKClass(SameHabitatRelocationByRuinQuestionContext), getKClass(SnareLocationQuestionContext), getKClass(SnareTrapLocationQuestionContext), getKClass(ActorForRamQuestionContext), getKClass(AnimalToMoveQuestionContext), getKClass(AnimalToSearchWithQuestionContext), getKClass(AttackTargetQuestionContext), getKClass(BeastToGainBeastlyTalentQuestionContext), getKClass(BeastToPerformEffectQuestionContext), getKClass(BeingRelocatingByGrapnelQuestionContext), getKClass(BeingToMoveAlongsideQuestionContext), getKClass(BeingToMoveByRuinQuestionContext), getKClass(BoarToMoveQuestionContext), getKClass(BoarToTransformQuestionContext), getKClass(DreamerToSacrificeQuestionContext), getKClass(EggToHatchQuestionContext), getKClass(EggToReturnToMoltQuestionContext), getKClass(FarmerToNobleQuestionContext), getKClass(HandInspectTargetQuestionContext), getKClass(HatchlingToReplaceQuestionContext), getKClass(HunterToCopyFirstRedCardQuestionContext), getKClass(HunterToGiveChainGrapnelQuestionContext), getKClass(HunterToGiveItemByRuinQuestionContext), getKClass(HunterToMesmeriseQuestionContext), getKClass(HunterToMoveQuestionContext), getKClass(HunterToPerformEffectQuestionContext), getKClass(HunterToReceiveItemByRuinQuestionContext), getKClass(HunterToRelocateQuestionContext), getKClass(HunterToResolveRuinQuestionContext), getKClass(HunterToReturnQuestionContext), getKClass(HunterToSkipNextTurnQuestionContext), getKClass(HunterToStealGrudgeQuestionContext), getKClass(HunterTrappedBySnareQuestionContext), getKClass(NobleToFarmerQuestionContext), getKClass(OutpostToReplaceQuestionContext), getKClass(SettlerQuestionContext), getKClass(SettlerToMoveQuestionContext), getKClass(SheepForMoveAndAttackQuestionContext), getKClass(SnareToReplaceQuestionContext), getKClass(SummonToActivateQuestionContext), getKClass(SummonToAttackWithQuestionContext), getKClass(SummonToMoveQuestionContext), getKClass(SummonToReplaceQuestionContext), getKClass(SummonToSacrificeForRuinQuestionContext), getKClass(SummonToSacrificeQuestionContext), getKClass(TargetToBlockDamageForQuestionContext), getKClass(TargetToDamageQuestionContext), getKClass(TargetToHealQuestionContext), getKClass(TargetToMoveQuestionContext), getKClass(TargetToPullQuestionContext), getKClass(TargetToRamQuestionContext), getKClass(TargetToRunFromFireQuestionContext), getKClass(TargetToSpendAncientPowersOnQuestionContext), getKClass(VictimToProtectQuestionContext), getKClass(UrgullMoltEggsToReturnQuestionContext)];
    var tmp_1 = BeastMovementCardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('BeastMovementCardQuestionContext', tmp_1, tmp$ret$3);
    var tmp_3 = ArsenalCardToGainQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('ArsenalCardToGainQuestionContext', tmp_3, tmp$ret$6);
    var tmp_5 = BeastlyTalentToPlayQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('BeastlyTalentToPlayQuestionContext', tmp_5, tmp$ret$9);
    var tmp_7 = CardToCopyForDeceiveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('CardToCopyForDeceiveQuestionContext', tmp_7, tmp$ret$12);
    var tmp_9 = CardToDiscardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('CardToDiscardQuestionContext', tmp_9, tmp$ret$15);
    var tmp_11 = DiscardedAbilityCardToRetrieveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('DiscardedAbilityCardToRetrieveQuestionContext', tmp_11, tmp$ret$18);
    var tmp_13 = DiscardedDraftActionCardToRetrieveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('DiscardedDraftActionCardToRetrieveQuestionContext', tmp_13, tmp$ret$21);
    var tmp_15 = HunterItemToDiscardFromArsenalQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('HunterItemToDiscardFromArsenalQuestionContext', tmp_15, tmp$ret$24);
    var tmp_17 = HunterItemToExchangeByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('HunterItemToExchangeByRuinQuestionContext', tmp_17, tmp$ret$27);
    var tmp_19 = HunterItemToGiveByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('HunterItemToGiveByRuinQuestionContext', tmp_19, tmp$ret$30);
    var tmp_21 = HunterItemToPlayQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('HunterItemToPlayQuestionContext', tmp_21, tmp$ret$33);
    var tmp_23 = $serializer_getInstance_175();
    var tmp_24 = RhagnerCardGainHoardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_25 = ObjectSerializer.l1c('RhagnerCardGainHoardQuestionContext', tmp_24, tmp$ret$36);
    var tmp_26 = RhagnerCardLoseHoardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_27 = ObjectSerializer.l1c('RhagnerCardLoseHoardQuestionContext', tmp_26, tmp$ret$39);
    var tmp_28 = SigridPactCardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_29 = ObjectSerializer.l1c('SigridPactCardQuestionContext', tmp_28, tmp$ret$42);
    var tmp_30 = TrapToPlayForTrapmasterQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_31 = ObjectSerializer.l1c('TrapToPlayForTrapmasterQuestionContext', tmp_30, tmp$ret$45);
    var tmp_32 = UnusedDraftActionCardToRetrieveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_33 = ObjectSerializer.l1c('UnusedDraftActionCardToRetrieveQuestionContext', tmp_32, tmp$ret$48);
    var tmp_34 = AshRuinLocationQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_35 = ObjectSerializer.l1c('AshRuinLocationQuestionContext', tmp_34, tmp$ret$51);
    var tmp_36 = BarrierFirstPositionQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_37 = ObjectSerializer.l1c('BarrierFirstPositionQuestionContext', tmp_36, tmp$ret$54);
    var tmp_38 = LocationForFireQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_39 = ObjectSerializer.l1c('LocationForFireQuestionContext', tmp_38, tmp$ret$57);
    var tmp_40 = LocationForLivingWebQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_41 = ObjectSerializer.l1c('LocationForLivingWebQuestionContext', tmp_40, tmp$ret$60);
    var tmp_42 = LocationToIncinerateQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_43 = ObjectSerializer.l1c('LocationToIncinerateQuestionContext', tmp_42, tmp$ret$63);
    var tmp_44 = LocationToTransformAndFireQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_45 = ObjectSerializer.l1c('LocationToTransformAndFireQuestionContext', tmp_44, tmp$ret$66);
    var tmp_46 = LocationsToCheckForBeastByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_47 = ObjectSerializer.l1c('LocationsToCheckForBeastByRuinQuestionContext', tmp_46, tmp$ret$69);
    var tmp_48 = SameHabitatRelocationByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_49 = ObjectSerializer.l1c('SameHabitatRelocationByRuinQuestionContext', tmp_48, tmp$ret$72);
    var tmp_50 = SnareLocationQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_51 = ObjectSerializer.l1c('SnareLocationQuestionContext', tmp_50, tmp$ret$75);
    var tmp_52 = SnareTrapLocationQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_53 = ObjectSerializer.l1c('SnareTrapLocationQuestionContext', tmp_52, tmp$ret$78);
    var tmp_54 = ActorForRamQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_55 = ObjectSerializer.l1c('ActorForRamQuestionContext', tmp_54, tmp$ret$81);
    var tmp_56 = AnimalToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_57 = ObjectSerializer.l1c('AnimalToMoveQuestionContext', tmp_56, tmp$ret$84);
    var tmp_58 = AnimalToSearchWithQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_59 = ObjectSerializer.l1c('AnimalToSearchWithQuestionContext', tmp_58, tmp$ret$87);
    var tmp_60 = AttackTargetQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_61 = ObjectSerializer.l1c('AttackTargetQuestionContext', tmp_60, tmp$ret$90);
    var tmp_62 = BeastToGainBeastlyTalentQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_63 = ObjectSerializer.l1c('BeastToGainBeastlyTalentQuestionContext', tmp_62, tmp$ret$93);
    var tmp_64 = BeastToPerformEffectQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_65 = ObjectSerializer.l1c('BeastToPerformEffectQuestionContext', tmp_64, tmp$ret$96);
    var tmp_66 = BeingRelocatingByGrapnelQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_67 = ObjectSerializer.l1c('BeingRelocatingByGrapnelQuestionContext', tmp_66, tmp$ret$99);
    var tmp_68 = BeingToMoveAlongsideQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_69 = ObjectSerializer.l1c('BeingToMoveAlongsideQuestionContext', tmp_68, tmp$ret$102);
    var tmp_70 = BeingToMoveByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_71 = ObjectSerializer.l1c('BeingToMoveByRuinQuestionContext', tmp_70, tmp$ret$105);
    var tmp_72 = BoarToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_73 = ObjectSerializer.l1c('BoarToMoveQuestionContext', tmp_72, tmp$ret$108);
    var tmp_74 = BoarToTransformQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_75 = ObjectSerializer.l1c('BoarToTransformQuestionContext', tmp_74, tmp$ret$111);
    var tmp_76 = DreamerToSacrificeQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_77 = ObjectSerializer.l1c('DreamerToSacrificeQuestionContext', tmp_76, tmp$ret$114);
    var tmp_78 = EggToHatchQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_79 = ObjectSerializer.l1c('EggToHatchQuestionContext', tmp_78, tmp$ret$117);
    var tmp_80 = EggToReturnToMoltQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_81 = ObjectSerializer.l1c('EggToReturnToMoltQuestionContext', tmp_80, tmp$ret$120);
    var tmp_82 = FarmerToNobleQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_83 = ObjectSerializer.l1c('FarmerToNobleQuestionContext', tmp_82, tmp$ret$123);
    var tmp_84 = HandInspectTargetQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_85 = ObjectSerializer.l1c('HandInspectTargetQuestionContext', tmp_84, tmp$ret$126);
    var tmp_86 = HatchlingToReplaceQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_87 = ObjectSerializer.l1c('HatchlingToReplaceQuestionContext', tmp_86, tmp$ret$129);
    var tmp_88 = HunterToCopyFirstRedCardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_89 = ObjectSerializer.l1c('HunterToCopyFirstRedCardQuestionContext', tmp_88, tmp$ret$132);
    var tmp_90 = HunterToGiveChainGrapnelQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_91 = ObjectSerializer.l1c('HunterToGiveChainGrapnelQuestionContext', tmp_90, tmp$ret$135);
    var tmp_92 = HunterToGiveItemByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    var tmp_93 = ObjectSerializer.l1c('HunterToGiveItemByRuinQuestionContext', tmp_92, tmp$ret$138);
    var tmp_94 = HunterToMesmeriseQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$141 = [];
    var tmp_95 = ObjectSerializer.l1c('HunterToMesmeriseQuestionContext', tmp_94, tmp$ret$141);
    var tmp_96 = HunterToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    var tmp_97 = ObjectSerializer.l1c('HunterToMoveQuestionContext', tmp_96, tmp$ret$144);
    var tmp_98 = HunterToPerformEffectQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$147 = [];
    var tmp_99 = ObjectSerializer.l1c('HunterToPerformEffectQuestionContext', tmp_98, tmp$ret$147);
    var tmp_100 = HunterToReceiveItemByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$150 = [];
    var tmp_101 = ObjectSerializer.l1c('HunterToReceiveItemByRuinQuestionContext', tmp_100, tmp$ret$150);
    var tmp_102 = HunterToRelocateQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$153 = [];
    var tmp_103 = ObjectSerializer.l1c('HunterToRelocateQuestionContext', tmp_102, tmp$ret$153);
    var tmp_104 = HunterToResolveRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$156 = [];
    var tmp_105 = ObjectSerializer.l1c('HunterToResolveRuinQuestionContext', tmp_104, tmp$ret$156);
    var tmp_106 = HunterToReturnQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$159 = [];
    var tmp_107 = ObjectSerializer.l1c('HunterToReturnQuestionContext', tmp_106, tmp$ret$159);
    var tmp_108 = HunterToSkipNextTurnQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$162 = [];
    var tmp_109 = ObjectSerializer.l1c('HunterToSkipNextTurnQuestionContext', tmp_108, tmp$ret$162);
    var tmp_110 = HunterToStealGrudgeQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$165 = [];
    var tmp_111 = ObjectSerializer.l1c('HunterToStealGrudgeQuestionContext', tmp_110, tmp$ret$165);
    var tmp_112 = HunterTrappedBySnareQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$168 = [];
    var tmp_113 = ObjectSerializer.l1c('HunterTrappedBySnareQuestionContext', tmp_112, tmp$ret$168);
    var tmp_114 = NobleToFarmerQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$171 = [];
    var tmp_115 = ObjectSerializer.l1c('NobleToFarmerQuestionContext', tmp_114, tmp$ret$171);
    var tmp_116 = OutpostToReplaceQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$174 = [];
    var tmp_117 = ObjectSerializer.l1c('OutpostToReplaceQuestionContext', tmp_116, tmp$ret$174);
    var tmp_118 = SettlerQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$177 = [];
    var tmp_119 = ObjectSerializer.l1c('SettlerQuestionContext', tmp_118, tmp$ret$177);
    var tmp_120 = SettlerToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$180 = [];
    var tmp_121 = ObjectSerializer.l1c('SettlerToMoveQuestionContext', tmp_120, tmp$ret$180);
    var tmp_122 = SheepForMoveAndAttackQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$183 = [];
    var tmp_123 = ObjectSerializer.l1c('SheepForMoveAndAttackQuestionContext', tmp_122, tmp$ret$183);
    var tmp_124 = SnareToReplaceQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$186 = [];
    var tmp_125 = ObjectSerializer.l1c('SnareToReplaceQuestionContext', tmp_124, tmp$ret$186);
    var tmp_126 = SummonToActivateQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$189 = [];
    var tmp_127 = ObjectSerializer.l1c('SummonToActivateQuestionContext', tmp_126, tmp$ret$189);
    var tmp_128 = SummonToAttackWithQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$192 = [];
    var tmp_129 = ObjectSerializer.l1c('SummonToAttackWithQuestionContext', tmp_128, tmp$ret$192);
    var tmp_130 = SummonToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$195 = [];
    var tmp_131 = ObjectSerializer.l1c('SummonToMoveQuestionContext', tmp_130, tmp$ret$195);
    var tmp_132 = SummonToReplaceQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$198 = [];
    var tmp_133 = ObjectSerializer.l1c('SummonToReplaceQuestionContext', tmp_132, tmp$ret$198);
    var tmp_134 = SummonToSacrificeForRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$201 = [];
    var tmp_135 = ObjectSerializer.l1c('SummonToSacrificeForRuinQuestionContext', tmp_134, tmp$ret$201);
    var tmp_136 = SummonToSacrificeQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$204 = [];
    var tmp_137 = ObjectSerializer.l1c('SummonToSacrificeQuestionContext', tmp_136, tmp$ret$204);
    var tmp_138 = TargetToBlockDamageForQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$207 = [];
    var tmp_139 = ObjectSerializer.l1c('TargetToBlockDamageForQuestionContext', tmp_138, tmp$ret$207);
    var tmp_140 = TargetToDamageQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$210 = [];
    var tmp_141 = ObjectSerializer.l1c('TargetToDamageQuestionContext', tmp_140, tmp$ret$210);
    var tmp_142 = TargetToHealQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$213 = [];
    var tmp_143 = ObjectSerializer.l1c('TargetToHealQuestionContext', tmp_142, tmp$ret$213);
    var tmp_144 = TargetToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$216 = [];
    var tmp_145 = ObjectSerializer.l1c('TargetToMoveQuestionContext', tmp_144, tmp$ret$216);
    var tmp_146 = TargetToPullQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$219 = [];
    var tmp_147 = ObjectSerializer.l1c('TargetToPullQuestionContext', tmp_146, tmp$ret$219);
    var tmp_148 = TargetToRamQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$222 = [];
    var tmp_149 = ObjectSerializer.l1c('TargetToRamQuestionContext', tmp_148, tmp$ret$222);
    var tmp_150 = TargetToRunFromFireQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$225 = [];
    var tmp_151 = ObjectSerializer.l1c('TargetToRunFromFireQuestionContext', tmp_150, tmp$ret$225);
    var tmp_152 = TargetToSpendAncientPowersOnQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$228 = [];
    var tmp_153 = ObjectSerializer.l1c('TargetToSpendAncientPowersOnQuestionContext', tmp_152, tmp$ret$228);
    var tmp_154 = VictimToProtectQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$231 = [];
    var tmp_155 = ObjectSerializer.l1c('VictimToProtectQuestionContext', tmp_154, tmp$ret$231);
    var tmp_156 = UrgullMoltEggsToReturnQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$234 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_157 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_23, tmp_25, tmp_27, tmp_29, tmp_31, tmp_33, tmp_35, tmp_37, tmp_39, tmp_41, tmp_43, tmp_45, tmp_47, tmp_49, tmp_51, tmp_53, tmp_55, tmp_57, tmp_59, tmp_61, tmp_63, tmp_65, tmp_67, tmp_69, tmp_71, tmp_73, tmp_75, tmp_77, tmp_79, tmp_81, tmp_83, tmp_85, tmp_87, tmp_89, tmp_91, tmp_93, tmp_95, tmp_97, tmp_99, tmp_101, tmp_103, tmp_105, tmp_107, tmp_109, tmp_111, tmp_113, tmp_115, tmp_117, tmp_119, tmp_121, tmp_123, tmp_125, tmp_127, tmp_129, tmp_131, tmp_133, tmp_135, tmp_137, tmp_139, tmp_141, tmp_143, tmp_145, tmp_147, tmp_149, tmp_151, tmp_153, tmp_155, ObjectSerializer.l1c('UrgullMoltEggsToReturnQuestionContext', tmp_156, tmp$ret$234)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$240 = [];
    return SealedClassSerializer.i10('steelart.beast.QuestionContext', tmp, tmp_0, tmp_157, tmp$ret$240);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_198 {
  constructor() {
    Companion_instance_198 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a4c_1 = [lazy(tmp_0, BeastMovementCardVariant$Companion$$childSerializers$_anonymous__ee5na5), null];
  }
}
class $serializer_173 {
  constructor() {
    $serializer_instance_172 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.BeastMovementCardVariant', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('indexOfMovementCard', false);
    this.b4c_1 = tmp0_serialDesc;
  }
  c4c(encoder, value) {
    var tmp0_desc = this.b4c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_199().a4c_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d4c_1);
    tmp1_output.z14(tmp0_desc, 1, value.e4c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c4c(encoder, value instanceof BeastMovementCardVariant ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b4c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_199().a4c_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BeastMovementCardVariant.f4c(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.b4c_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_199().a4c_1[0].k3(), IntSerializer_getInstance()];
  }
}
class BeastMovementCardVariant {
  constructor(beast, indexOfMovementCard) {
    Companion_getInstance_199();
    this.d4c_1 = beast;
    this.e4c_1 = indexOfMovementCard;
  }
  toString() {
    return 'BeastMovementCardVariant(beast=' + this.d4c_1.toString() + ', indexOfMovementCard=' + this.e4c_1 + ')';
  }
  hashCode() {
    var result = this.d4c_1.hashCode();
    result = imul(result, 31) + this.e4c_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastMovementCardVariant))
      return false;
    if (!this.d4c_1.equals(other.d4c_1))
      return false;
    if (!(this.e4c_1 === other.e4c_1))
      return false;
    return true;
  }
  static f4c(seen0, beast, indexOfMovementCard, serializationConstructorMarker) {
    Companion_getInstance_199();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_172().b4c_1);
    }
    var $this = createThis(this);
    $this.d4c_1 = beast;
    $this.e4c_1 = indexOfMovementCard;
    return $this;
  }
}
class BeastMovementCardQuestionContext {
  constructor() {
    BeastMovementCardQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g4c_1 = lazy(tmp_0, BeastMovementCardQuestionContext$_anonymous__5lowbw);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_211(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeastMovementCardQuestionContext';
  }
  hashCode() {
    return -2135637904;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastMovementCardQuestionContext))
      return false;
    return true;
  }
}
class Companion_199 {
  a2g() {
    var tmp = getKClass(BooleanGameQuestion);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion)];
    var tmp_1 = PlaceHatchlingWithInfestQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_1, tmp$ret$3);
    var tmp_3 = PlayOverloadedQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_3, tmp$ret$6);
    var tmp_5 = RevealToMoveQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_6 = [tmp_2, tmp_4, ObjectSerializer.l1c('RevealToMoveQuestion', tmp_5, tmp$ret$9), $serializer_getInstance_345(), $serializer_getInstance_428(), $serializer_getInstance_154()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    return SealedClassSerializer.i10('steelart.beast.BooleanGameQuestion', tmp, tmp_0, tmp_6, tmp$ret$15);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_200 {
  a2g() {
    var tmp = getKClass(CardQuestionContext);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ArsenalCardToGainQuestionContext), getKClass(BeastlyTalentToPlayQuestionContext), getKClass(CardToCopyForDeceiveQuestionContext), getKClass(CardToDiscardQuestionContext), getKClass(DiscardedAbilityCardToRetrieveQuestionContext), getKClass(DiscardedDraftActionCardToRetrieveQuestionContext), getKClass(HunterItemToDiscardFromArsenalQuestionContext), getKClass(HunterItemToExchangeByRuinQuestionContext), getKClass(HunterItemToGiveByRuinQuestionContext), getKClass(HunterItemToPlayQuestionContext), getKClass(RandomResultQuestionContext), getKClass(RhagnerCardGainHoardQuestionContext), getKClass(RhagnerCardLoseHoardQuestionContext), getKClass(SigridPactCardQuestionContext), getKClass(TrapToPlayForTrapmasterQuestionContext), getKClass(UnusedDraftActionCardToRetrieveQuestionContext)];
    var tmp_1 = ArsenalCardToGainQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('ArsenalCardToGainQuestionContext', tmp_1, tmp$ret$3);
    var tmp_3 = BeastlyTalentToPlayQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('BeastlyTalentToPlayQuestionContext', tmp_3, tmp$ret$6);
    var tmp_5 = CardToCopyForDeceiveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('CardToCopyForDeceiveQuestionContext', tmp_5, tmp$ret$9);
    var tmp_7 = CardToDiscardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('CardToDiscardQuestionContext', tmp_7, tmp$ret$12);
    var tmp_9 = DiscardedAbilityCardToRetrieveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('DiscardedAbilityCardToRetrieveQuestionContext', tmp_9, tmp$ret$15);
    var tmp_11 = DiscardedDraftActionCardToRetrieveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('DiscardedDraftActionCardToRetrieveQuestionContext', tmp_11, tmp$ret$18);
    var tmp_13 = HunterItemToDiscardFromArsenalQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('HunterItemToDiscardFromArsenalQuestionContext', tmp_13, tmp$ret$21);
    var tmp_15 = HunterItemToExchangeByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('HunterItemToExchangeByRuinQuestionContext', tmp_15, tmp$ret$24);
    var tmp_17 = HunterItemToGiveByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('HunterItemToGiveByRuinQuestionContext', tmp_17, tmp$ret$27);
    var tmp_19 = HunterItemToPlayQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('HunterItemToPlayQuestionContext', tmp_19, tmp$ret$30);
    var tmp_21 = $serializer_getInstance_175();
    var tmp_22 = RhagnerCardGainHoardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_23 = ObjectSerializer.l1c('RhagnerCardGainHoardQuestionContext', tmp_22, tmp$ret$33);
    var tmp_24 = RhagnerCardLoseHoardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_25 = ObjectSerializer.l1c('RhagnerCardLoseHoardQuestionContext', tmp_24, tmp$ret$36);
    var tmp_26 = SigridPactCardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_27 = ObjectSerializer.l1c('SigridPactCardQuestionContext', tmp_26, tmp$ret$39);
    var tmp_28 = TrapToPlayForTrapmasterQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_29 = ObjectSerializer.l1c('TrapToPlayForTrapmasterQuestionContext', tmp_28, tmp$ret$42);
    var tmp_30 = UnusedDraftActionCardToRetrieveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_31 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_21, tmp_23, tmp_25, tmp_27, tmp_29, ObjectSerializer.l1c('UnusedDraftActionCardToRetrieveQuestionContext', tmp_30, tmp$ret$45)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    return SealedClassSerializer.i10('steelart.beast.CardQuestionContext', tmp, tmp_0, tmp_31, tmp$ret$51);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_201 {
  a2g() {
    var tmp = getKClass(LocationQuestionBase);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_110(), $serializer_getInstance_159(), $serializer_getInstance_160(), $serializer_getInstance_161(), $serializer_getInstance_162(), $serializer_getInstance_163()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.LocationQuestionBase', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_202 {
  a2g() {
    var tmp = getKClass(LocationQuestionContext);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AshRuinLocationQuestionContext), getKClass(BarrierFirstPositionQuestionContext), getKClass(LocationForFireQuestionContext), getKClass(LocationForLivingWebQuestionContext), getKClass(LocationToIncinerateQuestionContext), getKClass(LocationToTransformAndFireQuestionContext), getKClass(LocationsToCheckForBeastByRuinQuestionContext), getKClass(SameHabitatRelocationByRuinQuestionContext), getKClass(SnareLocationQuestionContext), getKClass(SnareTrapLocationQuestionContext)];
    var tmp_1 = AshRuinLocationQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('AshRuinLocationQuestionContext', tmp_1, tmp$ret$3);
    var tmp_3 = BarrierFirstPositionQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('BarrierFirstPositionQuestionContext', tmp_3, tmp$ret$6);
    var tmp_5 = LocationForFireQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('LocationForFireQuestionContext', tmp_5, tmp$ret$9);
    var tmp_7 = LocationForLivingWebQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('LocationForLivingWebQuestionContext', tmp_7, tmp$ret$12);
    var tmp_9 = LocationToIncinerateQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('LocationToIncinerateQuestionContext', tmp_9, tmp$ret$15);
    var tmp_11 = LocationToTransformAndFireQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('LocationToTransformAndFireQuestionContext', tmp_11, tmp$ret$18);
    var tmp_13 = LocationsToCheckForBeastByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('LocationsToCheckForBeastByRuinQuestionContext', tmp_13, tmp$ret$21);
    var tmp_15 = SameHabitatRelocationByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('SameHabitatRelocationByRuinQuestionContext', tmp_15, tmp$ret$24);
    var tmp_17 = SnareLocationQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('SnareLocationQuestionContext', tmp_17, tmp$ret$27);
    var tmp_19 = SnareTrapLocationQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_20 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, ObjectSerializer.l1c('SnareTrapLocationQuestionContext', tmp_19, tmp$ret$30)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    return SealedClassSerializer.i10('steelart.beast.LocationQuestionContext', tmp, tmp_0, tmp_20, tmp$ret$36);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_203 {
  a2g() {
    var tmp = getKClass(TargetQuestionContext);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ActorForRamQuestionContext), getKClass(AnimalToMoveQuestionContext), getKClass(AnimalToSearchWithQuestionContext), getKClass(AttackTargetQuestionContext), getKClass(BeastToGainBeastlyTalentQuestionContext), getKClass(BeastToPerformEffectQuestionContext), getKClass(BeingRelocatingByGrapnelQuestionContext), getKClass(BeingToMoveAlongsideQuestionContext), getKClass(BeingToMoveByRuinQuestionContext), getKClass(BoarToMoveQuestionContext), getKClass(BoarToTransformQuestionContext), getKClass(DreamerToSacrificeQuestionContext), getKClass(EggToHatchQuestionContext), getKClass(EggToReturnToMoltQuestionContext), getKClass(FarmerToNobleQuestionContext), getKClass(HandInspectTargetQuestionContext), getKClass(HatchlingToReplaceQuestionContext), getKClass(HunterToCopyFirstRedCardQuestionContext), getKClass(HunterToGiveChainGrapnelQuestionContext), getKClass(HunterToGiveItemByRuinQuestionContext), getKClass(HunterToMesmeriseQuestionContext), getKClass(HunterToMoveQuestionContext), getKClass(HunterToPerformEffectQuestionContext), getKClass(HunterToReceiveItemByRuinQuestionContext), getKClass(HunterToRelocateQuestionContext), getKClass(HunterToResolveRuinQuestionContext), getKClass(HunterToReturnQuestionContext), getKClass(HunterToSkipNextTurnQuestionContext), getKClass(HunterToStealGrudgeQuestionContext), getKClass(HunterTrappedBySnareQuestionContext), getKClass(NobleToFarmerQuestionContext), getKClass(OutpostToReplaceQuestionContext), getKClass(SettlerQuestionContext), getKClass(SettlerToMoveQuestionContext), getKClass(SheepForMoveAndAttackQuestionContext), getKClass(SnareToReplaceQuestionContext), getKClass(SummonToActivateQuestionContext), getKClass(SummonToAttackWithQuestionContext), getKClass(SummonToMoveQuestionContext), getKClass(SummonToReplaceQuestionContext), getKClass(SummonToSacrificeForRuinQuestionContext), getKClass(SummonToSacrificeQuestionContext), getKClass(TargetToBlockDamageForQuestionContext), getKClass(TargetToDamageQuestionContext), getKClass(TargetToHealQuestionContext), getKClass(TargetToMoveQuestionContext), getKClass(TargetToPullQuestionContext), getKClass(TargetToRamQuestionContext), getKClass(TargetToRunFromFireQuestionContext), getKClass(TargetToSpendAncientPowersOnQuestionContext), getKClass(VictimToProtectQuestionContext)];
    var tmp_1 = ActorForRamQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('ActorForRamQuestionContext', tmp_1, tmp$ret$3);
    var tmp_3 = AnimalToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('AnimalToMoveQuestionContext', tmp_3, tmp$ret$6);
    var tmp_5 = AnimalToSearchWithQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('AnimalToSearchWithQuestionContext', tmp_5, tmp$ret$9);
    var tmp_7 = AttackTargetQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('AttackTargetQuestionContext', tmp_7, tmp$ret$12);
    var tmp_9 = BeastToGainBeastlyTalentQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('BeastToGainBeastlyTalentQuestionContext', tmp_9, tmp$ret$15);
    var tmp_11 = BeastToPerformEffectQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('BeastToPerformEffectQuestionContext', tmp_11, tmp$ret$18);
    var tmp_13 = BeingRelocatingByGrapnelQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('BeingRelocatingByGrapnelQuestionContext', tmp_13, tmp$ret$21);
    var tmp_15 = BeingToMoveAlongsideQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('BeingToMoveAlongsideQuestionContext', tmp_15, tmp$ret$24);
    var tmp_17 = BeingToMoveByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('BeingToMoveByRuinQuestionContext', tmp_17, tmp$ret$27);
    var tmp_19 = BoarToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('BoarToMoveQuestionContext', tmp_19, tmp$ret$30);
    var tmp_21 = BoarToTransformQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('BoarToTransformQuestionContext', tmp_21, tmp$ret$33);
    var tmp_23 = DreamerToSacrificeQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('DreamerToSacrificeQuestionContext', tmp_23, tmp$ret$36);
    var tmp_25 = EggToHatchQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('EggToHatchQuestionContext', tmp_25, tmp$ret$39);
    var tmp_27 = EggToReturnToMoltQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('EggToReturnToMoltQuestionContext', tmp_27, tmp$ret$42);
    var tmp_29 = FarmerToNobleQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('FarmerToNobleQuestionContext', tmp_29, tmp$ret$45);
    var tmp_31 = HandInspectTargetQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('HandInspectTargetQuestionContext', tmp_31, tmp$ret$48);
    var tmp_33 = HatchlingToReplaceQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('HatchlingToReplaceQuestionContext', tmp_33, tmp$ret$51);
    var tmp_35 = HunterToCopyFirstRedCardQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_36 = ObjectSerializer.l1c('HunterToCopyFirstRedCardQuestionContext', tmp_35, tmp$ret$54);
    var tmp_37 = HunterToGiveChainGrapnelQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_38 = ObjectSerializer.l1c('HunterToGiveChainGrapnelQuestionContext', tmp_37, tmp$ret$57);
    var tmp_39 = HunterToGiveItemByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_40 = ObjectSerializer.l1c('HunterToGiveItemByRuinQuestionContext', tmp_39, tmp$ret$60);
    var tmp_41 = HunterToMesmeriseQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_42 = ObjectSerializer.l1c('HunterToMesmeriseQuestionContext', tmp_41, tmp$ret$63);
    var tmp_43 = HunterToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_44 = ObjectSerializer.l1c('HunterToMoveQuestionContext', tmp_43, tmp$ret$66);
    var tmp_45 = HunterToPerformEffectQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_46 = ObjectSerializer.l1c('HunterToPerformEffectQuestionContext', tmp_45, tmp$ret$69);
    var tmp_47 = HunterToReceiveItemByRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_48 = ObjectSerializer.l1c('HunterToReceiveItemByRuinQuestionContext', tmp_47, tmp$ret$72);
    var tmp_49 = HunterToRelocateQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_50 = ObjectSerializer.l1c('HunterToRelocateQuestionContext', tmp_49, tmp$ret$75);
    var tmp_51 = HunterToResolveRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_52 = ObjectSerializer.l1c('HunterToResolveRuinQuestionContext', tmp_51, tmp$ret$78);
    var tmp_53 = HunterToReturnQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_54 = ObjectSerializer.l1c('HunterToReturnQuestionContext', tmp_53, tmp$ret$81);
    var tmp_55 = HunterToSkipNextTurnQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_56 = ObjectSerializer.l1c('HunterToSkipNextTurnQuestionContext', tmp_55, tmp$ret$84);
    var tmp_57 = HunterToStealGrudgeQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_58 = ObjectSerializer.l1c('HunterToStealGrudgeQuestionContext', tmp_57, tmp$ret$87);
    var tmp_59 = HunterTrappedBySnareQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_60 = ObjectSerializer.l1c('HunterTrappedBySnareQuestionContext', tmp_59, tmp$ret$90);
    var tmp_61 = NobleToFarmerQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_62 = ObjectSerializer.l1c('NobleToFarmerQuestionContext', tmp_61, tmp$ret$93);
    var tmp_63 = OutpostToReplaceQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_64 = ObjectSerializer.l1c('OutpostToReplaceQuestionContext', tmp_63, tmp$ret$96);
    var tmp_65 = SettlerQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_66 = ObjectSerializer.l1c('SettlerQuestionContext', tmp_65, tmp$ret$99);
    var tmp_67 = SettlerToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_68 = ObjectSerializer.l1c('SettlerToMoveQuestionContext', tmp_67, tmp$ret$102);
    var tmp_69 = SheepForMoveAndAttackQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_70 = ObjectSerializer.l1c('SheepForMoveAndAttackQuestionContext', tmp_69, tmp$ret$105);
    var tmp_71 = SnareToReplaceQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_72 = ObjectSerializer.l1c('SnareToReplaceQuestionContext', tmp_71, tmp$ret$108);
    var tmp_73 = SummonToActivateQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_74 = ObjectSerializer.l1c('SummonToActivateQuestionContext', tmp_73, tmp$ret$111);
    var tmp_75 = SummonToAttackWithQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_76 = ObjectSerializer.l1c('SummonToAttackWithQuestionContext', tmp_75, tmp$ret$114);
    var tmp_77 = SummonToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_78 = ObjectSerializer.l1c('SummonToMoveQuestionContext', tmp_77, tmp$ret$117);
    var tmp_79 = SummonToReplaceQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_80 = ObjectSerializer.l1c('SummonToReplaceQuestionContext', tmp_79, tmp$ret$120);
    var tmp_81 = SummonToSacrificeForRuinQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_82 = ObjectSerializer.l1c('SummonToSacrificeForRuinQuestionContext', tmp_81, tmp$ret$123);
    var tmp_83 = SummonToSacrificeQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_84 = ObjectSerializer.l1c('SummonToSacrificeQuestionContext', tmp_83, tmp$ret$126);
    var tmp_85 = TargetToBlockDamageForQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_86 = ObjectSerializer.l1c('TargetToBlockDamageForQuestionContext', tmp_85, tmp$ret$129);
    var tmp_87 = TargetToDamageQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_88 = ObjectSerializer.l1c('TargetToDamageQuestionContext', tmp_87, tmp$ret$132);
    var tmp_89 = TargetToHealQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_90 = ObjectSerializer.l1c('TargetToHealQuestionContext', tmp_89, tmp$ret$135);
    var tmp_91 = TargetToMoveQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    var tmp_92 = ObjectSerializer.l1c('TargetToMoveQuestionContext', tmp_91, tmp$ret$138);
    var tmp_93 = TargetToPullQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$141 = [];
    var tmp_94 = ObjectSerializer.l1c('TargetToPullQuestionContext', tmp_93, tmp$ret$141);
    var tmp_95 = TargetToRamQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    var tmp_96 = ObjectSerializer.l1c('TargetToRamQuestionContext', tmp_95, tmp$ret$144);
    var tmp_97 = TargetToRunFromFireQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$147 = [];
    var tmp_98 = ObjectSerializer.l1c('TargetToRunFromFireQuestionContext', tmp_97, tmp$ret$147);
    var tmp_99 = TargetToSpendAncientPowersOnQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$150 = [];
    var tmp_100 = ObjectSerializer.l1c('TargetToSpendAncientPowersOnQuestionContext', tmp_99, tmp$ret$150);
    var tmp_101 = VictimToProtectQuestionContext_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$153 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_102 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_66, tmp_68, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_80, tmp_82, tmp_84, tmp_86, tmp_88, tmp_90, tmp_92, tmp_94, tmp_96, tmp_98, tmp_100, ObjectSerializer.l1c('VictimToProtectQuestionContext', tmp_101, tmp$ret$153)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$159 = [];
    return SealedClassSerializer.i10('steelart.beast.TargetQuestionContext', tmp, tmp_0, tmp_102, tmp$ret$159);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_204 {
  a2g() {
    var tmp = getKClass(TurnVariant);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AbruptAssembleStatement), getKClass(AbruptDecayActionStatement), getKClass(AbyssalBeastStatement), getKClass(AbyssalHellFireStatement), getKClass(AbyssalPullStatement), getKClass(ActivateSnareStatement), getKClass(ActivateSummonsStatement), getKClass(ActivateTrapStatement), getKClass(AllureKillSoulBonusStatement), getKClass(AllureStatement), getKClass(AmassTransformationStatement), getKClass(BindingHuntReactionStatement), getKClass(BleatCardTriggerStatement), getKClass(DraugBerserkReactionStatement), getKClass(DreamerMaskReactionStatement), getKClass(EsmeriasStrandReactionStatement), getKClass(FlareReactionStatement), getKClass(IntuitionReactionStatement), getKClass(MistShroudReactionStatement), getKClass(PlayCardAsReactionStatement), getKClass(SmokebombReactionStatement), getKClass(SuddenMistReactionStatement), getKClass(WorldShiftReactionStatement), getKClass(ArrivalOfTheTitanHuntersTeamBonusMoveStatement), getKClass(AshfallAttackOrSummonFromRuinStatement), getKClass(AshfallEachBeastAndSummonMoves), getKClass(AttackBySheepStatement), getKClass(AttackOrSummonFromRuinStatement), getKClass(AttackStatement), getKClass(BeastlyTongueStatement), getKClass(BeholdStatement), getKClass(BeyondTheVeilPreventYeltrDamageStatement), getKClass(BindingHuntStatement), getKClass(BlackStarStatement), getKClass(BloodHuntStatement), getKClass(BloodTrackStatement), getKClass(BoltAndRecallStatement), getKClass(BramWardBarrierStatement), getKClass(BroodswellStatement), getKClass(BurstStatement), getKClass(CannotBePlayedStatement), getKClass(ChainGrapnelStatement), getKClass(ChargeUpgradeStatement), getKClass(ChiefsCommandStatement), getKClass(MoveAllSettlersAndHuntersByVarja), getKClass(ChooseAndPlayOneCard), getKClass(ChooseMesmeriseTargetStatement), getKClass(ClaimRuinStatement), getKClass(CommandCardStatement), getKClass(ChooseOneOfStatement), getKClass(OptionalStatement), getKClass(SummonSignStatement), getKClass(InAnyOrderStatement), getKClass(ThenActionStatement), getKClass(CopyCardStatement), getKClass(DealDamageToSummonsStatement), getKClass(DeceiveStatement), getKClass(DefenderWithChoiceAction), getKClass(DevotionStatement), getKClass(DiscardCardsStatement), getKClass(DiscardHunterItemFromArsenalStatement), getKClass(DiscardPlacedTrapStatement), getKClass(DischargeStatement), getKClass(DismemberStatement), getKClass(DisplaceTransformLocationsStatement), getKClass(EachBeastAndSummonMoves), getKClass(EludeStatement), getKClass(EmptyStatement), getKClass(EnsnareStatement), getKClass(EruptionEffectStatement), getKClass(ExtractStatement), getKClass(FlameRapierStatement), getKClass(FlourishStatement), getKClass(FylgjaFlightStatement), getKClass(GainAncientPowerStatement), getKClass(GainBeastlyTalentStatement), getKClass(GainDraugCorruptionStatement), getKClass(GainGrudgeStatement), getKClass(GainRandomUnusedDraftActionCardStatement), getKClass(GlimpsBeastsStatement), getKClass(GlipsHuntersStatement), getKClass(GrapnelStatement), getKClass(GreatHowlStatement), getKClass(HatchEggStatement), getKClass(HauntStatement), getKClass(HazeStatement), getKClass(HealNearHunterStatement), getKClass(HealNearbyHuntersAndSettlersStatement), getKClass(HerdStatement), getKClass(HeroicSpeechStatement), getKClass(IncinerateHoardStatement), getKClass(IncinerateStatement), getKClass(InfusionUpgradeStatement), getKClass(LureStatement), getKClass(MountStatement), getKClass(MoveAnimalStatement), getKClass(MoveEverySummonStatement), getKClass(MoveWithAnimalStatement), getKClass(BeastMovesDependingOnHuntersStatement), getKClass(BeastMovesDependingOnSummonsNumberStatement), getKClass(BeastMovesSameZoneStatement), getKClass(FixedDirectionBeastMovementStatement), getKClass(LeapStatement), getKClass(RaagaSlitherStatement), getKClass(SimpleBeastMovementStatement), getKClass(UpriseUpgradedStatement), getKClass(VoidStatement), getKClass(MovementUptoFixedStepsStatement), getKClass(OverloadedFlameRapierMovementStatement), getKClass(RunFromFireStatement), getKClass(TrackStatement), getKClass(WarhogsTuskStatement), getKClass(RelocationInRangeStatement), getKClass(OverloadedShatterStatement), getKClass(OvipunctureStatement), getKClass(AvariceCardHuntersStatement), getKClass(GainHunterItemStatement), getKClass(MoveSeveralHuntersStatement), getKClass(RecoveryTestForEachHunterStatement), getKClass(RetrieveDiscardedAbilitiesStatement), getKClass(PlaceBarrierInSameZoneStatement), getKClass(PlaceBarrierOnLocationsStatement), getKClass(PlaceFireTokenOnNearbyStatement), getKClass(PlaceFireTokensStatement), getKClass(PlaceHatchlingAfterEggStatement), getKClass(PlaceLivingWebNearbyStatement), getKClass(PlaceNewSummonNearbyStatement), getKClass(PlaceNewSummonOnLocationsStatement), getKClass(PlaceNewSummonStatement), getKClass(PlaceOutpostStatement), getKClass(PlaceSnareStatement), getKClass(PlaceUrgullEggOnOwnLocationStatement), getKClass(PlayAshRuinStatement), getKClass(PrimalInstinctsStatement), getKClass(PushStatement), getKClass(RaagaHydraStatement), getKClass(RamAnotherTargetStatement), getKClass(ReapStatement), getKClass(ReceiveSelfDamageStatement), getKClass(RecoveryTestStatement), getKClass(RedirectDamageToDreamerStatement), getKClass(RelocateOneHunterToAnother), getKClass(RelocateToBansheeAndRevealStatement), getKClass(RelocationToSettlementStatement), getKClass(RelocationToWatchtowerStatement), getKClass(ResonanceChooseStatement), getKClass(ResourcefulnessUpgradeStatement), getKClass(ResurrectionStatement), getKClass(RetrieveDiscardedAbilityStatement), getKClass(RetrieveDiscardedDraftActionCardStatement), getKClass(RetrieveUnusedCardStatement), getKClass(RevealLastMovementsStatement), getKClass(RevealToMoveStatement), getKClass(RevengeOfTheSheepStatement), getKClass(RhagnerAdjustHoardStatement), getKClass(RiseHoardStatement), getKClass(RiseStatement), getKClass(SacrificeToPlayDoubleDarkStatement), getKClass(ScorchedEarthHoardStatement), getKClass(ScorchedEarthStatement), getKClass(ScoutStatement), getKClass(SearchForBeastStatement), getKClass(SetTrapStatement), getKClass(ShipwreckSettlerMovementStatement), getKClass(SigridAttackAllNearbyLocationsStatement), getKClass(SigridCreatureLungeStatement), getKClass(SigridPactReversalStatement), getKClass(SigridSearchAllNearbyLocationsStatement), getKClass(SoulReapStatement), getKClass(SoulStealStatement), getKClass(StealGrudgeFromNearbyHunterStatement), getKClass(StrideHuntersStatement), getKClass(SuddenShockStatement), getKClass(SummonAdmirerStatement), getKClass(SummonCreatureStatement), getKClass(SummonFylgjaStatement), getKClass(SummonLindwyrmHoardStatement), getKClass(SummonLindwyrmStatement), getKClass(SummonMovesStatement), getKClass(SummonYeltrStatement), getKClass(SwarmAttackStatement), getKClass(ToothAndSeverStatement), getKClass(TransformAllNearbyStatement), getKClass(TransformLocationsStatement), getKClass(TrapmasterStatement), getKClass(UnnaturalResolveStatement), getKClass(UpgradeStatement), getKClass(VanishStatement), getKClass(VoidCallStatement), getKClass(WardStatement), getKClass(DiscardToMoveVariant), getKClass(DiscardToUseBoatVariant), getKClass(PassVariant), getKClass(PlayCardVariant)];
    var tmp_1 = $serializer_getInstance_107();
    var tmp_2 = AbruptDecayActionStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_3 = ObjectSerializer.l1c('AbruptDecayActionStatement', tmp_2, tmp$ret$3);
    var tmp_4 = AbyssalBeastStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_5 = ObjectSerializer.l1c('AbyssalBeastStatement', tmp_4, tmp$ret$6);
    var tmp_6 = $serializer_getInstance_382();
    var tmp_7 = $serializer_getInstance_68();
    var tmp_8 = $serializer_getInstance_363();
    var tmp_9 = $serializer_getInstance_12();
    var tmp_10 = $serializer_getInstance_13();
    var tmp_11 = $serializer_getInstance_421();
    var tmp_12 = $serializer_getInstance_422();
    var tmp_13 = $serializer_getInstance_324();
    var tmp_14 = $serializer_getInstance_111();
    var tmp_15 = $serializer_getInstance_404();
    var tmp_16 = $serializer_getInstance_128();
    var tmp_17 = $serializer_getInstance_14();
    var tmp_18 = $serializer_getInstance_15();
    var tmp_19 = $serializer_getInstance_16();
    var tmp_20 = $serializer_getInstance_17();
    var tmp_21 = $serializer_getInstance_364();
    var tmp_22 = $serializer_getInstance_18();
    var tmp_23 = $serializer_getInstance_19();
    var tmp_24 = $serializer_getInstance_20();
    var tmp_25 = $serializer_getInstance_21();
    var tmp_26 = $serializer_getInstance_72();
    var tmp_27 = $serializer_getInstance_76();
    var tmp_28 = $serializer_getInstance_77();
    var tmp_29 = $serializer_getInstance_356();
    var tmp_30 = $serializer_getInstance_411();
    var tmp_31 = $serializer_getInstance_5();
    var tmp_32 = $serializer_getInstance_105();
    var tmp_33 = $serializer_getInstance_423();
    var tmp_34 = $serializer_getInstance_346();
    var tmp_35 = $serializer_getInstance_109();
    var tmp_36 = BlackStarStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_37 = ObjectSerializer.l1c('BlackStarStatement', tmp_36, tmp$ret$9);
    var tmp_38 = $serializer_getInstance_429();
    var tmp_39 = $serializer_getInstance_430();
    var tmp_40 = $serializer_getInstance_347();
    var tmp_41 = $serializer_getInstance_112();
    var tmp_42 = $serializer_getInstance_414();
    var tmp_43 = $serializer_getInstance_104();
    var tmp_44 = CannotBePlayedStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_45 = ObjectSerializer.l1c('CannotBePlayedStatement', tmp_44, tmp$ret$12);
    var tmp_46 = $serializer_getInstance_22();
    var tmp_47 = $serializer_getInstance_23();
    var tmp_48 = ChiefsCommandStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_49 = ObjectSerializer.l1c('ChiefsCommandStatement', tmp_48, tmp$ret$15);
    var tmp_50 = MoveAllSettlersAndHuntersByVarja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_51 = ObjectSerializer.l1c('MoveAllSettlersAndHuntersByVarja', tmp_50, tmp$ret$18);
    var tmp_52 = $serializer_getInstance_24();
    var tmp_53 = ChooseMesmeriseTargetStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_54 = ObjectSerializer.l1c('ChooseMesmeriseTargetStatement', tmp_53, tmp$ret$21);
    var tmp_55 = $serializer_getInstance_25();
    var tmp_56 = $serializer_getInstance_433();
    var tmp_57 = $serializer_getInstance_6();
    var tmp_58 = $serializer_getInstance_26();
    var tmp_59 = $serializer_getInstance_27();
    var tmp_60 = $serializer_getInstance();
    var tmp_61 = $serializer_getInstance_2();
    var tmp_62 = $serializer_getInstance_28();
    var tmp_63 = $serializer_getInstance_29();
    var tmp_64 = $serializer_getInstance_138();
    var tmp_65 = $serializer_getInstance_322();
    var tmp_66 = $serializer_getInstance_144();
    var tmp_67 = $serializer_getInstance_30();
    var tmp_68 = $serializer_getInstance_365();
    var tmp_69 = DiscardPlacedTrapStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_70 = ObjectSerializer.l1c('DiscardPlacedTrapStatement', tmp_69, tmp$ret$24);
    var tmp_71 = $serializer_getInstance_405();
    var tmp_72 = $serializer_getInstance_366();
    var tmp_73 = $serializer_getInstance_31();
    var tmp_74 = $serializer_getInstance_412();
    var tmp_75 = $serializer_getInstance_424();
    var tmp_76 = EmptyStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_77 = ObjectSerializer.l1c('EmptyStatement', tmp_76, tmp$ret$27);
    var tmp_78 = $serializer_getInstance_32();
    var tmp_79 = EruptionEffectStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_80 = ObjectSerializer.l1c('EruptionEffectStatement', tmp_79, tmp$ret$30);
    var tmp_81 = ExtractStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_82 = ObjectSerializer.l1c('ExtractStatement', tmp_81, tmp$ret$33);
    var tmp_83 = $serializer_getInstance_142();
    var tmp_84 = $serializer_getInstance_33();
    var tmp_85 = $serializer_getInstance_134();
    var tmp_86 = $serializer_getInstance_34();
    var tmp_87 = $serializer_getInstance_35();
    var tmp_88 = $serializer_getInstance_129();
    var tmp_89 = $serializer_getInstance_36();
    var tmp_90 = $serializer_getInstance_37();
    var tmp_91 = $serializer_getInstance_38();
    var tmp_92 = $serializer_getInstance_39();
    var tmp_93 = $serializer_getInstance_7();
    var tmp_94 = GreatHowlStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_95 = ObjectSerializer.l1c('GreatHowlStatement', tmp_94, tmp$ret$36);
    var tmp_96 = $serializer_getInstance_415();
    var tmp_97 = $serializer_getInstance_137();
    var tmp_98 = $serializer_getInstance_367();
    var tmp_99 = $serializer_getInstance_40();
    var tmp_100 = $serializer_getInstance_41();
    var tmp_101 = $serializer_getInstance_357();
    var tmp_102 = HeroicSpeechStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_103 = ObjectSerializer.l1c('HeroicSpeechStatement', tmp_102, tmp$ret$39);
    var tmp_104 = $serializer_getInstance_383();
    var tmp_105 = $serializer_getInstance_384();
    var tmp_106 = InfusionUpgradeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_107 = ObjectSerializer.l1c('InfusionUpgradeStatement', tmp_106, tmp$ret$42);
    var tmp_108 = $serializer_getInstance_42();
    var tmp_109 = $serializer_getInstance_358();
    var tmp_110 = $serializer_getInstance_43();
    var tmp_111 = $serializer_getInstance_11();
    var tmp_112 = $serializer_getInstance_359();
    var tmp_113 = $serializer_getInstance_44();
    var tmp_114 = $serializer_getInstance_45();
    var tmp_115 = $serializer_getInstance_46();
    var tmp_116 = $serializer_getInstance_47();
    var tmp_117 = $serializer_getInstance_106();
    var tmp_118 = $serializer_getInstance_372();
    var tmp_119 = $serializer_getInstance_4();
    var tmp_120 = $serializer_getInstance_146();
    var tmp_121 = $serializer_getInstance_69();
    var tmp_122 = $serializer_getInstance_0();
    var tmp_123 = $serializer_getInstance_143();
    var tmp_124 = $serializer_getInstance_385();
    var tmp_125 = $serializer_getInstance_48();
    var tmp_126 = $serializer_getInstance_49();
    var tmp_127 = $serializer_getInstance_50();
    var tmp_128 = $serializer_getInstance_51();
    var tmp_129 = $serializer_getInstance_416();
    var tmp_130 = $serializer_getInstance_52();
    var tmp_131 = $serializer_getInstance_1();
    var tmp_132 = $serializer_getInstance_10();
    var tmp_133 = $serializer_getInstance_375();
    var tmp_134 = $serializer_getInstance_53();
    var tmp_135 = $serializer_getInstance_113();
    var tmp_136 = $serializer_getInstance_114();
    var tmp_137 = $serializer_getInstance_386();
    var tmp_138 = $serializer_getInstance_387();
    var tmp_139 = $serializer_getInstance_417();
    var tmp_140 = $serializer_getInstance_418();
    var tmp_141 = $serializer_getInstance_54();
    var tmp_142 = $serializer_getInstance_55();
    var tmp_143 = $serializer_getInstance_56();
    var tmp_144 = $serializer_getInstance_57();
    var tmp_145 = $serializer_getInstance_368();
    var tmp_146 = $serializer_getInstance_419();
    var tmp_147 = $serializer_getInstance_73();
    var tmp_148 = PrimalInstinctsStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_149 = ObjectSerializer.l1c('PrimalInstinctsStatement', tmp_148, tmp$ret$45);
    var tmp_150 = $serializer_getInstance_325();
    var tmp_151 = $serializer_getInstance_373();
    var tmp_152 = $serializer_getInstance_406();
    var tmp_153 = $serializer_getInstance_348();
    var tmp_154 = $serializer_getInstance_58();
    var tmp_155 = $serializer_getInstance_376();
    var tmp_156 = RedirectDamageToDreamerStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_157 = ObjectSerializer.l1c('RedirectDamageToDreamerStatement', tmp_156, tmp$ret$48);
    var tmp_158 = RelocateOneHunterToAnother_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_159 = ObjectSerializer.l1c('RelocateOneHunterToAnother', tmp_158, tmp$ret$51);
    var tmp_160 = $serializer_getInstance_354();
    var tmp_161 = $serializer_getInstance_59();
    var tmp_162 = $serializer_getInstance_323();
    var tmp_163 = ResonanceChooseStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_164 = ObjectSerializer.l1c('ResonanceChooseStatement', tmp_163, tmp$ret$54);
    var tmp_165 = ResourcefulnessUpgradeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_166 = ObjectSerializer.l1c('ResourcefulnessUpgradeStatement', tmp_165, tmp$ret$57);
    var tmp_167 = ResurrectionStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_168 = ObjectSerializer.l1c('ResurrectionStatement', tmp_167, tmp$ret$60);
    var tmp_169 = $serializer_getInstance_8();
    var tmp_170 = $serializer_getInstance_60();
    var tmp_171 = $serializer_getInstance_61();
    var tmp_172 = $serializer_getInstance_62();
    var tmp_173 = $serializer_getInstance_407();
    var tmp_174 = $serializer_getInstance_360();
    var tmp_175 = $serializer_getInstance_388();
    var tmp_176 = $serializer_getInstance_389();
    var tmp_177 = $serializer_getInstance_390();
    var tmp_178 = $serializer_getInstance_147();
    var tmp_179 = $serializer_getInstance_391();
    var tmp_180 = $serializer_getInstance_392();
    var tmp_181 = $serializer_getInstance_78();
    var tmp_182 = $serializer_getInstance_63();
    var tmp_183 = $serializer_getInstance_64();
    var tmp_184 = ShipwreckSettlerMovementStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_185 = ObjectSerializer.l1c('ShipwreckSettlerMovementStatement', tmp_184, tmp$ret$63);
    var tmp_186 = $serializer_getInstance_400();
    var tmp_187 = SigridCreatureLungeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_188 = ObjectSerializer.l1c('SigridCreatureLungeStatement', tmp_187, tmp$ret$66);
    var tmp_189 = SigridPactReversalStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_190 = ObjectSerializer.l1c('SigridPactReversalStatement', tmp_189, tmp$ret$69);
    var tmp_191 = $serializer_getInstance_401();
    var tmp_192 = $serializer_getInstance_349();
    var tmp_193 = $serializer_getInstance_425();
    var tmp_194 = $serializer_getInstance_145();
    var tmp_195 = $serializer_getInstance_65();
    var tmp_196 = $serializer_getInstance_408();
    var tmp_197 = $serializer_getInstance_426();
    var tmp_198 = SummonCreatureStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_199 = ObjectSerializer.l1c('SummonCreatureStatement', tmp_198, tmp$ret$72);
    var tmp_200 = SummonFylgjaStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_201 = ObjectSerializer.l1c('SummonFylgjaStatement', tmp_200, tmp$ret$75);
    var tmp_202 = $serializer_getInstance_393();
    var tmp_203 = $serializer_getInstance_394();
    var tmp_204 = $serializer_getInstance_66();
    var tmp_205 = $serializer_getInstance_350();
    var tmp_206 = SwarmAttackStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_207 = ObjectSerializer.l1c('SwarmAttackStatement', tmp_206, tmp$ret$78);
    var tmp_208 = $serializer_getInstance_351();
    var tmp_209 = $serializer_getInstance_3();
    var tmp_210 = $serializer_getInstance_9();
    var tmp_211 = $serializer_getInstance_344();
    var tmp_212 = $serializer_getInstance_140();
    var tmp_213 = $serializer_getInstance_67();
    var tmp_214 = $serializer_getInstance_355();
    var tmp_215 = VoidCallStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_216 = ObjectSerializer.l1c('VoidCallStatement', tmp_215, tmp$ret$81);
    var tmp_217 = $serializer_getInstance_108();
    var tmp_218 = $serializer_getInstance_176();
    var tmp_219 = $serializer_getInstance_177();
    var tmp_220 = PassVariant_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_221 = [tmp_1, tmp_3, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_45, tmp_46, tmp_47, tmp_49, tmp_51, tmp_52, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, tmp_64, tmp_65, tmp_66, tmp_67, tmp_68, tmp_70, tmp_71, tmp_72, tmp_73, tmp_74, tmp_75, tmp_77, tmp_78, tmp_80, tmp_82, tmp_83, tmp_84, tmp_85, tmp_86, tmp_87, tmp_88, tmp_89, tmp_90, tmp_91, tmp_92, tmp_93, tmp_95, tmp_96, tmp_97, tmp_98, tmp_99, tmp_100, tmp_101, tmp_103, tmp_104, tmp_105, tmp_107, tmp_108, tmp_109, tmp_110, tmp_111, tmp_112, tmp_113, tmp_114, tmp_115, tmp_116, tmp_117, tmp_118, tmp_119, tmp_120, tmp_121, tmp_122, tmp_123, tmp_124, tmp_125, tmp_126, tmp_127, tmp_128, tmp_129, tmp_130, tmp_131, tmp_132, tmp_133, tmp_134, tmp_135, tmp_136, tmp_137, tmp_138, tmp_139, tmp_140, tmp_141, tmp_142, tmp_143, tmp_144, tmp_145, tmp_146, tmp_147, tmp_149, tmp_150, tmp_151, tmp_152, tmp_153, tmp_154, tmp_155, tmp_157, tmp_159, tmp_160, tmp_161, tmp_162, tmp_164, tmp_166, tmp_168, tmp_169, tmp_170, tmp_171, tmp_172, tmp_173, tmp_174, tmp_175, tmp_176, tmp_177, tmp_178, tmp_179, tmp_180, tmp_181, tmp_182, tmp_183, tmp_185, tmp_186, tmp_188, tmp_190, tmp_191, tmp_192, tmp_193, tmp_194, tmp_195, tmp_196, tmp_197, tmp_199, tmp_201, tmp_202, tmp_203, tmp_204, tmp_205, tmp_207, tmp_208, tmp_209, tmp_210, tmp_211, tmp_212, tmp_213, tmp_214, tmp_216, tmp_217, tmp_218, tmp_219, ObjectSerializer.l1c('PassVariant', tmp_220, tmp$ret$84), $serializer_getInstance_178()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    return SealedClassSerializer.i10('steelart.beast.TurnVariant', tmp, tmp_0, tmp_221, tmp$ret$90);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_205 {
  constructor() {
    Companion_instance_205 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, TriggerOption$Companion$$childSerializers$_anonymous__aop2ar);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, TriggerOption$Companion$$childSerializers$_anonymous__aop2ar_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, TriggerOption$Companion$$childSerializers$_anonymous__aop2ar_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h4c_1 = [tmp_1, tmp_3, tmp_5, lazy(tmp_6, TriggerOption$Companion$$childSerializers$_anonymous__aop2ar_2)];
  }
}
class $serializer_174 {
  constructor() {
    $serializer_instance_173 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TriggerOption', this, 4);
    tmp0_serialDesc.h1b('effectSource', false);
    tmp0_serialDesc.h1b('actionStatement', false);
    tmp0_serialDesc.h1b('agentObject', false);
    tmp0_serialDesc.h1b('requirement', false);
    this.i4c_1 = tmp0_serialDesc;
  }
  j4c(encoder, value) {
    var tmp0_desc = this.i4c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_206().h4c_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k4c_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.l4c_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.m4c_1);
    tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.n4c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j4c(encoder, value instanceof TriggerOption ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i4c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_206().h4c_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return TriggerOption.o4c(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.i4c_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_206().h4c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), tmp0_cached[3].k3()];
  }
}
class TriggerOption {
  constructor(effectSource, actionStatement, agentObject, requirement) {
    Companion_getInstance_206();
    this.k4c_1 = effectSource;
    this.l4c_1 = actionStatement;
    this.m4c_1 = agentObject;
    this.n4c_1 = requirement;
  }
  toString() {
    return 'TriggerOption(effectSource=' + toString(this.k4c_1) + ', actionStatement=' + toString(this.l4c_1) + ', agentObject=' + this.m4c_1.toString() + ', requirement=' + toString(this.n4c_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.k4c_1);
    result = imul(result, 31) + hashCode(this.l4c_1) | 0;
    result = imul(result, 31) + this.m4c_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.n4c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TriggerOption))
      return false;
    if (!equals(this.k4c_1, other.k4c_1))
      return false;
    if (!equals(this.l4c_1, other.l4c_1))
      return false;
    if (!this.m4c_1.equals(other.m4c_1))
      return false;
    if (!equals(this.n4c_1, other.n4c_1))
      return false;
    return true;
  }
  static o4c(seen0, effectSource, actionStatement, agentObject, requirement, serializationConstructorMarker) {
    Companion_getInstance_206();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_173().i4c_1);
    }
    var $this = createThis(this);
    $this.k4c_1 = effectSource;
    $this.l4c_1 = actionStatement;
    $this.m4c_1 = agentObject;
    $this.n4c_1 = requirement;
    return $this;
  }
}
class Companion_206 {
  constructor() {
    Companion_instance_206 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, TheoreticalTrigger$Companion$$childSerializers$_anonymous__d5c9sq);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p4c_1 = [tmp_1, lazy(tmp_2, TheoreticalTrigger$Companion$$childSerializers$_anonymous__d5c9sq_0)];
  }
}
class $serializer_175 {
  constructor() {
    $serializer_instance_174 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TheoreticalTrigger', this, 2);
    tmp0_serialDesc.h1b('effectSource', false);
    tmp0_serialDesc.h1b('agentObject', false);
    this.q4c_1 = tmp0_serialDesc;
  }
  r4c(encoder, value) {
    var tmp0_desc = this.q4c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_207().p4c_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s4c_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.t4c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r4c(encoder, value instanceof TheoreticalTrigger ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q4c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_207().p4c_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return TheoreticalTrigger.u4c(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.q4c_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_207().p4c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class TheoreticalTrigger {
  constructor(effectSource, agentObject) {
    Companion_getInstance_207();
    this.s4c_1 = effectSource;
    this.t4c_1 = agentObject;
  }
  toString() {
    return 'TheoreticalTrigger(effectSource=' + toString(this.s4c_1) + ', agentObject=' + this.t4c_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.s4c_1);
    result = imul(result, 31) + this.t4c_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TheoreticalTrigger))
      return false;
    if (!equals(this.s4c_1, other.s4c_1))
      return false;
    if (!this.t4c_1.equals(other.t4c_1))
      return false;
    return true;
  }
  static u4c(seen0, effectSource, agentObject, serializationConstructorMarker) {
    Companion_getInstance_207();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_174().q4c_1);
    }
    var $this = createThis(this);
    $this.s4c_1 = effectSource;
    $this.t4c_1 = agentObject;
    return $this;
  }
}
class Companion_207 {
  a2g() {
    var tmp = getKClass(UpgradeQuestionContext);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.UpgradeQuestionContext', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class UpgradeQuestionContext {}
class ArsenalCardToGainQuestionContext {
  constructor() {
    ArsenalCardToGainQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v4c_1 = lazy(tmp_0, ArsenalCardToGainQuestionContext$_anonymous__25w4r6);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_212(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ArsenalCardToGainQuestionContext';
  }
  hashCode() {
    return -1417847506;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ArsenalCardToGainQuestionContext))
      return false;
    return true;
  }
}
class BeastlyTalentToPlayQuestionContext {
  constructor() {
    BeastlyTalentToPlayQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w4c_1 = lazy(tmp_0, BeastlyTalentToPlayQuestionContext$_anonymous__o3p7jf);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_213(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeastlyTalentToPlayQuestionContext';
  }
  hashCode() {
    return -1427755577;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastlyTalentToPlayQuestionContext))
      return false;
    return true;
  }
}
class CardToDiscardQuestionContext {
  constructor() {
    CardToDiscardQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x4c_1 = lazy(tmp_0, CardToDiscardQuestionContext$_anonymous__9w2in5);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_214(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CardToDiscardQuestionContext';
  }
  hashCode() {
    return 88106811;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardToDiscardQuestionContext))
      return false;
    return true;
  }
}
class DiscardedAbilityCardToRetrieveQuestionContext {
  constructor() {
    DiscardedAbilityCardToRetrieveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y4c_1 = lazy(tmp_0, DiscardedAbilityCardToRetrieveQuestionContext$_anonymous__10zrtq);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_215(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DiscardedAbilityCardToRetrieveQuestionContext';
  }
  hashCode() {
    return -1511965552;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardedAbilityCardToRetrieveQuestionContext))
      return false;
    return true;
  }
}
class DiscardedDraftActionCardToRetrieveQuestionContext {
  constructor() {
    DiscardedDraftActionCardToRetrieveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z4c_1 = lazy(tmp_0, DiscardedDraftActionCardToRetrieveQuestionContext$_anonymous__ymvqgh);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_216(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DiscardedDraftActionCardToRetrieveQuestionContext';
  }
  hashCode() {
    return 1481270691;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardedDraftActionCardToRetrieveQuestionContext))
      return false;
    return true;
  }
}
class HunterItemToPlayQuestionContext {
  constructor() {
    HunterItemToPlayQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a4d_1 = lazy(tmp_0, HunterItemToPlayQuestionContext$_anonymous__g2p3bk);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_217(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterItemToPlayQuestionContext';
  }
  hashCode() {
    return 414121538;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterItemToPlayQuestionContext))
      return false;
    return true;
  }
}
class Companion_208 {}
class $serializer_176 {
  constructor() {
    $serializer_instance_175 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RandomResultQuestionContext', this, 1);
    tmp0_serialDesc.h1b('currentRandomAnswer', false);
    this.b4d_1 = tmp0_serialDesc;
  }
  c4d(encoder, value) {
    var tmp0_desc = this.b4d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.d4d_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c4d(encoder, value instanceof RandomResultQuestionContext ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b4d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RandomResultQuestionContext.e4d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b4d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class RandomResultQuestionContext {
  constructor(currentRandomAnswer) {
    this.d4d_1 = currentRandomAnswer;
  }
  toString() {
    return 'RandomResultQuestionContext(currentRandomAnswer=' + this.d4d_1 + ')';
  }
  hashCode() {
    return this.d4d_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RandomResultQuestionContext))
      return false;
    if (!(this.d4d_1 === other.d4d_1))
      return false;
    return true;
  }
  static e4d(seen0, currentRandomAnswer, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_175().b4d_1);
    }
    var $this = createThis(this);
    $this.d4d_1 = currentRandomAnswer;
    return $this;
  }
}
class UnusedDraftActionCardToRetrieveQuestionContext {
  constructor() {
    UnusedDraftActionCardToRetrieveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f4d_1 = lazy(tmp_0, UnusedDraftActionCardToRetrieveQuestionContext$_anonymous__qs0jue);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_218(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UnusedDraftActionCardToRetrieveQuestionContext';
  }
  hashCode() {
    return -1890429210;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnusedDraftActionCardToRetrieveQuestionContext))
      return false;
    return true;
  }
}
class AshRuinLocationQuestionContext {
  constructor() {
    AshRuinLocationQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g4d_1 = lazy(tmp_0, AshRuinLocationQuestionContext$_anonymous__4sjren);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_219(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AshRuinLocationQuestionContext';
  }
  hashCode() {
    return 1086271067;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AshRuinLocationQuestionContext))
      return false;
    return true;
  }
}
class AnimalToMoveQuestionContext {
  constructor() {
    AnimalToMoveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h4d_1 = lazy(tmp_0, AnimalToMoveQuestionContext$_anonymous__w3vv3e);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_220(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AnimalToMoveQuestionContext';
  }
  hashCode() {
    return -1414947364;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AnimalToMoveQuestionContext))
      return false;
    return true;
  }
}
class AttackTargetQuestionContext {
  constructor() {
    AttackTargetQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i4d_1 = lazy(tmp_0, AttackTargetQuestionContext$_anonymous__rgn04n);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_221(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AttackTargetQuestionContext';
  }
  hashCode() {
    return 1763392971;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AttackTargetQuestionContext))
      return false;
    return true;
  }
}
class BeastToGainBeastlyTalentQuestionContext {
  constructor() {
    BeastToGainBeastlyTalentQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j4d_1 = lazy(tmp_0, BeastToGainBeastlyTalentQuestionContext$_anonymous__p859fx);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_222(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeastToGainBeastlyTalentQuestionContext';
  }
  hashCode() {
    return 1610966437;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastToGainBeastlyTalentQuestionContext))
      return false;
    return true;
  }
}
class BeastToPerformEffectQuestionContext {
  constructor() {
    BeastToPerformEffectQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k4d_1 = lazy(tmp_0, BeastToPerformEffectQuestionContext$_anonymous__5xo8q);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_223(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeastToPerformEffectQuestionContext';
  }
  hashCode() {
    return 1160017580;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastToPerformEffectQuestionContext))
      return false;
    return true;
  }
}
class BeingRelocatingByGrapnelQuestionContext {
  constructor() {
    BeingRelocatingByGrapnelQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l4d_1 = lazy(tmp_0, BeingRelocatingByGrapnelQuestionContext$_anonymous__mmivm7);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_224(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeingRelocatingByGrapnelQuestionContext';
  }
  hashCode() {
    return -1575478975;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeingRelocatingByGrapnelQuestionContext))
      return false;
    return true;
  }
}
class BeingToMoveAlongsideQuestionContext {
  constructor() {
    BeingToMoveAlongsideQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m4d_1 = lazy(tmp_0, BeingToMoveAlongsideQuestionContext$_anonymous__oxobx3);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_225(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeingToMoveAlongsideQuestionContext';
  }
  hashCode() {
    return -103599141;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeingToMoveAlongsideQuestionContext))
      return false;
    return true;
  }
}
class BeingToMoveByRuinQuestionContext {
  constructor() {
    BeingToMoveByRuinQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n4d_1 = lazy(tmp_0, BeingToMoveByRuinQuestionContext$_anonymous__hs6v2w);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_226(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeingToMoveByRuinQuestionContext';
  }
  hashCode() {
    return 338730564;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeingToMoveByRuinQuestionContext))
      return false;
    return true;
  }
}
class BoarToMoveQuestionContext {
  constructor() {
    BoarToMoveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o4d_1 = lazy(tmp_0, BoarToMoveQuestionContext$_anonymous__3zd048);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_227(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BoarToMoveQuestionContext';
  }
  hashCode() {
    return 466991770;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BoarToMoveQuestionContext))
      return false;
    return true;
  }
}
class FarmerToNobleQuestionContext {
  constructor() {
    FarmerToNobleQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p4d_1 = lazy(tmp_0, FarmerToNobleQuestionContext$_anonymous__wr9je2);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_228(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FarmerToNobleQuestionContext';
  }
  hashCode() {
    return -1211626702;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FarmerToNobleQuestionContext))
      return false;
    return true;
  }
}
class HandInspectTargetQuestionContext {
  constructor() {
    HandInspectTargetQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q4d_1 = lazy(tmp_0, HandInspectTargetQuestionContext$_anonymous__9nbmck);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_229(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HandInspectTargetQuestionContext';
  }
  hashCode() {
    return -1150366152;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HandInspectTargetQuestionContext))
      return false;
    return true;
  }
}
class HunterToGiveChainGrapnelQuestionContext {
  constructor() {
    HunterToGiveChainGrapnelQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r4d_1 = lazy(tmp_0, HunterToGiveChainGrapnelQuestionContext$_anonymous__93at1o);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_230(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToGiveChainGrapnelQuestionContext';
  }
  hashCode() {
    return 828532414;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToGiveChainGrapnelQuestionContext))
      return false;
    return true;
  }
}
class HunterToMesmeriseQuestionContext {
  constructor() {
    HunterToMesmeriseQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s4d_1 = lazy(tmp_0, HunterToMesmeriseQuestionContext$_anonymous__rrpnbj);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_231(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToMesmeriseQuestionContext';
  }
  hashCode() {
    return 1934474573;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToMesmeriseQuestionContext))
      return false;
    return true;
  }
}
class HunterToMoveQuestionContext {
  constructor() {
    HunterToMoveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t4d_1 = lazy(tmp_0, HunterToMoveQuestionContext$_anonymous__f0t6au);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_232(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToMoveQuestionContext';
  }
  hashCode() {
    return 314017496;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToMoveQuestionContext))
      return false;
    return true;
  }
}
class HunterToPerformEffectQuestionContext {
  constructor() {
    HunterToPerformEffectQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u4d_1 = lazy(tmp_0, HunterToPerformEffectQuestionContext$_anonymous__eljhnf);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_233(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToPerformEffectQuestionContext';
  }
  hashCode() {
    return 131024951;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToPerformEffectQuestionContext))
      return false;
    return true;
  }
}
class HunterToRelocateQuestionContext {
  constructor() {
    HunterToRelocateQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v4d_1 = lazy(tmp_0, HunterToRelocateQuestionContext$_anonymous__c2dff2);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_234(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToRelocateQuestionContext';
  }
  hashCode() {
    return -2117336860;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToRelocateQuestionContext))
      return false;
    return true;
  }
}
class HunterToResolveRuinQuestionContext {
  constructor() {
    HunterToResolveRuinQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w4d_1 = lazy(tmp_0, HunterToResolveRuinQuestionContext$_anonymous__huz2yv);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_235(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToResolveRuinQuestionContext';
  }
  hashCode() {
    return 1058963861;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToResolveRuinQuestionContext))
      return false;
    return true;
  }
}
class HunterToReturnQuestionContext {
  constructor() {
    HunterToReturnQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x4d_1 = lazy(tmp_0, HunterToReturnQuestionContext$_anonymous__rv4ic9);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_236(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToReturnQuestionContext';
  }
  hashCode() {
    return -1134904423;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToReturnQuestionContext))
      return false;
    return true;
  }
}
class HunterToSkipNextTurnQuestionContext {
  constructor() {
    HunterToSkipNextTurnQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y4d_1 = lazy(tmp_0, HunterToSkipNextTurnQuestionContext$_anonymous__z8p0ug);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_237(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterToSkipNextTurnQuestionContext';
  }
  hashCode() {
    return 1452966458;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterToSkipNextTurnQuestionContext))
      return false;
    return true;
  }
}
class NobleToFarmerQuestionContext {
  constructor() {
    NobleToFarmerQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z4d_1 = lazy(tmp_0, NobleToFarmerQuestionContext$_anonymous__d4sina);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_238(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NobleToFarmerQuestionContext';
  }
  hashCode() {
    return -2066804426;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NobleToFarmerQuestionContext))
      return false;
    return true;
  }
}
class OutpostToReplaceQuestionContext {
  constructor() {
    OutpostToReplaceQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a4e_1 = lazy(tmp_0, OutpostToReplaceQuestionContext$_anonymous__o8rzfd);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_239(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OutpostToReplaceQuestionContext';
  }
  hashCode() {
    return 1417844121;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OutpostToReplaceQuestionContext))
      return false;
    return true;
  }
}
class SettlerQuestionContext {
  constructor() {
    SettlerQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b4e_1 = lazy(tmp_0, SettlerQuestionContext$_anonymous__fj98qd);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_240(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SettlerQuestionContext';
  }
  hashCode() {
    return -1368017817;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SettlerQuestionContext))
      return false;
    return true;
  }
}
class SettlerToMoveQuestionContext {
  constructor() {
    SettlerToMoveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c4e_1 = lazy(tmp_0, SettlerToMoveQuestionContext$_anonymous__n54af5);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_241(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SettlerToMoveQuestionContext';
  }
  hashCode() {
    return -1257941157;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SettlerToMoveQuestionContext))
      return false;
    return true;
  }
}
class SummonToActivateQuestionContext {
  constructor() {
    SummonToActivateQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d4e_1 = lazy(tmp_0, SummonToActivateQuestionContext$_anonymous__4ojpfn);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_242(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonToActivateQuestionContext';
  }
  hashCode() {
    return 517350197;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonToActivateQuestionContext))
      return false;
    return true;
  }
}
class SummonToAttackWithQuestionContext {
  constructor() {
    SummonToAttackWithQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e4e_1 = lazy(tmp_0, SummonToAttackWithQuestionContext$_anonymous__ea30rc);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_243(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonToAttackWithQuestionContext';
  }
  hashCode() {
    return 496482266;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonToAttackWithQuestionContext))
      return false;
    return true;
  }
}
class SummonToMoveQuestionContext {
  constructor() {
    SummonToMoveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f4e_1 = lazy(tmp_0, SummonToMoveQuestionContext$_anonymous__ohb21n);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_244(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonToMoveQuestionContext';
  }
  hashCode() {
    return -321840105;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonToMoveQuestionContext))
      return false;
    return true;
  }
}
class SummonToReplaceQuestionContext {
  constructor() {
    SummonToReplaceQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g4e_1 = lazy(tmp_0, SummonToReplaceQuestionContext$_anonymous__6nee06);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_245(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonToReplaceQuestionContext';
  }
  hashCode() {
    return -1674841098;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonToReplaceQuestionContext))
      return false;
    return true;
  }
}
class SummonToSacrificeForRuinQuestionContext {
  constructor() {
    SummonToSacrificeForRuinQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h4e_1 = lazy(tmp_0, SummonToSacrificeForRuinQuestionContext$_anonymous__tv0qly);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_246(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonToSacrificeForRuinQuestionContext';
  }
  hashCode() {
    return -544827672;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonToSacrificeForRuinQuestionContext))
      return false;
    return true;
  }
}
class TargetToBlockDamageForQuestionContext {
  constructor() {
    TargetToBlockDamageForQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i4e_1 = lazy(tmp_0, TargetToBlockDamageForQuestionContext$_anonymous__ldm72f);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_247(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TargetToBlockDamageForQuestionContext';
  }
  hashCode() {
    return 391605803;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TargetToBlockDamageForQuestionContext))
      return false;
    return true;
  }
}
class TargetToDamageQuestionContext {
  constructor() {
    TargetToDamageQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j4e_1 = lazy(tmp_0, TargetToDamageQuestionContext$_anonymous__qo8co9);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_248(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TargetToDamageQuestionContext';
  }
  hashCode() {
    return -241003959;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TargetToDamageQuestionContext))
      return false;
    return true;
  }
}
class TargetToHealQuestionContext {
  constructor() {
    TargetToHealQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k4e_1 = lazy(tmp_0, TargetToHealQuestionContext$_anonymous__n8f0aq);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_249(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TargetToHealQuestionContext';
  }
  hashCode() {
    return -901163408;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TargetToHealQuestionContext))
      return false;
    return true;
  }
}
class TargetToMoveQuestionContext {
  constructor() {
    TargetToMoveQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l4e_1 = lazy(tmp_0, TargetToMoveQuestionContext$_anonymous__69t77v);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_250(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TargetToMoveQuestionContext';
  }
  hashCode() {
    return -280872601;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TargetToMoveQuestionContext))
      return false;
    return true;
  }
}
class TargetToPullQuestionContext {
  constructor() {
    TargetToPullQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m4e_1 = lazy(tmp_0, TargetToPullQuestionContext$_anonymous__a77sch);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_251(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TargetToPullQuestionContext';
  }
  hashCode() {
    return -133754765;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TargetToPullQuestionContext))
      return false;
    return true;
  }
}
class TargetToSpendAncientPowersOnQuestionContext {
  constructor() {
    TargetToSpendAncientPowersOnQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n4e_1 = lazy(tmp_0, TargetToSpendAncientPowersOnQuestionContext$_anonymous__pqxmov);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_252(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TargetToSpendAncientPowersOnQuestionContext';
  }
  hashCode() {
    return 692325457;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TargetToSpendAncientPowersOnQuestionContext))
      return false;
    return true;
  }
}
class VictimToProtectQuestionContext {
  constructor() {
    VictimToProtectQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o4e_1 = lazy(tmp_0, VictimToProtectQuestionContext$_anonymous__kqb2km);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_253(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'VictimToProtectQuestionContext';
  }
  hashCode() {
    return -1368002782;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VictimToProtectQuestionContext))
      return false;
    return true;
  }
}
class Companion_209 {
  constructor() {
    Companion_instance_209 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p4e_1 = [lazy(tmp_0, DiscardToMoveVariant$Companion$$childSerializers$_anonymous__gb77bl)];
  }
}
class $serializer_177 {
  constructor() {
    $serializer_instance_176 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DiscardToMoveVariant', this, 1);
    tmp0_serialDesc.h1b('card', false);
    this.q4e_1 = tmp0_serialDesc;
  }
  r4e(encoder, value) {
    var tmp0_desc = this.q4e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_210().p4e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s4e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r4e(encoder, value instanceof DiscardToMoveVariant ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q4e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_210().p4e_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DiscardToMoveVariant.t4e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.q4e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_210().p4e_1[0].k3()];
  }
}
class DiscardToMoveVariant {
  constructor(card) {
    Companion_getInstance_210();
    this.s4e_1 = card;
  }
  toString() {
    return 'DiscardToMoveVariant(card=' + toString(this.s4e_1) + ')';
  }
  hashCode() {
    return hashCode(this.s4e_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardToMoveVariant))
      return false;
    if (!equals(this.s4e_1, other.s4e_1))
      return false;
    return true;
  }
  static t4e(seen0, card, serializationConstructorMarker) {
    Companion_getInstance_210();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_176().q4e_1);
    }
    var $this = createThis(this);
    $this.s4e_1 = card;
    return $this;
  }
}
class Companion_210 {
  constructor() {
    Companion_instance_210 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u4e_1 = [lazy(tmp_0, DiscardToUseBoatVariant$Companion$$childSerializers$_anonymous__3ioslp)];
  }
}
class $serializer_178 {
  constructor() {
    $serializer_instance_177 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DiscardToUseBoatVariant', this, 1);
    tmp0_serialDesc.h1b('card', false);
    this.v4e_1 = tmp0_serialDesc;
  }
  w4e(encoder, value) {
    var tmp0_desc = this.v4e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_211().u4e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x4e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w4e(encoder, value instanceof DiscardToUseBoatVariant ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v4e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_211().u4e_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DiscardToUseBoatVariant.y4e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.v4e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_211().u4e_1[0].k3()];
  }
}
class DiscardToUseBoatVariant {
  constructor(card) {
    Companion_getInstance_211();
    this.x4e_1 = card;
  }
  toString() {
    return 'DiscardToUseBoatVariant(card=' + toString(this.x4e_1) + ')';
  }
  hashCode() {
    return hashCode(this.x4e_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardToUseBoatVariant))
      return false;
    if (!equals(this.x4e_1, other.x4e_1))
      return false;
    return true;
  }
  static y4e(seen0, card, serializationConstructorMarker) {
    Companion_getInstance_211();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_177().v4e_1);
    }
    var $this = createThis(this);
    $this.x4e_1 = card;
    return $this;
  }
}
class PassVariant {
  constructor() {
    PassVariant_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z4e_1 = lazy(tmp_0, PassVariant$_anonymous__6jdeqr);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_254(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PassVariant';
  }
  hashCode() {
    return 1102552911;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PassVariant))
      return false;
    return true;
  }
}
class Companion_211 {
  constructor() {
    Companion_instance_211 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a4f_1 = [lazy(tmp_0, PlayCardVariant$Companion$$childSerializers$_anonymous__ljwk4p)];
  }
}
class $serializer_179 {
  constructor() {
    $serializer_instance_178 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayCardVariant', this, 1);
    tmp0_serialDesc.h1b('card', false);
    this.b4f_1 = tmp0_serialDesc;
  }
  c4f(encoder, value) {
    var tmp0_desc = this.b4f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_212().a4f_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d4f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c4f(encoder, value instanceof PlayCardVariant ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_212().a4f_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlayCardVariant.e4f(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b4f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_212().a4f_1[0].k3()];
  }
}
class PlayCardVariant {
  constructor(card) {
    Companion_getInstance_212();
    this.d4f_1 = card;
  }
  toString() {
    return 'PlayCardVariant(card=' + toString(this.d4f_1) + ')';
  }
  hashCode() {
    return hashCode(this.d4f_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayCardVariant))
      return false;
    if (!equals(this.d4f_1, other.d4f_1))
      return false;
    return true;
  }
  static e4f(seen0, card, serializationConstructorMarker) {
    Companion_getInstance_212();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_178().b4f_1);
    }
    var $this = createThis(this);
    $this.d4f_1 = card;
    return $this;
  }
}
class Companion_212 {
  constructor() {
    Companion_instance_212 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f4f_1 = [lazy(tmp_0, TriggerOptionRequirement$CardRequirement$Companion$$childSerializers$_anonymous__88rt23), null];
  }
}
class $serializer_180 {
  constructor() {
    $serializer_instance_179 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CardTriggerOptionRequirement', this, 2);
    tmp0_serialDesc.h1b('boundCard', false);
    tmp0_serialDesc.h1b('costToPlay', false);
    this.g4f_1 = tmp0_serialDesc;
  }
  h4f(encoder, value) {
    var tmp0_desc = this.g4f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_213().f4f_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i4f_1);
    tmp1_output.z14(tmp0_desc, 1, value.j4f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h4f(encoder, value instanceof CardRequirement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_213().f4f_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return CardRequirement.k4f(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.g4f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_213().f4f_1[0].k3(), IntSerializer_getInstance()];
  }
}
class TriggerOptionRequirement {}
class CardRequirement {
  constructor(boundCard, costToPlay) {
    Companion_getInstance_213();
    this.i4f_1 = boundCard;
    this.j4f_1 = costToPlay;
  }
  toString() {
    return 'CardRequirement(boundCard=' + toString(this.i4f_1) + ', costToPlay=' + this.j4f_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.i4f_1);
    result = imul(result, 31) + this.j4f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardRequirement))
      return false;
    if (!equals(this.i4f_1, other.i4f_1))
      return false;
    if (!(this.j4f_1 === other.j4f_1))
      return false;
    return true;
  }
  static k4f(seen0, boundCard, costToPlay, serializationConstructorMarker) {
    Companion_getInstance_213();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_179().g4f_1);
    }
    var $this = createThis(this);
    $this.i4f_1 = boundCard;
    $this.j4f_1 = costToPlay;
    return $this;
  }
}
class Optional {
  constructor() {
    Optional_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l4f_1 = lazy(tmp_0, TriggerOptionRequirement$Optional$_anonymous__w11tux);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_255(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Optional';
  }
  hashCode() {
    return -196700525;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Optional))
      return false;
    return true;
  }
}
class Mandatory {
  constructor() {
    Mandatory_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m4f_1 = lazy(tmp_0, TriggerOptionRequirement$Mandatory$_anonymous__37bbws);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_256(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Mandatory';
  }
  hashCode() {
    return 253871366;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Mandatory))
      return false;
    return true;
  }
}
class Companion_213 {
  a2g() {
    var tmp = getKClass(TriggerOptionRequirement);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(CardRequirement), getKClass(Mandatory), getKClass(Optional)];
    var tmp_1 = $serializer_getInstance_179();
    var tmp_2 = Mandatory_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_3 = ObjectSerializer.l1c('MandatoryTriggerOptionRequirement', tmp_2, tmp$ret$3);
    var tmp_4 = Optional_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_5 = [tmp_1, tmp_3, ObjectSerializer.l1c('OptionalTriggerOptionRequirement', tmp_4, tmp$ret$6)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    return SealedClassSerializer.i10('steelart.beast.TriggerOptionRequirement', tmp, tmp_0, tmp_5, tmp$ret$12);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class BeastGameExpansions extends Enum {}
class Companion_214 {
  a2g() {
    var tmp = getKClass(GameRules);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ArrivalOfTheTitanContract), getKClass(AshfallUnlikelyAllianceContract), getKClass(AttackOnTheNorthernSettlementsContract), getKClass(DisturbanceOfTheNorthernGodsContract), getKClass(GreatCleansingContract), getKClass(PactLongForgottenContract), getKClass(RecoveryTestContract), getKClass(SecretsFromALostAgeContract), getKClass(ShipwreckContract), getKClass(UnleashingTheAbyssContract), getKClass(UnlikelyAllianceContract), getKClass(RegentOfRuinsContract)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_71(), $serializer_getInstance_75(), $serializer_getInstance_81(), $serializer_getInstance_126(), $serializer_getInstance_321(), $serializer_getInstance_371(), $serializer_getInstance_374(), $serializer_getInstance_397(), $serializer_getInstance_398(), $serializer_getInstance_409(), $serializer_getInstance_410(), $serializer_getInstance_380()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.GameRules', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_215 {
  constructor() {
    Companion_instance_215 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n4f_1 = lazy(tmp_0, ClassicGameRules$Companion$_anonymous__2qk93w);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_257(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_216 {
  constructor() {
    Companion_instance_216 = this;
    this.e3a_1 = BeastBalanceVersion_OfficialV2_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f3a_1 = lazy(tmp_0, BeastBalanceVersion$Companion$_anonymous__9e3ki4);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_258(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class BeastBalanceVersion extends Enum {}
class Companion_217 {
  constructor() {
    Companion_instance_217 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s4f_1 = lazy(tmp_0, KillingSettlersClassicGameRules$Companion$_anonymous__xdoej0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_259(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_218 {
  constructor() {
    Companion_instance_218 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t4f_1 = [lazy(tmp_0, GameRulesParameters$Companion$$childSerializers$_anonymous__b23c05), null, null, null, null];
  }
}
class $serializer_181 {
  constructor() {
    $serializer_instance_180 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GameRulesParameters', this, 5);
    tmp0_serialDesc.h1b('balanceVersion', false);
    tmp0_serialDesc.h1b('gameContentVersion', false);
    tmp0_serialDesc.h1b('simpleStartingBonuses', true);
    tmp0_serialDesc.h1b('useAlternativeBeastSetup', true);
    tmp0_serialDesc.h1b('useTwoPlayersDraft', true);
    this.u4f_1 = tmp0_serialDesc;
  }
  v4f(encoder, value) {
    var tmp0_desc = this.u4f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_219().t4f_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w4f_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_181(), value.x4f_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.y4f_1 == null)) {
      tmp1_output.i15(tmp0_desc, 2, $serializer_getInstance_182(), value.y4f_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.z4f_1 === false)) {
      tmp1_output.w14(tmp0_desc, 3, value.z4f_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.a4g_1 === false)) {
      tmp1_output.w14(tmp0_desc, 4, value.a4g_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v4f(encoder, value instanceof GameRulesParameters ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = false;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_219().t4f_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_181(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.d14(tmp0_desc, 2, $serializer_getInstance_182(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.r13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.r13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_181(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.d14(tmp0_desc, 2, $serializer_getInstance_182(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.r13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.r13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return GameRulesParameters.b4g(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.u4f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_219().t4f_1[0].k3(), $serializer_getInstance_181(), get_nullable($serializer_getInstance_182()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class GameRulesParameters {
  constructor(balanceVersion, gameContentVersion, simpleStartingBonuses, useAlternativeBeastSetup, useTwoPlayersDraft) {
    Companion_getInstance_219();
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    useAlternativeBeastSetup = useAlternativeBeastSetup === VOID ? false : useAlternativeBeastSetup;
    useTwoPlayersDraft = useTwoPlayersDraft === VOID ? false : useTwoPlayersDraft;
    this.w4f_1 = balanceVersion;
    this.x4f_1 = gameContentVersion;
    this.y4f_1 = simpleStartingBonuses;
    this.z4f_1 = useAlternativeBeastSetup;
    this.a4g_1 = useTwoPlayersDraft;
  }
  c4g(balanceVersion, gameContentVersion, simpleStartingBonuses, useAlternativeBeastSetup, useTwoPlayersDraft) {
    return new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses, useAlternativeBeastSetup, useTwoPlayersDraft);
  }
  d4g(balanceVersion, gameContentVersion, simpleStartingBonuses, useAlternativeBeastSetup, useTwoPlayersDraft, $super) {
    balanceVersion = balanceVersion === VOID ? this.w4f_1 : balanceVersion;
    gameContentVersion = gameContentVersion === VOID ? this.x4f_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? this.y4f_1 : simpleStartingBonuses;
    useAlternativeBeastSetup = useAlternativeBeastSetup === VOID ? this.z4f_1 : useAlternativeBeastSetup;
    useTwoPlayersDraft = useTwoPlayersDraft === VOID ? this.a4g_1 : useTwoPlayersDraft;
    return $super === VOID ? this.c4g(balanceVersion, gameContentVersion, simpleStartingBonuses, useAlternativeBeastSetup, useTwoPlayersDraft) : $super.c4g.call(this, balanceVersion, gameContentVersion, simpleStartingBonuses, useAlternativeBeastSetup, useTwoPlayersDraft);
  }
  toString() {
    return 'GameRulesParameters(balanceVersion=' + this.w4f_1.toString() + ', gameContentVersion=' + this.x4f_1.toString() + ', simpleStartingBonuses=' + toString_0(this.y4f_1) + ', useAlternativeBeastSetup=' + this.z4f_1 + ', useTwoPlayersDraft=' + this.a4g_1 + ')';
  }
  hashCode() {
    var result = this.w4f_1.hashCode();
    result = imul(result, 31) + this.x4f_1.hashCode() | 0;
    result = imul(result, 31) + (this.y4f_1 == null ? 0 : this.y4f_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z4f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a4g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameRulesParameters))
      return false;
    if (!this.w4f_1.equals(other.w4f_1))
      return false;
    if (!this.x4f_1.equals(other.x4f_1))
      return false;
    if (!equals(this.y4f_1, other.y4f_1))
      return false;
    if (!(this.z4f_1 === other.z4f_1))
      return false;
    if (!(this.a4g_1 === other.a4g_1))
      return false;
    return true;
  }
  static b4g(seen0, balanceVersion, gameContentVersion, simpleStartingBonuses, useAlternativeBeastSetup, useTwoPlayersDraft, serializationConstructorMarker) {
    Companion_getInstance_219();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_180().u4f_1);
    }
    var $this = createThis(this);
    $this.w4f_1 = balanceVersion;
    $this.x4f_1 = gameContentVersion;
    if (0 === (seen0 & 4))
      $this.y4f_1 = null;
    else
      $this.y4f_1 = simpleStartingBonuses;
    if (0 === (seen0 & 8))
      $this.z4f_1 = false;
    else
      $this.z4f_1 = useAlternativeBeastSetup;
    if (0 === (seen0 & 16))
      $this.a4g_1 = false;
    else
      $this.a4g_1 = useTwoPlayersDraft;
    return $this;
  }
}
class Companion_219 {
  constructor() {
    Companion_instance_219 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v39_1 = [lazy(tmp_0, GameContentVersion$Companion$$childSerializers$_anonymous__ggb893)];
    this.w39_1 = GameContentVersion.v3d(emptySet());
    this.x39_1 = GameContentVersion.r3d(BeastGameExpansions_ShatteredIsles_getInstance());
  }
}
class $serializer_182 {
  constructor() {
    $serializer_instance_181 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GameContentVersion', this, 1);
    tmp0_serialDesc.h1b('expansions', false);
    this.e4g_1 = tmp0_serialDesc;
  }
  f4g(encoder, value) {
    var tmp0_desc = this.e4g_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_220().v39_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q3d_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f4g(encoder, value instanceof GameContentVersion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e4g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_220().v39_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GameContentVersion.g4g(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e4g_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_220().v39_1[0].k3()];
  }
}
class GameContentVersion {
  constructor(expansions) {
    return new.target.v3d(expansions);
  }
  static v3d(expansions) {
    Companion_getInstance_220();
    var $this = createThis(this);
    $this.q3d_1 = expansions;
    return $this;
  }
  static r3d(singleGameExpansion) {
    Companion_getInstance_220();
    return this.v3d(setOf(singleGameExpansion));
  }
  p4f() {
    return this.q3d_1.w2(BeastGameExpansions_ShatteredIsles_getInstance());
  }
  h4g() {
    return this.q3d_1.w2(BeastGameExpansions_Ashfall_getInstance());
  }
  i4g(version) {
    return version.q3d_1.r4(this.q3d_1);
  }
  toString() {
    return 'GameContentVersion(expansions=' + toString(this.q3d_1) + ')';
  }
  hashCode() {
    return hashCode(this.q3d_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameContentVersion))
      return false;
    if (!equals(this.q3d_1, other.q3d_1))
      return false;
    return true;
  }
  static g4g(seen0, expansions, serializationConstructorMarker) {
    Companion_getInstance_220();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_181().e4g_1);
    }
    var $this = createThis(this);
    $this.q3d_1 = expansions;
    return $this;
  }
}
class Companion_220 {}
class $serializer_183 {
  constructor() {
    $serializer_instance_182 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.SimpleStartingBonuses', this, 3);
    tmp0_serialDesc.h1b('grudgesForBeasts', false);
    tmp0_serialDesc.h1b('grudgesForHunters', false);
    tmp0_serialDesc.h1b('bonusRandomBeastlyTalents', true);
    this.j4g_1 = tmp0_serialDesc;
  }
  k4g(encoder, value) {
    var tmp0_desc = this.j4g_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.l4g_1);
    tmp1_output.z14(tmp0_desc, 1, value.m4g_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.n4g_1 === 0)) {
      tmp1_output.z14(tmp0_desc, 2, value.n4g_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k4g(encoder, value instanceof SimpleStartingBonuses ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j4g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.p13(tmp0_desc);
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return SimpleStartingBonuses.o4g(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.j4g_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class SimpleStartingBonuses {
  constructor(grudgesForBeasts, grudgesForHunters, bonusRandomBeastlyTalents) {
    bonusRandomBeastlyTalents = bonusRandomBeastlyTalents === VOID ? 0 : bonusRandomBeastlyTalents;
    this.l4g_1 = grudgesForBeasts;
    this.m4g_1 = grudgesForHunters;
    this.n4g_1 = bonusRandomBeastlyTalents;
  }
  p4g(grudgesForBeasts, grudgesForHunters, bonusRandomBeastlyTalents) {
    return new SimpleStartingBonuses(grudgesForBeasts, grudgesForHunters, bonusRandomBeastlyTalents);
  }
  q4g(grudgesForBeasts, grudgesForHunters, bonusRandomBeastlyTalents, $super) {
    grudgesForBeasts = grudgesForBeasts === VOID ? this.l4g_1 : grudgesForBeasts;
    grudgesForHunters = grudgesForHunters === VOID ? this.m4g_1 : grudgesForHunters;
    bonusRandomBeastlyTalents = bonusRandomBeastlyTalents === VOID ? this.n4g_1 : bonusRandomBeastlyTalents;
    return $super === VOID ? this.p4g(grudgesForBeasts, grudgesForHunters, bonusRandomBeastlyTalents) : $super.p4g.call(this, grudgesForBeasts, grudgesForHunters, bonusRandomBeastlyTalents);
  }
  toString() {
    return 'SimpleStartingBonuses(grudgesForBeasts=' + this.l4g_1 + ', grudgesForHunters=' + this.m4g_1 + ', bonusRandomBeastlyTalents=' + this.n4g_1 + ')';
  }
  hashCode() {
    var result = this.l4g_1;
    result = imul(result, 31) + this.m4g_1 | 0;
    result = imul(result, 31) + this.n4g_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SimpleStartingBonuses))
      return false;
    if (!(this.l4g_1 === other.l4g_1))
      return false;
    if (!(this.m4g_1 === other.m4g_1))
      return false;
    if (!(this.n4g_1 === other.n4g_1))
      return false;
    return true;
  }
  static o4g(seen0, grudgesForBeasts, grudgesForHunters, bonusRandomBeastlyTalents, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_182().j4g_1);
    }
    var $this = createThis(this);
    $this.l4g_1 = grudgesForBeasts;
    $this.m4g_1 = grudgesForHunters;
    if (0 === (seen0 & 4))
      $this.n4g_1 = 0;
    else
      $this.n4g_1 = bonusRandomBeastlyTalents;
    return $this;
  }
}
class NightRewardStatus extends Enum {}
class Companion_221 {}
class $serializer_184 {
  constructor() {
    $serializer_instance_183 = this;
    var tmp0_serialDesc = new InlineClassDescriptor('steelart.beast.GameTeam', this);
    tmp0_serialDesc.h1b('teamId', false);
    this.r4g_1 = tmp0_serialDesc;
  }
  s4g(encoder, value) {
    var tmp0_inlineEncoder = encoder.v14(this.r4g_1);
    if (tmp0_inlineEncoder == null)
      null;
    else {
      tmp0_inlineEncoder.o14(_GameTeam___get_teamId__impl__chxeb3(value));
    }
  }
  ez(encoder, value) {
    return this.s4g(encoder, value instanceof GameTeam ? value.r3p_1 : THROW_CCE());
  }
  t4g(decoder) {
    return _GameTeam___init__impl__xtwsj2(decoder.m13(this.r4g_1).f13());
  }
  fz(decoder) {
    return new GameTeam(this.t4g(decoder));
  }
  dz() {
    return this.r4g_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class GameTeam {
  constructor(teamId) {
    this.r3p_1 = teamId;
  }
  toString() {
    return GameTeam__toString_impl_wfw0a6(this.r3p_1);
  }
  hashCode() {
    return GameTeam__hashCode_impl_gu24w3(this.r3p_1);
  }
  equals(other) {
    return GameTeam__equals_impl_fenwin(this.r3p_1, other);
  }
}
class Companion_222 {
  a2g() {
    var tmp = getKClass(GameScope);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(CardApplyingScope), getKClass(CardResolvingScope), getKClass(ControllingActorScope), getKClass(EffectsAfterEventScope), getKClass(EventTriggeredByEffectSourceScope), getKClass(AbruptAssembleStatement), getKClass(AbruptDecayActionStatement), getKClass(AbyssalBeastStatement), getKClass(AbyssalHellFireStatement), getKClass(AbyssalPullStatement), getKClass(ActivateSnareStatement), getKClass(ActivateSummonsStatement), getKClass(ActivateTrapStatement), getKClass(AllureKillSoulBonusStatement), getKClass(AllureStatement), getKClass(AmassTransformationStatement), getKClass(BindingHuntReactionStatement), getKClass(BleatCardTriggerStatement), getKClass(DraugBerserkReactionStatement), getKClass(DreamerMaskReactionStatement), getKClass(EsmeriasStrandReactionStatement), getKClass(FlareReactionStatement), getKClass(IntuitionReactionStatement), getKClass(MistShroudReactionStatement), getKClass(PlayCardAsReactionStatement), getKClass(SmokebombReactionStatement), getKClass(SuddenMistReactionStatement), getKClass(WorldShiftReactionStatement), getKClass(ArrivalOfTheTitanHuntersTeamBonusMoveStatement), getKClass(AshfallAttackOrSummonFromRuinStatement), getKClass(AshfallEachBeastAndSummonMoves), getKClass(AttackBySheepStatement), getKClass(AttackOrSummonFromRuinStatement), getKClass(AttackStatement), getKClass(BeastlyTongueStatement), getKClass(BeholdStatement), getKClass(BeyondTheVeilPreventYeltrDamageStatement), getKClass(BindingHuntStatement), getKClass(BlackStarStatement), getKClass(BloodHuntStatement), getKClass(BloodTrackStatement), getKClass(BoltAndRecallStatement), getKClass(BramWardBarrierStatement), getKClass(BroodswellStatement), getKClass(BurstStatement), getKClass(CannotBePlayedStatement), getKClass(ChainGrapnelStatement), getKClass(ChargeUpgradeStatement), getKClass(ChiefsCommandStatement), getKClass(MoveAllSettlersAndHuntersByVarja), getKClass(ChooseAndPlayOneCard), getKClass(ChooseMesmeriseTargetStatement), getKClass(ClaimRuinStatement), getKClass(CommandCardStatement), getKClass(ChooseOneOfStatement), getKClass(OptionalStatement), getKClass(SummonSignStatement), getKClass(InAnyOrderStatement), getKClass(ThenActionStatement), getKClass(CopyCardStatement), getKClass(DealDamageToSummonsStatement), getKClass(DeceiveStatement), getKClass(DefenderWithChoiceAction), getKClass(DevotionStatement), getKClass(DiscardCardsStatement), getKClass(DiscardHunterItemFromArsenalStatement), getKClass(DiscardPlacedTrapStatement), getKClass(DischargeStatement), getKClass(DismemberStatement), getKClass(DisplaceTransformLocationsStatement), getKClass(EachBeastAndSummonMoves), getKClass(EludeStatement), getKClass(EmptyStatement), getKClass(EnsnareStatement), getKClass(EruptionEffectStatement), getKClass(ExtractStatement), getKClass(FlameRapierStatement), getKClass(FlourishStatement), getKClass(FylgjaFlightStatement), getKClass(GainAncientPowerStatement), getKClass(GainBeastlyTalentStatement), getKClass(GainDraugCorruptionStatement), getKClass(GainGrudgeStatement), getKClass(GainRandomUnusedDraftActionCardStatement), getKClass(GlimpsBeastsStatement), getKClass(GlipsHuntersStatement), getKClass(GrapnelStatement), getKClass(GreatHowlStatement), getKClass(HatchEggStatement), getKClass(HauntStatement), getKClass(HazeStatement), getKClass(HealNearHunterStatement), getKClass(HealNearbyHuntersAndSettlersStatement), getKClass(HerdStatement), getKClass(HeroicSpeechStatement), getKClass(IncinerateHoardStatement), getKClass(IncinerateStatement), getKClass(InfusionUpgradeStatement), getKClass(LureStatement), getKClass(MountStatement), getKClass(MoveAnimalStatement), getKClass(MoveEverySummonStatement), getKClass(MoveWithAnimalStatement), getKClass(BeastMovesDependingOnHuntersStatement), getKClass(BeastMovesDependingOnSummonsNumberStatement), getKClass(BeastMovesSameZoneStatement), getKClass(FixedDirectionBeastMovementStatement), getKClass(LeapStatement), getKClass(RaagaSlitherStatement), getKClass(SimpleBeastMovementStatement), getKClass(UpriseUpgradedStatement), getKClass(VoidStatement), getKClass(MovementUptoFixedStepsStatement), getKClass(OverloadedFlameRapierMovementStatement), getKClass(RunFromFireStatement), getKClass(TrackStatement), getKClass(WarhogsTuskStatement), getKClass(RelocationInRangeStatement), getKClass(OverloadedShatterStatement), getKClass(OvipunctureStatement), getKClass(AvariceCardHuntersStatement), getKClass(GainHunterItemStatement), getKClass(MoveSeveralHuntersStatement), getKClass(RecoveryTestForEachHunterStatement), getKClass(RetrieveDiscardedAbilitiesStatement), getKClass(PlaceBarrierInSameZoneStatement), getKClass(PlaceBarrierOnLocationsStatement), getKClass(PlaceFireTokenOnNearbyStatement), getKClass(PlaceFireTokensStatement), getKClass(PlaceHatchlingAfterEggStatement), getKClass(PlaceLivingWebNearbyStatement), getKClass(PlaceNewSummonNearbyStatement), getKClass(PlaceNewSummonOnLocationsStatement), getKClass(PlaceNewSummonStatement), getKClass(PlaceOutpostStatement), getKClass(PlaceSnareStatement), getKClass(PlaceUrgullEggOnOwnLocationStatement), getKClass(PlayAshRuinStatement), getKClass(PrimalInstinctsStatement), getKClass(PushStatement), getKClass(RaagaHydraStatement), getKClass(RamAnotherTargetStatement), getKClass(ReapStatement), getKClass(ReceiveSelfDamageStatement), getKClass(RecoveryTestStatement), getKClass(RedirectDamageToDreamerStatement), getKClass(RelocateOneHunterToAnother), getKClass(RelocateToBansheeAndRevealStatement), getKClass(RelocationToSettlementStatement), getKClass(RelocationToWatchtowerStatement), getKClass(ResonanceChooseStatement), getKClass(ResourcefulnessUpgradeStatement), getKClass(ResurrectionStatement), getKClass(RetrieveDiscardedAbilityStatement), getKClass(RetrieveDiscardedDraftActionCardStatement), getKClass(RetrieveUnusedCardStatement), getKClass(RevealLastMovementsStatement), getKClass(RevealToMoveStatement), getKClass(RevengeOfTheSheepStatement), getKClass(RhagnerAdjustHoardStatement), getKClass(RiseHoardStatement), getKClass(RiseStatement), getKClass(SacrificeToPlayDoubleDarkStatement), getKClass(ScorchedEarthHoardStatement), getKClass(ScorchedEarthStatement), getKClass(ScoutStatement), getKClass(SearchForBeastStatement), getKClass(SetTrapStatement), getKClass(ShipwreckSettlerMovementStatement), getKClass(SigridAttackAllNearbyLocationsStatement), getKClass(SigridCreatureLungeStatement), getKClass(SigridPactReversalStatement), getKClass(SigridSearchAllNearbyLocationsStatement), getKClass(SoulReapStatement), getKClass(SoulStealStatement), getKClass(StealGrudgeFromNearbyHunterStatement), getKClass(StrideHuntersStatement), getKClass(SuddenShockStatement), getKClass(SummonAdmirerStatement), getKClass(SummonCreatureStatement), getKClass(SummonFylgjaStatement), getKClass(SummonLindwyrmHoardStatement), getKClass(SummonLindwyrmStatement), getKClass(SummonMovesStatement), getKClass(SummonYeltrStatement), getKClass(SwarmAttackStatement), getKClass(ToothAndSeverStatement), getKClass(TransformAllNearbyStatement), getKClass(TransformLocationsStatement), getKClass(TrapmasterStatement), getKClass(UnnaturalResolveStatement), getKClass(UpgradeStatement), getKClass(VanishStatement), getKClass(VoidCallStatement), getKClass(WardStatement), getKClass(ChooseSettlerForFlareScope), getKClass(EffectRecoveryScope), getKClass(ArrivalOfTheTitanInitialPhase), getKClass(AshfallUnlikelyAllianceInitialPhase), getKClass(AttackOnTheNorthernSettlementsInitialPhase), getKClass(DisturbanceOfTheNorthernGodsInitialPhase), getKClass(GreatCleansingInitialPhase), getKClass(PactLongForgottenInitialPhase), getKClass(RecoveryTestInitialPhase), getKClass(RegentOfRuinsInitialPhase), getKClass(SecretsFromALostAgeInitialPhase), getKClass(ShipwreckInitialPhase), getKClass(UnleashingTheAbyssInitialPhase), getKClass(UnlikelyAllianceInitialPhase), getKClass(DawnPhase), getKClass(FullPreGamePhase), getKClass(InitialPhase), getKClass(NightPhase), getKClass(NonePhase), getKClass(PlayerTurnPhase), getKClass(PreGamePhase), getKClass(StartOfDayPhase), getKClass(PhaseRecoveryScope), getKClass(TextItselfGameScope), getKClass(NightlyRewardScope), getKClass(ReactionCardScope), getKClass(RevealedTriggerSource), getKClass(TurnStageScope)];
    var tmp_1 = $serializer_getInstance_186();
    var tmp_2 = $serializer_getInstance_187();
    var tmp_3 = $serializer_getInstance_188();
    var tmp_4 = $serializer_getInstance_189();
    var tmp_5 = $serializer_getInstance_190();
    var tmp_6 = $serializer_getInstance_107();
    var tmp_7 = AbruptDecayActionStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_8 = ObjectSerializer.l1c('AbruptDecayActionStatement', tmp_7, tmp$ret$3);
    var tmp_9 = AbyssalBeastStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_10 = ObjectSerializer.l1c('AbyssalBeastStatement', tmp_9, tmp$ret$6);
    var tmp_11 = $serializer_getInstance_382();
    var tmp_12 = $serializer_getInstance_68();
    var tmp_13 = $serializer_getInstance_363();
    var tmp_14 = $serializer_getInstance_12();
    var tmp_15 = $serializer_getInstance_13();
    var tmp_16 = $serializer_getInstance_421();
    var tmp_17 = $serializer_getInstance_422();
    var tmp_18 = $serializer_getInstance_324();
    var tmp_19 = $serializer_getInstance_111();
    var tmp_20 = $serializer_getInstance_404();
    var tmp_21 = $serializer_getInstance_128();
    var tmp_22 = $serializer_getInstance_14();
    var tmp_23 = $serializer_getInstance_15();
    var tmp_24 = $serializer_getInstance_16();
    var tmp_25 = $serializer_getInstance_17();
    var tmp_26 = $serializer_getInstance_364();
    var tmp_27 = $serializer_getInstance_18();
    var tmp_28 = $serializer_getInstance_19();
    var tmp_29 = $serializer_getInstance_20();
    var tmp_30 = $serializer_getInstance_21();
    var tmp_31 = $serializer_getInstance_72();
    var tmp_32 = $serializer_getInstance_76();
    var tmp_33 = $serializer_getInstance_77();
    var tmp_34 = $serializer_getInstance_356();
    var tmp_35 = $serializer_getInstance_411();
    var tmp_36 = $serializer_getInstance_5();
    var tmp_37 = $serializer_getInstance_105();
    var tmp_38 = $serializer_getInstance_423();
    var tmp_39 = $serializer_getInstance_346();
    var tmp_40 = $serializer_getInstance_109();
    var tmp_41 = BlackStarStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_42 = ObjectSerializer.l1c('BlackStarStatement', tmp_41, tmp$ret$9);
    var tmp_43 = $serializer_getInstance_429();
    var tmp_44 = $serializer_getInstance_430();
    var tmp_45 = $serializer_getInstance_347();
    var tmp_46 = $serializer_getInstance_112();
    var tmp_47 = $serializer_getInstance_414();
    var tmp_48 = $serializer_getInstance_104();
    var tmp_49 = CannotBePlayedStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_50 = ObjectSerializer.l1c('CannotBePlayedStatement', tmp_49, tmp$ret$12);
    var tmp_51 = $serializer_getInstance_22();
    var tmp_52 = $serializer_getInstance_23();
    var tmp_53 = ChiefsCommandStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_54 = ObjectSerializer.l1c('ChiefsCommandStatement', tmp_53, tmp$ret$15);
    var tmp_55 = MoveAllSettlersAndHuntersByVarja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_56 = ObjectSerializer.l1c('MoveAllSettlersAndHuntersByVarja', tmp_55, tmp$ret$18);
    var tmp_57 = $serializer_getInstance_24();
    var tmp_58 = ChooseMesmeriseTargetStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_59 = ObjectSerializer.l1c('ChooseMesmeriseTargetStatement', tmp_58, tmp$ret$21);
    var tmp_60 = $serializer_getInstance_25();
    var tmp_61 = $serializer_getInstance_433();
    var tmp_62 = $serializer_getInstance_6();
    var tmp_63 = $serializer_getInstance_26();
    var tmp_64 = $serializer_getInstance_27();
    var tmp_65 = $serializer_getInstance();
    var tmp_66 = $serializer_getInstance_2();
    var tmp_67 = $serializer_getInstance_28();
    var tmp_68 = $serializer_getInstance_29();
    var tmp_69 = $serializer_getInstance_138();
    var tmp_70 = $serializer_getInstance_322();
    var tmp_71 = $serializer_getInstance_144();
    var tmp_72 = $serializer_getInstance_30();
    var tmp_73 = $serializer_getInstance_365();
    var tmp_74 = DiscardPlacedTrapStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_75 = ObjectSerializer.l1c('DiscardPlacedTrapStatement', tmp_74, tmp$ret$24);
    var tmp_76 = $serializer_getInstance_405();
    var tmp_77 = $serializer_getInstance_366();
    var tmp_78 = $serializer_getInstance_31();
    var tmp_79 = $serializer_getInstance_412();
    var tmp_80 = $serializer_getInstance_424();
    var tmp_81 = EmptyStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_82 = ObjectSerializer.l1c('EmptyStatement', tmp_81, tmp$ret$27);
    var tmp_83 = $serializer_getInstance_32();
    var tmp_84 = EruptionEffectStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_85 = ObjectSerializer.l1c('EruptionEffectStatement', tmp_84, tmp$ret$30);
    var tmp_86 = ExtractStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_87 = ObjectSerializer.l1c('ExtractStatement', tmp_86, tmp$ret$33);
    var tmp_88 = $serializer_getInstance_142();
    var tmp_89 = $serializer_getInstance_33();
    var tmp_90 = $serializer_getInstance_134();
    var tmp_91 = $serializer_getInstance_34();
    var tmp_92 = $serializer_getInstance_35();
    var tmp_93 = $serializer_getInstance_129();
    var tmp_94 = $serializer_getInstance_36();
    var tmp_95 = $serializer_getInstance_37();
    var tmp_96 = $serializer_getInstance_38();
    var tmp_97 = $serializer_getInstance_39();
    var tmp_98 = $serializer_getInstance_7();
    var tmp_99 = GreatHowlStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_100 = ObjectSerializer.l1c('GreatHowlStatement', tmp_99, tmp$ret$36);
    var tmp_101 = $serializer_getInstance_415();
    var tmp_102 = $serializer_getInstance_137();
    var tmp_103 = $serializer_getInstance_367();
    var tmp_104 = $serializer_getInstance_40();
    var tmp_105 = $serializer_getInstance_41();
    var tmp_106 = $serializer_getInstance_357();
    var tmp_107 = HeroicSpeechStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_108 = ObjectSerializer.l1c('HeroicSpeechStatement', tmp_107, tmp$ret$39);
    var tmp_109 = $serializer_getInstance_383();
    var tmp_110 = $serializer_getInstance_384();
    var tmp_111 = InfusionUpgradeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_112 = ObjectSerializer.l1c('InfusionUpgradeStatement', tmp_111, tmp$ret$42);
    var tmp_113 = $serializer_getInstance_42();
    var tmp_114 = $serializer_getInstance_358();
    var tmp_115 = $serializer_getInstance_43();
    var tmp_116 = $serializer_getInstance_11();
    var tmp_117 = $serializer_getInstance_359();
    var tmp_118 = $serializer_getInstance_44();
    var tmp_119 = $serializer_getInstance_45();
    var tmp_120 = $serializer_getInstance_46();
    var tmp_121 = $serializer_getInstance_47();
    var tmp_122 = $serializer_getInstance_106();
    var tmp_123 = $serializer_getInstance_372();
    var tmp_124 = $serializer_getInstance_4();
    var tmp_125 = $serializer_getInstance_146();
    var tmp_126 = $serializer_getInstance_69();
    var tmp_127 = $serializer_getInstance_0();
    var tmp_128 = $serializer_getInstance_143();
    var tmp_129 = $serializer_getInstance_385();
    var tmp_130 = $serializer_getInstance_48();
    var tmp_131 = $serializer_getInstance_49();
    var tmp_132 = $serializer_getInstance_50();
    var tmp_133 = $serializer_getInstance_51();
    var tmp_134 = $serializer_getInstance_416();
    var tmp_135 = $serializer_getInstance_52();
    var tmp_136 = $serializer_getInstance_1();
    var tmp_137 = $serializer_getInstance_10();
    var tmp_138 = $serializer_getInstance_375();
    var tmp_139 = $serializer_getInstance_53();
    var tmp_140 = $serializer_getInstance_113();
    var tmp_141 = $serializer_getInstance_114();
    var tmp_142 = $serializer_getInstance_386();
    var tmp_143 = $serializer_getInstance_387();
    var tmp_144 = $serializer_getInstance_417();
    var tmp_145 = $serializer_getInstance_418();
    var tmp_146 = $serializer_getInstance_54();
    var tmp_147 = $serializer_getInstance_55();
    var tmp_148 = $serializer_getInstance_56();
    var tmp_149 = $serializer_getInstance_57();
    var tmp_150 = $serializer_getInstance_368();
    var tmp_151 = $serializer_getInstance_419();
    var tmp_152 = $serializer_getInstance_73();
    var tmp_153 = PrimalInstinctsStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_154 = ObjectSerializer.l1c('PrimalInstinctsStatement', tmp_153, tmp$ret$45);
    var tmp_155 = $serializer_getInstance_325();
    var tmp_156 = $serializer_getInstance_373();
    var tmp_157 = $serializer_getInstance_406();
    var tmp_158 = $serializer_getInstance_348();
    var tmp_159 = $serializer_getInstance_58();
    var tmp_160 = $serializer_getInstance_376();
    var tmp_161 = RedirectDamageToDreamerStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_162 = ObjectSerializer.l1c('RedirectDamageToDreamerStatement', tmp_161, tmp$ret$48);
    var tmp_163 = RelocateOneHunterToAnother_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_164 = ObjectSerializer.l1c('RelocateOneHunterToAnother', tmp_163, tmp$ret$51);
    var tmp_165 = $serializer_getInstance_354();
    var tmp_166 = $serializer_getInstance_59();
    var tmp_167 = $serializer_getInstance_323();
    var tmp_168 = ResonanceChooseStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_169 = ObjectSerializer.l1c('ResonanceChooseStatement', tmp_168, tmp$ret$54);
    var tmp_170 = ResourcefulnessUpgradeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_171 = ObjectSerializer.l1c('ResourcefulnessUpgradeStatement', tmp_170, tmp$ret$57);
    var tmp_172 = ResurrectionStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_173 = ObjectSerializer.l1c('ResurrectionStatement', tmp_172, tmp$ret$60);
    var tmp_174 = $serializer_getInstance_8();
    var tmp_175 = $serializer_getInstance_60();
    var tmp_176 = $serializer_getInstance_61();
    var tmp_177 = $serializer_getInstance_62();
    var tmp_178 = $serializer_getInstance_407();
    var tmp_179 = $serializer_getInstance_360();
    var tmp_180 = $serializer_getInstance_388();
    var tmp_181 = $serializer_getInstance_389();
    var tmp_182 = $serializer_getInstance_390();
    var tmp_183 = $serializer_getInstance_147();
    var tmp_184 = $serializer_getInstance_391();
    var tmp_185 = $serializer_getInstance_392();
    var tmp_186 = $serializer_getInstance_78();
    var tmp_187 = $serializer_getInstance_63();
    var tmp_188 = $serializer_getInstance_64();
    var tmp_189 = ShipwreckSettlerMovementStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_190 = ObjectSerializer.l1c('ShipwreckSettlerMovementStatement', tmp_189, tmp$ret$63);
    var tmp_191 = $serializer_getInstance_400();
    var tmp_192 = SigridCreatureLungeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_193 = ObjectSerializer.l1c('SigridCreatureLungeStatement', tmp_192, tmp$ret$66);
    var tmp_194 = SigridPactReversalStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_195 = ObjectSerializer.l1c('SigridPactReversalStatement', tmp_194, tmp$ret$69);
    var tmp_196 = $serializer_getInstance_401();
    var tmp_197 = $serializer_getInstance_349();
    var tmp_198 = $serializer_getInstance_425();
    var tmp_199 = $serializer_getInstance_145();
    var tmp_200 = $serializer_getInstance_65();
    var tmp_201 = $serializer_getInstance_408();
    var tmp_202 = $serializer_getInstance_426();
    var tmp_203 = SummonCreatureStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_204 = ObjectSerializer.l1c('SummonCreatureStatement', tmp_203, tmp$ret$72);
    var tmp_205 = SummonFylgjaStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_206 = ObjectSerializer.l1c('SummonFylgjaStatement', tmp_205, tmp$ret$75);
    var tmp_207 = $serializer_getInstance_393();
    var tmp_208 = $serializer_getInstance_394();
    var tmp_209 = $serializer_getInstance_66();
    var tmp_210 = $serializer_getInstance_350();
    var tmp_211 = SwarmAttackStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_212 = ObjectSerializer.l1c('SwarmAttackStatement', tmp_211, tmp$ret$78);
    var tmp_213 = $serializer_getInstance_351();
    var tmp_214 = $serializer_getInstance_3();
    var tmp_215 = $serializer_getInstance_9();
    var tmp_216 = $serializer_getInstance_344();
    var tmp_217 = $serializer_getInstance_140();
    var tmp_218 = $serializer_getInstance_67();
    var tmp_219 = $serializer_getInstance_355();
    var tmp_220 = VoidCallStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_221 = ObjectSerializer.l1c('VoidCallStatement', tmp_220, tmp$ret$81);
    var tmp_222 = $serializer_getInstance_108();
    var tmp_223 = ChooseSettlerForFlareScope_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_224 = ObjectSerializer.l1c('ChooseSettlerForFlareScope', tmp_223, tmp$ret$84);
    var tmp_225 = $serializer_getInstance_191();
    var tmp_226 = ArrivalOfTheTitanInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_227 = ObjectSerializer.l1c('ArrivalOfTheTitanInitialPhase', tmp_226, tmp$ret$87);
    var tmp_228 = AshfallUnlikelyAllianceInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_229 = ObjectSerializer.l1c('AshfallUnlikelyAllianceInitialPhase', tmp_228, tmp$ret$90);
    var tmp_230 = AttackOnTheNorthernSettlementsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_231 = ObjectSerializer.l1c('AttackOnTheNorthernSettlementsInitialPhase', tmp_230, tmp$ret$93);
    var tmp_232 = DisturbanceOfTheNorthernGodsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_233 = ObjectSerializer.l1c('DisturbanceOfTheNorthernGodsInitialPhase', tmp_232, tmp$ret$96);
    var tmp_234 = GreatCleansingInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_235 = ObjectSerializer.l1c('GreatCleansingInitialPhase', tmp_234, tmp$ret$99);
    var tmp_236 = PactLongForgottenInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_237 = ObjectSerializer.l1c('PactLongForgottenInitialPhase', tmp_236, tmp$ret$102);
    var tmp_238 = RecoveryTestInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_239 = ObjectSerializer.l1c('RecoveryTestInitialPhase', tmp_238, tmp$ret$105);
    var tmp_240 = RegentOfRuinsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_241 = ObjectSerializer.l1c('RegentOfRuinsInitialPhase', tmp_240, tmp$ret$108);
    var tmp_242 = SecretsFromALostAgeInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_243 = ObjectSerializer.l1c('SecretsFromALostAgeInitialPhase', tmp_242, tmp$ret$111);
    var tmp_244 = ShipwreckInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_245 = ObjectSerializer.l1c('ShipwreckInitialPhase', tmp_244, tmp$ret$114);
    var tmp_246 = UnleashingTheAbyssInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_247 = ObjectSerializer.l1c('UnleashingTheAbyssInitialPhase', tmp_246, tmp$ret$117);
    var tmp_248 = UnlikelyAllianceInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_249 = ObjectSerializer.l1c('UnlikelyAllianceInitialPhase', tmp_248, tmp$ret$120);
    var tmp_250 = $serializer_getInstance_185();
    var tmp_251 = FullPreGamePhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_252 = ObjectSerializer.l1c('FullPreGamePhase', tmp_251, tmp$ret$123);
    var tmp_253 = InitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_254 = ObjectSerializer.l1c('InitialPhase', tmp_253, tmp$ret$126);
    var tmp_255 = NightPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_256 = ObjectSerializer.l1c('NightPhase', tmp_255, tmp$ret$129);
    var tmp_257 = NonePhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_258 = ObjectSerializer.l1c('NonePhase', tmp_257, tmp$ret$132);
    var tmp_259 = $serializer_getInstance_184();
    var tmp_260 = PreGamePhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_261 = ObjectSerializer.l1c('PreGamePhase', tmp_260, tmp$ret$135);
    var tmp_262 = StartOfDayPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_263 = [tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_8, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_50, tmp_51, tmp_52, tmp_54, tmp_56, tmp_57, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, tmp_64, tmp_65, tmp_66, tmp_67, tmp_68, tmp_69, tmp_70, tmp_71, tmp_72, tmp_73, tmp_75, tmp_76, tmp_77, tmp_78, tmp_79, tmp_80, tmp_82, tmp_83, tmp_85, tmp_87, tmp_88, tmp_89, tmp_90, tmp_91, tmp_92, tmp_93, tmp_94, tmp_95, tmp_96, tmp_97, tmp_98, tmp_100, tmp_101, tmp_102, tmp_103, tmp_104, tmp_105, tmp_106, tmp_108, tmp_109, tmp_110, tmp_112, tmp_113, tmp_114, tmp_115, tmp_116, tmp_117, tmp_118, tmp_119, tmp_120, tmp_121, tmp_122, tmp_123, tmp_124, tmp_125, tmp_126, tmp_127, tmp_128, tmp_129, tmp_130, tmp_131, tmp_132, tmp_133, tmp_134, tmp_135, tmp_136, tmp_137, tmp_138, tmp_139, tmp_140, tmp_141, tmp_142, tmp_143, tmp_144, tmp_145, tmp_146, tmp_147, tmp_148, tmp_149, tmp_150, tmp_151, tmp_152, tmp_154, tmp_155, tmp_156, tmp_157, tmp_158, tmp_159, tmp_160, tmp_162, tmp_164, tmp_165, tmp_166, tmp_167, tmp_169, tmp_171, tmp_173, tmp_174, tmp_175, tmp_176, tmp_177, tmp_178, tmp_179, tmp_180, tmp_181, tmp_182, tmp_183, tmp_184, tmp_185, tmp_186, tmp_187, tmp_188, tmp_190, tmp_191, tmp_193, tmp_195, tmp_196, tmp_197, tmp_198, tmp_199, tmp_200, tmp_201, tmp_202, tmp_204, tmp_206, tmp_207, tmp_208, tmp_209, tmp_210, tmp_212, tmp_213, tmp_214, tmp_215, tmp_216, tmp_217, tmp_218, tmp_219, tmp_221, tmp_222, tmp_224, tmp_225, tmp_227, tmp_229, tmp_231, tmp_233, tmp_235, tmp_237, tmp_239, tmp_241, tmp_243, tmp_245, tmp_247, tmp_249, tmp_250, tmp_252, tmp_254, tmp_256, tmp_258, tmp_259, tmp_261, ObjectSerializer.l1c('StartOfDayPhase', tmp_262, tmp$ret$138), $serializer_getInstance_192(), $serializer_getInstance_193(), $serializer_getInstance_194(), $serializer_getInstance_195(), $serializer_getInstance_196(), $serializer_getInstance_197()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    return SealedClassSerializer.i10('steelart.beast.GameScope', tmp, tmp_0, tmp_263, tmp$ret$144);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_223 {
  constructor() {
    Companion_instance_223 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u4g_1 = [lazy(tmp_0, PlayerTurnPhase$Companion$$childSerializers$_anonymous__y61okz), null];
  }
}
class $serializer_185 {
  constructor() {
    $serializer_instance_184 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayerTurnPhase', this, 2);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('isMesmerized', true);
    this.v4g_1 = tmp0_serialDesc;
  }
  w4g(encoder, value) {
    var tmp0_desc = this.v4g_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_224().u4g_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x4g_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.y4g_1 === false)) {
      tmp1_output.w14(tmp0_desc, 1, value.y4g_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w4g(encoder, value instanceof PlayerTurnPhase ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v4g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_224().u4g_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlayerTurnPhase.z4g(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.v4g_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_224().u4g_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class PlayerTurnPhase {
  constructor(characterObject, isMesmerized) {
    Companion_getInstance_224();
    isMesmerized = isMesmerized === VOID ? false : isMesmerized;
    this.x4g_1 = characterObject;
    this.y4g_1 = isMesmerized;
  }
  toString() {
    return 'PlayerTurnPhase(characterObject=' + this.x4g_1.toString() + ', isMesmerized=' + this.y4g_1 + ')';
  }
  hashCode() {
    var result = this.x4g_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.y4g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayerTurnPhase))
      return false;
    if (!this.x4g_1.equals(other.x4g_1))
      return false;
    if (!(this.y4g_1 === other.y4g_1))
      return false;
    return true;
  }
  static z4g(seen0, characterObject, isMesmerized, serializationConstructorMarker) {
    Companion_getInstance_224();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_184().v4g_1);
    }
    var $this = createThis(this);
    $this.x4g_1 = characterObject;
    if (0 === (seen0 & 2))
      $this.y4g_1 = false;
    else
      $this.y4g_1 = isMesmerized;
    return $this;
  }
}
class Companion_224 {
  a2g() {
    var tmp = getKClass(ContractInitPhase);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ArrivalOfTheTitanInitialPhase), getKClass(AshfallUnlikelyAllianceInitialPhase), getKClass(AttackOnTheNorthernSettlementsInitialPhase), getKClass(DisturbanceOfTheNorthernGodsInitialPhase), getKClass(GreatCleansingInitialPhase), getKClass(PactLongForgottenInitialPhase), getKClass(RecoveryTestInitialPhase), getKClass(RegentOfRuinsInitialPhase), getKClass(SecretsFromALostAgeInitialPhase), getKClass(ShipwreckInitialPhase), getKClass(UnleashingTheAbyssInitialPhase), getKClass(UnlikelyAllianceInitialPhase)];
    var tmp_1 = ArrivalOfTheTitanInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('ArrivalOfTheTitanInitialPhase', tmp_1, tmp$ret$3);
    var tmp_3 = AshfallUnlikelyAllianceInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('AshfallUnlikelyAllianceInitialPhase', tmp_3, tmp$ret$6);
    var tmp_5 = AttackOnTheNorthernSettlementsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('AttackOnTheNorthernSettlementsInitialPhase', tmp_5, tmp$ret$9);
    var tmp_7 = DisturbanceOfTheNorthernGodsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('DisturbanceOfTheNorthernGodsInitialPhase', tmp_7, tmp$ret$12);
    var tmp_9 = GreatCleansingInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('GreatCleansingInitialPhase', tmp_9, tmp$ret$15);
    var tmp_11 = PactLongForgottenInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('PactLongForgottenInitialPhase', tmp_11, tmp$ret$18);
    var tmp_13 = RecoveryTestInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('RecoveryTestInitialPhase', tmp_13, tmp$ret$21);
    var tmp_15 = RegentOfRuinsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('RegentOfRuinsInitialPhase', tmp_15, tmp$ret$24);
    var tmp_17 = SecretsFromALostAgeInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('SecretsFromALostAgeInitialPhase', tmp_17, tmp$ret$27);
    var tmp_19 = ShipwreckInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('ShipwreckInitialPhase', tmp_19, tmp$ret$30);
    var tmp_21 = UnleashingTheAbyssInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('UnleashingTheAbyssInitialPhase', tmp_21, tmp$ret$33);
    var tmp_23 = UnlikelyAllianceInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_24 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, ObjectSerializer.l1c('UnlikelyAllianceInitialPhase', tmp_23, tmp$ret$36)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    return SealedClassSerializer.i10('steelart.beast.ContractInitPhase', tmp, tmp_0, tmp_24, tmp$ret$42);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_225 {
  a2g() {
    var tmp = getKClass(GamePhase);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ArrivalOfTheTitanInitialPhase), getKClass(AshfallUnlikelyAllianceInitialPhase), getKClass(AttackOnTheNorthernSettlementsInitialPhase), getKClass(DisturbanceOfTheNorthernGodsInitialPhase), getKClass(GreatCleansingInitialPhase), getKClass(PactLongForgottenInitialPhase), getKClass(RecoveryTestInitialPhase), getKClass(RegentOfRuinsInitialPhase), getKClass(SecretsFromALostAgeInitialPhase), getKClass(ShipwreckInitialPhase), getKClass(UnleashingTheAbyssInitialPhase), getKClass(UnlikelyAllianceInitialPhase), getKClass(DawnPhase), getKClass(FullPreGamePhase), getKClass(InitialPhase), getKClass(NightPhase), getKClass(NonePhase), getKClass(PlayerTurnPhase), getKClass(PreGamePhase), getKClass(StartOfDayPhase)];
    var tmp_1 = ArrivalOfTheTitanInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('ArrivalOfTheTitanInitialPhase', tmp_1, tmp$ret$3);
    var tmp_3 = AshfallUnlikelyAllianceInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('AshfallUnlikelyAllianceInitialPhase', tmp_3, tmp$ret$6);
    var tmp_5 = AttackOnTheNorthernSettlementsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('AttackOnTheNorthernSettlementsInitialPhase', tmp_5, tmp$ret$9);
    var tmp_7 = DisturbanceOfTheNorthernGodsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('DisturbanceOfTheNorthernGodsInitialPhase', tmp_7, tmp$ret$12);
    var tmp_9 = GreatCleansingInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('GreatCleansingInitialPhase', tmp_9, tmp$ret$15);
    var tmp_11 = PactLongForgottenInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('PactLongForgottenInitialPhase', tmp_11, tmp$ret$18);
    var tmp_13 = RecoveryTestInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('RecoveryTestInitialPhase', tmp_13, tmp$ret$21);
    var tmp_15 = RegentOfRuinsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('RegentOfRuinsInitialPhase', tmp_15, tmp$ret$24);
    var tmp_17 = SecretsFromALostAgeInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('SecretsFromALostAgeInitialPhase', tmp_17, tmp$ret$27);
    var tmp_19 = ShipwreckInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('ShipwreckInitialPhase', tmp_19, tmp$ret$30);
    var tmp_21 = UnleashingTheAbyssInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('UnleashingTheAbyssInitialPhase', tmp_21, tmp$ret$33);
    var tmp_23 = UnlikelyAllianceInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('UnlikelyAllianceInitialPhase', tmp_23, tmp$ret$36);
    var tmp_25 = $serializer_getInstance_185();
    var tmp_26 = FullPreGamePhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_27 = ObjectSerializer.l1c('FullPreGamePhase', tmp_26, tmp$ret$39);
    var tmp_28 = InitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_29 = ObjectSerializer.l1c('InitialPhase', tmp_28, tmp$ret$42);
    var tmp_30 = NightPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_31 = ObjectSerializer.l1c('NightPhase', tmp_30, tmp$ret$45);
    var tmp_32 = NonePhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_33 = ObjectSerializer.l1c('NonePhase', tmp_32, tmp$ret$48);
    var tmp_34 = $serializer_getInstance_184();
    var tmp_35 = PreGamePhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_36 = ObjectSerializer.l1c('PreGamePhase', tmp_35, tmp$ret$51);
    var tmp_37 = StartOfDayPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_38 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_25, tmp_27, tmp_29, tmp_31, tmp_33, tmp_34, tmp_36, ObjectSerializer.l1c('StartOfDayPhase', tmp_37, tmp$ret$54)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    return SealedClassSerializer.i10('steelart.beast.GamePhase', tmp, tmp_0, tmp_38, tmp$ret$60);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class ValueId extends Enum {}
class Companion_226 {}
class $serializer_186 {
  constructor() {
    $serializer_instance_185 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DawnPhase', this, 1);
    tmp0_serialDesc.h1b('usePredefinedDraft', true);
    this.a4h_1 = tmp0_serialDesc;
  }
  b4h(encoder, value) {
    var tmp0_desc = this.a4h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.c4h_1 === false)) {
      tmp1_output.w14(tmp0_desc, 0, value.c4h_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b4h(encoder, value instanceof DawnPhase ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a4h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DawnPhase.d4h(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a4h_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance()];
  }
}
class DawnPhase {
  constructor(usePredefinedDraft) {
    usePredefinedDraft = usePredefinedDraft === VOID ? false : usePredefinedDraft;
    this.c4h_1 = usePredefinedDraft;
  }
  toString() {
    return 'DawnPhase(usePredefinedDraft=' + this.c4h_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.c4h_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DawnPhase))
      return false;
    if (!(this.c4h_1 === other.c4h_1))
      return false;
    return true;
  }
  static d4h(seen0, usePredefinedDraft, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_185().a4h_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.c4h_1 = false;
    else
      $this.c4h_1 = usePredefinedDraft;
    return $this;
  }
}
class StartOfDayPhase {
  constructor() {
    StartOfDayPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e4h_1 = lazy(tmp_0, StartOfDayPhase$_anonymous__voo9un);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_260(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'StartOfDayPhase';
  }
  hashCode() {
    return -1222210861;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StartOfDayPhase))
      return false;
    return true;
  }
}
class Companion_227 {
  constructor() {
    Companion_instance_227 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, CardApplyingScope$Companion$$childSerializers$_anonymous__dsrhba);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, CardApplyingScope$Companion$$childSerializers$_anonymous__dsrhba_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f4h_1 = [tmp_1, tmp_3, lazy(tmp_4, CardApplyingScope$Companion$$childSerializers$_anonymous__dsrhba_1)];
  }
}
class $serializer_187 {
  constructor() {
    $serializer_instance_186 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CardApplyingScope', this, 3);
    tmp0_serialDesc.h1b('card', false);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('cardStatement', false);
    this.g4h_1 = tmp0_serialDesc;
  }
  h4h(encoder, value) {
    var tmp0_desc = this.g4h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_228().f4h_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i4h_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.j4h_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.k4h_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h4h(encoder, value instanceof CardApplyingScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g4h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_228().f4h_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return CardApplyingScope.l4h(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.g4h_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_228().f4h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class CardApplyingScope {
  constructor(card, actor, cardStatement) {
    Companion_getInstance_228();
    this.i4h_1 = card;
    this.j4h_1 = actor;
    this.k4h_1 = cardStatement;
  }
  toString() {
    return 'CardApplyingScope(card=' + toString(this.i4h_1) + ', actor=' + this.j4h_1.toString() + ', cardStatement=' + toString(this.k4h_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.i4h_1);
    result = imul(result, 31) + this.j4h_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.k4h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardApplyingScope))
      return false;
    if (!equals(this.i4h_1, other.i4h_1))
      return false;
    if (!this.j4h_1.equals(other.j4h_1))
      return false;
    if (!equals(this.k4h_1, other.k4h_1))
      return false;
    return true;
  }
  static l4h(seen0, card, actor, cardStatement, serializationConstructorMarker) {
    Companion_getInstance_228();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_186().g4h_1);
    }
    var $this = createThis(this);
    $this.i4h_1 = card;
    $this.j4h_1 = actor;
    $this.k4h_1 = cardStatement;
    return $this;
  }
}
class Companion_228 {
  constructor() {
    Companion_instance_228 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, CardResolvingScope$Companion$$childSerializers$_anonymous__s2k8nj);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, CardResolvingScope$Companion$$childSerializers$_anonymous__s2k8nj_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m4h_1 = [tmp_1, tmp_3, lazy(tmp_4, CardResolvingScope$Companion$$childSerializers$_anonymous__s2k8nj_1)];
  }
}
class $serializer_188 {
  constructor() {
    $serializer_instance_187 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CardResolvingScope', this, 3);
    tmp0_serialDesc.h1b('card', false);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('resolvingKind', false);
    this.n4h_1 = tmp0_serialDesc;
  }
  o4h(encoder, value) {
    var tmp0_desc = this.n4h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_229().m4h_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p4h_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.q4h_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.r4h_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o4h(encoder, value instanceof CardResolvingScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n4h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_229().m4h_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return CardResolvingScope.s4h(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.n4h_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_229().m4h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class CardResolvingScope {
  constructor(card, actor, resolvingKind) {
    Companion_getInstance_229();
    this.p4h_1 = card;
    this.q4h_1 = actor;
    this.r4h_1 = resolvingKind;
  }
  toString() {
    return 'CardResolvingScope(card=' + toString(this.p4h_1) + ', actor=' + this.q4h_1.toString() + ', resolvingKind=' + toString(this.r4h_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.p4h_1);
    result = imul(result, 31) + this.q4h_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.r4h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardResolvingScope))
      return false;
    if (!equals(this.p4h_1, other.p4h_1))
      return false;
    if (!this.q4h_1.equals(other.q4h_1))
      return false;
    if (!equals(this.r4h_1, other.r4h_1))
      return false;
    return true;
  }
  static s4h(seen0, card, actor, resolvingKind, serializationConstructorMarker) {
    Companion_getInstance_229();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_187().n4h_1);
    }
    var $this = createThis(this);
    $this.p4h_1 = card;
    $this.q4h_1 = actor;
    $this.r4h_1 = resolvingKind;
    return $this;
  }
}
class Companion_229 {
  constructor() {
    Companion_instance_229 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t4h_1 = [lazy(tmp_0, ControllingActorScope$Companion$$childSerializers$_anonymous__acw4ko)];
  }
}
class $serializer_189 {
  constructor() {
    $serializer_instance_188 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ControllingActorScope', this, 1);
    tmp0_serialDesc.h1b('actor', false);
    this.u4h_1 = tmp0_serialDesc;
  }
  v4h(encoder, value) {
    var tmp0_desc = this.u4h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_230().t4h_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d3r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v4h(encoder, value instanceof ControllingActorScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u4h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_230().t4h_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ControllingActorScope.w4h(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.u4h_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_230().t4h_1[0].k3()];
  }
}
class ControllingActorScope {
  constructor(actor) {
    Companion_getInstance_230();
    this.d3r_1 = actor;
  }
  toString() {
    return 'ControllingActorScope(actor=' + toString(this.d3r_1) + ')';
  }
  hashCode() {
    return hashCode(this.d3r_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ControllingActorScope))
      return false;
    if (!equals(this.d3r_1, other.d3r_1))
      return false;
    return true;
  }
  static w4h(seen0, actor, serializationConstructorMarker) {
    Companion_getInstance_230();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_188().u4h_1);
    }
    var $this = createThis(this);
    $this.d3r_1 = actor;
    return $this;
  }
}
class Companion_230 {
  constructor() {
    Companion_instance_230 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x4h_1 = [lazy(tmp_0, EffectsAfterEventScope$Companion$$childSerializers$_anonymous__72pm0m)];
  }
}
class $serializer_190 {
  constructor() {
    $serializer_instance_189 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EffectsAfterEventScope', this, 1);
    tmp0_serialDesc.h1b('event', false);
    this.y4h_1 = tmp0_serialDesc;
  }
  z4h(encoder, value) {
    var tmp0_desc = this.y4h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_231().x4h_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a4i_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z4h(encoder, value instanceof EffectsAfterEventScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y4h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_231().x4h_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return EffectsAfterEventScope.b4i(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y4h_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_231().x4h_1[0].k3()];
  }
}
class EffectsAfterEventScope {
  constructor(event) {
    Companion_getInstance_231();
    this.a4i_1 = event;
  }
  toString() {
    return 'EffectsAfterEventScope(event=' + toString(this.a4i_1) + ')';
  }
  hashCode() {
    return hashCode(this.a4i_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EffectsAfterEventScope))
      return false;
    if (!equals(this.a4i_1, other.a4i_1))
      return false;
    return true;
  }
  static b4i(seen0, event, serializationConstructorMarker) {
    Companion_getInstance_231();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_189().y4h_1);
    }
    var $this = createThis(this);
    $this.a4i_1 = event;
    return $this;
  }
}
class Companion_231 {
  constructor() {
    Companion_instance_231 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c4i_1 = [lazy(tmp_0, EventTriggeredByEffectSourceScope$Companion$$childSerializers$_anonymous__e981va)];
  }
}
class $serializer_191 {
  constructor() {
    $serializer_instance_190 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EventTriggeredByEffectSourceScope', this, 1);
    tmp0_serialDesc.h1b('source', false);
    this.d4i_1 = tmp0_serialDesc;
  }
  e4i(encoder, value) {
    var tmp0_desc = this.d4i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_232().c4i_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f4i_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e4i(encoder, value instanceof EventTriggeredByEffectSourceScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d4i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_232().c4i_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return EventTriggeredByEffectSourceScope.g4i(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d4i_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_232().c4i_1[0].k3()];
  }
}
class EventTriggeredByEffectSourceScope {
  constructor(source) {
    Companion_getInstance_232();
    this.f4i_1 = source;
  }
  toString() {
    return 'EventTriggeredByEffectSourceScope(source=' + toString(this.f4i_1) + ')';
  }
  hashCode() {
    return hashCode(this.f4i_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventTriggeredByEffectSourceScope))
      return false;
    if (!equals(this.f4i_1, other.f4i_1))
      return false;
    return true;
  }
  static g4i(seen0, source, serializationConstructorMarker) {
    Companion_getInstance_232();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_190().d4i_1);
    }
    var $this = createThis(this);
    $this.f4i_1 = source;
    return $this;
  }
}
class Companion_232 {
  constructor() {
    Companion_instance_232 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h4i_1 = [lazy(tmp_0, EffectRecoveryScope$Companion$$childSerializers$_anonymous__b4jt0)];
  }
}
class $serializer_192 {
  constructor() {
    $serializer_instance_191 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EffectRecoveryScope', this, 1);
    tmp0_serialDesc.h1b('failedScope', false);
    this.i4i_1 = tmp0_serialDesc;
  }
  j4i(encoder, value) {
    var tmp0_desc = this.i4i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_233().h4i_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k4i_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j4i(encoder, value instanceof EffectRecoveryScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i4i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_233().h4i_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return EffectRecoveryScope.l4i(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.i4i_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_233().h4i_1[0].k3()];
  }
}
class EffectRecoveryScope {
  constructor(failedScope) {
    Companion_getInstance_233();
    this.k4i_1 = failedScope;
  }
  toString() {
    return 'EffectRecoveryScope(failedScope=' + toString(this.k4i_1) + ')';
  }
  hashCode() {
    return hashCode(this.k4i_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EffectRecoveryScope))
      return false;
    if (!equals(this.k4i_1, other.k4i_1))
      return false;
    return true;
  }
  static l4i(seen0, failedScope, serializationConstructorMarker) {
    Companion_getInstance_233();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_191().i4i_1);
    }
    var $this = createThis(this);
    $this.k4i_1 = failedScope;
    return $this;
  }
}
class FullPreGamePhase {
  constructor() {
    FullPreGamePhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m4i_1 = lazy(tmp_0, FullPreGamePhase$_anonymous__aco0ta);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_261(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FullPreGamePhase';
  }
  hashCode() {
    return -417580486;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FullPreGamePhase))
      return false;
    return true;
  }
}
class InitialPhase {
  constructor() {
    InitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n4i_1 = lazy(tmp_0, InitialPhase$_anonymous__emsibk);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_262(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'InitialPhase';
  }
  hashCode() {
    return 41930716;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InitialPhase))
      return false;
    return true;
  }
}
class NightPhase {
  constructor() {
    NightPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o4i_1 = lazy(tmp_0, NightPhase$_anonymous__jx0auk);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_263(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NightPhase';
  }
  hashCode() {
    return 1024898248;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NightPhase))
      return false;
    return true;
  }
}
class NonePhase {
  constructor() {
    NonePhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p4i_1 = lazy(tmp_0, NonePhase$_anonymous__z4i644);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_264(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NonePhase';
  }
  hashCode() {
    return 2036553726;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NonePhase))
      return false;
    return true;
  }
}
class PreGamePhase {
  constructor() {
    PreGamePhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q4i_1 = lazy(tmp_0, PreGamePhase$_anonymous__vmahzl);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_265(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PreGamePhase';
  }
  hashCode() {
    return -628077429;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreGamePhase))
      return false;
    return true;
  }
}
class Companion_233 {
  constructor() {
    Companion_instance_233 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r4i_1 = [lazy(tmp_0, PhaseRecoveryScope$Companion$$childSerializers$_anonymous__k24kyu)];
  }
}
class $serializer_193 {
  constructor() {
    $serializer_instance_192 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PhaseRecoveryScope', this, 1);
    tmp0_serialDesc.h1b('failedPhase', false);
    this.s4i_1 = tmp0_serialDesc;
  }
  t4i(encoder, value) {
    var tmp0_desc = this.s4i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_234().r4i_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u4i_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t4i(encoder, value instanceof PhaseRecoveryScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s4i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_234().r4i_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PhaseRecoveryScope.v4i(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s4i_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_234().r4i_1[0].k3()];
  }
}
class PhaseRecoveryScope {
  constructor(failedPhase) {
    Companion_getInstance_234();
    this.u4i_1 = failedPhase;
  }
  toString() {
    return 'PhaseRecoveryScope(failedPhase=' + toString(this.u4i_1) + ')';
  }
  hashCode() {
    return hashCode(this.u4i_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PhaseRecoveryScope))
      return false;
    if (!equals(this.u4i_1, other.u4i_1))
      return false;
    return true;
  }
  static v4i(seen0, failedPhase, serializationConstructorMarker) {
    Companion_getInstance_234();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_192().s4i_1);
    }
    var $this = createThis(this);
    $this.u4i_1 = failedPhase;
    return $this;
  }
}
class Companion_234 {}
class $serializer_194 {
  constructor() {
    $serializer_instance_193 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TextItselfGameScope', this, 1);
    tmp0_serialDesc.h1b('text', false);
    this.w4i_1 = tmp0_serialDesc;
  }
  x4i(encoder, value) {
    var tmp0_desc = this.w4i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.y4i_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x4i(encoder, value instanceof TextItselfGameScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w4i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return TextItselfGameScope.z4i(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w4i_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class TextItselfGameScope {
  constructor(text) {
    this.y4i_1 = text;
  }
  toString() {
    return 'TextItselfGameScope(text=' + this.y4i_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.y4i_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextItselfGameScope))
      return false;
    if (!(this.y4i_1 === other.y4i_1))
      return false;
    return true;
  }
  static z4i(seen0, text, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_193().w4i_1);
    }
    var $this = createThis(this);
    $this.y4i_1 = text;
    return $this;
  }
}
class Companion_235 {}
class $serializer_195 {
  constructor() {
    $serializer_instance_194 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('NightlyRewardScope', this, 1);
    tmp0_serialDesc.h1b('gameTeam', false);
    this.a4j_1 = tmp0_serialDesc;
  }
  b4j(encoder, value) {
    var tmp0_desc = this.a4j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_183(), new GameTeam(value.c4j_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b4j(encoder, value instanceof NightlyRewardScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a4j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return NightlyRewardScope.d4j(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a4j_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_183()];
  }
}
class NightlyRewardScope {
  constructor(gameTeam) {
    this.c4j_1 = gameTeam;
  }
  toString() {
    return 'NightlyRewardScope(gameTeam=' + GameTeam__toString_impl_wfw0a6(this.c4j_1) + ')';
  }
  hashCode() {
    return GameTeam__hashCode_impl_gu24w3(this.c4j_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NightlyRewardScope))
      return false;
    if (!(this.c4j_1 === other.c4j_1))
      return false;
    return true;
  }
  static d4j(seen0, gameTeam, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_194().a4j_1);
    }
    var $this = createThis(this);
    $this.c4j_1 = gameTeam;
    return $this;
  }
}
class Companion_236 {
  constructor() {
    Companion_instance_236 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e4j_1 = [lazy(tmp_0, ReactionCardScope$Companion$$childSerializers$_anonymous__20ew7l)];
  }
}
class $serializer_196 {
  constructor() {
    $serializer_instance_195 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ReactionCardScope', this, 1);
    tmp0_serialDesc.h1b('card', false);
    this.f4j_1 = tmp0_serialDesc;
  }
  g4j(encoder, value) {
    var tmp0_desc = this.f4j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_237().e4j_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h4j_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g4j(encoder, value instanceof ReactionCardScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f4j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_237().e4j_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ReactionCardScope.i4j(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.f4j_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_237().e4j_1[0].k3()];
  }
}
class ReactionCardScope {
  constructor(card) {
    Companion_getInstance_237();
    this.h4j_1 = card;
  }
  toString() {
    return 'ReactionCardScope(card=' + toString(this.h4j_1) + ')';
  }
  hashCode() {
    return hashCode(this.h4j_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReactionCardScope))
      return false;
    if (!equals(this.h4j_1, other.h4j_1))
      return false;
    return true;
  }
  static i4j(seen0, card, serializationConstructorMarker) {
    Companion_getInstance_237();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_195().f4j_1);
    }
    var $this = createThis(this);
    $this.h4j_1 = card;
    return $this;
  }
}
class Companion_237 {
  constructor() {
    Companion_instance_237 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j4j_1 = [lazy(tmp_0, RevealedTriggerSource$Companion$$childSerializers$_anonymous__qbknr7)];
  }
}
class $serializer_197 {
  constructor() {
    $serializer_instance_196 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevealedTriggerSource', this, 1);
    tmp0_serialDesc.h1b('revealedTriggers', false);
    this.k4j_1 = tmp0_serialDesc;
  }
  l4j(encoder, value) {
    var tmp0_desc = this.k4j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_238().j4j_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.m4j_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l4j(encoder, value instanceof RevealedTriggerSource ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k4j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_238().j4j_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RevealedTriggerSource.n4j(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.k4j_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_238().j4j_1[0].k3()];
  }
}
class RevealedTriggerSource {
  constructor(revealedTriggers) {
    Companion_getInstance_238();
    this.m4j_1 = revealedTriggers;
  }
  toString() {
    return 'RevealedTriggerSource(revealedTriggers=' + toString(this.m4j_1) + ')';
  }
  hashCode() {
    return hashCode(this.m4j_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealedTriggerSource))
      return false;
    if (!equals(this.m4j_1, other.m4j_1))
      return false;
    return true;
  }
  static n4j(seen0, revealedTriggers, serializationConstructorMarker) {
    Companion_getInstance_238();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_196().k4j_1);
    }
    var $this = createThis(this);
    $this.m4j_1 = revealedTriggers;
    return $this;
  }
}
class Companion_238 {
  constructor() {
    Companion_instance_238 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o4j_1 = [lazy(tmp_0, TurnStageScope$Companion$$childSerializers$_anonymous__mz1w6h), null];
  }
}
class $serializer_198 {
  constructor() {
    $serializer_instance_197 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TurnStageScope', this, 2);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('cardNumber', false);
    this.p4j_1 = tmp0_serialDesc;
  }
  q4j(encoder, value) {
    var tmp0_desc = this.p4j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_239().o4j_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r4j_1);
    tmp1_output.z14(tmp0_desc, 1, value.s4j_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q4j(encoder, value instanceof TurnStageScope ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p4j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_239().o4j_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return TurnStageScope.t4j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.p4j_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_239().o4j_1[0].k3(), IntSerializer_getInstance()];
  }
}
class TurnStageScope {
  constructor(actor, cardNumber) {
    Companion_getInstance_239();
    this.r4j_1 = actor;
    this.s4j_1 = cardNumber;
  }
  toString() {
    return 'TurnStageScope(actor=' + this.r4j_1.toString() + ', cardNumber=' + this.s4j_1 + ')';
  }
  hashCode() {
    var result = this.r4j_1.hashCode();
    result = imul(result, 31) + this.s4j_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TurnStageScope))
      return false;
    if (!this.r4j_1.equals(other.r4j_1))
      return false;
    if (!(this.s4j_1 === other.s4j_1))
      return false;
    return true;
  }
  static t4j(seen0, actor, cardNumber, serializationConstructorMarker) {
    Companion_getInstance_239();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_197().p4j_1);
    }
    var $this = createThis(this);
    $this.r4j_1 = actor;
    $this.s4j_1 = cardNumber;
    return $this;
  }
}
class Companion_239 {
  a2g() {
    var tmp = getKClass(ItselfGameScope);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AbruptAssembleStatement), getKClass(AbruptDecayActionStatement), getKClass(AbyssalBeastStatement), getKClass(AbyssalHellFireStatement), getKClass(AbyssalPullStatement), getKClass(ActivateSnareStatement), getKClass(ActivateSummonsStatement), getKClass(ActivateTrapStatement), getKClass(AllureKillSoulBonusStatement), getKClass(AllureStatement), getKClass(AmassTransformationStatement), getKClass(BindingHuntReactionStatement), getKClass(BleatCardTriggerStatement), getKClass(DraugBerserkReactionStatement), getKClass(DreamerMaskReactionStatement), getKClass(EsmeriasStrandReactionStatement), getKClass(FlareReactionStatement), getKClass(IntuitionReactionStatement), getKClass(MistShroudReactionStatement), getKClass(PlayCardAsReactionStatement), getKClass(SmokebombReactionStatement), getKClass(SuddenMistReactionStatement), getKClass(WorldShiftReactionStatement), getKClass(ArrivalOfTheTitanHuntersTeamBonusMoveStatement), getKClass(AshfallAttackOrSummonFromRuinStatement), getKClass(AshfallEachBeastAndSummonMoves), getKClass(AttackBySheepStatement), getKClass(AttackOrSummonFromRuinStatement), getKClass(AttackStatement), getKClass(BeastlyTongueStatement), getKClass(BeholdStatement), getKClass(BeyondTheVeilPreventYeltrDamageStatement), getKClass(BindingHuntStatement), getKClass(BlackStarStatement), getKClass(BloodHuntStatement), getKClass(BloodTrackStatement), getKClass(BoltAndRecallStatement), getKClass(BramWardBarrierStatement), getKClass(BroodswellStatement), getKClass(BurstStatement), getKClass(CannotBePlayedStatement), getKClass(ChainGrapnelStatement), getKClass(ChargeUpgradeStatement), getKClass(ChiefsCommandStatement), getKClass(MoveAllSettlersAndHuntersByVarja), getKClass(ChooseAndPlayOneCard), getKClass(ChooseMesmeriseTargetStatement), getKClass(ClaimRuinStatement), getKClass(CommandCardStatement), getKClass(ChooseOneOfStatement), getKClass(OptionalStatement), getKClass(SummonSignStatement), getKClass(InAnyOrderStatement), getKClass(ThenActionStatement), getKClass(CopyCardStatement), getKClass(DealDamageToSummonsStatement), getKClass(DeceiveStatement), getKClass(DefenderWithChoiceAction), getKClass(DevotionStatement), getKClass(DiscardCardsStatement), getKClass(DiscardHunterItemFromArsenalStatement), getKClass(DiscardPlacedTrapStatement), getKClass(DischargeStatement), getKClass(DismemberStatement), getKClass(DisplaceTransformLocationsStatement), getKClass(EachBeastAndSummonMoves), getKClass(EludeStatement), getKClass(EmptyStatement), getKClass(EnsnareStatement), getKClass(EruptionEffectStatement), getKClass(ExtractStatement), getKClass(FlameRapierStatement), getKClass(FlourishStatement), getKClass(FylgjaFlightStatement), getKClass(GainAncientPowerStatement), getKClass(GainBeastlyTalentStatement), getKClass(GainDraugCorruptionStatement), getKClass(GainGrudgeStatement), getKClass(GainRandomUnusedDraftActionCardStatement), getKClass(GlimpsBeastsStatement), getKClass(GlipsHuntersStatement), getKClass(GrapnelStatement), getKClass(GreatHowlStatement), getKClass(HatchEggStatement), getKClass(HauntStatement), getKClass(HazeStatement), getKClass(HealNearHunterStatement), getKClass(HealNearbyHuntersAndSettlersStatement), getKClass(HerdStatement), getKClass(HeroicSpeechStatement), getKClass(IncinerateHoardStatement), getKClass(IncinerateStatement), getKClass(InfusionUpgradeStatement), getKClass(LureStatement), getKClass(MountStatement), getKClass(MoveAnimalStatement), getKClass(MoveEverySummonStatement), getKClass(MoveWithAnimalStatement), getKClass(BeastMovesDependingOnHuntersStatement), getKClass(BeastMovesDependingOnSummonsNumberStatement), getKClass(BeastMovesSameZoneStatement), getKClass(FixedDirectionBeastMovementStatement), getKClass(LeapStatement), getKClass(RaagaSlitherStatement), getKClass(SimpleBeastMovementStatement), getKClass(UpriseUpgradedStatement), getKClass(VoidStatement), getKClass(MovementUptoFixedStepsStatement), getKClass(OverloadedFlameRapierMovementStatement), getKClass(RunFromFireStatement), getKClass(TrackStatement), getKClass(WarhogsTuskStatement), getKClass(RelocationInRangeStatement), getKClass(OverloadedShatterStatement), getKClass(OvipunctureStatement), getKClass(AvariceCardHuntersStatement), getKClass(GainHunterItemStatement), getKClass(MoveSeveralHuntersStatement), getKClass(RecoveryTestForEachHunterStatement), getKClass(RetrieveDiscardedAbilitiesStatement), getKClass(PlaceBarrierInSameZoneStatement), getKClass(PlaceBarrierOnLocationsStatement), getKClass(PlaceFireTokenOnNearbyStatement), getKClass(PlaceFireTokensStatement), getKClass(PlaceHatchlingAfterEggStatement), getKClass(PlaceLivingWebNearbyStatement), getKClass(PlaceNewSummonNearbyStatement), getKClass(PlaceNewSummonOnLocationsStatement), getKClass(PlaceNewSummonStatement), getKClass(PlaceOutpostStatement), getKClass(PlaceSnareStatement), getKClass(PlaceUrgullEggOnOwnLocationStatement), getKClass(PlayAshRuinStatement), getKClass(PrimalInstinctsStatement), getKClass(PushStatement), getKClass(RaagaHydraStatement), getKClass(RamAnotherTargetStatement), getKClass(ReapStatement), getKClass(ReceiveSelfDamageStatement), getKClass(RecoveryTestStatement), getKClass(RedirectDamageToDreamerStatement), getKClass(RelocateOneHunterToAnother), getKClass(RelocateToBansheeAndRevealStatement), getKClass(RelocationToSettlementStatement), getKClass(RelocationToWatchtowerStatement), getKClass(ResonanceChooseStatement), getKClass(ResourcefulnessUpgradeStatement), getKClass(ResurrectionStatement), getKClass(RetrieveDiscardedAbilityStatement), getKClass(RetrieveDiscardedDraftActionCardStatement), getKClass(RetrieveUnusedCardStatement), getKClass(RevealLastMovementsStatement), getKClass(RevealToMoveStatement), getKClass(RevengeOfTheSheepStatement), getKClass(RhagnerAdjustHoardStatement), getKClass(RiseHoardStatement), getKClass(RiseStatement), getKClass(SacrificeToPlayDoubleDarkStatement), getKClass(ScorchedEarthHoardStatement), getKClass(ScorchedEarthStatement), getKClass(ScoutStatement), getKClass(SearchForBeastStatement), getKClass(SetTrapStatement), getKClass(ShipwreckSettlerMovementStatement), getKClass(SigridAttackAllNearbyLocationsStatement), getKClass(SigridCreatureLungeStatement), getKClass(SigridPactReversalStatement), getKClass(SigridSearchAllNearbyLocationsStatement), getKClass(SoulReapStatement), getKClass(SoulStealStatement), getKClass(StealGrudgeFromNearbyHunterStatement), getKClass(StrideHuntersStatement), getKClass(SuddenShockStatement), getKClass(SummonAdmirerStatement), getKClass(SummonCreatureStatement), getKClass(SummonFylgjaStatement), getKClass(SummonLindwyrmHoardStatement), getKClass(SummonLindwyrmStatement), getKClass(SummonMovesStatement), getKClass(SummonYeltrStatement), getKClass(SwarmAttackStatement), getKClass(ToothAndSeverStatement), getKClass(TransformAllNearbyStatement), getKClass(TransformLocationsStatement), getKClass(TrapmasterStatement), getKClass(UnnaturalResolveStatement), getKClass(UpgradeStatement), getKClass(VanishStatement), getKClass(VoidCallStatement), getKClass(WardStatement), getKClass(ChooseSettlerForFlareScope), getKClass(EffectRecoveryScope), getKClass(ArrivalOfTheTitanInitialPhase), getKClass(AshfallUnlikelyAllianceInitialPhase), getKClass(AttackOnTheNorthernSettlementsInitialPhase), getKClass(DisturbanceOfTheNorthernGodsInitialPhase), getKClass(GreatCleansingInitialPhase), getKClass(PactLongForgottenInitialPhase), getKClass(RecoveryTestInitialPhase), getKClass(RegentOfRuinsInitialPhase), getKClass(SecretsFromALostAgeInitialPhase), getKClass(ShipwreckInitialPhase), getKClass(UnleashingTheAbyssInitialPhase), getKClass(UnlikelyAllianceInitialPhase), getKClass(DawnPhase), getKClass(FullPreGamePhase), getKClass(InitialPhase), getKClass(NightPhase), getKClass(NonePhase), getKClass(PlayerTurnPhase), getKClass(PreGamePhase), getKClass(StartOfDayPhase), getKClass(PhaseRecoveryScope), getKClass(TextItselfGameScope)];
    var tmp_1 = $serializer_getInstance_107();
    var tmp_2 = AbruptDecayActionStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_3 = ObjectSerializer.l1c('AbruptDecayActionStatement', tmp_2, tmp$ret$3);
    var tmp_4 = AbyssalBeastStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_5 = ObjectSerializer.l1c('AbyssalBeastStatement', tmp_4, tmp$ret$6);
    var tmp_6 = $serializer_getInstance_382();
    var tmp_7 = $serializer_getInstance_68();
    var tmp_8 = $serializer_getInstance_363();
    var tmp_9 = $serializer_getInstance_12();
    var tmp_10 = $serializer_getInstance_13();
    var tmp_11 = $serializer_getInstance_421();
    var tmp_12 = $serializer_getInstance_422();
    var tmp_13 = $serializer_getInstance_324();
    var tmp_14 = $serializer_getInstance_111();
    var tmp_15 = $serializer_getInstance_404();
    var tmp_16 = $serializer_getInstance_128();
    var tmp_17 = $serializer_getInstance_14();
    var tmp_18 = $serializer_getInstance_15();
    var tmp_19 = $serializer_getInstance_16();
    var tmp_20 = $serializer_getInstance_17();
    var tmp_21 = $serializer_getInstance_364();
    var tmp_22 = $serializer_getInstance_18();
    var tmp_23 = $serializer_getInstance_19();
    var tmp_24 = $serializer_getInstance_20();
    var tmp_25 = $serializer_getInstance_21();
    var tmp_26 = $serializer_getInstance_72();
    var tmp_27 = $serializer_getInstance_76();
    var tmp_28 = $serializer_getInstance_77();
    var tmp_29 = $serializer_getInstance_356();
    var tmp_30 = $serializer_getInstance_411();
    var tmp_31 = $serializer_getInstance_5();
    var tmp_32 = $serializer_getInstance_105();
    var tmp_33 = $serializer_getInstance_423();
    var tmp_34 = $serializer_getInstance_346();
    var tmp_35 = $serializer_getInstance_109();
    var tmp_36 = BlackStarStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_37 = ObjectSerializer.l1c('BlackStarStatement', tmp_36, tmp$ret$9);
    var tmp_38 = $serializer_getInstance_429();
    var tmp_39 = $serializer_getInstance_430();
    var tmp_40 = $serializer_getInstance_347();
    var tmp_41 = $serializer_getInstance_112();
    var tmp_42 = $serializer_getInstance_414();
    var tmp_43 = $serializer_getInstance_104();
    var tmp_44 = CannotBePlayedStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_45 = ObjectSerializer.l1c('CannotBePlayedStatement', tmp_44, tmp$ret$12);
    var tmp_46 = $serializer_getInstance_22();
    var tmp_47 = $serializer_getInstance_23();
    var tmp_48 = ChiefsCommandStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_49 = ObjectSerializer.l1c('ChiefsCommandStatement', tmp_48, tmp$ret$15);
    var tmp_50 = MoveAllSettlersAndHuntersByVarja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_51 = ObjectSerializer.l1c('MoveAllSettlersAndHuntersByVarja', tmp_50, tmp$ret$18);
    var tmp_52 = $serializer_getInstance_24();
    var tmp_53 = ChooseMesmeriseTargetStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_54 = ObjectSerializer.l1c('ChooseMesmeriseTargetStatement', tmp_53, tmp$ret$21);
    var tmp_55 = $serializer_getInstance_25();
    var tmp_56 = $serializer_getInstance_433();
    var tmp_57 = $serializer_getInstance_6();
    var tmp_58 = $serializer_getInstance_26();
    var tmp_59 = $serializer_getInstance_27();
    var tmp_60 = $serializer_getInstance();
    var tmp_61 = $serializer_getInstance_2();
    var tmp_62 = $serializer_getInstance_28();
    var tmp_63 = $serializer_getInstance_29();
    var tmp_64 = $serializer_getInstance_138();
    var tmp_65 = $serializer_getInstance_322();
    var tmp_66 = $serializer_getInstance_144();
    var tmp_67 = $serializer_getInstance_30();
    var tmp_68 = $serializer_getInstance_365();
    var tmp_69 = DiscardPlacedTrapStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_70 = ObjectSerializer.l1c('DiscardPlacedTrapStatement', tmp_69, tmp$ret$24);
    var tmp_71 = $serializer_getInstance_405();
    var tmp_72 = $serializer_getInstance_366();
    var tmp_73 = $serializer_getInstance_31();
    var tmp_74 = $serializer_getInstance_412();
    var tmp_75 = $serializer_getInstance_424();
    var tmp_76 = EmptyStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_77 = ObjectSerializer.l1c('EmptyStatement', tmp_76, tmp$ret$27);
    var tmp_78 = $serializer_getInstance_32();
    var tmp_79 = EruptionEffectStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_80 = ObjectSerializer.l1c('EruptionEffectStatement', tmp_79, tmp$ret$30);
    var tmp_81 = ExtractStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_82 = ObjectSerializer.l1c('ExtractStatement', tmp_81, tmp$ret$33);
    var tmp_83 = $serializer_getInstance_142();
    var tmp_84 = $serializer_getInstance_33();
    var tmp_85 = $serializer_getInstance_134();
    var tmp_86 = $serializer_getInstance_34();
    var tmp_87 = $serializer_getInstance_35();
    var tmp_88 = $serializer_getInstance_129();
    var tmp_89 = $serializer_getInstance_36();
    var tmp_90 = $serializer_getInstance_37();
    var tmp_91 = $serializer_getInstance_38();
    var tmp_92 = $serializer_getInstance_39();
    var tmp_93 = $serializer_getInstance_7();
    var tmp_94 = GreatHowlStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_95 = ObjectSerializer.l1c('GreatHowlStatement', tmp_94, tmp$ret$36);
    var tmp_96 = $serializer_getInstance_415();
    var tmp_97 = $serializer_getInstance_137();
    var tmp_98 = $serializer_getInstance_367();
    var tmp_99 = $serializer_getInstance_40();
    var tmp_100 = $serializer_getInstance_41();
    var tmp_101 = $serializer_getInstance_357();
    var tmp_102 = HeroicSpeechStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_103 = ObjectSerializer.l1c('HeroicSpeechStatement', tmp_102, tmp$ret$39);
    var tmp_104 = $serializer_getInstance_383();
    var tmp_105 = $serializer_getInstance_384();
    var tmp_106 = InfusionUpgradeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_107 = ObjectSerializer.l1c('InfusionUpgradeStatement', tmp_106, tmp$ret$42);
    var tmp_108 = $serializer_getInstance_42();
    var tmp_109 = $serializer_getInstance_358();
    var tmp_110 = $serializer_getInstance_43();
    var tmp_111 = $serializer_getInstance_11();
    var tmp_112 = $serializer_getInstance_359();
    var tmp_113 = $serializer_getInstance_44();
    var tmp_114 = $serializer_getInstance_45();
    var tmp_115 = $serializer_getInstance_46();
    var tmp_116 = $serializer_getInstance_47();
    var tmp_117 = $serializer_getInstance_106();
    var tmp_118 = $serializer_getInstance_372();
    var tmp_119 = $serializer_getInstance_4();
    var tmp_120 = $serializer_getInstance_146();
    var tmp_121 = $serializer_getInstance_69();
    var tmp_122 = $serializer_getInstance_0();
    var tmp_123 = $serializer_getInstance_143();
    var tmp_124 = $serializer_getInstance_385();
    var tmp_125 = $serializer_getInstance_48();
    var tmp_126 = $serializer_getInstance_49();
    var tmp_127 = $serializer_getInstance_50();
    var tmp_128 = $serializer_getInstance_51();
    var tmp_129 = $serializer_getInstance_416();
    var tmp_130 = $serializer_getInstance_52();
    var tmp_131 = $serializer_getInstance_1();
    var tmp_132 = $serializer_getInstance_10();
    var tmp_133 = $serializer_getInstance_375();
    var tmp_134 = $serializer_getInstance_53();
    var tmp_135 = $serializer_getInstance_113();
    var tmp_136 = $serializer_getInstance_114();
    var tmp_137 = $serializer_getInstance_386();
    var tmp_138 = $serializer_getInstance_387();
    var tmp_139 = $serializer_getInstance_417();
    var tmp_140 = $serializer_getInstance_418();
    var tmp_141 = $serializer_getInstance_54();
    var tmp_142 = $serializer_getInstance_55();
    var tmp_143 = $serializer_getInstance_56();
    var tmp_144 = $serializer_getInstance_57();
    var tmp_145 = $serializer_getInstance_368();
    var tmp_146 = $serializer_getInstance_419();
    var tmp_147 = $serializer_getInstance_73();
    var tmp_148 = PrimalInstinctsStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_149 = ObjectSerializer.l1c('PrimalInstinctsStatement', tmp_148, tmp$ret$45);
    var tmp_150 = $serializer_getInstance_325();
    var tmp_151 = $serializer_getInstance_373();
    var tmp_152 = $serializer_getInstance_406();
    var tmp_153 = $serializer_getInstance_348();
    var tmp_154 = $serializer_getInstance_58();
    var tmp_155 = $serializer_getInstance_376();
    var tmp_156 = RedirectDamageToDreamerStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_157 = ObjectSerializer.l1c('RedirectDamageToDreamerStatement', tmp_156, tmp$ret$48);
    var tmp_158 = RelocateOneHunterToAnother_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_159 = ObjectSerializer.l1c('RelocateOneHunterToAnother', tmp_158, tmp$ret$51);
    var tmp_160 = $serializer_getInstance_354();
    var tmp_161 = $serializer_getInstance_59();
    var tmp_162 = $serializer_getInstance_323();
    var tmp_163 = ResonanceChooseStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_164 = ObjectSerializer.l1c('ResonanceChooseStatement', tmp_163, tmp$ret$54);
    var tmp_165 = ResourcefulnessUpgradeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_166 = ObjectSerializer.l1c('ResourcefulnessUpgradeStatement', tmp_165, tmp$ret$57);
    var tmp_167 = ResurrectionStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_168 = ObjectSerializer.l1c('ResurrectionStatement', tmp_167, tmp$ret$60);
    var tmp_169 = $serializer_getInstance_8();
    var tmp_170 = $serializer_getInstance_60();
    var tmp_171 = $serializer_getInstance_61();
    var tmp_172 = $serializer_getInstance_62();
    var tmp_173 = $serializer_getInstance_407();
    var tmp_174 = $serializer_getInstance_360();
    var tmp_175 = $serializer_getInstance_388();
    var tmp_176 = $serializer_getInstance_389();
    var tmp_177 = $serializer_getInstance_390();
    var tmp_178 = $serializer_getInstance_147();
    var tmp_179 = $serializer_getInstance_391();
    var tmp_180 = $serializer_getInstance_392();
    var tmp_181 = $serializer_getInstance_78();
    var tmp_182 = $serializer_getInstance_63();
    var tmp_183 = $serializer_getInstance_64();
    var tmp_184 = ShipwreckSettlerMovementStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_185 = ObjectSerializer.l1c('ShipwreckSettlerMovementStatement', tmp_184, tmp$ret$63);
    var tmp_186 = $serializer_getInstance_400();
    var tmp_187 = SigridCreatureLungeStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_188 = ObjectSerializer.l1c('SigridCreatureLungeStatement', tmp_187, tmp$ret$66);
    var tmp_189 = SigridPactReversalStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_190 = ObjectSerializer.l1c('SigridPactReversalStatement', tmp_189, tmp$ret$69);
    var tmp_191 = $serializer_getInstance_401();
    var tmp_192 = $serializer_getInstance_349();
    var tmp_193 = $serializer_getInstance_425();
    var tmp_194 = $serializer_getInstance_145();
    var tmp_195 = $serializer_getInstance_65();
    var tmp_196 = $serializer_getInstance_408();
    var tmp_197 = $serializer_getInstance_426();
    var tmp_198 = SummonCreatureStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_199 = ObjectSerializer.l1c('SummonCreatureStatement', tmp_198, tmp$ret$72);
    var tmp_200 = SummonFylgjaStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_201 = ObjectSerializer.l1c('SummonFylgjaStatement', tmp_200, tmp$ret$75);
    var tmp_202 = $serializer_getInstance_393();
    var tmp_203 = $serializer_getInstance_394();
    var tmp_204 = $serializer_getInstance_66();
    var tmp_205 = $serializer_getInstance_350();
    var tmp_206 = SwarmAttackStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_207 = ObjectSerializer.l1c('SwarmAttackStatement', tmp_206, tmp$ret$78);
    var tmp_208 = $serializer_getInstance_351();
    var tmp_209 = $serializer_getInstance_3();
    var tmp_210 = $serializer_getInstance_9();
    var tmp_211 = $serializer_getInstance_344();
    var tmp_212 = $serializer_getInstance_140();
    var tmp_213 = $serializer_getInstance_67();
    var tmp_214 = $serializer_getInstance_355();
    var tmp_215 = VoidCallStatement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_216 = ObjectSerializer.l1c('VoidCallStatement', tmp_215, tmp$ret$81);
    var tmp_217 = $serializer_getInstance_108();
    var tmp_218 = ChooseSettlerForFlareScope_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_219 = ObjectSerializer.l1c('ChooseSettlerForFlareScope', tmp_218, tmp$ret$84);
    var tmp_220 = $serializer_getInstance_191();
    var tmp_221 = ArrivalOfTheTitanInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_222 = ObjectSerializer.l1c('ArrivalOfTheTitanInitialPhase', tmp_221, tmp$ret$87);
    var tmp_223 = AshfallUnlikelyAllianceInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_224 = ObjectSerializer.l1c('AshfallUnlikelyAllianceInitialPhase', tmp_223, tmp$ret$90);
    var tmp_225 = AttackOnTheNorthernSettlementsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_226 = ObjectSerializer.l1c('AttackOnTheNorthernSettlementsInitialPhase', tmp_225, tmp$ret$93);
    var tmp_227 = DisturbanceOfTheNorthernGodsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_228 = ObjectSerializer.l1c('DisturbanceOfTheNorthernGodsInitialPhase', tmp_227, tmp$ret$96);
    var tmp_229 = GreatCleansingInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_230 = ObjectSerializer.l1c('GreatCleansingInitialPhase', tmp_229, tmp$ret$99);
    var tmp_231 = PactLongForgottenInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_232 = ObjectSerializer.l1c('PactLongForgottenInitialPhase', tmp_231, tmp$ret$102);
    var tmp_233 = RecoveryTestInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_234 = ObjectSerializer.l1c('RecoveryTestInitialPhase', tmp_233, tmp$ret$105);
    var tmp_235 = RegentOfRuinsInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_236 = ObjectSerializer.l1c('RegentOfRuinsInitialPhase', tmp_235, tmp$ret$108);
    var tmp_237 = SecretsFromALostAgeInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_238 = ObjectSerializer.l1c('SecretsFromALostAgeInitialPhase', tmp_237, tmp$ret$111);
    var tmp_239 = ShipwreckInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_240 = ObjectSerializer.l1c('ShipwreckInitialPhase', tmp_239, tmp$ret$114);
    var tmp_241 = UnleashingTheAbyssInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_242 = ObjectSerializer.l1c('UnleashingTheAbyssInitialPhase', tmp_241, tmp$ret$117);
    var tmp_243 = UnlikelyAllianceInitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_244 = ObjectSerializer.l1c('UnlikelyAllianceInitialPhase', tmp_243, tmp$ret$120);
    var tmp_245 = $serializer_getInstance_185();
    var tmp_246 = FullPreGamePhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_247 = ObjectSerializer.l1c('FullPreGamePhase', tmp_246, tmp$ret$123);
    var tmp_248 = InitialPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_249 = ObjectSerializer.l1c('InitialPhase', tmp_248, tmp$ret$126);
    var tmp_250 = NightPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_251 = ObjectSerializer.l1c('NightPhase', tmp_250, tmp$ret$129);
    var tmp_252 = NonePhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_253 = ObjectSerializer.l1c('NonePhase', tmp_252, tmp$ret$132);
    var tmp_254 = $serializer_getInstance_184();
    var tmp_255 = PreGamePhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_256 = ObjectSerializer.l1c('PreGamePhase', tmp_255, tmp$ret$135);
    var tmp_257 = StartOfDayPhase_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_258 = [tmp_1, tmp_3, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_45, tmp_46, tmp_47, tmp_49, tmp_51, tmp_52, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, tmp_64, tmp_65, tmp_66, tmp_67, tmp_68, tmp_70, tmp_71, tmp_72, tmp_73, tmp_74, tmp_75, tmp_77, tmp_78, tmp_80, tmp_82, tmp_83, tmp_84, tmp_85, tmp_86, tmp_87, tmp_88, tmp_89, tmp_90, tmp_91, tmp_92, tmp_93, tmp_95, tmp_96, tmp_97, tmp_98, tmp_99, tmp_100, tmp_101, tmp_103, tmp_104, tmp_105, tmp_107, tmp_108, tmp_109, tmp_110, tmp_111, tmp_112, tmp_113, tmp_114, tmp_115, tmp_116, tmp_117, tmp_118, tmp_119, tmp_120, tmp_121, tmp_122, tmp_123, tmp_124, tmp_125, tmp_126, tmp_127, tmp_128, tmp_129, tmp_130, tmp_131, tmp_132, tmp_133, tmp_134, tmp_135, tmp_136, tmp_137, tmp_138, tmp_139, tmp_140, tmp_141, tmp_142, tmp_143, tmp_144, tmp_145, tmp_146, tmp_147, tmp_149, tmp_150, tmp_151, tmp_152, tmp_153, tmp_154, tmp_155, tmp_157, tmp_159, tmp_160, tmp_161, tmp_162, tmp_164, tmp_166, tmp_168, tmp_169, tmp_170, tmp_171, tmp_172, tmp_173, tmp_174, tmp_175, tmp_176, tmp_177, tmp_178, tmp_179, tmp_180, tmp_181, tmp_182, tmp_183, tmp_185, tmp_186, tmp_188, tmp_190, tmp_191, tmp_192, tmp_193, tmp_194, tmp_195, tmp_196, tmp_197, tmp_199, tmp_201, tmp_202, tmp_203, tmp_204, tmp_205, tmp_207, tmp_208, tmp_209, tmp_210, tmp_211, tmp_212, tmp_213, tmp_214, tmp_216, tmp_217, tmp_219, tmp_220, tmp_222, tmp_224, tmp_226, tmp_228, tmp_230, tmp_232, tmp_234, tmp_236, tmp_238, tmp_240, tmp_242, tmp_244, tmp_245, tmp_247, tmp_249, tmp_251, tmp_253, tmp_254, tmp_256, ObjectSerializer.l1c('StartOfDayPhase', tmp_257, tmp$ret$138), $serializer_getInstance_192(), $serializer_getInstance_193()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    return SealedClassSerializer.i10('steelart.beast.ItselfGameScope', tmp, tmp_0, tmp_258, tmp$ret$144);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class EndOfGameException extends Exception {}
class Companion_240 {
  constructor() {
    Companion_instance_240 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, GameSetupState$Companion$$childSerializers$_anonymous__57vero);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, GameSetupState$Companion$$childSerializers$_anonymous__57vero_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, GameSetupState$Companion$$childSerializers$_anonymous__57vero_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v4j_1 = [tmp_1, tmp_3, tmp_5, lazy(tmp_6, GameSetupState$Companion$$childSerializers$_anonymous__57vero_2)];
  }
}
class $serializer_199 {
  constructor() {
    $serializer_instance_198 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GameSetupState', this, 4);
    tmp0_serialDesc.h1b('gameRules', true);
    tmp0_serialDesc.h1b('balanceVersion', true);
    tmp0_serialDesc.h1b('beastCharacters', true);
    tmp0_serialDesc.h1b('hunterCharacters', true);
    this.w4j_1 = tmp0_serialDesc;
  }
  x4j(encoder, value) {
    var tmp0_desc = this.w4j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_241().v4j_1;
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.y4j_1 == null)) {
      tmp1_output.i15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y4j_1);
    }
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.z4j_1.equals(Companion_getInstance_217().e3a_1)) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.z4j_1);
    }
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 2)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      var tmp$ret$0 = ArrayList.p2();
      tmp = !equals(value.a4k_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.a4k_1);
    }
    var tmp_0;
    if (tmp1_output.m15(tmp0_desc, 3)) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      var tmp$ret$1 = ArrayList.p2();
      tmp_0 = !equals(value.b4k_1, tmp$ret$1);
    }
    if (tmp_0) {
      tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.b4k_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x4j(encoder, value instanceof GameSetupState ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w4j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_241().v4j_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.d14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.d14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return GameSetupState.c4k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.w4j_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_241().v4j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0].k3()), tmp0_cached[1].k3(), tmp0_cached[2].k3(), tmp0_cached[3].k3()];
  }
}
class GameSetupState {
  constructor(gameRules, balanceVersion, beastCharacters, hunterCharacters) {
    Companion_getInstance_241();
    gameRules = gameRules === VOID ? null : gameRules;
    balanceVersion = balanceVersion === VOID ? Companion_getInstance_217().e3a_1 : balanceVersion;
    var tmp;
    if (beastCharacters === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList.p2();
    } else {
      tmp = beastCharacters;
    }
    beastCharacters = tmp;
    var tmp_0;
    if (hunterCharacters === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_0 = ArrayList.p2();
    } else {
      tmp_0 = hunterCharacters;
    }
    hunterCharacters = tmp_0;
    this.y4j_1 = gameRules;
    this.z4j_1 = balanceVersion;
    this.a4k_1 = beastCharacters;
    this.b4k_1 = hunterCharacters;
  }
  toString() {
    return 'GameSetupState(gameRules=' + toString_0(this.y4j_1) + ', balanceVersion=' + this.z4j_1.toString() + ', beastCharacters=' + toString(this.a4k_1) + ', hunterCharacters=' + toString(this.b4k_1) + ')';
  }
  hashCode() {
    var result = this.y4j_1 == null ? 0 : hashCode(this.y4j_1);
    result = imul(result, 31) + this.z4j_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.a4k_1) | 0;
    result = imul(result, 31) + hashCode(this.b4k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameSetupState))
      return false;
    if (!equals(this.y4j_1, other.y4j_1))
      return false;
    if (!this.z4j_1.equals(other.z4j_1))
      return false;
    if (!equals(this.a4k_1, other.a4k_1))
      return false;
    if (!equals(this.b4k_1, other.b4k_1))
      return false;
    return true;
  }
  static c4k(seen0, gameRules, balanceVersion, beastCharacters, hunterCharacters, serializationConstructorMarker) {
    Companion_getInstance_241();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_198().w4j_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.y4j_1 = null;
    else
      $this.y4j_1 = gameRules;
    if (0 === (seen0 & 2))
      $this.z4j_1 = Companion_getInstance_217().e3a_1;
    else
      $this.z4j_1 = balanceVersion;
    if (0 === (seen0 & 4)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp.a4k_1 = ArrayList.p2();
    } else
      $this.a4k_1 = beastCharacters;
    if (0 === (seen0 & 8)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_0.b4k_1 = ArrayList.p2();
    } else
      $this.b4k_1 = hunterCharacters;
    return $this;
  }
}
class GameState {}
function get_gameMap() {
  return get_gameMap_0(this.x40());
}
class Companion_241 {
  constructor() {
    Companion_instance_241 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, DestroyRecord$Companion$$childSerializers$_anonymous__6kjatb);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, DestroyRecord$Companion$$childSerializers$_anonymous__6kjatb_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n4l_1 = [tmp_1, null, tmp_3, null, lazy(tmp_4, DestroyRecord$Companion$$childSerializers$_anonymous__6kjatb_1)];
  }
}
class $serializer_200 {
  constructor() {
    $serializer_instance_199 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.DestroyRecord', this, 5);
    tmp0_serialDesc.h1b('destroyed', false);
    tmp0_serialDesc.h1b('causedTeam', false);
    tmp0_serialDesc.h1b('caused', false);
    tmp0_serialDesc.h1b('dayNumber', false);
    tmp0_serialDesc.h1b('reason', false);
    this.o4l_1 = tmp0_serialDesc;
  }
  p4l(encoder, value) {
    var tmp0_desc = this.o4l_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_242().n4l_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o3a_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_183(), new GameTeam(value.p3a_1));
    tmp1_output.i15(tmp0_desc, 2, tmp2_cached[2].k3(), value.q3a_1);
    tmp1_output.z14(tmp0_desc, 3, value.r3a_1);
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.s3a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p4l(encoder, value instanceof DestroyRecord ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o4l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_242().n4l_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp9_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.d14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, tmp10_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp9_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.d14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, tmp10_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return DestroyRecord.q4l(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.o4l_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_242().n4l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), $serializer_getInstance_183(), get_nullable(tmp0_cached[2].k3()), IntSerializer_getInstance(), tmp0_cached[4].k3()];
  }
}
class DestroyRecord {
  constructor(destroyed, causedTeam, caused, dayNumber, reason) {
    Companion_getInstance_242();
    this.o3a_1 = destroyed;
    this.p3a_1 = causedTeam;
    this.q3a_1 = caused;
    this.r3a_1 = dayNumber;
    this.s3a_1 = reason;
  }
  toString() {
    return 'DestroyRecord(destroyed=' + this.o3a_1.toString() + ', causedTeam=' + GameTeam__toString_impl_wfw0a6(this.p3a_1) + ', caused=' + toString_0(this.q3a_1) + ', dayNumber=' + this.r3a_1 + ', reason=' + this.s3a_1.toString() + ')';
  }
  hashCode() {
    var result = this.o3a_1.hashCode();
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.p3a_1) | 0;
    result = imul(result, 31) + (this.q3a_1 == null ? 0 : this.q3a_1.hashCode()) | 0;
    result = imul(result, 31) + this.r3a_1 | 0;
    result = imul(result, 31) + this.s3a_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DestroyRecord))
      return false;
    if (!this.o3a_1.equals(other.o3a_1))
      return false;
    if (!(this.p3a_1 === other.p3a_1))
      return false;
    if (!equals(this.q3a_1, other.q3a_1))
      return false;
    if (!(this.r3a_1 === other.r3a_1))
      return false;
    if (!this.s3a_1.equals(other.s3a_1))
      return false;
    return true;
  }
  static q4l(seen0, destroyed, causedTeam, caused, dayNumber, reason, serializationConstructorMarker) {
    Companion_getInstance_242();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_199().o4l_1);
    }
    var $this = createThis(this);
    $this.o3a_1 = destroyed;
    $this.p3a_1 = causedTeam;
    $this.q3a_1 = caused;
    $this.r3a_1 = dayNumber;
    $this.s3a_1 = reason;
    return $this;
  }
}
class Companion_242 {
  constructor() {
    Companion_instance_242 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_7 = lazy(tmp_6, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_2);
    var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_9 = lazy(tmp_8, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_3);
    var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_11 = lazy(tmp_10, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_4);
    var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_13 = lazy(tmp_12, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_5);
    var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_15 = lazy(tmp_14, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_6);
    var tmp_16 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_17 = lazy(tmp_16, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_7);
    var tmp_18 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_19 = lazy(tmp_18, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_8);
    var tmp_20 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_21 = lazy(tmp_20, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_9);
    var tmp_22 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_23 = lazy(tmp_22, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_10);
    var tmp_24 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_25 = lazy(tmp_24, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_11);
    var tmp_26 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_27 = lazy(tmp_26, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_12);
    var tmp_28 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_29 = lazy(tmp_28, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_13);
    var tmp_30 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_31 = lazy(tmp_30, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_14);
    var tmp_32 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_33 = lazy(tmp_32, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_15);
    var tmp_34 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_35 = lazy(tmp_34, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_16);
    var tmp_36 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_37 = lazy(tmp_36, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_17);
    var tmp_38 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_39 = lazy(tmp_38, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_18);
    var tmp_40 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_41 = lazy(tmp_40, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_19);
    var tmp_42 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r4l_1 = [tmp_1, null, null, null, tmp_3, tmp_5, null, null, null, tmp_7, tmp_9, tmp_11, tmp_13, tmp_15, tmp_17, tmp_19, tmp_21, null, null, tmp_23, tmp_25, null, tmp_27, tmp_29, tmp_31, tmp_33, tmp_35, tmp_37, tmp_39, tmp_41, null, lazy(tmp_42, GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_20), null, null, null, null, null];
  }
}
class $serializer_201 {
  constructor() {
    $serializer_instance_200 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GameStateImpl', this, 37);
    tmp0_serialDesc.h1b('gameRules', false);
    tmp0_serialDesc.h1b('hunterItems', false);
    tmp0_serialDesc.h1b('beastlyTalents', false);
    tmp0_serialDesc.h1b('ashRuins', true);
    tmp0_serialDesc.h1b('gameScopes', true);
    tmp0_serialDesc.h1b('phase', true);
    tmp0_serialDesc.h1b('currentDayNumber', true);
    tmp0_serialDesc.h1b('currentTurnNumber', true);
    tmp0_serialDesc.h1b('revision', true);
    tmp0_serialDesc.h1b('objects', true);
    tmp0_serialDesc.h1b('charactersInOrder', true);
    tmp0_serialDesc.h1b('locationTypes', true);
    tmp0_serialDesc.h1b('pendingTriggerCards', true);
    tmp0_serialDesc.h1b('cardsInPlay', true);
    tmp0_serialDesc.h1b('duplicateCardEffect', true);
    tmp0_serialDesc.h1b('discardedDraftActionCards', true);
    tmp0_serialDesc.h1b('unusedDraftActionCards', true);
    tmp0_serialDesc.h1b('draftState', true);
    tmp0_serialDesc.h1b('remainAncientPowers', true);
    tmp0_serialDesc.h1b('pumpedUpgrades', true);
    tmp0_serialDesc.h1b('chargedUpgrades', true);
    tmp0_serialDesc.h1b('submittedCurrentDamage', true);
    tmp0_serialDesc.h1b('damageBlocked', true);
    tmp0_serialDesc.h1b('placedTrapsCardsInfo', true);
    tmp0_serialDesc.h1b('placedTrapsFullInfo', true);
    tmp0_serialDesc.h1b('ashRuinPositions', true);
    tmp0_serialDesc.h1b('ruinClaimingMap', true);
    tmp0_serialDesc.h1b('firePositions', true);
    tmp0_serialDesc.h1b('destroyRecords', true);
    tmp0_serialDesc.h1b('firstCharacterPassed', true);
    tmp0_serialDesc.h1b('playedCardsNumber', true);
    tmp0_serialDesc.h1b('knownInfo', true);
    tmp0_serialDesc.h1b('isReplayOpenGame', true);
    tmp0_serialDesc.h1b('useRandomPickOnArsenal', true);
    tmp0_serialDesc.h1b('damageDealtToBeasts', true);
    tmp0_serialDesc.h1b('additionalImpl', true);
    tmp0_serialDesc.h1b('nextId', true);
    this.s4l_1 = tmp0_serialDesc;
  }
  t4l(encoder, value) {
    var tmp0_desc = this.s4l_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_243().r4l_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y37_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_203(), value.z37_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_204(), value.a38_1);
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !value.b38_1.equals(new AshRuins())) {
      tmp1_output.g15(tmp0_desc, 3, $serializer_getInstance_205(), value.b38_1);
    }
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 4)) {
      tmp = true;
    } else {
      var tmp_0 = value.c38_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.c38_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !equals(value.d38_1, NonePhase_getInstance())) {
      tmp1_output.g15(tmp0_desc, 5, tmp2_cached[5].k3(), value.d38_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !(value.e38_1 === 1)) {
      tmp1_output.z14(tmp0_desc, 6, value.e38_1);
    }
    if (tmp1_output.m15(tmp0_desc, 7) ? true : !(value.f38_1 === 0)) {
      tmp1_output.z14(tmp0_desc, 7, value.f38_1);
    }
    if (tmp1_output.m15(tmp0_desc, 8) ? true : !(value.g38_1 === 0)) {
      tmp1_output.z14(tmp0_desc, 8, value.g38_1);
    }
    var tmp_1;
    if (tmp1_output.m15(tmp0_desc, 9)) {
      tmp_1 = true;
    } else {
      var tmp_2 = value.h38_1;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$1 = emptyMap();
      tmp_1 = !equals(tmp_2, tmp$ret$1);
    }
    if (tmp_1) {
      tmp1_output.g15(tmp0_desc, 9, tmp2_cached[9].k3(), value.h38_1);
    }
    var tmp_3;
    if (tmp1_output.m15(tmp0_desc, 10)) {
      tmp_3 = true;
    } else {
      var tmp_4 = value.i38_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$2 = emptyList();
      tmp_3 = !equals(tmp_4, tmp$ret$2);
    }
    if (tmp_3) {
      tmp1_output.g15(tmp0_desc, 10, tmp2_cached[10].k3(), value.i38_1);
    }
    var tmp_5;
    if (tmp1_output.m15(tmp0_desc, 11)) {
      tmp_5 = true;
    } else {
      var tmp_6 = value.j38_1;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$3 = emptyMap();
      tmp_5 = !equals(tmp_6, tmp$ret$3);
    }
    if (tmp_5) {
      tmp1_output.g15(tmp0_desc, 11, tmp2_cached[11].k3(), value.j38_1);
    }
    var tmp_7;
    if (tmp1_output.m15(tmp0_desc, 12)) {
      tmp_7 = true;
    } else {
      var tmp_8 = value.k38_1;
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$4 = emptySet();
      tmp_7 = !equals(tmp_8, tmp$ret$4);
    }
    if (tmp_7) {
      tmp1_output.g15(tmp0_desc, 12, tmp2_cached[12].k3(), value.k38_1);
    }
    var tmp_9;
    if (tmp1_output.m15(tmp0_desc, 13)) {
      tmp_9 = true;
    } else {
      var tmp_10 = value.l38_1;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$5 = emptyMap();
      tmp_9 = !equals(tmp_10, tmp$ret$5);
    }
    if (tmp_9) {
      tmp1_output.g15(tmp0_desc, 13, tmp2_cached[13].k3(), value.l38_1);
    }
    var tmp_11;
    if (tmp1_output.m15(tmp0_desc, 14)) {
      tmp_11 = true;
    } else {
      var tmp_12 = value.m38_1;
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$6 = emptySet();
      tmp_11 = !equals(tmp_12, tmp$ret$6);
    }
    if (tmp_11) {
      tmp1_output.g15(tmp0_desc, 14, tmp2_cached[14].k3(), value.m38_1);
    }
    var tmp_13;
    if (tmp1_output.m15(tmp0_desc, 15)) {
      tmp_13 = true;
    } else {
      var tmp_14 = value.n38_1;
      // Inline function 'kotlin.collections.linkedSetOf' call
      var tmp$ret$7 = LinkedHashSet.v2();
      tmp_13 = !equals(tmp_14, tmp$ret$7);
    }
    if (tmp_13) {
      tmp1_output.g15(tmp0_desc, 15, tmp2_cached[15].k3(), value.n38_1);
    }
    var tmp_15;
    if (tmp1_output.m15(tmp0_desc, 16)) {
      tmp_15 = true;
    } else {
      var tmp_16 = value.o38_1;
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$8 = emptySet();
      tmp_15 = !equals(tmp_16, tmp$ret$8);
    }
    if (tmp_15) {
      tmp1_output.g15(tmp0_desc, 16, tmp2_cached[16].k3(), value.o38_1);
    }
    if (tmp1_output.m15(tmp0_desc, 17) ? true : !(value.p38_1 == null)) {
      tmp1_output.i15(tmp0_desc, 17, $serializer_getInstance_202(), value.p38_1);
    }
    if (tmp1_output.m15(tmp0_desc, 18) ? true : !(value.q38_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 18, value.q38_1);
    }
    var tmp_17;
    if (tmp1_output.m15(tmp0_desc, 19)) {
      tmp_17 = true;
    } else {
      var tmp_18 = value.r38_1;
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$9 = emptySet();
      tmp_17 = !equals(tmp_18, tmp$ret$9);
    }
    if (tmp_17) {
      tmp1_output.g15(tmp0_desc, 19, tmp2_cached[19].k3(), value.r38_1);
    }
    var tmp_19;
    if (tmp1_output.m15(tmp0_desc, 20)) {
      tmp_19 = true;
    } else {
      var tmp_20 = value.s38_1;
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$10 = emptySet();
      tmp_19 = !equals(tmp_20, tmp$ret$10);
    }
    if (tmp_19) {
      tmp1_output.g15(tmp0_desc, 20, tmp2_cached[20].k3(), value.s38_1);
    }
    if (tmp1_output.m15(tmp0_desc, 21) ? true : !(value.t38_1 == null)) {
      tmp1_output.i15(tmp0_desc, 21, $serializer_getInstance_123(), value.t38_1);
    }
    var tmp_21;
    if (tmp1_output.m15(tmp0_desc, 22)) {
      tmp_21 = true;
    } else {
      var tmp_22 = value.u38_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$11 = emptyList();
      tmp_21 = !equals(tmp_22, tmp$ret$11);
    }
    if (tmp_21) {
      tmp1_output.g15(tmp0_desc, 22, tmp2_cached[22].k3(), value.u38_1);
    }
    var tmp_23;
    if (tmp1_output.m15(tmp0_desc, 23)) {
      tmp_23 = true;
    } else {
      var tmp_24 = value.v38_1;
      // Inline function 'kotlin.collections.associateWith' call
      var this_0 = get_gameMap_0(value.y37_1).y34();
      var result = LinkedHashMap.cd(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
      // Inline function 'kotlin.collections.associateWithTo' call
      var _iterator__ex2g4s = this_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp$ret$14 = emptySet();
        result.b5(element, tmp$ret$14);
      }
      tmp_23 = !equals(tmp_24, result);
    }
    if (tmp_23) {
      tmp1_output.g15(tmp0_desc, 23, tmp2_cached[23].k3(), value.v38_1);
    }
    var tmp_25;
    if (tmp1_output.m15(tmp0_desc, 24)) {
      tmp_25 = true;
    } else {
      var tmp_26 = value.w38_1;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$15 = emptyMap();
      tmp_25 = !equals(tmp_26, tmp$ret$15);
    }
    if (tmp_25) {
      tmp1_output.g15(tmp0_desc, 24, tmp2_cached[24].k3(), value.w38_1);
    }
    var tmp_27;
    if (tmp1_output.m15(tmp0_desc, 25)) {
      tmp_27 = true;
    } else {
      var tmp_28 = value.x38_1;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$16 = emptyMap();
      tmp_27 = !equals(tmp_28, tmp$ret$16);
    }
    if (tmp_27) {
      tmp1_output.g15(tmp0_desc, 25, tmp2_cached[25].k3(), value.x38_1);
    }
    var tmp_29;
    if (tmp1_output.m15(tmp0_desc, 26)) {
      tmp_29 = true;
    } else {
      var tmp_30 = value.y38_1;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$17 = emptyMap();
      tmp_29 = !equals(tmp_30, tmp$ret$17);
    }
    if (tmp_29) {
      tmp1_output.g15(tmp0_desc, 26, tmp2_cached[26].k3(), value.y38_1);
    }
    var tmp_31;
    if (tmp1_output.m15(tmp0_desc, 27)) {
      tmp_31 = true;
    } else {
      var tmp_32 = value.z38_1;
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$18 = emptySet();
      tmp_31 = !equals(tmp_32, tmp$ret$18);
    }
    if (tmp_31) {
      tmp1_output.g15(tmp0_desc, 27, tmp2_cached[27].k3(), value.z38_1);
    }
    var tmp_33;
    if (tmp1_output.m15(tmp0_desc, 28)) {
      tmp_33 = true;
    } else {
      var tmp_34 = value.a39_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$19 = emptyList();
      tmp_33 = !equals(tmp_34, tmp$ret$19);
    }
    if (tmp_33) {
      tmp1_output.g15(tmp0_desc, 28, tmp2_cached[28].k3(), value.a39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 29) ? true : !(value.b39_1 == null)) {
      tmp1_output.i15(tmp0_desc, 29, tmp2_cached[29].k3(), value.b39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 30) ? true : !(value.c39_1 === 0)) {
      tmp1_output.z14(tmp0_desc, 30, value.c39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 31) ? true : !equals(value.d39_1, mapOf([to(new GameTeam(get_beastsGameTeam()), new KnownInfo()), to(new GameTeam(get_huntersGameTeam()), new KnownInfo())]))) {
      tmp1_output.g15(tmp0_desc, 31, tmp2_cached[31].k3(), value.d39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 32) ? true : !(value.e39_1 === false)) {
      tmp1_output.w14(tmp0_desc, 32, value.e39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 33) ? true : !(value.f39_1 === false)) {
      tmp1_output.w14(tmp0_desc, 33, value.f39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 34) ? true : !(value.g39_1 === 0)) {
      tmp1_output.z14(tmp0_desc, 34, value.g39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 35) ? true : !value.h39_1.equals(GeneralObjectImpl.w4l(_EntityId___init__impl__cq1mhp(-1), emptyMap()))) {
      tmp1_output.g15(tmp0_desc, 35, $serializer_getInstance_308(), value.h39_1);
    }
    if (tmp1_output.m15(tmp0_desc, 36) ? true : !(value.i39_1 === 0)) {
      tmp1_output.z14(tmp0_desc, 36, value.i39_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t4l(encoder, value instanceof GameStateImpl ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s4l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_bitMask1 = 0;
    var tmp5_local0 = null;
    var tmp6_local1 = null;
    var tmp7_local2 = null;
    var tmp8_local3 = null;
    var tmp9_local4 = null;
    var tmp10_local5 = null;
    var tmp11_local6 = 0;
    var tmp12_local7 = 0;
    var tmp13_local8 = 0;
    var tmp14_local9 = null;
    var tmp15_local10 = null;
    var tmp16_local11 = null;
    var tmp17_local12 = null;
    var tmp18_local13 = null;
    var tmp19_local14 = null;
    var tmp20_local15 = null;
    var tmp21_local16 = null;
    var tmp22_local17 = null;
    var tmp23_local18 = 0;
    var tmp24_local19 = null;
    var tmp25_local20 = null;
    var tmp26_local21 = null;
    var tmp27_local22 = null;
    var tmp28_local23 = null;
    var tmp29_local24 = null;
    var tmp30_local25 = null;
    var tmp31_local26 = null;
    var tmp32_local27 = null;
    var tmp33_local28 = null;
    var tmp34_local29 = null;
    var tmp35_local30 = 0;
    var tmp36_local31 = null;
    var tmp37_local32 = false;
    var tmp38_local33 = false;
    var tmp39_local34 = 0;
    var tmp40_local35 = null;
    var tmp41_local36 = 0;
    var tmp42_input = decoder.p13(tmp0_desc);
    var tmp43_cached = Companion_getInstance_243().r4l_1;
    if (tmp42_input.e14()) {
      tmp5_local0 = tmp42_input.b14(tmp0_desc, 0, tmp43_cached[0].k3(), tmp5_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp6_local1 = tmp42_input.b14(tmp0_desc, 1, $serializer_getInstance_203(), tmp6_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp7_local2 = tmp42_input.b14(tmp0_desc, 2, $serializer_getInstance_204(), tmp7_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp8_local3 = tmp42_input.b14(tmp0_desc, 3, $serializer_getInstance_205(), tmp8_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp9_local4 = tmp42_input.b14(tmp0_desc, 4, tmp43_cached[4].k3(), tmp9_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp10_local5 = tmp42_input.b14(tmp0_desc, 5, tmp43_cached[5].k3(), tmp10_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp11_local6 = tmp42_input.u13(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp12_local7 = tmp42_input.u13(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp13_local8 = tmp42_input.u13(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp14_local9 = tmp42_input.b14(tmp0_desc, 9, tmp43_cached[9].k3(), tmp14_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp15_local10 = tmp42_input.b14(tmp0_desc, 10, tmp43_cached[10].k3(), tmp15_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp16_local11 = tmp42_input.b14(tmp0_desc, 11, tmp43_cached[11].k3(), tmp16_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp17_local12 = tmp42_input.b14(tmp0_desc, 12, tmp43_cached[12].k3(), tmp17_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp18_local13 = tmp42_input.b14(tmp0_desc, 13, tmp43_cached[13].k3(), tmp18_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp19_local14 = tmp42_input.b14(tmp0_desc, 14, tmp43_cached[14].k3(), tmp19_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp20_local15 = tmp42_input.b14(tmp0_desc, 15, tmp43_cached[15].k3(), tmp20_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp21_local16 = tmp42_input.b14(tmp0_desc, 16, tmp43_cached[16].k3(), tmp21_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp22_local17 = tmp42_input.d14(tmp0_desc, 17, $serializer_getInstance_202(), tmp22_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp23_local18 = tmp42_input.u13(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp24_local19 = tmp42_input.b14(tmp0_desc, 19, tmp43_cached[19].k3(), tmp24_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp25_local20 = tmp42_input.b14(tmp0_desc, 20, tmp43_cached[20].k3(), tmp25_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp26_local21 = tmp42_input.d14(tmp0_desc, 21, $serializer_getInstance_123(), tmp26_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp27_local22 = tmp42_input.b14(tmp0_desc, 22, tmp43_cached[22].k3(), tmp27_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp28_local23 = tmp42_input.b14(tmp0_desc, 23, tmp43_cached[23].k3(), tmp28_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp29_local24 = tmp42_input.b14(tmp0_desc, 24, tmp43_cached[24].k3(), tmp29_local24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp30_local25 = tmp42_input.b14(tmp0_desc, 25, tmp43_cached[25].k3(), tmp30_local25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp31_local26 = tmp42_input.b14(tmp0_desc, 26, tmp43_cached[26].k3(), tmp31_local26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
      tmp32_local27 = tmp42_input.b14(tmp0_desc, 27, tmp43_cached[27].k3(), tmp32_local27);
      tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
      tmp33_local28 = tmp42_input.b14(tmp0_desc, 28, tmp43_cached[28].k3(), tmp33_local28);
      tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
      tmp34_local29 = tmp42_input.d14(tmp0_desc, 29, tmp43_cached[29].k3(), tmp34_local29);
      tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
      tmp35_local30 = tmp42_input.u13(tmp0_desc, 30);
      tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
      tmp36_local31 = tmp42_input.b14(tmp0_desc, 31, tmp43_cached[31].k3(), tmp36_local31);
      tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
      tmp37_local32 = tmp42_input.r13(tmp0_desc, 32);
      tmp4_bitMask1 = tmp4_bitMask1 | 1;
      tmp38_local33 = tmp42_input.r13(tmp0_desc, 33);
      tmp4_bitMask1 = tmp4_bitMask1 | 2;
      tmp39_local34 = tmp42_input.u13(tmp0_desc, 34);
      tmp4_bitMask1 = tmp4_bitMask1 | 4;
      tmp40_local35 = tmp42_input.b14(tmp0_desc, 35, $serializer_getInstance_308(), tmp40_local35);
      tmp4_bitMask1 = tmp4_bitMask1 | 8;
      tmp41_local36 = tmp42_input.u13(tmp0_desc, 36);
      tmp4_bitMask1 = tmp4_bitMask1 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp42_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp5_local0 = tmp42_input.b14(tmp0_desc, 0, tmp43_cached[0].k3(), tmp5_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp6_local1 = tmp42_input.b14(tmp0_desc, 1, $serializer_getInstance_203(), tmp6_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp7_local2 = tmp42_input.b14(tmp0_desc, 2, $serializer_getInstance_204(), tmp7_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp8_local3 = tmp42_input.b14(tmp0_desc, 3, $serializer_getInstance_205(), tmp8_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp9_local4 = tmp42_input.b14(tmp0_desc, 4, tmp43_cached[4].k3(), tmp9_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp10_local5 = tmp42_input.b14(tmp0_desc, 5, tmp43_cached[5].k3(), tmp10_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp11_local6 = tmp42_input.u13(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp12_local7 = tmp42_input.u13(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp13_local8 = tmp42_input.u13(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp14_local9 = tmp42_input.b14(tmp0_desc, 9, tmp43_cached[9].k3(), tmp14_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp15_local10 = tmp42_input.b14(tmp0_desc, 10, tmp43_cached[10].k3(), tmp15_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp16_local11 = tmp42_input.b14(tmp0_desc, 11, tmp43_cached[11].k3(), tmp16_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp17_local12 = tmp42_input.b14(tmp0_desc, 12, tmp43_cached[12].k3(), tmp17_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp18_local13 = tmp42_input.b14(tmp0_desc, 13, tmp43_cached[13].k3(), tmp18_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp19_local14 = tmp42_input.b14(tmp0_desc, 14, tmp43_cached[14].k3(), tmp19_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp20_local15 = tmp42_input.b14(tmp0_desc, 15, tmp43_cached[15].k3(), tmp20_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp21_local16 = tmp42_input.b14(tmp0_desc, 16, tmp43_cached[16].k3(), tmp21_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp22_local17 = tmp42_input.d14(tmp0_desc, 17, $serializer_getInstance_202(), tmp22_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp23_local18 = tmp42_input.u13(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp24_local19 = tmp42_input.b14(tmp0_desc, 19, tmp43_cached[19].k3(), tmp24_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp25_local20 = tmp42_input.b14(tmp0_desc, 20, tmp43_cached[20].k3(), tmp25_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp26_local21 = tmp42_input.d14(tmp0_desc, 21, $serializer_getInstance_123(), tmp26_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp27_local22 = tmp42_input.b14(tmp0_desc, 22, tmp43_cached[22].k3(), tmp27_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp28_local23 = tmp42_input.b14(tmp0_desc, 23, tmp43_cached[23].k3(), tmp28_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp29_local24 = tmp42_input.b14(tmp0_desc, 24, tmp43_cached[24].k3(), tmp29_local24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp30_local25 = tmp42_input.b14(tmp0_desc, 25, tmp43_cached[25].k3(), tmp30_local25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp31_local26 = tmp42_input.b14(tmp0_desc, 26, tmp43_cached[26].k3(), tmp31_local26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          case 27:
            tmp32_local27 = tmp42_input.b14(tmp0_desc, 27, tmp43_cached[27].k3(), tmp32_local27);
            tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
            break;
          case 28:
            tmp33_local28 = tmp42_input.b14(tmp0_desc, 28, tmp43_cached[28].k3(), tmp33_local28);
            tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
            break;
          case 29:
            tmp34_local29 = tmp42_input.d14(tmp0_desc, 29, tmp43_cached[29].k3(), tmp34_local29);
            tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
            break;
          case 30:
            tmp35_local30 = tmp42_input.u13(tmp0_desc, 30);
            tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
            break;
          case 31:
            tmp36_local31 = tmp42_input.b14(tmp0_desc, 31, tmp43_cached[31].k3(), tmp36_local31);
            tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
            break;
          case 32:
            tmp37_local32 = tmp42_input.r13(tmp0_desc, 32);
            tmp4_bitMask1 = tmp4_bitMask1 | 1;
            break;
          case 33:
            tmp38_local33 = tmp42_input.r13(tmp0_desc, 33);
            tmp4_bitMask1 = tmp4_bitMask1 | 2;
            break;
          case 34:
            tmp39_local34 = tmp42_input.u13(tmp0_desc, 34);
            tmp4_bitMask1 = tmp4_bitMask1 | 4;
            break;
          case 35:
            tmp40_local35 = tmp42_input.b14(tmp0_desc, 35, $serializer_getInstance_308(), tmp40_local35);
            tmp4_bitMask1 = tmp4_bitMask1 | 8;
            break;
          case 36:
            tmp41_local36 = tmp42_input.u13(tmp0_desc, 36);
            tmp4_bitMask1 = tmp4_bitMask1 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp42_input.q13(tmp0_desc);
    return GameStateImpl.x4l(tmp3_bitMask0, tmp4_bitMask1, tmp5_local0, tmp6_local1, tmp7_local2, tmp8_local3, tmp9_local4, tmp10_local5, tmp11_local6, tmp12_local7, tmp13_local8, tmp14_local9, tmp15_local10, tmp16_local11, tmp17_local12, tmp18_local13, tmp19_local14, tmp20_local15, tmp21_local16, tmp22_local17, tmp23_local18, tmp24_local19, tmp25_local20, tmp26_local21, tmp27_local22, tmp28_local23, tmp29_local24, tmp30_local25, tmp31_local26, tmp32_local27, tmp33_local28, tmp34_local29, tmp35_local30, tmp36_local31, tmp37_local32, tmp38_local33, tmp39_local34, tmp40_local35, tmp41_local36, null);
  }
  dz() {
    return this.s4l_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_243().r4l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), $serializer_getInstance_203(), $serializer_getInstance_204(), $serializer_getInstance_205(), tmp0_cached[4].k3(), tmp0_cached[5].k3(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[9].k3(), tmp0_cached[10].k3(), tmp0_cached[11].k3(), tmp0_cached[12].k3(), tmp0_cached[13].k3(), tmp0_cached[14].k3(), tmp0_cached[15].k3(), tmp0_cached[16].k3(), get_nullable($serializer_getInstance_202()), IntSerializer_getInstance(), tmp0_cached[19].k3(), tmp0_cached[20].k3(), get_nullable($serializer_getInstance_123()), tmp0_cached[22].k3(), tmp0_cached[23].k3(), tmp0_cached[24].k3(), tmp0_cached[25].k3(), tmp0_cached[26].k3(), tmp0_cached[27].k3(), tmp0_cached[28].k3(), get_nullable(tmp0_cached[29].k3()), IntSerializer_getInstance(), tmp0_cached[31].k3(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_308(), IntSerializer_getInstance()];
  }
}
class GameStateImpl {
  constructor(gameRules, hunterItems, beastlyTalents, ashRuins, gameScopes, phase, currentDayNumber, currentTurnNumber, revision, objects, charactersInOrder, locationTypes, pendingTriggerCards, cardsInPlay, duplicateCardEffect, discardedDraftActionCards, unusedDraftActionCards, draftState, remainAncientPowers, pumpedUpgrades, chargedUpgrades, submittedCurrentDamage, damageBlocked, placedTrapsCardsInfo, placedTrapsFullInfo, ashRuinPositions, ruinClaimingMap, firePositions, destroyRecords, firstCharacterPassed, playedCardsNumber, knownInfo, isReplayOpenGame, useRandomPickOnArsenal, damageDealtToBeasts, additionalImpl, nextId) {
    Companion_getInstance_243();
    ashRuins = ashRuins === VOID ? new AshRuins() : ashRuins;
    var tmp;
    if (gameScopes === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = gameScopes;
    }
    gameScopes = tmp;
    phase = phase === VOID ? NonePhase_getInstance() : phase;
    currentDayNumber = currentDayNumber === VOID ? 1 : currentDayNumber;
    currentTurnNumber = currentTurnNumber === VOID ? 0 : currentTurnNumber;
    revision = revision === VOID ? 0 : revision;
    var tmp_0;
    if (objects === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0 = emptyMap();
    } else {
      tmp_0 = objects;
    }
    objects = tmp_0;
    var tmp_1;
    if (charactersInOrder === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_1 = emptyList();
    } else {
      tmp_1 = charactersInOrder;
    }
    charactersInOrder = tmp_1;
    var tmp_2;
    if (locationTypes === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_2 = emptyMap();
    } else {
      tmp_2 = locationTypes;
    }
    locationTypes = tmp_2;
    var tmp_3;
    if (pendingTriggerCards === VOID) {
      // Inline function 'kotlin.collections.setOf' call
      tmp_3 = emptySet();
    } else {
      tmp_3 = pendingTriggerCards;
    }
    pendingTriggerCards = tmp_3;
    var tmp_4;
    if (cardsInPlay === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_4 = emptyMap();
    } else {
      tmp_4 = cardsInPlay;
    }
    cardsInPlay = tmp_4;
    var tmp_5;
    if (duplicateCardEffect === VOID) {
      // Inline function 'kotlin.collections.setOf' call
      tmp_5 = emptySet();
    } else {
      tmp_5 = duplicateCardEffect;
    }
    duplicateCardEffect = tmp_5;
    var tmp_6;
    if (discardedDraftActionCards === VOID) {
      // Inline function 'kotlin.collections.linkedSetOf' call
      tmp_6 = LinkedHashSet.v2();
    } else {
      tmp_6 = discardedDraftActionCards;
    }
    discardedDraftActionCards = tmp_6;
    var tmp_7;
    if (unusedDraftActionCards === VOID) {
      // Inline function 'kotlin.collections.setOf' call
      tmp_7 = emptySet();
    } else {
      tmp_7 = unusedDraftActionCards;
    }
    unusedDraftActionCards = tmp_7;
    draftState = draftState === VOID ? null : draftState;
    remainAncientPowers = remainAncientPowers === VOID ? 3 : remainAncientPowers;
    var tmp_8;
    if (pumpedUpgrades === VOID) {
      // Inline function 'kotlin.collections.setOf' call
      tmp_8 = emptySet();
    } else {
      tmp_8 = pumpedUpgrades;
    }
    pumpedUpgrades = tmp_8;
    var tmp_9;
    if (chargedUpgrades === VOID) {
      // Inline function 'kotlin.collections.setOf' call
      tmp_9 = emptySet();
    } else {
      tmp_9 = chargedUpgrades;
    }
    chargedUpgrades = tmp_9;
    submittedCurrentDamage = submittedCurrentDamage === VOID ? null : submittedCurrentDamage;
    var tmp_10;
    if (damageBlocked === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_10 = emptyList();
    } else {
      tmp_10 = damageBlocked;
    }
    damageBlocked = tmp_10;
    var tmp_11;
    if (placedTrapsCardsInfo === VOID) {
      // Inline function 'kotlin.collections.associateWith' call
      var this_0 = get_gameMap_0(gameRules).y34();
      var result = LinkedHashMap.cd(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
      // Inline function 'kotlin.collections.associateWithTo' call
      var _iterator__ex2g4s = this_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp$ret$2 = emptySet();
        result.b5(element, tmp$ret$2);
      }
      tmp_11 = result;
    } else {
      tmp_11 = placedTrapsCardsInfo;
    }
    placedTrapsCardsInfo = tmp_11;
    var tmp_12;
    if (placedTrapsFullInfo === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_12 = emptyMap();
    } else {
      tmp_12 = placedTrapsFullInfo;
    }
    placedTrapsFullInfo = tmp_12;
    var tmp_13;
    if (ashRuinPositions === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_13 = emptyMap();
    } else {
      tmp_13 = ashRuinPositions;
    }
    ashRuinPositions = tmp_13;
    var tmp_14;
    if (ruinClaimingMap === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_14 = emptyMap();
    } else {
      tmp_14 = ruinClaimingMap;
    }
    ruinClaimingMap = tmp_14;
    var tmp_15;
    if (firePositions === VOID) {
      // Inline function 'kotlin.collections.setOf' call
      tmp_15 = emptySet();
    } else {
      tmp_15 = firePositions;
    }
    firePositions = tmp_15;
    var tmp_16;
    if (destroyRecords === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_16 = emptyList();
    } else {
      tmp_16 = destroyRecords;
    }
    destroyRecords = tmp_16;
    firstCharacterPassed = firstCharacterPassed === VOID ? null : firstCharacterPassed;
    playedCardsNumber = playedCardsNumber === VOID ? 0 : playedCardsNumber;
    knownInfo = knownInfo === VOID ? mapOf([to(new GameTeam(get_beastsGameTeam()), new KnownInfo()), to(new GameTeam(get_huntersGameTeam()), new KnownInfo())]) : knownInfo;
    isReplayOpenGame = isReplayOpenGame === VOID ? false : isReplayOpenGame;
    useRandomPickOnArsenal = useRandomPickOnArsenal === VOID ? false : useRandomPickOnArsenal;
    damageDealtToBeasts = damageDealtToBeasts === VOID ? 0 : damageDealtToBeasts;
    additionalImpl = additionalImpl === VOID ? GeneralObjectImpl.w4l(_EntityId___init__impl__cq1mhp(-1), emptyMap()) : additionalImpl;
    nextId = nextId === VOID ? 0 : nextId;
    this.y37_1 = gameRules;
    this.z37_1 = hunterItems;
    this.a38_1 = beastlyTalents;
    this.b38_1 = ashRuins;
    this.c38_1 = gameScopes;
    this.d38_1 = phase;
    this.e38_1 = currentDayNumber;
    this.f38_1 = currentTurnNumber;
    this.g38_1 = revision;
    this.h38_1 = objects;
    this.i38_1 = charactersInOrder;
    this.j38_1 = locationTypes;
    this.k38_1 = pendingTriggerCards;
    this.l38_1 = cardsInPlay;
    this.m38_1 = duplicateCardEffect;
    this.n38_1 = discardedDraftActionCards;
    this.o38_1 = unusedDraftActionCards;
    this.p38_1 = draftState;
    this.q38_1 = remainAncientPowers;
    this.r38_1 = pumpedUpgrades;
    this.s38_1 = chargedUpgrades;
    this.t38_1 = submittedCurrentDamage;
    this.u38_1 = damageBlocked;
    this.v38_1 = placedTrapsCardsInfo;
    this.w38_1 = placedTrapsFullInfo;
    this.x38_1 = ashRuinPositions;
    this.y38_1 = ruinClaimingMap;
    this.z38_1 = firePositions;
    this.a39_1 = destroyRecords;
    this.b39_1 = firstCharacterPassed;
    this.c39_1 = playedCardsNumber;
    this.d39_1 = knownInfo;
    this.e39_1 = isReplayOpenGame;
    this.f39_1 = useRandomPickOnArsenal;
    this.g39_1 = damageDealtToBeasts;
    this.h39_1 = additionalImpl;
    this.i39_1 = nextId;
  }
  x40() {
    return this.y37_1;
  }
  o4k() {
    return this.z37_1;
  }
  p4k() {
    return this.a38_1;
  }
  q4k() {
    return this.b38_1;
  }
  c3r() {
    return this.c38_1;
  }
  d4k() {
    return this.d38_1;
  }
  e4k() {
    return this.e38_1;
  }
  f4k() {
    return this.f38_1;
  }
  g4k() {
    return this.g38_1;
  }
  h4k() {
    return this.i38_1;
  }
  i4k() {
    return this.j38_1;
  }
  j4k() {
    return this.k38_1;
  }
  k4k() {
    return this.l38_1;
  }
  l4k() {
    return this.n38_1;
  }
  m4k() {
    return this.o38_1;
  }
  n4k() {
    return this.p38_1;
  }
  r4k() {
    return this.q38_1;
  }
  s4k() {
    return this.r38_1;
  }
  t4k() {
    return this.s38_1;
  }
  u4k() {
    return this.t38_1;
  }
  v4k() {
    return this.u38_1;
  }
  w4k() {
    return this.v38_1;
  }
  x4k() {
    return this.w38_1;
  }
  h3d() {
    return this.x38_1;
  }
  u4j() {
    return this.y38_1;
  }
  y4k() {
    return this.z38_1;
  }
  z4k() {
    return this.a39_1;
  }
  a4l() {
    return this.b39_1;
  }
  b4l() {
    return this.c39_1;
  }
  c4l() {
    return this.d39_1;
  }
  d4l() {
    return this.e39_1;
  }
  e4l() {
    return this.f39_1;
  }
  i4l() {
    return this.g39_1;
  }
  k4l() {
    return this.h39_1;
  }
  y4l() {
    return this.z4l();
  }
  f4l() {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.h4l();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (get_isAlive(this, element)) {
        destination.d2(element);
      }
    }
    return destination;
  }
  g4l() {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.h4l();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (get_isDead(this, element)) {
        destination.d2(element);
      }
    }
    return destination;
  }
  h4l() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.h38_1.y4();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = new ObjectOnBoard(item.u4l_1);
      destination.d2(tmp$ret$2);
    }
    return destination;
  }
  j4l(id) {
    var tmp0_elvis_lhs = this.h38_1.w4(new EntityId(id));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'No object with id = ' + EntityId__toString_impl_njecar(id);
      throw IllegalStateException.o(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  l4l() {
    // Inline function 'kotlin.let' call
    var it = ensureNotNull(this.h38_1.w4(new EntityId(_EntityId___init__impl__cq1mhp(this.i39_1 - 1 | 0))));
    return new ObjectOnBoard(it.u4l_1);
  }
  a4m(objectType, position) {
    var init = objectType.v36(this, position);
    var id = nextEntryId(this);
    var objectOnBoardImpl = GeneralObjectImpl.b4m(id, init);
    this.h38_1 = plus_3(this.h38_1, to(new EntityId(id), objectOnBoardImpl));
    // Inline function 'kotlin.let' call
    return new ObjectOnBoard(objectOnBoardImpl.u4l_1);
  }
  c4m() {
    this.i39_1 = this.i39_1 - 1 | 0;
    this.h38_1 = minus(this.h38_1, new EntityId(_EntityId___init__impl__cq1mhp(this.i39_1)));
  }
  m4l(arsenalType) {
    var tmp;
    switch (arsenalType.w1_1) {
      case 1:
        tmp = this.z37_1;
        break;
      case 0:
        tmp = this.a38_1;
        break;
      case 2:
        tmp = this.b38_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  d4m(id, key, value) {
    var objectImpl = this.j4l(id);
    this.h38_1 = plus_3(this.h38_1, to(new EntityId(id), withGeneralProperty(objectImpl, key, value)));
  }
  j39(id, key, value, default_0) {
    var objectImpl = this.j4l(id);
    this.h38_1 = plus_3(this.h38_1, to(new EntityId(id), withGeneralPropertyWithDefault(objectImpl, key, value, default_0)));
  }
  e4m(key, value, default_0) {
    this.h39_1 = withGeneralPropertyWithDefault(this.h39_1, key, value, default_0);
  }
  f4m(gameRules, hunterItems, beastlyTalents, ashRuins, gameScopes, phase, currentDayNumber, currentTurnNumber, revision, objects, charactersInOrder, locationTypes, pendingTriggerCards, cardsInPlay, duplicateCardEffect, discardedDraftActionCards, unusedDraftActionCards, draftState, remainAncientPowers, pumpedUpgrades, chargedUpgrades, submittedCurrentDamage, damageBlocked, placedTrapsCardsInfo, placedTrapsFullInfo, ashRuinPositions, ruinClaimingMap, firePositions, destroyRecords, firstCharacterPassed, playedCardsNumber, knownInfo, isReplayOpenGame, useRandomPickOnArsenal, damageDealtToBeasts, additionalImpl, nextId) {
    return new GameStateImpl(gameRules, hunterItems, beastlyTalents, ashRuins, gameScopes, phase, currentDayNumber, currentTurnNumber, revision, objects, charactersInOrder, locationTypes, pendingTriggerCards, cardsInPlay, duplicateCardEffect, discardedDraftActionCards, unusedDraftActionCards, draftState, remainAncientPowers, pumpedUpgrades, chargedUpgrades, submittedCurrentDamage, damageBlocked, placedTrapsCardsInfo, placedTrapsFullInfo, ashRuinPositions, ruinClaimingMap, firePositions, destroyRecords, firstCharacterPassed, playedCardsNumber, knownInfo, isReplayOpenGame, useRandomPickOnArsenal, damageDealtToBeasts, additionalImpl, nextId);
  }
  z4l(gameRules, hunterItems, beastlyTalents, ashRuins, gameScopes, phase, currentDayNumber, currentTurnNumber, revision, objects, charactersInOrder, locationTypes, pendingTriggerCards, cardsInPlay, duplicateCardEffect, discardedDraftActionCards, unusedDraftActionCards, draftState, remainAncientPowers, pumpedUpgrades, chargedUpgrades, submittedCurrentDamage, damageBlocked, placedTrapsCardsInfo, placedTrapsFullInfo, ashRuinPositions, ruinClaimingMap, firePositions, destroyRecords, firstCharacterPassed, playedCardsNumber, knownInfo, isReplayOpenGame, useRandomPickOnArsenal, damageDealtToBeasts, additionalImpl, nextId, $super) {
    gameRules = gameRules === VOID ? this.y37_1 : gameRules;
    hunterItems = hunterItems === VOID ? this.z37_1 : hunterItems;
    beastlyTalents = beastlyTalents === VOID ? this.a38_1 : beastlyTalents;
    ashRuins = ashRuins === VOID ? this.b38_1 : ashRuins;
    gameScopes = gameScopes === VOID ? this.c38_1 : gameScopes;
    phase = phase === VOID ? this.d38_1 : phase;
    currentDayNumber = currentDayNumber === VOID ? this.e38_1 : currentDayNumber;
    currentTurnNumber = currentTurnNumber === VOID ? this.f38_1 : currentTurnNumber;
    revision = revision === VOID ? this.g38_1 : revision;
    objects = objects === VOID ? this.h38_1 : objects;
    charactersInOrder = charactersInOrder === VOID ? this.i38_1 : charactersInOrder;
    locationTypes = locationTypes === VOID ? this.j38_1 : locationTypes;
    pendingTriggerCards = pendingTriggerCards === VOID ? this.k38_1 : pendingTriggerCards;
    cardsInPlay = cardsInPlay === VOID ? this.l38_1 : cardsInPlay;
    duplicateCardEffect = duplicateCardEffect === VOID ? this.m38_1 : duplicateCardEffect;
    discardedDraftActionCards = discardedDraftActionCards === VOID ? this.n38_1 : discardedDraftActionCards;
    unusedDraftActionCards = unusedDraftActionCards === VOID ? this.o38_1 : unusedDraftActionCards;
    draftState = draftState === VOID ? this.p38_1 : draftState;
    remainAncientPowers = remainAncientPowers === VOID ? this.q38_1 : remainAncientPowers;
    pumpedUpgrades = pumpedUpgrades === VOID ? this.r38_1 : pumpedUpgrades;
    chargedUpgrades = chargedUpgrades === VOID ? this.s38_1 : chargedUpgrades;
    submittedCurrentDamage = submittedCurrentDamage === VOID ? this.t38_1 : submittedCurrentDamage;
    damageBlocked = damageBlocked === VOID ? this.u38_1 : damageBlocked;
    placedTrapsCardsInfo = placedTrapsCardsInfo === VOID ? this.v38_1 : placedTrapsCardsInfo;
    placedTrapsFullInfo = placedTrapsFullInfo === VOID ? this.w38_1 : placedTrapsFullInfo;
    ashRuinPositions = ashRuinPositions === VOID ? this.x38_1 : ashRuinPositions;
    ruinClaimingMap = ruinClaimingMap === VOID ? this.y38_1 : ruinClaimingMap;
    firePositions = firePositions === VOID ? this.z38_1 : firePositions;
    destroyRecords = destroyRecords === VOID ? this.a39_1 : destroyRecords;
    firstCharacterPassed = firstCharacterPassed === VOID ? this.b39_1 : firstCharacterPassed;
    playedCardsNumber = playedCardsNumber === VOID ? this.c39_1 : playedCardsNumber;
    knownInfo = knownInfo === VOID ? this.d39_1 : knownInfo;
    isReplayOpenGame = isReplayOpenGame === VOID ? this.e39_1 : isReplayOpenGame;
    useRandomPickOnArsenal = useRandomPickOnArsenal === VOID ? this.f39_1 : useRandomPickOnArsenal;
    damageDealtToBeasts = damageDealtToBeasts === VOID ? this.g39_1 : damageDealtToBeasts;
    additionalImpl = additionalImpl === VOID ? this.h39_1 : additionalImpl;
    nextId = nextId === VOID ? this.i39_1 : nextId;
    return $super === VOID ? this.f4m(gameRules, hunterItems, beastlyTalents, ashRuins, gameScopes, phase, currentDayNumber, currentTurnNumber, revision, objects, charactersInOrder, locationTypes, pendingTriggerCards, cardsInPlay, duplicateCardEffect, discardedDraftActionCards, unusedDraftActionCards, draftState, remainAncientPowers, pumpedUpgrades, chargedUpgrades, submittedCurrentDamage, damageBlocked, placedTrapsCardsInfo, placedTrapsFullInfo, ashRuinPositions, ruinClaimingMap, firePositions, destroyRecords, firstCharacterPassed, playedCardsNumber, knownInfo, isReplayOpenGame, useRandomPickOnArsenal, damageDealtToBeasts, additionalImpl, nextId) : $super.f4m.call(this, gameRules, hunterItems, beastlyTalents, ashRuins, gameScopes, phase, currentDayNumber, currentTurnNumber, revision, objects, charactersInOrder, locationTypes, pendingTriggerCards, cardsInPlay, duplicateCardEffect, discardedDraftActionCards, unusedDraftActionCards, draftState, remainAncientPowers, pumpedUpgrades, chargedUpgrades, submittedCurrentDamage, damageBlocked, placedTrapsCardsInfo, placedTrapsFullInfo, ashRuinPositions, ruinClaimingMap, firePositions, destroyRecords, firstCharacterPassed, playedCardsNumber, knownInfo, isReplayOpenGame, useRandomPickOnArsenal, damageDealtToBeasts, additionalImpl, nextId);
  }
  toString() {
    return 'GameStateImpl(gameRules=' + toString(this.y37_1) + ', hunterItems=' + this.z37_1.toString() + ', beastlyTalents=' + this.a38_1.toString() + ', ashRuins=' + this.b38_1.toString() + ', gameScopes=' + toString(this.c38_1) + ', phase=' + toString(this.d38_1) + ', currentDayNumber=' + this.e38_1 + ', currentTurnNumber=' + this.f38_1 + ', revision=' + this.g38_1 + ', objects=' + toString(this.h38_1) + ', charactersInOrder=' + toString(this.i38_1) + ', locationTypes=' + toString(this.j38_1) + ', pendingTriggerCards=' + toString(this.k38_1) + ', cardsInPlay=' + toString(this.l38_1) + ', duplicateCardEffect=' + toString(this.m38_1) + ', discardedDraftActionCards=' + toString(this.n38_1) + ', unusedDraftActionCards=' + toString(this.o38_1) + ', draftState=' + toString_0(this.p38_1) + ', remainAncientPowers=' + this.q38_1 + ', pumpedUpgrades=' + toString(this.r38_1) + ', chargedUpgrades=' + toString(this.s38_1) + ', submittedCurrentDamage=' + toString_0(this.t38_1) + ', damageBlocked=' + toString(this.u38_1) + ', placedTrapsCardsInfo=' + toString(this.v38_1) + ', placedTrapsFullInfo=' + toString(this.w38_1) + ', ashRuinPositions=' + toString(this.x38_1) + ', ruinClaimingMap=' + toString(this.y38_1) + ', firePositions=' + toString(this.z38_1) + ', destroyRecords=' + toString(this.a39_1) + ', firstCharacterPassed=' + toString_0(this.b39_1) + ', playedCardsNumber=' + this.c39_1 + ', knownInfo=' + toString(this.d39_1) + ', isReplayOpenGame=' + this.e39_1 + ', useRandomPickOnArsenal=' + this.f39_1 + ', damageDealtToBeasts=' + this.g39_1 + ', additionalImpl=' + this.h39_1.toString() + ', nextId=' + this.i39_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.y37_1);
    result = imul(result, 31) + this.z37_1.hashCode() | 0;
    result = imul(result, 31) + this.a38_1.hashCode() | 0;
    result = imul(result, 31) + this.b38_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.c38_1) | 0;
    result = imul(result, 31) + hashCode(this.d38_1) | 0;
    result = imul(result, 31) + this.e38_1 | 0;
    result = imul(result, 31) + this.f38_1 | 0;
    result = imul(result, 31) + this.g38_1 | 0;
    result = imul(result, 31) + hashCode(this.h38_1) | 0;
    result = imul(result, 31) + hashCode(this.i38_1) | 0;
    result = imul(result, 31) + hashCode(this.j38_1) | 0;
    result = imul(result, 31) + hashCode(this.k38_1) | 0;
    result = imul(result, 31) + hashCode(this.l38_1) | 0;
    result = imul(result, 31) + hashCode(this.m38_1) | 0;
    result = imul(result, 31) + hashCode(this.n38_1) | 0;
    result = imul(result, 31) + hashCode(this.o38_1) | 0;
    result = imul(result, 31) + (this.p38_1 == null ? 0 : this.p38_1.hashCode()) | 0;
    result = imul(result, 31) + this.q38_1 | 0;
    result = imul(result, 31) + hashCode(this.r38_1) | 0;
    result = imul(result, 31) + hashCode(this.s38_1) | 0;
    result = imul(result, 31) + (this.t38_1 == null ? 0 : this.t38_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.u38_1) | 0;
    result = imul(result, 31) + hashCode(this.v38_1) | 0;
    result = imul(result, 31) + hashCode(this.w38_1) | 0;
    result = imul(result, 31) + hashCode(this.x38_1) | 0;
    result = imul(result, 31) + hashCode(this.y38_1) | 0;
    result = imul(result, 31) + hashCode(this.z38_1) | 0;
    result = imul(result, 31) + hashCode(this.a39_1) | 0;
    result = imul(result, 31) + (this.b39_1 == null ? 0 : this.b39_1.hashCode()) | 0;
    result = imul(result, 31) + this.c39_1 | 0;
    result = imul(result, 31) + hashCode(this.d39_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e39_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f39_1) | 0;
    result = imul(result, 31) + this.g39_1 | 0;
    result = imul(result, 31) + this.h39_1.hashCode() | 0;
    result = imul(result, 31) + this.i39_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameStateImpl))
      return false;
    if (!equals(this.y37_1, other.y37_1))
      return false;
    if (!this.z37_1.equals(other.z37_1))
      return false;
    if (!this.a38_1.equals(other.a38_1))
      return false;
    if (!this.b38_1.equals(other.b38_1))
      return false;
    if (!equals(this.c38_1, other.c38_1))
      return false;
    if (!equals(this.d38_1, other.d38_1))
      return false;
    if (!(this.e38_1 === other.e38_1))
      return false;
    if (!(this.f38_1 === other.f38_1))
      return false;
    if (!(this.g38_1 === other.g38_1))
      return false;
    if (!equals(this.h38_1, other.h38_1))
      return false;
    if (!equals(this.i38_1, other.i38_1))
      return false;
    if (!equals(this.j38_1, other.j38_1))
      return false;
    if (!equals(this.k38_1, other.k38_1))
      return false;
    if (!equals(this.l38_1, other.l38_1))
      return false;
    if (!equals(this.m38_1, other.m38_1))
      return false;
    if (!equals(this.n38_1, other.n38_1))
      return false;
    if (!equals(this.o38_1, other.o38_1))
      return false;
    if (!equals(this.p38_1, other.p38_1))
      return false;
    if (!(this.q38_1 === other.q38_1))
      return false;
    if (!equals(this.r38_1, other.r38_1))
      return false;
    if (!equals(this.s38_1, other.s38_1))
      return false;
    if (!equals(this.t38_1, other.t38_1))
      return false;
    if (!equals(this.u38_1, other.u38_1))
      return false;
    if (!equals(this.v38_1, other.v38_1))
      return false;
    if (!equals(this.w38_1, other.w38_1))
      return false;
    if (!equals(this.x38_1, other.x38_1))
      return false;
    if (!equals(this.y38_1, other.y38_1))
      return false;
    if (!equals(this.z38_1, other.z38_1))
      return false;
    if (!equals(this.a39_1, other.a39_1))
      return false;
    if (!equals(this.b39_1, other.b39_1))
      return false;
    if (!(this.c39_1 === other.c39_1))
      return false;
    if (!equals(this.d39_1, other.d39_1))
      return false;
    if (!(this.e39_1 === other.e39_1))
      return false;
    if (!(this.f39_1 === other.f39_1))
      return false;
    if (!(this.g39_1 === other.g39_1))
      return false;
    if (!this.h39_1.equals(other.h39_1))
      return false;
    if (!(this.i39_1 === other.i39_1))
      return false;
    return true;
  }
  static x4l(seen0, seen1, gameRules, hunterItems, beastlyTalents, ashRuins, gameScopes, phase, currentDayNumber, currentTurnNumber, revision, objects, charactersInOrder, locationTypes, pendingTriggerCards, cardsInPlay, duplicateCardEffect, discardedDraftActionCards, unusedDraftActionCards, draftState, remainAncientPowers, pumpedUpgrades, chargedUpgrades, submittedCurrentDamage, damageBlocked, placedTrapsCardsInfo, placedTrapsFullInfo, ashRuinPositions, ruinClaimingMap, firePositions, destroyRecords, firstCharacterPassed, playedCardsNumber, knownInfo, isReplayOpenGame, useRandomPickOnArsenal, damageDealtToBeasts, additionalImpl, nextId, serializationConstructorMarker) {
    Companion_getInstance_243();
    if (!!(!(7 === (7 & seen0)) | !(0 === (0 & seen1)))) {
      // Inline function 'kotlin.intArrayOf' call
      var tmp = new Int32Array([seen0, seen1]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$1 = new Int32Array([7, 0]);
      throwArrayMissingFieldException(tmp, tmp$ret$1, $serializer_getInstance_200().s4l_1);
    }
    var $this = createThis(this);
    $this.y37_1 = gameRules;
    $this.z37_1 = hunterItems;
    $this.a38_1 = beastlyTalents;
    if (0 === (seen0 & 8))
      $this.b38_1 = new AshRuins();
    else
      $this.b38_1 = ashRuins;
    if (0 === (seen0 & 16)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp_0.c38_1 = emptyList();
    } else
      $this.c38_1 = gameScopes;
    if (0 === (seen0 & 32))
      $this.d38_1 = NonePhase_getInstance();
    else
      $this.d38_1 = phase;
    if (0 === (seen0 & 64))
      $this.e38_1 = 1;
    else
      $this.e38_1 = currentDayNumber;
    if (0 === (seen0 & 128))
      $this.f38_1 = 0;
    else
      $this.f38_1 = currentTurnNumber;
    if (0 === (seen0 & 256))
      $this.g38_1 = 0;
    else
      $this.g38_1 = revision;
    if (0 === (seen0 & 512)) {
      var tmp_1 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_1.h38_1 = emptyMap();
    } else
      $this.h38_1 = objects;
    if (0 === (seen0 & 1024)) {
      var tmp_2 = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp_2.i38_1 = emptyList();
    } else
      $this.i38_1 = charactersInOrder;
    if (0 === (seen0 & 2048)) {
      var tmp_3 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_3.j38_1 = emptyMap();
    } else
      $this.j38_1 = locationTypes;
    if (0 === (seen0 & 4096)) {
      var tmp_4 = $this;
      // Inline function 'kotlin.collections.setOf' call
      tmp_4.k38_1 = emptySet();
    } else
      $this.k38_1 = pendingTriggerCards;
    if (0 === (seen0 & 8192)) {
      var tmp_5 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_5.l38_1 = emptyMap();
    } else
      $this.l38_1 = cardsInPlay;
    if (0 === (seen0 & 16384)) {
      var tmp_6 = $this;
      // Inline function 'kotlin.collections.setOf' call
      tmp_6.m38_1 = emptySet();
    } else
      $this.m38_1 = duplicateCardEffect;
    if (0 === (seen0 & 32768)) {
      var tmp_7 = $this;
      // Inline function 'kotlin.collections.linkedSetOf' call
      tmp_7.n38_1 = LinkedHashSet.v2();
    } else
      $this.n38_1 = discardedDraftActionCards;
    if (0 === (seen0 & 65536)) {
      var tmp_8 = $this;
      // Inline function 'kotlin.collections.setOf' call
      tmp_8.o38_1 = emptySet();
    } else
      $this.o38_1 = unusedDraftActionCards;
    if (0 === (seen0 & 131072))
      $this.p38_1 = null;
    else
      $this.p38_1 = draftState;
    if (0 === (seen0 & 262144))
      $this.q38_1 = 3;
    else
      $this.q38_1 = remainAncientPowers;
    if (0 === (seen0 & 524288)) {
      var tmp_9 = $this;
      // Inline function 'kotlin.collections.setOf' call
      tmp_9.r38_1 = emptySet();
    } else
      $this.r38_1 = pumpedUpgrades;
    if (0 === (seen0 & 1048576)) {
      var tmp_10 = $this;
      // Inline function 'kotlin.collections.setOf' call
      tmp_10.s38_1 = emptySet();
    } else
      $this.s38_1 = chargedUpgrades;
    if (0 === (seen0 & 2097152))
      $this.t38_1 = null;
    else
      $this.t38_1 = submittedCurrentDamage;
    if (0 === (seen0 & 4194304)) {
      var tmp_11 = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp_11.u38_1 = emptyList();
    } else
      $this.u38_1 = damageBlocked;
    if (0 === (seen0 & 8388608)) {
      var tmp_12 = $this;
      // Inline function 'kotlin.collections.associateWith' call
      var this_0 = get_gameMap_0($this.y37_1).y34();
      var result = LinkedHashMap.cd(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
      // Inline function 'kotlin.collections.associateWithTo' call
      var _iterator__ex2g4s = this_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp$ret$16 = emptySet();
        result.b5(element, tmp$ret$16);
      }
      tmp_12.v38_1 = result;
    } else
      $this.v38_1 = placedTrapsCardsInfo;
    if (0 === (seen0 & 16777216)) {
      var tmp_13 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_13.w38_1 = emptyMap();
    } else
      $this.w38_1 = placedTrapsFullInfo;
    if (0 === (seen0 & 33554432)) {
      var tmp_14 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_14.x38_1 = emptyMap();
    } else
      $this.x38_1 = ashRuinPositions;
    if (0 === (seen0 & 67108864)) {
      var tmp_15 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_15.y38_1 = emptyMap();
    } else
      $this.y38_1 = ruinClaimingMap;
    if (0 === (seen0 & 134217728)) {
      var tmp_16 = $this;
      // Inline function 'kotlin.collections.setOf' call
      tmp_16.z38_1 = emptySet();
    } else
      $this.z38_1 = firePositions;
    if (0 === (seen0 & 268435456)) {
      var tmp_17 = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp_17.a39_1 = emptyList();
    } else
      $this.a39_1 = destroyRecords;
    if (0 === (seen0 & 536870912))
      $this.b39_1 = null;
    else
      $this.b39_1 = firstCharacterPassed;
    if (0 === (seen0 & 1073741824))
      $this.c39_1 = 0;
    else
      $this.c39_1 = playedCardsNumber;
    if (0 === (seen0 & -2147483648))
      $this.d39_1 = mapOf([to(new GameTeam(get_beastsGameTeam()), new KnownInfo()), to(new GameTeam(get_huntersGameTeam()), new KnownInfo())]);
    else
      $this.d39_1 = knownInfo;
    if (0 === (seen1 & 1))
      $this.e39_1 = false;
    else
      $this.e39_1 = isReplayOpenGame;
    if (0 === (seen1 & 2))
      $this.f39_1 = false;
    else
      $this.f39_1 = useRandomPickOnArsenal;
    if (0 === (seen1 & 4))
      $this.g39_1 = 0;
    else
      $this.g39_1 = damageDealtToBeasts;
    if (0 === (seen1 & 8))
      $this.h39_1 = GeneralObjectImpl.w4l(_EntityId___init__impl__cq1mhp(-1), emptyMap());
    else
      $this.h39_1 = additionalImpl;
    if (0 === (seen1 & 16))
      $this.i39_1 = 0;
    else
      $this.i39_1 = nextId;
    return $this;
  }
}
class Companion_243 {}
class $serializer_202 {
  constructor() {
    $serializer_instance_201 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GameStateCheckCode', this, 1);
    tmp0_serialDesc.h1b('checkCodeValue', false);
    this.g4m_1 = tmp0_serialDesc;
  }
  h4m(encoder, value) {
    var tmp0_desc = this.g4m_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.i4m_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h4m(encoder, value instanceof GameStateCheckCode ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g4m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GameStateCheckCode.j4m(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g4m_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class GameStateCheckCode {
  constructor(checkCodeValue) {
    this.i4m_1 = checkCodeValue;
  }
  toString() {
    return 'GameStateCheckCode(checkCodeValue=' + this.i4m_1 + ')';
  }
  hashCode() {
    return this.i4m_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameStateCheckCode))
      return false;
    if (!(this.i4m_1 === other.i4m_1))
      return false;
    return true;
  }
  static j4m(seen0, checkCodeValue, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_201().g4m_1);
    }
    var $this = createThis(this);
    $this.i4m_1 = checkCodeValue;
    return $this;
  }
}
class Companion_244 {
  constructor() {
    Companion_instance_244 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, DraftState$Companion$$childSerializers$_anonymous__w7cg56);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, DraftState$Companion$$childSerializers$_anonymous__w7cg56_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, DraftState$Companion$$childSerializers$_anonymous__w7cg56_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_7 = lazy(tmp_6, DraftState$Companion$$childSerializers$_anonymous__w7cg56_2);
    var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l4m_1 = [tmp_1, tmp_3, tmp_5, tmp_7, null, null, lazy(tmp_8, DraftState$Companion$$childSerializers$_anonymous__w7cg56_3)];
  }
}
class $serializer_203 {
  constructor() {
    $serializer_instance_202 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.DraftState', this, 7);
    tmp0_serialDesc.h1b('offered', false);
    tmp0_serialDesc.h1b('picked', false);
    tmp0_serialDesc.h1b('removed', false);
    tmp0_serialDesc.h1b('eligibleCharacterIndices', false);
    tmp0_serialDesc.h1b('isForDiscard', true);
    tmp0_serialDesc.h1b('removedCardsReturnToUnused', true);
    tmp0_serialDesc.h1b('twoPlayerStage', true);
    this.m4m_1 = tmp0_serialDesc;
  }
  n4m(encoder, value) {
    var tmp0_desc = this.m4m_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_245().l4m_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o4m_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.p4m_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.q4m_1);
    tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.r4m_1);
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.s4m_1 === false)) {
      tmp1_output.w14(tmp0_desc, 4, value.s4m_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !(value.t4m_1 === false)) {
      tmp1_output.w14(tmp0_desc, 5, value.t4m_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !(value.u4m_1 == null)) {
      tmp1_output.i15(tmp0_desc, 6, tmp2_cached[6].k3(), value.u4m_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n4m(encoder, value instanceof DraftState ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m4m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_input = decoder.p13(tmp0_desc);
    var tmp12_cached = Companion_getInstance_245().l4m_1;
    if (tmp11_input.e14()) {
      tmp4_local0 = tmp11_input.b14(tmp0_desc, 0, tmp12_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.b14(tmp0_desc, 1, tmp12_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.b14(tmp0_desc, 2, tmp12_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.b14(tmp0_desc, 3, tmp12_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.r13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.r13(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.d14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.b14(tmp0_desc, 0, tmp12_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.b14(tmp0_desc, 1, tmp12_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.b14(tmp0_desc, 2, tmp12_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.b14(tmp0_desc, 3, tmp12_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.r13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.r13(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.d14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp11_input.q13(tmp0_desc);
    return DraftState.v4m(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  dz() {
    return this.m4m_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_245().l4m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), tmp0_cached[3].k3(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[6].k3())];
  }
}
class DraftState {
  constructor(offered, picked, removed, pendingChoiceCharacterIndices, isForDiscard, removedCardsReturnToUnused, twoPlayerStage) {
    Companion_getInstance_245();
    isForDiscard = isForDiscard === VOID ? false : isForDiscard;
    removedCardsReturnToUnused = removedCardsReturnToUnused === VOID ? false : removedCardsReturnToUnused;
    twoPlayerStage = twoPlayerStage === VOID ? null : twoPlayerStage;
    this.o4m_1 = offered;
    this.p4m_1 = picked;
    this.q4m_1 = removed;
    this.r4m_1 = pendingChoiceCharacterIndices;
    this.s4m_1 = isForDiscard;
    this.t4m_1 = removedCardsReturnToUnused;
    this.u4m_1 = twoPlayerStage;
  }
  w4m() {
    return toSet(plus_2(plus_2(flatten(this.o4m_1), flatten(this.p4m_1)), flatten(this.q4m_1)));
  }
  x4m(offered, picked, removed, pendingChoiceCharacterIndices, isForDiscard, removedCardsReturnToUnused, twoPlayerStage) {
    return new DraftState(offered, picked, removed, pendingChoiceCharacterIndices, isForDiscard, removedCardsReturnToUnused, twoPlayerStage);
  }
  y4m(offered, picked, removed, pendingChoiceCharacterIndices, isForDiscard, removedCardsReturnToUnused, twoPlayerStage, $super) {
    offered = offered === VOID ? this.o4m_1 : offered;
    picked = picked === VOID ? this.p4m_1 : picked;
    removed = removed === VOID ? this.q4m_1 : removed;
    pendingChoiceCharacterIndices = pendingChoiceCharacterIndices === VOID ? this.r4m_1 : pendingChoiceCharacterIndices;
    isForDiscard = isForDiscard === VOID ? this.s4m_1 : isForDiscard;
    removedCardsReturnToUnused = removedCardsReturnToUnused === VOID ? this.t4m_1 : removedCardsReturnToUnused;
    twoPlayerStage = twoPlayerStage === VOID ? this.u4m_1 : twoPlayerStage;
    return $super === VOID ? this.x4m(offered, picked, removed, pendingChoiceCharacterIndices, isForDiscard, removedCardsReturnToUnused, twoPlayerStage) : $super.x4m.call(this, offered, picked, removed, pendingChoiceCharacterIndices, isForDiscard, removedCardsReturnToUnused, twoPlayerStage);
  }
  toString() {
    return 'DraftState(offered=' + toString(this.o4m_1) + ', picked=' + toString(this.p4m_1) + ', removed=' + toString(this.q4m_1) + ', pendingChoiceCharacterIndices=' + toString(this.r4m_1) + ', isForDiscard=' + this.s4m_1 + ', removedCardsReturnToUnused=' + this.t4m_1 + ', twoPlayerStage=' + toString_0(this.u4m_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.o4m_1);
    result = imul(result, 31) + hashCode(this.p4m_1) | 0;
    result = imul(result, 31) + hashCode(this.q4m_1) | 0;
    result = imul(result, 31) + hashCode(this.r4m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s4m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t4m_1) | 0;
    result = imul(result, 31) + (this.u4m_1 == null ? 0 : this.u4m_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraftState))
      return false;
    if (!equals(this.o4m_1, other.o4m_1))
      return false;
    if (!equals(this.p4m_1, other.p4m_1))
      return false;
    if (!equals(this.q4m_1, other.q4m_1))
      return false;
    if (!equals(this.r4m_1, other.r4m_1))
      return false;
    if (!(this.s4m_1 === other.s4m_1))
      return false;
    if (!(this.t4m_1 === other.t4m_1))
      return false;
    if (!equals(this.u4m_1, other.u4m_1))
      return false;
    return true;
  }
  static v4m(seen0, offered, picked, removed, pendingChoiceCharacterIndices, isForDiscard, removedCardsReturnToUnused, twoPlayerStage, serializationConstructorMarker) {
    Companion_getInstance_245();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_202().m4m_1);
    }
    var $this = createThis(this);
    $this.o4m_1 = offered;
    $this.p4m_1 = picked;
    $this.q4m_1 = removed;
    $this.r4m_1 = pendingChoiceCharacterIndices;
    if (0 === (seen0 & 16))
      $this.s4m_1 = false;
    else
      $this.s4m_1 = isForDiscard;
    if (0 === (seen0 & 32))
      $this.t4m_1 = false;
    else
      $this.t4m_1 = removedCardsReturnToUnused;
    if (0 === (seen0 & 64))
      $this.u4m_1 = null;
    else
      $this.u4m_1 = twoPlayerStage;
    return $this;
  }
}
class Companion_245 {
  constructor() {
    Companion_instance_245 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, HunterItems$Companion$$childSerializers$_anonymous__fgtnli);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, HunterItems$Companion$$childSerializers$_anonymous__fgtnli_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z4m_1 = [tmp_1, tmp_3, lazy(tmp_4, HunterItems$Companion$$childSerializers$_anonymous__fgtnli_1), null];
  }
}
class $serializer_204 {
  constructor() {
    $serializer_instance_203 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HunterItems', this, 4);
    tmp0_serialDesc.h1b('comingCards', true);
    tmp0_serialDesc.h1b('openCards', true);
    tmp0_serialDesc.h1b('discardedCards', true);
    tmp0_serialDesc.h1b('numberOfOpenCardsToDeal', true);
    this.a4n_1 = tmp0_serialDesc;
  }
  b4n(encoder, value) {
    var tmp0_desc = this.a4n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_246().z4m_1;
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(value.c4n_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c4n_1);
    }
    var tmp_0;
    if (tmp1_output.m15(tmp0_desc, 1)) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.collections.linkedSetOf' call
      var tmp$ret$1 = LinkedHashSet.v2();
      tmp_0 = !equals(value.d4n_1, tmp$ret$1);
    }
    if (tmp_0) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.d4n_1);
    }
    var tmp_1;
    if (tmp1_output.m15(tmp0_desc, 2)) {
      tmp_1 = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$2 = emptyList();
      tmp_1 = !equals(value.e4n_1, tmp$ret$2);
    }
    if (tmp_1) {
      tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.e4n_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.f4n_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 3, value.f4n_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b4n(encoder, value instanceof HunterItems ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a4n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_246().z4m_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return HunterItems.g4n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.a4n_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_246().z4m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), IntSerializer_getInstance()];
  }
}
class HunterItems {
  constructor(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal) {
    Companion_getInstance_246();
    var tmp;
    if (comingCards === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = comingCards;
    }
    comingCards = tmp;
    var tmp_0;
    if (openCards === VOID) {
      // Inline function 'kotlin.collections.linkedSetOf' call
      tmp_0 = LinkedHashSet.v2();
    } else {
      tmp_0 = openCards;
    }
    openCards = tmp_0;
    var tmp_1;
    if (discardedCards === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_1 = emptyList();
    } else {
      tmp_1 = discardedCards;
    }
    discardedCards = tmp_1;
    numberOfOpenCardsToDeal = numberOfOpenCardsToDeal === VOID ? 3 : numberOfOpenCardsToDeal;
    this.c4n_1 = comingCards;
    this.d4n_1 = openCards;
    this.e4n_1 = discardedCards;
    this.f4n_1 = numberOfOpenCardsToDeal;
  }
  d36() {
    return this.c4n_1;
  }
  e36() {
    return this.d4n_1;
  }
  h4n() {
    return this.e4n_1;
  }
  i4n() {
    return this.f4n_1;
  }
  j4n(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal) {
    return new HunterItems(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal);
  }
  k4n(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal, $super) {
    comingCards = comingCards === VOID ? this.c4n_1 : comingCards;
    openCards = openCards === VOID ? this.d4n_1 : openCards;
    discardedCards = discardedCards === VOID ? this.e4n_1 : discardedCards;
    numberOfOpenCardsToDeal = numberOfOpenCardsToDeal === VOID ? this.f4n_1 : numberOfOpenCardsToDeal;
    return $super === VOID ? this.j4n(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal) : $super.j4n.call(this, comingCards, openCards, discardedCards, numberOfOpenCardsToDeal);
  }
  toString() {
    return 'HunterItems(comingCards=' + toString(this.c4n_1) + ', openCards=' + toString(this.d4n_1) + ', discardedCards=' + toString(this.e4n_1) + ', numberOfOpenCardsToDeal=' + this.f4n_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.c4n_1);
    result = imul(result, 31) + hashCode(this.d4n_1) | 0;
    result = imul(result, 31) + hashCode(this.e4n_1) | 0;
    result = imul(result, 31) + this.f4n_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterItems))
      return false;
    if (!equals(this.c4n_1, other.c4n_1))
      return false;
    if (!equals(this.d4n_1, other.d4n_1))
      return false;
    if (!equals(this.e4n_1, other.e4n_1))
      return false;
    if (!(this.f4n_1 === other.f4n_1))
      return false;
    return true;
  }
  static g4n(seen0, comingCards, openCards, discardedCards, numberOfOpenCardsToDeal, serializationConstructorMarker) {
    Companion_getInstance_246();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_203().a4n_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.c4n_1 = emptyList();
    } else
      $this.c4n_1 = comingCards;
    if (0 === (seen0 & 2)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.linkedSetOf' call
      tmp_0.d4n_1 = LinkedHashSet.v2();
    } else
      $this.d4n_1 = openCards;
    if (0 === (seen0 & 4)) {
      var tmp_1 = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp_1.e4n_1 = emptyList();
    } else
      $this.e4n_1 = discardedCards;
    if (0 === (seen0 & 8))
      $this.f4n_1 = 3;
    else
      $this.f4n_1 = numberOfOpenCardsToDeal;
    return $this;
  }
}
class Companion_246 {
  constructor() {
    Companion_instance_246 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, BeastlyTalents$Companion$$childSerializers$_anonymous__v0o6q9);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, BeastlyTalents$Companion$$childSerializers$_anonymous__v0o6q9_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l4n_1 = [tmp_1, tmp_3, lazy(tmp_4, BeastlyTalents$Companion$$childSerializers$_anonymous__v0o6q9_1), null];
  }
}
class $serializer_205 {
  constructor() {
    $serializer_instance_204 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeastlyTalents', this, 4);
    tmp0_serialDesc.h1b('comingCards', true);
    tmp0_serialDesc.h1b('openCards', true);
    tmp0_serialDesc.h1b('discardedCards', true);
    tmp0_serialDesc.h1b('numberOfOpenCardsToDeal', true);
    this.m4n_1 = tmp0_serialDesc;
  }
  n4n(encoder, value) {
    var tmp0_desc = this.m4n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_247().l4n_1;
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(value.t2y_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t2y_1);
    }
    var tmp_0;
    if (tmp1_output.m15(tmp0_desc, 1)) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.collections.linkedSetOf' call
      var tmp$ret$1 = LinkedHashSet.v2();
      tmp_0 = !equals(value.u2y_1, tmp$ret$1);
    }
    if (tmp_0) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.u2y_1);
    }
    var tmp_1;
    if (tmp1_output.m15(tmp0_desc, 2)) {
      tmp_1 = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$2 = emptyList();
      tmp_1 = !equals(value.v2y_1, tmp$ret$2);
    }
    if (tmp_1) {
      tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.v2y_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.w2y_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 3, value.w2y_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n4n(encoder, value instanceof BeastlyTalents ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m4n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_247().l4n_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return BeastlyTalents.o4n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.m4n_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_247().l4n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), IntSerializer_getInstance()];
  }
}
class BeastlyTalents {
  constructor(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal) {
    Companion_getInstance_247();
    var tmp;
    if (comingCards === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = comingCards;
    }
    comingCards = tmp;
    var tmp_0;
    if (openCards === VOID) {
      // Inline function 'kotlin.collections.linkedSetOf' call
      tmp_0 = LinkedHashSet.v2();
    } else {
      tmp_0 = openCards;
    }
    openCards = tmp_0;
    var tmp_1;
    if (discardedCards === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_1 = emptyList();
    } else {
      tmp_1 = discardedCards;
    }
    discardedCards = tmp_1;
    numberOfOpenCardsToDeal = numberOfOpenCardsToDeal === VOID ? 3 : numberOfOpenCardsToDeal;
    this.t2y_1 = comingCards;
    this.u2y_1 = openCards;
    this.v2y_1 = discardedCards;
    this.w2y_1 = numberOfOpenCardsToDeal;
  }
  d36() {
    return this.t2y_1;
  }
  e36() {
    return this.u2y_1;
  }
  h4n() {
    return this.v2y_1;
  }
  i4n() {
    return this.w2y_1;
  }
  p4n(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal) {
    return new BeastlyTalents(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal);
  }
  q4n(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal, $super) {
    comingCards = comingCards === VOID ? this.t2y_1 : comingCards;
    openCards = openCards === VOID ? this.u2y_1 : openCards;
    discardedCards = discardedCards === VOID ? this.v2y_1 : discardedCards;
    numberOfOpenCardsToDeal = numberOfOpenCardsToDeal === VOID ? this.w2y_1 : numberOfOpenCardsToDeal;
    return $super === VOID ? this.p4n(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal) : $super.p4n.call(this, comingCards, openCards, discardedCards, numberOfOpenCardsToDeal);
  }
  toString() {
    return 'BeastlyTalents(comingCards=' + toString(this.t2y_1) + ', openCards=' + toString(this.u2y_1) + ', discardedCards=' + toString(this.v2y_1) + ', numberOfOpenCardsToDeal=' + this.w2y_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.t2y_1);
    result = imul(result, 31) + hashCode(this.u2y_1) | 0;
    result = imul(result, 31) + hashCode(this.v2y_1) | 0;
    result = imul(result, 31) + this.w2y_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastlyTalents))
      return false;
    if (!equals(this.t2y_1, other.t2y_1))
      return false;
    if (!equals(this.u2y_1, other.u2y_1))
      return false;
    if (!equals(this.v2y_1, other.v2y_1))
      return false;
    if (!(this.w2y_1 === other.w2y_1))
      return false;
    return true;
  }
  static o4n(seen0, comingCards, openCards, discardedCards, numberOfOpenCardsToDeal, serializationConstructorMarker) {
    Companion_getInstance_247();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_204().m4n_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.t2y_1 = emptyList();
    } else
      $this.t2y_1 = comingCards;
    if (0 === (seen0 & 2)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.linkedSetOf' call
      tmp_0.u2y_1 = LinkedHashSet.v2();
    } else
      $this.u2y_1 = openCards;
    if (0 === (seen0 & 4)) {
      var tmp_1 = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp_1.v2y_1 = emptyList();
    } else
      $this.v2y_1 = discardedCards;
    if (0 === (seen0 & 8))
      $this.w2y_1 = 3;
    else
      $this.w2y_1 = numberOfOpenCardsToDeal;
    return $this;
  }
}
class Companion_247 {
  constructor() {
    Companion_instance_247 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, AshRuins$Companion$$childSerializers$_anonymous__vsmytn);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, AshRuins$Companion$$childSerializers$_anonymous__vsmytn_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r4n_1 = [tmp_1, tmp_3, lazy(tmp_4, AshRuins$Companion$$childSerializers$_anonymous__vsmytn_1), null];
  }
}
class $serializer_206 {
  constructor() {
    $serializer_instance_205 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AshRuins', this, 4);
    tmp0_serialDesc.h1b('comingCards', true);
    tmp0_serialDesc.h1b('openCards', true);
    tmp0_serialDesc.h1b('discardedCards', true);
    tmp0_serialDesc.h1b('numberOfOpenCardsToDeal', true);
    this.s4n_1 = tmp0_serialDesc;
  }
  t4n(encoder, value) {
    var tmp0_desc = this.s4n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_248().r4n_1;
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(value.u4n_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u4n_1);
    }
    var tmp_0;
    if (tmp1_output.m15(tmp0_desc, 1)) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.collections.linkedSetOf' call
      var tmp$ret$1 = LinkedHashSet.v2();
      tmp_0 = !equals(value.v4n_1, tmp$ret$1);
    }
    if (tmp_0) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.v4n_1);
    }
    var tmp_1;
    if (tmp1_output.m15(tmp0_desc, 2)) {
      tmp_1 = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$2 = emptyList();
      tmp_1 = !equals(value.w4n_1, tmp$ret$2);
    }
    if (tmp_1) {
      tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.w4n_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.x4n_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 3, value.x4n_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t4n(encoder, value instanceof AshRuins ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s4n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_248().r4n_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return AshRuins.y4n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.s4n_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_248().r4n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), IntSerializer_getInstance()];
  }
}
class AshRuins {
  constructor(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal) {
    Companion_getInstance_248();
    var tmp;
    if (comingCards === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = comingCards;
    }
    comingCards = tmp;
    var tmp_0;
    if (openCards === VOID) {
      // Inline function 'kotlin.collections.linkedSetOf' call
      tmp_0 = LinkedHashSet.v2();
    } else {
      tmp_0 = openCards;
    }
    openCards = tmp_0;
    var tmp_1;
    if (discardedCards === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_1 = emptyList();
    } else {
      tmp_1 = discardedCards;
    }
    discardedCards = tmp_1;
    numberOfOpenCardsToDeal = numberOfOpenCardsToDeal === VOID ? 3 : numberOfOpenCardsToDeal;
    this.u4n_1 = comingCards;
    this.v4n_1 = openCards;
    this.w4n_1 = discardedCards;
    this.x4n_1 = numberOfOpenCardsToDeal;
  }
  d36() {
    return this.u4n_1;
  }
  e36() {
    return this.v4n_1;
  }
  h4n() {
    return this.w4n_1;
  }
  i4n() {
    return this.x4n_1;
  }
  z4n(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal) {
    return new AshRuins(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal);
  }
  a4o(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal, $super) {
    comingCards = comingCards === VOID ? this.u4n_1 : comingCards;
    openCards = openCards === VOID ? this.v4n_1 : openCards;
    discardedCards = discardedCards === VOID ? this.w4n_1 : discardedCards;
    numberOfOpenCardsToDeal = numberOfOpenCardsToDeal === VOID ? this.x4n_1 : numberOfOpenCardsToDeal;
    return $super === VOID ? this.z4n(comingCards, openCards, discardedCards, numberOfOpenCardsToDeal) : $super.z4n.call(this, comingCards, openCards, discardedCards, numberOfOpenCardsToDeal);
  }
  toString() {
    return 'AshRuins(comingCards=' + toString(this.u4n_1) + ', openCards=' + toString(this.v4n_1) + ', discardedCards=' + toString(this.w4n_1) + ', numberOfOpenCardsToDeal=' + this.x4n_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.u4n_1);
    result = imul(result, 31) + hashCode(this.v4n_1) | 0;
    result = imul(result, 31) + hashCode(this.w4n_1) | 0;
    result = imul(result, 31) + this.x4n_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AshRuins))
      return false;
    if (!equals(this.u4n_1, other.u4n_1))
      return false;
    if (!equals(this.v4n_1, other.v4n_1))
      return false;
    if (!equals(this.w4n_1, other.w4n_1))
      return false;
    if (!(this.x4n_1 === other.x4n_1))
      return false;
    return true;
  }
  static y4n(seen0, comingCards, openCards, discardedCards, numberOfOpenCardsToDeal, serializationConstructorMarker) {
    Companion_getInstance_248();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_205().s4n_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.u4n_1 = emptyList();
    } else
      $this.u4n_1 = comingCards;
    if (0 === (seen0 & 2)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.linkedSetOf' call
      tmp_0.v4n_1 = LinkedHashSet.v2();
    } else
      $this.v4n_1 = openCards;
    if (0 === (seen0 & 4)) {
      var tmp_1 = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp_1.w4n_1 = emptyList();
    } else
      $this.w4n_1 = discardedCards;
    if (0 === (seen0 & 8))
      $this.x4n_1 = 3;
    else
      $this.x4n_1 = numberOfOpenCardsToDeal;
    return $this;
  }
}
class Companion_248 {
  constructor() {
    Companion_instance_248 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b4o_1 = [lazy(tmp_0, KnownInfo$Companion$$childSerializers$_anonymous__2q1srd)];
  }
}
class $serializer_207 {
  constructor() {
    $serializer_instance_206 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.KnownInfo', this, 1);
    tmp0_serialDesc.h1b('cardsKnownForSure', true);
    this.c4o_1 = tmp0_serialDesc;
  }
  d4o(encoder, value) {
    var tmp0_desc = this.c4o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_249().b4o_1;
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$0 = emptyMap();
      tmp = !equals(value.e4o_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.e4o_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d4o(encoder, value instanceof KnownInfo ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c4o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_249().b4o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return KnownInfo.f4o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.c4o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_249().b4o_1[0].k3()];
  }
}
class KnownInfo {
  constructor(cardsKnownForSure) {
    Companion_getInstance_249();
    var tmp;
    if (cardsKnownForSure === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp = emptyMap();
    } else {
      tmp = cardsKnownForSure;
    }
    cardsKnownForSure = tmp;
    this.e4o_1 = cardsKnownForSure;
  }
  toString() {
    return 'KnownInfo(cardsKnownForSure=' + toString(this.e4o_1) + ')';
  }
  hashCode() {
    return hashCode(this.e4o_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KnownInfo))
      return false;
    if (!equals(this.e4o_1, other.e4o_1))
      return false;
    return true;
  }
  static f4o(seen0, cardsKnownForSure, serializationConstructorMarker) {
    Companion_getInstance_249();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_206().c4o_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp.e4o_1 = emptyMap();
    } else
      $this.e4o_1 = cardsKnownForSure;
    return $this;
  }
}
class ArsenalType extends Enum {}
class DestroyReason extends Enum {}
class Companion_249 {
  constructor() {
    Companion_instance_249 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k4m_1 = lazy(tmp_0, TwoPlayerDraftStage$Companion$_anonymous__prcwg5);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_266(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class TwoPlayerDraftStage extends Enum {}
class Companion_250 {
  a2g() {
    var tmp = getKClass(CardsPlace);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ComingArsenalPlace), getKClass(DiscardPlace), getKClass(DraftOfferPlace), getKClass(DraftPickedPlace), getKClass(DraftRemovedPlace), getKClass(HandPlace), getKClass(InPlayPlace), getKClass(PendingTriggerPlace), getKClass(RevealedArsenalPlace), getKClass(TrapZonePlace), getKClass(UnusedDraftActionCardPlace)];
    var tmp_1 = ComingArsenalPlace_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('ComingArsenalPlace', tmp_1, tmp$ret$3);
    var tmp_3 = DiscardPlace_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('DiscardPlace', tmp_3, tmp$ret$6);
    var tmp_5 = $serializer_getInstance_207();
    var tmp_6 = $serializer_getInstance_208();
    var tmp_7 = $serializer_getInstance_209();
    var tmp_8 = $serializer_getInstance_210();
    var tmp_9 = InPlayPlace_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_10 = ObjectSerializer.l1c('InPlayPlace', tmp_9, tmp$ret$9);
    var tmp_11 = PendingTriggerPlace_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_12 = ObjectSerializer.l1c('PendingTriggerPlace', tmp_11, tmp$ret$12);
    var tmp_13 = RevealedArsenalPlace_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_14 = ObjectSerializer.l1c('RevealedArsenalPlace', tmp_13, tmp$ret$15);
    var tmp_15 = $serializer_getInstance_211();
    var tmp_16 = UnusedDraftActionCardPlace_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_17 = [tmp_2, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_10, tmp_12, tmp_14, tmp_15, ObjectSerializer.l1c('UnusedDraftActionCardPlace', tmp_16, tmp$ret$18)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    return SealedClassSerializer.i10('steelart.beast.CardsPlace', tmp, tmp_0, tmp_17, tmp$ret$24);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class CardsPlace {}
class ComingArsenalPlace {
  constructor() {
    ComingArsenalPlace_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l4o_1 = lazy(tmp_0, ComingArsenalPlace$_anonymous__plposl);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_267(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ComingArsenalPlace';
  }
  hashCode() {
    return 338433943;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ComingArsenalPlace))
      return false;
    return true;
  }
}
class DiscardPlace {
  constructor() {
    DiscardPlace_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m4o_1 = lazy(tmp_0, DiscardPlace$_anonymous__xq6rf2);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_268(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DiscardPlace';
  }
  hashCode() {
    return -595675570;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardPlace))
      return false;
    return true;
  }
}
class Companion_251 {
  constructor() {
    Companion_instance_251 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n4o_1 = [lazy(tmp_0, DraftOfferPlace$Companion$$childSerializers$_anonymous__ght8ta)];
  }
}
class $serializer_208 {
  constructor() {
    $serializer_instance_207 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DraftOfferPlace', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.o4o_1 = tmp0_serialDesc;
  }
  p4o(encoder, value) {
    var tmp0_desc = this.o4o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_252().n4o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q4o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p4o(encoder, value instanceof DraftOfferPlace ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o4o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_252().n4o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DraftOfferPlace.r4o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.o4o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_252().n4o_1[0].k3()];
  }
}
class DraftOfferPlace {
  constructor(characterObject) {
    Companion_getInstance_252();
    this.q4o_1 = characterObject;
  }
  toString() {
    return 'DraftOfferPlace(characterObject=' + this.q4o_1.toString() + ')';
  }
  hashCode() {
    return this.q4o_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraftOfferPlace))
      return false;
    if (!this.q4o_1.equals(other.q4o_1))
      return false;
    return true;
  }
  static r4o(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_252();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_207().o4o_1);
    }
    var $this = createThis(this);
    $this.q4o_1 = characterObject;
    return $this;
  }
}
class Companion_252 {
  constructor() {
    Companion_instance_252 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s4o_1 = [lazy(tmp_0, DraftPickedPlace$Companion$$childSerializers$_anonymous__61i47w)];
  }
}
class $serializer_209 {
  constructor() {
    $serializer_instance_208 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DraftPickedPlace', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.t4o_1 = tmp0_serialDesc;
  }
  u4o(encoder, value) {
    var tmp0_desc = this.t4o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_253().s4o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.v4o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u4o(encoder, value instanceof DraftPickedPlace ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t4o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_253().s4o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DraftPickedPlace.w4o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.t4o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_253().s4o_1[0].k3()];
  }
}
class DraftPickedPlace {
  constructor(characterObject) {
    Companion_getInstance_253();
    this.v4o_1 = characterObject;
  }
  toString() {
    return 'DraftPickedPlace(characterObject=' + this.v4o_1.toString() + ')';
  }
  hashCode() {
    return this.v4o_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraftPickedPlace))
      return false;
    if (!this.v4o_1.equals(other.v4o_1))
      return false;
    return true;
  }
  static w4o(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_253();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_208().t4o_1);
    }
    var $this = createThis(this);
    $this.v4o_1 = characterObject;
    return $this;
  }
}
class Companion_253 {
  constructor() {
    Companion_instance_253 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x4o_1 = [lazy(tmp_0, DraftRemovedPlace$Companion$$childSerializers$_anonymous__wv89jy)];
  }
}
class $serializer_210 {
  constructor() {
    $serializer_instance_209 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DraftRemovedPlace', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.y4o_1 = tmp0_serialDesc;
  }
  z4o(encoder, value) {
    var tmp0_desc = this.y4o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_254().x4o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a4p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z4o(encoder, value instanceof DraftRemovedPlace ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y4o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_254().x4o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DraftRemovedPlace.b4p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y4o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_254().x4o_1[0].k3()];
  }
}
class DraftRemovedPlace {
  constructor(characterObject) {
    Companion_getInstance_254();
    this.a4p_1 = characterObject;
  }
  toString() {
    return 'DraftRemovedPlace(characterObject=' + this.a4p_1.toString() + ')';
  }
  hashCode() {
    return this.a4p_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraftRemovedPlace))
      return false;
    if (!this.a4p_1.equals(other.a4p_1))
      return false;
    return true;
  }
  static b4p(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_254();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_209().y4o_1);
    }
    var $this = createThis(this);
    $this.a4p_1 = characterObject;
    return $this;
  }
}
class Companion_254 {
  constructor() {
    Companion_instance_254 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c4p_1 = [lazy(tmp_0, HandPlace$Companion$$childSerializers$_anonymous__885isu)];
  }
}
class $serializer_211 {
  constructor() {
    $serializer_instance_210 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HandPlace', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.d4p_1 = tmp0_serialDesc;
  }
  e4p(encoder, value) {
    var tmp0_desc = this.d4p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_255().c4p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f4p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e4p(encoder, value instanceof HandPlace ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d4p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_255().c4p_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return HandPlace.g4p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d4p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_255().c4p_1[0].k3()];
  }
}
class HandPlace {
  constructor(characterObject) {
    Companion_getInstance_255();
    this.f4p_1 = characterObject;
  }
  toString() {
    return 'HandPlace(characterObject=' + this.f4p_1.toString() + ')';
  }
  hashCode() {
    return this.f4p_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HandPlace))
      return false;
    if (!this.f4p_1.equals(other.f4p_1))
      return false;
    return true;
  }
  static g4p(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_255();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_210().d4p_1);
    }
    var $this = createThis(this);
    $this.f4p_1 = characterObject;
    return $this;
  }
}
class InPlayPlace {
  constructor() {
    InPlayPlace_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h4p_1 = lazy(tmp_0, InPlayPlace$_anonymous__c28ho7);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_269(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'InPlayPlace';
  }
  hashCode() {
    return -408343895;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InPlayPlace))
      return false;
    return true;
  }
}
class PendingTriggerPlace {
  constructor() {
    PendingTriggerPlace_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i4p_1 = lazy(tmp_0, PendingTriggerPlace$_anonymous__ng7fsh);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_270(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PendingTriggerPlace';
  }
  hashCode() {
    return 1851862657;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PendingTriggerPlace))
      return false;
    return true;
  }
}
class RevealedArsenalPlace {
  constructor() {
    RevealedArsenalPlace_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j4p_1 = lazy(tmp_0, RevealedArsenalPlace$_anonymous__e2zuxm);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_271(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RevealedArsenalPlace';
  }
  hashCode() {
    return 1715805250;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealedArsenalPlace))
      return false;
    return true;
  }
}
class Companion_255 {
  constructor() {
    Companion_instance_255 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k4p_1 = [lazy(tmp_0, TrapZonePlace$Companion$$childSerializers$_anonymous__372pwk)];
  }
}
class $serializer_212 {
  constructor() {
    $serializer_instance_211 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TrapZonePlace', this, 1);
    tmp0_serialDesc.h1b('zone', false);
    this.l4p_1 = tmp0_serialDesc;
  }
  m4p(encoder, value) {
    var tmp0_desc = this.l4p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_256().k4p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n4p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m4p(encoder, value instanceof TrapZonePlace ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l4p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_256().k4p_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return TrapZonePlace.o4p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l4p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_256().k4p_1[0].k3()];
  }
}
class TrapZonePlace {
  constructor(zone) {
    Companion_getInstance_256();
    this.n4p_1 = zone;
  }
  toString() {
    return 'TrapZonePlace(zone=' + this.n4p_1.toString() + ')';
  }
  hashCode() {
    return this.n4p_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrapZonePlace))
      return false;
    if (!this.n4p_1.equals(other.n4p_1))
      return false;
    return true;
  }
  static o4p(seen0, zone, serializationConstructorMarker) {
    Companion_getInstance_256();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_211().l4p_1);
    }
    var $this = createThis(this);
    $this.n4p_1 = zone;
    return $this;
  }
}
class UnusedDraftActionCardPlace {
  constructor() {
    UnusedDraftActionCardPlace_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p4p_1 = lazy(tmp_0, UnusedDraftActionCardPlace$_anonymous__nrr5of);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_272(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UnusedDraftActionCardPlace';
  }
  hashCode() {
    return -1751566373;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnusedDraftActionCardPlace))
      return false;
    return true;
  }
}
class Companion_256 {
  a2g() {
    var tmp = getKClass(GameStateChange);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AddNewCharacterToOrderChange), getKClass(AddObjectChange), getKClass(ArmorChange), getKClass(BeastMovementInfoChange), getKClass(CardsMoveChange), getKClass(DamageDealtToBeastsChange), getKClass(DestroyedChange), getKClass(AddTrapInfoChange), getKClass(AncientPowersChangeEvent), getKClass(AshRuinPositionChangeEvent), getKClass(AshRuinReplacementChangeEvent), getKClass(ChargingUpgradeChangeEvent), getKClass(DamageBlockChange), getKClass(DraftStateEvent), getKClass(DrainedSoulsChangeEvent), getKClass(DraugCorruptionChangeEvent), getKClass(DuplicateCardEffectChangeEvent), getKClass(FirePositionsChange), getKClass(GameScopesChangeEvent), getKClass(KnownCardsInfoChangeEvent), getKClass(LydanHarvestChangeEvent), getKClass(OpenArsenalCardsToDealChangeNumberEvent), getKClass(RegentDominionChangeEvent), getKClass(RemoveTrapInfoChange), getKClass(RevertForKnownCardsInfoChangeEvent), getKClass(RhagnerHoardChangeEvent), getKClass(RuinClaimedChangeEvent), getKClass(SetBeastMovementInfoAndTrailsChange), getKClass(SetDayNumberAndTurnChange), getKClass(SetEyeHazeStatusChangeEvent), getKClass(SetSnareMetadataChangeEvent), getKClass(SigridPactChangeEvent), getKClass(SubmittedDamageChange), getKClass(AkkeronEternityTransformedPositionsChangeEvent), getKClass(ChangeBlueDraftActionCardWasPlayedStatusEvent), getKClass(ChangeFeatheredKingRebornStatusEvent), getKClass(ChangeFylgjaFlightWasUsedThisTurnEvent), getKClass(ChangeRedDraftActionCardWasPlayedStatusEvent), getKClass(ChangeSettlersMovedStatusEvent), getKClass(DraugRespawnStateChangeEvent), getKClass(MesmeriseChooseEvent), getKClass(ResonanceChooseEvent), getKClass(SetCurrentPhaseEvent), getKClass(SetPlayingCardNumberChangeEvent), getKClass(SigridCreatureLungedStatusEvent), getKClass(SkipNextTurnStatusChangeEvent), getKClass(TrailsRevealedChange), getKClass(TransformSimpleObjectChangeEvent), getKClass(UrgullMoltCounterChangeEvent), getKClass(ValdiBloodChangeEvent), getKClass(ClearingAfterRevealChange), getKClass(FirstPassPlayerChange), getKClass(RevertAfterClearingAfterRevealChange), getKClass(GrudgesChange), getKClass(HpChange), getKClass(MovementChange), getKClass(RemoveUpgradeChange), getKClass(ResurrectObjectChange), getKClass(RevealLastMovementsChange), getKClass(RevertForAddNewCharacterToOrderChange), getKClass(RevertForAddObjectChange), getKClass(RevertForBeastMovementInfoChange), getKClass(RevertForDestroyedChange), getKClass(RevertForMovementChange), getKClass(RevertForRandomArsenalCardsMoveChange), getKClass(RevertForResurrectObjectChange), getKClass(SetValdiBloodEvent), getKClass(TransformLocationsChange), getKClass(UpgradeChange)];
    var tmp_1 = AddNewCharacterToOrderChange_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('AddNewCharacterToOrderChange', tmp_1, tmp$ret$3);
    var tmp_3 = $serializer_getInstance_230();
    var tmp_4 = $serializer_getInstance_229();
    var tmp_5 = $serializer_getInstance_238();
    var tmp_6 = $serializer_getInstance_235();
    var tmp_7 = $serializer_getInstance_232();
    var tmp_8 = $serializer_getInstance_234();
    var tmp_9 = $serializer_getInstance_212();
    var tmp_10 = $serializer_getInstance_213();
    var tmp_11 = $serializer_getInstance_263();
    var tmp_12 = $serializer_getInstance_264();
    var tmp_13 = $serializer_getInstance_265();
    var tmp_14 = $serializer_getInstance_214();
    var tmp_15 = $serializer_getInstance_266();
    var tmp_16 = $serializer_getInstance_427();
    var tmp_17 = $serializer_getInstance_131();
    var tmp_18 = $serializer_getInstance_267();
    var tmp_19 = $serializer_getInstance_215();
    var tmp_20 = $serializer_getInstance_216();
    var tmp_21 = $serializer_getInstance_217();
    var tmp_22 = $serializer_getInstance_353();
    var tmp_23 = $serializer_getInstance_218();
    var tmp_24 = $serializer_getInstance_381();
    var tmp_25 = $serializer_getInstance_219();
    var tmp_26 = $serializer_getInstance_220();
    var tmp_27 = $serializer_getInstance_395();
    var tmp_28 = $serializer_getInstance_268();
    var tmp_29 = $serializer_getInstance_221();
    var tmp_30 = $serializer_getInstance_222();
    var tmp_31 = $serializer_getInstance_369();
    var tmp_32 = $serializer_getInstance_370();
    var tmp_33 = $serializer_getInstance_402();
    var tmp_34 = $serializer_getInstance_223();
    var tmp_35 = $serializer_getInstance_70();
    var tmp_36 = $serializer_getInstance_141();
    var tmp_37 = $serializer_getInstance_148();
    var tmp_38 = $serializer_getInstance_135();
    var tmp_39 = $serializer_getInstance_79();
    var tmp_40 = $serializer_getInstance_399();
    var tmp_41 = $serializer_getInstance_132();
    var tmp_42 = $serializer_getInstance_139();
    var tmp_43 = $serializer_getInstance_80();
    var tmp_44 = $serializer_getInstance_224();
    var tmp_45 = $serializer_getInstance_225();
    var tmp_46 = $serializer_getInstance_403();
    var tmp_47 = $serializer_getInstance_226();
    var tmp_48 = $serializer_getInstance_227();
    var tmp_49 = $serializer_getInstance_228();
    var tmp_50 = $serializer_getInstance_420();
    var tmp_51 = $serializer_getInstance_431();
    var tmp_52 = $serializer_getInstance_241();
    var tmp_53 = $serializer_getInstance_233();
    var tmp_54 = $serializer_getInstance_245();
    var tmp_55 = $serializer_getInstance_236();
    var tmp_56 = $serializer_getInstance_231();
    var tmp_57 = $serializer_getInstance_237();
    var tmp_58 = $serializer_getInstance_239();
    var tmp_59 = $serializer_getInstance_240();
    var tmp_60 = $serializer_getInstance_242();
    var tmp_61 = RevertForAddNewCharacterToOrderChange_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_62 = ObjectSerializer.l1c('RevertForAddNewCharacterToOrderChange', tmp_61, tmp$ret$6);
    var tmp_63 = RevertForAddObjectChange_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_64 = ObjectSerializer.l1c('RevertForAddObjectChange', tmp_63, tmp$ret$9);
    var tmp_65 = $serializer_getInstance_246();
    var tmp_66 = RevertForDestroyedChange_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_67 = [tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_62, tmp_64, tmp_65, ObjectSerializer.l1c('RevertForDestroyedChange', tmp_66, tmp$ret$12), $serializer_getInstance_247(), $serializer_getInstance_248(), $serializer_getInstance_249(), $serializer_getInstance_432(), $serializer_getInstance_243(), $serializer_getInstance_244()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    return SealedClassSerializer.i10('steelart.beast.GameStateChange', tmp, tmp_0, tmp_67, tmp$ret$18);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_257 {
  constructor() {
    Companion_instance_257 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, AddTrapInfoChange$Companion$$childSerializers$_anonymous__3x6wte);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, AddTrapInfoChange$Companion$$childSerializers$_anonymous__3x6wte_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, AddTrapInfoChange$Companion$$childSerializers$_anonymous__3x6wte_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q4p_1 = [tmp_1, tmp_3, tmp_5, lazy(tmp_6, AddTrapInfoChange$Companion$$childSerializers$_anonymous__3x6wte_2), null];
  }
}
class $serializer_213 {
  constructor() {
    $serializer_instance_212 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AddTrapInfoChange', this, 5);
    tmp0_serialDesc.h1b('trap', false);
    tmp0_serialDesc.h1b('locationType', false);
    tmp0_serialDesc.h1b('zone', false);
    tmp0_serialDesc.h1b('owner', false);
    tmp0_serialDesc.h1b('revisionBeforePlacement', false);
    this.r4p_1 = tmp0_serialDesc;
  }
  s4p(encoder, value) {
    var tmp0_desc = this.r4p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_258().q4p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t4p_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.u4p_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.v4p_1);
    tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.w4p_1);
    tmp1_output.z14(tmp0_desc, 4, value.x4p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s4p(encoder, value instanceof AddTrapInfoChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r4p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_258().q4p_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.u13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.u13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return AddTrapInfoChange.y4p(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.r4p_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_258().q4p_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), tmp0_cached[3].k3(), IntSerializer_getInstance()];
  }
}
class AddTrapInfoChange {
  constructor(trap, locationType, zone, owner, revisionBeforePlacement) {
    Companion_getInstance_258();
    this.t4p_1 = trap;
    this.u4p_1 = locationType;
    this.v4p_1 = zone;
    this.w4p_1 = owner;
    this.x4p_1 = revisionBeforePlacement;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.w38_1 = plus_3(_this__u8e3s4.w38_1, to(this.t4p_1, new PlacedTrap(this.v4p_1, this.u4p_1, this.t4p_1, this.w4p_1, this.x4p_1)));
  }
  n37($context_GameState_t6qee5) {
    return new RemoveTrapInfoChange(this.t4p_1);
  }
  toString() {
    return 'AddTrapInfoChange(trap=' + toString(this.t4p_1) + ', locationType=' + this.u4p_1.toString() + ', zone=' + this.v4p_1.toString() + ', owner=' + this.w4p_1.toString() + ', revisionBeforePlacement=' + this.x4p_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.t4p_1);
    result = imul(result, 31) + this.u4p_1.hashCode() | 0;
    result = imul(result, 31) + this.v4p_1.hashCode() | 0;
    result = imul(result, 31) + this.w4p_1.hashCode() | 0;
    result = imul(result, 31) + this.x4p_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AddTrapInfoChange))
      return false;
    if (!equals(this.t4p_1, other.t4p_1))
      return false;
    if (!this.u4p_1.equals(other.u4p_1))
      return false;
    if (!this.v4p_1.equals(other.v4p_1))
      return false;
    if (!this.w4p_1.equals(other.w4p_1))
      return false;
    if (!(this.x4p_1 === other.x4p_1))
      return false;
    return true;
  }
  static y4p(seen0, trap, locationType, zone, owner, revisionBeforePlacement, serializationConstructorMarker) {
    Companion_getInstance_258();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_212().r4p_1);
    }
    var $this = createThis(this);
    $this.t4p_1 = trap;
    $this.u4p_1 = locationType;
    $this.v4p_1 = zone;
    $this.w4p_1 = owner;
    $this.x4p_1 = revisionBeforePlacement;
    return $this;
  }
}
class Companion_258 {
  constructor() {
    Companion_instance_258 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z4p_1 = [lazy(tmp_0, AncientPowersChangeEvent$Companion$$childSerializers$_anonymous__ktlhye), null];
  }
}
class $serializer_214 {
  constructor() {
    $serializer_instance_213 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AncientPowersChangeEvent', this, 2);
    tmp0_serialDesc.h1b('receiver', false);
    tmp0_serialDesc.h1b('ancientPowerNumber', false);
    this.a4q_1 = tmp0_serialDesc;
  }
  b4q(encoder, value) {
    var tmp0_desc = this.a4q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_259().z4p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c4q_1);
    tmp1_output.z14(tmp0_desc, 1, value.d4q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b4q(encoder, value instanceof AncientPowersChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a4q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_259().z4p_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return AncientPowersChangeEvent.e4q(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.a4q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_259().z4p_1[0].k3(), IntSerializer_getInstance()];
  }
}
class AncientPowersChangeEvent {
  constructor(receiver, ancientPowerNumber) {
    Companion_getInstance_259();
    this.c4q_1 = receiver;
    this.d4q_1 = ancientPowerNumber;
  }
  m37(_this__u8e3s4) {
    var _receiver__tnumb7 = this.c4q_1;
    set_ancientPowerNumberImpl(_this__u8e3s4, _receiver__tnumb7, get_ancientPowerNumberImpl(_this__u8e3s4, _receiver__tnumb7) + this.d4q_1 | 0);
    _this__u8e3s4.q38_1 = _this__u8e3s4.q38_1 - this.d4q_1 | 0;
  }
  n37($context_GameState_t6qee5) {
    return new AncientPowersChangeEvent(this.c4q_1, -this.d4q_1 | 0);
  }
  toString() {
    return 'AncientPowersChangeEvent(receiver=' + this.c4q_1.toString() + ', ancientPowerNumber=' + this.d4q_1 + ')';
  }
  hashCode() {
    var result = this.c4q_1.hashCode();
    result = imul(result, 31) + this.d4q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AncientPowersChangeEvent))
      return false;
    if (!this.c4q_1.equals(other.c4q_1))
      return false;
    if (!(this.d4q_1 === other.d4q_1))
      return false;
    return true;
  }
  static e4q(seen0, receiver, ancientPowerNumber, serializationConstructorMarker) {
    Companion_getInstance_259();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_213().a4q_1);
    }
    var $this = createThis(this);
    $this.c4q_1 = receiver;
    $this.d4q_1 = ancientPowerNumber;
    return $this;
  }
}
class Companion_259 {
  constructor() {
    Companion_instance_259 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f4q_1 = [lazy(tmp_0, DamageBlockChange$Companion$$childSerializers$_anonymous__l280g4)];
  }
}
class $serializer_215 {
  constructor() {
    $serializer_instance_214 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DamageBlockChange', this, 1);
    tmp0_serialDesc.h1b('newDamageBlocked', false);
    this.g4q_1 = tmp0_serialDesc;
  }
  h4q(encoder, value) {
    var tmp0_desc = this.g4q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_260().f4q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i4q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h4q(encoder, value instanceof DamageBlockChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g4q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_260().f4q_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DamageBlockChange.j4q(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g4q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_260().f4q_1[0].k3()];
  }
}
class DamageBlockChange {
  constructor(newDamageBlocked) {
    Companion_getInstance_260();
    this.i4q_1 = newDamageBlocked;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.u38_1 = toList(this.i4q_1);
  }
  n37($context_GameState_t6qee5) {
    return new DamageBlockChange(get_damageBlocked($context_GameState_t6qee5));
  }
  toString() {
    return 'DamageBlockChange(newDamageBlocked=' + toString(this.i4q_1) + ')';
  }
  hashCode() {
    return hashCode(this.i4q_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DamageBlockChange))
      return false;
    if (!equals(this.i4q_1, other.i4q_1))
      return false;
    return true;
  }
  static j4q(seen0, newDamageBlocked, serializationConstructorMarker) {
    Companion_getInstance_260();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_214().g4q_1);
    }
    var $this = createThis(this);
    $this.i4q_1 = newDamageBlocked;
    return $this;
  }
}
class Companion_260 {
  constructor() {
    Companion_instance_260 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k4q_1 = [lazy(tmp_0, FirePositionsChange$Companion$$childSerializers$_anonymous__2iy0ca)];
  }
}
class $serializer_216 {
  constructor() {
    $serializer_instance_215 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FirePositionsChange', this, 1);
    tmp0_serialDesc.h1b('newFirePositions', false);
    this.l4q_1 = tmp0_serialDesc;
  }
  m4q(encoder, value) {
    var tmp0_desc = this.l4q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_261().k4q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n4q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m4q(encoder, value instanceof FirePositionsChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l4q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_261().k4q_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return FirePositionsChange.o4q(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l4q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_261().k4q_1[0].k3()];
  }
}
class FirePositionsChange {
  constructor(newFirePositions) {
    Companion_getInstance_261();
    this.n4q_1 = newFirePositions;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.z38_1 = toSet(this.n4q_1);
  }
  n37(gsCtx) {
    return new FirePositionsChange(gsCtx.y4k());
  }
  toString() {
    return 'FirePositionsChange(newFirePositions=' + toString(this.n4q_1) + ')';
  }
  hashCode() {
    return hashCode(this.n4q_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FirePositionsChange))
      return false;
    if (!equals(this.n4q_1, other.n4q_1))
      return false;
    return true;
  }
  static o4q(seen0, newFirePositions, serializationConstructorMarker) {
    Companion_getInstance_261();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_215().l4q_1);
    }
    var $this = createThis(this);
    $this.n4q_1 = newFirePositions;
    return $this;
  }
}
class Companion_261 {
  constructor() {
    Companion_instance_261 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p4q_1 = [lazy(tmp_0, GameScopesChangeEvent$Companion$$childSerializers$_anonymous__z8deun)];
  }
}
class $serializer_217 {
  constructor() {
    $serializer_instance_216 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GameScopesChangeEvent', this, 1);
    tmp0_serialDesc.h1b('newGameScopes', false);
    this.q4q_1 = tmp0_serialDesc;
  }
  r4q(encoder, value) {
    var tmp0_desc = this.q4q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_262().p4q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s4q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r4q(encoder, value instanceof GameScopesChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q4q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_262().p4q_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GameScopesChangeEvent.t4q(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.q4q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_262().p4q_1[0].k3()];
  }
}
class GameScopesChangeEvent {
  constructor(newGameScopes) {
    Companion_getInstance_262();
    this.s4q_1 = newGameScopes;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.c38_1 = toList(this.s4q_1);
  }
  n37($context_GameState_t6qee5) {
    return new GameScopesChangeEvent(toList(get_gameScopes($context_GameState_t6qee5)));
  }
  toString() {
    return 'GameScopesChangeEvent(newGameScopes=' + toString(this.s4q_1) + ')';
  }
  hashCode() {
    return hashCode(this.s4q_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameScopesChangeEvent))
      return false;
    if (!equals(this.s4q_1, other.s4q_1))
      return false;
    return true;
  }
  static t4q(seen0, newGameScopes, serializationConstructorMarker) {
    Companion_getInstance_262();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_216().q4q_1);
    }
    var $this = createThis(this);
    $this.s4q_1 = newGameScopes;
    return $this;
  }
}
class Companion_262 {
  constructor() {
    Companion_instance_262 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, KnownCardsInfoChangeEvent$Companion$$childSerializers$_anonymous__gqqrwy);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, KnownCardsInfoChangeEvent$Companion$$childSerializers$_anonymous__gqqrwy_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u4q_1 = [null, tmp_1, tmp_3, lazy(tmp_4, KnownCardsInfoChangeEvent$Companion$$childSerializers$_anonymous__gqqrwy_1)];
  }
}
class $serializer_218 {
  constructor() {
    $serializer_instance_217 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('KnownCardsInfoChangeEvent', this, 4);
    tmp0_serialDesc.h1b('forGameTeam', false);
    tmp0_serialDesc.h1b('cards', false);
    tmp0_serialDesc.h1b('cardsPlace', false);
    tmp0_serialDesc.h1b('operation', false);
    this.v4q_1 = tmp0_serialDesc;
  }
  w4q(encoder, value) {
    var tmp0_desc = this.v4q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_263().u4q_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_183(), new GameTeam(value.x4q_1));
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.y4q_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.z4q_1);
    tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.a4r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w4q(encoder, value instanceof KnownCardsInfoChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v4q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_263().u4q_1;
    if (tmp8_input.e14()) {
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp8_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp8_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return KnownCardsInfoChangeEvent.b4r(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.v4q_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_263().u4q_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_183(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), tmp0_cached[3].k3()];
  }
}
class KnownCardsInfoChangeEvent {
  constructor(forGameTeam, cards, cardsPlace, operation) {
    Companion_getInstance_263();
    this.x4q_1 = forGameTeam;
    this.y4q_1 = cards;
    this.z4q_1 = cardsPlace;
    this.a4r_1 = operation;
  }
  m37(_this__u8e3s4) {
    var knownInfoForTeam = ensureNotNull(_this__u8e3s4.d39_1.w4(new GameTeam(this.x4q_1)));
    var tmp0 = this.y4q_1;
    var tmp0_elvis_lhs = knownInfoForTeam.e4o_1.w4(this.z4q_1);
    // Inline function 'kotlin.collections.fold' call
    var accumulator = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var current = accumulator;
      accumulator = withAddOrRemove(current, element, this.a4r_1);
    }
    var resultCardSet = accumulator;
    var tmp;
    if (resultCardSet.n1()) {
      tmp = minus(knownInfoForTeam.e4o_1, this.z4q_1);
    } else {
      tmp = plus_3(knownInfoForTeam.e4o_1, to(this.z4q_1, resultCardSet));
    }
    var resultCardsKnownForSure = tmp;
    _this__u8e3s4.d39_1 = plus_3(_this__u8e3s4.d39_1, to(new GameTeam(this.x4q_1), new KnownInfo(resultCardsKnownForSure)));
  }
  n37($context_GameState_t6qee5) {
    return new RevertForKnownCardsInfoChangeEvent(this, ensureNotNull(get_knownInfo($context_GameState_t6qee5).w4(new GameTeam(this.x4q_1))));
  }
  toString() {
    return 'KnownCardsInfoChangeEvent(forGameTeam=' + GameTeam__toString_impl_wfw0a6(this.x4q_1) + ', cards=' + toString(this.y4q_1) + ', cardsPlace=' + toString(this.z4q_1) + ', operation=' + this.a4r_1.toString() + ')';
  }
  hashCode() {
    var result = GameTeam__hashCode_impl_gu24w3(this.x4q_1);
    result = imul(result, 31) + hashCode(this.y4q_1) | 0;
    result = imul(result, 31) + hashCode(this.z4q_1) | 0;
    result = imul(result, 31) + this.a4r_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KnownCardsInfoChangeEvent))
      return false;
    if (!(this.x4q_1 === other.x4q_1))
      return false;
    if (!equals(this.y4q_1, other.y4q_1))
      return false;
    if (!equals(this.z4q_1, other.z4q_1))
      return false;
    if (!this.a4r_1.equals(other.a4r_1))
      return false;
    return true;
  }
  static b4r(seen0, forGameTeam, cards, cardsPlace, operation, serializationConstructorMarker) {
    Companion_getInstance_263();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_217().v4q_1);
    }
    var $this = createThis(this);
    $this.x4q_1 = forGameTeam;
    $this.y4q_1 = cards;
    $this.z4q_1 = cardsPlace;
    $this.a4r_1 = operation;
    return $this;
  }
}
class Companion_263 {
  constructor() {
    Companion_instance_263 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c4r_1 = [lazy(tmp_0, OpenArsenalCardsToDealChangeNumberEvent$Companion$$childSerializers$_anonymous__rsbhd3), null];
  }
}
class $serializer_219 {
  constructor() {
    $serializer_instance_218 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OpenArsenalCardsToDealChangeNumberEvent', this, 2);
    tmp0_serialDesc.h1b('arsenalType', false);
    tmp0_serialDesc.h1b('numberOfOpenCardsToDeal', false);
    this.d4r_1 = tmp0_serialDesc;
  }
  e4r(encoder, value) {
    var tmp0_desc = this.d4r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_264().c4r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f4r_1);
    tmp1_output.z14(tmp0_desc, 1, value.g4r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e4r(encoder, value instanceof OpenArsenalCardsToDealChangeNumberEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d4r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_264().c4r_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return OpenArsenalCardsToDealChangeNumberEvent.h4r(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d4r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_264().c4r_1[0].k3(), IntSerializer_getInstance()];
  }
}
class OpenArsenalCardsToDealChangeNumberEvent {
  constructor(arsenalType, numberOfOpenCardsToDeal) {
    Companion_getInstance_264();
    this.f4r_1 = arsenalType;
    this.g4r_1 = numberOfOpenCardsToDeal;
  }
  m37(_this__u8e3s4) {
    // Inline function 'kotlin.require' call
    if (!(this.g4r_1 >= 0)) {
      var message = 'Number of open cards to deal cannot be negative';
      throw IllegalArgumentException.h2(toString(message));
    }
    switch (this.f4r_1.w1_1) {
      case 0:
        _this__u8e3s4.a38_1 = _this__u8e3s4.a38_1.q4n(VOID, VOID, VOID, this.g4r_1);
        break;
      case 1:
        _this__u8e3s4.z37_1 = _this__u8e3s4.z37_1.k4n(VOID, VOID, VOID, this.g4r_1);
        break;
      case 2:
        _this__u8e3s4.b38_1 = _this__u8e3s4.b38_1.a4o(VOID, VOID, VOID, this.g4r_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  n37($context_GameState_t6qee5) {
    return new OpenArsenalCardsToDealChangeNumberEvent(this.f4r_1, getArsenal($context_GameState_t6qee5, this.f4r_1).i4n());
  }
  toString() {
    return 'OpenArsenalCardsToDealChangeNumberEvent(arsenalType=' + this.f4r_1.toString() + ', numberOfOpenCardsToDeal=' + this.g4r_1 + ')';
  }
  hashCode() {
    var result = this.f4r_1.hashCode();
    result = imul(result, 31) + this.g4r_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenArsenalCardsToDealChangeNumberEvent))
      return false;
    if (!this.f4r_1.equals(other.f4r_1))
      return false;
    if (!(this.g4r_1 === other.g4r_1))
      return false;
    return true;
  }
  static h4r(seen0, arsenalType, numberOfOpenCardsToDeal, serializationConstructorMarker) {
    Companion_getInstance_264();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_218().d4r_1);
    }
    var $this = createThis(this);
    $this.f4r_1 = arsenalType;
    $this.g4r_1 = numberOfOpenCardsToDeal;
    return $this;
  }
}
class Companion_264 {
  constructor() {
    Companion_instance_264 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i4r_1 = [lazy(tmp_0, RemoveTrapInfoChange$Companion$$childSerializers$_anonymous__u11f23)];
  }
}
class $serializer_220 {
  constructor() {
    $serializer_instance_219 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RemoveTrapInfoChange', this, 1);
    tmp0_serialDesc.h1b('trap', false);
    this.j4r_1 = tmp0_serialDesc;
  }
  k4r(encoder, value) {
    var tmp0_desc = this.j4r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_265().i4r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l4r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k4r(encoder, value instanceof RemoveTrapInfoChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j4r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_265().i4r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RemoveTrapInfoChange.m4r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.j4r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_265().i4r_1[0].k3()];
  }
}
class RemoveTrapInfoChange {
  constructor(trap) {
    Companion_getInstance_265();
    this.l4r_1 = trap;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.w38_1 = minus(_this__u8e3s4.w38_1, this.l4r_1);
  }
  n37($context_GameState_t6qee5) {
    var placedTrap = ensureNotNull(get_placedTrapsFullInfo($context_GameState_t6qee5).w4(this.l4r_1));
    return new AddTrapInfoChange(this.l4r_1, placedTrap.h4o_1, placedTrap.g4o_1, placedTrap.j4o_1, placedTrap.k4o_1);
  }
  toString() {
    return 'RemoveTrapInfoChange(trap=' + toString(this.l4r_1) + ')';
  }
  hashCode() {
    return hashCode(this.l4r_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoveTrapInfoChange))
      return false;
    if (!equals(this.l4r_1, other.l4r_1))
      return false;
    return true;
  }
  static m4r(seen0, trap, serializationConstructorMarker) {
    Companion_getInstance_265();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_219().j4r_1);
    }
    var $this = createThis(this);
    $this.l4r_1 = trap;
    return $this;
  }
}
class Companion_265 {}
class $serializer_221 {
  constructor() {
    $serializer_instance_220 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevertForKnownCardsInfoChangeEvent', this, 2);
    tmp0_serialDesc.h1b('original', false);
    tmp0_serialDesc.h1b('knownInfoBeforeChange', false);
    this.n4r_1 = tmp0_serialDesc;
  }
  o4r(encoder, value) {
    var tmp0_desc = this.n4r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_217(), value.p4r_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_206(), value.q4r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o4r(encoder, value instanceof RevertForKnownCardsInfoChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n4r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_217(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_206(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_217(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_206(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RevertForKnownCardsInfoChangeEvent.r4r(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.n4r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_217(), $serializer_getInstance_206()];
  }
}
class RevertForKnownCardsInfoChangeEvent {
  constructor(original, knownInfoBeforeChange) {
    this.p4r_1 = original;
    this.q4r_1 = knownInfoBeforeChange;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.d39_1 = plus_3(_this__u8e3s4.d39_1, to(new GameTeam(this.p4r_1.x4q_1), this.q4r_1));
  }
  n37($context_GameState_t6qee5) {
    return this.p4r_1;
  }
  toString() {
    return 'RevertForKnownCardsInfoChangeEvent(original=' + this.p4r_1.toString() + ', knownInfoBeforeChange=' + this.q4r_1.toString() + ')';
  }
  hashCode() {
    var result = this.p4r_1.hashCode();
    result = imul(result, 31) + this.q4r_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertForKnownCardsInfoChangeEvent))
      return false;
    if (!this.p4r_1.equals(other.p4r_1))
      return false;
    if (!this.q4r_1.equals(other.q4r_1))
      return false;
    return true;
  }
  static r4r(seen0, original, knownInfoBeforeChange, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_220().n4r_1);
    }
    var $this = createThis(this);
    $this.p4r_1 = original;
    $this.q4r_1 = knownInfoBeforeChange;
    return $this;
  }
}
class Companion_266 {
  constructor() {
    Companion_instance_266 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, SetBeastMovementInfoAndTrailsChange$Companion$$childSerializers$_anonymous__zc6rlc);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, SetBeastMovementInfoAndTrailsChange$Companion$$childSerializers$_anonymous__zc6rlc_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, SetBeastMovementInfoAndTrailsChange$Companion$$childSerializers$_anonymous__zc6rlc_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s4r_1 = [tmp_1, null, tmp_3, tmp_5, lazy(tmp_6, SetBeastMovementInfoAndTrailsChange$Companion$$childSerializers$_anonymous__zc6rlc_2)];
  }
}
class $serializer_222 {
  constructor() {
    $serializer_instance_221 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetBeastMovementInfoAndTrailsChange', this, 5);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('newPosition', false);
    tmp0_serialDesc.h1b('newBeastPath', false);
    tmp0_serialDesc.h1b('newBeastMovements', false);
    tmp0_serialDesc.h1b('newFoundTrails', false);
    this.t4r_1 = tmp0_serialDesc;
  }
  u4r(encoder, value) {
    var tmp0_desc = this.t4r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_267().s4r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.v4r_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_100(), new BoardPosition(value.w4r_1));
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.x4r_1);
    tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.y4r_1);
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.z4r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u4r(encoder, value instanceof SetBeastMovementInfoAndTrailsChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t4r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_267().s4r_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp9_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, tmp10_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp9_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, tmp10_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return SetBeastMovementInfoAndTrailsChange.a4s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.t4r_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_267().s4r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), $serializer_getInstance_100(), tmp0_cached[2].k3(), tmp0_cached[3].k3(), tmp0_cached[4].k3()];
  }
}
class SetBeastMovementInfoAndTrailsChange {
  constructor(beast, newPosition, newBeastPath, newBeastMovements, newFoundTrails) {
    Companion_getInstance_267();
    this.v4r_1 = beast;
    this.w4r_1 = newPosition;
    this.x4r_1 = newBeastPath;
    this.y4r_1 = newBeastMovements;
    this.z4r_1 = newFoundTrails;
  }
  m37(_this__u8e3s4) {
    this.v4r_1.b4s(_this__u8e3s4, this.w4r_1);
    set_beastPathImpl(_this__u8e3s4, this.v4r_1, this.x4r_1);
    set_beastMovementsImpl(_this__u8e3s4, this.v4r_1, this.y4r_1);
    set_foundTrailsImpl(_this__u8e3s4, this.v4r_1, this.z4r_1);
  }
  n37($context_GameState_t6qee5) {
    return new SetBeastMovementInfoAndTrailsChange(this.v4r_1, this.v4r_1.s2w($context_GameState_t6qee5), get_beastPath($context_GameState_t6qee5, this.v4r_1), get_beastMovements($context_GameState_t6qee5, this.v4r_1), get_foundTrails($context_GameState_t6qee5, this.v4r_1));
  }
  toString() {
    return 'SetBeastMovementInfoAndTrailsChange(beast=' + this.v4r_1.toString() + ', newPosition=' + BoardPosition__toString_impl_v4mn82(this.w4r_1) + ', newBeastPath=' + toString(this.x4r_1) + ', newBeastMovements=' + toString(this.y4r_1) + ', newFoundTrails=' + toString(this.z4r_1) + ')';
  }
  hashCode() {
    var result = this.v4r_1.hashCode();
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.w4r_1) | 0;
    result = imul(result, 31) + hashCode(this.x4r_1) | 0;
    result = imul(result, 31) + hashCode(this.y4r_1) | 0;
    result = imul(result, 31) + hashCode(this.z4r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetBeastMovementInfoAndTrailsChange))
      return false;
    if (!this.v4r_1.equals(other.v4r_1))
      return false;
    if (!(this.w4r_1 === other.w4r_1))
      return false;
    if (!equals(this.x4r_1, other.x4r_1))
      return false;
    if (!equals(this.y4r_1, other.y4r_1))
      return false;
    if (!equals(this.z4r_1, other.z4r_1))
      return false;
    return true;
  }
  static a4s(seen0, beast, newPosition, newBeastPath, newBeastMovements, newFoundTrails, serializationConstructorMarker) {
    Companion_getInstance_267();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_221().t4r_1);
    }
    var $this = createThis(this);
    $this.v4r_1 = beast;
    $this.w4r_1 = newPosition;
    $this.x4r_1 = newBeastPath;
    $this.y4r_1 = newBeastMovements;
    $this.z4r_1 = newFoundTrails;
    return $this;
  }
}
class Companion_267 {}
class $serializer_223 {
  constructor() {
    $serializer_instance_222 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetDayNumberAndTurnChange', this, 2);
    tmp0_serialDesc.h1b('dayNumber', false);
    tmp0_serialDesc.h1b('turnNumber', false);
    this.c4s_1 = tmp0_serialDesc;
  }
  d4s(encoder, value) {
    var tmp0_desc = this.c4s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.e4s_1);
    tmp1_output.z14(tmp0_desc, 1, value.f4s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d4s(encoder, value instanceof SetDayNumberAndTurnChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c4s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SetDayNumberAndTurnChange.g4s(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.c4s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class SetDayNumberAndTurnChange {
  constructor(dayNumber, turnNumber) {
    this.e4s_1 = dayNumber;
    this.f4s_1 = turnNumber;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.e38_1 = this.e4s_1;
    _this__u8e3s4.f38_1 = this.f4s_1;
  }
  n37($context_GameState_t6qee5) {
    return new SetDayNumberAndTurnChange(get_currentDayNumber($context_GameState_t6qee5), get_currentTurnNumber($context_GameState_t6qee5));
  }
  toString() {
    return 'SetDayNumberAndTurnChange(dayNumber=' + this.e4s_1 + ', turnNumber=' + this.f4s_1 + ')';
  }
  hashCode() {
    var result = this.e4s_1;
    result = imul(result, 31) + this.f4s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetDayNumberAndTurnChange))
      return false;
    if (!(this.e4s_1 === other.e4s_1))
      return false;
    if (!(this.f4s_1 === other.f4s_1))
      return false;
    return true;
  }
  static g4s(seen0, dayNumber, turnNumber, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_222().c4s_1);
    }
    var $this = createThis(this);
    $this.e4s_1 = dayNumber;
    $this.f4s_1 = turnNumber;
    return $this;
  }
}
class Companion_268 {}
class $serializer_224 {
  constructor() {
    $serializer_instance_223 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SubmittedDamageChange', this, 1);
    tmp0_serialDesc.h1b('submittedDamage', false);
    this.h4s_1 = tmp0_serialDesc;
  }
  i4s(encoder, value) {
    var tmp0_desc = this.h4s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.i15(tmp0_desc, 0, $serializer_getInstance_123(), value.j4s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i4s(encoder, value instanceof SubmittedDamageChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h4s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SubmittedDamageChange.k4s(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.h4s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_123())];
  }
}
class SubmittedDamageChange {
  constructor(submittedDamage) {
    this.j4s_1 = submittedDamage;
  }
  m37(_this__u8e3s4) {
    var tmp = _this__u8e3s4;
    var tmp0_safe_receiver = this.j4s_1;
    tmp.t38_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h3s(VOID, VOID, VOID, VOID, toLinkedSet(this.j4s_1.e3s_1));
  }
  n37($context_GameState_t6qee5) {
    return new SubmittedDamageChange(get_submittedCurrentDamage($context_GameState_t6qee5));
  }
  toString() {
    return 'SubmittedDamageChange(submittedDamage=' + toString_0(this.j4s_1) + ')';
  }
  hashCode() {
    return this.j4s_1 == null ? 0 : this.j4s_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SubmittedDamageChange))
      return false;
    if (!equals(this.j4s_1, other.j4s_1))
      return false;
    return true;
  }
  static k4s(seen0, submittedDamage, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_223().h4s_1);
    }
    var $this = createThis(this);
    $this.j4s_1 = submittedDamage;
    return $this;
  }
}
class Companion_269 {
  constructor() {
    Companion_instance_269 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l4s_1 = [lazy(tmp_0, SetCurrentPhaseEvent$Companion$$childSerializers$_anonymous__vyh9o4)];
  }
}
class $serializer_225 {
  constructor() {
    $serializer_instance_224 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetCurrentPhaseEvent', this, 1);
    tmp0_serialDesc.h1b('newPhase', false);
    this.m4s_1 = tmp0_serialDesc;
  }
  n4s(encoder, value) {
    var tmp0_desc = this.m4s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_270().l4s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o4s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n4s(encoder, value instanceof SetCurrentPhaseEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m4s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_270().l4s_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SetCurrentPhaseEvent.p4s(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m4s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_270().l4s_1[0].k3()];
  }
}
class SetCurrentPhaseEvent {
  constructor(newPhase) {
    Companion_getInstance_270();
    this.o4s_1 = newPhase;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.d38_1 = this.o4s_1;
  }
  n37($context_GameState_t6qee5) {
    return new SetCurrentPhaseEvent(get_phase($context_GameState_t6qee5));
  }
  toString() {
    return 'SetCurrentPhaseEvent(newPhase=' + toString(this.o4s_1) + ')';
  }
  hashCode() {
    return hashCode(this.o4s_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetCurrentPhaseEvent))
      return false;
    if (!equals(this.o4s_1, other.o4s_1))
      return false;
    return true;
  }
  static p4s(seen0, newPhase, serializationConstructorMarker) {
    Companion_getInstance_270();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_224().m4s_1);
    }
    var $this = createThis(this);
    $this.o4s_1 = newPhase;
    return $this;
  }
}
class Companion_270 {}
class $serializer_226 {
  constructor() {
    $serializer_instance_225 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetPlayingCardNumberChangeEvent', this, 1);
    tmp0_serialDesc.h1b('newValue', false);
    this.q4s_1 = tmp0_serialDesc;
  }
  r4s(encoder, value) {
    var tmp0_desc = this.q4s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.s4s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r4s(encoder, value instanceof SetPlayingCardNumberChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q4s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SetPlayingCardNumberChangeEvent.t4s(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.q4s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class SetPlayingCardNumberChangeEvent {
  constructor(newValue) {
    this.s4s_1 = newValue;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.c39_1 = this.s4s_1;
  }
  n37($context_GameState_t6qee5) {
    return new SetPlayingCardNumberChangeEvent(get_playedCardsNumber($context_GameState_t6qee5));
  }
  toString() {
    return 'SetPlayingCardNumberChangeEvent(newValue=' + this.s4s_1 + ')';
  }
  hashCode() {
    return this.s4s_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetPlayingCardNumberChangeEvent))
      return false;
    if (!(this.s4s_1 === other.s4s_1))
      return false;
    return true;
  }
  static t4s(seen0, newValue, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_225().q4s_1);
    }
    var $this = createThis(this);
    $this.s4s_1 = newValue;
    return $this;
  }
}
class Companion_271 {
  constructor() {
    Companion_instance_271 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u4s_1 = [lazy(tmp_0, SkipNextTurnStatusChangeEvent$Companion$$childSerializers$_anonymous__8vvs9t), null];
  }
}
class $serializer_227 {
  constructor() {
    $serializer_instance_226 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SkipNextTurnStatusChangeEvent', this, 2);
    tmp0_serialDesc.h1b('target', false);
    tmp0_serialDesc.h1b('newStatus', false);
    this.v4s_1 = tmp0_serialDesc;
  }
  w4s(encoder, value) {
    var tmp0_desc = this.v4s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_272().u4s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x4s_1);
    tmp1_output.w14(tmp0_desc, 1, value.y4s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w4s(encoder, value instanceof SkipNextTurnStatusChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v4s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_272().u4s_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SkipNextTurnStatusChangeEvent.z4s(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.v4s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_272().u4s_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class SkipNextTurnStatusChangeEvent {
  constructor(target, newStatus) {
    Companion_getInstance_272();
    this.x4s_1 = target;
    this.y4s_1 = newStatus;
  }
  m37(_this__u8e3s4) {
    set_skipNextTurnImpl(_this__u8e3s4, this.x4s_1, this.y4s_1);
  }
  n37($context_GameState_t6qee5) {
    return new SkipNextTurnStatusChangeEvent(this.x4s_1, get_skipNextTurn($context_GameState_t6qee5, this.x4s_1));
  }
  toString() {
    return 'SkipNextTurnStatusChangeEvent(target=' + this.x4s_1.toString() + ', newStatus=' + this.y4s_1 + ')';
  }
  hashCode() {
    var result = this.x4s_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.y4s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SkipNextTurnStatusChangeEvent))
      return false;
    if (!this.x4s_1.equals(other.x4s_1))
      return false;
    if (!(this.y4s_1 === other.y4s_1))
      return false;
    return true;
  }
  static z4s(seen0, target, newStatus, serializationConstructorMarker) {
    Companion_getInstance_272();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_226().v4s_1);
    }
    var $this = createThis(this);
    $this.x4s_1 = target;
    $this.y4s_1 = newStatus;
    return $this;
  }
}
class Companion_272 {
  constructor() {
    Companion_instance_272 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, TrailsRevealedChange$Companion$$childSerializers$_anonymous__4t2pun);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a4t_1 = [tmp_1, lazy(tmp_2, TrailsRevealedChange$Companion$$childSerializers$_anonymous__4t2pun_0)];
  }
}
class $serializer_228 {
  constructor() {
    $serializer_instance_227 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TrailsRevealedChange', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('newFoundTrails', false);
    this.b4t_1 = tmp0_serialDesc;
  }
  c4t(encoder, value) {
    var tmp0_desc = this.b4t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_273().a4t_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d4t_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.e4t_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c4t(encoder, value instanceof TrailsRevealedChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b4t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_273().a4t_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return TrailsRevealedChange.f4t(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.b4t_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_273().a4t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class TrailsRevealedChange {
  constructor(beast, newFoundTrails) {
    Companion_getInstance_273();
    this.d4t_1 = beast;
    this.e4t_1 = newFoundTrails;
  }
  m37(_this__u8e3s4) {
    set_foundTrailsImpl(_this__u8e3s4, this.d4t_1, this.e4t_1);
  }
  n37($context_GameState_t6qee5) {
    return new TrailsRevealedChange(this.d4t_1, get_foundTrails($context_GameState_t6qee5, this.d4t_1));
  }
  toString() {
    return 'TrailsRevealedChange(beast=' + this.d4t_1.toString() + ', newFoundTrails=' + toString(this.e4t_1) + ')';
  }
  hashCode() {
    var result = this.d4t_1.hashCode();
    result = imul(result, 31) + hashCode(this.e4t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrailsRevealedChange))
      return false;
    if (!this.d4t_1.equals(other.d4t_1))
      return false;
    if (!equals(this.e4t_1, other.e4t_1))
      return false;
    return true;
  }
  static f4t(seen0, beast, newFoundTrails, serializationConstructorMarker) {
    Companion_getInstance_273();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_227().b4t_1);
    }
    var $this = createThis(this);
    $this.d4t_1 = beast;
    $this.e4t_1 = newFoundTrails;
    return $this;
  }
}
class Companion_273 {
  constructor() {
    Companion_instance_273 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, TransformSimpleObjectChangeEvent$Companion$$childSerializers$_anonymous__hfpi6b);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g4t_1 = [null, tmp_1, lazy(tmp_2, TransformSimpleObjectChangeEvent$Companion$$childSerializers$_anonymous__hfpi6b_0)];
  }
}
class $serializer_229 {
  constructor() {
    $serializer_instance_228 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TransformSimpleObjectChangeEvent', this, 3);
    tmp0_serialDesc.h1b('gameTeam', false);
    tmp0_serialDesc.h1b('original', false);
    tmp0_serialDesc.h1b('newType', false);
    this.h4t_1 = tmp0_serialDesc;
  }
  i4t(encoder, value) {
    var tmp0_desc = this.h4t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_274().g4t_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_183(), new GameTeam(value.j4t_1));
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.k4t_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.l4t_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i4t(encoder, value instanceof TransformSimpleObjectChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h4t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_274().g4t_1;
    if (tmp7_input.e14()) {
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp7_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp7_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return TransformSimpleObjectChangeEvent.m4t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.h4t_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_274().g4t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_183(), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class TransformSimpleObjectChangeEvent {
  constructor(gameTeam, original, newType) {
    Companion_getInstance_274();
    this.j4t_1 = gameTeam;
    this.k4t_1 = original;
    this.l4t_1 = newType;
  }
  m37(_this__u8e3s4) {
    resetObjectType(_this__u8e3s4, this.k4t_1, this.l4t_1);
  }
  n37($context_GameState_t6qee5) {
    return new TransformSimpleObjectChangeEvent(this.j4t_1, this.k4t_1, get_objectType($context_GameState_t6qee5, this.k4t_1));
  }
  toString() {
    return 'TransformSimpleObjectChangeEvent(gameTeam=' + GameTeam__toString_impl_wfw0a6(this.j4t_1) + ', original=' + this.k4t_1.toString() + ', newType=' + toString(this.l4t_1) + ')';
  }
  hashCode() {
    var result = GameTeam__hashCode_impl_gu24w3(this.j4t_1);
    result = imul(result, 31) + this.k4t_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.l4t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TransformSimpleObjectChangeEvent))
      return false;
    if (!(this.j4t_1 === other.j4t_1))
      return false;
    if (!this.k4t_1.equals(other.k4t_1))
      return false;
    if (!equals(this.l4t_1, other.l4t_1))
      return false;
    return true;
  }
  static m4t(seen0, gameTeam, original, newType, serializationConstructorMarker) {
    Companion_getInstance_274();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_228().h4t_1);
    }
    var $this = createThis(this);
    $this.j4t_1 = gameTeam;
    $this.k4t_1 = original;
    $this.l4t_1 = newType;
    return $this;
  }
}
class Companion_274 {
  constructor() {
    Companion_instance_274 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n4t_1 = [lazy(tmp_0, ArmorChange$Companion$$childSerializers$_anonymous__flcknv), null];
  }
}
class $serializer_230 {
  constructor() {
    $serializer_instance_229 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ArmorChange', this, 2);
    tmp0_serialDesc.h1b('holder', false);
    tmp0_serialDesc.h1b('armorChange', false);
    this.o4t_1 = tmp0_serialDesc;
  }
  p4t(encoder, value) {
    var tmp0_desc = this.o4t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_275().n4t_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q4t_1);
    tmp1_output.z14(tmp0_desc, 1, value.r4t_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p4t(encoder, value instanceof ArmorChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o4t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_275().n4t_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ArmorChange.s4t(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.o4t_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_275().n4t_1[0].k3(), IntSerializer_getInstance()];
  }
}
class ArmorChange {
  constructor(holder, armorChange) {
    Companion_getInstance_275();
    this.q4t_1 = holder;
    this.r4t_1 = armorChange;
  }
  m37(_this__u8e3s4) {
    var _receiver__tnumb7 = this.q4t_1;
    set_armorImpl(_this__u8e3s4, _receiver__tnumb7, get_armorImpl(_this__u8e3s4, _receiver__tnumb7) + this.r4t_1 | 0);
    // Inline function 'kotlin.require' call
    if (!(get_armor(_this__u8e3s4, this.q4t_1) >= 0)) {
      var message = 'Armor cannot be negative';
      throw IllegalArgumentException.h2(toString(message));
    }
  }
  n37($context_GameState_t6qee5) {
    return new ArmorChange(this.q4t_1, -this.r4t_1 | 0);
  }
  toString() {
    return 'ArmorChange(holder=' + this.q4t_1.toString() + ', armorChange=' + this.r4t_1 + ')';
  }
  hashCode() {
    var result = this.q4t_1.hashCode();
    result = imul(result, 31) + this.r4t_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ArmorChange))
      return false;
    if (!this.q4t_1.equals(other.q4t_1))
      return false;
    if (!(this.r4t_1 === other.r4t_1))
      return false;
    return true;
  }
  static s4t(seen0, holder, armorChange, serializationConstructorMarker) {
    Companion_getInstance_275();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_229().o4t_1);
    }
    var $this = createThis(this);
    $this.q4t_1 = holder;
    $this.r4t_1 = armorChange;
    return $this;
  }
}
class Companion_275 {
  constructor() {
    Companion_instance_275 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t4t_1 = [lazy(tmp_0, AddObjectChange$Companion$$childSerializers$_anonymous__bsmrae), null];
  }
}
class $serializer_231 {
  constructor() {
    $serializer_instance_230 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AddObjectChange', this, 2);
    tmp0_serialDesc.h1b('objectType', false);
    tmp0_serialDesc.h1b('position', false);
    this.u4t_1 = tmp0_serialDesc;
  }
  v4t(encoder, value) {
    var tmp0_desc = this.u4t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_276().t4t_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w4t_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_100(), new BoardPosition(value.x4t_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v4t(encoder, value instanceof AddObjectChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u4t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_276().t4t_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return AddObjectChange.y4t(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.u4t_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_276().t4t_1[0].k3(), $serializer_getInstance_100()];
  }
}
class AddObjectChange {
  constructor(objectType, position) {
    Companion_getInstance_276();
    this.w4t_1 = objectType;
    this.x4t_1 = position;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.a4m(this.w4t_1, this.x4t_1);
  }
  n37($context_GameState_t6qee5) {
    return RevertForAddObjectChange_getInstance();
  }
  toString() {
    return 'AddObjectChange(objectType=' + toString(this.w4t_1) + ', position=' + BoardPosition__toString_impl_v4mn82(this.x4t_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.w4t_1);
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.x4t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AddObjectChange))
      return false;
    if (!equals(this.w4t_1, other.w4t_1))
      return false;
    if (!(this.x4t_1 === other.x4t_1))
      return false;
    return true;
  }
  static y4t(seen0, objectType, position, serializationConstructorMarker) {
    Companion_getInstance_276();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_230().u4t_1);
    }
    var $this = createThis(this);
    $this.w4t_1 = objectType;
    $this.x4t_1 = position;
    return $this;
  }
}
class AddNewCharacterToOrderChange {
  constructor() {
    AddNewCharacterToOrderChange_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z4t_1 = lazy(tmp_0, AddNewCharacterToOrderChange$_anonymous__sr8rzy);
  }
  m37(_this__u8e3s4) {
    var tmp = _this__u8e3s4.l4l();
    var characterObject = tmp instanceof ObjectOnBoard ? tmp : THROW_CCE();
    _this__u8e3s4.i38_1 = plus_1(_this__u8e3s4.i38_1, characterObject);
    set_handImpl(_this__u8e3s4, characterObject, get_objectType(_this__u8e3s4, characterObject).s36());
  }
  n37($context_GameState_t6qee5) {
    return RevertForAddNewCharacterToOrderChange_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_273(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AddNewCharacterToOrderChange';
  }
  hashCode() {
    return -681261090;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AddNewCharacterToOrderChange))
      return false;
    return true;
  }
}
class Companion_276 {
  constructor() {
    Companion_instance_276 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a4u_1 = [lazy(tmp_0, HpChange$Companion$$childSerializers$_anonymous__ytsazy), null];
  }
}
class $serializer_232 {
  constructor() {
    $serializer_instance_231 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HpChange', this, 2);
    tmp0_serialDesc.h1b('holder', false);
    tmp0_serialDesc.h1b('hpChange', false);
    this.b4u_1 = tmp0_serialDesc;
  }
  c4u(encoder, value) {
    var tmp0_desc = this.b4u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_277().a4u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d4u_1);
    tmp1_output.z14(tmp0_desc, 1, value.e4u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c4u(encoder, value instanceof HpChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b4u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_277().a4u_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return HpChange.f4u(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.b4u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_277().a4u_1[0].k3(), IntSerializer_getInstance()];
  }
}
class HpChange {
  constructor(holder, hpChange) {
    Companion_getInstance_277();
    this.d4u_1 = holder;
    this.e4u_1 = hpChange;
  }
  m37(_this__u8e3s4) {
    var _receiver__tnumb7 = this.d4u_1;
    set_woundsImpl(_this__u8e3s4, _receiver__tnumb7, get_woundsImpl(_this__u8e3s4, _receiver__tnumb7) - this.e4u_1 | 0);
  }
  n37($context_GameState_t6qee5) {
    return new HpChange(this.d4u_1, -this.e4u_1 | 0);
  }
  toString() {
    return 'HpChange(holder=' + this.d4u_1.toString() + ', hpChange=' + this.e4u_1 + ')';
  }
  hashCode() {
    var result = this.d4u_1.hashCode();
    result = imul(result, 31) + this.e4u_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HpChange))
      return false;
    if (!this.d4u_1.equals(other.d4u_1))
      return false;
    if (!(this.e4u_1 === other.e4u_1))
      return false;
    return true;
  }
  static f4u(seen0, holder, hpChange, serializationConstructorMarker) {
    Companion_getInstance_277();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_231().b4u_1);
    }
    var $this = createThis(this);
    $this.d4u_1 = holder;
    $this.e4u_1 = hpChange;
    return $this;
  }
}
class Companion_277 {}
class $serializer_233 {
  constructor() {
    $serializer_instance_232 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DamageDealtToBeastsChange', this, 1);
    tmp0_serialDesc.h1b('damage', false);
    this.g4u_1 = tmp0_serialDesc;
  }
  h4u(encoder, value) {
    var tmp0_desc = this.g4u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.i4u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h4u(encoder, value instanceof DamageDealtToBeastsChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g4u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DamageDealtToBeastsChange.j4u(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g4u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class DamageDealtToBeastsChange {
  constructor(damage) {
    this.i4u_1 = damage;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.g39_1 = _this__u8e3s4.g39_1 + this.i4u_1 | 0;
  }
  n37($context_GameState_t6qee5) {
    return new DamageDealtToBeastsChange(-this.i4u_1 | 0);
  }
  toString() {
    return 'DamageDealtToBeastsChange(damage=' + this.i4u_1 + ')';
  }
  hashCode() {
    return this.i4u_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DamageDealtToBeastsChange))
      return false;
    if (!(this.i4u_1 === other.i4u_1))
      return false;
    return true;
  }
  static j4u(seen0, damage, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_232().g4u_1);
    }
    var $this = createThis(this);
    $this.i4u_1 = damage;
    return $this;
  }
}
class Companion_278 {
  constructor() {
    Companion_instance_278 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k4u_1 = [lazy(tmp_0, FirstPassPlayerChange$Companion$$childSerializers$_anonymous__v2dqm0)];
  }
}
class $serializer_234 {
  constructor() {
    $serializer_instance_233 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FirstPassPlayerChange', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.l4u_1 = tmp0_serialDesc;
  }
  m4u(encoder, value) {
    var tmp0_desc = this.l4u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_279().k4u_1;
    tmp1_output.i15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n4u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m4u(encoder, value instanceof FirstPassPlayerChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l4u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_279().k4u_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return FirstPassPlayerChange.o4u(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l4u_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_279().k4u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0].k3())];
  }
}
class FirstPassPlayerChange {
  constructor(characterObject) {
    Companion_getInstance_279();
    this.n4u_1 = characterObject;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.b39_1 = this.n4u_1;
  }
  n37($context_GameState_t6qee5) {
    return new FirstPassPlayerChange(get_firstCharacterPassed($context_GameState_t6qee5));
  }
  toString() {
    return 'FirstPassPlayerChange(characterObject=' + toString_0(this.n4u_1) + ')';
  }
  hashCode() {
    return this.n4u_1 == null ? 0 : this.n4u_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FirstPassPlayerChange))
      return false;
    if (!equals(this.n4u_1, other.n4u_1))
      return false;
    return true;
  }
  static o4u(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_279();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_233().l4u_1);
    }
    var $this = createThis(this);
    $this.n4u_1 = characterObject;
    return $this;
  }
}
class Companion_279 {
  constructor() {
    Companion_instance_279 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, DestroyedChange$Companion$$childSerializers$_anonymous__nkgbb5);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, DestroyedChange$Companion$$childSerializers$_anonymous__nkgbb5_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p4u_1 = [tmp_1, null, tmp_3, lazy(tmp_4, DestroyedChange$Companion$$childSerializers$_anonymous__nkgbb5_1)];
  }
}
class $serializer_235 {
  constructor() {
    $serializer_instance_234 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DestroyedChange', this, 4);
    tmp0_serialDesc.h1b('destroyed', false);
    tmp0_serialDesc.h1b('gameTeam', false);
    tmp0_serialDesc.h1b('cause', false);
    tmp0_serialDesc.h1b('reason', true);
    this.q4u_1 = tmp0_serialDesc;
  }
  r4u(encoder, value) {
    var tmp0_desc = this.q4u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_280().p4u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s4u_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_183(), new GameTeam(value.t4u_1));
    tmp1_output.i15(tmp0_desc, 2, tmp2_cached[2].k3(), value.u4u_1);
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !value.v4u_1.equals(DestroyReason_DestroyByDamage_getInstance())) {
      tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.v4u_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r4u(encoder, value instanceof DestroyedChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q4u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_280().p4u_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp8_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.d14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp8_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.d14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return DestroyedChange.w4u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.q4u_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_280().p4u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), $serializer_getInstance_183(), get_nullable(tmp0_cached[2].k3()), tmp0_cached[3].k3()];
  }
}
class DestroyedChange {
  constructor(destroyed, gameTeam, cause, reason) {
    Companion_getInstance_280();
    reason = reason === VOID ? DestroyReason_DestroyByDamage_getInstance() : reason;
    this.s4u_1 = destroyed;
    this.t4u_1 = gameTeam;
    this.u4u_1 = cause;
    this.v4u_1 = reason;
  }
  m37(_this__u8e3s4) {
    var record = new DestroyRecord(this.s4u_1, this.t4u_1, this.u4u_1, _this__u8e3s4.e38_1, this.v4u_1);
    var nextDestroyIndex = _this__u8e3s4.a39_1.s2();
    _this__u8e3s4.a39_1 = plus_1(_this__u8e3s4.a39_1, record);
    set_destroyRecordIndexImpl(_this__u8e3s4, this.s4u_1, nextDestroyIndex);
  }
  n37($context_GameState_t6qee5) {
    return RevertForDestroyedChange_getInstance();
  }
  toString() {
    return 'DestroyedChange(destroyed=' + this.s4u_1.toString() + ', gameTeam=' + GameTeam__toString_impl_wfw0a6(this.t4u_1) + ', cause=' + toString_0(this.u4u_1) + ', reason=' + this.v4u_1.toString() + ')';
  }
  hashCode() {
    var result = this.s4u_1.hashCode();
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.t4u_1) | 0;
    result = imul(result, 31) + (this.u4u_1 == null ? 0 : this.u4u_1.hashCode()) | 0;
    result = imul(result, 31) + this.v4u_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DestroyedChange))
      return false;
    if (!this.s4u_1.equals(other.s4u_1))
      return false;
    if (!(this.t4u_1 === other.t4u_1))
      return false;
    if (!equals(this.u4u_1, other.u4u_1))
      return false;
    if (!this.v4u_1.equals(other.v4u_1))
      return false;
    return true;
  }
  static w4u(seen0, destroyed, gameTeam, cause, reason, serializationConstructorMarker) {
    Companion_getInstance_280();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_234().q4u_1);
    }
    var $this = createThis(this);
    $this.s4u_1 = destroyed;
    $this.t4u_1 = gameTeam;
    $this.u4u_1 = cause;
    if (0 === (seen0 & 8))
      $this.v4u_1 = DestroyReason_DestroyByDamage_getInstance();
    else
      $this.v4u_1 = reason;
    return $this;
  }
}
class Companion_280 {
  constructor() {
    Companion_instance_280 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, CardsMoveChange$Companion$$childSerializers$_anonymous__bojyuy);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, CardsMoveChange$Companion$$childSerializers$_anonymous__bojyuy_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x4u_1 = [tmp_1, tmp_3, lazy(tmp_4, CardsMoveChange$Companion$$childSerializers$_anonymous__bojyuy_1), null];
  }
}
class $serializer_236 {
  constructor() {
    $serializer_instance_235 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CardsMoveChange', this, 4);
    tmp0_serialDesc.h1b('from', false);
    tmp0_serialDesc.h1b('to', false);
    tmp0_serialDesc.h1b('cards', false);
    tmp0_serialDesc.h1b('cardsInPlayPosition', true);
    this.y4u_1 = tmp0_serialDesc;
  }
  z4u(encoder, value) {
    var tmp0_desc = this.y4u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_281().x4u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a4v_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.b4v_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.c4v_1);
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 3)) {
      tmp = true;
    } else {
      var tmp_0 = value.d4v_1;
      tmp = !((tmp_0 == null ? null : new BoardPosition(tmp_0)) == null);
    }
    if (tmp) {
      var tmp_1 = $serializer_getInstance_100();
      var tmp_2 = value.d4v_1;
      tmp1_output.i15(tmp0_desc, 3, tmp_1, tmp_2 == null ? null : new BoardPosition(tmp_2));
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z4u(encoder, value instanceof CardsMoveChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y4u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_281().x4u_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp7_local3;
      var tmp_1 = tmp8_input.d14(tmp0_desc, 3, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp7_local3 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp7_local3;
            var tmp_4 = tmp8_input.d14(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp7_local3 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return CardsMoveChange.e4v(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.y4u_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_281().x4u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), get_nullable($serializer_getInstance_100())];
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.f4v_1 = function_0;
  }
  pj(a, b) {
    return this.f4v_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.f4v_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class CardsMoveChange {
  constructor(from, to, cards, cardsInPlayPosition) {
    Companion_getInstance_281();
    cardsInPlayPosition = cardsInPlayPosition === VOID ? null : cardsInPlayPosition;
    this.a4v_1 = from;
    this.b4v_1 = to;
    this.c4v_1 = cards;
    this.d4v_1 = cardsInPlayPosition;
  }
  m37(_this__u8e3s4) {
    var _iterator__ex2g4s = this.c4v_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var card = _iterator__ex2g4s.r1();
      this.g4v(_this__u8e3s4, card, this.b4v_1, CollectionOperation_Add_getInstance());
      this.g4v(_this__u8e3s4, card, this.a4v_1, CollectionOperation_Remove_getInstance());
    }
  }
  g4v(_this__u8e3s4, card, place, operation) {
    if (place instanceof TrapZonePlace) {
      var trapsInZone = ensureNotNull(_this__u8e3s4.v38_1.w4(place.n4p_1));
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = _this__u8e3s4.w38_1;
      // Inline function 'kotlin.require' call
      if (!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u4(card)) {
        var message = 'No information about trap ' + toString(card) + ' in zone ' + place.n4p_1.toString();
        throw IllegalArgumentException.h2(toString(message));
      }
      var tmp = _this__u8e3s4;
      var tmp_0 = _this__u8e3s4.v38_1;
      tmp.v38_1 = plus_3(tmp_0, to(place.n4p_1, withAddOrRemove(trapsInZone, isInterface(card, TrapCard) ? card : THROW_CCE(), operation)));
    } else {
      if (equals(place, DiscardPlace_getInstance())) {
        if (isInterface(card, DraftActionCard))
          _this__u8e3s4.n38_1 = withAddOrRemove(_this__u8e3s4.n38_1, card, operation);
        else {
          if (isInterface(card, HunterItemCard))
            _this__u8e3s4.z37_1 = _this__u8e3s4.z37_1.k4n(VOID, VOID, withAddOrRemove_0(_this__u8e3s4.z37_1.e4n_1, card, operation));
          else {
            if (isInterface(card, BeastlyTalentCard))
              _this__u8e3s4.a38_1 = _this__u8e3s4.a38_1.q4n(VOID, VOID, withAddOrRemove_0(_this__u8e3s4.a38_1.v2y_1, card, operation));
            else {
              if (isInterface(card, AshRuinCard))
                _this__u8e3s4.b38_1 = _this__u8e3s4.b38_1.a4o(VOID, VOID, withAddOrRemove_0(_this__u8e3s4.b38_1.w4n_1, card, operation));
              else {
                if (isInterface(card, AbilityCard)) {
                  changeDiscardedAbilityCards(_this__u8e3s4, characterObject(_this__u8e3s4, card.t37()), card, operation);
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
      } else {
        if (equals(place, UnusedDraftActionCardPlace_getInstance())) {
          // Inline function 'kotlin.require' call
          if (!isInterface(card, DraftActionCard)) {
            var message_0 = toString(card) + ' is not a draft action card';
            throw IllegalArgumentException.h2(toString(message_0));
          }
          _this__u8e3s4.o38_1 = withAddOrRemove(_this__u8e3s4.o38_1, card, operation);
        } else {
          var tmp_1;
          if (place instanceof DraftOfferPlace) {
            tmp_1 = true;
          } else {
            var tmp_2;
            if (place instanceof DraftPickedPlace) {
              tmp_2 = true;
            } else {
              tmp_2 = place instanceof DraftRemovedPlace;
            }
            tmp_1 = tmp_2;
          }
          if (tmp_1) {
            // Inline function 'kotlin.require' call
            if (!isInterface(card, DraftActionCard)) {
              var message_1 = toString(card) + ' is not a draft action card';
              throw IllegalArgumentException.h2(toString(message_1));
            }
            var tmp2_elvis_lhs = _this__u8e3s4.p38_1;
            var tmp_3;
            if (tmp2_elvis_lhs == null) {
              // Inline function 'kotlin.error' call
              var message_2 = 'No active draft for ' + toString(card);
              throw IllegalStateException.o(toString(message_2));
            } else {
              tmp_3 = tmp2_elvis_lhs;
            }
            var current = tmp_3;
            var tmp_4;
            if (place instanceof DraftOfferPlace) {
              tmp_4 = place.q4o_1;
            } else {
              if (place instanceof DraftPickedPlace) {
                tmp_4 = place.v4o_1;
              } else {
                if (place instanceof DraftRemovedPlace) {
                  tmp_4 = place.a4p_1;
                } else {
                  // Inline function 'kotlin.error' call
                  var message_3 = 'Unexpected draft place ' + toString(place);
                  throw IllegalStateException.o(toString(message_3));
                }
              }
            }
            var owner = tmp_4;
            var index = _this__u8e3s4.i38_1.y2(owner);
            // Inline function 'kotlin.require' call
            if (!(index >= 0)) {
              var message_4 = 'No draft row for ' + owner.toString();
              throw IllegalArgumentException.h2(toString(message_4));
            }
            var tmp_5 = _this__u8e3s4;
            var tmp_6;
            if (place instanceof DraftOfferPlace) {
              // Inline function 'kotlin.collections.mapIndexed' call
              var this_1 = current.o4m_1;
              // Inline function 'kotlin.collections.mapIndexedTo' call
              var destination = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
              var index_0 = 0;
              var _iterator__ex2g4s = this_1.p1();
              while (_iterator__ex2g4s.q1()) {
                var item = _iterator__ex2g4s.r1();
                var _unary__edvuaz = index_0;
                index_0 = _unary__edvuaz + 1 | 0;
                var tmp$ret$13 = checkIndexOverflow(_unary__edvuaz) === index ? withAddOrRemove(item, card, operation) : item;
                destination.d2(tmp$ret$13);
              }
              tmp_6 = current.y4m(destination);
            } else {
              if (place instanceof DraftPickedPlace) {
                // Inline function 'kotlin.collections.mapIndexed' call
                var this_2 = current.p4m_1;
                // Inline function 'kotlin.collections.mapIndexedTo' call
                var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_2, 10));
                var index_1 = 0;
                var _iterator__ex2g4s_0 = this_2.p1();
                while (_iterator__ex2g4s_0.q1()) {
                  var item_0 = _iterator__ex2g4s_0.r1();
                  var _unary__edvuaz_0 = index_1;
                  index_1 = _unary__edvuaz_0 + 1 | 0;
                  var tmp$ret$16 = checkIndexOverflow(_unary__edvuaz_0) === index ? withAddOrRemove_0(item_0, card, operation) : item_0;
                  destination_0.d2(tmp$ret$16);
                }
                tmp_6 = current.y4m(VOID, destination_0);
              } else {
                if (place instanceof DraftRemovedPlace) {
                  // Inline function 'kotlin.collections.mapIndexed' call
                  var this_3 = current.q4m_1;
                  // Inline function 'kotlin.collections.mapIndexedTo' call
                  var destination_1 = ArrayList.n2(collectionSizeOrDefault(this_3, 10));
                  var index_2 = 0;
                  var _iterator__ex2g4s_1 = this_3.p1();
                  while (_iterator__ex2g4s_1.q1()) {
                    var item_1 = _iterator__ex2g4s_1.r1();
                    var _unary__edvuaz_1 = index_2;
                    index_2 = _unary__edvuaz_1 + 1 | 0;
                    var tmp$ret$19 = checkIndexOverflow(_unary__edvuaz_1) === index ? withAddOrRemove(item_1, card, operation) : item_1;
                    destination_1.d2(tmp$ret$19);
                  }
                  tmp_6 = current.y4m(VOID, VOID, destination_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message_5 = 'Unexpected draft place ' + toString(place);
                  throw IllegalStateException.o(toString(message_5));
                }
              }
            }
            tmp_5.p38_1 = tmp_6;
          } else {
            if (equals(place, PendingTriggerPlace_getInstance())) {
              _this__u8e3s4.k38_1 = withAddOrRemove(_this__u8e3s4.k38_1, card, operation);
            } else {
              if (place instanceof HandPlace) {
                changeHand(_this__u8e3s4, place.f4p_1, card, operation);
              } else {
                if (equals(place, InPlayPlace_getInstance())) {
                  var tmp_7 = _this__u8e3s4;
                  var tmp_8;
                  switch (operation.w1_1) {
                    case 0:
                      // Inline function 'kotlin.require' call

                      if (!!_this__u8e3s4.l38_1.u4(card)) {
                        var message_6 = 'Duplicating ' + toString(card) + ' in ' + toString(_this__u8e3s4.l38_1);
                        throw IllegalArgumentException.h2(toString(message_6));
                      }

                      var tmp_9 = _this__u8e3s4.l38_1;
                      var tmp_10 = this.d4v_1;
                      tmp_8 = plus_3(tmp_9, to(card, tmp_10 == null ? null : new BoardPosition(tmp_10)));
                      break;
                    case 1:
                      // Inline function 'kotlin.require' call

                      if (!_this__u8e3s4.l38_1.u4(card)) {
                        var message_7 = 'There was no element ' + toString(card) + ' in ' + toString(_this__u8e3s4.l38_1);
                        throw IllegalArgumentException.h2(toString(message_7));
                      }

                      tmp_8 = minus(_this__u8e3s4.l38_1, card);
                      break;
                    default:
                      noWhenBranchMatchedException();
                      break;
                  }
                  tmp_7.l38_1 = tmp_8;
                } else {
                  if (equals(place, RevealedArsenalPlace_getInstance())) {
                    if (isInterface(card, HunterItemCard))
                      _this__u8e3s4.z37_1 = _this__u8e3s4.z37_1.k4n(VOID, withAddOrRemove(_this__u8e3s4.z37_1.d4n_1, card, operation));
                    else {
                      if (isInterface(card, BeastlyTalentCard))
                        _this__u8e3s4.a38_1 = _this__u8e3s4.a38_1.q4n(VOID, withAddOrRemove(_this__u8e3s4.a38_1.u2y_1, card, operation));
                      else {
                        if (isInterface(card, AshRuinCard))
                          _this__u8e3s4.b38_1 = _this__u8e3s4.b38_1.a4o(VOID, withAddOrRemove(_this__u8e3s4.b38_1.v4n_1, card, operation));
                        else {
                          // Inline function 'kotlin.error' call
                          var message_8 = 'Cannot find arsenal for ' + toString(card);
                          throw IllegalStateException.o(toString(message_8));
                        }
                      }
                    }
                  } else {
                    if (place instanceof ComingArsenalPlace) {
                      if (isInterface(card, HunterItemCard))
                        _this__u8e3s4.z37_1 = _this__u8e3s4.z37_1.k4n(withAddOrRemove_0(_this__u8e3s4.z37_1.c4n_1, card, operation));
                      else {
                        if (isInterface(card, BeastlyTalentCard))
                          _this__u8e3s4.a38_1 = _this__u8e3s4.a38_1.q4n(withAddOrRemove_0(_this__u8e3s4.a38_1.t2y_1, card, operation));
                        else {
                          if (isInterface(card, AshRuinCard))
                            _this__u8e3s4.b38_1 = _this__u8e3s4.b38_1.a4o(withAddOrRemove_0(_this__u8e3s4.b38_1.u4n_1, card, operation));
                          else {
                            // Inline function 'kotlin.error' call
                            var message_9 = 'Cannot find arsenal for ' + toString(card);
                            throw IllegalStateException.o(toString(message_9));
                          }
                        }
                      }
                    } else {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  n37(gameState) {
    var tmp;
    if (get_useRandomPickOnArsenal(gameState)) {
      var tmp_0 = this.a4v_1;
      tmp = tmp_0 instanceof ComingArsenalPlace;
    } else {
      tmp = false;
    }
    if (tmp) {
      return new RevertForRandomArsenalCardsMoveChange(this.a4v_1, this.b4v_1, this.c4v_1, this.d4v_1, get_hunterItems(gameState).c4n_1, get_beastlyTalents(gameState).t2y_1, gameState.q4k().u4n_1);
    }
    var tmp_1;
    if (equals(this.a4v_1, RevealedArsenalPlace_getInstance())) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.c4v_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var item = _iterator__ex2g4s.r1();
        var tmp_2;
        if (isInterface(item, HunterItemCard)) {
          tmp_2 = to(indexOf(get_hunterItems(gameState).d4n_1, item), item);
        } else {
          if (isInterface(item, BeastlyTalentCard)) {
            tmp_2 = to(indexOf(get_beastlyTalents(gameState).u2y_1, item), item);
          } else {
            if (isInterface(item, AshRuinCard)) {
              tmp_2 = to(indexOf(gameState.q4k().v4n_1, item), item);
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Cannot find arsenal for ' + toString(item);
              throw IllegalStateException.o(toString(message));
            }
          }
        }
        var tmp$ret$2 = tmp_2;
        destination.d2(tmp$ret$2);
      }
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_3 = CardsMoveChange$revertChange$lambda;
      var tmp$ret$5 = new sam$kotlin_Comparator$0(tmp_3);
      // Inline function 'kotlin.collections.map' call
      var this_1 = sortedWith(destination, tmp$ret$5);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s_0 = this_1.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var item_0 = _iterator__ex2g4s_0.r1();
        var tmp$ret$8 = item_0.qm_1;
        destination_0.d2(tmp$ret$8);
      }
      tmp_1 = toLinkedSet(destination_0);
    } else {
      tmp_1 = this.c4v_1;
    }
    var adjustedCards = tmp_1;
    return new CardsMoveChange(this.b4v_1, this.a4v_1, adjustedCards, this.d4v_1);
  }
  toString() {
    var tmp = toString(this.a4v_1);
    var tmp_0 = toString(this.b4v_1);
    var tmp_1 = toString(this.c4v_1);
    var tmp_2 = this.d4v_1;
    return 'CardsMoveChange(from=' + tmp + ', to=' + tmp_0 + ', cards=' + tmp_1 + ', cardsInPlayPosition=' + toString_0(tmp_2 == null ? null : new BoardPosition(tmp_2)) + ')';
  }
  hashCode() {
    var result = hashCode(this.a4v_1);
    result = imul(result, 31) + hashCode(this.b4v_1) | 0;
    result = imul(result, 31) + hashCode(this.c4v_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.d4v_1;
    if ((tmp_1 == null ? null : new BoardPosition(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = BoardPosition__hashCode_impl_9dgqf7(this.d4v_1);
    }
    result = tmp + tmp_0 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardsMoveChange))
      return false;
    if (!equals(this.a4v_1, other.a4v_1))
      return false;
    if (!equals(this.b4v_1, other.b4v_1))
      return false;
    if (!equals(this.c4v_1, other.c4v_1))
      return false;
    var tmp = this.d4v_1;
    var tmp_0 = tmp == null ? null : new BoardPosition(tmp);
    var tmp_1 = other.d4v_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new BoardPosition(tmp_1)))
      return false;
    return true;
  }
  static e4v(seen0, from, to, cards, cardsInPlayPosition, serializationConstructorMarker) {
    Companion_getInstance_281();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_235().y4u_1);
    }
    var $this = createThis(this);
    $this.a4v_1 = from;
    $this.b4v_1 = to;
    $this.c4v_1 = cards;
    if (0 === (seen0 & 8))
      $this.d4v_1 = null;
    else
      $this.d4v_1 = cardsInPlayPosition;
    return $this;
  }
}
class Companion_281 {
  constructor() {
    Companion_instance_281 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h4v_1 = [lazy(tmp_0, GrudgesChange$Companion$$childSerializers$_anonymous__5sampt), null];
  }
}
class $serializer_237 {
  constructor() {
    $serializer_instance_236 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GrudgesChange', this, 2);
    tmp0_serialDesc.h1b('receiver', false);
    tmp0_serialDesc.h1b('grudgesChange', false);
    this.i4v_1 = tmp0_serialDesc;
  }
  j4v(encoder, value) {
    var tmp0_desc = this.i4v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_282().h4v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k4v_1);
    tmp1_output.z14(tmp0_desc, 1, value.l4v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j4v(encoder, value instanceof GrudgesChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i4v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_282().h4v_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GrudgesChange.m4v(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.i4v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_282().h4v_1[0].k3(), IntSerializer_getInstance()];
  }
}
class GrudgesChange {
  constructor(receiver, grudgesChange) {
    Companion_getInstance_282();
    this.k4v_1 = receiver;
    this.l4v_1 = grudgesChange;
  }
  m37(_this__u8e3s4) {
    var _receiver__tnumb7 = this.k4v_1;
    set_grudgesNumberImpl(_this__u8e3s4, _receiver__tnumb7, get_grudgesNumberImpl(_this__u8e3s4, _receiver__tnumb7) + this.l4v_1 | 0);
  }
  n37($context_GameState_t6qee5) {
    return new GrudgesChange(this.k4v_1, -this.l4v_1 | 0);
  }
  toString() {
    return 'GrudgesChange(receiver=' + this.k4v_1.toString() + ', grudgesChange=' + this.l4v_1 + ')';
  }
  hashCode() {
    var result = this.k4v_1.hashCode();
    result = imul(result, 31) + this.l4v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GrudgesChange))
      return false;
    if (!this.k4v_1.equals(other.k4v_1))
      return false;
    if (!(this.l4v_1 === other.l4v_1))
      return false;
    return true;
  }
  static m4v(seen0, receiver, grudgesChange, serializationConstructorMarker) {
    Companion_getInstance_282();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_236().i4v_1);
    }
    var $this = createThis(this);
    $this.k4v_1 = receiver;
    $this.l4v_1 = grudgesChange;
    return $this;
  }
}
class Companion_282 {
  constructor() {
    Companion_instance_282 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, MovementChange$Companion$$childSerializers$_anonymous__yjbxud);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n4v_1 = [tmp_1, lazy(tmp_2, MovementChange$Companion$$childSerializers$_anonymous__yjbxud_0), null];
  }
}
class $serializer_238 {
  constructor() {
    $serializer_instance_237 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MovementChange', this, 3);
    tmp0_serialDesc.h1b('movedObject', false);
    tmp0_serialDesc.h1b('path', false);
    tmp0_serialDesc.h1b('isOpenMovement', false);
    this.o4v_1 = tmp0_serialDesc;
  }
  p4v(encoder, value) {
    var tmp0_desc = this.o4v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_283().n4v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q4v_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.r4v_1);
    tmp1_output.w14(tmp0_desc, 2, value.s4v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p4v(encoder, value instanceof MovementChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o4v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_283().n4v_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return MovementChange.t4v(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.o4v_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_283().n4v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), BooleanSerializer_getInstance()];
  }
}
class MovementChange {
  constructor(movedObject, path, isOpenMovement) {
    Companion_getInstance_283();
    this.q4v_1 = movedObject;
    this.r4v_1 = path;
    this.s4v_1 = isOpenMovement;
  }
  m37(_this__u8e3s4) {
    var newPosition = last(this.r4v_1).r2v_1;
    if (this.s4v_1) {
      var tmp2 = this.q4v_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp = get_objectType(_this__u8e3s4, tmp2);
        if (isInterface(tmp, BeastCharacter)) {
          tmp$ret$0 = tmp2 instanceof ObjectOnBoard ? tmp2 : THROW_CCE();
          break $l$block;
        }
        tmp$ret$0 = null;
      }
      var beast = tmp$ret$0;
      if (!(beast == null)) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!get_beastPath(_this__u8e3s4, beast).n1()) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException.h2(toString(message));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!get_beastMovements(_this__u8e3s4, beast).n1()) {
          var message_0 = 'Failed requirement.';
          throw IllegalArgumentException.h2(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!get_foundTrails(_this__u8e3s4, beast).n1()) {
          var message_1 = 'Failed requirement.';
          throw IllegalArgumentException.h2(toString(message_1));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!(get_lastSeenPosition(_this__u8e3s4, beast) === beast.s2w(_this__u8e3s4))) {
          var message_2 = 'Failed requirement.';
          throw IllegalArgumentException.h2(toString(message_2));
        }
        set_lastSeenPositionImpl(_this__u8e3s4, beast, newPosition);
      }
    }
    this.q4v_1.b4s(_this__u8e3s4, newPosition);
  }
  n37($context_GameState_t6qee5) {
    return new RevertForMovementChange(this, this.q4v_1.s2w($context_GameState_t6qee5));
  }
  toString() {
    return 'MovementChange(movedObject=' + this.q4v_1.toString() + ', path=' + toString(this.r4v_1) + ', isOpenMovement=' + this.s4v_1 + ')';
  }
  hashCode() {
    var result = this.q4v_1.hashCode();
    result = imul(result, 31) + hashCode(this.r4v_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s4v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MovementChange))
      return false;
    if (!this.q4v_1.equals(other.q4v_1))
      return false;
    if (!equals(this.r4v_1, other.r4v_1))
      return false;
    if (!(this.s4v_1 === other.s4v_1))
      return false;
    return true;
  }
  static t4v(seen0, movedObject, path, isOpenMovement, serializationConstructorMarker) {
    Companion_getInstance_283();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_237().o4v_1);
    }
    var $this = createThis(this);
    $this.q4v_1 = movedObject;
    $this.r4v_1 = path;
    $this.s4v_1 = isOpenMovement;
    return $this;
  }
}
class Companion_283 {
  constructor() {
    Companion_instance_283 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, BeastMovementInfoChange$Companion$$childSerializers$_anonymous__syf3oi);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u4v_1 = [tmp_1, lazy(tmp_2, BeastMovementInfoChange$Companion$$childSerializers$_anonymous__syf3oi_0), null, null];
  }
}
class $serializer_239 {
  constructor() {
    $serializer_instance_238 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeastMovementInfoChange', this, 4);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('path', false);
    tmp0_serialDesc.h1b('isRelocation', true);
    tmp0_serialDesc.h1b('movementCardsAdded', true);
    this.v4v_1 = tmp0_serialDesc;
  }
  w4v(encoder, value) {
    var tmp0_desc = this.v4v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_284().u4v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x4v_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.y4v_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.z4v_1 === false)) {
      tmp1_output.w14(tmp0_desc, 2, value.z4v_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.a4w_1 === (value.y4v_1.s2() - 1 | 0))) {
      tmp1_output.z14(tmp0_desc, 3, value.a4w_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w4v(encoder, value instanceof BeastMovementInfoChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v4v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_284().u4v_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return BeastMovementInfoChange.b4w(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.v4v_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_284().u4v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), BooleanSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class BeastMovementInfoChange {
  constructor(beast, path, isRelocation) {
    Companion_getInstance_284();
    isRelocation = isRelocation === VOID ? false : isRelocation;
    this.x4v_1 = beast;
    this.y4v_1 = path;
    this.z4v_1 = isRelocation;
    this.a4w_1 = this.y4v_1.s2() - 1 | 0;
  }
  m37(_this__u8e3s4) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var movements = ArrayList.p2();
    if (get_beastPath(_this__u8e3s4, this.x4v_1).n1()) {
      set_beastPathImpl(_this__u8e3s4, this.x4v_1, listOf(first(this.y4v_1)));
    }
    // Inline function 'kotlin.require' call
    if (!(last(get_beastPath(_this__u8e3s4, this.x4v_1)).c3g().v3g_1 === first(this.y4v_1).c3g().v3g_1)) {
      var message = 'Last beast path location is ' + last(get_beastPath(_this__u8e3s4, this.x4v_1)).toString() + ' but path starts from ' + first(this.y4v_1).toString();
      throw IllegalArgumentException.h2(toString(message));
    }
    var inductionVariable = 1;
    var last_0 = this.y4v_1.s2();
    if (inductionVariable < last_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var prevPosition = this.y4v_1.u2(i - 1 | 0).c3g();
        var next = this.y4v_1.u2(i);
        var nextPosition = next.c3g();
        // Inline function 'kotlin.collections.map' call
        var this_0 = next.x3f_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp;
          if (this.z4v_1 || item.w3g_1.equals(MovementType_AbyssalSwampRelocation_getInstance())) {
            tmp = new RelocationStep(item.v3g_1);
          } else if (prevPosition.v3g_1 === item.v3g_1) {
            tmp = NoMovement_getInstance();
          } else {
            var tmp0_elvis_lhs = direction(_this__u8e3s4, prevPosition.v3g_1, item.v3g_1);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.error' call
              var message_0 = 'No direction for ' + prevPosition.toString() + ' -> ' + nextPosition.toString();
              throw IllegalStateException.o(toString(message_0));
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp = tmp_0;
          }
          var tmp$ret$5 = tmp;
          destination.d2(tmp$ret$5);
        }
        var stepMovements = destination;
        movements.d2(new MovementAndState(stepMovements));
        if (!equals(stepMovements.u2(0), NoMovement_getInstance())) {
          var _receiver__tnumb7 = this.x4v_1;
          set_beastPathImpl(_this__u8e3s4, _receiver__tnumb7, plus_1(get_beastPathImpl(_this__u8e3s4, _receiver__tnumb7), next));
        } else if (next.x3f_1.s2() > 1) {
          var lastStep = last(get_beastPath(_this__u8e3s4, this.x4v_1));
          var tmp_1 = dropLast(get_beastPath(_this__u8e3s4, this.x4v_1), 1);
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = next.x3f_1;
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList.p2();
          var _iterator__ex2g4s_0 = tmp0.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var element = _iterator__ex2g4s_0.r1();
            if (!element.equals(nextPosition)) {
              destination_0.d2(element);
            }
          }
          set_beastPathImpl(_this__u8e3s4, this.x4v_1, plus_1(tmp_1, lastStep.e3g(plus_2(lastStep.x3f_1, destination_0))));
        }
      }
       while (inductionVariable < last_0);
    var _receiver__tnumb7_0 = this.x4v_1;
    set_beastMovementsImpl(_this__u8e3s4, _receiver__tnumb7_0, plus_2(get_beastMovementsImpl(_this__u8e3s4, _receiver__tnumb7_0), movements));
  }
  n37($context_GameState_t6qee5) {
    return new RevertForBeastMovementInfoChange(this, get_beastPath($context_GameState_t6qee5, this.x4v_1), get_beastMovements($context_GameState_t6qee5, this.x4v_1));
  }
  toString() {
    return 'BeastMovementInfoChange(beast=' + this.x4v_1.toString() + ', path=' + toString(this.y4v_1) + ', isRelocation=' + this.z4v_1 + ')';
  }
  hashCode() {
    var result = this.x4v_1.hashCode();
    result = imul(result, 31) + hashCode(this.y4v_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z4v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastMovementInfoChange))
      return false;
    if (!this.x4v_1.equals(other.x4v_1))
      return false;
    if (!equals(this.y4v_1, other.y4v_1))
      return false;
    if (!(this.z4v_1 === other.z4v_1))
      return false;
    return true;
  }
  static b4w(seen0, beast, path, isRelocation, movementCardsAdded, serializationConstructorMarker) {
    Companion_getInstance_284();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_238().v4v_1);
    }
    var $this = createThis(this);
    $this.x4v_1 = beast;
    $this.y4v_1 = path;
    if (0 === (seen0 & 4))
      $this.z4v_1 = false;
    else
      $this.z4v_1 = isRelocation;
    if (0 === (seen0 & 8))
      $this.a4w_1 = $this.y4v_1.s2() - 1 | 0;
    else
      $this.a4w_1 = movementCardsAdded;
    return $this;
  }
}
class Companion_284 {
  constructor() {
    Companion_instance_284 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RemoveUpgradeChange$Companion$$childSerializers$_anonymous__b7r332);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c4w_1 = [tmp_1, lazy(tmp_2, RemoveUpgradeChange$Companion$$childSerializers$_anonymous__b7r332_0)];
  }
}
class $serializer_240 {
  constructor() {
    $serializer_instance_239 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RemoveUpgradeChange', this, 2);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('upgrade', false);
    this.d4w_1 = tmp0_serialDesc;
  }
  e4w(encoder, value) {
    var tmp0_desc = this.d4w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_285().c4w_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f4w_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.g4w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e4w(encoder, value instanceof RemoveUpgradeChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d4w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_285().c4w_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RemoveUpgradeChange.h4w(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d4w_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_285().c4w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class RemoveUpgradeChange {
  constructor(actor, upgrade) {
    Companion_getInstance_285();
    this.f4w_1 = actor;
    this.g4w_1 = upgrade;
  }
  m37(_this__u8e3s4) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!get_objectType(_this__u8e3s4, this.f4w_1).t35().w2(this.g4w_1)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!_this__u8e3s4.r38_1.w2(this.g4w_1)) {
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message_0));
    }
    _this__u8e3s4.r38_1 = minus_0(_this__u8e3s4.r38_1, this.g4w_1);
  }
  n37($context_GameState_t6qee5) {
    return new UpgradeChange(this.f4w_1, this.g4w_1);
  }
  toString() {
    return 'RemoveUpgradeChange(actor=' + this.f4w_1.toString() + ', upgrade=' + toString(this.g4w_1) + ')';
  }
  hashCode() {
    var result = this.f4w_1.hashCode();
    result = imul(result, 31) + hashCode(this.g4w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoveUpgradeChange))
      return false;
    if (!this.f4w_1.equals(other.f4w_1))
      return false;
    if (!equals(this.g4w_1, other.g4w_1))
      return false;
    return true;
  }
  static h4w(seen0, actor, upgrade, serializationConstructorMarker) {
    Companion_getInstance_285();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_239().d4w_1);
    }
    var $this = createThis(this);
    $this.f4w_1 = actor;
    $this.g4w_1 = upgrade;
    return $this;
  }
}
class Companion_285 {
  constructor() {
    Companion_instance_285 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i4w_1 = [lazy(tmp_0, ResurrectObjectChange$Companion$$childSerializers$_anonymous__riwyi)];
  }
}
class $serializer_241 {
  constructor() {
    $serializer_instance_240 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ResurrectObjectChange', this, 1);
    tmp0_serialDesc.h1b('holder', false);
    this.j4w_1 = tmp0_serialDesc;
  }
  k4w(encoder, value) {
    var tmp0_desc = this.j4w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_286().i4w_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l4w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k4w(encoder, value instanceof ResurrectObjectChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j4w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_286().i4w_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ResurrectObjectChange.m4w(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.j4w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_286().i4w_1[0].k3()];
  }
}
class ResurrectObjectChange {
  constructor(holder) {
    Companion_getInstance_286();
    this.l4w_1 = holder;
  }
  m37(_this__u8e3s4) {
    set_destroyRecordIndexImpl(_this__u8e3s4, this.l4w_1, -1);
  }
  n37($context_GameState_t6qee5) {
    return new RevertForResurrectObjectChange(this.l4w_1, get_destroyRecordIndex($context_GameState_t6qee5, this.l4w_1));
  }
  toString() {
    return 'ResurrectObjectChange(holder=' + this.l4w_1.toString() + ')';
  }
  hashCode() {
    return this.l4w_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResurrectObjectChange))
      return false;
    if (!this.l4w_1.equals(other.l4w_1))
      return false;
    return true;
  }
  static m4w(seen0, holder, serializationConstructorMarker) {
    Companion_getInstance_286();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_240().j4w_1);
    }
    var $this = createThis(this);
    $this.l4w_1 = holder;
    return $this;
  }
}
class Companion_286 {
  constructor() {
    Companion_instance_286 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n4w_1 = [lazy(tmp_0, ClearingAfterRevealChange$Companion$$childSerializers$_anonymous__6h6zy2)];
  }
}
class $serializer_242 {
  constructor() {
    $serializer_instance_241 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ClearingAfterRevealChange', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.o4w_1 = tmp0_serialDesc;
  }
  p4w(encoder, value) {
    var tmp0_desc = this.o4w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_287().n4w_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q4w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p4w(encoder, value instanceof ClearingAfterRevealChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o4w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_287().n4w_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ClearingAfterRevealChange.r4w(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.o4w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_287().n4w_1[0].k3()];
  }
}
class ClearingAfterRevealChange {
  constructor(beast) {
    Companion_getInstance_287();
    this.q4w_1 = beast;
  }
  m37(_this__u8e3s4) {
    set_lastSeenPositionImpl(_this__u8e3s4, this.q4w_1, this.q4w_1.s2w(_this__u8e3s4));
    set_beastPathImpl(_this__u8e3s4, this.q4w_1, emptyList());
    set_beastMovementsImpl(_this__u8e3s4, this.q4w_1, emptyList());
    set_foundTrailsImpl(_this__u8e3s4, this.q4w_1, emptyMap());
  }
  n37($context_GameState_t6qee5) {
    return new RevertAfterClearingAfterRevealChange(this.q4w_1, get_lastSeenPosition($context_GameState_t6qee5, this.q4w_1), get_beastPath($context_GameState_t6qee5, this.q4w_1), get_beastMovements($context_GameState_t6qee5, this.q4w_1), get_foundTrails($context_GameState_t6qee5, this.q4w_1));
  }
  toString() {
    return 'ClearingAfterRevealChange(beast=' + this.q4w_1.toString() + ')';
  }
  hashCode() {
    return this.q4w_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearingAfterRevealChange))
      return false;
    if (!this.q4w_1.equals(other.q4w_1))
      return false;
    return true;
  }
  static r4w(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_287();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_241().o4w_1);
    }
    var $this = createThis(this);
    $this.q4w_1 = beast;
    return $this;
  }
}
class Companion_287 {
  constructor() {
    Companion_instance_287 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RevealLastMovementsChange$Companion$$childSerializers$_anonymous__9j4cjr);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s4w_1 = [tmp_1, null, null, lazy(tmp_2, RevealLastMovementsChange$Companion$$childSerializers$_anonymous__9j4cjr_0)];
  }
}
class $serializer_243 {
  constructor() {
    $serializer_instance_242 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevealLastMovementsChange', this, 4);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('indexOfMovementCard', false);
    tmp0_serialDesc.h1b('shouldBeRevealed', false);
    tmp0_serialDesc.h1b('leadToType', false);
    this.t4w_1 = tmp0_serialDesc;
  }
  u4w(encoder, value) {
    var tmp0_desc = this.t4w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_288().s4w_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.v4w_1);
    tmp1_output.z14(tmp0_desc, 1, value.w4w_1);
    tmp1_output.w14(tmp0_desc, 2, value.x4w_1);
    tmp1_output.i15(tmp0_desc, 3, tmp2_cached[3].k3(), value.y4w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u4w(encoder, value instanceof RevealLastMovementsChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t4w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_288().s4w_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.d14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.d14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return RevealLastMovementsChange.z4w(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.t4w_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_288().s4w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[3].k3())];
  }
}
class RevealLastMovementsChange {
  constructor(beast, indexOfMovementCard, shouldBeRevealed, leadToType) {
    Companion_getInstance_288();
    this.v4w_1 = beast;
    this.w4w_1 = indexOfMovementCard;
    this.x4w_1 = shouldBeRevealed;
    this.y4w_1 = leadToType;
  }
  m37(_this__u8e3s4) {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = get_beastMovements(_this__u8e3s4, this.v4w_1);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var tmp;
      if (checkIndexOverflow(_unary__edvuaz) === this.w4w_1) {
        var tmp0_isOpen = this.x4w_1;
        var tmp1_leadToLocationType = this.y4w_1;
        tmp = item.p3g(VOID, tmp1_leadToLocationType, tmp0_isOpen);
      } else {
        tmp = item;
      }
      var tmp$ret$2 = tmp;
      destination.d2(tmp$ret$2);
    }
    set_beastMovementsImpl(_this__u8e3s4, this.v4w_1, destination);
  }
  n37($context_GameState_t6qee5) {
    var movementState = get_beastMovements($context_GameState_t6qee5, this.v4w_1).u2(this.w4w_1);
    return new RevealLastMovementsChange(this.v4w_1, this.w4w_1, movementState.k3g_1, movementState.j3g_1);
  }
  toString() {
    return 'RevealLastMovementsChange(beast=' + this.v4w_1.toString() + ', indexOfMovementCard=' + this.w4w_1 + ', shouldBeRevealed=' + this.x4w_1 + ', leadToType=' + toString_0(this.y4w_1) + ')';
  }
  hashCode() {
    var result = this.v4w_1.hashCode();
    result = imul(result, 31) + this.w4w_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x4w_1) | 0;
    result = imul(result, 31) + (this.y4w_1 == null ? 0 : this.y4w_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealLastMovementsChange))
      return false;
    if (!this.v4w_1.equals(other.v4w_1))
      return false;
    if (!(this.w4w_1 === other.w4w_1))
      return false;
    if (!(this.x4w_1 === other.x4w_1))
      return false;
    if (!equals(this.y4w_1, other.y4w_1))
      return false;
    return true;
  }
  static z4w(seen0, beast, indexOfMovementCard, shouldBeRevealed, leadToType, serializationConstructorMarker) {
    Companion_getInstance_288();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_242().t4w_1);
    }
    var $this = createThis(this);
    $this.v4w_1 = beast;
    $this.w4w_1 = indexOfMovementCard;
    $this.x4w_1 = shouldBeRevealed;
    $this.y4w_1 = leadToType;
    return $this;
  }
}
class Companion_288 {
  constructor() {
    Companion_instance_288 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a4x_1 = [lazy(tmp_0, TransformLocationsChange$Companion$$childSerializers$_anonymous__y4dqbc)];
  }
}
class $serializer_244 {
  constructor() {
    $serializer_instance_243 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TransformLocationsChange', this, 1);
    tmp0_serialDesc.h1b('positions', false);
    this.b4x_1 = tmp0_serialDesc;
  }
  c4x(encoder, value) {
    var tmp0_desc = this.b4x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_289().a4x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d4x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c4x(encoder, value instanceof TransformLocationsChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b4x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_289().a4x_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return TransformLocationsChange.e4x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b4x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_289().a4x_1[0].k3()];
  }
}
class TransformLocationsChange {
  constructor(positions) {
    Companion_getInstance_289();
    this.d4x_1 = positions;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.j38_1 = plus_4(_this__u8e3s4.j38_1, this.d4x_1);
  }
  n37($context_GameState_t6qee5) {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = this.d4x_1.x4();
    var result = LinkedHashMap.cd(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var it = element.r2v_1;
      var tmp$ret$2 = ensureNotNull(get_locationTypes($context_GameState_t6qee5).w4(new BoardPosition(it)));
      result.b5(element, tmp$ret$2);
    }
    return new TransformLocationsChange(result);
  }
  toString() {
    return 'TransformLocationsChange(positions=' + toString(this.d4x_1) + ')';
  }
  hashCode() {
    return hashCode(this.d4x_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TransformLocationsChange))
      return false;
    if (!equals(this.d4x_1, other.d4x_1))
      return false;
    return true;
  }
  static e4x(seen0, positions, serializationConstructorMarker) {
    Companion_getInstance_289();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_243().b4x_1);
    }
    var $this = createThis(this);
    $this.d4x_1 = positions;
    return $this;
  }
}
class Companion_289 {
  constructor() {
    Companion_instance_289 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, UpgradeChange$Companion$$childSerializers$_anonymous__nehif6);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f4x_1 = [tmp_1, lazy(tmp_2, UpgradeChange$Companion$$childSerializers$_anonymous__nehif6_0)];
  }
}
class $serializer_245 {
  constructor() {
    $serializer_instance_244 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UpgradeChange', this, 2);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('upgrade', false);
    this.g4x_1 = tmp0_serialDesc;
  }
  h4x(encoder, value) {
    var tmp0_desc = this.g4x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_290().f4x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i4x_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.j4x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h4x(encoder, value instanceof UpgradeChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g4x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_290().f4x_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return UpgradeChange.k4x(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.g4x_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_290().f4x_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class UpgradeChange {
  constructor(actor, upgrade) {
    Companion_getInstance_290();
    this.i4x_1 = actor;
    this.j4x_1 = upgrade;
  }
  m37(_this__u8e3s4) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!get_objectType(_this__u8e3s4, this.i4x_1).t35().w2(this.j4x_1)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message));
    }
    _this__u8e3s4.r38_1 = plus_0(_this__u8e3s4.r38_1, this.j4x_1);
  }
  n37($context_GameState_t6qee5) {
    return new RemoveUpgradeChange(this.i4x_1, this.j4x_1);
  }
  toString() {
    return 'UpgradeChange(actor=' + this.i4x_1.toString() + ', upgrade=' + toString(this.j4x_1) + ')';
  }
  hashCode() {
    var result = this.i4x_1.hashCode();
    result = imul(result, 31) + hashCode(this.j4x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UpgradeChange))
      return false;
    if (!this.i4x_1.equals(other.i4x_1))
      return false;
    if (!equals(this.j4x_1, other.j4x_1))
      return false;
    return true;
  }
  static k4x(seen0, actor, upgrade, serializationConstructorMarker) {
    Companion_getInstance_290();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_244().g4x_1);
    }
    var $this = createThis(this);
    $this.i4x_1 = actor;
    $this.j4x_1 = upgrade;
    return $this;
  }
}
class Companion_290 {
  constructor() {
    Companion_instance_290 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RevertAfterClearingAfterRevealChange$Companion$$childSerializers$_anonymous__f8335q);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, RevertAfterClearingAfterRevealChange$Companion$$childSerializers$_anonymous__f8335q_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, RevertAfterClearingAfterRevealChange$Companion$$childSerializers$_anonymous__f8335q_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l4x_1 = [tmp_1, null, tmp_3, tmp_5, lazy(tmp_6, RevertAfterClearingAfterRevealChange$Companion$$childSerializers$_anonymous__f8335q_2)];
  }
}
class $serializer_246 {
  constructor() {
    $serializer_instance_245 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevertAfterClearingAfterRevealChange', this, 5);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('lastSeenPosition', false);
    tmp0_serialDesc.h1b('beastPath', false);
    tmp0_serialDesc.h1b('beastMovements', false);
    tmp0_serialDesc.h1b('foundTrails', false);
    this.m4x_1 = tmp0_serialDesc;
  }
  n4x(encoder, value) {
    var tmp0_desc = this.m4x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_291().l4x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o4x_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_100(), new BoardPosition(value.p4x_1));
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.q4x_1);
    tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.r4x_1);
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.s4x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n4x(encoder, value instanceof RevertAfterClearingAfterRevealChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m4x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_291().l4x_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp9_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, tmp10_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp9_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, tmp10_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return RevertAfterClearingAfterRevealChange.t4x(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.m4x_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_291().l4x_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), $serializer_getInstance_100(), tmp0_cached[2].k3(), tmp0_cached[3].k3(), tmp0_cached[4].k3()];
  }
}
class RevertAfterClearingAfterRevealChange {
  constructor(beast, lastSeenPosition, beastPath, beastMovements, foundTrails) {
    Companion_getInstance_291();
    this.o4x_1 = beast;
    this.p4x_1 = lastSeenPosition;
    this.q4x_1 = beastPath;
    this.r4x_1 = beastMovements;
    this.s4x_1 = foundTrails;
  }
  m37(_this__u8e3s4) {
    set_lastSeenPositionImpl(_this__u8e3s4, this.o4x_1, this.p4x_1);
    var _receiver__tnumb7 = this.o4x_1;
    set_beastPathImpl(_this__u8e3s4, _receiver__tnumb7, plus_2(get_beastPathImpl(_this__u8e3s4, _receiver__tnumb7), this.q4x_1));
    var _receiver__tnumb7_0 = this.o4x_1;
    set_beastMovementsImpl(_this__u8e3s4, _receiver__tnumb7_0, plus_2(get_beastMovementsImpl(_this__u8e3s4, _receiver__tnumb7_0), this.r4x_1));
    set_foundTrailsImpl(_this__u8e3s4, this.o4x_1, this.s4x_1);
  }
  n37($context_GameState_t6qee5) {
    return new ClearingAfterRevealChange(this.o4x_1);
  }
  toString() {
    return 'RevertAfterClearingAfterRevealChange(beast=' + this.o4x_1.toString() + ', lastSeenPosition=' + BoardPosition__toString_impl_v4mn82(this.p4x_1) + ', beastPath=' + toString(this.q4x_1) + ', beastMovements=' + toString(this.r4x_1) + ', foundTrails=' + toString(this.s4x_1) + ')';
  }
  hashCode() {
    var result = this.o4x_1.hashCode();
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.p4x_1) | 0;
    result = imul(result, 31) + hashCode(this.q4x_1) | 0;
    result = imul(result, 31) + hashCode(this.r4x_1) | 0;
    result = imul(result, 31) + hashCode(this.s4x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertAfterClearingAfterRevealChange))
      return false;
    if (!this.o4x_1.equals(other.o4x_1))
      return false;
    if (!(this.p4x_1 === other.p4x_1))
      return false;
    if (!equals(this.q4x_1, other.q4x_1))
      return false;
    if (!equals(this.r4x_1, other.r4x_1))
      return false;
    if (!equals(this.s4x_1, other.s4x_1))
      return false;
    return true;
  }
  static t4x(seen0, beast, lastSeenPosition, beastPath, beastMovements, foundTrails, serializationConstructorMarker) {
    Companion_getInstance_291();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_245().m4x_1);
    }
    var $this = createThis(this);
    $this.o4x_1 = beast;
    $this.p4x_1 = lastSeenPosition;
    $this.q4x_1 = beastPath;
    $this.r4x_1 = beastMovements;
    $this.s4x_1 = foundTrails;
    return $this;
  }
}
class RevertForAddNewCharacterToOrderChange {
  constructor() {
    RevertForAddNewCharacterToOrderChange_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u4x_1 = lazy(tmp_0, RevertForAddNewCharacterToOrderChange$_anonymous__j1ua93);
  }
  m37(_this__u8e3s4) {
    set_handImpl(_this__u8e3s4, last(_this__u8e3s4.i38_1), emptySet());
    _this__u8e3s4.i38_1 = dropLast(_this__u8e3s4.i38_1, 1);
  }
  n37($context_GameState_t6qee5) {
    return AddNewCharacterToOrderChange_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_274(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RevertForAddNewCharacterToOrderChange';
  }
  hashCode() {
    return -1126871591;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertForAddNewCharacterToOrderChange))
      return false;
    return true;
  }
}
class RevertForAddObjectChange {
  constructor() {
    RevertForAddObjectChange_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v4x_1 = lazy(tmp_0, RevertForAddObjectChange$_anonymous__iqivyk);
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.c4m();
  }
  n37($context_GameState_t6qee5) {
    // Inline function 'kotlin.let' call
    var it = get_lastAddedObject($context_GameState_t6qee5);
    return new AddObjectChange(get_objectType($context_GameState_t6qee5, it), it.s2w($context_GameState_t6qee5));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_275(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RevertForAddObjectChange';
  }
  hashCode() {
    return -1989372976;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertForAddObjectChange))
      return false;
    return true;
  }
}
class Companion_291 {
  constructor() {
    Companion_instance_291 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RevertForBeastMovementInfoChange$Companion$$childSerializers$_anonymous__w6pcil);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w4x_1 = [null, tmp_1, lazy(tmp_2, RevertForBeastMovementInfoChange$Companion$$childSerializers$_anonymous__w6pcil_0)];
  }
}
class $serializer_247 {
  constructor() {
    $serializer_instance_246 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevertForBeastMovementInfoChange', this, 3);
    tmp0_serialDesc.h1b('beastMovementInfoChange', false);
    tmp0_serialDesc.h1b('beastPathToRestore', false);
    tmp0_serialDesc.h1b('beastMovementsToRestore', false);
    this.x4x_1 = tmp0_serialDesc;
  }
  y4x(encoder, value) {
    var tmp0_desc = this.x4x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_292().w4x_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_238(), value.z4x_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.a4y_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.b4y_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y4x(encoder, value instanceof RevertForBeastMovementInfoChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x4x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_292().w4x_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, $serializer_getInstance_238(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, $serializer_getInstance_238(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return RevertForBeastMovementInfoChange.c4y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.x4x_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_292().w4x_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_238(), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class RevertForBeastMovementInfoChange {
  constructor(beastMovementInfoChange, beastPathToRestore, beastMovementsToRestore) {
    Companion_getInstance_292();
    this.z4x_1 = beastMovementInfoChange;
    this.a4y_1 = beastPathToRestore;
    this.b4y_1 = beastMovementsToRestore;
  }
  m37(_this__u8e3s4) {
    set_beastPathImpl(_this__u8e3s4, this.z4x_1.x4v_1, this.a4y_1);
    set_beastMovementsImpl(_this__u8e3s4, this.z4x_1.x4v_1, this.b4y_1);
  }
  n37($context_GameState_t6qee5) {
    return this.z4x_1;
  }
  toString() {
    return 'RevertForBeastMovementInfoChange(beastMovementInfoChange=' + this.z4x_1.toString() + ', beastPathToRestore=' + toString(this.a4y_1) + ', beastMovementsToRestore=' + toString(this.b4y_1) + ')';
  }
  hashCode() {
    var result = this.z4x_1.hashCode();
    result = imul(result, 31) + hashCode(this.a4y_1) | 0;
    result = imul(result, 31) + hashCode(this.b4y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertForBeastMovementInfoChange))
      return false;
    if (!this.z4x_1.equals(other.z4x_1))
      return false;
    if (!equals(this.a4y_1, other.a4y_1))
      return false;
    if (!equals(this.b4y_1, other.b4y_1))
      return false;
    return true;
  }
  static c4y(seen0, beastMovementInfoChange, beastPathToRestore, beastMovementsToRestore, serializationConstructorMarker) {
    Companion_getInstance_292();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_246().x4x_1);
    }
    var $this = createThis(this);
    $this.z4x_1 = beastMovementInfoChange;
    $this.a4y_1 = beastPathToRestore;
    $this.b4y_1 = beastMovementsToRestore;
    return $this;
  }
}
class RevertForDestroyedChange {
  constructor() {
    RevertForDestroyedChange_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d4y_1 = lazy(tmp_0, RevertForDestroyedChange$_anonymous__f3cwc3);
  }
  m37(_this__u8e3s4) {
    var destroyRecord = last(_this__u8e3s4.a39_1);
    _this__u8e3s4.a39_1 = dropLast(_this__u8e3s4.a39_1, 1);
    set_destroyRecordIndexImpl(_this__u8e3s4, destroyRecord.o3a_1, -1);
  }
  n37($context_GameState_t6qee5) {
    var destroyRecord = last(get_destroyRecords($context_GameState_t6qee5));
    return new DestroyedChange(destroyRecord.o3a_1, destroyRecord.p3a_1, destroyRecord.q3a_1, destroyRecord.s3a_1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_276(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RevertForDestroyedChange';
  }
  hashCode() {
    return -1180133399;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertForDestroyedChange))
      return false;
    return true;
  }
}
class Companion_292 {}
class $serializer_248 {
  constructor() {
    $serializer_instance_247 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevertForMovementChange', this, 2);
    tmp0_serialDesc.h1b('movementChange', false);
    tmp0_serialDesc.h1b('startingPosition', false);
    this.e4y_1 = tmp0_serialDesc;
  }
  f4y(encoder, value) {
    var tmp0_desc = this.e4y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_237(), value.g4y_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_100(), new BoardPosition(value.h4y_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f4y(encoder, value instanceof RevertForMovementChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e4y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_237(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_237(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RevertForMovementChange.i4y(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.e4y_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_237(), $serializer_getInstance_100()];
  }
}
class RevertForMovementChange {
  constructor(movementChange, startingPosition) {
    this.g4y_1 = movementChange;
    this.h4y_1 = startingPosition;
  }
  m37(_this__u8e3s4) {
    this.g4y_1.q4v_1.b4s(_this__u8e3s4, this.h4y_1);
    if (this.g4y_1.s4v_1) {
      var tmp2 = this.g4y_1.q4v_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp = get_objectType(_this__u8e3s4, tmp2);
        if (isInterface(tmp, BeastCharacter)) {
          tmp$ret$0 = tmp2 instanceof ObjectOnBoard ? tmp2 : THROW_CCE();
          break $l$block;
        }
        tmp$ret$0 = null;
      }
      var beast = tmp$ret$0;
      if (beast == null)
        null;
      else {
        set_lastSeenPositionImpl(_this__u8e3s4, beast, this.h4y_1);
      }
    }
  }
  n37($context_GameState_t6qee5) {
    return this.g4y_1;
  }
  toString() {
    return 'RevertForMovementChange(movementChange=' + this.g4y_1.toString() + ', startingPosition=' + BoardPosition__toString_impl_v4mn82(this.h4y_1) + ')';
  }
  hashCode() {
    var result = this.g4y_1.hashCode();
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.h4y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertForMovementChange))
      return false;
    if (!this.g4y_1.equals(other.g4y_1))
      return false;
    if (!(this.h4y_1 === other.h4y_1))
      return false;
    return true;
  }
  static i4y(seen0, movementChange, startingPosition, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_247().e4y_1);
    }
    var $this = createThis(this);
    $this.g4y_1 = movementChange;
    $this.h4y_1 = startingPosition;
    return $this;
  }
}
class Companion_293 {
  constructor() {
    Companion_instance_293 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_7 = lazy(tmp_6, RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_2);
    var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_9 = lazy(tmp_8, RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_3);
    var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j4y_1 = [tmp_1, tmp_3, tmp_5, null, tmp_7, tmp_9, lazy(tmp_10, RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_4)];
  }
}
class $serializer_249 {
  constructor() {
    $serializer_instance_248 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevertForRandomArsenalCardsMoveChange', this, 7);
    tmp0_serialDesc.h1b('originalFrom', false);
    tmp0_serialDesc.h1b('originalTo', false);
    tmp0_serialDesc.h1b('originalCards', false);
    tmp0_serialDesc.h1b('originalCardsInPlayPosition', false);
    tmp0_serialDesc.h1b('originalComingHunterItems', false);
    tmp0_serialDesc.h1b('originalComingBeastlyTalents', false);
    tmp0_serialDesc.h1b('originalComingAshRuins', false);
    this.k4y_1 = tmp0_serialDesc;
  }
  l4y(encoder, value) {
    var tmp0_desc = this.k4y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_294().j4y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.m4y_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.n4y_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.o4y_1);
    var tmp = $serializer_getInstance_100();
    var tmp_0 = value.p4y_1;
    tmp1_output.i15(tmp0_desc, 3, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.q4y_1);
    tmp1_output.g15(tmp0_desc, 5, tmp2_cached[5].k3(), value.r4y_1);
    tmp1_output.g15(tmp0_desc, 6, tmp2_cached[6].k3(), value.s4y_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l4y(encoder, value instanceof RevertForRandomArsenalCardsMoveChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k4y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.p13(tmp0_desc);
    var tmp12_cached = Companion_getInstance_294().j4y_1;
    if (tmp11_input.e14()) {
      tmp4_local0 = tmp11_input.b14(tmp0_desc, 0, tmp12_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.b14(tmp0_desc, 1, tmp12_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.b14(tmp0_desc, 2, tmp12_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp7_local3;
      var tmp_1 = tmp11_input.d14(tmp0_desc, 3, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp7_local3 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.b14(tmp0_desc, 4, tmp12_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.b14(tmp0_desc, 5, tmp12_cached[5].k3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.b14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.b14(tmp0_desc, 0, tmp12_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.b14(tmp0_desc, 1, tmp12_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.b14(tmp0_desc, 2, tmp12_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp7_local3;
            var tmp_4 = tmp11_input.d14(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp7_local3 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.b14(tmp0_desc, 4, tmp12_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.b14(tmp0_desc, 5, tmp12_cached[5].k3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.b14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp11_input.q13(tmp0_desc);
    return RevertForRandomArsenalCardsMoveChange.t4y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  dz() {
    return this.k4y_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_294().j4y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), get_nullable($serializer_getInstance_100()), tmp0_cached[4].k3(), tmp0_cached[5].k3(), tmp0_cached[6].k3()];
  }
}
class RevertForRandomArsenalCardsMoveChange {
  constructor(originalFrom, originalTo, originalCards, originalCardsInPlayPosition, originalComingHunterItems, originalComingBeastlyTalents, originalComingAshRuins) {
    Companion_getInstance_294();
    this.m4y_1 = originalFrom;
    this.n4y_1 = originalTo;
    this.o4y_1 = originalCards;
    this.p4y_1 = originalCardsInPlayPosition;
    this.q4y_1 = originalComingHunterItems;
    this.r4y_1 = originalComingBeastlyTalents;
    this.s4y_1 = originalComingAshRuins;
  }
  m37(_this__u8e3s4) {
    var from = this.n4y_1;
    var to = this.m4y_1;
    var neededChange = new CardsMoveChange(from, to, this.o4y_1, this.p4y_1);
    var _iterator__ex2g4s = this.o4y_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var card = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.with' call
      if (!(to instanceof ComingArsenalPlace)) {
        neededChange.g4v(_this__u8e3s4, card, to, CollectionOperation_Add_getInstance());
      }
      if (!(from instanceof ComingArsenalPlace)) {
        neededChange.g4v(_this__u8e3s4, card, from, CollectionOperation_Remove_getInstance());
      }
    }
    _this__u8e3s4.z37_1 = _this__u8e3s4.z37_1.k4n(this.q4y_1);
    _this__u8e3s4.a38_1 = _this__u8e3s4.a38_1.q4n(this.r4y_1);
    _this__u8e3s4.b38_1 = _this__u8e3s4.b38_1.a4o(this.s4y_1);
  }
  n37($context_GameState_t6qee5) {
    return new CardsMoveChange(this.m4y_1, this.n4y_1, this.o4y_1, this.p4y_1);
  }
  toString() {
    var tmp = toString(this.m4y_1);
    var tmp_0 = toString(this.n4y_1);
    var tmp_1 = toString(this.o4y_1);
    var tmp_2 = this.p4y_1;
    return 'RevertForRandomArsenalCardsMoveChange(originalFrom=' + tmp + ', originalTo=' + tmp_0 + ', originalCards=' + tmp_1 + ', originalCardsInPlayPosition=' + toString_0(tmp_2 == null ? null : new BoardPosition(tmp_2)) + ', originalComingHunterItems=' + toString(this.q4y_1) + ', originalComingBeastlyTalents=' + toString(this.r4y_1) + ', originalComingAshRuins=' + toString(this.s4y_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.m4y_1);
    result = imul(result, 31) + hashCode(this.n4y_1) | 0;
    result = imul(result, 31) + hashCode(this.o4y_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.p4y_1;
    if ((tmp_1 == null ? null : new BoardPosition(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = BoardPosition__hashCode_impl_9dgqf7(this.p4y_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + hashCode(this.q4y_1) | 0;
    result = imul(result, 31) + hashCode(this.r4y_1) | 0;
    result = imul(result, 31) + hashCode(this.s4y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertForRandomArsenalCardsMoveChange))
      return false;
    if (!equals(this.m4y_1, other.m4y_1))
      return false;
    if (!equals(this.n4y_1, other.n4y_1))
      return false;
    if (!equals(this.o4y_1, other.o4y_1))
      return false;
    var tmp = this.p4y_1;
    var tmp_0 = tmp == null ? null : new BoardPosition(tmp);
    var tmp_1 = other.p4y_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new BoardPosition(tmp_1)))
      return false;
    if (!equals(this.q4y_1, other.q4y_1))
      return false;
    if (!equals(this.r4y_1, other.r4y_1))
      return false;
    if (!equals(this.s4y_1, other.s4y_1))
      return false;
    return true;
  }
  static t4y(seen0, originalFrom, originalTo, originalCards, originalCardsInPlayPosition, originalComingHunterItems, originalComingBeastlyTalents, originalComingAshRuins, serializationConstructorMarker) {
    Companion_getInstance_294();
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_248().k4y_1);
    }
    var $this = createThis(this);
    $this.m4y_1 = originalFrom;
    $this.n4y_1 = originalTo;
    $this.o4y_1 = originalCards;
    $this.p4y_1 = originalCardsInPlayPosition;
    $this.q4y_1 = originalComingHunterItems;
    $this.r4y_1 = originalComingBeastlyTalents;
    $this.s4y_1 = originalComingAshRuins;
    return $this;
  }
}
class Companion_294 {
  constructor() {
    Companion_instance_294 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u4y_1 = [lazy(tmp_0, RevertForResurrectObjectChange$Companion$$childSerializers$_anonymous__65ndcv), null];
  }
}
class $serializer_250 {
  constructor() {
    $serializer_instance_249 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevertForResurrectObjectChange', this, 2);
    tmp0_serialDesc.h1b('holder', false);
    tmp0_serialDesc.h1b('destroyRecordIndex', false);
    this.v4y_1 = tmp0_serialDesc;
  }
  w4y(encoder, value) {
    var tmp0_desc = this.v4y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_295().u4y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x4y_1);
    tmp1_output.z14(tmp0_desc, 1, value.y4y_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w4y(encoder, value instanceof RevertForResurrectObjectChange ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v4y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_295().u4y_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RevertForResurrectObjectChange.z4y(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.v4y_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_295().u4y_1[0].k3(), IntSerializer_getInstance()];
  }
}
class RevertForResurrectObjectChange {
  constructor(holder, destroyRecordIndex) {
    Companion_getInstance_295();
    this.x4y_1 = holder;
    this.y4y_1 = destroyRecordIndex;
  }
  m37(_this__u8e3s4) {
    set_destroyRecordIndexImpl(_this__u8e3s4, this.x4y_1, this.y4y_1);
  }
  n37($context_GameState_t6qee5) {
    return new ResurrectObjectChange(this.x4y_1);
  }
  toString() {
    return 'RevertForResurrectObjectChange(holder=' + this.x4y_1.toString() + ', destroyRecordIndex=' + this.y4y_1 + ')';
  }
  hashCode() {
    var result = this.x4y_1.hashCode();
    result = imul(result, 31) + this.y4y_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertForResurrectObjectChange))
      return false;
    if (!this.x4y_1.equals(other.x4y_1))
      return false;
    if (!(this.y4y_1 === other.y4y_1))
      return false;
    return true;
  }
  static z4y(seen0, holder, destroyRecordIndex, serializationConstructorMarker) {
    Companion_getInstance_295();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_249().v4y_1);
    }
    var $this = createThis(this);
    $this.x4y_1 = holder;
    $this.y4y_1 = destroyRecordIndex;
    return $this;
  }
}
class Companion_295 {
  a2g() {
    var tmp = getKClass(GameStateEvent);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AddArmorEvent), getKClass(AddCharacterInOrderEvent), getKClass(AddFirePositionEvent), getKClass(ApplyDamageEvent), getKClass(CharacterPassed), getKClass(CheckForDestroyEvent), getKClass(DiscardAfterCharactersDeathEvent), getKClass(DiscardTrapsEvent), getKClass(DraftResultEvent), getKClass(DraugRespawnEvent), getKClass(EndOfGameEvent), getKClass(GainOpenArsenalCardEvent), getKClass(GainUnknownArsenalCardEvent), getKClass(GainDraugCorruptionEvent), getKClass(GainGrudgesEvent), getKClass(GainLydanHarvestEvent), getKClass(AddTrapInfoChange), getKClass(AncientPowersChangeEvent), getKClass(AshRuinPositionChangeEvent), getKClass(AshRuinReplacementChangeEvent), getKClass(ChargingUpgradeChangeEvent), getKClass(DamageBlockChange), getKClass(DraftStateEvent), getKClass(DrainedSoulsChangeEvent), getKClass(DraugCorruptionChangeEvent), getKClass(DuplicateCardEffectChangeEvent), getKClass(FirePositionsChange), getKClass(GameScopesChangeEvent), getKClass(KnownCardsInfoChangeEvent), getKClass(LydanHarvestChangeEvent), getKClass(OpenArsenalCardsToDealChangeNumberEvent), getKClass(RegentDominionChangeEvent), getKClass(RemoveTrapInfoChange), getKClass(RevertForKnownCardsInfoChangeEvent), getKClass(RhagnerHoardChangeEvent), getKClass(RuinClaimedChangeEvent), getKClass(SetBeastMovementInfoAndTrailsChange), getKClass(SetDayNumberAndTurnChange), getKClass(SetEyeHazeStatusChangeEvent), getKClass(SetSnareMetadataChangeEvent), getKClass(SigridPactChangeEvent), getKClass(SubmittedDamageChange), getKClass(AkkeronEternityTransformedPositionsChangeEvent), getKClass(ChangeBlueDraftActionCardWasPlayedStatusEvent), getKClass(ChangeFeatheredKingRebornStatusEvent), getKClass(ChangeFylgjaFlightWasUsedThisTurnEvent), getKClass(ChangeRedDraftActionCardWasPlayedStatusEvent), getKClass(ChangeSettlersMovedStatusEvent), getKClass(DraugRespawnStateChangeEvent), getKClass(MesmeriseChooseEvent), getKClass(ResonanceChooseEvent), getKClass(SetCurrentPhaseEvent), getKClass(SetPlayingCardNumberChangeEvent), getKClass(SigridCreatureLungedStatusEvent), getKClass(SkipNextTurnStatusChangeEvent), getKClass(TrailsRevealedChange), getKClass(TransformSimpleObjectChangeEvent), getKClass(UrgullMoltCounterChangeEvent), getKClass(ValdiBloodChangeEvent), getKClass(GameWarningEvent), getKClass(GeneralCardMoveEvent), getKClass(HealEvent), getKClass(InitGameStateEvent), getKClass(AssignDamageEvent), getKClass(CardWasResolvedEvent), getKClass(DamageResolvedEvent), getKClass(EndPhaseEvent), getKClass(GameQuestionIsComingEvent), getKClass(NothingEvent), getKClass(RewardAchieved), getKClass(SearchForBeastEvent), getKClass(SigridCreatureLungedEvent), getKClass(ModifySubmittedDamageEvent), getKClass(MoveCardToDiscardEvent), getKClass(MovementEvent), getKClass(NewSimpleObjectEvent), getKClass(ObjectRemoveForReplacingEvent), getKClass(PickCardsFromDeadCharacterEvent), getKClass(PrepareDraugRespawnEvent), getKClass(RecoveryTestEvent), getKClass(RecoveryTestFailingEvent), getKClass(RemoveFirePositionsEvent), getKClass(RemoveUpgradeEvent), getKClass(ReplayIsFinishedEvent), getKClass(ReplayNotificationEvent), getKClass(RestoreArsenalEvent), getKClass(RestoreStuffEvent), getKClass(RestoringHunterAfterDeathEvent), getKClass(RetrieveCardEvent), getKClass(RevealBeastEvent), getKClass(RevealLastMovementsEvent), getKClass(RevealLeadsToLocationTypeEvent), getKClass(RevealMovementCardEvent), getKClass(RevertLastBeastMovementEvent), getKClass(SetTrapEvent), getKClass(SpendGrudgesEvent), getKClass(StartPhaseEvent), getKClass(StartResolveCardEvent), getKClass(SubmitDamageBlockChangeEvent), getKClass(SubmitDamageEvent), getKClass(TrailsRevealedEvent), getKClass(TransformLocationsEvent), getKClass(UpgradeEvent)];
    var tmp_1 = $serializer_getInstance_250();
    var tmp_2 = $serializer_getInstance_251();
    var tmp_3 = $serializer_getInstance_252();
    var tmp_4 = $serializer_getInstance_253();
    var tmp_5 = $serializer_getInstance_254();
    var tmp_6 = $serializer_getInstance_255();
    var tmp_7 = $serializer_getInstance_256();
    var tmp_8 = $serializer_getInstance_257();
    var tmp_9 = $serializer_getInstance_258();
    var tmp_10 = DraugRespawnEvent_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_11 = ObjectSerializer.l1c('DraugRespawnEvent', tmp_10, tmp$ret$3);
    var tmp_12 = $serializer_getInstance_259();
    var tmp_13 = $serializer_getInstance_260();
    var tmp_14 = $serializer_getInstance_261();
    var tmp_15 = $serializer_getInstance_130();
    var tmp_16 = $serializer_getInstance_262();
    var tmp_17 = $serializer_getInstance_352();
    var tmp_18 = $serializer_getInstance_212();
    var tmp_19 = $serializer_getInstance_213();
    var tmp_20 = $serializer_getInstance_263();
    var tmp_21 = $serializer_getInstance_264();
    var tmp_22 = $serializer_getInstance_265();
    var tmp_23 = $serializer_getInstance_214();
    var tmp_24 = $serializer_getInstance_266();
    var tmp_25 = $serializer_getInstance_427();
    var tmp_26 = $serializer_getInstance_131();
    var tmp_27 = $serializer_getInstance_267();
    var tmp_28 = $serializer_getInstance_215();
    var tmp_29 = $serializer_getInstance_216();
    var tmp_30 = $serializer_getInstance_217();
    var tmp_31 = $serializer_getInstance_353();
    var tmp_32 = $serializer_getInstance_218();
    var tmp_33 = $serializer_getInstance_381();
    var tmp_34 = $serializer_getInstance_219();
    var tmp_35 = $serializer_getInstance_220();
    var tmp_36 = $serializer_getInstance_395();
    var tmp_37 = $serializer_getInstance_268();
    var tmp_38 = $serializer_getInstance_221();
    var tmp_39 = $serializer_getInstance_222();
    var tmp_40 = $serializer_getInstance_369();
    var tmp_41 = $serializer_getInstance_370();
    var tmp_42 = $serializer_getInstance_402();
    var tmp_43 = $serializer_getInstance_223();
    var tmp_44 = $serializer_getInstance_70();
    var tmp_45 = $serializer_getInstance_141();
    var tmp_46 = $serializer_getInstance_148();
    var tmp_47 = $serializer_getInstance_135();
    var tmp_48 = $serializer_getInstance_79();
    var tmp_49 = $serializer_getInstance_399();
    var tmp_50 = $serializer_getInstance_132();
    var tmp_51 = $serializer_getInstance_139();
    var tmp_52 = $serializer_getInstance_80();
    var tmp_53 = $serializer_getInstance_224();
    var tmp_54 = $serializer_getInstance_225();
    var tmp_55 = $serializer_getInstance_403();
    var tmp_56 = $serializer_getInstance_226();
    var tmp_57 = $serializer_getInstance_227();
    var tmp_58 = $serializer_getInstance_228();
    var tmp_59 = $serializer_getInstance_420();
    var tmp_60 = $serializer_getInstance_431();
    var tmp_61 = $serializer_getInstance_269();
    var tmp_62 = $serializer_getInstance_270();
    var tmp_63 = $serializer_getInstance_271();
    var tmp_64 = $serializer_getInstance_272();
    var tmp_65 = $serializer_getInstance_273();
    var tmp_66 = $serializer_getInstance_274();
    var tmp_67 = $serializer_getInstance_275();
    var tmp_68 = $serializer_getInstance_276();
    var tmp_69 = $serializer_getInstance_277();
    var tmp_70 = NothingEvent_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_71 = ObjectSerializer.l1c('NothingEvent', tmp_70, tmp$ret$6);
    var tmp_72 = $serializer_getInstance_278();
    var tmp_73 = $serializer_getInstance_279();
    var tmp_74 = SigridCreatureLungedEvent_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_75 = ObjectSerializer.l1c('SigridCreatureLungedEvent', tmp_74, tmp$ret$9);
    var tmp_76 = $serializer_getInstance_280();
    var tmp_77 = $serializer_getInstance_281();
    var tmp_78 = $serializer_getInstance_282();
    var tmp_79 = $serializer_getInstance_283();
    var tmp_80 = $serializer_getInstance_284();
    var tmp_81 = $serializer_getInstance_285();
    var tmp_82 = PrepareDraugRespawnEvent_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_83 = ObjectSerializer.l1c('PrepareDraugRespawnEvent', tmp_82, tmp$ret$12);
    var tmp_84 = $serializer_getInstance_377();
    var tmp_85 = RecoveryTestFailingEvent_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_86 = ObjectSerializer.l1c('RecoveryTestFailingEvent', tmp_85, tmp$ret$15);
    var tmp_87 = $serializer_getInstance_286();
    var tmp_88 = $serializer_getInstance_287();
    var tmp_89 = ReplayIsFinishedEvent_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_90 = ObjectSerializer.l1c('ReplayIsFinishedEvent', tmp_89, tmp$ret$18);
    var tmp_91 = $serializer_getInstance_288();
    var tmp_92 = RestoreArsenalEvent_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_93 = ObjectSerializer.l1c('RestoreArsenalEvent', tmp_92, tmp$ret$21);
    var tmp_94 = RestoreStuffEvent_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_95 = [tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, tmp_64, tmp_65, tmp_66, tmp_67, tmp_68, tmp_69, tmp_71, tmp_72, tmp_73, tmp_75, tmp_76, tmp_77, tmp_78, tmp_79, tmp_80, tmp_81, tmp_83, tmp_84, tmp_86, tmp_87, tmp_88, tmp_90, tmp_91, tmp_93, ObjectSerializer.l1c('RestoreStuffEvent', tmp_94, tmp$ret$24), $serializer_getInstance_289(), $serializer_getInstance_290(), $serializer_getInstance_291(), $serializer_getInstance_292(), $serializer_getInstance_293(), $serializer_getInstance_294(), $serializer_getInstance_295(), $serializer_getInstance_296(), $serializer_getInstance_297(), $serializer_getInstance_298(), $serializer_getInstance_299(), $serializer_getInstance_300(), $serializer_getInstance_301(), $serializer_getInstance_302(), $serializer_getInstance_303(), $serializer_getInstance_304()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    return SealedClassSerializer.i10('steelart.beast.GameStateEvent', tmp, tmp_0, tmp_95, tmp$ret$30);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class ResolvingKind {}
class PlayedRedCard {
  constructor() {
    PlayedRedCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a4z_1 = lazy(tmp_0, ResolvingKind$PlayedRedCard$_anonymous__f7irm8);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_277(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PlayedRedCard';
  }
  hashCode() {
    return -671603304;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayedRedCard))
      return false;
    return true;
  }
}
class PlayedBlueCard {
  constructor() {
    PlayedBlueCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b4z_1 = lazy(tmp_0, ResolvingKind$PlayedBlueCard$_anonymous__b9cpsj);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_278(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PlayedBlueCard';
  }
  hashCode() {
    return 974716691;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayedBlueCard))
      return false;
    return true;
  }
}
class BonusCard {
  constructor() {
    BonusCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c4z_1 = lazy(tmp_0, ResolvingKind$BonusCard$_anonymous__mcmfl);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_279(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BonusCard';
  }
  hashCode() {
    return -176340615;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BonusCard))
      return false;
    return true;
  }
}
class Reaction {
  constructor() {
    Reaction_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d4z_1 = lazy(tmp_0, ResolvingKind$Reaction$_anonymous__to5413);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_280(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Reaction';
  }
  hashCode() {
    return -1612405953;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Reaction))
      return false;
    return true;
  }
}
class Trap {
  constructor() {
    Trap_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e4z_1 = lazy(tmp_0, ResolvingKind$Trap$_anonymous__q4gvtv);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_281(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Trap';
  }
  hashCode() {
    return 52180803;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Trap))
      return false;
    return true;
  }
}
class Companion_296 {
  a2g() {
    var tmp = getKClass(ResolvingKind);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BonusCard), getKClass(PlayedBlueCard), getKClass(PlayedRedCard), getKClass(Reaction), getKClass(Trap)];
    var tmp_1 = BonusCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('BonusCard', tmp_1, tmp$ret$3);
    var tmp_3 = PlayedBlueCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('PlayedBlueCard', tmp_3, tmp$ret$6);
    var tmp_5 = PlayedRedCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('PlayedRedCard', tmp_5, tmp$ret$9);
    var tmp_7 = Reaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Reaction', tmp_7, tmp$ret$12);
    var tmp_9 = Trap_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_10 = [tmp_2, tmp_4, tmp_6, tmp_8, ObjectSerializer.l1c('Trap', tmp_9, tmp$ret$15)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    return SealedClassSerializer.i10('steelart.beast.ResolvingKind', tmp, tmp_0, tmp_10, tmp$ret$21);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_297 {
  constructor() {
    Companion_instance_297 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f4z_1 = [lazy(tmp_0, AddArmorEvent$Companion$$childSerializers$_anonymous__20emvi)];
  }
}
class $serializer_251 {
  constructor() {
    $serializer_instance_250 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AddArmorEvent', this, 1);
    tmp0_serialDesc.h1b('targets', false);
    this.g4z_1 = tmp0_serialDesc;
  }
  h4z(encoder, value) {
    var tmp0_desc = this.g4z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_298().f4z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i4z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h4z(encoder, value instanceof AddArmorEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g4z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_298().f4z_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AddArmorEvent.j4z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g4z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_298().f4z_1[0].k3()];
  }
}
class AddArmorEvent {
  constructor(targets) {
    Companion_getInstance_298();
    this.i4z_1 = targets;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.i4z_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = new ArmorChange(item, 1);
      destination.d2(tmp$ret$2);
    }
    return destination;
  }
  toString() {
    return 'AddArmorEvent(targets=' + toString(this.i4z_1) + ')';
  }
  hashCode() {
    return hashCode(this.i4z_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AddArmorEvent))
      return false;
    if (!equals(this.i4z_1, other.i4z_1))
      return false;
    return true;
  }
  static j4z(seen0, targets, serializationConstructorMarker) {
    Companion_getInstance_298();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_250().g4z_1);
    }
    var $this = createThis(this);
    $this.i4z_1 = targets;
    return $this;
  }
}
class Companion_298 {
  constructor() {
    Companion_instance_298 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k4z_1 = [lazy(tmp_0, AddCharacterInOrderEvent$Companion$$childSerializers$_anonymous__s0y07l), null];
  }
}
class $serializer_252 {
  constructor() {
    $serializer_instance_251 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AddCharacterInOrderEvent', this, 2);
    tmp0_serialDesc.h1b('pickedCharacter', false);
    tmp0_serialDesc.h1b('initialPosition', false);
    this.l4z_1 = tmp0_serialDesc;
  }
  m4z(encoder, value) {
    var tmp0_desc = this.l4z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_299().k4z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n4z_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_100(), new BoardPosition(value.o4z_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m4z(encoder, value instanceof AddCharacterInOrderEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l4z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_299().k4z_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return AddCharacterInOrderEvent.p4z(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.l4z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_299().k4z_1[0].k3(), $serializer_getInstance_100()];
  }
}
class AddCharacterInOrderEvent {
  constructor(pickedCharacter, initialPosition) {
    Companion_getInstance_299();
    this.n4z_1 = pickedCharacter;
    this.o4z_1 = initialPosition;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf_0([new AddObjectChange(this.n4z_1, this.o4z_1), AddNewCharacterToOrderChange_getInstance()]);
  }
  toString() {
    return 'AddCharacterInOrderEvent(pickedCharacter=' + toString(this.n4z_1) + ', initialPosition=' + BoardPosition__toString_impl_v4mn82(this.o4z_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.n4z_1);
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.o4z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AddCharacterInOrderEvent))
      return false;
    if (!equals(this.n4z_1, other.n4z_1))
      return false;
    if (!(this.o4z_1 === other.o4z_1))
      return false;
    return true;
  }
  static p4z(seen0, pickedCharacter, initialPosition, serializationConstructorMarker) {
    Companion_getInstance_299();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_251().l4z_1);
    }
    var $this = createThis(this);
    $this.n4z_1 = pickedCharacter;
    $this.o4z_1 = initialPosition;
    return $this;
  }
}
class Companion_299 {
  constructor() {
    Companion_instance_299 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q4z_1 = [lazy(tmp_0, AddFirePositionEvent$Companion$$childSerializers$_anonymous__kjnhio)];
  }
}
class $serializer_253 {
  constructor() {
    $serializer_instance_252 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AddFirePositionEvent', this, 1);
    tmp0_serialDesc.h1b('positions', false);
    this.r4z_1 = tmp0_serialDesc;
  }
  s4z(encoder, value) {
    var tmp0_desc = this.r4z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_300().q4z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t4z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s4z(encoder, value instanceof AddFirePositionEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r4z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_300().q4z_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AddFirePositionEvent.u4z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r4z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_300().q4z_1[0].k3()];
  }
}
class AddFirePositionEvent {
  constructor(positions) {
    Companion_getInstance_300();
    this.t4z_1 = positions;
  }
  o37(gsCtx) {
    return listOf(new FirePositionsChange(plus(gsCtx.y4k(), this.t4z_1)));
  }
  toString() {
    return 'AddFirePositionEvent(positions=' + toString(this.t4z_1) + ')';
  }
  hashCode() {
    return hashCode(this.t4z_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AddFirePositionEvent))
      return false;
    if (!equals(this.t4z_1, other.t4z_1))
      return false;
    return true;
  }
  static u4z(seen0, positions, serializationConstructorMarker) {
    Companion_getInstance_300();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_252().r4z_1);
    }
    var $this = createThis(this);
    $this.t4z_1 = positions;
    return $this;
  }
}
class Companion_300 {}
class $serializer_254 {
  constructor() {
    $serializer_instance_253 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ApplyDamageEvent', this, 1);
    tmp0_serialDesc.h1b('hit', false);
    this.v4z_1 = tmp0_serialDesc;
  }
  w4z(encoder, value) {
    var tmp0_desc = this.v4z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_123(), value.x4z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w4z(encoder, value instanceof ApplyDamageEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v4z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ApplyDamageEvent.y4z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.v4z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_123()];
  }
}
class ApplyDamageEvent {
  constructor(hit) {
    this.x4z_1 = hit;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList.p2();
    var _iterator__ex2g4s = this.x4z_1.e3s_1.p1();
    $l$loop: while (_iterator__ex2g4s.q1()) {
      var damageToTarget = _iterator__ex2g4s.r1();
      var target = damageToTarget.r3s_1;
      var tmp;
      var tmp_0 = damageToTarget.t3s_1;
      if (!((tmp_0 == null ? null : new BoardPosition(tmp_0)) == null)) {
        var tmp_1 = damageToTarget.t3s_1;
        tmp = !equals(tmp_1 == null ? null : new BoardPosition(tmp_1), new BoardPosition(target.s2w($context_GameStateRuntime_604ce3)));
      } else {
        tmp = false;
      }
      if (tmp) {
        reportWarning($context_GameStateRuntime_604ce3, damageToTarget.toString() + ' was not filtered!');
        continue $l$loop;
      }
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_damageBlocked($context_GameStateRuntime_604ce3);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s_0 = tmp0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element = _iterator__ex2g4s_0.r1();
        if (element.l3s_1.equals(damageToTarget.r3s_1)) {
          destination.d2(element);
        }
      }
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var _iterator__ex2g4s_1 = destination.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_0 = _iterator__ex2g4s_1.r1();
        var tmp_2 = sum;
        sum = tmp_2 + element_0.m3s_1 | 0;
      }
      var blocked = sum;
      // Inline function 'kotlin.math.max' call
      var a = damageToTarget.s3s_1 - blocked | 0;
      var damage = Math.max(a, 0);
      if (damage > 0) {
        if (get_armor($context_GameStateRuntime_604ce3, target) > 0) {
          var tmp0_0 = damage;
          // Inline function 'kotlin.math.min' call
          var b = get_armor($context_GameStateRuntime_604ce3, target);
          var armorDamage = Math.min(tmp0_0, b);
          damage = damage - armorDamage | 0;
          // Inline function 'kotlin.collections.plusAssign' call
          var element_1 = new ArmorChange(target, -armorDamage | 0);
          result.d2(element_1);
        }
        if (!(damage === 0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          var element_2 = new HpChange(target, -damage | 0);
          result.d2(element_2);
          var tmp_3 = get_objectType($context_GameStateRuntime_604ce3, target);
          if (isInterface(tmp_3, BeastCharacter)) {
            // Inline function 'kotlin.collections.plusAssign' call
            var element_3 = new DamageDealtToBeastsChange(damage);
            result.d2(element_3);
          }
        }
      }
    }
    if (!(get_submittedCurrentDamage($context_GameStateRuntime_604ce3) == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_4 = new SubmittedDamageChange(null);
      result.d2(element_4);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!get_damageBlocked($context_GameStateRuntime_604ce3).n1()) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_5 = new DamageBlockChange(emptyList());
      result.d2(element_5);
    }
    return toList(result);
  }
  toString() {
    return 'ApplyDamageEvent(hit=' + this.x4z_1.toString() + ')';
  }
  hashCode() {
    return this.x4z_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ApplyDamageEvent))
      return false;
    if (!this.x4z_1.equals(other.x4z_1))
      return false;
    return true;
  }
  static y4z(seen0, hit, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_253().v4z_1);
    }
    var $this = createThis(this);
    $this.x4z_1 = hit;
    return $this;
  }
}
class Companion_301 {
  constructor() {
    Companion_instance_301 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z4z_1 = [lazy(tmp_0, CharacterPassed$Companion$$childSerializers$_anonymous__6bstip)];
  }
}
class $serializer_255 {
  constructor() {
    $serializer_instance_254 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CharacterPassed', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.a50_1 = tmp0_serialDesc;
  }
  b50(encoder, value) {
    var tmp0_desc = this.a50_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_302().z4z_1;
    tmp1_output.i15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c50_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b50(encoder, value instanceof CharacterPassed ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a50_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_302().z4z_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return CharacterPassed.d50(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a50_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_302().z4z_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0].k3())];
  }
}
class CharacterPassed {
  constructor(characterObject) {
    Companion_getInstance_302();
    this.c50_1 = characterObject;
  }
  o37($context_GameStateRuntime_604ce3) {
    var tmp;
    if (this.c50_1 == null && !(get_firstCharacterPassed($context_GameStateRuntime_604ce3) == null)) {
      tmp = listOf(new FirstPassPlayerChange(null));
    } else if (get_firstCharacterPassed($context_GameStateRuntime_604ce3) == null) {
      tmp = listOf(new FirstPassPlayerChange(this.c50_1));
    } else {
      tmp = emptyList();
    }
    return tmp;
  }
  toString() {
    return 'CharacterPassed(characterObject=' + toString_0(this.c50_1) + ')';
  }
  hashCode() {
    return this.c50_1 == null ? 0 : this.c50_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CharacterPassed))
      return false;
    if (!equals(this.c50_1, other.c50_1))
      return false;
    return true;
  }
  static d50(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_302();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_254().a50_1);
    }
    var $this = createThis(this);
    $this.c50_1 = characterObject;
    return $this;
  }
}
class Companion_302 {}
class $serializer_256 {
  constructor() {
    $serializer_instance_255 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CheckForDestroyEvent', this, 2);
    tmp0_serialDesc.h1b('causedTeam', false);
    tmp0_serialDesc.h1b('hit', false);
    this.e50_1 = tmp0_serialDesc;
  }
  f50(encoder, value) {
    var tmp0_desc = this.e50_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_183(), new GameTeam(value.g50_1));
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_123(), value.h50_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f50(encoder, value instanceof CheckForDestroyEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e50_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_123(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_123(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return CheckForDestroyEvent.i50(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.e50_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_183(), $serializer_getInstance_123()];
  }
}
class CheckForDestroyEvent {
  constructor(causedTeam, hit) {
    this.g50_1 = causedTeam;
    this.h50_1 = hit;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.h50_1.e3s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.r3s_1;
      destination.d2(tmp$ret$2);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = destination.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      if (get_hp($context_GameStateRuntime_604ce3, element) <= 0) {
        destination_0.d2(element);
      }
    }
    var candidates = toSet(destination_0);
    var tmp;
    if (get_isSharedBeastHpGame($context_GameStateRuntime_604ce3)) {
      // Inline function 'kotlin.collections.filterNot' call
      // Inline function 'kotlin.collections.filterNotTo' call
      var destination_1 = ArrayList.p2();
      var _iterator__ex2g4s_1 = candidates.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_0 = _iterator__ex2g4s_1.r1();
        var tmp_0 = get_objectType($context_GameStateRuntime_604ce3, element_0);
        if (!isInterface(tmp_0, BeastCharacter)) {
          destination_1.d2(element_0);
        }
      }
      var nonBeasts = toSet(destination_1);
      var tmp_1;
      if (get_sharedBeastHp_0($context_GameStateRuntime_604ce3) <= 0) {
        tmp_1 = plus(nonBeasts, get_aliveBeasts_0($context_GameStateRuntime_604ce3));
      } else {
        tmp_1 = nonBeasts;
      }
      tmp = tmp_1;
    } else {
      tmp = candidates;
    }
    var destroyed = tmp;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.n2(collectionSizeOrDefault(destroyed, 10));
    var _iterator__ex2g4s_2 = destroyed.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var item_0 = _iterator__ex2g4s_2.r1();
      var tmp$ret$11 = new DestroyedChange(item_0, this.g50_1, this.h50_1.d3s_1);
      destination_2.d2(tmp$ret$11);
    }
    return destination_2;
  }
  toString() {
    return 'CheckForDestroyEvent(causedTeam=' + GameTeam__toString_impl_wfw0a6(this.g50_1) + ', hit=' + this.h50_1.toString() + ')';
  }
  hashCode() {
    var result = GameTeam__hashCode_impl_gu24w3(this.g50_1);
    result = imul(result, 31) + this.h50_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CheckForDestroyEvent))
      return false;
    if (!(this.g50_1 === other.g50_1))
      return false;
    if (!this.h50_1.equals(other.h50_1))
      return false;
    return true;
  }
  static i50(seen0, causedTeam, hit, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_255().e50_1);
    }
    var $this = createThis(this);
    $this.g50_1 = causedTeam;
    $this.h50_1 = hit;
    return $this;
  }
}
class Companion_303 {
  constructor() {
    Companion_instance_303 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j50_1 = [lazy(tmp_0, DiscardAfterCharactersDeathEvent$Companion$$childSerializers$_anonymous__z5kckc)];
  }
}
class $serializer_257 {
  constructor() {
    $serializer_instance_256 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DiscardAfterCharactersDeathEvent', this, 1);
    tmp0_serialDesc.h1b('characters', false);
    this.k50_1 = tmp0_serialDesc;
  }
  l50(encoder, value) {
    var tmp0_desc = this.k50_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_304().j50_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.m50_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l50(encoder, value instanceof DiscardAfterCharactersDeathEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k50_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_304().j50_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DiscardAfterCharactersDeathEvent.n50(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.k50_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_304().j50_1[0].k3()];
  }
}
class DiscardAfterCharactersDeathEvent {
  constructor(characters) {
    Companion_getInstance_304();
    this.m50_1 = characters;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList.p2();
    var _iterator__ex2g4s = this.m50_1.p1();
    $l$loop: while (_iterator__ex2g4s.q1()) {
      var character = _iterator__ex2g4s.r1();
      var tmp$ret$1;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp = get_objectType($context_GameStateRuntime_604ce3, character);
        if (tmp instanceof Draug) {
          tmp$ret$1 = character instanceof ObjectOnBoard ? character : THROW_CCE();
          break $l$block;
        }
        tmp$ret$1 = null;
      }
      var draug = tmp$ret$1;
      if ((draug == null ? null : get_draugWillRespawn($context_GameStateRuntime_604ce3, draug)) === true)
        continue $l$loop;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!get_hand($context_GameStateRuntime_604ce3, character).n1()) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new CardsMoveChange(new HandPlace(character), DiscardPlace_getInstance(), toSet(get_hand($context_GameStateRuntime_604ce3, character)));
        result.d2(element);
      }
      if (!(get_grudgesNumber($context_GameStateRuntime_604ce3, character) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = new GrudgesChange(character, -get_grudgesNumber($context_GameStateRuntime_604ce3, character) | 0);
        result.d2(element_0);
      }
      if (!(get_ancientPowerNumber($context_GameStateRuntime_604ce3, character) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_1 = new AncientPowersChangeEvent(character, -get_ancientPowerNumber($context_GameStateRuntime_604ce3, character) | 0);
        result.d2(element_1);
      }
    }
    return toList(result);
  }
  toString() {
    return 'DiscardAfterCharactersDeathEvent(characters=' + toString(this.m50_1) + ')';
  }
  hashCode() {
    return hashCode(this.m50_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardAfterCharactersDeathEvent))
      return false;
    if (!equals(this.m50_1, other.m50_1))
      return false;
    return true;
  }
  static n50(seen0, characters, serializationConstructorMarker) {
    Companion_getInstance_304();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_256().k50_1);
    }
    var $this = createThis(this);
    $this.m50_1 = characters;
    return $this;
  }
}
class Companion_304 {
  constructor() {
    Companion_instance_304 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, DiscardTrapsEvent$Companion$$childSerializers$_anonymous__mg6rx4);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o50_1 = [tmp_1, lazy(tmp_2, DiscardTrapsEvent$Companion$$childSerializers$_anonymous__mg6rx4_0)];
  }
}
class $serializer_258 {
  constructor() {
    $serializer_instance_257 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DiscardTrapsEvent', this, 2);
    tmp0_serialDesc.h1b('zone', false);
    tmp0_serialDesc.h1b('toRemove', false);
    this.p50_1 = tmp0_serialDesc;
  }
  q50(encoder, value) {
    var tmp0_desc = this.p50_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_305().o50_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r50_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.s50_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q50(encoder, value instanceof DiscardTrapsEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p50_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_305().o50_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return DiscardTrapsEvent.t50(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.p50_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_305().o50_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class DiscardTrapsEvent {
  constructor(zone, toRemove) {
    Companion_getInstance_305();
    this.r50_1 = zone;
    this.s50_1 = toRemove;
  }
  o37($context_GameStateRuntime_604ce3) {
    var tmp = listOf(new CardsMoveChange(new TrapZonePlace(this.r50_1), DiscardPlace_getInstance(), this.s50_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.s50_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = new RemoveTrapInfoChange(item);
      destination.d2(tmp$ret$2);
    }
    return plus_2(tmp, destination);
  }
  toString() {
    return 'DiscardTrapsEvent(zone=' + this.r50_1.toString() + ', toRemove=' + toString(this.s50_1) + ')';
  }
  hashCode() {
    var result = this.r50_1.hashCode();
    result = imul(result, 31) + hashCode(this.s50_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardTrapsEvent))
      return false;
    if (!this.r50_1.equals(other.r50_1))
      return false;
    if (!equals(this.s50_1, other.s50_1))
      return false;
    return true;
  }
  static t50(seen0, zone, toRemove, serializationConstructorMarker) {
    Companion_getInstance_305();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_257().p50_1);
    }
    var $this = createThis(this);
    $this.r50_1 = zone;
    $this.s50_1 = toRemove;
    return $this;
  }
}
class Companion_305 {
  constructor() {
    Companion_instance_305 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u50_1 = [lazy(tmp_0, DraftResultEvent$Companion$$childSerializers$_anonymous__1hq0pa)];
  }
}
class $serializer_259 {
  constructor() {
    $serializer_instance_258 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DraftResultEvent', this, 1);
    tmp0_serialDesc.h1b('draftKnownInfo', true);
    this.v50_1 = tmp0_serialDesc;
  }
  w50(encoder, value) {
    var tmp0_desc = this.v50_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_306().u50_1;
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$0 = emptyMap();
      tmp = !equals(value.x50_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x50_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w50(encoder, value instanceof DraftResultEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v50_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_306().u50_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DraftResultEvent.y50(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.v50_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_306().u50_1[0].k3()];
  }
}
class DraftResultEvent {
  constructor(draftKnownInfo) {
    Companion_getInstance_306();
    var tmp;
    if (draftKnownInfo === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp = emptyMap();
    } else {
      tmp = draftKnownInfo;
    }
    draftKnownInfo = tmp;
    this.x50_1 = draftKnownInfo;
  }
  o37($context_GameStateRuntime_604ce3) {
    var tmp0 = get_draftState($context_GameStateRuntime_604ce3);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Cannot finish a draft without its state';
        throw IllegalArgumentException.h2(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    var draft = tmp$ret$0;
    // Inline function 'kotlin.require' call
    if (!(draft.p4m_1.s2() === get_charactersInOrder($context_GameStateRuntime_604ce3).s2())) {
      var message_0 = 'Draft result row count does not match characters';
      throw IllegalArgumentException.h2(toString(message_0));
    }
    var removedCards = toSet(flatten(draft.q4m_1));
    var resultDiscarded = draft.t4m_1 ? emptySet() : removedCards;
    var resultUnused = plus(toSet(flatten(draft.o4m_1)), draft.t4m_1 ? removedCards : emptySet());
    // Inline function 'kotlin.collections.mutableListOf' call
    var moves = ArrayList.p2();
    var iterator = draft.p4m_1.p1();
    var index = 0;
    while (iterator.q1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var cards = iterator.r1();
      var characterObject = get_charactersInOrder($context_GameStateRuntime_604ce3).u2(index_0);
      var target = get_isAlive($context_GameStateRuntime_604ce3, characterObject) ? new HandPlace(characterObject) : DiscardPlace_getInstance();
      // Inline function 'kotlin.collections.groupBy' call
      // Inline function 'kotlin.collections.groupByTo' call
      var destination = LinkedHashMap.m7();
      var _iterator__ex2g4s = cards.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var key = get_place($context_GameStateRuntime_604ce3, element);
        // Inline function 'kotlin.collections.getOrPut' call
        var value = destination.w4(key);
        var tmp;
        if (value == null) {
          var answer = ArrayList.p2();
          destination.b5(key, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var list = tmp;
        list.d2(element);
      }
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = destination.i3().p1();
      while (_iterator__ex2g4s_0.q1()) {
        var _destruct__k2r9zo = _iterator__ex2g4s_0.r1();
        // Inline function 'kotlin.collections.component1' call
        var source = _destruct__k2r9zo.j3();
        // Inline function 'kotlin.collections.component2' call
        var sourceCards = _destruct__k2r9zo.k3();
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = new CardsMoveChange(source, target, toSet(sourceCards));
        moves.d2(element_0);
      }
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_0 = LinkedHashMap.m7();
    var _iterator__ex2g4s_1 = resultDiscarded.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var element_1 = _iterator__ex2g4s_1.r1();
      var key_0 = get_place($context_GameStateRuntime_604ce3, element_1);
      // Inline function 'kotlin.collections.getOrPut' call
      var value_0 = destination_0.w4(key_0);
      var tmp_0;
      if (value_0 == null) {
        var answer_0 = ArrayList.p2();
        destination_0.b5(key_0, answer_0);
        tmp_0 = answer_0;
      } else {
        tmp_0 = value_0;
      }
      var list_0 = tmp_0;
      list_0.d2(element_1);
    }
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = destination_0.i3().p1();
    while (_iterator__ex2g4s_2.q1()) {
      var _destruct__k2r9zo_0 = _iterator__ex2g4s_2.r1();
      // Inline function 'kotlin.collections.component1' call
      var source_0 = _destruct__k2r9zo_0.j3();
      // Inline function 'kotlin.collections.component2' call
      var sourceCards_0 = _destruct__k2r9zo_0.k3();
      // Inline function 'kotlin.collections.plusAssign' call
      var element_2 = new CardsMoveChange(source_0, DiscardPlace_getInstance(), toSet(sourceCards_0));
      moves.d2(element_2);
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_1 = LinkedHashMap.m7();
    var _iterator__ex2g4s_3 = resultUnused.p1();
    while (_iterator__ex2g4s_3.q1()) {
      var element_3 = _iterator__ex2g4s_3.r1();
      var key_1 = get_place($context_GameStateRuntime_604ce3, element_3);
      // Inline function 'kotlin.collections.getOrPut' call
      var value_1 = destination_1.w4(key_1);
      var tmp_1;
      if (value_1 == null) {
        var answer_1 = ArrayList.p2();
        destination_1.b5(key_1, answer_1);
        tmp_1 = answer_1;
      } else {
        tmp_1 = value_1;
      }
      var list_1 = tmp_1;
      list_1.d2(element_3);
    }
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_4 = destination_1.i3().p1();
    while (_iterator__ex2g4s_4.q1()) {
      var _destruct__k2r9zo_1 = _iterator__ex2g4s_4.r1();
      // Inline function 'kotlin.collections.component1' call
      var source_1 = _destruct__k2r9zo_1.j3();
      // Inline function 'kotlin.collections.component2' call
      var sourceCards_1 = _destruct__k2r9zo_1.k3();
      if (!equals(source_1, UnusedDraftActionCardPlace_getInstance())) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_4 = new CardsMoveChange(source_1, UnusedDraftActionCardPlace_getInstance(), toSet(sourceCards_1));
        moves.d2(element_4);
      }
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var element_5 = new DraftStateEvent(null);
    moves.d2(element_5);
    return moves;
  }
  toString() {
    return 'DraftResultEvent(draftKnownInfo=' + toString(this.x50_1) + ')';
  }
  hashCode() {
    return hashCode(this.x50_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraftResultEvent))
      return false;
    if (!equals(this.x50_1, other.x50_1))
      return false;
    return true;
  }
  static y50(seen0, draftKnownInfo, serializationConstructorMarker) {
    Companion_getInstance_306();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_258().v50_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp.x50_1 = emptyMap();
    } else
      $this.x50_1 = draftKnownInfo;
    return $this;
  }
}
class Companion_306 {}
class $serializer_260 {
  constructor() {
    $serializer_instance_259 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EndOfGameEvent', this, 1);
    tmp0_serialDesc.h1b('winnerTeam', false);
    this.z50_1 = tmp0_serialDesc;
  }
  a51(encoder, value) {
    var tmp0_desc = this.z50_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_183(), new GameTeam(value.b51_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a51(encoder, value instanceof EndOfGameEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z50_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return EndOfGameEvent.c51(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.z50_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_183()];
  }
}
class EndOfGameEvent {
  constructor(winnerTeam) {
    this.b51_1 = winnerTeam;
  }
  toString() {
    return 'EndOfGameEvent(winnerTeam=' + GameTeam__toString_impl_wfw0a6(this.b51_1) + ')';
  }
  hashCode() {
    return GameTeam__hashCode_impl_gu24w3(this.b51_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EndOfGameEvent))
      return false;
    if (!(this.b51_1 === other.b51_1))
      return false;
    return true;
  }
  static c51(seen0, winnerTeam, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_259().z50_1);
    }
    var $this = createThis(this);
    $this.b51_1 = winnerTeam;
    return $this;
  }
}
class Companion_307 {
  constructor() {
    Companion_instance_307 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, GainOpenArsenalCardEvent$Companion$$childSerializers$_anonymous__p4exl9);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, GainOpenArsenalCardEvent$Companion$$childSerializers$_anonymous__p4exl9_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d51_1 = [tmp_1, tmp_3, lazy(tmp_4, GainOpenArsenalCardEvent$Companion$$childSerializers$_anonymous__p4exl9_1)];
  }
}
class $serializer_261 {
  constructor() {
    $serializer_instance_260 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainOpenArsenalCardEvent', this, 3);
    tmp0_serialDesc.h1b('receiver', false);
    tmp0_serialDesc.h1b('arsenalType', false);
    tmp0_serialDesc.h1b('card', false);
    this.e51_1 = tmp0_serialDesc;
  }
  f51(encoder, value) {
    var tmp0_desc = this.e51_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_308().d51_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g51_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.h51_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.i51_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f51(encoder, value instanceof GainOpenArsenalCardEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e51_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_308().d51_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return GainOpenArsenalCardEvent.j51(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.e51_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_308().d51_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class GainOpenArsenalCardEvent {
  constructor(receiver, arsenalType, card) {
    Companion_getInstance_308();
    this.g51_1 = receiver;
    this.h51_1 = arsenalType;
    this.i51_1 = card;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new CardsMoveChange(RevealedArsenalPlace_getInstance(), new HandPlace(this.g51_1), setOf(this.i51_1)));
  }
  toString() {
    return 'GainOpenArsenalCardEvent(receiver=' + this.g51_1.toString() + ', arsenalType=' + this.h51_1.toString() + ', card=' + toString(this.i51_1) + ')';
  }
  hashCode() {
    var result = this.g51_1.hashCode();
    result = imul(result, 31) + this.h51_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.i51_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainOpenArsenalCardEvent))
      return false;
    if (!this.g51_1.equals(other.g51_1))
      return false;
    if (!this.h51_1.equals(other.h51_1))
      return false;
    if (!equals(this.i51_1, other.i51_1))
      return false;
    return true;
  }
  static j51(seen0, receiver, arsenalType, card, serializationConstructorMarker) {
    Companion_getInstance_308();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_260().e51_1);
    }
    var $this = createThis(this);
    $this.g51_1 = receiver;
    $this.h51_1 = arsenalType;
    $this.i51_1 = card;
    return $this;
  }
}
class Companion_308 {
  constructor() {
    Companion_instance_308 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, GainUnknownArsenalCardEvent$Companion$$childSerializers$_anonymous__bnsmzv);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k51_1 = [tmp_1, lazy(tmp_2, GainUnknownArsenalCardEvent$Companion$$childSerializers$_anonymous__bnsmzv_0)];
  }
}
class $serializer_262 {
  constructor() {
    $serializer_instance_261 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainUnknownArsenalCardEvent', this, 2);
    tmp0_serialDesc.h1b('receiver', false);
    tmp0_serialDesc.h1b('arsenalType', false);
    this.l51_1 = tmp0_serialDesc;
  }
  m51(encoder, value) {
    var tmp0_desc = this.l51_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_309().k51_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n51_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.o51_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m51(encoder, value instanceof GainUnknownArsenalCardEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l51_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_309().k51_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GainUnknownArsenalCardEvent.p51(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.l51_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_309().k51_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class GainUnknownArsenalCardEvent {
  constructor(receiver, arsenalType) {
    Companion_getInstance_309();
    this.n51_1 = receiver;
    this.o51_1 = arsenalType;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new CardsMoveChange(ComingArsenalPlace_getInstance(), new HandPlace(this.n51_1), setOf(last(getArsenal($context_GameStateRuntime_604ce3, this.o51_1).d36()))));
  }
  toString() {
    return 'GainUnknownArsenalCardEvent(receiver=' + this.n51_1.toString() + ', arsenalType=' + this.o51_1.toString() + ')';
  }
  hashCode() {
    var result = this.n51_1.hashCode();
    result = imul(result, 31) + this.o51_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainUnknownArsenalCardEvent))
      return false;
    if (!this.n51_1.equals(other.n51_1))
      return false;
    if (!this.o51_1.equals(other.o51_1))
      return false;
    return true;
  }
  static p51(seen0, receiver, arsenalType, serializationConstructorMarker) {
    Companion_getInstance_309();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_261().l51_1);
    }
    var $this = createThis(this);
    $this.n51_1 = receiver;
    $this.o51_1 = arsenalType;
    return $this;
  }
}
class Companion_309 {
  constructor() {
    Companion_instance_309 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q51_1 = [lazy(tmp_0, GainGrudgesEvent$Companion$$childSerializers$_anonymous__7eimmk), null];
  }
}
class $serializer_263 {
  constructor() {
    $serializer_instance_262 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainGrudgesEvent', this, 2);
    tmp0_serialDesc.h1b('receivers', false);
    tmp0_serialDesc.h1b('grudgesNumber', false);
    this.r51_1 = tmp0_serialDesc;
  }
  s51(encoder, value) {
    var tmp0_desc = this.r51_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_310().q51_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t51_1);
    tmp1_output.z14(tmp0_desc, 1, value.u51_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s51(encoder, value instanceof GainGrudgesEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r51_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_310().q51_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GainGrudgesEvent.v51(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r51_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_310().q51_1[0].k3(), IntSerializer_getInstance()];
  }
}
class GainGrudgesEvent {
  constructor(receivers, grudgesNumber) {
    return new.target.w51(receivers, grudgesNumber);
  }
  static w51(receivers, grudgesNumber) {
    Companion_getInstance_310();
    var $this = createThis(this);
    $this.t51_1 = receivers;
    $this.u51_1 = grudgesNumber;
    return $this;
  }
  static x51(receiver, grudgesNumber) {
    Companion_getInstance_310();
    return this.w51(setOf(receiver), grudgesNumber);
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.t51_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = new GrudgesChange(item, this.u51_1);
      destination.d2(tmp$ret$2);
    }
    return destination;
  }
  toString() {
    return 'GainGrudgesEvent(receivers=' + toString(this.t51_1) + ', grudgesNumber=' + this.u51_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.t51_1);
    result = imul(result, 31) + this.u51_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainGrudgesEvent))
      return false;
    if (!equals(this.t51_1, other.t51_1))
      return false;
    if (!(this.u51_1 === other.u51_1))
      return false;
    return true;
  }
  static v51(seen0, receivers, grudgesNumber, serializationConstructorMarker) {
    Companion_getInstance_310();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_262().r51_1);
    }
    var $this = createThis(this);
    $this.t51_1 = receivers;
    $this.u51_1 = grudgesNumber;
    return $this;
  }
}
class Companion_310 {
  constructor() {
    Companion_instance_310 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y51_1 = [lazy(tmp_0, AshRuinPositionChangeEvent$Companion$$childSerializers$_anonymous__rexmcn), null];
  }
}
class $serializer_264 {
  constructor() {
    $serializer_instance_263 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AshRuinPositionChangeEvent', this, 2);
    tmp0_serialDesc.h1b('ashRuin', false);
    tmp0_serialDesc.h1b('position', false);
    this.z51_1 = tmp0_serialDesc;
  }
  a52(encoder, value) {
    var tmp0_desc = this.z51_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_311().y51_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.b52_1);
    var tmp = $serializer_getInstance_100();
    var tmp_0 = value.c52_1;
    tmp1_output.i15(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a52(encoder, value instanceof AshRuinPositionChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z51_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_311().y51_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.d14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.d14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return AshRuinPositionChangeEvent.d52(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.z51_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_311().y51_1[0].k3(), get_nullable($serializer_getInstance_100())];
  }
}
class AshRuinPositionChangeEvent {
  constructor(ashRuin, position) {
    Companion_getInstance_311();
    this.b52_1 = ashRuin;
    this.c52_1 = position;
  }
  m37(_this__u8e3s4) {
    var tmp = _this__u8e3s4.x38_1.w4(this.b52_1);
    var oldPosition = tmp == null ? null : tmp.r2v_1;
    var tmp_0 = this.c52_1;
    if ((tmp_0 == null ? null : new BoardPosition(tmp_0)) == null) {
      _this__u8e3s4.x38_1 = minus(_this__u8e3s4.x38_1, this.b52_1);
    } else {
      // Inline function 'kotlin.require' call
      if (!_this__u8e3s4.h47().b45().w2(new BoardPosition(this.c52_1))) {
        var message = 'Incorrect ash ruin position: ' + BoardPosition__toString_impl_v4mn82(this.c52_1);
        throw IllegalArgumentException.h2(toString(message));
      }
      _this__u8e3s4.x38_1 = plus_3(_this__u8e3s4.x38_1, to(this.b52_1, new BoardPosition(this.c52_1)));
    }
    var tmp_1;
    var tmp_2 = oldPosition;
    if (!((tmp_2 == null ? null : new BoardPosition(tmp_2)) == null)) {
      var tmp_3 = oldPosition;
      var tmp_4 = tmp_3 == null ? null : new BoardPosition(tmp_3);
      var tmp_5 = this.c52_1;
      tmp_1 = !equals(tmp_4, tmp_5 == null ? null : new BoardPosition(tmp_5));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp_6 = _this__u8e3s4.y38_1.w4(new BoardPosition(oldPosition));
      var oldClaim = tmp_6 == null ? null : tmp_6.r3p_1;
      _this__u8e3s4.y38_1 = minus(_this__u8e3s4.y38_1, new BoardPosition(oldPosition));
      var tmp_7;
      var tmp_8 = this.c52_1;
      if (!((tmp_8 == null ? null : new BoardPosition(tmp_8)) == null)) {
        var tmp_9 = oldClaim;
        tmp_7 = !((tmp_9 == null ? null : new GameTeam(tmp_9)) == null);
      } else {
        tmp_7 = false;
      }
      if (tmp_7) {
        _this__u8e3s4.y38_1 = plus_3(_this__u8e3s4.y38_1, to(new BoardPosition(this.c52_1), new GameTeam(oldClaim)));
      }
    }
  }
  n37(gameState) {
    var tmp = gameState.h3d().w4(this.b52_1);
    return new AshRuinPositionChangeEvent(this.b52_1, tmp == null ? null : tmp.r2v_1);
  }
  toString() {
    var tmp = toString(this.b52_1);
    var tmp_0 = this.c52_1;
    return 'AshRuinPositionChangeEvent(ashRuin=' + tmp + ', position=' + toString_0(tmp_0 == null ? null : new BoardPosition(tmp_0)) + ')';
  }
  hashCode() {
    var result = hashCode(this.b52_1);
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.c52_1;
    if ((tmp_1 == null ? null : new BoardPosition(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = BoardPosition__hashCode_impl_9dgqf7(this.c52_1);
    }
    result = tmp + tmp_0 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AshRuinPositionChangeEvent))
      return false;
    if (!equals(this.b52_1, other.b52_1))
      return false;
    var tmp = this.c52_1;
    var tmp_0 = tmp == null ? null : new BoardPosition(tmp);
    var tmp_1 = other.c52_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new BoardPosition(tmp_1)))
      return false;
    return true;
  }
  static d52(seen0, ashRuin, position, serializationConstructorMarker) {
    Companion_getInstance_311();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_263().z51_1);
    }
    var $this = createThis(this);
    $this.b52_1 = ashRuin;
    $this.c52_1 = position;
    return $this;
  }
}
class Companion_311 {
  constructor() {
    Companion_instance_311 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, AshRuinReplacementChangeEvent$Companion$$childSerializers$_anonymous__c58d9w);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e52_1 = [tmp_1, lazy(tmp_2, AshRuinReplacementChangeEvent$Companion$$childSerializers$_anonymous__c58d9w_0), null];
  }
}
class $serializer_265 {
  constructor() {
    $serializer_instance_264 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AshRuinReplacementChangeEvent', this, 3);
    tmp0_serialDesc.h1b('oldAshRuin', false);
    tmp0_serialDesc.h1b('newAshRuin', false);
    tmp0_serialDesc.h1b('position', false);
    this.f52_1 = tmp0_serialDesc;
  }
  g52(encoder, value) {
    var tmp0_desc = this.f52_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_312().e52_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h52_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.i52_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_100(), new BoardPosition(value.j52_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g52(encoder, value instanceof AshRuinReplacementChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f52_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_312().e52_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp7_input.b14(tmp0_desc, 2, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp6_local2;
            var tmp_4 = tmp7_input.b14(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp6_local2 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return AshRuinReplacementChangeEvent.k52(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.f52_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_312().e52_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), $serializer_getInstance_100()];
  }
}
class AshRuinReplacementChangeEvent {
  constructor(oldAshRuin, newAshRuin, position) {
    Companion_getInstance_312();
    this.h52_1 = oldAshRuin;
    this.i52_1 = newAshRuin;
    this.j52_1 = position;
  }
  m37(_this__u8e3s4) {
    // Inline function 'kotlin.require' call
    if (!equals(ashRuinAt(_this__u8e3s4, this.j52_1), this.h52_1)) {
      var message = 'Cannot replace ' + toString(this.h52_1) + ' at ' + BoardPosition__toString_impl_v4mn82(this.j52_1) + ' because it is not there';
      throw IllegalArgumentException.h2(toString(message));
    }
    var tmp0 = _this__u8e3s4.x38_1;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = this.i52_1;
    // Inline function 'kotlin.require' call
    if (!!(isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).u4(key)) {
      var message_0 = 'Cannot replace ' + toString(this.h52_1) + ' with already placed ' + toString(this.i52_1);
      throw IllegalArgumentException.h2(toString(message_0));
    }
    _this__u8e3s4.x38_1 = minus(_this__u8e3s4.x38_1, this.h52_1);
    _this__u8e3s4.x38_1 = plus_3(_this__u8e3s4.x38_1, to(this.i52_1, new BoardPosition(this.j52_1)));
  }
  n37($context_GameState_t6qee5) {
    return new AshRuinReplacementChangeEvent(this.i52_1, this.h52_1, this.j52_1);
  }
  toString() {
    return 'AshRuinReplacementChangeEvent(oldAshRuin=' + toString(this.h52_1) + ', newAshRuin=' + toString(this.i52_1) + ', position=' + BoardPosition__toString_impl_v4mn82(this.j52_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.h52_1);
    result = imul(result, 31) + hashCode(this.i52_1) | 0;
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.j52_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AshRuinReplacementChangeEvent))
      return false;
    if (!equals(this.h52_1, other.h52_1))
      return false;
    if (!equals(this.i52_1, other.i52_1))
      return false;
    if (!(this.j52_1 === other.j52_1))
      return false;
    return true;
  }
  static k52(seen0, oldAshRuin, newAshRuin, position, serializationConstructorMarker) {
    Companion_getInstance_312();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_264().f52_1);
    }
    var $this = createThis(this);
    $this.h52_1 = oldAshRuin;
    $this.i52_1 = newAshRuin;
    $this.j52_1 = position;
    return $this;
  }
}
class Companion_312 {
  constructor() {
    Companion_instance_312 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l52_1 = [lazy(tmp_0, ChargingUpgradeChangeEvent$Companion$$childSerializers$_anonymous__6r7jd7), null];
  }
}
class $serializer_266 {
  constructor() {
    $serializer_instance_265 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChargingUpgradeChangeEvent', this, 2);
    tmp0_serialDesc.h1b('upgrade', false);
    tmp0_serialDesc.h1b('isCharged', false);
    this.m52_1 = tmp0_serialDesc;
  }
  n52(encoder, value) {
    var tmp0_desc = this.m52_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_313().l52_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o52_1);
    tmp1_output.w14(tmp0_desc, 1, value.p52_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n52(encoder, value instanceof ChargingUpgradeChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m52_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_313().l52_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ChargingUpgradeChangeEvent.q52(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.m52_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_313().l52_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class ChargingUpgradeChangeEvent {
  constructor(upgrade, isCharged) {
    Companion_getInstance_313();
    this.o52_1 = upgrade;
    this.p52_1 = isCharged;
  }
  m37(_this__u8e3s4) {
    if (this.p52_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!!_this__u8e3s4.s38_1.w2(this.o52_1)) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException.h2(toString(message));
      }
      _this__u8e3s4.s38_1 = plus_0(_this__u8e3s4.s38_1, this.o52_1);
    } else {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!_this__u8e3s4.s38_1.w2(this.o52_1)) {
        var message_0 = 'Failed requirement.';
        throw IllegalArgumentException.h2(toString(message_0));
      }
      _this__u8e3s4.s38_1 = minus_0(_this__u8e3s4.s38_1, this.o52_1);
    }
  }
  n37($context_GameState_t6qee5) {
    return new ChargingUpgradeChangeEvent(this.o52_1, !this.p52_1);
  }
  toString() {
    return 'ChargingUpgradeChangeEvent(upgrade=' + toString(this.o52_1) + ', isCharged=' + this.p52_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.o52_1);
    result = imul(result, 31) + getBooleanHashCode(this.p52_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChargingUpgradeChangeEvent))
      return false;
    if (!equals(this.o52_1, other.o52_1))
      return false;
    if (!(this.p52_1 === other.p52_1))
      return false;
    return true;
  }
  static q52(seen0, upgrade, isCharged, serializationConstructorMarker) {
    Companion_getInstance_313();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_265().m52_1);
    }
    var $this = createThis(this);
    $this.o52_1 = upgrade;
    $this.p52_1 = isCharged;
    return $this;
  }
}
class Companion_313 {}
class $serializer_267 {
  constructor() {
    $serializer_instance_266 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DraftStateEvent', this, 1);
    tmp0_serialDesc.h1b('newDraftState', false);
    this.r52_1 = tmp0_serialDesc;
  }
  s52(encoder, value) {
    var tmp0_desc = this.r52_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.i15(tmp0_desc, 0, $serializer_getInstance_202(), value.t52_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s52(encoder, value instanceof DraftStateEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r52_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, $serializer_getInstance_202(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, $serializer_getInstance_202(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DraftStateEvent.u52(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r52_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_202())];
  }
}
class DraftStateEvent {
  constructor(newDraftState) {
    this.t52_1 = newDraftState;
  }
  m37(_this__u8e3s4) {
    var tmp0_safe_receiver = this.t52_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var rowCount = _this__u8e3s4.i38_1.s2();
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(tmp0_safe_receiver.o4m_1.s2() === rowCount && tmp0_safe_receiver.p4m_1.s2() === rowCount && tmp0_safe_receiver.q4m_1.s2() === rowCount)) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException.h2(toString(message));
      }
      var tmp0 = tmp0_safe_receiver.r4m_1;
      var tmp$ret$5;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var tmp;
        if (isInterface(tmp0, Collection)) {
          tmp = tmp0.n1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$5 = true;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (!(0 <= element ? element < rowCount : false)) {
            tmp$ret$5 = false;
            break $l$block_0;
          }
        }
        tmp$ret$5 = true;
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!tmp$ret$5) {
        var message_0 = 'Failed requirement.';
        throw IllegalArgumentException.h2(toString(message_0));
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(tmp0_safe_receiver.u4m_1 == null || rowCount === 3)) {
        var message_1 = 'Failed requirement.';
        throw IllegalArgumentException.h2(toString(message_1));
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(!tmp0_safe_receiver.t4m_1 || tmp0_safe_receiver.s4m_1)) {
        var message_2 = 'Failed requirement.';
        throw IllegalArgumentException.h2(toString(message_2));
      }
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var _iterator__ex2g4s_0 = tmp0_safe_receiver.o4m_1.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        var tmp_0 = sum;
        sum = tmp_0 + element_0.s2() | 0;
      }
      var tmp_1 = sum;
      // Inline function 'kotlin.collections.sumOf' call
      var sum_0 = 0;
      var _iterator__ex2g4s_1 = tmp0_safe_receiver.p4m_1.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        var tmp_2 = sum_0;
        sum_0 = tmp_2 + element_1.s2() | 0;
      }
      var tmp_3 = tmp_1 + sum_0 | 0;
      // Inline function 'kotlin.collections.sumOf' call
      var sum_1 = 0;
      var _iterator__ex2g4s_2 = tmp0_safe_receiver.q4m_1.p1();
      while (_iterator__ex2g4s_2.q1()) {
        var element_2 = _iterator__ex2g4s_2.r1();
        var tmp_4 = sum_1;
        sum_1 = tmp_4 + element_2.s2() | 0;
      }
      var cardCount = tmp_3 + sum_1 | 0;
      // Inline function 'kotlin.require' call
      if (!(tmp0_safe_receiver.w4m().s2() === cardCount)) {
        var message_3 = 'A card occurs in more than one draft pile';
        throw IllegalArgumentException.h2(toString(message_3));
      }
    }
    var tmp1_safe_receiver = _this__u8e3s4.p38_1;
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w4m();
    var previousCards = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
    var tmp2_safe_receiver = this.t52_1;
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w4m();
    var nextCards = tmp0_elvis_lhs_0 == null ? emptySet() : tmp0_elvis_lhs_0;
    _this__u8e3s4.o38_1 = minus_1(plus(_this__u8e3s4.o38_1, minus_1(previousCards, nextCards)), minus_1(nextCards, previousCards));
    _this__u8e3s4.p38_1 = this.t52_1;
  }
  n37($context_GameState_t6qee5) {
    return new DraftStateEvent(get_draftState($context_GameState_t6qee5));
  }
  toString() {
    return 'DraftStateEvent(newDraftState=' + toString_0(this.t52_1) + ')';
  }
  hashCode() {
    return this.t52_1 == null ? 0 : this.t52_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraftStateEvent))
      return false;
    if (!equals(this.t52_1, other.t52_1))
      return false;
    return true;
  }
  static u52(seen0, newDraftState, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_266().r52_1);
    }
    var $this = createThis(this);
    $this.t52_1 = newDraftState;
    return $this;
  }
}
class Companion_314 {
  constructor() {
    Companion_instance_314 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v52_1 = [lazy(tmp_0, DuplicateCardEffectChangeEvent$Companion$$childSerializers$_anonymous__jxuq0c), null];
  }
}
class $serializer_268 {
  constructor() {
    $serializer_instance_267 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DuplicateCardEffectChangeEvent', this, 2);
    tmp0_serialDesc.h1b('card', false);
    tmp0_serialDesc.h1b('needToDuplicate', false);
    this.w52_1 = tmp0_serialDesc;
  }
  x52(encoder, value) {
    var tmp0_desc = this.w52_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_315().v52_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y52_1);
    tmp1_output.w14(tmp0_desc, 1, value.z52_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x52(encoder, value instanceof DuplicateCardEffectChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w52_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_315().v52_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return DuplicateCardEffectChangeEvent.a53(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.w52_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_315().v52_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class DuplicateCardEffectChangeEvent {
  constructor(card, needToDuplicate) {
    Companion_getInstance_315();
    this.y52_1 = card;
    this.z52_1 = needToDuplicate;
  }
  m37(_this__u8e3s4) {
    _this__u8e3s4.m38_1 = withAddOrRemove(_this__u8e3s4.m38_1, this.y52_1, this.z52_1 ? CollectionOperation_Add_getInstance() : CollectionOperation_Remove_getInstance());
  }
  n37($context_GameState_t6qee5) {
    return new DuplicateCardEffectChangeEvent(this.y52_1, !this.z52_1);
  }
  toString() {
    return 'DuplicateCardEffectChangeEvent(card=' + toString(this.y52_1) + ', needToDuplicate=' + this.z52_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.y52_1);
    result = imul(result, 31) + getBooleanHashCode(this.z52_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DuplicateCardEffectChangeEvent))
      return false;
    if (!equals(this.y52_1, other.y52_1))
      return false;
    if (!(this.z52_1 === other.z52_1))
      return false;
    return true;
  }
  static a53(seen0, card, needToDuplicate, serializationConstructorMarker) {
    Companion_getInstance_315();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_267().w52_1);
    }
    var $this = createThis(this);
    $this.y52_1 = card;
    $this.z52_1 = needToDuplicate;
    return $this;
  }
}
class Companion_315 {}
class $serializer_269 {
  constructor() {
    $serializer_instance_268 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RuinClaimedChangeEvent', this, 2);
    tmp0_serialDesc.h1b('ruinPosition', false);
    tmp0_serialDesc.h1b('gameTeam', false);
    this.b53_1 = tmp0_serialDesc;
  }
  c53(encoder, value) {
    var tmp0_desc = this.b53_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.d53_1));
    var tmp = $serializer_getInstance_183();
    var tmp_0 = value.e53_1;
    tmp1_output.i15(tmp0_desc, 1, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c53(encoder, value instanceof RuinClaimedChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b53_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp_2 = $serializer_getInstance_183();
      var tmp_3 = tmp5_local1;
      var tmp_4 = tmp6_input.d14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
      tmp5_local1 = tmp_4 == null ? null : tmp_4.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_5 = $serializer_getInstance_100();
            var tmp_6 = tmp4_local0;
            var tmp_7 = tmp6_input.b14(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new BoardPosition(tmp_6));
            tmp4_local0 = tmp_7 == null ? null : tmp_7.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_8 = $serializer_getInstance_183();
            var tmp_9 = tmp5_local1;
            var tmp_10 = tmp6_input.d14(tmp0_desc, 1, tmp_8, tmp_9 == null ? null : new GameTeam(tmp_9));
            tmp5_local1 = tmp_10 == null ? null : tmp_10.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RuinClaimedChangeEvent.f53(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.b53_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100(), get_nullable($serializer_getInstance_183())];
  }
}
class RuinClaimedChangeEvent {
  constructor(ruinPosition, gameTeam) {
    this.d53_1 = ruinPosition;
    this.e53_1 = gameTeam;
  }
  m37(_this__u8e3s4) {
    // Inline function 'kotlin.require' call
    if (!get_activeRuinPositions(_this__u8e3s4).w2(new BoardPosition(this.d53_1))) {
      var message = 'Incorrect ruin position: ' + BoardPosition__toString_impl_v4mn82(this.d53_1);
      throw IllegalArgumentException.h2(toString(message));
    }
    var tmp = this.e53_1;
    if ((tmp == null ? null : new GameTeam(tmp)) == null) {
      _this__u8e3s4.y38_1 = minus(_this__u8e3s4.y38_1, new BoardPosition(this.d53_1));
    } else {
      _this__u8e3s4.y38_1 = plus_3(_this__u8e3s4.y38_1, to(new BoardPosition(this.d53_1), new GameTeam(this.e53_1)));
    }
  }
  n37($context_GameState_t6qee5) {
    var tmp = get_ruinClaimingMap($context_GameState_t6qee5).w4(new BoardPosition(this.d53_1));
    return new RuinClaimedChangeEvent(this.d53_1, tmp == null ? null : tmp.r3p_1);
  }
  toString() {
    var tmp = BoardPosition__toString_impl_v4mn82(this.d53_1);
    var tmp_0 = this.e53_1;
    return 'RuinClaimedChangeEvent(ruinPosition=' + tmp + ', gameTeam=' + toString_0(tmp_0 == null ? null : new GameTeam(tmp_0)) + ')';
  }
  hashCode() {
    var result = BoardPosition__hashCode_impl_9dgqf7(this.d53_1);
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.e53_1;
    if ((tmp_1 == null ? null : new GameTeam(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = GameTeam__hashCode_impl_gu24w3(this.e53_1);
    }
    result = tmp + tmp_0 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RuinClaimedChangeEvent))
      return false;
    if (!(this.d53_1 === other.d53_1))
      return false;
    var tmp = this.e53_1;
    var tmp_0 = tmp == null ? null : new GameTeam(tmp);
    var tmp_1 = other.e53_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new GameTeam(tmp_1)))
      return false;
    return true;
  }
  static f53(seen0, ruinPosition, gameTeam, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_268().b53_1);
    }
    var $this = createThis(this);
    $this.d53_1 = ruinPosition;
    $this.e53_1 = gameTeam;
    return $this;
  }
}
class Companion_316 {}
class $serializer_270 {
  constructor() {
    $serializer_instance_269 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GameWarningEvent', this, 2);
    tmp0_serialDesc.h1b('warning', false);
    tmp0_serialDesc.h1b('errorReportId', true);
    this.g53_1 = tmp0_serialDesc;
  }
  h53(encoder, value) {
    var tmp0_desc = this.g53_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.i53_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.j53_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, IntSerializer_getInstance(), value.j53_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h53(encoder, value instanceof GameWarningEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g53_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GameWarningEvent.k53(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.g53_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance())];
  }
}
class GameWarningEvent {
  constructor(warning, errorReportId) {
    errorReportId = errorReportId === VOID ? null : errorReportId;
    this.i53_1 = warning;
    this.j53_1 = errorReportId;
  }
  toString() {
    return 'GameWarningEvent(warning=' + this.i53_1 + ', errorReportId=' + this.j53_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.i53_1);
    result = imul(result, 31) + (this.j53_1 == null ? 0 : this.j53_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWarningEvent))
      return false;
    if (!(this.i53_1 === other.i53_1))
      return false;
    if (!(this.j53_1 == other.j53_1))
      return false;
    return true;
  }
  static k53(seen0, warning, errorReportId, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_269().g53_1);
    }
    var $this = createThis(this);
    $this.i53_1 = warning;
    if (0 === (seen0 & 2))
      $this.j53_1 = null;
    else
      $this.j53_1 = errorReportId;
    return $this;
  }
}
class Companion_317 {
  constructor() {
    Companion_instance_317 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, GeneralCardMoveEvent$Companion$$childSerializers$_anonymous__v54qg7);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l53_1 = [tmp_1, lazy(tmp_2, GeneralCardMoveEvent$Companion$$childSerializers$_anonymous__v54qg7_0)];
  }
}
class $serializer_271 {
  constructor() {
    $serializer_instance_270 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GeneralCardMoveEvent', this, 2);
    tmp0_serialDesc.h1b('cards', false);
    tmp0_serialDesc.h1b('to', false);
    this.m53_1 = tmp0_serialDesc;
  }
  n53(encoder, value) {
    var tmp0_desc = this.m53_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_318().l53_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o53_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.p53_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n53(encoder, value instanceof GeneralCardMoveEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m53_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_318().l53_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GeneralCardMoveEvent.q53(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.m53_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_318().l53_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class GeneralCardMoveEvent {
  constructor(cards, to) {
    return new.target.r53(cards, to);
  }
  static r53(cards, to) {
    Companion_getInstance_318();
    var $this = createThis(this);
    $this.o53_1 = cards;
    $this.p53_1 = to;
    return $this;
  }
  static s53(card, to) {
    Companion_getInstance_318();
    return this.r53(setOf(card), to);
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.groupBy' call
    var tmp0 = this.o53_1;
    // Inline function 'kotlin.collections.groupByTo' call
    var destination = LinkedHashMap.m7();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp = get_place($context_GameStateRuntime_604ce3, element);
      var tmp_0 = inPlayPosition($context_GameStateRuntime_604ce3, element);
      var key = to(tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.w4(key);
      var tmp_1;
      if (value == null) {
        var answer = ArrayList.p2();
        destination.b5(key, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value;
      }
      var list = tmp_1;
      list.d2(element);
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(destination.s2());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = destination.i3().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      // Inline function 'kotlin.collections.component1' call
      var source = item.j3();
      // Inline function 'kotlin.collections.component2' call
      var cards = item.k3();
      var tmp_2 = toSet(cards);
      var tmp_3 = source.qm_1;
      var tmp$ret$8 = new CardsMoveChange(source.pm_1, this.p53_1, tmp_2, tmp_3 == null ? null : tmp_3.r2v_1);
      destination_0.d2(tmp$ret$8);
    }
    return destination_0;
  }
  toString() {
    return 'GeneralCardMoveEvent(cards=' + toString(this.o53_1) + ', to=' + toString(this.p53_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.o53_1);
    result = imul(result, 31) + hashCode(this.p53_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GeneralCardMoveEvent))
      return false;
    if (!equals(this.o53_1, other.o53_1))
      return false;
    if (!equals(this.p53_1, other.p53_1))
      return false;
    return true;
  }
  static q53(seen0, cards, to, serializationConstructorMarker) {
    Companion_getInstance_318();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_270().m53_1);
    }
    var $this = createThis(this);
    $this.o53_1 = cards;
    $this.p53_1 = to;
    return $this;
  }
}
class Companion_318 {
  constructor() {
    Companion_instance_318 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t53_1 = [lazy(tmp_0, HealEvent$Companion$$childSerializers$_anonymous__2xkgyg)];
  }
}
class $serializer_272 {
  constructor() {
    $serializer_instance_271 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HealEvent', this, 1);
    tmp0_serialDesc.h1b('healedObjects', false);
    this.u53_1 = tmp0_serialDesc;
  }
  v53(encoder, value) {
    var tmp0_desc = this.u53_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_319().t53_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w53_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v53(encoder, value instanceof HealEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u53_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_319().t53_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return HealEvent.x53(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.u53_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_319().t53_1[0].k3()];
  }
}
class HealEvent {
  constructor(healedObjects) {
    Companion_getInstance_319();
    this.w53_1 = healedObjects;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.w53_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = new HpChange(item, 1);
      destination.d2(tmp$ret$2);
    }
    return destination;
  }
  toString() {
    return 'HealEvent(healedObjects=' + toString(this.w53_1) + ')';
  }
  hashCode() {
    return hashCode(this.w53_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HealEvent))
      return false;
    if (!equals(this.w53_1, other.w53_1))
      return false;
    return true;
  }
  static x53(seen0, healedObjects, serializationConstructorMarker) {
    Companion_getInstance_319();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_271().u53_1);
    }
    var $this = createThis(this);
    $this.w53_1 = healedObjects;
    return $this;
  }
}
class Companion_319 {}
class $serializer_273 {
  constructor() {
    $serializer_instance_272 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('InitGameStateEvent', this, 2);
    tmp0_serialDesc.h1b('initialState', false);
    tmp0_serialDesc.h1b('isSandboxInit', true);
    this.y53_1 = tmp0_serialDesc;
  }
  z53(encoder, value) {
    var tmp0_desc = this.y53_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_200(), value.a54_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.b54_1 === false)) {
      tmp1_output.w14(tmp0_desc, 1, value.b54_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z53(encoder, value instanceof InitGameStateEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y53_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_200(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_200(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return InitGameStateEvent.c54(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.y53_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_200(), BooleanSerializer_getInstance()];
  }
}
class InitGameStateEvent {
  constructor(initialState, isSandboxInit) {
    isSandboxInit = isSandboxInit === VOID ? false : isSandboxInit;
    this.a54_1 = initialState;
    this.b54_1 = isSandboxInit;
  }
  toString() {
    return 'InitGameStateEvent(initialState=' + this.a54_1.toString() + ', isSandboxInit=' + this.b54_1 + ')';
  }
  hashCode() {
    var result = this.a54_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.b54_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InitGameStateEvent))
      return false;
    if (!this.a54_1.equals(other.a54_1))
      return false;
    if (!(this.b54_1 === other.b54_1))
      return false;
    return true;
  }
  static c54(seen0, initialState, isSandboxInit, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_272().y53_1);
    }
    var $this = createThis(this);
    $this.a54_1 = initialState;
    if (0 === (seen0 & 2))
      $this.b54_1 = false;
    else
      $this.b54_1 = isSandboxInit;
    return $this;
  }
}
class Companion_320 {}
class $serializer_274 {
  constructor() {
    $serializer_instance_273 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AssignDamageEvent', this, 1);
    tmp0_serialDesc.h1b('hit', false);
    this.d54_1 = tmp0_serialDesc;
  }
  e54(encoder, value) {
    var tmp0_desc = this.d54_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_123(), value.f54_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e54(encoder, value instanceof AssignDamageEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d54_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AssignDamageEvent.g54(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d54_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_123()];
  }
}
class MarkerGameStateEvent {
  constructor() {
    Companion_getInstance_353();
  }
  o37($context_GameStateRuntime_604ce3) {
    return emptyList();
  }
  static h54(seen0, serializationConstructorMarker) {
    Companion_getInstance_353();
    return createThis(this);
  }
}
class AssignDamageEvent extends MarkerGameStateEvent {
  constructor(hit) {
    super();
    this.f54_1 = hit;
  }
  toString() {
    return 'AssignDamageEvent(hit=' + this.f54_1.toString() + ')';
  }
  hashCode() {
    return this.f54_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AssignDamageEvent))
      return false;
    if (!this.f54_1.equals(other.f54_1))
      return false;
    return true;
  }
  static g54(seen0, hit, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_273().d54_1);
    }
    var $this = this.h54(seen0, serializationConstructorMarker);
    $this.f54_1 = hit;
    return $this;
  }
}
class Companion_321 {
  constructor() {
    Companion_instance_321 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, CardWasResolvedEvent$Companion$$childSerializers$_anonymous__pqnhun);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, CardWasResolvedEvent$Companion$$childSerializers$_anonymous__pqnhun_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i54_1 = [tmp_1, tmp_3, lazy(tmp_4, CardWasResolvedEvent$Companion$$childSerializers$_anonymous__pqnhun_1)];
  }
}
class $serializer_275 {
  constructor() {
    $serializer_instance_274 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CardWasResolvedEvent', this, 3);
    tmp0_serialDesc.h1b('character', false);
    tmp0_serialDesc.h1b('card', false);
    tmp0_serialDesc.h1b('resolvingKind', false);
    this.j54_1 = tmp0_serialDesc;
  }
  k54(encoder, value) {
    var tmp0_desc = this.j54_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_322().i54_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l54_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.m54_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.n54_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k54(encoder, value instanceof CardWasResolvedEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j54_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_322().i54_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return CardWasResolvedEvent.o54(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.j54_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_322().i54_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class CardWasResolvedEvent extends MarkerGameStateEvent {
  constructor(character, card, resolvingKind) {
    Companion_getInstance_322();
    super();
    this.l54_1 = character;
    this.m54_1 = card;
    this.n54_1 = resolvingKind;
  }
  toString() {
    return 'CardWasResolvedEvent(character=' + this.l54_1.toString() + ', card=' + toString(this.m54_1) + ', resolvingKind=' + toString(this.n54_1) + ')';
  }
  hashCode() {
    var result = this.l54_1.hashCode();
    result = imul(result, 31) + hashCode(this.m54_1) | 0;
    result = imul(result, 31) + hashCode(this.n54_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardWasResolvedEvent))
      return false;
    if (!this.l54_1.equals(other.l54_1))
      return false;
    if (!equals(this.m54_1, other.m54_1))
      return false;
    if (!equals(this.n54_1, other.n54_1))
      return false;
    return true;
  }
  static o54(seen0, character, card, resolvingKind, serializationConstructorMarker) {
    Companion_getInstance_322();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_274().j54_1);
    }
    var $this = this.h54(seen0, serializationConstructorMarker);
    $this.l54_1 = character;
    $this.m54_1 = card;
    $this.n54_1 = resolvingKind;
    return $this;
  }
}
class Companion_322 {
  constructor() {
    Companion_instance_322 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p54_1 = [null, lazy(tmp_0, DamageResolvedEvent$Companion$$childSerializers$_anonymous__vp32eh)];
  }
}
class $serializer_276 {
  constructor() {
    $serializer_instance_275 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DamageResolvedEvent', this, 2);
    tmp0_serialDesc.h1b('hit', false);
    tmp0_serialDesc.h1b('destroyed', false);
    this.q54_1 = tmp0_serialDesc;
  }
  r54(encoder, value) {
    var tmp0_desc = this.q54_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_323().p54_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_123(), value.s54_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.t54_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r54(encoder, value instanceof DamageResolvedEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q54_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_323().p54_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return DamageResolvedEvent.u54(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.q54_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_323().p54_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_123(), tmp0_cached[1].k3()];
  }
}
class DamageResolvedEvent extends MarkerGameStateEvent {
  constructor(hit, destroyed) {
    Companion_getInstance_323();
    super();
    this.s54_1 = hit;
    this.t54_1 = destroyed;
  }
  toString() {
    return 'DamageResolvedEvent(hit=' + this.s54_1.toString() + ', destroyed=' + toString(this.t54_1) + ')';
  }
  hashCode() {
    var result = this.s54_1.hashCode();
    result = imul(result, 31) + hashCode(this.t54_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DamageResolvedEvent))
      return false;
    if (!this.s54_1.equals(other.s54_1))
      return false;
    if (!equals(this.t54_1, other.t54_1))
      return false;
    return true;
  }
  static u54(seen0, hit, destroyed, serializationConstructorMarker) {
    Companion_getInstance_323();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_275().q54_1);
    }
    var $this = this.h54(seen0, serializationConstructorMarker);
    $this.s54_1 = hit;
    $this.t54_1 = destroyed;
    return $this;
  }
}
class Companion_323 {
  constructor() {
    Companion_instance_323 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v54_1 = [lazy(tmp_0, EndPhaseEvent$Companion$$childSerializers$_anonymous__a98ua8)];
  }
}
class $serializer_277 {
  constructor() {
    $serializer_instance_276 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EndPhaseEvent', this, 1);
    tmp0_serialDesc.h1b('phase', false);
    this.w54_1 = tmp0_serialDesc;
  }
  x54(encoder, value) {
    var tmp0_desc = this.w54_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_324().v54_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y54_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x54(encoder, value instanceof EndPhaseEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w54_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_324().v54_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return EndPhaseEvent.z54(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w54_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_324().v54_1[0].k3()];
  }
}
class EndPhaseEvent extends MarkerGameStateEvent {
  constructor(phase) {
    Companion_getInstance_324();
    super();
    this.y54_1 = phase;
  }
  toString() {
    return 'EndPhaseEvent(phase=' + toString(this.y54_1) + ')';
  }
  hashCode() {
    return hashCode(this.y54_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EndPhaseEvent))
      return false;
    if (!equals(this.y54_1, other.y54_1))
      return false;
    return true;
  }
  static z54(seen0, phase, serializationConstructorMarker) {
    Companion_getInstance_324();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_276().w54_1);
    }
    var $this = this.h54(seen0, serializationConstructorMarker);
    $this.y54_1 = phase;
    return $this;
  }
}
class Companion_324 {
  constructor() {
    Companion_instance_324 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a55_1 = [lazy(tmp_0, GameQuestionIsComingEvent$Companion$$childSerializers$_anonymous__tdnmml), null, null];
  }
}
class $serializer_278 {
  constructor() {
    $serializer_instance_277 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GameQuestionIsComingEvent', this, 3);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('gameQuestion', false);
    tmp0_serialDesc.h1b('mayNothing', false);
    this.b55_1 = tmp0_serialDesc;
  }
  c55(encoder, value) {
    var tmp0_desc = this.b55_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_325().a55_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d55_1);
    var tmp = getKClass(GameQuestion);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AncientPowerNumberQuestion), getKClass(BeastMovementCardQuestion), getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion), getKClass(CardPlayColorQuestion), getKClass(ChooseCardOnDraftQuestion), getKClass(ChooseCardsQuestion), getKClass(ChooseCharacterQuestion), getKClass(ContinueAfterRecoveryQuestion), getKClass(DestinationQuestion), getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion), getKClass(LocationTypeQuestion), getKClass(ObjectsGameQuestion), getKClass(PhaseRecoveryQuestion), getKClass(PlayCardInTurnQuestion), getKClass(SnareTypeQuestion), getKClass(StatementQuestion), getKClass(TrapByNumberQuestion), getKClass(TriggersQuestion), getKClass(UpgradeQuestion), getKClass(UrgullMoltEggsToReturnQuestion), getKClass(ZoneQuestion)];
    var tmp_1 = $serializer_getInstance_152();
    var tmp_2 = $serializer_getInstance_153();
    var tmp_3 = PlaceHatchlingWithInfestQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_4 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_3, tmp$ret$3);
    var tmp_5 = PlayOverloadedQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_6 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_5, tmp$ret$6);
    var tmp_7 = RevealToMoveQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_8 = ObjectSerializer.l1c('RevealToMoveQuestion', tmp_7, tmp$ret$9);
    var tmp_9 = $serializer_getInstance_345();
    var tmp_10 = $serializer_getInstance_428();
    var tmp_11 = $serializer_getInstance_154();
    var tmp_12 = CardPlayColorQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_13 = ObjectSerializer.l1c('CardPlayColorQuestion', tmp_12, tmp$ret$12);
    var tmp_14 = $serializer_getInstance_155();
    var tmp_15 = $serializer_getInstance_156();
    var tmp_16 = $serializer_getInstance_157();
    var tmp_17 = ContinueAfterRecoveryQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_18 = ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp_17, tmp$ret$15);
    var tmp_19 = $serializer_getInstance_158();
    var tmp_20 = $serializer_getInstance_110();
    var tmp_21 = $serializer_getInstance_159();
    var tmp_22 = $serializer_getInstance_160();
    var tmp_23 = $serializer_getInstance_161();
    var tmp_24 = $serializer_getInstance_162();
    var tmp_25 = $serializer_getInstance_163();
    var tmp_26 = $serializer_getInstance_164();
    var tmp_27 = getKClass(ObjectOnBoardType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_28 = [tmp_1, tmp_2, tmp_4, tmp_6, tmp_8, tmp_9, tmp_10, tmp_11, tmp_13, tmp_14, tmp_15, tmp_16, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, $serializer_165.l47(PolymorphicSerializer.vz(tmp_27, tmp$ret$18)), $serializer_getInstance_165(), $serializer_getInstance_166(), $serializer_getInstance_362(), $serializer_getInstance_167(), $serializer_getInstance_168(), $serializer_getInstance_169(), $serializer_getInstance_170(), $serializer_getInstance_413(), $serializer_getInstance_171()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    tmp1_output.g15(tmp0_desc, 1, SealedClassSerializer.i10('steelart.beast.GameQuestion', tmp, tmp_0, tmp_28, tmp$ret$24), value.e55_1);
    tmp1_output.w14(tmp0_desc, 2, value.f55_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c55(encoder, value instanceof GameQuestionIsComingEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b55_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_325().a55_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = getKClass(GameQuestion);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = [getKClass(AncientPowerNumberQuestion), getKClass(BeastMovementCardQuestion), getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion), getKClass(CardPlayColorQuestion), getKClass(ChooseCardOnDraftQuestion), getKClass(ChooseCardsQuestion), getKClass(ChooseCharacterQuestion), getKClass(ContinueAfterRecoveryQuestion), getKClass(DestinationQuestion), getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion), getKClass(LocationTypeQuestion), getKClass(ObjectsGameQuestion), getKClass(PhaseRecoveryQuestion), getKClass(PlayCardInTurnQuestion), getKClass(SnareTypeQuestion), getKClass(StatementQuestion), getKClass(TrapByNumberQuestion), getKClass(TriggersQuestion), getKClass(UpgradeQuestion), getKClass(UrgullMoltEggsToReturnQuestion), getKClass(ZoneQuestion)];
      var tmp_1 = $serializer_getInstance_152();
      var tmp_2 = $serializer_getInstance_153();
      var tmp_3 = PlaceHatchlingWithInfestQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [];
      var tmp_4 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_3, tmp$ret$3);
      var tmp_5 = PlayOverloadedQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = [];
      var tmp_6 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_5, tmp$ret$6);
      var tmp_7 = RevealToMoveQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$9 = [];
      var tmp_8 = ObjectSerializer.l1c('RevealToMoveQuestion', tmp_7, tmp$ret$9);
      var tmp_9 = $serializer_getInstance_345();
      var tmp_10 = $serializer_getInstance_428();
      var tmp_11 = $serializer_getInstance_154();
      var tmp_12 = CardPlayColorQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$12 = [];
      var tmp_13 = ObjectSerializer.l1c('CardPlayColorQuestion', tmp_12, tmp$ret$12);
      var tmp_14 = $serializer_getInstance_155();
      var tmp_15 = $serializer_getInstance_156();
      var tmp_16 = $serializer_getInstance_157();
      var tmp_17 = ContinueAfterRecoveryQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$15 = [];
      var tmp_18 = ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp_17, tmp$ret$15);
      var tmp_19 = $serializer_getInstance_158();
      var tmp_20 = $serializer_getInstance_110();
      var tmp_21 = $serializer_getInstance_159();
      var tmp_22 = $serializer_getInstance_160();
      var tmp_23 = $serializer_getInstance_161();
      var tmp_24 = $serializer_getInstance_162();
      var tmp_25 = $serializer_getInstance_163();
      var tmp_26 = $serializer_getInstance_164();
      var tmp_27 = getKClass(ObjectOnBoardType);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$18 = [];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_28 = [tmp_1, tmp_2, tmp_4, tmp_6, tmp_8, tmp_9, tmp_10, tmp_11, tmp_13, tmp_14, tmp_15, tmp_16, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, $serializer_165.l47(PolymorphicSerializer.vz(tmp_27, tmp$ret$18)), $serializer_getInstance_165(), $serializer_getInstance_166(), $serializer_getInstance_362(), $serializer_getInstance_167(), $serializer_getInstance_168(), $serializer_getInstance_169(), $serializer_getInstance_170(), $serializer_getInstance_413(), $serializer_getInstance_171()];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$24 = [];
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, SealedClassSerializer.i10('steelart.beast.GameQuestion', tmp, tmp_0, tmp_28, tmp$ret$24), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_29 = getKClass(GameQuestion);
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp_30 = [getKClass(AncientPowerNumberQuestion), getKClass(BeastMovementCardQuestion), getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion), getKClass(CardPlayColorQuestion), getKClass(ChooseCardOnDraftQuestion), getKClass(ChooseCardsQuestion), getKClass(ChooseCharacterQuestion), getKClass(ContinueAfterRecoveryQuestion), getKClass(DestinationQuestion), getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion), getKClass(LocationTypeQuestion), getKClass(ObjectsGameQuestion), getKClass(PhaseRecoveryQuestion), getKClass(PlayCardInTurnQuestion), getKClass(SnareTypeQuestion), getKClass(StatementQuestion), getKClass(TrapByNumberQuestion), getKClass(TriggersQuestion), getKClass(UpgradeQuestion), getKClass(UrgullMoltEggsToReturnQuestion), getKClass(ZoneQuestion)];
            var tmp_31 = $serializer_getInstance_152();
            var tmp_32 = $serializer_getInstance_153();
            var tmp_33 = PlaceHatchlingWithInfestQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$30 = [];
            var tmp_34 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_33, tmp$ret$30);
            var tmp_35 = PlayOverloadedQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$33 = [];
            var tmp_36 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_35, tmp$ret$33);
            var tmp_37 = RevealToMoveQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$36 = [];
            var tmp_38 = ObjectSerializer.l1c('RevealToMoveQuestion', tmp_37, tmp$ret$36);
            var tmp_39 = $serializer_getInstance_345();
            var tmp_40 = $serializer_getInstance_428();
            var tmp_41 = $serializer_getInstance_154();
            var tmp_42 = CardPlayColorQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$39 = [];
            var tmp_43 = ObjectSerializer.l1c('CardPlayColorQuestion', tmp_42, tmp$ret$39);
            var tmp_44 = $serializer_getInstance_155();
            var tmp_45 = $serializer_getInstance_156();
            var tmp_46 = $serializer_getInstance_157();
            var tmp_47 = ContinueAfterRecoveryQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$42 = [];
            var tmp_48 = ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp_47, tmp$ret$42);
            var tmp_49 = $serializer_getInstance_158();
            var tmp_50 = $serializer_getInstance_110();
            var tmp_51 = $serializer_getInstance_159();
            var tmp_52 = $serializer_getInstance_160();
            var tmp_53 = $serializer_getInstance_161();
            var tmp_54 = $serializer_getInstance_162();
            var tmp_55 = $serializer_getInstance_163();
            var tmp_56 = $serializer_getInstance_164();
            var tmp_57 = getKClass(ObjectOnBoardType);
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$45 = [];
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp_58 = [tmp_31, tmp_32, tmp_34, tmp_36, tmp_38, tmp_39, tmp_40, tmp_41, tmp_43, tmp_44, tmp_45, tmp_46, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, $serializer_165.l47(PolymorphicSerializer.vz(tmp_57, tmp$ret$45)), $serializer_getInstance_165(), $serializer_getInstance_166(), $serializer_getInstance_362(), $serializer_getInstance_167(), $serializer_getInstance_168(), $serializer_getInstance_169(), $serializer_getInstance_170(), $serializer_getInstance_413(), $serializer_getInstance_171()];
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$51 = [];
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, SealedClassSerializer.i10('steelart.beast.GameQuestion', tmp_29, tmp_30, tmp_58, tmp$ret$51), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return GameQuestionIsComingEvent.g55(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.b55_1;
  }
  y1b() {
    var tmp = Companion_getInstance_325().a55_1[0].k3();
    var tmp_0 = getKClass(GameQuestion);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [getKClass(AncientPowerNumberQuestion), getKClass(BeastMovementCardQuestion), getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion), getKClass(CardPlayColorQuestion), getKClass(ChooseCardOnDraftQuestion), getKClass(ChooseCardsQuestion), getKClass(ChooseCharacterQuestion), getKClass(ContinueAfterRecoveryQuestion), getKClass(DestinationQuestion), getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion), getKClass(LocationTypeQuestion), getKClass(ObjectsGameQuestion), getKClass(PhaseRecoveryQuestion), getKClass(PlayCardInTurnQuestion), getKClass(SnareTypeQuestion), getKClass(StatementQuestion), getKClass(TrapByNumberQuestion), getKClass(TriggersQuestion), getKClass(UpgradeQuestion), getKClass(UrgullMoltEggsToReturnQuestion), getKClass(ZoneQuestion)];
    var tmp_2 = $serializer_getInstance_152();
    var tmp_3 = $serializer_getInstance_153();
    var tmp_4 = PlaceHatchlingWithInfestQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_5 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_4, tmp$ret$3);
    var tmp_6 = PlayOverloadedQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_7 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_6, tmp$ret$6);
    var tmp_8 = RevealToMoveQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_9 = ObjectSerializer.l1c('RevealToMoveQuestion', tmp_8, tmp$ret$9);
    var tmp_10 = $serializer_getInstance_345();
    var tmp_11 = $serializer_getInstance_428();
    var tmp_12 = $serializer_getInstance_154();
    var tmp_13 = CardPlayColorQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_14 = ObjectSerializer.l1c('CardPlayColorQuestion', tmp_13, tmp$ret$12);
    var tmp_15 = $serializer_getInstance_155();
    var tmp_16 = $serializer_getInstance_156();
    var tmp_17 = $serializer_getInstance_157();
    var tmp_18 = ContinueAfterRecoveryQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_19 = ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp_18, tmp$ret$15);
    var tmp_20 = $serializer_getInstance_158();
    var tmp_21 = $serializer_getInstance_110();
    var tmp_22 = $serializer_getInstance_159();
    var tmp_23 = $serializer_getInstance_160();
    var tmp_24 = $serializer_getInstance_161();
    var tmp_25 = $serializer_getInstance_162();
    var tmp_26 = $serializer_getInstance_163();
    var tmp_27 = $serializer_getInstance_164();
    var tmp_28 = getKClass(ObjectOnBoardType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_29 = [tmp_2, tmp_3, tmp_5, tmp_7, tmp_9, tmp_10, tmp_11, tmp_12, tmp_14, tmp_15, tmp_16, tmp_17, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, $serializer_165.l47(PolymorphicSerializer.vz(tmp_28, tmp$ret$18)), $serializer_getInstance_165(), $serializer_getInstance_166(), $serializer_getInstance_362(), $serializer_getInstance_167(), $serializer_getInstance_168(), $serializer_getInstance_169(), $serializer_getInstance_170(), $serializer_getInstance_413(), $serializer_getInstance_171()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp, SealedClassSerializer.i10('steelart.beast.GameQuestion', tmp_0, tmp_1, tmp_29, tmp$ret$24), BooleanSerializer_getInstance()];
  }
}
class GameQuestionIsComingEvent extends MarkerGameStateEvent {
  constructor(actor, gameQuestion, mayNothing) {
    Companion_getInstance_325();
    super();
    this.d55_1 = actor;
    this.e55_1 = gameQuestion;
    this.f55_1 = mayNothing;
  }
  toString() {
    return 'GameQuestionIsComingEvent(actor=' + toString(this.d55_1) + ', gameQuestion=' + toString(this.e55_1) + ', mayNothing=' + this.f55_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.d55_1);
    result = imul(result, 31) + hashCode(this.e55_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f55_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameQuestionIsComingEvent))
      return false;
    if (!equals(this.d55_1, other.d55_1))
      return false;
    if (!equals(this.e55_1, other.e55_1))
      return false;
    if (!(this.f55_1 === other.f55_1))
      return false;
    return true;
  }
  static g55(seen0, actor, gameQuestion, mayNothing, serializationConstructorMarker) {
    Companion_getInstance_325();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_277().b55_1);
    }
    var $this = this.h54(seen0, serializationConstructorMarker);
    $this.d55_1 = actor;
    $this.e55_1 = gameQuestion;
    $this.f55_1 = mayNothing;
    return $this;
  }
}
class NothingEvent extends MarkerGameStateEvent {
  constructor() {
    NothingEvent_instance = null;
    super();
    NothingEvent_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h55_1 = lazy(tmp_0, NothingEvent$_anonymous__ppsebu);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_282(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NothingEvent';
  }
  hashCode() {
    return -261908974;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NothingEvent))
      return false;
    return true;
  }
}
class Companion_325 {}
class $serializer_279 {
  constructor() {
    $serializer_instance_278 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RewardAchieved', this, 1);
    tmp0_serialDesc.h1b('gameTeam', false);
    this.i55_1 = tmp0_serialDesc;
  }
  j55(encoder, value) {
    var tmp0_desc = this.i55_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_183(), new GameTeam(value.k55_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j55(encoder, value instanceof RewardAchieved ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i55_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RewardAchieved.l55(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.i55_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_183()];
  }
}
class RewardAchieved extends MarkerGameStateEvent {
  constructor(gameTeam) {
    super();
    this.k55_1 = gameTeam;
  }
  toString() {
    return 'RewardAchieved(gameTeam=' + GameTeam__toString_impl_wfw0a6(this.k55_1) + ')';
  }
  hashCode() {
    return GameTeam__hashCode_impl_gu24w3(this.k55_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RewardAchieved))
      return false;
    if (!(this.k55_1 === other.k55_1))
      return false;
    return true;
  }
  static l55(seen0, gameTeam, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_278().i55_1);
    }
    var $this = this.h54(seen0, serializationConstructorMarker);
    $this.k55_1 = gameTeam;
    return $this;
  }
}
class Companion_326 {
  constructor() {
    Companion_instance_326 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m55_1 = [lazy(tmp_0, SearchForBeastEvent$Companion$$childSerializers$_anonymous__muv8qa), null];
  }
}
class $serializer_280 {
  constructor() {
    $serializer_instance_279 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SearchForBeastEvent', this, 2);
    tmp0_serialDesc.h1b('searcher', false);
    tmp0_serialDesc.h1b('position', false);
    this.n55_1 = tmp0_serialDesc;
  }
  o55(encoder, value) {
    var tmp0_desc = this.n55_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_327().m55_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p55_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_100(), new BoardPosition(value.q55_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o55(encoder, value instanceof SearchForBeastEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n55_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_327().m55_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SearchForBeastEvent.r55(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.n55_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_327().m55_1[0].k3(), $serializer_getInstance_100()];
  }
}
class SearchForBeastEvent extends MarkerGameStateEvent {
  constructor(searcher, position) {
    Companion_getInstance_327();
    super();
    this.p55_1 = searcher;
    this.q55_1 = position;
  }
  toString() {
    return 'SearchForBeastEvent(searcher=' + this.p55_1.toString() + ', position=' + BoardPosition__toString_impl_v4mn82(this.q55_1) + ')';
  }
  hashCode() {
    var result = this.p55_1.hashCode();
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.q55_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SearchForBeastEvent))
      return false;
    if (!this.p55_1.equals(other.p55_1))
      return false;
    if (!(this.q55_1 === other.q55_1))
      return false;
    return true;
  }
  static r55(seen0, searcher, position, serializationConstructorMarker) {
    Companion_getInstance_327();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_279().n55_1);
    }
    var $this = this.h54(seen0, serializationConstructorMarker);
    $this.p55_1 = searcher;
    $this.q55_1 = position;
    return $this;
  }
}
class Companion_327 {}
class $serializer_281 {
  constructor() {
    $serializer_instance_280 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ModifySubmittedDamageEvent', this, 1);
    tmp0_serialDesc.h1b('submittedDamage', false);
    this.s55_1 = tmp0_serialDesc;
  }
  t55(encoder, value) {
    var tmp0_desc = this.s55_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_123(), value.u55_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t55(encoder, value instanceof ModifySubmittedDamageEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s55_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ModifySubmittedDamageEvent.v55(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s55_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_123()];
  }
}
class ModifySubmittedDamageEvent {
  constructor(submittedDamage) {
    this.u55_1 = submittedDamage;
  }
  o37($context_GameStateRuntime_604ce3) {
    if (get_submittedCurrentDamage($context_GameStateRuntime_604ce3) == null) {
      // Inline function 'kotlin.error' call
      var message = 'No damage to modify';
      throw IllegalStateException.o(toString(message));
    }
    if (this.u55_1.equals(get_submittedCurrentDamage($context_GameStateRuntime_604ce3))) {
      // Inline function 'kotlin.error' call
      var message_0 = 'Same damage was already submitted';
      throw IllegalStateException.o(toString(message_0));
    }
    return listOf(new SubmittedDamageChange(this.u55_1));
  }
  toString() {
    return 'ModifySubmittedDamageEvent(submittedDamage=' + this.u55_1.toString() + ')';
  }
  hashCode() {
    return this.u55_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ModifySubmittedDamageEvent))
      return false;
    if (!this.u55_1.equals(other.u55_1))
      return false;
    return true;
  }
  static v55(seen0, submittedDamage, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_280().s55_1);
    }
    var $this = createThis(this);
    $this.u55_1 = submittedDamage;
    return $this;
  }
}
class Companion_328 {
  constructor() {
    Companion_instance_328 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, MoveCardToDiscardEvent$Companion$$childSerializers$_anonymous__9pzxxu);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w55_1 = [tmp_1, lazy(tmp_2, MoveCardToDiscardEvent$Companion$$childSerializers$_anonymous__9pzxxu_0)];
  }
}
class $serializer_282 {
  constructor() {
    $serializer_instance_281 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MoveCardToDiscardEvent', this, 2);
    tmp0_serialDesc.h1b('cardPlace', false);
    tmp0_serialDesc.h1b('card', false);
    this.x55_1 = tmp0_serialDesc;
  }
  y55(encoder, value) {
    var tmp0_desc = this.x55_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_329().w55_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.z55_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.a56_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y55(encoder, value instanceof MoveCardToDiscardEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x55_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_329().w55_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return MoveCardToDiscardEvent.b56(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.x55_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_329().w55_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class MoveCardToDiscardEvent {
  constructor(cardPlace, card) {
    return new.target.c56(cardPlace, card);
  }
  static c56(cardPlace, card) {
    Companion_getInstance_329();
    var $this = createThis(this);
    $this.z55_1 = cardPlace;
    $this.a56_1 = card;
    return $this;
  }
  static d56(holder, card) {
    Companion_getInstance_329();
    return this.c56(new HandPlace(holder), card);
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new CardsMoveChange(this.z55_1, DiscardPlace_getInstance(), setOf(this.a56_1), inPlayPosition($context_GameStateRuntime_604ce3, this.a56_1)));
  }
  toString() {
    return 'MoveCardToDiscardEvent(cardPlace=' + toString(this.z55_1) + ', card=' + toString(this.a56_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.z55_1);
    result = imul(result, 31) + hashCode(this.a56_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MoveCardToDiscardEvent))
      return false;
    if (!equals(this.z55_1, other.z55_1))
      return false;
    if (!equals(this.a56_1, other.a56_1))
      return false;
    return true;
  }
  static b56(seen0, cardPlace, card, serializationConstructorMarker) {
    Companion_getInstance_329();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_281().x55_1);
    }
    var $this = createThis(this);
    $this.z55_1 = cardPlace;
    $this.a56_1 = card;
    return $this;
  }
}
class Companion_329 {
  constructor() {
    Companion_instance_329 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e56_1 = [lazy(tmp_0, MovementEvent$Companion$$childSerializers$_anonymous__ynfxz5), null];
  }
}
class $serializer_283 {
  constructor() {
    $serializer_instance_282 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MovementEvent', this, 2);
    tmp0_serialDesc.h1b('movements', false);
    tmp0_serialDesc.h1b('isPull', true);
    this.f56_1 = tmp0_serialDesc;
  }
  g56(encoder, value) {
    var tmp0_desc = this.f56_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_330().e56_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h56_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.i56_1 === false)) {
      tmp1_output.w14(tmp0_desc, 1, value.i56_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g56(encoder, value instanceof MovementEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f56_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_330().e56_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return MovementEvent.j56(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.f56_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_330().e56_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class MovementEvent {
  constructor(movements, isPull) {
    Companion_getInstance_330();
    isPull = isPull === VOID ? false : isPull;
    this.h56_1 = movements;
    this.i56_1 = isPull;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = this.h56_1;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (element instanceof OpenObjectMovement) {
        destination.d2(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$4 = new MovementChange(item.k56_1, item.l56_1, true);
      destination_0.d2(tmp$ret$4);
    }
    var tmp = destination_0;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_0 = this.h56_1;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_1 = ArrayList.p2();
    var _iterator__ex2g4s_1 = tmp0_0.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var element_0 = _iterator__ex2g4s_1.r1();
      if (element_0 instanceof HiddenBeastMovement) {
        destination_1.d2(element_0);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.n2(collectionSizeOrDefault(destination_1, 10));
    var _iterator__ex2g4s_2 = destination_1.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var item_0 = _iterator__ex2g4s_2.r1();
      // Inline function 'kotlin.collections.map' call
      var this_0 = item_0.o56_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s_3 = this_0.p1();
      while (_iterator__ex2g4s_3.q1()) {
        var item_1 = _iterator__ex2g4s_3.r1();
        var tmp$ret$12 = new BoardPosition(item_1.c3g().v3g_1);
        destination_3.d2(tmp$ret$12);
      }
      var tmp$ret$9 = new MovementChange(item_0.n56_1, destination_3, false);
      destination_2.d2(tmp$ret$9);
    }
    var tmp_0 = plus_2(tmp, destination_2);
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_1 = this.h56_1;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_4 = ArrayList.p2();
    var _iterator__ex2g4s_4 = tmp0_1.p1();
    while (_iterator__ex2g4s_4.q1()) {
      var element_1 = _iterator__ex2g4s_4.r1();
      if (element_1 instanceof HiddenBeastMovement) {
        destination_4.d2(element_1);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList.n2(collectionSizeOrDefault(destination_4, 10));
    var _iterator__ex2g4s_5 = destination_4.p1();
    while (_iterator__ex2g4s_5.q1()) {
      var item_2 = _iterator__ex2g4s_5.r1();
      var tmp$ret$17 = new BeastMovementInfoChange(item_2.n56_1, item_2.o56_1, item_2.p56_1);
      destination_5.d2(tmp$ret$17);
    }
    var changes = plus_2(tmp_0, destination_5);
    return changes;
  }
  toString() {
    return 'MovementEvent(movements=' + toString(this.h56_1) + ', isPull=' + this.i56_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.h56_1);
    result = imul(result, 31) + getBooleanHashCode(this.i56_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MovementEvent))
      return false;
    if (!equals(this.h56_1, other.h56_1))
      return false;
    if (!(this.i56_1 === other.i56_1))
      return false;
    return true;
  }
  static j56(seen0, movements, isPull, serializationConstructorMarker) {
    Companion_getInstance_330();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_282().f56_1);
    }
    var $this = createThis(this);
    $this.h56_1 = movements;
    if (0 === (seen0 & 2))
      $this.i56_1 = false;
    else
      $this.i56_1 = isPull;
    return $this;
  }
}
class Companion_330 {
  constructor() {
    Companion_instance_330 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q56_1 = [lazy(tmp_0, NewSimpleObjectEvent$Companion$$childSerializers$_anonymous__j35v33), null];
  }
}
class $serializer_284 {
  constructor() {
    $serializer_instance_283 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('NewSimpleObjectEvent', this, 2);
    tmp0_serialDesc.h1b('newType', false);
    tmp0_serialDesc.h1b('position', false);
    this.r56_1 = tmp0_serialDesc;
  }
  s56(encoder, value) {
    var tmp0_desc = this.r56_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_331().q56_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t56_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_100(), new BoardPosition(value.u56_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s56(encoder, value instanceof NewSimpleObjectEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r56_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_331().q56_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return NewSimpleObjectEvent.v56(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r56_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_331().q56_1[0].k3(), $serializer_getInstance_100()];
  }
}
class NewSimpleObjectEvent {
  constructor(newType, position) {
    Companion_getInstance_331();
    this.t56_1 = newType;
    this.u56_1 = position;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new AddObjectChange(this.t56_1, this.u56_1));
  }
  toString() {
    return 'NewSimpleObjectEvent(newType=' + toString(this.t56_1) + ', position=' + BoardPosition__toString_impl_v4mn82(this.u56_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.t56_1);
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.u56_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NewSimpleObjectEvent))
      return false;
    if (!equals(this.t56_1, other.t56_1))
      return false;
    if (!(this.u56_1 === other.u56_1))
      return false;
    return true;
  }
  static v56(seen0, newType, position, serializationConstructorMarker) {
    Companion_getInstance_331();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_283().r56_1);
    }
    var $this = createThis(this);
    $this.t56_1 = newType;
    $this.u56_1 = position;
    return $this;
  }
}
class Companion_331 {
  constructor() {
    Companion_instance_331 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w56_1 = [null, lazy(tmp_0, ObjectRemoveForReplacingEvent$Companion$$childSerializers$_anonymous__4f1rln)];
  }
}
class $serializer_285 {
  constructor() {
    $serializer_instance_284 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ObjectRemoveForReplacingEvent', this, 2);
    tmp0_serialDesc.h1b('causedTeam', false);
    tmp0_serialDesc.h1b('replacing', false);
    this.x56_1 = tmp0_serialDesc;
  }
  y56(encoder, value) {
    var tmp0_desc = this.x56_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_332().w56_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_183(), new GameTeam(value.z56_1));
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.a57_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y56(encoder, value instanceof ObjectRemoveForReplacingEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x56_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_332().w56_1;
    if (tmp6_input.e14()) {
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ObjectRemoveForReplacingEvent.b57(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.x56_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_332().w56_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_183(), tmp0_cached[1].k3()];
  }
}
class ObjectRemoveForReplacingEvent {
  constructor(causedTeam, replacing) {
    Companion_getInstance_332();
    this.z56_1 = causedTeam;
    this.a57_1 = replacing;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new DestroyedChange(this.a57_1, this.z56_1, null, DestroyReason_ObjectWillBeReplaced_getInstance()));
  }
  toString() {
    return 'ObjectRemoveForReplacingEvent(causedTeam=' + GameTeam__toString_impl_wfw0a6(this.z56_1) + ', replacing=' + this.a57_1.toString() + ')';
  }
  hashCode() {
    var result = GameTeam__hashCode_impl_gu24w3(this.z56_1);
    result = imul(result, 31) + this.a57_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ObjectRemoveForReplacingEvent))
      return false;
    if (!(this.z56_1 === other.z56_1))
      return false;
    if (!this.a57_1.equals(other.a57_1))
      return false;
    return true;
  }
  static b57(seen0, causedTeam, replacing, serializationConstructorMarker) {
    Companion_getInstance_332();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_284().x56_1);
    }
    var $this = createThis(this);
    $this.z56_1 = causedTeam;
    $this.a57_1 = replacing;
    return $this;
  }
}
class Companion_332 {
  constructor() {
    Companion_instance_332 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, PickCardsFromDeadCharacterEvent$Companion$$childSerializers$_anonymous__25im5z);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c57_1 = [tmp_1, lazy(tmp_2, PickCardsFromDeadCharacterEvent$Companion$$childSerializers$_anonymous__25im5z_0)];
  }
}
class $serializer_286 {
  constructor() {
    $serializer_instance_285 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PickCardsFromDeadCharacterEvent', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('cardsToPick', false);
    this.d57_1 = tmp0_serialDesc;
  }
  e57(encoder, value) {
    var tmp0_desc = this.d57_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_333().c57_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f57_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.g57_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e57(encoder, value instanceof PickCardsFromDeadCharacterEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d57_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_333().c57_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PickCardsFromDeadCharacterEvent.h57(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d57_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_333().c57_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class PickCardsFromDeadCharacterEvent {
  constructor(beast, cardsToPick) {
    Companion_getInstance_333();
    this.f57_1 = beast;
    this.g57_1 = cardsToPick;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.g57_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(this_0.s2());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this_0.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var hunter = item.j3();
      // Inline function 'kotlin.collections.component2' call
      var card = item.k3();
      var tmp$ret$3 = new CardsMoveChange(new HandPlace(hunter), new HandPlace(this.f57_1), setOf(card));
      destination.d2(tmp$ret$3);
    }
    return destination;
  }
  toString() {
    return 'PickCardsFromDeadCharacterEvent(beast=' + this.f57_1.toString() + ', cardsToPick=' + toString(this.g57_1) + ')';
  }
  hashCode() {
    var result = this.f57_1.hashCode();
    result = imul(result, 31) + hashCode(this.g57_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PickCardsFromDeadCharacterEvent))
      return false;
    if (!this.f57_1.equals(other.f57_1))
      return false;
    if (!equals(this.g57_1, other.g57_1))
      return false;
    return true;
  }
  static h57(seen0, beast, cardsToPick, serializationConstructorMarker) {
    Companion_getInstance_333();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_285().d57_1);
    }
    var $this = createThis(this);
    $this.f57_1 = beast;
    $this.g57_1 = cardsToPick;
    return $this;
  }
}
class Companion_333 {
  constructor() {
    Companion_instance_333 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i57_1 = [lazy(tmp_0, RemoveFirePositionsEvent$Companion$$childSerializers$_anonymous__69qh7k)];
  }
}
class $serializer_287 {
  constructor() {
    $serializer_instance_286 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RemoveFirePositionsEvent', this, 1);
    tmp0_serialDesc.h1b('positions', false);
    this.j57_1 = tmp0_serialDesc;
  }
  k57(encoder, value) {
    var tmp0_desc = this.j57_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_334().i57_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l57_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k57(encoder, value instanceof RemoveFirePositionsEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j57_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_334().i57_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RemoveFirePositionsEvent.m57(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.j57_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_334().i57_1[0].k3()];
  }
}
class RemoveFirePositionsEvent {
  constructor(positions) {
    Companion_getInstance_334();
    this.l57_1 = positions;
  }
  o37(gsCtx) {
    var updated = minus_1(gsCtx.y4k(), this.l57_1);
    if (equals(updated, gsCtx.y4k()))
      return emptyList();
    return listOf(new FirePositionsChange(updated));
  }
  toString() {
    return 'RemoveFirePositionsEvent(positions=' + toString(this.l57_1) + ')';
  }
  hashCode() {
    return hashCode(this.l57_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoveFirePositionsEvent))
      return false;
    if (!equals(this.l57_1, other.l57_1))
      return false;
    return true;
  }
  static m57(seen0, positions, serializationConstructorMarker) {
    Companion_getInstance_334();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_286().j57_1);
    }
    var $this = createThis(this);
    $this.l57_1 = positions;
    return $this;
  }
}
class Companion_334 {
  constructor() {
    Companion_instance_334 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RemoveUpgradeEvent$Companion$$childSerializers$_anonymous__vlvec8);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n57_1 = [tmp_1, lazy(tmp_2, RemoveUpgradeEvent$Companion$$childSerializers$_anonymous__vlvec8_0)];
  }
}
class $serializer_288 {
  constructor() {
    $serializer_instance_287 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RemoveUpgradeEvent', this, 2);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('upgrade', false);
    this.o57_1 = tmp0_serialDesc;
  }
  p57(encoder, value) {
    var tmp0_desc = this.o57_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_335().n57_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q57_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.r57_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p57(encoder, value instanceof RemoveUpgradeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o57_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_335().n57_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RemoveUpgradeEvent.s57(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.o57_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_335().n57_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class RemoveUpgradeEvent {
  constructor(actor, upgrade) {
    Companion_getInstance_335();
    this.q57_1 = actor;
    this.r57_1 = upgrade;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new RemoveUpgradeChange(this.q57_1, this.r57_1));
  }
  toString() {
    return 'RemoveUpgradeEvent(actor=' + this.q57_1.toString() + ', upgrade=' + toString(this.r57_1) + ')';
  }
  hashCode() {
    var result = this.q57_1.hashCode();
    result = imul(result, 31) + hashCode(this.r57_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoveUpgradeEvent))
      return false;
    if (!this.q57_1.equals(other.q57_1))
      return false;
    if (!equals(this.r57_1, other.r57_1))
      return false;
    return true;
  }
  static s57(seen0, actor, upgrade, serializationConstructorMarker) {
    Companion_getInstance_335();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_287().o57_1);
    }
    var $this = createThis(this);
    $this.q57_1 = actor;
    $this.r57_1 = upgrade;
    return $this;
  }
}
class ReplayIsFinishedEvent {
  constructor() {
    ReplayIsFinishedEvent_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t57_1 = lazy(tmp_0, ReplayIsFinishedEvent$_anonymous__y8bsjk);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_283(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ReplayIsFinishedEvent';
  }
  hashCode() {
    return -2097475662;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReplayIsFinishedEvent))
      return false;
    return true;
  }
}
class Companion_335 {
  constructor() {
    Companion_instance_335 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u57_1 = [lazy(tmp_0, ReplayNotificationEvent$Companion$$childSerializers$_anonymous__rg6va6)];
  }
}
class $serializer_289 {
  constructor() {
    $serializer_instance_288 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ReplayNotificationEvent', this, 1);
    tmp0_serialDesc.h1b('info', false);
    this.v57_1 = tmp0_serialDesc;
  }
  w57(encoder, value) {
    var tmp0_desc = this.v57_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_336().u57_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x57_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w57(encoder, value instanceof ReplayNotificationEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v57_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_336().u57_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ReplayNotificationEvent.y57(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.v57_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_336().u57_1[0].k3()];
  }
}
class ReplayNotificationEvent {
  constructor(info) {
    Companion_getInstance_336();
    this.x57_1 = info;
  }
  toString() {
    return 'ReplayNotificationEvent(info=' + toString(this.x57_1) + ')';
  }
  hashCode() {
    return hashCode(this.x57_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReplayNotificationEvent))
      return false;
    if (!equals(this.x57_1, other.x57_1))
      return false;
    return true;
  }
  static y57(seen0, info, serializationConstructorMarker) {
    Companion_getInstance_336();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_288().v57_1);
    }
    var $this = createThis(this);
    $this.x57_1 = info;
    return $this;
  }
}
class RestoreArsenalEvent {
  constructor() {
    RestoreArsenalEvent_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z57_1 = lazy(tmp_0, RestoreArsenalEvent$_anonymous__ua52or);
  }
  o37(gameState) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList.p2();
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = get_entries_2();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var list = getArsenal(gameState, element).e36();
      addAll(destination, list);
    }
    var arsenalToDiscard = toSet(destination);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!arsenalToDiscard.n1()) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = new CardsMoveChange(RevealedArsenalPlace_getInstance(), DiscardPlace_getInstance(), arsenalToDiscard);
      result.d2(element_0);
    }
    var ashRuinsAfterOpenDiscard = gameState.q4k().a4o(VOID, emptySet(), plus_2(gameState.q4k().w4n_1, gameState.q4k().v4n_1));
    var tmp;
    if (ashRuinsAfterOpenDiscard.u4n_1.n1()) {
      var discarded = toSet(ashRuinsAfterOpenDiscard.w4n_1);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!discarded.n1()) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_1 = new CardsMoveChange(DiscardPlace_getInstance(), ComingArsenalPlace_getInstance(), discarded);
        result.d2(element_1);
      }
      tmp = ashRuinsAfterOpenDiscard.a4o(ashRuinsAfterOpenDiscard.w4n_1, VOID, emptyList());
    } else {
      tmp = ashRuinsAfterOpenDiscard;
    }
    var refilledAshRuins = tmp;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_0 = get_entries_2();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = tmp0_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_2 = _iterator__ex2g4s_0.r1();
      var arsenal = element_2.equals(ArsenalType_AshRuinsArsenal_getInstance()) ? refilledAshRuins : getArsenal(gameState, element_2);
      var comingCards = arsenal.d36();
      // Inline function 'kotlin.math.max' call
      var a = comingCards.s2() - arsenal.i4n() | 0;
      var tmp$ret$11 = Math.max(a, 0);
      var list_0 = comingCards.t4(tmp$ret$11, comingCards.s2());
      addAll(destination_0, list_0);
    }
    var dealArsenalCards = toSet(destination_0);
    // Inline function 'kotlin.collections.plusAssign' call
    var element_3 = new CardsMoveChange(ComingArsenalPlace_getInstance(), RevealedArsenalPlace_getInstance(), dealArsenalCards);
    result.d2(element_3);
    return toList(result);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_284(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RestoreArsenalEvent';
  }
  hashCode() {
    return 1151129357;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RestoreArsenalEvent))
      return false;
    return true;
  }
}
class RestoreStuffEvent {
  constructor() {
    RestoreStuffEvent_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a58_1 = lazy(tmp_0, RestoreStuffEvent$_anonymous__gogx7h);
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList.p2();
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_allObjectOnBoard($context_GameStateRuntime_604ce3);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp;
      var tmp_0 = get_objectType($context_GameStateRuntime_604ce3, element);
      if (isInterface(tmp_0, AnimalType)) {
        tmp = true;
      } else {
        var tmp_1 = get_objectType($context_GameStateRuntime_604ce3, element);
        tmp = isInterface(tmp_1, SettlerType);
      }
      if (tmp) {
        destination.d2(element);
      }
    }
    var tmp_2 = destination;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = get_charactersInOrder($context_GameStateRuntime_604ce3);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = tmp0_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      var tmp_3;
      var tmp_4 = get_objectType($context_GameStateRuntime_604ce3, element_0);
      if (isInterface(tmp_4, HunterCharacter)) {
        tmp_3 = get_isDead($context_GameStateRuntime_604ce3, element_0);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        destination_0.d2(element_0);
      }
    }
    var restoringHpObjects = plus_2(tmp_2, destination_0);
    var _iterator__ex2g4s_1 = restoringHpObjects.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var objectOnBoard = _iterator__ex2g4s_1.r1();
      var maxHP = get_objectType($context_GameStateRuntime_604ce3, objectOnBoard).n2z($context_GameStateRuntime_604ce3);
      var hp = get_hp($context_GameStateRuntime_604ce3, objectOnBoard);
      if (!(hp === maxHP)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_1 = new HpChange(objectOnBoard, maxHP - hp | 0);
        result.d2(element_1);
      }
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!get_discardedDraftActionCards($context_GameStateRuntime_604ce3).n1()) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_2 = new CardsMoveChange(DiscardPlace_getInstance(), UnusedDraftActionCardPlace_getInstance(), toSet(get_discardedDraftActionCards($context_GameStateRuntime_604ce3)));
      result.d2(element_2);
    }
    var _iterator__ex2g4s_2 = get_charactersInOrder($context_GameStateRuntime_604ce3).p1();
    while (_iterator__ex2g4s_2.q1()) {
      var characterObject = _iterator__ex2g4s_2.r1();
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0_1 = get_hand($context_GameStateRuntime_604ce3, characterObject);
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination_1 = ArrayList.p2();
      var _iterator__ex2g4s_3 = tmp0_1.p1();
      while (_iterator__ex2g4s_3.q1()) {
        var element_3 = _iterator__ex2g4s_3.r1();
        if (!(element_3 == null) ? isInterface(element_3, DraftActionCard) : false) {
          destination_1.d2(element_3);
        }
      }
      var draftCardsInHand = destination_1;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!draftCardsInHand.n1()) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_4 = new CardsMoveChange(new HandPlace(characterObject), UnusedDraftActionCardPlace_getInstance(), toSet(draftCardsInHand));
        result.d2(element_4);
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!get_discardedAbilityCards($context_GameStateRuntime_604ce3, characterObject).n1()) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_5 = new CardsMoveChange(DiscardPlace_getInstance(), new HandPlace(characterObject), toSet(get_discardedAbilityCards($context_GameStateRuntime_604ce3, characterObject)));
        result.d2(element_5);
      }
    }
    return toList(result);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_285(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RestoreStuffEvent';
  }
  hashCode() {
    return 489390607;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RestoreStuffEvent))
      return false;
    return true;
  }
}
class Companion_336 {
  constructor() {
    Companion_instance_336 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b58_1 = [lazy(tmp_0, RestoringHunterAfterDeathEvent$Companion$$childSerializers$_anonymous__ikzlub)];
  }
}
class $serializer_290 {
  constructor() {
    $serializer_instance_289 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RestoringHunterAfterDeathEvent', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.c58_1 = tmp0_serialDesc;
  }
  d58(encoder, value) {
    var tmp0_desc = this.c58_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_337().b58_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.e58_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d58(encoder, value instanceof RestoringHunterAfterDeathEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c58_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_337().b58_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RestoringHunterAfterDeathEvent.f58(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.c58_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_337().b58_1[0].k3()];
  }
}
class RestoringHunterAfterDeathEvent {
  constructor(hunter) {
    Companion_getInstance_337();
    this.e58_1 = hunter;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf_0([new HpChange(this.e58_1, get_wounds($context_GameStateRuntime_604ce3, this.e58_1)), new ResurrectObjectChange(this.e58_1)]);
  }
  toString() {
    return 'RestoringHunterAfterDeathEvent(hunter=' + this.e58_1.toString() + ')';
  }
  hashCode() {
    return this.e58_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RestoringHunterAfterDeathEvent))
      return false;
    if (!this.e58_1.equals(other.e58_1))
      return false;
    return true;
  }
  static f58(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_337();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_289().c58_1);
    }
    var $this = createThis(this);
    $this.e58_1 = hunter;
    return $this;
  }
}
class Companion_337 {
  constructor() {
    Companion_instance_337 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RetrieveCardEvent$Companion$$childSerializers$_anonymous__uh7w2s);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g58_1 = [tmp_1, lazy(tmp_2, RetrieveCardEvent$Companion$$childSerializers$_anonymous__uh7w2s_0)];
  }
}
class $serializer_291 {
  constructor() {
    $serializer_instance_290 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RetrieveCardEvent', this, 2);
    tmp0_serialDesc.h1b('receiver', false);
    tmp0_serialDesc.h1b('card', false);
    this.h58_1 = tmp0_serialDesc;
  }
  i58(encoder, value) {
    var tmp0_desc = this.h58_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_338().g58_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.j58_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.k58_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i58(encoder, value instanceof RetrieveCardEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h58_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_338().g58_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RetrieveCardEvent.l58(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.h58_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_338().g58_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class RetrieveCardEvent {
  constructor(receiver, card) {
    Companion_getInstance_338();
    this.j58_1 = receiver;
    this.k58_1 = card;
  }
  o37($context_GameStateRuntime_604ce3) {
    var tmp;
    if (get_cardsInPlay($context_GameStateRuntime_604ce3).u4(this.k58_1)) {
      tmp = InPlayPlace_getInstance();
    } else if (contains(get_unusedDraftActionCards($context_GameStateRuntime_604ce3), this.k58_1)) {
      tmp = UnusedDraftActionCardPlace_getInstance();
    } else if (contains(get_discardedDraftActionCards($context_GameStateRuntime_604ce3), this.k58_1)) {
      tmp = DiscardPlace_getInstance();
    } else if (get_discardedAbilityCards($context_GameStateRuntime_604ce3, this.j58_1).w2(this.k58_1)) {
      tmp = DiscardPlace_getInstance();
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Cannot retrieve ' + toString(this.k58_1) + ' for ' + this.j58_1.toString();
      throw IllegalStateException.o(toString(message));
    }
    var place = tmp;
    return listOf(new CardsMoveChange(place, new HandPlace(this.j58_1), setOf(this.k58_1), inPlayPosition($context_GameStateRuntime_604ce3, this.k58_1)));
  }
  toString() {
    return 'RetrieveCardEvent(receiver=' + this.j58_1.toString() + ', card=' + toString(this.k58_1) + ')';
  }
  hashCode() {
    var result = this.j58_1.hashCode();
    result = imul(result, 31) + hashCode(this.k58_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RetrieveCardEvent))
      return false;
    if (!this.j58_1.equals(other.j58_1))
      return false;
    if (!equals(this.k58_1, other.k58_1))
      return false;
    return true;
  }
  static l58(seen0, receiver, card, serializationConstructorMarker) {
    Companion_getInstance_338();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_290().h58_1);
    }
    var $this = createThis(this);
    $this.j58_1 = receiver;
    $this.k58_1 = card;
    return $this;
  }
}
class Companion_338 {
  constructor() {
    Companion_instance_338 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m58_1 = [lazy(tmp_0, RevealBeastEvent$Companion$$childSerializers$_anonymous__mz9v5u)];
  }
}
class $serializer_292 {
  constructor() {
    $serializer_instance_291 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevealBeastEvent', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.n58_1 = tmp0_serialDesc;
  }
  o58(encoder, value) {
    var tmp0_desc = this.n58_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_339().m58_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p58_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o58(encoder, value instanceof RevealBeastEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n58_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_339().m58_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RevealBeastEvent.q58(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.n58_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_339().m58_1[0].k3()];
  }
}
class RevealBeastEvent {
  constructor(beast) {
    Companion_getInstance_339();
    this.p58_1 = beast;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new ClearingAfterRevealChange(this.p58_1));
  }
  toString() {
    return 'RevealBeastEvent(beast=' + this.p58_1.toString() + ')';
  }
  hashCode() {
    return this.p58_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealBeastEvent))
      return false;
    if (!this.p58_1.equals(other.p58_1))
      return false;
    return true;
  }
  static q58(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_339();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_291().n58_1);
    }
    var $this = createThis(this);
    $this.p58_1 = beast;
    return $this;
  }
}
class Companion_339 {
  constructor() {
    Companion_instance_339 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r58_1 = [null, lazy(tmp_0, RevealLastMovementsEvent$Companion$$childSerializers$_anonymous__pq9rld)];
  }
}
class $serializer_293 {
  constructor() {
    $serializer_instance_292 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevealLastMovementsEvent', this, 2);
    tmp0_serialDesc.h1b('movementsNumber', false);
    tmp0_serialDesc.h1b('beast', true);
    this.s58_1 = tmp0_serialDesc;
  }
  t58(encoder, value) {
    var tmp0_desc = this.s58_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_340().r58_1;
    tmp1_output.z14(tmp0_desc, 0, value.u58_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.v58_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.v58_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t58(encoder, value instanceof RevealLastMovementsEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s58_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_340().r58_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RevealLastMovementsEvent.w58(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.s58_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_340().r58_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), get_nullable(tmp0_cached[1].k3())];
  }
}
class RevealLastMovementsEvent {
  constructor(movementsNumber, beast) {
    Companion_getInstance_340();
    beast = beast === VOID ? null : beast;
    this.u58_1 = movementsNumber;
    this.v58_1 = beast;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList.p2();
    var tmp;
    if (this.v58_1 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = setOf(this.v58_1);
    }
    var tmp1_elvis_lhs = tmp;
    var beasts = tmp1_elvis_lhs == null ? get_aliveBeasts_0($context_GameStateRuntime_604ce3) : tmp1_elvis_lhs;
    var _iterator__ex2g4s = beasts.p1();
    while (_iterator__ex2g4s.q1()) {
      var beast = _iterator__ex2g4s.r1();
      var inductionVariable = 0;
      var last = this.u58_1;
      if (inductionVariable < last)
        $l$loop: do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var index = (get_beastMovements($context_GameStateRuntime_604ce3, beast).s2() - i | 0) - 1 | 0;
          if (index < 0)
            break $l$loop;
          if (get_beastMovements($context_GameStateRuntime_604ce3, beast).u2(index).m3g()) {
            this_0.d2(new Pair(beast, index));
          }
        }
         while (inductionVariable < last);
    }
    var toChanges = this_0.g9();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(toChanges, 10));
    var _iterator__ex2g4s_0 = toChanges.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var beast_0 = item.jm();
      var index_0 = item.km();
      var tmp$ret$8 = new RevealLastMovementsChange(beast_0, index_0, true, get_beastMovements($context_GameStateRuntime_604ce3, beast_0).u2(index_0).j3g_1);
      destination.d2(tmp$ret$8);
    }
    return destination;
  }
  toString() {
    return 'RevealLastMovementsEvent(movementsNumber=' + this.u58_1 + ', beast=' + toString_0(this.v58_1) + ')';
  }
  hashCode() {
    var result = this.u58_1;
    result = imul(result, 31) + (this.v58_1 == null ? 0 : this.v58_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealLastMovementsEvent))
      return false;
    if (!(this.u58_1 === other.u58_1))
      return false;
    if (!equals(this.v58_1, other.v58_1))
      return false;
    return true;
  }
  static w58(seen0, movementsNumber, beast, serializationConstructorMarker) {
    Companion_getInstance_340();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_292().s58_1);
    }
    var $this = createThis(this);
    $this.u58_1 = movementsNumber;
    if (0 === (seen0 & 2))
      $this.v58_1 = null;
    else
      $this.v58_1 = beast;
    return $this;
  }
}
class Companion_340 {
  constructor() {
    Companion_instance_340 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RevealLeadsToLocationTypeEvent$Companion$$childSerializers$_anonymous__5vd1l0);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x58_1 = [tmp_1, lazy(tmp_2, RevealLeadsToLocationTypeEvent$Companion$$childSerializers$_anonymous__5vd1l0_0), null];
  }
}
class $serializer_294 {
  constructor() {
    $serializer_instance_293 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevealLeadsToLocationTypeEvent', this, 3);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('locationType', false);
    tmp0_serialDesc.h1b('indexOfMovementCard', false);
    this.y58_1 = tmp0_serialDesc;
  }
  z58(encoder, value) {
    var tmp0_desc = this.y58_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_341().x58_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a59_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.b59_1);
    tmp1_output.z14(tmp0_desc, 2, value.c59_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z58(encoder, value instanceof RevealLeadsToLocationTypeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y58_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_341().x58_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return RevealLeadsToLocationTypeEvent.d59(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.y58_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_341().x58_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), IntSerializer_getInstance()];
  }
}
class RevealLeadsToLocationTypeEvent {
  constructor(beast, locationType, indexOfMovementCard) {
    Companion_getInstance_341();
    this.a59_1 = beast;
    this.b59_1 = locationType;
    this.c59_1 = indexOfMovementCard;
  }
  o37($context_GameStateRuntime_604ce3) {
    var beastMovements = get_beastMovements($context_GameStateRuntime_604ce3, this.a59_1);
    return listOf(new RevealLastMovementsChange(this.a59_1, this.c59_1, beastMovements.u2(this.c59_1).k3g_1, this.b59_1));
  }
  toString() {
    return 'RevealLeadsToLocationTypeEvent(beast=' + this.a59_1.toString() + ', locationType=' + this.b59_1.toString() + ', indexOfMovementCard=' + this.c59_1 + ')';
  }
  hashCode() {
    var result = this.a59_1.hashCode();
    result = imul(result, 31) + this.b59_1.hashCode() | 0;
    result = imul(result, 31) + this.c59_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealLeadsToLocationTypeEvent))
      return false;
    if (!this.a59_1.equals(other.a59_1))
      return false;
    if (!this.b59_1.equals(other.b59_1))
      return false;
    if (!(this.c59_1 === other.c59_1))
      return false;
    return true;
  }
  static d59(seen0, beast, locationType, indexOfMovementCard, serializationConstructorMarker) {
    Companion_getInstance_341();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_293().y58_1);
    }
    var $this = createThis(this);
    $this.a59_1 = beast;
    $this.b59_1 = locationType;
    $this.c59_1 = indexOfMovementCard;
    return $this;
  }
}
class Companion_341 {
  constructor() {
    Companion_instance_341 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e59_1 = [lazy(tmp_0, RevealMovementCardEvent$Companion$$childSerializers$_anonymous__sa3e4c), null];
  }
}
class $serializer_295 {
  constructor() {
    $serializer_instance_294 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevealMovementCardEvent', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('indexOfMovementCard', false);
    this.f59_1 = tmp0_serialDesc;
  }
  g59(encoder, value) {
    var tmp0_desc = this.f59_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_342().e59_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h59_1);
    tmp1_output.z14(tmp0_desc, 1, value.i59_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g59(encoder, value instanceof RevealMovementCardEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f59_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_342().e59_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RevealMovementCardEvent.j59(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.f59_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_342().e59_1[0].k3(), IntSerializer_getInstance()];
  }
}
class RevealMovementCardEvent {
  constructor(beast, indexOfMovementCard) {
    Companion_getInstance_342();
    this.h59_1 = beast;
    this.i59_1 = indexOfMovementCard;
  }
  o37($context_GameStateRuntime_604ce3) {
    var movementState = get_beastMovements($context_GameStateRuntime_604ce3, this.h59_1).u2(this.i59_1);
    return listOf(new RevealLastMovementsChange(this.h59_1, this.i59_1, true, movementState.j3g_1));
  }
  toString() {
    return 'RevealMovementCardEvent(beast=' + this.h59_1.toString() + ', indexOfMovementCard=' + this.i59_1 + ')';
  }
  hashCode() {
    var result = this.h59_1.hashCode();
    result = imul(result, 31) + this.i59_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealMovementCardEvent))
      return false;
    if (!this.h59_1.equals(other.h59_1))
      return false;
    if (!(this.i59_1 === other.i59_1))
      return false;
    return true;
  }
  static j59(seen0, beast, indexOfMovementCard, serializationConstructorMarker) {
    Companion_getInstance_342();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_294().f59_1);
    }
    var $this = createThis(this);
    $this.h59_1 = beast;
    $this.i59_1 = indexOfMovementCard;
    return $this;
  }
}
class Companion_342 {
  constructor() {
    Companion_instance_342 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k59_1 = [lazy(tmp_0, RevertLastBeastMovementEvent$Companion$$childSerializers$_anonymous__zasyck)];
  }
}
class $serializer_296 {
  constructor() {
    $serializer_instance_295 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevertLastBeastMovementEvent', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.l59_1 = tmp0_serialDesc;
  }
  m59(encoder, value) {
    var tmp0_desc = this.l59_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_343().k59_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n59_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m59(encoder, value instanceof RevertLastBeastMovementEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l59_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_343().k59_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RevertLastBeastMovementEvent.o59(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l59_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_343().k59_1[0].k3()];
  }
}
class RevertLastBeastMovementEvent$stateChanges$$inlined$groupingBy$1 {
  constructor($this) {
    this.p59_1 = $this;
  }
  n7() {
    return this.p59_1.p1();
  }
  f10(element) {
    return new BoardPosition(element.v3g_1);
  }
  o7(element) {
    return this.f10(element);
  }
}
class RevertLastBeastMovementEvent {
  constructor(beast) {
    Companion_getInstance_343();
    this.n59_1 = beast;
  }
  o37($context_GameStateRuntime_604ce3) {
    var beastMovements = get_beastMovements($context_GameStateRuntime_604ce3, this.n59_1);
    if (beastMovements.n1())
      return emptyList();
    var lastMovement = last(beastMovements);
    var tmp;
    if (equals(lastMovement.n3g(), NoMovement_getInstance())) {
      var falseMovementsNumber = lastMovement.i3g_1.s2() - 1 | 0;
      var tmp_0;
      if (falseMovementsNumber === 0) {
        tmp_0 = get_beastPath($context_GameStateRuntime_604ce3, this.n59_1);
      } else {
        var lastStep = last(get_beastPath($context_GameStateRuntime_604ce3, this.n59_1));
        // Inline function 'kotlin.require' call
        if (!(lastStep.x3f_1.s2() > falseMovementsNumber)) {
          var message = 'Cannot remove ' + falseMovementsNumber + ' false movements from ' + lastStep.toString();
          throw IllegalArgumentException.h2(toString(message));
        }
        tmp_0 = plus_1(dropLast(get_beastPath($context_GameStateRuntime_604ce3, this.n59_1), 1), lastStep.e3g(dropLast(lastStep.x3f_1, falseMovementsNumber)));
      }
      tmp = tmp_0;
    } else {
      tmp = dropLast(get_beastPath($context_GameStateRuntime_604ce3, this.n59_1), 1);
    }
    var nextBeastPath = tmp;
    // Inline function 'kotlin.collections.flatMapIndexed' call
    // Inline function 'kotlin.collections.flatMapIndexedTo' call
    var destination = ArrayList.p2();
    var index = 0;
    var _iterator__ex2g4s = nextBeastPath.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var list = checkIndexOverflow(_unary__edvuaz) === 0 ? drop(element.x3f_1, 1) : element.x3f_1;
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.groupingBy' call
    var tmp$ret$5 = new RevertLastBeastMovementEvent$stateChanges$$inlined$groupingBy$1(destination);
    var possibleTrailCountsAfterChange = eachCount(tmp$ret$5);
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = get_foundTrails($context_GameStateRuntime_604ce3, this.n59_1);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = tmp0.i3().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      // Inline function 'kotlin.collections.component1' call
      var position = element_0.j3().r2v_1;
      // Inline function 'kotlin.collections.component2' call
      var foundCount = element_0.k3();
      var tmp0_elvis_lhs = possibleTrailCountsAfterChange.w4(new BoardPosition(position));
      // Inline function 'kotlin.comparisons.minOf' call
      var b = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var remainingCount = Math.min(foundCount, b);
      // Inline function 'kotlin.takeIf' call
      var this_0 = new BoardPosition(position);
      var tmp_1;
      this_0.r2v_1;
      if (remainingCount > 0) {
        tmp_1 = this_0;
      } else {
        tmp_1 = null;
      }
      var tmp_2 = tmp_1;
      var tmp1_safe_receiver = tmp_2 == null ? null : tmp_2.r2v_1;
      var tmp_3;
      var tmp_4 = tmp1_safe_receiver;
      if ((tmp_4 == null ? null : new BoardPosition(tmp_4)) == null) {
        tmp_3 = null;
      } else {
        var tmp_5 = tmp1_safe_receiver;
        // Inline function 'kotlin.let' call
        var it = (tmp_5 == null ? null : new BoardPosition(tmp_5)).r2v_1;
        tmp_3 = to(new BoardPosition(it), remainingCount);
      }
      var tmp0_safe_receiver = tmp_3;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.d2(tmp0_safe_receiver);
      }
    }
    var nextFoundTrails = toMap_0(destination_0);
    var tmp0_safe_receiver_0 = lastOrNull(nextBeastPath);
    var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.c3g();
    var tmp2_elvis_lhs = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.v3g_1;
    var tmp_6;
    var tmp_7 = tmp2_elvis_lhs;
    if ((tmp_7 == null ? null : new BoardPosition(tmp_7)) == null) {
      tmp_6 = get_lastSeenPosition($context_GameStateRuntime_604ce3, this.n59_1);
    } else {
      tmp_6 = tmp2_elvis_lhs;
    }
    var nextPosition = tmp_6;
    return listOf(new SetBeastMovementInfoAndTrailsChange(this.n59_1, nextPosition, nextBeastPath, dropLast(beastMovements, 1), nextFoundTrails));
  }
  toString() {
    return 'RevertLastBeastMovementEvent(beast=' + this.n59_1.toString() + ')';
  }
  hashCode() {
    return this.n59_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertLastBeastMovementEvent))
      return false;
    if (!this.n59_1.equals(other.n59_1))
      return false;
    return true;
  }
  static o59(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_343();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_295().l59_1);
    }
    var $this = createThis(this);
    $this.n59_1 = beast;
    return $this;
  }
}
class Companion_343 {
  constructor() {
    Companion_instance_343 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, SetTrapEvent$Companion$$childSerializers$_anonymous__f953b3);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, SetTrapEvent$Companion$$childSerializers$_anonymous__f953b3_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, SetTrapEvent$Companion$$childSerializers$_anonymous__f953b3_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q59_1 = [tmp_1, tmp_3, tmp_5, lazy(tmp_6, SetTrapEvent$Companion$$childSerializers$_anonymous__f953b3_2), null];
  }
}
class $serializer_297 {
  constructor() {
    $serializer_instance_296 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetTrapEvent', this, 5);
    tmp0_serialDesc.h1b('trap', false);
    tmp0_serialDesc.h1b('locationType', false);
    tmp0_serialDesc.h1b('zone', false);
    tmp0_serialDesc.h1b('owner', false);
    tmp0_serialDesc.h1b('revisionBeforePlacement', false);
    this.r59_1 = tmp0_serialDesc;
  }
  s59(encoder, value) {
    var tmp0_desc = this.r59_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_344().q59_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t59_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.u59_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.v59_1);
    tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.w59_1);
    tmp1_output.z14(tmp0_desc, 4, value.x59_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s59(encoder, value instanceof SetTrapEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r59_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_344().q59_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.u13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.u13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return SetTrapEvent.y59(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.r59_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_344().q59_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), tmp0_cached[3].k3(), IntSerializer_getInstance()];
  }
}
class SetTrapEvent {
  constructor(trap, locationType, zone, owner, revisionBeforePlacement) {
    Companion_getInstance_344();
    this.t59_1 = trap;
    this.u59_1 = locationType;
    this.v59_1 = zone;
    this.w59_1 = owner;
    this.x59_1 = revisionBeforePlacement;
  }
  o37($context_GameStateRuntime_604ce3) {
    var trapsInZone = ensureNotNull(get_placedTrapsCardsInfo($context_GameStateRuntime_604ce3).w4(this.v59_1));
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(trapsInZone.s2() < get_maxTrapsInZone($context_GameStateRuntime_604ce3))) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message));
    }
    var from = get_place($context_GameStateRuntime_604ce3, this.t59_1);
    return listOf_0([new AddTrapInfoChange(this.t59_1, this.u59_1, this.v59_1, this.w59_1, this.x59_1), new CardsMoveChange(from, new TrapZonePlace(this.v59_1), setOf(this.t59_1), inPlayPosition($context_GameStateRuntime_604ce3, this.t59_1))]);
  }
  toString() {
    return 'SetTrapEvent(trap=' + toString(this.t59_1) + ', locationType=' + this.u59_1.toString() + ', zone=' + this.v59_1.toString() + ', owner=' + this.w59_1.toString() + ', revisionBeforePlacement=' + this.x59_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.t59_1);
    result = imul(result, 31) + this.u59_1.hashCode() | 0;
    result = imul(result, 31) + this.v59_1.hashCode() | 0;
    result = imul(result, 31) + this.w59_1.hashCode() | 0;
    result = imul(result, 31) + this.x59_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetTrapEvent))
      return false;
    if (!equals(this.t59_1, other.t59_1))
      return false;
    if (!this.u59_1.equals(other.u59_1))
      return false;
    if (!this.v59_1.equals(other.v59_1))
      return false;
    if (!this.w59_1.equals(other.w59_1))
      return false;
    if (!(this.x59_1 === other.x59_1))
      return false;
    return true;
  }
  static y59(seen0, trap, locationType, zone, owner, revisionBeforePlacement, serializationConstructorMarker) {
    Companion_getInstance_344();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_296().r59_1);
    }
    var $this = createThis(this);
    $this.t59_1 = trap;
    $this.u59_1 = locationType;
    $this.v59_1 = zone;
    $this.w59_1 = owner;
    $this.x59_1 = revisionBeforePlacement;
    return $this;
  }
}
class Companion_344 {
  constructor() {
    Companion_instance_344 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z59_1 = [lazy(tmp_0, SpendGrudgesEvent$Companion$$childSerializers$_anonymous__67zgfh), null];
  }
}
class $serializer_298 {
  constructor() {
    $serializer_instance_297 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SpendGrudgesEvent', this, 2);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('grudgesNumber', false);
    this.a5a_1 = tmp0_serialDesc;
  }
  b5a(encoder, value) {
    var tmp0_desc = this.a5a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_345().z59_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c5a_1);
    tmp1_output.z14(tmp0_desc, 1, value.d5a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b5a(encoder, value instanceof SpendGrudgesEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a5a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_345().z59_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SpendGrudgesEvent.e5a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.a5a_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_345().z59_1[0].k3(), IntSerializer_getInstance()];
  }
}
class SpendGrudgesEvent {
  constructor(actor, grudgesNumber) {
    Companion_getInstance_345();
    this.c5a_1 = actor;
    this.d5a_1 = grudgesNumber;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new GrudgesChange(this.c5a_1, -this.d5a_1 | 0));
  }
  toString() {
    return 'SpendGrudgesEvent(actor=' + this.c5a_1.toString() + ', grudgesNumber=' + this.d5a_1 + ')';
  }
  hashCode() {
    var result = this.c5a_1.hashCode();
    result = imul(result, 31) + this.d5a_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpendGrudgesEvent))
      return false;
    if (!this.c5a_1.equals(other.c5a_1))
      return false;
    if (!(this.d5a_1 === other.d5a_1))
      return false;
    return true;
  }
  static e5a(seen0, actor, grudgesNumber, serializationConstructorMarker) {
    Companion_getInstance_345();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_297().a5a_1);
    }
    var $this = createThis(this);
    $this.c5a_1 = actor;
    $this.d5a_1 = grudgesNumber;
    return $this;
  }
}
class Companion_345 {
  constructor() {
    Companion_instance_345 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f5a_1 = [lazy(tmp_0, StartPhaseEvent$Companion$$childSerializers$_anonymous__xdz5h3)];
  }
}
class $serializer_299 {
  constructor() {
    $serializer_instance_298 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('StartPhaseEvent', this, 1);
    tmp0_serialDesc.h1b('phase', false);
    this.g5a_1 = tmp0_serialDesc;
  }
  h5a(encoder, value) {
    var tmp0_desc = this.g5a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_346().f5a_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i5a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h5a(encoder, value instanceof StartPhaseEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g5a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_346().f5a_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return StartPhaseEvent.j5a(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g5a_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_346().f5a_1[0].k3()];
  }
}
class StartPhaseEvent {
  constructor(phase) {
    Companion_getInstance_346();
    this.i5a_1 = phase;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList.p2();
    var tmp;
    var tmp_0 = this.i5a_1;
    if (tmp_0 instanceof PlayerTurnPhase) {
      tmp = get_charactersInOrder($context_GameStateRuntime_604ce3).y2(this.i5a_1.x4g_1) === 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      this_0.d2(new SetDayNumberAndTurnChange(get_currentDayNumber($context_GameStateRuntime_604ce3), get_currentTurnNumber($context_GameStateRuntime_604ce3) + 1 | 0));
    }
    return this_0.g9();
  }
  toString() {
    return 'StartPhaseEvent(phase=' + toString(this.i5a_1) + ')';
  }
  hashCode() {
    return hashCode(this.i5a_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StartPhaseEvent))
      return false;
    if (!equals(this.i5a_1, other.i5a_1))
      return false;
    return true;
  }
  static j5a(seen0, phase, serializationConstructorMarker) {
    Companion_getInstance_346();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_298().g5a_1);
    }
    var $this = createThis(this);
    $this.i5a_1 = phase;
    return $this;
  }
}
class Companion_346 {
  constructor() {
    Companion_instance_346 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, StartResolveCardEvent$Companion$$childSerializers$_anonymous__baxwqy);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, StartResolveCardEvent$Companion$$childSerializers$_anonymous__baxwqy_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, StartResolveCardEvent$Companion$$childSerializers$_anonymous__baxwqy_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k5a_1 = [tmp_1, tmp_3, tmp_5, lazy(tmp_6, StartResolveCardEvent$Companion$$childSerializers$_anonymous__baxwqy_2)];
  }
}
class $serializer_300 {
  constructor() {
    $serializer_instance_299 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('StartResolveCardEvent', this, 4);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('from', false);
    tmp0_serialDesc.h1b('card', false);
    tmp0_serialDesc.h1b('resolvingKind', false);
    this.l5a_1 = tmp0_serialDesc;
  }
  m5a(encoder, value) {
    var tmp0_desc = this.l5a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_347().k5a_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n5a_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.o5a_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.p5a_1);
    tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.q5a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m5a(encoder, value instanceof StartResolveCardEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l5a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_347().k5a_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, tmp9_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, tmp9_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return StartResolveCardEvent.r5a(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.l5a_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_347().k5a_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), tmp0_cached[3].k3()];
  }
}
class StartResolveCardEvent {
  constructor(actor, from, card, resolvingKind) {
    Companion_getInstance_347();
    this.n5a_1 = actor;
    this.o5a_1 = from;
    this.p5a_1 = card;
    this.q5a_1 = resolvingKind;
  }
  o37($context_GameStateRuntime_604ce3) {
    var isTrapActivation = equals(this.q5a_1, Trap_getInstance());
    var playedFromPosition = isTrapActivation ? null : this.n5a_1.s2w($context_GameStateRuntime_604ce3);
    var changes = listOf(new CardsMoveChange(this.o5a_1, InPlayPlace_getInstance(), setOf(this.p5a_1), playedFromPosition));
    var tmp;
    var tmp_0;
    if (isTrapActivation) {
      var tmp_1 = this.p5a_1;
      tmp_0 = isInterface(tmp_1, TrapCard);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = get_placedTrapsFullInfo($context_GameStateRuntime_604ce3).u4(this.p5a_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      return plus_1(changes, new RemoveTrapInfoChange(this.p5a_1));
    }
    return changes;
  }
  toString() {
    return 'StartResolveCardEvent(actor=' + this.n5a_1.toString() + ', from=' + toString(this.o5a_1) + ', card=' + toString(this.p5a_1) + ', resolvingKind=' + toString(this.q5a_1) + ')';
  }
  hashCode() {
    var result = this.n5a_1.hashCode();
    result = imul(result, 31) + hashCode(this.o5a_1) | 0;
    result = imul(result, 31) + hashCode(this.p5a_1) | 0;
    result = imul(result, 31) + hashCode(this.q5a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StartResolveCardEvent))
      return false;
    if (!this.n5a_1.equals(other.n5a_1))
      return false;
    if (!equals(this.o5a_1, other.o5a_1))
      return false;
    if (!equals(this.p5a_1, other.p5a_1))
      return false;
    if (!equals(this.q5a_1, other.q5a_1))
      return false;
    return true;
  }
  static r5a(seen0, actor, from, card, resolvingKind, serializationConstructorMarker) {
    Companion_getInstance_347();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_299().l5a_1);
    }
    var $this = createThis(this);
    $this.n5a_1 = actor;
    $this.o5a_1 = from;
    $this.p5a_1 = card;
    $this.q5a_1 = resolvingKind;
    return $this;
  }
}
class Companion_347 {}
class $serializer_301 {
  constructor() {
    $serializer_instance_300 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SubmitDamageBlockChangeEvent', this, 1);
    tmp0_serialDesc.h1b('addingBlock', false);
    this.s5a_1 = tmp0_serialDesc;
  }
  t5a(encoder, value) {
    var tmp0_desc = this.s5a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_124(), value.u5a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t5a(encoder, value instanceof SubmitDamageBlockChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s5a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_124(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_124(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SubmitDamageBlockChangeEvent.v5a(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s5a_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_124()];
  }
}
class SubmitDamageBlockChangeEvent {
  constructor(addingBlock) {
    this.u5a_1 = addingBlock;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new DamageBlockChange(plus_1(get_damageBlocked($context_GameStateRuntime_604ce3), this.u5a_1)));
  }
  toString() {
    return 'SubmitDamageBlockChangeEvent(addingBlock=' + this.u5a_1.toString() + ')';
  }
  hashCode() {
    return this.u5a_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SubmitDamageBlockChangeEvent))
      return false;
    if (!this.u5a_1.equals(other.u5a_1))
      return false;
    return true;
  }
  static v5a(seen0, addingBlock, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_300().s5a_1);
    }
    var $this = createThis(this);
    $this.u5a_1 = addingBlock;
    return $this;
  }
}
class Companion_348 {}
class $serializer_302 {
  constructor() {
    $serializer_instance_301 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SubmitDamageEvent', this, 1);
    tmp0_serialDesc.h1b('submittedDamage', false);
    this.w5a_1 = tmp0_serialDesc;
  }
  x5a(encoder, value) {
    var tmp0_desc = this.w5a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_123(), value.y5a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x5a(encoder, value instanceof SubmitDamageEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w5a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SubmitDamageEvent.z5a(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w5a_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_123()];
  }
}
class SubmitDamageEvent {
  constructor(submittedDamage) {
    this.y5a_1 = submittedDamage;
  }
  o37($context_GameStateRuntime_604ce3) {
    if (!(get_submittedCurrentDamage($context_GameStateRuntime_604ce3) == null)) {
      // Inline function 'kotlin.error' call
      var message = 'Current damage is already submitted, ' + this.y5a_1.toString();
      throw IllegalStateException.o(toString(message));
    }
    return listOf(new SubmittedDamageChange(this.y5a_1));
  }
  toString() {
    return 'SubmitDamageEvent(submittedDamage=' + this.y5a_1.toString() + ')';
  }
  hashCode() {
    return this.y5a_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SubmitDamageEvent))
      return false;
    if (!this.y5a_1.equals(other.y5a_1))
      return false;
    return true;
  }
  static z5a(seen0, submittedDamage, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_301().w5a_1);
    }
    var $this = createThis(this);
    $this.y5a_1 = submittedDamage;
    return $this;
  }
}
class Companion_349 {
  constructor() {
    Companion_instance_349 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a5b_1 = [lazy(tmp_0, TrailsRevealedEvent$Companion$$childSerializers$_anonymous__xox2d3)];
  }
}
class $serializer_303 {
  constructor() {
    $serializer_instance_302 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TrailsRevealedEvent', this, 1);
    tmp0_serialDesc.h1b('newTrails', false);
    this.b5b_1 = tmp0_serialDesc;
  }
  c5b(encoder, value) {
    var tmp0_desc = this.b5b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_350().a5b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d5b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c5b(encoder, value instanceof TrailsRevealedEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b5b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_350().a5b_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return TrailsRevealedEvent.e5b(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b5b_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_350().a5b_1[0].k3()];
  }
}
class TrailsRevealedEvent {
  constructor(newTrails) {
    Companion_getInstance_350();
    this.d5b_1 = newTrails;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.d5b_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(this_0.s2());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this_0.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var beast = item.j3();
      // Inline function 'kotlin.collections.component2' call
      var trails = item.k3();
      var tmp0 = trails.i3();
      // Inline function 'kotlin.collections.fold' call
      var accumulator = get_foundTrails($context_GameStateRuntime_604ce3, beast);
      var _iterator__ex2g4s_0 = tmp0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element = _iterator__ex2g4s_0.r1();
        var total = accumulator;
        // Inline function 'kotlin.collections.component1' call
        var position = element.j3().r2v_1;
        // Inline function 'kotlin.collections.component2' call
        var newlyFound = element.k3();
        // Inline function 'kotlin.collections.getOrElse' call
        var key = new BoardPosition(position);
        var tmp0_elvis_lhs = total.w4(key);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          tmp = 0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp$ret$10 = tmp;
        accumulator = plus_3(total, to(new BoardPosition(position), tmp$ret$10 + newlyFound | 0));
      }
      var totalFoundTrails = accumulator;
      var tmp$ret$3 = new TrailsRevealedChange(beast, totalFoundTrails);
      destination.d2(tmp$ret$3);
    }
    return destination;
  }
  toString() {
    return 'TrailsRevealedEvent(newTrails=' + toString(this.d5b_1) + ')';
  }
  hashCode() {
    return hashCode(this.d5b_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrailsRevealedEvent))
      return false;
    if (!equals(this.d5b_1, other.d5b_1))
      return false;
    return true;
  }
  static e5b(seen0, newTrails, serializationConstructorMarker) {
    Companion_getInstance_350();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_302().b5b_1);
    }
    var $this = createThis(this);
    $this.d5b_1 = newTrails;
    return $this;
  }
}
class Companion_350 {
  constructor() {
    Companion_instance_350 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, TransformLocationsEvent$Companion$$childSerializers$_anonymous__iljqbi);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f5b_1 = [null, tmp_1, lazy(tmp_2, TransformLocationsEvent$Companion$$childSerializers$_anonymous__iljqbi_0)];
  }
}
class $serializer_304 {
  constructor() {
    $serializer_instance_303 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TransformLocationsEvent', this, 3);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('positions', false);
    tmp0_serialDesc.h1b('newLocationType', false);
    this.g5b_1 = tmp0_serialDesc;
  }
  h5b(encoder, value) {
    var tmp0_desc = this.g5b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_351().f5b_1;
    tmp1_output.i15(tmp0_desc, 0, $serializer_364.y2o(Companion_instance_420.a2g()), value.i5b_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.j5b_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.k5b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h5b(encoder, value instanceof TransformLocationsEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g5b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_351().f5b_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.d14(tmp0_desc, 0, $serializer_364.y2o(Companion_instance_420.a2g()), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.d14(tmp0_desc, 0, $serializer_364.y2o(Companion_instance_420.a2g()), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return TransformLocationsEvent.l5b(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.g5b_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_351().f5b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_364.y2o(Companion_instance_420.a2g())), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class TransformLocationsEvent {
  constructor(actor, positions, newLocationType) {
    Companion_getInstance_351();
    this.i5b_1 = actor;
    this.j5b_1 = positions;
    this.k5b_1 = newLocationType;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.j5b_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var it = element.r2v_1;
      if (!get_locationType($context_GameStateRuntime_604ce3, it).equals(this.k5b_1)) {
        destination.d2(element);
      }
    }
    var actuallyChanging = destination;
    if (actuallyChanging.n1())
      return emptyList();
    // Inline function 'kotlin.collections.associateWith' call
    var result = LinkedHashMap.cd(coerceAtLeast(mapCapacity(collectionSizeOrDefault(actuallyChanging, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var _iterator__ex2g4s_0 = actuallyChanging.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      element_0.r2v_1;
      var tmp$ret$5 = this.k5b_1;
      result.b5(element_0, tmp$ret$5);
    }
    return listOf(new TransformLocationsChange(result));
  }
  toString() {
    return 'TransformLocationsEvent(actor=' + toString_0(this.i5b_1) + ', positions=' + toString(this.j5b_1) + ', newLocationType=' + this.k5b_1.toString() + ')';
  }
  hashCode() {
    var result = this.i5b_1 == null ? 0 : this.i5b_1.hashCode();
    result = imul(result, 31) + hashCode(this.j5b_1) | 0;
    result = imul(result, 31) + this.k5b_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TransformLocationsEvent))
      return false;
    if (!equals(this.i5b_1, other.i5b_1))
      return false;
    if (!equals(this.j5b_1, other.j5b_1))
      return false;
    if (!this.k5b_1.equals(other.k5b_1))
      return false;
    return true;
  }
  static l5b(seen0, actor, positions, newLocationType, serializationConstructorMarker) {
    Companion_getInstance_351();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_303().g5b_1);
    }
    var $this = createThis(this);
    $this.i5b_1 = actor;
    $this.j5b_1 = positions;
    $this.k5b_1 = newLocationType;
    return $this;
  }
}
class Companion_351 {
  constructor() {
    Companion_instance_351 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, UpgradeEvent$Companion$$childSerializers$_anonymous__kjl584);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m5b_1 = [tmp_1, lazy(tmp_2, UpgradeEvent$Companion$$childSerializers$_anonymous__kjl584_0)];
  }
}
class $serializer_305 {
  constructor() {
    $serializer_instance_304 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UpgradeEvent', this, 2);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('upgrade', false);
    this.n5b_1 = tmp0_serialDesc;
  }
  o5b(encoder, value) {
    var tmp0_desc = this.n5b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_352().m5b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p5b_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.q5b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o5b(encoder, value instanceof UpgradeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n5b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_352().m5b_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return UpgradeEvent.r5b(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.n5b_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_352().m5b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class UpgradeEvent {
  constructor(actor, upgrade) {
    Companion_getInstance_352();
    this.p5b_1 = actor;
    this.q5b_1 = upgrade;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new UpgradeChange(this.p5b_1, this.q5b_1));
  }
  toString() {
    return 'UpgradeEvent(actor=' + this.p5b_1.toString() + ', upgrade=' + toString(this.q5b_1) + ')';
  }
  hashCode() {
    var result = this.p5b_1.hashCode();
    result = imul(result, 31) + hashCode(this.q5b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UpgradeEvent))
      return false;
    if (!this.p5b_1.equals(other.p5b_1))
      return false;
    if (!equals(this.q5b_1, other.q5b_1))
      return false;
    return true;
  }
  static r5b(seen0, actor, upgrade, serializationConstructorMarker) {
    Companion_getInstance_352();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_304().n5b_1);
    }
    var $this = createThis(this);
    $this.p5b_1 = actor;
    $this.q5b_1 = upgrade;
    return $this;
  }
}
class Companion_352 {
  constructor() {
    Companion_instance_352 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s5b_1 = lazy(tmp_0, MarkerGameStateEvent$Companion$_anonymous__asbmhy);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_286(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_353 {
  a2g() {
    var tmp = getKClass(ObjectMovement);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(HiddenBeastMovement), getKClass(OpenObjectMovement)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_306(), $serializer_getInstance_305()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.ObjectMovement', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class ObjectMovement {}
class Companion_354 {
  constructor() {
    Companion_instance_354 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, OpenObjectMovement$Companion$$childSerializers$_anonymous__1efvw2);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t5b_1 = [tmp_1, lazy(tmp_2, OpenObjectMovement$Companion$$childSerializers$_anonymous__1efvw2_0), null];
  }
}
class $serializer_306 {
  constructor() {
    $serializer_instance_305 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OpenObjectMovement', this, 3);
    tmp0_serialDesc.h1b('movedObject', false);
    tmp0_serialDesc.h1b('path', false);
    tmp0_serialDesc.h1b('isRelocation', false);
    this.u5b_1 = tmp0_serialDesc;
  }
  v5b(encoder, value) {
    var tmp0_desc = this.u5b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_355().t5b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k56_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.l56_1);
    tmp1_output.w14(tmp0_desc, 2, value.m56_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v5b(encoder, value instanceof OpenObjectMovement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u5b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_355().t5b_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return OpenObjectMovement.w5b(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.u5b_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_355().t5b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), BooleanSerializer_getInstance()];
  }
}
class OpenObjectMovement {
  constructor(movedObject, path, isRelocation) {
    Companion_getInstance_355();
    this.k56_1 = movedObject;
    this.l56_1 = path;
    this.m56_1 = isRelocation;
  }
  toString() {
    return 'OpenObjectMovement(movedObject=' + this.k56_1.toString() + ', path=' + toString(this.l56_1) + ', isRelocation=' + this.m56_1 + ')';
  }
  hashCode() {
    var result = this.k56_1.hashCode();
    result = imul(result, 31) + hashCode(this.l56_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m56_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenObjectMovement))
      return false;
    if (!this.k56_1.equals(other.k56_1))
      return false;
    if (!equals(this.l56_1, other.l56_1))
      return false;
    if (!(this.m56_1 === other.m56_1))
      return false;
    return true;
  }
  static w5b(seen0, movedObject, path, isRelocation, serializationConstructorMarker) {
    Companion_getInstance_355();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_305().u5b_1);
    }
    var $this = createThis(this);
    $this.k56_1 = movedObject;
    $this.l56_1 = path;
    $this.m56_1 = isRelocation;
    return $this;
  }
}
class Companion_355 {
  constructor() {
    Companion_instance_355 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, HiddenBeastMovement$Companion$$childSerializers$_anonymous__uv3w3e);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x5b_1 = [tmp_1, lazy(tmp_2, HiddenBeastMovement$Companion$$childSerializers$_anonymous__uv3w3e_0), null];
  }
}
class $serializer_307 {
  constructor() {
    $serializer_instance_306 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HiddenBeastMovement', this, 3);
    tmp0_serialDesc.h1b('movedObject', false);
    tmp0_serialDesc.h1b('path', false);
    tmp0_serialDesc.h1b('isRelocation', false);
    this.y5b_1 = tmp0_serialDesc;
  }
  z5b(encoder, value) {
    var tmp0_desc = this.y5b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_356().x5b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n56_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.o56_1);
    tmp1_output.w14(tmp0_desc, 2, value.p56_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z5b(encoder, value instanceof HiddenBeastMovement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y5b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_356().x5b_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return HiddenBeastMovement.a5c(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.y5b_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_356().x5b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), BooleanSerializer_getInstance()];
  }
}
class HiddenBeastMovement {
  constructor(movedObject, path, isRelocation) {
    Companion_getInstance_356();
    this.n56_1 = movedObject;
    this.o56_1 = path;
    this.p56_1 = isRelocation;
  }
  toString() {
    return 'HiddenBeastMovement(movedObject=' + this.n56_1.toString() + ', path=' + toString(this.o56_1) + ', isRelocation=' + this.p56_1 + ')';
  }
  hashCode() {
    var result = this.n56_1.hashCode();
    result = imul(result, 31) + hashCode(this.o56_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p56_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HiddenBeastMovement))
      return false;
    if (!this.n56_1.equals(other.n56_1))
      return false;
    if (!equals(this.o56_1, other.o56_1))
      return false;
    if (!(this.p56_1 === other.p56_1))
      return false;
    return true;
  }
  static a5c(seen0, movedObject, path, isRelocation, serializationConstructorMarker) {
    Companion_getInstance_356();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_306().y5b_1);
    }
    var $this = createThis(this);
    $this.n56_1 = movedObject;
    $this.o56_1 = path;
    $this.p56_1 = isRelocation;
    return $this;
  }
}
class Companion_356 {
  a2g() {
    var tmp = getKClass(ReplayNotificationInfo);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ReplayNotificationPlainText)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_307()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.ReplayNotificationInfo', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class ReplayNotificationInfo {}
class Companion_357 {}
class $serializer_308 {
  constructor() {
    $serializer_instance_307 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ReplayNotificationPlainText', this, 1);
    tmp0_serialDesc.h1b('notificationText', false);
    this.b5c_1 = tmp0_serialDesc;
  }
  c5c(encoder, value) {
    var tmp0_desc = this.b5c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.d5c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c5c(encoder, value instanceof ReplayNotificationPlainText ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b5c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ReplayNotificationPlainText.e5c(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b5c_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class ReplayNotificationPlainText {
  constructor(notificationText) {
    this.d5c_1 = notificationText;
  }
  toString() {
    return 'ReplayNotificationPlainText(notificationText=' + this.d5c_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.d5c_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReplayNotificationPlainText))
      return false;
    if (!(this.d5c_1 === other.d5c_1))
      return false;
    return true;
  }
  static e5c(seen0, notificationText, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_307().b5c_1);
    }
    var $this = createThis(this);
    $this.d5c_1 = notificationText;
    return $this;
  }
}
class Companion_358 {
  a2g() {
    var tmp = getKClass(TechnicalGameStateChangeEvent);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AkkeronEternityTransformedPositionsChangeEvent), getKClass(ChangeBlueDraftActionCardWasPlayedStatusEvent), getKClass(ChangeFeatheredKingRebornStatusEvent), getKClass(ChangeFylgjaFlightWasUsedThisTurnEvent), getKClass(ChangeRedDraftActionCardWasPlayedStatusEvent), getKClass(ChangeSettlersMovedStatusEvent), getKClass(DraugRespawnStateChangeEvent), getKClass(MesmeriseChooseEvent), getKClass(ResonanceChooseEvent), getKClass(SetCurrentPhaseEvent), getKClass(SetPlayingCardNumberChangeEvent), getKClass(SigridCreatureLungedStatusEvent), getKClass(SkipNextTurnStatusChangeEvent)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_70(), $serializer_getInstance_141(), $serializer_getInstance_148(), $serializer_getInstance_135(), $serializer_getInstance_79(), $serializer_getInstance_399(), $serializer_getInstance_132(), $serializer_getInstance_139(), $serializer_getInstance_80(), $serializer_getInstance_224(), $serializer_getInstance_225(), $serializer_getInstance_403(), $serializer_getInstance_226()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.TechnicalGameStateChangeEvent', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class PrintingGameRuntimeDiagnostics {
  f5c(warning, cause) {
    println('!WARNING!: ' + warning);
    if (cause == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      println(stackTraceToString(cause));
    }
    return -1;
  }
}
class CombinedRuntime {
  constructor(state, runtime) {
    this.g5c_1 = state;
    this.h5c_1 = runtime;
  }
  x40() {
    return this.g5c_1.x40();
  }
  c3r() {
    return this.g5c_1.c3r();
  }
  d4k() {
    return this.g5c_1.d4k();
  }
  e4k() {
    return this.g5c_1.e4k();
  }
  f4k() {
    return this.g5c_1.f4k();
  }
  g4k() {
    return this.g5c_1.g4k();
  }
  h4k() {
    return this.g5c_1.h4k();
  }
  i4k() {
    return this.g5c_1.i4k();
  }
  j4k() {
    return this.g5c_1.j4k();
  }
  k4k() {
    return this.g5c_1.k4k();
  }
  l4k() {
    return this.g5c_1.l4k();
  }
  m4k() {
    return this.g5c_1.m4k();
  }
  n4k() {
    return this.g5c_1.n4k();
  }
  o4k() {
    return this.g5c_1.o4k();
  }
  p4k() {
    return this.g5c_1.p4k();
  }
  q4k() {
    return this.g5c_1.q4k();
  }
  r4k() {
    return this.g5c_1.r4k();
  }
  s4k() {
    return this.g5c_1.s4k();
  }
  t4k() {
    return this.g5c_1.t4k();
  }
  u4k() {
    return this.g5c_1.u4k();
  }
  v4k() {
    return this.g5c_1.v4k();
  }
  w4k() {
    return this.g5c_1.w4k();
  }
  x4k() {
    return this.g5c_1.x4k();
  }
  h3d() {
    return this.g5c_1.h3d();
  }
  u4j() {
    return this.g5c_1.u4j();
  }
  y4k() {
    return this.g5c_1.y4k();
  }
  z4k() {
    return this.g5c_1.z4k();
  }
  a4l() {
    return this.g5c_1.a4l();
  }
  b4l() {
    return this.g5c_1.b4l();
  }
  c4l() {
    return this.g5c_1.c4l();
  }
  d4l() {
    return this.g5c_1.d4l();
  }
  e4l() {
    return this.g5c_1.e4l();
  }
  h47() {
    return this.g5c_1.h47();
  }
  f4l() {
    return this.g5c_1.f4l();
  }
  g4l() {
    return this.g5c_1.g4l();
  }
  h4l() {
    return this.g5c_1.h4l();
  }
  i4l() {
    return this.g5c_1.i4l();
  }
  j4l(id) {
    return this.g5c_1.j4l(id);
  }
  k4l() {
    return this.g5c_1.k4l();
  }
  l4l() {
    return this.g5c_1.l4l();
  }
  m4l(arsenalType) {
    return this.g5c_1.m4l(arsenalType);
  }
  f5c(warning, cause) {
    return this.h5c_1.f5c(warning, cause);
  }
}
class Companion_359 {
  constructor() {
    Companion_instance_359 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l5c_1 = [null, lazy(tmp_0, GeneralObjectImpl$Companion$$childSerializers$_anonymous__se0twj)];
  }
}
class $serializer_309 {
  constructor() {
    $serializer_instance_308 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GeneralObjectImpl', this, 2);
    tmp0_serialDesc.h1b('id', false);
    tmp0_serialDesc.h1b('properties', false);
    this.m5c_1 = tmp0_serialDesc;
  }
  n5c(encoder, value) {
    var tmp0_desc = this.m5c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_360().l5c_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_136(), new EntityId(value.u4l_1));
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.v4l_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n5c(encoder, value instanceof GeneralObjectImpl ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m5c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_360().l5c_1;
    if (tmp6_input.e14()) {
      var tmp = $serializer_getInstance_136();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new EntityId(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.c3y_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_136();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new EntityId(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.c3y_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GeneralObjectImpl.o5c(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.m5c_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_360().l5c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_136(), tmp0_cached[1].k3()];
  }
}
class GeneralObjectImpl {
  constructor(id, properties) {
    return new.target.w4l(id, properties);
  }
  static w4l(id, properties) {
    Companion_getInstance_360();
    var $this = createThis(this);
    $this.u4l_1 = id;
    $this.v4l_1 = properties;
    return $this;
  }
  static b4m(id, init) {
    Companion_getInstance_360();
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(init, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap.cd(capacity);
    var _iterator__ex2g4s = init.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(new GeneralMapKey(element.p5c_1), element.q5c_1);
      destination.b5(pair.pm_1, pair.qm_1);
    }
    return this.w4l(id, destination);
  }
  r5c(id, properties) {
    return GeneralObjectImpl.w4l(id, properties);
  }
  s5c(id, properties, $super) {
    id = id === VOID ? this.u4l_1 : id;
    properties = properties === VOID ? this.v4l_1 : properties;
    return $super === VOID ? this.r5c(id, properties) : $super.r5c.call(this, new EntityId(id), properties);
  }
  toString() {
    return 'GeneralObjectImpl(id=' + EntityId__toString_impl_njecar(this.u4l_1) + ', properties=' + toString(this.v4l_1) + ')';
  }
  hashCode() {
    var result = EntityId__hashCode_impl_1s8fhw(this.u4l_1);
    result = imul(result, 31) + hashCode(this.v4l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GeneralObjectImpl))
      return false;
    if (!(this.u4l_1 === other.u4l_1))
      return false;
    if (!equals(this.v4l_1, other.v4l_1))
      return false;
    return true;
  }
  static o5c(seen0, id, properties, serializationConstructorMarker) {
    Companion_getInstance_360();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_308().m5c_1);
    }
    var $this = createThis(this);
    $this.u4l_1 = id;
    $this.v4l_1 = properties;
    return $this;
  }
}
class Companion_360 {
  i47(typeSerial0) {
    return $serializer_310.k5c(typeSerial0);
  }
  m1c(typeParamsSerializers) {
    return this.i47(typeParamsSerializers[0]);
  }
}
class $serializer_310 {
  constructor() {
    return new.target.t5c();
  }
  static t5c() {
    var $this = createThis(this);
    var tmp0_serialDesc = new InlineClassDescriptor('steelart.beast.GeneralMapKey', $this);
    tmp0_serialDesc.h1b('key', false);
    $this.i5c_1 = tmp0_serialDesc;
    return $this;
  }
  u5c(encoder, value) {
    var tmp0_inlineEncoder = encoder.v14(this.i5c_1);
    if (tmp0_inlineEncoder == null)
      null;
    else {
      tmp0_inlineEncoder.t14(_GeneralMapKey___get_key__impl__tk32ss(value));
    }
  }
  ez(encoder, value) {
    return this.u5c(encoder, value instanceof GeneralMapKey ? value.v5c_1 : THROW_CCE());
  }
  w5c(decoder) {
    return _GeneralMapKey___init__impl__zdmbea(decoder.m13(this.i5c_1).k13());
  }
  fz(decoder) {
    return new GeneralMapKey(this.w5c(decoder));
  }
  dz() {
    return this.i5c_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
  z1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.j5c_1];
  }
  static k5c(typeSerial0) {
    var $this = this.t5c();
    $this.j5c_1 = typeSerial0;
    return $this;
  }
}
class GeneralMapKey {
  constructor(key) {
    this.v5c_1 = key;
  }
  toString() {
    return GeneralMapKey__toString_impl_sepxnu(this.v5c_1);
  }
  hashCode() {
    return GeneralMapKey__hashCode_impl_kv87if(this.v5c_1);
  }
  equals(other) {
    return GeneralMapKey__equals_impl_lbn93x(this.v5c_1, other);
  }
}
class Companion_361 {
  constructor() {
    Companion_instance_361 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x5c_1 = [lazy(tmp_0, BoardPositionSetWrapper$Companion$$childSerializers$_anonymous__oqunt6)];
  }
}
class $serializer_311 {
  constructor() {
    $serializer_instance_309 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BoardPositionSetWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.y5c_1 = tmp0_serialDesc;
  }
  z5c(encoder, value) {
    var tmp0_desc = this.y5c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_362().x5c_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k39_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z5c(encoder, value instanceof BoardPositionSetWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y5c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_362().x5c_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BoardPositionSetWrapper.a5d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y5c_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_362().x5c_1[0].k3()];
  }
}
class BoardPositionSetWrapper {
  constructor(value) {
    Companion_getInstance_362();
    this.k39_1 = value;
  }
  toString() {
    return 'BoardPositionSetWrapper(value=' + toString(this.k39_1) + ')';
  }
  hashCode() {
    return hashCode(this.k39_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BoardPositionSetWrapper))
      return false;
    if (!equals(this.k39_1, other.k39_1))
      return false;
    return true;
  }
  static a5d(seen0, value, serializationConstructorMarker) {
    Companion_getInstance_362();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_309().y5c_1);
    }
    var $this = createThis(this);
    $this.k39_1 = value;
    return $this;
  }
}
class Companion_362 {}
class $serializer_312 {
  constructor() {
    $serializer_instance_310 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BooleanWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.b5d_1 = tmp0_serialDesc;
  }
  c5d(encoder, value) {
    var tmp0_desc = this.b5d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.w14(tmp0_desc, 0, value.j3w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c5d(encoder, value instanceof BooleanWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b5d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BooleanWrapper.d5d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b5d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance()];
  }
}
class BooleanWrapper {
  constructor(value) {
    this.j3w_1 = value;
  }
  toString() {
    return 'BooleanWrapper(value=' + this.j3w_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.j3w_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BooleanWrapper))
      return false;
    if (!(this.j3w_1 === other.j3w_1))
      return false;
    return true;
  }
  static d5d(seen0, value, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_310().b5d_1);
    }
    var $this = createThis(this);
    $this.j3w_1 = value;
    return $this;
  }
}
class Companion_363 {}
class $serializer_313 {
  constructor() {
    $serializer_instance_311 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ObjectOnBoardWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.e5d_1 = tmp0_serialDesc;
  }
  f5d(encoder, value) {
    var tmp0_desc = this.e5d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.i15(tmp0_desc, 0, $serializer_364.y2o(Companion_instance_420.a2g()), value.i3f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f5d(encoder, value instanceof ObjectOnBoardWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e5d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, $serializer_364.y2o(Companion_instance_420.a2g()), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, $serializer_364.y2o(Companion_instance_420.a2g()), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ObjectOnBoardWrapper.g5d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e5d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_364.y2o(Companion_instance_420.a2g()))];
  }
}
class ObjectOnBoardWrapper {
  constructor(value) {
    this.i3f_1 = value;
  }
  toString() {
    return 'ObjectOnBoardWrapper(value=' + toString_0(this.i3f_1) + ')';
  }
  hashCode() {
    return this.i3f_1 == null ? 0 : this.i3f_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ObjectOnBoardWrapper))
      return false;
    if (!equals(this.i3f_1, other.i3f_1))
      return false;
    return true;
  }
  static g5d(seen0, value, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_311().e5d_1);
    }
    var $this = createThis(this);
    $this.i3f_1 = value;
    return $this;
  }
}
class Companion_364 {
  constructor() {
    Companion_instance_364 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GeneralMapKeyAndInit', null, 2);
    tmp0_serialDesc.h1b('key', false);
    tmp0_serialDesc.h1b('initialValue', false);
    this.h5d_1 = tmp0_serialDesc;
  }
  i47(typeSerial0) {
    return $serializer_314.k5d(typeSerial0);
  }
  m1c(typeParamsSerializers) {
    return this.i47(typeParamsSerializers[0]);
  }
}
class $serializer_314 {
  constructor() {
    return new.target.l5d();
  }
  static l5d() {
    var $this = createThis(this);
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.GeneralMapKeyAndInit', $this, 2);
    tmp0_serialDesc.h1b('key', false);
    tmp0_serialDesc.h1b('initialValue', false);
    $this.i5d_1 = tmp0_serialDesc;
    return $this;
  }
  m5d(encoder, value) {
    var tmp0_desc = this.i5d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_310.k5c(this.j5d_1), new GeneralMapKey(value.p5c_1));
    tmp1_output.g15(tmp0_desc, 1, this.j5d_1, value.q5c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m5d(encoder, value instanceof GeneralMapKeyAndInit ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i5d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      var tmp = $serializer_310.k5c(this.j5d_1);
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GeneralMapKey(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.v5c_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, this.j5d_1, tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_310.k5c(this.j5d_1);
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GeneralMapKey(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.v5c_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, this.j5d_1, tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GeneralMapKeyAndInit.n5d(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.i5d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_310.k5c(this.j5d_1), this.j5d_1];
  }
  z1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.j5d_1];
  }
  static k5d(typeSerial0) {
    var $this = this.l5d();
    $this.j5d_1 = typeSerial0;
    return $this;
  }
}
class GeneralMapKeyAndInit {
  constructor(key, initialValue) {
    Companion_getInstance_365();
    this.p5c_1 = key;
    this.q5c_1 = initialValue;
  }
  toString() {
    return 'GeneralMapKeyAndInit(key=' + GeneralMapKey__toString_impl_sepxnu(this.p5c_1) + ', initialValue=' + toString(this.q5c_1) + ')';
  }
  hashCode() {
    var result = GeneralMapKey__hashCode_impl_kv87if(this.p5c_1);
    result = imul(result, 31) + hashCode(this.q5c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GeneralMapKeyAndInit))
      return false;
    if (!(this.p5c_1 === other.p5c_1))
      return false;
    if (!equals(this.q5c_1, other.q5c_1))
      return false;
    return true;
  }
  static n5d(seen0, key, initialValue, serializationConstructorMarker) {
    Companion_getInstance_365();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, Companion_getInstance_365().h5d_1);
    }
    var $this = createThis(this);
    $this.p5c_1 = key;
    $this.q5c_1 = initialValue;
    return $this;
  }
}
class Companion_365 {}
class $serializer_315 {
  constructor() {
    $serializer_instance_312 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BoardPositionWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.o5d_1 = tmp0_serialDesc;
  }
  p5d(encoder, value) {
    var tmp0_desc = this.o5d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.t3g_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p5d(encoder, value instanceof BoardPositionWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o5d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BoardPositionWrapper.q5d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.o5d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100()];
  }
}
class BoardPositionWrapper {
  constructor(value) {
    this.t3g_1 = value;
  }
  toString() {
    return 'BoardPositionWrapper(value=' + BoardPosition__toString_impl_v4mn82(this.t3g_1) + ')';
  }
  hashCode() {
    return BoardPosition__hashCode_impl_9dgqf7(this.t3g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BoardPositionWrapper))
      return false;
    if (!(this.t3g_1 === other.t3g_1))
      return false;
    return true;
  }
  static q5d(seen0, value, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_312().o5d_1);
    }
    var $this = createThis(this);
    $this.t3g_1 = value;
    return $this;
  }
}
class Companion_366 {
  constructor() {
    Companion_instance_366 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r5d_1 = [lazy(tmp_0, BeastPathStepListWrapper$Companion$$childSerializers$_anonymous__yr6dl1)];
  }
}
class $serializer_316 {
  constructor() {
    $serializer_instance_313 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeastPathStepListWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.s5d_1 = tmp0_serialDesc;
  }
  t5d(encoder, value) {
    var tmp0_desc = this.s5d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_367().r5d_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s3g_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t5d(encoder, value instanceof BeastPathStepListWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s5d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_367().r5d_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BeastPathStepListWrapper.u5d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s5d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_367().r5d_1[0].k3()];
  }
}
class BeastPathStepListWrapper {
  constructor(value) {
    Companion_getInstance_367();
    this.s3g_1 = value;
  }
  toString() {
    return 'BeastPathStepListWrapper(value=' + toString(this.s3g_1) + ')';
  }
  hashCode() {
    return hashCode(this.s3g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastPathStepListWrapper))
      return false;
    if (!equals(this.s3g_1, other.s3g_1))
      return false;
    return true;
  }
  static u5d(seen0, value, serializationConstructorMarker) {
    Companion_getInstance_367();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_313().s5d_1);
    }
    var $this = createThis(this);
    $this.s3g_1 = value;
    return $this;
  }
}
class Companion_367 {
  constructor() {
    Companion_instance_367 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v5d_1 = [lazy(tmp_0, MovementAndStateListWrapper$Companion$$childSerializers$_anonymous__xtboyq)];
  }
}
class $serializer_317 {
  constructor() {
    $serializer_instance_314 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MovementAndStateListWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.w5d_1 = tmp0_serialDesc;
  }
  x5d(encoder, value) {
    var tmp0_desc = this.w5d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_368().v5d_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r3g_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x5d(encoder, value instanceof MovementAndStateListWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w5d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_368().v5d_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return MovementAndStateListWrapper.y5d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w5d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_368().v5d_1[0].k3()];
  }
}
class MovementAndStateListWrapper {
  constructor(value) {
    Companion_getInstance_368();
    this.r3g_1 = value;
  }
  toString() {
    return 'MovementAndStateListWrapper(value=' + toString(this.r3g_1) + ')';
  }
  hashCode() {
    return hashCode(this.r3g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MovementAndStateListWrapper))
      return false;
    if (!equals(this.r3g_1, other.r3g_1))
      return false;
    return true;
  }
  static y5d(seen0, value, serializationConstructorMarker) {
    Companion_getInstance_368();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_314().w5d_1);
    }
    var $this = createThis(this);
    $this.r3g_1 = value;
    return $this;
  }
}
class Companion_368 {
  constructor() {
    Companion_instance_368 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z5d_1 = [lazy(tmp_0, BoardPositionToIntMapWrapper$Companion$$childSerializers$_anonymous__fjbp66)];
  }
}
class $serializer_318 {
  constructor() {
    $serializer_instance_315 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BoardPositionToIntMapWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.a5e_1 = tmp0_serialDesc;
  }
  b5e(encoder, value) {
    var tmp0_desc = this.a5e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_369().z5d_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q3g_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b5e(encoder, value instanceof BoardPositionToIntMapWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a5e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_369().z5d_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BoardPositionToIntMapWrapper.c5e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a5e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_369().z5d_1[0].k3()];
  }
}
class BoardPositionToIntMapWrapper {
  constructor(value) {
    Companion_getInstance_369();
    this.q3g_1 = value;
  }
  toString() {
    return 'BoardPositionToIntMapWrapper(value=' + toString(this.q3g_1) + ')';
  }
  hashCode() {
    return hashCode(this.q3g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BoardPositionToIntMapWrapper))
      return false;
    if (!equals(this.q3g_1, other.q3g_1))
      return false;
    return true;
  }
  static c5e(seen0, value, serializationConstructorMarker) {
    Companion_getInstance_369();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_315().a5e_1);
    }
    var $this = createThis(this);
    $this.q3g_1 = value;
    return $this;
  }
}
class Companion_369 {
  a2g() {
    var tmp = getKClass(GeneralObjectProperty);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BeastPathStepListWrapper), getKClass(BoardPositionSetWrapper), getKClass(BoardPositionToIntMapWrapper), getKClass(BoardPositionWrapper), getKClass(BooleanWrapper), getKClass(IntWrapper), getKClass(MovementAndState), getKClass(MovementAndStateListWrapper), getKClass(Akkeron), getKClass(Bolgin), getKClass(EsmeriaBeast), getKClass(Fangrir), getKClass(FeatheredKing), getKClass(Hogbad), getKClass(Lydan), getKClass(Mara), getKClass(Omma), getKClass(Raaga), getKClass(Rhagner), getKClass(Thalduk), getKClass(Urgull), getKClass(Vacker), getKClass(Assar), getKClass(Bram), getKClass(Draug), getKClass(Eivind), getKClass(EsmeriaHuntress), getKClass(Fara), getKClass(Grimgeir), getKClass(Helga), getKClass(Iona), getKClass(Krim), getKClass(Nora), getKClass(Sigrid), getKClass(Valdi), getKClass(Varja), getKClass(Assar), getKClass(Bram), getKClass(Draug), getKClass(Eivind), getKClass(EsmeriaHuntress), getKClass(Fara), getKClass(Grimgeir), getKClass(Helga), getKClass(Iona), getKClass(Krim), getKClass(Nora), getKClass(Sigrid), getKClass(Valdi), getKClass(Varja), getKClass(CreatureType), getKClass(Fylgja), getKClass(FarmerType), getKClass(NobleType), getKClass(BearType), getKClass(BoarType), getKClass(SheepType), getKClass(TigerType), getKClass(BarrierSideType), getKClass(BoatType), getKClass(CreatureType), getKClass(Fylgja), getKClass(FarmerType), getKClass(NobleType), getKClass(SnareTokenType), getKClass(AbominationType), getKClass(AdmirerType), getKClass(BansheeType), getKClass(BasiliskType), getKClass(ChangelingType), getKClass(DreamerType), getKClass(EggType), getKClass(EyeType), getKClass(HatchlingType), getKClass(LindwyrmType), getKClass(PolypType), getKClass(WarhogType), getKClass(WolfType), getKClass(YagiType), getKClass(YeltrType), getKClass(WatchtowerType), getKClass(ObjectOnBoardWrapper), getKClass(AcclivityCard), getKClass(BeastlyTongueCard), getKClass(ConsumeCard), getKClass(CorruptCard), getKClass(DeceiveCard), getKClass(DefileCard), getKClass(DismemberCard), getKClass(EngorgeCard), getKClass(FeedCard), getKClass(FlickerCard), getKClass(FloodCard), getKClass(GatherThePackCard), getKClass(HydraCard), getKClass(LeapCard), getKClass(LurkCard), getKClass(BoltAndRecallCard), getKClass(SoulReapCard), getKClass(SummonYeltrCard), getKClass(ToothAndSeverCard), getKClass(MurderCard), getKClass(ObscureTalentCard), getKClass(OverloadedStormCard), getKClass(PreyUponCard), getKClass(RambleCard), getKClass(IncinerateCard), getKClass(RiseCard), getKClass(ScorchedEarthCard), getKClass(SummonLindwyrmCard), getKClass(ShadowStepCard), getKClass(SlitherCard), getKClass(SpookCard), getKClass(StalkCard), getKClass(StampedeCard), getKClass(StormCard), getKClass(SummonBasiliskCard), getKClass(SummonChangelingCard), getKClass(SummonDreamerCard), getKClass(SummonEyeCard), getKClass(SummonPolypCard), getKClass(SummonWarhogCard), getKClass(SummonWolfCard), getKClass(SummonYagiCard), getKClass(SummonEyeCard), getKClass(TuskCard), getKClass(UnburdenCard), getKClass(UnwillingSacrificeCard), getKClass(UpriseCard), getKClass(NestCard), getKClass(OverloadedNestCard), getKClass(OvipunctureCard), getKClass(SilkCard), getKClass(SummonEggCard), getKClass(AllureCard), getKClass(BeholdCard), getKClass(EludeCard), getKClass(SummonAdmirerCard), getKClass(VoidCard), getKClass(BleatCard), getKClass(AviationCard), getKClass(BerserkCard), getKClass(CleaverCard), getKClass(CommandCard), getKClass(DelegateCard), getKClass(FlameRapierCard), getKClass(GrapplingHookCard), getKClass(HerdCard), getKClass(BindingHuntCard), getKClass(BloodHuntCard), getKClass(HuntCard), getKClass(TraitorsHuntCard), getKClass(IncisionCard), getKClass(MountCard), getKClass(OverloadedFlameRapierCard), getKClass(ScoutCard), getKClass(SeerCard), getKClass(BondedTrackCard), getKClass(ScroungeCard), getKClass(TraitorsHuntCard), getKClass(SilverArrowCard), getKClass(BloodTrackCard), getKClass(BondedTrackCard), getKClass(TrackCard), getKClass(TrapmasterCard), getKClass(UnnaturalResolveCard), getKClass(WardCard), getKClass(MistShroudCard), getKClass(Ruin1), getKClass(Ruin10), getKClass(Ruin11), getKClass(Ruin12), getKClass(Ruin2), getKClass(Ruin3), getKClass(Ruin4), getKClass(Ruin5), getKClass(Ruin6), getKClass(Ruin7), getKClass(Ruin8), getKClass(Ruin9), getKClass(UnknownAshRuinCard), getKClass(IntuitionCard), getKClass(AbruptDecayCard), getKClass(BrutalityCard), getKClass(DisappearCard), getKClass(DisperseCard), getKClass(EvolveCard), getKClass(FeastCard), getKClass(FlourishCard), getKClass(FuryCard), getKClass(HatredCard), getKClass(InsidiousGrowthCard), getKClass(MirrorStepCard), getKClass(OverloadedFuryCard), getKClass(OverloadedShatterCard), getKClass(RageCard), getKClass(RecoveryTestBeastCard), getKClass(RoamCard), getKClass(ShatterCard), getKClass(SprawlCard), getKClass(StrangeSummonsCard), getKClass(SwarmCard), getKClass(UnbendingWillCard), getKClass(RecoveryTestBeastReaction), getKClass(RecoveryTestNightlyRewardsFailureCard), getKClass(RecoveryTestPhaseFailureCard), getKClass(RecoveryTestTeamRewardFailureCard), getKClass(SuddenMistCard), getKClass(UnknownBeastlyTalentCard), getKClass(WorldShiftCard), getKClass(DreamerMaskCard), getKClass(EsmeriasStrandCard), getKClass(FlareCard), getKClass(AurorasPassage), getKClass(BansheesLureCard), getKClass(BladeOfValhCard), getKClass(ChainGrapnelCard), getKClass(ExpeditionMapCard), getKClass(GrapeshotCard), getKClass(HuntersBellCard), getKClass(HuntersPassageCard), getKClass(HuntersRestCard), getKClass(OutpostCard), getKClass(RecoveryTestHunterCard), getKClass(SacredRichesCard), getKClass(SpyglassCard), getKClass(FireTrapCard), getKClass(HexingTrapCard), getKClass(RitualTrapCard), getKClass(ShriekerTrapCard), getKClass(WarhogsTuskCard), getKClass(WolfsbaneCard), getKClass(RecoveryTestHunterReaction), getKClass(SmokeBombCard), getKClass(UnknownHunterItemCard), getKClass(RecoveryTestBeastCard), getKClass(RecoveryTestHunterCard), getKClass(Ruin1), getKClass(Ruin10), getKClass(Ruin11), getKClass(Ruin12), getKClass(Ruin2), getKClass(Ruin3), getKClass(Ruin4), getKClass(Ruin5), getKClass(Ruin6), getKClass(Ruin7), getKClass(Ruin8), getKClass(Ruin9), getKClass(AcclivityCard), getKClass(BeastlyTongueCard), getKClass(ConsumeCard), getKClass(CorruptCard), getKClass(DeceiveCard), getKClass(DefileCard), getKClass(DismemberCard), getKClass(EngorgeCard), getKClass(FeedCard), getKClass(FlickerCard), getKClass(FloodCard), getKClass(GatherThePackCard), getKClass(HydraCard), getKClass(LeapCard), getKClass(LurkCard), getKClass(BoltAndRecallCard), getKClass(SoulReapCard), getKClass(SummonYeltrCard), getKClass(ToothAndSeverCard), getKClass(MurderCard), getKClass(ObscureTalentCard), getKClass(OverloadedStormCard), getKClass(PreyUponCard), getKClass(RambleCard), getKClass(IncinerateCard), getKClass(RiseCard), getKClass(ScorchedEarthCard), getKClass(SummonLindwyrmCard), getKClass(ShadowStepCard), getKClass(SlitherCard), getKClass(SpookCard), getKClass(StalkCard), getKClass(StampedeCard), getKClass(StormCard), getKClass(SummonBasiliskCard), getKClass(SummonChangelingCard), getKClass(SummonDreamerCard), getKClass(SummonEyeCard), getKClass(SummonPolypCard), getKClass(SummonWarhogCard), getKClass(SummonWolfCard), getKClass(SummonYagiCard), getKClass(SummonEyeCard), getKClass(TuskCard), getKClass(UnburdenCard), getKClass(UnwillingSacrificeCard), getKClass(UpriseCard), getKClass(NestCard), getKClass(OverloadedNestCard), getKClass(OvipunctureCard), getKClass(SilkCard), getKClass(SummonEggCard), getKClass(AllureCard), getKClass(BeholdCard), getKClass(EludeCard), getKClass(SummonAdmirerCard), getKClass(VoidCard), getKClass(AdaptCard), getKClass(AnimateCard), getKClass(AvariceCard), getKClass(BolsterCard), getKClass(ChargeCard), getKClass(DashCard), getKClass(DisplaceCard), getKClass(DarkDealingsCard), getKClass(DarkOfferingsCard), getKClass(DarkRitualsCard), getKClass(EnsnareCard), getKClass(GlimpseCard), getKClass(HasteCard), getKClass(HiddenPassageCard), getKClass(InciteCard), getKClass(ProwlCard), getKClass(PursuitCard), getKClass(RushCard), getKClass(StrideCard), getKClass(UnearthCard), getKClass(UnknownDraftActionCard), getKClass(AviationCard), getKClass(BerserkCard), getKClass(CleaverCard), getKClass(CommandCard), getKClass(DelegateCard), getKClass(FlameRapierCard), getKClass(GrapplingHookCard), getKClass(HerdCard), getKClass(BindingHuntCard), getKClass(BloodHuntCard), getKClass(HuntCard), getKClass(TraitorsHuntCard), getKClass(IncisionCard), getKClass(MountCard), getKClass(OverloadedFlameRapierCard), getKClass(ScoutCard), getKClass(SeerCard), getKClass(BondedTrackCard), getKClass(ScroungeCard), getKClass(TraitorsHuntCard), getKClass(SilverArrowCard), getKClass(BloodTrackCard), getKClass(BondedTrackCard), getKClass(TrackCard), getKClass(TrapmasterCard), getKClass(UnnaturalResolveCard), getKClass(WardCard), getKClass(OverloadedFlameRapierCard), getKClass(OverloadedFuryCard), getKClass(OverloadedNestCard), getKClass(OverloadedShatterCard), getKClass(OverloadedStormCard), getKClass(AbruptDecayCard), getKClass(BrutalityCard), getKClass(DisappearCard), getKClass(DisperseCard), getKClass(EvolveCard), getKClass(FeastCard), getKClass(FlourishCard), getKClass(FuryCard), getKClass(HatredCard), getKClass(InsidiousGrowthCard), getKClass(MirrorStepCard), getKClass(OverloadedFuryCard), getKClass(OverloadedShatterCard), getKClass(RageCard), getKClass(RecoveryTestBeastCard), getKClass(RoamCard), getKClass(ShatterCard), getKClass(SprawlCard), getKClass(StrangeSummonsCard), getKClass(SwarmCard), getKClass(UnbendingWillCard), getKClass(AurorasPassage), getKClass(BansheesLureCard), getKClass(BladeOfValhCard), getKClass(ChainGrapnelCard), getKClass(ExpeditionMapCard), getKClass(GrapeshotCard), getKClass(HuntersBellCard), getKClass(HuntersPassageCard), getKClass(HuntersRestCard), getKClass(OutpostCard), getKClass(RecoveryTestHunterCard), getKClass(SacredRichesCard), getKClass(SpyglassCard), getKClass(FireTrapCard), getKClass(HexingTrapCard), getKClass(RitualTrapCard), getKClass(ShriekerTrapCard), getKClass(WarhogsTuskCard), getKClass(WolfsbaneCard), getKClass(BleatCard), getKClass(DreamerMaskCard), getKClass(EsmeriasStrandCard), getKClass(FlareCard), getKClass(IntuitionCard), getKClass(MistShroudCard), getKClass(RecoveryTestBeastReaction), getKClass(RecoveryTestHunterReaction), getKClass(SmokeBombCard), getKClass(SuddenMistCard), getKClass(WorldShiftCard), getKClass(UnknownAshRuinCard), getKClass(UnknownBeastlyTalentCard), getKClass(UnknownDraftActionCard), getKClass(UnknownHunterItemCard), getKClass(PlayableCardSetWrapper), getKClass(PlayableCardToIntMapWrapper), getKClass(PlayableCardToLocationTypeMapWrapper), getKClass(SnareTypeWrapper)];
    var tmp_1 = $serializer_getInstance_313();
    var tmp_2 = $serializer_getInstance_309();
    var tmp_3 = $serializer_getInstance_315();
    var tmp_4 = $serializer_getInstance_312();
    var tmp_5 = $serializer_getInstance_310();
    var tmp_6 = $serializer_getInstance_316();
    var tmp_7 = $serializer_getInstance_83();
    var tmp_8 = $serializer_getInstance_314();
    var tmp_9 = Akkeron_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_10 = ObjectSerializer.l1c('Akkeron', tmp_9, tmp$ret$3);
    var tmp_11 = Bolgin_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_12 = ObjectSerializer.l1c('Bolgin', tmp_11, tmp$ret$6);
    var tmp_13 = EsmeriaBeast_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_14 = ObjectSerializer.l1c('EsmeriaBeast', tmp_13, tmp$ret$9);
    var tmp_15 = Fangrir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_16 = ObjectSerializer.l1c('Fangrir', tmp_15, tmp$ret$12);
    var tmp_17 = FeatheredKing_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_18 = ObjectSerializer.l1c('FeatheredKing', tmp_17, tmp$ret$15);
    var tmp_19 = Hogbad_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_20 = ObjectSerializer.l1c('Hogbad', tmp_19, tmp$ret$18);
    var tmp_21 = Lydan_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_22 = ObjectSerializer.l1c('Lydan', tmp_21, tmp$ret$21);
    var tmp_23 = Mara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_24 = ObjectSerializer.l1c('Mara', tmp_23, tmp$ret$24);
    var tmp_25 = Omma_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_26 = ObjectSerializer.l1c('Omma', tmp_25, tmp$ret$27);
    var tmp_27 = Raaga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_28 = ObjectSerializer.l1c('Raaga', tmp_27, tmp$ret$30);
    var tmp_29 = Rhagner_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_30 = ObjectSerializer.l1c('Rhagner', tmp_29, tmp$ret$33);
    var tmp_31 = Thalduk_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_32 = ObjectSerializer.l1c('Thalduk', tmp_31, tmp$ret$36);
    var tmp_33 = Urgull_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_34 = ObjectSerializer.l1c('Urgull', tmp_33, tmp$ret$39);
    var tmp_35 = Vacker_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_36 = ObjectSerializer.l1c('Vacker', tmp_35, tmp$ret$42);
    var tmp_37 = Assar_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_38 = ObjectSerializer.l1c('Assar', tmp_37, tmp$ret$45);
    var tmp_39 = Bram_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_40 = ObjectSerializer.l1c('Bram', tmp_39, tmp$ret$48);
    var tmp_41 = Draug_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_42 = ObjectSerializer.l1c('Draug', tmp_41, tmp$ret$51);
    var tmp_43 = Eivind_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_44 = ObjectSerializer.l1c('Eivind', tmp_43, tmp$ret$54);
    var tmp_45 = EsmeriaHuntress_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_46 = ObjectSerializer.l1c('EsmeriaHuntress', tmp_45, tmp$ret$57);
    var tmp_47 = Fara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_48 = ObjectSerializer.l1c('Fara', tmp_47, tmp$ret$60);
    var tmp_49 = Grimgeir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_50 = ObjectSerializer.l1c('Grimgeir', tmp_49, tmp$ret$63);
    var tmp_51 = Helga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_52 = ObjectSerializer.l1c('Helga', tmp_51, tmp$ret$66);
    var tmp_53 = Iona_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_54 = ObjectSerializer.l1c('Iona', tmp_53, tmp$ret$69);
    var tmp_55 = Krim_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_56 = ObjectSerializer.l1c('Krim', tmp_55, tmp$ret$72);
    var tmp_57 = Nora_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_58 = ObjectSerializer.l1c('Nora', tmp_57, tmp$ret$75);
    var tmp_59 = Sigrid_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_60 = ObjectSerializer.l1c('Sigrid', tmp_59, tmp$ret$78);
    var tmp_61 = Valdi_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_62 = ObjectSerializer.l1c('Valdi', tmp_61, tmp$ret$81);
    var tmp_63 = Varja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_64 = ObjectSerializer.l1c('Varja', tmp_63, tmp$ret$84);
    var tmp_65 = Assar_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_66 = ObjectSerializer.l1c('Assar', tmp_65, tmp$ret$87);
    var tmp_67 = Bram_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_68 = ObjectSerializer.l1c('Bram', tmp_67, tmp$ret$90);
    var tmp_69 = Draug_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_70 = ObjectSerializer.l1c('Draug', tmp_69, tmp$ret$93);
    var tmp_71 = Eivind_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_72 = ObjectSerializer.l1c('Eivind', tmp_71, tmp$ret$96);
    var tmp_73 = EsmeriaHuntress_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_74 = ObjectSerializer.l1c('EsmeriaHuntress', tmp_73, tmp$ret$99);
    var tmp_75 = Fara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_76 = ObjectSerializer.l1c('Fara', tmp_75, tmp$ret$102);
    var tmp_77 = Grimgeir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_78 = ObjectSerializer.l1c('Grimgeir', tmp_77, tmp$ret$105);
    var tmp_79 = Helga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_80 = ObjectSerializer.l1c('Helga', tmp_79, tmp$ret$108);
    var tmp_81 = Iona_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_82 = ObjectSerializer.l1c('Iona', tmp_81, tmp$ret$111);
    var tmp_83 = Krim_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_84 = ObjectSerializer.l1c('Krim', tmp_83, tmp$ret$114);
    var tmp_85 = Nora_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_86 = ObjectSerializer.l1c('Nora', tmp_85, tmp$ret$117);
    var tmp_87 = Sigrid_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_88 = ObjectSerializer.l1c('Sigrid', tmp_87, tmp$ret$120);
    var tmp_89 = Valdi_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_90 = ObjectSerializer.l1c('Valdi', tmp_89, tmp$ret$123);
    var tmp_91 = Varja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_92 = ObjectSerializer.l1c('Varja', tmp_91, tmp$ret$126);
    var tmp_93 = CreatureType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_94 = ObjectSerializer.l1c('CreatureType', tmp_93, tmp$ret$129);
    var tmp_95 = Fylgja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_96 = ObjectSerializer.l1c('Fylgja', tmp_95, tmp$ret$132);
    var tmp_97 = FarmerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_98 = ObjectSerializer.l1c('FarmerType', tmp_97, tmp$ret$135);
    var tmp_99 = NobleType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    var tmp_100 = ObjectSerializer.l1c('NobleType', tmp_99, tmp$ret$138);
    var tmp_101 = BearType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$141 = [];
    var tmp_102 = ObjectSerializer.l1c('BearType', tmp_101, tmp$ret$141);
    var tmp_103 = BoarType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    var tmp_104 = ObjectSerializer.l1c('BoarType', tmp_103, tmp$ret$144);
    var tmp_105 = SheepType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$147 = [];
    var tmp_106 = ObjectSerializer.l1c('SheepType', tmp_105, tmp$ret$147);
    var tmp_107 = TigerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$150 = [];
    var tmp_108 = ObjectSerializer.l1c('TigerType', tmp_107, tmp$ret$150);
    var tmp_109 = $serializer_getInstance_361();
    var tmp_110 = BoatType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$153 = [];
    var tmp_111 = ObjectSerializer.l1c('BoatType', tmp_110, tmp$ret$153);
    var tmp_112 = CreatureType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$156 = [];
    var tmp_113 = ObjectSerializer.l1c('CreatureType', tmp_112, tmp$ret$156);
    var tmp_114 = Fylgja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$159 = [];
    var tmp_115 = ObjectSerializer.l1c('Fylgja', tmp_114, tmp$ret$159);
    var tmp_116 = FarmerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$162 = [];
    var tmp_117 = ObjectSerializer.l1c('FarmerType', tmp_116, tmp$ret$162);
    var tmp_118 = NobleType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$165 = [];
    var tmp_119 = ObjectSerializer.l1c('NobleType', tmp_118, tmp$ret$165);
    var tmp_120 = SnareTokenType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$168 = [];
    var tmp_121 = ObjectSerializer.l1c('SnareTokenType', tmp_120, tmp$ret$168);
    var tmp_122 = AbominationType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$171 = [];
    var tmp_123 = ObjectSerializer.l1c('AbominationType', tmp_122, tmp$ret$171);
    var tmp_124 = AdmirerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$174 = [];
    var tmp_125 = ObjectSerializer.l1c('AdmirerType', tmp_124, tmp$ret$174);
    var tmp_126 = BansheeType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$177 = [];
    var tmp_127 = ObjectSerializer.l1c('BansheeType', tmp_126, tmp$ret$177);
    var tmp_128 = BasiliskType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$180 = [];
    var tmp_129 = ObjectSerializer.l1c('BasiliskType', tmp_128, tmp$ret$180);
    var tmp_130 = ChangelingType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$183 = [];
    var tmp_131 = ObjectSerializer.l1c('ChangelingType', tmp_130, tmp$ret$183);
    var tmp_132 = DreamerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$186 = [];
    var tmp_133 = ObjectSerializer.l1c('DreamerType', tmp_132, tmp$ret$186);
    var tmp_134 = EggType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$189 = [];
    var tmp_135 = ObjectSerializer.l1c('EggType', tmp_134, tmp$ret$189);
    var tmp_136 = EyeType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$192 = [];
    var tmp_137 = ObjectSerializer.l1c('EyeType', tmp_136, tmp$ret$192);
    var tmp_138 = HatchlingType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$195 = [];
    var tmp_139 = ObjectSerializer.l1c('HatchlingType', tmp_138, tmp$ret$195);
    var tmp_140 = LindwyrmType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$198 = [];
    var tmp_141 = ObjectSerializer.l1c('LindwyrmType', tmp_140, tmp$ret$198);
    var tmp_142 = PolypType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$201 = [];
    var tmp_143 = ObjectSerializer.l1c('PolypType', tmp_142, tmp$ret$201);
    var tmp_144 = WarhogType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$204 = [];
    var tmp_145 = ObjectSerializer.l1c('WarhogType', tmp_144, tmp$ret$204);
    var tmp_146 = WolfType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$207 = [];
    var tmp_147 = ObjectSerializer.l1c('WolfType', tmp_146, tmp$ret$207);
    var tmp_148 = YagiType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$210 = [];
    var tmp_149 = ObjectSerializer.l1c('YagiType', tmp_148, tmp$ret$210);
    var tmp_150 = YeltrType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$213 = [];
    var tmp_151 = ObjectSerializer.l1c('YeltrType', tmp_150, tmp$ret$213);
    var tmp_152 = WatchtowerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$216 = [];
    var tmp_153 = ObjectSerializer.l1c('WatchtowerType', tmp_152, tmp$ret$216);
    var tmp_154 = $serializer_getInstance_311();
    var tmp_155 = AcclivityCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$219 = [];
    var tmp_156 = ObjectSerializer.l1c('AcclivityCard', tmp_155, tmp$ret$219);
    var tmp_157 = BeastlyTongueCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$222 = [];
    var tmp_158 = ObjectSerializer.l1c('BeastlyTongueCard', tmp_157, tmp$ret$222);
    var tmp_159 = ConsumeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$225 = [];
    var tmp_160 = ObjectSerializer.l1c('ConsumeCard', tmp_159, tmp$ret$225);
    var tmp_161 = CorruptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$228 = [];
    var tmp_162 = ObjectSerializer.l1c('CorruptCard', tmp_161, tmp$ret$228);
    var tmp_163 = DeceiveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$231 = [];
    var tmp_164 = ObjectSerializer.l1c('DeceiveCard', tmp_163, tmp$ret$231);
    var tmp_165 = DefileCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$234 = [];
    var tmp_166 = ObjectSerializer.l1c('DefileCard', tmp_165, tmp$ret$234);
    var tmp_167 = DismemberCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$237 = [];
    var tmp_168 = ObjectSerializer.l1c('DismemberCard', tmp_167, tmp$ret$237);
    var tmp_169 = EngorgeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$240 = [];
    var tmp_170 = ObjectSerializer.l1c('EngorgeCard', tmp_169, tmp$ret$240);
    var tmp_171 = FeedCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$243 = [];
    var tmp_172 = ObjectSerializer.l1c('FeedCard', tmp_171, tmp$ret$243);
    var tmp_173 = FlickerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$246 = [];
    var tmp_174 = ObjectSerializer.l1c('FlickerCard', tmp_173, tmp$ret$246);
    var tmp_175 = FloodCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$249 = [];
    var tmp_176 = ObjectSerializer.l1c('FloodCard', tmp_175, tmp$ret$249);
    var tmp_177 = GatherThePackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$252 = [];
    var tmp_178 = ObjectSerializer.l1c('GatherThePackCard', tmp_177, tmp$ret$252);
    var tmp_179 = HydraCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$255 = [];
    var tmp_180 = ObjectSerializer.l1c('HydraCard', tmp_179, tmp$ret$255);
    var tmp_181 = LeapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$258 = [];
    var tmp_182 = ObjectSerializer.l1c('LeapCard', tmp_181, tmp$ret$258);
    var tmp_183 = LurkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$261 = [];
    var tmp_184 = ObjectSerializer.l1c('LurkCard', tmp_183, tmp$ret$261);
    var tmp_185 = BoltAndRecallCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$264 = [];
    var tmp_186 = ObjectSerializer.l1c('BoltAndRecallCard', tmp_185, tmp$ret$264);
    var tmp_187 = SoulReapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$267 = [];
    var tmp_188 = ObjectSerializer.l1c('SoulReapCard', tmp_187, tmp$ret$267);
    var tmp_189 = SummonYeltrCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$270 = [];
    var tmp_190 = ObjectSerializer.l1c('SummonYeltrCard', tmp_189, tmp$ret$270);
    var tmp_191 = ToothAndSeverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$273 = [];
    var tmp_192 = ObjectSerializer.l1c('ToothAndSeverCard', tmp_191, tmp$ret$273);
    var tmp_193 = MurderCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$276 = [];
    var tmp_194 = ObjectSerializer.l1c('MurderCard', tmp_193, tmp$ret$276);
    var tmp_195 = ObscureTalentCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$279 = [];
    var tmp_196 = ObjectSerializer.l1c('ObscureTalentCard', tmp_195, tmp$ret$279);
    var tmp_197 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$282 = [];
    var tmp_198 = ObjectSerializer.l1c('OverloadedStormCard', tmp_197, tmp$ret$282);
    var tmp_199 = PreyUponCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$285 = [];
    var tmp_200 = ObjectSerializer.l1c('PreyUponCard', tmp_199, tmp$ret$285);
    var tmp_201 = RambleCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$288 = [];
    var tmp_202 = ObjectSerializer.l1c('RambleCard', tmp_201, tmp$ret$288);
    var tmp_203 = IncinerateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$291 = [];
    var tmp_204 = ObjectSerializer.l1c('IncinerateCard', tmp_203, tmp$ret$291);
    var tmp_205 = RiseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$294 = [];
    var tmp_206 = ObjectSerializer.l1c('RiseCard', tmp_205, tmp$ret$294);
    var tmp_207 = ScorchedEarthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$297 = [];
    var tmp_208 = ObjectSerializer.l1c('ScorchedEarthCard', tmp_207, tmp$ret$297);
    var tmp_209 = SummonLindwyrmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$300 = [];
    var tmp_210 = ObjectSerializer.l1c('SummonLindwyrmCard', tmp_209, tmp$ret$300);
    var tmp_211 = ShadowStepCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$303 = [];
    var tmp_212 = ObjectSerializer.l1c('ShadowStepCard', tmp_211, tmp$ret$303);
    var tmp_213 = SlitherCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$306 = [];
    var tmp_214 = ObjectSerializer.l1c('SlitherCard', tmp_213, tmp$ret$306);
    var tmp_215 = SpookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$309 = [];
    var tmp_216 = ObjectSerializer.l1c('SpookCard', tmp_215, tmp$ret$309);
    var tmp_217 = StalkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$312 = [];
    var tmp_218 = ObjectSerializer.l1c('StalkCard', tmp_217, tmp$ret$312);
    var tmp_219 = StampedeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$315 = [];
    var tmp_220 = ObjectSerializer.l1c('StampedeCard', tmp_219, tmp$ret$315);
    var tmp_221 = StormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$318 = [];
    var tmp_222 = ObjectSerializer.l1c('StormCard', tmp_221, tmp$ret$318);
    var tmp_223 = SummonBasiliskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$321 = [];
    var tmp_224 = ObjectSerializer.l1c('SummonBasiliskCard', tmp_223, tmp$ret$321);
    var tmp_225 = SummonChangelingCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$324 = [];
    var tmp_226 = ObjectSerializer.l1c('SummonChangelingCard', tmp_225, tmp$ret$324);
    var tmp_227 = SummonDreamerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$327 = [];
    var tmp_228 = ObjectSerializer.l1c('SummonDreamerCard', tmp_227, tmp$ret$327);
    var tmp_229 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$330 = [];
    var tmp_230 = ObjectSerializer.l1c('SummonEyeCard', tmp_229, tmp$ret$330);
    var tmp_231 = SummonPolypCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$333 = [];
    var tmp_232 = ObjectSerializer.l1c('SummonPolypCard', tmp_231, tmp$ret$333);
    var tmp_233 = SummonWarhogCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$336 = [];
    var tmp_234 = ObjectSerializer.l1c('SummonWarhogCard', tmp_233, tmp$ret$336);
    var tmp_235 = SummonWolfCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$339 = [];
    var tmp_236 = ObjectSerializer.l1c('SummonWolfCard', tmp_235, tmp$ret$339);
    var tmp_237 = SummonYagiCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$342 = [];
    var tmp_238 = ObjectSerializer.l1c('SummonYagiCard', tmp_237, tmp$ret$342);
    var tmp_239 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$345 = [];
    var tmp_240 = ObjectSerializer.l1c('SummonEyeCard', tmp_239, tmp$ret$345);
    var tmp_241 = TuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$348 = [];
    var tmp_242 = ObjectSerializer.l1c('TuskCard', tmp_241, tmp$ret$348);
    var tmp_243 = UnburdenCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$351 = [];
    var tmp_244 = ObjectSerializer.l1c('UnburdenCard', tmp_243, tmp$ret$351);
    var tmp_245 = UnwillingSacrificeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$354 = [];
    var tmp_246 = ObjectSerializer.l1c('UnwillingSacrificeCard', tmp_245, tmp$ret$354);
    var tmp_247 = UpriseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$357 = [];
    var tmp_248 = ObjectSerializer.l1c('UpriseCard', tmp_247, tmp$ret$357);
    var tmp_249 = NestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$360 = [];
    var tmp_250 = ObjectSerializer.l1c('NestCard', tmp_249, tmp$ret$360);
    var tmp_251 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$363 = [];
    var tmp_252 = ObjectSerializer.l1c('OverloadedNestCard', tmp_251, tmp$ret$363);
    var tmp_253 = OvipunctureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$366 = [];
    var tmp_254 = ObjectSerializer.l1c('OvipunctureCard', tmp_253, tmp$ret$366);
    var tmp_255 = SilkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$369 = [];
    var tmp_256 = ObjectSerializer.l1c('SilkCard', tmp_255, tmp$ret$369);
    var tmp_257 = SummonEggCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$372 = [];
    var tmp_258 = ObjectSerializer.l1c('SummonEggCard', tmp_257, tmp$ret$372);
    var tmp_259 = AllureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$375 = [];
    var tmp_260 = ObjectSerializer.l1c('AllureCard', tmp_259, tmp$ret$375);
    var tmp_261 = BeholdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$378 = [];
    var tmp_262 = ObjectSerializer.l1c('BeholdCard', tmp_261, tmp$ret$378);
    var tmp_263 = EludeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$381 = [];
    var tmp_264 = ObjectSerializer.l1c('EludeCard', tmp_263, tmp$ret$381);
    var tmp_265 = SummonAdmirerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$384 = [];
    var tmp_266 = ObjectSerializer.l1c('SummonAdmirerCard', tmp_265, tmp$ret$384);
    var tmp_267 = VoidCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$387 = [];
    var tmp_268 = ObjectSerializer.l1c('VoidCard', tmp_267, tmp$ret$387);
    var tmp_269 = BleatCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$390 = [];
    var tmp_270 = ObjectSerializer.l1c('BleatCard', tmp_269, tmp$ret$390);
    var tmp_271 = AviationCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$393 = [];
    var tmp_272 = ObjectSerializer.l1c('AviationCard', tmp_271, tmp$ret$393);
    var tmp_273 = BerserkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$396 = [];
    var tmp_274 = ObjectSerializer.l1c('BerserkCard', tmp_273, tmp$ret$396);
    var tmp_275 = CleaverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$399 = [];
    var tmp_276 = ObjectSerializer.l1c('CleaverCard', tmp_275, tmp$ret$399);
    var tmp_277 = CommandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$402 = [];
    var tmp_278 = ObjectSerializer.l1c('CommandCard', tmp_277, tmp$ret$402);
    var tmp_279 = DelegateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$405 = [];
    var tmp_280 = ObjectSerializer.l1c('DelegateCard', tmp_279, tmp$ret$405);
    var tmp_281 = FlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$408 = [];
    var tmp_282 = ObjectSerializer.l1c('FlameRapierCard', tmp_281, tmp$ret$408);
    var tmp_283 = GrapplingHookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$411 = [];
    var tmp_284 = ObjectSerializer.l1c('GrapplingHookCard', tmp_283, tmp$ret$411);
    var tmp_285 = HerdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$414 = [];
    var tmp_286 = ObjectSerializer.l1c('HerdCard', tmp_285, tmp$ret$414);
    var tmp_287 = BindingHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$417 = [];
    var tmp_288 = ObjectSerializer.l1c('BindingHuntCard', tmp_287, tmp$ret$417);
    var tmp_289 = BloodHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$420 = [];
    var tmp_290 = ObjectSerializer.l1c('BloodHuntCard', tmp_289, tmp$ret$420);
    var tmp_291 = $serializer_getInstance_327();
    var tmp_292 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$423 = [];
    var tmp_293 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_292, tmp$ret$423);
    var tmp_294 = IncisionCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$426 = [];
    var tmp_295 = ObjectSerializer.l1c('IncisionCard', tmp_294, tmp$ret$426);
    var tmp_296 = MountCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$429 = [];
    var tmp_297 = ObjectSerializer.l1c('MountCard', tmp_296, tmp$ret$429);
    var tmp_298 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$432 = [];
    var tmp_299 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_298, tmp$ret$432);
    var tmp_300 = ScoutCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$435 = [];
    var tmp_301 = ObjectSerializer.l1c('ScoutCard', tmp_300, tmp$ret$435);
    var tmp_302 = SeerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$438 = [];
    var tmp_303 = ObjectSerializer.l1c('SeerCard', tmp_302, tmp$ret$438);
    var tmp_304 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$441 = [];
    var tmp_305 = ObjectSerializer.l1c('BondedTrackCard', tmp_304, tmp$ret$441);
    var tmp_306 = ScroungeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$444 = [];
    var tmp_307 = ObjectSerializer.l1c('ScroungeCard', tmp_306, tmp$ret$444);
    var tmp_308 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$447 = [];
    var tmp_309 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_308, tmp$ret$447);
    var tmp_310 = SilverArrowCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$450 = [];
    var tmp_311 = ObjectSerializer.l1c('SilverArrowCard', tmp_310, tmp$ret$450);
    var tmp_312 = BloodTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$453 = [];
    var tmp_313 = ObjectSerializer.l1c('BloodTrackCard', tmp_312, tmp$ret$453);
    var tmp_314 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$456 = [];
    var tmp_315 = ObjectSerializer.l1c('BondedTrackCard', tmp_314, tmp$ret$456);
    var tmp_316 = $serializer_getInstance_326();
    var tmp_317 = TrapmasterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$459 = [];
    var tmp_318 = ObjectSerializer.l1c('TrapmasterCard', tmp_317, tmp$ret$459);
    var tmp_319 = UnnaturalResolveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$462 = [];
    var tmp_320 = ObjectSerializer.l1c('UnnaturalResolveCard', tmp_319, tmp$ret$462);
    var tmp_321 = WardCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$465 = [];
    var tmp_322 = ObjectSerializer.l1c('WardCard', tmp_321, tmp$ret$465);
    var tmp_323 = MistShroudCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$468 = [];
    var tmp_324 = ObjectSerializer.l1c('MistShroudCard', tmp_323, tmp$ret$468);
    var tmp_325 = Ruin1_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$471 = [];
    var tmp_326 = ObjectSerializer.l1c('Ruin1', tmp_325, tmp$ret$471);
    var tmp_327 = Ruin10_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$474 = [];
    var tmp_328 = ObjectSerializer.l1c('Ruin10', tmp_327, tmp$ret$474);
    var tmp_329 = Ruin11_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$477 = [];
    var tmp_330 = ObjectSerializer.l1c('Ruin11', tmp_329, tmp$ret$477);
    var tmp_331 = Ruin12_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$480 = [];
    var tmp_332 = ObjectSerializer.l1c('Ruin12', tmp_331, tmp$ret$480);
    var tmp_333 = Ruin2_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$483 = [];
    var tmp_334 = ObjectSerializer.l1c('Ruin2', tmp_333, tmp$ret$483);
    var tmp_335 = Ruin3_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$486 = [];
    var tmp_336 = ObjectSerializer.l1c('Ruin3', tmp_335, tmp$ret$486);
    var tmp_337 = Ruin4_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$489 = [];
    var tmp_338 = ObjectSerializer.l1c('Ruin4', tmp_337, tmp$ret$489);
    var tmp_339 = Ruin5_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$492 = [];
    var tmp_340 = ObjectSerializer.l1c('Ruin5', tmp_339, tmp$ret$492);
    var tmp_341 = Ruin6_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$495 = [];
    var tmp_342 = ObjectSerializer.l1c('Ruin6', tmp_341, tmp$ret$495);
    var tmp_343 = Ruin7_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$498 = [];
    var tmp_344 = ObjectSerializer.l1c('Ruin7', tmp_343, tmp$ret$498);
    var tmp_345 = Ruin8_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$501 = [];
    var tmp_346 = ObjectSerializer.l1c('Ruin8', tmp_345, tmp$ret$501);
    var tmp_347 = Ruin9_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$504 = [];
    var tmp_348 = ObjectSerializer.l1c('Ruin9', tmp_347, tmp$ret$504);
    var tmp_349 = $serializer_getInstance_74();
    var tmp_350 = $serializer_getInstance_84();
    var tmp_351 = AbruptDecayCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$507 = [];
    var tmp_352 = ObjectSerializer.l1c('AbruptDecayCard', tmp_351, tmp$ret$507);
    var tmp_353 = $serializer_getInstance_88();
    var tmp_354 = DisappearCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$510 = [];
    var tmp_355 = ObjectSerializer.l1c('DisappearCard', tmp_354, tmp$ret$510);
    var tmp_356 = $serializer_getInstance_92();
    var tmp_357 = $serializer_getInstance_86();
    var tmp_358 = $serializer_getInstance_96();
    var tmp_359 = $serializer_getInstance_97();
    var tmp_360 = FuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$513 = [];
    var tmp_361 = ObjectSerializer.l1c('FuryCard', tmp_360, tmp$ret$513);
    var tmp_362 = $serializer_getInstance_91();
    var tmp_363 = $serializer_getInstance_93();
    var tmp_364 = $serializer_getInstance_98();
    var tmp_365 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$516 = [];
    var tmp_366 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_365, tmp$ret$516);
    var tmp_367 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$519 = [];
    var tmp_368 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_367, tmp$ret$519);
    var tmp_369 = $serializer_getInstance_89();
    var tmp_370 = $serializer_getInstance_378();
    var tmp_371 = $serializer_getInstance_94();
    var tmp_372 = ShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$522 = [];
    var tmp_373 = ObjectSerializer.l1c('ShatterCard', tmp_372, tmp$ret$522);
    var tmp_374 = $serializer_getInstance_95();
    var tmp_375 = $serializer_getInstance_90();
    var tmp_376 = SwarmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$525 = [];
    var tmp_377 = ObjectSerializer.l1c('SwarmCard', tmp_376, tmp$ret$525);
    var tmp_378 = $serializer_getInstance_87();
    var tmp_379 = RecoveryTestBeastReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$528 = [];
    var tmp_380 = ObjectSerializer.l1c('RecoveryTestBeastReaction', tmp_379, tmp$ret$528);
    var tmp_381 = RecoveryTestNightlyRewardsFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$531 = [];
    var tmp_382 = ObjectSerializer.l1c('RecoveryTestNightlyRewardsFailureCard', tmp_381, tmp$ret$531);
    var tmp_383 = RecoveryTestPhaseFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$534 = [];
    var tmp_384 = ObjectSerializer.l1c('RecoveryTestPhaseFailureCard', tmp_383, tmp$ret$534);
    var tmp_385 = RecoveryTestTeamRewardFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$537 = [];
    var tmp_386 = ObjectSerializer.l1c('RecoveryTestTeamRewardFailureCard', tmp_385, tmp$ret$537);
    var tmp_387 = SuddenMistCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$540 = [];
    var tmp_388 = ObjectSerializer.l1c('SuddenMistCard', tmp_387, tmp$ret$540);
    var tmp_389 = $serializer_getInstance_99();
    var tmp_390 = $serializer_getInstance_85();
    var tmp_391 = $serializer_getInstance_329();
    var tmp_392 = EsmeriasStrandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$543 = [];
    var tmp_393 = ObjectSerializer.l1c('EsmeriasStrandCard', tmp_392, tmp$ret$543);
    var tmp_394 = $serializer_getInstance_330();
    var tmp_395 = AurorasPassage_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$546 = [];
    var tmp_396 = ObjectSerializer.l1c('AurorasPassage', tmp_395, tmp$ret$546);
    var tmp_397 = BansheesLureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$549 = [];
    var tmp_398 = ObjectSerializer.l1c('BansheesLureCard', tmp_397, tmp$ret$549);
    var tmp_399 = BladeOfValhCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$552 = [];
    var tmp_400 = ObjectSerializer.l1c('BladeOfValhCard', tmp_399, tmp$ret$552);
    var tmp_401 = ChainGrapnelCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$555 = [];
    var tmp_402 = ObjectSerializer.l1c('ChainGrapnelCard', tmp_401, tmp$ret$555);
    var tmp_403 = $serializer_getInstance_339();
    var tmp_404 = GrapeshotCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$558 = [];
    var tmp_405 = ObjectSerializer.l1c('GrapeshotCard', tmp_404, tmp$ret$558);
    var tmp_406 = $serializer_getInstance_337();
    var tmp_407 = $serializer_getInstance_338();
    var tmp_408 = $serializer_getInstance_336();
    var tmp_409 = $serializer_getInstance_334();
    var tmp_410 = $serializer_getInstance_379();
    var tmp_411 = $serializer_getInstance_341();
    var tmp_412 = SpyglassCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$561 = [];
    var tmp_413 = ObjectSerializer.l1c('SpyglassCard', tmp_412, tmp$ret$561);
    var tmp_414 = $serializer_getInstance_333();
    var tmp_415 = $serializer_getInstance_332();
    var tmp_416 = $serializer_getInstance_340();
    var tmp_417 = $serializer_getInstance_328();
    var tmp_418 = WarhogsTuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$564 = [];
    var tmp_419 = ObjectSerializer.l1c('WarhogsTuskCard', tmp_418, tmp$ret$564);
    var tmp_420 = $serializer_getInstance_335();
    var tmp_421 = RecoveryTestHunterReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$567 = [];
    var tmp_422 = ObjectSerializer.l1c('RecoveryTestHunterReaction', tmp_421, tmp$ret$567);
    var tmp_423 = $serializer_getInstance_331();
    var tmp_424 = $serializer_getInstance_343();
    var tmp_425 = $serializer_getInstance_378();
    var tmp_426 = $serializer_getInstance_379();
    var tmp_427 = Ruin1_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$570 = [];
    var tmp_428 = ObjectSerializer.l1c('Ruin1', tmp_427, tmp$ret$570);
    var tmp_429 = Ruin10_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$573 = [];
    var tmp_430 = ObjectSerializer.l1c('Ruin10', tmp_429, tmp$ret$573);
    var tmp_431 = Ruin11_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$576 = [];
    var tmp_432 = ObjectSerializer.l1c('Ruin11', tmp_431, tmp$ret$576);
    var tmp_433 = Ruin12_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$579 = [];
    var tmp_434 = ObjectSerializer.l1c('Ruin12', tmp_433, tmp$ret$579);
    var tmp_435 = Ruin2_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$582 = [];
    var tmp_436 = ObjectSerializer.l1c('Ruin2', tmp_435, tmp$ret$582);
    var tmp_437 = Ruin3_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$585 = [];
    var tmp_438 = ObjectSerializer.l1c('Ruin3', tmp_437, tmp$ret$585);
    var tmp_439 = Ruin4_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$588 = [];
    var tmp_440 = ObjectSerializer.l1c('Ruin4', tmp_439, tmp$ret$588);
    var tmp_441 = Ruin5_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$591 = [];
    var tmp_442 = ObjectSerializer.l1c('Ruin5', tmp_441, tmp$ret$591);
    var tmp_443 = Ruin6_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$594 = [];
    var tmp_444 = ObjectSerializer.l1c('Ruin6', tmp_443, tmp$ret$594);
    var tmp_445 = Ruin7_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$597 = [];
    var tmp_446 = ObjectSerializer.l1c('Ruin7', tmp_445, tmp$ret$597);
    var tmp_447 = Ruin8_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$600 = [];
    var tmp_448 = ObjectSerializer.l1c('Ruin8', tmp_447, tmp$ret$600);
    var tmp_449 = Ruin9_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$603 = [];
    var tmp_450 = ObjectSerializer.l1c('Ruin9', tmp_449, tmp$ret$603);
    var tmp_451 = AcclivityCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$606 = [];
    var tmp_452 = ObjectSerializer.l1c('AcclivityCard', tmp_451, tmp$ret$606);
    var tmp_453 = BeastlyTongueCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$609 = [];
    var tmp_454 = ObjectSerializer.l1c('BeastlyTongueCard', tmp_453, tmp$ret$609);
    var tmp_455 = ConsumeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$612 = [];
    var tmp_456 = ObjectSerializer.l1c('ConsumeCard', tmp_455, tmp$ret$612);
    var tmp_457 = CorruptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$615 = [];
    var tmp_458 = ObjectSerializer.l1c('CorruptCard', tmp_457, tmp$ret$615);
    var tmp_459 = DeceiveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$618 = [];
    var tmp_460 = ObjectSerializer.l1c('DeceiveCard', tmp_459, tmp$ret$618);
    var tmp_461 = DefileCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$621 = [];
    var tmp_462 = ObjectSerializer.l1c('DefileCard', tmp_461, tmp$ret$621);
    var tmp_463 = DismemberCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$624 = [];
    var tmp_464 = ObjectSerializer.l1c('DismemberCard', tmp_463, tmp$ret$624);
    var tmp_465 = EngorgeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$627 = [];
    var tmp_466 = ObjectSerializer.l1c('EngorgeCard', tmp_465, tmp$ret$627);
    var tmp_467 = FeedCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$630 = [];
    var tmp_468 = ObjectSerializer.l1c('FeedCard', tmp_467, tmp$ret$630);
    var tmp_469 = FlickerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$633 = [];
    var tmp_470 = ObjectSerializer.l1c('FlickerCard', tmp_469, tmp$ret$633);
    var tmp_471 = FloodCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$636 = [];
    var tmp_472 = ObjectSerializer.l1c('FloodCard', tmp_471, tmp$ret$636);
    var tmp_473 = GatherThePackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$639 = [];
    var tmp_474 = ObjectSerializer.l1c('GatherThePackCard', tmp_473, tmp$ret$639);
    var tmp_475 = HydraCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$642 = [];
    var tmp_476 = ObjectSerializer.l1c('HydraCard', tmp_475, tmp$ret$642);
    var tmp_477 = LeapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$645 = [];
    var tmp_478 = ObjectSerializer.l1c('LeapCard', tmp_477, tmp$ret$645);
    var tmp_479 = LurkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$648 = [];
    var tmp_480 = ObjectSerializer.l1c('LurkCard', tmp_479, tmp$ret$648);
    var tmp_481 = BoltAndRecallCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$651 = [];
    var tmp_482 = ObjectSerializer.l1c('BoltAndRecallCard', tmp_481, tmp$ret$651);
    var tmp_483 = SoulReapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$654 = [];
    var tmp_484 = ObjectSerializer.l1c('SoulReapCard', tmp_483, tmp$ret$654);
    var tmp_485 = SummonYeltrCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$657 = [];
    var tmp_486 = ObjectSerializer.l1c('SummonYeltrCard', tmp_485, tmp$ret$657);
    var tmp_487 = ToothAndSeverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$660 = [];
    var tmp_488 = ObjectSerializer.l1c('ToothAndSeverCard', tmp_487, tmp$ret$660);
    var tmp_489 = MurderCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$663 = [];
    var tmp_490 = ObjectSerializer.l1c('MurderCard', tmp_489, tmp$ret$663);
    var tmp_491 = ObscureTalentCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$666 = [];
    var tmp_492 = ObjectSerializer.l1c('ObscureTalentCard', tmp_491, tmp$ret$666);
    var tmp_493 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$669 = [];
    var tmp_494 = ObjectSerializer.l1c('OverloadedStormCard', tmp_493, tmp$ret$669);
    var tmp_495 = PreyUponCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$672 = [];
    var tmp_496 = ObjectSerializer.l1c('PreyUponCard', tmp_495, tmp$ret$672);
    var tmp_497 = RambleCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$675 = [];
    var tmp_498 = ObjectSerializer.l1c('RambleCard', tmp_497, tmp$ret$675);
    var tmp_499 = IncinerateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$678 = [];
    var tmp_500 = ObjectSerializer.l1c('IncinerateCard', tmp_499, tmp$ret$678);
    var tmp_501 = RiseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$681 = [];
    var tmp_502 = ObjectSerializer.l1c('RiseCard', tmp_501, tmp$ret$681);
    var tmp_503 = ScorchedEarthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$684 = [];
    var tmp_504 = ObjectSerializer.l1c('ScorchedEarthCard', tmp_503, tmp$ret$684);
    var tmp_505 = SummonLindwyrmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$687 = [];
    var tmp_506 = ObjectSerializer.l1c('SummonLindwyrmCard', tmp_505, tmp$ret$687);
    var tmp_507 = ShadowStepCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$690 = [];
    var tmp_508 = ObjectSerializer.l1c('ShadowStepCard', tmp_507, tmp$ret$690);
    var tmp_509 = SlitherCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$693 = [];
    var tmp_510 = ObjectSerializer.l1c('SlitherCard', tmp_509, tmp$ret$693);
    var tmp_511 = SpookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$696 = [];
    var tmp_512 = ObjectSerializer.l1c('SpookCard', tmp_511, tmp$ret$696);
    var tmp_513 = StalkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$699 = [];
    var tmp_514 = ObjectSerializer.l1c('StalkCard', tmp_513, tmp$ret$699);
    var tmp_515 = StampedeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$702 = [];
    var tmp_516 = ObjectSerializer.l1c('StampedeCard', tmp_515, tmp$ret$702);
    var tmp_517 = StormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$705 = [];
    var tmp_518 = ObjectSerializer.l1c('StormCard', tmp_517, tmp$ret$705);
    var tmp_519 = SummonBasiliskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$708 = [];
    var tmp_520 = ObjectSerializer.l1c('SummonBasiliskCard', tmp_519, tmp$ret$708);
    var tmp_521 = SummonChangelingCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$711 = [];
    var tmp_522 = ObjectSerializer.l1c('SummonChangelingCard', tmp_521, tmp$ret$711);
    var tmp_523 = SummonDreamerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$714 = [];
    var tmp_524 = ObjectSerializer.l1c('SummonDreamerCard', tmp_523, tmp$ret$714);
    var tmp_525 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$717 = [];
    var tmp_526 = ObjectSerializer.l1c('SummonEyeCard', tmp_525, tmp$ret$717);
    var tmp_527 = SummonPolypCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$720 = [];
    var tmp_528 = ObjectSerializer.l1c('SummonPolypCard', tmp_527, tmp$ret$720);
    var tmp_529 = SummonWarhogCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$723 = [];
    var tmp_530 = ObjectSerializer.l1c('SummonWarhogCard', tmp_529, tmp$ret$723);
    var tmp_531 = SummonWolfCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$726 = [];
    var tmp_532 = ObjectSerializer.l1c('SummonWolfCard', tmp_531, tmp$ret$726);
    var tmp_533 = SummonYagiCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$729 = [];
    var tmp_534 = ObjectSerializer.l1c('SummonYagiCard', tmp_533, tmp$ret$729);
    var tmp_535 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$732 = [];
    var tmp_536 = ObjectSerializer.l1c('SummonEyeCard', tmp_535, tmp$ret$732);
    var tmp_537 = TuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$735 = [];
    var tmp_538 = ObjectSerializer.l1c('TuskCard', tmp_537, tmp$ret$735);
    var tmp_539 = UnburdenCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$738 = [];
    var tmp_540 = ObjectSerializer.l1c('UnburdenCard', tmp_539, tmp$ret$738);
    var tmp_541 = UnwillingSacrificeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$741 = [];
    var tmp_542 = ObjectSerializer.l1c('UnwillingSacrificeCard', tmp_541, tmp$ret$741);
    var tmp_543 = UpriseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$744 = [];
    var tmp_544 = ObjectSerializer.l1c('UpriseCard', tmp_543, tmp$ret$744);
    var tmp_545 = NestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$747 = [];
    var tmp_546 = ObjectSerializer.l1c('NestCard', tmp_545, tmp$ret$747);
    var tmp_547 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$750 = [];
    var tmp_548 = ObjectSerializer.l1c('OverloadedNestCard', tmp_547, tmp$ret$750);
    var tmp_549 = OvipunctureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$753 = [];
    var tmp_550 = ObjectSerializer.l1c('OvipunctureCard', tmp_549, tmp$ret$753);
    var tmp_551 = SilkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$756 = [];
    var tmp_552 = ObjectSerializer.l1c('SilkCard', tmp_551, tmp$ret$756);
    var tmp_553 = SummonEggCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$759 = [];
    var tmp_554 = ObjectSerializer.l1c('SummonEggCard', tmp_553, tmp$ret$759);
    var tmp_555 = AllureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$762 = [];
    var tmp_556 = ObjectSerializer.l1c('AllureCard', tmp_555, tmp$ret$762);
    var tmp_557 = BeholdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$765 = [];
    var tmp_558 = ObjectSerializer.l1c('BeholdCard', tmp_557, tmp$ret$765);
    var tmp_559 = EludeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$768 = [];
    var tmp_560 = ObjectSerializer.l1c('EludeCard', tmp_559, tmp$ret$768);
    var tmp_561 = SummonAdmirerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$771 = [];
    var tmp_562 = ObjectSerializer.l1c('SummonAdmirerCard', tmp_561, tmp$ret$771);
    var tmp_563 = VoidCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$774 = [];
    var tmp_564 = ObjectSerializer.l1c('VoidCard', tmp_563, tmp$ret$774);
    var tmp_565 = AdaptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$777 = [];
    var tmp_566 = ObjectSerializer.l1c('AdaptCard', tmp_565, tmp$ret$777);
    var tmp_567 = AnimateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$780 = [];
    var tmp_568 = ObjectSerializer.l1c('AnimateCard', tmp_567, tmp$ret$780);
    var tmp_569 = AvariceCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$783 = [];
    var tmp_570 = ObjectSerializer.l1c('AvariceCard', tmp_569, tmp$ret$783);
    var tmp_571 = BolsterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$786 = [];
    var tmp_572 = ObjectSerializer.l1c('BolsterCard', tmp_571, tmp$ret$786);
    var tmp_573 = ChargeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$789 = [];
    var tmp_574 = ObjectSerializer.l1c('ChargeCard', tmp_573, tmp$ret$789);
    var tmp_575 = DashCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$792 = [];
    var tmp_576 = ObjectSerializer.l1c('DashCard', tmp_575, tmp$ret$792);
    var tmp_577 = DisplaceCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$795 = [];
    var tmp_578 = ObjectSerializer.l1c('DisplaceCard', tmp_577, tmp$ret$795);
    var tmp_579 = DarkDealingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$798 = [];
    var tmp_580 = ObjectSerializer.l1c('DarkDealingsCard', tmp_579, tmp$ret$798);
    var tmp_581 = DarkOfferingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$801 = [];
    var tmp_582 = ObjectSerializer.l1c('DarkOfferingsCard', tmp_581, tmp$ret$801);
    var tmp_583 = DarkRitualsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$804 = [];
    var tmp_584 = ObjectSerializer.l1c('DarkRitualsCard', tmp_583, tmp$ret$804);
    var tmp_585 = EnsnareCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$807 = [];
    var tmp_586 = ObjectSerializer.l1c('EnsnareCard', tmp_585, tmp$ret$807);
    var tmp_587 = GlimpseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$810 = [];
    var tmp_588 = ObjectSerializer.l1c('GlimpseCard', tmp_587, tmp$ret$810);
    var tmp_589 = HasteCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$813 = [];
    var tmp_590 = ObjectSerializer.l1c('HasteCard', tmp_589, tmp$ret$813);
    var tmp_591 = HiddenPassageCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$816 = [];
    var tmp_592 = ObjectSerializer.l1c('HiddenPassageCard', tmp_591, tmp$ret$816);
    var tmp_593 = InciteCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$819 = [];
    var tmp_594 = ObjectSerializer.l1c('InciteCard', tmp_593, tmp$ret$819);
    var tmp_595 = ProwlCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$822 = [];
    var tmp_596 = ObjectSerializer.l1c('ProwlCard', tmp_595, tmp$ret$822);
    var tmp_597 = PursuitCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$825 = [];
    var tmp_598 = ObjectSerializer.l1c('PursuitCard', tmp_597, tmp$ret$825);
    var tmp_599 = RushCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$828 = [];
    var tmp_600 = ObjectSerializer.l1c('RushCard', tmp_599, tmp$ret$828);
    var tmp_601 = StrideCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$831 = [];
    var tmp_602 = ObjectSerializer.l1c('StrideCard', tmp_601, tmp$ret$831);
    var tmp_603 = UnearthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$834 = [];
    var tmp_604 = ObjectSerializer.l1c('UnearthCard', tmp_603, tmp$ret$834);
    var tmp_605 = $serializer_getInstance_127();
    var tmp_606 = AviationCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$837 = [];
    var tmp_607 = ObjectSerializer.l1c('AviationCard', tmp_606, tmp$ret$837);
    var tmp_608 = BerserkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$840 = [];
    var tmp_609 = ObjectSerializer.l1c('BerserkCard', tmp_608, tmp$ret$840);
    var tmp_610 = CleaverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$843 = [];
    var tmp_611 = ObjectSerializer.l1c('CleaverCard', tmp_610, tmp$ret$843);
    var tmp_612 = CommandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$846 = [];
    var tmp_613 = ObjectSerializer.l1c('CommandCard', tmp_612, tmp$ret$846);
    var tmp_614 = DelegateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$849 = [];
    var tmp_615 = ObjectSerializer.l1c('DelegateCard', tmp_614, tmp$ret$849);
    var tmp_616 = FlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$852 = [];
    var tmp_617 = ObjectSerializer.l1c('FlameRapierCard', tmp_616, tmp$ret$852);
    var tmp_618 = GrapplingHookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$855 = [];
    var tmp_619 = ObjectSerializer.l1c('GrapplingHookCard', tmp_618, tmp$ret$855);
    var tmp_620 = HerdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$858 = [];
    var tmp_621 = ObjectSerializer.l1c('HerdCard', tmp_620, tmp$ret$858);
    var tmp_622 = BindingHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$861 = [];
    var tmp_623 = ObjectSerializer.l1c('BindingHuntCard', tmp_622, tmp$ret$861);
    var tmp_624 = BloodHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$864 = [];
    var tmp_625 = ObjectSerializer.l1c('BloodHuntCard', tmp_624, tmp$ret$864);
    var tmp_626 = $serializer_getInstance_327();
    var tmp_627 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$867 = [];
    var tmp_628 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_627, tmp$ret$867);
    var tmp_629 = IncisionCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$870 = [];
    var tmp_630 = ObjectSerializer.l1c('IncisionCard', tmp_629, tmp$ret$870);
    var tmp_631 = MountCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$873 = [];
    var tmp_632 = ObjectSerializer.l1c('MountCard', tmp_631, tmp$ret$873);
    var tmp_633 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$876 = [];
    var tmp_634 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_633, tmp$ret$876);
    var tmp_635 = ScoutCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$879 = [];
    var tmp_636 = ObjectSerializer.l1c('ScoutCard', tmp_635, tmp$ret$879);
    var tmp_637 = SeerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$882 = [];
    var tmp_638 = ObjectSerializer.l1c('SeerCard', tmp_637, tmp$ret$882);
    var tmp_639 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$885 = [];
    var tmp_640 = ObjectSerializer.l1c('BondedTrackCard', tmp_639, tmp$ret$885);
    var tmp_641 = ScroungeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$888 = [];
    var tmp_642 = ObjectSerializer.l1c('ScroungeCard', tmp_641, tmp$ret$888);
    var tmp_643 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$891 = [];
    var tmp_644 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_643, tmp$ret$891);
    var tmp_645 = SilverArrowCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$894 = [];
    var tmp_646 = ObjectSerializer.l1c('SilverArrowCard', tmp_645, tmp$ret$894);
    var tmp_647 = BloodTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$897 = [];
    var tmp_648 = ObjectSerializer.l1c('BloodTrackCard', tmp_647, tmp$ret$897);
    var tmp_649 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$900 = [];
    var tmp_650 = ObjectSerializer.l1c('BondedTrackCard', tmp_649, tmp$ret$900);
    var tmp_651 = $serializer_getInstance_326();
    var tmp_652 = TrapmasterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$903 = [];
    var tmp_653 = ObjectSerializer.l1c('TrapmasterCard', tmp_652, tmp$ret$903);
    var tmp_654 = UnnaturalResolveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$906 = [];
    var tmp_655 = ObjectSerializer.l1c('UnnaturalResolveCard', tmp_654, tmp$ret$906);
    var tmp_656 = WardCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$909 = [];
    var tmp_657 = ObjectSerializer.l1c('WardCard', tmp_656, tmp$ret$909);
    var tmp_658 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$912 = [];
    var tmp_659 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_658, tmp$ret$912);
    var tmp_660 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$915 = [];
    var tmp_661 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_660, tmp$ret$915);
    var tmp_662 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$918 = [];
    var tmp_663 = ObjectSerializer.l1c('OverloadedNestCard', tmp_662, tmp$ret$918);
    var tmp_664 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$921 = [];
    var tmp_665 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_664, tmp$ret$921);
    var tmp_666 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$924 = [];
    var tmp_667 = ObjectSerializer.l1c('OverloadedStormCard', tmp_666, tmp$ret$924);
    var tmp_668 = AbruptDecayCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$927 = [];
    var tmp_669 = ObjectSerializer.l1c('AbruptDecayCard', tmp_668, tmp$ret$927);
    var tmp_670 = $serializer_getInstance_88();
    var tmp_671 = DisappearCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$930 = [];
    var tmp_672 = ObjectSerializer.l1c('DisappearCard', tmp_671, tmp$ret$930);
    var tmp_673 = $serializer_getInstance_92();
    var tmp_674 = $serializer_getInstance_86();
    var tmp_675 = $serializer_getInstance_96();
    var tmp_676 = $serializer_getInstance_97();
    var tmp_677 = FuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$933 = [];
    var tmp_678 = ObjectSerializer.l1c('FuryCard', tmp_677, tmp$ret$933);
    var tmp_679 = $serializer_getInstance_91();
    var tmp_680 = $serializer_getInstance_93();
    var tmp_681 = $serializer_getInstance_98();
    var tmp_682 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$936 = [];
    var tmp_683 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_682, tmp$ret$936);
    var tmp_684 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$939 = [];
    var tmp_685 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_684, tmp$ret$939);
    var tmp_686 = $serializer_getInstance_89();
    var tmp_687 = $serializer_getInstance_378();
    var tmp_688 = $serializer_getInstance_94();
    var tmp_689 = ShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$942 = [];
    var tmp_690 = ObjectSerializer.l1c('ShatterCard', tmp_689, tmp$ret$942);
    var tmp_691 = $serializer_getInstance_95();
    var tmp_692 = $serializer_getInstance_90();
    var tmp_693 = SwarmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$945 = [];
    var tmp_694 = ObjectSerializer.l1c('SwarmCard', tmp_693, tmp$ret$945);
    var tmp_695 = $serializer_getInstance_87();
    var tmp_696 = AurorasPassage_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$948 = [];
    var tmp_697 = ObjectSerializer.l1c('AurorasPassage', tmp_696, tmp$ret$948);
    var tmp_698 = BansheesLureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$951 = [];
    var tmp_699 = ObjectSerializer.l1c('BansheesLureCard', tmp_698, tmp$ret$951);
    var tmp_700 = BladeOfValhCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$954 = [];
    var tmp_701 = ObjectSerializer.l1c('BladeOfValhCard', tmp_700, tmp$ret$954);
    var tmp_702 = ChainGrapnelCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$957 = [];
    var tmp_703 = ObjectSerializer.l1c('ChainGrapnelCard', tmp_702, tmp$ret$957);
    var tmp_704 = $serializer_getInstance_339();
    var tmp_705 = GrapeshotCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$960 = [];
    var tmp_706 = ObjectSerializer.l1c('GrapeshotCard', tmp_705, tmp$ret$960);
    var tmp_707 = $serializer_getInstance_337();
    var tmp_708 = $serializer_getInstance_338();
    var tmp_709 = $serializer_getInstance_336();
    var tmp_710 = $serializer_getInstance_334();
    var tmp_711 = $serializer_getInstance_379();
    var tmp_712 = $serializer_getInstance_341();
    var tmp_713 = SpyglassCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$963 = [];
    var tmp_714 = ObjectSerializer.l1c('SpyglassCard', tmp_713, tmp$ret$963);
    var tmp_715 = $serializer_getInstance_333();
    var tmp_716 = $serializer_getInstance_332();
    var tmp_717 = $serializer_getInstance_340();
    var tmp_718 = $serializer_getInstance_328();
    var tmp_719 = WarhogsTuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$966 = [];
    var tmp_720 = ObjectSerializer.l1c('WarhogsTuskCard', tmp_719, tmp$ret$966);
    var tmp_721 = $serializer_getInstance_335();
    var tmp_722 = BleatCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$969 = [];
    var tmp_723 = ObjectSerializer.l1c('BleatCard', tmp_722, tmp$ret$969);
    var tmp_724 = $serializer_getInstance_329();
    var tmp_725 = EsmeriasStrandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$972 = [];
    var tmp_726 = ObjectSerializer.l1c('EsmeriasStrandCard', tmp_725, tmp$ret$972);
    var tmp_727 = $serializer_getInstance_330();
    var tmp_728 = $serializer_getInstance_84();
    var tmp_729 = MistShroudCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$975 = [];
    var tmp_730 = ObjectSerializer.l1c('MistShroudCard', tmp_729, tmp$ret$975);
    var tmp_731 = RecoveryTestBeastReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$978 = [];
    var tmp_732 = ObjectSerializer.l1c('RecoveryTestBeastReaction', tmp_731, tmp$ret$978);
    var tmp_733 = RecoveryTestHunterReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$981 = [];
    var tmp_734 = ObjectSerializer.l1c('RecoveryTestHunterReaction', tmp_733, tmp$ret$981);
    var tmp_735 = $serializer_getInstance_331();
    var tmp_736 = SuddenMistCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$984 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_737 = [tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_66, tmp_68, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_80, tmp_82, tmp_84, tmp_86, tmp_88, tmp_90, tmp_92, tmp_94, tmp_96, tmp_98, tmp_100, tmp_102, tmp_104, tmp_106, tmp_108, tmp_109, tmp_111, tmp_113, tmp_115, tmp_117, tmp_119, tmp_121, tmp_123, tmp_125, tmp_127, tmp_129, tmp_131, tmp_133, tmp_135, tmp_137, tmp_139, tmp_141, tmp_143, tmp_145, tmp_147, tmp_149, tmp_151, tmp_153, tmp_154, tmp_156, tmp_158, tmp_160, tmp_162, tmp_164, tmp_166, tmp_168, tmp_170, tmp_172, tmp_174, tmp_176, tmp_178, tmp_180, tmp_182, tmp_184, tmp_186, tmp_188, tmp_190, tmp_192, tmp_194, tmp_196, tmp_198, tmp_200, tmp_202, tmp_204, tmp_206, tmp_208, tmp_210, tmp_212, tmp_214, tmp_216, tmp_218, tmp_220, tmp_222, tmp_224, tmp_226, tmp_228, tmp_230, tmp_232, tmp_234, tmp_236, tmp_238, tmp_240, tmp_242, tmp_244, tmp_246, tmp_248, tmp_250, tmp_252, tmp_254, tmp_256, tmp_258, tmp_260, tmp_262, tmp_264, tmp_266, tmp_268, tmp_270, tmp_272, tmp_274, tmp_276, tmp_278, tmp_280, tmp_282, tmp_284, tmp_286, tmp_288, tmp_290, tmp_291, tmp_293, tmp_295, tmp_297, tmp_299, tmp_301, tmp_303, tmp_305, tmp_307, tmp_309, tmp_311, tmp_313, tmp_315, tmp_316, tmp_318, tmp_320, tmp_322, tmp_324, tmp_326, tmp_328, tmp_330, tmp_332, tmp_334, tmp_336, tmp_338, tmp_340, tmp_342, tmp_344, tmp_346, tmp_348, tmp_349, tmp_350, tmp_352, tmp_353, tmp_355, tmp_356, tmp_357, tmp_358, tmp_359, tmp_361, tmp_362, tmp_363, tmp_364, tmp_366, tmp_368, tmp_369, tmp_370, tmp_371, tmp_373, tmp_374, tmp_375, tmp_377, tmp_378, tmp_380, tmp_382, tmp_384, tmp_386, tmp_388, tmp_389, tmp_390, tmp_391, tmp_393, tmp_394, tmp_396, tmp_398, tmp_400, tmp_402, tmp_403, tmp_405, tmp_406, tmp_407, tmp_408, tmp_409, tmp_410, tmp_411, tmp_413, tmp_414, tmp_415, tmp_416, tmp_417, tmp_419, tmp_420, tmp_422, tmp_423, tmp_424, tmp_425, tmp_426, tmp_428, tmp_430, tmp_432, tmp_434, tmp_436, tmp_438, tmp_440, tmp_442, tmp_444, tmp_446, tmp_448, tmp_450, tmp_452, tmp_454, tmp_456, tmp_458, tmp_460, tmp_462, tmp_464, tmp_466, tmp_468, tmp_470, tmp_472, tmp_474, tmp_476, tmp_478, tmp_480, tmp_482, tmp_484, tmp_486, tmp_488, tmp_490, tmp_492, tmp_494, tmp_496, tmp_498, tmp_500, tmp_502, tmp_504, tmp_506, tmp_508, tmp_510, tmp_512, tmp_514, tmp_516, tmp_518, tmp_520, tmp_522, tmp_524, tmp_526, tmp_528, tmp_530, tmp_532, tmp_534, tmp_536, tmp_538, tmp_540, tmp_542, tmp_544, tmp_546, tmp_548, tmp_550, tmp_552, tmp_554, tmp_556, tmp_558, tmp_560, tmp_562, tmp_564, tmp_566, tmp_568, tmp_570, tmp_572, tmp_574, tmp_576, tmp_578, tmp_580, tmp_582, tmp_584, tmp_586, tmp_588, tmp_590, tmp_592, tmp_594, tmp_596, tmp_598, tmp_600, tmp_602, tmp_604, tmp_605, tmp_607, tmp_609, tmp_611, tmp_613, tmp_615, tmp_617, tmp_619, tmp_621, tmp_623, tmp_625, tmp_626, tmp_628, tmp_630, tmp_632, tmp_634, tmp_636, tmp_638, tmp_640, tmp_642, tmp_644, tmp_646, tmp_648, tmp_650, tmp_651, tmp_653, tmp_655, tmp_657, tmp_659, tmp_661, tmp_663, tmp_665, tmp_667, tmp_669, tmp_670, tmp_672, tmp_673, tmp_674, tmp_675, tmp_676, tmp_678, tmp_679, tmp_680, tmp_681, tmp_683, tmp_685, tmp_686, tmp_687, tmp_688, tmp_690, tmp_691, tmp_692, tmp_694, tmp_695, tmp_697, tmp_699, tmp_701, tmp_703, tmp_704, tmp_706, tmp_707, tmp_708, tmp_709, tmp_710, tmp_711, tmp_712, tmp_714, tmp_715, tmp_716, tmp_717, tmp_718, tmp_720, tmp_721, tmp_723, tmp_724, tmp_726, tmp_727, tmp_728, tmp_730, tmp_732, tmp_734, tmp_735, ObjectSerializer.l1c('SuddenMistCard', tmp_736, tmp$ret$984), $serializer_getInstance_85(), $serializer_getInstance_74(), $serializer_getInstance_99(), $serializer_getInstance_127(), $serializer_getInstance_343(), $serializer_getInstance_317(), $serializer_getInstance_318(), $serializer_getInstance_319(), $serializer_getInstance_320()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$990 = [];
    return SealedClassSerializer.i10('steelart.beast.GeneralObjectProperty', tmp, tmp_0, tmp_737, tmp$ret$990);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_370 {}
class $serializer_319 {
  constructor() {
    $serializer_instance_316 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('IntWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.d5e_1 = tmp0_serialDesc;
  }
  e5e(encoder, value) {
    var tmp0_desc = this.d5e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.t3p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e5e(encoder, value instanceof IntWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d5e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return IntWrapper.f5e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d5e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class IntWrapper {
  constructor(value) {
    this.t3p_1 = value;
  }
  toString() {
    return 'IntWrapper(value=' + this.t3p_1 + ')';
  }
  hashCode() {
    return this.t3p_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IntWrapper))
      return false;
    if (!(this.t3p_1 === other.t3p_1))
      return false;
    return true;
  }
  static f5e(seen0, value, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_316().d5e_1);
    }
    var $this = createThis(this);
    $this.t3p_1 = value;
    return $this;
  }
}
class Companion_371 {
  constructor() {
    Companion_instance_371 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g5e_1 = [lazy(tmp_0, PlayableCardSetWrapper$Companion$$childSerializers$_anonymous__ankcud)];
  }
}
class $serializer_320 {
  constructor() {
    $serializer_instance_317 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayableCardSetWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.h5e_1 = tmp0_serialDesc;
  }
  i5e(encoder, value) {
    var tmp0_desc = this.h5e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_372().g5e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s3p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i5e(encoder, value instanceof PlayableCardSetWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h5e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_372().g5e_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlayableCardSetWrapper.j5e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.h5e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_372().g5e_1[0].k3()];
  }
}
class PlayableCardSetWrapper {
  constructor(value) {
    Companion_getInstance_372();
    this.s3p_1 = value;
  }
  toString() {
    return 'PlayableCardSetWrapper(value=' + toString(this.s3p_1) + ')';
  }
  hashCode() {
    return hashCode(this.s3p_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayableCardSetWrapper))
      return false;
    if (!equals(this.s3p_1, other.s3p_1))
      return false;
    return true;
  }
  static j5e(seen0, value, serializationConstructorMarker) {
    Companion_getInstance_372();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_317().h5e_1);
    }
    var $this = createThis(this);
    $this.s3p_1 = value;
    return $this;
  }
}
class Companion_372 {
  constructor() {
    Companion_instance_372 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k5e_1 = [lazy(tmp_0, PlayableCardToIntMapWrapper$Companion$$childSerializers$_anonymous__ajmb4t)];
  }
}
class $serializer_321 {
  constructor() {
    $serializer_instance_318 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayableCardToIntMapWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.l5e_1 = tmp0_serialDesc;
  }
  m5e(encoder, value) {
    var tmp0_desc = this.l5e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_373().k5e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n5e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m5e(encoder, value instanceof PlayableCardToIntMapWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l5e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_373().k5e_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlayableCardToIntMapWrapper.o5e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l5e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_373().k5e_1[0].k3()];
  }
}
class PlayableCardToIntMapWrapper {
  constructor(value) {
    Companion_getInstance_373();
    this.n5e_1 = value;
  }
  toString() {
    return 'PlayableCardToIntMapWrapper(value=' + toString(this.n5e_1) + ')';
  }
  hashCode() {
    return hashCode(this.n5e_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayableCardToIntMapWrapper))
      return false;
    if (!equals(this.n5e_1, other.n5e_1))
      return false;
    return true;
  }
  static o5e(seen0, value, serializationConstructorMarker) {
    Companion_getInstance_373();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_318().l5e_1);
    }
    var $this = createThis(this);
    $this.n5e_1 = value;
    return $this;
  }
}
class Companion_373 {
  constructor() {
    Companion_instance_373 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p5e_1 = [lazy(tmp_0, PlayableCardToLocationTypeMapWrapper$Companion$$childSerializers$_anonymous__e4scq3)];
  }
}
class $serializer_322 {
  constructor() {
    $serializer_instance_319 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayableCardToLocationTypeMapWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.q5e_1 = tmp0_serialDesc;
  }
  r5e(encoder, value) {
    var tmp0_desc = this.q5e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_374().p5e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.s5e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r5e(encoder, value instanceof PlayableCardToLocationTypeMapWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q5e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_374().p5e_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlayableCardToLocationTypeMapWrapper.t5e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.q5e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_374().p5e_1[0].k3()];
  }
}
class PlayableCardToLocationTypeMapWrapper {
  constructor(value) {
    Companion_getInstance_374();
    this.s5e_1 = value;
  }
  toString() {
    return 'PlayableCardToLocationTypeMapWrapper(value=' + toString(this.s5e_1) + ')';
  }
  hashCode() {
    return hashCode(this.s5e_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayableCardToLocationTypeMapWrapper))
      return false;
    if (!equals(this.s5e_1, other.s5e_1))
      return false;
    return true;
  }
  static t5e(seen0, value, serializationConstructorMarker) {
    Companion_getInstance_374();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_319().q5e_1);
    }
    var $this = createThis(this);
    $this.s5e_1 = value;
    return $this;
  }
}
class Companion_374 {
  constructor() {
    Companion_instance_374 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v5e_1 = [lazy(tmp_0, SnareTypeWrapper$Companion$$childSerializers$_anonymous__7uoave)];
  }
}
class $serializer_323 {
  constructor() {
    $serializer_instance_320 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SnareTypeWrapper', this, 1);
    tmp0_serialDesc.h1b('value', false);
    this.w5e_1 = tmp0_serialDesc;
  }
  x5e(encoder, value) {
    var tmp0_desc = this.w5e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_375().v5e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y5e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x5e(encoder, value instanceof SnareTypeWrapper ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w5e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_375().v5e_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SnareTypeWrapper.z5e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w5e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_375().v5e_1[0].k3()];
  }
}
class SnareTypeWrapper {
  constructor(value) {
    Companion_getInstance_375();
    this.y5e_1 = value;
  }
  toString() {
    return 'SnareTypeWrapper(value=' + this.y5e_1.toString() + ')';
  }
  hashCode() {
    return this.y5e_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SnareTypeWrapper))
      return false;
    if (!this.y5e_1.equals(other.y5e_1))
      return false;
    return true;
  }
  static z5e(seen0, value, serializationConstructorMarker) {
    Companion_getInstance_375();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_320().w5e_1);
    }
    var $this = createThis(this);
    $this.y5e_1 = value;
    return $this;
  }
}
class Companion_375 {}
class $serializer_324 {
  constructor() {
    $serializer_instance_321 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GreatCleansingContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.a5f_1 = tmp0_serialDesc;
  }
  b5f(encoder, value) {
    var tmp0_desc = this.a5f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.d5f_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.e5f_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 2, value.e5f_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.f5f_1 === 2)) {
      tmp1_output.z14(tmp0_desc, 3, value.f5f_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.g5f_1.equals(Companion_getInstance_220().w39_1)) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.g5f_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b5f(encoder, value instanceof GreatCleansingContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a5f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return GreatCleansingContract.h5f(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.a5f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class GreatCleansingContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.i5f(rulesParameters);
  }
  static i5f(rulesParameters) {
    var $this = this.b3a();
    $this.d5f_1 = rulesParameters;
    $this.e5f_1 = 3;
    $this.f5f_1 = 2;
    $this.g5f_1 = Companion_getInstance_220().w39_1;
    return $this;
  }
  c3a() {
    return this.d5f_1;
  }
  static j5f(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().w39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.i5f(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(2, 1);
  }
  h3a() {
    return GameMapId_DrenchedLands_getInstance();
  }
  i3a() {
    return this.e5f_1;
  }
  j3a() {
    return 1;
  }
  k3a() {
    return 2;
  }
  l3a() {
    return this.f5f_1;
  }
  m3a() {
    return GreatCleansingInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_isClassicTwoSheepOrBoarCompleted_0($context_GameState_t6qee5));
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0 = get_destroyedObjects($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp$ret$6;
        $l$block: {
          // Inline function 'steelart.beast.cast' call
          var tmp_0 = get_objectType($context_GameState_t6qee5, element);
          if (isInterface(tmp_0, SettlerType)) {
            tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
            break $l$block;
          }
          tmp$ret$6 = null;
        }
        var tmp0_safe_receiver = tmp$ret$6;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.d2(tmp0_safe_receiver);
        }
      }
      tmp = expectedOrFailedRewardStatus(destination.n1());
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_0 = get_destroyedObjects($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = tmp0_0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        var tmp$ret$15;
        $l$block_0: {
          // Inline function 'steelart.beast.cast' call
          var tmp_1 = get_objectType($context_GameState_t6qee5, element_0);
          if (isInterface(tmp_1, SettlerType)) {
            tmp$ret$15 = element_0 instanceof ObjectOnBoard ? element_0 : THROW_CCE();
            break $l$block_0;
          }
          tmp$ret$15 = null;
        }
        var tmp0_safe_receiver_0 = tmp$ret$15;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_0.d2(tmp0_safe_receiver_0);
        }
      }
      var tmp$ret$18;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_2;
        if (isInterface(destination_0, Collection)) {
          tmp_2 = destination_0.n1();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$18 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_1 = destination_0.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var element_1 = _iterator__ex2g4s_1.r1();
          if (equals(get_gameMap_0(this).h3t(get_initialPosition($context_GameState_t6qee5, element_1)), Zone_Vildmark_getInstance())) {
            tmp$ret$18 = true;
            break $l$block_2;
          }
        }
        tmp$ret$18 = false;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp$ret$18);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) >= 2);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.g5f_1;
  }
  v3a(rulesParameters) {
    return GreatCleansingContract.i5f(rulesParameters);
  }
  toString() {
    return 'GreatCleansingContract(rulesParameters=' + this.d5f_1.toString() + ')';
  }
  hashCode() {
    return this.d5f_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GreatCleansingContract))
      return false;
    if (!this.d5f_1.equals(other.d5f_1))
      return false;
    return true;
  }
  static h5f(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_321().a5f_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.d5f_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.e5f_1 = 3;
    else
      $this.e5f_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.f5f_1 = 2;
    else
      $this.f5f_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.g5f_1 = Companion_getInstance_220().w39_1;
    else
      $this.g5f_1 = requiredVersion;
    return $this;
  }
}
class GreatCleansingInitialPhase {
  constructor() {
    GreatCleansingInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k5f_1 = lazy(tmp_0, GreatCleansingInitialPhase$_anonymous__r4dnsb);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_287(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'GreatCleansingInitialPhase';
  }
  hashCode() {
    return -1199696121;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GreatCleansingInitialPhase))
      return false;
    return true;
  }
}
class Grimgeir {
  constructor() {
    Grimgeir_instance = this;
    this.l5f_1 = setOf_0([WatchtowerPassageUpgrade_getInstance(), RefugeUpgrade_getInstance(), TownswatchUpgrade_getInstance(), DefenderUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m5f_1 = lazy(tmp_0, Grimgeir$_anonymous__knohoh);
  }
  s36() {
    return plus_0(get_abilityCards.call(this), CleaverCard_getInstance());
  }
  t35() {
    return this.l5f_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_288(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Grimgeir';
  }
  hashCode() {
    return -185322469;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Grimgeir))
      return false;
    return true;
  }
}
class WatchtowerPassageUpgrade {
  constructor() {
    WatchtowerPassageUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n5f_1 = lazy(tmp_0, WatchtowerPassageUpgrade$_anonymous__kdfxyn);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_289(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WatchtowerPassageUpgrade';
  }
  hashCode() {
    return -1488431891;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WatchtowerPassageUpgrade))
      return false;
    return true;
  }
}
class RefugeUpgrade {
  constructor() {
    RefugeUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o5f_1 = lazy(tmp_0, RefugeUpgrade$_anonymous__ml9akb);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_290(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RefugeUpgrade';
  }
  hashCode() {
    return -1923947337;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RefugeUpgrade))
      return false;
    return true;
  }
}
class TownswatchUpgrade {
  constructor() {
    TownswatchUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p5f_1 = lazy(tmp_0, TownswatchUpgrade$_anonymous__rzbro7);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_291(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TownswatchUpgrade';
  }
  hashCode() {
    return 629085385;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TownswatchUpgrade))
      return false;
    return true;
  }
}
class DefenderUpgrade {
  constructor() {
    DefenderUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q5f_1 = lazy(tmp_0, DefenderUpgrade$_anonymous__x6yhu);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_292(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DefenderUpgrade';
  }
  hashCode() {
    return -1781254828;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DefenderUpgrade))
      return false;
    return true;
  }
}
class Companion_376 {
  constructor() {
    Companion_instance_376 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r5f_1 = [lazy(tmp_0, DefenderWithChoiceAction$Companion$$childSerializers$_anonymous__uj2422)];
  }
}
class $serializer_325 {
  constructor() {
    $serializer_instance_322 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DefenderWithChoiceAction', this, 1);
    tmp0_serialDesc.h1b('canBlockForTargets', false);
    this.s5f_1 = tmp0_serialDesc;
  }
  t5f(encoder, value) {
    var tmp0_desc = this.s5f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_377().r5f_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u5f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t5f(encoder, value instanceof DefenderWithChoiceAction ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s5f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_377().r5f_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DefenderWithChoiceAction.v5f(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s5f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_377().r5f_1[0].k3()];
  }
}
class DefenderWithChoiceAction {
  constructor(canBlockForTargets) {
    Companion_getInstance_377();
    this.u5f_1 = canBlockForTargets;
  }
  toString() {
    return 'DefenderWithChoiceAction(canBlockForTargets=' + toString(this.u5f_1) + ')';
  }
  hashCode() {
    return hashCode(this.u5f_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DefenderWithChoiceAction))
      return false;
    if (!equals(this.u5f_1, other.u5f_1))
      return false;
    return true;
  }
  static v5f(seen0, canBlockForTargets, serializationConstructorMarker) {
    Companion_getInstance_377();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_322().s5f_1);
    }
    var $this = createThis(this);
    $this.u5f_1 = canBlockForTargets;
    return $this;
  }
}
class Companion_377 {
  constructor() {
    Companion_instance_377 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w5f_1 = [lazy(tmp_0, RelocationToWatchtowerStatement$Companion$$childSerializers$_anonymous__d16diw)];
  }
}
class $serializer_326 {
  constructor() {
    $serializer_instance_323 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RelocationToWatchtowerStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.x5f_1 = tmp0_serialDesc;
  }
  y5f(encoder, value) {
    var tmp0_desc = this.x5f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_378().w5f_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.z5f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y5f(encoder, value instanceof RelocationToWatchtowerStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x5f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_378().w5f_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RelocationToWatchtowerStatement.a5g(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x5f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_378().w5f_1[0].k3()];
  }
}
class RelocationToWatchtowerStatement {
  constructor(hunter) {
    Companion_getInstance_378();
    this.z5f_1 = hunter;
  }
  toString() {
    return 'RelocationToWatchtowerStatement(hunter=' + this.z5f_1.toString() + ')';
  }
  hashCode() {
    return this.z5f_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RelocationToWatchtowerStatement))
      return false;
    if (!this.z5f_1.equals(other.z5f_1))
      return false;
    return true;
  }
  static a5g(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_378();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_323().x5f_1);
    }
    var $this = createThis(this);
    $this.z5f_1 = hunter;
    return $this;
  }
}
class CleaverCard {
  constructor() {
    CleaverCard_instance = this;
    this.b5g_1 = Red_getInstance();
    this.c5g_1 = Grimgeir_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d5g_1 = lazy(tmp_0, CleaverCard$_anonymous__9oeasp);
  }
  t37() {
    return this.c5g_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_293(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CleaverCard';
  }
  hashCode() {
    return 1798877961;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CleaverCard))
      return false;
    return true;
  }
}
class Helga {
  constructor() {
    Helga_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e5g_1 = lazy(tmp_0, Helga$_anonymous__lysu3y);
  }
  s36() {
    return plus_0(get_abilityCards.call(this), SeerCard_getInstance());
  }
  t35() {
    return setOf_0([TormentingVisionsUpgrade_getInstance(), SoothsayerUpgrade_getInstance(), ClairvoyantUpgrade_getInstance(), AncientBondUpgrade_getInstance()]);
  }
  n2z($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_294(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Helga';
  }
  hashCode() {
    return 1657333892;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Helga))
      return false;
    return true;
  }
}
class TormentingVisionsUpgrade {
  constructor() {
    TormentingVisionsUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f5g_1 = lazy(tmp_0, TormentingVisionsUpgrade$_anonymous__j7zcgp);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_295(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TormentingVisionsUpgrade';
  }
  hashCode() {
    return 802586563;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TormentingVisionsUpgrade))
      return false;
    return true;
  }
}
class SoothsayerUpgrade {
  constructor() {
    SoothsayerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g5g_1 = lazy(tmp_0, SoothsayerUpgrade$_anonymous__phq8j0);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_296(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SoothsayerUpgrade';
  }
  hashCode() {
    return -276261434;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoothsayerUpgrade))
      return false;
    return true;
  }
}
class ClairvoyantUpgrade {
  constructor() {
    ClairvoyantUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h5g_1 = lazy(tmp_0, ClairvoyantUpgrade$_anonymous__f3z7a5);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_297(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ClairvoyantUpgrade';
  }
  hashCode() {
    return -1971475463;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClairvoyantUpgrade))
      return false;
    return true;
  }
}
class AncientBondUpgrade {
  constructor() {
    AncientBondUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i5g_1 = lazy(tmp_0, AncientBondUpgrade$_anonymous__3ft57u);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_298(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AncientBondUpgrade';
  }
  hashCode() {
    return -2135088250;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AncientBondUpgrade))
      return false;
    return true;
  }
}
class SeerCard {
  constructor() {
    SeerCard_instance = this;
    this.j5g_1 = Red_getInstance();
    this.k5g_1 = Helga_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l5g_1 = lazy(tmp_0, SeerCard$_anonymous__scyi1k);
  }
  t37() {
    return this.k5g_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_299(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SeerCard';
  }
  hashCode() {
    return 489944052;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SeerCard))
      return false;
    return true;
  }
}
class RampageousUpgrade {
  constructor() {
    RampageousUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m5g_1 = lazy(tmp_0, RampageousUpgrade$_anonymous__6zyhx);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_300(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RampageousUpgrade';
  }
  hashCode() {
    return -1599461033;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RampageousUpgrade))
      return false;
    return true;
  }
}
class InfernalTusksUpgrade {
  constructor() {
    InfernalTusksUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n5g_1 = lazy(tmp_0, InfernalTusksUpgrade$_anonymous__yn2u52);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_301(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'InfernalTusksUpgrade';
  }
  hashCode() {
    return 766036402;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InfernalTusksUpgrade))
      return false;
    return true;
  }
}
class HordesMarchUpgrade {
  constructor() {
    HordesMarchUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o5g_1 = lazy(tmp_0, HordesMarchUpgrade$_anonymous__3f5895);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_302(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HordesMarchUpgrade';
  }
  hashCode() {
    return 1229452133;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HordesMarchUpgrade))
      return false;
    return true;
  }
}
class WildOdeUpgrade {
  constructor() {
    WildOdeUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p5g_1 = lazy(tmp_0, WildOdeUpgrade$_anonymous__r4sw2n);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_303(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WildOdeUpgrade';
  }
  hashCode() {
    return 147885115;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WildOdeUpgrade))
      return false;
    return true;
  }
}
class ChiefsCommandUpgrade {
  constructor() {
    ChiefsCommandUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q5g_1 = lazy(tmp_0, ChiefsCommandUpgrade$_anonymous__rdo1go);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_304(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ChiefsCommandUpgrade';
  }
  hashCode() {
    return 1345881860;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChiefsCommandUpgrade))
      return false;
    return true;
  }
}
class PrimalInstinctsUpgrade {
  constructor() {
    PrimalInstinctsUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r5g_1 = lazy(tmp_0, PrimalInstinctsUpgrade$_anonymous__44nom7);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_305(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PrimalInstinctsUpgrade';
  }
  hashCode() {
    return 1393878587;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimalInstinctsUpgrade))
      return false;
    return true;
  }
}
class AmassUpgrade {
  constructor() {
    AmassUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s5g_1 = lazy(tmp_0, AmassUpgrade$_anonymous__msv2z4);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_306(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AmassUpgrade';
  }
  hashCode() {
    return -1785004852;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AmassUpgrade))
      return false;
    return true;
  }
}
class Hogbad {
  constructor() {
    Hogbad_instance = this;
    this.t5g_1 = setOf_0([RampageousUpgrade_getInstance(), InfernalTusksUpgrade_getInstance(), HordesMarchUpgrade_getInstance(), WildOdeUpgrade_getInstance(), ChiefsCommandUpgrade_getInstance(), PrimalInstinctsUpgrade_getInstance(), AmassUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u5g_1 = lazy(tmp_0, Hogbad$_anonymous__1ae4j2);
  }
  q36() {
    return WarhogType_getInstance();
  }
  u36() {
    return 3;
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Forest_getInstance();
  }
  s36() {
    return setOf_0([TuskCard_getInstance(), SummonWarhogCard_getInstance(), StampedeCard_getInstance(), RambleCard_getInstance()]);
  }
  t35() {
    return this.t5g_1;
  }
  n2z($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_307(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Hogbad';
  }
  hashCode() {
    return -153175350;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Hogbad))
      return false;
    return true;
  }
}
class BoarToTransformQuestionContext {
  constructor() {
    BoarToTransformQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v5g_1 = lazy(tmp_0, BoarToTransformQuestionContext$_anonymous__58grcv);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_308(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BoarToTransformQuestionContext';
  }
  hashCode() {
    return 1561500507;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BoarToTransformQuestionContext))
      return false;
    return true;
  }
}
class Companion_378 {
  constructor() {
    Companion_instance_378 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w5g_1 = [lazy(tmp_0, AmassTransformationStatement$Companion$$childSerializers$_anonymous__7zd5y1)];
  }
}
class $serializer_327 {
  constructor() {
    $serializer_instance_324 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AmassTransformationStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.x5g_1 = tmp0_serialDesc;
  }
  y5g(encoder, value) {
    var tmp0_desc = this.x5g_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_379().w5g_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.z5g_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y5g(encoder, value instanceof AmassTransformationStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x5g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_379().w5g_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AmassTransformationStatement.a5h(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x5g_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_379().w5g_1[0].k3()];
  }
}
class AmassTransformationStatement {
  constructor(beast) {
    Companion_getInstance_379();
    this.z5g_1 = beast;
  }
  toString() {
    return 'AmassTransformationStatement(beast=' + this.z5g_1.toString() + ')';
  }
  hashCode() {
    return this.z5g_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AmassTransformationStatement))
      return false;
    if (!this.z5g_1.equals(other.z5g_1))
      return false;
    return true;
  }
  static a5h(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_379();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_324().x5g_1);
    }
    var $this = createThis(this);
    $this.z5g_1 = beast;
    return $this;
  }
}
class ChiefsCommandStatement {
  constructor() {
    ChiefsCommandStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b5h_1 = lazy(tmp_0, ChiefsCommandStatement$_anonymous__if0dq3);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_309(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ChiefsCommandStatement';
  }
  hashCode() {
    return 1634696279;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChiefsCommandStatement))
      return false;
    return true;
  }
}
class PrimalInstinctsStatement {
  constructor() {
    PrimalInstinctsStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c5h_1 = lazy(tmp_0, PrimalInstinctsStatement$_anonymous__le5bgu);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_310(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PrimalInstinctsStatement';
  }
  hashCode() {
    return 514910670;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimalInstinctsStatement))
      return false;
    return true;
  }
}
class Companion_379 {
  constructor() {
    Companion_instance_379 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d5h_1 = [lazy(tmp_0, PushStatement$Companion$$childSerializers$_anonymous__eaa1aj), null];
  }
}
class $serializer_328 {
  constructor() {
    $serializer_instance_325 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PushStatement', this, 2);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('isStampede', false);
    this.e5h_1 = tmp0_serialDesc;
  }
  f5h(encoder, value) {
    var tmp0_desc = this.e5h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_380().d5h_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g5h_1);
    tmp1_output.w14(tmp0_desc, 1, value.h5h_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f5h(encoder, value instanceof PushStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e5h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_380().d5h_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PushStatement.i5h(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.e5h_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_380().d5h_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class PushStatement {
  constructor(actor, isStampede) {
    Companion_getInstance_380();
    this.g5h_1 = actor;
    this.h5h_1 = isStampede;
  }
  toString() {
    return 'PushStatement(actor=' + this.g5h_1.toString() + ', isStampede=' + this.h5h_1 + ')';
  }
  hashCode() {
    var result = this.g5h_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.h5h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PushStatement))
      return false;
    if (!this.g5h_1.equals(other.g5h_1))
      return false;
    if (!(this.h5h_1 === other.h5h_1))
      return false;
    return true;
  }
  static i5h(seen0, actor, isStampede, serializationConstructorMarker) {
    Companion_getInstance_380();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_325().e5h_1);
    }
    var $this = createThis(this);
    $this.g5h_1 = actor;
    $this.h5h_1 = isStampede;
    return $this;
  }
}
class WarhogType {
  constructor() {
    WarhogType_instance = this;
    this.j5h_1 = Hogbad_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k5h_1 = lazy(tmp_0, WarhogType$_anonymous__9c2f2z);
  }
  r37() {
    return this.j5h_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_311(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WarhogType';
  }
  hashCode() {
    return -1595389897;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WarhogType))
      return false;
    return true;
  }
}
class RambleCard {
  constructor() {
    RambleCard_instance = this;
    this.l5h_1 = Hogbad_getInstance();
    this.m5h_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n5h_1 = lazy(tmp_0, RambleCard$_anonymous__ogxyqy);
  }
  t37() {
    return this.l5h_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_312(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RambleCard';
  }
  hashCode() {
    return -1855258190;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RambleCard))
      return false;
    return true;
  }
}
class StampedeCard {
  constructor() {
    StampedeCard_instance = this;
    this.o5h_1 = Hogbad_getInstance();
    this.p5h_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q5h_1 = lazy(tmp_0, StampedeCard$_anonymous__uu04t8);
  }
  t37() {
    return this.o5h_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_313(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'StampedeCard';
  }
  hashCode() {
    return -1160551944;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StampedeCard))
      return false;
    return true;
  }
}
class SummonWarhogCard {
  constructor() {
    SummonWarhogCard_instance = this;
    this.r5h_1 = Hogbad_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s5h_1 = lazy(tmp_0, SummonWarhogCard$_anonymous__3r00ky);
  }
  t37() {
    return this.r5h_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_314(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonWarhogCard';
  }
  hashCode() {
    return 1769813006;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonWarhogCard))
      return false;
    return true;
  }
}
class TuskCard {
  constructor() {
    TuskCard_instance = this;
    this.t5h_1 = Hogbad_getInstance();
    this.u5h_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v5h_1 = lazy(tmp_0, TuskCard$_anonymous__l4vy1a);
  }
  t37() {
    return this.t5h_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_315(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TuskCard';
  }
  hashCode() {
    return -352712434;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TuskCard))
      return false;
    return true;
  }
}
class Companion_380 {
  a2g() {
    var tmp = getKClass(HunterCharacter);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Assar), getKClass(Bram), getKClass(Draug), getKClass(Eivind), getKClass(EsmeriaHuntress), getKClass(Fara), getKClass(Grimgeir), getKClass(Helga), getKClass(Iona), getKClass(Krim), getKClass(Nora), getKClass(Sigrid), getKClass(Valdi), getKClass(Varja)];
    var tmp_1 = Assar_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Assar', tmp_1, tmp$ret$3);
    var tmp_3 = Bram_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('Bram', tmp_3, tmp$ret$6);
    var tmp_5 = Draug_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('Draug', tmp_5, tmp$ret$9);
    var tmp_7 = Eivind_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Eivind', tmp_7, tmp$ret$12);
    var tmp_9 = EsmeriaHuntress_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('EsmeriaHuntress', tmp_9, tmp$ret$15);
    var tmp_11 = Fara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('Fara', tmp_11, tmp$ret$18);
    var tmp_13 = Grimgeir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('Grimgeir', tmp_13, tmp$ret$21);
    var tmp_15 = Helga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('Helga', tmp_15, tmp$ret$24);
    var tmp_17 = Iona_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('Iona', tmp_17, tmp$ret$27);
    var tmp_19 = Krim_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('Krim', tmp_19, tmp$ret$30);
    var tmp_21 = Nora_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('Nora', tmp_21, tmp$ret$33);
    var tmp_23 = Sigrid_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('Sigrid', tmp_23, tmp$ret$36);
    var tmp_25 = Valdi_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('Valdi', tmp_25, tmp$ret$39);
    var tmp_27 = Varja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_28 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, ObjectSerializer.l1c('Varja', tmp_27, tmp$ret$42)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    return SealedClassSerializer.i10('steelart.beast.HunterCharacter', tmp, tmp_0, tmp_28, tmp$ret$48);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_381 {
  constructor() {
    Companion_instance_381 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, TrackCard$Companion$$childSerializers$_anonymous__fc705t);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w5h_1 = [tmp_1, lazy(tmp_2, TrackCard$Companion$$childSerializers$_anonymous__fc705t_0)];
  }
}
class $serializer_329 {
  constructor() {
    $serializer_instance_326 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TrackCard', this, 2);
    tmp0_serialDesc.h1b('character', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.x5h_1 = tmp0_serialDesc;
  }
  y5h(encoder, value) {
    var tmp0_desc = this.x5h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_382().w5h_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.z5h_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.a5i_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.a5i_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y5h(encoder, value instanceof TrackCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x5h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_382().w5h_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return TrackCard.b5i(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.x5h_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_382().w5h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class TrackCard {
  constructor(character) {
    Companion_getInstance_382();
    this.z5h_1 = character;
    this.a5i_1 = Blue_getInstance();
  }
  t37() {
    return this.z5h_1;
  }
  toString() {
    return 'TrackCard(character=' + toString(this.z5h_1) + ')';
  }
  hashCode() {
    return hashCode(this.z5h_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrackCard))
      return false;
    if (!equals(this.z5h_1, other.z5h_1))
      return false;
    return true;
  }
  static b5i(seen0, character, playColor, serializationConstructorMarker) {
    Companion_getInstance_382();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_326().x5h_1);
    }
    var $this = createThis(this);
    $this.z5h_1 = character;
    if (0 === (seen0 & 2))
      $this.a5i_1 = Blue_getInstance();
    else
      $this.a5i_1 = playColor;
    return $this;
  }
}
class Companion_382 {
  constructor() {
    Companion_instance_382 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, HuntCard$Companion$$childSerializers$_anonymous__xctvyx);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c5i_1 = [tmp_1, lazy(tmp_2, HuntCard$Companion$$childSerializers$_anonymous__xctvyx_0)];
  }
}
class $serializer_330 {
  constructor() {
    $serializer_instance_327 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HuntCard', this, 2);
    tmp0_serialDesc.h1b('character', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.d5i_1 = tmp0_serialDesc;
  }
  e5i(encoder, value) {
    var tmp0_desc = this.d5i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_383().c5i_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f5i_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.g5i_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.g5i_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e5i(encoder, value instanceof HuntCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d5i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_383().c5i_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return HuntCard.h5i(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d5i_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_383().c5i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class HuntCard {
  constructor(character) {
    Companion_getInstance_383();
    this.f5i_1 = character;
    this.g5i_1 = Blue_getInstance();
  }
  t37() {
    return this.f5i_1;
  }
  toString() {
    return 'HuntCard(character=' + toString(this.f5i_1) + ')';
  }
  hashCode() {
    return hashCode(this.f5i_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HuntCard))
      return false;
    if (!equals(this.f5i_1, other.f5i_1))
      return false;
    return true;
  }
  static h5i(seen0, character, playColor, serializationConstructorMarker) {
    Companion_getInstance_383();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_327().d5i_1);
    }
    var $this = createThis(this);
    $this.f5i_1 = character;
    if (0 === (seen0 & 2))
      $this.g5i_1 = Blue_getInstance();
    else
      $this.g5i_1 = playColor;
    return $this;
  }
}
class Companion_383 {
  a2g() {
    var tmp = getKClass(HunterCompanionType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(CreatureType), getKClass(Fylgja)];
    var tmp_1 = CreatureType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('CreatureType', tmp_1, tmp$ret$3);
    var tmp_3 = Fylgja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_4 = [tmp_2, ObjectSerializer.l1c('Fylgja', tmp_3, tmp$ret$6)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    return SealedClassSerializer.i10('steelart.beast.HunterCompanionType', tmp, tmp_0, tmp_4, tmp$ret$12);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_384 {}
class $serializer_331 {
  constructor() {
    $serializer_instance_328 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ShriekerTrapCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.i5i_1 = tmp0_serialDesc;
  }
  j5i(encoder, value) {
    var tmp0_desc = this.i5i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.k5i_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j5i(encoder, value instanceof ShriekerTrapCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i5i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ShriekerTrapCard.l5i(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.i5i_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class HunterItemCard {}
class TrapCard {}
class ShriekerTrapCard {
  constructor(number) {
    this.k5i_1 = number;
  }
  u37() {
    return this.k5i_1;
  }
  toString() {
    return 'ShriekerTrapCard(number=' + this.k5i_1 + ')';
  }
  hashCode() {
    return this.k5i_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShriekerTrapCard))
      return false;
    if (!(this.k5i_1 === other.k5i_1))
      return false;
    return true;
  }
  static l5i(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_328().i5i_1);
    }
    var $this = createThis(this);
    $this.k5i_1 = number;
    return $this;
  }
}
class Companion_385 {}
class $serializer_332 {
  constructor() {
    $serializer_instance_329 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DreamerMaskCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.m5i_1 = tmp0_serialDesc;
  }
  n5i(encoder, value) {
    var tmp0_desc = this.m5i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.o5i_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n5i(encoder, value instanceof DreamerMaskCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m5i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DreamerMaskCard.p5i(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m5i_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class DreamerMaskCard {
  constructor(number) {
    this.o5i_1 = number;
  }
  u37() {
    return this.o5i_1;
  }
  toString() {
    return 'DreamerMaskCard(number=' + this.o5i_1 + ')';
  }
  hashCode() {
    return this.o5i_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DreamerMaskCard))
      return false;
    if (!(this.o5i_1 === other.o5i_1))
      return false;
    return true;
  }
  static p5i(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_329().m5i_1);
    }
    var $this = createThis(this);
    $this.o5i_1 = number;
    return $this;
  }
}
class EsmeriasStrandCard {
  constructor() {
    EsmeriasStrandCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q5i_1 = lazy(tmp_0, EsmeriasStrandCard$_anonymous__e06ouq);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_316(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EsmeriasStrandCard';
  }
  hashCode() {
    return 854209418;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EsmeriasStrandCard))
      return false;
    return true;
  }
}
class Companion_386 {}
class $serializer_333 {
  constructor() {
    $serializer_instance_330 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FlareCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.r5i_1 = tmp0_serialDesc;
  }
  s5i(encoder, value) {
    var tmp0_desc = this.r5i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.t5i_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s5i(encoder, value instanceof FlareCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r5i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return FlareCard.u5i(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r5i_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class FlareCard {
  constructor(number) {
    this.t5i_1 = number;
  }
  u37() {
    return this.t5i_1;
  }
  toString() {
    return 'FlareCard(number=' + this.t5i_1 + ')';
  }
  hashCode() {
    return this.t5i_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FlareCard))
      return false;
    if (!(this.t5i_1 === other.t5i_1))
      return false;
    return true;
  }
  static u5i(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_330().r5i_1);
    }
    var $this = createThis(this);
    $this.t5i_1 = number;
    return $this;
  }
}
class Companion_387 {}
class $serializer_334 {
  constructor() {
    $serializer_instance_331 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SmokeBombCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.v5i_1 = tmp0_serialDesc;
  }
  w5i(encoder, value) {
    var tmp0_desc = this.v5i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.x5i_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w5i(encoder, value instanceof SmokeBombCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v5i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SmokeBombCard.y5i(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.v5i_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class SmokeBombCard {
  constructor(number) {
    this.x5i_1 = number;
  }
  u37() {
    return this.x5i_1;
  }
  toString() {
    return 'SmokeBombCard(number=' + this.x5i_1 + ')';
  }
  hashCode() {
    return this.x5i_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SmokeBombCard))
      return false;
    if (!(this.x5i_1 === other.x5i_1))
      return false;
    return true;
  }
  static y5i(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_331().v5i_1);
    }
    var $this = createThis(this);
    $this.x5i_1 = number;
    return $this;
  }
}
class Companion_388 {
  a2g() {
    var tmp = getKClass(HunterItemCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(DreamerMaskCard), getKClass(EsmeriasStrandCard), getKClass(FlareCard), getKClass(AurorasPassage), getKClass(BansheesLureCard), getKClass(BladeOfValhCard), getKClass(ChainGrapnelCard), getKClass(ExpeditionMapCard), getKClass(GrapeshotCard), getKClass(HuntersBellCard), getKClass(HuntersPassageCard), getKClass(HuntersRestCard), getKClass(OutpostCard), getKClass(RecoveryTestHunterCard), getKClass(SacredRichesCard), getKClass(SpyglassCard), getKClass(FireTrapCard), getKClass(HexingTrapCard), getKClass(RitualTrapCard), getKClass(ShriekerTrapCard), getKClass(WarhogsTuskCard), getKClass(WolfsbaneCard), getKClass(RecoveryTestHunterReaction), getKClass(SmokeBombCard), getKClass(UnknownHunterItemCard)];
    var tmp_1 = $serializer_getInstance_329();
    var tmp_2 = EsmeriasStrandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_3 = ObjectSerializer.l1c('EsmeriasStrandCard', tmp_2, tmp$ret$3);
    var tmp_4 = $serializer_getInstance_330();
    var tmp_5 = AurorasPassage_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_6 = ObjectSerializer.l1c('AurorasPassage', tmp_5, tmp$ret$6);
    var tmp_7 = BansheesLureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_8 = ObjectSerializer.l1c('BansheesLureCard', tmp_7, tmp$ret$9);
    var tmp_9 = BladeOfValhCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_10 = ObjectSerializer.l1c('BladeOfValhCard', tmp_9, tmp$ret$12);
    var tmp_11 = ChainGrapnelCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_12 = ObjectSerializer.l1c('ChainGrapnelCard', tmp_11, tmp$ret$15);
    var tmp_13 = $serializer_getInstance_339();
    var tmp_14 = GrapeshotCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_15 = ObjectSerializer.l1c('GrapeshotCard', tmp_14, tmp$ret$18);
    var tmp_16 = $serializer_getInstance_337();
    var tmp_17 = $serializer_getInstance_338();
    var tmp_18 = $serializer_getInstance_336();
    var tmp_19 = $serializer_getInstance_334();
    var tmp_20 = $serializer_getInstance_379();
    var tmp_21 = $serializer_getInstance_341();
    var tmp_22 = SpyglassCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_23 = ObjectSerializer.l1c('SpyglassCard', tmp_22, tmp$ret$21);
    var tmp_24 = $serializer_getInstance_333();
    var tmp_25 = $serializer_getInstance_332();
    var tmp_26 = $serializer_getInstance_340();
    var tmp_27 = $serializer_getInstance_328();
    var tmp_28 = WarhogsTuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_29 = ObjectSerializer.l1c('WarhogsTuskCard', tmp_28, tmp$ret$24);
    var tmp_30 = $serializer_getInstance_335();
    var tmp_31 = RecoveryTestHunterReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_32 = [tmp_1, tmp_3, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_13, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_29, tmp_30, ObjectSerializer.l1c('RecoveryTestHunterReaction', tmp_31, tmp$ret$27), $serializer_getInstance_331(), $serializer_getInstance_343()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    return SealedClassSerializer.i10('steelart.beast.HunterItemCard', tmp, tmp_0, tmp_32, tmp$ret$33);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_389 {}
class $serializer_335 {
  constructor() {
    $serializer_instance_332 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HexingTrapCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.z5i_1 = tmp0_serialDesc;
  }
  a5j(encoder, value) {
    var tmp0_desc = this.z5i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.b5j_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a5j(encoder, value instanceof HexingTrapCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z5i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return HexingTrapCard.c5j(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.z5i_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class HexingTrapCard {
  constructor(number) {
    this.b5j_1 = number;
  }
  u37() {
    return this.b5j_1;
  }
  toString() {
    return 'HexingTrapCard(number=' + this.b5j_1 + ')';
  }
  hashCode() {
    return this.b5j_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HexingTrapCard))
      return false;
    if (!(this.b5j_1 === other.b5j_1))
      return false;
    return true;
  }
  static c5j(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_332().z5i_1);
    }
    var $this = createThis(this);
    $this.b5j_1 = number;
    return $this;
  }
}
class Companion_390 {}
class $serializer_336 {
  constructor() {
    $serializer_instance_333 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FireTrapCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.d5j_1 = tmp0_serialDesc;
  }
  e5j(encoder, value) {
    var tmp0_desc = this.d5j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.f5j_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e5j(encoder, value instanceof FireTrapCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d5j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return FireTrapCard.g5j(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d5j_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class FireTrapCard {
  constructor(number) {
    this.f5j_1 = number;
  }
  u37() {
    return this.f5j_1;
  }
  toString() {
    return 'FireTrapCard(number=' + this.f5j_1 + ')';
  }
  hashCode() {
    return this.f5j_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FireTrapCard))
      return false;
    if (!(this.f5j_1 === other.f5j_1))
      return false;
    return true;
  }
  static g5j(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_333().d5j_1);
    }
    var $this = createThis(this);
    $this.f5j_1 = number;
    return $this;
  }
}
class Companion_391 {
  constructor() {
    Companion_instance_391 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h5j_1 = [null, lazy(tmp_0, OutpostCard$Companion$$childSerializers$_anonymous__vydq5w)];
  }
}
class $serializer_337 {
  constructor() {
    $serializer_instance_334 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OutpostCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.i5j_1 = tmp0_serialDesc;
  }
  j5j(encoder, value) {
    var tmp0_desc = this.i5j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_392().h5j_1;
    tmp1_output.z14(tmp0_desc, 0, value.k5j_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.l5j_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.l5j_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j5j(encoder, value instanceof OutpostCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i5j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_392().h5j_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return OutpostCard.m5j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.i5j_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_392().h5j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class OutpostCard {
  constructor(number) {
    Companion_getInstance_392();
    this.k5j_1 = number;
    this.l5j_1 = Red_getInstance();
  }
  u37() {
    return this.k5j_1;
  }
  toString() {
    return 'OutpostCard(number=' + this.k5j_1 + ')';
  }
  hashCode() {
    return this.k5j_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OutpostCard))
      return false;
    if (!(this.k5j_1 === other.k5j_1))
      return false;
    return true;
  }
  static m5j(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_392();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_334().i5j_1);
    }
    var $this = createThis(this);
    $this.k5j_1 = number;
    if (0 === (seen0 & 2))
      $this.l5j_1 = Red_getInstance();
    else
      $this.l5j_1 = playColor;
    return $this;
  }
}
class Companion_392 {
  constructor() {
    Companion_instance_392 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n5j_1 = [null, lazy(tmp_0, WolfsbaneCard$Companion$$childSerializers$_anonymous__vyq2eb)];
  }
}
class $serializer_338 {
  constructor() {
    $serializer_instance_335 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('WolfsbaneCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.o5j_1 = tmp0_serialDesc;
  }
  p5j(encoder, value) {
    var tmp0_desc = this.o5j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_393().n5j_1;
    tmp1_output.z14(tmp0_desc, 0, value.q5j_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.r5j_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.r5j_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p5j(encoder, value instanceof WolfsbaneCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o5j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_393().n5j_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return WolfsbaneCard.s5j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.o5j_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_393().n5j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class WolfsbaneCard {
  constructor(number) {
    Companion_getInstance_393();
    this.q5j_1 = number;
    this.r5j_1 = Blue_getInstance();
  }
  u37() {
    return this.q5j_1;
  }
  toString() {
    return 'WolfsbaneCard(number=' + this.q5j_1 + ')';
  }
  hashCode() {
    return this.q5j_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WolfsbaneCard))
      return false;
    if (!(this.q5j_1 === other.q5j_1))
      return false;
    return true;
  }
  static s5j(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_393();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_335().o5j_1);
    }
    var $this = createThis(this);
    $this.q5j_1 = number;
    if (0 === (seen0 & 2))
      $this.r5j_1 = Blue_getInstance();
    else
      $this.r5j_1 = playColor;
    return $this;
  }
}
class Companion_393 {
  constructor() {
    Companion_instance_393 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t5j_1 = [null, lazy(tmp_0, HuntersRestCard$Companion$$childSerializers$_anonymous__5h3u7h)];
  }
}
class $serializer_339 {
  constructor() {
    $serializer_instance_336 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HuntersRestCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.u5j_1 = tmp0_serialDesc;
  }
  v5j(encoder, value) {
    var tmp0_desc = this.u5j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_394().t5j_1;
    tmp1_output.z14(tmp0_desc, 0, value.w5j_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.x5j_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.x5j_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v5j(encoder, value instanceof HuntersRestCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u5j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_394().t5j_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return HuntersRestCard.y5j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.u5j_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_394().t5j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class HuntersRestCard {
  constructor(number) {
    Companion_getInstance_394();
    this.w5j_1 = number;
    this.x5j_1 = Blue_getInstance();
  }
  u37() {
    return this.w5j_1;
  }
  toString() {
    return 'HuntersRestCard(number=' + this.w5j_1 + ')';
  }
  hashCode() {
    return this.w5j_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HuntersRestCard))
      return false;
    if (!(this.w5j_1 === other.w5j_1))
      return false;
    return true;
  }
  static y5j(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_394();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_336().u5j_1);
    }
    var $this = createThis(this);
    $this.w5j_1 = number;
    if (0 === (seen0 & 2))
      $this.x5j_1 = Blue_getInstance();
    else
      $this.x5j_1 = playColor;
    return $this;
  }
}
class Companion_394 {
  constructor() {
    Companion_instance_394 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z5j_1 = [null, lazy(tmp_0, HuntersBellCard$Companion$$childSerializers$_anonymous__v4z7hg)];
  }
}
class $serializer_340 {
  constructor() {
    $serializer_instance_337 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HuntersBellCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.a5k_1 = tmp0_serialDesc;
  }
  b5k(encoder, value) {
    var tmp0_desc = this.a5k_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_395().z5j_1;
    tmp1_output.z14(tmp0_desc, 0, value.c5k_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.d5k_1.equals(Red_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.d5k_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b5k(encoder, value instanceof HuntersBellCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a5k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_395().z5j_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return HuntersBellCard.e5k(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.a5k_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_395().z5j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class HuntersBellCard {
  constructor(number) {
    Companion_getInstance_395();
    this.c5k_1 = number;
    this.d5k_1 = Red_getInstance();
  }
  u37() {
    return this.c5k_1;
  }
  toString() {
    return 'HuntersBellCard(number=' + this.c5k_1 + ')';
  }
  hashCode() {
    return this.c5k_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HuntersBellCard))
      return false;
    if (!(this.c5k_1 === other.c5k_1))
      return false;
    return true;
  }
  static e5k(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_395();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_337().a5k_1);
    }
    var $this = createThis(this);
    $this.c5k_1 = number;
    if (0 === (seen0 & 2))
      $this.d5k_1 = Red_getInstance();
    else
      $this.d5k_1 = playColor;
    return $this;
  }
}
class Companion_395 {
  constructor() {
    Companion_instance_395 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f5k_1 = [null, lazy(tmp_0, HuntersPassageCard$Companion$$childSerializers$_anonymous__cp76n5)];
  }
}
class $serializer_341 {
  constructor() {
    $serializer_instance_338 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HuntersPassageCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.g5k_1 = tmp0_serialDesc;
  }
  h5k(encoder, value) {
    var tmp0_desc = this.g5k_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_396().f5k_1;
    tmp1_output.z14(tmp0_desc, 0, value.i5k_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.j5k_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.j5k_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h5k(encoder, value instanceof HuntersPassageCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g5k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_396().f5k_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return HuntersPassageCard.k5k(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.g5k_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_396().f5k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class HuntersPassageCard {
  constructor(number) {
    Companion_getInstance_396();
    this.i5k_1 = number;
    this.j5k_1 = Blue_getInstance();
  }
  u37() {
    return this.i5k_1;
  }
  toString() {
    return 'HuntersPassageCard(number=' + this.i5k_1 + ')';
  }
  hashCode() {
    return this.i5k_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HuntersPassageCard))
      return false;
    if (!(this.i5k_1 === other.i5k_1))
      return false;
    return true;
  }
  static k5k(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_396();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_338().g5k_1);
    }
    var $this = createThis(this);
    $this.i5k_1 = number;
    if (0 === (seen0 & 2))
      $this.j5k_1 = Blue_getInstance();
    else
      $this.j5k_1 = playColor;
    return $this;
  }
}
class GrapeshotCard {
  constructor() {
    GrapeshotCard_instance = this;
    this.l5k_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m5k_1 = lazy(tmp_0, GrapeshotCard$_anonymous__7pou8y);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_317(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'GrapeshotCard';
  }
  hashCode() {
    return 1973110992;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GrapeshotCard))
      return false;
    return true;
  }
}
class AurorasPassage {
  constructor() {
    AurorasPassage_instance = this;
    this.n5k_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o5k_1 = lazy(tmp_0, AurorasPassage$_anonymous__e6uq90);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_318(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AurorasPassage';
  }
  hashCode() {
    return -1744672576;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AurorasPassage))
      return false;
    return true;
  }
}
class BladeOfValhCard {
  constructor() {
    BladeOfValhCard_instance = this;
    this.p5k_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q5k_1 = lazy(tmp_0, BladeOfValhCard$_anonymous__up63z);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_319(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BladeOfValhCard';
  }
  hashCode() {
    return -999279391;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BladeOfValhCard))
      return false;
    return true;
  }
}
class Companion_396 {
  constructor() {
    Companion_instance_396 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r5k_1 = [null, lazy(tmp_0, ExpeditionMapCard$Companion$$childSerializers$_anonymous__uqm6e9)];
  }
}
class $serializer_342 {
  constructor() {
    $serializer_instance_339 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ExpeditionMapCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.s5k_1 = tmp0_serialDesc;
  }
  t5k(encoder, value) {
    var tmp0_desc = this.s5k_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_397().r5k_1;
    tmp1_output.z14(tmp0_desc, 0, value.u5k_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.v5k_1.equals(Blue_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.v5k_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t5k(encoder, value instanceof ExpeditionMapCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s5k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_397().r5k_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ExpeditionMapCard.w5k(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.s5k_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_397().r5k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class ExpeditionMapCard {
  constructor(number) {
    Companion_getInstance_397();
    this.u5k_1 = number;
    this.v5k_1 = Blue_getInstance();
  }
  u37() {
    return this.u5k_1;
  }
  toString() {
    return 'ExpeditionMapCard(number=' + this.u5k_1 + ')';
  }
  hashCode() {
    return this.u5k_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExpeditionMapCard))
      return false;
    if (!(this.u5k_1 === other.u5k_1))
      return false;
    return true;
  }
  static w5k(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_397();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_339().s5k_1);
    }
    var $this = createThis(this);
    $this.u5k_1 = number;
    if (0 === (seen0 & 2))
      $this.v5k_1 = Blue_getInstance();
    else
      $this.v5k_1 = playColor;
    return $this;
  }
}
class Companion_397 {}
class $serializer_343 {
  constructor() {
    $serializer_instance_340 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RitualTrapCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.x5k_1 = tmp0_serialDesc;
  }
  y5k(encoder, value) {
    var tmp0_desc = this.x5k_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.z5k_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y5k(encoder, value instanceof RitualTrapCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x5k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RitualTrapCard.a5l(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x5k_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class RitualTrapCard {
  constructor(number) {
    this.z5k_1 = number;
  }
  u37() {
    return this.z5k_1;
  }
  toString() {
    return 'RitualTrapCard(number=' + this.z5k_1 + ')';
  }
  hashCode() {
    return this.z5k_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RitualTrapCard))
      return false;
    if (!(this.z5k_1 === other.z5k_1))
      return false;
    return true;
  }
  static a5l(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_340().x5k_1);
    }
    var $this = createThis(this);
    $this.z5k_1 = number;
    return $this;
  }
}
class Companion_398 {
  constructor() {
    Companion_instance_398 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b5l_1 = [null, lazy(tmp_0, SacredRichesCard$Companion$$childSerializers$_anonymous__ek42fg)];
  }
}
class $serializer_344 {
  constructor() {
    $serializer_instance_341 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SacredRichesCard', this, 2);
    tmp0_serialDesc.h1b('number', false);
    tmp0_serialDesc.h1b('playColor', true);
    this.c5l_1 = tmp0_serialDesc;
  }
  d5l(encoder, value) {
    var tmp0_desc = this.c5l_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_399().b5l_1;
    tmp1_output.z14(tmp0_desc, 0, value.e5l_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.f5l_1.equals(Split_getInstance())) {
      tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.f5l_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d5l(encoder, value instanceof SacredRichesCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_399().b5l_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SacredRichesCard.g5l(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.c5l_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_399().b5l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), tmp0_cached[1].k3()];
  }
}
class SacredRichesCard {
  constructor(number) {
    Companion_getInstance_399();
    this.e5l_1 = number;
    this.f5l_1 = Split_getInstance();
  }
  u37() {
    return this.e5l_1;
  }
  toString() {
    return 'SacredRichesCard(number=' + this.e5l_1 + ')';
  }
  hashCode() {
    return this.e5l_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SacredRichesCard))
      return false;
    if (!(this.e5l_1 === other.e5l_1))
      return false;
    return true;
  }
  static g5l(seen0, number, playColor, serializationConstructorMarker) {
    Companion_getInstance_399();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_341().c5l_1);
    }
    var $this = createThis(this);
    $this.e5l_1 = number;
    if (0 === (seen0 & 2))
      $this.f5l_1 = Split_getInstance();
    else
      $this.f5l_1 = playColor;
    return $this;
  }
}
class BansheesLureCard {
  constructor() {
    BansheesLureCard_instance = this;
    this.h5l_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i5l_1 = lazy(tmp_0, BansheesLureCard$_anonymous__bta3ok);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_320(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BansheesLureCard';
  }
  hashCode() {
    return -2100428992;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BansheesLureCard))
      return false;
    return true;
  }
}
class ChainGrapnelCard {
  constructor() {
    ChainGrapnelCard_instance = this;
    this.j5l_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k5l_1 = lazy(tmp_0, ChainGrapnelCard$_anonymous__hyfwrx);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_321(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ChainGrapnelCard';
  }
  hashCode() {
    return -640124433;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChainGrapnelCard))
      return false;
    return true;
  }
}
class SpyglassCard {
  constructor() {
    SpyglassCard_instance = this;
    this.l5l_1 = Split_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m5l_1 = lazy(tmp_0, SpyglassCard$_anonymous__m7lpwn);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_322(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SpyglassCard';
  }
  hashCode() {
    return 2076766645;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpyglassCard))
      return false;
    return true;
  }
}
class WarhogsTuskCard {
  constructor() {
    WarhogsTuskCard_instance = this;
    this.n5l_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o5l_1 = lazy(tmp_0, WarhogsTuskCard$_anonymous__5immi5);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_323(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WarhogsTuskCard';
  }
  hashCode() {
    return 33815071;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WarhogsTuskCard))
      return false;
    return true;
  }
}
class Companion_399 {
  a2g() {
    var tmp = getKClass(TrapCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(FireTrapCard), getKClass(HexingTrapCard), getKClass(RitualTrapCard), getKClass(ShriekerTrapCard)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_333(), $serializer_getInstance_332(), $serializer_getInstance_340(), $serializer_getInstance_328()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.TrapCard', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_400 {
  constructor() {
    Companion_instance_400 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, PlacedTrap$Companion$$childSerializers$_anonymous__ilw7og);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, PlacedTrap$Companion$$childSerializers$_anonymous__ilw7og_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy(tmp_4, PlacedTrap$Companion$$childSerializers$_anonymous__ilw7og_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p5l_1 = [tmp_1, tmp_3, tmp_5, lazy(tmp_6, PlacedTrap$Companion$$childSerializers$_anonymous__ilw7og_2), null];
  }
}
class $serializer_345 {
  constructor() {
    $serializer_instance_342 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.PlacedTrap', this, 5);
    tmp0_serialDesc.h1b('zone', false);
    tmp0_serialDesc.h1b('locationType', false);
    tmp0_serialDesc.h1b('trapCard', false);
    tmp0_serialDesc.h1b('owner', false);
    tmp0_serialDesc.h1b('revisionBeforePlacement', false);
    this.q5l_1 = tmp0_serialDesc;
  }
  r5l(encoder, value) {
    var tmp0_desc = this.q5l_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_401().p5l_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g4o_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.h4o_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.i4o_1);
    tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.j4o_1);
    tmp1_output.z14(tmp0_desc, 4, value.k4o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r5l(encoder, value instanceof PlacedTrap ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_401().p5l_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.u13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, tmp10_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, tmp10_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.u13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return PlacedTrap.s5l(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.q5l_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_401().p5l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), tmp0_cached[3].k3(), IntSerializer_getInstance()];
  }
}
class PlacedTrap {
  constructor(zone, locationType, trapCard, owner, revisionBeforePlacement) {
    Companion_getInstance_401();
    this.g4o_1 = zone;
    this.h4o_1 = locationType;
    this.i4o_1 = trapCard;
    this.j4o_1 = owner;
    this.k4o_1 = revisionBeforePlacement;
  }
  toString() {
    return 'PlacedTrap(zone=' + this.g4o_1.toString() + ', locationType=' + this.h4o_1.toString() + ', trapCard=' + toString(this.i4o_1) + ', owner=' + this.j4o_1.toString() + ', revisionBeforePlacement=' + this.k4o_1 + ')';
  }
  hashCode() {
    var result = this.g4o_1.hashCode();
    result = imul(result, 31) + this.h4o_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.i4o_1) | 0;
    result = imul(result, 31) + this.j4o_1.hashCode() | 0;
    result = imul(result, 31) + this.k4o_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedTrap))
      return false;
    if (!this.g4o_1.equals(other.g4o_1))
      return false;
    if (!this.h4o_1.equals(other.h4o_1))
      return false;
    if (!equals(this.i4o_1, other.i4o_1))
      return false;
    if (!this.j4o_1.equals(other.j4o_1))
      return false;
    if (!(this.k4o_1 === other.k4o_1))
      return false;
    return true;
  }
  static s5l(seen0, zone, locationType, trapCard, owner, revisionBeforePlacement, serializationConstructorMarker) {
    Companion_getInstance_401();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_342().q5l_1);
    }
    var $this = createThis(this);
    $this.g4o_1 = zone;
    $this.h4o_1 = locationType;
    $this.i4o_1 = trapCard;
    $this.j4o_1 = owner;
    $this.k4o_1 = revisionBeforePlacement;
    return $this;
  }
}
class Companion_401 {}
class $serializer_346 {
  constructor() {
    $serializer_instance_343 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UnknownHunterItemCard', this, 1);
    tmp0_serialDesc.h1b('number', false);
    this.t5l_1 = tmp0_serialDesc;
  }
  u5l(encoder, value) {
    var tmp0_desc = this.t5l_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.v5l_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u5l(encoder, value instanceof UnknownHunterItemCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UnknownHunterItemCard.w5l(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.t5l_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class UnknownHunterItemCard {
  constructor(number) {
    this.v5l_1 = number;
  }
  u37() {
    return this.v5l_1;
  }
  toString() {
    return 'UnknownHunterItemCard(number=' + this.v5l_1 + ')';
  }
  hashCode() {
    return this.v5l_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnknownHunterItemCard))
      return false;
    if (!(this.v5l_1 === other.v5l_1))
      return false;
    return true;
  }
  static w5l(seen0, number, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_343().t5l_1);
    }
    var $this = createThis(this);
    $this.v5l_1 = number;
    return $this;
  }
}
class Iona {
  constructor() {
    Iona_instance = this;
    this.x5l_1 = setOf_0([JointEffortUpgrade_getInstance(), BallistaUpgrade_getInstance(), CrepuscularUpgrade_getInstance(), AncientCallingUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y5l_1 = lazy(tmp_0, Iona$_anonymous__v5d2pq);
  }
  s36() {
    return plus_0(get_abilityCards.call(this), SilverArrowCard_getInstance());
  }
  t35() {
    return this.x5l_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_324(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Iona';
  }
  hashCode() {
    return 607691166;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Iona))
      return false;
    return true;
  }
}
class JointEffortUpgrade {
  constructor() {
    JointEffortUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z5l_1 = lazy(tmp_0, JointEffortUpgrade$_anonymous__ihru4v);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_325(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'JointEffortUpgrade';
  }
  hashCode() {
    return 567648939;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JointEffortUpgrade))
      return false;
    return true;
  }
}
class BallistaUpgrade {
  constructor() {
    BallistaUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a5m_1 = lazy(tmp_0, BallistaUpgrade$_anonymous__mclor3);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_326(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BallistaUpgrade';
  }
  hashCode() {
    return 1501073473;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BallistaUpgrade))
      return false;
    return true;
  }
}
class CrepuscularUpgrade {
  constructor() {
    CrepuscularUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b5m_1 = lazy(tmp_0, CrepuscularUpgrade$_anonymous__obmjma);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_327(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CrepuscularUpgrade';
  }
  hashCode() {
    return -1143612242;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CrepuscularUpgrade))
      return false;
    return true;
  }
}
class AncientCallingUpgrade {
  constructor() {
    AncientCallingUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c5m_1 = lazy(tmp_0, AncientCallingUpgrade$_anonymous__26yglj);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_328(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AncientCallingUpgrade';
  }
  hashCode() {
    return -240632853;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AncientCallingUpgrade))
      return false;
    return true;
  }
}
class SilverArrowCard {
  constructor() {
    SilverArrowCard_instance = this;
    this.d5m_1 = Red_getInstance();
    this.e5m_1 = Iona_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f5m_1 = lazy(tmp_0, SilverArrowCard$_anonymous__ezwgrv);
  }
  t37() {
    return this.e5m_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_329(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SilverArrowCard';
  }
  hashCode() {
    return -1098187577;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SilverArrowCard))
      return false;
    return true;
  }
}
class NearSummonsAndBeastAttackModifier {
  constructor() {
    NearSummonsAndBeastAttackModifier_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g5m_1 = lazy(tmp_0, NearSummonsAndBeastAttackModifier$_anonymous__7yu7q2);
  }
  w35($context_GameState_t6qee5, target) {
    var tmp;
    var tmp_0 = get_objectType($context_GameState_t6qee5, target);
    if (isInterface(tmp_0, SummonType)) {
      tmp = true;
    } else {
      var tmp_1 = get_objectType($context_GameState_t6qee5, target);
      tmp = isInterface(tmp_1, BeastCharacter);
    }
    return tmp;
  }
  x35($context_GameState_t6qee5, target) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_330(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NearSummonsAndBeastAttackModifier';
  }
  hashCode() {
    return 2085960716;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NearSummonsAndBeastAttackModifier))
      return false;
    return true;
  }
}
class Krim {
  constructor() {
    Krim_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h5m_1 = lazy(tmp_0, Krim$_anonymous__ac5qb8);
  }
  s36() {
    return plus_0(get_abilityCards.call(this), TrapmasterCard_getInstance());
  }
  t35() {
    return setOf_0([ScavengerUpgrade_getInstance(), TrapLauncherUpgrade_getInstance(), PortableWorkshopUpgrade_getInstance(), ResourcefulnessUpgrade_getInstance()]);
  }
  n2z($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_331(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Krim';
  }
  hashCode() {
    return 607753488;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Krim))
      return false;
    return true;
  }
}
class ScavengerUpgrade {
  constructor() {
    ScavengerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i5m_1 = lazy(tmp_0, ScavengerUpgrade$_anonymous__bcj2o1);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_332(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ScavengerUpgrade';
  }
  hashCode() {
    return 1102162267;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScavengerUpgrade))
      return false;
    return true;
  }
}
class TrapLauncherUpgrade {
  constructor() {
    TrapLauncherUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j5m_1 = lazy(tmp_0, TrapLauncherUpgrade$_anonymous__x3nh08);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_333(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TrapLauncherUpgrade';
  }
  hashCode() {
    return -1750218614;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrapLauncherUpgrade))
      return false;
    return true;
  }
}
class PortableWorkshopUpgrade {
  constructor() {
    PortableWorkshopUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k5m_1 = lazy(tmp_0, PortableWorkshopUpgrade$_anonymous__m8y999);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_334(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PortableWorkshopUpgrade';
  }
  hashCode() {
    return -1251767467;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PortableWorkshopUpgrade))
      return false;
    return true;
  }
}
class ResourcefulnessUpgrade {
  constructor() {
    ResourcefulnessUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l5m_1 = lazy(tmp_0, ResourcefulnessUpgrade$_anonymous__xd16n3);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_335(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ResourcefulnessUpgrade';
  }
  hashCode() {
    return 1159782075;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResourcefulnessUpgrade))
      return false;
    return true;
  }
}
class TrapToPlayForTrapmasterQuestionContext {
  constructor() {
    TrapToPlayForTrapmasterQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m5m_1 = lazy(tmp_0, TrapToPlayForTrapmasterQuestionContext$_anonymous__azu392);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_336(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TrapToPlayForTrapmasterQuestionContext';
  }
  hashCode() {
    return -1905570478;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrapToPlayForTrapmasterQuestionContext))
      return false;
    return true;
  }
}
class ResourcefulnessUpgradeStatement {
  constructor() {
    ResourcefulnessUpgradeStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n5m_1 = lazy(tmp_0, ResourcefulnessUpgradeStatement$_anonymous__8pb0zm);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_337(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ResourcefulnessUpgradeStatement';
  }
  hashCode() {
    return -1681404684;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResourcefulnessUpgradeStatement))
      return false;
    return true;
  }
}
class Companion_402 {
  constructor() {
    Companion_instance_402 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o5m_1 = [lazy(tmp_0, TrapmasterStatement$Companion$$childSerializers$_anonymous__u7s4ju), null];
  }
}
class $serializer_347 {
  constructor() {
    $serializer_instance_344 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TrapmasterStatement', this, 2);
    tmp0_serialDesc.h1b('hunter', false);
    tmp0_serialDesc.h1b('isRestrictedToZone', false);
    this.p5m_1 = tmp0_serialDesc;
  }
  q5m(encoder, value) {
    var tmp0_desc = this.p5m_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_403().o5m_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r5m_1);
    tmp1_output.w14(tmp0_desc, 1, value.s5m_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q5m(encoder, value instanceof TrapmasterStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p5m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_403().o5m_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return TrapmasterStatement.t5m(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.p5m_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_403().o5m_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class TrapmasterStatement {
  constructor(hunter, isRestrictedToZone) {
    Companion_getInstance_403();
    this.r5m_1 = hunter;
    this.s5m_1 = isRestrictedToZone;
  }
  toString() {
    return 'TrapmasterStatement(hunter=' + this.r5m_1.toString() + ', isRestrictedToZone=' + this.s5m_1 + ')';
  }
  hashCode() {
    var result = this.r5m_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.s5m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrapmasterStatement))
      return false;
    if (!this.r5m_1.equals(other.r5m_1))
      return false;
    if (!(this.s5m_1 === other.s5m_1))
      return false;
    return true;
  }
  static t5m(seen0, hunter, isRestrictedToZone, serializationConstructorMarker) {
    Companion_getInstance_403();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_344().p5m_1);
    }
    var $this = createThis(this);
    $this.r5m_1 = hunter;
    $this.s5m_1 = isRestrictedToZone;
    return $this;
  }
}
class TrapmasterCard {
  constructor() {
    TrapmasterCard_instance = this;
    this.u5m_1 = Red_getInstance();
    this.v5m_1 = Krim_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w5m_1 = lazy(tmp_0, TrapmasterCard$_anonymous__91cd7c);
  }
  t37() {
    return this.v5m_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_338(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TrapmasterCard';
  }
  hashCode() {
    return 1403559300;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrapmasterCard))
      return false;
    return true;
  }
}
class LowerShatteredSettlements {
  constructor() {
    LowerShatteredSettlements_instance = this;
    this.o3b_1 = _BoardPosition___init__impl__1nizgq_0(-4, -3);
    this.p3b_1 = _BoardPosition___init__impl__1nizgq_0(2, -4);
    this.q3b_1 = _BoardPosition___init__impl__1nizgq_0(-3, 1);
    this.r3b_1 = _BoardPosition___init__impl__1nizgq_0(3, 1);
    this.s3b_1 = _BoardPosition___init__impl__1nizgq_0(0, 4);
  }
}
class LowerShatteredRuins {
  constructor() {
    LowerShatteredRuins_instance = this;
    this.x5m_1 = _BoardPosition___init__impl__1nizgq_0(-2, 1);
    this.y5m_1 = _BoardPosition___init__impl__1nizgq_0(0, -3);
    this.z5m_1 = _BoardPosition___init__impl__1nizgq_0(1, 2);
  }
}
class BeyondTheVeilUpgrade {
  constructor() {
    BeyondTheVeilUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a5n_1 = lazy(tmp_0, BeyondTheVeilUpgrade$_anonymous__z0sr69);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_339(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeyondTheVeilUpgrade';
  }
  hashCode() {
    return 1055984301;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeyondTheVeilUpgrade))
      return false;
    return true;
  }
}
class AbundanceUpgrade {
  constructor() {
    AbundanceUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b5n_1 = lazy(tmp_0, AbundanceUpgrade$_anonymous__gukhys);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_340(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AbundanceUpgrade';
  }
  hashCode() {
    return -460625112;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbundanceUpgrade))
      return false;
    return true;
  }
}
class ReuniteUpgrade {
  constructor() {
    ReuniteUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c5n_1 = lazy(tmp_0, ReuniteUpgrade$_anonymous__ynud07);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_341(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ReuniteUpgrade';
  }
  hashCode() {
    return 257538867;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReuniteUpgrade))
      return false;
    return true;
  }
}
class DoomCallUpgrade {
  constructor() {
    DoomCallUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d5n_1 = lazy(tmp_0, DoomCallUpgrade$_anonymous__yf3r32);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_342(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DoomCallUpgrade';
  }
  hashCode() {
    return -940040944;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DoomCallUpgrade))
      return false;
    return true;
  }
}
class FleshboundUpgrade {
  constructor() {
    FleshboundUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e5n_1 = lazy(tmp_0, FleshboundUpgrade$_anonymous__xh47mj);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  u35($context_GameState_t6qee5) {
    return !get_upgraded($context_GameState_t6qee5, SpiritboundUpgrade_getInstance());
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_343(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FleshboundUpgrade';
  }
  hashCode() {
    return 644497293;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FleshboundUpgrade))
      return false;
    return true;
  }
}
class SpiritboundUpgrade {
  constructor() {
    SpiritboundUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f5n_1 = lazy(tmp_0, SpiritboundUpgrade$_anonymous__mp9yqw);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  u35($context_GameState_t6qee5) {
    return !get_upgraded($context_GameState_t6qee5, FleshboundUpgrade_getInstance());
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_344(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SpiritboundUpgrade';
  }
  hashCode() {
    return -529763148;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpiritboundUpgrade))
      return false;
    return true;
  }
}
class Lydan {
  constructor() {
    Lydan_instance = this;
    this.g5n_1 = YeltrType_getInstance();
    this.h5n_1 = setOf_0([BeyondTheVeilUpgrade_getInstance(), AbundanceUpgrade_getInstance(), ReuniteUpgrade_getInstance(), DoomCallUpgrade_getInstance(), FleshboundUpgrade_getInstance(), SpiritboundUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i5n_1 = lazy(tmp_0, Lydan$_anonymous__tk065v);
  }
  q36() {
    return this.g5n_1;
  }
  u36() {
    return 1;
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Forest_getInstance();
  }
  s36() {
    return setOf_0([SummonYeltrCard_getInstance(), SoulReapCard_getInstance(), ToothAndSeverCard_getInstance(), BoltAndRecallCard_getInstance()]);
  }
  t35() {
    return this.h5n_1;
  }
  n2z($context_GameState_t6qee5) {
    return 3;
  }
  v36($context_GameState_t6qee5, position) {
    return plus_2(getInitList_1.call(this, $context_GameState_t6qee5, position), listOf(init_0(get_lydanHarvestKey(), 0)));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_345(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Lydan';
  }
  hashCode() {
    return 1661615935;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Lydan))
      return false;
    return true;
  }
}
class YeltrDeathDamageSource {
  constructor() {
    YeltrDeathDamageSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j5n_1 = lazy(tmp_0, YeltrDeathDamageSource$_anonymous__5n0srb);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_346(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'YeltrDeathDamageSource';
  }
  hashCode() {
    return 529299525;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YeltrDeathDamageSource))
      return false;
    return true;
  }
}
class YeltrReapDamageSource {
  constructor() {
    YeltrReapDamageSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k5n_1 = lazy(tmp_0, YeltrReapDamageSource$_anonymous__bfwvhp);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_347(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'YeltrReapDamageSource';
  }
  hashCode() {
    return 276612869;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YeltrReapDamageSource))
      return false;
    return true;
  }
}
class LydanInitialHarvestEffectSource {
  constructor() {
    LydanInitialHarvestEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l5n_1 = lazy(tmp_0, LydanInitialHarvestEffectSource$_anonymous__pvwtcu);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_348(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LydanInitialHarvestEffectSource';
  }
  hashCode() {
    return 2060280784;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LydanInitialHarvestEffectSource))
      return false;
    return true;
  }
}
class Companion_403 {}
class $serializer_348 {
  constructor() {
    $serializer_instance_345 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SpendLydanHarvestQuestion', this, 1);
    tmp0_serialDesc.h1b('harvestToBeSpend', false);
    this.m5n_1 = tmp0_serialDesc;
  }
  n5n(encoder, value) {
    var tmp0_desc = this.m5n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.o5n_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n5n(encoder, value instanceof SpendLydanHarvestQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SpendLydanHarvestQuestion.p5n(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m5n_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class SpendLydanHarvestQuestion {
  constructor(harvestToBeSpend) {
    this.o5n_1 = harvestToBeSpend;
  }
  toString() {
    return 'SpendLydanHarvestQuestion(harvestToBeSpend=' + this.o5n_1 + ')';
  }
  hashCode() {
    return this.o5n_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpendLydanHarvestQuestion))
      return false;
    if (!(this.o5n_1 === other.o5n_1))
      return false;
    return true;
  }
  static p5n(seen0, harvestToBeSpend, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_345().m5n_1);
    }
    var $this = createThis(this);
    $this.o5n_1 = harvestToBeSpend;
    return $this;
  }
}
class Companion_404 {
  constructor() {
    Companion_instance_404 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q5n_1 = [lazy(tmp_0, BeyondTheVeilPreventYeltrDamageStatement$Companion$$childSerializers$_anonymous__bxv61w), null];
  }
}
class $serializer_349 {
  constructor() {
    $serializer_instance_346 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeyondTheVeilPreventYeltrDamageStatement', this, 2);
    tmp0_serialDesc.h1b('yeltr', false);
    tmp0_serialDesc.h1b('damage', false);
    this.r5n_1 = tmp0_serialDesc;
  }
  s5n(encoder, value) {
    var tmp0_desc = this.r5n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_405().q5n_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t5n_1);
    tmp1_output.z14(tmp0_desc, 1, value.u5n_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s5n(encoder, value instanceof BeyondTheVeilPreventYeltrDamageStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_405().q5n_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BeyondTheVeilPreventYeltrDamageStatement.v5n(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r5n_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_405().q5n_1[0].k3(), IntSerializer_getInstance()];
  }
}
class BeyondTheVeilPreventYeltrDamageStatement {
  constructor(yeltr, damage) {
    Companion_getInstance_405();
    this.t5n_1 = yeltr;
    this.u5n_1 = damage;
  }
  n2o($context_GameStateRuntime_604ce3) {
    return get_isAlive($context_GameStateRuntime_604ce3, this.t5n_1) && get_lydanHarvest($context_GameStateRuntime_604ce3, get_lydanBeast($context_GameStateRuntime_604ce3)) >= 2 && this.u5n_1 > 0;
  }
  toString() {
    return 'BeyondTheVeilPreventYeltrDamageStatement(yeltr=' + this.t5n_1.toString() + ', damage=' + this.u5n_1 + ')';
  }
  hashCode() {
    var result = this.t5n_1.hashCode();
    result = imul(result, 31) + this.u5n_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeyondTheVeilPreventYeltrDamageStatement))
      return false;
    if (!this.t5n_1.equals(other.t5n_1))
      return false;
    if (!(this.u5n_1 === other.u5n_1))
      return false;
    return true;
  }
  static v5n(seen0, yeltr, damage, serializationConstructorMarker) {
    Companion_getInstance_405();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_346().r5n_1);
    }
    var $this = createThis(this);
    $this.t5n_1 = yeltr;
    $this.u5n_1 = damage;
    return $this;
  }
}
class Companion_405 {
  constructor() {
    Companion_instance_405 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w5n_1 = [lazy(tmp_0, BoltAndRecallStatement$Companion$$childSerializers$_anonymous__agwiqa)];
  }
}
class $serializer_350 {
  constructor() {
    $serializer_instance_347 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BoltAndRecallStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.x5n_1 = tmp0_serialDesc;
  }
  y5n(encoder, value) {
    var tmp0_desc = this.x5n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_406().w5n_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.z5n_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y5n(encoder, value instanceof BoltAndRecallStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_406().w5n_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BoltAndRecallStatement.a5o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x5n_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_406().w5n_1[0].k3()];
  }
}
class BoltAndRecallStatement {
  constructor(beast) {
    Companion_getInstance_406();
    this.z5n_1 = beast;
  }
  toString() {
    return 'BoltAndRecallStatement(beast=' + this.z5n_1.toString() + ')';
  }
  hashCode() {
    return this.z5n_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BoltAndRecallStatement))
      return false;
    if (!this.z5n_1.equals(other.z5n_1))
      return false;
    return true;
  }
  static a5o(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_406();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_347().x5n_1);
    }
    var $this = createThis(this);
    $this.z5n_1 = beast;
    return $this;
  }
}
class Companion_406 {
  constructor() {
    Companion_instance_406 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b5o_1 = [lazy(tmp_0, ReapStatement$Companion$$childSerializers$_anonymous__h6kh37)];
  }
}
class $serializer_351 {
  constructor() {
    $serializer_instance_348 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ReapStatement', this, 1);
    tmp0_serialDesc.h1b('yeltr', false);
    this.c5o_1 = tmp0_serialDesc;
  }
  d5o(encoder, value) {
    var tmp0_desc = this.c5o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_407().b5o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.e5o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d5o(encoder, value instanceof ReapStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c5o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_407().b5o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ReapStatement.f5o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.c5o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_407().b5o_1[0].k3()];
  }
}
class ReapStatement {
  constructor(yeltr) {
    Companion_getInstance_407();
    this.e5o_1 = yeltr;
  }
  n2o($context_GameStateRuntime_604ce3) {
    return get_isAlive($context_GameStateRuntime_604ce3, this.e5o_1);
  }
  toString() {
    return 'ReapStatement(yeltr=' + this.e5o_1.toString() + ')';
  }
  hashCode() {
    return this.e5o_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReapStatement))
      return false;
    if (!this.e5o_1.equals(other.e5o_1))
      return false;
    return true;
  }
  static f5o(seen0, yeltr, serializationConstructorMarker) {
    Companion_getInstance_407();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_348().c5o_1);
    }
    var $this = createThis(this);
    $this.e5o_1 = yeltr;
    return $this;
  }
}
class Companion_407 {
  constructor() {
    Companion_instance_407 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g5o_1 = [lazy(tmp_0, SoulReapStatement$Companion$$childSerializers$_anonymous__addyuo)];
  }
}
class $serializer_352 {
  constructor() {
    $serializer_instance_349 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SoulReapStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.h5o_1 = tmp0_serialDesc;
  }
  i5o(encoder, value) {
    var tmp0_desc = this.h5o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_408().g5o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.j5o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i5o(encoder, value instanceof SoulReapStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h5o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_408().g5o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SoulReapStatement.k5o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.h5o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_408().g5o_1[0].k3()];
  }
}
class SoulReapStatement {
  constructor(beast) {
    Companion_getInstance_408();
    this.j5o_1 = beast;
  }
  n2o($context_GameStateRuntime_604ce3) {
    return !(get_lydanYeltr($context_GameStateRuntime_604ce3) == null);
  }
  toString() {
    return 'SoulReapStatement(beast=' + this.j5o_1.toString() + ')';
  }
  hashCode() {
    return this.j5o_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoulReapStatement))
      return false;
    if (!this.j5o_1.equals(other.j5o_1))
      return false;
    return true;
  }
  static k5o(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_408();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_349().h5o_1);
    }
    var $this = createThis(this);
    $this.j5o_1 = beast;
    return $this;
  }
}
class Companion_408 {
  constructor() {
    Companion_instance_408 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l5o_1 = [lazy(tmp_0, SummonYeltrStatement$Companion$$childSerializers$_anonymous__c2h1ko)];
  }
}
class $serializer_353 {
  constructor() {
    $serializer_instance_350 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SummonYeltrStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.m5o_1 = tmp0_serialDesc;
  }
  n5o(encoder, value) {
    var tmp0_desc = this.m5o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_409().l5o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o5o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n5o(encoder, value instanceof SummonYeltrStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m5o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_409().l5o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SummonYeltrStatement.p5o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m5o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_409().l5o_1[0].k3()];
  }
}
class SummonYeltrStatement {
  constructor(beast) {
    Companion_getInstance_409();
    this.o5o_1 = beast;
  }
  toString() {
    return 'SummonYeltrStatement(beast=' + this.o5o_1.toString() + ')';
  }
  hashCode() {
    return this.o5o_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonYeltrStatement))
      return false;
    if (!this.o5o_1.equals(other.o5o_1))
      return false;
    return true;
  }
  static p5o(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_409();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_350().m5o_1);
    }
    var $this = createThis(this);
    $this.o5o_1 = beast;
    return $this;
  }
}
class Companion_409 {
  constructor() {
    Companion_instance_409 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q5o_1 = [lazy(tmp_0, ToothAndSeverStatement$Companion$$childSerializers$_anonymous__lky0oz)];
  }
}
class $serializer_354 {
  constructor() {
    $serializer_instance_351 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ToothAndSeverStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.r5o_1 = tmp0_serialDesc;
  }
  s5o(encoder, value) {
    var tmp0_desc = this.r5o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_410().q5o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t5o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s5o(encoder, value instanceof ToothAndSeverStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r5o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_410().q5o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ToothAndSeverStatement.u5o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r5o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_410().q5o_1[0].k3()];
  }
}
class ToothAndSeverStatement {
  constructor(beast) {
    Companion_getInstance_410();
    this.t5o_1 = beast;
  }
  toString() {
    return 'ToothAndSeverStatement(beast=' + this.t5o_1.toString() + ')';
  }
  hashCode() {
    return this.t5o_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ToothAndSeverStatement))
      return false;
    if (!this.t5o_1.equals(other.t5o_1))
      return false;
    return true;
  }
  static u5o(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_410();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_351().r5o_1);
    }
    var $this = createThis(this);
    $this.t5o_1 = beast;
    return $this;
  }
}
class Companion_410 {}
class $serializer_355 {
  constructor() {
    $serializer_instance_352 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GainLydanHarvestEvent', this, 1);
    tmp0_serialDesc.h1b('harvestGain', false);
    this.v5o_1 = tmp0_serialDesc;
  }
  w5o(encoder, value) {
    var tmp0_desc = this.v5o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.x5o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w5o(encoder, value instanceof GainLydanHarvestEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v5o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GainLydanHarvestEvent.y5o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.v5o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class GainLydanHarvestEvent {
  constructor(harvestGain) {
    this.x5o_1 = harvestGain;
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.require' call
    if (!(this.x5o_1 >= 0)) {
      var message = 'Lydan harvest gain cannot be negative';
      throw IllegalArgumentException.h2(toString(message));
    }
    var tmp0 = this.x5o_1;
    // Inline function 'kotlin.math.min' call
    var b = get_lydanHarvestCapacityLeft($context_GameStateRuntime_604ce3, get_lydanBeast($context_GameStateRuntime_604ce3));
    var adjustedGain = Math.min(tmp0, b);
    if (adjustedGain === 0)
      return emptyList();
    return listOf(new LydanHarvestChangeEvent(adjustedGain));
  }
  toString() {
    return 'GainLydanHarvestEvent(harvestGain=' + this.x5o_1 + ')';
  }
  hashCode() {
    return this.x5o_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GainLydanHarvestEvent))
      return false;
    if (!(this.x5o_1 === other.x5o_1))
      return false;
    return true;
  }
  static y5o(seen0, harvestGain, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_352().v5o_1);
    }
    var $this = createThis(this);
    $this.x5o_1 = harvestGain;
    return $this;
  }
}
class Companion_411 {}
class $serializer_356 {
  constructor() {
    $serializer_instance_353 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LydanHarvestChangeEvent', this, 1);
    tmp0_serialDesc.h1b('harvestChange', false);
    this.z5o_1 = tmp0_serialDesc;
  }
  a5p(encoder, value) {
    var tmp0_desc = this.z5o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.b5p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a5p(encoder, value instanceof LydanHarvestChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z5o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return LydanHarvestChangeEvent.c5p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.z5o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class LydanHarvestChangeEvent {
  constructor(harvestChange) {
    this.b5p_1 = harvestChange;
  }
  m37(_this__u8e3s4) {
    var _receiver__tnumb7 = get_lydanBeast(_this__u8e3s4);
    set_lydanHarvestImpl(_this__u8e3s4, _receiver__tnumb7, get_lydanHarvestImpl(_this__u8e3s4, _receiver__tnumb7) + this.b5p_1 | 0);
    // Inline function 'kotlin.require' call
    if (!(get_lydanHarvestImpl(_this__u8e3s4, get_lydanBeast(_this__u8e3s4)) >= 0)) {
      var message = 'Lydan harvest cannot be negative';
      throw IllegalArgumentException.h2(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(get_lydanHarvestImpl(_this__u8e3s4, get_lydanBeast(_this__u8e3s4)) <= 6)) {
      var message_0 = 'Lydan harvest cannot exceed 6';
      throw IllegalArgumentException.h2(toString(message_0));
    }
  }
  n37($context_GameState_t6qee5) {
    return new LydanHarvestChangeEvent(-this.b5p_1 | 0);
  }
  toString() {
    return 'LydanHarvestChangeEvent(harvestChange=' + this.b5p_1 + ')';
  }
  hashCode() {
    return this.b5p_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LydanHarvestChangeEvent))
      return false;
    if (!(this.b5p_1 === other.b5p_1))
      return false;
    return true;
  }
  static c5p(seen0, harvestChange, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_353().z5o_1);
    }
    var $this = createThis(this);
    $this.b5p_1 = harvestChange;
    return $this;
  }
}
class YeltrType {
  constructor() {
    YeltrType_instance = this;
    this.d5p_1 = Lydan_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e5p_1 = lazy(tmp_0, YeltrType$_anonymous__ft9ahr);
  }
  r37() {
    return this.d5p_1;
  }
  n2z($context_GameState_t6qee5) {
    return get_gameRules($context_GameState_t6qee5).j3a() === 2 ? 2 : 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_349(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'YeltrType';
  }
  hashCode() {
    return 2066413715;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YeltrType))
      return false;
    return true;
  }
}
class LydanCard {}
function get_character() {
  return Lydan_getInstance();
}
class BoltAndRecallCard {
  constructor() {
    BoltAndRecallCard_instance = this;
    this.f5p_1 = Red_getInstance();
    this.g5p_1 = 3;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h5p_1 = lazy(tmp_0, BoltAndRecallCard$_anonymous__8mbjkc);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_350(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BoltAndRecallCard';
  }
  hashCode() {
    return -273343938;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BoltAndRecallCard))
      return false;
    return true;
  }
}
class SoulReapCard {
  constructor() {
    SoulReapCard_instance = this;
    this.i5p_1 = Blue_getInstance();
    this.j5p_1 = 2;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k5p_1 = lazy(tmp_0, SoulReapCard$_anonymous__wwz1qm);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_351(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SoulReapCard';
  }
  hashCode() {
    return 585990698;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoulReapCard))
      return false;
    return true;
  }
}
class SummonYeltrCard {
  constructor() {
    SummonYeltrCard_instance = this;
    this.l5p_1 = Blue_getInstance();
    this.m5p_1 = 1;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n5p_1 = lazy(tmp_0, SummonYeltrCard$_anonymous__dj84ye);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_352(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonYeltrCard';
  }
  hashCode() {
    return 1758814280;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonYeltrCard))
      return false;
    return true;
  }
}
class ToothAndSeverCard {
  constructor() {
    ToothAndSeverCard_instance = this;
    this.o5p_1 = Red_getInstance();
    this.p5p_1 = 3;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q5p_1 = lazy(tmp_0, ToothAndSeverCard$_anonymous__eks70b);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_353(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ToothAndSeverCard';
  }
  hashCode() {
    return 1363532141;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ToothAndSeverCard))
      return false;
    return true;
  }
}
class DeathsLamentUpgrade {
  constructor() {
    DeathsLamentUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r5p_1 = lazy(tmp_0, DeathsLamentUpgrade$_anonymous__7lrdot);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_354(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DeathsLamentUpgrade';
  }
  hashCode() {
    return 1622797605;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DeathsLamentUpgrade))
      return false;
    return true;
  }
}
class SoulHarvestUpgrade {
  constructor() {
    SoulHarvestUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s5p_1 = lazy(tmp_0, SoulHarvestUpgrade$_anonymous__yuxor5);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_355(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SoulHarvestUpgrade';
  }
  hashCode() {
    return -497998133;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoulHarvestUpgrade))
      return false;
    return true;
  }
}
class PandemoniumUpgrade {
  constructor() {
    PandemoniumUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t5p_1 = lazy(tmp_0, PandemoniumUpgrade$_anonymous__9gn6fi);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_356(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PandemoniumUpgrade';
  }
  hashCode() {
    return 1510539406;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PandemoniumUpgrade))
      return false;
    return true;
  }
}
class SongOfTemptationUpgrade {
  constructor() {
    SongOfTemptationUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u5p_1 = lazy(tmp_0, SongOfTemptationUpgrade$_anonymous__dvuwsc);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_357(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SongOfTemptationUpgrade';
  }
  hashCode() {
    return -1896430666;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SongOfTemptationUpgrade))
      return false;
    return true;
  }
}
class VanishUpgrade {
  constructor() {
    VanishUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v5p_1 = lazy(tmp_0, VanishUpgrade$_anonymous__928k22);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_358(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'VanishUpgrade';
  }
  hashCode() {
    return -2027590532;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VanishUpgrade))
      return false;
    return true;
  }
}
class VoidPresenceUpgrade {
  constructor() {
    VoidPresenceUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w5p_1 = lazy(tmp_0, VoidPresenceUpgrade$_anonymous__cdm4eu);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_359(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'VoidPresenceUpgrade';
  }
  hashCode() {
    return -239127160;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VoidPresenceUpgrade))
      return false;
    return true;
  }
}
class FearTheNightUpgrade {
  constructor() {
    FearTheNightUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x5p_1 = lazy(tmp_0, FearTheNightUpgrade$_anonymous__tspyj2);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_360(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FearTheNightUpgrade';
  }
  hashCode() {
    return 1396758464;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FearTheNightUpgrade))
      return false;
    return true;
  }
}
class Mara {
  constructor() {
    Mara_instance = this;
    this.y5p_1 = BansheeType_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z5p_1 = lazy(tmp_0, Mara$_anonymous__l8b9n8);
  }
  q36() {
    return this.y5p_1;
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Cave_getInstance();
  }
  s36() {
    return setOf_0([FeedCard_getInstance(), FlickerCard_getInstance(), ObscureTalentCard_getInstance(), ShadowStepCard_getInstance()]);
  }
  t35() {
    return setOf_0([DeathsLamentUpgrade_getInstance(), SoulHarvestUpgrade_getInstance(), PandemoniumUpgrade_getInstance(), SongOfTemptationUpgrade_getInstance(), VanishUpgrade_getInstance(), VoidPresenceUpgrade_getInstance(), FearTheNightUpgrade_getInstance()]);
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_361(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Mara';
  }
  hashCode() {
    return 607797000;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Mara))
      return false;
    return true;
  }
}
class FeedCard {
  constructor() {
    FeedCard_instance = this;
    this.a5q_1 = Mara_getInstance();
    this.b5q_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c5q_1 = lazy(tmp_0, FeedCard$_anonymous__g0dq0n);
  }
  t37() {
    return this.a5q_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_362(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FeedCard';
  }
  hashCode() {
    return -704683117;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FeedCard))
      return false;
    return true;
  }
}
class Companion_412 {
  constructor() {
    Companion_instance_412 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d5q_1 = [lazy(tmp_0, RelocateToBansheeAndRevealStatement$Companion$$childSerializers$_anonymous__g7ck1x)];
  }
}
class $serializer_357 {
  constructor() {
    $serializer_instance_354 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RelocateToBansheeAndRevealStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.e5q_1 = tmp0_serialDesc;
  }
  f5q(encoder, value) {
    var tmp0_desc = this.e5q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_413().d5q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g5q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f5q(encoder, value instanceof RelocateToBansheeAndRevealStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e5q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_413().d5q_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RelocateToBansheeAndRevealStatement.h5q(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e5q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_413().d5q_1[0].k3()];
  }
}
class RelocateToBansheeAndRevealStatement {
  constructor(beast) {
    Companion_getInstance_413();
    this.g5q_1 = beast;
  }
  n2o($context_GameStateRuntime_604ce3) {
    var tmp0 = get_allObjectOnBoard($context_GameStateRuntime_604ce3);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp_0 = get_objectType($context_GameStateRuntime_604ce3, element);
        if (tmp_0 instanceof BansheeType) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  toString() {
    return 'RelocateToBansheeAndRevealStatement(beast=' + this.g5q_1.toString() + ')';
  }
  hashCode() {
    return this.g5q_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RelocateToBansheeAndRevealStatement))
      return false;
    if (!this.g5q_1.equals(other.g5q_1))
      return false;
    return true;
  }
  static h5q(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_413();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_354().e5q_1);
    }
    var $this = createThis(this);
    $this.g5q_1 = beast;
    return $this;
  }
}
class Companion_413 {
  constructor() {
    Companion_instance_413 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i5q_1 = [lazy(tmp_0, VanishStatement$Companion$$childSerializers$_anonymous__qwhzgq)];
  }
}
class $serializer_358 {
  constructor() {
    $serializer_instance_355 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('VanishStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.j5q_1 = tmp0_serialDesc;
  }
  k5q(encoder, value) {
    var tmp0_desc = this.j5q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_414().i5q_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l5q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k5q(encoder, value instanceof VanishStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j5q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_414().i5q_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return VanishStatement.m5q(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.j5q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_414().i5q_1[0].k3()];
  }
}
class VanishStatement {
  constructor(beast) {
    Companion_getInstance_414();
    this.l5q_1 = beast;
  }
  toString() {
    return 'VanishStatement(beast=' + this.l5q_1.toString() + ')';
  }
  hashCode() {
    return this.l5q_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VanishStatement))
      return false;
    if (!this.l5q_1.equals(other.l5q_1))
      return false;
    return true;
  }
  static m5q(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_414();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_355().j5q_1);
    }
    var $this = createThis(this);
    $this.l5q_1 = beast;
    return $this;
  }
}
class BansheeType {
  constructor() {
    BansheeType_instance = this;
    this.n5q_1 = Mara_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o5q_1 = lazy(tmp_0, BansheeType$_anonymous__hqzdkp);
  }
  r37() {
    return this.n5q_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_363(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BansheeType';
  }
  hashCode() {
    return -165488711;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BansheeType))
      return false;
    return true;
  }
}
class FlickerCard {
  constructor() {
    FlickerCard_instance = this;
    this.p5q_1 = Mara_getInstance();
    this.q5q_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r5q_1 = lazy(tmp_0, FlickerCard$_anonymous__6xd433);
  }
  t37() {
    return this.p5q_1;
  }
  s5q($context_GameState_t6qee5, beast) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_destroyRecords($context_GameState_t6qee5);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (element.p3a_1 === get_gameTeam($context_GameState_t6qee5, beast)) {
        destination.d2(element);
      }
    }
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp;
      if (isInterface(destination, Collection)) {
        tmp = destination.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$3 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s_0 = destination.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        var tmp_0;
        var tmp_1;
        if (element_0.r3a_1 === get_currentDayNumber($context_GameState_t6qee5)) {
          var tmp0_safe_receiver = element_0.q3a_1;
          var tmp_2 = tmp0_safe_receiver == null ? null : get_objectType($context_GameState_t6qee5, tmp0_safe_receiver);
          tmp_1 = !(!(tmp_2 == null) ? isInterface(tmp_2, HunterCharacter) : false);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = isAnimalSettlerOrHunter($context_GameState_t6qee5, element_0.o3a_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$3 = count;
    }
    return tmp$ret$3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_364(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FlickerCard';
  }
  hashCode() {
    return 81155395;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FlickerCard))
      return false;
    return true;
  }
}
class ObscureTalentCard {
  constructor() {
    ObscureTalentCard_instance = this;
    this.t5q_1 = Mara_getInstance();
    this.u5q_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v5q_1 = lazy(tmp_0, ObscureTalentCard$_anonymous__fll186);
  }
  t37() {
    return this.t5q_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_365(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ObscureTalentCard';
  }
  hashCode() {
    return 1163546364;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ObscureTalentCard))
      return false;
    return true;
  }
}
class ShadowStepCard {
  constructor() {
    ShadowStepCard_instance = this;
    this.w5q_1 = Mara_getInstance();
    this.x5q_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y5q_1 = lazy(tmp_0, ShadowStepCard$_anonymous__g3c0ij);
  }
  t37() {
    return this.w5q_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_366(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ShadowStepCard';
  }
  hashCode() {
    return -802761919;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShadowStepCard))
      return false;
    return true;
  }
}
class Nora {
  constructor() {
    Nora_instance = this;
    this.z5q_1 = setOf_0([AwarenessUpgrade_getInstance(), RevengeOfTheSheepUpgrade_getInstance(), WildbondUpgrade_getInstance(), BeastTongueUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a5r_1 = lazy(tmp_0, Nora$_anonymous__z92xnd);
  }
  s36() {
    return setOf_0([HerdCard_getInstance(), MountCard_getInstance(), new HuntCard(this)]);
  }
  t35() {
    return this.z5q_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_367(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Nora';
  }
  hashCode() {
    return 607840245;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Nora))
      return false;
    return true;
  }
}
class AwarenessUpgrade {
  constructor() {
    AwarenessUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b5r_1 = lazy(tmp_0, AwarenessUpgrade$_anonymous__9q9cxc);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_368(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AwarenessUpgrade';
  }
  hashCode() {
    return 1268031340;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AwarenessUpgrade))
      return false;
    return true;
  }
}
class RevengeOfTheSheepUpgrade {
  constructor() {
    RevengeOfTheSheepUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c5r_1 = lazy(tmp_0, RevengeOfTheSheepUpgrade$_anonymous__7uljxi);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_369(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RevengeOfTheSheepUpgrade';
  }
  hashCode() {
    return -1038172426;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevengeOfTheSheepUpgrade))
      return false;
    return true;
  }
}
class WildbondUpgrade {
  constructor() {
    WildbondUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d5r_1 = lazy(tmp_0, WildbondUpgrade$_anonymous__ymor3s);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_370(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WildbondUpgrade';
  }
  hashCode() {
    return 1685827178;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WildbondUpgrade))
      return false;
    return true;
  }
}
class BeastTongueUpgrade {
  constructor() {
    BeastTongueUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e5r_1 = lazy(tmp_0, BeastTongueUpgrade$_anonymous__yh2mm6);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_371(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeastTongueUpgrade';
  }
  hashCode() {
    return 1975514334;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastTongueUpgrade))
      return false;
    return true;
  }
}
class AnimalToSearchWithQuestionContext {
  constructor() {
    AnimalToSearchWithQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f5r_1 = lazy(tmp_0, AnimalToSearchWithQuestionContext$_anonymous__34wnf1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_372(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AnimalToSearchWithQuestionContext';
  }
  hashCode() {
    return 1360174719;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AnimalToSearchWithQuestionContext))
      return false;
    return true;
  }
}
class SheepForMoveAndAttackQuestionContext {
  constructor() {
    SheepForMoveAndAttackQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g5r_1 = lazy(tmp_0, SheepForMoveAndAttackQuestionContext$_anonymous__mur5ea);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_373(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SheepForMoveAndAttackQuestionContext';
  }
  hashCode() {
    return -1853685842;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SheepForMoveAndAttackQuestionContext))
      return false;
    return true;
  }
}
class Companion_414 {
  constructor() {
    Companion_instance_414 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h5r_1 = [lazy(tmp_0, AttackBySheepStatement$Companion$$childSerializers$_anonymous__9s14uh)];
  }
}
class $serializer_359 {
  constructor() {
    $serializer_instance_356 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AttackBySheepStatement', this, 1);
    tmp0_serialDesc.h1b('sheep', false);
    this.i5r_1 = tmp0_serialDesc;
  }
  j5r(encoder, value) {
    var tmp0_desc = this.i5r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_415().h5r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k5r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j5r(encoder, value instanceof AttackBySheepStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i5r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_415().h5r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AttackBySheepStatement.l5r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.i5r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_415().h5r_1[0].k3()];
  }
}
class AttackBySheepStatement {
  constructor(sheep) {
    Companion_getInstance_415();
    this.k5r_1 = sheep;
  }
  toString() {
    return 'AttackBySheepStatement(sheep=' + this.k5r_1.toString() + ')';
  }
  hashCode() {
    return this.k5r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AttackBySheepStatement))
      return false;
    if (!this.k5r_1.equals(other.k5r_1))
      return false;
    return true;
  }
  static l5r(seen0, sheep, serializationConstructorMarker) {
    Companion_getInstance_415();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_356().i5r_1);
    }
    var $this = createThis(this);
    $this.k5r_1 = sheep;
    return $this;
  }
}
class Companion_415 {
  constructor() {
    Companion_instance_415 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m5r_1 = [lazy(tmp_0, HerdStatement$Companion$$childSerializers$_anonymous__8cgmcq)];
  }
}
class $serializer_360 {
  constructor() {
    $serializer_instance_357 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HerdStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.n5r_1 = tmp0_serialDesc;
  }
  o5r(encoder, value) {
    var tmp0_desc = this.n5r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_416().m5r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p5r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o5r(encoder, value instanceof HerdStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n5r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_416().m5r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return HerdStatement.q5r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.n5r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_416().m5r_1[0].k3()];
  }
}
class HerdStatement {
  constructor(hunter) {
    Companion_getInstance_416();
    this.p5r_1 = hunter;
  }
  toString() {
    return 'HerdStatement(hunter=' + this.p5r_1.toString() + ')';
  }
  hashCode() {
    return this.p5r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HerdStatement))
      return false;
    if (!this.p5r_1.equals(other.p5r_1))
      return false;
    return true;
  }
  static q5r(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_416();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_357().n5r_1);
    }
    var $this = createThis(this);
    $this.p5r_1 = hunter;
    return $this;
  }
}
class Companion_416 {
  constructor() {
    Companion_instance_416 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r5r_1 = [lazy(tmp_0, MountStatement$Companion$$childSerializers$_anonymous__boibsc)];
  }
}
class $serializer_361 {
  constructor() {
    $serializer_instance_358 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MountStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.s5r_1 = tmp0_serialDesc;
  }
  t5r(encoder, value) {
    var tmp0_desc = this.s5r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_417().r5r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u5r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t5r(encoder, value instanceof MountStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s5r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_417().r5r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return MountStatement.v5r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s5r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_417().r5r_1[0].k3()];
  }
}
class MountStatement {
  constructor(hunter) {
    Companion_getInstance_417();
    this.u5r_1 = hunter;
  }
  toString() {
    return 'MountStatement(hunter=' + this.u5r_1.toString() + ')';
  }
  hashCode() {
    return this.u5r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MountStatement))
      return false;
    if (!this.u5r_1.equals(other.u5r_1))
      return false;
    return true;
  }
  static v5r(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_417();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_358().s5r_1);
    }
    var $this = createThis(this);
    $this.u5r_1 = hunter;
    return $this;
  }
}
class Companion_417 {
  constructor() {
    Companion_instance_417 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w5r_1 = [lazy(tmp_0, MoveWithAnimalStatement$Companion$$childSerializers$_anonymous__b0aq0i)];
  }
}
class $serializer_362 {
  constructor() {
    $serializer_instance_359 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MoveWithAnimalStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.x5r_1 = tmp0_serialDesc;
  }
  y5r(encoder, value) {
    var tmp0_desc = this.x5r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_418().w5r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.z5r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y5r(encoder, value instanceof MoveWithAnimalStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x5r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_418().w5r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return MoveWithAnimalStatement.a5s(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x5r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_418().w5r_1[0].k3()];
  }
}
class MoveWithAnimalStatement {
  constructor(hunter) {
    Companion_getInstance_418();
    this.z5r_1 = hunter;
  }
  toString() {
    return 'MoveWithAnimalStatement(hunter=' + this.z5r_1.toString() + ')';
  }
  hashCode() {
    return this.z5r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MoveWithAnimalStatement))
      return false;
    if (!this.z5r_1.equals(other.z5r_1))
      return false;
    return true;
  }
  static a5s(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_418();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_359().x5r_1);
    }
    var $this = createThis(this);
    $this.z5r_1 = hunter;
    return $this;
  }
}
class Companion_418 {
  constructor() {
    Companion_instance_418 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b5s_1 = [lazy(tmp_0, RevengeOfTheSheepStatement$Companion$$childSerializers$_anonymous__wjnqqi)];
  }
}
class $serializer_363 {
  constructor() {
    $serializer_instance_360 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevengeOfTheSheepStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.c5s_1 = tmp0_serialDesc;
  }
  d5s(encoder, value) {
    var tmp0_desc = this.c5s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_419().b5s_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.e5s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d5s(encoder, value instanceof RevengeOfTheSheepStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c5s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_419().b5s_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RevengeOfTheSheepStatement.f5s(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.c5s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_419().b5s_1[0].k3()];
  }
}
class RevengeOfTheSheepStatement {
  constructor(hunter) {
    Companion_getInstance_419();
    this.e5s_1 = hunter;
  }
  toString() {
    return 'RevengeOfTheSheepStatement(hunter=' + this.e5s_1.toString() + ')';
  }
  hashCode() {
    return this.e5s_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevengeOfTheSheepStatement))
      return false;
    if (!this.e5s_1.equals(other.e5s_1))
      return false;
    return true;
  }
  static f5s(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_419();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_360().c5s_1);
    }
    var $this = createThis(this);
    $this.e5s_1 = hunter;
    return $this;
  }
}
class HerdCard {
  constructor() {
    HerdCard_instance = this;
    this.g5s_1 = Split_getInstance();
    this.h5s_1 = Nora_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i5s_1 = lazy(tmp_0, HerdCard$_anonymous__17pgzs);
  }
  t37() {
    return this.h5s_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_374(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HerdCard';
  }
  hashCode() {
    return -1141850780;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HerdCard))
      return false;
    return true;
  }
}
class MountCard {
  constructor() {
    MountCard_instance = this;
    this.j5s_1 = Blue_getInstance();
    this.k5s_1 = Nora_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l5s_1 = lazy(tmp_0, MountCard$_anonymous__5tiv2m);
  }
  t37() {
    return this.k5s_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_375(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'MountCard';
  }
  hashCode() {
    return 1756406180;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MountCard))
      return false;
    return true;
  }
}
class NorthernNamedSettlements {
  constructor() {
    NorthernNamedSettlements_instance = this;
    this.m5s_1 = _BoardPosition___init__impl__1nizgq_0(0, -3);
    this.n5s_1 = _BoardPosition___init__impl__1nizgq_0(-3, -1);
    this.o5s_1 = _BoardPosition___init__impl__1nizgq_0(-2, 2);
    this.p5s_1 = _BoardPosition___init__impl__1nizgq_0(-4, 3);
    this.q5s_1 = _BoardPosition___init__impl__1nizgq_0(3, -2);
    this.r5s_1 = _BoardPosition___init__impl__1nizgq_0(2, 2);
    this.s5s_1 = _BoardPosition___init__impl__1nizgq_0(3, 3);
  }
}
class Companion_419 {
  constructor() {
    Companion_instance_419 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.ObjectOnBoard', null, 1);
    tmp0_serialDesc.h1b('id', false);
    this.t5s_1 = tmp0_serialDesc;
  }
  i47(typeSerial0) {
    return $serializer_364.y2o(typeSerial0);
  }
  m1c(typeParamsSerializers) {
    return this.i47(typeParamsSerializers[0]);
  }
}
class $serializer_364 {
  constructor() {
    return new.target.u5s();
  }
  static u5s() {
    var $this = createThis(this);
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.ObjectOnBoard', $this, 1);
    tmp0_serialDesc.h1b('id', false);
    $this.w2o_1 = tmp0_serialDesc;
    return $this;
  }
  v5s(encoder, value) {
    var tmp0_desc = this.w2o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_136(), new EntityId(value.r2w_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v5s(encoder, value instanceof ObjectOnBoard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_136();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new EntityId(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.c3y_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_136();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new EntityId(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.c3y_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ObjectOnBoard.w5s(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w2o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_136()];
  }
  z1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.x2o_1];
  }
  static y2o(typeSerial0) {
    var $this = this.u5s();
    $this.x2o_1 = typeSerial0;
    return $this;
  }
}
class ObjectOnBoard {
  constructor(id) {
    Companion_getInstance_420();
    this.r2w_1 = id;
  }
  l39(gsCtx) {
    return gsCtx.j4l(this.r2w_1);
  }
  l32($context_GameState_t6qee5) {
    return get_objectType($context_GameState_t6qee5, this).r36($context_GameState_t6qee5);
  }
  s2w(gsCtx) {
    return getPositionImpl(this, gsCtx);
  }
  b4s(gsiCtx, value) {
    setImplProperty(gsiCtx, this, get_positionKey(), new BoardPositionWrapper(value));
  }
  toString() {
    return 'ObjectOnBoard(id=' + EntityId__toString_impl_njecar(this.r2w_1) + ')';
  }
  hashCode() {
    return EntityId__hashCode_impl_1s8fhw(this.r2w_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ObjectOnBoard))
      return false;
    if (!(this.r2w_1 === other.r2w_1))
      return false;
    return true;
  }
  static w5s(seen0, id, serializationConstructorMarker) {
    Companion_getInstance_420();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, Companion_getInstance_420().t5s_1);
    }
    var $this = createThis(this);
    $this.r2w_1 = id;
    return $this;
  }
}
class Companion_420 {
  a2g() {
    var tmp = getKClass(ObjectOnBoardType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Akkeron), getKClass(Bolgin), getKClass(EsmeriaBeast), getKClass(Fangrir), getKClass(FeatheredKing), getKClass(Hogbad), getKClass(Lydan), getKClass(Mara), getKClass(Omma), getKClass(Raaga), getKClass(Rhagner), getKClass(Thalduk), getKClass(Urgull), getKClass(Vacker), getKClass(Assar), getKClass(Bram), getKClass(Draug), getKClass(Eivind), getKClass(EsmeriaHuntress), getKClass(Fara), getKClass(Grimgeir), getKClass(Helga), getKClass(Iona), getKClass(Krim), getKClass(Nora), getKClass(Sigrid), getKClass(Valdi), getKClass(Varja), getKClass(Assar), getKClass(Bram), getKClass(Draug), getKClass(Eivind), getKClass(EsmeriaHuntress), getKClass(Fara), getKClass(Grimgeir), getKClass(Helga), getKClass(Iona), getKClass(Krim), getKClass(Nora), getKClass(Sigrid), getKClass(Valdi), getKClass(Varja), getKClass(CreatureType), getKClass(Fylgja), getKClass(FarmerType), getKClass(NobleType), getKClass(BearType), getKClass(BoarType), getKClass(SheepType), getKClass(TigerType), getKClass(BarrierSideType), getKClass(BoatType), getKClass(CreatureType), getKClass(Fylgja), getKClass(FarmerType), getKClass(NobleType), getKClass(SnareTokenType), getKClass(AbominationType), getKClass(AdmirerType), getKClass(BansheeType), getKClass(BasiliskType), getKClass(ChangelingType), getKClass(DreamerType), getKClass(EggType), getKClass(EyeType), getKClass(HatchlingType), getKClass(LindwyrmType), getKClass(PolypType), getKClass(WarhogType), getKClass(WolfType), getKClass(YagiType), getKClass(YeltrType), getKClass(WatchtowerType)];
    var tmp_1 = Akkeron_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Akkeron', tmp_1, tmp$ret$3);
    var tmp_3 = Bolgin_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('Bolgin', tmp_3, tmp$ret$6);
    var tmp_5 = EsmeriaBeast_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('EsmeriaBeast', tmp_5, tmp$ret$9);
    var tmp_7 = Fangrir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Fangrir', tmp_7, tmp$ret$12);
    var tmp_9 = FeatheredKing_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('FeatheredKing', tmp_9, tmp$ret$15);
    var tmp_11 = Hogbad_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('Hogbad', tmp_11, tmp$ret$18);
    var tmp_13 = Lydan_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('Lydan', tmp_13, tmp$ret$21);
    var tmp_15 = Mara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('Mara', tmp_15, tmp$ret$24);
    var tmp_17 = Omma_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('Omma', tmp_17, tmp$ret$27);
    var tmp_19 = Raaga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('Raaga', tmp_19, tmp$ret$30);
    var tmp_21 = Rhagner_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('Rhagner', tmp_21, tmp$ret$33);
    var tmp_23 = Thalduk_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('Thalduk', tmp_23, tmp$ret$36);
    var tmp_25 = Urgull_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('Urgull', tmp_25, tmp$ret$39);
    var tmp_27 = Vacker_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('Vacker', tmp_27, tmp$ret$42);
    var tmp_29 = Assar_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('Assar', tmp_29, tmp$ret$45);
    var tmp_31 = Bram_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('Bram', tmp_31, tmp$ret$48);
    var tmp_33 = Draug_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('Draug', tmp_33, tmp$ret$51);
    var tmp_35 = Eivind_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_36 = ObjectSerializer.l1c('Eivind', tmp_35, tmp$ret$54);
    var tmp_37 = EsmeriaHuntress_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_38 = ObjectSerializer.l1c('EsmeriaHuntress', tmp_37, tmp$ret$57);
    var tmp_39 = Fara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_40 = ObjectSerializer.l1c('Fara', tmp_39, tmp$ret$60);
    var tmp_41 = Grimgeir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_42 = ObjectSerializer.l1c('Grimgeir', tmp_41, tmp$ret$63);
    var tmp_43 = Helga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_44 = ObjectSerializer.l1c('Helga', tmp_43, tmp$ret$66);
    var tmp_45 = Iona_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_46 = ObjectSerializer.l1c('Iona', tmp_45, tmp$ret$69);
    var tmp_47 = Krim_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_48 = ObjectSerializer.l1c('Krim', tmp_47, tmp$ret$72);
    var tmp_49 = Nora_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_50 = ObjectSerializer.l1c('Nora', tmp_49, tmp$ret$75);
    var tmp_51 = Sigrid_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_52 = ObjectSerializer.l1c('Sigrid', tmp_51, tmp$ret$78);
    var tmp_53 = Valdi_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_54 = ObjectSerializer.l1c('Valdi', tmp_53, tmp$ret$81);
    var tmp_55 = Varja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_56 = ObjectSerializer.l1c('Varja', tmp_55, tmp$ret$84);
    var tmp_57 = Assar_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_58 = ObjectSerializer.l1c('Assar', tmp_57, tmp$ret$87);
    var tmp_59 = Bram_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_60 = ObjectSerializer.l1c('Bram', tmp_59, tmp$ret$90);
    var tmp_61 = Draug_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_62 = ObjectSerializer.l1c('Draug', tmp_61, tmp$ret$93);
    var tmp_63 = Eivind_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_64 = ObjectSerializer.l1c('Eivind', tmp_63, tmp$ret$96);
    var tmp_65 = EsmeriaHuntress_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_66 = ObjectSerializer.l1c('EsmeriaHuntress', tmp_65, tmp$ret$99);
    var tmp_67 = Fara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_68 = ObjectSerializer.l1c('Fara', tmp_67, tmp$ret$102);
    var tmp_69 = Grimgeir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_70 = ObjectSerializer.l1c('Grimgeir', tmp_69, tmp$ret$105);
    var tmp_71 = Helga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_72 = ObjectSerializer.l1c('Helga', tmp_71, tmp$ret$108);
    var tmp_73 = Iona_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_74 = ObjectSerializer.l1c('Iona', tmp_73, tmp$ret$111);
    var tmp_75 = Krim_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_76 = ObjectSerializer.l1c('Krim', tmp_75, tmp$ret$114);
    var tmp_77 = Nora_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_78 = ObjectSerializer.l1c('Nora', tmp_77, tmp$ret$117);
    var tmp_79 = Sigrid_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_80 = ObjectSerializer.l1c('Sigrid', tmp_79, tmp$ret$120);
    var tmp_81 = Valdi_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_82 = ObjectSerializer.l1c('Valdi', tmp_81, tmp$ret$123);
    var tmp_83 = Varja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_84 = ObjectSerializer.l1c('Varja', tmp_83, tmp$ret$126);
    var tmp_85 = CreatureType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_86 = ObjectSerializer.l1c('CreatureType', tmp_85, tmp$ret$129);
    var tmp_87 = Fylgja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_88 = ObjectSerializer.l1c('Fylgja', tmp_87, tmp$ret$132);
    var tmp_89 = FarmerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_90 = ObjectSerializer.l1c('FarmerType', tmp_89, tmp$ret$135);
    var tmp_91 = NobleType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    var tmp_92 = ObjectSerializer.l1c('NobleType', tmp_91, tmp$ret$138);
    var tmp_93 = BearType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$141 = [];
    var tmp_94 = ObjectSerializer.l1c('BearType', tmp_93, tmp$ret$141);
    var tmp_95 = BoarType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    var tmp_96 = ObjectSerializer.l1c('BoarType', tmp_95, tmp$ret$144);
    var tmp_97 = SheepType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$147 = [];
    var tmp_98 = ObjectSerializer.l1c('SheepType', tmp_97, tmp$ret$147);
    var tmp_99 = TigerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$150 = [];
    var tmp_100 = ObjectSerializer.l1c('TigerType', tmp_99, tmp$ret$150);
    var tmp_101 = $serializer_getInstance_361();
    var tmp_102 = BoatType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$153 = [];
    var tmp_103 = ObjectSerializer.l1c('BoatType', tmp_102, tmp$ret$153);
    var tmp_104 = CreatureType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$156 = [];
    var tmp_105 = ObjectSerializer.l1c('CreatureType', tmp_104, tmp$ret$156);
    var tmp_106 = Fylgja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$159 = [];
    var tmp_107 = ObjectSerializer.l1c('Fylgja', tmp_106, tmp$ret$159);
    var tmp_108 = FarmerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$162 = [];
    var tmp_109 = ObjectSerializer.l1c('FarmerType', tmp_108, tmp$ret$162);
    var tmp_110 = NobleType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$165 = [];
    var tmp_111 = ObjectSerializer.l1c('NobleType', tmp_110, tmp$ret$165);
    var tmp_112 = SnareTokenType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$168 = [];
    var tmp_113 = ObjectSerializer.l1c('SnareTokenType', tmp_112, tmp$ret$168);
    var tmp_114 = AbominationType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$171 = [];
    var tmp_115 = ObjectSerializer.l1c('AbominationType', tmp_114, tmp$ret$171);
    var tmp_116 = AdmirerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$174 = [];
    var tmp_117 = ObjectSerializer.l1c('AdmirerType', tmp_116, tmp$ret$174);
    var tmp_118 = BansheeType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$177 = [];
    var tmp_119 = ObjectSerializer.l1c('BansheeType', tmp_118, tmp$ret$177);
    var tmp_120 = BasiliskType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$180 = [];
    var tmp_121 = ObjectSerializer.l1c('BasiliskType', tmp_120, tmp$ret$180);
    var tmp_122 = ChangelingType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$183 = [];
    var tmp_123 = ObjectSerializer.l1c('ChangelingType', tmp_122, tmp$ret$183);
    var tmp_124 = DreamerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$186 = [];
    var tmp_125 = ObjectSerializer.l1c('DreamerType', tmp_124, tmp$ret$186);
    var tmp_126 = EggType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$189 = [];
    var tmp_127 = ObjectSerializer.l1c('EggType', tmp_126, tmp$ret$189);
    var tmp_128 = EyeType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$192 = [];
    var tmp_129 = ObjectSerializer.l1c('EyeType', tmp_128, tmp$ret$192);
    var tmp_130 = HatchlingType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$195 = [];
    var tmp_131 = ObjectSerializer.l1c('HatchlingType', tmp_130, tmp$ret$195);
    var tmp_132 = LindwyrmType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$198 = [];
    var tmp_133 = ObjectSerializer.l1c('LindwyrmType', tmp_132, tmp$ret$198);
    var tmp_134 = PolypType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$201 = [];
    var tmp_135 = ObjectSerializer.l1c('PolypType', tmp_134, tmp$ret$201);
    var tmp_136 = WarhogType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$204 = [];
    var tmp_137 = ObjectSerializer.l1c('WarhogType', tmp_136, tmp$ret$204);
    var tmp_138 = WolfType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$207 = [];
    var tmp_139 = ObjectSerializer.l1c('WolfType', tmp_138, tmp$ret$207);
    var tmp_140 = YagiType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$210 = [];
    var tmp_141 = ObjectSerializer.l1c('YagiType', tmp_140, tmp$ret$210);
    var tmp_142 = YeltrType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$213 = [];
    var tmp_143 = ObjectSerializer.l1c('YeltrType', tmp_142, tmp$ret$213);
    var tmp_144 = WatchtowerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$216 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_145 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_66, tmp_68, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_80, tmp_82, tmp_84, tmp_86, tmp_88, tmp_90, tmp_92, tmp_94, tmp_96, tmp_98, tmp_100, tmp_101, tmp_103, tmp_105, tmp_107, tmp_109, tmp_111, tmp_113, tmp_115, tmp_117, tmp_119, tmp_121, tmp_123, tmp_125, tmp_127, tmp_129, tmp_131, tmp_133, tmp_135, tmp_137, tmp_139, tmp_141, tmp_143, ObjectSerializer.l1c('WatchtowerType', tmp_144, tmp$ret$216)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$222 = [];
    return SealedClassSerializer.i10('steelart.beast.ObjectOnBoardType', tmp, tmp_0, tmp_145, tmp$ret$222);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_421 {
  a2g() {
    var tmp = getKClass(HumanKindType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Assar), getKClass(Bram), getKClass(Draug), getKClass(Eivind), getKClass(EsmeriaHuntress), getKClass(Fara), getKClass(Grimgeir), getKClass(Helga), getKClass(Iona), getKClass(Krim), getKClass(Nora), getKClass(Sigrid), getKClass(Valdi), getKClass(Varja), getKClass(CreatureType), getKClass(Fylgja), getKClass(FarmerType), getKClass(NobleType)];
    var tmp_1 = Assar_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Assar', tmp_1, tmp$ret$3);
    var tmp_3 = Bram_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('Bram', tmp_3, tmp$ret$6);
    var tmp_5 = Draug_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('Draug', tmp_5, tmp$ret$9);
    var tmp_7 = Eivind_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Eivind', tmp_7, tmp$ret$12);
    var tmp_9 = EsmeriaHuntress_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('EsmeriaHuntress', tmp_9, tmp$ret$15);
    var tmp_11 = Fara_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('Fara', tmp_11, tmp$ret$18);
    var tmp_13 = Grimgeir_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('Grimgeir', tmp_13, tmp$ret$21);
    var tmp_15 = Helga_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('Helga', tmp_15, tmp$ret$24);
    var tmp_17 = Iona_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('Iona', tmp_17, tmp$ret$27);
    var tmp_19 = Krim_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('Krim', tmp_19, tmp$ret$30);
    var tmp_21 = Nora_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('Nora', tmp_21, tmp$ret$33);
    var tmp_23 = Sigrid_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('Sigrid', tmp_23, tmp$ret$36);
    var tmp_25 = Valdi_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('Valdi', tmp_25, tmp$ret$39);
    var tmp_27 = Varja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('Varja', tmp_27, tmp$ret$42);
    var tmp_29 = CreatureType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('CreatureType', tmp_29, tmp$ret$45);
    var tmp_31 = Fylgja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('Fylgja', tmp_31, tmp$ret$48);
    var tmp_33 = FarmerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('FarmerType', tmp_33, tmp$ret$51);
    var tmp_35 = NobleType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_36 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, ObjectSerializer.l1c('NobleType', tmp_35, tmp$ret$54)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    return SealedClassSerializer.i10('steelart.beast.HumanKindType', tmp, tmp_0, tmp_36, tmp$ret$60);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class AnimalType {}
class SheepType {
  constructor() {
    SheepType_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x5s_1 = lazy(tmp_0, SheepType$_anonymous__u6ndsu);
  }
  n2z($context_GameState_t6qee5) {
    return get_gameRules($context_GameState_t6qee5).e3b(ValueId_SheepHP_getInstance(), 1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_376(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SheepType';
  }
  hashCode() {
    return -1389140464;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SheepType))
      return false;
    return true;
  }
}
class Companion_422 {
  a2g() {
    var tmp = getKClass(SettlerType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(FarmerType), getKClass(NobleType)];
    var tmp_1 = FarmerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('FarmerType', tmp_1, tmp$ret$3);
    var tmp_3 = NobleType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_4 = [tmp_2, ObjectSerializer.l1c('NobleType', tmp_3, tmp$ret$6)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    return SealedClassSerializer.i10('steelart.beast.SettlerType', tmp, tmp_0, tmp_4, tmp$ret$12);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class SettlerType {}
class Companion_423 {
  a2g() {
    var tmp = getKClass(SimpleObjectType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BearType), getKClass(BoarType), getKClass(SheepType), getKClass(TigerType), getKClass(BarrierSideType), getKClass(BoatType), getKClass(CreatureType), getKClass(Fylgja), getKClass(FarmerType), getKClass(NobleType), getKClass(SnareTokenType), getKClass(AbominationType), getKClass(AdmirerType), getKClass(BansheeType), getKClass(BasiliskType), getKClass(ChangelingType), getKClass(DreamerType), getKClass(EggType), getKClass(EyeType), getKClass(HatchlingType), getKClass(LindwyrmType), getKClass(PolypType), getKClass(WarhogType), getKClass(WolfType), getKClass(YagiType), getKClass(YeltrType), getKClass(WatchtowerType)];
    var tmp_1 = BearType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('BearType', tmp_1, tmp$ret$3);
    var tmp_3 = BoarType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('BoarType', tmp_3, tmp$ret$6);
    var tmp_5 = SheepType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('SheepType', tmp_5, tmp$ret$9);
    var tmp_7 = TigerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('TigerType', tmp_7, tmp$ret$12);
    var tmp_9 = $serializer_getInstance_361();
    var tmp_10 = BoatType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_11 = ObjectSerializer.l1c('BoatType', tmp_10, tmp$ret$15);
    var tmp_12 = CreatureType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_13 = ObjectSerializer.l1c('CreatureType', tmp_12, tmp$ret$18);
    var tmp_14 = Fylgja_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_15 = ObjectSerializer.l1c('Fylgja', tmp_14, tmp$ret$21);
    var tmp_16 = FarmerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_17 = ObjectSerializer.l1c('FarmerType', tmp_16, tmp$ret$24);
    var tmp_18 = NobleType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_19 = ObjectSerializer.l1c('NobleType', tmp_18, tmp$ret$27);
    var tmp_20 = SnareTokenType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_21 = ObjectSerializer.l1c('SnareTokenType', tmp_20, tmp$ret$30);
    var tmp_22 = AbominationType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_23 = ObjectSerializer.l1c('AbominationType', tmp_22, tmp$ret$33);
    var tmp_24 = AdmirerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_25 = ObjectSerializer.l1c('AdmirerType', tmp_24, tmp$ret$36);
    var tmp_26 = BansheeType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_27 = ObjectSerializer.l1c('BansheeType', tmp_26, tmp$ret$39);
    var tmp_28 = BasiliskType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_29 = ObjectSerializer.l1c('BasiliskType', tmp_28, tmp$ret$42);
    var tmp_30 = ChangelingType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_31 = ObjectSerializer.l1c('ChangelingType', tmp_30, tmp$ret$45);
    var tmp_32 = DreamerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_33 = ObjectSerializer.l1c('DreamerType', tmp_32, tmp$ret$48);
    var tmp_34 = EggType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_35 = ObjectSerializer.l1c('EggType', tmp_34, tmp$ret$51);
    var tmp_36 = EyeType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_37 = ObjectSerializer.l1c('EyeType', tmp_36, tmp$ret$54);
    var tmp_38 = HatchlingType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_39 = ObjectSerializer.l1c('HatchlingType', tmp_38, tmp$ret$57);
    var tmp_40 = LindwyrmType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_41 = ObjectSerializer.l1c('LindwyrmType', tmp_40, tmp$ret$60);
    var tmp_42 = PolypType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_43 = ObjectSerializer.l1c('PolypType', tmp_42, tmp$ret$63);
    var tmp_44 = WarhogType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_45 = ObjectSerializer.l1c('WarhogType', tmp_44, tmp$ret$66);
    var tmp_46 = WolfType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_47 = ObjectSerializer.l1c('WolfType', tmp_46, tmp$ret$69);
    var tmp_48 = YagiType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_49 = ObjectSerializer.l1c('YagiType', tmp_48, tmp$ret$72);
    var tmp_50 = YeltrType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_51 = ObjectSerializer.l1c('YeltrType', tmp_50, tmp$ret$75);
    var tmp_52 = WatchtowerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_53 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_9, tmp_11, tmp_13, tmp_15, tmp_17, tmp_19, tmp_21, tmp_23, tmp_25, tmp_27, tmp_29, tmp_31, tmp_33, tmp_35, tmp_37, tmp_39, tmp_41, tmp_43, tmp_45, tmp_47, tmp_49, tmp_51, ObjectSerializer.l1c('WatchtowerType', tmp_52, tmp$ret$78)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    return SealedClassSerializer.i10('steelart.beast.SimpleObjectType', tmp, tmp_0, tmp_53, tmp$ret$84);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class NobleType {
  constructor() {
    NobleType_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y5s_1 = lazy(tmp_0, NobleType$_anonymous__t5kjh);
  }
  n2z($context_GameState_t6qee5) {
    return get_gameRules($context_GameState_t6qee5).e3b(ValueId_NobleHP_getInstance(), 3);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_377(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NobleType';
  }
  hashCode() {
    return 195669295;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NobleType))
      return false;
    return true;
  }
}
class FarmerType {
  constructor() {
    FarmerType_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z5s_1 = lazy(tmp_0, FarmerType$_anonymous__6wzja);
  }
  n2z($context_GameState_t6qee5) {
    return get_gameRules($context_GameState_t6qee5).e3b(ValueId_FarmerHP_getInstance(), 2);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_378(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FarmerType';
  }
  hashCode() {
    return 1611758018;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FarmerType))
      return false;
    return true;
  }
}
class BoatType {
  constructor() {
    BoatType_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a5t_1 = lazy(tmp_0, BoatType$_anonymous__ctibwj);
  }
  n2z($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_379(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BoatType';
  }
  hashCode() {
    return 1099901535;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BoatType))
      return false;
    return true;
  }
}
class BoarType {
  constructor() {
    BoarType_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b5t_1 = lazy(tmp_0, BoarType$_anonymous__vxxwzj);
  }
  n2z($context_GameState_t6qee5) {
    return get_gameRules($context_GameState_t6qee5).e3b(ValueId_BoarHP_getInstance(), 2);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_380(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BoarType';
  }
  hashCode() {
    return 1098054493;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BoarType))
      return false;
    return true;
  }
}
class TigerType {
  constructor() {
    TigerType_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c5t_1 = lazy(tmp_0, TigerType$_anonymous__ra4vzy);
  }
  n2z($context_GameState_t6qee5) {
    return get_gameRules($context_GameState_t6qee5).e3b(ValueId_TigerHP_getInstance(), 2);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_381(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TigerType';
  }
  hashCode() {
    return 323069812;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TigerType))
      return false;
    return true;
  }
}
class Companion_424 {
  a2g() {
    var tmp = getKClass(SummonType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AbominationType), getKClass(AdmirerType), getKClass(BansheeType), getKClass(BasiliskType), getKClass(ChangelingType), getKClass(DreamerType), getKClass(EggType), getKClass(EyeType), getKClass(HatchlingType), getKClass(LindwyrmType), getKClass(PolypType), getKClass(WarhogType), getKClass(WolfType), getKClass(YagiType), getKClass(YeltrType)];
    var tmp_1 = AbominationType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('AbominationType', tmp_1, tmp$ret$3);
    var tmp_3 = AdmirerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('AdmirerType', tmp_3, tmp$ret$6);
    var tmp_5 = BansheeType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('BansheeType', tmp_5, tmp$ret$9);
    var tmp_7 = BasiliskType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('BasiliskType', tmp_7, tmp$ret$12);
    var tmp_9 = ChangelingType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('ChangelingType', tmp_9, tmp$ret$15);
    var tmp_11 = DreamerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('DreamerType', tmp_11, tmp$ret$18);
    var tmp_13 = EggType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('EggType', tmp_13, tmp$ret$21);
    var tmp_15 = EyeType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('EyeType', tmp_15, tmp$ret$24);
    var tmp_17 = HatchlingType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('HatchlingType', tmp_17, tmp$ret$27);
    var tmp_19 = LindwyrmType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('LindwyrmType', tmp_19, tmp$ret$30);
    var tmp_21 = PolypType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('PolypType', tmp_21, tmp$ret$33);
    var tmp_23 = WarhogType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('WarhogType', tmp_23, tmp$ret$36);
    var tmp_25 = WolfType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('WolfType', tmp_25, tmp$ret$39);
    var tmp_27 = YagiType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('YagiType', tmp_27, tmp$ret$42);
    var tmp_29 = YeltrType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_30 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, ObjectSerializer.l1c('YeltrType', tmp_29, tmp$ret$45)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    return SealedClassSerializer.i10('steelart.beast.SummonType', tmp, tmp_0, tmp_30, tmp$ret$51);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_425 {
  a2g() {
    var tmp = getKClass(AnimalType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BearType), getKClass(BoarType), getKClass(SheepType), getKClass(TigerType)];
    var tmp_1 = BearType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('BearType', tmp_1, tmp$ret$3);
    var tmp_3 = BoarType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('BoarType', tmp_3, tmp$ret$6);
    var tmp_5 = SheepType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('SheepType', tmp_5, tmp$ret$9);
    var tmp_7 = TigerType_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_8 = [tmp_2, tmp_4, tmp_6, ObjectSerializer.l1c('TigerType', tmp_7, tmp$ret$12)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    return SealedClassSerializer.i10('steelart.beast.AnimalType', tmp, tmp_0, tmp_8, tmp$ret$18);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_426 {}
class $serializer_365 {
  constructor() {
    $serializer_instance_361 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BarrierSideType', this, 1);
    tmp0_serialDesc.h1b('direction', false);
    this.d5t_1 = tmp0_serialDesc;
  }
  e5t(encoder, value) {
    var tmp0_desc = this.d5t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_101(), value.q4f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e5t(encoder, value instanceof BarrierSideType ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d5t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_101(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_101(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BarrierSideType.f5t(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d5t_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_101()];
  }
}
class BarrierSideType {
  constructor(direction) {
    this.q4f_1 = direction;
  }
  n2z($context_GameState_t6qee5) {
    return 1;
  }
  toString() {
    return 'BarrierSideType(direction=' + this.q4f_1.toString() + ')';
  }
  hashCode() {
    return this.q4f_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BarrierSideType))
      return false;
    if (!this.q4f_1.equals(other.q4f_1))
      return false;
    return true;
  }
  static f5t(seen0, direction, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_361().d5t_1);
    }
    var $this = createThis(this);
    $this.q4f_1 = direction;
    return $this;
  }
}
class WatchtowerType {
  constructor() {
    WatchtowerType_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g5t_1 = lazy(tmp_0, WatchtowerType$_anonymous__jt3mxv);
  }
  n2z($context_GameState_t6qee5) {
    return get_gameRules($context_GameState_t6qee5).e3b(ValueId_WatchtowerHP_getInstance(), 1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_382(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WatchtowerType';
  }
  hashCode() {
    return 1610340345;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WatchtowerType))
      return false;
    return true;
  }
}
class BearType {
  constructor() {
    BearType_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h5t_1 = lazy(tmp_0, BearType$_anonymous__yceea1);
  }
  n2z($context_GameState_t6qee5) {
    return get_gameRules($context_GameState_t6qee5).e3b(ValueId_BearHP_getInstance(), 2);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_383(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BearType';
  }
  hashCode() {
    return 812952275;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BearType))
      return false;
    return true;
  }
}
class DistractionUpgrade {
  constructor() {
    DistractionUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i5t_1 = lazy(tmp_0, DistractionUpgrade$_anonymous__azz5y5);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_384(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DistractionUpgrade';
  }
  hashCode() {
    return 125780607;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DistractionUpgrade))
      return false;
    return true;
  }
}
class DoubleUpgrade {
  constructor() {
    DoubleUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j5t_1 = lazy(tmp_0, DoubleUpgrade$_anonymous__6o0yoc);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_385(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DoubleUpgrade';
  }
  hashCode() {
    return 1281506918;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DoubleUpgrade))
      return false;
    return true;
  }
}
class ThickMistUpgrade {
  constructor() {
    ThickMistUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k5t_1 = lazy(tmp_0, ThickMistUpgrade$_anonymous__2s4o8b);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_386(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ThickMistUpgrade';
  }
  hashCode() {
    return 277057351;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ThickMistUpgrade))
      return false;
    return true;
  }
}
class NightbindUpgrade {
  constructor() {
    NightbindUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l5t_1 = lazy(tmp_0, NightbindUpgrade$_anonymous__t1wj3k);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_387(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NightbindUpgrade';
  }
  hashCode() {
    return 509596876;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NightbindUpgrade))
      return false;
    return true;
  }
}
class CursedLandUpgrade {
  constructor() {
    CursedLandUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m5t_1 = lazy(tmp_0, CursedLandUpgrade$_anonymous__99ke5k);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_388(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CursedLandUpgrade';
  }
  hashCode() {
    return -2054502374;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CursedLandUpgrade))
      return false;
    return true;
  }
}
class Omma {
  constructor() {
    Omma_instance = this;
    this.n5t_1 = setOf_0([DistractionUpgrade_getInstance(), DoubleUpgrade_getInstance(), ThickMistUpgrade_getInstance(), NightbindUpgrade_getInstance(), CursedLandUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o5t_1 = lazy(tmp_0, Omma$_anonymous__iqznrv);
  }
  q36() {
    return EyeType_getInstance();
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Swamp_getInstance();
  }
  s36() {
    return setOf_0([DismemberCard_getInstance(), SummonEyeCard_getInstance(), SpookCard_getInstance(), MistShroudCard_getInstance()]);
  }
  t35() {
    return this.n5t_1;
  }
  v36($context_GameState_t6qee5, position) {
    return getInitList_1.call(this, $context_GameState_t6qee5, position);
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_389(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Omma';
  }
  hashCode() {
    return 607867959;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Omma))
      return false;
    return true;
  }
}
class PossibleMistShroudEffectSource {
  constructor() {
    PossibleMistShroudEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p5t_1 = lazy(tmp_0, PossibleMistShroudEffectSource$_anonymous__4i0dy4);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_390(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleMistShroudEffectSource';
  }
  hashCode() {
    return -23808064;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleMistShroudEffectSource))
      return false;
    return true;
  }
}
class PossibleSnareEffectSource {
  constructor() {
    PossibleSnareEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q5t_1 = lazy(tmp_0, PossibleSnareEffectSource$_anonymous__wlovcz);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_391(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleSnareEffectSource';
  }
  hashCode() {
    return -1099318993;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleSnareEffectSource))
      return false;
    return true;
  }
}
class Companion_427 {
  constructor() {
    Companion_instance_427 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r5t_1 = [lazy(tmp_0, SnareTypeQuestion$Companion$$childSerializers$_anonymous__y3ocr3)];
  }
}
class $serializer_366 {
  constructor() {
    $serializer_instance_362 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SnareTypeQuestion', this, 1);
    tmp0_serialDesc.h1b('variants', false);
    this.s5t_1 = tmp0_serialDesc;
  }
  t5t(encoder, value) {
    var tmp0_desc = this.s5t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_428().r5t_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.u5t_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t5t(encoder, value instanceof SnareTypeQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s5t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_428().r5t_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SnareTypeQuestion.v5t(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.s5t_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_428().r5t_1[0].k3()];
  }
}
class SnareTypeQuestion {
  constructor(variants) {
    Companion_getInstance_428();
    this.u5t_1 = variants;
  }
  s3o() {
    return this.u5t_1;
  }
  toString() {
    return 'SnareTypeQuestion(variants=' + this.u5t_1.toString() + ')';
  }
  hashCode() {
    return this.u5t_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SnareTypeQuestion))
      return false;
    if (!this.u5t_1.equals(other.u5t_1))
      return false;
    return true;
  }
  static v5t(seen0, variants, serializationConstructorMarker) {
    Companion_getInstance_428();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_362().s5t_1);
    }
    var $this = createThis(this);
    $this.u5t_1 = variants;
    return $this;
  }
}
class HunterItemToDiscardFromArsenalQuestionContext {
  constructor() {
    HunterItemToDiscardFromArsenalQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w5t_1 = lazy(tmp_0, HunterItemToDiscardFromArsenalQuestionContext$_anonymous__aec0dm);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_392(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterItemToDiscardFromArsenalQuestionContext';
  }
  hashCode() {
    return -377499128;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterItemToDiscardFromArsenalQuestionContext))
      return false;
    return true;
  }
}
class SnareLocationQuestionContext {
  constructor() {
    SnareLocationQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x5t_1 = lazy(tmp_0, SnareLocationQuestionContext$_anonymous__a4l9oc);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_393(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SnareLocationQuestionContext';
  }
  hashCode() {
    return 1544230240;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SnareLocationQuestionContext))
      return false;
    return true;
  }
}
class SnareTrapLocationQuestionContext {
  constructor() {
    SnareTrapLocationQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y5t_1 = lazy(tmp_0, SnareTrapLocationQuestionContext$_anonymous__ajjrqh);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_394(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SnareTrapLocationQuestionContext';
  }
  hashCode() {
    return -360259213;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SnareTrapLocationQuestionContext))
      return false;
    return true;
  }
}
class HunterTrappedBySnareQuestionContext {
  constructor() {
    HunterTrappedBySnareQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z5t_1 = lazy(tmp_0, HunterTrappedBySnareQuestionContext$_anonymous__1rst3i);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_395(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HunterTrappedBySnareQuestionContext';
  }
  hashCode() {
    return -461730972;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HunterTrappedBySnareQuestionContext))
      return false;
    return true;
  }
}
class SnareToReplaceQuestionContext {
  constructor() {
    SnareToReplaceQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a5u_1 = lazy(tmp_0, SnareToReplaceQuestionContext$_anonymous__e6akcy);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_396(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SnareToReplaceQuestionContext';
  }
  hashCode() {
    return -2136405884;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SnareToReplaceQuestionContext))
      return false;
    return true;
  }
}
class Companion_428 {
  constructor() {
    Companion_instance_428 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, ActivateSnareStatement$Companion$$childSerializers$_anonymous__5wm3up);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b5u_1 = [tmp_1, lazy(tmp_2, ActivateSnareStatement$Companion$$childSerializers$_anonymous__5wm3up_0)];
  }
}
class $serializer_367 {
  constructor() {
    $serializer_instance_363 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ActivateSnareStatement', this, 2);
    tmp0_serialDesc.h1b('hunter', false);
    tmp0_serialDesc.h1b('snare', false);
    this.c5u_1 = tmp0_serialDesc;
  }
  d5u(encoder, value) {
    var tmp0_desc = this.c5u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_429().b5u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.e5u_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.f5u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d5u(encoder, value instanceof ActivateSnareStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c5u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_429().b5u_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ActivateSnareStatement.g5u(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.c5u_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_429().b5u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class ActivateSnareStatement {
  constructor(hunter, snare) {
    Companion_getInstance_429();
    this.e5u_1 = hunter;
    this.f5u_1 = snare;
  }
  toString() {
    return 'ActivateSnareStatement(hunter=' + this.e5u_1.toString() + ', snare=' + this.f5u_1.toString() + ')';
  }
  hashCode() {
    var result = this.e5u_1.hashCode();
    result = imul(result, 31) + this.f5u_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ActivateSnareStatement))
      return false;
    if (!this.e5u_1.equals(other.e5u_1))
      return false;
    if (!this.f5u_1.equals(other.f5u_1))
      return false;
    return true;
  }
  static g5u(seen0, hunter, snare, serializationConstructorMarker) {
    Companion_getInstance_429();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_363().c5u_1);
    }
    var $this = createThis(this);
    $this.e5u_1 = hunter;
    $this.f5u_1 = snare;
    return $this;
  }
}
class Companion_429 {
  constructor() {
    Companion_instance_429 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, MistShroudReactionStatement$Companion$$childSerializers$_anonymous__auocse);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, MistShroudReactionStatement$Companion$$childSerializers$_anonymous__auocse_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h5u_1 = [tmp_1, tmp_3, lazy(tmp_4, MistShroudReactionStatement$Companion$$childSerializers$_anonymous__auocse_1)];
  }
}
class $serializer_368 {
  constructor() {
    $serializer_instance_364 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MistShroudReactionStatement', this, 3);
    tmp0_serialDesc.h1b('characterObject', false);
    tmp0_serialDesc.h1b('reactionCard', false);
    tmp0_serialDesc.h1b('cardToCopy', false);
    this.i5u_1 = tmp0_serialDesc;
  }
  j5u(encoder, value) {
    var tmp0_desc = this.i5u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_430().h5u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k5u_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.l5u_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.m5u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j5u(encoder, value instanceof MistShroudReactionStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i5u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_430().h5u_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return MistShroudReactionStatement.n5u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.i5u_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_430().h5u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class MistShroudReactionStatement {
  constructor(characterObject, reactionCard, cardToCopy) {
    Companion_getInstance_430();
    this.k5u_1 = characterObject;
    this.l5u_1 = reactionCard;
    this.m5u_1 = cardToCopy;
  }
  d2t() {
    return this.l5u_1;
  }
  toString() {
    return 'MistShroudReactionStatement(characterObject=' + this.k5u_1.toString() + ', reactionCard=' + this.l5u_1.toString() + ', cardToCopy=' + toString(this.m5u_1) + ')';
  }
  hashCode() {
    var result = this.k5u_1.hashCode();
    result = imul(result, 31) + this.l5u_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.m5u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MistShroudReactionStatement))
      return false;
    if (!this.k5u_1.equals(other.k5u_1))
      return false;
    if (!this.l5u_1.equals(other.l5u_1))
      return false;
    if (!equals(this.m5u_1, other.m5u_1))
      return false;
    return true;
  }
  static n5u(seen0, characterObject, reactionCard, cardToCopy, serializationConstructorMarker) {
    Companion_getInstance_430();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_364().i5u_1);
    }
    var $this = createThis(this);
    $this.k5u_1 = characterObject;
    $this.l5u_1 = reactionCard;
    $this.m5u_1 = cardToCopy;
    return $this;
  }
}
class Companion_430 {
  constructor() {
    Companion_instance_430 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o5u_1 = [lazy(tmp_0, DiscardHunterItemFromArsenalStatement$Companion$$childSerializers$_anonymous__gg0ei)];
  }
}
class $serializer_369 {
  constructor() {
    $serializer_instance_365 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DiscardHunterItemFromArsenalStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.p5u_1 = tmp0_serialDesc;
  }
  q5u(encoder, value) {
    var tmp0_desc = this.p5u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_431().o5u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r5u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q5u(encoder, value instanceof DiscardHunterItemFromArsenalStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p5u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_431().o5u_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DiscardHunterItemFromArsenalStatement.s5u(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.p5u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_431().o5u_1[0].k3()];
  }
}
class DiscardHunterItemFromArsenalStatement {
  constructor(beast) {
    Companion_getInstance_431();
    this.r5u_1 = beast;
  }
  o2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !get_hunterItems($context_GameStateRuntime_604ce3).d4n_1.n1();
  }
  toString() {
    return 'DiscardHunterItemFromArsenalStatement(beast=' + this.r5u_1.toString() + ')';
  }
  hashCode() {
    return this.r5u_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardHunterItemFromArsenalStatement))
      return false;
    if (!this.r5u_1.equals(other.r5u_1))
      return false;
    return true;
  }
  static s5u(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_431();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_365().p5u_1);
    }
    var $this = createThis(this);
    $this.r5u_1 = beast;
    return $this;
  }
}
class Companion_431 {
  constructor() {
    Companion_instance_431 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t5u_1 = [lazy(tmp_0, DismemberStatement$Companion$$childSerializers$_anonymous__by7hxf)];
  }
}
class $serializer_370 {
  constructor() {
    $serializer_instance_366 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DismemberStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.u5u_1 = tmp0_serialDesc;
  }
  v5u(encoder, value) {
    var tmp0_desc = this.u5u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_432().t5u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w5u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v5u(encoder, value instanceof DismemberStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u5u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_432().t5u_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DismemberStatement.x5u(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.u5u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_432().t5u_1[0].k3()];
  }
}
class DismemberStatement {
  constructor(beast) {
    Companion_getInstance_432();
    this.w5u_1 = beast;
  }
  n2o($context_GameStateRuntime_604ce3) {
    return (new AttackStatement(get_cardDamageSource(DismemberCard_getInstance()), this.w5u_1)).n2o($context_GameStateRuntime_604ce3);
  }
  toString() {
    return 'DismemberStatement(beast=' + this.w5u_1.toString() + ')';
  }
  hashCode() {
    return this.w5u_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DismemberStatement))
      return false;
    if (!this.w5u_1.equals(other.w5u_1))
      return false;
    return true;
  }
  static x5u(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_432();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_366().u5u_1);
    }
    var $this = createThis(this);
    $this.w5u_1 = beast;
    return $this;
  }
}
class Companion_432 {
  constructor() {
    Companion_instance_432 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y5u_1 = [lazy(tmp_0, HazeStatement$Companion$$childSerializers$_anonymous__fotfup)];
  }
}
class $serializer_371 {
  constructor() {
    $serializer_instance_367 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HazeStatement', this, 1);
    tmp0_serialDesc.h1b('actor', false);
    this.z5u_1 = tmp0_serialDesc;
  }
  a5v(encoder, value) {
    var tmp0_desc = this.z5u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_433().y5u_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.b5v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a5v(encoder, value instanceof HazeStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z5u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_433().y5u_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return HazeStatement.c5v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.z5u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_433().y5u_1[0].k3()];
  }
}
class HazeStatement {
  constructor(actor) {
    Companion_getInstance_433();
    this.b5v_1 = actor;
  }
  toString() {
    return 'HazeStatement(actor=' + this.b5v_1.toString() + ')';
  }
  hashCode() {
    return this.b5v_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HazeStatement))
      return false;
    if (!this.b5v_1.equals(other.b5v_1))
      return false;
    return true;
  }
  static c5v(seen0, actor, serializationConstructorMarker) {
    Companion_getInstance_433();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_367().z5u_1);
    }
    var $this = createThis(this);
    $this.b5v_1 = actor;
    return $this;
  }
}
class Companion_433 {
  constructor() {
    Companion_instance_433 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d5v_1 = [lazy(tmp_0, PlaceSnareStatement$Companion$$childSerializers$_anonymous__g3nn4j)];
  }
}
class $serializer_372 {
  constructor() {
    $serializer_instance_368 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceSnareStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.e5v_1 = tmp0_serialDesc;
  }
  f5v(encoder, value) {
    var tmp0_desc = this.e5v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_434().d5v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g5v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f5v(encoder, value instanceof PlaceSnareStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e5v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_434().d5v_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlaceSnareStatement.h5v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e5v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_434().d5v_1[0].k3()];
  }
}
class PlaceSnareStatement {
  constructor(beast) {
    Companion_getInstance_434();
    this.g5v_1 = beast;
  }
  toString() {
    return 'PlaceSnareStatement(beast=' + this.g5v_1.toString() + ')';
  }
  hashCode() {
    return this.g5v_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceSnareStatement))
      return false;
    if (!this.g5v_1.equals(other.g5v_1))
      return false;
    return true;
  }
  static h5v(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_434();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_368().e5v_1);
    }
    var $this = createThis(this);
    $this.g5v_1 = beast;
    return $this;
  }
}
class SnareTokenType {
  constructor() {
    SnareTokenType_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i5v_1 = lazy(tmp_0, SnareTokenType$_anonymous__8p5i5);
  }
  n2z($context_GameState_t6qee5) {
    return 1;
  }
  v36($context_GameState_t6qee5, position) {
    return plus_2(getInitList.call(this, $context_GameState_t6qee5, position), listOf_0([init(get_snareTypeKey(), new SnareTypeWrapper(SnareType_Animate_getInstance())), init(get_trapPositionsKey(), new BoardPositionSetWrapper(emptySet()))]));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_397(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SnareTokenType';
  }
  hashCode() {
    return 1005969599;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SnareTokenType))
      return false;
    return true;
  }
}
class Companion_434 {
  constructor() {
    Companion_instance_434 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j5v_1 = [lazy(tmp_0, SetEyeHazeStatusChangeEvent$Companion$$childSerializers$_anonymous__c3qwyj)];
  }
}
class $serializer_373 {
  constructor() {
    $serializer_instance_369 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetEyeHazeStatusChangeEvent', this, 1);
    tmp0_serialDesc.h1b('newStatuses', false);
    this.k5v_1 = tmp0_serialDesc;
  }
  l5v(encoder, value) {
    var tmp0_desc = this.k5v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_435().j5v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.m5v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l5v(encoder, value instanceof SetEyeHazeStatusChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k5v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_435().j5v_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SetEyeHazeStatusChangeEvent.n5v(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.k5v_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_435().j5v_1[0].k3()];
  }
}
class SetEyeHazeStatusChangeEvent {
  constructor(newStatuses) {
    Companion_getInstance_435();
    this.m5v_1 = newStatuses;
  }
  m37(_this__u8e3s4) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.m5v_1.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var eye = element.j3();
      // Inline function 'kotlin.collections.component2' call
      var isHazed = element.k3();
      set_isHazedImpl(_this__u8e3s4, eye, isHazed);
    }
  }
  n37($context_GameState_t6qee5) {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = this.m5v_1.x4();
    var result = LinkedHashMap.cd(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$2 = get_isHazed($context_GameState_t6qee5, element);
      result.b5(element, tmp$ret$2);
    }
    return new SetEyeHazeStatusChangeEvent(result);
  }
  toString() {
    return 'SetEyeHazeStatusChangeEvent(newStatuses=' + toString(this.m5v_1) + ')';
  }
  hashCode() {
    return hashCode(this.m5v_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetEyeHazeStatusChangeEvent))
      return false;
    if (!equals(this.m5v_1, other.m5v_1))
      return false;
    return true;
  }
  static n5v(seen0, newStatuses, serializationConstructorMarker) {
    Companion_getInstance_435();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_369().k5v_1);
    }
    var $this = createThis(this);
    $this.m5v_1 = newStatuses;
    return $this;
  }
}
class Companion_435 {
  constructor() {
    Companion_instance_435 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, SetSnareMetadataChangeEvent$Companion$$childSerializers$_anonymous__ubhx9i);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, SetSnareMetadataChangeEvent$Companion$$childSerializers$_anonymous__ubhx9i_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o5v_1 = [tmp_1, tmp_3, lazy(tmp_4, SetSnareMetadataChangeEvent$Companion$$childSerializers$_anonymous__ubhx9i_1)];
  }
}
class $serializer_374 {
  constructor() {
    $serializer_instance_370 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetSnareMetadataChangeEvent', this, 3);
    tmp0_serialDesc.h1b('snare', false);
    tmp0_serialDesc.h1b('newSnareType', false);
    tmp0_serialDesc.h1b('newTrapPositions', false);
    this.p5v_1 = tmp0_serialDesc;
  }
  q5v(encoder, value) {
    var tmp0_desc = this.p5v_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_436().o5v_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r5v_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.s5v_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.t5v_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q5v(encoder, value instanceof SetSnareMetadataChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p5v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_436().o5v_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, tmp8_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return SetSnareMetadataChangeEvent.u5v(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.p5v_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_436().o5v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3(), tmp0_cached[2].k3()];
  }
}
class SetSnareMetadataChangeEvent {
  constructor(snare, newSnareType, newTrapPositions) {
    Companion_getInstance_436();
    this.r5v_1 = snare;
    this.s5v_1 = newSnareType;
    this.t5v_1 = newTrapPositions;
  }
  m37(_this__u8e3s4) {
    set_snareTypeImpl(_this__u8e3s4, this.r5v_1, this.s5v_1);
    set_trapPositionsImpl(_this__u8e3s4, this.r5v_1, toSet(this.t5v_1));
  }
  n37($context_GameState_t6qee5) {
    return new SetSnareMetadataChangeEvent(this.r5v_1, get_snareType($context_GameState_t6qee5, this.r5v_1), get_trapPositions($context_GameState_t6qee5, this.r5v_1));
  }
  toString() {
    return 'SetSnareMetadataChangeEvent(snare=' + this.r5v_1.toString() + ', newSnareType=' + this.s5v_1.toString() + ', newTrapPositions=' + toString(this.t5v_1) + ')';
  }
  hashCode() {
    var result = this.r5v_1.hashCode();
    result = imul(result, 31) + this.s5v_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.t5v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetSnareMetadataChangeEvent))
      return false;
    if (!this.r5v_1.equals(other.r5v_1))
      return false;
    if (!this.s5v_1.equals(other.s5v_1))
      return false;
    if (!equals(this.t5v_1, other.t5v_1))
      return false;
    return true;
  }
  static u5v(seen0, snare, newSnareType, newTrapPositions, serializationConstructorMarker) {
    Companion_getInstance_436();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_370().p5v_1);
    }
    var $this = createThis(this);
    $this.r5v_1 = snare;
    $this.s5v_1 = newSnareType;
    $this.t5v_1 = newTrapPositions;
    return $this;
  }
}
class EyeType {
  constructor() {
    EyeType_instance = this;
    this.v5v_1 = Omma_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w5v_1 = lazy(tmp_0, EyeType$_anonymous__u19uno);
  }
  r37() {
    return this.v5v_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_398(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EyeType';
  }
  hashCode() {
    return 1463038630;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EyeType))
      return false;
    return true;
  }
}
class DismemberCard {
  constructor() {
    DismemberCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x5v_1 = lazy(tmp_0, DismemberCard$_anonymous__uvvghr);
  }
  t37() {
    return Omma_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_399(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DismemberCard';
  }
  hashCode() {
    return 1110609203;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DismemberCard))
      return false;
    return true;
  }
}
class SpookCard {
  constructor() {
    SpookCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y5v_1 = lazy(tmp_0, SpookCard$_anonymous__gbskkn);
  }
  t37() {
    return Omma_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_400(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SpookCard';
  }
  hashCode() {
    return 234687001;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpookCard))
      return false;
    return true;
  }
}
class SummonEyeCard {
  constructor() {
    SummonEyeCard_instance = this;
    this.z5v_1 = Omma_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a5w_1 = lazy(tmp_0, SummonEyeCard$_anonymous__i67n87);
  }
  t37() {
    return this.z5v_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_401(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonEyeCard';
  }
  hashCode() {
    return 1891239451;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonEyeCard))
      return false;
    return true;
  }
}
class MistShroudCard {
  constructor() {
    MistShroudCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b5w_1 = lazy(tmp_0, MistShroudCard$_anonymous__m5okq1);
  }
  t37() {
    return Omma_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_402(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'MistShroudCard';
  }
  hashCode() {
    return -1969306893;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MistShroudCard))
      return false;
    return true;
  }
}
class Companion_436 {
  constructor() {
    Companion_instance_436 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u5e_1 = lazy(tmp_0, SnareType$Companion$_anonymous__17a604);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_403(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class SnareType extends Enum {}
class Companion_437 {}
class $serializer_375 {
  constructor() {
    $serializer_instance_371 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PactLongForgottenContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.c5w_1 = tmp0_serialDesc;
  }
  d5w(encoder, value) {
    var tmp0_desc = this.c5w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.f5w_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.g5w_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 2, value.g5w_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.h5w_1 === 2)) {
      tmp1_output.z14(tmp0_desc, 3, value.h5w_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.i5w_1.equals(Companion_getInstance_220().x39_1)) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.i5w_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d5w(encoder, value instanceof PactLongForgottenContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c5w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return PactLongForgottenContract.j5w(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.c5w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class PactLongForgottenContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.k5w(rulesParameters);
  }
  static k5w(rulesParameters) {
    var $this = this.b3a();
    $this.f5w_1 = rulesParameters;
    $this.g5w_1 = 3;
    $this.h5w_1 = 2;
    $this.i5w_1 = Companion_getInstance_220().x39_1;
    return $this;
  }
  c3a() {
    return this.f5w_1;
  }
  static l5w(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    balanceVersion = balanceVersion === VOID ? Companion_getInstance_217().e3a_1 : balanceVersion;
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().x39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.k5w(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(1, 1);
  }
  h3a() {
    return GameMapId_LowerShatteredIsles_getInstance();
  }
  i3a() {
    return this.g5w_1;
  }
  j3a() {
    return 1;
  }
  k3a() {
    return 3;
  }
  l3a() {
    return this.h5w_1;
  }
  m3a() {
    return PactLongForgottenInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_isTwoSheepOrTigerCompleted_0($context_GameState_t6qee5));
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredExpectedOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) > 0, ruinsControlled_0($context_GameState_t6qee5, get_huntersGameTeam()) >= 2);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      var tmp0 = get_destroyedObjects($context_GameState_t6qee5);
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.n1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var tmp_1 = get_objectType($context_GameState_t6qee5, element);
          if (isInterface(tmp_1, SettlerType)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp$ret$0);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) >= 2);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.i5w_1;
  }
  v3a(rulesParameters) {
    return PactLongForgottenContract.k5w(rulesParameters);
  }
  toString() {
    return 'PactLongForgottenContract(rulesParameters=' + this.f5w_1.toString() + ')';
  }
  hashCode() {
    return this.f5w_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PactLongForgottenContract))
      return false;
    if (!this.f5w_1.equals(other.f5w_1))
      return false;
    return true;
  }
  static j5w(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_371().c5w_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.f5w_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.g5w_1 = 3;
    else
      $this.g5w_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.h5w_1 = 2;
    else
      $this.h5w_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.i5w_1 = Companion_getInstance_220().x39_1;
    else
      $this.i5w_1 = requiredVersion;
    return $this;
  }
}
class PactLongForgottenInitialPhase {
  constructor() {
    PactLongForgottenInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m5w_1 = lazy(tmp_0, PactLongForgottenInitialPhase$_anonymous__ctxqn0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_404(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PactLongForgottenInitialPhase';
  }
  hashCode() {
    return -2134133234;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PactLongForgottenInitialPhase))
      return false;
    return true;
  }
}
class Companion_438 {
  a2g() {
    var tmp = getKClass(PlayableInTurnCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Ruin1), getKClass(Ruin10), getKClass(Ruin11), getKClass(Ruin12), getKClass(Ruin2), getKClass(Ruin3), getKClass(Ruin4), getKClass(Ruin5), getKClass(Ruin6), getKClass(Ruin7), getKClass(Ruin8), getKClass(Ruin9), getKClass(AcclivityCard), getKClass(BeastlyTongueCard), getKClass(ConsumeCard), getKClass(CorruptCard), getKClass(DeceiveCard), getKClass(DefileCard), getKClass(DismemberCard), getKClass(EngorgeCard), getKClass(FeedCard), getKClass(FlickerCard), getKClass(FloodCard), getKClass(GatherThePackCard), getKClass(HydraCard), getKClass(LeapCard), getKClass(LurkCard), getKClass(BoltAndRecallCard), getKClass(SoulReapCard), getKClass(SummonYeltrCard), getKClass(ToothAndSeverCard), getKClass(MurderCard), getKClass(ObscureTalentCard), getKClass(OverloadedStormCard), getKClass(PreyUponCard), getKClass(RambleCard), getKClass(IncinerateCard), getKClass(RiseCard), getKClass(ScorchedEarthCard), getKClass(SummonLindwyrmCard), getKClass(ShadowStepCard), getKClass(SlitherCard), getKClass(SpookCard), getKClass(StalkCard), getKClass(StampedeCard), getKClass(StormCard), getKClass(SummonBasiliskCard), getKClass(SummonChangelingCard), getKClass(SummonDreamerCard), getKClass(SummonEyeCard), getKClass(SummonPolypCard), getKClass(SummonWarhogCard), getKClass(SummonWolfCard), getKClass(SummonYagiCard), getKClass(SummonEyeCard), getKClass(TuskCard), getKClass(UnburdenCard), getKClass(UnwillingSacrificeCard), getKClass(UpriseCard), getKClass(NestCard), getKClass(OverloadedNestCard), getKClass(OvipunctureCard), getKClass(SilkCard), getKClass(SummonEggCard), getKClass(AllureCard), getKClass(BeholdCard), getKClass(EludeCard), getKClass(SummonAdmirerCard), getKClass(VoidCard), getKClass(AdaptCard), getKClass(AnimateCard), getKClass(AvariceCard), getKClass(BolsterCard), getKClass(ChargeCard), getKClass(DashCard), getKClass(DisplaceCard), getKClass(DarkDealingsCard), getKClass(DarkOfferingsCard), getKClass(DarkRitualsCard), getKClass(EnsnareCard), getKClass(GlimpseCard), getKClass(HasteCard), getKClass(HiddenPassageCard), getKClass(InciteCard), getKClass(ProwlCard), getKClass(PursuitCard), getKClass(RushCard), getKClass(StrideCard), getKClass(UnearthCard), getKClass(UnknownDraftActionCard), getKClass(AviationCard), getKClass(BerserkCard), getKClass(CleaverCard), getKClass(CommandCard), getKClass(DelegateCard), getKClass(FlameRapierCard), getKClass(GrapplingHookCard), getKClass(HerdCard), getKClass(BindingHuntCard), getKClass(BloodHuntCard), getKClass(HuntCard), getKClass(TraitorsHuntCard), getKClass(IncisionCard), getKClass(MountCard), getKClass(OverloadedFlameRapierCard), getKClass(ScoutCard), getKClass(SeerCard), getKClass(BondedTrackCard), getKClass(ScroungeCard), getKClass(TraitorsHuntCard), getKClass(SilverArrowCard), getKClass(BloodTrackCard), getKClass(BondedTrackCard), getKClass(TrackCard), getKClass(TrapmasterCard), getKClass(UnnaturalResolveCard), getKClass(WardCard), getKClass(OverloadedFlameRapierCard), getKClass(OverloadedFuryCard), getKClass(OverloadedNestCard), getKClass(OverloadedShatterCard), getKClass(OverloadedStormCard), getKClass(AbruptDecayCard), getKClass(BrutalityCard), getKClass(DisappearCard), getKClass(DisperseCard), getKClass(EvolveCard), getKClass(FeastCard), getKClass(FlourishCard), getKClass(FuryCard), getKClass(HatredCard), getKClass(InsidiousGrowthCard), getKClass(MirrorStepCard), getKClass(OverloadedFuryCard), getKClass(OverloadedShatterCard), getKClass(RageCard), getKClass(RecoveryTestBeastCard), getKClass(RoamCard), getKClass(ShatterCard), getKClass(SprawlCard), getKClass(StrangeSummonsCard), getKClass(SwarmCard), getKClass(UnbendingWillCard), getKClass(AurorasPassage), getKClass(BansheesLureCard), getKClass(BladeOfValhCard), getKClass(ChainGrapnelCard), getKClass(ExpeditionMapCard), getKClass(GrapeshotCard), getKClass(HuntersBellCard), getKClass(HuntersPassageCard), getKClass(HuntersRestCard), getKClass(OutpostCard), getKClass(RecoveryTestHunterCard), getKClass(SacredRichesCard), getKClass(SpyglassCard), getKClass(FireTrapCard), getKClass(HexingTrapCard), getKClass(RitualTrapCard), getKClass(ShriekerTrapCard), getKClass(WarhogsTuskCard), getKClass(WolfsbaneCard)];
    var tmp_1 = Ruin1_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Ruin1', tmp_1, tmp$ret$3);
    var tmp_3 = Ruin10_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('Ruin10', tmp_3, tmp$ret$6);
    var tmp_5 = Ruin11_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('Ruin11', tmp_5, tmp$ret$9);
    var tmp_7 = Ruin12_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Ruin12', tmp_7, tmp$ret$12);
    var tmp_9 = Ruin2_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('Ruin2', tmp_9, tmp$ret$15);
    var tmp_11 = Ruin3_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('Ruin3', tmp_11, tmp$ret$18);
    var tmp_13 = Ruin4_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('Ruin4', tmp_13, tmp$ret$21);
    var tmp_15 = Ruin5_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('Ruin5', tmp_15, tmp$ret$24);
    var tmp_17 = Ruin6_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('Ruin6', tmp_17, tmp$ret$27);
    var tmp_19 = Ruin7_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('Ruin7', tmp_19, tmp$ret$30);
    var tmp_21 = Ruin8_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('Ruin8', tmp_21, tmp$ret$33);
    var tmp_23 = Ruin9_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('Ruin9', tmp_23, tmp$ret$36);
    var tmp_25 = AcclivityCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('AcclivityCard', tmp_25, tmp$ret$39);
    var tmp_27 = BeastlyTongueCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('BeastlyTongueCard', tmp_27, tmp$ret$42);
    var tmp_29 = ConsumeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('ConsumeCard', tmp_29, tmp$ret$45);
    var tmp_31 = CorruptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('CorruptCard', tmp_31, tmp$ret$48);
    var tmp_33 = DeceiveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('DeceiveCard', tmp_33, tmp$ret$51);
    var tmp_35 = DefileCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_36 = ObjectSerializer.l1c('DefileCard', tmp_35, tmp$ret$54);
    var tmp_37 = DismemberCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_38 = ObjectSerializer.l1c('DismemberCard', tmp_37, tmp$ret$57);
    var tmp_39 = EngorgeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_40 = ObjectSerializer.l1c('EngorgeCard', tmp_39, tmp$ret$60);
    var tmp_41 = FeedCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_42 = ObjectSerializer.l1c('FeedCard', tmp_41, tmp$ret$63);
    var tmp_43 = FlickerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_44 = ObjectSerializer.l1c('FlickerCard', tmp_43, tmp$ret$66);
    var tmp_45 = FloodCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_46 = ObjectSerializer.l1c('FloodCard', tmp_45, tmp$ret$69);
    var tmp_47 = GatherThePackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_48 = ObjectSerializer.l1c('GatherThePackCard', tmp_47, tmp$ret$72);
    var tmp_49 = HydraCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_50 = ObjectSerializer.l1c('HydraCard', tmp_49, tmp$ret$75);
    var tmp_51 = LeapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_52 = ObjectSerializer.l1c('LeapCard', tmp_51, tmp$ret$78);
    var tmp_53 = LurkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_54 = ObjectSerializer.l1c('LurkCard', tmp_53, tmp$ret$81);
    var tmp_55 = BoltAndRecallCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_56 = ObjectSerializer.l1c('BoltAndRecallCard', tmp_55, tmp$ret$84);
    var tmp_57 = SoulReapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_58 = ObjectSerializer.l1c('SoulReapCard', tmp_57, tmp$ret$87);
    var tmp_59 = SummonYeltrCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_60 = ObjectSerializer.l1c('SummonYeltrCard', tmp_59, tmp$ret$90);
    var tmp_61 = ToothAndSeverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_62 = ObjectSerializer.l1c('ToothAndSeverCard', tmp_61, tmp$ret$93);
    var tmp_63 = MurderCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_64 = ObjectSerializer.l1c('MurderCard', tmp_63, tmp$ret$96);
    var tmp_65 = ObscureTalentCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_66 = ObjectSerializer.l1c('ObscureTalentCard', tmp_65, tmp$ret$99);
    var tmp_67 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_68 = ObjectSerializer.l1c('OverloadedStormCard', tmp_67, tmp$ret$102);
    var tmp_69 = PreyUponCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_70 = ObjectSerializer.l1c('PreyUponCard', tmp_69, tmp$ret$105);
    var tmp_71 = RambleCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_72 = ObjectSerializer.l1c('RambleCard', tmp_71, tmp$ret$108);
    var tmp_73 = IncinerateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_74 = ObjectSerializer.l1c('IncinerateCard', tmp_73, tmp$ret$111);
    var tmp_75 = RiseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_76 = ObjectSerializer.l1c('RiseCard', tmp_75, tmp$ret$114);
    var tmp_77 = ScorchedEarthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_78 = ObjectSerializer.l1c('ScorchedEarthCard', tmp_77, tmp$ret$117);
    var tmp_79 = SummonLindwyrmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_80 = ObjectSerializer.l1c('SummonLindwyrmCard', tmp_79, tmp$ret$120);
    var tmp_81 = ShadowStepCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_82 = ObjectSerializer.l1c('ShadowStepCard', tmp_81, tmp$ret$123);
    var tmp_83 = SlitherCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_84 = ObjectSerializer.l1c('SlitherCard', tmp_83, tmp$ret$126);
    var tmp_85 = SpookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_86 = ObjectSerializer.l1c('SpookCard', tmp_85, tmp$ret$129);
    var tmp_87 = StalkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_88 = ObjectSerializer.l1c('StalkCard', tmp_87, tmp$ret$132);
    var tmp_89 = StampedeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_90 = ObjectSerializer.l1c('StampedeCard', tmp_89, tmp$ret$135);
    var tmp_91 = StormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    var tmp_92 = ObjectSerializer.l1c('StormCard', tmp_91, tmp$ret$138);
    var tmp_93 = SummonBasiliskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$141 = [];
    var tmp_94 = ObjectSerializer.l1c('SummonBasiliskCard', tmp_93, tmp$ret$141);
    var tmp_95 = SummonChangelingCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    var tmp_96 = ObjectSerializer.l1c('SummonChangelingCard', tmp_95, tmp$ret$144);
    var tmp_97 = SummonDreamerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$147 = [];
    var tmp_98 = ObjectSerializer.l1c('SummonDreamerCard', tmp_97, tmp$ret$147);
    var tmp_99 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$150 = [];
    var tmp_100 = ObjectSerializer.l1c('SummonEyeCard', tmp_99, tmp$ret$150);
    var tmp_101 = SummonPolypCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$153 = [];
    var tmp_102 = ObjectSerializer.l1c('SummonPolypCard', tmp_101, tmp$ret$153);
    var tmp_103 = SummonWarhogCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$156 = [];
    var tmp_104 = ObjectSerializer.l1c('SummonWarhogCard', tmp_103, tmp$ret$156);
    var tmp_105 = SummonWolfCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$159 = [];
    var tmp_106 = ObjectSerializer.l1c('SummonWolfCard', tmp_105, tmp$ret$159);
    var tmp_107 = SummonYagiCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$162 = [];
    var tmp_108 = ObjectSerializer.l1c('SummonYagiCard', tmp_107, tmp$ret$162);
    var tmp_109 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$165 = [];
    var tmp_110 = ObjectSerializer.l1c('SummonEyeCard', tmp_109, tmp$ret$165);
    var tmp_111 = TuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$168 = [];
    var tmp_112 = ObjectSerializer.l1c('TuskCard', tmp_111, tmp$ret$168);
    var tmp_113 = UnburdenCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$171 = [];
    var tmp_114 = ObjectSerializer.l1c('UnburdenCard', tmp_113, tmp$ret$171);
    var tmp_115 = UnwillingSacrificeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$174 = [];
    var tmp_116 = ObjectSerializer.l1c('UnwillingSacrificeCard', tmp_115, tmp$ret$174);
    var tmp_117 = UpriseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$177 = [];
    var tmp_118 = ObjectSerializer.l1c('UpriseCard', tmp_117, tmp$ret$177);
    var tmp_119 = NestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$180 = [];
    var tmp_120 = ObjectSerializer.l1c('NestCard', tmp_119, tmp$ret$180);
    var tmp_121 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$183 = [];
    var tmp_122 = ObjectSerializer.l1c('OverloadedNestCard', tmp_121, tmp$ret$183);
    var tmp_123 = OvipunctureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$186 = [];
    var tmp_124 = ObjectSerializer.l1c('OvipunctureCard', tmp_123, tmp$ret$186);
    var tmp_125 = SilkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$189 = [];
    var tmp_126 = ObjectSerializer.l1c('SilkCard', tmp_125, tmp$ret$189);
    var tmp_127 = SummonEggCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$192 = [];
    var tmp_128 = ObjectSerializer.l1c('SummonEggCard', tmp_127, tmp$ret$192);
    var tmp_129 = AllureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$195 = [];
    var tmp_130 = ObjectSerializer.l1c('AllureCard', tmp_129, tmp$ret$195);
    var tmp_131 = BeholdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$198 = [];
    var tmp_132 = ObjectSerializer.l1c('BeholdCard', tmp_131, tmp$ret$198);
    var tmp_133 = EludeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$201 = [];
    var tmp_134 = ObjectSerializer.l1c('EludeCard', tmp_133, tmp$ret$201);
    var tmp_135 = SummonAdmirerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$204 = [];
    var tmp_136 = ObjectSerializer.l1c('SummonAdmirerCard', tmp_135, tmp$ret$204);
    var tmp_137 = VoidCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$207 = [];
    var tmp_138 = ObjectSerializer.l1c('VoidCard', tmp_137, tmp$ret$207);
    var tmp_139 = AdaptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$210 = [];
    var tmp_140 = ObjectSerializer.l1c('AdaptCard', tmp_139, tmp$ret$210);
    var tmp_141 = AnimateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$213 = [];
    var tmp_142 = ObjectSerializer.l1c('AnimateCard', tmp_141, tmp$ret$213);
    var tmp_143 = AvariceCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$216 = [];
    var tmp_144 = ObjectSerializer.l1c('AvariceCard', tmp_143, tmp$ret$216);
    var tmp_145 = BolsterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$219 = [];
    var tmp_146 = ObjectSerializer.l1c('BolsterCard', tmp_145, tmp$ret$219);
    var tmp_147 = ChargeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$222 = [];
    var tmp_148 = ObjectSerializer.l1c('ChargeCard', tmp_147, tmp$ret$222);
    var tmp_149 = DashCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$225 = [];
    var tmp_150 = ObjectSerializer.l1c('DashCard', tmp_149, tmp$ret$225);
    var tmp_151 = DisplaceCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$228 = [];
    var tmp_152 = ObjectSerializer.l1c('DisplaceCard', tmp_151, tmp$ret$228);
    var tmp_153 = DarkDealingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$231 = [];
    var tmp_154 = ObjectSerializer.l1c('DarkDealingsCard', tmp_153, tmp$ret$231);
    var tmp_155 = DarkOfferingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$234 = [];
    var tmp_156 = ObjectSerializer.l1c('DarkOfferingsCard', tmp_155, tmp$ret$234);
    var tmp_157 = DarkRitualsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$237 = [];
    var tmp_158 = ObjectSerializer.l1c('DarkRitualsCard', tmp_157, tmp$ret$237);
    var tmp_159 = EnsnareCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$240 = [];
    var tmp_160 = ObjectSerializer.l1c('EnsnareCard', tmp_159, tmp$ret$240);
    var tmp_161 = GlimpseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$243 = [];
    var tmp_162 = ObjectSerializer.l1c('GlimpseCard', tmp_161, tmp$ret$243);
    var tmp_163 = HasteCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$246 = [];
    var tmp_164 = ObjectSerializer.l1c('HasteCard', tmp_163, tmp$ret$246);
    var tmp_165 = HiddenPassageCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$249 = [];
    var tmp_166 = ObjectSerializer.l1c('HiddenPassageCard', tmp_165, tmp$ret$249);
    var tmp_167 = InciteCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$252 = [];
    var tmp_168 = ObjectSerializer.l1c('InciteCard', tmp_167, tmp$ret$252);
    var tmp_169 = ProwlCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$255 = [];
    var tmp_170 = ObjectSerializer.l1c('ProwlCard', tmp_169, tmp$ret$255);
    var tmp_171 = PursuitCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$258 = [];
    var tmp_172 = ObjectSerializer.l1c('PursuitCard', tmp_171, tmp$ret$258);
    var tmp_173 = RushCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$261 = [];
    var tmp_174 = ObjectSerializer.l1c('RushCard', tmp_173, tmp$ret$261);
    var tmp_175 = StrideCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$264 = [];
    var tmp_176 = ObjectSerializer.l1c('StrideCard', tmp_175, tmp$ret$264);
    var tmp_177 = UnearthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$267 = [];
    var tmp_178 = ObjectSerializer.l1c('UnearthCard', tmp_177, tmp$ret$267);
    var tmp_179 = $serializer_getInstance_127();
    var tmp_180 = AviationCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$270 = [];
    var tmp_181 = ObjectSerializer.l1c('AviationCard', tmp_180, tmp$ret$270);
    var tmp_182 = BerserkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$273 = [];
    var tmp_183 = ObjectSerializer.l1c('BerserkCard', tmp_182, tmp$ret$273);
    var tmp_184 = CleaverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$276 = [];
    var tmp_185 = ObjectSerializer.l1c('CleaverCard', tmp_184, tmp$ret$276);
    var tmp_186 = CommandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$279 = [];
    var tmp_187 = ObjectSerializer.l1c('CommandCard', tmp_186, tmp$ret$279);
    var tmp_188 = DelegateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$282 = [];
    var tmp_189 = ObjectSerializer.l1c('DelegateCard', tmp_188, tmp$ret$282);
    var tmp_190 = FlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$285 = [];
    var tmp_191 = ObjectSerializer.l1c('FlameRapierCard', tmp_190, tmp$ret$285);
    var tmp_192 = GrapplingHookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$288 = [];
    var tmp_193 = ObjectSerializer.l1c('GrapplingHookCard', tmp_192, tmp$ret$288);
    var tmp_194 = HerdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$291 = [];
    var tmp_195 = ObjectSerializer.l1c('HerdCard', tmp_194, tmp$ret$291);
    var tmp_196 = BindingHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$294 = [];
    var tmp_197 = ObjectSerializer.l1c('BindingHuntCard', tmp_196, tmp$ret$294);
    var tmp_198 = BloodHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$297 = [];
    var tmp_199 = ObjectSerializer.l1c('BloodHuntCard', tmp_198, tmp$ret$297);
    var tmp_200 = $serializer_getInstance_327();
    var tmp_201 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$300 = [];
    var tmp_202 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_201, tmp$ret$300);
    var tmp_203 = IncisionCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$303 = [];
    var tmp_204 = ObjectSerializer.l1c('IncisionCard', tmp_203, tmp$ret$303);
    var tmp_205 = MountCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$306 = [];
    var tmp_206 = ObjectSerializer.l1c('MountCard', tmp_205, tmp$ret$306);
    var tmp_207 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$309 = [];
    var tmp_208 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_207, tmp$ret$309);
    var tmp_209 = ScoutCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$312 = [];
    var tmp_210 = ObjectSerializer.l1c('ScoutCard', tmp_209, tmp$ret$312);
    var tmp_211 = SeerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$315 = [];
    var tmp_212 = ObjectSerializer.l1c('SeerCard', tmp_211, tmp$ret$315);
    var tmp_213 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$318 = [];
    var tmp_214 = ObjectSerializer.l1c('BondedTrackCard', tmp_213, tmp$ret$318);
    var tmp_215 = ScroungeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$321 = [];
    var tmp_216 = ObjectSerializer.l1c('ScroungeCard', tmp_215, tmp$ret$321);
    var tmp_217 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$324 = [];
    var tmp_218 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_217, tmp$ret$324);
    var tmp_219 = SilverArrowCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$327 = [];
    var tmp_220 = ObjectSerializer.l1c('SilverArrowCard', tmp_219, tmp$ret$327);
    var tmp_221 = BloodTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$330 = [];
    var tmp_222 = ObjectSerializer.l1c('BloodTrackCard', tmp_221, tmp$ret$330);
    var tmp_223 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$333 = [];
    var tmp_224 = ObjectSerializer.l1c('BondedTrackCard', tmp_223, tmp$ret$333);
    var tmp_225 = $serializer_getInstance_326();
    var tmp_226 = TrapmasterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$336 = [];
    var tmp_227 = ObjectSerializer.l1c('TrapmasterCard', tmp_226, tmp$ret$336);
    var tmp_228 = UnnaturalResolveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$339 = [];
    var tmp_229 = ObjectSerializer.l1c('UnnaturalResolveCard', tmp_228, tmp$ret$339);
    var tmp_230 = WardCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$342 = [];
    var tmp_231 = ObjectSerializer.l1c('WardCard', tmp_230, tmp$ret$342);
    var tmp_232 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$345 = [];
    var tmp_233 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_232, tmp$ret$345);
    var tmp_234 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$348 = [];
    var tmp_235 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_234, tmp$ret$348);
    var tmp_236 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$351 = [];
    var tmp_237 = ObjectSerializer.l1c('OverloadedNestCard', tmp_236, tmp$ret$351);
    var tmp_238 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$354 = [];
    var tmp_239 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_238, tmp$ret$354);
    var tmp_240 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$357 = [];
    var tmp_241 = ObjectSerializer.l1c('OverloadedStormCard', tmp_240, tmp$ret$357);
    var tmp_242 = AbruptDecayCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$360 = [];
    var tmp_243 = ObjectSerializer.l1c('AbruptDecayCard', tmp_242, tmp$ret$360);
    var tmp_244 = $serializer_getInstance_88();
    var tmp_245 = DisappearCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$363 = [];
    var tmp_246 = ObjectSerializer.l1c('DisappearCard', tmp_245, tmp$ret$363);
    var tmp_247 = $serializer_getInstance_92();
    var tmp_248 = $serializer_getInstance_86();
    var tmp_249 = $serializer_getInstance_96();
    var tmp_250 = $serializer_getInstance_97();
    var tmp_251 = FuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$366 = [];
    var tmp_252 = ObjectSerializer.l1c('FuryCard', tmp_251, tmp$ret$366);
    var tmp_253 = $serializer_getInstance_91();
    var tmp_254 = $serializer_getInstance_93();
    var tmp_255 = $serializer_getInstance_98();
    var tmp_256 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$369 = [];
    var tmp_257 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_256, tmp$ret$369);
    var tmp_258 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$372 = [];
    var tmp_259 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_258, tmp$ret$372);
    var tmp_260 = $serializer_getInstance_89();
    var tmp_261 = $serializer_getInstance_378();
    var tmp_262 = $serializer_getInstance_94();
    var tmp_263 = ShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$375 = [];
    var tmp_264 = ObjectSerializer.l1c('ShatterCard', tmp_263, tmp$ret$375);
    var tmp_265 = $serializer_getInstance_95();
    var tmp_266 = $serializer_getInstance_90();
    var tmp_267 = SwarmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$378 = [];
    var tmp_268 = ObjectSerializer.l1c('SwarmCard', tmp_267, tmp$ret$378);
    var tmp_269 = $serializer_getInstance_87();
    var tmp_270 = AurorasPassage_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$381 = [];
    var tmp_271 = ObjectSerializer.l1c('AurorasPassage', tmp_270, tmp$ret$381);
    var tmp_272 = BansheesLureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$384 = [];
    var tmp_273 = ObjectSerializer.l1c('BansheesLureCard', tmp_272, tmp$ret$384);
    var tmp_274 = BladeOfValhCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$387 = [];
    var tmp_275 = ObjectSerializer.l1c('BladeOfValhCard', tmp_274, tmp$ret$387);
    var tmp_276 = ChainGrapnelCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$390 = [];
    var tmp_277 = ObjectSerializer.l1c('ChainGrapnelCard', tmp_276, tmp$ret$390);
    var tmp_278 = $serializer_getInstance_339();
    var tmp_279 = GrapeshotCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$393 = [];
    var tmp_280 = ObjectSerializer.l1c('GrapeshotCard', tmp_279, tmp$ret$393);
    var tmp_281 = $serializer_getInstance_337();
    var tmp_282 = $serializer_getInstance_338();
    var tmp_283 = $serializer_getInstance_336();
    var tmp_284 = $serializer_getInstance_334();
    var tmp_285 = $serializer_getInstance_379();
    var tmp_286 = $serializer_getInstance_341();
    var tmp_287 = SpyglassCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$396 = [];
    var tmp_288 = ObjectSerializer.l1c('SpyglassCard', tmp_287, tmp$ret$396);
    var tmp_289 = $serializer_getInstance_333();
    var tmp_290 = $serializer_getInstance_332();
    var tmp_291 = $serializer_getInstance_340();
    var tmp_292 = $serializer_getInstance_328();
    var tmp_293 = WarhogsTuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$399 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_294 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_66, tmp_68, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_80, tmp_82, tmp_84, tmp_86, tmp_88, tmp_90, tmp_92, tmp_94, tmp_96, tmp_98, tmp_100, tmp_102, tmp_104, tmp_106, tmp_108, tmp_110, tmp_112, tmp_114, tmp_116, tmp_118, tmp_120, tmp_122, tmp_124, tmp_126, tmp_128, tmp_130, tmp_132, tmp_134, tmp_136, tmp_138, tmp_140, tmp_142, tmp_144, tmp_146, tmp_148, tmp_150, tmp_152, tmp_154, tmp_156, tmp_158, tmp_160, tmp_162, tmp_164, tmp_166, tmp_168, tmp_170, tmp_172, tmp_174, tmp_176, tmp_178, tmp_179, tmp_181, tmp_183, tmp_185, tmp_187, tmp_189, tmp_191, tmp_193, tmp_195, tmp_197, tmp_199, tmp_200, tmp_202, tmp_204, tmp_206, tmp_208, tmp_210, tmp_212, tmp_214, tmp_216, tmp_218, tmp_220, tmp_222, tmp_224, tmp_225, tmp_227, tmp_229, tmp_231, tmp_233, tmp_235, tmp_237, tmp_239, tmp_241, tmp_243, tmp_244, tmp_246, tmp_247, tmp_248, tmp_249, tmp_250, tmp_252, tmp_253, tmp_254, tmp_255, tmp_257, tmp_259, tmp_260, tmp_261, tmp_262, tmp_264, tmp_265, tmp_266, tmp_268, tmp_269, tmp_271, tmp_273, tmp_275, tmp_277, tmp_278, tmp_280, tmp_281, tmp_282, tmp_283, tmp_284, tmp_285, tmp_286, tmp_288, tmp_289, tmp_290, tmp_291, tmp_292, ObjectSerializer.l1c('WarhogsTuskCard', tmp_293, tmp$ret$399), $serializer_getInstance_335()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$405 = [];
    return SealedClassSerializer.i10('steelart.beast.PlayableInTurnCard', tmp, tmp_0, tmp_294, tmp$ret$405);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Split {
  constructor() {
    Split_instance = this;
    this.n5w_1 = true;
    this.o5w_1 = true;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p5w_1 = lazy(tmp_0, CardPlayColor$Split$_anonymous__8r29y6);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_405(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Split';
  }
  hashCode() {
    return -327478074;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Split))
      return false;
    return true;
  }
}
class Red {
  constructor() {
    Red_instance = this;
    this.q5w_1 = true;
    this.r5w_1 = false;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s5w_1 = lazy(tmp_0, CardPlayColor$Red$_anonymous__6jzbl7);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_406(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Red';
  }
  hashCode() {
    return -1019335363;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Red))
      return false;
    return true;
  }
}
class Blue {
  constructor() {
    Blue_instance = this;
    this.t5w_1 = false;
    this.u5w_1 = true;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v5w_1 = lazy(tmp_0, CardPlayColor$Blue$_anonymous__33dft4);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_407(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Blue';
  }
  hashCode() {
    return -1535094482;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Blue))
      return false;
    return true;
  }
}
class Companion_439 {
  a2g() {
    var tmp = getKClass(ArsenalCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Ruin1), getKClass(Ruin10), getKClass(Ruin11), getKClass(Ruin12), getKClass(Ruin2), getKClass(Ruin3), getKClass(Ruin4), getKClass(Ruin5), getKClass(Ruin6), getKClass(Ruin7), getKClass(Ruin8), getKClass(Ruin9), getKClass(UnknownAshRuinCard), getKClass(IntuitionCard), getKClass(AbruptDecayCard), getKClass(BrutalityCard), getKClass(DisappearCard), getKClass(DisperseCard), getKClass(EvolveCard), getKClass(FeastCard), getKClass(FlourishCard), getKClass(FuryCard), getKClass(HatredCard), getKClass(InsidiousGrowthCard), getKClass(MirrorStepCard), getKClass(OverloadedFuryCard), getKClass(OverloadedShatterCard), getKClass(RageCard), getKClass(RecoveryTestBeastCard), getKClass(RoamCard), getKClass(ShatterCard), getKClass(SprawlCard), getKClass(StrangeSummonsCard), getKClass(SwarmCard), getKClass(UnbendingWillCard), getKClass(RecoveryTestBeastReaction), getKClass(RecoveryTestNightlyRewardsFailureCard), getKClass(RecoveryTestPhaseFailureCard), getKClass(RecoveryTestTeamRewardFailureCard), getKClass(SuddenMistCard), getKClass(UnknownBeastlyTalentCard), getKClass(WorldShiftCard), getKClass(DreamerMaskCard), getKClass(EsmeriasStrandCard), getKClass(FlareCard), getKClass(AurorasPassage), getKClass(BansheesLureCard), getKClass(BladeOfValhCard), getKClass(ChainGrapnelCard), getKClass(ExpeditionMapCard), getKClass(GrapeshotCard), getKClass(HuntersBellCard), getKClass(HuntersPassageCard), getKClass(HuntersRestCard), getKClass(OutpostCard), getKClass(RecoveryTestHunterCard), getKClass(SacredRichesCard), getKClass(SpyglassCard), getKClass(FireTrapCard), getKClass(HexingTrapCard), getKClass(RitualTrapCard), getKClass(ShriekerTrapCard), getKClass(WarhogsTuskCard), getKClass(WolfsbaneCard), getKClass(RecoveryTestHunterReaction), getKClass(SmokeBombCard), getKClass(UnknownHunterItemCard), getKClass(RecoveryTestBeastCard), getKClass(RecoveryTestHunterCard)];
    var tmp_1 = Ruin1_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Ruin1', tmp_1, tmp$ret$3);
    var tmp_3 = Ruin10_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('Ruin10', tmp_3, tmp$ret$6);
    var tmp_5 = Ruin11_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('Ruin11', tmp_5, tmp$ret$9);
    var tmp_7 = Ruin12_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('Ruin12', tmp_7, tmp$ret$12);
    var tmp_9 = Ruin2_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('Ruin2', tmp_9, tmp$ret$15);
    var tmp_11 = Ruin3_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('Ruin3', tmp_11, tmp$ret$18);
    var tmp_13 = Ruin4_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('Ruin4', tmp_13, tmp$ret$21);
    var tmp_15 = Ruin5_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('Ruin5', tmp_15, tmp$ret$24);
    var tmp_17 = Ruin6_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('Ruin6', tmp_17, tmp$ret$27);
    var tmp_19 = Ruin7_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('Ruin7', tmp_19, tmp$ret$30);
    var tmp_21 = Ruin8_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('Ruin8', tmp_21, tmp$ret$33);
    var tmp_23 = Ruin9_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('Ruin9', tmp_23, tmp$ret$36);
    var tmp_25 = $serializer_getInstance_74();
    var tmp_26 = $serializer_getInstance_84();
    var tmp_27 = AbruptDecayCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_28 = ObjectSerializer.l1c('AbruptDecayCard', tmp_27, tmp$ret$39);
    var tmp_29 = $serializer_getInstance_88();
    var tmp_30 = DisappearCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_31 = ObjectSerializer.l1c('DisappearCard', tmp_30, tmp$ret$42);
    var tmp_32 = $serializer_getInstance_92();
    var tmp_33 = $serializer_getInstance_86();
    var tmp_34 = $serializer_getInstance_96();
    var tmp_35 = $serializer_getInstance_97();
    var tmp_36 = FuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_37 = ObjectSerializer.l1c('FuryCard', tmp_36, tmp$ret$45);
    var tmp_38 = $serializer_getInstance_91();
    var tmp_39 = $serializer_getInstance_93();
    var tmp_40 = $serializer_getInstance_98();
    var tmp_41 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_42 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_41, tmp$ret$48);
    var tmp_43 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_44 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_43, tmp$ret$51);
    var tmp_45 = $serializer_getInstance_89();
    var tmp_46 = $serializer_getInstance_378();
    var tmp_47 = $serializer_getInstance_94();
    var tmp_48 = ShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_49 = ObjectSerializer.l1c('ShatterCard', tmp_48, tmp$ret$54);
    var tmp_50 = $serializer_getInstance_95();
    var tmp_51 = $serializer_getInstance_90();
    var tmp_52 = SwarmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_53 = ObjectSerializer.l1c('SwarmCard', tmp_52, tmp$ret$57);
    var tmp_54 = $serializer_getInstance_87();
    var tmp_55 = RecoveryTestBeastReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_56 = ObjectSerializer.l1c('RecoveryTestBeastReaction', tmp_55, tmp$ret$60);
    var tmp_57 = RecoveryTestNightlyRewardsFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_58 = ObjectSerializer.l1c('RecoveryTestNightlyRewardsFailureCard', tmp_57, tmp$ret$63);
    var tmp_59 = RecoveryTestPhaseFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_60 = ObjectSerializer.l1c('RecoveryTestPhaseFailureCard', tmp_59, tmp$ret$66);
    var tmp_61 = RecoveryTestTeamRewardFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_62 = ObjectSerializer.l1c('RecoveryTestTeamRewardFailureCard', tmp_61, tmp$ret$69);
    var tmp_63 = SuddenMistCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_64 = ObjectSerializer.l1c('SuddenMistCard', tmp_63, tmp$ret$72);
    var tmp_65 = $serializer_getInstance_99();
    var tmp_66 = $serializer_getInstance_85();
    var tmp_67 = $serializer_getInstance_329();
    var tmp_68 = EsmeriasStrandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_69 = ObjectSerializer.l1c('EsmeriasStrandCard', tmp_68, tmp$ret$75);
    var tmp_70 = $serializer_getInstance_330();
    var tmp_71 = AurorasPassage_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_72 = ObjectSerializer.l1c('AurorasPassage', tmp_71, tmp$ret$78);
    var tmp_73 = BansheesLureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_74 = ObjectSerializer.l1c('BansheesLureCard', tmp_73, tmp$ret$81);
    var tmp_75 = BladeOfValhCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_76 = ObjectSerializer.l1c('BladeOfValhCard', tmp_75, tmp$ret$84);
    var tmp_77 = ChainGrapnelCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_78 = ObjectSerializer.l1c('ChainGrapnelCard', tmp_77, tmp$ret$87);
    var tmp_79 = $serializer_getInstance_339();
    var tmp_80 = GrapeshotCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_81 = ObjectSerializer.l1c('GrapeshotCard', tmp_80, tmp$ret$90);
    var tmp_82 = $serializer_getInstance_337();
    var tmp_83 = $serializer_getInstance_338();
    var tmp_84 = $serializer_getInstance_336();
    var tmp_85 = $serializer_getInstance_334();
    var tmp_86 = $serializer_getInstance_379();
    var tmp_87 = $serializer_getInstance_341();
    var tmp_88 = SpyglassCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_89 = ObjectSerializer.l1c('SpyglassCard', tmp_88, tmp$ret$93);
    var tmp_90 = $serializer_getInstance_333();
    var tmp_91 = $serializer_getInstance_332();
    var tmp_92 = $serializer_getInstance_340();
    var tmp_93 = $serializer_getInstance_328();
    var tmp_94 = WarhogsTuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_95 = ObjectSerializer.l1c('WarhogsTuskCard', tmp_94, tmp$ret$96);
    var tmp_96 = $serializer_getInstance_335();
    var tmp_97 = RecoveryTestHunterReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_98 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_25, tmp_26, tmp_28, tmp_29, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_37, tmp_38, tmp_39, tmp_40, tmp_42, tmp_44, tmp_45, tmp_46, tmp_47, tmp_49, tmp_50, tmp_51, tmp_53, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_65, tmp_66, tmp_67, tmp_69, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_79, tmp_81, tmp_82, tmp_83, tmp_84, tmp_85, tmp_86, tmp_87, tmp_89, tmp_90, tmp_91, tmp_92, tmp_93, tmp_95, tmp_96, ObjectSerializer.l1c('RecoveryTestHunterReaction', tmp_97, tmp$ret$99), $serializer_getInstance_331(), $serializer_getInstance_343(), $serializer_getInstance_378(), $serializer_getInstance_379()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    return SealedClassSerializer.i10('steelart.beast.ArsenalCard', tmp, tmp_0, tmp_98, tmp$ret$105);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_440 {
  a2g() {
    var tmp = getKClass(UnknownCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(UnknownAshRuinCard), getKClass(UnknownBeastlyTalentCard), getKClass(UnknownDraftActionCard), getKClass(UnknownHunterItemCard)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_74(), $serializer_getInstance_99(), $serializer_getInstance_127(), $serializer_getInstance_343()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.UnknownCard', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_441 {
  a2g() {
    var tmp = getKClass(AbilityCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AcclivityCard), getKClass(BeastlyTongueCard), getKClass(ConsumeCard), getKClass(CorruptCard), getKClass(DeceiveCard), getKClass(DefileCard), getKClass(DismemberCard), getKClass(EngorgeCard), getKClass(FeedCard), getKClass(FlickerCard), getKClass(FloodCard), getKClass(GatherThePackCard), getKClass(HydraCard), getKClass(LeapCard), getKClass(LurkCard), getKClass(BoltAndRecallCard), getKClass(SoulReapCard), getKClass(SummonYeltrCard), getKClass(ToothAndSeverCard), getKClass(MurderCard), getKClass(ObscureTalentCard), getKClass(OverloadedStormCard), getKClass(PreyUponCard), getKClass(RambleCard), getKClass(IncinerateCard), getKClass(RiseCard), getKClass(ScorchedEarthCard), getKClass(SummonLindwyrmCard), getKClass(ShadowStepCard), getKClass(SlitherCard), getKClass(SpookCard), getKClass(StalkCard), getKClass(StampedeCard), getKClass(StormCard), getKClass(SummonBasiliskCard), getKClass(SummonChangelingCard), getKClass(SummonDreamerCard), getKClass(SummonEyeCard), getKClass(SummonPolypCard), getKClass(SummonWarhogCard), getKClass(SummonWolfCard), getKClass(SummonYagiCard), getKClass(SummonEyeCard), getKClass(TuskCard), getKClass(UnburdenCard), getKClass(UnwillingSacrificeCard), getKClass(UpriseCard), getKClass(NestCard), getKClass(OverloadedNestCard), getKClass(OvipunctureCard), getKClass(SilkCard), getKClass(SummonEggCard), getKClass(AllureCard), getKClass(BeholdCard), getKClass(EludeCard), getKClass(SummonAdmirerCard), getKClass(VoidCard), getKClass(BleatCard), getKClass(AviationCard), getKClass(BerserkCard), getKClass(CleaverCard), getKClass(CommandCard), getKClass(DelegateCard), getKClass(FlameRapierCard), getKClass(GrapplingHookCard), getKClass(HerdCard), getKClass(BindingHuntCard), getKClass(BloodHuntCard), getKClass(HuntCard), getKClass(TraitorsHuntCard), getKClass(IncisionCard), getKClass(MountCard), getKClass(OverloadedFlameRapierCard), getKClass(ScoutCard), getKClass(SeerCard), getKClass(BondedTrackCard), getKClass(ScroungeCard), getKClass(TraitorsHuntCard), getKClass(SilverArrowCard), getKClass(BloodTrackCard), getKClass(BondedTrackCard), getKClass(TrackCard), getKClass(TrapmasterCard), getKClass(UnnaturalResolveCard), getKClass(WardCard), getKClass(MistShroudCard)];
    var tmp_1 = AcclivityCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('AcclivityCard', tmp_1, tmp$ret$3);
    var tmp_3 = BeastlyTongueCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('BeastlyTongueCard', tmp_3, tmp$ret$6);
    var tmp_5 = ConsumeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('ConsumeCard', tmp_5, tmp$ret$9);
    var tmp_7 = CorruptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('CorruptCard', tmp_7, tmp$ret$12);
    var tmp_9 = DeceiveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('DeceiveCard', tmp_9, tmp$ret$15);
    var tmp_11 = DefileCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('DefileCard', tmp_11, tmp$ret$18);
    var tmp_13 = DismemberCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('DismemberCard', tmp_13, tmp$ret$21);
    var tmp_15 = EngorgeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('EngorgeCard', tmp_15, tmp$ret$24);
    var tmp_17 = FeedCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('FeedCard', tmp_17, tmp$ret$27);
    var tmp_19 = FlickerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('FlickerCard', tmp_19, tmp$ret$30);
    var tmp_21 = FloodCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('FloodCard', tmp_21, tmp$ret$33);
    var tmp_23 = GatherThePackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('GatherThePackCard', tmp_23, tmp$ret$36);
    var tmp_25 = HydraCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('HydraCard', tmp_25, tmp$ret$39);
    var tmp_27 = LeapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('LeapCard', tmp_27, tmp$ret$42);
    var tmp_29 = LurkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('LurkCard', tmp_29, tmp$ret$45);
    var tmp_31 = BoltAndRecallCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('BoltAndRecallCard', tmp_31, tmp$ret$48);
    var tmp_33 = SoulReapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('SoulReapCard', tmp_33, tmp$ret$51);
    var tmp_35 = SummonYeltrCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_36 = ObjectSerializer.l1c('SummonYeltrCard', tmp_35, tmp$ret$54);
    var tmp_37 = ToothAndSeverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_38 = ObjectSerializer.l1c('ToothAndSeverCard', tmp_37, tmp$ret$57);
    var tmp_39 = MurderCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_40 = ObjectSerializer.l1c('MurderCard', tmp_39, tmp$ret$60);
    var tmp_41 = ObscureTalentCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_42 = ObjectSerializer.l1c('ObscureTalentCard', tmp_41, tmp$ret$63);
    var tmp_43 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_44 = ObjectSerializer.l1c('OverloadedStormCard', tmp_43, tmp$ret$66);
    var tmp_45 = PreyUponCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_46 = ObjectSerializer.l1c('PreyUponCard', tmp_45, tmp$ret$69);
    var tmp_47 = RambleCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_48 = ObjectSerializer.l1c('RambleCard', tmp_47, tmp$ret$72);
    var tmp_49 = IncinerateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_50 = ObjectSerializer.l1c('IncinerateCard', tmp_49, tmp$ret$75);
    var tmp_51 = RiseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_52 = ObjectSerializer.l1c('RiseCard', tmp_51, tmp$ret$78);
    var tmp_53 = ScorchedEarthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_54 = ObjectSerializer.l1c('ScorchedEarthCard', tmp_53, tmp$ret$81);
    var tmp_55 = SummonLindwyrmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_56 = ObjectSerializer.l1c('SummonLindwyrmCard', tmp_55, tmp$ret$84);
    var tmp_57 = ShadowStepCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_58 = ObjectSerializer.l1c('ShadowStepCard', tmp_57, tmp$ret$87);
    var tmp_59 = SlitherCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_60 = ObjectSerializer.l1c('SlitherCard', tmp_59, tmp$ret$90);
    var tmp_61 = SpookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_62 = ObjectSerializer.l1c('SpookCard', tmp_61, tmp$ret$93);
    var tmp_63 = StalkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_64 = ObjectSerializer.l1c('StalkCard', tmp_63, tmp$ret$96);
    var tmp_65 = StampedeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_66 = ObjectSerializer.l1c('StampedeCard', tmp_65, tmp$ret$99);
    var tmp_67 = StormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_68 = ObjectSerializer.l1c('StormCard', tmp_67, tmp$ret$102);
    var tmp_69 = SummonBasiliskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_70 = ObjectSerializer.l1c('SummonBasiliskCard', tmp_69, tmp$ret$105);
    var tmp_71 = SummonChangelingCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_72 = ObjectSerializer.l1c('SummonChangelingCard', tmp_71, tmp$ret$108);
    var tmp_73 = SummonDreamerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_74 = ObjectSerializer.l1c('SummonDreamerCard', tmp_73, tmp$ret$111);
    var tmp_75 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_76 = ObjectSerializer.l1c('SummonEyeCard', tmp_75, tmp$ret$114);
    var tmp_77 = SummonPolypCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_78 = ObjectSerializer.l1c('SummonPolypCard', tmp_77, tmp$ret$117);
    var tmp_79 = SummonWarhogCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_80 = ObjectSerializer.l1c('SummonWarhogCard', tmp_79, tmp$ret$120);
    var tmp_81 = SummonWolfCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_82 = ObjectSerializer.l1c('SummonWolfCard', tmp_81, tmp$ret$123);
    var tmp_83 = SummonYagiCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_84 = ObjectSerializer.l1c('SummonYagiCard', tmp_83, tmp$ret$126);
    var tmp_85 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_86 = ObjectSerializer.l1c('SummonEyeCard', tmp_85, tmp$ret$129);
    var tmp_87 = TuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_88 = ObjectSerializer.l1c('TuskCard', tmp_87, tmp$ret$132);
    var tmp_89 = UnburdenCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_90 = ObjectSerializer.l1c('UnburdenCard', tmp_89, tmp$ret$135);
    var tmp_91 = UnwillingSacrificeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    var tmp_92 = ObjectSerializer.l1c('UnwillingSacrificeCard', tmp_91, tmp$ret$138);
    var tmp_93 = UpriseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$141 = [];
    var tmp_94 = ObjectSerializer.l1c('UpriseCard', tmp_93, tmp$ret$141);
    var tmp_95 = NestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    var tmp_96 = ObjectSerializer.l1c('NestCard', tmp_95, tmp$ret$144);
    var tmp_97 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$147 = [];
    var tmp_98 = ObjectSerializer.l1c('OverloadedNestCard', tmp_97, tmp$ret$147);
    var tmp_99 = OvipunctureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$150 = [];
    var tmp_100 = ObjectSerializer.l1c('OvipunctureCard', tmp_99, tmp$ret$150);
    var tmp_101 = SilkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$153 = [];
    var tmp_102 = ObjectSerializer.l1c('SilkCard', tmp_101, tmp$ret$153);
    var tmp_103 = SummonEggCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$156 = [];
    var tmp_104 = ObjectSerializer.l1c('SummonEggCard', tmp_103, tmp$ret$156);
    var tmp_105 = AllureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$159 = [];
    var tmp_106 = ObjectSerializer.l1c('AllureCard', tmp_105, tmp$ret$159);
    var tmp_107 = BeholdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$162 = [];
    var tmp_108 = ObjectSerializer.l1c('BeholdCard', tmp_107, tmp$ret$162);
    var tmp_109 = EludeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$165 = [];
    var tmp_110 = ObjectSerializer.l1c('EludeCard', tmp_109, tmp$ret$165);
    var tmp_111 = SummonAdmirerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$168 = [];
    var tmp_112 = ObjectSerializer.l1c('SummonAdmirerCard', tmp_111, tmp$ret$168);
    var tmp_113 = VoidCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$171 = [];
    var tmp_114 = ObjectSerializer.l1c('VoidCard', tmp_113, tmp$ret$171);
    var tmp_115 = BleatCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$174 = [];
    var tmp_116 = ObjectSerializer.l1c('BleatCard', tmp_115, tmp$ret$174);
    var tmp_117 = AviationCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$177 = [];
    var tmp_118 = ObjectSerializer.l1c('AviationCard', tmp_117, tmp$ret$177);
    var tmp_119 = BerserkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$180 = [];
    var tmp_120 = ObjectSerializer.l1c('BerserkCard', tmp_119, tmp$ret$180);
    var tmp_121 = CleaverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$183 = [];
    var tmp_122 = ObjectSerializer.l1c('CleaverCard', tmp_121, tmp$ret$183);
    var tmp_123 = CommandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$186 = [];
    var tmp_124 = ObjectSerializer.l1c('CommandCard', tmp_123, tmp$ret$186);
    var tmp_125 = DelegateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$189 = [];
    var tmp_126 = ObjectSerializer.l1c('DelegateCard', tmp_125, tmp$ret$189);
    var tmp_127 = FlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$192 = [];
    var tmp_128 = ObjectSerializer.l1c('FlameRapierCard', tmp_127, tmp$ret$192);
    var tmp_129 = GrapplingHookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$195 = [];
    var tmp_130 = ObjectSerializer.l1c('GrapplingHookCard', tmp_129, tmp$ret$195);
    var tmp_131 = HerdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$198 = [];
    var tmp_132 = ObjectSerializer.l1c('HerdCard', tmp_131, tmp$ret$198);
    var tmp_133 = BindingHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$201 = [];
    var tmp_134 = ObjectSerializer.l1c('BindingHuntCard', tmp_133, tmp$ret$201);
    var tmp_135 = BloodHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$204 = [];
    var tmp_136 = ObjectSerializer.l1c('BloodHuntCard', tmp_135, tmp$ret$204);
    var tmp_137 = $serializer_getInstance_327();
    var tmp_138 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$207 = [];
    var tmp_139 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_138, tmp$ret$207);
    var tmp_140 = IncisionCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$210 = [];
    var tmp_141 = ObjectSerializer.l1c('IncisionCard', tmp_140, tmp$ret$210);
    var tmp_142 = MountCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$213 = [];
    var tmp_143 = ObjectSerializer.l1c('MountCard', tmp_142, tmp$ret$213);
    var tmp_144 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$216 = [];
    var tmp_145 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_144, tmp$ret$216);
    var tmp_146 = ScoutCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$219 = [];
    var tmp_147 = ObjectSerializer.l1c('ScoutCard', tmp_146, tmp$ret$219);
    var tmp_148 = SeerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$222 = [];
    var tmp_149 = ObjectSerializer.l1c('SeerCard', tmp_148, tmp$ret$222);
    var tmp_150 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$225 = [];
    var tmp_151 = ObjectSerializer.l1c('BondedTrackCard', tmp_150, tmp$ret$225);
    var tmp_152 = ScroungeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$228 = [];
    var tmp_153 = ObjectSerializer.l1c('ScroungeCard', tmp_152, tmp$ret$228);
    var tmp_154 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$231 = [];
    var tmp_155 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_154, tmp$ret$231);
    var tmp_156 = SilverArrowCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$234 = [];
    var tmp_157 = ObjectSerializer.l1c('SilverArrowCard', tmp_156, tmp$ret$234);
    var tmp_158 = BloodTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$237 = [];
    var tmp_159 = ObjectSerializer.l1c('BloodTrackCard', tmp_158, tmp$ret$237);
    var tmp_160 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$240 = [];
    var tmp_161 = ObjectSerializer.l1c('BondedTrackCard', tmp_160, tmp$ret$240);
    var tmp_162 = $serializer_getInstance_326();
    var tmp_163 = TrapmasterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$243 = [];
    var tmp_164 = ObjectSerializer.l1c('TrapmasterCard', tmp_163, tmp$ret$243);
    var tmp_165 = UnnaturalResolveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$246 = [];
    var tmp_166 = ObjectSerializer.l1c('UnnaturalResolveCard', tmp_165, tmp$ret$246);
    var tmp_167 = WardCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$249 = [];
    var tmp_168 = ObjectSerializer.l1c('WardCard', tmp_167, tmp$ret$249);
    var tmp_169 = MistShroudCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$252 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_170 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_66, tmp_68, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_80, tmp_82, tmp_84, tmp_86, tmp_88, tmp_90, tmp_92, tmp_94, tmp_96, tmp_98, tmp_100, tmp_102, tmp_104, tmp_106, tmp_108, tmp_110, tmp_112, tmp_114, tmp_116, tmp_118, tmp_120, tmp_122, tmp_124, tmp_126, tmp_128, tmp_130, tmp_132, tmp_134, tmp_136, tmp_137, tmp_139, tmp_141, tmp_143, tmp_145, tmp_147, tmp_149, tmp_151, tmp_153, tmp_155, tmp_157, tmp_159, tmp_161, tmp_162, tmp_164, tmp_166, tmp_168, ObjectSerializer.l1c('MistShroudCard', tmp_169, tmp$ret$252)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$258 = [];
    return SealedClassSerializer.i10('steelart.beast.AbilityCard', tmp, tmp_0, tmp_170, tmp$ret$258);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_442 {
  a2g() {
    var tmp = getKClass(PlayableCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AcclivityCard), getKClass(BeastlyTongueCard), getKClass(ConsumeCard), getKClass(CorruptCard), getKClass(DeceiveCard), getKClass(DefileCard), getKClass(DismemberCard), getKClass(EngorgeCard), getKClass(FeedCard), getKClass(FlickerCard), getKClass(FloodCard), getKClass(GatherThePackCard), getKClass(HydraCard), getKClass(LeapCard), getKClass(LurkCard), getKClass(BoltAndRecallCard), getKClass(SoulReapCard), getKClass(SummonYeltrCard), getKClass(ToothAndSeverCard), getKClass(MurderCard), getKClass(ObscureTalentCard), getKClass(OverloadedStormCard), getKClass(PreyUponCard), getKClass(RambleCard), getKClass(IncinerateCard), getKClass(RiseCard), getKClass(ScorchedEarthCard), getKClass(SummonLindwyrmCard), getKClass(ShadowStepCard), getKClass(SlitherCard), getKClass(SpookCard), getKClass(StalkCard), getKClass(StampedeCard), getKClass(StormCard), getKClass(SummonBasiliskCard), getKClass(SummonChangelingCard), getKClass(SummonDreamerCard), getKClass(SummonEyeCard), getKClass(SummonPolypCard), getKClass(SummonWarhogCard), getKClass(SummonWolfCard), getKClass(SummonYagiCard), getKClass(SummonEyeCard), getKClass(TuskCard), getKClass(UnburdenCard), getKClass(UnwillingSacrificeCard), getKClass(UpriseCard), getKClass(NestCard), getKClass(OverloadedNestCard), getKClass(OvipunctureCard), getKClass(SilkCard), getKClass(SummonEggCard), getKClass(AllureCard), getKClass(BeholdCard), getKClass(EludeCard), getKClass(SummonAdmirerCard), getKClass(VoidCard), getKClass(BleatCard), getKClass(AviationCard), getKClass(BerserkCard), getKClass(CleaverCard), getKClass(CommandCard), getKClass(DelegateCard), getKClass(FlameRapierCard), getKClass(GrapplingHookCard), getKClass(HerdCard), getKClass(BindingHuntCard), getKClass(BloodHuntCard), getKClass(HuntCard), getKClass(TraitorsHuntCard), getKClass(IncisionCard), getKClass(MountCard), getKClass(OverloadedFlameRapierCard), getKClass(ScoutCard), getKClass(SeerCard), getKClass(BondedTrackCard), getKClass(ScroungeCard), getKClass(TraitorsHuntCard), getKClass(SilverArrowCard), getKClass(BloodTrackCard), getKClass(BondedTrackCard), getKClass(TrackCard), getKClass(TrapmasterCard), getKClass(UnnaturalResolveCard), getKClass(WardCard), getKClass(MistShroudCard), getKClass(Ruin1), getKClass(Ruin10), getKClass(Ruin11), getKClass(Ruin12), getKClass(Ruin2), getKClass(Ruin3), getKClass(Ruin4), getKClass(Ruin5), getKClass(Ruin6), getKClass(Ruin7), getKClass(Ruin8), getKClass(Ruin9), getKClass(UnknownAshRuinCard), getKClass(IntuitionCard), getKClass(AbruptDecayCard), getKClass(BrutalityCard), getKClass(DisappearCard), getKClass(DisperseCard), getKClass(EvolveCard), getKClass(FeastCard), getKClass(FlourishCard), getKClass(FuryCard), getKClass(HatredCard), getKClass(InsidiousGrowthCard), getKClass(MirrorStepCard), getKClass(OverloadedFuryCard), getKClass(OverloadedShatterCard), getKClass(RageCard), getKClass(RecoveryTestBeastCard), getKClass(RoamCard), getKClass(ShatterCard), getKClass(SprawlCard), getKClass(StrangeSummonsCard), getKClass(SwarmCard), getKClass(UnbendingWillCard), getKClass(RecoveryTestBeastReaction), getKClass(RecoveryTestNightlyRewardsFailureCard), getKClass(RecoveryTestPhaseFailureCard), getKClass(RecoveryTestTeamRewardFailureCard), getKClass(SuddenMistCard), getKClass(UnknownBeastlyTalentCard), getKClass(WorldShiftCard), getKClass(DreamerMaskCard), getKClass(EsmeriasStrandCard), getKClass(FlareCard), getKClass(AurorasPassage), getKClass(BansheesLureCard), getKClass(BladeOfValhCard), getKClass(ChainGrapnelCard), getKClass(ExpeditionMapCard), getKClass(GrapeshotCard), getKClass(HuntersBellCard), getKClass(HuntersPassageCard), getKClass(HuntersRestCard), getKClass(OutpostCard), getKClass(RecoveryTestHunterCard), getKClass(SacredRichesCard), getKClass(SpyglassCard), getKClass(FireTrapCard), getKClass(HexingTrapCard), getKClass(RitualTrapCard), getKClass(ShriekerTrapCard), getKClass(WarhogsTuskCard), getKClass(WolfsbaneCard), getKClass(RecoveryTestHunterReaction), getKClass(SmokeBombCard), getKClass(UnknownHunterItemCard), getKClass(RecoveryTestBeastCard), getKClass(RecoveryTestHunterCard), getKClass(Ruin1), getKClass(Ruin10), getKClass(Ruin11), getKClass(Ruin12), getKClass(Ruin2), getKClass(Ruin3), getKClass(Ruin4), getKClass(Ruin5), getKClass(Ruin6), getKClass(Ruin7), getKClass(Ruin8), getKClass(Ruin9), getKClass(AcclivityCard), getKClass(BeastlyTongueCard), getKClass(ConsumeCard), getKClass(CorruptCard), getKClass(DeceiveCard), getKClass(DefileCard), getKClass(DismemberCard), getKClass(EngorgeCard), getKClass(FeedCard), getKClass(FlickerCard), getKClass(FloodCard), getKClass(GatherThePackCard), getKClass(HydraCard), getKClass(LeapCard), getKClass(LurkCard), getKClass(BoltAndRecallCard), getKClass(SoulReapCard), getKClass(SummonYeltrCard), getKClass(ToothAndSeverCard), getKClass(MurderCard), getKClass(ObscureTalentCard), getKClass(OverloadedStormCard), getKClass(PreyUponCard), getKClass(RambleCard), getKClass(IncinerateCard), getKClass(RiseCard), getKClass(ScorchedEarthCard), getKClass(SummonLindwyrmCard), getKClass(ShadowStepCard), getKClass(SlitherCard), getKClass(SpookCard), getKClass(StalkCard), getKClass(StampedeCard), getKClass(StormCard), getKClass(SummonBasiliskCard), getKClass(SummonChangelingCard), getKClass(SummonDreamerCard), getKClass(SummonEyeCard), getKClass(SummonPolypCard), getKClass(SummonWarhogCard), getKClass(SummonWolfCard), getKClass(SummonYagiCard), getKClass(SummonEyeCard), getKClass(TuskCard), getKClass(UnburdenCard), getKClass(UnwillingSacrificeCard), getKClass(UpriseCard), getKClass(NestCard), getKClass(OverloadedNestCard), getKClass(OvipunctureCard), getKClass(SilkCard), getKClass(SummonEggCard), getKClass(AllureCard), getKClass(BeholdCard), getKClass(EludeCard), getKClass(SummonAdmirerCard), getKClass(VoidCard), getKClass(AdaptCard), getKClass(AnimateCard), getKClass(AvariceCard), getKClass(BolsterCard), getKClass(ChargeCard), getKClass(DashCard), getKClass(DisplaceCard), getKClass(DarkDealingsCard), getKClass(DarkOfferingsCard), getKClass(DarkRitualsCard), getKClass(EnsnareCard), getKClass(GlimpseCard), getKClass(HasteCard), getKClass(HiddenPassageCard), getKClass(InciteCard), getKClass(ProwlCard), getKClass(PursuitCard), getKClass(RushCard), getKClass(StrideCard), getKClass(UnearthCard), getKClass(UnknownDraftActionCard), getKClass(AviationCard), getKClass(BerserkCard), getKClass(CleaverCard), getKClass(CommandCard), getKClass(DelegateCard), getKClass(FlameRapierCard), getKClass(GrapplingHookCard), getKClass(HerdCard), getKClass(BindingHuntCard), getKClass(BloodHuntCard), getKClass(HuntCard), getKClass(TraitorsHuntCard), getKClass(IncisionCard), getKClass(MountCard), getKClass(OverloadedFlameRapierCard), getKClass(ScoutCard), getKClass(SeerCard), getKClass(BondedTrackCard), getKClass(ScroungeCard), getKClass(TraitorsHuntCard), getKClass(SilverArrowCard), getKClass(BloodTrackCard), getKClass(BondedTrackCard), getKClass(TrackCard), getKClass(TrapmasterCard), getKClass(UnnaturalResolveCard), getKClass(WardCard), getKClass(OverloadedFlameRapierCard), getKClass(OverloadedFuryCard), getKClass(OverloadedNestCard), getKClass(OverloadedShatterCard), getKClass(OverloadedStormCard), getKClass(AbruptDecayCard), getKClass(BrutalityCard), getKClass(DisappearCard), getKClass(DisperseCard), getKClass(EvolveCard), getKClass(FeastCard), getKClass(FlourishCard), getKClass(FuryCard), getKClass(HatredCard), getKClass(InsidiousGrowthCard), getKClass(MirrorStepCard), getKClass(OverloadedFuryCard), getKClass(OverloadedShatterCard), getKClass(RageCard), getKClass(RecoveryTestBeastCard), getKClass(RoamCard), getKClass(ShatterCard), getKClass(SprawlCard), getKClass(StrangeSummonsCard), getKClass(SwarmCard), getKClass(UnbendingWillCard), getKClass(AurorasPassage), getKClass(BansheesLureCard), getKClass(BladeOfValhCard), getKClass(ChainGrapnelCard), getKClass(ExpeditionMapCard), getKClass(GrapeshotCard), getKClass(HuntersBellCard), getKClass(HuntersPassageCard), getKClass(HuntersRestCard), getKClass(OutpostCard), getKClass(RecoveryTestHunterCard), getKClass(SacredRichesCard), getKClass(SpyglassCard), getKClass(FireTrapCard), getKClass(HexingTrapCard), getKClass(RitualTrapCard), getKClass(ShriekerTrapCard), getKClass(WarhogsTuskCard), getKClass(WolfsbaneCard), getKClass(BleatCard), getKClass(DreamerMaskCard), getKClass(EsmeriasStrandCard), getKClass(FlareCard), getKClass(IntuitionCard), getKClass(MistShroudCard), getKClass(RecoveryTestBeastReaction), getKClass(RecoveryTestHunterReaction), getKClass(SmokeBombCard), getKClass(SuddenMistCard), getKClass(WorldShiftCard), getKClass(UnknownAshRuinCard), getKClass(UnknownBeastlyTalentCard), getKClass(UnknownDraftActionCard), getKClass(UnknownHunterItemCard)];
    var tmp_1 = AcclivityCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('AcclivityCard', tmp_1, tmp$ret$3);
    var tmp_3 = BeastlyTongueCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('BeastlyTongueCard', tmp_3, tmp$ret$6);
    var tmp_5 = ConsumeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('ConsumeCard', tmp_5, tmp$ret$9);
    var tmp_7 = CorruptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('CorruptCard', tmp_7, tmp$ret$12);
    var tmp_9 = DeceiveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_10 = ObjectSerializer.l1c('DeceiveCard', tmp_9, tmp$ret$15);
    var tmp_11 = DefileCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_12 = ObjectSerializer.l1c('DefileCard', tmp_11, tmp$ret$18);
    var tmp_13 = DismemberCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_14 = ObjectSerializer.l1c('DismemberCard', tmp_13, tmp$ret$21);
    var tmp_15 = EngorgeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_16 = ObjectSerializer.l1c('EngorgeCard', tmp_15, tmp$ret$24);
    var tmp_17 = FeedCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_18 = ObjectSerializer.l1c('FeedCard', tmp_17, tmp$ret$27);
    var tmp_19 = FlickerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_20 = ObjectSerializer.l1c('FlickerCard', tmp_19, tmp$ret$30);
    var tmp_21 = FloodCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_22 = ObjectSerializer.l1c('FloodCard', tmp_21, tmp$ret$33);
    var tmp_23 = GatherThePackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_24 = ObjectSerializer.l1c('GatherThePackCard', tmp_23, tmp$ret$36);
    var tmp_25 = HydraCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_26 = ObjectSerializer.l1c('HydraCard', tmp_25, tmp$ret$39);
    var tmp_27 = LeapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    var tmp_28 = ObjectSerializer.l1c('LeapCard', tmp_27, tmp$ret$42);
    var tmp_29 = LurkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$45 = [];
    var tmp_30 = ObjectSerializer.l1c('LurkCard', tmp_29, tmp$ret$45);
    var tmp_31 = BoltAndRecallCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    var tmp_32 = ObjectSerializer.l1c('BoltAndRecallCard', tmp_31, tmp$ret$48);
    var tmp_33 = SoulReapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$51 = [];
    var tmp_34 = ObjectSerializer.l1c('SoulReapCard', tmp_33, tmp$ret$51);
    var tmp_35 = SummonYeltrCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$54 = [];
    var tmp_36 = ObjectSerializer.l1c('SummonYeltrCard', tmp_35, tmp$ret$54);
    var tmp_37 = ToothAndSeverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$57 = [];
    var tmp_38 = ObjectSerializer.l1c('ToothAndSeverCard', tmp_37, tmp$ret$57);
    var tmp_39 = MurderCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$60 = [];
    var tmp_40 = ObjectSerializer.l1c('MurderCard', tmp_39, tmp$ret$60);
    var tmp_41 = ObscureTalentCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$63 = [];
    var tmp_42 = ObjectSerializer.l1c('ObscureTalentCard', tmp_41, tmp$ret$63);
    var tmp_43 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$66 = [];
    var tmp_44 = ObjectSerializer.l1c('OverloadedStormCard', tmp_43, tmp$ret$66);
    var tmp_45 = PreyUponCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$69 = [];
    var tmp_46 = ObjectSerializer.l1c('PreyUponCard', tmp_45, tmp$ret$69);
    var tmp_47 = RambleCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$72 = [];
    var tmp_48 = ObjectSerializer.l1c('RambleCard', tmp_47, tmp$ret$72);
    var tmp_49 = IncinerateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$75 = [];
    var tmp_50 = ObjectSerializer.l1c('IncinerateCard', tmp_49, tmp$ret$75);
    var tmp_51 = RiseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$78 = [];
    var tmp_52 = ObjectSerializer.l1c('RiseCard', tmp_51, tmp$ret$78);
    var tmp_53 = ScorchedEarthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [];
    var tmp_54 = ObjectSerializer.l1c('ScorchedEarthCard', tmp_53, tmp$ret$81);
    var tmp_55 = SummonLindwyrmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$84 = [];
    var tmp_56 = ObjectSerializer.l1c('SummonLindwyrmCard', tmp_55, tmp$ret$84);
    var tmp_57 = ShadowStepCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$87 = [];
    var tmp_58 = ObjectSerializer.l1c('ShadowStepCard', tmp_57, tmp$ret$87);
    var tmp_59 = SlitherCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$90 = [];
    var tmp_60 = ObjectSerializer.l1c('SlitherCard', tmp_59, tmp$ret$90);
    var tmp_61 = SpookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [];
    var tmp_62 = ObjectSerializer.l1c('SpookCard', tmp_61, tmp$ret$93);
    var tmp_63 = StalkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [];
    var tmp_64 = ObjectSerializer.l1c('StalkCard', tmp_63, tmp$ret$96);
    var tmp_65 = StampedeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [];
    var tmp_66 = ObjectSerializer.l1c('StampedeCard', tmp_65, tmp$ret$99);
    var tmp_67 = StormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [];
    var tmp_68 = ObjectSerializer.l1c('StormCard', tmp_67, tmp$ret$102);
    var tmp_69 = SummonBasiliskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [];
    var tmp_70 = ObjectSerializer.l1c('SummonBasiliskCard', tmp_69, tmp$ret$105);
    var tmp_71 = SummonChangelingCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$108 = [];
    var tmp_72 = ObjectSerializer.l1c('SummonChangelingCard', tmp_71, tmp$ret$108);
    var tmp_73 = SummonDreamerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$111 = [];
    var tmp_74 = ObjectSerializer.l1c('SummonDreamerCard', tmp_73, tmp$ret$111);
    var tmp_75 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$114 = [];
    var tmp_76 = ObjectSerializer.l1c('SummonEyeCard', tmp_75, tmp$ret$114);
    var tmp_77 = SummonPolypCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$117 = [];
    var tmp_78 = ObjectSerializer.l1c('SummonPolypCard', tmp_77, tmp$ret$117);
    var tmp_79 = SummonWarhogCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$120 = [];
    var tmp_80 = ObjectSerializer.l1c('SummonWarhogCard', tmp_79, tmp$ret$120);
    var tmp_81 = SummonWolfCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$123 = [];
    var tmp_82 = ObjectSerializer.l1c('SummonWolfCard', tmp_81, tmp$ret$123);
    var tmp_83 = SummonYagiCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$126 = [];
    var tmp_84 = ObjectSerializer.l1c('SummonYagiCard', tmp_83, tmp$ret$126);
    var tmp_85 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$129 = [];
    var tmp_86 = ObjectSerializer.l1c('SummonEyeCard', tmp_85, tmp$ret$129);
    var tmp_87 = TuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$132 = [];
    var tmp_88 = ObjectSerializer.l1c('TuskCard', tmp_87, tmp$ret$132);
    var tmp_89 = UnburdenCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$135 = [];
    var tmp_90 = ObjectSerializer.l1c('UnburdenCard', tmp_89, tmp$ret$135);
    var tmp_91 = UnwillingSacrificeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$138 = [];
    var tmp_92 = ObjectSerializer.l1c('UnwillingSacrificeCard', tmp_91, tmp$ret$138);
    var tmp_93 = UpriseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$141 = [];
    var tmp_94 = ObjectSerializer.l1c('UpriseCard', tmp_93, tmp$ret$141);
    var tmp_95 = NestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$144 = [];
    var tmp_96 = ObjectSerializer.l1c('NestCard', tmp_95, tmp$ret$144);
    var tmp_97 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$147 = [];
    var tmp_98 = ObjectSerializer.l1c('OverloadedNestCard', tmp_97, tmp$ret$147);
    var tmp_99 = OvipunctureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$150 = [];
    var tmp_100 = ObjectSerializer.l1c('OvipunctureCard', tmp_99, tmp$ret$150);
    var tmp_101 = SilkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$153 = [];
    var tmp_102 = ObjectSerializer.l1c('SilkCard', tmp_101, tmp$ret$153);
    var tmp_103 = SummonEggCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$156 = [];
    var tmp_104 = ObjectSerializer.l1c('SummonEggCard', tmp_103, tmp$ret$156);
    var tmp_105 = AllureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$159 = [];
    var tmp_106 = ObjectSerializer.l1c('AllureCard', tmp_105, tmp$ret$159);
    var tmp_107 = BeholdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$162 = [];
    var tmp_108 = ObjectSerializer.l1c('BeholdCard', tmp_107, tmp$ret$162);
    var tmp_109 = EludeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$165 = [];
    var tmp_110 = ObjectSerializer.l1c('EludeCard', tmp_109, tmp$ret$165);
    var tmp_111 = SummonAdmirerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$168 = [];
    var tmp_112 = ObjectSerializer.l1c('SummonAdmirerCard', tmp_111, tmp$ret$168);
    var tmp_113 = VoidCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$171 = [];
    var tmp_114 = ObjectSerializer.l1c('VoidCard', tmp_113, tmp$ret$171);
    var tmp_115 = BleatCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$174 = [];
    var tmp_116 = ObjectSerializer.l1c('BleatCard', tmp_115, tmp$ret$174);
    var tmp_117 = AviationCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$177 = [];
    var tmp_118 = ObjectSerializer.l1c('AviationCard', tmp_117, tmp$ret$177);
    var tmp_119 = BerserkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$180 = [];
    var tmp_120 = ObjectSerializer.l1c('BerserkCard', tmp_119, tmp$ret$180);
    var tmp_121 = CleaverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$183 = [];
    var tmp_122 = ObjectSerializer.l1c('CleaverCard', tmp_121, tmp$ret$183);
    var tmp_123 = CommandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$186 = [];
    var tmp_124 = ObjectSerializer.l1c('CommandCard', tmp_123, tmp$ret$186);
    var tmp_125 = DelegateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$189 = [];
    var tmp_126 = ObjectSerializer.l1c('DelegateCard', tmp_125, tmp$ret$189);
    var tmp_127 = FlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$192 = [];
    var tmp_128 = ObjectSerializer.l1c('FlameRapierCard', tmp_127, tmp$ret$192);
    var tmp_129 = GrapplingHookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$195 = [];
    var tmp_130 = ObjectSerializer.l1c('GrapplingHookCard', tmp_129, tmp$ret$195);
    var tmp_131 = HerdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$198 = [];
    var tmp_132 = ObjectSerializer.l1c('HerdCard', tmp_131, tmp$ret$198);
    var tmp_133 = BindingHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$201 = [];
    var tmp_134 = ObjectSerializer.l1c('BindingHuntCard', tmp_133, tmp$ret$201);
    var tmp_135 = BloodHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$204 = [];
    var tmp_136 = ObjectSerializer.l1c('BloodHuntCard', tmp_135, tmp$ret$204);
    var tmp_137 = $serializer_getInstance_327();
    var tmp_138 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$207 = [];
    var tmp_139 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_138, tmp$ret$207);
    var tmp_140 = IncisionCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$210 = [];
    var tmp_141 = ObjectSerializer.l1c('IncisionCard', tmp_140, tmp$ret$210);
    var tmp_142 = MountCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$213 = [];
    var tmp_143 = ObjectSerializer.l1c('MountCard', tmp_142, tmp$ret$213);
    var tmp_144 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$216 = [];
    var tmp_145 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_144, tmp$ret$216);
    var tmp_146 = ScoutCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$219 = [];
    var tmp_147 = ObjectSerializer.l1c('ScoutCard', tmp_146, tmp$ret$219);
    var tmp_148 = SeerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$222 = [];
    var tmp_149 = ObjectSerializer.l1c('SeerCard', tmp_148, tmp$ret$222);
    var tmp_150 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$225 = [];
    var tmp_151 = ObjectSerializer.l1c('BondedTrackCard', tmp_150, tmp$ret$225);
    var tmp_152 = ScroungeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$228 = [];
    var tmp_153 = ObjectSerializer.l1c('ScroungeCard', tmp_152, tmp$ret$228);
    var tmp_154 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$231 = [];
    var tmp_155 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_154, tmp$ret$231);
    var tmp_156 = SilverArrowCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$234 = [];
    var tmp_157 = ObjectSerializer.l1c('SilverArrowCard', tmp_156, tmp$ret$234);
    var tmp_158 = BloodTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$237 = [];
    var tmp_159 = ObjectSerializer.l1c('BloodTrackCard', tmp_158, tmp$ret$237);
    var tmp_160 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$240 = [];
    var tmp_161 = ObjectSerializer.l1c('BondedTrackCard', tmp_160, tmp$ret$240);
    var tmp_162 = $serializer_getInstance_326();
    var tmp_163 = TrapmasterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$243 = [];
    var tmp_164 = ObjectSerializer.l1c('TrapmasterCard', tmp_163, tmp$ret$243);
    var tmp_165 = UnnaturalResolveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$246 = [];
    var tmp_166 = ObjectSerializer.l1c('UnnaturalResolveCard', tmp_165, tmp$ret$246);
    var tmp_167 = WardCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$249 = [];
    var tmp_168 = ObjectSerializer.l1c('WardCard', tmp_167, tmp$ret$249);
    var tmp_169 = MistShroudCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$252 = [];
    var tmp_170 = ObjectSerializer.l1c('MistShroudCard', tmp_169, tmp$ret$252);
    var tmp_171 = Ruin1_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$255 = [];
    var tmp_172 = ObjectSerializer.l1c('Ruin1', tmp_171, tmp$ret$255);
    var tmp_173 = Ruin10_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$258 = [];
    var tmp_174 = ObjectSerializer.l1c('Ruin10', tmp_173, tmp$ret$258);
    var tmp_175 = Ruin11_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$261 = [];
    var tmp_176 = ObjectSerializer.l1c('Ruin11', tmp_175, tmp$ret$261);
    var tmp_177 = Ruin12_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$264 = [];
    var tmp_178 = ObjectSerializer.l1c('Ruin12', tmp_177, tmp$ret$264);
    var tmp_179 = Ruin2_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$267 = [];
    var tmp_180 = ObjectSerializer.l1c('Ruin2', tmp_179, tmp$ret$267);
    var tmp_181 = Ruin3_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$270 = [];
    var tmp_182 = ObjectSerializer.l1c('Ruin3', tmp_181, tmp$ret$270);
    var tmp_183 = Ruin4_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$273 = [];
    var tmp_184 = ObjectSerializer.l1c('Ruin4', tmp_183, tmp$ret$273);
    var tmp_185 = Ruin5_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$276 = [];
    var tmp_186 = ObjectSerializer.l1c('Ruin5', tmp_185, tmp$ret$276);
    var tmp_187 = Ruin6_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$279 = [];
    var tmp_188 = ObjectSerializer.l1c('Ruin6', tmp_187, tmp$ret$279);
    var tmp_189 = Ruin7_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$282 = [];
    var tmp_190 = ObjectSerializer.l1c('Ruin7', tmp_189, tmp$ret$282);
    var tmp_191 = Ruin8_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$285 = [];
    var tmp_192 = ObjectSerializer.l1c('Ruin8', tmp_191, tmp$ret$285);
    var tmp_193 = Ruin9_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$288 = [];
    var tmp_194 = ObjectSerializer.l1c('Ruin9', tmp_193, tmp$ret$288);
    var tmp_195 = $serializer_getInstance_74();
    var tmp_196 = $serializer_getInstance_84();
    var tmp_197 = AbruptDecayCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$291 = [];
    var tmp_198 = ObjectSerializer.l1c('AbruptDecayCard', tmp_197, tmp$ret$291);
    var tmp_199 = $serializer_getInstance_88();
    var tmp_200 = DisappearCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$294 = [];
    var tmp_201 = ObjectSerializer.l1c('DisappearCard', tmp_200, tmp$ret$294);
    var tmp_202 = $serializer_getInstance_92();
    var tmp_203 = $serializer_getInstance_86();
    var tmp_204 = $serializer_getInstance_96();
    var tmp_205 = $serializer_getInstance_97();
    var tmp_206 = FuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$297 = [];
    var tmp_207 = ObjectSerializer.l1c('FuryCard', tmp_206, tmp$ret$297);
    var tmp_208 = $serializer_getInstance_91();
    var tmp_209 = $serializer_getInstance_93();
    var tmp_210 = $serializer_getInstance_98();
    var tmp_211 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$300 = [];
    var tmp_212 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_211, tmp$ret$300);
    var tmp_213 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$303 = [];
    var tmp_214 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_213, tmp$ret$303);
    var tmp_215 = $serializer_getInstance_89();
    var tmp_216 = $serializer_getInstance_378();
    var tmp_217 = $serializer_getInstance_94();
    var tmp_218 = ShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$306 = [];
    var tmp_219 = ObjectSerializer.l1c('ShatterCard', tmp_218, tmp$ret$306);
    var tmp_220 = $serializer_getInstance_95();
    var tmp_221 = $serializer_getInstance_90();
    var tmp_222 = SwarmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$309 = [];
    var tmp_223 = ObjectSerializer.l1c('SwarmCard', tmp_222, tmp$ret$309);
    var tmp_224 = $serializer_getInstance_87();
    var tmp_225 = RecoveryTestBeastReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$312 = [];
    var tmp_226 = ObjectSerializer.l1c('RecoveryTestBeastReaction', tmp_225, tmp$ret$312);
    var tmp_227 = RecoveryTestNightlyRewardsFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$315 = [];
    var tmp_228 = ObjectSerializer.l1c('RecoveryTestNightlyRewardsFailureCard', tmp_227, tmp$ret$315);
    var tmp_229 = RecoveryTestPhaseFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$318 = [];
    var tmp_230 = ObjectSerializer.l1c('RecoveryTestPhaseFailureCard', tmp_229, tmp$ret$318);
    var tmp_231 = RecoveryTestTeamRewardFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$321 = [];
    var tmp_232 = ObjectSerializer.l1c('RecoveryTestTeamRewardFailureCard', tmp_231, tmp$ret$321);
    var tmp_233 = SuddenMistCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$324 = [];
    var tmp_234 = ObjectSerializer.l1c('SuddenMistCard', tmp_233, tmp$ret$324);
    var tmp_235 = $serializer_getInstance_99();
    var tmp_236 = $serializer_getInstance_85();
    var tmp_237 = $serializer_getInstance_329();
    var tmp_238 = EsmeriasStrandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$327 = [];
    var tmp_239 = ObjectSerializer.l1c('EsmeriasStrandCard', tmp_238, tmp$ret$327);
    var tmp_240 = $serializer_getInstance_330();
    var tmp_241 = AurorasPassage_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$330 = [];
    var tmp_242 = ObjectSerializer.l1c('AurorasPassage', tmp_241, tmp$ret$330);
    var tmp_243 = BansheesLureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$333 = [];
    var tmp_244 = ObjectSerializer.l1c('BansheesLureCard', tmp_243, tmp$ret$333);
    var tmp_245 = BladeOfValhCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$336 = [];
    var tmp_246 = ObjectSerializer.l1c('BladeOfValhCard', tmp_245, tmp$ret$336);
    var tmp_247 = ChainGrapnelCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$339 = [];
    var tmp_248 = ObjectSerializer.l1c('ChainGrapnelCard', tmp_247, tmp$ret$339);
    var tmp_249 = $serializer_getInstance_339();
    var tmp_250 = GrapeshotCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$342 = [];
    var tmp_251 = ObjectSerializer.l1c('GrapeshotCard', tmp_250, tmp$ret$342);
    var tmp_252 = $serializer_getInstance_337();
    var tmp_253 = $serializer_getInstance_338();
    var tmp_254 = $serializer_getInstance_336();
    var tmp_255 = $serializer_getInstance_334();
    var tmp_256 = $serializer_getInstance_379();
    var tmp_257 = $serializer_getInstance_341();
    var tmp_258 = SpyglassCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$345 = [];
    var tmp_259 = ObjectSerializer.l1c('SpyglassCard', tmp_258, tmp$ret$345);
    var tmp_260 = $serializer_getInstance_333();
    var tmp_261 = $serializer_getInstance_332();
    var tmp_262 = $serializer_getInstance_340();
    var tmp_263 = $serializer_getInstance_328();
    var tmp_264 = WarhogsTuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$348 = [];
    var tmp_265 = ObjectSerializer.l1c('WarhogsTuskCard', tmp_264, tmp$ret$348);
    var tmp_266 = $serializer_getInstance_335();
    var tmp_267 = RecoveryTestHunterReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$351 = [];
    var tmp_268 = ObjectSerializer.l1c('RecoveryTestHunterReaction', tmp_267, tmp$ret$351);
    var tmp_269 = $serializer_getInstance_331();
    var tmp_270 = $serializer_getInstance_343();
    var tmp_271 = $serializer_getInstance_378();
    var tmp_272 = $serializer_getInstance_379();
    var tmp_273 = Ruin1_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$354 = [];
    var tmp_274 = ObjectSerializer.l1c('Ruin1', tmp_273, tmp$ret$354);
    var tmp_275 = Ruin10_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$357 = [];
    var tmp_276 = ObjectSerializer.l1c('Ruin10', tmp_275, tmp$ret$357);
    var tmp_277 = Ruin11_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$360 = [];
    var tmp_278 = ObjectSerializer.l1c('Ruin11', tmp_277, tmp$ret$360);
    var tmp_279 = Ruin12_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$363 = [];
    var tmp_280 = ObjectSerializer.l1c('Ruin12', tmp_279, tmp$ret$363);
    var tmp_281 = Ruin2_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$366 = [];
    var tmp_282 = ObjectSerializer.l1c('Ruin2', tmp_281, tmp$ret$366);
    var tmp_283 = Ruin3_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$369 = [];
    var tmp_284 = ObjectSerializer.l1c('Ruin3', tmp_283, tmp$ret$369);
    var tmp_285 = Ruin4_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$372 = [];
    var tmp_286 = ObjectSerializer.l1c('Ruin4', tmp_285, tmp$ret$372);
    var tmp_287 = Ruin5_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$375 = [];
    var tmp_288 = ObjectSerializer.l1c('Ruin5', tmp_287, tmp$ret$375);
    var tmp_289 = Ruin6_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$378 = [];
    var tmp_290 = ObjectSerializer.l1c('Ruin6', tmp_289, tmp$ret$378);
    var tmp_291 = Ruin7_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$381 = [];
    var tmp_292 = ObjectSerializer.l1c('Ruin7', tmp_291, tmp$ret$381);
    var tmp_293 = Ruin8_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$384 = [];
    var tmp_294 = ObjectSerializer.l1c('Ruin8', tmp_293, tmp$ret$384);
    var tmp_295 = Ruin9_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$387 = [];
    var tmp_296 = ObjectSerializer.l1c('Ruin9', tmp_295, tmp$ret$387);
    var tmp_297 = AcclivityCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$390 = [];
    var tmp_298 = ObjectSerializer.l1c('AcclivityCard', tmp_297, tmp$ret$390);
    var tmp_299 = BeastlyTongueCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$393 = [];
    var tmp_300 = ObjectSerializer.l1c('BeastlyTongueCard', tmp_299, tmp$ret$393);
    var tmp_301 = ConsumeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$396 = [];
    var tmp_302 = ObjectSerializer.l1c('ConsumeCard', tmp_301, tmp$ret$396);
    var tmp_303 = CorruptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$399 = [];
    var tmp_304 = ObjectSerializer.l1c('CorruptCard', tmp_303, tmp$ret$399);
    var tmp_305 = DeceiveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$402 = [];
    var tmp_306 = ObjectSerializer.l1c('DeceiveCard', tmp_305, tmp$ret$402);
    var tmp_307 = DefileCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$405 = [];
    var tmp_308 = ObjectSerializer.l1c('DefileCard', tmp_307, tmp$ret$405);
    var tmp_309 = DismemberCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$408 = [];
    var tmp_310 = ObjectSerializer.l1c('DismemberCard', tmp_309, tmp$ret$408);
    var tmp_311 = EngorgeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$411 = [];
    var tmp_312 = ObjectSerializer.l1c('EngorgeCard', tmp_311, tmp$ret$411);
    var tmp_313 = FeedCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$414 = [];
    var tmp_314 = ObjectSerializer.l1c('FeedCard', tmp_313, tmp$ret$414);
    var tmp_315 = FlickerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$417 = [];
    var tmp_316 = ObjectSerializer.l1c('FlickerCard', tmp_315, tmp$ret$417);
    var tmp_317 = FloodCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$420 = [];
    var tmp_318 = ObjectSerializer.l1c('FloodCard', tmp_317, tmp$ret$420);
    var tmp_319 = GatherThePackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$423 = [];
    var tmp_320 = ObjectSerializer.l1c('GatherThePackCard', tmp_319, tmp$ret$423);
    var tmp_321 = HydraCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$426 = [];
    var tmp_322 = ObjectSerializer.l1c('HydraCard', tmp_321, tmp$ret$426);
    var tmp_323 = LeapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$429 = [];
    var tmp_324 = ObjectSerializer.l1c('LeapCard', tmp_323, tmp$ret$429);
    var tmp_325 = LurkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$432 = [];
    var tmp_326 = ObjectSerializer.l1c('LurkCard', tmp_325, tmp$ret$432);
    var tmp_327 = BoltAndRecallCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$435 = [];
    var tmp_328 = ObjectSerializer.l1c('BoltAndRecallCard', tmp_327, tmp$ret$435);
    var tmp_329 = SoulReapCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$438 = [];
    var tmp_330 = ObjectSerializer.l1c('SoulReapCard', tmp_329, tmp$ret$438);
    var tmp_331 = SummonYeltrCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$441 = [];
    var tmp_332 = ObjectSerializer.l1c('SummonYeltrCard', tmp_331, tmp$ret$441);
    var tmp_333 = ToothAndSeverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$444 = [];
    var tmp_334 = ObjectSerializer.l1c('ToothAndSeverCard', tmp_333, tmp$ret$444);
    var tmp_335 = MurderCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$447 = [];
    var tmp_336 = ObjectSerializer.l1c('MurderCard', tmp_335, tmp$ret$447);
    var tmp_337 = ObscureTalentCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$450 = [];
    var tmp_338 = ObjectSerializer.l1c('ObscureTalentCard', tmp_337, tmp$ret$450);
    var tmp_339 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$453 = [];
    var tmp_340 = ObjectSerializer.l1c('OverloadedStormCard', tmp_339, tmp$ret$453);
    var tmp_341 = PreyUponCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$456 = [];
    var tmp_342 = ObjectSerializer.l1c('PreyUponCard', tmp_341, tmp$ret$456);
    var tmp_343 = RambleCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$459 = [];
    var tmp_344 = ObjectSerializer.l1c('RambleCard', tmp_343, tmp$ret$459);
    var tmp_345 = IncinerateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$462 = [];
    var tmp_346 = ObjectSerializer.l1c('IncinerateCard', tmp_345, tmp$ret$462);
    var tmp_347 = RiseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$465 = [];
    var tmp_348 = ObjectSerializer.l1c('RiseCard', tmp_347, tmp$ret$465);
    var tmp_349 = ScorchedEarthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$468 = [];
    var tmp_350 = ObjectSerializer.l1c('ScorchedEarthCard', tmp_349, tmp$ret$468);
    var tmp_351 = SummonLindwyrmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$471 = [];
    var tmp_352 = ObjectSerializer.l1c('SummonLindwyrmCard', tmp_351, tmp$ret$471);
    var tmp_353 = ShadowStepCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$474 = [];
    var tmp_354 = ObjectSerializer.l1c('ShadowStepCard', tmp_353, tmp$ret$474);
    var tmp_355 = SlitherCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$477 = [];
    var tmp_356 = ObjectSerializer.l1c('SlitherCard', tmp_355, tmp$ret$477);
    var tmp_357 = SpookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$480 = [];
    var tmp_358 = ObjectSerializer.l1c('SpookCard', tmp_357, tmp$ret$480);
    var tmp_359 = StalkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$483 = [];
    var tmp_360 = ObjectSerializer.l1c('StalkCard', tmp_359, tmp$ret$483);
    var tmp_361 = StampedeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$486 = [];
    var tmp_362 = ObjectSerializer.l1c('StampedeCard', tmp_361, tmp$ret$486);
    var tmp_363 = StormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$489 = [];
    var tmp_364 = ObjectSerializer.l1c('StormCard', tmp_363, tmp$ret$489);
    var tmp_365 = SummonBasiliskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$492 = [];
    var tmp_366 = ObjectSerializer.l1c('SummonBasiliskCard', tmp_365, tmp$ret$492);
    var tmp_367 = SummonChangelingCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$495 = [];
    var tmp_368 = ObjectSerializer.l1c('SummonChangelingCard', tmp_367, tmp$ret$495);
    var tmp_369 = SummonDreamerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$498 = [];
    var tmp_370 = ObjectSerializer.l1c('SummonDreamerCard', tmp_369, tmp$ret$498);
    var tmp_371 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$501 = [];
    var tmp_372 = ObjectSerializer.l1c('SummonEyeCard', tmp_371, tmp$ret$501);
    var tmp_373 = SummonPolypCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$504 = [];
    var tmp_374 = ObjectSerializer.l1c('SummonPolypCard', tmp_373, tmp$ret$504);
    var tmp_375 = SummonWarhogCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$507 = [];
    var tmp_376 = ObjectSerializer.l1c('SummonWarhogCard', tmp_375, tmp$ret$507);
    var tmp_377 = SummonWolfCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$510 = [];
    var tmp_378 = ObjectSerializer.l1c('SummonWolfCard', tmp_377, tmp$ret$510);
    var tmp_379 = SummonYagiCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$513 = [];
    var tmp_380 = ObjectSerializer.l1c('SummonYagiCard', tmp_379, tmp$ret$513);
    var tmp_381 = SummonEyeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$516 = [];
    var tmp_382 = ObjectSerializer.l1c('SummonEyeCard', tmp_381, tmp$ret$516);
    var tmp_383 = TuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$519 = [];
    var tmp_384 = ObjectSerializer.l1c('TuskCard', tmp_383, tmp$ret$519);
    var tmp_385 = UnburdenCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$522 = [];
    var tmp_386 = ObjectSerializer.l1c('UnburdenCard', tmp_385, tmp$ret$522);
    var tmp_387 = UnwillingSacrificeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$525 = [];
    var tmp_388 = ObjectSerializer.l1c('UnwillingSacrificeCard', tmp_387, tmp$ret$525);
    var tmp_389 = UpriseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$528 = [];
    var tmp_390 = ObjectSerializer.l1c('UpriseCard', tmp_389, tmp$ret$528);
    var tmp_391 = NestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$531 = [];
    var tmp_392 = ObjectSerializer.l1c('NestCard', tmp_391, tmp$ret$531);
    var tmp_393 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$534 = [];
    var tmp_394 = ObjectSerializer.l1c('OverloadedNestCard', tmp_393, tmp$ret$534);
    var tmp_395 = OvipunctureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$537 = [];
    var tmp_396 = ObjectSerializer.l1c('OvipunctureCard', tmp_395, tmp$ret$537);
    var tmp_397 = SilkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$540 = [];
    var tmp_398 = ObjectSerializer.l1c('SilkCard', tmp_397, tmp$ret$540);
    var tmp_399 = SummonEggCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$543 = [];
    var tmp_400 = ObjectSerializer.l1c('SummonEggCard', tmp_399, tmp$ret$543);
    var tmp_401 = AllureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$546 = [];
    var tmp_402 = ObjectSerializer.l1c('AllureCard', tmp_401, tmp$ret$546);
    var tmp_403 = BeholdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$549 = [];
    var tmp_404 = ObjectSerializer.l1c('BeholdCard', tmp_403, tmp$ret$549);
    var tmp_405 = EludeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$552 = [];
    var tmp_406 = ObjectSerializer.l1c('EludeCard', tmp_405, tmp$ret$552);
    var tmp_407 = SummonAdmirerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$555 = [];
    var tmp_408 = ObjectSerializer.l1c('SummonAdmirerCard', tmp_407, tmp$ret$555);
    var tmp_409 = VoidCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$558 = [];
    var tmp_410 = ObjectSerializer.l1c('VoidCard', tmp_409, tmp$ret$558);
    var tmp_411 = AdaptCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$561 = [];
    var tmp_412 = ObjectSerializer.l1c('AdaptCard', tmp_411, tmp$ret$561);
    var tmp_413 = AnimateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$564 = [];
    var tmp_414 = ObjectSerializer.l1c('AnimateCard', tmp_413, tmp$ret$564);
    var tmp_415 = AvariceCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$567 = [];
    var tmp_416 = ObjectSerializer.l1c('AvariceCard', tmp_415, tmp$ret$567);
    var tmp_417 = BolsterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$570 = [];
    var tmp_418 = ObjectSerializer.l1c('BolsterCard', tmp_417, tmp$ret$570);
    var tmp_419 = ChargeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$573 = [];
    var tmp_420 = ObjectSerializer.l1c('ChargeCard', tmp_419, tmp$ret$573);
    var tmp_421 = DashCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$576 = [];
    var tmp_422 = ObjectSerializer.l1c('DashCard', tmp_421, tmp$ret$576);
    var tmp_423 = DisplaceCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$579 = [];
    var tmp_424 = ObjectSerializer.l1c('DisplaceCard', tmp_423, tmp$ret$579);
    var tmp_425 = DarkDealingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$582 = [];
    var tmp_426 = ObjectSerializer.l1c('DarkDealingsCard', tmp_425, tmp$ret$582);
    var tmp_427 = DarkOfferingsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$585 = [];
    var tmp_428 = ObjectSerializer.l1c('DarkOfferingsCard', tmp_427, tmp$ret$585);
    var tmp_429 = DarkRitualsCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$588 = [];
    var tmp_430 = ObjectSerializer.l1c('DarkRitualsCard', tmp_429, tmp$ret$588);
    var tmp_431 = EnsnareCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$591 = [];
    var tmp_432 = ObjectSerializer.l1c('EnsnareCard', tmp_431, tmp$ret$591);
    var tmp_433 = GlimpseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$594 = [];
    var tmp_434 = ObjectSerializer.l1c('GlimpseCard', tmp_433, tmp$ret$594);
    var tmp_435 = HasteCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$597 = [];
    var tmp_436 = ObjectSerializer.l1c('HasteCard', tmp_435, tmp$ret$597);
    var tmp_437 = HiddenPassageCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$600 = [];
    var tmp_438 = ObjectSerializer.l1c('HiddenPassageCard', tmp_437, tmp$ret$600);
    var tmp_439 = InciteCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$603 = [];
    var tmp_440 = ObjectSerializer.l1c('InciteCard', tmp_439, tmp$ret$603);
    var tmp_441 = ProwlCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$606 = [];
    var tmp_442 = ObjectSerializer.l1c('ProwlCard', tmp_441, tmp$ret$606);
    var tmp_443 = PursuitCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$609 = [];
    var tmp_444 = ObjectSerializer.l1c('PursuitCard', tmp_443, tmp$ret$609);
    var tmp_445 = RushCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$612 = [];
    var tmp_446 = ObjectSerializer.l1c('RushCard', tmp_445, tmp$ret$612);
    var tmp_447 = StrideCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$615 = [];
    var tmp_448 = ObjectSerializer.l1c('StrideCard', tmp_447, tmp$ret$615);
    var tmp_449 = UnearthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$618 = [];
    var tmp_450 = ObjectSerializer.l1c('UnearthCard', tmp_449, tmp$ret$618);
    var tmp_451 = $serializer_getInstance_127();
    var tmp_452 = AviationCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$621 = [];
    var tmp_453 = ObjectSerializer.l1c('AviationCard', tmp_452, tmp$ret$621);
    var tmp_454 = BerserkCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$624 = [];
    var tmp_455 = ObjectSerializer.l1c('BerserkCard', tmp_454, tmp$ret$624);
    var tmp_456 = CleaverCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$627 = [];
    var tmp_457 = ObjectSerializer.l1c('CleaverCard', tmp_456, tmp$ret$627);
    var tmp_458 = CommandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$630 = [];
    var tmp_459 = ObjectSerializer.l1c('CommandCard', tmp_458, tmp$ret$630);
    var tmp_460 = DelegateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$633 = [];
    var tmp_461 = ObjectSerializer.l1c('DelegateCard', tmp_460, tmp$ret$633);
    var tmp_462 = FlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$636 = [];
    var tmp_463 = ObjectSerializer.l1c('FlameRapierCard', tmp_462, tmp$ret$636);
    var tmp_464 = GrapplingHookCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$639 = [];
    var tmp_465 = ObjectSerializer.l1c('GrapplingHookCard', tmp_464, tmp$ret$639);
    var tmp_466 = HerdCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$642 = [];
    var tmp_467 = ObjectSerializer.l1c('HerdCard', tmp_466, tmp$ret$642);
    var tmp_468 = BindingHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$645 = [];
    var tmp_469 = ObjectSerializer.l1c('BindingHuntCard', tmp_468, tmp$ret$645);
    var tmp_470 = BloodHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$648 = [];
    var tmp_471 = ObjectSerializer.l1c('BloodHuntCard', tmp_470, tmp$ret$648);
    var tmp_472 = $serializer_getInstance_327();
    var tmp_473 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$651 = [];
    var tmp_474 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_473, tmp$ret$651);
    var tmp_475 = IncisionCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$654 = [];
    var tmp_476 = ObjectSerializer.l1c('IncisionCard', tmp_475, tmp$ret$654);
    var tmp_477 = MountCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$657 = [];
    var tmp_478 = ObjectSerializer.l1c('MountCard', tmp_477, tmp$ret$657);
    var tmp_479 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$660 = [];
    var tmp_480 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_479, tmp$ret$660);
    var tmp_481 = ScoutCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$663 = [];
    var tmp_482 = ObjectSerializer.l1c('ScoutCard', tmp_481, tmp$ret$663);
    var tmp_483 = SeerCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$666 = [];
    var tmp_484 = ObjectSerializer.l1c('SeerCard', tmp_483, tmp$ret$666);
    var tmp_485 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$669 = [];
    var tmp_486 = ObjectSerializer.l1c('BondedTrackCard', tmp_485, tmp$ret$669);
    var tmp_487 = ScroungeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$672 = [];
    var tmp_488 = ObjectSerializer.l1c('ScroungeCard', tmp_487, tmp$ret$672);
    var tmp_489 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$675 = [];
    var tmp_490 = ObjectSerializer.l1c('TraitorsHuntCard', tmp_489, tmp$ret$675);
    var tmp_491 = SilverArrowCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$678 = [];
    var tmp_492 = ObjectSerializer.l1c('SilverArrowCard', tmp_491, tmp$ret$678);
    var tmp_493 = BloodTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$681 = [];
    var tmp_494 = ObjectSerializer.l1c('BloodTrackCard', tmp_493, tmp$ret$681);
    var tmp_495 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$684 = [];
    var tmp_496 = ObjectSerializer.l1c('BondedTrackCard', tmp_495, tmp$ret$684);
    var tmp_497 = $serializer_getInstance_326();
    var tmp_498 = TrapmasterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$687 = [];
    var tmp_499 = ObjectSerializer.l1c('TrapmasterCard', tmp_498, tmp$ret$687);
    var tmp_500 = UnnaturalResolveCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$690 = [];
    var tmp_501 = ObjectSerializer.l1c('UnnaturalResolveCard', tmp_500, tmp$ret$690);
    var tmp_502 = WardCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$693 = [];
    var tmp_503 = ObjectSerializer.l1c('WardCard', tmp_502, tmp$ret$693);
    var tmp_504 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$696 = [];
    var tmp_505 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_504, tmp$ret$696);
    var tmp_506 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$699 = [];
    var tmp_507 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_506, tmp$ret$699);
    var tmp_508 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$702 = [];
    var tmp_509 = ObjectSerializer.l1c('OverloadedNestCard', tmp_508, tmp$ret$702);
    var tmp_510 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$705 = [];
    var tmp_511 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_510, tmp$ret$705);
    var tmp_512 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$708 = [];
    var tmp_513 = ObjectSerializer.l1c('OverloadedStormCard', tmp_512, tmp$ret$708);
    var tmp_514 = AbruptDecayCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$711 = [];
    var tmp_515 = ObjectSerializer.l1c('AbruptDecayCard', tmp_514, tmp$ret$711);
    var tmp_516 = $serializer_getInstance_88();
    var tmp_517 = DisappearCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$714 = [];
    var tmp_518 = ObjectSerializer.l1c('DisappearCard', tmp_517, tmp$ret$714);
    var tmp_519 = $serializer_getInstance_92();
    var tmp_520 = $serializer_getInstance_86();
    var tmp_521 = $serializer_getInstance_96();
    var tmp_522 = $serializer_getInstance_97();
    var tmp_523 = FuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$717 = [];
    var tmp_524 = ObjectSerializer.l1c('FuryCard', tmp_523, tmp$ret$717);
    var tmp_525 = $serializer_getInstance_91();
    var tmp_526 = $serializer_getInstance_93();
    var tmp_527 = $serializer_getInstance_98();
    var tmp_528 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$720 = [];
    var tmp_529 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_528, tmp$ret$720);
    var tmp_530 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$723 = [];
    var tmp_531 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_530, tmp$ret$723);
    var tmp_532 = $serializer_getInstance_89();
    var tmp_533 = $serializer_getInstance_378();
    var tmp_534 = $serializer_getInstance_94();
    var tmp_535 = ShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$726 = [];
    var tmp_536 = ObjectSerializer.l1c('ShatterCard', tmp_535, tmp$ret$726);
    var tmp_537 = $serializer_getInstance_95();
    var tmp_538 = $serializer_getInstance_90();
    var tmp_539 = SwarmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$729 = [];
    var tmp_540 = ObjectSerializer.l1c('SwarmCard', tmp_539, tmp$ret$729);
    var tmp_541 = $serializer_getInstance_87();
    var tmp_542 = AurorasPassage_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$732 = [];
    var tmp_543 = ObjectSerializer.l1c('AurorasPassage', tmp_542, tmp$ret$732);
    var tmp_544 = BansheesLureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$735 = [];
    var tmp_545 = ObjectSerializer.l1c('BansheesLureCard', tmp_544, tmp$ret$735);
    var tmp_546 = BladeOfValhCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$738 = [];
    var tmp_547 = ObjectSerializer.l1c('BladeOfValhCard', tmp_546, tmp$ret$738);
    var tmp_548 = ChainGrapnelCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$741 = [];
    var tmp_549 = ObjectSerializer.l1c('ChainGrapnelCard', tmp_548, tmp$ret$741);
    var tmp_550 = $serializer_getInstance_339();
    var tmp_551 = GrapeshotCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$744 = [];
    var tmp_552 = ObjectSerializer.l1c('GrapeshotCard', tmp_551, tmp$ret$744);
    var tmp_553 = $serializer_getInstance_337();
    var tmp_554 = $serializer_getInstance_338();
    var tmp_555 = $serializer_getInstance_336();
    var tmp_556 = $serializer_getInstance_334();
    var tmp_557 = $serializer_getInstance_379();
    var tmp_558 = $serializer_getInstance_341();
    var tmp_559 = SpyglassCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$747 = [];
    var tmp_560 = ObjectSerializer.l1c('SpyglassCard', tmp_559, tmp$ret$747);
    var tmp_561 = $serializer_getInstance_333();
    var tmp_562 = $serializer_getInstance_332();
    var tmp_563 = $serializer_getInstance_340();
    var tmp_564 = $serializer_getInstance_328();
    var tmp_565 = WarhogsTuskCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$750 = [];
    var tmp_566 = ObjectSerializer.l1c('WarhogsTuskCard', tmp_565, tmp$ret$750);
    var tmp_567 = $serializer_getInstance_335();
    var tmp_568 = BleatCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$753 = [];
    var tmp_569 = ObjectSerializer.l1c('BleatCard', tmp_568, tmp$ret$753);
    var tmp_570 = $serializer_getInstance_329();
    var tmp_571 = EsmeriasStrandCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$756 = [];
    var tmp_572 = ObjectSerializer.l1c('EsmeriasStrandCard', tmp_571, tmp$ret$756);
    var tmp_573 = $serializer_getInstance_330();
    var tmp_574 = $serializer_getInstance_84();
    var tmp_575 = MistShroudCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$759 = [];
    var tmp_576 = ObjectSerializer.l1c('MistShroudCard', tmp_575, tmp$ret$759);
    var tmp_577 = RecoveryTestBeastReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$762 = [];
    var tmp_578 = ObjectSerializer.l1c('RecoveryTestBeastReaction', tmp_577, tmp$ret$762);
    var tmp_579 = RecoveryTestHunterReaction_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$765 = [];
    var tmp_580 = ObjectSerializer.l1c('RecoveryTestHunterReaction', tmp_579, tmp$ret$765);
    var tmp_581 = $serializer_getInstance_331();
    var tmp_582 = SuddenMistCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$768 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_583 = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_66, tmp_68, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_80, tmp_82, tmp_84, tmp_86, tmp_88, tmp_90, tmp_92, tmp_94, tmp_96, tmp_98, tmp_100, tmp_102, tmp_104, tmp_106, tmp_108, tmp_110, tmp_112, tmp_114, tmp_116, tmp_118, tmp_120, tmp_122, tmp_124, tmp_126, tmp_128, tmp_130, tmp_132, tmp_134, tmp_136, tmp_137, tmp_139, tmp_141, tmp_143, tmp_145, tmp_147, tmp_149, tmp_151, tmp_153, tmp_155, tmp_157, tmp_159, tmp_161, tmp_162, tmp_164, tmp_166, tmp_168, tmp_170, tmp_172, tmp_174, tmp_176, tmp_178, tmp_180, tmp_182, tmp_184, tmp_186, tmp_188, tmp_190, tmp_192, tmp_194, tmp_195, tmp_196, tmp_198, tmp_199, tmp_201, tmp_202, tmp_203, tmp_204, tmp_205, tmp_207, tmp_208, tmp_209, tmp_210, tmp_212, tmp_214, tmp_215, tmp_216, tmp_217, tmp_219, tmp_220, tmp_221, tmp_223, tmp_224, tmp_226, tmp_228, tmp_230, tmp_232, tmp_234, tmp_235, tmp_236, tmp_237, tmp_239, tmp_240, tmp_242, tmp_244, tmp_246, tmp_248, tmp_249, tmp_251, tmp_252, tmp_253, tmp_254, tmp_255, tmp_256, tmp_257, tmp_259, tmp_260, tmp_261, tmp_262, tmp_263, tmp_265, tmp_266, tmp_268, tmp_269, tmp_270, tmp_271, tmp_272, tmp_274, tmp_276, tmp_278, tmp_280, tmp_282, tmp_284, tmp_286, tmp_288, tmp_290, tmp_292, tmp_294, tmp_296, tmp_298, tmp_300, tmp_302, tmp_304, tmp_306, tmp_308, tmp_310, tmp_312, tmp_314, tmp_316, tmp_318, tmp_320, tmp_322, tmp_324, tmp_326, tmp_328, tmp_330, tmp_332, tmp_334, tmp_336, tmp_338, tmp_340, tmp_342, tmp_344, tmp_346, tmp_348, tmp_350, tmp_352, tmp_354, tmp_356, tmp_358, tmp_360, tmp_362, tmp_364, tmp_366, tmp_368, tmp_370, tmp_372, tmp_374, tmp_376, tmp_378, tmp_380, tmp_382, tmp_384, tmp_386, tmp_388, tmp_390, tmp_392, tmp_394, tmp_396, tmp_398, tmp_400, tmp_402, tmp_404, tmp_406, tmp_408, tmp_410, tmp_412, tmp_414, tmp_416, tmp_418, tmp_420, tmp_422, tmp_424, tmp_426, tmp_428, tmp_430, tmp_432, tmp_434, tmp_436, tmp_438, tmp_440, tmp_442, tmp_444, tmp_446, tmp_448, tmp_450, tmp_451, tmp_453, tmp_455, tmp_457, tmp_459, tmp_461, tmp_463, tmp_465, tmp_467, tmp_469, tmp_471, tmp_472, tmp_474, tmp_476, tmp_478, tmp_480, tmp_482, tmp_484, tmp_486, tmp_488, tmp_490, tmp_492, tmp_494, tmp_496, tmp_497, tmp_499, tmp_501, tmp_503, tmp_505, tmp_507, tmp_509, tmp_511, tmp_513, tmp_515, tmp_516, tmp_518, tmp_519, tmp_520, tmp_521, tmp_522, tmp_524, tmp_525, tmp_526, tmp_527, tmp_529, tmp_531, tmp_532, tmp_533, tmp_534, tmp_536, tmp_537, tmp_538, tmp_540, tmp_541, tmp_543, tmp_545, tmp_547, tmp_549, tmp_550, tmp_552, tmp_553, tmp_554, tmp_555, tmp_556, tmp_557, tmp_558, tmp_560, tmp_561, tmp_562, tmp_563, tmp_564, tmp_566, tmp_567, tmp_569, tmp_570, tmp_572, tmp_573, tmp_574, tmp_576, tmp_578, tmp_580, tmp_581, ObjectSerializer.l1c('SuddenMistCard', tmp_582, tmp$ret$768), $serializer_getInstance_85(), $serializer_getInstance_74(), $serializer_getInstance_99(), $serializer_getInstance_127(), $serializer_getInstance_343()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$774 = [];
    return SealedClassSerializer.i10('steelart.beast.PlayableCard', tmp, tmp_0, tmp_583, tmp$ret$774);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_443 {
  a2g() {
    var tmp = getKClass(OverloadedCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(OverloadedFlameRapierCard), getKClass(OverloadedFuryCard), getKClass(OverloadedNestCard), getKClass(OverloadedShatterCard), getKClass(OverloadedStormCard)];
    var tmp_1 = OverloadedFlameRapierCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp_1, tmp$ret$3);
    var tmp_3 = OverloadedFuryCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('OverloadedFuryCard', tmp_3, tmp$ret$6);
    var tmp_5 = OverloadedNestCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('OverloadedNestCard', tmp_5, tmp$ret$9);
    var tmp_7 = OverloadedShatterCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_8 = ObjectSerializer.l1c('OverloadedShatterCard', tmp_7, tmp$ret$12);
    var tmp_9 = OverloadedStormCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_10 = [tmp_2, tmp_4, tmp_6, tmp_8, ObjectSerializer.l1c('OverloadedStormCard', tmp_9, tmp$ret$15)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    return SealedClassSerializer.i10('steelart.beast.OverloadedCard', tmp, tmp_0, tmp_10, tmp$ret$21);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class WrathOfEirtirUpgrade {
  constructor() {
    WrathOfEirtirUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w5w_1 = lazy(tmp_0, WrathOfEirtirUpgrade$_anonymous__waw1ln);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_408(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'WrathOfEirtirUpgrade';
  }
  hashCode() {
    return -1692079615;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WrathOfEirtirUpgrade))
      return false;
    return true;
  }
}
class LeviathanUpgrade {
  constructor() {
    LeviathanUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x5w_1 = lazy(tmp_0, LeviathanUpgrade$_anonymous__onnb1t);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_409(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LeviathanUpgrade';
  }
  hashCode() {
    return -1757528341;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LeviathanUpgrade))
      return false;
    return true;
  }
}
class MendrsFuryUpgrade {
  constructor() {
    MendrsFuryUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y5w_1 = lazy(tmp_0, MendrsFuryUpgrade$_anonymous__9p22tc);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_410(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'MendrsFuryUpgrade';
  }
  hashCode() {
    return -291622350;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MendrsFuryUpgrade))
      return false;
    return true;
  }
}
class DrownerUpgrade {
  constructor() {
    DrownerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z5w_1 = lazy(tmp_0, DrownerUpgrade$_anonymous__w7dctc);
  }
  v35($context_GameState_t6qee5) {
    return 0;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_411(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DrownerUpgrade';
  }
  hashCode() {
    return 1000107388;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DrownerUpgrade))
      return false;
    return true;
  }
}
class TorrentialUpgrade {
  constructor() {
    TorrentialUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a5x_1 = lazy(tmp_0, TorrentialUpgrade$_anonymous__wsz9cx);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_412(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TorrentialUpgrade';
  }
  hashCode() {
    return -1609483757;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TorrentialUpgrade))
      return false;
    return true;
  }
}
class DevourerUpgrade {
  constructor() {
    DevourerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b5x_1 = lazy(tmp_0, DevourerUpgrade$_anonymous__z7ug7z);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_413(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DevourerUpgrade';
  }
  hashCode() {
    return 960112147;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DevourerUpgrade))
      return false;
    return true;
  }
}
class FatalGazeUpgrade {
  constructor() {
    FatalGazeUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c5x_1 = lazy(tmp_0, FatalGazeUpgrade$_anonymous__bkjnbw);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_414(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FatalGazeUpgrade';
  }
  hashCode() {
    return -54364680;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FatalGazeUpgrade))
      return false;
    return true;
  }
}
class Raaga {
  constructor() {
    Raaga_instance = this;
    this.d5x_1 = setOf_0([WrathOfEirtirUpgrade_getInstance(), LeviathanUpgrade_getInstance(), MendrsFuryUpgrade_getInstance(), DrownerUpgrade_getInstance(), TorrentialUpgrade_getInstance(), DevourerUpgrade_getInstance(), FatalGazeUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e5x_1 = lazy(tmp_0, Raaga$_anonymous__we9sgl);
  }
  q36() {
    return BasiliskType_getInstance();
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Swamp_getInstance();
  }
  s36() {
    return setOf_0([SummonBasiliskCard_getInstance(), HydraCard_getInstance(), FloodCard_getInstance(), SlitherCard_getInstance()]);
  }
  t35() {
    return this.d5x_1;
  }
  n2z($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_415(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Raaga';
  }
  hashCode() {
    return 1666439367;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Raaga))
      return false;
    return true;
  }
}
class Companion_444 {
  constructor() {
    Companion_instance_444 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f5x_1 = [lazy(tmp_0, RaagaSlitherStatement$Companion$$childSerializers$_anonymous__kq9hs0)];
  }
}
class $serializer_376 {
  constructor() {
    $serializer_instance_372 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RaagaSlitherStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.g5x_1 = tmp0_serialDesc;
  }
  h5x(encoder, value) {
    var tmp0_desc = this.g5x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_445().f5x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i5x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h5x(encoder, value instanceof RaagaSlitherStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g5x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_445().f5x_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RaagaSlitherStatement.j5x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g5x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_445().f5x_1[0].k3()];
  }
}
class RaagaSlitherStatement extends BeastMovementStatement {
  constructor(movingObject) {
    Companion_getInstance_445();
    super();
    this.i5x_1 = movingObject;
  }
  f2p() {
    return this.i5x_1;
  }
  toString() {
    return 'RaagaSlitherStatement(movingObject=' + this.i5x_1.toString() + ')';
  }
  hashCode() {
    return this.i5x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RaagaSlitherStatement))
      return false;
    if (!this.i5x_1.equals(other.i5x_1))
      return false;
    return true;
  }
  static j5x(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_445();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_372().g5x_1);
    }
    var $this = this.f2q(seen0, serializationConstructorMarker);
    $this.i5x_1 = movingObject;
    return $this;
  }
}
class Companion_445 {
  constructor() {
    Companion_instance_445 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k5x_1 = [lazy(tmp_0, RaagaHydraStatement$Companion$$childSerializers$_anonymous__r74jpr)];
  }
}
class $serializer_377 {
  constructor() {
    $serializer_instance_373 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RaagaHydraStatement', this, 1);
    tmp0_serialDesc.h1b('attacker', false);
    this.l5x_1 = tmp0_serialDesc;
  }
  m5x(encoder, value) {
    var tmp0_desc = this.l5x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_446().k5x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n5x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m5x(encoder, value instanceof RaagaHydraStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l5x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_446().k5x_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RaagaHydraStatement.o5x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l5x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_446().k5x_1[0].k3()];
  }
}
class RaagaHydraStatement {
  constructor(attacker) {
    Companion_getInstance_446();
    this.n5x_1 = attacker;
  }
  toString() {
    return 'RaagaHydraStatement(attacker=' + this.n5x_1.toString() + ')';
  }
  hashCode() {
    return this.n5x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RaagaHydraStatement))
      return false;
    if (!this.n5x_1.equals(other.n5x_1))
      return false;
    return true;
  }
  static o5x(seen0, attacker, serializationConstructorMarker) {
    Companion_getInstance_446();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_373().l5x_1);
    }
    var $this = createThis(this);
    $this.n5x_1 = attacker;
    return $this;
  }
}
class BasiliskType {
  constructor() {
    BasiliskType_instance = this;
    this.p5x_1 = Raaga_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q5x_1 = lazy(tmp_0, BasiliskType$_anonymous__1yfyb1);
  }
  r37() {
    return this.p5x_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_416(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BasiliskType';
  }
  hashCode() {
    return 1429202569;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BasiliskType))
      return false;
    return true;
  }
}
class FloodCard {
  constructor() {
    FloodCard_instance = this;
    this.r5x_1 = Red_getInstance();
    this.s5x_1 = Raaga_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t5x_1 = lazy(tmp_0, FloodCard$_anonymous__go9vqh);
  }
  t37() {
    return this.s5x_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_417(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'FloodCard';
  }
  hashCode() {
    return -425980151;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FloodCard))
      return false;
    return true;
  }
}
class HydraCard {
  constructor() {
    HydraCard_instance = this;
    this.u5x_1 = Red_getInstance();
    this.v5x_1 = Raaga_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w5x_1 = lazy(tmp_0, HydraCard$_anonymous__agqewr);
  }
  t37() {
    return this.v5x_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_418(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HydraCard';
  }
  hashCode() {
    return 346287085;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HydraCard))
      return false;
    return true;
  }
}
class SlitherCard {
  constructor() {
    SlitherCard_instance = this;
    this.x5x_1 = Blue_getInstance();
    this.y5x_1 = Raaga_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z5x_1 = lazy(tmp_0, SlitherCard$_anonymous__pfx5zq);
  }
  t37() {
    return this.y5x_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_419(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SlitherCard';
  }
  hashCode() {
    return -608914916;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SlitherCard))
      return false;
    return true;
  }
}
class SummonBasiliskCard {
  constructor() {
    SummonBasiliskCard_instance = this;
    this.a5y_1 = Raaga_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b5y_1 = lazy(tmp_0, SummonBasiliskCard$_anonymous__6xv29w);
  }
  t37() {
    return this.a5y_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_420(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonBasiliskCard';
  }
  hashCode() {
    return 1787090464;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonBasiliskCard))
      return false;
    return true;
  }
}
class PetrifyAttackModifier {
  constructor() {
    PetrifyAttackModifier_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c5y_1 = lazy(tmp_0, PetrifyAttackModifier$_anonymous__s79n5d);
  }
  w35($context_GameState_t6qee5, target) {
    var tmp = get_objectType($context_GameState_t6qee5, target);
    return isInterface(tmp, HunterCharacter);
  }
  x35($context_GameState_t6qee5, target) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_421(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PetrifyAttackModifier';
  }
  hashCode() {
    return 571652835;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PetrifyAttackModifier))
      return false;
    return true;
  }
}
class Companion_446 {}
class $serializer_378 {
  constructor() {
    $serializer_instance_374 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RecoveryTestContract', this, 2);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', true);
    this.d5y_1 = tmp0_serialDesc;
  }
  e5y(encoder, value) {
    var tmp0_desc = this.d5y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !value.g5y_1.equals(new GameRulesParameters(Companion_getInstance_217().e3a_1, Companion_getInstance_220().w39_1))) {
      tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.g5y_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e5y(encoder, value instanceof RecoveryTestContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d5y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RecoveryTestContract.h5y(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d5y_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180()];
  }
}
class RecoveryTestContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.i5y(rulesParameters);
  }
  static i5y(rulesParameters) {
    rulesParameters = rulesParameters === VOID ? new GameRulesParameters(Companion_getInstance_217().e3a_1, Companion_getInstance_220().w39_1) : rulesParameters;
    var $this = this.b3a();
    $this.g5y_1 = rulesParameters;
    return $this;
  }
  c3a() {
    return this.g5y_1;
  }
  g3a() {
    return new SimpleStartingBonuses(2, 1);
  }
  h3a() {
    return GameMapId_DrenchedLands_getInstance();
  }
  i3a() {
    return 3;
  }
  j3a() {
    return 1;
  }
  k3a() {
    return 2;
  }
  l3a() {
    return 2;
  }
  m3a() {
    return RecoveryTestInitialPhase_getInstance();
  }
  y3a() {
    return plus_2(super.y3a(), get_recoveryTestHunterCards());
  }
  z3a() {
    return plus_2(super.z3a(), get_recoveryTestBeastCards());
  }
  w3a() {
    return Companion_getInstance_220().w39_1;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    return nightNumber < get_currentDayNumber($context_GameState_t6qee5) ? NightRewardStatus_NightWasPassed_getInstance() : ensuredOrNotGainedRewardStatus(true);
  }
  v3a(rulesParameters) {
    return RecoveryTestContract.i5y(rulesParameters);
  }
  toString() {
    return 'RecoveryTestContract(rulesParameters=' + this.g5y_1.toString() + ')';
  }
  hashCode() {
    return this.g5y_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestContract))
      return false;
    if (!this.g5y_1.equals(other.g5y_1))
      return false;
    return true;
  }
  static h5y(seen0, maxWatchtowersOnBoard, rulesParameters, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_374().d5y_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    if (0 === (seen0 & 2))
      $this.g5y_1 = new GameRulesParameters(Companion_getInstance_217().e3a_1, Companion_getInstance_220().w39_1);
    else
      $this.g5y_1 = rulesParameters;
    return $this;
  }
}
class Companion_447 {
  constructor() {
    Companion_instance_447 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RecoveryTestForEachHunterStatement$Companion$$childSerializers$_anonymous__p1dp4y);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j5y_1 = [tmp_1, lazy(tmp_2, RecoveryTestForEachHunterStatement$Companion$$childSerializers$_anonymous__p1dp4y_0)];
  }
}
class $serializer_379 {
  constructor() {
    $serializer_instance_375 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RecoveryTestForEachHunterStatement', this, 2);
    tmp0_serialDesc.h1b('hunters', false);
    tmp0_serialDesc.h1b('failingHunter', false);
    this.k5y_1 = tmp0_serialDesc;
  }
  l5y(encoder, value) {
    var tmp0_desc = this.k5y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_448().j5y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.m5y_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.n5y_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l5y(encoder, value instanceof RecoveryTestForEachHunterStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k5y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_448().j5y_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RecoveryTestForEachHunterStatement.o5y(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.k5y_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_448().j5y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class RecoveryTestForEachHunterStatement extends PerformForEachHunter {
  constructor(hunters, failingHunter) {
    Companion_getInstance_448();
    super();
    this.m5y_1 = hunters;
    this.n5y_1 = failingHunter;
  }
  toString() {
    return 'RecoveryTestForEachHunterStatement(hunters=' + toString(this.m5y_1) + ', failingHunter=' + this.n5y_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.m5y_1);
    result = imul(result, 31) + this.n5y_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestForEachHunterStatement))
      return false;
    if (!equals(this.m5y_1, other.m5y_1))
      return false;
    if (!this.n5y_1.equals(other.n5y_1))
      return false;
    return true;
  }
  static o5y(seen0, hunters, failingHunter, serializationConstructorMarker) {
    Companion_getInstance_448();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_375().k5y_1);
    }
    var $this = this.n2p(seen0, serializationConstructorMarker);
    $this.m5y_1 = hunters;
    $this.n5y_1 = failingHunter;
    return $this;
  }
}
class Companion_448 {
  constructor() {
    Companion_instance_448 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RecoveryTestStatement$Companion$$childSerializers$_anonymous__5mxeym);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q5y_1 = [tmp_1, lazy(tmp_2, RecoveryTestStatement$Companion$$childSerializers$_anonymous__5mxeym_0)];
  }
}
class $serializer_380 {
  constructor() {
    $serializer_instance_376 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RecoveryTestStatement', this, 2);
    tmp0_serialDesc.h1b('character', false);
    tmp0_serialDesc.h1b('failure', false);
    this.r5y_1 = tmp0_serialDesc;
  }
  s5y(encoder, value) {
    var tmp0_desc = this.r5y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_449().q5y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t5y_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.u5y_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s5y(encoder, value instanceof RecoveryTestStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r5y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_449().q5y_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RecoveryTestStatement.v5y(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r5y_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_449().q5y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class RecoveryTestStatement {
  constructor(character, failure) {
    Companion_getInstance_449();
    this.t5y_1 = character;
    this.u5y_1 = failure;
  }
  toString() {
    return 'RecoveryTestStatement(character=' + this.t5y_1.toString() + ', failure=' + this.u5y_1.toString() + ')';
  }
  hashCode() {
    var result = this.t5y_1.hashCode();
    result = imul(result, 31) + this.u5y_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestStatement))
      return false;
    if (!this.t5y_1.equals(other.t5y_1))
      return false;
    if (!this.u5y_1.equals(other.u5y_1))
      return false;
    return true;
  }
  static v5y(seen0, character, failure, serializationConstructorMarker) {
    Companion_getInstance_449();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_376().r5y_1);
    }
    var $this = createThis(this);
    $this.t5y_1 = character;
    $this.u5y_1 = failure;
    return $this;
  }
}
class RecoveryTestInitialPhase {
  constructor() {
    RecoveryTestInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w5y_1 = lazy(tmp_0, RecoveryTestInitialPhase$_anonymous__1amq07);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_422(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RecoveryTestInitialPhase';
  }
  hashCode() {
    return 869029827;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestInitialPhase))
      return false;
    return true;
  }
}
class Companion_449 {
  constructor() {
    Companion_instance_449 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RecoveryTestEvent$Companion$$childSerializers$_anonymous__l5icvd);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x5y_1 = [tmp_1, lazy(tmp_2, RecoveryTestEvent$Companion$$childSerializers$_anonymous__l5icvd_0)];
  }
}
class $serializer_381 {
  constructor() {
    $serializer_instance_377 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RecoveryTestEvent', this, 2);
    tmp0_serialDesc.h1b('character', false);
    tmp0_serialDesc.h1b('failure', false);
    this.y5y_1 = tmp0_serialDesc;
  }
  z5y(encoder, value) {
    var tmp0_desc = this.y5y_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_450().x5y_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a5z_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.b5z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z5y(encoder, value instanceof RecoveryTestEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y5y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_450().x5y_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RecoveryTestEvent.c5z(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.y5y_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_450().x5y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class RecoveryTestEvent {
  constructor(character, failure) {
    Companion_getInstance_450();
    this.a5z_1 = character;
    this.b5z_1 = failure;
  }
  o37($context_GameStateRuntime_604ce3) {
    return listOf(new GrudgesChange(this.a5z_1, 1));
  }
  toString() {
    return 'RecoveryTestEvent(character=' + this.a5z_1.toString() + ', failure=' + this.b5z_1.toString() + ')';
  }
  hashCode() {
    var result = this.a5z_1.hashCode();
    result = imul(result, 31) + this.b5z_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestEvent))
      return false;
    if (!this.a5z_1.equals(other.a5z_1))
      return false;
    if (!this.b5z_1.equals(other.b5z_1))
      return false;
    return true;
  }
  static c5z(seen0, character, failure, serializationConstructorMarker) {
    Companion_getInstance_450();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_377().y5y_1);
    }
    var $this = createThis(this);
    $this.a5z_1 = character;
    $this.b5z_1 = failure;
    return $this;
  }
}
class RecoveryTestFailingEvent {
  constructor() {
    RecoveryTestFailingEvent_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d5z_1 = lazy(tmp_0, RecoveryTestFailingEvent$_anonymous__ol2ayu);
  }
  o37($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.error' call
    var message = 'Recovery test: automatic event application';
    throw IllegalStateException.o(toString(message));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_423(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RecoveryTestFailingEvent';
  }
  hashCode() {
    return -1853158366;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestFailingEvent))
      return false;
    return true;
  }
}
class Companion_450 {
  constructor() {
    Companion_instance_450 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e5z_1 = [lazy(tmp_0, RecoveryTestBeastCard$Companion$$childSerializers$_anonymous__chal42)];
  }
}
class $serializer_382 {
  constructor() {
    $serializer_instance_378 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RecoveryTestBeastCard', this, 1);
    tmp0_serialDesc.h1b('failure', false);
    this.f5z_1 = tmp0_serialDesc;
  }
  g5z(encoder, value) {
    var tmp0_desc = this.f5z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_451().e5z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h5z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g5z(encoder, value instanceof RecoveryTestBeastCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f5z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_451().e5z_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RecoveryTestBeastCard.i5z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.f5z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_451().e5z_1[0].k3()];
  }
}
class RecoveryTestCard {}
class RecoveryTestBeastCard {
  constructor(failure) {
    Companion_getInstance_451();
    this.h5z_1 = failure;
  }
  j5z() {
    return this.h5z_1;
  }
  toString() {
    return 'RecoveryTestBeastCard(failure=' + this.h5z_1.toString() + ')';
  }
  hashCode() {
    return this.h5z_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestBeastCard))
      return false;
    if (!this.h5z_1.equals(other.h5z_1))
      return false;
    return true;
  }
  static i5z(seen0, failure, serializationConstructorMarker) {
    Companion_getInstance_451();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_378().f5z_1);
    }
    var $this = createThis(this);
    $this.h5z_1 = failure;
    return $this;
  }
}
class RecoveryTestBeastReaction {
  constructor() {
    RecoveryTestBeastReaction_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k5z_1 = lazy(tmp_0, RecoveryTestBeastReaction$_anonymous__40vone);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_424(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RecoveryTestBeastReaction';
  }
  hashCode() {
    return -759984900;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestBeastReaction))
      return false;
    return true;
  }
}
class RecoveryTestConditionCard {}
class RecoveryTestNightlyRewardsFailureCard {
  constructor() {
    RecoveryTestNightlyRewardsFailureCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l5z_1 = lazy(tmp_0, RecoveryTestNightlyRewardsFailureCard$_anonymous__uxcy1p);
  }
  m5z() {
    return 'Night rewards failure';
  }
  n5z() {
    return "While held in hand, fail before either team's night rewards. After repair, continue with night restoration.";
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_425(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RecoveryTestNightlyRewardsFailureCard';
  }
  hashCode() {
    return 418898639;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestNightlyRewardsFailureCard))
      return false;
    return true;
  }
}
class RecoveryTestPhaseFailureCard {
  constructor() {
    RecoveryTestPhaseFailureCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o5z_1 = lazy(tmp_0, RecoveryTestPhaseFailureCard$_anonymous__th1umn);
  }
  m5z() {
    return 'Setup failure';
  }
  n5z() {
    return 'While held in hand, contract setup applies starting bonuses, then fails. Remove this card to allow setup to finish.';
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_426(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RecoveryTestPhaseFailureCard';
  }
  hashCode() {
    return 1031402603;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestPhaseFailureCard))
      return false;
    return true;
  }
}
class RecoveryTestTeamRewardFailureCard {
  constructor() {
    RecoveryTestTeamRewardFailureCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p5z_1 = lazy(tmp_0, RecoveryTestTeamRewardFailureCard$_anonymous__yeiewg);
  }
  m5z() {
    return 'Beast reward failure';
  }
  n5z() {
    return 'While held in hand, the Beast reward grants 1 Grudge, then fails. After repair, the Hunter reward still grants 1 Grudge.';
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_427(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RecoveryTestTeamRewardFailureCard';
  }
  hashCode() {
    return 439364226;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestTeamRewardFailureCard))
      return false;
    return true;
  }
}
class Companion_451 {
  constructor() {
    Companion_instance_451 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q5z_1 = [lazy(tmp_0, RecoveryTestHunterCard$Companion$$childSerializers$_anonymous__tpkytv)];
  }
}
class $serializer_383 {
  constructor() {
    $serializer_instance_379 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RecoveryTestHunterCard', this, 1);
    tmp0_serialDesc.h1b('failure', false);
    this.r5z_1 = tmp0_serialDesc;
  }
  s5z(encoder, value) {
    var tmp0_desc = this.r5z_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_452().q5z_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t5z_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s5z(encoder, value instanceof RecoveryTestHunterCard ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r5z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_452().q5z_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RecoveryTestHunterCard.u5z(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r5z_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_452().q5z_1[0].k3()];
  }
}
class RecoveryTestHunterCard {
  constructor(failure) {
    Companion_getInstance_452();
    this.t5z_1 = failure;
  }
  j5z() {
    return this.t5z_1;
  }
  toString() {
    return 'RecoveryTestHunterCard(failure=' + this.t5z_1.toString() + ')';
  }
  hashCode() {
    return this.t5z_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestHunterCard))
      return false;
    if (!this.t5z_1.equals(other.t5z_1))
      return false;
    return true;
  }
  static u5z(seen0, failure, serializationConstructorMarker) {
    Companion_getInstance_452();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_379().r5z_1);
    }
    var $this = createThis(this);
    $this.t5z_1 = failure;
    return $this;
  }
}
class RecoveryTestHunterReaction {
  constructor() {
    RecoveryTestHunterReaction_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v5z_1 = lazy(tmp_0, RecoveryTestHunterReaction$_anonymous__qdbvyx);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_428(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RecoveryTestHunterReaction';
  }
  hashCode() {
    return 31051253;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryTestHunterReaction))
      return false;
    return true;
  }
}
class Companion_452 {
  constructor() {
    Companion_instance_452 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p5y_1 = lazy(tmp_0, RecoveryTestFailure$Companion$_anonymous__hrnpo4);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_429(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class RecoveryTestFailure extends Enum {
  constructor(name, ordinal, title, description) {
    super(name, ordinal);
    this.y5z_1 = title;
    this.z5z_1 = description;
  }
}
class Companion_453 {
  a2g() {
    var tmp = getKClass(RecoveryTestCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(RecoveryTestBeastCard), getKClass(RecoveryTestHunterCard)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_378(), $serializer_getInstance_379()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.RecoveryTestCard', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_454 {
  a2g() {
    var tmp = getKClass(RecoveryTestConditionCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(RecoveryTestNightlyRewardsFailureCard), getKClass(RecoveryTestPhaseFailureCard), getKClass(RecoveryTestTeamRewardFailureCard)];
    var tmp_1 = RecoveryTestNightlyRewardsFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('RecoveryTestNightlyRewardsFailureCard', tmp_1, tmp$ret$3);
    var tmp_3 = RecoveryTestPhaseFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('RecoveryTestPhaseFailureCard', tmp_3, tmp$ret$6);
    var tmp_5 = RecoveryTestTeamRewardFailureCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_6 = [tmp_2, tmp_4, ObjectSerializer.l1c('RecoveryTestTeamRewardFailureCard', tmp_5, tmp$ret$9)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    return SealedClassSerializer.i10('steelart.beast.RecoveryTestConditionCard', tmp, tmp_0, tmp_6, tmp$ret$15);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_455 {}
class $serializer_384 {
  constructor() {
    $serializer_instance_380 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RegentOfRuinsContract', this, 4);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.a60_1 = tmp0_serialDesc;
  }
  b60(encoder, value) {
    var tmp0_desc = this.a60_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.d60_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.e60_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 2, value.e60_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !value.f60_1.equals(Companion_getInstance_220().x39_1)) {
      tmp1_output.g15(tmp0_desc, 3, $serializer_getInstance_181(), value.f60_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b60(encoder, value instanceof RegentOfRuinsContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a60_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, $serializer_getInstance_181(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.b14(tmp0_desc, 3, $serializer_getInstance_181(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return RegentOfRuinsContract.g60(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.a60_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class RegentOfRuinsContract extends ClassicGameRules {
  constructor(rulesParameters) {
    return new.target.h60(rulesParameters);
  }
  static h60(rulesParameters) {
    var $this = this.o4f();
    $this.d60_1 = rulesParameters;
    $this.e60_1 = 3;
    $this.f60_1 = Companion_getInstance_220().x39_1;
    return $this;
  }
  c3a() {
    return this.d60_1;
  }
  static i60(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    balanceVersion = balanceVersion === VOID ? Companion_getInstance_217().e3a_1 : balanceVersion;
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().x39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.h60(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(1, 1);
  }
  h3a() {
    return GameMapId_LowerShatteredIsles_getInstance();
  }
  i3a() {
    return this.e60_1;
  }
  j3a() {
    return 1;
  }
  k3a() {
    return 2;
  }
  m3a() {
    return RegentOfRuinsInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_isTwoSheepOrTigerCompleted_0($context_GameState_t6qee5));
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = expectedOrNotGainedRewardStatus(ruinsControlled_0($context_GameState_t6qee5, get_huntersGameTeam()) > 0);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_destroyRecords($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.p3a_1 === get_beastsGameTeam()) {
          destination.d2(element);
        }
      }
      var beastKills = destination;
      var tmp_0;
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.count' call
        var tmp_1;
        if (isInterface(beastKills, Collection)) {
          tmp_1 = beastKills.n1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$3 = 0;
          break $l$block;
        }
        var count = 0;
        var _iterator__ex2g4s_0 = beastKills.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (equals(get_objectType($context_GameState_t6qee5, element_0.o3a_1), SheepType_getInstance())) {
            count = count + 1 | 0;
            checkCountOverflow(count);
          }
        }
        tmp$ret$3 = count;
      }
      if (tmp$ret$3 >= 3) {
        var tmp$ret$5;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_2;
          if (isInterface(beastKills, Collection)) {
            tmp_2 = beastKills.n1();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$5 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_1 = beastKills.p1();
          while (_iterator__ex2g4s_1.q1()) {
            var element_1 = _iterator__ex2g4s_1.r1();
            if (equals(get_objectType($context_GameState_t6qee5, element_1.o3a_1), TigerType_getInstance())) {
              tmp$ret$5 = true;
              break $l$block_1;
            }
          }
          tmp$ret$5 = false;
        }
        tmp_0 = tmp$ret$5;
      } else {
        tmp_0 = false;
      }
      var enoughAnimalsKilled = tmp_0;
      var tmp_3;
      if (enoughAnimalsKilled) {
        tmp_3 = true;
      } else {
        var tmp0_0 = get_destroyedObjects($context_GameState_t6qee5);
        var tmp$ret$7;
        $l$block_3: {
          // Inline function 'kotlin.collections.any' call
          var tmp_4;
          if (isInterface(tmp0_0, Collection)) {
            tmp_4 = tmp0_0.n1();
          } else {
            tmp_4 = false;
          }
          if (tmp_4) {
            tmp$ret$7 = false;
            break $l$block_3;
          }
          var _iterator__ex2g4s_2 = tmp0_0.p1();
          while (_iterator__ex2g4s_2.q1()) {
            var element_2 = _iterator__ex2g4s_2.r1();
            var tmp_5 = get_objectType($context_GameState_t6qee5, element_2);
            if (isInterface(tmp_5, SettlerType)) {
              tmp$ret$7 = true;
              break $l$block_3;
            }
          }
          tmp$ret$7 = false;
        }
        tmp_3 = tmp$ret$7;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp_3);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_regentHunterDominion($context_GameState_t6qee5) >= 8);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  e3b(id, default_0) {
    var tmp;
    if (id.w1_1 === 12) {
      tmp = ((!(default_0 == null) ? typeof default_0 === 'number' : false) ? default_0 : THROW_CCE()) + 1 | 0;
    } else {
      tmp = super.e3b(id, default_0);
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.f60_1;
  }
  v3a(rulesParameters) {
    return RegentOfRuinsContract.h60(rulesParameters);
  }
  toString() {
    return 'RegentOfRuinsContract(rulesParameters=' + this.d60_1.toString() + ')';
  }
  hashCode() {
    return this.d60_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RegentOfRuinsContract))
      return false;
    if (!this.d60_1.equals(other.d60_1))
      return false;
    return true;
  }
  static g60(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_380().a60_1);
    }
    var $this = this.r4f(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.d60_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.e60_1 = 3;
    else
      $this.e60_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.f60_1 = Companion_getInstance_220().x39_1;
    else
      $this.f60_1 = requiredVersion;
    return $this;
  }
}
class RegentOfRuinsInitialPhase {
  constructor() {
    RegentOfRuinsInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j60_1 = lazy(tmp_0, RegentOfRuinsInitialPhase$_anonymous__4wblhf);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_430(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RegentOfRuinsInitialPhase';
  }
  hashCode() {
    return 1150652783;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RegentOfRuinsInitialPhase))
      return false;
    return true;
  }
}
class Companion_456 {}
class $serializer_385 {
  constructor() {
    $serializer_instance_381 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RegentDominionChangeEvent', this, 2);
    tmp0_serialDesc.h1b('gameTeam', false);
    tmp0_serialDesc.h1b('dominionSteps', false);
    this.k60_1 = tmp0_serialDesc;
  }
  l60(encoder, value) {
    var tmp0_desc = this.k60_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_183(), new GameTeam(value.m60_1));
    tmp1_output.z14(tmp0_desc, 1, value.n60_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l60(encoder, value instanceof RegentDominionChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k60_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RegentDominionChangeEvent.o60(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.k60_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_183(), IntSerializer_getInstance()];
  }
}
class RegentDominionChangeEvent {
  constructor(gameTeam, dominionSteps) {
    this.m60_1 = gameTeam;
    this.n60_1 = dominionSteps;
  }
  m37(_this__u8e3s4) {
    var tmp0_subject = this.m60_1;
    if (tmp0_subject === get_beastsGameTeam()) {
      set_regentBeastDominionImpl(_this__u8e3s4, get_regentBeastDominion(_this__u8e3s4) + this.n60_1 | 0);
    } else if (tmp0_subject === get_huntersGameTeam()) {
      set_regentHunterDominionImpl(_this__u8e3s4, get_regentHunterDominion(_this__u8e3s4) + this.n60_1 | 0);
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Unexpected team for dominion change: ' + GameTeam__toString_impl_wfw0a6(this.m60_1);
      throw IllegalStateException.o(toString(message));
    }
  }
  n37($context_GameState_t6qee5) {
    return new RegentDominionChangeEvent(this.m60_1, -this.n60_1 | 0);
  }
  toString() {
    return 'RegentDominionChangeEvent(gameTeam=' + GameTeam__toString_impl_wfw0a6(this.m60_1) + ', dominionSteps=' + this.n60_1 + ')';
  }
  hashCode() {
    var result = GameTeam__hashCode_impl_gu24w3(this.m60_1);
    result = imul(result, 31) + this.n60_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RegentDominionChangeEvent))
      return false;
    if (!(this.m60_1 === other.m60_1))
      return false;
    if (!(this.n60_1 === other.n60_1))
      return false;
    return true;
  }
  static o60(seen0, gameTeam, dominionSteps, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_381().k60_1);
    }
    var $this = createThis(this);
    $this.m60_1 = gameTeam;
    $this.n60_1 = dominionSteps;
    return $this;
  }
}
class AbyssalHellFireUpgrade {
  constructor() {
    AbyssalHellFireUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p60_1 = lazy(tmp_0, AbyssalHellFireUpgrade$_anonymous__cz7x75);
  }
  v35($context_GameState_t6qee5) {
    return 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_431(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AbyssalHellFireUpgrade';
  }
  hashCode() {
    return -1222682869;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbyssalHellFireUpgrade))
      return false;
    return true;
  }
}
class BurnUpgrade {
  constructor() {
    BurnUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q60_1 = lazy(tmp_0, BurnUpgrade$_anonymous__bvcp86);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_432(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BurnUpgrade';
  }
  hashCode() {
    return 2070145384;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BurnUpgrade))
      return false;
    return true;
  }
}
class DraconicBondsUpgrade {
  constructor() {
    DraconicBondsUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r60_1 = lazy(tmp_0, DraconicBondsUpgrade$_anonymous__1movaa);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_433(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DraconicBondsUpgrade';
  }
  hashCode() {
    return -1838062790;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraconicBondsUpgrade))
      return false;
    return true;
  }
}
class AngerUpgrade {
  constructor() {
    AngerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s60_1 = lazy(tmp_0, AngerUpgrade$_anonymous__xj49c2);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_434(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AngerUpgrade';
  }
  hashCode() {
    return 1620645722;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AngerUpgrade))
      return false;
    return true;
  }
}
class Companion_457 {
  a2g() {
    var tmp = getKClass(RhagnerCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(IncinerateCard), getKClass(RiseCard), getKClass(ScorchedEarthCard), getKClass(SummonLindwyrmCard)];
    var tmp_1 = IncinerateCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('IncinerateCard', tmp_1, tmp$ret$3);
    var tmp_3 = RiseCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('RiseCard', tmp_3, tmp$ret$6);
    var tmp_5 = ScorchedEarthCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_6 = ObjectSerializer.l1c('ScorchedEarthCard', tmp_5, tmp$ret$9);
    var tmp_7 = SummonLindwyrmCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_8 = [tmp_2, tmp_4, tmp_6, ObjectSerializer.l1c('SummonLindwyrmCard', tmp_7, tmp$ret$12)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    return SealedClassSerializer.i10('steelart.beast.RhagnerCard', tmp, tmp_0, tmp_8, tmp$ret$18);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class RhagnerCard {}
function get_character_0() {
  return Rhagner_getInstance();
}
class IncinerateCard {
  constructor() {
    IncinerateCard_instance = this;
    this.t60_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u60_1 = lazy(tmp_0, IncinerateCard$_anonymous__pdhfgl);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_435(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'IncinerateCard';
  }
  hashCode() {
    return -344171689;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IncinerateCard))
      return false;
    return true;
  }
}
class RiseCard {
  constructor() {
    RiseCard_instance = this;
    this.v60_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w60_1 = lazy(tmp_0, RiseCard$_anonymous__povwv6);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_436(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RiseCard';
  }
  hashCode() {
    return -1609016514;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RiseCard))
      return false;
    return true;
  }
}
class ScorchedEarthCard {
  constructor() {
    ScorchedEarthCard_instance = this;
    this.x60_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y60_1 = lazy(tmp_0, ScorchedEarthCard$_anonymous__f30vkk);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_437(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ScorchedEarthCard';
  }
  hashCode() {
    return 2075188638;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScorchedEarthCard))
      return false;
    return true;
  }
}
class SummonLindwyrmCard {
  constructor() {
    SummonLindwyrmCard_instance = this;
    this.z60_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a61_1 = lazy(tmp_0, SummonLindwyrmCard$_anonymous__3zp46i);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_438(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonLindwyrmCard';
  }
  hashCode() {
    return 2001566022;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonLindwyrmCard))
      return false;
    return true;
  }
}
class Rhagner {
  constructor() {
    Rhagner_instance = this;
    this.b61_1 = LindwyrmType_getInstance();
    this.c61_1 = setOf_0([AbyssalHellFireUpgrade_getInstance(), BurnUpgrade_getInstance(), DraconicBondsUpgrade_getInstance(), AngerUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d61_1 = lazy(tmp_0, Rhagner$_anonymous__bcpzdk);
  }
  q36() {
    return this.b61_1;
  }
  u36() {
    return 2;
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Cave_getInstance();
  }
  s36() {
    return setOf_0([IncinerateCard_getInstance(), SummonLindwyrmCard_getInstance(), ScorchedEarthCard_getInstance(), RiseCard_getInstance()]);
  }
  t35() {
    return this.c61_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  v36($context_GameState_t6qee5, position) {
    return plus_2(getInitList_1.call(this, $context_GameState_t6qee5, position), listOf(init(get_rhagnerHoardLevelsKey(), new PlayableCardToIntMapWrapper(mapOf([to(IncinerateCard_getInstance(), 0), to(SummonLindwyrmCard_getInstance(), 0), to(ScorchedEarthCard_getInstance(), 0), to(RiseCard_getInstance(), 0)])))));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_439(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Rhagner';
  }
  hashCode() {
    return -374149926;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rhagner))
      return false;
    return true;
  }
}
class RhagnerGainHoardEffectSource {
  constructor() {
    RhagnerGainHoardEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e61_1 = lazy(tmp_0, RhagnerGainHoardEffectSource$_anonymous__rnjdrx);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_440(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RhagnerGainHoardEffectSource';
  }
  hashCode() {
    return -1601930081;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RhagnerGainHoardEffectSource))
      return false;
    return true;
  }
}
class RhagnerReduceHoardEffectSource {
  constructor() {
    RhagnerReduceHoardEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f61_1 = lazy(tmp_0, RhagnerReduceHoardEffectSource$_anonymous__mwtpvo);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_441(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RhagnerReduceHoardEffectSource';
  }
  hashCode() {
    return 1235305496;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RhagnerReduceHoardEffectSource))
      return false;
    return true;
  }
}
class RhagnerCardGainHoardQuestionContext {
  constructor() {
    RhagnerCardGainHoardQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g61_1 = lazy(tmp_0, RhagnerCardGainHoardQuestionContext$_anonymous__gdd4wc);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_442(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RhagnerCardGainHoardQuestionContext';
  }
  hashCode() {
    return 720418982;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RhagnerCardGainHoardQuestionContext))
      return false;
    return true;
  }
}
class RhagnerCardLoseHoardQuestionContext {
  constructor() {
    RhagnerCardLoseHoardQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h61_1 = lazy(tmp_0, RhagnerCardLoseHoardQuestionContext$_anonymous__qfibue);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_443(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RhagnerCardLoseHoardQuestionContext';
  }
  hashCode() {
    return -175665860;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RhagnerCardLoseHoardQuestionContext))
      return false;
    return true;
  }
}
class LocationForFireQuestionContext {
  constructor() {
    LocationForFireQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i61_1 = lazy(tmp_0, LocationForFireQuestionContext$_anonymous__t7qf48);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_444(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LocationForFireQuestionContext';
  }
  hashCode() {
    return -1676443548;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LocationForFireQuestionContext))
      return false;
    return true;
  }
}
class LocationToIncinerateQuestionContext {
  constructor() {
    LocationToIncinerateQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j61_1 = lazy(tmp_0, LocationToIncinerateQuestionContext$_anonymous__g9lrxc);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_445(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LocationToIncinerateQuestionContext';
  }
  hashCode() {
    return -239826094;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LocationToIncinerateQuestionContext))
      return false;
    return true;
  }
}
class LocationToTransformAndFireQuestionContext {
  constructor() {
    LocationToTransformAndFireQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k61_1 = lazy(tmp_0, LocationToTransformAndFireQuestionContext$_anonymous__h6ok73);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_446(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LocationToTransformAndFireQuestionContext';
  }
  hashCode() {
    return -1804284749;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LocationToTransformAndFireQuestionContext))
      return false;
    return true;
  }
}
class SummonToSacrificeQuestionContext {
  constructor() {
    SummonToSacrificeQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l61_1 = lazy(tmp_0, SummonToSacrificeQuestionContext$_anonymous__lquv43);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_447(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonToSacrificeQuestionContext';
  }
  hashCode() {
    return 876319129;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonToSacrificeQuestionContext))
      return false;
    return true;
  }
}
class TargetToRunFromFireQuestionContext {
  constructor() {
    TargetToRunFromFireQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m61_1 = lazy(tmp_0, TargetToRunFromFireQuestionContext$_anonymous__ucb6rx);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_448(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TargetToRunFromFireQuestionContext';
  }
  hashCode() {
    return 962742607;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TargetToRunFromFireQuestionContext))
      return false;
    return true;
  }
}
class Companion_458 {
  constructor() {
    Companion_instance_458 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n61_1 = [lazy(tmp_0, AbyssalHellFireStatement$Companion$$childSerializers$_anonymous__tvw9xt)];
  }
}
class $serializer_386 {
  constructor() {
    $serializer_instance_382 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AbyssalHellFireStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.o61_1 = tmp0_serialDesc;
  }
  p61(encoder, value) {
    var tmp0_desc = this.o61_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_459().n61_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q61_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p61(encoder, value instanceof AbyssalHellFireStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o61_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_459().n61_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AbyssalHellFireStatement.r61(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.o61_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_459().n61_1[0].k3()];
  }
}
class AbyssalHellFireStatement {
  constructor(beast) {
    Companion_getInstance_459();
    this.q61_1 = beast;
  }
  toString() {
    return 'AbyssalHellFireStatement(beast=' + this.q61_1.toString() + ')';
  }
  hashCode() {
    return this.q61_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbyssalHellFireStatement))
      return false;
    if (!this.q61_1.equals(other.q61_1))
      return false;
    return true;
  }
  static r61(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_459();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_382().o61_1);
    }
    var $this = createThis(this);
    $this.q61_1 = beast;
    return $this;
  }
}
class Companion_459 {
  constructor() {
    Companion_instance_459 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s61_1 = [lazy(tmp_0, IncinerateHoardStatement$Companion$$childSerializers$_anonymous__vy8gw5)];
  }
}
class $serializer_387 {
  constructor() {
    $serializer_instance_383 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('IncinerateHoardStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.t61_1 = tmp0_serialDesc;
  }
  u61(encoder, value) {
    var tmp0_desc = this.t61_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_460().s61_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.v61_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u61(encoder, value instanceof IncinerateHoardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t61_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_460().s61_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return IncinerateHoardStatement.w61(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.t61_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_460().s61_1[0].k3()];
  }
}
class IncinerateHoardStatement {
  constructor(beast) {
    Companion_getInstance_460();
    this.v61_1 = beast;
  }
  toString() {
    return 'IncinerateHoardStatement(beast=' + this.v61_1.toString() + ')';
  }
  hashCode() {
    return this.v61_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IncinerateHoardStatement))
      return false;
    if (!this.v61_1.equals(other.v61_1))
      return false;
    return true;
  }
  static w61(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_460();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_383().t61_1);
    }
    var $this = createThis(this);
    $this.v61_1 = beast;
    return $this;
  }
}
class Companion_460 {
  constructor() {
    Companion_instance_460 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x61_1 = [lazy(tmp_0, IncinerateStatement$Companion$$childSerializers$_anonymous__fbteyr)];
  }
}
class $serializer_388 {
  constructor() {
    $serializer_instance_384 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('IncinerateStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.y61_1 = tmp0_serialDesc;
  }
  z61(encoder, value) {
    var tmp0_desc = this.y61_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_461().x61_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a62_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z61(encoder, value instanceof IncinerateStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y61_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_461().x61_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return IncinerateStatement.b62(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y61_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_461().x61_1[0].k3()];
  }
}
class IncinerateStatement {
  constructor(beast) {
    Companion_getInstance_461();
    this.a62_1 = beast;
  }
  toString() {
    return 'IncinerateStatement(beast=' + this.a62_1.toString() + ')';
  }
  hashCode() {
    return this.a62_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IncinerateStatement))
      return false;
    if (!this.a62_1.equals(other.a62_1))
      return false;
    return true;
  }
  static b62(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_461();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_384().y61_1);
    }
    var $this = createThis(this);
    $this.a62_1 = beast;
    return $this;
  }
}
class Companion_461 {
  constructor() {
    Companion_instance_461 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c62_1 = [lazy(tmp_0, RunFromFireStatement$Companion$$childSerializers$_anonymous__t140re)];
  }
}
class $serializer_389 {
  constructor() {
    $serializer_instance_385 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RunFromFireStatement', this, 1);
    tmp0_serialDesc.h1b('movingObject', false);
    this.d62_1 = tmp0_serialDesc;
  }
  e62(encoder, value) {
    var tmp0_desc = this.d62_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_462().c62_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f62_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e62(encoder, value instanceof RunFromFireStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d62_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_462().c62_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RunFromFireStatement.g62(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.d62_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_462().c62_1[0].k3()];
  }
}
class RunFromFireStatement extends MovementStepByStepStatement {
  constructor(movingObject) {
    Companion_getInstance_462();
    super();
    this.f62_1 = movingObject;
  }
  f2p() {
    return this.f62_1;
  }
  toString() {
    return 'RunFromFireStatement(movingObject=' + this.f62_1.toString() + ')';
  }
  hashCode() {
    return this.f62_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RunFromFireStatement))
      return false;
    if (!this.f62_1.equals(other.f62_1))
      return false;
    return true;
  }
  static g62(seen0, movingObject, serializationConstructorMarker) {
    Companion_getInstance_462();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_385().d62_1);
    }
    var $this = this.g2p(seen0, serializationConstructorMarker);
    $this.f62_1 = movingObject;
    return $this;
  }
}
class Companion_462 {
  constructor() {
    Companion_instance_462 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h62_1 = [lazy(tmp_0, PlaceFireTokenOnNearbyStatement$Companion$$childSerializers$_anonymous__mvhz6d)];
  }
}
class $serializer_390 {
  constructor() {
    $serializer_instance_386 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceFireTokenOnNearbyStatement', this, 1);
    tmp0_serialDesc.h1b('actor', false);
    this.i62_1 = tmp0_serialDesc;
  }
  j62(encoder, value) {
    var tmp0_desc = this.i62_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_463().h62_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.k62_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j62(encoder, value instanceof PlaceFireTokenOnNearbyStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i62_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_463().h62_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlaceFireTokenOnNearbyStatement.l62(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.i62_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_463().h62_1[0].k3()];
  }
}
class PlaceFireTokenOnNearbyStatement {
  constructor(actor) {
    Companion_getInstance_463();
    this.k62_1 = actor;
  }
  m62(gsCtx) {
    return minus_1(toSet(get_nearbyPositions(gsCtx, this.k62_1)), gsCtx.y4k());
  }
  o2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.m62($context_GameStateRuntime_604ce3).n1();
  }
  toString() {
    return 'PlaceFireTokenOnNearbyStatement(actor=' + this.k62_1.toString() + ')';
  }
  hashCode() {
    return this.k62_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceFireTokenOnNearbyStatement))
      return false;
    if (!this.k62_1.equals(other.k62_1))
      return false;
    return true;
  }
  static l62(seen0, actor, serializationConstructorMarker) {
    Companion_getInstance_463();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_386().i62_1);
    }
    var $this = createThis(this);
    $this.k62_1 = actor;
    return $this;
  }
}
class Companion_463 {
  constructor() {
    Companion_instance_463 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, PlaceFireTokensStatement$Companion$$childSerializers$_anonymous__odt5ua);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n62_1 = [tmp_1, lazy(tmp_2, PlaceFireTokensStatement$Companion$$childSerializers$_anonymous__odt5ua_0)];
  }
}
class $serializer_391 {
  constructor() {
    $serializer_instance_387 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceFireTokensStatement', this, 2);
    tmp0_serialDesc.h1b('actor', false);
    tmp0_serialDesc.h1b('positions', false);
    this.o62_1 = tmp0_serialDesc;
  }
  p62(encoder, value) {
    var tmp0_desc = this.o62_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_464().n62_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q62_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.r62_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p62(encoder, value instanceof PlaceFireTokensStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o62_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_464().n62_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PlaceFireTokensStatement.s62(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.o62_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_464().n62_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class PlaceFireTokensStatement {
  constructor(actor, positions) {
    Companion_getInstance_464();
    this.q62_1 = actor;
    this.r62_1 = positions;
  }
  m62(gsCtx) {
    return minus_1(this.r62_1, gsCtx.y4k());
  }
  o2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.m62($context_GameStateRuntime_604ce3).n1();
  }
  toString() {
    return 'PlaceFireTokensStatement(actor=' + this.q62_1.toString() + ', positions=' + toString(this.r62_1) + ')';
  }
  hashCode() {
    var result = this.q62_1.hashCode();
    result = imul(result, 31) + hashCode(this.r62_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceFireTokensStatement))
      return false;
    if (!this.q62_1.equals(other.q62_1))
      return false;
    if (!equals(this.r62_1, other.r62_1))
      return false;
    return true;
  }
  static s62(seen0, actor, positions, serializationConstructorMarker) {
    Companion_getInstance_464();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_387().o62_1);
    }
    var $this = createThis(this);
    $this.q62_1 = actor;
    $this.r62_1 = positions;
    return $this;
  }
}
class Companion_464 {}
class $serializer_392 {
  constructor() {
    $serializer_instance_388 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RhagnerAdjustHoardStatement', this, 2);
    tmp0_serialDesc.h1b('changesNumber', false);
    tmp0_serialDesc.h1b('isGain', false);
    this.t62_1 = tmp0_serialDesc;
  }
  u62(encoder, value) {
    var tmp0_desc = this.t62_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.v62_1);
    tmp1_output.w14(tmp0_desc, 1, value.w62_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u62(encoder, value instanceof RhagnerAdjustHoardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t62_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RhagnerAdjustHoardStatement.x62(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.t62_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class RhagnerAdjustHoardStatement {
  constructor(changesNumber, isGain) {
    this.v62_1 = changesNumber;
    this.w62_1 = isGain;
  }
  toString() {
    return 'RhagnerAdjustHoardStatement(changesNumber=' + this.v62_1 + ', isGain=' + this.w62_1 + ')';
  }
  hashCode() {
    var result = this.v62_1;
    result = imul(result, 31) + getBooleanHashCode(this.w62_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RhagnerAdjustHoardStatement))
      return false;
    if (!(this.v62_1 === other.v62_1))
      return false;
    if (!(this.w62_1 === other.w62_1))
      return false;
    return true;
  }
  static x62(seen0, changesNumber, isGain, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_388().t62_1);
    }
    var $this = createThis(this);
    $this.v62_1 = changesNumber;
    $this.w62_1 = isGain;
    return $this;
  }
}
class Companion_465 {
  constructor() {
    Companion_instance_465 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y62_1 = [lazy(tmp_0, RiseHoardStatement$Companion$$childSerializers$_anonymous__ue7yzm)];
  }
}
class $serializer_393 {
  constructor() {
    $serializer_instance_389 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RiseHoardStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.z62_1 = tmp0_serialDesc;
  }
  a63(encoder, value) {
    var tmp0_desc = this.z62_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_466().y62_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.b63_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a63(encoder, value instanceof RiseHoardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z62_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_466().y62_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RiseHoardStatement.c63(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.z62_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_466().y62_1[0].k3()];
  }
}
class RiseHoardStatement {
  constructor(beast) {
    Companion_getInstance_466();
    this.b63_1 = beast;
  }
  toString() {
    return 'RiseHoardStatement(beast=' + this.b63_1.toString() + ')';
  }
  hashCode() {
    return this.b63_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RiseHoardStatement))
      return false;
    if (!this.b63_1.equals(other.b63_1))
      return false;
    return true;
  }
  static c63(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_466();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_389().z62_1);
    }
    var $this = createThis(this);
    $this.b63_1 = beast;
    return $this;
  }
}
class Companion_466 {
  constructor() {
    Companion_instance_466 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d63_1 = [lazy(tmp_0, RiseStatement$Companion$$childSerializers$_anonymous__mz3igs)];
  }
}
class $serializer_394 {
  constructor() {
    $serializer_instance_390 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RiseStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.e63_1 = tmp0_serialDesc;
  }
  f63(encoder, value) {
    var tmp0_desc = this.e63_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_467().d63_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g63_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f63(encoder, value instanceof RiseStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e63_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_467().d63_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RiseStatement.h63(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e63_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_467().d63_1[0].k3()];
  }
}
class RiseStatement {
  constructor(beast) {
    Companion_getInstance_467();
    this.g63_1 = beast;
  }
  toString() {
    return 'RiseStatement(beast=' + this.g63_1.toString() + ')';
  }
  hashCode() {
    return this.g63_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RiseStatement))
      return false;
    if (!this.g63_1.equals(other.g63_1))
      return false;
    return true;
  }
  static h63(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_467();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_390().e63_1);
    }
    var $this = createThis(this);
    $this.g63_1 = beast;
    return $this;
  }
}
class Companion_467 {
  constructor() {
    Companion_instance_467 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i63_1 = [lazy(tmp_0, ScorchedEarthHoardStatement$Companion$$childSerializers$_anonymous__qdlsb8)];
  }
}
class $serializer_395 {
  constructor() {
    $serializer_instance_391 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ScorchedEarthHoardStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.j63_1 = tmp0_serialDesc;
  }
  k63(encoder, value) {
    var tmp0_desc = this.j63_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_468().i63_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l63_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k63(encoder, value instanceof ScorchedEarthHoardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j63_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_468().i63_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ScorchedEarthHoardStatement.m63(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.j63_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_468().i63_1[0].k3()];
  }
}
class ScorchedEarthHoardStatement {
  constructor(beast) {
    Companion_getInstance_468();
    this.l63_1 = beast;
  }
  toString() {
    return 'ScorchedEarthHoardStatement(beast=' + this.l63_1.toString() + ')';
  }
  hashCode() {
    return this.l63_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScorchedEarthHoardStatement))
      return false;
    if (!this.l63_1.equals(other.l63_1))
      return false;
    return true;
  }
  static m63(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_468();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_391().j63_1);
    }
    var $this = createThis(this);
    $this.l63_1 = beast;
    return $this;
  }
}
class Companion_468 {
  constructor() {
    Companion_instance_468 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n63_1 = [lazy(tmp_0, ScorchedEarthStatement$Companion$$childSerializers$_anonymous__3ii55a)];
  }
}
class $serializer_396 {
  constructor() {
    $serializer_instance_392 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ScorchedEarthStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.o63_1 = tmp0_serialDesc;
  }
  p63(encoder, value) {
    var tmp0_desc = this.o63_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_469().n63_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q63_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p63(encoder, value instanceof ScorchedEarthStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o63_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_469().n63_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ScorchedEarthStatement.r63(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.o63_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_469().n63_1[0].k3()];
  }
}
class ScorchedEarthStatement {
  constructor(beast) {
    Companion_getInstance_469();
    this.q63_1 = beast;
  }
  toString() {
    return 'ScorchedEarthStatement(beast=' + this.q63_1.toString() + ')';
  }
  hashCode() {
    return this.q63_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScorchedEarthStatement))
      return false;
    if (!this.q63_1.equals(other.q63_1))
      return false;
    return true;
  }
  static r63(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_469();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_392().o63_1);
    }
    var $this = createThis(this);
    $this.q63_1 = beast;
    return $this;
  }
}
class Companion_469 {
  constructor() {
    Companion_instance_469 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s63_1 = [lazy(tmp_0, SummonLindwyrmHoardStatement$Companion$$childSerializers$_anonymous__3gw0k6)];
  }
}
class $serializer_397 {
  constructor() {
    $serializer_instance_393 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SummonLindwyrmHoardStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.t63_1 = tmp0_serialDesc;
  }
  u63(encoder, value) {
    var tmp0_desc = this.t63_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_470().s63_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.v63_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u63(encoder, value instanceof SummonLindwyrmHoardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t63_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_470().s63_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SummonLindwyrmHoardStatement.w63(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.t63_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_470().s63_1[0].k3()];
  }
}
class SummonLindwyrmHoardStatement {
  constructor(beast) {
    Companion_getInstance_470();
    this.v63_1 = beast;
  }
  o2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !summonsOnMap($context_GameStateRuntime_604ce3, this.v63_1).n1();
  }
  toString() {
    return 'SummonLindwyrmHoardStatement(beast=' + this.v63_1.toString() + ')';
  }
  hashCode() {
    return this.v63_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonLindwyrmHoardStatement))
      return false;
    if (!this.v63_1.equals(other.v63_1))
      return false;
    return true;
  }
  static w63(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_470();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_393().t63_1);
    }
    var $this = createThis(this);
    $this.v63_1 = beast;
    return $this;
  }
}
class Companion_470 {
  constructor() {
    Companion_instance_470 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x63_1 = [lazy(tmp_0, SummonLindwyrmStatement$Companion$$childSerializers$_anonymous__25d1xo)];
  }
}
class $serializer_398 {
  constructor() {
    $serializer_instance_394 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SummonLindwyrmStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.y63_1 = tmp0_serialDesc;
  }
  z63(encoder, value) {
    var tmp0_desc = this.y63_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_471().x63_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.a64_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z63(encoder, value instanceof SummonLindwyrmStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y63_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_471().x63_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SummonLindwyrmStatement.b64(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.y63_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_471().x63_1[0].k3()];
  }
}
class SummonLindwyrmStatement {
  constructor(beast) {
    Companion_getInstance_471();
    this.a64_1 = beast;
  }
  toString() {
    return 'SummonLindwyrmStatement(beast=' + this.a64_1.toString() + ')';
  }
  hashCode() {
    return this.a64_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonLindwyrmStatement))
      return false;
    if (!this.a64_1.equals(other.a64_1))
      return false;
    return true;
  }
  static b64(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_471();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_394().y63_1);
    }
    var $this = createThis(this);
    $this.a64_1 = beast;
    return $this;
  }
}
class Companion_471 {
  constructor() {
    Companion_instance_471 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c64_1 = [lazy(tmp_0, RhagnerHoardChangeEvent$Companion$$childSerializers$_anonymous__ialzqr), null];
  }
}
class $serializer_399 {
  constructor() {
    $serializer_instance_395 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RhagnerHoardChangeEvent', this, 2);
    tmp0_serialDesc.h1b('card', false);
    tmp0_serialDesc.h1b('hoardChange', false);
    this.d64_1 = tmp0_serialDesc;
  }
  e64(encoder, value) {
    var tmp0_desc = this.d64_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_472().c64_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f64_1);
    tmp1_output.z14(tmp0_desc, 1, value.g64_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e64(encoder, value instanceof RhagnerHoardChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d64_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_472().c64_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return RhagnerHoardChangeEvent.h64(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d64_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_472().c64_1[0].k3(), IntSerializer_getInstance()];
  }
}
class RhagnerHoardChangeEvent {
  constructor(card, hoardChange) {
    Companion_getInstance_472();
    this.f64_1 = card;
    this.g64_1 = hoardChange;
  }
  m37(_this__u8e3s4) {
    setHoardLevel(_this__u8e3s4, get_rhagnerBeast(_this__u8e3s4), this.f64_1, ensureNotNull(get_rhagnerHoardLevelsImpl(_this__u8e3s4, get_rhagnerBeast(_this__u8e3s4)).w4(this.f64_1)) + this.g64_1 | 0);
  }
  n37($context_GameState_t6qee5) {
    return new RhagnerHoardChangeEvent(this.f64_1, -this.g64_1 | 0);
  }
  toString() {
    return 'RhagnerHoardChangeEvent(card=' + toString(this.f64_1) + ', hoardChange=' + this.g64_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.f64_1);
    result = imul(result, 31) + this.g64_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RhagnerHoardChangeEvent))
      return false;
    if (!equals(this.f64_1, other.f64_1))
      return false;
    if (!(this.g64_1 === other.g64_1))
      return false;
    return true;
  }
  static h64(seen0, card, hoardChange, serializationConstructorMarker) {
    Companion_getInstance_472();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_395().d64_1);
    }
    var $this = createThis(this);
    $this.f64_1 = card;
    $this.g64_1 = hoardChange;
    return $this;
  }
}
class LindwyrmType {
  constructor() {
    LindwyrmType_instance = this;
    this.i64_1 = Rhagner_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j64_1 = lazy(tmp_0, LindwyrmType$_anonymous__zpzsd);
  }
  r37() {
    return this.i64_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_449(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LindwyrmType';
  }
  hashCode() {
    return 1643678127;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LindwyrmType))
      return false;
    return true;
  }
}
class Companion_472 {}
class $serializer_400 {
  constructor() {
    $serializer_instance_396 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AngerIncinerateAttackModifier', this, 1);
    tmp0_serialDesc.h1b('targetPosition', false);
    this.k64_1 = tmp0_serialDesc;
  }
  l64(encoder, value) {
    var tmp0_desc = this.k64_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.m64_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l64(encoder, value instanceof AngerIncinerateAttackModifier ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k64_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AngerIncinerateAttackModifier.n64(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.k64_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100()];
  }
}
class AngerIncinerateAttackModifier {
  constructor(targetPosition) {
    this.m64_1 = targetPosition;
  }
  w35($context_GameState_t6qee5, target) {
    return target.s2w($context_GameState_t6qee5) === this.m64_1;
  }
  x35($context_GameState_t6qee5, target) {
    return 2;
  }
  toString() {
    return 'AngerIncinerateAttackModifier(targetPosition=' + BoardPosition__toString_impl_v4mn82(this.m64_1) + ')';
  }
  hashCode() {
    return BoardPosition__hashCode_impl_9dgqf7(this.m64_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AngerIncinerateAttackModifier))
      return false;
    if (!(this.m64_1 === other.m64_1))
      return false;
    return true;
  }
  static n64(seen0, targetPosition, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_396().k64_1);
    }
    var $this = createThis(this);
    $this.m64_1 = targetPosition;
    return $this;
  }
}
class Companion_473 {}
class $serializer_401 {
  constructor() {
    $serializer_instance_397 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SecretsFromALostAgeContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.o64_1 = tmp0_serialDesc;
  }
  p64(encoder, value) {
    var tmp0_desc = this.o64_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.r64_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.s64_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 2, value.s64_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.t64_1 === 2)) {
      tmp1_output.z14(tmp0_desc, 3, value.t64_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.u64_1.equals(Companion_getInstance_220().x39_1)) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.u64_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p64(encoder, value instanceof SecretsFromALostAgeContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o64_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return SecretsFromALostAgeContract.v64(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.o64_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class SecretsFromALostAgeContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.w64(rulesParameters);
  }
  static w64(rulesParameters) {
    var $this = this.b3a();
    $this.r64_1 = rulesParameters;
    $this.s64_1 = 3;
    $this.t64_1 = 2;
    $this.u64_1 = Companion_getInstance_220().x39_1;
    return $this;
  }
  c3a() {
    return this.r64_1;
  }
  static x64(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    balanceVersion = balanceVersion === VOID ? Companion_getInstance_217().e3a_1 : balanceVersion;
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().x39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.w64(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(1, 1);
  }
  h3a() {
    return GameMapId_UpperShatteredIsles_getInstance();
  }
  i3a() {
    return this.s64_1;
  }
  j3a() {
    return 1;
  }
  k3a() {
    return 2;
  }
  l3a() {
    return this.t64_1;
  }
  m3a() {
    return SecretsFromALostAgeInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_isTwoSheepOrTigerCompleted_0($context_GameState_t6qee5));
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) > 0);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_destroyRecords($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.p3a_1 === get_beastsGameTeam()) {
          destination.d2(element);
        }
      }
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(destination, Collection)) {
          tmp_0 = destination.n1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = destination.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          // Inline function 'kotlin.let' call
          var type = get_objectType($context_GameState_t6qee5, element_0.o3a_1);
          var tmp_1;
          if (equals(type, TigerType_getInstance())) {
            tmp_1 = true;
          } else {
            tmp_1 = isInterface(type, SettlerType);
          }
          if (tmp_1) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
        }
        tmp$ret$3 = false;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp$ret$3);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredExpectedOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) >= 2, ruinsControlled_0($context_GameState_t6qee5, get_huntersGameTeam()) >= 2);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.u64_1;
  }
  v3a(rulesParameters) {
    return SecretsFromALostAgeContract.w64(rulesParameters);
  }
  toString() {
    return 'SecretsFromALostAgeContract(rulesParameters=' + this.r64_1.toString() + ')';
  }
  hashCode() {
    return this.r64_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SecretsFromALostAgeContract))
      return false;
    if (!this.r64_1.equals(other.r64_1))
      return false;
    return true;
  }
  static v64(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_397().o64_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.r64_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.s64_1 = 3;
    else
      $this.s64_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.t64_1 = 2;
    else
      $this.t64_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.u64_1 = Companion_getInstance_220().x39_1;
    else
      $this.u64_1 = requiredVersion;
    return $this;
  }
}
class SecretsFromALostAgeInitialPhase {
  constructor() {
    SecretsFromALostAgeInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y64_1 = lazy(tmp_0, SecretsFromALostAgeInitialPhase$_anonymous__n3dhpj);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_450(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SecretsFromALostAgeInitialPhase';
  }
  hashCode() {
    return -779934823;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SecretsFromALostAgeInitialPhase))
      return false;
    return true;
  }
}
class Companion_474 {}
class $serializer_402 {
  constructor() {
    $serializer_instance_398 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ShipwreckContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.z64_1 = tmp0_serialDesc;
  }
  a65(encoder, value) {
    var tmp0_desc = this.z64_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.c65_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.d65_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 2, value.d65_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.e65_1 === 2)) {
      tmp1_output.z14(tmp0_desc, 3, value.e65_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.f65_1.equals(Companion_getInstance_220().w39_1)) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.f65_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a65(encoder, value instanceof ShipwreckContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z64_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return ShipwreckContract.g65(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.z64_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class ShipwreckContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.h65(rulesParameters);
  }
  static h65(rulesParameters) {
    var $this = this.b3a();
    $this.c65_1 = rulesParameters;
    $this.d65_1 = 3;
    $this.e65_1 = 2;
    $this.f65_1 = Companion_getInstance_220().w39_1;
    return $this;
  }
  c3a() {
    return this.c65_1;
  }
  static i65(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().w39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.h65(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(1, 0);
  }
  h3a() {
    return GameMapId_DrenchedLands_getInstance();
  }
  i3a() {
    return this.d65_1;
  }
  j3a() {
    return 1;
  }
  k3a() {
    return 2;
  }
  l3a() {
    return this.e65_1;
  }
  m3a() {
    return ShipwreckInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_isClassicTwoSheepOrBoarCompleted_0($context_GameState_t6qee5));
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) > 0);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0 = get_destroyedObjects($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp$ret$6;
        $l$block: {
          // Inline function 'steelart.beast.cast' call
          var tmp_0 = get_objectType($context_GameState_t6qee5, element);
          if (isInterface(tmp_0, SettlerType)) {
            tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
            break $l$block;
          }
          tmp$ret$6 = null;
        }
        var tmp0_safe_receiver = tmp$ret$6;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.d2(tmp0_safe_receiver);
        }
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$9 = !destination.n1();
      tmp = ensuredOrNotGainedRewardStatus(tmp$ret$9);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      // Inline function 'steelart.beast.castFilter' call
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_0 = get_allObjectOnBoard($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = tmp0_0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        var tmp$ret$16;
        $l$block_0: {
          // Inline function 'steelart.beast.cast' call
          var tmp_1 = get_objectType($context_GameState_t6qee5, element_0);
          if (isInterface(tmp_1, SettlerType)) {
            tmp$ret$16 = element_0 instanceof ObjectOnBoard ? element_0 : THROW_CCE();
            break $l$block_0;
          }
          tmp$ret$16 = null;
        }
        var tmp0_safe_receiver_0 = tmp$ret$16;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_0.d2(tmp0_safe_receiver_0);
        }
      }
      var tmp$ret$19;
      $l$block_2: {
        // Inline function 'kotlin.collections.none' call
        var tmp_2;
        if (isInterface(destination_0, Collection)) {
          tmp_2 = destination_0.n1();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$19 = true;
          break $l$block_2;
        }
        var _iterator__ex2g4s_1 = destination_0.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var element_1 = _iterator__ex2g4s_1.r1();
          if (element_1.s2w($context_GameState_t6qee5) === _BoardPosition___init__impl__1nizgq_0(0, -3)) {
            tmp$ret$19 = false;
            break $l$block_2;
          }
        }
        tmp$ret$19 = true;
      }
      tmp = expectedOrFailedRewardStatus(tmp$ret$19);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.f65_1;
  }
  v3a(rulesParameters) {
    return ShipwreckContract.h65(rulesParameters);
  }
  toString() {
    return 'ShipwreckContract(rulesParameters=' + this.c65_1.toString() + ')';
  }
  hashCode() {
    return this.c65_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShipwreckContract))
      return false;
    if (!this.c65_1.equals(other.c65_1))
      return false;
    return true;
  }
  static g65(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_398().z64_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.c65_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.d65_1 = 3;
    else
      $this.d65_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.e65_1 = 2;
    else
      $this.e65_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.f65_1 = Companion_getInstance_220().w39_1;
    else
      $this.f65_1 = requiredVersion;
    return $this;
  }
}
class ShipwreckRedDraftActionCardEffectSource {
  constructor() {
    ShipwreckRedDraftActionCardEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j65_1 = lazy(tmp_0, ShipwreckRedDraftActionCardEffectSource$_anonymous__ern0m9);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_451(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ShipwreckRedDraftActionCardEffectSource';
  }
  hashCode() {
    return -1475282029;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShipwreckRedDraftActionCardEffectSource))
      return false;
    return true;
  }
}
class ShipwreckSettlerMovementStatement {
  constructor() {
    ShipwreckSettlerMovementStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k65_1 = lazy(tmp_0, ShipwreckSettlerMovementStatement$_anonymous__ggs1ig);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_452(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ShipwreckSettlerMovementStatement';
  }
  hashCode() {
    return -1587134006;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShipwreckSettlerMovementStatement))
      return false;
    return true;
  }
}
class ShipwreckInitialPhase {
  constructor() {
    ShipwreckInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l65_1 = lazy(tmp_0, ShipwreckInitialPhase$_anonymous__d8tqyy);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_453(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ShipwreckInitialPhase';
  }
  hashCode() {
    return -329597912;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShipwreckInitialPhase))
      return false;
    return true;
  }
}
class Companion_475 {
  constructor() {
    Companion_instance_475 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m65_1 = [lazy(tmp_0, ChangeSettlersMovedStatusEvent$Companion$$childSerializers$_anonymous__t7n4iv), null];
  }
}
class $serializer_403 {
  constructor() {
    $serializer_instance_399 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ChangeSettlersMovedStatusEvent', this, 2);
    tmp0_serialDesc.h1b('settlersMoved', false);
    tmp0_serialDesc.h1b('newStatus', false);
    this.n65_1 = tmp0_serialDesc;
  }
  o65(encoder, value) {
    var tmp0_desc = this.n65_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_476().m65_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p65_1);
    tmp1_output.w14(tmp0_desc, 1, value.q65_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o65(encoder, value instanceof ChangeSettlersMovedStatusEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n65_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_476().m65_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return ChangeSettlersMovedStatusEvent.r65(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.n65_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_476().m65_1[0].k3(), BooleanSerializer_getInstance()];
  }
}
class ChangeSettlersMovedStatusEvent {
  constructor(settlersMoved, newStatus) {
    Companion_getInstance_476();
    this.p65_1 = settlersMoved;
    this.q65_1 = newStatus;
  }
  m37(_this__u8e3s4) {
    var _iterator__ex2g4s = this.p65_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var it = _iterator__ex2g4s.r1();
      set_settlerWasMovedOnHunterTurnImpl(_this__u8e3s4, it, this.q65_1);
    }
  }
  n37($context_GameState_t6qee5) {
    return new ChangeSettlersMovedStatusEvent(this.p65_1, !this.q65_1);
  }
  toString() {
    return 'ChangeSettlersMovedStatusEvent(settlersMoved=' + toString(this.p65_1) + ', newStatus=' + this.q65_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.p65_1);
    result = imul(result, 31) + getBooleanHashCode(this.q65_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangeSettlersMovedStatusEvent))
      return false;
    if (!equals(this.p65_1, other.p65_1))
      return false;
    if (!(this.q65_1 === other.q65_1))
      return false;
    return true;
  }
  static r65(seen0, settlersMoved, newStatus, serializationConstructorMarker) {
    Companion_getInstance_476();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_399().n65_1);
    }
    var $this = createThis(this);
    $this.p65_1 = settlersMoved;
    $this.q65_1 = newStatus;
    return $this;
  }
}
class Sigrid {
  constructor() {
    Sigrid_instance = this;
    this.s65_1 = setOf_0([EcholocationUpgrade_getInstance(), SwapUpgrade_getInstance(), PactReversalUpgrade_getInstance()]);
    this.t65_1 = CreatureType_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u65_1 = lazy(tmp_0, Sigrid$_anonymous__hn1iv9);
  }
  s36() {
    return get_sigridAbilityCards();
  }
  t35() {
    return this.s65_1;
  }
  n2z($context_GameState_t6qee5) {
    return 3;
  }
  i3e() {
    return this.t65_1;
  }
  v36($context_GameState_t6qee5, position) {
    var tmp = getInitList_0.call(this, $context_GameState_t6qee5, position);
    var tmp_0 = get_sigridPactsKey();
    // Inline function 'kotlin.collections.mapOf' call
    var tmp$ret$0 = emptyMap();
    return plus_2(tmp, listOf_0([init(tmp_0, new PlayableCardToLocationTypeMapWrapper(tmp$ret$0)), init(get_sigridCreatureLungedThisTurnKey(), new BooleanWrapper(false))]));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_454(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Sigrid';
  }
  hashCode() {
    return 156219809;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Sigrid))
      return false;
    return true;
  }
}
class EcholocationUpgrade {
  constructor() {
    EcholocationUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v65_1 = lazy(tmp_0, EcholocationUpgrade$_anonymous__7uirsl);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_455(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EcholocationUpgrade';
  }
  hashCode() {
    return -936613635;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EcholocationUpgrade))
      return false;
    return true;
  }
}
class SwapUpgrade {
  constructor() {
    SwapUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w65_1 = lazy(tmp_0, SwapUpgrade$_anonymous__8dy4c2);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_456(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SwapUpgrade';
  }
  hashCode() {
    return 1046324516;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SwapUpgrade))
      return false;
    return true;
  }
}
class PactReversalUpgrade {
  constructor() {
    PactReversalUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x65_1 = lazy(tmp_0, PactReversalUpgrade$_anonymous__kjb9gr);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  u35($context_GameState_t6qee5) {
    var tmp0_safe_receiver = get_creatureCompanion($context_GameState_t6qee5);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = (!get_isDead($context_GameState_t6qee5, tmp0_safe_receiver) && !(tmp0_safe_receiver.s2w($context_GameState_t6qee5) === get_sigridHunter($context_GameState_t6qee5).s2w($context_GameState_t6qee5)));
    }
    return tmp === true;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_457(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PactReversalUpgrade';
  }
  hashCode() {
    return 1057281927;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PactReversalUpgrade))
      return false;
    return true;
  }
}
class SigridCreatureDeathEffectSource {
  constructor() {
    SigridCreatureDeathEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y65_1 = lazy(tmp_0, SigridCreatureDeathEffectSource$_anonymous__9w7vle);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_458(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SigridCreatureDeathEffectSource';
  }
  hashCode() {
    return 1639943296;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridCreatureDeathEffectSource))
      return false;
    return true;
  }
}
class SigridCreatureLungeEffectSource {
  constructor() {
    SigridCreatureLungeEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z65_1 = lazy(tmp_0, SigridCreatureLungeEffectSource$_anonymous__xerxj1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_459(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SigridCreatureLungeEffectSource';
  }
  hashCode() {
    return 1283747631;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridCreatureLungeEffectSource))
      return false;
    return true;
  }
}
class SigridSummonCreatureEffectSource {
  constructor() {
    SigridSummonCreatureEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a66_1 = lazy(tmp_0, SigridSummonCreatureEffectSource$_anonymous__u7wsdr);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_460(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SigridSummonCreatureEffectSource';
  }
  hashCode() {
    return 1984446445;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridSummonCreatureEffectSource))
      return false;
    return true;
  }
}
class SigridPactCardQuestionContext {
  constructor() {
    SigridPactCardQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b66_1 = lazy(tmp_0, SigridPactCardQuestionContext$_anonymous__d53xic);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_461(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SigridPactCardQuestionContext';
  }
  hashCode() {
    return 1217836374;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridPactCardQuestionContext))
      return false;
    return true;
  }
}
class Companion_476 {
  constructor() {
    Companion_instance_476 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, SigridAttackAllNearbyLocationsStatement$Companion$$childSerializers$_anonymous__701kxv);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c66_1 = [tmp_1, lazy(tmp_2, SigridAttackAllNearbyLocationsStatement$Companion$$childSerializers$_anonymous__701kxv_0)];
  }
}
class $serializer_404 {
  constructor() {
    $serializer_instance_400 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SigridAttackAllNearbyLocationsStatement', this, 2);
    tmp0_serialDesc.h1b('damageSource', false);
    tmp0_serialDesc.h1b('hunter', false);
    this.d66_1 = tmp0_serialDesc;
  }
  e66(encoder, value) {
    var tmp0_desc = this.d66_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_477().c66_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.f66_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.g66_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e66(encoder, value instanceof SigridAttackAllNearbyLocationsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d66_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_477().c66_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SigridAttackAllNearbyLocationsStatement.h66(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d66_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_477().c66_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), tmp0_cached[1].k3()];
  }
}
class SigridAttackAllNearbyLocationsStatement {
  constructor(damageSource, hunter) {
    Companion_getInstance_477();
    this.f66_1 = damageSource;
    this.g66_1 = hunter;
  }
  o2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !get_gameRules($context_GameStateRuntime_604ce3).n2q($context_GameStateRuntime_604ce3, this.g66_1, JustNearbyAttackModifier_getInstance()).n1();
  }
  toString() {
    return 'SigridAttackAllNearbyLocationsStatement(damageSource=' + toString(this.f66_1) + ', hunter=' + this.g66_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.f66_1);
    result = imul(result, 31) + this.g66_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridAttackAllNearbyLocationsStatement))
      return false;
    if (!equals(this.f66_1, other.f66_1))
      return false;
    if (!this.g66_1.equals(other.g66_1))
      return false;
    return true;
  }
  static h66(seen0, damageSource, hunter, serializationConstructorMarker) {
    Companion_getInstance_477();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_400().d66_1);
    }
    var $this = createThis(this);
    $this.f66_1 = damageSource;
    $this.g66_1 = hunter;
    return $this;
  }
}
class SigridCreatureLungeStatement {
  constructor() {
    SigridCreatureLungeStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i66_1 = lazy(tmp_0, SigridCreatureLungeStatement$_anonymous__lw2n3k);
  }
  o2o($context_GameStateRuntime_604ce3) {
    var tmp0_safe_receiver = get_creatureCompanion($context_GameStateRuntime_604ce3);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = (!get_isDead($context_GameStateRuntime_604ce3, tmp0_safe_receiver) && !get_sigridCreatureLungedThisTurn($context_GameStateRuntime_604ce3, get_sigridHunter($context_GameStateRuntime_604ce3)));
    }
    return tmp === true;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_462(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SigridCreatureLungeStatement';
  }
  hashCode() {
    return -1359052244;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridCreatureLungeStatement))
      return false;
    return true;
  }
}
class SigridPactReversalStatement {
  constructor() {
    SigridPactReversalStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j66_1 = lazy(tmp_0, SigridPactReversalStatement$_anonymous__do2a6s);
  }
  o2o($context_GameStateRuntime_604ce3) {
    var tmp0_safe_receiver = get_creatureCompanion($context_GameStateRuntime_604ce3);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = (!get_isDead($context_GameStateRuntime_604ce3, tmp0_safe_receiver) && !(tmp0_safe_receiver.s2w($context_GameStateRuntime_604ce3) === get_sigridHunter($context_GameStateRuntime_604ce3).s2w($context_GameStateRuntime_604ce3)));
    }
    return tmp === true;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_463(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SigridPactReversalStatement';
  }
  hashCode() {
    return 934384286;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridPactReversalStatement))
      return false;
    return true;
  }
}
class Companion_477 {
  constructor() {
    Companion_instance_477 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k66_1 = [lazy(tmp_0, SigridSearchAllNearbyLocationsStatement$Companion$$childSerializers$_anonymous__wg2ujh)];
  }
}
class $serializer_405 {
  constructor() {
    $serializer_instance_401 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SigridSearchAllNearbyLocationsStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.l66_1 = tmp0_serialDesc;
  }
  m66(encoder, value) {
    var tmp0_desc = this.l66_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_478().k66_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.n66_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m66(encoder, value instanceof SigridSearchAllNearbyLocationsStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l66_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_478().k66_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SigridSearchAllNearbyLocationsStatement.o66(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l66_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_478().k66_1[0].k3()];
  }
}
class SigridSearchAllNearbyLocationsStatement {
  constructor(hunter) {
    Companion_getInstance_478();
    this.n66_1 = hunter;
  }
  o2o($context_GameStateRuntime_604ce3) {
    var tmp0 = get_aliveBeasts_0($context_GameStateRuntime_604ce3);
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp0_0 = get_nearbyPositions($context_GameStateRuntime_604ce3, this.n66_1);
        var tmp$ret$2;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp0_0, Collection)) {
            tmp_0 = tmp0_0.n1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$2 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_0 = tmp0_0.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var element_0 = _iterator__ex2g4s_0.r1();
            var it = element_0.r2v_1;
            if (get_positionsWithTrailsOrStandee($context_GameStateRuntime_604ce3, element).w2(new BoardPosition(it))) {
              tmp$ret$2 = true;
              break $l$block_1;
            }
          }
          tmp$ret$2 = false;
        }
        if (tmp$ret$2) {
          tmp$ret$0 = true;
          break $l$block_2;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  toString() {
    return 'SigridSearchAllNearbyLocationsStatement(hunter=' + this.n66_1.toString() + ')';
  }
  hashCode() {
    return this.n66_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridSearchAllNearbyLocationsStatement))
      return false;
    if (!this.n66_1.equals(other.n66_1))
      return false;
    return true;
  }
  static o66(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_478();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_401().l66_1);
    }
    var $this = createThis(this);
    $this.n66_1 = hunter;
    return $this;
  }
}
class SummonCreatureStatement {
  constructor() {
    SummonCreatureStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p66_1 = lazy(tmp_0, SummonCreatureStatement$_anonymous__6onuk8);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_464(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonCreatureStatement';
  }
  hashCode() {
    return 1470714026;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonCreatureStatement))
      return false;
    return true;
  }
}
class Companion_478 {
  constructor() {
    Companion_instance_478 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, SigridPactChangeEvent$Companion$$childSerializers$_anonymous__2izx3y);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q66_1 = [tmp_1, lazy(tmp_2, SigridPactChangeEvent$Companion$$childSerializers$_anonymous__2izx3y_0)];
  }
}
class $serializer_406 {
  constructor() {
    $serializer_instance_402 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SigridPactChangeEvent', this, 2);
    tmp0_serialDesc.h1b('card', false);
    tmp0_serialDesc.h1b('terrain', false);
    this.r66_1 = tmp0_serialDesc;
  }
  s66(encoder, value) {
    var tmp0_desc = this.r66_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_479().q66_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t66_1);
    tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.u66_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s66(encoder, value instanceof SigridPactChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r66_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_479().q66_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SigridPactChangeEvent.v66(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r66_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_479().q66_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].k3(), get_nullable(tmp0_cached[1].k3())];
  }
}
class SigridPactChangeEvent {
  constructor(card, terrain) {
    Companion_getInstance_479();
    this.t66_1 = card;
    this.u66_1 = terrain;
  }
  m37(_this__u8e3s4) {
    setSigridPact(_this__u8e3s4, get_sigridHunter(_this__u8e3s4), this.t66_1, this.u66_1);
  }
  n37($context_GameState_t6qee5) {
    return new SigridPactChangeEvent(this.t66_1, pactTerrain($context_GameState_t6qee5, get_sigridHunter($context_GameState_t6qee5), this.t66_1));
  }
  toString() {
    return 'SigridPactChangeEvent(card=' + toString(this.t66_1) + ', terrain=' + toString_0(this.u66_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.t66_1);
    result = imul(result, 31) + (this.u66_1 == null ? 0 : this.u66_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridPactChangeEvent))
      return false;
    if (!equals(this.t66_1, other.t66_1))
      return false;
    if (!equals(this.u66_1, other.u66_1))
      return false;
    return true;
  }
  static v66(seen0, card, terrain, serializationConstructorMarker) {
    Companion_getInstance_479();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_402().r66_1);
    }
    var $this = createThis(this);
    $this.t66_1 = card;
    $this.u66_1 = terrain;
    return $this;
  }
}
class Companion_479 {}
class $serializer_407 {
  constructor() {
    $serializer_instance_403 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SigridCreatureLungedStatusEvent', this, 1);
    tmp0_serialDesc.h1b('newStatus', false);
    this.w66_1 = tmp0_serialDesc;
  }
  x66(encoder, value) {
    var tmp0_desc = this.w66_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.w14(tmp0_desc, 0, value.y66_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x66(encoder, value instanceof SigridCreatureLungedStatusEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w66_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SigridCreatureLungedStatusEvent.z66(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w66_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance()];
  }
}
class SigridCreatureLungedStatusEvent {
  constructor(newStatus) {
    this.y66_1 = newStatus;
  }
  m37(_this__u8e3s4) {
    set_sigridCreatureLungedThisTurnImpl(_this__u8e3s4, get_sigridHunter(_this__u8e3s4), this.y66_1);
  }
  n37($context_GameState_t6qee5) {
    return new SigridCreatureLungedStatusEvent(!this.y66_1);
  }
  toString() {
    return 'SigridCreatureLungedStatusEvent(newStatus=' + this.y66_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.y66_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridCreatureLungedStatusEvent))
      return false;
    if (!(this.y66_1 === other.y66_1))
      return false;
    return true;
  }
  static z66(seen0, newStatus, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_403().w66_1);
    }
    var $this = createThis(this);
    $this.y66_1 = newStatus;
    return $this;
  }
}
class SigridCreatureLungedEvent extends MarkerGameStateEvent {
  constructor() {
    SigridCreatureLungedEvent_instance = null;
    super();
    SigridCreatureLungedEvent_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a67_1 = lazy(tmp_0, SigridCreatureLungedEvent$_anonymous__5jadpj);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_465(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SigridCreatureLungedEvent';
  }
  hashCode() {
    return -536355623;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SigridCreatureLungedEvent))
      return false;
    return true;
  }
}
class CreatureType {
  constructor() {
    CreatureType_instance = this;
    this.b67_1 = Sigrid_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c67_1 = lazy(tmp_0, CreatureType$_anonymous__t2c2pu);
  }
  p3x() {
    return this.b67_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_466(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CreatureType';
  }
  hashCode() {
    return -105608354;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CreatureType))
      return false;
    return true;
  }
}
class SigridAbilityCard {}
function get_character_1() {
  return Sigrid_getInstance();
}
class TraitorsHuntCard {
  constructor() {
    TraitorsHuntCard_instance = this;
    this.d67_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e67_1 = lazy(tmp_0, TraitorsHuntCard$_anonymous__g05hym);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_467(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TraitorsHuntCard';
  }
  hashCode() {
    return 2092494410;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TraitorsHuntCard))
      return false;
    return true;
  }
}
class BondedTrackCard {
  constructor() {
    BondedTrackCard_instance = this;
    this.f67_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g67_1 = lazy(tmp_0, BondedTrackCard$_anonymous__itqr4y);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_468(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BondedTrackCard';
  }
  hashCode() {
    return 1901523220;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BondedTrackCard))
      return false;
    return true;
  }
}
class ScroungeCard {
  constructor() {
    ScroungeCard_instance = this;
    this.h67_1 = Split_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i67_1 = lazy(tmp_0, ScroungeCard$_anonymous__sn5mqr);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_469(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ScroungeCard';
  }
  hashCode() {
    return 564749241;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScroungeCard))
      return false;
    return true;
  }
}
class Companion_480 {
  a2g() {
    var tmp = getKClass(SigridAbilityCard);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(BondedTrackCard), getKClass(ScroungeCard), getKClass(TraitorsHuntCard)];
    var tmp_1 = BondedTrackCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('BondedTrackCard', tmp_1, tmp$ret$3);
    var tmp_3 = ScroungeCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_4 = ObjectSerializer.l1c('ScroungeCard', tmp_3, tmp$ret$6);
    var tmp_5 = TraitorsHuntCard_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_6 = [tmp_2, tmp_4, ObjectSerializer.l1c('TraitorsHuntCard', tmp_5, tmp$ret$9)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    return SealedClassSerializer.i10('steelart.beast.SigridAbilityCard', tmp, tmp_0, tmp_6, tmp$ret$15);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class CloudShiftUpgrade {
  constructor() {
    CloudShiftUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j67_1 = lazy(tmp_0, CloudShiftUpgrade$_anonymous__b7y0s8);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_470(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CloudShiftUpgrade';
  }
  hashCode() {
    return -1551713814;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CloudShiftUpgrade))
      return false;
    return true;
  }
}
class BehornedUpgrade {
  constructor() {
    BehornedUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k67_1 = lazy(tmp_0, BehornedUpgrade$_anonymous__de7ujk);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_471(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BehornedUpgrade';
  }
  hashCode() {
    return 1010083218;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BehornedUpgrade))
      return false;
    return true;
  }
}
class StormBringerUpgrade {
  constructor() {
    StormBringerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l67_1 = lazy(tmp_0, StormBringerUpgrade$_anonymous__82st4h);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_472(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'StormBringerUpgrade';
  }
  hashCode() {
    return 982204865;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StormBringerUpgrade))
      return false;
    return true;
  }
}
class EruptionUpgrade {
  constructor() {
    EruptionUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m67_1 = lazy(tmp_0, EruptionUpgrade$_anonymous__a7ip8p);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_473(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EruptionUpgrade';
  }
  hashCode() {
    return 607478267;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EruptionUpgrade))
      return false;
    return true;
  }
}
class SuddenShockUpgrade {
  constructor() {
    SuddenShockUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n67_1 = lazy(tmp_0, SuddenShockUpgrade$_anonymous__q2m9ke);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_474(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SuddenShockUpgrade';
  }
  hashCode() {
    return 1009816266;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SuddenShockUpgrade))
      return false;
    return true;
  }
}
class DischargeUpgrade {
  constructor() {
    DischargeUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o67_1 = lazy(tmp_0, DischargeUpgrade$_anonymous__lqein1);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_475(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DischargeUpgrade';
  }
  hashCode() {
    return 1004677055;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DischargeUpgrade))
      return false;
    return true;
  }
}
class StarFallUpgrade {
  constructor() {
    StarFallUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p67_1 = lazy(tmp_0, StarFallUpgrade$_anonymous__vcvjrs);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_476(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'StarFallUpgrade';
  }
  hashCode() {
    return 1327775498;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StarFallUpgrade))
      return false;
    return true;
  }
}
class Thalduk {
  constructor() {
    Thalduk_instance = this;
    this.q67_1 = YagiType_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r67_1 = lazy(tmp_0, Thalduk$_anonymous__4g4ckc);
  }
  q36() {
    return this.q67_1;
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Cave_getInstance();
  }
  s36() {
    return setOf_0([SummonYagiCard_getInstance(), StormCard_getInstance(), AcclivityCard_getInstance(), BleatCard_getInstance()]);
  }
  t35() {
    return setOf_0([CloudShiftUpgrade_getInstance(), BehornedUpgrade_getInstance(), StormBringerUpgrade_getInstance(), EruptionUpgrade_getInstance(), SuddenShockUpgrade_getInstance(), DischargeUpgrade_getInstance(), StarFallUpgrade_getInstance()]);
  }
  n2z($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_477(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Thalduk';
  }
  hashCode() {
    return 1400997270;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Thalduk))
      return false;
    return true;
  }
}
class PossibleBleatEffectSource {
  constructor() {
    PossibleBleatEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s67_1 = lazy(tmp_0, PossibleBleatEffectSource$_anonymous__uuzunm);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_478(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PossibleBleatEffectSource';
  }
  hashCode() {
    return 24045156;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PossibleBleatEffectSource))
      return false;
    return true;
  }
}
class ActorForRamQuestionContext {
  constructor() {
    ActorForRamQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t67_1 = lazy(tmp_0, ActorForRamQuestionContext$_anonymous__k5a2x4);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_479(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ActorForRamQuestionContext';
  }
  hashCode() {
    return -1242762460;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ActorForRamQuestionContext))
      return false;
    return true;
  }
}
class TargetToRamQuestionContext {
  constructor() {
    TargetToRamQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u67_1 = lazy(tmp_0, TargetToRamQuestionContext$_anonymous__9alkm8);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_480(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TargetToRamQuestionContext';
  }
  hashCode() {
    return 515800700;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TargetToRamQuestionContext))
      return false;
    return true;
  }
}
class Companion_481 {
  constructor() {
    Companion_instance_481 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v67_1 = [lazy(tmp_0, BleatCardTriggerStatement$Companion$$childSerializers$_anonymous__6l5wln)];
  }
}
class $serializer_408 {
  constructor() {
    $serializer_instance_404 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BleatCardTriggerStatement', this, 1);
    tmp0_serialDesc.h1b('characterObject', false);
    this.w67_1 = tmp0_serialDesc;
  }
  x67(encoder, value) {
    var tmp0_desc = this.w67_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_482().v67_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.y67_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x67(encoder, value instanceof BleatCardTriggerStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w67_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_482().v67_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BleatCardTriggerStatement.z67(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w67_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_482().v67_1[0].k3()];
  }
}
class BleatCardTriggerStatement {
  constructor(characterObject) {
    Companion_getInstance_482();
    this.y67_1 = characterObject;
  }
  d2t() {
    return BleatCard_getInstance();
  }
  toString() {
    return 'BleatCardTriggerStatement(characterObject=' + this.y67_1.toString() + ')';
  }
  hashCode() {
    return this.y67_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BleatCardTriggerStatement))
      return false;
    if (!this.y67_1.equals(other.y67_1))
      return false;
    return true;
  }
  static z67(seen0, characterObject, serializationConstructorMarker) {
    Companion_getInstance_482();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_404().w67_1);
    }
    var $this = createThis(this);
    $this.y67_1 = characterObject;
    return $this;
  }
}
class Companion_482 {
  constructor() {
    Companion_instance_482 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a68_1 = [lazy(tmp_0, DischargeStatement$Companion$$childSerializers$_anonymous__1q3jc3)];
  }
}
class $serializer_409 {
  constructor() {
    $serializer_instance_405 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DischargeStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.b68_1 = tmp0_serialDesc;
  }
  c68(encoder, value) {
    var tmp0_desc = this.b68_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_483().a68_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.d68_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c68(encoder, value instanceof DischargeStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b68_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_483().a68_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DischargeStatement.e68(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b68_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_483().a68_1[0].k3()];
  }
}
class DischargeStatement {
  constructor(beast) {
    Companion_getInstance_483();
    this.d68_1 = beast;
  }
  toString() {
    return 'DischargeStatement(beast=' + this.d68_1.toString() + ')';
  }
  hashCode() {
    return this.d68_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DischargeStatement))
      return false;
    if (!this.d68_1.equals(other.d68_1))
      return false;
    return true;
  }
  static e68(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_483();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_405().b68_1);
    }
    var $this = createThis(this);
    $this.d68_1 = beast;
    return $this;
  }
}
class EruptionEffectStatement {
  constructor() {
    EruptionEffectStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f68_1 = lazy(tmp_0, EruptionEffectStatement$_anonymous__vdw00b);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_481(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EruptionEffectStatement';
  }
  hashCode() {
    return -1812055107;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EruptionEffectStatement))
      return false;
    return true;
  }
}
class Companion_483 {
  constructor() {
    Companion_instance_483 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g68_1 = [lazy(tmp_0, RamAnotherTargetStatement$Companion$$childSerializers$_anonymous__tatpox)];
  }
}
class $serializer_410 {
  constructor() {
    $serializer_instance_406 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RamAnotherTargetStatement', this, 1);
    tmp0_serialDesc.h1b('actor', false);
    this.h68_1 = tmp0_serialDesc;
  }
  i68(encoder, value) {
    var tmp0_desc = this.h68_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_484().g68_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.j68_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i68(encoder, value instanceof RamAnotherTargetStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h68_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_484().g68_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RamAnotherTargetStatement.k68(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.h68_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_484().g68_1[0].k3()];
  }
}
class RamAnotherTargetStatement {
  constructor(actor) {
    Companion_getInstance_484();
    this.j68_1 = actor;
  }
  toString() {
    return 'RamAnotherTargetStatement(actor=' + this.j68_1.toString() + ')';
  }
  hashCode() {
    return this.j68_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RamAnotherTargetStatement))
      return false;
    if (!this.j68_1.equals(other.j68_1))
      return false;
    return true;
  }
  static k68(seen0, actor, serializationConstructorMarker) {
    Companion_getInstance_484();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_406().h68_1);
    }
    var $this = createThis(this);
    $this.j68_1 = actor;
    return $this;
  }
}
class Companion_484 {
  constructor() {
    Companion_instance_484 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l68_1 = [lazy(tmp_0, RevealToMoveStatement$Companion$$childSerializers$_anonymous__wvg5ws)];
  }
}
class $serializer_411 {
  constructor() {
    $serializer_instance_407 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RevealToMoveStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.m68_1 = tmp0_serialDesc;
  }
  n68(encoder, value) {
    var tmp0_desc = this.m68_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_485().l68_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o68_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n68(encoder, value instanceof RevealToMoveStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m68_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_485().l68_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RevealToMoveStatement.p68(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m68_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_485().l68_1[0].k3()];
  }
}
class RevealToMoveStatement {
  constructor(beast) {
    Companion_getInstance_485();
    this.o68_1 = beast;
  }
  toString() {
    return 'RevealToMoveStatement(beast=' + this.o68_1.toString() + ')';
  }
  hashCode() {
    return this.o68_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevealToMoveStatement))
      return false;
    if (!this.o68_1.equals(other.o68_1))
      return false;
    return true;
  }
  static p68(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_485();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_407().m68_1);
    }
    var $this = createThis(this);
    $this.o68_1 = beast;
    return $this;
  }
}
class Companion_485 {
  constructor() {
    Companion_instance_485 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q68_1 = [lazy(tmp_0, SuddenShockStatement$Companion$$childSerializers$_anonymous__eilea)];
  }
}
class $serializer_412 {
  constructor() {
    $serializer_instance_408 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SuddenShockStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.r68_1 = tmp0_serialDesc;
  }
  s68(encoder, value) {
    var tmp0_desc = this.r68_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_486().q68_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t68_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s68(encoder, value instanceof SuddenShockStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r68_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_486().q68_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SuddenShockStatement.u68(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r68_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_486().q68_1[0].k3()];
  }
}
class SuddenShockStatement {
  constructor(beast) {
    Companion_getInstance_486();
    this.t68_1 = beast;
  }
  o2o($context_GameStateRuntime_604ce3) {
    var tmp0 = get_aliveHunters_0($context_GameStateRuntime_604ce3);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (get_nearbyPositions($context_GameStateRuntime_604ce3, this.t68_1).w2(new BoardPosition(element.s2w($context_GameStateRuntime_604ce3)))) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  toString() {
    return 'SuddenShockStatement(beast=' + this.t68_1.toString() + ')';
  }
  hashCode() {
    return this.t68_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SuddenShockStatement))
      return false;
    if (!this.t68_1.equals(other.t68_1))
      return false;
    return true;
  }
  static u68(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_486();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_408().r68_1);
    }
    var $this = createThis(this);
    $this.t68_1 = beast;
    return $this;
  }
}
class YagiType {
  constructor() {
    YagiType_instance = this;
    this.v68_1 = Thalduk_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w68_1 = lazy(tmp_0, YagiType$_anonymous__867no3);
  }
  r37() {
    return this.v68_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_482(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'YagiType';
  }
  hashCode() {
    return -1143667191;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YagiType))
      return false;
    return true;
  }
}
class AcclivityCard {
  constructor() {
    AcclivityCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x68_1 = lazy(tmp_0, AcclivityCard$_anonymous__pz0dyp);
  }
  t37() {
    return Thalduk_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_483(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AcclivityCard';
  }
  hashCode() {
    return -1976680255;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AcclivityCard))
      return false;
    return true;
  }
}
class OverloadedStormCard {
  constructor() {
    OverloadedStormCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y68_1 = lazy(tmp_0, OverloadedStormCard$_anonymous__tao4a1);
  }
  t37() {
    return Thalduk_getInstance();
  }
  y3k() {
    return StormCard_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_484(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OverloadedStormCard';
  }
  hashCode() {
    return 1886324443;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OverloadedStormCard))
      return false;
    return true;
  }
}
class StormCard {
  constructor() {
    StormCard_instance = this;
    this.z68_1 = OverloadedStormCard_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a69_1 = lazy(tmp_0, StormCard$_anonymous__ff9fjy);
  }
  t37() {
    return Thalduk_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_485(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'StormCard';
  }
  hashCode() {
    return -1296271756;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StormCard))
      return false;
    return true;
  }
}
class SummonYagiCard {
  constructor() {
    SummonYagiCard_instance = this;
    this.b69_1 = Thalduk_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c69_1 = lazy(tmp_0, SummonYagiCard$_anonymous__2wiwcc);
  }
  t37() {
    return this.b69_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_486(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonYagiCard';
  }
  hashCode() {
    return -738460128;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonYagiCard))
      return false;
    return true;
  }
}
class BleatCard {
  constructor() {
    BleatCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d69_1 = lazy(tmp_0, BleatCard$_anonymous__ccio0p);
  }
  t37() {
    return Thalduk_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_487(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BleatCard';
  }
  hashCode() {
    return 1837736409;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BleatCard))
      return false;
    return true;
  }
}
class Companion_486 {}
class $serializer_413 {
  constructor() {
    $serializer_instance_409 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UnleashingTheAbyssContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.e69_1 = tmp0_serialDesc;
  }
  f69(encoder, value) {
    var tmp0_desc = this.e69_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.h69_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.i69_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 2, value.i69_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.j69_1 === 2)) {
      tmp1_output.z14(tmp0_desc, 3, value.j69_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.k69_1.equals(Companion_getInstance_220().x39_1)) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.k69_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f69(encoder, value instanceof UnleashingTheAbyssContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e69_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return UnleashingTheAbyssContract.l69(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.e69_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class UnleashingTheAbyssContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.m69(rulesParameters);
  }
  static m69(rulesParameters) {
    var $this = this.b3a();
    $this.h69_1 = rulesParameters;
    $this.i69_1 = 3;
    $this.j69_1 = 2;
    $this.k69_1 = Companion_getInstance_220().x39_1;
    return $this;
  }
  c3a() {
    return this.h69_1;
  }
  static n69(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    balanceVersion = balanceVersion === VOID ? Companion_getInstance_217().e3a_1 : balanceVersion;
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().x39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.m69(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(1, 1);
  }
  h3a() {
    return GameMapId_UpperShatteredIsles_getInstance();
  }
  i3a() {
    return this.i69_1;
  }
  j3a() {
    return 1;
  }
  k3a() {
    return 3;
  }
  l3a() {
    return this.j69_1;
  }
  m3a() {
    return UnleashingTheAbyssInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_destroyRecords($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.p3a_1 === get_beastsGameTeam()) {
          destination.d2(element);
        }
      }
      var beastKills = destination;
      var tmp_0;
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.count' call
        var tmp_1;
        if (isInterface(beastKills, Collection)) {
          tmp_1 = beastKills.n1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$3 = 0;
          break $l$block;
        }
        var count = 0;
        var _iterator__ex2g4s_0 = beastKills.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (equals(get_objectType($context_GameState_t6qee5, element_0.o3a_1), SheepType_getInstance())) {
            count = count + 1 | 0;
            checkCountOverflow(count);
          }
        }
        tmp$ret$3 = count;
      }
      if (tmp$ret$3 >= 2) {
        tmp_0 = true;
      } else {
        var tmp$ret$5;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_2;
          if (isInterface(beastKills, Collection)) {
            tmp_2 = beastKills.n1();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$5 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_1 = beastKills.p1();
          while (_iterator__ex2g4s_1.q1()) {
            var element_1 = _iterator__ex2g4s_1.r1();
            if (equals(get_objectType($context_GameState_t6qee5, element_1.o3a_1), TigerType_getInstance())) {
              tmp$ret$5 = true;
              break $l$block_1;
            }
          }
          tmp$ret$5 = false;
        }
        tmp_0 = tmp$ret$5;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp_0);
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) > 0);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      var tmp0_0 = get_destroyedObjects($context_GameState_t6qee5);
      var tmp$ret$7;
      $l$block_3: {
        // Inline function 'kotlin.collections.any' call
        var tmp_3;
        if (isInterface(tmp0_0, Collection)) {
          tmp_3 = tmp0_0.n1();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$7 = false;
          break $l$block_3;
        }
        var _iterator__ex2g4s_2 = tmp0_0.p1();
        while (_iterator__ex2g4s_2.q1()) {
          var element_2 = _iterator__ex2g4s_2.r1();
          var tmp_4 = get_objectType($context_GameState_t6qee5, element_2);
          if (isInterface(tmp_4, SettlerType)) {
            tmp$ret$7 = true;
            break $l$block_3;
          }
        }
        tmp$ret$7 = false;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp$ret$7);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) >= 2);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.k69_1;
  }
  v3a(rulesParameters) {
    return UnleashingTheAbyssContract.m69(rulesParameters);
  }
  toString() {
    return 'UnleashingTheAbyssContract(rulesParameters=' + this.h69_1.toString() + ')';
  }
  hashCode() {
    return this.h69_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnleashingTheAbyssContract))
      return false;
    if (!this.h69_1.equals(other.h69_1))
      return false;
    return true;
  }
  static l69(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_409().e69_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.h69_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.i69_1 = 3;
    else
      $this.i69_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.j69_1 = 2;
    else
      $this.j69_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.k69_1 = Companion_getInstance_220().x39_1;
    else
      $this.k69_1 = requiredVersion;
    return $this;
  }
}
class UnleashingTheAbyssInitialPhase {
  constructor() {
    UnleashingTheAbyssInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o69_1 = lazy(tmp_0, UnleashingTheAbyssInitialPhase$_anonymous__bwg7l1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_488(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UnleashingTheAbyssInitialPhase';
  }
  hashCode() {
    return -993046463;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnleashingTheAbyssInitialPhase))
      return false;
    return true;
  }
}
class Companion_487 {}
class $serializer_414 {
  constructor() {
    $serializer_instance_410 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UnlikelyAllianceContract', this, 5);
    tmp0_serialDesc.h1b('maxWatchtowersOnBoard', true);
    tmp0_serialDesc.h1b('rulesParameters', false);
    tmp0_serialDesc.h1b('numberOfDays', true);
    tmp0_serialDesc.h1b('settlersKillNumber', true);
    tmp0_serialDesc.h1b('requiredVersion', true);
    this.p69_1 = tmp0_serialDesc;
  }
  q69(encoder, value) {
    var tmp0_desc = this.p69_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.p39() === 6)) {
      tmp1_output.z14(tmp0_desc, 0, value.p39());
    }
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_180(), value.s69_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.t69_1 === 3)) {
      tmp1_output.z14(tmp0_desc, 2, value.t69_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.u69_1 === 2)) {
      tmp1_output.z14(tmp0_desc, 3, value.u69_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !value.v69_1.equals(Companion_getInstance_220().x39_1)) {
      tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_181(), value.v69_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q69(encoder, value instanceof UnlikelyAllianceContract ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p69_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b14(tmp0_desc, 4, $serializer_getInstance_181(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return UnlikelyAllianceContract.w69(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.p69_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_180(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_181()];
  }
}
class UnlikelyAllianceContract extends KillingSettlersClassicGameRules {
  constructor(rulesParameters) {
    return new.target.x69(rulesParameters);
  }
  static x69(rulesParameters) {
    var $this = this.b3a();
    $this.s69_1 = rulesParameters;
    $this.t69_1 = 3;
    $this.u69_1 = 2;
    $this.v69_1 = Companion_getInstance_220().x39_1;
    return $this;
  }
  c3a() {
    return this.s69_1;
  }
  static y69(balanceVersion, gameContentVersion, simpleStartingBonuses) {
    balanceVersion = balanceVersion === VOID ? Companion_getInstance_217().e3a_1 : balanceVersion;
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().x39_1 : gameContentVersion;
    simpleStartingBonuses = simpleStartingBonuses === VOID ? null : simpleStartingBonuses;
    return this.x69(new GameRulesParameters(balanceVersion, gameContentVersion, simpleStartingBonuses));
  }
  g3a() {
    return new SimpleStartingBonuses(1, 1);
  }
  h3a() {
    return GameMapId_UpperShatteredIsles_getInstance();
  }
  i3a() {
    return this.t69_1;
  }
  j3a() {
    return 2;
  }
  k3a() {
    return 3;
  }
  l3a() {
    return this.u69_1;
  }
  m3a() {
    return UnlikelyAllianceInitialPhase_getInstance();
  }
  n3a($context_GameState_t6qee5, gameTeam, nightNumber) {
    if (nightNumber < get_currentDayNumber($context_GameState_t6qee5))
      return NightRewardStatus_NightWasPassed_getInstance();
    var tmp0_subject = to(nightNumber, new GameTeam(gameTeam));
    var tmp;
    if (tmp0_subject.equals(to(1, new GameTeam(get_beastsGameTeam())))) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_destroyRecords($context_GameState_t6qee5);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp0_safe_receiver = element.q3a_1;
        var tmp_0 = tmp0_safe_receiver == null ? null : get_objectType($context_GameState_t6qee5, tmp0_safe_receiver);
        if (!(!(tmp_0 == null) ? isInterface(tmp_0, HunterCharacter) : false)) {
          destination.d2(element);
        }
      }
      var killings = destination;
      var tmp_1;
      var tmp_2;
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.count' call
        var tmp_3;
        if (isInterface(killings, Collection)) {
          tmp_3 = killings.n1();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$3 = 0;
          break $l$block;
        }
        var count = 0;
        var _iterator__ex2g4s_0 = killings.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (equals(get_objectType($context_GameState_t6qee5, element_0.o3a_1), SheepType_getInstance())) {
            count = count + 1 | 0;
            checkCountOverflow(count);
          }
        }
        tmp$ret$3 = count;
      }
      if (tmp$ret$3 >= 4) {
        tmp_2 = true;
      } else {
        var tmp_4;
        var tmp$ret$5;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_5;
          if (isInterface(killings, Collection)) {
            tmp_5 = killings.n1();
          } else {
            tmp_5 = false;
          }
          if (tmp_5) {
            tmp$ret$5 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_1 = killings.p1();
          while (_iterator__ex2g4s_1.q1()) {
            var element_1 = _iterator__ex2g4s_1.r1();
            if (equals(get_objectType($context_GameState_t6qee5, element_1.o3a_1), BoarType_getInstance())) {
              tmp$ret$5 = true;
              break $l$block_1;
            }
          }
          tmp$ret$5 = false;
        }
        if (tmp$ret$5) {
          var tmp$ret$7;
          $l$block_2: {
            // Inline function 'kotlin.collections.count' call
            var tmp_6;
            if (isInterface(killings, Collection)) {
              tmp_6 = killings.n1();
            } else {
              tmp_6 = false;
            }
            if (tmp_6) {
              tmp$ret$7 = 0;
              break $l$block_2;
            }
            var count_0 = 0;
            var _iterator__ex2g4s_2 = killings.p1();
            while (_iterator__ex2g4s_2.q1()) {
              var element_2 = _iterator__ex2g4s_2.r1();
              if (equals(get_objectType($context_GameState_t6qee5, element_2.o3a_1), SheepType_getInstance())) {
                count_0 = count_0 + 1 | 0;
                checkCountOverflow(count_0);
              }
            }
            tmp$ret$7 = count_0;
          }
          tmp_4 = tmp$ret$7 >= 2;
        } else {
          tmp_4 = false;
        }
        tmp_2 = tmp_4;
      }
      if (tmp_2) {
        tmp_1 = true;
      } else {
        var tmp_7;
        var tmp$ret$9;
        $l$block_4: {
          // Inline function 'kotlin.collections.any' call
          var tmp_8;
          if (isInterface(killings, Collection)) {
            tmp_8 = killings.n1();
          } else {
            tmp_8 = false;
          }
          if (tmp_8) {
            tmp$ret$9 = false;
            break $l$block_4;
          }
          var _iterator__ex2g4s_3 = killings.p1();
          while (_iterator__ex2g4s_3.q1()) {
            var element_3 = _iterator__ex2g4s_3.r1();
            if (equals(get_objectType($context_GameState_t6qee5, element_3.o3a_1), SheepType_getInstance())) {
              tmp$ret$9 = true;
              break $l$block_4;
            }
          }
          tmp$ret$9 = false;
        }
        if (tmp$ret$9) {
          var tmp$ret$11;
          $l$block_6: {
            // Inline function 'kotlin.collections.any' call
            var tmp_9;
            if (isInterface(killings, Collection)) {
              tmp_9 = killings.n1();
            } else {
              tmp_9 = false;
            }
            if (tmp_9) {
              tmp$ret$11 = false;
              break $l$block_6;
            }
            var _iterator__ex2g4s_4 = killings.p1();
            while (_iterator__ex2g4s_4.q1()) {
              var element_4 = _iterator__ex2g4s_4.r1();
              if (equals(get_objectType($context_GameState_t6qee5, element_4.o3a_1), TigerType_getInstance())) {
                tmp$ret$11 = true;
                break $l$block_6;
              }
            }
            tmp$ret$11 = false;
          }
          tmp_7 = tmp$ret$11;
        } else {
          tmp_7 = false;
        }
        tmp_1 = tmp_7;
      }
      tmp = ensuredOrNotGainedRewardStatus(tmp_1);
    } else if (tmp0_subject.equals(to(1, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredExpectedOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) > 0, ruinsControlled_0($context_GameState_t6qee5, get_huntersGameTeam()) >= 2);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_beastsGameTeam())))) {
      var tmp0_0 = get_destroyedObjects($context_GameState_t6qee5);
      var tmp$ret$13;
      $l$block_8: {
        // Inline function 'kotlin.collections.any' call
        var tmp_10;
        if (isInterface(tmp0_0, Collection)) {
          tmp_10 = tmp0_0.n1();
        } else {
          tmp_10 = false;
        }
        if (tmp_10) {
          tmp$ret$13 = false;
          break $l$block_8;
        }
        var _iterator__ex2g4s_5 = tmp0_0.p1();
        while (_iterator__ex2g4s_5.q1()) {
          var element_5 = _iterator__ex2g4s_5.r1();
          var tmp_11 = get_objectType($context_GameState_t6qee5, element_5);
          if (isInterface(tmp_11, SettlerType)) {
            tmp$ret$13 = true;
            break $l$block_8;
          }
        }
        tmp$ret$13 = false;
      }
      tmp = ensuredExpectedOrNotGainedRewardStatus(tmp$ret$13, ruinsControlled_0($context_GameState_t6qee5, get_beastsGameTeam()) >= 2);
    } else if (tmp0_subject.equals(to(2, new GameTeam(get_huntersGameTeam())))) {
      tmp = ensuredOrNotGainedRewardStatus(get_damageDealtToBeasts($context_GameState_t6qee5) >= 2);
    } else {
      tmp = NightRewardStatus_InvalidNightNumber_getInstance();
    }
    return tmp;
  }
  u3a(newParameters) {
    return this.v3a(newParameters);
  }
  w3a() {
    return this.v69_1;
  }
  v3a(rulesParameters) {
    return UnlikelyAllianceContract.x69(rulesParameters);
  }
  toString() {
    return 'UnlikelyAllianceContract(rulesParameters=' + this.s69_1.toString() + ')';
  }
  hashCode() {
    return this.s69_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnlikelyAllianceContract))
      return false;
    if (!this.s69_1.equals(other.s69_1))
      return false;
    return true;
  }
  static w69(seen0, maxWatchtowersOnBoard, rulesParameters, numberOfDays, settlersKillNumber, requiredVersion, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_410().p69_1);
    }
    var $this = this.x3a(seen0, maxWatchtowersOnBoard, serializationConstructorMarker);
    $this.s69_1 = rulesParameters;
    if (0 === (seen0 & 4))
      $this.t69_1 = 3;
    else
      $this.t69_1 = numberOfDays;
    if (0 === (seen0 & 8))
      $this.u69_1 = 2;
    else
      $this.u69_1 = settlersKillNumber;
    if (0 === (seen0 & 16))
      $this.v69_1 = Companion_getInstance_220().x39_1;
    else
      $this.v69_1 = requiredVersion;
    return $this;
  }
}
class Companion_488 {}
class $serializer_415 {
  constructor() {
    $serializer_instance_411 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AttackOrSummonFromRuinStatement', this, 1);
    tmp0_serialDesc.h1b('ruinPosition', false);
    this.z69_1 = tmp0_serialDesc;
  }
  a6a(encoder, value) {
    var tmp0_desc = this.z69_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.b6a_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a6a(encoder, value instanceof AttackOrSummonFromRuinStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z69_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AttackOrSummonFromRuinStatement.c6a(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.z69_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100()];
  }
}
class AttackOrSummonFromRuinStatement {
  constructor(ruinPosition) {
    this.b6a_1 = ruinPosition;
  }
  toString() {
    return 'AttackOrSummonFromRuinStatement(ruinPosition=' + BoardPosition__toString_impl_v4mn82(this.b6a_1) + ')';
  }
  hashCode() {
    return BoardPosition__hashCode_impl_9dgqf7(this.b6a_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AttackOrSummonFromRuinStatement))
      return false;
    if (!(this.b6a_1 === other.b6a_1))
      return false;
    return true;
  }
  static c6a(seen0, ruinPosition, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_411().z69_1);
    }
    var $this = createThis(this);
    $this.b6a_1 = ruinPosition;
    return $this;
  }
}
class Companion_489 {}
class $serializer_416 {
  constructor() {
    $serializer_instance_412 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EachBeastAndSummonMoves', this, 2);
    tmp0_serialDesc.h1b('isOnlyBeasts', false);
    tmp0_serialDesc.h1b('distance', false);
    this.d6a_1 = tmp0_serialDesc;
  }
  e6a(encoder, value) {
    var tmp0_desc = this.d6a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.w14(tmp0_desc, 0, value.f6a_1);
    tmp1_output.z14(tmp0_desc, 1, value.g6a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e6a(encoder, value instanceof EachBeastAndSummonMoves ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d6a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return EachBeastAndSummonMoves.h6a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.d6a_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class EachBeastAndSummonMoves {
  constructor(isOnlyBeasts, distance) {
    this.f6a_1 = isOnlyBeasts;
    this.g6a_1 = distance;
  }
  toString() {
    return 'EachBeastAndSummonMoves(isOnlyBeasts=' + this.f6a_1 + ', distance=' + this.g6a_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.f6a_1);
    result = imul(result, 31) + this.g6a_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EachBeastAndSummonMoves))
      return false;
    if (!(this.f6a_1 === other.f6a_1))
      return false;
    if (!(this.g6a_1 === other.g6a_1))
      return false;
    return true;
  }
  static h6a(seen0, isOnlyBeasts, distance, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_412().d6a_1);
    }
    var $this = createThis(this);
    $this.f6a_1 = isOnlyBeasts;
    $this.g6a_1 = distance;
    return $this;
  }
}
class UnlikelyAllianceInitialPhase {
  constructor() {
    UnlikelyAllianceInitialPhase_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i6a_1 = lazy(tmp_0, UnlikelyAllianceInitialPhase$_anonymous__s4wdw);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_489(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UnlikelyAllianceInitialPhase';
  }
  hashCode() {
    return 2121041552;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnlikelyAllianceInitialPhase))
      return false;
    return true;
  }
}
class UpperShatteredRuins {
  constructor() {
    UpperShatteredRuins_instance = this;
    this.j6a_1 = _BoardPosition___init__impl__1nizgq_0(-1, 0);
    this.k6a_1 = _BoardPosition___init__impl__1nizgq_0(1, 2);
    this.l6a_1 = _BoardPosition___init__impl__1nizgq_0(2, -2);
  }
}
class UpperShatteredSettlements {
  constructor() {
    UpperShatteredSettlements_instance = this;
    this.m6a_1 = _BoardPosition___init__impl__1nizgq_0(-1, -3);
    this.n6a_1 = _BoardPosition___init__impl__1nizgq_0(-2, 2);
    this.o6a_1 = _BoardPosition___init__impl__1nizgq_0(3, 1);
  }
}
class BroodswellUpgrade {
  constructor() {
    BroodswellUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p6a_1 = lazy(tmp_0, BroodswellUpgrade$_anonymous__sfkipk);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_490(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BroodswellUpgrade';
  }
  hashCode() {
    return 1779951914;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BroodswellUpgrade))
      return false;
    return true;
  }
}
class RuptureSeedsUpgrade {
  constructor() {
    RuptureSeedsUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q6a_1 = lazy(tmp_0, RuptureSeedsUpgrade$_anonymous__d62t3w);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_491(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'RuptureSeedsUpgrade';
  }
  hashCode() {
    return 1455784918;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RuptureSeedsUpgrade))
      return false;
    return true;
  }
}
class InfestUrgullUpgrade {
  constructor() {
    InfestUrgullUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r6a_1 = lazy(tmp_0, InfestUrgullUpgrade$_anonymous__elehdh);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_492(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'InfestUrgullUpgrade';
  }
  hashCode() {
    return -1387312217;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InfestUrgullUpgrade))
      return false;
    return true;
  }
}
class LairUpgrade {
  constructor() {
    LairUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s6a_1 = lazy(tmp_0, LairUpgrade$_anonymous__j0za61);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_493(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LairUpgrade';
  }
  hashCode() {
    return -1615668487;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LairUpgrade))
      return false;
    return true;
  }
}
class Urgull {
  constructor() {
    Urgull_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t6a_1 = lazy(tmp_0, Urgull$_anonymous__g3tjyk);
  }
  q36() {
    return EggType_getInstance();
  }
  t36() {
    return setOf_0([EggType_getInstance(), HatchlingType_getInstance()]);
  }
  u36() {
    return 7;
  }
  q2s($context_GameState_t6qee5) {
    return get_urgullHatchlingsOnMap($context_GameState_t6qee5);
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Cave_getInstance();
  }
  s36() {
    return setOf_0([OvipunctureCard_getInstance(), NestCard_getInstance(), SummonEggCard_getInstance(), SilkCard_getInstance()]);
  }
  t35() {
    return setOf_0([BroodswellUpgrade_getInstance(), RuptureSeedsUpgrade_getInstance(), InfestUrgullUpgrade_getInstance(), LairUpgrade_getInstance()]);
  }
  n2z($context_GameState_t6qee5) {
    return 3;
  }
  v36($context_GameState_t6qee5, position) {
    return plus_2(getInitList_1.call(this, $context_GameState_t6qee5, position), listOf_0([init_0(get_woundKey(), 2), init_0(get_remainMoltEggsOnCounterKey(), 7)]));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_494(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Urgull';
  }
  hashCode() {
    return 221792784;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Urgull))
      return false;
    return true;
  }
}
class UrgullHatchDamageSource {
  constructor() {
    UrgullHatchDamageSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u6a_1 = lazy(tmp_0, UrgullHatchDamageSource$_anonymous__ax9vu0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_495(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UrgullHatchDamageSource';
  }
  hashCode() {
    return -2128019302;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UrgullHatchDamageSource))
      return false;
    return true;
  }
}
class UrgullMoltRewardEffectSource {
  constructor() {
    UrgullMoltRewardEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v6a_1 = lazy(tmp_0, UrgullMoltRewardEffectSource$_anonymous__w8a1q1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_496(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UrgullMoltRewardEffectSource';
  }
  hashCode() {
    return 99064917;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UrgullMoltRewardEffectSource))
      return false;
    return true;
  }
}
class PlaceHatchlingWithInfestQuestion {
  constructor() {
    PlaceHatchlingWithInfestQuestion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w6a_1 = lazy(tmp_0, PlaceHatchlingWithInfestQuestion$_anonymous__ktt4wn);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_497(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PlaceHatchlingWithInfestQuestion';
  }
  hashCode() {
    return 546574213;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceHatchlingWithInfestQuestion))
      return false;
    return true;
  }
}
class Companion_490 {}
class $serializer_417 {
  constructor() {
    $serializer_instance_413 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UrgullMoltEggsToReturnQuestion', this, 1);
    tmp0_serialDesc.h1b('maxToReturn', false);
    this.x6a_1 = tmp0_serialDesc;
  }
  y6a(encoder, value) {
    var tmp0_desc = this.x6a_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.z6a_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y6a(encoder, value instanceof UrgullMoltEggsToReturnQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x6a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UrgullMoltEggsToReturnQuestion.a6b(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x6a_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class UrgullMoltEggsToReturnQuestion {
  constructor(maxToReturn) {
    this.z6a_1 = maxToReturn;
  }
  s3o() {
    return toCollection(numberRangeToNumber(0, this.z6a_1), LinkedHashSet.v2());
  }
  toString() {
    return 'UrgullMoltEggsToReturnQuestion(maxToReturn=' + this.z6a_1 + ')';
  }
  hashCode() {
    return this.z6a_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UrgullMoltEggsToReturnQuestion))
      return false;
    if (!(this.z6a_1 === other.z6a_1))
      return false;
    return true;
  }
  static a6b(seen0, maxToReturn, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_413().x6a_1);
    }
    var $this = createThis(this);
    $this.z6a_1 = maxToReturn;
    return $this;
  }
}
class LocationForLivingWebQuestionContext {
  constructor() {
    LocationForLivingWebQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b6b_1 = lazy(tmp_0, LocationForLivingWebQuestionContext$_anonymous__qtdgo5);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_498(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'LocationForLivingWebQuestionContext';
  }
  hashCode() {
    return 398862221;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LocationForLivingWebQuestionContext))
      return false;
    return true;
  }
}
class EggToHatchQuestionContext {
  constructor() {
    EggToHatchQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c6b_1 = lazy(tmp_0, EggToHatchQuestionContext$_anonymous__k4emj2);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_499(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EggToHatchQuestionContext';
  }
  hashCode() {
    return 1553288420;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EggToHatchQuestionContext))
      return false;
    return true;
  }
}
class EggToReturnToMoltQuestionContext {
  constructor() {
    EggToReturnToMoltQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d6b_1 = lazy(tmp_0, EggToReturnToMoltQuestionContext$_anonymous__ncfqv1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_500(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EggToReturnToMoltQuestionContext';
  }
  hashCode() {
    return -1276119463;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EggToReturnToMoltQuestionContext))
      return false;
    return true;
  }
}
class HatchlingToReplaceQuestionContext {
  constructor() {
    HatchlingToReplaceQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e6b_1 = lazy(tmp_0, HatchlingToReplaceQuestionContext$_anonymous__421xrj);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_501(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HatchlingToReplaceQuestionContext';
  }
  hashCode() {
    return 1880917537;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HatchlingToReplaceQuestionContext))
      return false;
    return true;
  }
}
class UrgullMoltEggsToReturnQuestionContext {
  constructor() {
    UrgullMoltEggsToReturnQuestionContext_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f6b_1 = lazy(tmp_0, UrgullMoltEggsToReturnQuestionContext$_anonymous__h74cho);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_502(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'UrgullMoltEggsToReturnQuestionContext';
  }
  hashCode() {
    return -642747978;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UrgullMoltEggsToReturnQuestionContext))
      return false;
    return true;
  }
}
class Companion_491 {
  constructor() {
    Companion_instance_491 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g6b_1 = [lazy(tmp_0, BroodswellStatement$Companion$$childSerializers$_anonymous__wyg2a0)];
  }
}
class $serializer_418 {
  constructor() {
    $serializer_instance_414 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BroodswellStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.h6b_1 = tmp0_serialDesc;
  }
  i6b(encoder, value) {
    var tmp0_desc = this.h6b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_492().g6b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.j6b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i6b(encoder, value instanceof BroodswellStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h6b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_492().g6b_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BroodswellStatement.k6b(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.h6b_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_492().g6b_1[0].k3()];
  }
}
class BroodswellStatement {
  constructor(beast) {
    Companion_getInstance_492();
    this.j6b_1 = beast;
  }
  toString() {
    return 'BroodswellStatement(beast=' + this.j6b_1.toString() + ')';
  }
  hashCode() {
    return this.j6b_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BroodswellStatement))
      return false;
    if (!this.j6b_1.equals(other.j6b_1))
      return false;
    return true;
  }
  static k6b(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_492();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_414().h6b_1);
    }
    var $this = createThis(this);
    $this.j6b_1 = beast;
    return $this;
  }
}
class Companion_492 {
  constructor() {
    Companion_instance_492 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l6b_1 = [lazy(tmp_0, HatchEggStatement$Companion$$childSerializers$_anonymous__tc8u1s)];
  }
}
class $serializer_419 {
  constructor() {
    $serializer_instance_415 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('HatchEggStatement', this, 1);
    tmp0_serialDesc.h1b('egg', false);
    this.m6b_1 = tmp0_serialDesc;
  }
  n6b(encoder, value) {
    var tmp0_desc = this.m6b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_493().l6b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o6b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n6b(encoder, value instanceof HatchEggStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m6b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_493().l6b_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return HatchEggStatement.p6b(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m6b_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_493().l6b_1[0].k3()];
  }
}
class HatchEggStatement {
  constructor(egg) {
    Companion_getInstance_493();
    this.o6b_1 = egg;
  }
  toString() {
    return 'HatchEggStatement(egg=' + this.o6b_1.toString() + ')';
  }
  hashCode() {
    return this.o6b_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HatchEggStatement))
      return false;
    if (!this.o6b_1.equals(other.o6b_1))
      return false;
    return true;
  }
  static p6b(seen0, egg, serializationConstructorMarker) {
    Companion_getInstance_493();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_415().m6b_1);
    }
    var $this = createThis(this);
    $this.o6b_1 = egg;
    return $this;
  }
}
class Companion_493 {
  constructor() {
    Companion_instance_493 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q6b_1 = [lazy(tmp_0, OvipunctureStatement$Companion$$childSerializers$_anonymous__cgc251)];
  }
}
class $serializer_420 {
  constructor() {
    $serializer_instance_416 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OvipunctureStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.r6b_1 = tmp0_serialDesc;
  }
  s6b(encoder, value) {
    var tmp0_desc = this.r6b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_494().q6b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t6b_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s6b(encoder, value instanceof OvipunctureStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r6b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_494().q6b_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return OvipunctureStatement.u6b(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r6b_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_494().q6b_1[0].k3()];
  }
}
class OvipunctureStatement {
  constructor(beast) {
    Companion_getInstance_494();
    this.t6b_1 = beast;
  }
  toString() {
    return 'OvipunctureStatement(beast=' + this.t6b_1.toString() + ')';
  }
  hashCode() {
    return this.t6b_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OvipunctureStatement))
      return false;
    if (!this.t6b_1.equals(other.t6b_1))
      return false;
    return true;
  }
  static u6b(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_494();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_416().r6b_1);
    }
    var $this = createThis(this);
    $this.t6b_1 = beast;
    return $this;
  }
}
class Companion_494 {}
class $serializer_421 {
  constructor() {
    $serializer_instance_417 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceHatchlingAfterEggStatement', this, 1);
    tmp0_serialDesc.h1b('position', false);
    this.v6b_1 = tmp0_serialDesc;
  }
  w6b(encoder, value) {
    var tmp0_desc = this.v6b_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.x6b_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w6b(encoder, value instanceof PlaceHatchlingAfterEggStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v6b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlaceHatchlingAfterEggStatement.y6b(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.v6b_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100()];
  }
}
class PlaceHatchlingAfterEggStatement {
  constructor(position) {
    this.x6b_1 = position;
  }
  toString() {
    return 'PlaceHatchlingAfterEggStatement(position=' + BoardPosition__toString_impl_v4mn82(this.x6b_1) + ')';
  }
  hashCode() {
    return BoardPosition__hashCode_impl_9dgqf7(this.x6b_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceHatchlingAfterEggStatement))
      return false;
    if (!(this.x6b_1 === other.x6b_1))
      return false;
    return true;
  }
  static y6b(seen0, position, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_417().v6b_1);
    }
    var $this = createThis(this);
    $this.x6b_1 = position;
    return $this;
  }
}
class Companion_495 {
  constructor() {
    Companion_instance_495 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z6b_1 = [lazy(tmp_0, PlaceLivingWebNearbyStatement$Companion$$childSerializers$_anonymous__qp4w72)];
  }
}
class $serializer_422 {
  constructor() {
    $serializer_instance_418 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceLivingWebNearbyStatement', this, 1);
    tmp0_serialDesc.h1b('actor', false);
    this.a6c_1 = tmp0_serialDesc;
  }
  b6c(encoder, value) {
    var tmp0_desc = this.a6c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_496().z6b_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c6c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b6c(encoder, value instanceof PlaceLivingWebNearbyStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a6c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_496().z6b_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlaceLivingWebNearbyStatement.d6c(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a6c_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_496().z6b_1[0].k3()];
  }
}
class PlaceLivingWebNearbyStatement {
  constructor(actor) {
    Companion_getInstance_496();
    this.c6c_1 = actor;
  }
  e6c($context_GameState_t6qee5) {
    return toSet(get_filterMayBeTransformed($context_GameState_t6qee5, get_nearbyPositions($context_GameState_t6qee5, this.c6c_1)));
  }
  n2o($context_GameStateRuntime_604ce3) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.e6c($context_GameStateRuntime_604ce3).n1();
  }
  toString() {
    return 'PlaceLivingWebNearbyStatement(actor=' + this.c6c_1.toString() + ')';
  }
  hashCode() {
    return this.c6c_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceLivingWebNearbyStatement))
      return false;
    if (!this.c6c_1.equals(other.c6c_1))
      return false;
    return true;
  }
  static d6c(seen0, actor, serializationConstructorMarker) {
    Companion_getInstance_496();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_418().a6c_1);
    }
    var $this = createThis(this);
    $this.c6c_1 = actor;
    return $this;
  }
}
class Companion_496 {
  constructor() {
    Companion_instance_496 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f6c_1 = [lazy(tmp_0, PlaceUrgullEggOnOwnLocationStatement$Companion$$childSerializers$_anonymous__qsarpg)];
  }
}
class $serializer_423 {
  constructor() {
    $serializer_instance_419 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlaceUrgullEggOnOwnLocationStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.g6c_1 = tmp0_serialDesc;
  }
  h6c(encoder, value) {
    var tmp0_desc = this.g6c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_497().f6c_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i6c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h6c(encoder, value instanceof PlaceUrgullEggOnOwnLocationStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g6c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_497().f6c_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PlaceUrgullEggOnOwnLocationStatement.j6c(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g6c_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_497().f6c_1[0].k3()];
  }
}
class PlaceUrgullEggOnOwnLocationStatement {
  constructor(beast) {
    Companion_getInstance_497();
    this.i6c_1 = beast;
  }
  n2o($context_GameStateRuntime_604ce3) {
    return get_urgullCanPlaceEggs($context_GameStateRuntime_604ce3);
  }
  toString() {
    return 'PlaceUrgullEggOnOwnLocationStatement(beast=' + this.i6c_1.toString() + ')';
  }
  hashCode() {
    return this.i6c_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceUrgullEggOnOwnLocationStatement))
      return false;
    if (!this.i6c_1.equals(other.i6c_1))
      return false;
    return true;
  }
  static j6c(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_497();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_419().g6c_1);
    }
    var $this = createThis(this);
    $this.i6c_1 = beast;
    return $this;
  }
}
class EggType {
  constructor() {
    EggType_instance = this;
    this.k6c_1 = Urgull_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l6c_1 = lazy(tmp_0, EggType$_anonymous__ggisso);
  }
  r37() {
    return this.k6c_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_503(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EggType';
  }
  hashCode() {
    return 949560954;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EggType))
      return false;
    return true;
  }
}
class HatchlingType {
  constructor() {
    HatchlingType_instance = this;
    this.m6c_1 = Urgull_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n6c_1 = lazy(tmp_0, HatchlingType$_anonymous__nakqyv);
  }
  r37() {
    return this.m6c_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_504(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HatchlingType';
  }
  hashCode() {
    return -1632095765;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HatchlingType))
      return false;
    return true;
  }
}
class Companion_497 {}
class $serializer_424 {
  constructor() {
    $serializer_instance_420 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('UrgullMoltCounterChangeEvent', this, 1);
    tmp0_serialDesc.h1b('change', false);
    this.o6c_1 = tmp0_serialDesc;
  }
  p6c(encoder, value) {
    var tmp0_desc = this.o6c_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.q6c_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p6c(encoder, value instanceof UrgullMoltCounterChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o6c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return UrgullMoltCounterChangeEvent.r6c(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.o6c_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class UrgullMoltCounterChangeEvent {
  constructor(change) {
    this.q6c_1 = change;
  }
  m37(_this__u8e3s4) {
    var _receiver__tnumb7 = get_urgullBeast(_this__u8e3s4);
    set_remainMoltEggsOnCounterImpl(_this__u8e3s4, _receiver__tnumb7, get_remainMoltEggsOnCounterImpl(_this__u8e3s4, _receiver__tnumb7) + this.q6c_1 | 0);
  }
  n37($context_GameState_t6qee5) {
    return new UrgullMoltCounterChangeEvent(-this.q6c_1 | 0);
  }
  toString() {
    return 'UrgullMoltCounterChangeEvent(change=' + this.q6c_1 + ')';
  }
  hashCode() {
    return this.q6c_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UrgullMoltCounterChangeEvent))
      return false;
    if (!(this.q6c_1 === other.q6c_1))
      return false;
    return true;
  }
  static r6c(seen0, change, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_420().o6c_1);
    }
    var $this = createThis(this);
    $this.q6c_1 = change;
    return $this;
  }
}
class UrgullCard {}
function get_character_2() {
  return Urgull_getInstance();
}
class NestCard {
  constructor() {
    NestCard_instance = this;
    this.s6c_1 = Red_getInstance();
    this.t6c_1 = OverloadedNestCard_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u6c_1 = lazy(tmp_0, NestCard$_anonymous__i4tdip);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_505(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NestCard';
  }
  hashCode() {
    return 768482125;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NestCard))
      return false;
    return true;
  }
}
class OverloadedNestCard {
  constructor() {
    OverloadedNestCard_instance = this;
    this.v6c_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w6c_1 = lazy(tmp_0, OverloadedNestCard$_anonymous__sjhkuu);
  }
  y3k() {
    return NestCard_getInstance();
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_506(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OverloadedNestCard';
  }
  hashCode() {
    return 316957190;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OverloadedNestCard))
      return false;
    return true;
  }
}
class OvipunctureCard {
  constructor() {
    OvipunctureCard_instance = this;
    this.x6c_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y6c_1 = lazy(tmp_0, OvipunctureCard$_anonymous__t055zr);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_507(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OvipunctureCard';
  }
  hashCode() {
    return 1988079899;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OvipunctureCard))
      return false;
    return true;
  }
}
class SilkCard {
  constructor() {
    SilkCard_instance = this;
    this.z6c_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a6d_1 = lazy(tmp_0, SilkCard$_anonymous__fh71hu);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_508(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SilkCard';
  }
  hashCode() {
    return -61069110;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SilkCard))
      return false;
    return true;
  }
}
class SummonEggCard {
  constructor() {
    SummonEggCard_instance = this;
    this.b6d_1 = Blue_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c6d_1 = lazy(tmp_0, SummonEggCard$_anonymous__vqyp37);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_509(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonEggCard';
  }
  hashCode() {
    return 1377761775;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonEggCard))
      return false;
    return true;
  }
}
class MirrorBeastUpgrade {
  constructor() {
    MirrorBeastUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d6d_1 = lazy(tmp_0, MirrorBeastUpgrade$_anonymous__cc50or);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_510(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'MirrorBeastUpgrade';
  }
  hashCode() {
    return -214824287;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MirrorBeastUpgrade))
      return false;
    return true;
  }
}
class GoldenBeakUpgrade {
  constructor() {
    GoldenBeakUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e6d_1 = lazy(tmp_0, GoldenBeakUpgrade$_anonymous__tyl3nz);
  }
  v35($context_GameState_t6qee5) {
    return 5;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_511(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'GoldenBeakUpgrade';
  }
  hashCode() {
    return -998665023;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GoldenBeakUpgrade))
      return false;
    return true;
  }
}
class SoulHarvestVackerUpgrade {
  constructor() {
    SoulHarvestVackerUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f6d_1 = lazy(tmp_0, SoulHarvestVackerUpgrade$_anonymous__cnkv3l);
  }
  v35($context_GameState_t6qee5) {
    return 0;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_512(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SoulHarvestVackerUpgrade';
  }
  hashCode() {
    return 812717867;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoulHarvestVackerUpgrade))
      return false;
    return true;
  }
}
class SwiftKillUpgrade {
  constructor() {
    SwiftKillUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g6d_1 = lazy(tmp_0, SwiftKillUpgrade$_anonymous__l3mpvw);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_513(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SwiftKillUpgrade';
  }
  hashCode() {
    return 216201616;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SwiftKillUpgrade))
      return false;
    return true;
  }
}
class EntrancingUpgrade {
  constructor() {
    EntrancingUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h6d_1 = lazy(tmp_0, EntrancingUpgrade$_anonymous__nbstta);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_514(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EntrancingUpgrade';
  }
  hashCode() {
    return -1692796796;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EntrancingUpgrade))
      return false;
    return true;
  }
}
class ReveranceUpgrade {
  constructor() {
    ReveranceUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i6d_1 = lazy(tmp_0, ReveranceUpgrade$_anonymous__upc5ju);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_515(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ReveranceUpgrade';
  }
  hashCode() {
    return -674824190;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReveranceUpgrade))
      return false;
    return true;
  }
}
class Vacker {
  constructor() {
    Vacker_instance = this;
    this.j6d_1 = AdmirerType_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k6d_1 = lazy(tmp_0, Vacker$_anonymous__uyr9nb);
  }
  q36() {
    return this.j6d_1;
  }
  r36($context_GameState_t6qee5) {
    return LocationType_Forest_getInstance();
  }
  s36() {
    return setOf_0([SummonAdmirerCard_getInstance(), AllureCard_getInstance(), EludeCard_getInstance(), BeholdCard_getInstance()]);
  }
  t35() {
    return setOf_0([MirrorBeastUpgrade_getInstance(), GoldenBeakUpgrade_getInstance(), SoulHarvestVackerUpgrade_getInstance(), SwiftKillUpgrade_getInstance(), EntrancingUpgrade_getInstance(), ReveranceUpgrade_getInstance()]);
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  v36($context_GameState_t6qee5, position) {
    return plus_1(getInitList_1.call(this, $context_GameState_t6qee5, position), init_0(get_drainedSoulsKey(), 0));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_516(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Vacker';
  }
  hashCode() {
    return 234593093;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vacker))
      return false;
    return true;
  }
}
class AllureSoulChangedDamageSource {
  constructor() {
    AllureSoulChangedDamageSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l6d_1 = lazy(tmp_0, AllureSoulChangedDamageSource$_anonymous__1m1vyl);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_517(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AllureSoulChangedDamageSource';
  }
  hashCode() {
    return -1740621953;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AllureSoulChangedDamageSource))
      return false;
    return true;
  }
}
class AllureKillEffectSource {
  constructor() {
    AllureKillEffectSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m6d_1 = lazy(tmp_0, AllureKillEffectSource$_anonymous__guz8g6);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_518(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AllureKillEffectSource';
  }
  hashCode() {
    return -1390685482;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AllureKillEffectSource))
      return false;
    return true;
  }
}
class SoulsChangeSource {
  constructor() {
    SoulsChangeSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n6d_1 = lazy(tmp_0, SoulsChangeSource$_anonymous__6yqus4);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_519(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SoulsChangeSource';
  }
  hashCode() {
    return -763113274;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoulsChangeSource))
      return false;
    return true;
  }
}
class Companion_498 {
  constructor() {
    Companion_instance_498 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o6d_1 = [lazy(tmp_0, AllureKillSoulBonusStatement$Companion$$childSerializers$_anonymous__kmu4zi)];
  }
}
class $serializer_425 {
  constructor() {
    $serializer_instance_421 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AllureKillSoulBonusStatement', this, 1);
    tmp0_serialDesc.h1b('beast', false);
    this.p6d_1 = tmp0_serialDesc;
  }
  q6d(encoder, value) {
    var tmp0_desc = this.p6d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_499().o6d_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.r6d_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q6d(encoder, value instanceof AllureKillSoulBonusStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p6d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_499().o6d_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return AllureKillSoulBonusStatement.s6d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.p6d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_499().o6d_1[0].k3()];
  }
}
class AllureKillSoulBonusStatement {
  constructor(beast) {
    Companion_getInstance_499();
    this.r6d_1 = beast;
  }
  toString() {
    return 'AllureKillSoulBonusStatement(beast=' + this.r6d_1.toString() + ')';
  }
  hashCode() {
    return this.r6d_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AllureKillSoulBonusStatement))
      return false;
    if (!this.r6d_1.equals(other.r6d_1))
      return false;
    return true;
  }
  static s6d(seen0, beast, serializationConstructorMarker) {
    Companion_getInstance_499();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_421().p6d_1);
    }
    var $this = createThis(this);
    $this.r6d_1 = beast;
    return $this;
  }
}
class Companion_499 {
  constructor() {
    Companion_instance_499 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t6d_1 = [lazy(tmp_0, AllureStatement$Companion$$childSerializers$_anonymous__49opsu), null];
  }
}
class $serializer_426 {
  constructor() {
    $serializer_instance_422 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AllureStatement', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('soulsCostForBonus', false);
    this.u6d_1 = tmp0_serialDesc;
  }
  v6d(encoder, value) {
    var tmp0_desc = this.u6d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_500().t6d_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.w6d_1);
    tmp1_output.z14(tmp0_desc, 1, value.x6d_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v6d(encoder, value instanceof AllureStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u6d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_500().t6d_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return AllureStatement.y6d(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.u6d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_500().t6d_1[0].k3(), IntSerializer_getInstance()];
  }
}
class AllureStatement {
  constructor(beast, soulsCostForBonus) {
    Companion_getInstance_500();
    this.w6d_1 = beast;
    this.x6d_1 = soulsCostForBonus;
  }
  o2o($context_GameStateRuntime_604ce3) {
    return (new AttackStatement(get_cardDamageSource(AllureCard_getInstance()), this.w6d_1)).o2o($context_GameStateRuntime_604ce3);
  }
  toString() {
    return 'AllureStatement(beast=' + this.w6d_1.toString() + ', soulsCostForBonus=' + this.x6d_1 + ')';
  }
  hashCode() {
    var result = this.w6d_1.hashCode();
    result = imul(result, 31) + this.x6d_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AllureStatement))
      return false;
    if (!this.w6d_1.equals(other.w6d_1))
      return false;
    if (!(this.x6d_1 === other.x6d_1))
      return false;
    return true;
  }
  static y6d(seen0, beast, soulsCostForBonus, serializationConstructorMarker) {
    Companion_getInstance_500();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_422().u6d_1);
    }
    var $this = createThis(this);
    $this.w6d_1 = beast;
    $this.x6d_1 = soulsCostForBonus;
    return $this;
  }
}
class Companion_500 {
  constructor() {
    Companion_instance_500 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z6d_1 = [lazy(tmp_0, BeholdStatement$Companion$$childSerializers$_anonymous__lcny3h), null];
  }
}
class $serializer_427 {
  constructor() {
    $serializer_instance_423 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BeholdStatement', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('soulsCostForBonus', false);
    this.a6e_1 = tmp0_serialDesc;
  }
  b6e(encoder, value) {
    var tmp0_desc = this.a6e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_501().z6d_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c6e_1);
    tmp1_output.z14(tmp0_desc, 1, value.d6e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b6e(encoder, value instanceof BeholdStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a6e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_501().z6d_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BeholdStatement.e6e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.a6e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_501().z6d_1[0].k3(), IntSerializer_getInstance()];
  }
}
class BeholdStatement {
  constructor(beast, soulsCostForBonus) {
    Companion_getInstance_501();
    this.c6e_1 = beast;
    this.d6e_1 = soulsCostForBonus;
  }
  toString() {
    return 'BeholdStatement(beast=' + this.c6e_1.toString() + ', soulsCostForBonus=' + this.d6e_1 + ')';
  }
  hashCode() {
    var result = this.c6e_1.hashCode();
    result = imul(result, 31) + this.d6e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeholdStatement))
      return false;
    if (!this.c6e_1.equals(other.c6e_1))
      return false;
    if (!(this.d6e_1 === other.d6e_1))
      return false;
    return true;
  }
  static e6e(seen0, beast, soulsCostForBonus, serializationConstructorMarker) {
    Companion_getInstance_501();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_423().a6e_1);
    }
    var $this = createThis(this);
    $this.c6e_1 = beast;
    $this.d6e_1 = soulsCostForBonus;
    return $this;
  }
}
class Companion_501 {
  constructor() {
    Companion_instance_501 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f6e_1 = [lazy(tmp_0, EludeStatement$Companion$$childSerializers$_anonymous__7fxgve), null];
  }
}
class $serializer_428 {
  constructor() {
    $serializer_instance_424 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EludeStatement', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('soulsCostForBonus', false);
    this.g6e_1 = tmp0_serialDesc;
  }
  h6e(encoder, value) {
    var tmp0_desc = this.g6e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_502().f6e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i6e_1);
    tmp1_output.z14(tmp0_desc, 1, value.j6e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h6e(encoder, value instanceof EludeStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g6e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_502().f6e_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return EludeStatement.k6e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.g6e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_502().f6e_1[0].k3(), IntSerializer_getInstance()];
  }
}
class EludeStatement {
  constructor(beast, soulsCostForBonus) {
    Companion_getInstance_502();
    this.i6e_1 = beast;
    this.j6e_1 = soulsCostForBonus;
  }
  toString() {
    return 'EludeStatement(beast=' + this.i6e_1.toString() + ', soulsCostForBonus=' + this.j6e_1 + ')';
  }
  hashCode() {
    var result = this.i6e_1.hashCode();
    result = imul(result, 31) + this.j6e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EludeStatement))
      return false;
    if (!this.i6e_1.equals(other.i6e_1))
      return false;
    if (!(this.j6e_1 === other.j6e_1))
      return false;
    return true;
  }
  static k6e(seen0, beast, soulsCostForBonus, serializationConstructorMarker) {
    Companion_getInstance_502();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_424().g6e_1);
    }
    var $this = createThis(this);
    $this.i6e_1 = beast;
    $this.j6e_1 = soulsCostForBonus;
    return $this;
  }
}
class Companion_502 {
  constructor() {
    Companion_instance_502 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l6e_1 = [lazy(tmp_0, SoulStealStatement$Companion$$childSerializers$_anonymous__o0jtkn)];
  }
}
class $serializer_429 {
  constructor() {
    $serializer_instance_425 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SoulStealStatement', this, 1);
    tmp0_serialDesc.h1b('admirer', false);
    this.m6e_1 = tmp0_serialDesc;
  }
  n6e(encoder, value) {
    var tmp0_desc = this.m6e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_503().l6e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.o6e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n6e(encoder, value instanceof SoulStealStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m6e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_503().l6e_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SoulStealStatement.p6e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m6e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_503().l6e_1[0].k3()];
  }
}
class SoulStealStatement {
  constructor(admirer) {
    Companion_getInstance_503();
    this.o6e_1 = admirer;
  }
  toString() {
    return 'SoulStealStatement(admirer=' + this.o6e_1.toString() + ')';
  }
  hashCode() {
    return this.o6e_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoulStealStatement))
      return false;
    if (!this.o6e_1.equals(other.o6e_1))
      return false;
    return true;
  }
  static p6e(seen0, admirer, serializationConstructorMarker) {
    Companion_getInstance_503();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_425().m6e_1);
    }
    var $this = createThis(this);
    $this.o6e_1 = admirer;
    return $this;
  }
}
class Companion_503 {
  constructor() {
    Companion_instance_503 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q6e_1 = [lazy(tmp_0, SummonAdmirerStatement$Companion$$childSerializers$_anonymous__1i6psq), null];
  }
}
class $serializer_430 {
  constructor() {
    $serializer_instance_426 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SummonAdmirerStatement', this, 2);
    tmp0_serialDesc.h1b('beast', false);
    tmp0_serialDesc.h1b('soulsCostForBonus', false);
    this.r6e_1 = tmp0_serialDesc;
  }
  s6e(encoder, value) {
    var tmp0_desc = this.r6e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_504().q6e_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t6e_1);
    tmp1_output.z14(tmp0_desc, 1, value.u6e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s6e(encoder, value instanceof SummonAdmirerStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r6e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_504().q6e_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SummonAdmirerStatement.v6e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r6e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_504().q6e_1[0].k3(), IntSerializer_getInstance()];
  }
}
class SummonAdmirerStatement {
  constructor(beast, soulsCostForBonus) {
    Companion_getInstance_504();
    this.t6e_1 = beast;
    this.u6e_1 = soulsCostForBonus;
  }
  toString() {
    return 'SummonAdmirerStatement(beast=' + this.t6e_1.toString() + ', soulsCostForBonus=' + this.u6e_1 + ')';
  }
  hashCode() {
    var result = this.t6e_1.hashCode();
    result = imul(result, 31) + this.u6e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonAdmirerStatement))
      return false;
    if (!this.t6e_1.equals(other.t6e_1))
      return false;
    if (!(this.u6e_1 === other.u6e_1))
      return false;
    return true;
  }
  static v6e(seen0, beast, soulsCostForBonus, serializationConstructorMarker) {
    Companion_getInstance_504();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_426().r6e_1);
    }
    var $this = createThis(this);
    $this.t6e_1 = beast;
    $this.u6e_1 = soulsCostForBonus;
    return $this;
  }
}
class Companion_504 {}
class $serializer_431 {
  constructor() {
    $serializer_instance_427 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DrainedSoulsChangeEvent', this, 1);
    tmp0_serialDesc.h1b('drainedSoulsChange', false);
    this.w6e_1 = tmp0_serialDesc;
  }
  x6e(encoder, value) {
    var tmp0_desc = this.w6e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.y6e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x6e(encoder, value instanceof DrainedSoulsChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w6e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return DrainedSoulsChangeEvent.z6e(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w6e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class DrainedSoulsChangeEvent {
  constructor(drainedSoulsChange) {
    this.y6e_1 = drainedSoulsChange;
  }
  m37(_this__u8e3s4) {
    var _receiver__tnumb7 = get_vackerBeast(_this__u8e3s4);
    set_drainedSoulsImpl(_this__u8e3s4, _receiver__tnumb7, get_drainedSoulsImpl(_this__u8e3s4, _receiver__tnumb7) + this.y6e_1 | 0);
  }
  n37($context_GameState_t6qee5) {
    return new DrainedSoulsChangeEvent(-this.y6e_1 | 0);
  }
  toString() {
    return 'DrainedSoulsChangeEvent(drainedSoulsChange=' + this.y6e_1 + ')';
  }
  hashCode() {
    return this.y6e_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DrainedSoulsChangeEvent))
      return false;
    if (!(this.y6e_1 === other.y6e_1))
      return false;
    return true;
  }
  static z6e(seen0, drainedSoulsChange, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_427().w6e_1);
    }
    var $this = createThis(this);
    $this.y6e_1 = drainedSoulsChange;
    return $this;
  }
}
class AdmirerType {
  constructor() {
    AdmirerType_instance = this;
    this.a6f_1 = Vacker_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b6f_1 = lazy(tmp_0, AdmirerType$_anonymous__4xgarn);
  }
  r37() {
    return this.a6f_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_520(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AdmirerType';
  }
  hashCode() {
    return -1396716875;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AdmirerType))
      return false;
    return true;
  }
}
class VackerCard {}
function get_character_3() {
  return Vacker_getInstance();
}
class AllureCard {
  constructor() {
    AllureCard_instance = this;
    this.c6f_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d6f_1 = lazy(tmp_0, AllureCard$_anonymous__gcn4ao);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_521(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'AllureCard';
  }
  hashCode() {
    return 1189974108;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AllureCard))
      return false;
    return true;
  }
}
class BeholdCard {
  constructor() {
    BeholdCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e6f_1 = lazy(tmp_0, BeholdCard$_anonymous__3iikm3);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_522(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BeholdCard';
  }
  hashCode() {
    return 1176679991;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeholdCard))
      return false;
    return true;
  }
}
class EludeCard {
  constructor() {
    EludeCard_instance = this;
    this.f6f_1 = Red_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g6f_1 = lazy(tmp_0, EludeCard$_anonymous__srscso);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_523(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'EludeCard';
  }
  hashCode() {
    return 2097531962;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EludeCard))
      return false;
    return true;
  }
}
class SummonAdmirerCard {
  constructor() {
    SummonAdmirerCard_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h6f_1 = lazy(tmp_0, SummonAdmirerCard$_anonymous__i302iw);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_524(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SummonAdmirerCard';
  }
  hashCode() {
    return -138758486;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SummonAdmirerCard))
      return false;
    return true;
  }
}
class Valdi {
  constructor() {
    Valdi_instance = this;
    this.i6f_1 = 4;
    this.j6f_1 = setOf_0([InfusionUpgrade_getInstance(), BloodCraftUpgrade_getInstance(), DissectionUpgrade_getInstance(), ExtractUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.k6f_1 = lazy(tmp_0, Valdi$_anonymous__ra97wv);
  }
  s36() {
    return setOf_0([IncisionCard_getInstance(), BloodHuntCard_getInstance(), BloodTrackCard_getInstance()]);
  }
  t35() {
    return this.j6f_1;
  }
  n2z($context_GameState_t6qee5) {
    return 4;
  }
  v36($context_GameState_t6qee5, position) {
    return plus_1(getInitList_0.call(this, $context_GameState_t6qee5, position), init_0(get_valdiBloodKey(), 0));
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_525(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Valdi';
  }
  hashCode() {
    return 1670143937;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Valdi))
      return false;
    return true;
  }
}
class InfusionUpgrade {
  constructor() {
    InfusionUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l6f_1 = lazy(tmp_0, InfusionUpgrade$_anonymous__7azrj8);
  }
  v35($context_GameState_t6qee5) {
    return 0;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_526(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'InfusionUpgrade';
  }
  hashCode() {
    return -1676539122;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InfusionUpgrade))
      return false;
    return true;
  }
}
class BloodCraftUpgrade {
  constructor() {
    BloodCraftUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m6f_1 = lazy(tmp_0, BloodCraftUpgrade$_anonymous__7aqxi9);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_527(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BloodCraftUpgrade';
  }
  hashCode() {
    return -1154531631;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BloodCraftUpgrade))
      return false;
    return true;
  }
}
class DissectionUpgrade {
  constructor() {
    DissectionUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n6f_1 = lazy(tmp_0, DissectionUpgrade$_anonymous__9q9tke);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_528(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'DissectionUpgrade';
  }
  hashCode() {
    return 513780576;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DissectionUpgrade))
      return false;
    return true;
  }
}
class ExtractUpgrade {
  constructor() {
    ExtractUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o6f_1 = lazy(tmp_0, ExtractUpgrade$_anonymous__69uqd8);
  }
  v35($context_GameState_t6qee5) {
    return 2;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_529(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ExtractUpgrade';
  }
  hashCode() {
    return 839637088;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExtractUpgrade))
      return false;
    return true;
  }
}
class ValdiBloodKillSource {
  constructor() {
    ValdiBloodKillSource_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p6f_1 = lazy(tmp_0, ValdiBloodKillSource$_anonymous__bugljq);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_530(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ValdiBloodKillSource';
  }
  hashCode() {
    return 993771698;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ValdiBloodKillSource))
      return false;
    return true;
  }
}
class Companion_505 {}
class $serializer_432 {
  constructor() {
    $serializer_instance_428 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SpendValdiBloodQuestion', this, 1);
    tmp0_serialDesc.h1b('bloodToBeSpend', false);
    this.q6f_1 = tmp0_serialDesc;
  }
  r6f(encoder, value) {
    var tmp0_desc = this.q6f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.s6f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r6f(encoder, value instanceof SpendValdiBloodQuestion ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q6f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SpendValdiBloodQuestion.t6f(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.q6f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class SpendValdiBloodQuestion {
  constructor(bloodToBeSpend) {
    this.s6f_1 = bloodToBeSpend;
  }
  toString() {
    return 'SpendValdiBloodQuestion(bloodToBeSpend=' + this.s6f_1 + ')';
  }
  hashCode() {
    return this.s6f_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpendValdiBloodQuestion))
      return false;
    if (!(this.s6f_1 === other.s6f_1))
      return false;
    return true;
  }
  static t6f(seen0, bloodToBeSpend, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_428().q6f_1);
    }
    var $this = createThis(this);
    $this.s6f_1 = bloodToBeSpend;
    return $this;
  }
}
class Companion_506 {
  constructor() {
    Companion_instance_506 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u6f_1 = [lazy(tmp_0, BloodHuntStatement$Companion$$childSerializers$_anonymous__qjo6i0)];
  }
}
class $serializer_433 {
  constructor() {
    $serializer_instance_429 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BloodHuntStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.v6f_1 = tmp0_serialDesc;
  }
  w6f(encoder, value) {
    var tmp0_desc = this.v6f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_507().u6f_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.x6f_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w6f(encoder, value instanceof BloodHuntStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v6f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_507().u6f_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BloodHuntStatement.y6f(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.v6f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_507().u6f_1[0].k3()];
  }
}
class BloodHuntStatement {
  constructor(hunter) {
    Companion_getInstance_507();
    this.x6f_1 = hunter;
  }
  toString() {
    return 'BloodHuntStatement(hunter=' + this.x6f_1.toString() + ')';
  }
  hashCode() {
    return this.x6f_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BloodHuntStatement))
      return false;
    if (!this.x6f_1.equals(other.x6f_1))
      return false;
    return true;
  }
  static y6f(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_507();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_429().v6f_1);
    }
    var $this = createThis(this);
    $this.x6f_1 = hunter;
    return $this;
  }
}
class Companion_507 {
  constructor() {
    Companion_instance_507 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z6f_1 = [lazy(tmp_0, BloodTrackStatement$Companion$$childSerializers$_anonymous__jrpeac)];
  }
}
class $serializer_434 {
  constructor() {
    $serializer_instance_430 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BloodTrackStatement', this, 1);
    tmp0_serialDesc.h1b('hunter', false);
    this.a6g_1 = tmp0_serialDesc;
  }
  b6g(encoder, value) {
    var tmp0_desc = this.a6g_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_508().z6f_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.c6g_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b6g(encoder, value instanceof BloodTrackStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a6g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_508().z6f_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return BloodTrackStatement.d6g(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a6g_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_508().z6f_1[0].k3()];
  }
}
class BloodTrackStatement {
  constructor(hunter) {
    Companion_getInstance_508();
    this.c6g_1 = hunter;
  }
  toString() {
    return 'BloodTrackStatement(hunter=' + this.c6g_1.toString() + ')';
  }
  hashCode() {
    return this.c6g_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BloodTrackStatement))
      return false;
    if (!this.c6g_1.equals(other.c6g_1))
      return false;
    return true;
  }
  static d6g(seen0, hunter, serializationConstructorMarker) {
    Companion_getInstance_508();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_430().a6g_1);
    }
    var $this = createThis(this);
    $this.c6g_1 = hunter;
    return $this;
  }
}
class ExtractStatement {
  constructor() {
    ExtractStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e6g_1 = lazy(tmp_0, ExtractStatement$_anonymous__3evkdl);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_531(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'ExtractStatement';
  }
  hashCode() {
    return 464774835;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExtractStatement))
      return false;
    return true;
  }
}
class InfusionUpgradeStatement {
  constructor() {
    InfusionUpgradeStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f6g_1 = lazy(tmp_0, InfusionUpgradeStatement$_anonymous__x7haqj);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_532(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'InfusionUpgradeStatement';
  }
  hashCode() {
    return 1463275009;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InfusionUpgradeStatement))
      return false;
    return true;
  }
}
class Companion_508 {}
class $serializer_435 {
  constructor() {
    $serializer_instance_431 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ValdiBloodChangeEvent', this, 1);
    tmp0_serialDesc.h1b('valdiBloodChange', false);
    this.g6g_1 = tmp0_serialDesc;
  }
  h6g(encoder, value) {
    var tmp0_desc = this.g6g_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.i6g_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h6g(encoder, value instanceof ValdiBloodChangeEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g6g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ValdiBloodChangeEvent.j6g(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.g6g_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class ValdiBloodChangeEvent {
  constructor(valdiBloodChange) {
    this.i6g_1 = valdiBloodChange;
  }
  m37(_this__u8e3s4) {
    var _receiver__tnumb7 = get_valdiHunter(_this__u8e3s4);
    set_valdiBloodImpl(_this__u8e3s4, _receiver__tnumb7, get_valdiBloodImpl(_this__u8e3s4, _receiver__tnumb7) + this.i6g_1 | 0);
  }
  n37($context_GameState_t6qee5) {
    var previousBlood = get_valdiBlood($context_GameState_t6qee5, get_valdiHunter($context_GameState_t6qee5));
    var changedBlood = previousBlood + this.i6g_1 | 0;
    return new SetValdiBloodEvent(changedBlood, previousBlood, this);
  }
  toString() {
    return 'ValdiBloodChangeEvent(valdiBloodChange=' + this.i6g_1 + ')';
  }
  hashCode() {
    return this.i6g_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ValdiBloodChangeEvent))
      return false;
    if (!(this.i6g_1 === other.i6g_1))
      return false;
    return true;
  }
  static j6g(seen0, valdiBloodChange, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_431().g6g_1);
    }
    var $this = createThis(this);
    $this.i6g_1 = valdiBloodChange;
    return $this;
  }
}
class BloodHuntCard {
  constructor() {
    BloodHuntCard_instance = this;
    this.k6g_1 = Blue_getInstance();
    this.l6g_1 = Valdi_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m6g_1 = lazy(tmp_0, BloodHuntCard$_anonymous__ohw6ka);
  }
  t37() {
    return this.l6g_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_533(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BloodHuntCard';
  }
  hashCode() {
    return 1979698872;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BloodHuntCard))
      return false;
    return true;
  }
}
class IncisionCard {
  constructor() {
    IncisionCard_instance = this;
    this.n6g_1 = Red_getInstance();
    this.o6g_1 = Valdi_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p6g_1 = lazy(tmp_0, IncisionCard$_anonymous__606z3b);
  }
  t37() {
    return this.o6g_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_534(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'IncisionCard';
  }
  hashCode() {
    return -1501005835;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IncisionCard))
      return false;
    return true;
  }
}
class BloodTrackCard {
  constructor() {
    BloodTrackCard_instance = this;
    this.q6g_1 = Blue_getInstance();
    this.r6g_1 = Valdi_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s6g_1 = lazy(tmp_0, BloodTrackCard$_anonymous__a5tjxy);
  }
  t37() {
    return this.r6g_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_535(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'BloodTrackCard';
  }
  hashCode() {
    return 989731878;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BloodTrackCard))
      return false;
    return true;
  }
}
class Companion_509 {
  constructor() {
    Companion_instance_509 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t6g_1 = [null, null, lazy(tmp_0, SetValdiBloodEvent$Companion$$childSerializers$_anonymous__8g4m3e)];
  }
}
class $serializer_436 {
  constructor() {
    $serializer_instance_432 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetValdiBloodEvent', this, 3);
    tmp0_serialDesc.h1b('fromBlood', false);
    tmp0_serialDesc.h1b('toBlood', false);
    tmp0_serialDesc.h1b('revertTo', false);
    this.u6g_1 = tmp0_serialDesc;
  }
  v6g(encoder, value) {
    var tmp0_desc = this.u6g_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_510().t6g_1;
    tmp1_output.z14(tmp0_desc, 0, value.w6g_1);
    tmp1_output.z14(tmp0_desc, 1, value.x6g_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.y6g_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v6g(encoder, value instanceof SetValdiBloodEvent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u6g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_510().t6g_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return SetValdiBloodEvent.z6g(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.u6g_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_510().t6g_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[2].k3()];
  }
}
class SetValdiBloodEvent {
  constructor(fromBlood, toBlood, revertTo) {
    Companion_getInstance_510();
    this.w6g_1 = fromBlood;
    this.x6g_1 = toBlood;
    this.y6g_1 = revertTo;
  }
  m37(_this__u8e3s4) {
    // Inline function 'kotlin.check' call
    if (!(get_valdiBlood(_this__u8e3s4, get_valdiHunter(_this__u8e3s4)) === this.w6g_1)) {
      throw IllegalStateException.o('Check failed.');
    }
    set_valdiBloodImpl(_this__u8e3s4, get_valdiHunter(_this__u8e3s4), this.x6g_1);
  }
  n37($context_GameState_t6qee5) {
    // Inline function 'kotlin.check' call
    if (!(get_valdiBlood($context_GameState_t6qee5, get_valdiHunter($context_GameState_t6qee5)) === this.w6g_1)) {
      throw IllegalStateException.o('Check failed.');
    }
    return this.y6g_1;
  }
  toString() {
    return 'SetValdiBloodEvent(fromBlood=' + this.w6g_1 + ', toBlood=' + this.x6g_1 + ', revertTo=' + toString(this.y6g_1) + ')';
  }
  hashCode() {
    var result = this.w6g_1;
    result = imul(result, 31) + this.x6g_1 | 0;
    result = imul(result, 31) + hashCode(this.y6g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetValdiBloodEvent))
      return false;
    if (!(this.w6g_1 === other.w6g_1))
      return false;
    if (!(this.x6g_1 === other.x6g_1))
      return false;
    if (!equals(this.y6g_1, other.y6g_1))
      return false;
    return true;
  }
  static z6g(seen0, fromBlood, toBlood, revertTo, serializationConstructorMarker) {
    Companion_getInstance_510();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_432().u6g_1);
    }
    var $this = createThis(this);
    $this.w6g_1 = fromBlood;
    $this.x6g_1 = toBlood;
    $this.y6g_1 = revertTo;
    return $this;
  }
}
class OnlyAnimalsAttackModifier {
  constructor() {
    OnlyAnimalsAttackModifier_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a6h_1 = lazy(tmp_0, OnlyAnimalsAttackModifier$_anonymous__ehrg6r);
  }
  w35($context_GameState_t6qee5, target) {
    var tmp = get_objectType($context_GameState_t6qee5, target);
    return isInterface(tmp, AnimalType);
  }
  x35($context_GameState_t6qee5, target) {
    return 0;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_536(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'OnlyAnimalsAttackModifier';
  }
  hashCode() {
    return -137472091;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OnlyAnimalsAttackModifier))
      return false;
    return true;
  }
}
class Varja {
  constructor() {
    Varja_instance = this;
    this.b6h_1 = setOf_0([HornOfValhUpgrade_getInstance(), HuntersBaneUpgrade_getInstance(), HeroicSpeechUpgrade_getInstance(), TacticalManouverUpgrade_getInstance()]);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c6h_1 = lazy(tmp_0, Varja$_anonymous__ngveyv);
  }
  w36(gameState) {
    var tmp1_safe_receiver = gameState == null ? null : gameState.x40();
    var tmp2_subject = tmp1_safe_receiver == null ? null : get_balanceVersion(tmp1_safe_receiver);
    var tmp;
    switch (tmp2_subject == null ? -1 : tmp2_subject.w1_1) {
      case 0:
        tmp = 1;
        break;
      case 1:
      case -1:
        tmp = 2;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  s36() {
    return plus_0(get_abilityCards.call(this), CommandCard_getInstance());
  }
  t35() {
    return this.b6h_1;
  }
  n2z($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_537(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Varja';
  }
  hashCode() {
    return 1670149881;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Varja))
      return false;
    return true;
  }
}
class HornOfValhUpgrade {
  constructor() {
    HornOfValhUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d6h_1 = lazy(tmp_0, HornOfValhUpgrade$_anonymous__k8m138);
  }
  v35($context_GameState_t6qee5) {
    return 3;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_538(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HornOfValhUpgrade';
  }
  hashCode() {
    return 1042777974;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HornOfValhUpgrade))
      return false;
    return true;
  }
}
class HuntersBaneUpgrade {
  constructor() {
    HuntersBaneUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e6h_1 = lazy(tmp_0, HuntersBaneUpgrade$_anonymous__pum4w4);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_539(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HuntersBaneUpgrade';
  }
  hashCode() {
    return 1632169880;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HuntersBaneUpgrade))
      return false;
    return true;
  }
}
class HeroicSpeechUpgrade {
  constructor() {
    HeroicSpeechUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f6h_1 = lazy(tmp_0, HeroicSpeechUpgrade$_anonymous__26tbwv);
  }
  v35($context_GameState_t6qee5) {
    return get_balanceVersion(get_gameRules($context_GameState_t6qee5)).equals(BeastBalanceVersion_OfficialV2_getInstance()) ? 3 : 4;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_540(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HeroicSpeechUpgrade';
  }
  hashCode() {
    return -617998911;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HeroicSpeechUpgrade))
      return false;
    return true;
  }
}
class TacticalManouverUpgrade {
  constructor() {
    TacticalManouverUpgrade_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g6h_1 = lazy(tmp_0, TacticalManouverUpgrade$_anonymous__c4vi2p);
  }
  v35($context_GameState_t6qee5) {
    return 1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_541(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'TacticalManouverUpgrade';
  }
  hashCode() {
    return -1100761231;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TacticalManouverUpgrade))
      return false;
    return true;
  }
}
class ChooseAndMoveByVarja {
  constructor() {
    Companion_getInstance_512();
  }
}
class MoveAllSettlersAndHuntersByVarja extends ChooseAndMoveByVarja {
  constructor() {
    MoveAllSettlersAndHuntersByVarja_instance = null;
    super();
    MoveAllSettlersAndHuntersByVarja_instance = this;
    this.h6h_1 = null;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i6h_1 = lazy(tmp_0, MoveAllSettlersAndHuntersByVarja$_anonymous__4bik7s);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_542(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'MoveAllSettlersAndHuntersByVarja';
  }
  hashCode() {
    return -1899021580;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MoveAllSettlersAndHuntersByVarja))
      return false;
    return true;
  }
}
class Companion_510 {
  constructor() {
    Companion_instance_510 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j6h_1 = [lazy(tmp_0, CommandCardStatement$Companion$$childSerializers$_anonymous__p1hn5i)];
  }
}
class $serializer_437 {
  constructor() {
    $serializer_instance_433 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('CommandCardStatement', this, 1);
    tmp0_serialDesc.h1b('actor', false);
    this.k6h_1 = tmp0_serialDesc;
  }
  l6h(encoder, value) {
    var tmp0_desc = this.k6h_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_511().j6h_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.m6h_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l6h(encoder, value instanceof CommandCardStatement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k6h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_511().j6h_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return CommandCardStatement.n6h(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.k6h_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_511().j6h_1[0].k3()];
  }
}
class CommandCardStatement {
  constructor(actor) {
    Companion_getInstance_511();
    this.m6h_1 = actor;
  }
  toString() {
    return 'CommandCardStatement(actor=' + this.m6h_1.toString() + ')';
  }
  hashCode() {
    return this.m6h_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CommandCardStatement))
      return false;
    if (!this.m6h_1.equals(other.m6h_1))
      return false;
    return true;
  }
  static n6h(seen0, actor, serializationConstructorMarker) {
    Companion_getInstance_511();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_433().k6h_1);
    }
    var $this = createThis(this);
    $this.m6h_1 = actor;
    return $this;
  }
}
class HeroicSpeechStatement {
  constructor() {
    HeroicSpeechStatement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o6h_1 = lazy(tmp_0, HeroicSpeechStatement$_anonymous__w0n1lu);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_543(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'HeroicSpeechStatement';
  }
  hashCode() {
    return -164081708;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HeroicSpeechStatement))
      return false;
    return true;
  }
}
class CommandCard {
  constructor() {
    CommandCard_instance = this;
    this.p6h_1 = Red_getInstance();
    this.q6h_1 = Varja_getInstance();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r6h_1 = lazy(tmp_0, CommandCard$_anonymous__mq8q5g);
  }
  t37() {
    return this.q6h_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_544(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'CommandCard';
  }
  hashCode() {
    return -2139483882;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CommandCard))
      return false;
    return true;
  }
}
class Companion_511 {
  constructor() {
    Companion_instance_511 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s6h_1 = lazy(tmp_0, ChooseAndMoveByVarja$Companion$_anonymous__vces5j);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_545(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class CurrentAndOldStateHolder {}
function *applyGameStateChanges(notification, $completion) {
  var event = notification.x3p_1;
  if (event instanceof InitGameStateEvent) {
    this.x6h(event.a54_1);
    this.v6h(event.a54_1);
    return emptyList();
  } else {
    // Inline function 'kotlin.require' call
    if (!this.y6h()) {
      var message = 'Game state is not initialized yet, but the first event is ' + toString(event);
      throw IllegalArgumentException.h2(toString(message));
    }
    this.v6h(this.t6h());
    var oldRevision = this.w6h().g38_1;
    this.x6h(this.w6h().y4l());
    // Inline function 'kotlin.with' call
    var $this$with = this.t6h();
    var stateChanges = withStateRuntime(this, $this$with, CurrentAndOldStateHolder$applyGameStateChanges$lambda(event));
    var _iterator__ex2g4s = stateChanges.p1();
    while (_iterator__ex2g4s.q1()) {
      var change = _iterator__ex2g4s.r1();
      apply($this$with, change);
    }
    var stateChanges_0 = stateChanges;
    var tmp0_safe_receiver = notification.y3p_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.t6h().g38_1 = tmp0_safe_receiver.e3q_1;
      if (!(tmp0_safe_receiver.d3q_1 === -1) && !(tmp0_safe_receiver.d3q_1 === oldRevision)) {
        yield* this.u6h('Old revision revision from server = ' + tmp0_safe_receiver.d3q_1 + ' is not equal to old revision ' + oldRevision, $completion);
      }
      var checkCode = calculateCheckCode(this.t6h());
      if (!tmp0_safe_receiver.f3q_1.equals(checkCode)) {
        yield* this.u6h('Check code from server = ' + tmp0_safe_receiver.f3q_1.toString() + ' is not equal to local ' + checkCode.toString(), $completion);
      }
    }
    return stateChanges_0;
  }
}
function *applyGameStateRevertChanges(revertOutcome, $completion) {
  yield* /*#__NOINLINE__*/applyGameStateRevertChanges_1(this, revertOutcome.b6i_1, revertOutcome.c6i_1, revertOutcome.d6i_1, $completion);
  return Unit_instance;
}
function *applyGameStateRevertChanges_0(event, revertingChanges, checkInfo, $completion) {
  if (!(checkInfo.d3q_1 === this.t6h().g38_1)) {
    yield* this.u6h('Revision before revert from server = ' + checkInfo.d3q_1 + ' is not equal to current revision ' + this.t6h().g38_1, $completion);
  }
  yield* /*#__NOINLINE__*/applyGameStateRevertChanges_1(this, revertingChanges, checkInfo.e3q_1, checkInfo.f3q_1, $completion);
  return Unit_instance;
}
function *reportRevisionProblem(message, $completion) {
  // Inline function 'kotlin.error' call
  throw IllegalStateException.o(toString(message));
}
class CurrentAndOldStateHolderSimple {
  constructor(diagnostics) {
    this.l6i_1 = diagnostics;
  }
  v6h(_set____db54di) {
    this.m6i_1 = _set____db54di;
  }
  w6h() {
    var tmp = this.m6i_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('oldGameState');
    }
  }
  x6h(_set____db54di) {
    this.n6i_1 = _set____db54di;
  }
  t6h() {
    var tmp = this.n6i_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('gameState');
    }
  }
  y6h() {
    return !(this.n6i_1 == null);
  }
  f5c(warning, cause) {
    return this.l6i_1.f5c(warning, cause);
  }
}
class Companion_512 {
  constructor() {
    Companion_instance_512 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o6i_1 = lazy(tmp_0, BeastClientFeature$Companion$_anonymous__5v4bgd);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_546(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class BeastClientFeature extends Enum {}
class Companion_513 {
  constructor() {
    Companion_instance_513 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p6i_1 = [null, null, null, lazy(tmp_0, BeastAuthenticationCapabilities$Companion$$childSerializers$_anonymous__p1nmn1), null, null, null];
  }
}
class $serializer_438 {
  constructor() {
    $serializer_instance_434 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.BeastAuthenticationCapabilities', this, 7);
    tmp0_serialDesc.h1b('accessCodeLoginSupported', false);
    tmp0_serialDesc.h1b('discordLoginSupported', false);
    tmp0_serialDesc.h1b('steamLoginSupported', true);
    tmp0_serialDesc.h1b('allowedExpansions', true);
    tmp0_serialDesc.h1b('retainedServerMainClientPath', true);
    tmp0_serialDesc.h1b('allowSandboxForEveryone', true);
    tmp0_serialDesc.h1b('enableRecoveryTestContent', true);
    this.q6i_1 = tmp0_serialDesc;
  }
  r6i(encoder, value) {
    var tmp0_desc = this.q6i_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_514().p6i_1;
    tmp1_output.w14(tmp0_desc, 0, value.s6i_1);
    tmp1_output.w14(tmp0_desc, 1, value.t6i_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.u6i_1 === false)) {
      tmp1_output.w14(tmp0_desc, 2, value.u6i_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !equals(value.v6i_1, toSet(get_entries_0()))) {
      tmp1_output.g15(tmp0_desc, 3, tmp2_cached[3].k3(), value.v6i_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.w6i_1 == null)) {
      tmp1_output.i15(tmp0_desc, 4, StringSerializer_getInstance(), value.w6i_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !(value.x6i_1 === false)) {
      tmp1_output.w14(tmp0_desc, 5, value.x6i_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !(value.y6i_1 === false)) {
      tmp1_output.w14(tmp0_desc, 6, value.y6i_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r6i(encoder, value instanceof BeastAuthenticationCapabilities ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q6i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = false;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = false;
    var tmp10_local6 = false;
    var tmp11_input = decoder.p13(tmp0_desc);
    var tmp12_cached = Companion_getInstance_514().p6i_1;
    if (tmp11_input.e14()) {
      tmp4_local0 = tmp11_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.b14(tmp0_desc, 3, tmp12_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.d14(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.r13(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.r13(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.b14(tmp0_desc, 3, tmp12_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.d14(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.r13(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.r13(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp11_input.q13(tmp0_desc);
    return BeastAuthenticationCapabilities.z6i(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  dz() {
    return this.q6i_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_514().p6i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[3].k3(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class BeastAuthenticationCapabilities {
  constructor(accessCodeLoginSupported, discordLoginSupported, steamLoginSupported, allowedExpansions, retainedServerMainClientPath, allowSandboxForEveryone, enableRecoveryTestContent) {
    Companion_getInstance_514();
    steamLoginSupported = steamLoginSupported === VOID ? false : steamLoginSupported;
    allowedExpansions = allowedExpansions === VOID ? toSet(get_entries_0()) : allowedExpansions;
    retainedServerMainClientPath = retainedServerMainClientPath === VOID ? null : retainedServerMainClientPath;
    allowSandboxForEveryone = allowSandboxForEveryone === VOID ? false : allowSandboxForEveryone;
    enableRecoveryTestContent = enableRecoveryTestContent === VOID ? false : enableRecoveryTestContent;
    this.s6i_1 = accessCodeLoginSupported;
    this.t6i_1 = discordLoginSupported;
    this.u6i_1 = steamLoginSupported;
    this.v6i_1 = allowedExpansions;
    this.w6i_1 = retainedServerMainClientPath;
    this.x6i_1 = allowSandboxForEveryone;
    this.y6i_1 = enableRecoveryTestContent;
  }
  toString() {
    return 'BeastAuthenticationCapabilities(accessCodeLoginSupported=' + this.s6i_1 + ', discordLoginSupported=' + this.t6i_1 + ', steamLoginSupported=' + this.u6i_1 + ', allowedExpansions=' + toString(this.v6i_1) + ', retainedServerMainClientPath=' + this.w6i_1 + ', allowSandboxForEveryone=' + this.x6i_1 + ', enableRecoveryTestContent=' + this.y6i_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.s6i_1);
    result = imul(result, 31) + getBooleanHashCode(this.t6i_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u6i_1) | 0;
    result = imul(result, 31) + hashCode(this.v6i_1) | 0;
    result = imul(result, 31) + (this.w6i_1 == null ? 0 : getStringHashCode(this.w6i_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x6i_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y6i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastAuthenticationCapabilities))
      return false;
    if (!(this.s6i_1 === other.s6i_1))
      return false;
    if (!(this.t6i_1 === other.t6i_1))
      return false;
    if (!(this.u6i_1 === other.u6i_1))
      return false;
    if (!equals(this.v6i_1, other.v6i_1))
      return false;
    if (!(this.w6i_1 == other.w6i_1))
      return false;
    if (!(this.x6i_1 === other.x6i_1))
      return false;
    if (!(this.y6i_1 === other.y6i_1))
      return false;
    return true;
  }
  static z6i(seen0, accessCodeLoginSupported, discordLoginSupported, steamLoginSupported, allowedExpansions, retainedServerMainClientPath, allowSandboxForEveryone, enableRecoveryTestContent, serializationConstructorMarker) {
    Companion_getInstance_514();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_434().q6i_1);
    }
    var $this = createThis(this);
    $this.s6i_1 = accessCodeLoginSupported;
    $this.t6i_1 = discordLoginSupported;
    if (0 === (seen0 & 4))
      $this.u6i_1 = false;
    else
      $this.u6i_1 = steamLoginSupported;
    if (0 === (seen0 & 8))
      $this.v6i_1 = toSet(get_entries_0());
    else
      $this.v6i_1 = allowedExpansions;
    if (0 === (seen0 & 16))
      $this.w6i_1 = null;
    else
      $this.w6i_1 = retainedServerMainClientPath;
    if (0 === (seen0 & 32))
      $this.x6i_1 = false;
    else
      $this.x6i_1 = allowSandboxForEveryone;
    if (0 === (seen0 & 64))
      $this.y6i_1 = false;
    else
      $this.y6i_1 = enableRecoveryTestContent;
    return $this;
  }
}
class Companion_514 {}
class $serializer_439 {
  constructor() {
    $serializer_instance_435 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Success', this, 1);
    tmp0_serialDesc.h1b('configuration', false);
    this.a6j_1 = tmp0_serialDesc;
  }
  b6j(encoder, value) {
    var tmp0_desc = this.a6j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_437(), value.c6j_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b6j(encoder, value instanceof Success ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a6j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_437(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_437(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return Success.d6j(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a6j_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_437()];
  }
}
class BeastLoginResult {}
class Success {
  constructor(configuration) {
    this.c6j_1 = configuration;
  }
  toString() {
    return 'Success(configuration=' + this.c6j_1.toString() + ')';
  }
  hashCode() {
    return this.c6j_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Success))
      return false;
    if (!this.c6j_1.equals(other.c6j_1))
      return false;
    return true;
  }
  static d6j(seen0, configuration, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_435().a6j_1);
    }
    var $this = createThis(this);
    $this.c6j_1 = configuration;
    return $this;
  }
}
class Failure {
  constructor() {
    Failure_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e6j_1 = lazy(tmp_0, BeastLoginResult$Failure$_anonymous__52qr2i);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_547(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Failure';
  }
  hashCode() {
    return 2000154888;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Failure))
      return false;
    return true;
  }
}
class Companion_515 {
  a2g() {
    var tmp = getKClass(BeastLoginResult);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Failure), getKClass(Success)];
    var tmp_1 = Failure_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_2 = [ObjectSerializer.l1c('Failure', tmp_1, tmp$ret$3), $serializer_getInstance_435()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    return SealedClassSerializer.i10('steelart.beast.network.BeastLoginResult', tmp, tmp_0, tmp_2, tmp$ret$9);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_516 {}
class $serializer_440 {
  constructor() {
    $serializer_instance_436 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Authenticated', this, 1);
    tmp0_serialDesc.h1b('configuration', false);
    this.f6j_1 = tmp0_serialDesc;
  }
  g6j(encoder, value) {
    var tmp0_desc = this.f6j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_437(), value.h6j_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g6j(encoder, value instanceof Authenticated ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f6j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_437(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_437(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return Authenticated.i6j(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.f6j_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_437()];
  }
}
class BeastSessionState {}
class Authenticated {
  constructor(configuration) {
    this.h6j_1 = configuration;
  }
  toString() {
    return 'Authenticated(configuration=' + this.h6j_1.toString() + ')';
  }
  hashCode() {
    return this.h6j_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Authenticated))
      return false;
    if (!this.h6j_1.equals(other.h6j_1))
      return false;
    return true;
  }
  static i6j(seen0, configuration, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_436().f6j_1);
    }
    var $this = createThis(this);
    $this.h6j_1 = configuration;
    return $this;
  }
}
class Unauthenticated {
  constructor() {
    Unauthenticated_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j6j_1 = lazy(tmp_0, BeastSessionState$Unauthenticated$_anonymous__sb6uph);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_548(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Unauthenticated';
  }
  hashCode() {
    return -166882339;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Unauthenticated))
      return false;
    return true;
  }
}
class Companion_517 {
  a2g() {
    var tmp = getKClass(BeastSessionState);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Authenticated), getKClass(Unauthenticated)];
    var tmp_1 = $serializer_getInstance_436();
    var tmp_2 = Unauthenticated_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_3 = [tmp_1, ObjectSerializer.l1c('Unauthenticated', tmp_2, tmp$ret$3)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    return SealedClassSerializer.i10('steelart.beast.network.BeastSessionState', tmp, tmp_0, tmp_3, tmp$ret$9);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_518 {
  constructor() {
    Companion_instance_518 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, BeastClientConfiguration$Companion$$childSerializers$_anonymous__q7dzvm);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k6j_1 = [null, tmp_1, lazy(tmp_2, BeastClientConfiguration$Companion$$childSerializers$_anonymous__q7dzvm_0), null, null, null];
  }
}
class $serializer_441 {
  constructor() {
    $serializer_instance_437 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.BeastClientConfiguration', this, 6);
    tmp0_serialDesc.h1b('user', false);
    tmp0_serialDesc.h1b('availableFeatures', false);
    tmp0_serialDesc.h1b('allowedExpansions', true);
    tmp0_serialDesc.h1b('recordingGameModeAvailable', true);
    tmp0_serialDesc.h1b('isGuest', true);
    tmp0_serialDesc.h1b('enableRecoveryTestContent', true);
    this.l6j_1 = tmp0_serialDesc;
  }
  m6j(encoder, value) {
    var tmp0_desc = this.l6j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_519().k6j_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_438(), value.n6j_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.o6j_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !equals(value.p6j_1, toSet(get_entries_0()))) {
      tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.p6j_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.q6j_1 === true)) {
      tmp1_output.w14(tmp0_desc, 3, value.q6j_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.r6j_1 === false)) {
      tmp1_output.w14(tmp0_desc, 4, value.r6j_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !(value.s6j_1 === false)) {
      tmp1_output.w14(tmp0_desc, 5, value.s6j_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m6j(encoder, value instanceof BeastClientConfiguration ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l6j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_input = decoder.p13(tmp0_desc);
    var tmp11_cached = Companion_getInstance_519().k6j_1;
    if (tmp10_input.e14()) {
      tmp4_local0 = tmp10_input.b14(tmp0_desc, 0, $serializer_getInstance_438(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.b14(tmp0_desc, 1, tmp11_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.b14(tmp0_desc, 2, tmp11_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.r13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.r13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.r13(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.b14(tmp0_desc, 0, $serializer_getInstance_438(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.b14(tmp0_desc, 1, tmp11_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.b14(tmp0_desc, 2, tmp11_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.r13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.r13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.r13(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp10_input.q13(tmp0_desc);
    return BeastClientConfiguration.t6j(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  dz() {
    return this.l6j_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_519().k6j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_438(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class BeastClientConfiguration {
  constructor(user, availableFeatures, allowedExpansions, recordingGameModeAvailable, isGuest, enableRecoveryTestContent) {
    Companion_getInstance_519();
    allowedExpansions = allowedExpansions === VOID ? toSet(get_entries_0()) : allowedExpansions;
    recordingGameModeAvailable = recordingGameModeAvailable === VOID ? true : recordingGameModeAvailable;
    isGuest = isGuest === VOID ? false : isGuest;
    enableRecoveryTestContent = enableRecoveryTestContent === VOID ? false : enableRecoveryTestContent;
    this.n6j_1 = user;
    this.o6j_1 = availableFeatures;
    this.p6j_1 = allowedExpansions;
    this.q6j_1 = recordingGameModeAvailable;
    this.r6j_1 = isGuest;
    this.s6j_1 = enableRecoveryTestContent;
  }
  toString() {
    return 'BeastClientConfiguration(user=' + this.n6j_1.toString() + ', availableFeatures=' + toString(this.o6j_1) + ', allowedExpansions=' + toString(this.p6j_1) + ', recordingGameModeAvailable=' + this.q6j_1 + ', isGuest=' + this.r6j_1 + ', enableRecoveryTestContent=' + this.s6j_1 + ')';
  }
  hashCode() {
    var result = this.n6j_1.hashCode();
    result = imul(result, 31) + hashCode(this.o6j_1) | 0;
    result = imul(result, 31) + hashCode(this.p6j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q6j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r6j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s6j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastClientConfiguration))
      return false;
    if (!this.n6j_1.equals(other.n6j_1))
      return false;
    if (!equals(this.o6j_1, other.o6j_1))
      return false;
    if (!equals(this.p6j_1, other.p6j_1))
      return false;
    if (!(this.q6j_1 === other.q6j_1))
      return false;
    if (!(this.r6j_1 === other.r6j_1))
      return false;
    if (!(this.s6j_1 === other.s6j_1))
      return false;
    return true;
  }
  static t6j(seen0, user, availableFeatures, allowedExpansions, recordingGameModeAvailable, isGuest, enableRecoveryTestContent, serializationConstructorMarker) {
    Companion_getInstance_519();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_437().l6j_1);
    }
    var $this = createThis(this);
    $this.n6j_1 = user;
    $this.o6j_1 = availableFeatures;
    if (0 === (seen0 & 4))
      $this.p6j_1 = toSet(get_entries_0());
    else
      $this.p6j_1 = allowedExpansions;
    if (0 === (seen0 & 8))
      $this.q6j_1 = true;
    else
      $this.q6j_1 = recordingGameModeAvailable;
    if (0 === (seen0 & 16))
      $this.r6j_1 = false;
    else
      $this.r6j_1 = isGuest;
    if (0 === (seen0 & 32))
      $this.s6j_1 = false;
    else
      $this.s6j_1 = enableRecoveryTestContent;
    return $this;
  }
}
class Companion_519 {}
class $serializer_442 {
  constructor() {
    $serializer_instance_438 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.BeastClientUser', this, 2);
    tmp0_serialDesc.h1b('displayName', false);
    tmp0_serialDesc.h1b('avatarUrl', false);
    this.u6j_1 = tmp0_serialDesc;
  }
  v6j(encoder, value) {
    var tmp0_desc = this.u6j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.w6j_1);
    tmp1_output.i15(tmp0_desc, 1, StringSerializer_getInstance(), value.x6j_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v6j(encoder, value instanceof BeastClientUser ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u6j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BeastClientUser.y6j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.u6j_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  }
}
class BeastClientUser {
  constructor(displayName, avatarUrl) {
    this.w6j_1 = displayName;
    this.x6j_1 = avatarUrl;
  }
  toString() {
    return 'BeastClientUser(displayName=' + this.w6j_1 + ', avatarUrl=' + this.x6j_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.w6j_1);
    result = imul(result, 31) + (this.x6j_1 == null ? 0 : getStringHashCode(this.x6j_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastClientUser))
      return false;
    if (!(this.w6j_1 === other.w6j_1))
      return false;
    if (!(this.x6j_1 == other.x6j_1))
      return false;
    return true;
  }
  static y6j(seen0, displayName, avatarUrl, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_438().u6j_1);
    }
    var $this = createThis(this);
    $this.w6j_1 = displayName;
    $this.x6j_1 = avatarUrl;
    return $this;
  }
}
class Companion_520 {}
class $serializer_443 {
  constructor() {
    $serializer_instance_439 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ClientLinks', this, 5);
    tmp0_serialDesc.h1b('beastEditionUrl', true);
    tmp0_serialDesc.h1b('versionUrl', true);
    tmp0_serialDesc.h1b('termOfUseUrl', true);
    tmp0_serialDesc.h1b('beastUniverseDiscordUrl', true);
    tmp0_serialDesc.h1b('bggThreadUrl', true);
    this.z6j_1 = tmp0_serialDesc;
  }
  a6k(encoder, value) {
    var tmp0_desc = this.z6j_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.b6k_1 == null)) {
      tmp1_output.i15(tmp0_desc, 0, StringSerializer_getInstance(), value.b6k_1);
    }
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.c6k_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, StringSerializer_getInstance(), value.c6k_1);
    }
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.d6k_1 == null)) {
      tmp1_output.i15(tmp0_desc, 2, StringSerializer_getInstance(), value.d6k_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.e6k_1 == null)) {
      tmp1_output.i15(tmp0_desc, 3, StringSerializer_getInstance(), value.e6k_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.f6k_1 == null)) {
      tmp1_output.i15(tmp0_desc, 4, StringSerializer_getInstance(), value.f6k_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a6k(encoder, value instanceof ClientLinks ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z6j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.d14(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.d14(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.d14(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.d14(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.d14(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.d14(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.d14(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.d14(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.d14(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.d14(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return ClientLinks.g6k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.z6j_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  }
}
class ClientLinks {
  constructor(beastEditionUrl, versionUrl, termOfUseUrl, beastUniverseDiscordUrl, bggThreadUrl) {
    beastEditionUrl = beastEditionUrl === VOID ? null : beastEditionUrl;
    versionUrl = versionUrl === VOID ? null : versionUrl;
    termOfUseUrl = termOfUseUrl === VOID ? null : termOfUseUrl;
    beastUniverseDiscordUrl = beastUniverseDiscordUrl === VOID ? null : beastUniverseDiscordUrl;
    bggThreadUrl = bggThreadUrl === VOID ? null : bggThreadUrl;
    this.b6k_1 = beastEditionUrl;
    this.c6k_1 = versionUrl;
    this.d6k_1 = termOfUseUrl;
    this.e6k_1 = beastUniverseDiscordUrl;
    this.f6k_1 = bggThreadUrl;
  }
  toString() {
    return 'ClientLinks(beastEditionUrl=' + this.b6k_1 + ', versionUrl=' + this.c6k_1 + ', termOfUseUrl=' + this.d6k_1 + ', beastUniverseDiscordUrl=' + this.e6k_1 + ', bggThreadUrl=' + this.f6k_1 + ')';
  }
  hashCode() {
    var result = this.b6k_1 == null ? 0 : getStringHashCode(this.b6k_1);
    result = imul(result, 31) + (this.c6k_1 == null ? 0 : getStringHashCode(this.c6k_1)) | 0;
    result = imul(result, 31) + (this.d6k_1 == null ? 0 : getStringHashCode(this.d6k_1)) | 0;
    result = imul(result, 31) + (this.e6k_1 == null ? 0 : getStringHashCode(this.e6k_1)) | 0;
    result = imul(result, 31) + (this.f6k_1 == null ? 0 : getStringHashCode(this.f6k_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClientLinks))
      return false;
    if (!(this.b6k_1 == other.b6k_1))
      return false;
    if (!(this.c6k_1 == other.c6k_1))
      return false;
    if (!(this.d6k_1 == other.d6k_1))
      return false;
    if (!(this.e6k_1 == other.e6k_1))
      return false;
    if (!(this.f6k_1 == other.f6k_1))
      return false;
    return true;
  }
  static g6k(seen0, beastEditionUrl, versionUrl, termOfUseUrl, beastUniverseDiscordUrl, bggThreadUrl, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_439().z6j_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.b6k_1 = null;
    else
      $this.b6k_1 = beastEditionUrl;
    if (0 === (seen0 & 2))
      $this.c6k_1 = null;
    else
      $this.c6k_1 = versionUrl;
    if (0 === (seen0 & 4))
      $this.d6k_1 = null;
    else
      $this.d6k_1 = termOfUseUrl;
    if (0 === (seen0 & 8))
      $this.e6k_1 = null;
    else
      $this.e6k_1 = beastUniverseDiscordUrl;
    if (0 === (seen0 & 16))
      $this.f6k_1 = null;
    else
      $this.f6k_1 = bggThreadUrl;
    return $this;
  }
}
class Companion_521 {}
class $serializer_444 {
  constructor() {
    $serializer_instance_440 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.InfoSourceCursor', this, 2);
    tmp0_serialDesc.h1b('messageId', false);
    tmp0_serialDesc.h1b('internalIndex', false);
    this.h6k_1 = tmp0_serialDesc;
  }
  i6k(encoder, value) {
    var tmp0_desc = this.h6k_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.a15(tmp0_desc, 0, value.j6k_1);
    tmp1_output.z14(tmp0_desc, 1, value.k6k_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i6k(encoder, value instanceof InfoSourceCursor ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h6k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return InfoSourceCursor.l6k(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.h6k_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class InfoSourceCursor {
  constructor(messageId, internalIndex) {
    this.j6k_1 = messageId;
    this.k6k_1 = internalIndex;
  }
  toString() {
    return 'InfoSourceCursor(messageId=' + this.j6k_1.toString() + ', internalIndex=' + this.k6k_1 + ')';
  }
  hashCode() {
    var result = this.j6k_1.hashCode();
    result = imul(result, 31) + this.k6k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InfoSourceCursor))
      return false;
    if (!equalsLong(this.j6k_1, other.j6k_1))
      return false;
    if (!(this.k6k_1 === other.k6k_1))
      return false;
    return true;
  }
  static l6k(seen0, messageId, internalIndex, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_440().h6k_1);
    }
    var $this = createThis(this);
    $this.j6k_1 = messageId;
    $this.k6k_1 = internalIndex;
    return $this;
  }
}
class Companion_522 {}
class $serializer_445 {
  constructor() {
    $serializer_instance_441 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.GameCode', this, 1);
    tmp0_serialDesc.h1b('code', false);
    this.m6k_1 = tmp0_serialDesc;
  }
  n6k(encoder, value) {
    var tmp0_desc = this.m6k_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.o6k_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n6k(encoder, value instanceof GameCode ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m6k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GameCode.p6k(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m6k_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class GameCode {
  constructor(code) {
    this.o6k_1 = code;
  }
  toString() {
    return 'GameCode(code=' + this.o6k_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.o6k_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameCode))
      return false;
    if (!(this.o6k_1 === other.o6k_1))
      return false;
    return true;
  }
  static p6k(seen0, code, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_441().m6k_1);
    }
    var $this = createThis(this);
    $this.o6k_1 = code;
    return $this;
  }
}
class ServerDrivenConfiguration {}
function reconnectGame$default(gameCode, gameTeam, lastSeenInfoSourceCursor, $completion, $super) {
  lastSeenInfoSourceCursor = lastSeenInfoSourceCursor === VOID ? null : lastSeenInfoSourceCursor;
  return $super === VOID ? this.f6l(gameCode, gameTeam, lastSeenInfoSourceCursor, $completion) : $super.f6l.call(this, gameCode, new GameTeam(gameTeam), lastSeenInfoSourceCursor, $completion);
}
function processClient$default(goingBeastGame, onReloadRequired, $completion, $super) {
  onReloadRequired = onReloadRequired === VOID ? null : onReloadRequired;
  return $super === VOID ? this.u6l(goingBeastGame, onReloadRequired, $completion) : $super.u6l.call(this, goingBeastGame, onReloadRequired, $completion);
}
function *requestGamePresence($completion) {
  return null;
}
class RevertResult {
  constructor(revertChanges, previousRevision, previousCheckCode, currentReplayElement, previousToReverted, currentRevertQuestion, mayNothingInRevertQuestion, previousQuestionData, previousGameStateEvent) {
    this.b6i_1 = revertChanges;
    this.c6i_1 = previousRevision;
    this.d6i_1 = previousCheckCode;
    this.e6i_1 = currentReplayElement;
    this.f6i_1 = previousToReverted;
    this.g6i_1 = currentRevertQuestion;
    this.h6i_1 = mayNothingInRevertQuestion;
    this.i6i_1 = previousQuestionData;
    this.j6i_1 = previousGameStateEvent;
  }
}
class ConnectionStatus extends Enum {}
class Companion_523 {
  constructor() {
    Companion_instance_523 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d6m_1 = [lazy(tmp_0, ActiveGameSessions$Companion$$childSerializers$_anonymous__d8uq1h)];
  }
}
class $serializer_446 {
  constructor() {
    $serializer_instance_442 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ActiveGameSessions', this, 1);
    tmp0_serialDesc.h1b('activeDuelSessionGames', false);
    this.e6m_1 = tmp0_serialDesc;
  }
  f6m(encoder, value) {
    var tmp0_desc = this.e6m_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_524().d6m_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.g6m_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f6m(encoder, value instanceof ActiveGameSessions ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e6m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_524().d6m_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ActiveGameSessions.h6m(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e6m_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_524().d6m_1[0].k3()];
  }
}
class ActiveGameSessions {
  constructor(activeDuelSessionGames) {
    Companion_getInstance_524();
    this.g6m_1 = activeDuelSessionGames;
  }
  toString() {
    return 'ActiveGameSessions(activeDuelSessionGames=' + toString(this.g6m_1) + ')';
  }
  hashCode() {
    return hashCode(this.g6m_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ActiveGameSessions))
      return false;
    if (!equals(this.g6m_1, other.g6m_1))
      return false;
    return true;
  }
  static h6m(seen0, activeDuelSessionGames, serializationConstructorMarker) {
    Companion_getInstance_524();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_442().e6m_1);
    }
    var $this = createThis(this);
    $this.g6m_1 = activeDuelSessionGames;
    return $this;
  }
}
class Companion_524 {
  constructor() {
    Companion_instance_524 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i6m_1 = [lazy(tmp_0, LobbyList$Companion$$childSerializers$_anonymous__tx2q52)];
  }
}
class $serializer_447 {
  constructor() {
    $serializer_instance_443 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.LobbyList', this, 1);
    tmp0_serialDesc.h1b('lobbies', false);
    this.j6m_1 = tmp0_serialDesc;
  }
  k6m(encoder, value) {
    var tmp0_desc = this.j6m_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_525().i6m_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.l6m_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k6m(encoder, value instanceof LobbyList ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j6m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_525().i6m_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return LobbyList.m6m(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.j6m_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_525().i6m_1[0].k3()];
  }
}
class LobbyList {
  constructor(lobbies) {
    Companion_getInstance_525();
    this.l6m_1 = lobbies;
  }
  toString() {
    return 'LobbyList(lobbies=' + toString(this.l6m_1) + ')';
  }
  hashCode() {
    return hashCode(this.l6m_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LobbyList))
      return false;
    if (!equals(this.l6m_1, other.l6m_1))
      return false;
    return true;
  }
  static m6m(seen0, lobbies, serializationConstructorMarker) {
    Companion_getInstance_525();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_443().j6m_1);
    }
    var $this = createThis(this);
    $this.l6m_1 = lobbies;
    return $this;
  }
}
class Companion_525 {}
class $serializer_448 {
  constructor() {
    $serializer_instance_444 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Resumed', this, 2);
    tmp0_serialDesc.h1b('setup', false);
    tmp0_serialDesc.h1b('acceptedInfoSourceCursor', false);
    this.n6m_1 = tmp0_serialDesc;
  }
  o6m(encoder, value) {
    var tmp0_desc = this.n6m_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_459(), value.p6m_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_440(), value.q6m_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o6m(encoder, value instanceof Resumed ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n6m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_459(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_440(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_459(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_440(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return Resumed.r6m(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.n6m_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_459(), $serializer_getInstance_440()];
  }
}
class Companion_526 {
  constructor() {
    Companion_instance_526 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s6m_1 = [lazy(tmp_0, ResumeDuelGameResult$Terminal$Companion$$childSerializers$_anonymous__9wvq82)];
  }
}
class $serializer_449 {
  constructor() {
    $serializer_instance_445 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Terminal', this, 1);
    tmp0_serialDesc.h1b('status', false);
    this.t6m_1 = tmp0_serialDesc;
  }
  u6m(encoder, value) {
    var tmp0_desc = this.t6m_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_527().s6m_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.v6m_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u6m(encoder, value instanceof Terminal ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t6m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_527().s6m_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return Terminal.w6m(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.t6m_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_527().s6m_1[0].k3()];
  }
}
class ResumeDuelGameResult {}
class Resumed {
  constructor(setup, acceptedInfoSourceCursor) {
    this.p6m_1 = setup;
    this.q6m_1 = acceptedInfoSourceCursor;
  }
  toString() {
    return 'Resumed(setup=' + this.p6m_1.toString() + ', acceptedInfoSourceCursor=' + this.q6m_1.toString() + ')';
  }
  hashCode() {
    var result = this.p6m_1.hashCode();
    result = imul(result, 31) + this.q6m_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Resumed))
      return false;
    if (!this.p6m_1.equals(other.p6m_1))
      return false;
    if (!this.q6m_1.equals(other.q6m_1))
      return false;
    return true;
  }
  static r6m(seen0, setup, acceptedInfoSourceCursor, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_444().n6m_1);
    }
    var $this = createThis(this);
    $this.p6m_1 = setup;
    $this.q6m_1 = acceptedInfoSourceCursor;
    return $this;
  }
}
class Terminal {
  constructor(status) {
    Companion_getInstance_527();
    this.v6m_1 = status;
  }
  toString() {
    return 'Terminal(status=' + this.v6m_1.toString() + ')';
  }
  hashCode() {
    return this.v6m_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Terminal))
      return false;
    if (!this.v6m_1.equals(other.v6m_1))
      return false;
    return true;
  }
  static w6m(seen0, status, serializationConstructorMarker) {
    Companion_getInstance_527();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_445().t6m_1);
    }
    var $this = createThis(this);
    $this.v6m_1 = status;
    return $this;
  }
}
class NotFound {
  constructor() {
    NotFound_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x6m_1 = lazy(tmp_0, ResumeDuelGameResult$NotFound$_anonymous__52vl4o);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_549(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NotFound';
  }
  hashCode() {
    return 1548585604;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NotFound))
      return false;
    return true;
  }
}
class Forbidden {
  constructor() {
    Forbidden_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y6m_1 = lazy(tmp_0, ResumeDuelGameResult$Forbidden$_anonymous__k4xeby);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_550(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Forbidden';
  }
  hashCode() {
    return 1356799108;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Forbidden))
      return false;
    return true;
  }
}
class Companion_527 {
  a2g() {
    var tmp = getKClass(ResumeDuelGameResult);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Forbidden), getKClass(NotFound), getKClass(Resumed), getKClass(Terminal)];
    var tmp_1 = Forbidden_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('Forbidden', tmp_1, tmp$ret$3);
    var tmp_3 = NotFound_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_4 = [tmp_2, ObjectSerializer.l1c('NotFound', tmp_3, tmp$ret$6), $serializer_getInstance_444(), $serializer_getInstance_445()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    return SealedClassSerializer.i10('steelart.beast.network.ResumeDuelGameResult', tmp, tmp_0, tmp_4, tmp$ret$12);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_528 {
  constructor() {
    Companion_instance_528 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, CompletedGame$Companion$$childSerializers$_anonymous__365cb1);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, CompletedGame$Companion$$childSerializers$_anonymous__365cb1_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z6m_1 = [null, null, tmp_1, null, tmp_3, null, lazy(tmp_4, CompletedGame$Companion$$childSerializers$_anonymous__365cb1_1)];
  }
}
class $serializer_450 {
  constructor() {
    $serializer_instance_446 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.CompletedGame', this, 7);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('gameName', false);
    tmp0_serialDesc.h1b('gameStatus', false);
    tmp0_serialDesc.h1b('epochSeconds', false);
    tmp0_serialDesc.h1b('rules', false);
    tmp0_serialDesc.h1b('canShareReplay', false);
    tmp0_serialDesc.h1b('characters', true);
    this.a6n_1 = tmp0_serialDesc;
  }
  b6n(encoder, value) {
    var tmp0_desc = this.a6n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_529().z6m_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_441(), value.c6n_1);
    tmp1_output.e15(tmp0_desc, 1, value.d6n_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.e6n_1);
    tmp1_output.a15(tmp0_desc, 3, value.f6n_1);
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.g6n_1);
    tmp1_output.w14(tmp0_desc, 5, value.h6n_1);
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !equals(value.i6n_1, emptyList())) {
      tmp1_output.g15(tmp0_desc, 6, tmp2_cached[6].k3(), value.i6n_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b6n(encoder, value instanceof CompletedGame ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a6n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = null;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_input = decoder.p13(tmp0_desc);
    var tmp12_cached = Companion_getInstance_529().z6m_1;
    if (tmp11_input.e14()) {
      tmp4_local0 = tmp11_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.b14(tmp0_desc, 2, tmp12_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.b14(tmp0_desc, 4, tmp12_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.r13(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.b14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.b14(tmp0_desc, 2, tmp12_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.b14(tmp0_desc, 4, tmp12_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.r13(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.b14(tmp0_desc, 6, tmp12_cached[6].k3(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp11_input.q13(tmp0_desc);
    return CompletedGame.j6n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  dz() {
    return this.a6n_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_529().z6m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_441(), StringSerializer_getInstance(), tmp0_cached[2].k3(), LongSerializer_getInstance(), tmp0_cached[4].k3(), BooleanSerializer_getInstance(), tmp0_cached[6].k3()];
  }
}
class CompletedGame {
  constructor(gameCode, gameName, gameStatus, epochSeconds, rules, canShareReplay, characters) {
    Companion_getInstance_529();
    characters = characters === VOID ? emptyList() : characters;
    this.c6n_1 = gameCode;
    this.d6n_1 = gameName;
    this.e6n_1 = gameStatus;
    this.f6n_1 = epochSeconds;
    this.g6n_1 = rules;
    this.h6n_1 = canShareReplay;
    this.i6n_1 = characters;
  }
  k6n() {
    return !equalsLong(this.f6n_1, new Long(0, 0)) ? Companion_getInstance().jv(this.f6n_1) : null;
  }
  toString() {
    return 'CompletedGame(gameCode=' + this.c6n_1.toString() + ', gameName=' + this.d6n_1 + ', gameStatus=' + this.e6n_1.toString() + ', epochSeconds=' + this.f6n_1.toString() + ', rules=' + toString(this.g6n_1) + ', canShareReplay=' + this.h6n_1 + ', characters=' + toString(this.i6n_1) + ')';
  }
  hashCode() {
    var result = this.c6n_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.d6n_1) | 0;
    result = imul(result, 31) + this.e6n_1.hashCode() | 0;
    result = imul(result, 31) + this.f6n_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.g6n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h6n_1) | 0;
    result = imul(result, 31) + hashCode(this.i6n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedGame))
      return false;
    if (!this.c6n_1.equals(other.c6n_1))
      return false;
    if (!(this.d6n_1 === other.d6n_1))
      return false;
    if (!this.e6n_1.equals(other.e6n_1))
      return false;
    if (!equalsLong(this.f6n_1, other.f6n_1))
      return false;
    if (!equals(this.g6n_1, other.g6n_1))
      return false;
    if (!(this.h6n_1 === other.h6n_1))
      return false;
    if (!equals(this.i6n_1, other.i6n_1))
      return false;
    return true;
  }
  static j6n(seen0, gameCode, gameName, gameStatus, epochSeconds, rules, canShareReplay, characters, serializationConstructorMarker) {
    Companion_getInstance_529();
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_446().a6n_1);
    }
    var $this = createThis(this);
    $this.c6n_1 = gameCode;
    $this.d6n_1 = gameName;
    $this.e6n_1 = gameStatus;
    $this.f6n_1 = epochSeconds;
    $this.g6n_1 = rules;
    $this.h6n_1 = canShareReplay;
    if (0 === (seen0 & 64))
      $this.i6n_1 = emptyList();
    else
      $this.i6n_1 = characters;
    return $this;
  }
}
class Companion_529 {}
class $serializer_451 {
  constructor() {
    $serializer_instance_447 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.RetainedResourceHandoff', this, 1);
    tmp0_serialDesc.h1b('clientUrl', false);
    this.l6n_1 = tmp0_serialDesc;
  }
  m6n(encoder, value) {
    var tmp0_desc = this.l6n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.n6n_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m6n(encoder, value instanceof RetainedResourceHandoff ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l6n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RetainedResourceHandoff.o6n(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.l6n_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class RetainedResourceHandoff {
  constructor(clientUrl) {
    this.n6n_1 = clientUrl;
  }
  toString() {
    return 'RetainedResourceHandoff(clientUrl=' + this.n6n_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.n6n_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RetainedResourceHandoff))
      return false;
    if (!(this.n6n_1 === other.n6n_1))
      return false;
    return true;
  }
  static o6n(seen0, clientUrl, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_447().l6n_1);
    }
    var $this = createThis(this);
    $this.n6n_1 = clientUrl;
    return $this;
  }
}
class Companion_530 {
  constructor() {
    Companion_instance_530 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q6n_1 = [lazy(tmp_0, BeastResourceLookupRequest$Companion$$childSerializers$_anonymous__lswh6q), null, null, null];
  }
}
class $serializer_452 {
  constructor() {
    $serializer_instance_448 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.BeastResourceLookupRequest', this, 4);
    tmp0_serialDesc.h1b('kind', false);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('isSandboxGame', true);
    tmp0_serialDesc.h1b('gameTeam', true);
    this.r6n_1 = tmp0_serialDesc;
  }
  s6n(encoder, value) {
    var tmp0_desc = this.r6n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_531().q6n_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.t6n_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_441(), value.u6n_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.v6n_1 === false)) {
      tmp1_output.w14(tmp0_desc, 2, value.v6n_1);
    }
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 3)) {
      tmp = true;
    } else {
      var tmp_0 = value.w6n_1;
      tmp = !((tmp_0 == null ? null : new GameTeam(tmp_0)) == null);
    }
    if (tmp) {
      var tmp_1 = $serializer_getInstance_183();
      var tmp_2 = value.w6n_1;
      tmp1_output.i15(tmp0_desc, 3, tmp_1, tmp_2 == null ? null : new GameTeam(tmp_2));
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s6n(encoder, value instanceof BeastResourceLookupRequest ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r6n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_531().q6n_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, $serializer_getInstance_441(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp7_local3;
      var tmp_1 = tmp8_input.d14(tmp0_desc, 3, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp7_local3 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b14(tmp0_desc, 0, tmp9_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, $serializer_getInstance_441(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp7_local3;
            var tmp_4 = tmp8_input.d14(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp7_local3 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return BeastResourceLookupRequest.x6n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.r6n_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_531().q6n_1[0].k3(), $serializer_getInstance_441(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_183())];
  }
}
class BeastResourceLookupRequest {
  constructor(kind, gameCode, isSandboxGame, gameTeam) {
    Companion_getInstance_531();
    isSandboxGame = isSandboxGame === VOID ? false : isSandboxGame;
    gameTeam = gameTeam === VOID ? null : gameTeam;
    this.t6n_1 = kind;
    this.u6n_1 = gameCode;
    this.v6n_1 = isSandboxGame;
    this.w6n_1 = gameTeam;
    var tmp;
    if (this.t6n_1.equals(BeastResourceKind_Game_getInstance())) {
      tmp = true;
    } else {
      var tmp_0 = this.w6n_1;
      tmp = (tmp_0 == null ? null : new GameTeam(tmp_0)) == null;
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      var message = 'A game team may only be supplied when opening an active game';
      throw IllegalArgumentException.h2(toString(message));
    }
    var tmp_1;
    if (this.v6n_1 || this.t6n_1.equals(BeastResourceKind_Replay_getInstance())) {
      tmp_1 = true;
    } else {
      var tmp_2 = this.w6n_1;
      tmp_1 = !((tmp_2 == null ? null : new GameTeam(tmp_2)) == null);
    }
    // Inline function 'kotlin.require' call
    if (!tmp_1) {
      var message_0 = 'A duel game handoff requires a game team';
      throw IllegalArgumentException.h2(toString(message_0));
    }
  }
  toString() {
    var tmp = this.t6n_1.toString();
    var tmp_0 = this.u6n_1.toString();
    var tmp_1 = this.w6n_1;
    return 'BeastResourceLookupRequest(kind=' + tmp + ', gameCode=' + tmp_0 + ', isSandboxGame=' + this.v6n_1 + ', gameTeam=' + toString_0(tmp_1 == null ? null : new GameTeam(tmp_1)) + ')';
  }
  hashCode() {
    var result = this.t6n_1.hashCode();
    result = imul(result, 31) + this.u6n_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v6n_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.w6n_1;
    if ((tmp_1 == null ? null : new GameTeam(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = GameTeam__hashCode_impl_gu24w3(this.w6n_1);
    }
    result = tmp + tmp_0 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastResourceLookupRequest))
      return false;
    if (!this.t6n_1.equals(other.t6n_1))
      return false;
    if (!this.u6n_1.equals(other.u6n_1))
      return false;
    if (!(this.v6n_1 === other.v6n_1))
      return false;
    var tmp = this.w6n_1;
    var tmp_0 = tmp == null ? null : new GameTeam(tmp);
    var tmp_1 = other.w6n_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new GameTeam(tmp_1)))
      return false;
    return true;
  }
  static x6n(seen0, kind, gameCode, isSandboxGame, gameTeam, serializationConstructorMarker) {
    Companion_getInstance_531();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_448().r6n_1);
    }
    var $this = createThis(this);
    $this.t6n_1 = kind;
    $this.u6n_1 = gameCode;
    if (0 === (seen0 & 4))
      $this.v6n_1 = false;
    else
      $this.v6n_1 = isSandboxGame;
    if (0 === (seen0 & 8))
      $this.w6n_1 = null;
    else
      $this.w6n_1 = gameTeam;
    var tmp;
    if ($this.t6n_1.equals(BeastResourceKind_Game_getInstance())) {
      tmp = true;
    } else {
      var tmp_0 = $this.w6n_1;
      tmp = (tmp_0 == null ? null : new GameTeam(tmp_0)) == null;
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      var message = 'A game team may only be supplied when opening an active game';
      throw IllegalArgumentException.h2(toString(message));
    }
    var tmp_1;
    if ($this.v6n_1 || $this.t6n_1.equals(BeastResourceKind_Replay_getInstance())) {
      tmp_1 = true;
    } else {
      var tmp_2 = $this.w6n_1;
      tmp_1 = !((tmp_2 == null ? null : new GameTeam(tmp_2)) == null);
    }
    // Inline function 'kotlin.require' call
    if (!tmp_1) {
      var message_0 = 'A duel game handoff requires a game team';
      throw IllegalArgumentException.h2(toString(message_0));
    }
    return $this;
  }
}
class Companion_531 {
  constructor() {
    Companion_instance_531 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y6n_1 = lazy(tmp_0, ReplaySharingStatus$Companion$_anonymous__flthvs);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_551(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class ReplaySharingStatus extends Enum {}
class Companion_532 {}
class $serializer_453 {
  constructor() {
    $serializer_instance_449 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.PendingReplayConsent', this, 2);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('gameName', false);
    this.z6n_1 = tmp0_serialDesc;
  }
  a6o(encoder, value) {
    var tmp0_desc = this.z6n_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_441(), value.b6o_1);
    tmp1_output.e15(tmp0_desc, 1, value.c6o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.a6o(encoder, value instanceof PendingReplayConsent ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.z6n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PendingReplayConsent.d6o(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.z6n_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_441(), StringSerializer_getInstance()];
  }
}
class PendingReplayConsent {
  constructor(gameCode, gameName) {
    this.b6o_1 = gameCode;
    this.c6o_1 = gameName;
  }
  toString() {
    return 'PendingReplayConsent(gameCode=' + this.b6o_1.toString() + ', gameName=' + this.c6o_1 + ')';
  }
  hashCode() {
    var result = this.b6o_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.c6o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PendingReplayConsent))
      return false;
    if (!this.b6o_1.equals(other.b6o_1))
      return false;
    if (!(this.c6o_1 === other.c6o_1))
      return false;
    return true;
  }
  static d6o(seen0, gameCode, gameName, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_449().z6n_1);
    }
    var $this = createThis(this);
    $this.b6o_1 = gameCode;
    $this.c6o_1 = gameName;
    return $this;
  }
}
class Companion_533 {}
class $serializer_454 {
  constructor() {
    $serializer_instance_450 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ReconnectSandboxInit', this, 3);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('currentGameState', false);
    tmp0_serialDesc.h1b('numberOfAppliedEvents', false);
    this.h6o_1 = tmp0_serialDesc;
  }
  i6o(encoder, value) {
    var tmp0_desc = this.h6o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_441(), value.j6o_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_200(), value.k6o_1);
    tmp1_output.z14(tmp0_desc, 2, value.l6o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i6o(encoder, value instanceof ReconnectSandboxInit ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h6o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.p13(tmp0_desc);
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, $serializer_getInstance_200(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, $serializer_getInstance_200(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.u13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return ReconnectSandboxInit.m6o(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.h6o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_441(), $serializer_getInstance_200(), IntSerializer_getInstance()];
  }
}
class Companion_534 {
  constructor() {
    Companion_instance_534 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n6o_1 = [lazy(tmp_0, ReconnectSandboxResult$ReconnectSandboxPlaying$Companion$$childSerializers$_anonymous__1ew57h)];
  }
}
class $serializer_455 {
  constructor() {
    $serializer_instance_451 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ReconnectSandboxPlaying', this, 1);
    tmp0_serialDesc.h1b('gameRules', false);
    this.o6o_1 = tmp0_serialDesc;
  }
  p6o(encoder, value) {
    var tmp0_desc = this.o6o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_535().n6o_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.q6o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.p6o(encoder, value instanceof ReconnectSandboxPlaying ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.o6o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_535().n6o_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return ReconnectSandboxPlaying.r6o(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.o6o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_535().n6o_1[0].k3()];
  }
}
class ReconnectSandboxResult {}
class PermissionError {
  constructor() {
    PermissionError_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e6o_1 = lazy(tmp_0, ReconnectSandboxResult$PermissionError$_anonymous__m59305);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_552(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PermissionError';
  }
  hashCode() {
    return 2101824221;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PermissionError))
      return false;
    return true;
  }
}
class SandboxGameWasNotFound {
  constructor() {
    SandboxGameWasNotFound_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f6o_1 = lazy(tmp_0, ReconnectSandboxResult$SandboxGameWasNotFound$_anonymous__h0cgxt);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_553(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SandboxGameWasNotFound';
  }
  hashCode() {
    return -1497660549;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxGameWasNotFound))
      return false;
    return true;
  }
}
class SandboxGameWasCanceled {
  constructor() {
    SandboxGameWasCanceled_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g6o_1 = lazy(tmp_0, ReconnectSandboxResult$SandboxGameWasCanceled$_anonymous__crvey1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_554(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SandboxGameWasCanceled';
  }
  hashCode() {
    return 1120812965;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxGameWasCanceled))
      return false;
    return true;
  }
}
class ReconnectSandboxInit {
  constructor(gameCode, currentGameState, numberOfAppliedEvents) {
    this.j6o_1 = gameCode;
    this.k6o_1 = currentGameState;
    this.l6o_1 = numberOfAppliedEvents;
  }
  toString() {
    return 'ReconnectSandboxInit(gameCode=' + this.j6o_1.toString() + ', currentGameState=' + this.k6o_1.toString() + ', numberOfAppliedEvents=' + this.l6o_1 + ')';
  }
  hashCode() {
    var result = this.j6o_1.hashCode();
    result = imul(result, 31) + this.k6o_1.hashCode() | 0;
    result = imul(result, 31) + this.l6o_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReconnectSandboxInit))
      return false;
    if (!this.j6o_1.equals(other.j6o_1))
      return false;
    if (!this.k6o_1.equals(other.k6o_1))
      return false;
    if (!(this.l6o_1 === other.l6o_1))
      return false;
    return true;
  }
  static m6o(seen0, gameCode, currentGameState, numberOfAppliedEvents, serializationConstructorMarker) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_450().h6o_1);
    }
    var $this = createThis(this);
    $this.j6o_1 = gameCode;
    $this.k6o_1 = currentGameState;
    $this.l6o_1 = numberOfAppliedEvents;
    return $this;
  }
}
class ReconnectSandboxPlaying {
  constructor(gameRules) {
    Companion_getInstance_535();
    this.q6o_1 = gameRules;
  }
  toString() {
    return 'ReconnectSandboxPlaying(gameRules=' + toString(this.q6o_1) + ')';
  }
  hashCode() {
    return hashCode(this.q6o_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReconnectSandboxPlaying))
      return false;
    if (!equals(this.q6o_1, other.q6o_1))
      return false;
    return true;
  }
  static r6o(seen0, gameRules, serializationConstructorMarker) {
    Companion_getInstance_535();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_451().o6o_1);
    }
    var $this = createThis(this);
    $this.q6o_1 = gameRules;
    return $this;
  }
}
class Companion_535 {
  a2g() {
    var tmp = getKClass(ReconnectSandboxResult);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(PermissionError), getKClass(ReconnectSandboxInit), getKClass(ReconnectSandboxPlaying), getKClass(SandboxGameWasCanceled), getKClass(SandboxGameWasNotFound)];
    var tmp_1 = PermissionError_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer.l1c('PermissionError', tmp_1, tmp$ret$3);
    var tmp_3 = $serializer_getInstance_450();
    var tmp_4 = $serializer_getInstance_451();
    var tmp_5 = SandboxGameWasCanceled_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_6 = ObjectSerializer.l1c('SandboxGameWasCanceled', tmp_5, tmp$ret$6);
    var tmp_7 = SandboxGameWasNotFound_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_8 = [tmp_2, tmp_3, tmp_4, tmp_6, ObjectSerializer.l1c('SandboxGameWasNotFound', tmp_7, tmp$ret$9)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    return SealedClassSerializer.i10('steelart.beast.network.ReconnectSandboxResult', tmp, tmp_0, tmp_8, tmp$ret$15);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_536 {}
class $serializer_456 {
  constructor() {
    $serializer_instance_452 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Duel', this, 2);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('gameTeam', false);
    this.s6o_1 = tmp0_serialDesc;
  }
  t6o(encoder, value) {
    var tmp0_desc = this.s6o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_441(), value.u6o_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_183(), new GameTeam(value.v6o_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t6o(encoder, value instanceof Duel ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s6o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return Duel.w6o(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.s6o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_441(), $serializer_getInstance_183()];
  }
}
class Companion_537 {}
class $serializer_457 {
  constructor() {
    $serializer_instance_453 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Sandbox', this, 1);
    tmp0_serialDesc.h1b('gameCode', false);
    this.x6o_1 = tmp0_serialDesc;
  }
  y6o(encoder, value) {
    var tmp0_desc = this.x6o_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_441(), value.z6o_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y6o(encoder, value instanceof Sandbox ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x6o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return Sandbox.a6p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x6o_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_441()];
  }
}
class Companion_538 {}
class $serializer_458 {
  constructor() {
    $serializer_instance_454 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Replay', this, 1);
    tmp0_serialDesc.h1b('gameCode', false);
    this.b6p_1 = tmp0_serialDesc;
  }
  c6p(encoder, value) {
    var tmp0_desc = this.b6p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_441(), value.d6p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c6p(encoder, value instanceof Replay ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b6p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return Replay.e6p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b6p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_441()];
  }
}
class Duel {
  constructor(gameCode, gameTeam) {
    this.u6o_1 = gameCode;
    this.v6o_1 = gameTeam;
  }
  toString() {
    return 'Duel(gameCode=' + this.u6o_1.toString() + ', gameTeam=' + GameTeam__toString_impl_wfw0a6(this.v6o_1) + ')';
  }
  hashCode() {
    var result = this.u6o_1.hashCode();
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.v6o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Duel))
      return false;
    if (!this.u6o_1.equals(other.u6o_1))
      return false;
    if (!(this.v6o_1 === other.v6o_1))
      return false;
    return true;
  }
  static w6o(seen0, gameCode, gameTeam, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_452().s6o_1);
    }
    var $this = createThis(this);
    $this.u6o_1 = gameCode;
    $this.v6o_1 = gameTeam;
    return $this;
  }
}
class Sandbox {
  constructor(gameCode) {
    this.z6o_1 = gameCode;
  }
  toString() {
    return 'Sandbox(gameCode=' + this.z6o_1.toString() + ')';
  }
  hashCode() {
    return this.z6o_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Sandbox))
      return false;
    if (!this.z6o_1.equals(other.z6o_1))
      return false;
    return true;
  }
  static a6p(seen0, gameCode, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_453().x6o_1);
    }
    var $this = createThis(this);
    $this.z6o_1 = gameCode;
    return $this;
  }
}
class Replay {
  constructor(gameCode) {
    this.d6p_1 = gameCode;
  }
  toString() {
    return 'Replay(gameCode=' + this.d6p_1.toString() + ')';
  }
  hashCode() {
    return this.d6p_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Replay))
      return false;
    if (!this.d6p_1.equals(other.d6p_1))
      return false;
    return true;
  }
  static e6p(seen0, gameCode, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_454().b6p_1);
    }
    var $this = createThis(this);
    $this.d6p_1 = gameCode;
    return $this;
  }
}
class Companion_539 {
  a2g() {
    var tmp = getKClass(PingElement);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(PingBoardPositionElement), getKClass(PingLocationTypeElement), getKClass(PingPlayableCardElement)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_460(), $serializer_getInstance_461(), $serializer_getInstance_462()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.network.PingElement', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class PingElement {}
class Companion_540 {
  constructor() {
    Companion_instance_540 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f6p_1 = [lazy(tmp_0, GamePresence$Companion$$childSerializers$_anonymous__vcuggz), null];
  }
}
class $serializer_459 {
  constructor() {
    $serializer_instance_455 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.GamePresence', this, 2);
    tmp0_serialDesc.h1b('clientsByTeam', false);
    tmp0_serialDesc.h1b('unboundObservers', true);
    this.g6p_1 = tmp0_serialDesc;
  }
  h6p(encoder, value) {
    var tmp0_desc = this.g6p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_541().f6p_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.i6p_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.j6p_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, IntSerializer_getInstance(), value.j6p_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h6p(encoder, value instanceof GamePresence ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g6p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_541().f6p_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.d14(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GamePresence.k6p(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.g6p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_541().f6p_1[0].k3(), get_nullable(IntSerializer_getInstance())];
  }
}
class GamePresence {
  constructor(clientsByTeam, unboundObservers) {
    Companion_getInstance_541();
    unboundObservers = unboundObservers === VOID ? null : unboundObservers;
    this.i6p_1 = clientsByTeam;
    this.j6p_1 = unboundObservers;
  }
  toString() {
    return 'GamePresence(clientsByTeam=' + toString(this.i6p_1) + ', unboundObservers=' + this.j6p_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.i6p_1);
    result = imul(result, 31) + (this.j6p_1 == null ? 0 : this.j6p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePresence))
      return false;
    if (!equals(this.i6p_1, other.i6p_1))
      return false;
    if (!(this.j6p_1 == other.j6p_1))
      return false;
    return true;
  }
  static k6p(seen0, clientsByTeam, unboundObservers, serializationConstructorMarker) {
    Companion_getInstance_541();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_455().g6p_1);
    }
    var $this = createThis(this);
    $this.i6p_1 = clientsByTeam;
    if (0 === (seen0 & 2))
      $this.j6p_1 = null;
    else
      $this.j6p_1 = unboundObservers;
    return $this;
  }
}
class Companion_541 {}
class $serializer_460 {
  constructor() {
    $serializer_instance_456 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('InternalRevertError', this, 1);
    tmp0_serialDesc.h1b('message', false);
    this.m6p_1 = tmp0_serialDesc;
  }
  n6p(encoder, value) {
    var tmp0_desc = this.m6p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.o6p_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n6p(encoder, value instanceof InternalRevertError ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m6p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return InternalRevertError.p6p(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.m6p_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class RequestRevertTurnResult {}
class Success_0 {
  constructor() {
    Success_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l6p_1 = lazy(tmp_0, RequestRevertTurnResult$Success$_anonymous__pimi3v);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_555(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'Success';
  }
  hashCode() {
    return -302221955;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Success_0))
      return false;
    return true;
  }
}
class InternalRevertError {
  constructor(message) {
    this.o6p_1 = message;
  }
  toString() {
    return 'InternalRevertError(message=' + this.o6p_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.o6p_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InternalRevertError))
      return false;
    if (!(this.o6p_1 === other.o6p_1))
      return false;
    return true;
  }
  static p6p(seen0, message, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_456().m6p_1);
    }
    var $this = createThis(this);
    $this.o6p_1 = message;
    return $this;
  }
}
class Companion_542 {
  a2g() {
    var tmp = getKClass(RequestRevertTurnResult);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(InternalRevertError), getKClass(Success_0)];
    var tmp_1 = $serializer_getInstance_456();
    var tmp_2 = Success_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_3 = [tmp_1, ObjectSerializer.l1c('Success', tmp_2, tmp$ret$3)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    return SealedClassSerializer.i10('steelart.beast.network.RequestRevertTurnResult', tmp, tmp_0, tmp_3, tmp$ret$9);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class WhatWillBeReapply extends Enum {}
class QuestionDataToRestore {
  constructor(gameQuestion, mayNothing, answer) {
    this.q6p_1 = gameQuestion;
    this.r6p_1 = mayNothing;
    this.s6p_1 = answer;
  }
  toString() {
    return 'QuestionDataToRestore(gameQuestion=' + toString(this.q6p_1) + ', mayNothing=' + this.r6p_1 + ', answer=' + toString_0(this.s6p_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.q6p_1);
    result = imul(result, 31) + getBooleanHashCode(this.r6p_1) | 0;
    result = imul(result, 31) + (this.s6p_1 == null ? 0 : hashCode(this.s6p_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof QuestionDataToRestore))
      return false;
    if (!equals(this.q6p_1, other.q6p_1))
      return false;
    if (!(this.r6p_1 === other.r6p_1))
      return false;
    if (!equals(this.s6p_1, other.s6p_1))
      return false;
    return true;
  }
}
class Companion_543 {
  constructor() {
    Companion_instance_543 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t6p_1 = [null, null, lazy(tmp_0, ActiveDuelSession$Companion$$childSerializers$_anonymous__ccr7pu), null];
  }
}
class $serializer_461 {
  constructor() {
    $serializer_instance_457 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ActiveDuelSession', this, 4);
    tmp0_serialDesc.h1b('gameId', false);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('gameTeams', false);
    tmp0_serialDesc.h1b('hasExplicitAccess', true);
    this.u6p_1 = tmp0_serialDesc;
  }
  v6p(encoder, value) {
    var tmp0_desc = this.u6p_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_544().t6p_1;
    tmp1_output.z14(tmp0_desc, 0, value.w6p_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_441(), value.x6p_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.y6p_1);
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.z6p_1 === true)) {
      tmp1_output.w14(tmp0_desc, 3, value.z6p_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.v6p(encoder, value instanceof ActiveDuelSession ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.u6p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_input = decoder.p13(tmp0_desc);
    var tmp9_cached = Companion_getInstance_544().t6p_1;
    if (tmp8_input.e14()) {
      tmp4_local0 = tmp8_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, $serializer_getInstance_441(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.r13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b14(tmp0_desc, 1, $serializer_getInstance_441(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b14(tmp0_desc, 2, tmp9_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.r13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp8_input.q13(tmp0_desc);
    return ActiveDuelSession.a6q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  dz() {
    return this.u6p_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_544().t6p_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance_441(), tmp0_cached[2].k3(), BooleanSerializer_getInstance()];
  }
}
class ActiveDuelSession {
  constructor(gameId, gameCode, gameTeams, hasExplicitAccess) {
    Companion_getInstance_544();
    hasExplicitAccess = hasExplicitAccess === VOID ? true : hasExplicitAccess;
    this.w6p_1 = gameId;
    this.x6p_1 = gameCode;
    this.y6p_1 = gameTeams;
    this.z6p_1 = hasExplicitAccess;
  }
  toString() {
    return 'ActiveDuelSession(gameId=' + this.w6p_1 + ', gameCode=' + this.x6p_1.toString() + ', gameTeams=' + toString(this.y6p_1) + ', hasExplicitAccess=' + this.z6p_1 + ')';
  }
  hashCode() {
    var result = this.w6p_1;
    result = imul(result, 31) + this.x6p_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.y6p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z6p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ActiveDuelSession))
      return false;
    if (!(this.w6p_1 === other.w6p_1))
      return false;
    if (!this.x6p_1.equals(other.x6p_1))
      return false;
    if (!equals(this.y6p_1, other.y6p_1))
      return false;
    if (!(this.z6p_1 === other.z6p_1))
      return false;
    return true;
  }
  static a6q(seen0, gameId, gameCode, gameTeams, hasExplicitAccess, serializationConstructorMarker) {
    Companion_getInstance_544();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_457().u6p_1);
    }
    var $this = createThis(this);
    $this.w6p_1 = gameId;
    $this.x6p_1 = gameCode;
    $this.y6p_1 = gameTeams;
    if (0 === (seen0 & 8))
      $this.z6p_1 = true;
    else
      $this.z6p_1 = hasExplicitAccess;
    return $this;
  }
}
class Companion_544 {
  constructor() {
    Companion_instance_544 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, LobbyInfo$Companion$$childSerializers$_anonymous__ouvsue);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b6q_1 = [null, null, null, tmp_1, lazy(tmp_2, LobbyInfo$Companion$$childSerializers$_anonymous__ouvsue_0), null];
  }
}
class $serializer_462 {
  constructor() {
    $serializer_instance_458 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.LobbyInfo', this, 6);
    tmp0_serialDesc.h1b('gameName', false);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('gameContentVersion', false);
    tmp0_serialDesc.h1b('rules', false);
    tmp0_serialDesc.h1b('gameTeamPickMap', false);
    tmp0_serialDesc.h1b('clientsInLobby', false);
    this.c6q_1 = tmp0_serialDesc;
  }
  d6q(encoder, value) {
    var tmp0_desc = this.c6q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_545().b6q_1;
    tmp1_output.e15(tmp0_desc, 0, value.e6q_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_441(), value.f6q_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_181(), value.g6q_1);
    tmp1_output.i15(tmp0_desc, 3, tmp2_cached[3].k3(), value.h6q_1);
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.i6q_1);
    tmp1_output.z14(tmp0_desc, 5, value.j6q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d6q(encoder, value instanceof LobbyInfo ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c6q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_input = decoder.p13(tmp0_desc);
    var tmp11_cached = Companion_getInstance_545().b6q_1;
    if (tmp10_input.e14()) {
      tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.b14(tmp0_desc, 1, $serializer_getInstance_441(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.b14(tmp0_desc, 2, $serializer_getInstance_181(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, tmp11_cached[3].k3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.b14(tmp0_desc, 4, tmp11_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.u13(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.b14(tmp0_desc, 1, $serializer_getInstance_441(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.b14(tmp0_desc, 2, $serializer_getInstance_181(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.d14(tmp0_desc, 3, tmp11_cached[3].k3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.b14(tmp0_desc, 4, tmp11_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.u13(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp10_input.q13(tmp0_desc);
    return LobbyInfo.k6q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  dz() {
    return this.c6q_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_545().b6q_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_441(), $serializer_getInstance_181(), get_nullable(tmp0_cached[3].k3()), tmp0_cached[4].k3(), IntSerializer_getInstance()];
  }
}
class LobbyInfo {
  constructor(gameName, gameCode, gameContentVersion, rules, gameTeamPickMap, clientsInLobby) {
    Companion_getInstance_545();
    this.e6q_1 = gameName;
    this.f6q_1 = gameCode;
    this.g6q_1 = gameContentVersion;
    this.h6q_1 = rules;
    this.i6q_1 = gameTeamPickMap;
    this.j6q_1 = clientsInLobby;
  }
  toString() {
    return 'LobbyInfo(gameName=' + this.e6q_1 + ', gameCode=' + this.f6q_1.toString() + ', gameContentVersion=' + this.g6q_1.toString() + ', rules=' + toString_0(this.h6q_1) + ', gameTeamPickMap=' + toString(this.i6q_1) + ', clientsInLobby=' + this.j6q_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.e6q_1);
    result = imul(result, 31) + this.f6q_1.hashCode() | 0;
    result = imul(result, 31) + this.g6q_1.hashCode() | 0;
    result = imul(result, 31) + (this.h6q_1 == null ? 0 : hashCode(this.h6q_1)) | 0;
    result = imul(result, 31) + hashCode(this.i6q_1) | 0;
    result = imul(result, 31) + this.j6q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LobbyInfo))
      return false;
    if (!(this.e6q_1 === other.e6q_1))
      return false;
    if (!this.f6q_1.equals(other.f6q_1))
      return false;
    if (!this.g6q_1.equals(other.g6q_1))
      return false;
    if (!equals(this.h6q_1, other.h6q_1))
      return false;
    if (!equals(this.i6q_1, other.i6q_1))
      return false;
    if (!(this.j6q_1 === other.j6q_1))
      return false;
    return true;
  }
  static k6q(seen0, gameName, gameCode, gameContentVersion, rules, gameTeamPickMap, clientsInLobby, serializationConstructorMarker) {
    Companion_getInstance_545();
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_458().c6q_1);
    }
    var $this = createThis(this);
    $this.e6q_1 = gameName;
    $this.f6q_1 = gameCode;
    $this.g6q_1 = gameContentVersion;
    $this.h6q_1 = rules;
    $this.i6q_1 = gameTeamPickMap;
    $this.j6q_1 = clientsInLobby;
    return $this;
  }
}
class Companion_545 {
  a2g() {
    var tmp = getKClass(SetupUpdateFromServer);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(GameStarted), getKClass(NotFoundSetupSession), getKClass(SetupEnded), getKClass(SetupUpdate)];
    var tmp_1 = $serializer_getInstance_464();
    var tmp_2 = NotFoundSetupSession_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_3 = [tmp_1, ObjectSerializer.l1c('NotFoundSetupSession', tmp_2, tmp$ret$3), $serializer_getInstance_465(), $serializer_getInstance_466()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    return SealedClassSerializer.i10('steelart.beast.network.SetupUpdateFromServer', tmp, tmp_0, tmp_3, tmp$ret$9);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class SetupUpdateFromServer {}
class Companion_546 {
  constructor() {
    Companion_instance_546 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l6q_1 = [null, null, lazy(tmp_0, ClientSetup$Companion$$childSerializers$_anonymous__h03ifc)];
  }
}
class $serializer_463 {
  constructor() {
    $serializer_instance_459 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ClientSetup', this, 3);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('gameTeam', false);
    tmp0_serialDesc.h1b('gameRules', false);
    this.m6q_1 = tmp0_serialDesc;
  }
  n6q(encoder, value) {
    var tmp0_desc = this.m6q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_547().l6q_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_441(), value.o6q_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_183(), new GameTeam(value.p6q_1));
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.q6q_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n6q(encoder, value instanceof ClientSetup ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m6q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_547().l6q_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp7_input.b14(tmp0_desc, 1, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp7_input.b14(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, tmp8_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return ClientSetup.r6q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.m6q_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_547().l6q_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_441(), $serializer_getInstance_183(), tmp0_cached[2].k3()];
  }
}
class ClientSetup {
  constructor(gameCode, gameTeam, gameRules) {
    Companion_getInstance_547();
    this.o6q_1 = gameCode;
    this.p6q_1 = gameTeam;
    this.q6q_1 = gameRules;
  }
  toString() {
    return 'ClientSetup(gameCode=' + this.o6q_1.toString() + ', gameTeam=' + GameTeam__toString_impl_wfw0a6(this.p6q_1) + ', gameRules=' + toString(this.q6q_1) + ')';
  }
  hashCode() {
    var result = this.o6q_1.hashCode();
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.p6q_1) | 0;
    result = imul(result, 31) + hashCode(this.q6q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClientSetup))
      return false;
    if (!this.o6q_1.equals(other.o6q_1))
      return false;
    if (!(this.p6q_1 === other.p6q_1))
      return false;
    if (!equals(this.q6q_1, other.q6q_1))
      return false;
    return true;
  }
  static r6q(seen0, gameCode, gameTeam, gameRules, serializationConstructorMarker) {
    Companion_getInstance_547();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_459().m6q_1);
    }
    var $this = createThis(this);
    $this.o6q_1 = gameCode;
    $this.p6q_1 = gameTeam;
    $this.q6q_1 = gameRules;
    return $this;
  }
}
class GameStatus extends Enum {}
class PingingSupport {}
function *pingElement(element, $completion) {
  return Unit_instance;
}
class RevertSupportingAgent {}
function *approveRevert(requestingTeam, $completion) {
  return false;
}
function *revertEvent(event, revertingChanges, checkInfo, $completion) {
  return Unit_instance;
}
class MasterFixingSupportingAgent {}
function *approveMasterFixing(requestingTeam, $completion) {
  return false;
}
function *useMasterFixingEvents(masterFixingEventsConsumer, $completion) {
  return Unit_instance;
}
class Companion_547 {
  constructor() {
    Companion_instance_547 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p6n_1 = lazy(tmp_0, BeastResourceKind$Companion$_anonymous__isew4y);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_556(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class BeastResourceKind extends Enum {}
class Companion_548 {}
class $serializer_464 {
  constructor() {
    $serializer_instance_460 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PingBoardPositionElement', this, 1);
    tmp0_serialDesc.h1b('position', false);
    this.x6q_1 = tmp0_serialDesc;
  }
  y6q(encoder, value) {
    var tmp0_desc = this.x6q_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_100(), new BoardPosition(value.z6q_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y6q(encoder, value instanceof PingBoardPositionElement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x6q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      var tmp = $serializer_getInstance_100();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp5_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BoardPosition(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.r2v_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_100();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp5_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BoardPosition(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.r2v_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PingBoardPositionElement.a6r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x6q_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_100()];
  }
}
class PingBoardPositionElement {
  constructor(position) {
    this.z6q_1 = position;
  }
  toString() {
    return 'PingBoardPositionElement(position=' + BoardPosition__toString_impl_v4mn82(this.z6q_1) + ')';
  }
  hashCode() {
    return BoardPosition__hashCode_impl_9dgqf7(this.z6q_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PingBoardPositionElement))
      return false;
    if (!(this.z6q_1 === other.z6q_1))
      return false;
    return true;
  }
  static a6r(seen0, position, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_460().x6q_1);
    }
    var $this = createThis(this);
    $this.z6q_1 = position;
    return $this;
  }
}
class Companion_549 {
  constructor() {
    Companion_instance_549 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b6r_1 = [lazy(tmp_0, PingLocationTypeElement$Companion$$childSerializers$_anonymous__fg2ehb)];
  }
}
class $serializer_465 {
  constructor() {
    $serializer_instance_461 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PingLocationTypeElement', this, 1);
    tmp0_serialDesc.h1b('locationType', false);
    this.c6r_1 = tmp0_serialDesc;
  }
  d6r(encoder, value) {
    var tmp0_desc = this.c6r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_550().b6r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.e6r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.d6r(encoder, value instanceof PingLocationTypeElement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.c6r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_550().b6r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PingLocationTypeElement.f6r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.c6r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_550().b6r_1[0].k3()];
  }
}
class PingLocationTypeElement {
  constructor(locationType) {
    Companion_getInstance_550();
    this.e6r_1 = locationType;
  }
  toString() {
    return 'PingLocationTypeElement(locationType=' + this.e6r_1.toString() + ')';
  }
  hashCode() {
    return this.e6r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PingLocationTypeElement))
      return false;
    if (!this.e6r_1.equals(other.e6r_1))
      return false;
    return true;
  }
  static f6r(seen0, locationType, serializationConstructorMarker) {
    Companion_getInstance_550();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_461().c6r_1);
    }
    var $this = createThis(this);
    $this.e6r_1 = locationType;
    return $this;
  }
}
class Companion_550 {
  constructor() {
    Companion_instance_550 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g6r_1 = [lazy(tmp_0, PingPlayableCardElement$Companion$$childSerializers$_anonymous__enuc4e)];
  }
}
class $serializer_466 {
  constructor() {
    $serializer_instance_462 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PingPlayableCardElement', this, 1);
    tmp0_serialDesc.h1b('card', false);
    this.h6r_1 = tmp0_serialDesc;
  }
  i6r(encoder, value) {
    var tmp0_desc = this.h6r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_551().g6r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.j6r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.i6r(encoder, value instanceof PingPlayableCardElement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.h6r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_551().g6r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return PingPlayableCardElement.k6r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.h6r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_551().g6r_1[0].k3()];
  }
}
class PingPlayableCardElement {
  constructor(card) {
    Companion_getInstance_551();
    this.j6r_1 = card;
  }
  toString() {
    return 'PingPlayableCardElement(card=' + toString(this.j6r_1) + ')';
  }
  hashCode() {
    return hashCode(this.j6r_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PingPlayableCardElement))
      return false;
    if (!equals(this.j6r_1, other.j6r_1))
      return false;
    return true;
  }
  static k6r(seen0, card, serializationConstructorMarker) {
    Companion_getInstance_551();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_462().h6r_1);
    }
    var $this = createThis(this);
    $this.j6r_1 = card;
    return $this;
  }
}
class Companion_551 {}
class $serializer_467 {
  constructor() {
    $serializer_instance_463 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.GameRoleClient', this, 2);
    tmp0_serialDesc.h1b('displayName', false);
    tmp0_serialDesc.h1b('isConnected', false);
    this.l6r_1 = tmp0_serialDesc;
  }
  m6r(encoder, value) {
    var tmp0_desc = this.l6r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.n6r_1);
    tmp1_output.w14(tmp0_desc, 1, value.o6r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m6r(encoder, value instanceof GameRoleClient ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l6r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return GameRoleClient.p6r(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.l6r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class GameRoleClient {
  constructor(displayName, isConnected) {
    this.n6r_1 = displayName;
    this.o6r_1 = isConnected;
  }
  toString() {
    return 'GameRoleClient(displayName=' + this.n6r_1 + ', isConnected=' + this.o6r_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.n6r_1);
    result = imul(result, 31) + getBooleanHashCode(this.o6r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameRoleClient))
      return false;
    if (!(this.n6r_1 === other.n6r_1))
      return false;
    if (!(this.o6r_1 === other.o6r_1))
      return false;
    return true;
  }
  static p6r(seen0, displayName, isConnected, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_463().l6r_1);
    }
    var $this = createThis(this);
    $this.n6r_1 = displayName;
    $this.o6r_1 = isConnected;
    return $this;
  }
}
class Companion_552 {}
class $serializer_468 {
  constructor() {
    $serializer_instance_464 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GameStarted', this, 1);
    tmp0_serialDesc.h1b('finalSetup', false);
    this.q6r_1 = tmp0_serialDesc;
  }
  r6r(encoder, value) {
    var tmp0_desc = this.q6r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.i15(tmp0_desc, 0, $serializer_getInstance_459(), value.s6r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.r6r(encoder, value instanceof GameStarted ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.q6r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, $serializer_getInstance_459(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.d14(tmp0_desc, 0, $serializer_getInstance_459(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return GameStarted.t6r(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.q6r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_459())];
  }
}
class GameStarted {
  constructor(finalSetup) {
    this.s6r_1 = finalSetup;
  }
  toString() {
    return 'GameStarted(finalSetup=' + toString_0(this.s6r_1) + ')';
  }
  hashCode() {
    return this.s6r_1 == null ? 0 : this.s6r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameStarted))
      return false;
    if (!equals(this.s6r_1, other.s6r_1))
      return false;
    return true;
  }
  static t6r(seen0, finalSetup, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_464().q6r_1);
    }
    var $this = createThis(this);
    $this.s6r_1 = finalSetup;
    return $this;
  }
}
class NotFoundSetupSession {
  constructor() {
    NotFoundSetupSession_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u6r_1 = lazy(tmp_0, NotFoundSetupSession$_anonymous__bfd6z5);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_557(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NotFoundSetupSession';
  }
  hashCode() {
    return -1391453075;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NotFoundSetupSession))
      return false;
    return true;
  }
}
class Companion_553 {
  constructor() {
    Companion_instance_553 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w6r_1 = [lazy(tmp_0, SetupEnded$Companion$$childSerializers$_anonymous__mg597x)];
  }
}
class $serializer_469 {
  constructor() {
    $serializer_instance_465 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetupEnded', this, 1);
    tmp0_serialDesc.h1b('status', false);
    this.x6r_1 = tmp0_serialDesc;
  }
  y6r(encoder, value) {
    var tmp0_desc = this.x6r_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_554().w6r_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.z6r_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y6r(encoder, value instanceof SetupEnded ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x6r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    var tmp6_cached = Companion_getInstance_554().w6r_1;
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, tmp6_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SetupEnded.a6s(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x6r_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_554().w6r_1[0].k3()];
  }
}
class SetupEnded {
  constructor(status) {
    Companion_getInstance_554();
    this.z6r_1 = status;
  }
  toString() {
    return 'SetupEnded(status=' + this.z6r_1.toString() + ')';
  }
  hashCode() {
    return this.z6r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupEnded))
      return false;
    if (!this.z6r_1.equals(other.z6r_1))
      return false;
    return true;
  }
  static a6s(seen0, status, serializationConstructorMarker) {
    Companion_getInstance_554();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_465().x6r_1);
    }
    var $this = createThis(this);
    $this.z6r_1 = status;
    return $this;
  }
}
class Companion_554 {}
class $serializer_470 {
  constructor() {
    $serializer_instance_466 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetupUpdate', this, 1);
    tmp0_serialDesc.h1b('updatedSetup', false);
    this.b6s_1 = tmp0_serialDesc;
  }
  c6s(encoder, value) {
    var tmp0_desc = this.b6s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_467(), value.d6s_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c6s(encoder, value instanceof SetupUpdate ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b6s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_467(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_467(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SetupUpdate.e6s(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b6s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_467()];
  }
}
class SetupUpdate {
  constructor(updatedSetup) {
    this.d6s_1 = updatedSetup;
  }
  toString() {
    return 'SetupUpdate(updatedSetup=' + this.d6s_1.toString() + ')';
  }
  hashCode() {
    return this.d6s_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupUpdate))
      return false;
    if (!this.d6s_1.equals(other.d6s_1))
      return false;
    return true;
  }
  static e6s(seen0, updatedSetup, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_466().b6s_1);
    }
    var $this = createThis(this);
    $this.d6s_1 = updatedSetup;
    return $this;
  }
}
class Companion_555 {
  constructor() {
    Companion_instance_555 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v6r_1 = lazy(tmp_0, SetupTerminalStatus$Companion$_anonymous__avviho);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_558(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class SetupTerminalStatus extends Enum {}
class Companion_556 {
  constructor() {
    Companion_instance_556 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, ServerDuelSetupGameData$Companion$$childSerializers$_anonymous__pbube4);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, ServerDuelSetupGameData$Companion$$childSerializers$_anonymous__pbube4_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f6s_1 = [null, tmp_1, null, null, tmp_3, null, lazy(tmp_4, ServerDuelSetupGameData$Companion$$childSerializers$_anonymous__pbube4_1), null];
  }
}
class $serializer_471 {
  constructor() {
    $serializer_instance_467 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ServerDuelSetupGameData', this, 8);
    tmp0_serialDesc.h1b('gameContentVersion', true);
    tmp0_serialDesc.h1b('rules', true);
    tmp0_serialDesc.h1b('myGameTeam', true);
    tmp0_serialDesc.h1b('isRecordingGameMode', true);
    tmp0_serialDesc.h1b('gameTeamPickMap', false);
    tmp0_serialDesc.h1b('clientsInLobby', false);
    tmp0_serialDesc.h1b('connectedClients', true);
    tmp0_serialDesc.h1b('isPubliclyObserved', true);
    this.g6s_1 = tmp0_serialDesc;
  }
  h6s(encoder, value) {
    var tmp0_desc = this.g6s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_557().f6s_1;
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !value.i6s_1.equals(Companion_getInstance_220().w39_1)) {
      tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_181(), value.i6s_1);
    }
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.j6s_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, tmp2_cached[1].k3(), value.j6s_1);
    }
    var tmp;
    if (tmp1_output.m15(tmp0_desc, 2)) {
      tmp = true;
    } else {
      var tmp_0 = value.k6s_1;
      tmp = !((tmp_0 == null ? null : new GameTeam(tmp_0)) == null);
    }
    if (tmp) {
      var tmp_1 = $serializer_getInstance_183();
      var tmp_2 = value.k6s_1;
      tmp1_output.i15(tmp0_desc, 2, tmp_1, tmp_2 == null ? null : new GameTeam(tmp_2));
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.l6s_1 === false)) {
      tmp1_output.w14(tmp0_desc, 3, value.l6s_1);
    }
    tmp1_output.g15(tmp0_desc, 4, tmp2_cached[4].k3(), value.m6s_1);
    tmp1_output.z14(tmp0_desc, 5, value.n6s_1);
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !equals(value.o6s_1, emptyList())) {
      tmp1_output.g15(tmp0_desc, 6, tmp2_cached[6].k3(), value.o6s_1);
    }
    if (tmp1_output.m15(tmp0_desc, 7) ? true : !(value.p6s_1 === false)) {
      tmp1_output.w14(tmp0_desc, 7, value.p6s_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h6s(encoder, value instanceof ServerDuelSetupGameData ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g6s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_input = decoder.p13(tmp0_desc);
    var tmp13_cached = Companion_getInstance_557().f6s_1;
    if (tmp12_input.e14()) {
      tmp4_local0 = tmp12_input.b14(tmp0_desc, 0, $serializer_getInstance_181(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.d14(tmp0_desc, 1, tmp13_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = $serializer_getInstance_183();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp12_input.d14(tmp0_desc, 2, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.r13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.b14(tmp0_desc, 4, tmp13_cached[4].k3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.u13(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.b14(tmp0_desc, 6, tmp13_cached[6].k3(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.r13(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.b14(tmp0_desc, 0, $serializer_getInstance_181(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.d14(tmp0_desc, 1, tmp13_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_2 = $serializer_getInstance_183();
            var tmp_3 = tmp6_local2;
            var tmp_4 = tmp12_input.d14(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp6_local2 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.r13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.b14(tmp0_desc, 4, tmp13_cached[4].k3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.u13(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.b14(tmp0_desc, 6, tmp13_cached[6].k3(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.r13(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp12_input.q13(tmp0_desc);
    return ServerDuelSetupGameData.q6s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  }
  dz() {
    return this.g6s_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_557().f6s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_181(), get_nullable(tmp0_cached[1].k3()), get_nullable($serializer_getInstance_183()), BooleanSerializer_getInstance(), tmp0_cached[4].k3(), IntSerializer_getInstance(), tmp0_cached[6].k3(), BooleanSerializer_getInstance()];
  }
}
class ServerDuelSetupGameData {
  constructor(gameContentVersion, rules, myGameTeam, isRecordingGameMode, gameTeamPickMap, clientsInLobby, connectedClients, isPubliclyObserved) {
    Companion_getInstance_557();
    gameContentVersion = gameContentVersion === VOID ? Companion_getInstance_220().w39_1 : gameContentVersion;
    rules = rules === VOID ? null : rules;
    myGameTeam = myGameTeam === VOID ? null : myGameTeam;
    isRecordingGameMode = isRecordingGameMode === VOID ? false : isRecordingGameMode;
    connectedClients = connectedClients === VOID ? emptyList() : connectedClients;
    isPubliclyObserved = isPubliclyObserved === VOID ? false : isPubliclyObserved;
    this.i6s_1 = gameContentVersion;
    this.j6s_1 = rules;
    this.k6s_1 = myGameTeam;
    this.l6s_1 = isRecordingGameMode;
    this.m6s_1 = gameTeamPickMap;
    this.n6s_1 = clientsInLobby;
    this.o6s_1 = connectedClients;
    this.p6s_1 = isPubliclyObserved;
  }
  toString() {
    var tmp = this.i6s_1.toString();
    var tmp_0 = toString_0(this.j6s_1);
    var tmp_1 = this.k6s_1;
    return 'ServerDuelSetupGameData(gameContentVersion=' + tmp + ', rules=' + tmp_0 + ', myGameTeam=' + toString_0(tmp_1 == null ? null : new GameTeam(tmp_1)) + ', isRecordingGameMode=' + this.l6s_1 + ', gameTeamPickMap=' + toString(this.m6s_1) + ', clientsInLobby=' + this.n6s_1 + ', connectedClients=' + toString(this.o6s_1) + ', isPubliclyObserved=' + this.p6s_1 + ')';
  }
  hashCode() {
    var result = this.i6s_1.hashCode();
    result = imul(result, 31) + (this.j6s_1 == null ? 0 : hashCode(this.j6s_1)) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.k6s_1;
    if ((tmp_1 == null ? null : new GameTeam(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = GameTeam__hashCode_impl_gu24w3(this.k6s_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l6s_1) | 0;
    result = imul(result, 31) + hashCode(this.m6s_1) | 0;
    result = imul(result, 31) + this.n6s_1 | 0;
    result = imul(result, 31) + hashCode(this.o6s_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p6s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ServerDuelSetupGameData))
      return false;
    if (!this.i6s_1.equals(other.i6s_1))
      return false;
    if (!equals(this.j6s_1, other.j6s_1))
      return false;
    var tmp = this.k6s_1;
    var tmp_0 = tmp == null ? null : new GameTeam(tmp);
    var tmp_1 = other.k6s_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new GameTeam(tmp_1)))
      return false;
    if (!(this.l6s_1 === other.l6s_1))
      return false;
    if (!equals(this.m6s_1, other.m6s_1))
      return false;
    if (!(this.n6s_1 === other.n6s_1))
      return false;
    if (!equals(this.o6s_1, other.o6s_1))
      return false;
    if (!(this.p6s_1 === other.p6s_1))
      return false;
    return true;
  }
  static q6s(seen0, gameContentVersion, rules, myGameTeam, isRecordingGameMode, gameTeamPickMap, clientsInLobby, connectedClients, isPubliclyObserved, serializationConstructorMarker) {
    Companion_getInstance_557();
    if (!(48 === (48 & seen0))) {
      throwMissingFieldException(seen0, 48, $serializer_getInstance_467().g6s_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.i6s_1 = Companion_getInstance_220().w39_1;
    else
      $this.i6s_1 = gameContentVersion;
    if (0 === (seen0 & 2))
      $this.j6s_1 = null;
    else
      $this.j6s_1 = rules;
    if (0 === (seen0 & 4))
      $this.k6s_1 = null;
    else
      $this.k6s_1 = myGameTeam;
    if (0 === (seen0 & 8))
      $this.l6s_1 = false;
    else
      $this.l6s_1 = isRecordingGameMode;
    $this.m6s_1 = gameTeamPickMap;
    $this.n6s_1 = clientsInLobby;
    if (0 === (seen0 & 64))
      $this.o6s_1 = emptyList();
    else
      $this.o6s_1 = connectedClients;
    if (0 === (seen0 & 128))
      $this.p6s_1 = false;
    else
      $this.p6s_1 = isPubliclyObserved;
    return $this;
  }
}
class Companion_557 {}
class $serializer_472 {
  constructor() {
    $serializer_instance_468 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.LobbyClient', this, 3);
    tmp0_serialDesc.h1b('displayName', false);
    tmp0_serialDesc.h1b('sessionCount', false);
    tmp0_serialDesc.h1b('avatarUrl', true);
    this.r6s_1 = tmp0_serialDesc;
  }
  s6s(encoder, value) {
    var tmp0_desc = this.r6s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.t6s_1);
    tmp1_output.z14(tmp0_desc, 1, value.u6s_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.v6s_1 == null)) {
      tmp1_output.i15(tmp0_desc, 2, StringSerializer_getInstance(), value.v6s_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s6s(encoder, value instanceof LobbyClient ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r6s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.d14(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.d14(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return LobbyClient.w6s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.r6s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  }
}
class LobbyClient {
  constructor(displayName, sessionCount, avatarUrl) {
    avatarUrl = avatarUrl === VOID ? null : avatarUrl;
    this.t6s_1 = displayName;
    this.u6s_1 = sessionCount;
    this.v6s_1 = avatarUrl;
  }
  toString() {
    return 'LobbyClient(displayName=' + this.t6s_1 + ', sessionCount=' + this.u6s_1 + ', avatarUrl=' + this.v6s_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.t6s_1);
    result = imul(result, 31) + this.u6s_1 | 0;
    result = imul(result, 31) + (this.v6s_1 == null ? 0 : getStringHashCode(this.v6s_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LobbyClient))
      return false;
    if (!(this.t6s_1 === other.t6s_1))
      return false;
    if (!(this.u6s_1 === other.u6s_1))
      return false;
    if (!(this.v6s_1 == other.v6s_1))
      return false;
    return true;
  }
  static w6s(seen0, displayName, sessionCount, avatarUrl, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_468().r6s_1);
    }
    var $this = createThis(this);
    $this.t6s_1 = displayName;
    $this.u6s_1 = sessionCount;
    if (0 === (seen0 & 4))
      $this.v6s_1 = null;
    else
      $this.v6s_1 = avatarUrl;
    return $this;
  }
}
class Companion_558 {}
class $serializer_473 {
  constructor() {
    $serializer_instance_469 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.DebugOutputSessionConfiguration', this, 5);
    tmp0_serialDesc.h1b('needPrettyPrintAnswers', true);
    tmp0_serialDesc.h1b('needPrintQuestionClasses', true);
    tmp0_serialDesc.h1b('needPrintPhaseStarts', true);
    tmp0_serialDesc.h1b('needPrintCommas', true);
    tmp0_serialDesc.h1b('printObviousAnswers', true);
    this.x6s_1 = tmp0_serialDesc;
  }
  y6s(encoder, value) {
    var tmp0_desc = this.x6s_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    if (tmp1_output.m15(tmp0_desc, 0) ? true : !(value.z6s_1 === false)) {
      tmp1_output.w14(tmp0_desc, 0, value.z6s_1);
    }
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.a6t_1 === false)) {
      tmp1_output.w14(tmp0_desc, 1, value.a6t_1);
    }
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.b6t_1 === false)) {
      tmp1_output.w14(tmp0_desc, 2, value.b6t_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.c6t_1 === false)) {
      tmp1_output.w14(tmp0_desc, 3, value.c6t_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.d6t_1 === false)) {
      tmp1_output.w14(tmp0_desc, 4, value.d6t_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y6s(encoder, value instanceof DebugOutputSessionConfiguration ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x6s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = false;
    var tmp6_local2 = false;
    var tmp7_local3 = false;
    var tmp8_local4 = false;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.r13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.r13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.r13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.r13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.r13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.r13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.r13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.r13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return DebugOutputSessionConfiguration.e6t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.x6s_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class DebugOutputSessionConfiguration {
  constructor(needPrettyPrintAnswers, needPrintQuestionClasses, needPrintPhaseStarts, needPrintCommas, printObviousAnswers) {
    needPrettyPrintAnswers = needPrettyPrintAnswers === VOID ? false : needPrettyPrintAnswers;
    needPrintQuestionClasses = needPrintQuestionClasses === VOID ? false : needPrintQuestionClasses;
    needPrintPhaseStarts = needPrintPhaseStarts === VOID ? false : needPrintPhaseStarts;
    needPrintCommas = needPrintCommas === VOID ? false : needPrintCommas;
    printObviousAnswers = printObviousAnswers === VOID ? false : printObviousAnswers;
    this.z6s_1 = needPrettyPrintAnswers;
    this.a6t_1 = needPrintQuestionClasses;
    this.b6t_1 = needPrintPhaseStarts;
    this.c6t_1 = needPrintCommas;
    this.d6t_1 = printObviousAnswers;
  }
  toString() {
    return 'DebugOutputSessionConfiguration(needPrettyPrintAnswers=' + this.z6s_1 + ', needPrintQuestionClasses=' + this.a6t_1 + ', needPrintPhaseStarts=' + this.b6t_1 + ', needPrintCommas=' + this.c6t_1 + ', printObviousAnswers=' + this.d6t_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.z6s_1);
    result = imul(result, 31) + getBooleanHashCode(this.a6t_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b6t_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c6t_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d6t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DebugOutputSessionConfiguration))
      return false;
    if (!(this.z6s_1 === other.z6s_1))
      return false;
    if (!(this.a6t_1 === other.a6t_1))
      return false;
    if (!(this.b6t_1 === other.b6t_1))
      return false;
    if (!(this.c6t_1 === other.c6t_1))
      return false;
    if (!(this.d6t_1 === other.d6t_1))
      return false;
    return true;
  }
  static e6t(seen0, needPrettyPrintAnswers, needPrintQuestionClasses, needPrintPhaseStarts, needPrintCommas, printObviousAnswers, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_469().x6s_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.z6s_1 = false;
    else
      $this.z6s_1 = needPrettyPrintAnswers;
    if (0 === (seen0 & 2))
      $this.a6t_1 = false;
    else
      $this.a6t_1 = needPrintQuestionClasses;
    if (0 === (seen0 & 4))
      $this.b6t_1 = false;
    else
      $this.b6t_1 = needPrintPhaseStarts;
    if (0 === (seen0 & 8))
      $this.c6t_1 = false;
    else
      $this.c6t_1 = needPrintCommas;
    if (0 === (seen0 & 16))
      $this.d6t_1 = false;
    else
      $this.d6t_1 = printObviousAnswers;
    return $this;
  }
}
class ServerDrivenConfigurationTransparentException {}
class GameSessionReloadRequiredException extends IllegalStateException {
  constructor() {
    return new.target.j6t();
  }
  static j6t() {
    var $this = this.o('Game session must reconnect after reload');
    captureStack($this, $this.i6t_1);
    return $this;
  }
}
class SimpleReplayFullClientAgent {
  constructor(diagnostics) {
    this.k6t_1 = diagnostics;
    this.l6t_1 = null;
    this.n6t_1 = new SimpleSavedAnswersSource();
  }
  o6t() {
    return this.n6t_1;
  }
  *p6t($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, $completion) {
    // Inline function 'steelart.beast.completedAnswer' call
    var savedAnswer = yield* this.n6t_1.q6t($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, $completion);
    return CompletableDeferred_0(savedAnswer);
  }
  *r6t(notification, $completion) {
    var event = notification.x3p_1;
    var tmp0_safe_receiver = event instanceof InitGameStateEvent ? event : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.m6t_1 = tmp0_safe_receiver.a54_1.y4l();
    }
    if (event instanceof EndOfGameEvent) {
      var tmp = this.l6t_1;
      // Inline function 'kotlin.require' call
      if (!((tmp == null ? null : new GameTeam(tmp)) == null)) {
        var tmp_0 = this.l6t_1;
        var message = 'Winner already determined, ' + toString_0(tmp_0 == null ? null : new GameTeam(tmp_0)) + ', but ' + GameTeam__toString_impl_wfw0a6(event.b51_1) + ' is coming';
        throw IllegalArgumentException.h2(toString(message));
      }
      this.l6t_1 = event.b51_1;
    }
    // Inline function 'kotlin.with' call
    var $this$with = _get_currentState__wsfiyb(this);
    applyAllChanges($this$with, this, event);
    var tmp0_safe_receiver_0 = notification.y3p_1;
    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.e3q_1;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      $this$with.g38_1 = tmp1_safe_receiver;
      tmp_1 = Unit_instance;
    }
    var tmp1_safe_receiver_0 = notification.y3p_1;
    var tmp2_safe_receiver = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.f3q_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.require' call
      if (!tmp2_safe_receiver.equals(calculateCheckCode(_get_currentState__wsfiyb(this)))) {
        var message_0 = 'Inconsistent check code';
        throw IllegalArgumentException.h2(toString(message_0));
      }
    }
    return Unit_instance;
  }
  *s6t($completion) {
    return _get_currentState__wsfiyb(this);
  }
  f5c(warning, cause) {
    return this.k6t_1.f5c(warning, cause);
  }
}
class GameIsNotFound {
  toString() {
    return 'GameIsNotFound';
  }
  hashCode() {
    return -2027068926;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameIsNotFound))
      return false;
    return true;
  }
}
class GameIsEnded {
  constructor(winner) {
    this.t6t_1 = winner;
  }
  toString() {
    return 'GameIsEnded(winner=' + GameTeam__toString_impl_wfw0a6(this.t6t_1) + ')';
  }
  hashCode() {
    return GameTeam__hashCode_impl_gu24w3(this.t6t_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameIsEnded))
      return false;
    if (!(this.t6t_1 === other.t6t_1))
      return false;
    return true;
  }
}
class IncompleteGame {
  toString() {
    return 'IncompleteGame';
  }
  hashCode() {
    return -1508066521;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IncompleteGame))
      return false;
    return true;
  }
}
class ExceptionInReplaying {
  constructor(e) {
    this.u6t_1 = e;
  }
  toString() {
    return 'ExceptionInReplaying(e=' + this.u6t_1.toString() + ')';
  }
  hashCode() {
    return hashCode(this.u6t_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExceptionInReplaying))
      return false;
    if (!equals(this.u6t_1, other.u6t_1))
      return false;
    return true;
  }
}
class Companion_559 {}
class $serializer_474 {
  constructor() {
    $serializer_instance_470 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ServerMessage.Announcement', this, 2);
    tmp0_serialDesc.h1b('id', false);
    tmp0_serialDesc.h1b('text', false);
    this.y6t_1 = tmp0_serialDesc;
  }
  z6t(encoder, value) {
    var tmp0_desc = this.y6t_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.a15(tmp0_desc, 0, value.a6u_1);
    tmp1_output.e15(tmp0_desc, 1, value.b6u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.z6t(encoder, value instanceof Announcement ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.y6t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.z13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.z13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return Announcement.c6u(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.y6t_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class Companion_560 {}
class $serializer_475 {
  constructor() {
    $serializer_instance_471 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ServerMessage.Maintenance', this, 3);
    tmp0_serialDesc.h1b('id', false);
    tmp0_serialDesc.h1b('startsAtEpochMilliseconds', false);
    tmp0_serialDesc.h1b('estimatedDurationSeconds', false);
    this.d6u_1 = tmp0_serialDesc;
  }
  e6u(encoder, value) {
    var tmp0_desc = this.d6u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.a15(tmp0_desc, 0, value.f6u_1);
    tmp1_output.a15(tmp0_desc, 1, value.g6u_1);
    tmp1_output.a15(tmp0_desc, 2, value.h6u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.e6u(encoder, value instanceof Maintenance ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.d6u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.p13(tmp0_desc);
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return Maintenance.i6u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.d6u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance()];
  }
}
class ServerMessage {}
class Announcement {
  constructor(id, text) {
    this.a6u_1 = id;
    this.b6u_1 = text;
  }
  j6u() {
    return this.a6u_1;
  }
  toString() {
    return 'Announcement(id=' + this.a6u_1.toString() + ', text=' + this.b6u_1 + ')';
  }
  hashCode() {
    var result = this.a6u_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.b6u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Announcement))
      return false;
    if (!equalsLong(this.a6u_1, other.a6u_1))
      return false;
    if (!(this.b6u_1 === other.b6u_1))
      return false;
    return true;
  }
  static c6u(seen0, id, text, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_470().y6t_1);
    }
    var $this = createThis(this);
    $this.a6u_1 = id;
    $this.b6u_1 = text;
    return $this;
  }
}
class Maintenance {
  constructor(id, startsAtEpochMilliseconds, estimatedDurationSeconds) {
    this.f6u_1 = id;
    this.g6u_1 = startsAtEpochMilliseconds;
    this.h6u_1 = estimatedDurationSeconds;
  }
  j6u() {
    return this.f6u_1;
  }
  toString() {
    return 'Maintenance(id=' + this.f6u_1.toString() + ', startsAtEpochMilliseconds=' + this.g6u_1.toString() + ', estimatedDurationSeconds=' + this.h6u_1.toString() + ')';
  }
  hashCode() {
    var result = this.f6u_1.hashCode();
    result = imul(result, 31) + this.g6u_1.hashCode() | 0;
    result = imul(result, 31) + this.h6u_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Maintenance))
      return false;
    if (!equalsLong(this.f6u_1, other.f6u_1))
      return false;
    if (!equalsLong(this.g6u_1, other.g6u_1))
      return false;
    if (!equalsLong(this.h6u_1, other.h6u_1))
      return false;
    return true;
  }
  static i6u(seen0, id, startsAtEpochMilliseconds, estimatedDurationSeconds, serializationConstructorMarker) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_471().d6u_1);
    }
    var $this = createThis(this);
    $this.f6u_1 = id;
    $this.g6u_1 = startsAtEpochMilliseconds;
    $this.h6u_1 = estimatedDurationSeconds;
    return $this;
  }
}
class Companion_561 {
  a2g() {
    var tmp = getKClass(ServerMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Announcement), getKClass(Maintenance)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_470(), $serializer_getInstance_471()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.network.ServerMessage', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_562 {
  constructor() {
    Companion_instance_562 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k6u_1 = [lazy(tmp_0, BeastUserSettingValues$Companion$$childSerializers$_anonymous__53cu9u)];
    this.l6u_1 = _BeastUserSettingValues___init__impl__8n6syv(emptyMap());
  }
}
class $serializer_476 {
  constructor() {
    $serializer_instance_472 = this;
    var tmp0_serialDesc = new InlineClassDescriptor('steelart.beast.network.settings.BeastUserSettingValues', this);
    tmp0_serialDesc.h1b('values', false);
    this.m6u_1 = tmp0_serialDesc;
  }
  n6u(encoder, value) {
    var tmp0_inlineEncoder = encoder.v14(this.m6u_1);
    if (tmp0_inlineEncoder == null)
      null;
    else {
      tmp0_inlineEncoder.h15(new LinkedHashMapSerializer($serializer_getInstance_474(), StringSerializer_getInstance()), _BeastUserSettingValues___get_values__impl__oxd02m(value));
    }
  }
  ez(encoder, value) {
    return this.n6u(encoder, value instanceof BeastUserSettingValues ? value.o6u_1 : THROW_CCE());
  }
  p6u(decoder) {
    return _BeastUserSettingValues___init__impl__8n6syv(decoder.m13(this.m6u_1).o13(new LinkedHashMapSerializer($serializer_getInstance_474(), StringSerializer_getInstance())));
  }
  fz(decoder) {
    return new BeastUserSettingValues(this.p6u(decoder));
  }
  dz() {
    return this.m6u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_563().k6u_1[0].k3()];
  }
}
class BeastUserSettingValues {
  constructor(values) {
    Companion_getInstance_563();
    this.o6u_1 = values;
  }
  toString() {
    return BeastUserSettingValues__toString_impl_duqbrb(this.o6u_1);
  }
  hashCode() {
    return BeastUserSettingValues__hashCode_impl_zf7tey(this.o6u_1);
  }
  equals(other) {
    return BeastUserSettingValues__equals_impl_rue0li(this.o6u_1, other);
  }
}
class Companion_563 {
  constructor() {
    Companion_instance_563 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q6u_1 = [null, lazy(tmp_0, BeastUserSettingsPatch$Companion$$childSerializers$_anonymous__l7dsep)];
  }
}
class $serializer_477 {
  constructor() {
    $serializer_instance_473 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.settings.BeastUserSettingsPatch', this, 2);
    tmp0_serialDesc.h1b('changedValues', false);
    tmp0_serialDesc.h1b('removedKeys', false);
    this.r6u_1 = tmp0_serialDesc;
  }
  s6u(encoder, value) {
    var tmp0_desc = this.r6u_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_564().q6u_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_472(), new BeastUserSettingValues(value.t6u_1));
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.u6u_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s6u(encoder, value instanceof BeastUserSettingsPatch ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r6u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_564().q6u_1;
    if (tmp6_input.e14()) {
      var tmp = $serializer_getInstance_472();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp6_input.b14(tmp0_desc, 0, tmp, tmp_0 == null ? null : new BeastUserSettingValues(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.o6u_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = $serializer_getInstance_472();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp6_input.b14(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new BeastUserSettingValues(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.o6u_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return BeastUserSettingsPatch.v6u(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.r6u_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_564().q6u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_472(), tmp0_cached[1].k3()];
  }
}
class BeastUserSettingsPatch {
  constructor(changedValues, removedKeys) {
    Companion_getInstance_564();
    this.t6u_1 = changedValues;
    this.u6u_1 = removedKeys;
  }
  toString() {
    return 'BeastUserSettingsPatch(changedValues=' + BeastUserSettingValues__toString_impl_duqbrb(this.t6u_1) + ', removedKeys=' + toString(this.u6u_1) + ')';
  }
  hashCode() {
    var result = BeastUserSettingValues__hashCode_impl_zf7tey(this.t6u_1);
    result = imul(result, 31) + hashCode(this.u6u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastUserSettingsPatch))
      return false;
    if (!equals(this.t6u_1, other.t6u_1))
      return false;
    if (!equals(this.u6u_1, other.u6u_1))
      return false;
    return true;
  }
  static v6u(seen0, changedValues, removedKeys, serializationConstructorMarker) {
    Companion_getInstance_564();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_473().r6u_1);
    }
    var $this = createThis(this);
    $this.t6u_1 = changedValues;
    $this.u6u_1 = removedKeys;
    return $this;
  }
}
class Companion_564 {}
class $serializer_478 {
  constructor() {
    $serializer_instance_474 = this;
    var tmp0_serialDesc = new InlineClassDescriptor('steelart.beast.network.settings.BeastUserSettingId', this);
    tmp0_serialDesc.h1b('value', false);
    this.w6u_1 = tmp0_serialDesc;
  }
  x6u(encoder, value) {
    var tmp0_inlineEncoder = encoder.v14(this.w6u_1);
    if (tmp0_inlineEncoder == null)
      null;
    else {
      tmp0_inlineEncoder.t14(_BeastUserSettingId___get_value__impl__836oj0(value));
    }
  }
  ez(encoder, value) {
    return this.x6u(encoder, value instanceof BeastUserSettingId ? value.y6u_1 : THROW_CCE());
  }
  z6u(decoder) {
    return _BeastUserSettingId___init__impl__l8z068(decoder.m13(this.w6u_1).k13());
  }
  fz(decoder) {
    return new BeastUserSettingId(this.z6u(decoder));
  }
  dz() {
    return this.w6u_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class BeastUserSettingId {
  constructor(value) {
    this.y6u_1 = value;
  }
  toString() {
    return BeastUserSettingId__toString_impl_h8i31c(this.y6u_1);
  }
  hashCode() {
    return BeastUserSettingId__hashCode_impl_4intrj(this.y6u_1);
  }
  equals(other) {
    return BeastUserSettingId__equals_impl_kzaj0z(this.y6u_1, other);
  }
}
class UserSetting {
  constructor(id, defaultValue, encode, decode) {
    this.a6v_1 = id;
    this.b6v_1 = defaultValue;
    this.c6v_1 = encode;
    this.d6v_1 = decode;
  }
  e6v(values) {
    var tmp0_safe_receiver = _BeastUserSettingValues___get_values__impl__oxd02m(values).w4(new BeastUserSettingId(this.a6v_1));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.d6v_1(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? this.b6v_1 : tmp1_elvis_lhs;
  }
  f6v(value) {
    return new BeastUserSettingsPatch(_BeastUserSettingValues___init__impl__8n6syv(mapOf_0(to(new BeastUserSettingId(this.a6v_1), this.c6v_1(value)))), emptySet());
  }
}
class BeastUserSettings {
  constructor() {
    BeastUserSettings_instance = this;
    var tmp = this;
    var tmp_0 = _BeastUserSettingId___init__impl__l8z068('AnimationsEnabled');
    var tmp_1 = Boolean$toString$ref();
    tmp.g6v_1 = new UserSetting(tmp_0, true, tmp_1, toBooleanStrictOrNull$ref());
    var tmp_2 = this;
    var tmp_3 = _BeastUserSettingId___init__impl__l8z068('AlwaysPlayPrecisely');
    var tmp_4 = Boolean$toString$ref();
    tmp_2.h6v_1 = new UserSetting(tmp_3, false, tmp_4, toBooleanStrictOrNull$ref());
  }
}
class ReplayTimeline {
  constructor(days) {
    this.i6v_1 = days;
  }
  toString() {
    return 'ReplayTimeline(days=' + toString(this.i6v_1) + ')';
  }
  hashCode() {
    return hashCode(this.i6v_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReplayTimeline))
      return false;
    if (!equals(this.i6v_1, other.i6v_1))
      return false;
    return true;
  }
}
class ReplayTimelineDay {
  constructor(number, fromDawnAnswerIndex, turns, nightAnswerIndex) {
    this.j6v_1 = number;
    this.k6v_1 = fromDawnAnswerIndex;
    this.l6v_1 = turns;
    this.m6v_1 = nightAnswerIndex;
  }
  toString() {
    return 'ReplayTimelineDay(number=' + this.j6v_1 + ', fromDawnAnswerIndex=' + this.k6v_1 + ', turns=' + toString(this.l6v_1) + ', nightAnswerIndex=' + this.m6v_1 + ')';
  }
  hashCode() {
    var result = this.j6v_1;
    result = imul(result, 31) + (this.k6v_1 == null ? 0 : this.k6v_1) | 0;
    result = imul(result, 31) + hashCode(this.l6v_1) | 0;
    result = imul(result, 31) + (this.m6v_1 == null ? 0 : this.m6v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReplayTimelineDay))
      return false;
    if (!(this.j6v_1 === other.j6v_1))
      return false;
    if (!(this.k6v_1 == other.k6v_1))
      return false;
    if (!equals(this.l6v_1, other.l6v_1))
      return false;
    if (!(this.m6v_1 == other.m6v_1))
      return false;
    return true;
  }
}
class ReplayTimelineTurn {
  constructor(number, characters) {
    this.n6v_1 = number;
    this.o6v_1 = characters;
  }
  toString() {
    return 'ReplayTimelineTurn(number=' + this.n6v_1 + ', characters=' + toString(this.o6v_1) + ')';
  }
  hashCode() {
    var result = this.n6v_1;
    result = imul(result, 31) + hashCode(this.o6v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReplayTimelineTurn))
      return false;
    if (!(this.n6v_1 === other.n6v_1))
      return false;
    if (!equals(this.o6v_1, other.o6v_1))
      return false;
    return true;
  }
}
class ReplayTimelineCharacter {
  constructor(character, answerIndex) {
    this.p6v_1 = character;
    this.q6v_1 = answerIndex;
  }
  toString() {
    return 'ReplayTimelineCharacter(character=' + toString(this.p6v_1) + ', answerIndex=' + this.q6v_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.p6v_1);
    result = imul(result, 31) + this.q6v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReplayTimelineCharacter))
      return false;
    if (!equals(this.p6v_1, other.p6v_1))
      return false;
    if (!(this.q6v_1 === other.q6v_1))
      return false;
    return true;
  }
}
class Dawn {
  constructor(day, answerIndex) {
    this.r6v_1 = day;
    this.s6v_1 = answerIndex;
  }
  t6v() {
    return this.r6v_1;
  }
  toString() {
    return 'Dawn(day=' + this.r6v_1 + ', answerIndex=' + this.s6v_1 + ')';
  }
  hashCode() {
    var result = this.r6v_1;
    result = imul(result, 31) + this.s6v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Dawn))
      return false;
    if (!(this.r6v_1 === other.r6v_1))
      return false;
    if (!(this.s6v_1 === other.s6v_1))
      return false;
    return true;
  }
}
class Turn {
  constructor(day, answerIndex, turn, character) {
    this.u6v_1 = day;
    this.v6v_1 = answerIndex;
    this.w6v_1 = turn;
    this.x6v_1 = character;
  }
  t6v() {
    return this.u6v_1;
  }
  toString() {
    return 'Turn(day=' + this.u6v_1 + ', answerIndex=' + this.v6v_1 + ', turn=' + this.w6v_1 + ', character=' + toString(this.x6v_1) + ')';
  }
  hashCode() {
    var result = this.u6v_1;
    result = imul(result, 31) + this.v6v_1 | 0;
    result = imul(result, 31) + this.w6v_1 | 0;
    result = imul(result, 31) + hashCode(this.x6v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Turn))
      return false;
    if (!(this.u6v_1 === other.u6v_1))
      return false;
    if (!(this.v6v_1 === other.v6v_1))
      return false;
    if (!(this.w6v_1 === other.w6v_1))
      return false;
    if (!equals(this.x6v_1, other.x6v_1))
      return false;
    return true;
  }
}
class Night {
  constructor(day, answerIndex) {
    this.y6v_1 = day;
    this.z6v_1 = answerIndex;
  }
  t6v() {
    return this.y6v_1;
  }
  toString() {
    return 'Night(day=' + this.y6v_1 + ', answerIndex=' + this.z6v_1 + ')';
  }
  hashCode() {
    var result = this.y6v_1;
    result = imul(result, 31) + this.z6v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Night))
      return false;
    if (!(this.y6v_1 === other.y6v_1))
      return false;
    if (!(this.z6v_1 === other.z6v_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.f6w_1 = function_0;
  }
  pj(a, b) {
    return this.f6w_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.f6w_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class SandboxGameManager {}
function *submitEventForSandboxGame(gameCode, applyingEventNumber, checkCodeBeforeEvent, event, $completion) {
  // Inline function 'kotlin.error' call
  var message = 'Should not be called';
  throw IllegalStateException.o(toString(message));
}
function startSandboxGame$default(beastAgentControl, huntersAgentControl, gameState, startParams, gameCode, sandboxEventsNumber, sandboxIdCallback, fullCheck, debugOutputSessionConfiguration, $completion, $super) {
  debugOutputSessionConfiguration = debugOutputSessionConfiguration === VOID ? new DebugOutputSessionConfiguration() : debugOutputSessionConfiguration;
  return $super === VOID ? this.i6w(beastAgentControl, huntersAgentControl, gameState, startParams, gameCode, sandboxEventsNumber, sandboxIdCallback, fullCheck, debugOutputSessionConfiguration, $completion) : $super.i6w.call(this, beastAgentControl, huntersAgentControl, gameState, startParams, gameCode, sandboxEventsNumber, sandboxIdCallback, fullCheck, debugOutputSessionConfiguration, $completion);
}
class Companion_565 {}
class $serializer_479 {
  constructor() {
    $serializer_instance_475 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.predefined.InitSandboxResult', this, 2);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('gameState', false);
    this.l6w_1 = tmp0_serialDesc;
  }
  m6w(encoder, value) {
    var tmp0_desc = this.l6w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_441(), value.n6w_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_200(), value.o6w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.m6w(encoder, value instanceof InitSandboxResult ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.l6w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_200(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, $serializer_getInstance_200(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return InitSandboxResult.p6w(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.l6w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_441(), $serializer_getInstance_200()];
  }
}
class InitSandboxResult {
  constructor(gameCode, gameState) {
    this.n6w_1 = gameCode;
    this.o6w_1 = gameState;
  }
  toString() {
    return 'InitSandboxResult(gameCode=' + this.n6w_1.toString() + ', gameState=' + this.o6w_1.toString() + ')';
  }
  hashCode() {
    var result = this.n6w_1.hashCode();
    result = imul(result, 31) + this.o6w_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InitSandboxResult))
      return false;
    if (!this.n6w_1.equals(other.n6w_1))
      return false;
    if (!this.o6w_1.equals(other.o6w_1))
      return false;
    return true;
  }
  static p6w(seen0, gameCode, gameState, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_475().l6w_1);
    }
    var $this = createThis(this);
    $this.n6w_1 = gameCode;
    $this.o6w_1 = gameState;
    return $this;
  }
}
class Companion_566 {}
class $serializer_480 {
  constructor() {
    $serializer_instance_476 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('InternalServerError', this, 1);
    tmp0_serialDesc.h1b('errorNumber', false);
    this.r6w_1 = tmp0_serialDesc;
  }
  s6w(encoder, value) {
    var tmp0_desc = this.r6w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.t6w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.s6w(encoder, value instanceof InternalServerError ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.r6w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return InternalServerError.u6w(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.r6w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class Companion_567 {}
class $serializer_481 {
  constructor() {
    $serializer_instance_477 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SandboxInitMissedSomeEvents', this, 1);
    tmp0_serialDesc.h1b('lastSeenEventNumber', false);
    this.v6w_1 = tmp0_serialDesc;
  }
  w6w(encoder, value) {
    var tmp0_desc = this.v6w_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.x6w_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.w6w(encoder, value instanceof SandboxInitMissedSomeEvents ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.v6w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SandboxInitMissedSomeEvents.y6w(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.v6w_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class Companion_568 {}
class $serializer_482 {
  constructor() {
    $serializer_instance_478 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SandboxInitApplyEventSuccessResult', this, 1);
    tmp0_serialDesc.h1b('checkCode', false);
    this.a6x_1 = tmp0_serialDesc;
  }
  b6x(encoder, value) {
    var tmp0_desc = this.a6x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_201(), value.c6x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.b6x(encoder, value instanceof SandboxInitApplyEventSuccessResult ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.a6x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_201(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_201(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SandboxInitApplyEventSuccessResult.d6x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.a6x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_201()];
  }
}
class SandboxInitApplyEventResult {}
class SandboxInitWasNotFound {
  constructor() {
    SandboxInitWasNotFound_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q6w_1 = lazy(tmp_0, SandboxInitApplyEventResult$SandboxInitWasNotFound$_anonymous__1g2bbi);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_559(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SandboxInitWasNotFound';
  }
  hashCode() {
    return 620503602;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxInitWasNotFound))
      return false;
    return true;
  }
}
class InternalServerError {
  constructor(errorNumber) {
    this.t6w_1 = errorNumber;
  }
  toString() {
    return 'InternalServerError(errorNumber=' + this.t6w_1 + ')';
  }
  hashCode() {
    return this.t6w_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InternalServerError))
      return false;
    if (!(this.t6w_1 === other.t6w_1))
      return false;
    return true;
  }
  static u6w(seen0, errorNumber, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_476().r6w_1);
    }
    var $this = createThis(this);
    $this.t6w_1 = errorNumber;
    return $this;
  }
}
class SandboxInitMissedSomeEvents {
  constructor(lastSeenEventNumber) {
    this.x6w_1 = lastSeenEventNumber;
  }
  toString() {
    return 'SandboxInitMissedSomeEvents(lastSeenEventNumber=' + this.x6w_1 + ')';
  }
  hashCode() {
    return this.x6w_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxInitMissedSomeEvents))
      return false;
    if (!(this.x6w_1 === other.x6w_1))
      return false;
    return true;
  }
  static y6w(seen0, lastSeenEventNumber, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_477().v6w_1);
    }
    var $this = createThis(this);
    $this.x6w_1 = lastSeenEventNumber;
    return $this;
  }
}
class SandboxInitInvalidCheckCodes {
  constructor() {
    SandboxInitInvalidCheckCodes_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z6w_1 = lazy(tmp_0, SandboxInitApplyEventResult$SandboxInitInvalidCheckCodes$_anonymous__dkso0l);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_560(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SandboxInitInvalidCheckCodes';
  }
  hashCode() {
    return -366275185;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxInitInvalidCheckCodes))
      return false;
    return true;
  }
}
class SandboxInitApplyEventSuccessResult {
  constructor(checkCode) {
    this.c6x_1 = checkCode;
  }
  toString() {
    return 'SandboxInitApplyEventSuccessResult(checkCode=' + this.c6x_1.toString() + ')';
  }
  hashCode() {
    return this.c6x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxInitApplyEventSuccessResult))
      return false;
    if (!this.c6x_1.equals(other.c6x_1))
      return false;
    return true;
  }
  static d6x(seen0, checkCode, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_478().a6x_1);
    }
    var $this = createThis(this);
    $this.c6x_1 = checkCode;
    return $this;
  }
}
class Companion_569 {
  a2g() {
    var tmp = getKClass(SandboxInitApplyEventResult);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(InternalServerError), getKClass(SandboxInitApplyEventSuccessResult), getKClass(SandboxInitInvalidCheckCodes), getKClass(SandboxInitMissedSomeEvents), getKClass(SandboxInitWasNotFound)];
    var tmp_1 = $serializer_getInstance_476();
    var tmp_2 = $serializer_getInstance_478();
    var tmp_3 = SandboxInitInvalidCheckCodes_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_4 = ObjectSerializer.l1c('SandboxInitInvalidCheckCodes', tmp_3, tmp$ret$3);
    var tmp_5 = $serializer_getInstance_477();
    var tmp_6 = SandboxInitWasNotFound_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_7 = [tmp_1, tmp_2, tmp_4, tmp_5, ObjectSerializer.l1c('SandboxInitWasNotFound', tmp_6, tmp$ret$6)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    return SealedClassSerializer.i10('steelart.beast.predefined.SandboxInitApplyEventResult', tmp, tmp_0, tmp_7, tmp$ret$12);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_570 {
  constructor() {
    Companion_instance_570 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e6x_1 = [lazy(tmp_0, SandboxStartParams$Companion$$childSerializers$_anonymous__kvx71l), null];
  }
}
class $serializer_483 {
  constructor() {
    $serializer_instance_479 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.predefined.SandboxStartParams', this, 2);
    tmp0_serialDesc.h1b('gamePhase', false);
    tmp0_serialDesc.h1b('dayNumber', false);
    this.f6x_1 = tmp0_serialDesc;
  }
  g6x(encoder, value) {
    var tmp0_desc = this.f6x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_571().e6x_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.h6x_1);
    tmp1_output.z14(tmp0_desc, 1, value.i6x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.g6x(encoder, value instanceof SandboxStartParams ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.f6x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_571().e6x_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, tmp7_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return SandboxStartParams.j6x(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.f6x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_571().e6x_1[0].k3(), IntSerializer_getInstance()];
  }
}
class SandboxStartParams {
  constructor(gamePhase, dayNumber) {
    Companion_getInstance_571();
    this.h6x_1 = gamePhase;
    this.i6x_1 = dayNumber;
  }
  toString() {
    return 'SandboxStartParams(gamePhase=' + toString(this.h6x_1) + ', dayNumber=' + this.i6x_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.h6x_1);
    result = imul(result, 31) + this.i6x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxStartParams))
      return false;
    if (!equals(this.h6x_1, other.h6x_1))
      return false;
    if (!(this.i6x_1 === other.i6x_1))
      return false;
    return true;
  }
  static j6x(seen0, gamePhase, dayNumber, serializationConstructorMarker) {
    Companion_getInstance_571();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_479().f6x_1);
    }
    var $this = createThis(this);
    $this.h6x_1 = gamePhase;
    $this.i6x_1 = dayNumber;
    return $this;
  }
}
class Companion_571 {}
class $serializer_484 {
  constructor() {
    $serializer_instance_480 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SandboxGameStarted', this, 1);
    tmp0_serialDesc.h1b('gameCode', false);
    this.k6x_1 = tmp0_serialDesc;
  }
  l6x(encoder, value) {
    var tmp0_desc = this.k6x_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_441(), value.m6x_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.l6x(encoder, value instanceof SandboxGameStarted ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.k6x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_441(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SandboxGameStarted.n6x(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.k6x_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_441()];
  }
}
class StartSandboxResult {}
class SandboxGameStarted {
  constructor(gameCode) {
    this.m6x_1 = gameCode;
  }
  toString() {
    return 'SandboxGameStarted(gameCode=' + this.m6x_1.toString() + ')';
  }
  hashCode() {
    return this.m6x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxGameStarted))
      return false;
    if (!this.m6x_1.equals(other.m6x_1))
      return false;
    return true;
  }
  static n6x(seen0, gameCode, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_480().k6x_1);
    }
    var $this = createThis(this);
    $this.m6x_1 = gameCode;
    return $this;
  }
}
class SandboxInitInvalidCheckCodes_0 {
  constructor() {
    SandboxInitInvalidCheckCodes_instance_0 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o6x_1 = lazy(tmp_0, StartSandboxResult$SandboxInitInvalidCheckCodes$_anonymous__ri70y1);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_561(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SandboxInitInvalidCheckCodes';
  }
  hashCode() {
    return -38940153;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxInitInvalidCheckCodes_0))
      return false;
    return true;
  }
}
class SandboxInitWasNotFound_0 {
  constructor() {
    SandboxInitWasNotFound_instance_0 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p6x_1 = lazy(tmp_0, StartSandboxResult$SandboxInitWasNotFound$_anonymous__xacoz0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_562(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SandboxInitWasNotFound';
  }
  hashCode() {
    return -830236502;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxInitWasNotFound_0))
      return false;
    return true;
  }
}
class Companion_572 {
  a2g() {
    var tmp = getKClass(StartSandboxResult);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(SandboxGameStarted), getKClass(SandboxInitInvalidCheckCodes_0), getKClass(SandboxInitWasNotFound_0)];
    var tmp_1 = $serializer_getInstance_480();
    var tmp_2 = SandboxInitInvalidCheckCodes_getInstance_0();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_3 = ObjectSerializer.l1c('SandboxInitInvalidCheckCodes', tmp_2, tmp$ret$3);
    var tmp_4 = SandboxInitWasNotFound_getInstance_0();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_5 = [tmp_1, tmp_3, ObjectSerializer.l1c('SandboxInitWasNotFound', tmp_4, tmp$ret$6)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    return SealedClassSerializer.i10('steelart.beast.predefined.StartSandboxResult', tmp, tmp_0, tmp_5, tmp$ret$12);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class AnotherAnswerReaction extends Enum {}
class AnimationInsertion {}
class MapUiScalingAndPosition {
  constructor(x, y, scale, animationType) {
    animationType = animationType === VOID ? AnimationInsertionType_AfterAnswer_getInstance() : animationType;
    this.q6x_1 = x;
    this.r6x_1 = y;
    this.s6x_1 = scale;
    this.t6x_1 = animationType;
  }
  u6x() {
    return this.t6x_1;
  }
  jm() {
    return this.q6x_1;
  }
  km() {
    return this.r6x_1;
  }
  fx() {
    return this.s6x_1;
  }
  toString() {
    return 'MapUiScalingAndPosition(x=' + this.q6x_1 + ', y=' + this.r6x_1 + ', scale=' + this.s6x_1 + ', animationType=' + this.t6x_1.toString() + ')';
  }
  hashCode() {
    var result = this.q6x_1;
    result = imul(result, 31) + this.r6x_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.s6x_1) | 0;
    result = imul(result, 31) + this.t6x_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapUiScalingAndPosition))
      return false;
    if (!(this.q6x_1 === other.q6x_1))
      return false;
    if (!(this.r6x_1 === other.r6x_1))
      return false;
    if (!equals(this.s6x_1, other.s6x_1))
      return false;
    if (!this.t6x_1.equals(other.t6x_1))
      return false;
    return true;
  }
}
class PursuitHunterSearchAndAttackAnswer {
  constructor() {
    PursuitHunterSearchAndAttackAnswer_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v6x_1 = lazy(tmp_0, PursuitHunterSearchAndAttackAnswer$_anonymous__9yawh0);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_563(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PursuitHunterSearchAndAttackAnswer';
  }
  hashCode() {
    return 652561342;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PursuitHunterSearchAndAttackAnswer))
      return false;
    return true;
  }
}
class PursuitHunterGainItemAndAttackSummon {
  constructor() {
    PursuitHunterGainItemAndAttackSummon_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w6x_1 = lazy(tmp_0, PursuitHunterGainItemAndAttackSummon$_anonymous__uabef7);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_564(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'PursuitHunterGainItemAndAttackSummon';
  }
  hashCode() {
    return 1787376599;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PursuitHunterGainItemAndAttackSummon))
      return false;
    return true;
  }
}
class AnimationInsertionType extends Enum {}
class SimpleSavedAnswersSource {
  constructor(predefinedAnswersParam, startFromIndex) {
    predefinedAnswersParam = predefinedAnswersParam === VOID ? emptyList() : predefinedAnswersParam;
    startFromIndex = startFromIndex === VOID ? 0 : startFromIndex;
    this.x6x_1 = startFromIndex;
    this.y6x_1 = toMutableList(predefinedAnswersParam);
  }
  z6x() {
    return this.x6x_1;
  }
  a6y() {
    return this.y6x_1;
  }
  b6y() {
    return this.x6x_1 < this.y6x_1.s2();
  }
  c6y(answer) {
    // Inline function 'kotlin.require' call
    if (!(this.x6x_1 === this.y6x_1.s2())) {
      var message = 'Predefined answers already filled: currentIndex = ' + this.x6x_1 + ', predefinedAnswers size = ' + this.y6x_1.s2();
      throw IllegalArgumentException.h2(toString(message));
    }
    this.y6x_1.d2(answer);
  }
  d6y(hasToBeLast) {
    if (this.x6x_1 === this.y6x_1.s2()) {
      this.x6x_1 = this.x6x_1 - 1 | 0;
    }
    var last = removeLast(this.y6x_1);
    // Inline function 'kotlin.require' call
    if (!equals(last, hasToBeLast)) {
      var message = 'Last predefined answer is not ' + toString_0(hasToBeLast) + ', instead it is ' + toString_0(last);
      throw IllegalArgumentException.h2(toString(message));
    }
  }
  e6y() {
    if (this.x6x_1 >= this.y6x_1.s2())
      return emptyList();
    var answer = this.y6x_1.u2(this.x6x_1);
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList.p2();
    $l$loop: while (true) {
      var tmp;
      if (!(answer == null) ? isInterface(answer, AnimationInsertion) : false) {
        tmp = answer.u6x().equals(AnimationInsertionType_AfterAnswer_getInstance());
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      result.d2(answer);
      this.x6x_1 = this.x6x_1 + 1 | 0;
      answer = getOrNull(this.y6x_1, this.x6x_1);
    }
    return result;
  }
  *q6t($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, $completion) {
    var answer = yield* this.f6y($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, $completion);
    this.g6y();
    return answer;
  }
  *f6y($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, $completion) {
    if (!this.b6y()) {
      throw ReplayIsFinishedException.j3q();
    }
    return this.y6x_1.u2(this.x6x_1);
  }
  g6y() {
    if (!this.b6y()) {
      throw ReplayIsFinishedException.j3q();
    }
    this.x6x_1 = this.x6x_1 + 1 | 0;
  }
}
class LogicalAnimationInsertion {}
class ShowLocationAnimation {}
class ShowFromPossibleAnswer {}
class ShowFromDraft {}
class AdjustedSavedAnswer {}
class StartPhaseMarker {}
class StartTurnReplayMarker {}
class BeastGameI18n {
  constructor() {
    this.i6y_1 = 'How to play';
    this.j6y_1 = "Quixote's Tournament Replays";
    this.k6y_1 = 'Sandbox';
    this.l6y_1 = 'Start game';
    this.m6y_1 = 'New Server duel game';
    this.n6y_1 = 'New Hot Seat game';
    this.o6y_1 = 'Load game';
    this.p6y_1 = 'Offline game recording';
    this.q6y_1 = 'Menu';
    this.r6y_1 = 'Exit to main menu';
    this.s6y_1 = 'Show contract';
    this.t6y_1 = 'Discard';
    this.u6y_1 = 'Beasts';
    this.v6y_1 = 'Hunters';
    this.w6y_1 = 'Restore dialog';
    this.x6y_1 = 'Pass';
    this.y6y_1 = 'Finish';
    this.z6y_1 = 'End move';
    this.a6z_1 = 'No target';
    this.b6z_1 = 'Skip';
    this.c6z_1 = 'None';
    this.d6z_1 = 'Choose Ancient Powers to spend';
    this.e6z_1 = 'Choose location type';
    this.f6z_1 = 'Choose upgrade';
    this.g6z_1 = 'Finish upgrades';
    this.h6z_1 = 'Finish Hunters\u2019 upgrades';
    this.i6z_1 = 'Finish Beasts\u2019 upgrades';
    this.j6z_1 = 'Choose card to play';
    this.k6z_1 = 'Choose Zone';
    this.l6z_1 = 'Choose where transform';
    this.m6z_1 = 'Enough';
    this.n6z_1 = 'Choose relocating object';
    this.o6z_1 = 'Choose search location';
    this.p6z_1 = 'Choose destination';
    this.q6z_1 = 'Choose a false movement';
    this.r6z_1 = 'Choose Trap by order of placing';
    this.s6z_1 = 'Choose a settler to move';
    this.t6z_1 = 'Search your location and attack';
    this.u6z_1 = 'Gain a hunter Item and attack a nearby Summon';
    this.v6z_1 = 'Do nothing';
    this.w6z_1 = 'Make movement';
    this.x6z_1 = 'Summon';
    this.y6z_1 = mapOf([to(GameMapId_LowerShatteredIsles_getInstance(), mapOf([to(new BoardPosition(LowerShatteredRuins_getInstance().x5m_1), 'Yagi Cliffs'), to(new BoardPosition(LowerShatteredRuins_getInstance().y5m_1), "Admirer's Glade"), to(new BoardPosition(LowerShatteredRuins_getInstance().z5m_1), 'Sunken Ruins')])), to(GameMapId_UpperShatteredIsles_getInstance(), mapOf([to(new BoardPosition(UpperShatteredRuins_getInstance().j6a_1), 'The High Peaks'), to(new BoardPosition(UpperShatteredRuins_getInstance().k6a_1), "Admirer's Glade"), to(new BoardPosition(UpperShatteredRuins_getInstance().l6a_1), 'Abyssal Spire')]))]);
    this.z6z_1 = 'Modify Contract';
    this.a70_1 = 'Balance Version';
    this.b70_1 = 'Content Version';
    this.c70_1 = 'Beast Grudges';
    this.d70_1 = 'Hunter Grudges';
    this.e70_1 = 'Bonus Talents';
    this.f70_1 = '2-Players Draft';
    this.g70_1 = 'Apply';
    this.h70_1 = 'Use master fixing to repair the state, or revert the turn.';
    this.i70_1 = 'An internal error interrupted the phase.\n' + (this.h70_1 + ' After fixing, choose the next phase to continue.');
    this.j70_1 = 'An internal error interrupted this operation.\n' + (this.h70_1 + ' After fixing, continue to abandon the rest of this operation.');
  }
  k70(name) {
    return 'Pick an Action Card for ' + name;
  }
  l70(team) {
    return 'Waiting for ' + this.m70(team) + ' to finish their draft choices';
  }
  n70(team) {
    return this.m70(team) + ' have finished their choices for this draft round';
  }
  o70(draft, characterTeams) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = draft.r4m_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = characterTeams.u2(item);
      destination.d2(tmp$ret$2);
    }
    var choosingTeams = toSet(destination);
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf_0([new GameTeam(get_beastsGameTeam()), new GameTeam(get_huntersGameTeam())]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item_0 = _iterator__ex2g4s_0.r1();
      var team = item_0.r3p_1;
      var tmp;
      if (choosingTeams.w2(new GameTeam(team)) && draft.s4m_1) {
        tmp = 'discarding cards';
      } else {
        if (choosingTeams.w2(new GameTeam(team)) && equals(draft.u4m_1, TwoPlayerDraftStage_Dividing_getInstance())) {
          tmp = 'dividing cards';
        } else {
          if (choosingTeams.w2(new GameTeam(team))) {
            tmp = 'choosing cards';
          } else {
            var tmp_0;
            if (equals(draft.u4m_1, TwoPlayerDraftStage_Collecting_getInstance())) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              tmp_0 = !choosingTeams.n1();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp = 'waiting for next pick';
            } else {
              if (draft.s4m_1) {
                tmp = 'discard choices complete';
              } else {
                if (equals(draft.u4m_1, TwoPlayerDraftStage_Dividing_getInstance())) {
                  tmp = 'cards chosen';
                } else {
                  tmp = 'cards chosen for this round';
                }
              }
            }
          }
        }
      }
      var status = tmp;
      var tmp$ret$5 = this.m70(team) + ': ' + status;
      destination_0.d2(tmp$ret$5);
    }
    var lines = destination_0;
    return 'Draft\n' + joinToString(lines, '\n');
  }
  p70(name) {
    return 'Choose an Action Card from ' + name + ' to Discard';
  }
  q70(name) {
    return 'Choose an Action Card from ' + name + ' to return to Unused';
  }
  r70(objectType) {
    return 'Where transform to place ' + this.s70(objectType);
  }
  t70(name) {
    return name + ' is moving';
  }
  u70(name) {
    return 'Move ' + name;
  }
  v70($context_GameState_t6qee5, statement) {
    var attacker = statement.k2q_1;
    var name = this.s70(get_objectType($context_GameState_t6qee5, attacker));
    var tmp$ret$0;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, attacker);
      if (isInterface(tmp, Character)) {
        tmp$ret$0 = attacker instanceof ObjectOnBoard ? attacker : THROW_CCE();
        break $l$block;
      }
      tmp$ret$0 = null;
    }
    var characterAttacker = tmp$ret$0;
    var tmp0_subject = statement.l2q_1;
    var tmp_0;
    if (tmp0_subject instanceof OnlyNearSummonsAttackModifier) {
      tmp_0 = 'Attack nearby Summon';
    } else {
      if (tmp0_subject instanceof JustNearbyAttackModifier) {
        tmp_0 = 'Attack nearby target';
      } else {
        if (tmp0_subject instanceof BonusDamageAttackModifier) {
          tmp_0 = 'Attack (+1 damage)';
        } else {
          if (tmp0_subject instanceof FeastCardAttackModifier) {
            tmp_0 = 'Attack (+1 damage against Animals)';
          } else {
            if (tmp0_subject instanceof NearSummonsAndBeastAttackModifier) {
              tmp_0 = 'Attack nearby Summon or Beast';
            } else {
              if (tmp0_subject instanceof PetrifyAttackModifier) {
                tmp_0 = 'Attack nearby Hunter';
              } else {
                if (tmp0_subject instanceof OnlyAnimalsAttackModifier) {
                  tmp_0 = 'Attack Animal';
                } else {
                  if (tmp0_subject instanceof AngerIncinerateAttackModifier) {
                    tmp_0 = 'Incinerate';
                  } else {
                    if (tmp0_subject == null) {
                      tmp_0 = 'Attack';
                    } else {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    var attackPrefix = tmp_0;
    var tmp_1;
    if (!(characterAttacker == null) && isActiveCharacter_0($context_GameState_t6qee5, characterAttacker)) {
      tmp_1 = attackPrefix;
    } else {
      tmp_1 = attackPrefix + ' by ' + name;
    }
    return tmp_1;
  }
  w70(number) {
    switch (number) {
      case 1:
        return 'First Trap';
      case 2:
        return 'Second Trap';
      case 3:
        return 'Third Trap';
      default:
        return 'Trap ' + number;
    }
  }
  x70($context_GameState_t6qee5, movingObject) {
    return this.s70(get_objectType($context_GameState_t6qee5, movingObject)) + ' is relocating';
  }
  y70(beastCharacter) {
    return this.s70(beastCharacter) + ' reveals';
  }
  s70(objectType) {
    return removeSuffix(ensureNotNull(getKClassFromExpression(objectType).j1()), 'Type');
  }
  z70($context_GameState_t6qee5, phase) {
    var tmp;
    if (isInterface(phase, ContractInitPhase)) {
      tmp = 'Contract specific setup';
    } else {
      if (phase instanceof InitialPhase) {
        tmp = 'Start of the game';
      } else {
        if (phase instanceof DawnPhase) {
          tmp = phase.c4h_1 ? 'Dawn (predefined draft)' : 'Dawn (draft)';
        } else {
          if (phase instanceof StartOfDayPhase) {
            tmp = 'Start of Day';
          } else {
            if (phase instanceof NightPhase) {
              tmp = 'Night';
            } else {
              if (phase instanceof PlayerTurnPhase) {
                var objectName = this.s70(get_objectType($context_GameState_t6qee5, phase.x4g_1));
                tmp = phase.y4g_1 ? 'Turn of mesmerized ' + objectName : 'Turn of ' + objectName;
              } else {
                tmp = null;
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  a71(rewarding) {
    return 'Reward for ' + this.m70(rewarding);
  }
  b71(winnerTeam) {
    return 'The winner: ' + this.m70(winnerTeam);
  }
  m70(gameTeam) {
    return gameTeam === get_observerGameTeamMarker() ? 'Observer' : gameTeam === get_fullObserverGameTeamMarker() ? 'Full Observer' : gameTeam === get_huntersGameTeam() ? 'Hunters' : 'Beasts';
  }
  c71(zone) {
    return zone.toString();
  }
  d71(gameRules) {
    var tmp;
    if (gameRules instanceof RecoveryTestContract) {
      tmp = 'Recovery test';
    } else {
      if (gameRules instanceof GreatCleansingContract) {
        tmp = 'The Great Cleansing';
      } else {
        if (gameRules instanceof PactLongForgottenContract) {
          tmp = 'Pact Long Forgotten';
        } else {
          if (gameRules instanceof RegentOfRuinsContract) {
            tmp = 'Regent of Ruins';
          } else {
            if (gameRules instanceof ArrivalOfTheTitanContract) {
              tmp = 'Arrival of the Titan';
            } else {
              if (gameRules instanceof ShipwreckContract) {
                tmp = 'Shipwreck';
              } else {
                if (gameRules instanceof SecretsFromALostAgeContract) {
                  tmp = 'Secrets from a Lost Age';
                } else {
                  if (gameRules instanceof UnleashingTheAbyssContract) {
                    tmp = 'Unleashing the Abyss';
                  } else {
                    if (gameRules instanceof AttackOnTheNorthernSettlementsContract) {
                      tmp = 'Attack on the Northern Settlements';
                    } else {
                      if (gameRules instanceof DisturbanceOfTheNorthernGodsContract) {
                        tmp = 'Disturbance of the Northern Gods';
                      } else {
                        if (gameRules instanceof AshfallUnlikelyAllianceContract) {
                          tmp = 'Ashfall Unlikely Alliance';
                        } else {
                          if (gameRules instanceof UnlikelyAllianceContract) {
                            tmp = 'Unlikely Alliance';
                          } else {
                            noWhenBranchMatchedException();
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  e71($context_GameState_t6qee5, ruinPosition) {
    var tmp;
    var tmp_0 = ruinPosition;
    if ((tmp_0 == null ? null : new BoardPosition(tmp_0)) == null) {
      tmp = null;
    } else {
      var tmp_1 = ruinPosition;
      // Inline function 'kotlin.let' call
      var it = (tmp_1 == null ? null : new BoardPosition(tmp_1)).r2v_1;
      tmp = ruinName(this, $context_GameState_t6qee5, it);
    }
    var ruinName_0 = tmp;
    return !(ruinName_0 == null) ? 'Claim ' + ruinName_0 : 'Claim Ruin';
  }
  f71(gameRules) {
    if (!get_gameContentVersion(gameRules).h4g()) {
      return null;
    }
    var tmp;
    if (gameRules.c3a().z4f_1) {
      tmp = 'Alternative Beast setup is enabled';
    } else {
      tmp = 'Alternative Beast setup is disabled';
    }
    return tmp;
  }
  g71(booleanGameQuestion) {
    var tmp;
    if (equals(booleanGameQuestion, PlayOverloadedQuestion_getInstance())) {
      tmp = 'Play overloaded variant?';
    } else {
      if (equals(booleanGameQuestion, RevealToMoveQuestion_getInstance())) {
        tmp = 'Reveal to move?';
      } else {
        if (booleanGameQuestion instanceof UseVackerSoulsQuestion) {
          tmp = 'Spend ' + booleanGameQuestion.a48_1 + ' Souls to amplify ability?';
        } else {
          if (booleanGameQuestion instanceof SpendValdiBloodQuestion) {
            tmp = 'Spend ' + booleanGameQuestion.s6f_1 + ' Blood to amplify ability?';
          } else {
            if (booleanGameQuestion instanceof SpendLydanHarvestQuestion) {
              tmp = 'Spend ' + booleanGameQuestion.o5n_1 + ' Harvest to amplify ability?';
            } else {
              if (equals(booleanGameQuestion, PlaceHatchlingWithInfestQuestion_getInstance())) {
                tmp = 'Use Infest to place a Hatchling instead?';
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  h71(questionContext) {
    if (questionContext == null)
      return null;
    var tmp;
    if (questionContext instanceof CardToDiscardQuestionContext) {
      tmp = 'Choose card to discard';
    } else {
      if (questionContext instanceof ArsenalCardToGainQuestionContext) {
        tmp = 'Choose arsenal card to gain';
      } else {
        if (questionContext instanceof BeastlyTalentToPlayQuestionContext) {
          tmp = 'Choose Beastly Talent to play';
        } else {
          if (questionContext instanceof HunterItemToPlayQuestionContext) {
            tmp = 'Choose Hunter Item to play';
          } else {
            if (questionContext instanceof DiscardedAbilityCardToRetrieveQuestionContext) {
              tmp = 'Choose discarded Ability to retrieve';
            } else {
              if (questionContext instanceof DiscardedDraftActionCardToRetrieveQuestionContext) {
                tmp = 'Choose discarded Action card to retrieve';
              } else {
                if (questionContext instanceof HunterItemToGiveByRuinQuestionContext) {
                  tmp = 'Choose Hunter Item to give';
                } else {
                  if (questionContext instanceof HunterItemToExchangeByRuinQuestionContext) {
                    tmp = 'Choose Hunter Item to exchange';
                  } else {
                    if (questionContext instanceof UnusedDraftActionCardToRetrieveQuestionContext) {
                      tmp = 'Choose unused Action card to retrieve';
                    } else {
                      if (questionContext instanceof TargetToMoveQuestionContext) {
                        tmp = 'Choose target to move';
                      } else {
                        if (questionContext instanceof SettlerToMoveQuestionContext) {
                          tmp = 'Choose settler to move';
                        } else {
                          if (questionContext instanceof TargetToBlockDamageForQuestionContext) {
                            tmp = 'Choose target to block damage for';
                          } else {
                            if (questionContext instanceof BeingToMoveAlongsideQuestionContext) {
                              tmp = 'Choose being to move alongside';
                            } else {
                              if (questionContext instanceof HunterToGiveChainGrapnelQuestionContext) {
                                tmp = 'Choose Hunter to give the Chain Grapnel';
                              } else {
                                if (questionContext instanceof HunterToMoveQuestionContext) {
                                  tmp = 'Choose Hunter to move';
                                } else {
                                  if (questionContext instanceof BeastToGainBeastlyTalentQuestionContext) {
                                    tmp = 'Choose Beast to gain Beastly Talent';
                                  } else {
                                    if (questionContext instanceof AnimalToMoveQuestionContext) {
                                      tmp = 'Choose Animal to move';
                                    } else {
                                      if (questionContext instanceof SummonToMoveQuestionContext) {
                                        tmp = 'Choose Summon to move';
                                      } else {
                                        if (questionContext instanceof SummonToReplaceQuestionContext) {
                                          tmp = 'Choose Summon to replace';
                                        } else {
                                          if (questionContext instanceof OutpostToReplaceQuestionContext) {
                                            tmp = 'Choose Outpost to replace';
                                          } else {
                                            if (questionContext instanceof SummonToAttackWithQuestionContext) {
                                              tmp = 'Choose Summon to attack with';
                                            } else {
                                              if (questionContext instanceof SummonToActivateQuestionContext) {
                                                tmp = 'Choose Summon to activate';
                                              } else {
                                                if (questionContext instanceof NobleToFarmerQuestionContext) {
                                                  tmp = 'Choose Noble to convert him to Farmer';
                                                } else {
                                                  if (questionContext instanceof HunterToPerformEffectQuestionContext) {
                                                    tmp = 'Choose Hunter to perform the effect';
                                                  } else {
                                                    if (questionContext instanceof TargetToPullQuestionContext) {
                                                      tmp = 'Choose target to pull';
                                                    } else {
                                                      if (questionContext instanceof HunterToMesmeriseQuestionContext) {
                                                        tmp = 'Choose Hunter to mesmerise';
                                                      } else {
                                                        if (questionContext instanceof HunterToStealGrudgeQuestionContext) {
                                                          tmp = 'Choose Hunter to steal a Grudge from';
                                                        } else {
                                                          if (questionContext instanceof DreamerToSacrificeQuestionContext) {
                                                            tmp = 'Choose dreamer to sacrifice';
                                                          } else {
                                                            if (questionContext instanceof BoarToMoveQuestionContext) {
                                                              tmp = 'Choose Boar to move';
                                                            } else {
                                                              if (questionContext instanceof BoarToTransformQuestionContext) {
                                                                tmp = 'Choose Boar to transform';
                                                              } else {
                                                                if (questionContext instanceof TargetToSpendAncientPowersOnQuestionContext) {
                                                                  tmp = 'Choose a target to spend Ancient Powers on';
                                                                } else {
                                                                  if (questionContext instanceof TargetToRamQuestionContext) {
                                                                    tmp = 'Choose target to ram';
                                                                  } else {
                                                                    if (questionContext instanceof HunterToSkipNextTurnQuestionContext) {
                                                                      tmp = 'Choose Hunter to skip next turn';
                                                                    } else {
                                                                      if (questionContext instanceof ActorForRamQuestionContext) {
                                                                        tmp = 'Choose who will Ram';
                                                                      } else {
                                                                        if (questionContext instanceof SettlerQuestionContext) {
                                                                          tmp = 'Choose Settler';
                                                                        } else {
                                                                          if (questionContext instanceof BeastToPerformEffectQuestionContext) {
                                                                            tmp = 'Choose Beast to perform the effect';
                                                                          } else {
                                                                            if (questionContext instanceof FarmerToNobleQuestionContext) {
                                                                              tmp = 'Choose Farmer to convert him to Noble';
                                                                            } else {
                                                                              if (questionContext instanceof TargetToHealQuestionContext) {
                                                                                tmp = 'Choose whom to heal';
                                                                              } else {
                                                                                if (questionContext instanceof TargetToDamageQuestionContext) {
                                                                                  tmp = 'Choose whom to damage';
                                                                                } else {
                                                                                  if (questionContext instanceof HunterToCopyFirstRedCardQuestionContext) {
                                                                                    tmp = 'Choose character to copy first red card from';
                                                                                  } else {
                                                                                    if (questionContext instanceof VictimToProtectQuestionContext) {
                                                                                      tmp = 'Choose victim to protect';
                                                                                    } else {
                                                                                      if (questionContext instanceof AttackTargetQuestionContext) {
                                                                                        tmp = 'Choose attack target';
                                                                                      } else {
                                                                                        if (questionContext instanceof HandInspectTargetQuestionContext) {
                                                                                          tmp = 'Choose character whose hand to inspect';
                                                                                        } else {
                                                                                          if (questionContext instanceof CardToCopyForDeceiveQuestionContext) {
                                                                                            tmp = 'Choose card to copy effect from';
                                                                                          } else {
                                                                                            if (questionContext instanceof HunterToRelocateQuestionContext) {
                                                                                              tmp = 'Choose Hunter to relocate';
                                                                                            } else {
                                                                                              if (questionContext instanceof HunterToReturnQuestionContext) {
                                                                                                tmp = 'Choose Hunter to return';
                                                                                              } else {
                                                                                                if (questionContext instanceof RandomResultQuestionContext) {
                                                                                                  tmp = 'Choose random result (#' + questionContext.d4d_1 + ')';
                                                                                                } else {
                                                                                                  if (questionContext instanceof BeingRelocatingByGrapnelQuestionContext) {
                                                                                                    tmp = 'Choose being that will relocate';
                                                                                                  } else {
                                                                                                    if (questionContext instanceof TrapToPlayForTrapmasterQuestionContext) {
                                                                                                      tmp = 'Choose Trap to play';
                                                                                                    } else {
                                                                                                      if (questionContext instanceof TargetToRunFromFireQuestionContext) {
                                                                                                        tmp = 'Choose target to run from fire';
                                                                                                      } else {
                                                                                                        if (questionContext instanceof SummonToSacrificeQuestionContext) {
                                                                                                          tmp = 'Choose Summon to sacrifice';
                                                                                                        } else {
                                                                                                          if (questionContext instanceof RhagnerCardGainHoardQuestionContext) {
                                                                                                            tmp = 'Choose Rhagner card to gain Hoard';
                                                                                                          } else {
                                                                                                            if (questionContext instanceof RhagnerCardLoseHoardQuestionContext) {
                                                                                                              tmp = 'Choose Rhagner card to lose Hoard';
                                                                                                            } else {
                                                                                                              if (questionContext instanceof LocationForFireQuestionContext) {
                                                                                                                tmp = 'Choose a location to place a fire';
                                                                                                              } else {
                                                                                                                if (questionContext instanceof LocationToTransformAndFireQuestionContext) {
                                                                                                                  tmp = 'Choose a location to transform and fire';
                                                                                                                } else {
                                                                                                                  if (questionContext instanceof LocationToIncinerateQuestionContext) {
                                                                                                                    tmp = 'Choose a location to Incinerate';
                                                                                                                  } else {
                                                                                                                    if (questionContext instanceof AnimalToSearchWithQuestionContext) {
                                                                                                                      tmp = 'Choose Animal that will search';
                                                                                                                    } else {
                                                                                                                      if (questionContext instanceof SheepForMoveAndAttackQuestionContext) {
                                                                                                                        tmp = 'Choose a Sheep that will move and attack';
                                                                                                                      } else {
                                                                                                                        if (questionContext instanceof BarrierFirstPositionQuestionContext) {
                                                                                                                          tmp = 'Choose a location to place a Barrier in adjusted path';
                                                                                                                        } else {
                                                                                                                          if (questionContext instanceof HunterItemToDiscardFromArsenalQuestionContext) {
                                                                                                                            tmp = 'Choose Hunter Item to discard from Arsenal';
                                                                                                                          } else {
                                                                                                                            if (questionContext instanceof HunterTrappedBySnareQuestionContext) {
                                                                                                                              tmp = 'Choose Hunter trapped by Snare';
                                                                                                                            } else {
                                                                                                                              if (questionContext instanceof SnareToReplaceQuestionContext) {
                                                                                                                                tmp = 'Choose Snare to replace';
                                                                                                                              } else {
                                                                                                                                if (questionContext instanceof SnareLocationQuestionContext) {
                                                                                                                                  tmp = 'Choose a location for the Snare';
                                                                                                                                } else {
                                                                                                                                  if (questionContext instanceof SnareTrapLocationQuestionContext) {
                                                                                                                                    tmp = 'Choose the Snare trap location';
                                                                                                                                  } else {
                                                                                                                                    if (questionContext instanceof LocationForLivingWebQuestionContext) {
                                                                                                                                      tmp = 'Choose a location to place a Living Web';
                                                                                                                                    } else {
                                                                                                                                      if (questionContext instanceof EggToHatchQuestionContext) {
                                                                                                                                        tmp = 'Choose Egg to hatch';
                                                                                                                                      } else {
                                                                                                                                        if (questionContext instanceof HatchlingToReplaceQuestionContext) {
                                                                                                                                          tmp = 'Choose Hatchling to replace';
                                                                                                                                        } else {
                                                                                                                                          if (questionContext instanceof EggToReturnToMoltQuestionContext) {
                                                                                                                                            tmp = 'Choose Egg to return to Molt Counter';
                                                                                                                                          } else {
                                                                                                                                            if (questionContext instanceof UrgullMoltEggsToReturnQuestionContext) {
                                                                                                                                              tmp = 'Choose Eggs to return to Molt Counter';
                                                                                                                                            } else {
                                                                                                                                              if (questionContext instanceof SigridPactCardQuestionContext) {
                                                                                                                                                tmp = 'Choose Sigrid Ability to pact';
                                                                                                                                              } else {
                                                                                                                                                if (questionContext instanceof HunterToResolveRuinQuestionContext) {
                                                                                                                                                  tmp = 'Choose Hunter to resolve the Ruin';
                                                                                                                                                } else {
                                                                                                                                                  if (questionContext instanceof HunterToGiveItemByRuinQuestionContext) {
                                                                                                                                                    tmp = 'Choose Hunter to give an Item';
                                                                                                                                                  } else {
                                                                                                                                                    if (questionContext instanceof HunterToReceiveItemByRuinQuestionContext) {
                                                                                                                                                      tmp = 'Choose Hunter to receive or exchange the Item';
                                                                                                                                                    } else {
                                                                                                                                                      if (questionContext instanceof SummonToSacrificeForRuinQuestionContext) {
                                                                                                                                                        tmp = 'Choose Summon to remove';
                                                                                                                                                      } else {
                                                                                                                                                        if (questionContext instanceof BeingToMoveByRuinQuestionContext) {
                                                                                                                                                          tmp = 'Choose being to move';
                                                                                                                                                        } else {
                                                                                                                                                          if (questionContext instanceof AshRuinLocationQuestionContext) {
                                                                                                                                                            tmp = 'Choose Ash Ruin location';
                                                                                                                                                          } else {
                                                                                                                                                            if (questionContext instanceof LocationsToCheckForBeastByRuinQuestionContext) {
                                                                                                                                                              tmp = 'Choose a location to check for the Beast';
                                                                                                                                                            } else {
                                                                                                                                                              if (questionContext instanceof SameHabitatRelocationByRuinQuestionContext) {
                                                                                                                                                                tmp = 'Choose a location with the same habitat';
                                                                                                                                                              } else {
                                                                                                                                                                if (questionContext instanceof BeastMovementCardQuestionContext) {
                                                                                                                                                                  tmp = 'Choose movement card to reveal';
                                                                                                                                                                } else {
                                                                                                                                                                  noWhenBranchMatchedException();
                                                                                                                                                                }
                                                                                                                                                              }
                                                                                                                                                            }
                                                                                                                                                          }
                                                                                                                                                        }
                                                                                                                                                      }
                                                                                                                                                    }
                                                                                                                                                  }
                                                                                                                                                }
                                                                                                                                              }
                                                                                                                                            }
                                                                                                                                          }
                                                                                                                                        }
                                                                                                                                      }
                                                                                                                                    }
                                                                                                                                  }
                                                                                                                                }
                                                                                                                              }
                                                                                                                            }
                                                                                                                          }
                                                                                                                        }
                                                                                                                      }
                                                                                                                    }
                                                                                                                  }
                                                                                                                }
                                                                                                              }
                                                                                                            }
                                                                                                          }
                                                                                                        }
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
}
class sam$kotlin_Comparator$0_1 {
  constructor(function_0) {
    this.i71_1 = function_0;
  }
  pj(a, b) {
    return this.i71_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.i71_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class DefaultAnswer {
  constructor(answer) {
    this.j71_1 = answer;
  }
  toString() {
    return 'DefaultAnswer(answer=' + toString_0(this.j71_1) + ')';
  }
  hashCode() {
    return this.j71_1 == null ? 0 : hashCode(this.j71_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DefaultAnswer))
      return false;
    if (!equals(this.j71_1, other.j71_1))
      return false;
    return true;
  }
}
class CollectionOperation extends Enum {}
class WaitingIsCanceledException extends Exception {
  constructor() {
    return new.target.m71();
  }
  static m71() {
    var $this = this.te();
    captureStack($this, $this.l71_1);
    return $this;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function InAnyOrderStatement$Companion$$childSerializers$_anonymous__q3varm() {
  return new LinkedHashSetSerializer(Companion_instance.a2g());
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new $serializer();
  return $serializer_instance;
}
function MovementUptoFixedStepsStatement$Companion$$childSerializers$_anonymous__h5ce5v() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new $serializer_0();
  return $serializer_instance_0;
}
function GainHunterItemStatement$Companion$$childSerializers$_anonymous__l0333h() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_380.a2g()));
}
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new $serializer_1();
  return $serializer_instance_1;
}
function ThenActionStatement$Companion$$childSerializers$_anonymous__dmyr9u() {
  return new ArrayListSerializer(Companion_instance.a2g());
}
var Companion_instance_3;
function Companion_getInstance_4() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new $serializer_2();
  return $serializer_instance_2;
}
function TransformAllNearbyStatement$Companion$$childSerializers$_anonymous__5qkvtb() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_4;
function Companion_getInstance_5() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new $serializer_3();
  return $serializer_instance_3;
}
function SimpleBeastMovementStatement$Companion$$childSerializers$_anonymous__uv80zt() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_5;
function Companion_getInstance_6() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new $serializer_4();
  return $serializer_instance_4;
}
function AttackStatement$Companion$$childSerializers$_anonymous__temil9() {
  return Companion_instance_138.a2g();
}
function AttackStatement$Companion$$childSerializers$_anonymous__temil9_0() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function AttackStatement$Companion$$childSerializers$_anonymous__temil9_1() {
  return Companion_instance_71.a2g();
}
var Companion_instance_6;
function Companion_getInstance_7() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new $serializer_5();
  return $serializer_instance_5;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.o2q_1.k3();
}
function BeastMovementStatement$Companion$_anonymous__uuy8vi() {
  var tmp = getKClass(BeastMovementStatement);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(BeastMovesDependingOnHuntersStatement), getKClass(BeastMovesDependingOnSummonsNumberStatement), getKClass(BeastMovesSameZoneStatement), getKClass(FixedDirectionBeastMovementStatement), getKClass(LeapStatement), getKClass(RaagaSlitherStatement), getKClass(SimpleBeastMovementStatement), getKClass(UpriseUpgradedStatement), getKClass(VoidStatement)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_44(), $serializer_getInstance_45(), $serializer_getInstance_46(), $serializer_getInstance_47(), $serializer_getInstance_106(), $serializer_getInstance_372(), $serializer_getInstance_4(), $serializer_getInstance_146(), $serializer_getInstance_69()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [];
  return SealedClassSerializer.i10('BeastMovementStatement', tmp, tmp_0, tmp_1, tmp$ret$6);
}
var Companion_instance_7;
function Companion_getInstance_8() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
function ChooseOneOfStatement$Companion$$childSerializers$_anonymous__bwv5cv() {
  return new LinkedHashSetSerializer(Companion_instance.a2g());
}
var Companion_instance_8;
function Companion_getInstance_9() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 === VOID)
    new $serializer_6();
  return $serializer_instance_6;
}
function GrapnelStatement$Companion$$childSerializers$_anonymous__mgwgi2() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_9;
function Companion_getInstance_10() {
  if (Companion_instance_9 === VOID)
    new Companion_9();
  return Companion_instance_9;
}
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 === VOID)
    new $serializer_7();
  return $serializer_instance_7;
}
function RetrieveDiscardedAbilityStatement$Companion$$childSerializers$_anonymous__mn6gos() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function RetrieveDiscardedAbilityStatement$Companion$$childSerializers$_anonymous__mn6gos_0() {
  return Companion_instance_442.a2g();
}
var Companion_instance_10;
function Companion_getInstance_11() {
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 === VOID)
    new $serializer_8();
  return $serializer_instance_8;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.i2r_1.k3();
}
function DiscardPlacedTrapStatement$_anonymous__a3c5v4() {
  var tmp = DiscardPlacedTrapStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DiscardPlacedTrapStatement', tmp, tmp$ret$0);
}
var DiscardPlacedTrapStatement_instance;
function DiscardPlacedTrapStatement_getInstance() {
  if (DiscardPlacedTrapStatement_instance === VOID)
    new DiscardPlacedTrapStatement();
  return DiscardPlacedTrapStatement_instance;
}
function TransformLocationsStatement$Companion$$childSerializers$_anonymous__opeymr() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
function TransformLocationsStatement$Companion$$childSerializers$_anonymous__opeymr_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
function TransformLocationsStatement$Companion$$childSerializers$_anonymous__opeymr_1() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_11;
function Companion_getInstance_12() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 === VOID)
    new $serializer_9();
  return $serializer_instance_9;
}
function MoveSeveralHuntersStatement$Companion$$childSerializers$_anonymous__4q92sd() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_380.a2g()));
}
var Companion_instance_12;
function Companion_getInstance_13() {
  if (Companion_instance_12 === VOID)
    new Companion_12();
  return Companion_instance_12;
}
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 === VOID)
    new $serializer_10();
  return $serializer_instance_10;
}
function MoveEverySummonStatement$Companion$$childSerializers$_anonymous__w300u2() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function MoveEverySummonStatement$Companion$$childSerializers$_anonymous__w300u2_0() {
  return Companion_instance_424.a2g();
}
var Companion_instance_13;
function Companion_getInstance_14() {
  if (Companion_instance_13 === VOID)
    new Companion_13();
  return Companion_instance_13;
}
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 === VOID)
    new $serializer_11();
  return $serializer_instance_11;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.i2s_1.k3();
}
function MovementStepByStepStatement$Companion$_anonymous__froa0y() {
  var tmp = getKClass(MovementStepByStepStatement);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(MovementUptoFixedStepsStatement), getKClass(OverloadedFlameRapierMovementStatement), getKClass(RunFromFireStatement), getKClass(TrackStatement), getKClass(WarhogsTuskStatement)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_0(), $serializer_getInstance_143(), $serializer_getInstance_385(), $serializer_getInstance_48(), $serializer_getInstance_49()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [];
  return SealedClassSerializer.i10('MovementStepByStepStatement', tmp, tmp_0, tmp_1, tmp$ret$6);
}
var Companion_instance_14;
function Companion_getInstance_15() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.j2s_1.k3();
}
function AbruptDecayActionStatement$_anonymous__g66d74() {
  var tmp = AbruptDecayActionStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AbruptDecayActionStatement', tmp, tmp$ret$0);
}
var AbruptDecayActionStatement_instance;
function AbruptDecayActionStatement_getInstance() {
  if (AbruptDecayActionStatement_instance === VOID)
    new AbruptDecayActionStatement();
  return AbruptDecayActionStatement_instance;
}
function ActivateSummonsStatement$Companion$$childSerializers$_anonymous__ljgerq() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_15;
function Companion_getInstance_16() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 === VOID)
    new $serializer_12();
  return $serializer_instance_12;
}
function ActivateTrapStatement$Companion$$childSerializers$_anonymous__xsffff() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function ActivateTrapStatement$Companion$$childSerializers$_anonymous__xsffff_0() {
  return Companion_instance_399.a2g();
}
var Companion_instance_16;
function Companion_getInstance_17() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
var $serializer_instance_13;
function $serializer_getInstance_13() {
  if ($serializer_instance_13 === VOID)
    new $serializer_13();
  return $serializer_instance_13;
}
function DreamerMaskReactionStatement$Companion$$childSerializers$_anonymous__hfgqdc() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_17;
function Companion_getInstance_18() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
var $serializer_instance_14;
function $serializer_getInstance_14() {
  if ($serializer_instance_14 === VOID)
    new $serializer_14();
  return $serializer_instance_14;
}
function EsmeriasStrandReactionStatement$Companion$$childSerializers$_anonymous__pppkp3() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
function EsmeriasStrandReactionStatement$Companion$$childSerializers$_anonymous__pppkp3_0() {
  var tmp = EsmeriasStrandCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EsmeriasStrandCard', tmp, tmp$ret$0);
}
function EsmeriasStrandReactionStatement$Companion$$childSerializers$_anonymous__pppkp3_1() {
  return Companion_instance_146.a2g();
}
var Companion_instance_18;
function Companion_getInstance_19() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
var $serializer_instance_15;
function $serializer_getInstance_15() {
  if ($serializer_instance_15 === VOID)
    new $serializer_15();
  return $serializer_instance_15;
}
function FlareReactionStatement$Companion$$childSerializers$_anonymous__m1o9ny() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_19;
function Companion_getInstance_20() {
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
var $serializer_instance_16;
function $serializer_getInstance_16() {
  if ($serializer_instance_16 === VOID)
    new $serializer_16();
  return $serializer_instance_16;
}
function IntuitionReactionStatement$Companion$$childSerializers$_anonymous__r37am3() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_20;
function Companion_getInstance_21() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
var $serializer_instance_17;
function $serializer_getInstance_17() {
  if ($serializer_instance_17 === VOID)
    new $serializer_17();
  return $serializer_instance_17;
}
function PlayCardAsReactionStatement$Companion$$childSerializers$_anonymous__li1q6e() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function PlayCardAsReactionStatement$Companion$$childSerializers$_anonymous__li1q6e_0() {
  return Companion_instance_438.a2g();
}
var Companion_instance_21;
function Companion_getInstance_22() {
  if (Companion_instance_21 === VOID)
    new Companion_21();
  return Companion_instance_21;
}
var $serializer_instance_18;
function $serializer_getInstance_18() {
  if ($serializer_instance_18 === VOID)
    new $serializer_18();
  return $serializer_instance_18;
}
function SmokebombReactionStatement$Companion$$childSerializers$_anonymous__wjjfkb() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_22;
function Companion_getInstance_23() {
  if (Companion_instance_22 === VOID)
    new Companion_22();
  return Companion_instance_22;
}
var $serializer_instance_19;
function $serializer_getInstance_19() {
  if ($serializer_instance_19 === VOID)
    new $serializer_19();
  return $serializer_instance_19;
}
function SuddenMistReactionStatement$Companion$$childSerializers$_anonymous__yib2s() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function SuddenMistReactionStatement$Companion$$childSerializers$_anonymous__yib2s_0() {
  var tmp = SuddenMistCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SuddenMistCard', tmp, tmp$ret$0);
}
var Companion_instance_23;
function Companion_getInstance_24() {
  if (Companion_instance_23 === VOID)
    new Companion_23();
  return Companion_instance_23;
}
var $serializer_instance_20;
function $serializer_getInstance_20() {
  if ($serializer_instance_20 === VOID)
    new $serializer_20();
  return $serializer_instance_20;
}
function WorldShiftReactionStatement$Companion$$childSerializers$_anonymous__rptl7w() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_24;
function Companion_getInstance_25() {
  if (Companion_instance_24 === VOID)
    new Companion_24();
  return Companion_instance_24;
}
var $serializer_instance_21;
function $serializer_getInstance_21() {
  if ($serializer_instance_21 === VOID)
    new $serializer_21();
  return $serializer_instance_21;
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.w2u_1.k3();
}
function CannotBePlayedStatement$_anonymous__ho92v5() {
  var tmp = CannotBePlayedStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CannotBePlayedStatement', tmp, tmp$ret$0);
}
var CannotBePlayedStatement_instance;
function CannotBePlayedStatement_getInstance() {
  if (CannotBePlayedStatement_instance === VOID)
    new CannotBePlayedStatement();
  return CannotBePlayedStatement_instance;
}
function ChainGrapnelStatement$Companion$$childSerializers$_anonymous__bd2qqd() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_25;
function Companion_getInstance_26() {
  if (Companion_instance_25 === VOID)
    new Companion_25();
  return Companion_instance_25;
}
var $serializer_instance_22;
function $serializer_getInstance_22() {
  if ($serializer_instance_22 === VOID)
    new $serializer_22();
  return $serializer_instance_22;
}
function ChargeUpgradeStatement$Companion$$childSerializers$_anonymous__q89kd9() {
  return Companion_instance_130.a2g();
}
var Companion_instance_26;
function Companion_getInstance_27() {
  if (Companion_instance_26 === VOID)
    new Companion_26();
  return Companion_instance_26;
}
var $serializer_instance_23;
function $serializer_getInstance_23() {
  if ($serializer_instance_23 === VOID)
    new $serializer_23();
  return $serializer_instance_23;
}
function ChooseAndPlayOneCard$Companion$$childSerializers$_anonymous__hroq14() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_27;
function Companion_getInstance_28() {
  if (Companion_instance_27 === VOID)
    new Companion_27();
  return Companion_instance_27;
}
var $serializer_instance_24;
function $serializer_getInstance_24() {
  if ($serializer_instance_24 === VOID)
    new $serializer_24();
  return $serializer_instance_24;
}
function ClaimRuinStatement$Companion$$childSerializers$_anonymous__sw4m73() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_28;
function Companion_getInstance_29() {
  if (Companion_instance_28 === VOID)
    new Companion_28();
  return Companion_instance_28;
}
var $serializer_instance_25;
function $serializer_getInstance_25() {
  if ($serializer_instance_25 === VOID)
    new $serializer_25();
  return $serializer_instance_25;
}
function OptionalStatement$Companion$$childSerializers$_anonymous__po5rwb() {
  return Companion_instance.a2g();
}
var Companion_instance_29;
function Companion_getInstance_30() {
  if (Companion_instance_29 === VOID)
    new Companion_29();
  return Companion_instance_29;
}
var $serializer_instance_26;
function $serializer_getInstance_26() {
  if ($serializer_instance_26 === VOID)
    new $serializer_26();
  return $serializer_instance_26;
}
function SummonSignStatement$Companion$$childSerializers$_anonymous__mdx2ft() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_30;
function Companion_getInstance_31() {
  if (Companion_instance_30 === VOID)
    new Companion_30();
  return Companion_instance_30;
}
var $serializer_instance_27;
function $serializer_getInstance_27() {
  if ($serializer_instance_27 === VOID)
    new $serializer_27();
  return $serializer_instance_27;
}
function CopyCardStatement$Companion$$childSerializers$_anonymous__dh8h28() {
  return Companion_instance_438.a2g();
}
function CopyCardStatement$Companion$$childSerializers$_anonymous__dh8h28_0() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_31;
function Companion_getInstance_32() {
  if (Companion_instance_31 === VOID)
    new Companion_31();
  return Companion_instance_31;
}
var $serializer_instance_28;
function $serializer_getInstance_28() {
  if ($serializer_instance_28 === VOID)
    new $serializer_28();
  return $serializer_instance_28;
}
function DealDamageToSummonsStatement$Companion$$childSerializers$_anonymous__3fixt5() {
  return Companion_instance_138.a2g();
}
function DealDamageToSummonsStatement$Companion$$childSerializers$_anonymous__3fixt5_0() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_32;
function Companion_getInstance_33() {
  if (Companion_instance_32 === VOID)
    new Companion_32();
  return Companion_instance_32;
}
var $serializer_instance_29;
function $serializer_getInstance_29() {
  if ($serializer_instance_29 === VOID)
    new $serializer_29();
  return $serializer_instance_29;
}
function DiscardCardsStatement$Companion$$childSerializers$_anonymous__fyyfc0() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_33;
function Companion_getInstance_34() {
  if (Companion_instance_33 === VOID)
    new Companion_33();
  return Companion_instance_33;
}
var $serializer_instance_30;
function $serializer_getInstance_30() {
  if ($serializer_instance_30 === VOID)
    new $serializer_30();
  return $serializer_instance_30;
}
function DisplaceTransformLocationsStatement$Companion$$childSerializers$_anonymous__gmpvza() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_34;
function Companion_getInstance_35() {
  if (Companion_instance_34 === VOID)
    new Companion_34();
  return Companion_instance_34;
}
var $serializer_instance_31;
function $serializer_getInstance_31() {
  if ($serializer_instance_31 === VOID)
    new $serializer_31();
  return $serializer_instance_31;
}
function _get_$cachedSerializer__te6jhj_4($this) {
  return $this.e2x_1.k3();
}
function EmptyStatement$_anonymous__u3n6lx() {
  var tmp = EmptyStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EmptyStatement', tmp, tmp$ret$0);
}
var EmptyStatement_instance;
function EmptyStatement_getInstance() {
  if (EmptyStatement_instance === VOID)
    new EmptyStatement();
  return EmptyStatement_instance;
}
function EnsnareStatement$Companion$$childSerializers$_anonymous__809r6z() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_35;
function Companion_getInstance_36() {
  if (Companion_instance_35 === VOID)
    new Companion_35();
  return Companion_instance_35;
}
var $serializer_instance_32;
function $serializer_getInstance_32() {
  if ($serializer_instance_32 === VOID)
    new $serializer_32();
  return $serializer_instance_32;
}
function FlourishStatement$Companion$$childSerializers$_anonymous__vt9p0t() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_36;
function Companion_getInstance_37() {
  if (Companion_instance_36 === VOID)
    new Companion_36();
  return Companion_instance_36;
}
var $serializer_instance_33;
function $serializer_getInstance_33() {
  if ($serializer_instance_33 === VOID)
    new $serializer_33();
  return $serializer_instance_33;
}
function GainAncientPowerStatement$Companion$$childSerializers$_anonymous__8r2jfr() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_37;
function Companion_getInstance_38() {
  if (Companion_instance_37 === VOID)
    new Companion_37();
  return Companion_instance_37;
}
var $serializer_instance_34;
function $serializer_getInstance_34() {
  if ($serializer_instance_34 === VOID)
    new $serializer_34();
  return $serializer_instance_34;
}
function GainBeastlyTalentStatement$Companion$$childSerializers$_anonymous__z93gp8() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_92.a2g()));
}
var Companion_instance_38;
function Companion_getInstance_39() {
  if (Companion_instance_38 === VOID)
    new Companion_38();
  return Companion_instance_38;
}
var $serializer_instance_35;
function $serializer_getInstance_35() {
  if ($serializer_instance_35 === VOID)
    new $serializer_35();
  return $serializer_instance_35;
}
function GainGrudgeStatement$Companion$$childSerializers$_anonymous__qmo3w2() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_128.a2g()));
}
var Companion_instance_39;
function Companion_getInstance_40() {
  if (Companion_instance_39 === VOID)
    new Companion_39();
  return Companion_instance_39;
}
var $serializer_instance_36;
function $serializer_getInstance_36() {
  if ($serializer_instance_36 === VOID)
    new $serializer_36();
  return $serializer_instance_36;
}
function GainRandomUnusedDraftActionCardStatement$Companion$$childSerializers$_anonymous__2sczx2() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_40;
function Companion_getInstance_41() {
  if (Companion_instance_40 === VOID)
    new Companion_40();
  return Companion_instance_40;
}
var $serializer_instance_37;
function $serializer_getInstance_37() {
  if ($serializer_instance_37 === VOID)
    new $serializer_37();
  return $serializer_instance_37;
}
function GlimpsBeastsStatement$Companion$$childSerializers$_anonymous__5tjs1n() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_41;
function Companion_getInstance_42() {
  if (Companion_instance_41 === VOID)
    new Companion_41();
  return Companion_instance_41;
}
var $serializer_instance_38;
function $serializer_getInstance_38() {
  if ($serializer_instance_38 === VOID)
    new $serializer_38();
  return $serializer_instance_38;
}
function GlipsHuntersStatement$Companion$$childSerializers$_anonymous__squba1() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_42;
function Companion_getInstance_43() {
  if (Companion_instance_42 === VOID)
    new Companion_42();
  return Companion_instance_42;
}
var $serializer_instance_39;
function $serializer_getInstance_39() {
  if ($serializer_instance_39 === VOID)
    new $serializer_39();
  return $serializer_instance_39;
}
function HealNearHunterStatement$Companion$$childSerializers$_anonymous__y2l1ij() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_43;
function Companion_getInstance_44() {
  if (Companion_instance_43 === VOID)
    new Companion_43();
  return Companion_instance_43;
}
var $serializer_instance_40;
function $serializer_getInstance_40() {
  if ($serializer_instance_40 === VOID)
    new $serializer_40();
  return $serializer_instance_40;
}
function HealNearbyHuntersAndSettlersStatement$Companion$$childSerializers$_anonymous__uqp88i() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_44;
function Companion_getInstance_45() {
  if (Companion_instance_44 === VOID)
    new Companion_44();
  return Companion_instance_44;
}
var $serializer_instance_41;
function $serializer_getInstance_41() {
  if ($serializer_instance_41 === VOID)
    new $serializer_41();
  return $serializer_instance_41;
}
function LureStatement$Companion$$childSerializers$_anonymous__77c07r() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_45;
function Companion_getInstance_46() {
  if (Companion_instance_45 === VOID)
    new Companion_45();
  return Companion_instance_45;
}
var $serializer_instance_42;
function $serializer_getInstance_42() {
  if ($serializer_instance_42 === VOID)
    new $serializer_42();
  return $serializer_instance_42;
}
function MoveAnimalStatement$Companion$$childSerializers$_anonymous__gaadlk() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_46;
function Companion_getInstance_47() {
  if (Companion_instance_46 === VOID)
    new Companion_46();
  return Companion_instance_46;
}
var $serializer_instance_43;
function $serializer_getInstance_43() {
  if ($serializer_instance_43 === VOID)
    new $serializer_43();
  return $serializer_instance_43;
}
function BeastMovesDependingOnHuntersStatement$Companion$$childSerializers$_anonymous__ev3k90() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_47;
function Companion_getInstance_48() {
  if (Companion_instance_47 === VOID)
    new Companion_47();
  return Companion_instance_47;
}
var $serializer_instance_44;
function $serializer_getInstance_44() {
  if ($serializer_instance_44 === VOID)
    new $serializer_44();
  return $serializer_instance_44;
}
function BeastMovesDependingOnSummonsNumberStatement$Companion$$childSerializers$_anonymous__qplm90() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_48;
function Companion_getInstance_49() {
  if (Companion_instance_48 === VOID)
    new Companion_48();
  return Companion_instance_48;
}
var $serializer_instance_45;
function $serializer_getInstance_45() {
  if ($serializer_instance_45 === VOID)
    new $serializer_45();
  return $serializer_instance_45;
}
function BeastMovesSameZoneStatement$Companion$$childSerializers$_anonymous__k82g7k() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_49;
function Companion_getInstance_50() {
  if (Companion_instance_49 === VOID)
    new Companion_49();
  return Companion_instance_49;
}
var $serializer_instance_46;
function $serializer_getInstance_46() {
  if ($serializer_instance_46 === VOID)
    new $serializer_46();
  return $serializer_instance_46;
}
function FixedDirectionBeastMovementStatement$Companion$$childSerializers$_anonymous__n3n3lu() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_50;
function Companion_getInstance_51() {
  if (Companion_instance_50 === VOID)
    new Companion_50();
  return Companion_instance_50;
}
var $serializer_instance_47;
function $serializer_getInstance_47() {
  if ($serializer_instance_47 === VOID)
    new $serializer_47();
  return $serializer_instance_47;
}
function TrackStatement$Companion$$childSerializers$_anonymous__vpyxfq() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_51;
function Companion_getInstance_52() {
  if (Companion_instance_51 === VOID)
    new Companion_51();
  return Companion_instance_51;
}
var $serializer_instance_48;
function $serializer_getInstance_48() {
  if ($serializer_instance_48 === VOID)
    new $serializer_48();
  return $serializer_instance_48;
}
function WarhogsTuskStatement$Companion$$childSerializers$_anonymous__y3eo4v() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_52;
function Companion_getInstance_53() {
  if (Companion_instance_52 === VOID)
    new Companion_52();
  return Companion_instance_52;
}
var $serializer_instance_49;
function $serializer_getInstance_49() {
  if ($serializer_instance_49 === VOID)
    new $serializer_49();
  return $serializer_instance_49;
}
function RelocationInRangeStatement$Companion$$childSerializers$_anonymous__f7k6qd() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_53;
function Companion_getInstance_54() {
  if (Companion_instance_53 === VOID)
    new Companion_53();
  return Companion_instance_53;
}
var $serializer_instance_50;
function $serializer_getInstance_50() {
  if ($serializer_instance_50 === VOID)
    new $serializer_50();
  return $serializer_instance_50;
}
function OverloadedShatterStatement$Companion$$childSerializers$_anonymous__7cfp7p() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_54;
function Companion_getInstance_55() {
  if (Companion_instance_54 === VOID)
    new Companion_54();
  return Companion_instance_54;
}
var $serializer_instance_51;
function $serializer_getInstance_51() {
  if ($serializer_instance_51 === VOID)
    new $serializer_51();
  return $serializer_instance_51;
}
function AvariceCardHuntersStatement$Companion$$childSerializers$_anonymous__qnmhmv() {
  return Companion_instance_146.a2g();
}
function AvariceCardHuntersStatement$Companion$$childSerializers$_anonymous__qnmhmv_0() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_380.a2g()));
}
var Companion_instance_55;
function Companion_getInstance_56() {
  if (Companion_instance_55 === VOID)
    new Companion_55();
  return Companion_instance_55;
}
var $serializer_instance_52;
function $serializer_getInstance_52() {
  if ($serializer_instance_52 === VOID)
    new $serializer_52();
  return $serializer_instance_52;
}
function RetrieveDiscardedAbilitiesStatement$Companion$$childSerializers$_anonymous__4hx0gy() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_380.a2g()));
}
var Companion_instance_56;
function Companion_getInstance_57() {
  if (Companion_instance_56 === VOID)
    new Companion_56();
  return Companion_instance_56;
}
var $serializer_instance_53;
function $serializer_getInstance_53() {
  if ($serializer_instance_53 === VOID)
    new $serializer_53();
  return $serializer_instance_53;
}
function PlaceNewSummonNearbyStatement$Companion$$childSerializers$_anonymous__vrqgdw() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_57;
function Companion_getInstance_58() {
  if (Companion_instance_57 === VOID)
    new Companion_57();
  return Companion_instance_57;
}
var $serializer_instance_54;
function $serializer_getInstance_54() {
  if ($serializer_instance_54 === VOID)
    new $serializer_54();
  return $serializer_instance_54;
}
function PlaceNewSummonOnLocationsStatement$Companion$$childSerializers$_anonymous__j7116o() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function PlaceNewSummonOnLocationsStatement$Companion$$childSerializers$_anonymous__j7116o_0() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_58;
function Companion_getInstance_59() {
  if (Companion_instance_58 === VOID)
    new Companion_58();
  return Companion_instance_58;
}
var $serializer_instance_55;
function $serializer_getInstance_55() {
  if ($serializer_instance_55 === VOID)
    new $serializer_55();
  return $serializer_instance_55;
}
function PlaceNewSummonStatement$Companion$$childSerializers$_anonymous__iaholn() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_59;
function Companion_getInstance_60() {
  if (Companion_instance_59 === VOID)
    new Companion_59();
  return Companion_instance_59;
}
var $serializer_instance_56;
function $serializer_getInstance_56() {
  if ($serializer_instance_56 === VOID)
    new $serializer_56();
  return $serializer_instance_56;
}
function PlaceOutpostStatement$Companion$$childSerializers$_anonymous__nx14wy() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_60;
function Companion_getInstance_61() {
  if (Companion_instance_60 === VOID)
    new Companion_60();
  return Companion_instance_60;
}
var $serializer_instance_57;
function $serializer_getInstance_57() {
  if ($serializer_instance_57 === VOID)
    new $serializer_57();
  return $serializer_instance_57;
}
function ReceiveSelfDamageStatement$Companion$$childSerializers$_anonymous__r3l9h5() {
  return Companion_instance_138.a2g();
}
function ReceiveSelfDamageStatement$Companion$$childSerializers$_anonymous__r3l9h5_0() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_61;
function Companion_getInstance_62() {
  if (Companion_instance_61 === VOID)
    new Companion_61();
  return Companion_instance_61;
}
var $serializer_instance_58;
function $serializer_getInstance_58() {
  if ($serializer_instance_58 === VOID)
    new $serializer_58();
  return $serializer_instance_58;
}
function _get_$cachedSerializer__te6jhj_5($this) {
  return $this.p33_1.k3();
}
function RelocateOneHunterToAnother$_anonymous__4f9muo() {
  var tmp = RelocateOneHunterToAnother_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RelocateOneHunterToAnother', tmp, tmp$ret$0);
}
var RelocateOneHunterToAnother_instance;
function RelocateOneHunterToAnother_getInstance() {
  if (RelocateOneHunterToAnother_instance === VOID)
    new RelocateOneHunterToAnother();
  return RelocateOneHunterToAnother_instance;
}
function RelocationToSettlementStatement$Companion$$childSerializers$_anonymous__7ubvzb() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_62;
function Companion_getInstance_63() {
  if (Companion_instance_62 === VOID)
    new Companion_62();
  return Companion_instance_62;
}
var $serializer_instance_59;
function $serializer_getInstance_59() {
  if ($serializer_instance_59 === VOID)
    new $serializer_59();
  return $serializer_instance_59;
}
function RetrieveDiscardedDraftActionCardStatement$Companion$$childSerializers$_anonymous__6vsr8f() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_63;
function Companion_getInstance_64() {
  if (Companion_instance_63 === VOID)
    new Companion_63();
  return Companion_instance_63;
}
var $serializer_instance_60;
function $serializer_getInstance_60() {
  if ($serializer_instance_60 === VOID)
    new $serializer_60();
  return $serializer_instance_60;
}
function RetrieveUnusedCardStatement$Companion$$childSerializers$_anonymous__g9cnnn() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_64;
function Companion_getInstance_65() {
  if (Companion_instance_64 === VOID)
    new Companion_64();
  return Companion_instance_64;
}
var $serializer_instance_61;
function $serializer_getInstance_61() {
  if ($serializer_instance_61 === VOID)
    new $serializer_61();
  return $serializer_instance_61;
}
function RevealLastMovementsStatement$Companion$$childSerializers$_anonymous__bb62zg() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_65;
function Companion_getInstance_66() {
  if (Companion_instance_65 === VOID)
    new Companion_65();
  return Companion_instance_65;
}
var $serializer_instance_62;
function $serializer_getInstance_62() {
  if ($serializer_instance_62 === VOID)
    new $serializer_62();
  return $serializer_instance_62;
}
function SearchForBeastStatement$Companion$$childSerializers$_anonymous__2hdagp() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_66;
function Companion_getInstance_67() {
  if (Companion_instance_66 === VOID)
    new Companion_66();
  return Companion_instance_66;
}
var $serializer_instance_63;
function $serializer_getInstance_63() {
  if ($serializer_instance_63 === VOID)
    new $serializer_63();
  return $serializer_instance_63;
}
function SetTrapStatement$Companion$$childSerializers$_anonymous__ecp1li() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
function SetTrapStatement$Companion$$childSerializers$_anonymous__ecp1li_0() {
  return Companion_instance_399.a2g();
}
function SetTrapStatement$Companion$$childSerializers$_anonymous__ecp1li_1() {
  return createSimpleEnumSerializer('steelart.beast.Zone', values_1());
}
var Companion_instance_67;
function Companion_getInstance_68() {
  if (Companion_instance_67 === VOID)
    new Companion_67();
  return Companion_instance_67;
}
var $serializer_instance_64;
function $serializer_getInstance_64() {
  if ($serializer_instance_64 === VOID)
    new $serializer_64();
  return $serializer_instance_64;
}
function StrideHuntersStatement$Companion$$childSerializers$_anonymous__jl78tx() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_68;
function Companion_getInstance_69() {
  if (Companion_instance_68 === VOID)
    new Companion_68();
  return Companion_instance_68;
}
var $serializer_instance_65;
function $serializer_getInstance_65() {
  if ($serializer_instance_65 === VOID)
    new $serializer_65();
  return $serializer_instance_65;
}
function SummonMovesStatement$Companion$$childSerializers$_anonymous__72wvfg() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_69;
function Companion_getInstance_70() {
  if (Companion_instance_69 === VOID)
    new Companion_69();
  return Companion_instance_69;
}
var $serializer_instance_66;
function $serializer_getInstance_66() {
  if ($serializer_instance_66 === VOID)
    new $serializer_66();
  return $serializer_instance_66;
}
function _get_$cachedSerializer__te6jhj_6($this) {
  return $this.l35_1.k3();
}
function SwarmAttackStatement$_anonymous__6sg6jc() {
  var tmp = SwarmAttackStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SwarmAttackStatement', tmp, tmp$ret$0);
}
var SwarmAttackStatement_instance;
function SwarmAttackStatement_getInstance() {
  if (SwarmAttackStatement_instance === VOID)
    new SwarmAttackStatement();
  return SwarmAttackStatement_instance;
}
function UpgradeStatement$Companion$$childSerializers$_anonymous__u6mi5z() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_70;
function Companion_getInstance_71() {
  if (Companion_instance_70 === VOID)
    new Companion_70();
  return Companion_instance_70;
}
var $serializer_instance_67;
function $serializer_getInstance_67() {
  if ($serializer_instance_67 === VOID)
    new $serializer_67();
  return $serializer_instance_67;
}
var Companion_instance_71;
function Companion_getInstance_72() {
  return Companion_instance_71;
}
function _get_$cachedSerializer__te6jhj_7($this) {
  return $this.y35_1.k3();
}
function ChooseSettlerForFlareScope$_anonymous__sy4umw() {
  var tmp = ChooseSettlerForFlareScope_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ChooseSettlerForFlareScope', tmp, tmp$ret$0);
}
var ChooseSettlerForFlareScope_instance;
function ChooseSettlerForFlareScope_getInstance() {
  if (ChooseSettlerForFlareScope_instance === VOID)
    new ChooseSettlerForFlareScope();
  return ChooseSettlerForFlareScope_instance;
}
function _get_$cachedSerializer__te6jhj_8($this) {
  return $this.z35_1.k3();
}
function BonusDamageAttackModifier$_anonymous__hx4rli() {
  var tmp = BonusDamageAttackModifier_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BonusDamageAttackModifier', tmp, tmp$ret$0);
}
var BonusDamageAttackModifier_instance;
function BonusDamageAttackModifier_getInstance() {
  if (BonusDamageAttackModifier_instance === VOID)
    new BonusDamageAttackModifier();
  return BonusDamageAttackModifier_instance;
}
function _get_$cachedSerializer__te6jhj_9($this) {
  return $this.a36_1.k3();
}
function OnlyNearSummonsAttackModifier$_anonymous__r6ekyi() {
  var tmp = OnlyNearSummonsAttackModifier_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OnlyNearSummonsAttackModifier', tmp, tmp$ret$0);
}
var OnlyNearSummonsAttackModifier_instance;
function OnlyNearSummonsAttackModifier_getInstance() {
  if (OnlyNearSummonsAttackModifier_instance === VOID)
    new OnlyNearSummonsAttackModifier();
  return OnlyNearSummonsAttackModifier_instance;
}
var Companion_instance_72;
function Companion_getInstance_73() {
  return Companion_instance_72;
}
function _get_$cachedSerializer__te6jhj_10($this) {
  return $this.b36_1.k3();
}
function PerformForEachHunter$Companion$_anonymous__qfzihm() {
  var tmp = getKClass(PerformForEachHunter);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(AvariceCardHuntersStatement), getKClass(GainHunterItemStatement), getKClass(MoveSeveralHuntersStatement), getKClass(RecoveryTestForEachHunterStatement), getKClass(RetrieveDiscardedAbilitiesStatement)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_52(), $serializer_getInstance_1(), $serializer_getInstance_10(), $serializer_getInstance_375(), $serializer_getInstance_53()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [];
  return SealedClassSerializer.i10('PerformForEachHunter', tmp, tmp_0, tmp_1, tmp$ret$6);
}
var Companion_instance_73;
function Companion_getInstance_74() {
  if (Companion_instance_73 === VOID)
    new Companion_73();
  return Companion_instance_73;
}
function _get_$cachedSerializer__te6jhj_11($this) {
  return $this.c36_1.k3();
}
function JustNearbyAttackModifier$_anonymous__obvidv() {
  var tmp = JustNearbyAttackModifier_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('JustNearbyAttackModifier', tmp, tmp$ret$0);
}
var JustNearbyAttackModifier_instance;
function JustNearbyAttackModifier_getInstance() {
  if (JustNearbyAttackModifier_instance === VOID)
    new JustNearbyAttackModifier();
  return JustNearbyAttackModifier_instance;
}
var Companion_instance_74;
function Companion_getInstance_75() {
  return Companion_instance_74;
}
function noAvailableArsenalCards(_this__u8e3s4) {
  return _this__u8e3s4.d36().n1() && _this__u8e3s4.e36().n1();
}
function _get_$cachedSerializer__te6jhj_12($this) {
  return $this.f36_1.k3();
}
function PlaceNewSummonBaseStatement$Companion$_anonymous__ieiesr() {
  var tmp = getKClass(PlaceNewSummonBaseStatement);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(PlaceNewSummonNearbyStatement), getKClass(PlaceNewSummonOnLocationsStatement), getKClass(PlaceNewSummonStatement)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_54(), $serializer_getInstance_55(), $serializer_getInstance_56()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [];
  return SealedClassSerializer.i10('PlaceNewSummonBaseStatement', tmp, tmp_0, tmp_1, tmp$ret$6);
}
var Companion_instance_75;
function Companion_getInstance_76() {
  if (Companion_instance_75 === VOID)
    new Companion_75();
  return Companion_instance_75;
}
function get_akkeronEternityTransformedPositionsKey() {
  _init_properties_Akkeron_kt__hfh50b();
  return akkeronEternityTransformedPositionsKey;
}
var akkeronEternityTransformedPositionsKey;
function _get_$cachedSerializer__te6jhj_13($this) {
  return $this.g36_1.k3();
}
function VoidCallUpgrade$_anonymous__vh33vx() {
  var tmp = VoidCallUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('VoidCallUpgrade', tmp, tmp$ret$0);
}
var VoidCallUpgrade_instance;
function VoidCallUpgrade_getInstance() {
  if (VoidCallUpgrade_instance === VOID)
    new VoidCallUpgrade();
  return VoidCallUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_14($this) {
  return $this.h36_1.k3();
}
function AbyssalBeastUpgrade$_anonymous__im3hyv() {
  var tmp = AbyssalBeastUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AbyssalBeastUpgrade', tmp, tmp$ret$0);
}
var AbyssalBeastUpgrade_instance;
function AbyssalBeastUpgrade_getInstance() {
  if (AbyssalBeastUpgrade_instance === VOID)
    new AbyssalBeastUpgrade();
  return AbyssalBeastUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_15($this) {
  return $this.i36_1.k3();
}
function EchoUpgrade$_anonymous__ns4tc() {
  var tmp = EchoUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EchoUpgrade', tmp, tmp$ret$0);
}
var EchoUpgrade_instance;
function EchoUpgrade_getInstance() {
  if (EchoUpgrade_instance === VOID)
    new EchoUpgrade();
  return EchoUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_16($this) {
  return $this.j36_1.k3();
}
function EternityUpgrade$_anonymous__n3p3k9() {
  var tmp = EternityUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EternityUpgrade', tmp, tmp$ret$0);
}
var EternityUpgrade_instance;
function EternityUpgrade_getInstance() {
  if (EternityUpgrade_instance === VOID)
    new EternityUpgrade();
  return EternityUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_17($this) {
  return $this.k36_1.k3();
}
function VoidStepUpgrade$_anonymous__w61g11() {
  var tmp = VoidStepUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('VoidStepUpgrade', tmp, tmp$ret$0);
}
var VoidStepUpgrade_instance;
function VoidStepUpgrade_getInstance() {
  if (VoidStepUpgrade_instance === VOID)
    new VoidStepUpgrade();
  return VoidStepUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_18($this) {
  return $this.l36_1.k3();
}
function DarkSpawnUpgrade$_anonymous__ldo61s() {
  var tmp = DarkSpawnUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DarkSpawnUpgrade', tmp, tmp$ret$0);
}
var DarkSpawnUpgrade_instance;
function DarkSpawnUpgrade_getInstance() {
  if (DarkSpawnUpgrade_instance === VOID)
    new DarkSpawnUpgrade();
  return DarkSpawnUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_19($this) {
  return $this.m36_1.k3();
}
function VoidCallStatement$_anonymous__1y95y() {
  var tmp = VoidCallStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('VoidCallStatement', tmp, tmp$ret$0);
}
var VoidCallStatement_instance;
function VoidCallStatement_getInstance() {
  if (VoidCallStatement_instance === VOID)
    new VoidCallStatement();
  return VoidCallStatement_instance;
}
function _get_$cachedSerializer__te6jhj_20($this) {
  return $this.n36_1.k3();
}
function AbyssalBeastStatement$_anonymous__33750() {
  var tmp = AbyssalBeastStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AbyssalBeastStatement', tmp, tmp$ret$0);
}
var AbyssalBeastStatement_instance;
function AbyssalBeastStatement_getInstance() {
  if (AbyssalBeastStatement_instance === VOID)
    new AbyssalBeastStatement();
  return AbyssalBeastStatement_instance;
}
function _get_$cachedSerializer__te6jhj_21($this) {
  return $this.p36_1.k3();
}
function Akkeron$_anonymous__qn399y() {
  var tmp = Akkeron_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Akkeron', tmp, tmp$ret$0);
}
var Akkeron_instance;
function Akkeron_getInstance() {
  if (Akkeron_instance === VOID)
    new Akkeron();
  return Akkeron_instance;
}
function AbyssalPullStatement$Companion$$childSerializers$_anonymous__gt7kcj() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_76;
function Companion_getInstance_77() {
  if (Companion_instance_76 === VOID)
    new Companion_76();
  return Companion_instance_76;
}
var $serializer_instance_68;
function $serializer_getInstance_68() {
  if ($serializer_instance_68 === VOID)
    new $serializer_68();
  return $serializer_instance_68;
}
function VoidStatement$Companion$$childSerializers$_anonymous__1kxo0h() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_77;
function Companion_getInstance_78() {
  if (Companion_instance_77 === VOID)
    new Companion_77();
  return Companion_instance_77;
}
var $serializer_instance_69;
function $serializer_getInstance_69() {
  if ($serializer_instance_69 === VOID)
    new $serializer_69();
  return $serializer_instance_69;
}
function AkkeronEternityTransformedPositionsChangeEvent$Companion$$childSerializers$_anonymous__307kqg() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_78;
function Companion_getInstance_79() {
  if (Companion_instance_78 === VOID)
    new Companion_78();
  return Companion_instance_78;
}
var $serializer_instance_70;
function $serializer_getInstance_70() {
  if ($serializer_instance_70 === VOID)
    new $serializer_70();
  return $serializer_instance_70;
}
function _get_$cachedSerializer__te6jhj_22($this) {
  return $this.q37_1.k3();
}
function AbominationType$_anonymous__oemc2c() {
  var tmp = AbominationType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AbominationType', tmp, tmp$ret$0);
}
var AbominationType_instance;
function AbominationType_getInstance() {
  if (AbominationType_instance === VOID)
    new AbominationType();
  return AbominationType_instance;
}
function _get_$cachedSerializer__te6jhj_23($this) {
  return $this.s37_1.k3();
}
function ConsumeCard$_anonymous__tbxdsl() {
  var tmp = ConsumeCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ConsumeCard', tmp, tmp$ret$0);
}
var ConsumeCard_instance;
function ConsumeCard_getInstance() {
  if (ConsumeCard_instance === VOID)
    new ConsumeCard();
  return ConsumeCard_instance;
}
function _get_$cachedSerializer__te6jhj_24($this) {
  return $this.v37_1.k3();
}
function CorruptCard$_anonymous__itwqu2() {
  var tmp = CorruptCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CorruptCard', tmp, tmp$ret$0);
}
var CorruptCard_instance;
function CorruptCard_getInstance() {
  if (CorruptCard_instance === VOID)
    new CorruptCard();
  return CorruptCard_instance;
}
function _get_$cachedSerializer__te6jhj_25($this) {
  return $this.w37_1.k3();
}
function DefileCard$_anonymous__f87rxm() {
  var tmp = DefileCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DefileCard', tmp, tmp$ret$0);
}
var DefileCard_instance;
function DefileCard_getInstance() {
  if (DefileCard_instance === VOID)
    new DefileCard();
  return DefileCard_instance;
}
function _get_$cachedSerializer__te6jhj_26($this) {
  return $this.x37_1.k3();
}
function VoidCard$_anonymous__dnwx77() {
  var tmp = VoidCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('VoidCard', tmp, tmp$ret$0);
}
var VoidCard_instance;
function VoidCard_getInstance() {
  if (VoidCard_instance === VOID)
    new VoidCard();
  return VoidCard_instance;
}
function set_akkeronEternityTransformedPositionsImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Akkeron_kt__hfh50b();
  gsiCtx.j39(_this__u8e3s4.r2w_1, get_akkeronEternityTransformedPositionsKey(), new BoardPositionSetWrapper(value), new BoardPositionSetWrapper(emptySet()));
}
function get_akkeronBeast($context_GameState_t6qee5) {
  _init_properties_Akkeron_kt__hfh50b();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Akkeron) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function get_akkeronEternityTransformedPositions(gsCtx, _this__u8e3s4) {
  _init_properties_Akkeron_kt__hfh50b();
  return getAkkeronEternityTransformedPositionsImpl(_this__u8e3s4, gsCtx);
}
function getAkkeronEternityTransformedPositionsImpl(_this__u8e3s4, gameState) {
  _init_properties_Akkeron_kt__hfh50b();
  // Inline function 'kotlin.with' call
  return getGeneralPropertyWithDefault(_this__u8e3s4.l39(gameState), get_akkeronEternityTransformedPositionsKey(), new BoardPositionSetWrapper(emptySet())).k39_1;
}
var properties_initialized_Akkeron_kt_r7muxv;
function _init_properties_Akkeron_kt__hfh50b() {
  if (!properties_initialized_Akkeron_kt_r7muxv) {
    properties_initialized_Akkeron_kt_r7muxv = true;
    akkeronEternityTransformedPositionsKey = _GeneralMapKey___init__impl__zdmbea('akkeronEternityTransformedPositions');
  }
}
function get_arrivalOfTheTitanHabitatLocations() {
  _init_properties_ArrivalOfTheTitanContract_kt__4au6qz();
  return arrivalOfTheTitanHabitatLocations;
}
var arrivalOfTheTitanHabitatLocations;
var Companion_instance_79;
function Companion_getInstance_80() {
  return Companion_instance_79;
}
var $serializer_instance_71;
function $serializer_getInstance_71() {
  if ($serializer_instance_71 === VOID)
    new $serializer_71();
  return $serializer_instance_71;
}
function _get_$cachedSerializer__te6jhj_27($this) {
  return $this.f3b_1.k3();
}
function ArrivalOfTheTitanInitialPhase$_anonymous__x4l9mz() {
  var tmp = ArrivalOfTheTitanInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ArrivalOfTheTitanInitialPhase', tmp, tmp$ret$0);
}
var ArrivalOfTheTitanInitialPhase_instance;
function ArrivalOfTheTitanInitialPhase_getInstance() {
  if (ArrivalOfTheTitanInitialPhase_instance === VOID)
    new ArrivalOfTheTitanInitialPhase();
  return ArrivalOfTheTitanInitialPhase_instance;
}
function get_arrivalOfTheTitanHabitatTokensPlaced($context_GameState_t6qee5) {
  _init_properties_ArrivalOfTheTitanContract_kt__4au6qz();
  var tmp0 = get_arrivalOfTheTitanHabitatLocations();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var it = element.r2v_1;
      if (get_locationType($context_GameState_t6qee5, it).equals(LocationType_Settlement_getInstance())) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$0 = count;
  }
  return tmp$ret$0;
}
function _get_$cachedSerializer__te6jhj_28($this) {
  return $this.g3b_1.k3();
}
function ArrivalOfTheTitanSettlementClaimingSource$_anonymous__u7thr6() {
  var tmp = ArrivalOfTheTitanSettlementClaimingSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ArrivalOfTheTitanSettlementClaimingSource', tmp, tmp$ret$0);
}
var ArrivalOfTheTitanSettlementClaimingSource_instance;
function ArrivalOfTheTitanSettlementClaimingSource_getInstance() {
  if (ArrivalOfTheTitanSettlementClaimingSource_instance === VOID)
    new ArrivalOfTheTitanSettlementClaimingSource();
  return ArrivalOfTheTitanSettlementClaimingSource_instance;
}
function _get_$cachedSerializer__te6jhj_29($this) {
  return $this.h3b_1.k3();
}
function ArrivalOfTheTitanSettlerMoveEffectSource$_anonymous__46kk82() {
  var tmp = ArrivalOfTheTitanSettlerMoveEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ArrivalOfTheTitanSettlerMoveEffectSource', tmp, tmp$ret$0);
}
var ArrivalOfTheTitanSettlerMoveEffectSource_instance;
function ArrivalOfTheTitanSettlerMoveEffectSource_getInstance() {
  if (ArrivalOfTheTitanSettlerMoveEffectSource_instance === VOID)
    new ArrivalOfTheTitanSettlerMoveEffectSource();
  return ArrivalOfTheTitanSettlerMoveEffectSource_instance;
}
var Companion_instance_80;
function Companion_getInstance_81() {
  return Companion_instance_80;
}
var $serializer_instance_72;
function $serializer_getInstance_72() {
  if ($serializer_instance_72 === VOID)
    new $serializer_72();
  return $serializer_instance_72;
}
var properties_initialized_ArrivalOfTheTitanContract_kt_1zh04t;
function _init_properties_ArrivalOfTheTitanContract_kt__4au6qz() {
  if (!properties_initialized_ArrivalOfTheTitanContract_kt_1zh04t) {
    properties_initialized_ArrivalOfTheTitanContract_kt_1zh04t = true;
    arrivalOfTheTitanHabitatLocations = setOf_0([new BoardPosition(LowerShatteredSettlements_getInstance().p3b_1), new BoardPosition(LowerShatteredSettlements_getInstance().s3b_1), new BoardPosition(LowerShatteredSettlements_getInstance().r3b_1)]);
  }
}
function get_ashfallRuinPositionsByZone() {
  _init_properties_AshfallRuins_kt__2p8ikm();
  return ashfallRuinPositionsByZone;
}
var ashfallRuinPositionsByZone;
function get_allAshRuins() {
  _init_properties_AshfallRuins_kt__2p8ikm();
  return allAshRuins;
}
var allAshRuins;
var Companion_instance_81;
function Companion_getInstance_82() {
  return Companion_instance_81;
}
function _get_$cachedSerializer__te6jhj_30($this) {
  return $this.u3b_1.k3();
}
function Ruin1$_anonymous__oa3lde() {
  var tmp = Ruin1_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin1', tmp, tmp$ret$0);
}
var Ruin1_instance;
function Ruin1_getInstance() {
  if (Ruin1_instance === VOID)
    new Ruin1();
  return Ruin1_instance;
}
function _get_$cachedSerializer__te6jhj_31($this) {
  return $this.w3b_1.k3();
}
function Ruin2$_anonymous__jfey5v() {
  var tmp = Ruin2_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin2', tmp, tmp$ret$0);
}
var Ruin2_instance;
function Ruin2_getInstance() {
  if (Ruin2_instance === VOID)
    new Ruin2();
  return Ruin2_instance;
}
function _get_$cachedSerializer__te6jhj_32($this) {
  return $this.y3b_1.k3();
}
function Ruin3$_anonymous__ekqayc() {
  var tmp = Ruin3_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin3', tmp, tmp$ret$0);
}
var Ruin3_instance;
function Ruin3_getInstance() {
  if (Ruin3_instance === VOID)
    new Ruin3();
  return Ruin3_instance;
}
function _get_$cachedSerializer__te6jhj_33($this) {
  return $this.a3c_1.k3();
}
function Ruin4$_anonymous__9q1nqt() {
  var tmp = Ruin4_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin4', tmp, tmp$ret$0);
}
var Ruin4_instance;
function Ruin4_getInstance() {
  if (Ruin4_instance === VOID)
    new Ruin4();
  return Ruin4_instance;
}
function _get_$cachedSerializer__te6jhj_34($this) {
  return $this.c3c_1.k3();
}
function Ruin5$_anonymous__4vd0ja() {
  var tmp = Ruin5_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin5', tmp, tmp$ret$0);
}
var Ruin5_instance;
function Ruin5_getInstance() {
  if (Ruin5_instance === VOID)
    new Ruin5();
  return Ruin5_instance;
}
function _get_$cachedSerializer__te6jhj_35($this) {
  return $this.e3c_1.k3();
}
function Ruin6$_anonymous__odbr() {
  var tmp = Ruin6_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin6', tmp, tmp$ret$0);
}
var Ruin6_instance;
function Ruin6_getInstance() {
  if (Ruin6_instance === VOID)
    new Ruin6();
  return Ruin6_instance;
}
function _get_$cachedSerializer__te6jhj_36($this) {
  return $this.g3c_1.k3();
}
function Ruin7$_anonymous__4u09vs() {
  var tmp = Ruin7_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin7', tmp, tmp$ret$0);
}
var Ruin7_instance;
function Ruin7_getInstance() {
  if (Ruin7_instance === VOID)
    new Ruin7();
  return Ruin7_instance;
}
function _get_$cachedSerializer__te6jhj_37($this) {
  return $this.i3c_1.k3();
}
function Ruin8$_anonymous__9oox3b() {
  var tmp = Ruin8_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin8', tmp, tmp$ret$0);
}
var Ruin8_instance;
function Ruin8_getInstance() {
  if (Ruin8_instance === VOID)
    new Ruin8();
  return Ruin8_instance;
}
function _get_$cachedSerializer__te6jhj_38($this) {
  return $this.k3c_1.k3();
}
function Ruin9$_anonymous__ejdkau() {
  var tmp = Ruin9_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin9', tmp, tmp$ret$0);
}
var Ruin9_instance;
function Ruin9_getInstance() {
  if (Ruin9_instance === VOID)
    new Ruin9();
  return Ruin9_instance;
}
function _get_$cachedSerializer__te6jhj_39($this) {
  return $this.m3c_1.k3();
}
function Ruin10$_anonymous__grtpxs() {
  var tmp = Ruin10_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin10', tmp, tmp$ret$0);
}
var Ruin10_instance;
function Ruin10_getInstance() {
  if (Ruin10_instance === VOID)
    new Ruin10();
  return Ruin10_instance;
}
function _get_$cachedSerializer__te6jhj_40($this) {
  return $this.o3c_1.k3();
}
function Ruin11$_anonymous__lmid5b() {
  var tmp = Ruin11_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin11', tmp, tmp$ret$0);
}
var Ruin11_instance;
function Ruin11_getInstance() {
  if (Ruin11_instance === VOID)
    new Ruin11();
  return Ruin11_instance;
}
function _get_$cachedSerializer__te6jhj_41($this) {
  return $this.q3c_1.k3();
}
function Ruin12$_anonymous__qh70cu() {
  var tmp = Ruin12_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Ruin12', tmp, tmp$ret$0);
}
var Ruin12_instance;
function Ruin12_getInstance() {
  if (Ruin12_instance === VOID)
    new Ruin12();
  return Ruin12_instance;
}
var Companion_instance_82;
function Companion_getInstance_83() {
  return Companion_instance_82;
}
function PlayAshRuinStatement$Companion$$childSerializers$_anonymous__77i2h1() {
  return Companion_instance_81.a2g();
}
function PlayAshRuinStatement$Companion$$childSerializers$_anonymous__77i2h1_0() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_83;
function Companion_getInstance_84() {
  if (Companion_instance_83 === VOID)
    new Companion_83();
  return Companion_instance_83;
}
var $serializer_instance_73;
function $serializer_getInstance_73() {
  if ($serializer_instance_73 === VOID)
    new $serializer_73();
  return $serializer_instance_73;
}
var Companion_instance_84;
function Companion_getInstance_85() {
  return Companion_instance_84;
}
var $serializer_instance_74;
function $serializer_getInstance_74() {
  if ($serializer_instance_74 === VOID)
    new $serializer_74();
  return $serializer_instance_74;
}
function _get_$cachedSerializer__te6jhj_42($this) {
  return $this.b3d_1.k3();
}
function HunterItemToExchangeByRuinQuestionContext$_anonymous__c7yogy() {
  var tmp = HunterItemToExchangeByRuinQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterItemToExchangeByRuinQuestionContext', tmp, tmp$ret$0);
}
var HunterItemToExchangeByRuinQuestionContext_instance;
function HunterItemToExchangeByRuinQuestionContext_getInstance() {
  if (HunterItemToExchangeByRuinQuestionContext_instance === VOID)
    new HunterItemToExchangeByRuinQuestionContext();
  return HunterItemToExchangeByRuinQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_43($this) {
  return $this.c3d_1.k3();
}
function HunterItemToGiveByRuinQuestionContext$_anonymous__ig0md0() {
  var tmp = HunterItemToGiveByRuinQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterItemToGiveByRuinQuestionContext', tmp, tmp$ret$0);
}
var HunterItemToGiveByRuinQuestionContext_instance;
function HunterItemToGiveByRuinQuestionContext_getInstance() {
  if (HunterItemToGiveByRuinQuestionContext_instance === VOID)
    new HunterItemToGiveByRuinQuestionContext();
  return HunterItemToGiveByRuinQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_44($this) {
  return $this.d3d_1.k3();
}
function LocationsToCheckForBeastByRuinQuestionContext$_anonymous__i7u3ce() {
  var tmp = LocationsToCheckForBeastByRuinQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LocationsToCheckForBeastByRuinQuestionContext', tmp, tmp$ret$0);
}
var LocationsToCheckForBeastByRuinQuestionContext_instance;
function LocationsToCheckForBeastByRuinQuestionContext_getInstance() {
  if (LocationsToCheckForBeastByRuinQuestionContext_instance === VOID)
    new LocationsToCheckForBeastByRuinQuestionContext();
  return LocationsToCheckForBeastByRuinQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_45($this) {
  return $this.e3d_1.k3();
}
function SameHabitatRelocationByRuinQuestionContext$_anonymous__hrfway() {
  var tmp = SameHabitatRelocationByRuinQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SameHabitatRelocationByRuinQuestionContext', tmp, tmp$ret$0);
}
var SameHabitatRelocationByRuinQuestionContext_instance;
function SameHabitatRelocationByRuinQuestionContext_getInstance() {
  if (SameHabitatRelocationByRuinQuestionContext_instance === VOID)
    new SameHabitatRelocationByRuinQuestionContext();
  return SameHabitatRelocationByRuinQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_46($this) {
  return $this.f3d_1.k3();
}
function HunterToGiveItemByRuinQuestionContext$_anonymous__hnaxv8() {
  var tmp = HunterToGiveItemByRuinQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToGiveItemByRuinQuestionContext', tmp, tmp$ret$0);
}
var HunterToGiveItemByRuinQuestionContext_instance;
function HunterToGiveItemByRuinQuestionContext_getInstance() {
  if (HunterToGiveItemByRuinQuestionContext_instance === VOID)
    new HunterToGiveItemByRuinQuestionContext();
  return HunterToGiveItemByRuinQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_47($this) {
  return $this.g3d_1.k3();
}
function HunterToReceiveItemByRuinQuestionContext$_anonymous__b32qiw() {
  var tmp = HunterToReceiveItemByRuinQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToReceiveItemByRuinQuestionContext', tmp, tmp$ret$0);
}
var HunterToReceiveItemByRuinQuestionContext_instance;
function HunterToReceiveItemByRuinQuestionContext_getInstance() {
  if (HunterToReceiveItemByRuinQuestionContext_instance === VOID)
    new HunterToReceiveItemByRuinQuestionContext();
  return HunterToReceiveItemByRuinQuestionContext_instance;
}
function ashRuinAt(gameState, position) {
  _init_properties_AshfallRuins_kt__2p8ikm();
  var tmp;
  if (get_usesAshfallMapFeatures(get_gameRules(gameState))) {
    var tmp0 = gameState.h3d().i3();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.singleOrNull' call
      var single = null;
      var found = false;
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.k3().equals(new BoardPosition(position))) {
          if (found) {
            tmp$ret$0 = null;
            break $l$block_0;
          }
          single = element;
          found = true;
        }
      }
      if (!found) {
        tmp$ret$0 = null;
        break $l$block_0;
      }
      tmp$ret$0 = single;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j3();
  } else {
    tmp = null;
  }
  return tmp;
}
function get_activeRuinPositions(gameState) {
  _init_properties_AshfallRuins_kt__2p8ikm();
  var tmp;
  var tmp_0;
  if (get_usesAshfallMapFeatures(get_gameRules(gameState))) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_0 = !gameState.h3d().n1();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = toSet(gameState.h3d().y4());
  } else {
    tmp = get_gameMap_1(gameState).i3d();
  }
  return tmp;
}
var properties_initialized_AshfallRuins_kt_h9w884;
function _init_properties_AshfallRuins_kt__2p8ikm() {
  if (!properties_initialized_AshfallRuins_kt_h9w884) {
    properties_initialized_AshfallRuins_kt_h9w884 = true;
    ashfallRuinPositionsByZone = mapOf([to(Zone_Barum_getInstance(), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-1, -2))), to(Zone_Vildmark_getInstance(), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(2, -1))), to(Zone_NewElda_getInstance(), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-1, 3))), to(Zone_Jarlland_getInstance(), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(4, 2)))]);
    allAshRuins = linkedSetOf([Ruin1_getInstance(), Ruin2_getInstance(), Ruin3_getInstance(), Ruin4_getInstance(), Ruin5_getInstance(), Ruin6_getInstance(), Ruin7_getInstance(), Ruin8_getInstance(), Ruin9_getInstance(), Ruin10_getInstance(), Ruin11_getInstance(), Ruin12_getInstance()]);
  }
}
var Companion_instance_85;
function Companion_getInstance_86() {
  return Companion_instance_85;
}
var $serializer_instance_75;
function $serializer_getInstance_75() {
  if ($serializer_instance_75 === VOID)
    new $serializer_75();
  return $serializer_instance_75;
}
function _get_$cachedSerializer__te6jhj_48($this) {
  return $this.w3d_1.k3();
}
function AshfallUnlikelyAllianceInitialPhase$_anonymous__3ku9tn() {
  var tmp = AshfallUnlikelyAllianceInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AshfallUnlikelyAllianceInitialPhase', tmp, tmp$ret$0);
}
var AshfallUnlikelyAllianceInitialPhase_instance;
function AshfallUnlikelyAllianceInitialPhase_getInstance() {
  if (AshfallUnlikelyAllianceInitialPhase_instance === VOID)
    new AshfallUnlikelyAllianceInitialPhase();
  return AshfallUnlikelyAllianceInitialPhase_instance;
}
var Companion_instance_86;
function Companion_getInstance_87() {
  return Companion_instance_86;
}
var $serializer_instance_76;
function $serializer_getInstance_76() {
  if ($serializer_instance_76 === VOID)
    new $serializer_76();
  return $serializer_instance_76;
}
var Companion_instance_87;
function Companion_getInstance_88() {
  return Companion_instance_87;
}
var $serializer_instance_77;
function $serializer_getInstance_77() {
  if ($serializer_instance_77 === VOID)
    new $serializer_77();
  return $serializer_instance_77;
}
function get_redDraftActionCardWasPlayedKey() {
  _init_properties_Assar_kt__jell34();
  return redDraftActionCardWasPlayedKey;
}
var redDraftActionCardWasPlayedKey;
function get_assarWillCopyCardOfKey() {
  _init_properties_Assar_kt__jell34();
  return assarWillCopyCardOfKey;
}
var assarWillCopyCardOfKey;
function _get_$cachedSerializer__te6jhj_49($this) {
  return $this.h3e_1.k3();
}
function Assar$_anonymous__cku3dx() {
  var tmp = Assar_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Assar', tmp, tmp$ret$0);
}
var Assar_instance;
function Assar_getInstance() {
  if (Assar_instance === VOID)
    new Assar();
  return Assar_instance;
}
function _get_$cachedSerializer__te6jhj_50($this) {
  return $this.j3e_1.k3();
}
function ResonanceUpgrade$_anonymous__g6rrop() {
  var tmp = ResonanceUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ResonanceUpgrade', tmp, tmp$ret$0);
}
var ResonanceUpgrade_instance;
function ResonanceUpgrade_getInstance() {
  if (ResonanceUpgrade_instance === VOID)
    new ResonanceUpgrade();
  return ResonanceUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_51($this) {
  return $this.k3e_1.k3();
}
function ExceptionalTrackerUpgrade$_anonymous__6r143d() {
  var tmp = ExceptionalTrackerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ExceptionalTrackerUpgrade', tmp, tmp$ret$0);
}
var ExceptionalTrackerUpgrade_instance;
function ExceptionalTrackerUpgrade_getInstance() {
  if (ExceptionalTrackerUpgrade_instance === VOID)
    new ExceptionalTrackerUpgrade();
  return ExceptionalTrackerUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_52($this) {
  return $this.l3e_1.k3();
}
function SeekerUpgrade$_anonymous__mkuly8() {
  var tmp = SeekerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SeekerUpgrade', tmp, tmp$ret$0);
}
var SeekerUpgrade_instance;
function SeekerUpgrade_getInstance() {
  if (SeekerUpgrade_instance === VOID)
    new SeekerUpgrade();
  return SeekerUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_53($this) {
  return $this.m3e_1.k3();
}
function ExploreUpgrade$_anonymous__h7ch8u() {
  var tmp = ExploreUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ExploreUpgrade', tmp, tmp$ret$0);
}
var ExploreUpgrade_instance;
function ExploreUpgrade_getInstance() {
  if (ExploreUpgrade_instance === VOID)
    new ExploreUpgrade();
  return ExploreUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_54($this) {
  return $this.p3e_1.k3();
}
function ScoutCard$_anonymous__6dk0rt() {
  var tmp = ScoutCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ScoutCard', tmp, tmp$ret$0);
}
var ScoutCard_instance;
function ScoutCard_getInstance() {
  if (ScoutCard_instance === VOID)
    new ScoutCard();
  return ScoutCard_instance;
}
function _get_$cachedSerializer__te6jhj_55($this) {
  return $this.q3e_1.k3();
}
function ResonanceChooseStatement$_anonymous__qaisq5() {
  var tmp = ResonanceChooseStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ResonanceChooseStatement', tmp, tmp$ret$0);
}
var ResonanceChooseStatement_instance;
function ResonanceChooseStatement_getInstance() {
  if (ResonanceChooseStatement_instance === VOID)
    new ResonanceChooseStatement();
  return ResonanceChooseStatement_instance;
}
function get_assarHunter($context_GameState_t6qee5) {
  _init_properties_Assar_kt__jell34();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Assar) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function ScoutStatement$Companion$$childSerializers$_anonymous__52ls7t() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_88;
function Companion_getInstance_89() {
  if (Companion_instance_88 === VOID)
    new Companion_88();
  return Companion_instance_88;
}
var $serializer_instance_78;
function $serializer_getInstance_78() {
  if ($serializer_instance_78 === VOID)
    new $serializer_78();
  return $serializer_instance_78;
}
function _get_$cachedSerializer__te6jhj_56($this) {
  return $this.w3e_1.k3();
}
function HunterToCopyFirstRedCardQuestionContext$_anonymous__5ybt4f() {
  var tmp = HunterToCopyFirstRedCardQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToCopyFirstRedCardQuestionContext', tmp, tmp$ret$0);
}
var HunterToCopyFirstRedCardQuestionContext_instance;
function HunterToCopyFirstRedCardQuestionContext_getInstance() {
  if (HunterToCopyFirstRedCardQuestionContext_instance === VOID)
    new HunterToCopyFirstRedCardQuestionContext();
  return HunterToCopyFirstRedCardQuestionContext_instance;
}
function ChangeRedDraftActionCardWasPlayedStatusEvent$Companion$$childSerializers$_anonymous__21p2p4() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_380.a2g()));
}
var Companion_instance_89;
function Companion_getInstance_90() {
  if (Companion_instance_89 === VOID)
    new Companion_89();
  return Companion_instance_89;
}
var $serializer_instance_79;
function $serializer_getInstance_79() {
  if ($serializer_instance_79 === VOID)
    new $serializer_79();
  return $serializer_instance_79;
}
function ResonanceChooseEvent$Companion$$childSerializers$_anonymous__t3dvu3() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_90;
function Companion_getInstance_91() {
  if (Companion_instance_90 === VOID)
    new Companion_90();
  return Companion_instance_90;
}
var $serializer_instance_80;
function $serializer_getInstance_80() {
  if ($serializer_instance_80 === VOID)
    new $serializer_80();
  return $serializer_instance_80;
}
function set_redDraftActionCardWasPlayedImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Assar_kt__jell34();
  gsiCtx.j39(_this__u8e3s4.r2w_1, get_redDraftActionCardWasPlayedKey(), new BooleanWrapper(value), new BooleanWrapper(false));
}
function set_assarWillCopyCardOfImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Assar_kt__jell34();
  setImplProperty(gsiCtx, _this__u8e3s4, get_assarWillCopyCardOfKey(), new ObjectOnBoardWrapper(value));
}
function get_assarWillCopyCardOf(gsCtx, _this__u8e3s4) {
  _init_properties_Assar_kt__jell34();
  return getAssarWillCopyCardOfImpl(_this__u8e3s4, gsCtx);
}
function getAssarWillCopyCardOfImpl(_this__u8e3s4, gameState) {
  _init_properties_Assar_kt__jell34();
  // Inline function 'kotlin.with' call
  var tmp = get_implProperty(gameState, _this__u8e3s4, get_assarWillCopyCardOfKey()).i3f_1;
  return (tmp == null ? true : tmp instanceof ObjectOnBoard) ? tmp : THROW_CCE();
}
var properties_initialized_Assar_kt_fjwqvy;
function _init_properties_Assar_kt__jell34() {
  if (!properties_initialized_Assar_kt_fjwqvy) {
    properties_initialized_Assar_kt_fjwqvy = true;
    redDraftActionCardWasPlayedKey = _GeneralMapKey___init__impl__zdmbea('redDraftActionCardWasPlayed');
    assarWillCopyCardOfKey = _GeneralMapKey___init__impl__zdmbea('assarWillCopyCardOf');
  }
}
var Companion_instance_91;
function Companion_getInstance_92() {
  return Companion_instance_91;
}
var $serializer_instance_81;
function $serializer_getInstance_81() {
  if ($serializer_instance_81 === VOID)
    new $serializer_81();
  return $serializer_instance_81;
}
function _get_$cachedSerializer__te6jhj_57($this) {
  return $this.t3f_1.k3();
}
function AttackOnTheNorthernSettlementsInitialPhase$_anonymous__u3xjx8() {
  var tmp = AttackOnTheNorthernSettlementsInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AttackOnTheNorthernSettlementsInitialPhase', tmp, tmp$ret$0);
}
var AttackOnTheNorthernSettlementsInitialPhase_instance;
function AttackOnTheNorthernSettlementsInitialPhase_getInstance() {
  if (AttackOnTheNorthernSettlementsInitialPhase_instance === VOID)
    new AttackOnTheNorthernSettlementsInitialPhase();
  return AttackOnTheNorthernSettlementsInitialPhase_instance;
}
function get_lastSeenPositionKey() {
  _init_properties_Beast_kt__1ufzal();
  return lastSeenPositionKey;
}
var lastSeenPositionKey;
function get_beastPathKey() {
  _init_properties_Beast_kt__1ufzal();
  return beastPathKey;
}
var beastPathKey;
function get_beastMovementsKey() {
  _init_properties_Beast_kt__1ufzal();
  return beastMovementsKey;
}
var beastMovementsKey;
function get_foundTrailsKey() {
  _init_properties_Beast_kt__1ufzal();
  return foundTrailsKey;
}
var foundTrailsKey;
var Companion_instance_92;
function Companion_getInstance_93() {
  return Companion_instance_92;
}
function BeastPathStep$Companion$$childSerializers$_anonymous__3n7h5y() {
  return new ArrayListSerializer($serializer_getInstance_102());
}
function BeastPathStep$Companion$$childSerializers$_anonymous__3n7h5y_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
var Companion_instance_93;
function Companion_getInstance_94() {
  if (Companion_instance_93 === VOID)
    new Companion_93();
  return Companion_instance_93;
}
var $serializer_instance_82;
function $serializer_getInstance_82() {
  if ($serializer_instance_82 === VOID)
    new $serializer_82();
  return $serializer_instance_82;
}
function MovementAndState$Companion$$childSerializers$_anonymous__hybmvz() {
  return new ArrayListSerializer(Companion_instance_115.a2g());
}
function MovementAndState$Companion$$childSerializers$_anonymous__hybmvz_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
var Companion_instance_94;
function Companion_getInstance_95() {
  if (Companion_instance_94 === VOID)
    new Companion_94();
  return Companion_instance_94;
}
var $serializer_instance_83;
function $serializer_getInstance_83() {
  if ($serializer_instance_83 === VOID)
    new $serializer_83();
  return $serializer_instance_83;
}
function summonsOnMap($context_GameState_t6qee5, beast) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (isInterface(tmp, SummonType)) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (get_objectType($context_GameState_t6qee5, beast).t36().w2(get_objectType($context_GameState_t6qee5, element_0)) && get_isAlive($context_GameState_t6qee5, element_0)) {
      destination_0.d2(element_0);
    }
  }
  return toSet(destination_0);
}
function get_isRevealed($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  return get_beastMovements($context_GameState_t6qee5, _this__u8e3s4).n1();
}
function get_foundTrails(gsCtx, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  return getFoundTrailsImpl(_this__u8e3s4, gsCtx);
}
function get_beastMovements(gsCtx, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  return getBeastMovementsImpl(_this__u8e3s4, gsCtx);
}
function get_beastPath(gsCtx, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  return getBeastPathImpl(_this__u8e3s4, gsCtx);
}
function get_lastSeenPosition(gsCtx, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  return getLastSeenPositionImpl(_this__u8e3s4, gsCtx);
}
function get_positionsWithTrailsOrStandee($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  return get_isRevealed($context_GameState_t6qee5, _this__u8e3s4) ? emptySet() : plus_0(get_foundTrails($context_GameState_t6qee5, _this__u8e3s4).x4(), new BoardPosition(get_lastSeenPosition($context_GameState_t6qee5, _this__u8e3s4)));
}
function get_isHidden($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !get_beastMovements($context_GameState_t6qee5, _this__u8e3s4).n1();
}
function possibleLocationsWithBeastType($context_GameState_t6qee5, beast) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = positionsUpToDistance($context_GameState_t6qee5, beast, 2);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var it = element.r2v_1;
    if (get_locationType($context_GameState_t6qee5, it).p32(get_objectType($context_GameState_t6qee5, beast).r36($context_GameState_t6qee5))) {
      destination.d2(element);
    }
  }
  return toSet(destination);
}
function getFoundTrailsImpl(_this__u8e3s4, gameState) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_foundTrailsKey()).q3g_1;
}
function getBeastMovementsImpl(_this__u8e3s4, gameState) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_beastMovementsKey()).r3g_1;
}
function getBeastPathImpl(_this__u8e3s4, gameState) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_beastPathKey()).s3g_1;
}
function getLastSeenPositionImpl(_this__u8e3s4, gameState) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_lastSeenPositionKey()).t3g_1;
}
function set_beastPathImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Beast_kt__1ufzal();
  setImplProperty(gsiCtx, _this__u8e3s4, get_beastPathKey(), new BeastPathStepListWrapper(normalizeBeastPath(value)));
}
function get_beastPathImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  return getBeastPathImpl(_this__u8e3s4, gsiCtx);
}
function set_beastMovementsImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Beast_kt__1ufzal();
  setImplProperty(gsiCtx, _this__u8e3s4, get_beastMovementsKey(), new MovementAndStateListWrapper(normalizeBeastMovements(value)));
}
function get_beastMovementsImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  return getBeastMovementsImpl(_this__u8e3s4, gsiCtx);
}
function set_foundTrailsImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Beast_kt__1ufzal();
  setImplProperty(gsiCtx, _this__u8e3s4, get_foundTrailsKey(), new BoardPositionToIntMapWrapper(toMap(value)));
}
function set_lastSeenPositionImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Beast_kt__1ufzal();
  setImplProperty(gsiCtx, _this__u8e3s4, get_lastSeenPositionKey(), new BoardPositionWrapper(value));
}
function normalizeBeastPath(_this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(_this__u8e3s4, 10));
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = item.e3g(toList(item.x3f_1));
    destination.d2(tmp$ret$2);
  }
  return destination;
}
function normalizeBeastMovements(_this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(_this__u8e3s4, 10));
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = item.p3g(toList(item.i3g_1));
    destination.d2(tmp$ret$2);
  }
  return destination;
}
function get_possibleTrailMaxCounts($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_Beast_kt__1ufzal();
  // Inline function 'kotlin.collections.flatMapIndexed' call
  var tmp0 = get_beastPath($context_GameState_t6qee5, _this__u8e3s4);
  // Inline function 'kotlin.collections.flatMapIndexedTo' call
  var destination = ArrayList.p2();
  var index = 0;
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var list = checkIndexOverflow(_unary__edvuaz) === 0 ? drop(element.x3f_1, 1) : element.x3f_1;
    addAll(destination, list);
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$3 = new possibleTrailMaxCounts$$inlined$groupingBy$1(destination);
  return eachCount(tmp$ret$3);
}
var properties_initialized_Beast_kt_rao9nz;
function _init_properties_Beast_kt__1ufzal() {
  if (!properties_initialized_Beast_kt_rao9nz) {
    properties_initialized_Beast_kt_rao9nz = true;
    lastSeenPositionKey = _GeneralMapKey___init__impl__zdmbea('lastSeenPosition');
    beastPathKey = _GeneralMapKey___init__impl__zdmbea('beastPath');
    beastMovementsKey = _GeneralMapKey___init__impl__zdmbea('beastMovements');
    foundTrailsKey = _GeneralMapKey___init__impl__zdmbea('foundTrails');
  }
}
var Companion_instance_95;
function Companion_getInstance_96() {
  return Companion_instance_95;
}
var $serializer_instance_84;
function $serializer_getInstance_84() {
  if ($serializer_instance_84 === VOID)
    new $serializer_84();
  return $serializer_instance_84;
}
function _get_$cachedSerializer__te6jhj_58($this) {
  return $this.b3h_1.k3();
}
function SuddenMistCard$_anonymous__yihj7l() {
  var tmp = SuddenMistCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SuddenMistCard', tmp, tmp$ret$0);
}
var SuddenMistCard_instance;
function SuddenMistCard_getInstance() {
  if (SuddenMistCard_instance === VOID)
    new SuddenMistCard();
  return SuddenMistCard_instance;
}
var Companion_instance_96;
function Companion_getInstance_97() {
  return Companion_instance_96;
}
var $serializer_instance_85;
function $serializer_getInstance_85() {
  if ($serializer_instance_85 === VOID)
    new $serializer_85();
  return $serializer_instance_85;
}
var Companion_instance_97;
function Companion_getInstance_98() {
  return Companion_instance_97;
}
function EvolveCard$Companion$$childSerializers$_anonymous__e2t2wt() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_98;
function Companion_getInstance_99() {
  if (Companion_instance_98 === VOID)
    new Companion_98();
  return Companion_instance_98;
}
var $serializer_instance_86;
function $serializer_getInstance_86() {
  if ($serializer_instance_86 === VOID)
    new $serializer_86();
  return $serializer_instance_86;
}
function UnbendingWillCard$Companion$$childSerializers$_anonymous__9rfi14() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_99;
function Companion_getInstance_100() {
  if (Companion_instance_99 === VOID)
    new Companion_99();
  return Companion_instance_99;
}
var $serializer_instance_87;
function $serializer_getInstance_87() {
  if ($serializer_instance_87 === VOID)
    new $serializer_87();
  return $serializer_instance_87;
}
function BrutalityCard$Companion$$childSerializers$_anonymous__y5p32y() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_100;
function Companion_getInstance_101() {
  if (Companion_instance_100 === VOID)
    new Companion_100();
  return Companion_instance_100;
}
var $serializer_instance_88;
function $serializer_getInstance_88() {
  if ($serializer_instance_88 === VOID)
    new $serializer_88();
  return $serializer_instance_88;
}
function RageCard$Companion$$childSerializers$_anonymous__tnthar() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_101;
function Companion_getInstance_102() {
  if (Companion_instance_101 === VOID)
    new Companion_101();
  return Companion_instance_101;
}
var $serializer_instance_89;
function $serializer_getInstance_89() {
  if ($serializer_instance_89 === VOID)
    new $serializer_89();
  return $serializer_instance_89;
}
function StrangeSummonsCard$Companion$$childSerializers$_anonymous__o2tiec() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_102;
function Companion_getInstance_103() {
  if (Companion_instance_102 === VOID)
    new Companion_102();
  return Companion_instance_102;
}
var $serializer_instance_90;
function $serializer_getInstance_90() {
  if ($serializer_instance_90 === VOID)
    new $serializer_90();
  return $serializer_instance_90;
}
function HatredCard$Companion$$childSerializers$_anonymous__q0s6p0() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_103;
function Companion_getInstance_104() {
  if (Companion_instance_103 === VOID)
    new Companion_103();
  return Companion_instance_103;
}
var $serializer_instance_91;
function $serializer_getInstance_91() {
  if ($serializer_instance_91 === VOID)
    new $serializer_91();
  return $serializer_instance_91;
}
function DisperseCard$Companion$$childSerializers$_anonymous__v9ciqv() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_104;
function Companion_getInstance_105() {
  if (Companion_instance_104 === VOID)
    new Companion_104();
  return Companion_instance_104;
}
var $serializer_instance_92;
function $serializer_getInstance_92() {
  if ($serializer_instance_92 === VOID)
    new $serializer_92();
  return $serializer_instance_92;
}
function InsidiousGrowthCard$Companion$$childSerializers$_anonymous__decta2() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_105;
function Companion_getInstance_106() {
  if (Companion_instance_105 === VOID)
    new Companion_105();
  return Companion_instance_105;
}
var $serializer_instance_93;
function $serializer_getInstance_93() {
  if ($serializer_instance_93 === VOID)
    new $serializer_93();
  return $serializer_instance_93;
}
function RoamCard$Companion$$childSerializers$_anonymous__n93hrj() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_106;
function Companion_getInstance_107() {
  if (Companion_instance_106 === VOID)
    new Companion_106();
  return Companion_instance_106;
}
var $serializer_instance_94;
function $serializer_getInstance_94() {
  if ($serializer_instance_94 === VOID)
    new $serializer_94();
  return $serializer_instance_94;
}
function SprawlCard$Companion$$childSerializers$_anonymous__rnuamx() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_107;
function Companion_getInstance_108() {
  if (Companion_instance_107 === VOID)
    new Companion_107();
  return Companion_instance_107;
}
var $serializer_instance_95;
function $serializer_getInstance_95() {
  if ($serializer_instance_95 === VOID)
    new $serializer_95();
  return $serializer_instance_95;
}
function _get_$cachedSerializer__te6jhj_59($this) {
  return $this.p3j_1.k3();
}
function DisappearCard$_anonymous__adj3us() {
  var tmp = DisappearCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DisappearCard', tmp, tmp$ret$0);
}
var DisappearCard_instance;
function DisappearCard_getInstance() {
  if (DisappearCard_instance === VOID)
    new DisappearCard();
  return DisappearCard_instance;
}
function _get_$cachedSerializer__te6jhj_60($this) {
  return $this.r3j_1.k3();
}
function AbruptDecayCard$_anonymous__jkord7() {
  var tmp = AbruptDecayCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AbruptDecayCard', tmp, tmp$ret$0);
}
var AbruptDecayCard_instance;
function AbruptDecayCard_getInstance() {
  if (AbruptDecayCard_instance === VOID)
    new AbruptDecayCard();
  return AbruptDecayCard_instance;
}
function FeastCard$Companion$$childSerializers$_anonymous__nqxuw9() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_108;
function Companion_getInstance_109() {
  if (Companion_instance_108 === VOID)
    new Companion_108();
  return Companion_instance_108;
}
var $serializer_instance_96;
function $serializer_getInstance_96() {
  if ($serializer_instance_96 === VOID)
    new $serializer_96();
  return $serializer_instance_96;
}
function FlourishCard$Companion$$childSerializers$_anonymous__txsem6() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_109;
function Companion_getInstance_110() {
  if (Companion_instance_109 === VOID)
    new Companion_109();
  return Companion_instance_109;
}
var $serializer_instance_97;
function $serializer_getInstance_97() {
  if ($serializer_instance_97 === VOID)
    new $serializer_97();
  return $serializer_instance_97;
}
function MirrorStepCard$Companion$$childSerializers$_anonymous__sxzw6p() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_110;
function Companion_getInstance_111() {
  if (Companion_instance_110 === VOID)
    new Companion_110();
  return Companion_instance_110;
}
var $serializer_instance_98;
function $serializer_getInstance_98() {
  if ($serializer_instance_98 === VOID)
    new $serializer_98();
  return $serializer_instance_98;
}
function _get_$cachedSerializer__te6jhj_61($this) {
  return $this.m3k_1.k3();
}
function FuryCard$_anonymous__mu4imp() {
  var tmp = FuryCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FuryCard', tmp, tmp$ret$0);
}
var FuryCard_instance;
function FuryCard_getInstance() {
  if (FuryCard_instance === VOID)
    new FuryCard();
  return FuryCard_instance;
}
function _get_$cachedSerializer__te6jhj_62($this) {
  return $this.p3k_1.k3();
}
function ShatterCard$_anonymous__f56232() {
  var tmp = ShatterCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ShatterCard', tmp, tmp$ret$0);
}
var ShatterCard_instance;
function ShatterCard_getInstance() {
  if (ShatterCard_instance === VOID)
    new ShatterCard();
  return ShatterCard_instance;
}
function _get_$cachedSerializer__te6jhj_63($this) {
  return $this.r3k_1.k3();
}
function SwarmCard$_anonymous__hr6dg1() {
  var tmp = SwarmCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SwarmCard', tmp, tmp$ret$0);
}
var SwarmCard_instance;
function SwarmCard_getInstance() {
  if (SwarmCard_instance === VOID)
    new SwarmCard();
  return SwarmCard_instance;
}
var Companion_instance_111;
function Companion_getInstance_112() {
  return Companion_instance_111;
}
var $serializer_instance_99;
function $serializer_getInstance_99() {
  if ($serializer_instance_99 === VOID)
    new $serializer_99();
  return $serializer_instance_99;
}
function _get_$cachedSerializer__te6jhj_64($this) {
  return $this.x3k_1.k3();
}
function OverloadedFuryCard$_anonymous__1iokyw() {
  var tmp = OverloadedFuryCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OverloadedFuryCard', tmp, tmp$ret$0);
}
var OverloadedFuryCard_instance;
function OverloadedFuryCard_getInstance() {
  if (OverloadedFuryCard_instance === VOID)
    new OverloadedFuryCard();
  return OverloadedFuryCard_instance;
}
function _get_$cachedSerializer__te6jhj_65($this) {
  return $this.a3l_1.k3();
}
function OverloadedShatterCard$_anonymous__clou1z() {
  var tmp = OverloadedShatterCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OverloadedShatterCard', tmp, tmp$ret$0);
}
var OverloadedShatterCard_instance;
function OverloadedShatterCard_getInstance() {
  if (OverloadedShatterCard_instance === VOID)
    new OverloadedShatterCard();
  return OverloadedShatterCard_instance;
}
function _get_$cachedSerializer__te6jhj_66($this) {
  return $this.b3l_1.k3();
}
function FeastCardAttackModifier$_anonymous__rnb4rp() {
  var tmp = FeastCardAttackModifier_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FeastCardAttackModifier', tmp, tmp$ret$0);
}
var FeastCardAttackModifier_instance;
function FeastCardAttackModifier_getInstance() {
  if (FeastCardAttackModifier_instance === VOID)
    new FeastCardAttackModifier();
  return FeastCardAttackModifier_instance;
}
function _BoardPosition___init__impl__1nizgq(value) {
  return value;
}
function _get_value__a43j40($this) {
  return $this;
}
function _BoardPosition___init__impl__1nizgq_0(x, y) {
  return _BoardPosition___init__impl__1nizgq((x + 50 | 0) + imul(y + 50 | 0, 100) | 0);
}
function _BoardPosition___get_x__impl__gyx07($this) {
  return (_get_value__a43j40($this) % 100 | 0) - 50 | 0;
}
function _BoardPosition___get_y__impl__tale2e($this) {
  return (_get_value__a43j40($this) / 100 | 0) - 50 | 0;
}
function BoardPosition__toString_impl_v4mn82($this) {
  return 'BoardPosition(' + _BoardPosition___get_x__impl__gyx07($this) + ', ' + _BoardPosition___get_y__impl__tale2e($this) + ')';
}
var Companion_instance_112;
function Companion_getInstance_113() {
  return Companion_instance_112;
}
var $serializer_instance_100;
function $serializer_getInstance_100() {
  if ($serializer_instance_100 === VOID)
    new $serializer_100();
  return $serializer_instance_100;
}
function BoardPosition__hashCode_impl_9dgqf7($this) {
  return $this;
}
function BoardPosition__equals_impl_yrjbvj($this, other) {
  if (!(other instanceof BoardPosition))
    return false;
  if (!($this === other.r2v_1))
    return false;
  return true;
}
var Companion_instance_113;
function Companion_getInstance_114() {
  if (Companion_instance_113 === VOID)
    new Companion_113();
  return Companion_instance_113;
}
var $serializer_instance_101;
function $serializer_getInstance_101() {
  if ($serializer_instance_101 === VOID)
    new $serializer_101();
  return $serializer_instance_101;
}
function MovementToLocation$Companion$$childSerializers$_anonymous__bo7j63() {
  return createSimpleEnumSerializer('steelart.beast.MovementType', values());
}
var Companion_instance_114;
function Companion_getInstance_115() {
  if (Companion_instance_114 === VOID)
    new Companion_114();
  return Companion_instance_114;
}
var $serializer_instance_102;
function $serializer_getInstance_102() {
  if ($serializer_instance_102 === VOID)
    new $serializer_102();
  return $serializer_instance_102;
}
var MovementType_SimpleMovement_instance;
var MovementType_AbyssalSwampRelocation_instance;
var MovementType_StopMoving_instance;
function values() {
  return [MovementType_SimpleMovement_getInstance(), MovementType_AbyssalSwampRelocation_getInstance(), MovementType_StopMoving_getInstance()];
}
var MovementType_entriesInitialized;
function MovementType_initEntries() {
  if (MovementType_entriesInitialized)
    return Unit_instance;
  MovementType_entriesInitialized = true;
  MovementType_SimpleMovement_instance = new MovementType('SimpleMovement', 0);
  MovementType_AbyssalSwampRelocation_instance = new MovementType('AbyssalSwampRelocation', 1);
  MovementType_StopMoving_instance = new MovementType('StopMoving', 2);
}
var Companion_instance_115;
function Companion_getInstance_116() {
  return Companion_instance_115;
}
function _get_$cachedSerializer__te6jhj_67($this) {
  return $this.t3l_1.k3();
}
function NoMovement$_anonymous__e8a4l5() {
  var tmp = NoMovement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NoMovement', tmp, tmp$ret$0);
}
var NoMovement_instance;
function NoMovement_getInstance() {
  if (NoMovement_instance === VOID)
    new NoMovement();
  return NoMovement_instance;
}
var Companion_instance_116;
function Companion_getInstance_117() {
  return Companion_instance_116;
}
var $serializer_instance_103;
function $serializer_getInstance_103() {
  if ($serializer_instance_103 === VOID)
    new $serializer_103();
  return $serializer_instance_103;
}
function MovementType_SimpleMovement_getInstance() {
  MovementType_initEntries();
  return MovementType_SimpleMovement_instance;
}
function MovementType_AbyssalSwampRelocation_getInstance() {
  MovementType_initEntries();
  return MovementType_AbyssalSwampRelocation_instance;
}
function MovementType_StopMoving_getInstance() {
  MovementType_initEntries();
  return MovementType_StopMoving_instance;
}
function _get_$cachedSerializer__te6jhj_68($this) {
  return $this.y3l_1.k3();
}
function InfestationUpgrade$_anonymous__56bd9n() {
  var tmp = InfestationUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('InfestationUpgrade', tmp, tmp$ret$0);
}
var InfestationUpgrade_instance;
function InfestationUpgrade_getInstance() {
  if (InfestationUpgrade_instance === VOID)
    new InfestationUpgrade();
  return InfestationUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_69($this) {
  return $this.z3l_1.k3();
}
function WitheringMawUpgrade$_anonymous__3knq1d() {
  var tmp = WitheringMawUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WitheringMawUpgrade', tmp, tmp$ret$0);
}
var WitheringMawUpgrade_instance;
function WitheringMawUpgrade_getInstance() {
  if (WitheringMawUpgrade_instance === VOID)
    new WitheringMawUpgrade();
  return WitheringMawUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_70($this) {
  return $this.a3m_1.k3();
}
function UnendingHungerUpgrade$_anonymous__1alb1u() {
  var tmp = UnendingHungerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UnendingHungerUpgrade', tmp, tmp$ret$0);
}
var UnendingHungerUpgrade_instance;
function UnendingHungerUpgrade_getInstance() {
  if (UnendingHungerUpgrade_instance === VOID)
    new UnendingHungerUpgrade();
  return UnendingHungerUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_71($this) {
  return $this.b3m_1.k3();
}
function BlightUpgrade$_anonymous__vm99bl() {
  var tmp = BlightUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BlightUpgrade', tmp, tmp$ret$0);
}
var BlightUpgrade_instance;
function BlightUpgrade_getInstance() {
  if (BlightUpgrade_instance === VOID)
    new BlightUpgrade();
  return BlightUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_72($this) {
  return $this.c3m_1.k3();
}
function ExpandTheMarshUpgrade$_anonymous__mckexj() {
  var tmp = ExpandTheMarshUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ExpandTheMarshUpgrade', tmp, tmp$ret$0);
}
var ExpandTheMarshUpgrade_instance;
function ExpandTheMarshUpgrade_getInstance() {
  if (ExpandTheMarshUpgrade_instance === VOID)
    new ExpandTheMarshUpgrade();
  return ExpandTheMarshUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_73($this) {
  return $this.d3m_1.k3();
}
function LurkingDeadUpgrade$_anonymous__ml5iin() {
  var tmp = LurkingDeadUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LurkingDeadUpgrade', tmp, tmp$ret$0);
}
var LurkingDeadUpgrade_instance;
function LurkingDeadUpgrade_getInstance() {
  if (LurkingDeadUpgrade_instance === VOID)
    new LurkingDeadUpgrade();
  return LurkingDeadUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_74($this) {
  return $this.e3m_1.k3();
}
function CascadeUpgrade$_anonymous__bt2a5t() {
  var tmp = CascadeUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CascadeUpgrade', tmp, tmp$ret$0);
}
var CascadeUpgrade_instance;
function CascadeUpgrade_getInstance() {
  if (CascadeUpgrade_instance === VOID)
    new CascadeUpgrade();
  return CascadeUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_75($this) {
  return $this.f3m_1.k3();
}
function Bolgin$_anonymous__3rrbfu() {
  var tmp = Bolgin_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Bolgin', tmp, tmp$ret$0);
}
var Bolgin_instance;
function Bolgin_getInstance() {
  if (Bolgin_instance === VOID)
    new Bolgin();
  return Bolgin_instance;
}
function get_bolginBeast($context_GameState_t6qee5) {
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Bolgin) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function _get_$cachedSerializer__te6jhj_76($this) {
  return $this.h3m_1.k3();
}
function PolypType$_anonymous__t021sp() {
  var tmp = PolypType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PolypType', tmp, tmp$ret$0);
}
var PolypType_instance;
function PolypType_getInstance() {
  if (PolypType_instance === VOID)
    new PolypType();
  return PolypType_instance;
}
function _get_$cachedSerializer__te6jhj_77($this) {
  return $this.j3m_1.k3();
}
function SummonPolypCard$_anonymous__cfdng() {
  var tmp = SummonPolypCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonPolypCard', tmp, tmp$ret$0);
}
var SummonPolypCard_instance;
function SummonPolypCard_getInstance() {
  if (SummonPolypCard_instance === VOID)
    new SummonPolypCard();
  return SummonPolypCard_instance;
}
function _get_$cachedSerializer__te6jhj_78($this) {
  return $this.m3m_1.k3();
}
function BeastlyTongueCard$_anonymous__k26tnb() {
  var tmp = BeastlyTongueCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeastlyTongueCard', tmp, tmp$ret$0);
}
var BeastlyTongueCard_instance;
function BeastlyTongueCard_getInstance() {
  if (BeastlyTongueCard_instance === VOID)
    new BeastlyTongueCard();
  return BeastlyTongueCard_instance;
}
function _get_$cachedSerializer__te6jhj_79($this) {
  return $this.p3m_1.k3();
}
function EngorgeCard$_anonymous__yj3i0o() {
  var tmp = EngorgeCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EngorgeCard', tmp, tmp$ret$0);
}
var EngorgeCard_instance;
function EngorgeCard_getInstance() {
  if (EngorgeCard_instance === VOID)
    new EngorgeCard();
  return EngorgeCard_instance;
}
function _get_$cachedSerializer__te6jhj_80($this) {
  return $this.s3m_1.k3();
}
function LeapCard$_anonymous__puqqip() {
  var tmp = LeapCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LeapCard', tmp, tmp$ret$0);
}
var LeapCard_instance;
function LeapCard_getInstance() {
  if (LeapCard_instance === VOID)
    new LeapCard();
  return LeapCard_instance;
}
function BurstStatement$Companion$$childSerializers$_anonymous__9kbpj9() {
  return $serializer_364.y2o(Companion_instance_424.a2g());
}
var Companion_instance_117;
function Companion_getInstance_118() {
  if (Companion_instance_117 === VOID)
    new Companion_117();
  return Companion_instance_117;
}
var $serializer_instance_104;
function $serializer_getInstance_104() {
  if ($serializer_instance_104 === VOID)
    new $serializer_104();
  return $serializer_instance_104;
}
function BeastlyTongueStatement$Companion$$childSerializers$_anonymous__n78xez() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_118;
function Companion_getInstance_119() {
  if (Companion_instance_118 === VOID)
    new Companion_118();
  return Companion_instance_118;
}
var $serializer_instance_105;
function $serializer_getInstance_105() {
  if ($serializer_instance_105 === VOID)
    new $serializer_105();
  return $serializer_instance_105;
}
function LeapStatement$Companion$$childSerializers$_anonymous__4uairn() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_119;
function Companion_getInstance_120() {
  if (Companion_instance_119 === VOID)
    new Companion_119();
  return Companion_instance_119;
}
var $serializer_instance_106;
function $serializer_getInstance_106() {
  if ($serializer_instance_106 === VOID)
    new $serializer_106();
  return $serializer_instance_106;
}
function _get_$cachedSerializer__te6jhj_81($this) {
  return $this.i3n_1.k3();
}
function BurstEffectSource$_anonymous__75ski3() {
  var tmp = BurstEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BurstEffectSource', tmp, tmp$ret$0);
}
var BurstEffectSource_instance;
function BurstEffectSource_getInstance() {
  if (BurstEffectSource_instance === VOID)
    new BurstEffectSource();
  return BurstEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_82($this) {
  return $this.k3n_1.k3();
}
function Bram$_anonymous__b5jaud() {
  var tmp = Bram_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Bram', tmp, tmp$ret$0);
}
var Bram_instance;
function Bram_getInstance() {
  if (Bram_instance === VOID)
    new Bram();
  return Bram_instance;
}
function _get_$cachedSerializer__te6jhj_83($this) {
  return $this.l3n_1.k3();
}
function AbruptAssembleUpgrade$_anonymous__l2fn2j() {
  var tmp = AbruptAssembleUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AbruptAssembleUpgrade', tmp, tmp$ret$0);
}
var AbruptAssembleUpgrade_instance;
function AbruptAssembleUpgrade_getInstance() {
  if (AbruptAssembleUpgrade_instance === VOID)
    new AbruptAssembleUpgrade();
  return AbruptAssembleUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_84($this) {
  return $this.m3n_1.k3();
}
function MassProductionUpgrade$_anonymous__3qzci0() {
  var tmp = MassProductionUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MassProductionUpgrade', tmp, tmp$ret$0);
}
var MassProductionUpgrade_instance;
function MassProductionUpgrade_getInstance() {
  if (MassProductionUpgrade_instance === VOID)
    new MassProductionUpgrade();
  return MassProductionUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_85($this) {
  return $this.n3n_1.k3();
}
function LivingBlockadeUpgrade$_anonymous__de1ymx() {
  var tmp = LivingBlockadeUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LivingBlockadeUpgrade', tmp, tmp$ret$0);
}
var LivingBlockadeUpgrade_instance;
function LivingBlockadeUpgrade_getInstance() {
  if (LivingBlockadeUpgrade_instance === VOID)
    new LivingBlockadeUpgrade();
  return LivingBlockadeUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_86($this) {
  return $this.o3n_1.k3();
}
function TacticalInsightUpgrade$_anonymous__a6j3o0() {
  var tmp = TacticalInsightUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TacticalInsightUpgrade', tmp, tmp$ret$0);
}
var TacticalInsightUpgrade_instance;
function TacticalInsightUpgrade_getInstance() {
  if (TacticalInsightUpgrade_instance === VOID)
    new TacticalInsightUpgrade();
  return TacticalInsightUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_87($this) {
  return $this.r3n_1.k3();
}
function WardCard$_anonymous__qovjrp() {
  var tmp = WardCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WardCard', tmp, tmp$ret$0);
}
var WardCard_instance;
function WardCard_getInstance() {
  if (WardCard_instance === VOID)
    new WardCard();
  return WardCard_instance;
}
function _get_$cachedSerializer__te6jhj_88($this) {
  return $this.u3n_1.k3();
}
function BindingHuntCard$_anonymous__5soh7z() {
  var tmp = BindingHuntCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BindingHuntCard', tmp, tmp$ret$0);
}
var BindingHuntCard_instance;
function BindingHuntCard_getInstance() {
  if (BindingHuntCard_instance === VOID)
    new BindingHuntCard();
  return BindingHuntCard_instance;
}
function AbruptAssembleStatement$Companion$$childSerializers$_anonymous__rmqprp() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_120;
function Companion_getInstance_121() {
  if (Companion_instance_120 === VOID)
    new Companion_120();
  return Companion_instance_120;
}
var $serializer_instance_107;
function $serializer_getInstance_107() {
  if ($serializer_instance_107 === VOID)
    new $serializer_107();
  return $serializer_instance_107;
}
function WardStatement$Companion$$childSerializers$_anonymous__vcgyqx() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_121;
function Companion_getInstance_122() {
  if (Companion_instance_121 === VOID)
    new Companion_121();
  return Companion_instance_121;
}
var $serializer_instance_108;
function $serializer_getInstance_108() {
  if ($serializer_instance_108 === VOID)
    new $serializer_108();
  return $serializer_instance_108;
}
function BindingHuntStatement$Companion$$childSerializers$_anonymous__dskg31() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_122;
function Companion_getInstance_123() {
  if (Companion_instance_122 === VOID)
    new Companion_122();
  return Companion_instance_122;
}
var $serializer_instance_109;
function $serializer_getInstance_109() {
  if ($serializer_instance_109 === VOID)
    new $serializer_109();
  return $serializer_instance_109;
}
function _get_$cachedSerializer__te6jhj_89($this) {
  return $this.k3o_1.k3();
}
function BramBarrierCleanupEffectSource$_anonymous__9ljx0e() {
  var tmp = BramBarrierCleanupEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BramBarrierCleanupEffectSource', tmp, tmp$ret$0);
}
var BramBarrierCleanupEffectSource_instance;
function BramBarrierCleanupEffectSource_getInstance() {
  if (BramBarrierCleanupEffectSource_instance === VOID)
    new BramBarrierCleanupEffectSource();
  return BramBarrierCleanupEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_90($this) {
  return $this.l3o_1.k3();
}
function PossibleBindingHuntEffectSource$_anonymous__6khwtg() {
  var tmp = PossibleBindingHuntEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleBindingHuntEffectSource', tmp, tmp$ret$0);
}
var PossibleBindingHuntEffectSource_instance;
function PossibleBindingHuntEffectSource_getInstance() {
  if (PossibleBindingHuntEffectSource_instance === VOID)
    new PossibleBindingHuntEffectSource();
  return PossibleBindingHuntEffectSource_instance;
}
function BarrierConnectedLocationQuestion$Companion$$childSerializers$_anonymous__3ospfn() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_123;
function Companion_getInstance_124() {
  if (Companion_instance_123 === VOID)
    new Companion_123();
  return Companion_instance_123;
}
var $serializer_instance_110;
function $serializer_getInstance_110() {
  if ($serializer_instance_110 === VOID)
    new $serializer_110();
  return $serializer_instance_110;
}
function _get_$cachedSerializer__te6jhj_91($this) {
  return $this.u3o_1.k3();
}
function BarrierFirstPositionQuestionContext$_anonymous__qw8dio() {
  var tmp = BarrierFirstPositionQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BarrierFirstPositionQuestionContext', tmp, tmp$ret$0);
}
var BarrierFirstPositionQuestionContext_instance;
function BarrierFirstPositionQuestionContext_getInstance() {
  if (BarrierFirstPositionQuestionContext_instance === VOID)
    new BarrierFirstPositionQuestionContext();
  return BarrierFirstPositionQuestionContext_instance;
}
function BindingHuntReactionStatement$Companion$$childSerializers$_anonymous__r9vpoc() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
function BindingHuntReactionStatement$Companion$$childSerializers$_anonymous__r9vpoc_0() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_124;
function Companion_getInstance_125() {
  if (Companion_instance_124 === VOID)
    new Companion_124();
  return Companion_instance_124;
}
var $serializer_instance_111;
function $serializer_getInstance_111() {
  if ($serializer_instance_111 === VOID)
    new $serializer_111();
  return $serializer_instance_111;
}
function BramWardBarrierStatement$Companion$$childSerializers$_anonymous__umtunu() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_125;
function Companion_getInstance_126() {
  if (Companion_instance_125 === VOID)
    new Companion_125();
  return Companion_instance_125;
}
var $serializer_instance_112;
function $serializer_getInstance_112() {
  if ($serializer_instance_112 === VOID)
    new $serializer_112();
  return $serializer_instance_112;
}
function PlaceBarrierInSameZoneStatement$Companion$$childSerializers$_anonymous__t794zm() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_126;
function Companion_getInstance_127() {
  if (Companion_instance_126 === VOID)
    new Companion_126();
  return Companion_instance_126;
}
var $serializer_instance_113;
function $serializer_getInstance_113() {
  if ($serializer_instance_113 === VOID)
    new $serializer_113();
  return $serializer_instance_113;
}
function PlaceBarrierOnLocationsStatement$Companion$$childSerializers$_anonymous__wqbmom() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
function PlaceBarrierOnLocationsStatement$Companion$$childSerializers$_anonymous__wqbmom_0() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_127;
function Companion_getInstance_128() {
  if (Companion_instance_127 === VOID)
    new Companion_127();
  return Companion_instance_127;
}
var $serializer_instance_114;
function $serializer_getInstance_114() {
  if ($serializer_instance_114 === VOID)
    new $serializer_114();
  return $serializer_instance_114;
}
function get_grudgesNumberKey() {
  _init_properties_Character_kt__4wpy9j();
  return grudgesNumberKey;
}
var grudgesNumberKey;
function get_ancientPowerNumberKey() {
  _init_properties_Character_kt__4wpy9j();
  return ancientPowerNumberKey;
}
var ancientPowerNumberKey;
function get_handKey() {
  _init_properties_Character_kt__4wpy9j();
  return handKey;
}
var handKey;
function get_discardedAbilityCardsKey() {
  _init_properties_Character_kt__4wpy9j();
  return discardedAbilityCardsKey;
}
var discardedAbilityCardsKey;
var Companion_instance_128;
function Companion_getInstance_129() {
  return Companion_instance_128;
}
function get_gameTeam($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_Character_kt__4wpy9j();
  var tmp = get_gameRules($context_GameState_t6qee5).c3b($context_GameState_t6qee5, _this__u8e3s4);
  return ensureNotNull(tmp == null ? null : new GameTeam(tmp)).r3p_1;
}
function get_hand(gsCtx, _this__u8e3s4) {
  _init_properties_Character_kt__4wpy9j();
  return getHandImpl(_this__u8e3s4, gsCtx);
}
function get_grudgesNumber(gsCtx, _this__u8e3s4) {
  _init_properties_Character_kt__4wpy9j();
  return getGrudgesNumberImpl(_this__u8e3s4, gsCtx);
}
function get_ancientPowerNumber(gsCtx, _this__u8e3s4) {
  _init_properties_Character_kt__4wpy9j();
  return getAncientPowerNumberImpl(_this__u8e3s4, gsCtx);
}
function get_discardedAbilityCards(gsCtx, _this__u8e3s4) {
  _init_properties_Character_kt__4wpy9j();
  return getDiscardedAbilityCardsImpl(_this__u8e3s4, gsCtx);
}
function getHandImpl(_this__u8e3s4, gameState) {
  _init_properties_Character_kt__4wpy9j();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_handKey()).s3p_1;
}
function getGrudgesNumberImpl(_this__u8e3s4, gameState) {
  _init_properties_Character_kt__4wpy9j();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_grudgesNumberKey()).t3p_1;
}
function getAncientPowerNumberImpl(_this__u8e3s4, gameState) {
  _init_properties_Character_kt__4wpy9j();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_ancientPowerNumberKey()).t3p_1;
}
function getDiscardedAbilityCardsImpl(_this__u8e3s4, gameState) {
  _init_properties_Character_kt__4wpy9j();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_discardedAbilityCardsKey()).s3p_1;
}
function set_ancientPowerNumberImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Character_kt__4wpy9j();
  setImplProperty(gsiCtx, _this__u8e3s4, get_ancientPowerNumberKey(), new IntWrapper(value));
}
function get_ancientPowerNumberImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Character_kt__4wpy9j();
  return getAncientPowerNumberImpl(_this__u8e3s4, gsiCtx);
}
function set_handImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Character_kt__4wpy9j();
  setImplProperty(gsiCtx, _this__u8e3s4, get_handKey(), new PlayableCardSetWrapper(toLinkedSet(value)));
}
function changeDiscardedAbilityCards($context_GameStateImpl_x43bj1, _this__u8e3s4, card, operation) {
  _init_properties_Character_kt__4wpy9j();
  updatePlayableCards($context_GameStateImpl_x43bj1, _this__u8e3s4, get_discardedAbilityCardsKey(), card, operation);
}
function changeHand($context_GameStateImpl_x43bj1, _this__u8e3s4, card, operation) {
  _init_properties_Character_kt__4wpy9j();
  updatePlayableCards($context_GameStateImpl_x43bj1, _this__u8e3s4, get_handKey(), card, operation);
}
function set_grudgesNumberImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Character_kt__4wpy9j();
  setImplProperty(gsiCtx, _this__u8e3s4, get_grudgesNumberKey(), new IntWrapper(value));
}
function get_grudgesNumberImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Character_kt__4wpy9j();
  return getGrudgesNumberImpl(_this__u8e3s4, gsiCtx);
}
function updatePlayableCards($context_GameStateImpl_x43bj1, _this__u8e3s4, key, card, operation) {
  _init_properties_Character_kt__4wpy9j();
  var updated = toLinkedSet(get_implProperty($context_GameStateImpl_x43bj1, _this__u8e3s4, key).s3p_1);
  addOrRemove(updated, card, operation);
  setImplProperty($context_GameStateImpl_x43bj1, _this__u8e3s4, key, new PlayableCardSetWrapper(updated));
}
var properties_initialized_Character_kt_9q9zlz;
function _init_properties_Character_kt__4wpy9j() {
  if (!properties_initialized_Character_kt_9q9zlz) {
    properties_initialized_Character_kt_9q9zlz = true;
    grudgesNumberKey = _GeneralMapKey___init__impl__zdmbea('grudgesNumber');
    ancientPowerNumberKey = _GeneralMapKey___init__impl__zdmbea('ancientPowerNumber');
    handKey = _GeneralMapKey___init__impl__zdmbea('hand');
    discardedAbilityCardsKey = _GeneralMapKey___init__impl__zdmbea('discardedAbilityCards');
  }
}
var Companion_instance_129;
function Companion_getInstance_130() {
  return Companion_instance_129;
}
function get_upgraded($context_GameState_t6qee5, _this__u8e3s4) {
  return get_pumpedUpgrades($context_GameState_t6qee5).w2(_this__u8e3s4);
}
var Companion_instance_130;
function Companion_getInstance_131() {
  return Companion_instance_130;
}
function get_charged($context_GameState_t6qee5, _this__u8e3s4) {
  return get_chargedUpgrades($context_GameState_t6qee5).w2(_this__u8e3s4);
}
function GameNotification$Companion$$childSerializers$_anonymous__uialnx() {
  return Companion_instance_295.a2g();
}
var Companion_instance_131;
function Companion_getInstance_132() {
  if (Companion_instance_131 === VOID)
    new Companion_131();
  return Companion_instance_131;
}
var $serializer_instance_115;
function $serializer_getInstance_115() {
  if ($serializer_instance_115 === VOID)
    new $serializer_115();
  return $serializer_instance_115;
}
var Companion_instance_132;
function Companion_getInstance_133() {
  return Companion_instance_132;
}
var $serializer_instance_116;
function $serializer_getInstance_116() {
  if ($serializer_instance_116 === VOID)
    new $serializer_116();
  return $serializer_instance_116;
}
var Companion_instance_133;
function Companion_getInstance_134() {
  return Companion_instance_133;
}
var Companion_instance_134;
function Companion_getInstance_135() {
  return Companion_instance_134;
}
function ControllingByCharacter$Companion$$childSerializers$_anonymous__f6geaz() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_135;
function Companion_getInstance_136() {
  if (Companion_instance_135 === VOID)
    new Companion_135();
  return Companion_instance_135;
}
var $serializer_instance_117;
function $serializer_getInstance_117() {
  if ($serializer_instance_117 === VOID)
    new $serializer_117();
  return $serializer_instance_117;
}
var Companion_instance_136;
function Companion_getInstance_137() {
  return Companion_instance_136;
}
var $serializer_instance_118;
function $serializer_getInstance_118() {
  if ($serializer_instance_118 === VOID)
    new $serializer_118();
  return $serializer_instance_118;
}
function MesmerizedControlling$Companion$$childSerializers$_anonymous__vvqjei() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_137;
function Companion_getInstance_138() {
  if (Companion_instance_137 === VOID)
    new Companion_137();
  return Companion_instance_137;
}
var $serializer_instance_119;
function $serializer_getInstance_119() {
  if ($serializer_instance_119 === VOID)
    new $serializer_119();
  return $serializer_instance_119;
}
function _get_$cachedSerializer__te6jhj_92($this) {
  return $this.b3r_1.k3();
}
function ControllingByNothing$_anonymous__if9hu4() {
  var tmp = ControllingByNothing_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ControllingByNothing', tmp, tmp$ret$0);
}
var ControllingByNothing_instance;
function ControllingByNothing_getInstance() {
  if (ControllingByNothing_instance === VOID)
    new ControllingByNothing();
  return ControllingByNothing_instance;
}
function isActiveCharacter(_this__u8e3s4, characterObject) {
  var controllingActor = get_currentControllingActor(_this__u8e3s4.c3r());
  var tmp;
  var tmp_0;
  if (controllingActor instanceof ControllingByCharacter) {
    tmp_0 = controllingActor.o3q_1.equals(characterObject);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = true;
  } else {
    var tmp_1;
    if (controllingActor instanceof MesmerizedControlling) {
      var tmp_2 = get_objectType(_this__u8e3s4, characterObject);
      tmp_1 = tmp_2 instanceof EsmeriaBeast;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp = true;
    } else {
      var tmp_3;
      if (controllingActor instanceof ControllingByTeam) {
        tmp_3 = controllingActor.t3q_1 === get_gameTeam(_this__u8e3s4, characterObject);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp = true;
      } else {
        tmp = false;
      }
    }
  }
  return tmp;
}
function get_currentControllingActor(_this__u8e3s4) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof ControllingActorScope) {
      destination.d2(element);
    }
  }
  var tmp0_safe_receiver = lastOrNull(destination);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d3r_1;
  return tmp1_elvis_lhs == null ? ControllingByNothing_getInstance() : tmp1_elvis_lhs;
}
function get_currentControllingTeam(_this__u8e3s4) {
  var actor = get_currentControllingActor(_this__u8e3s4);
  var tmp;
  if (equals(actor, ControllingByNothing_getInstance())) {
    tmp = null;
  } else {
    if (isInterface(actor, ControllingActorWithTeam)) {
      tmp = actor.k3q();
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function get_cardDamageSource(_this__u8e3s4) {
  return new CardDamageSourceImpl(_this__u8e3s4);
}
var Companion_instance_138;
function Companion_getInstance_139() {
  return Companion_instance_138;
}
function CardDamageSourceImpl$Companion$$childSerializers$_anonymous__4zo0j4() {
  return Companion_instance_442.a2g();
}
var Companion_instance_139;
function Companion_getInstance_140() {
  if (Companion_instance_139 === VOID)
    new Companion_139();
  return Companion_instance_139;
}
var $serializer_instance_120;
function $serializer_getInstance_120() {
  if ($serializer_instance_120 === VOID)
    new $serializer_120();
  return $serializer_instance_120;
}
function _get_$cachedSerializer__te6jhj_93($this) {
  return $this.j3r_1.k3();
}
function AbyssalSwampRelocationDamage$_anonymous__lh850d() {
  var tmp = AbyssalSwampRelocationDamage_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AbyssalSwampRelocationDamage', tmp, tmp$ret$0);
}
var AbyssalSwampRelocationDamage_instance;
function AbyssalSwampRelocationDamage_getInstance() {
  if (AbyssalSwampRelocationDamage_instance === VOID)
    new AbyssalSwampRelocationDamage();
  return AbyssalSwampRelocationDamage_instance;
}
function _get_$cachedSerializer__te6jhj_94($this) {
  return $this.k3r_1.k3();
}
function ContractReward$_anonymous__vcb2iy() {
  var tmp = ContractReward_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ContractReward', tmp, tmp$ret$0);
}
var ContractReward_instance;
function ContractReward_getInstance() {
  if (ContractReward_instance === VOID)
    new ContractReward();
  return ContractReward_instance;
}
var Companion_instance_140;
function Companion_getInstance_141() {
  return Companion_instance_140;
}
var $serializer_instance_121;
function $serializer_getInstance_121() {
  if ($serializer_instance_121 === VOID)
    new $serializer_121();
  return $serializer_instance_121;
}
function _get_$cachedSerializer__te6jhj_95($this) {
  return $this.p3r_1.k3();
}
function SandboxDamage$_anonymous__9d0pvj() {
  var tmp = SandboxDamage_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SandboxDamage', tmp, tmp$ret$0);
}
var SandboxDamage_instance;
function SandboxDamage_getInstance() {
  if (SandboxDamage_instance === VOID)
    new SandboxDamage();
  return SandboxDamage_instance;
}
function _get_$cachedSerializer__te6jhj_96($this) {
  return $this.q3r_1.k3();
}
function SummonActivation$_anonymous__o9ixds() {
  var tmp = SummonActivation_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonActivation', tmp, tmp$ret$0);
}
var SummonActivation_instance;
function SummonActivation_getInstance() {
  if (SummonActivation_instance === VOID)
    new SummonActivation();
  return SummonActivation_instance;
}
function _get_$cachedSerializer__te6jhj_97($this) {
  return $this.r3r_1.k3();
}
function TrapActivation$_anonymous__j1raoc() {
  var tmp = TrapActivation_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TrapActivation', tmp, tmp$ret$0);
}
var TrapActivation_instance;
function TrapActivation_getInstance() {
  if (TrapActivation_instance === VOID)
    new TrapActivation();
  return TrapActivation_instance;
}
function UpgradeDamageSource$Companion$$childSerializers$_anonymous__82ofyc() {
  return Companion_instance_129.a2g();
}
var Companion_instance_141;
function Companion_getInstance_142() {
  if (Companion_instance_141 === VOID)
    new Companion_141();
  return Companion_instance_141;
}
var $serializer_instance_122;
function $serializer_getInstance_122() {
  if ($serializer_instance_122 === VOID)
    new $serializer_122();
  return $serializer_instance_122;
}
function DealingDamage$Companion$$childSerializers$_anonymous__82ndd1() {
  return Companion_instance.a2g();
}
function DealingDamage$Companion$$childSerializers$_anonymous__82ndd1_0() {
  return Companion_instance_138.a2g();
}
function DealingDamage$Companion$$childSerializers$_anonymous__82ndd1_1() {
  return createSimpleEnumSerializer('steelart.beast.DamageKind', values_0());
}
function DealingDamage$Companion$$childSerializers$_anonymous__82ndd1_2() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function DealingDamage$Companion$$childSerializers$_anonymous__82ndd1_3() {
  return new LinkedHashSetSerializer($serializer_getInstance_125());
}
var Companion_instance_142;
function Companion_getInstance_143() {
  if (Companion_instance_142 === VOID)
    new Companion_142();
  return Companion_instance_142;
}
var $serializer_instance_123;
function $serializer_getInstance_123() {
  if ($serializer_instance_123 === VOID)
    new $serializer_123();
  return $serializer_instance_123;
}
function DamageBlock$Companion$$childSerializers$_anonymous__vr37qs() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_143;
function Companion_getInstance_144() {
  if (Companion_instance_143 === VOID)
    new Companion_143();
  return Companion_instance_143;
}
var $serializer_instance_124;
function $serializer_getInstance_124() {
  if ($serializer_instance_124 === VOID)
    new $serializer_124();
  return $serializer_instance_124;
}
function DamageToTarget$Companion$$childSerializers$_anonymous__kzafyp() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_144;
function Companion_getInstance_145() {
  if (Companion_instance_144 === VOID)
    new Companion_144();
  return Companion_instance_144;
}
var $serializer_instance_125;
function $serializer_getInstance_125() {
  if ($serializer_instance_125 === VOID)
    new $serializer_125();
  return $serializer_instance_125;
}
var DamageKind_Attack_instance;
var DamageKind_Self_instance;
var DamageKind_Trap_instance;
var DamageKind_Upgrade_instance;
var DamageKind_Ability_instance;
var DamageKind_RuinActivation_instance;
var DamageKind_ChangingObjectType_instance;
var DamageKind_Other_instance;
function values_0() {
  return [DamageKind_Attack_getInstance(), DamageKind_Self_getInstance(), DamageKind_Trap_getInstance(), DamageKind_Upgrade_getInstance(), DamageKind_Ability_getInstance(), DamageKind_RuinActivation_getInstance(), DamageKind_ChangingObjectType_getInstance(), DamageKind_Other_getInstance()];
}
var DamageKind_entriesInitialized;
function DamageKind_initEntries() {
  if (DamageKind_entriesInitialized)
    return Unit_instance;
  DamageKind_entriesInitialized = true;
  DamageKind_Attack_instance = new DamageKind('Attack', 0);
  DamageKind_Self_instance = new DamageKind('Self', 1);
  DamageKind_Trap_instance = new DamageKind('Trap', 2);
  DamageKind_Upgrade_instance = new DamageKind('Upgrade', 3);
  DamageKind_Ability_instance = new DamageKind('Ability', 4);
  DamageKind_RuinActivation_instance = new DamageKind('RuinActivation', 5);
  DamageKind_ChangingObjectType_instance = new DamageKind('ChangingObjectType', 6);
  DamageKind_Other_instance = new DamageKind('Other', 7);
}
function DamageKind_Attack_getInstance() {
  DamageKind_initEntries();
  return DamageKind_Attack_instance;
}
function DamageKind_Self_getInstance() {
  DamageKind_initEntries();
  return DamageKind_Self_instance;
}
function DamageKind_Trap_getInstance() {
  DamageKind_initEntries();
  return DamageKind_Trap_instance;
}
function DamageKind_Upgrade_getInstance() {
  DamageKind_initEntries();
  return DamageKind_Upgrade_instance;
}
function DamageKind_Ability_getInstance() {
  DamageKind_initEntries();
  return DamageKind_Ability_instance;
}
function DamageKind_RuinActivation_getInstance() {
  DamageKind_initEntries();
  return DamageKind_RuinActivation_instance;
}
function DamageKind_ChangingObjectType_getInstance() {
  DamageKind_initEntries();
  return DamageKind_ChangingObjectType_instance;
}
function DamageKind_Other_getInstance() {
  DamageKind_initEntries();
  return DamageKind_Other_instance;
}
function *boundAwait(_this__u8e3s4, $completion) {
  var tmp;
  try {
    tmp = yield* _this__u8e3s4.m1q($completion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof CancellationException) {
      var cancelled = $p;
      _this__u8e3s4.n1n(cancelled);
      var tmp_1 = NonCancellable_getInstance();
      yield* withContext(tmp_1, boundAwait$slambda(_this__u8e3s4), $completion);
      throw cancelled;
    } else {
      throw $p;
    }
  }
  return tmp;
}
function *installAnswer(_this__u8e3s4, answer, $completion) {
  var installed = CompletableDeferred();
  var result = CompletableDeferred();
  var tmp = CoroutineStart_LAZY_getInstance();
  var worker = launch(_this__u8e3s4, VOID, tmp, installAnswer$slambda(result, answer, installed));
  result.g1n(installAnswer$lambda(worker));
  worker.g1n(installAnswer$lambda_0(installed, result));
  worker.b1n();
  try {
    yield* installed.m1q($completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var failure = $p;
      worker.o1n();
      var tmp_0 = NonCancellable_getInstance();
      yield* withContext(tmp_0, installAnswer$slambda_0(worker), $completion);
      throw failure;
    } else {
      throw $p;
    }
  }
  return new installAnswer$5(result, worker);
}
function boundAwait$slambda($this_boundAwait) {
  return constructCallableReference(function *($this$withContext, $completion) {
    yield* $this_boundAwait.k1n($completion);
    return Unit_instance;
  }, 1);
}
function installAnswer$slambda$lambda($installed) {
  return () => {
    $installed.l1t(Unit_instance);
    return Unit_instance;
  };
}
function installAnswer$slambda($result, $answer, $installed) {
  return constructCallableReference(function *($this$launch, $completion) {
    try {
      $result.l1t(yield* $answer(installAnswer$slambda$lambda($installed), $completion));
      $installed.l1t(Unit_instance);
    } catch ($p) {
      if ($p instanceof Error) {
        var failure = $p;
        $installed.k1t(failure);
        $result.k1t(failure);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 1);
}
function installAnswer$lambda($worker) {
  return (cause) => {
    var tmp;
    if (cause instanceof CancellationException) {
      $worker.n1n(cause);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function installAnswer$lambda_0($installed, $result) {
  return (cause) => {
    var tmp;
    if (!(cause == null)) {
      $installed.k1t(cause);
      $result.k1t(cause);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function installAnswer$slambda_0($worker) {
  return constructCallableReference(function *($this$withContext, $completion) {
    yield* $worker.k1n($completion);
    return Unit_instance;
  }, 1);
}
var Companion_instance_145;
function Companion_getInstance_146() {
  return Companion_instance_145;
}
var $serializer_instance_126;
function $serializer_getInstance_126() {
  if ($serializer_instance_126 === VOID)
    new $serializer_126();
  return $serializer_instance_126;
}
function _get_$cachedSerializer__te6jhj_98($this) {
  return $this.i3t_1.k3();
}
function DisturbanceOfTheNorthernGodsInitialPhase$_anonymous__oq6doh() {
  var tmp = DisturbanceOfTheNorthernGodsInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DisturbanceOfTheNorthernGodsInitialPhase', tmp, tmp$ret$0);
}
var DisturbanceOfTheNorthernGodsInitialPhase_instance;
function DisturbanceOfTheNorthernGodsInitialPhase_getInstance() {
  if (DisturbanceOfTheNorthernGodsInitialPhase_instance === VOID)
    new DisturbanceOfTheNorthernGodsInitialPhase();
  return DisturbanceOfTheNorthernGodsInitialPhase_instance;
}
function _get_$cachedSerializer__te6jhj_99($this) {
  return $this.k3t_1.k3();
}
function AvariceCard$_anonymous__p00r42() {
  var tmp = AvariceCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AvariceCard', tmp, tmp$ret$0);
}
var AvariceCard_instance;
function AvariceCard_getInstance() {
  if (AvariceCard_instance === VOID)
    new AvariceCard();
  return AvariceCard_instance;
}
function _get_$cachedSerializer__te6jhj_100($this) {
  return $this.m3t_1.k3();
}
function DarkOfferingsCard$_anonymous__otbots() {
  var tmp = DarkOfferingsCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DarkOfferingsCard', tmp, tmp$ret$0);
}
var DarkOfferingsCard_instance;
function DarkOfferingsCard_getInstance() {
  if (DarkOfferingsCard_instance === VOID)
    new DarkOfferingsCard();
  return DarkOfferingsCard_instance;
}
var Companion_instance_146;
function Companion_getInstance_147() {
  return Companion_instance_146;
}
function _get_$cachedSerializer__te6jhj_101($this) {
  return $this.o3t_1.k3();
}
function RushCard$_anonymous__3q57tb() {
  var tmp = RushCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RushCard', tmp, tmp$ret$0);
}
var RushCard_instance;
function RushCard_getInstance() {
  if (RushCard_instance === VOID)
    new RushCard();
  return RushCard_instance;
}
function _get_$cachedSerializer__te6jhj_102($this) {
  return $this.q3t_1.k3();
}
function DashCard$_anonymous__f3h2p7() {
  var tmp = DashCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DashCard', tmp, tmp$ret$0);
}
var DashCard_instance;
function DashCard_getInstance() {
  if (DashCard_instance === VOID)
    new DashCard();
  return DashCard_instance;
}
function _get_$cachedSerializer__te6jhj_103($this) {
  return $this.s3t_1.k3();
}
function AnimateCard$_anonymous__48tzba() {
  var tmp = AnimateCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AnimateCard', tmp, tmp$ret$0);
}
var AnimateCard_instance;
function AnimateCard_getInstance() {
  if (AnimateCard_instance === VOID)
    new AnimateCard();
  return AnimateCard_instance;
}
function _get_$cachedSerializer__te6jhj_104($this) {
  return $this.u3t_1.k3();
}
function EnsnareCard$_anonymous__2sgudz() {
  var tmp = EnsnareCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EnsnareCard', tmp, tmp$ret$0);
}
var EnsnareCard_instance;
function EnsnareCard_getInstance() {
  if (EnsnareCard_instance === VOID)
    new EnsnareCard();
  return EnsnareCard_instance;
}
function _get_$cachedSerializer__te6jhj_105($this) {
  return $this.w3t_1.k3();
}
function BolsterCard$_anonymous__ceqsrq() {
  var tmp = BolsterCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BolsterCard', tmp, tmp$ret$0);
}
var BolsterCard_instance;
function BolsterCard_getInstance() {
  if (BolsterCard_instance === VOID)
    new BolsterCard();
  return BolsterCard_instance;
}
function _get_$cachedSerializer__te6jhj_106($this) {
  return $this.y3t_1.k3();
}
function PursuitCard$_anonymous__d5r1rn() {
  var tmp = PursuitCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PursuitCard', tmp, tmp$ret$0);
}
var PursuitCard_instance;
function PursuitCard_getInstance() {
  if (PursuitCard_instance === VOID)
    new PursuitCard();
  return PursuitCard_instance;
}
function _get_$cachedSerializer__te6jhj_107($this) {
  return $this.a3u_1.k3();
}
function AdaptCard$_anonymous__b69br9() {
  var tmp = AdaptCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AdaptCard', tmp, tmp$ret$0);
}
var AdaptCard_instance;
function AdaptCard_getInstance() {
  if (AdaptCard_instance === VOID)
    new AdaptCard();
  return AdaptCard_instance;
}
function _get_$cachedSerializer__te6jhj_108($this) {
  return $this.c3u_1.k3();
}
function HiddenPassageCard$_anonymous__nrnyhp() {
  var tmp = HiddenPassageCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HiddenPassageCard', tmp, tmp$ret$0);
}
var HiddenPassageCard_instance;
function HiddenPassageCard_getInstance() {
  if (HiddenPassageCard_instance === VOID)
    new HiddenPassageCard();
  return HiddenPassageCard_instance;
}
function _get_$cachedSerializer__te6jhj_109($this) {
  return $this.e3u_1.k3();
}
function HasteCard$_anonymous__jsejs4() {
  var tmp = HasteCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HasteCard', tmp, tmp$ret$0);
}
var HasteCard_instance;
function HasteCard_getInstance() {
  if (HasteCard_instance === VOID)
    new HasteCard();
  return HasteCard_instance;
}
function _get_$cachedSerializer__te6jhj_110($this) {
  return $this.g3u_1.k3();
}
function DarkDealingsCard$_anonymous__pfyuhg() {
  var tmp = DarkDealingsCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DarkDealingsCard', tmp, tmp$ret$0);
}
var DarkDealingsCard_instance;
function DarkDealingsCard_getInstance() {
  if (DarkDealingsCard_instance === VOID)
    new DarkDealingsCard();
  return DarkDealingsCard_instance;
}
function _get_$cachedSerializer__te6jhj_111($this) {
  return $this.i3u_1.k3();
}
function ProwlCard$_anonymous__oue1jv() {
  var tmp = ProwlCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ProwlCard', tmp, tmp$ret$0);
}
var ProwlCard_instance;
function ProwlCard_getInstance() {
  if (ProwlCard_instance === VOID)
    new ProwlCard();
  return ProwlCard_instance;
}
function _get_$cachedSerializer__te6jhj_112($this) {
  return $this.k3u_1.k3();
}
function DarkRitualsCard$_anonymous__t2mir7() {
  var tmp = DarkRitualsCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DarkRitualsCard', tmp, tmp$ret$0);
}
var DarkRitualsCard_instance;
function DarkRitualsCard_getInstance() {
  if (DarkRitualsCard_instance === VOID)
    new DarkRitualsCard();
  return DarkRitualsCard_instance;
}
function _get_$cachedSerializer__te6jhj_113($this) {
  return $this.m3u_1.k3();
}
function InciteCard$_anonymous__k6uzx1() {
  var tmp = InciteCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('InciteCard', tmp, tmp$ret$0);
}
var InciteCard_instance;
function InciteCard_getInstance() {
  if (InciteCard_instance === VOID)
    new InciteCard();
  return InciteCard_instance;
}
function _get_$cachedSerializer__te6jhj_114($this) {
  return $this.o3u_1.k3();
}
function UnearthCard$_anonymous__k87l2i() {
  var tmp = UnearthCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UnearthCard', tmp, tmp$ret$0);
}
var UnearthCard_instance;
function UnearthCard_getInstance() {
  if (UnearthCard_instance === VOID)
    new UnearthCard();
  return UnearthCard_instance;
}
function _get_$cachedSerializer__te6jhj_115($this) {
  return $this.q3u_1.k3();
}
function ChargeCard$_anonymous__jivcb1() {
  var tmp = ChargeCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ChargeCard', tmp, tmp$ret$0);
}
var ChargeCard_instance;
function ChargeCard_getInstance() {
  if (ChargeCard_instance === VOID)
    new ChargeCard();
  return ChargeCard_instance;
}
function _get_$cachedSerializer__te6jhj_116($this) {
  return $this.s3u_1.k3();
}
function DisplaceCard$_anonymous__yhz3pu() {
  var tmp = DisplaceCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DisplaceCard', tmp, tmp$ret$0);
}
var DisplaceCard_instance;
function DisplaceCard_getInstance() {
  if (DisplaceCard_instance === VOID)
    new DisplaceCard();
  return DisplaceCard_instance;
}
function _get_$cachedSerializer__te6jhj_117($this) {
  return $this.u3u_1.k3();
}
function GlimpseCard$_anonymous__6bfq8e() {
  var tmp = GlimpseCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('GlimpseCard', tmp, tmp$ret$0);
}
var GlimpseCard_instance;
function GlimpseCard_getInstance() {
  if (GlimpseCard_instance === VOID)
    new GlimpseCard();
  return GlimpseCard_instance;
}
function _get_$cachedSerializer__te6jhj_118($this) {
  return $this.w3u_1.k3();
}
function StrideCard$_anonymous__8l2ipe() {
  var tmp = StrideCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('StrideCard', tmp, tmp$ret$0);
}
var StrideCard_instance;
function StrideCard_getInstance() {
  if (StrideCard_instance === VOID)
    new StrideCard();
  return StrideCard_instance;
}
var Companion_instance_147;
function Companion_getInstance_148() {
  return Companion_instance_147;
}
var $serializer_instance_127;
function $serializer_getInstance_127() {
  if ($serializer_instance_127 === VOID)
    new $serializer_127();
  return $serializer_instance_127;
}
var Companion_instance_148;
function Companion_getInstance_149() {
  return Companion_instance_148;
}
function get_draugCorruptionLevelKey() {
  _init_properties_Draug_kt__xdtsoj();
  return draugCorruptionLevelKey;
}
var draugCorruptionLevelKey;
function get_draugWillRespawnKey() {
  _init_properties_Draug_kt__xdtsoj();
  return draugWillRespawnKey;
}
var draugWillRespawnKey;
function _get_$cachedSerializer__te6jhj_119($this) {
  return $this.c3v_1.k3();
}
function Draug$_anonymous__2ecgfm() {
  var tmp = Draug_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Draug', tmp, tmp$ret$0);
}
var Draug_instance;
function Draug_getInstance() {
  if (Draug_instance === VOID)
    new Draug();
  return Draug_instance;
}
function _get_$cachedSerializer__te6jhj_120($this) {
  return $this.d3v_1.k3();
}
function BloodlessFuryUpgrade$_anonymous__17ds78() {
  var tmp = BloodlessFuryUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BloodlessFuryUpgrade', tmp, tmp$ret$0);
}
var BloodlessFuryUpgrade_instance;
function BloodlessFuryUpgrade_getInstance() {
  if (BloodlessFuryUpgrade_instance === VOID)
    new BloodlessFuryUpgrade();
  return BloodlessFuryUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_121($this) {
  return $this.e3v_1.k3();
}
function PalebloodAxesUpgrade$_anonymous__nd0pf4() {
  var tmp = PalebloodAxesUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PalebloodAxesUpgrade', tmp, tmp$ret$0);
}
var PalebloodAxesUpgrade_instance;
function PalebloodAxesUpgrade_getInstance() {
  if (PalebloodAxesUpgrade_instance === VOID)
    new PalebloodAxesUpgrade();
  return PalebloodAxesUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_122($this) {
  return $this.f3v_1.k3();
}
function SharedMadnessUpgrade$_anonymous__9c9tp9() {
  var tmp = SharedMadnessUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SharedMadnessUpgrade', tmp, tmp$ret$0);
}
var SharedMadnessUpgrade_instance;
function SharedMadnessUpgrade_getInstance() {
  if (SharedMadnessUpgrade_instance === VOID)
    new SharedMadnessUpgrade();
  return SharedMadnessUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_123($this) {
  return $this.g3v_1.k3();
}
function DraugCardWoundEffectSource$_anonymous__qvizwz() {
  var tmp = DraugCardWoundEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DraugCardWoundEffectSource', tmp, tmp$ret$0);
}
var DraugCardWoundEffectSource_instance;
function DraugCardWoundEffectSource_getInstance() {
  if (DraugCardWoundEffectSource_instance === VOID)
    new DraugCardWoundEffectSource();
  return DraugCardWoundEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_124($this) {
  return $this.j3v_1.k3();
}
function BerserkCard$_anonymous__47628d() {
  var tmp = BerserkCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BerserkCard', tmp, tmp$ret$0);
}
var BerserkCard_instance;
function BerserkCard_getInstance() {
  if (BerserkCard_instance === VOID)
    new BerserkCard();
  return BerserkCard_instance;
}
function get_draugCorruptionLevel(gsCtx, _this__u8e3s4) {
  _init_properties_Draug_kt__xdtsoj();
  return getDraugCorruptionLevelImpl(_this__u8e3s4, gsCtx);
}
function getDraugCorruptionLevelImpl(_this__u8e3s4, gameState) {
  _init_properties_Draug_kt__xdtsoj();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_draugCorruptionLevelKey()).t3p_1;
}
function DraugBerserkReactionStatement$Companion$$childSerializers$_anonymous__ebqcgp() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_149;
function Companion_getInstance_150() {
  if (Companion_instance_149 === VOID)
    new Companion_149();
  return Companion_instance_149;
}
var $serializer_instance_128;
function $serializer_getInstance_128() {
  if ($serializer_instance_128 === VOID)
    new $serializer_128();
  return $serializer_instance_128;
}
function GainDraugCorruptionStatement$Companion$$childSerializers$_anonymous__2eib38() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_150;
function Companion_getInstance_151() {
  if (Companion_instance_150 === VOID)
    new Companion_150();
  return Companion_instance_150;
}
var $serializer_instance_129;
function $serializer_getInstance_129() {
  if ($serializer_instance_129 === VOID)
    new $serializer_129();
  return $serializer_instance_129;
}
function _get_$cachedSerializer__te6jhj_125($this) {
  return $this.v3v_1.k3();
}
function DraugRespawnEvent$_anonymous__920qio() {
  var tmp = DraugRespawnEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DraugRespawnEvent', tmp, tmp$ret$0);
}
var DraugRespawnEvent_instance;
function DraugRespawnEvent_getInstance() {
  if (DraugRespawnEvent_instance === VOID)
    new DraugRespawnEvent();
  return DraugRespawnEvent_instance;
}
var Companion_instance_151;
function Companion_getInstance_152() {
  return Companion_instance_151;
}
var $serializer_instance_130;
function $serializer_getInstance_130() {
  if ($serializer_instance_130 === VOID)
    new $serializer_130();
  return $serializer_instance_130;
}
var Companion_instance_152;
function Companion_getInstance_153() {
  return Companion_instance_152;
}
var $serializer_instance_131;
function $serializer_getInstance_131() {
  if ($serializer_instance_131 === VOID)
    new $serializer_131();
  return $serializer_instance_131;
}
var Companion_instance_153;
function Companion_getInstance_154() {
  return Companion_instance_153;
}
var $serializer_instance_132;
function $serializer_getInstance_132() {
  if ($serializer_instance_132 === VOID)
    new $serializer_132();
  return $serializer_instance_132;
}
function _get_$cachedSerializer__te6jhj_126($this) {
  return $this.i3w_1.k3();
}
function PrepareDraugRespawnEvent$_anonymous__ov7g3d() {
  var tmp = PrepareDraugRespawnEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PrepareDraugRespawnEvent', tmp, tmp$ret$0);
}
var PrepareDraugRespawnEvent_instance;
function PrepareDraugRespawnEvent_getInstance() {
  if (PrepareDraugRespawnEvent_instance === VOID)
    new PrepareDraugRespawnEvent();
  return PrepareDraugRespawnEvent_instance;
}
function get_draugWillRespawn(gsCtx, _this__u8e3s4) {
  _init_properties_Draug_kt__xdtsoj();
  return getDraugWillRespawnImpl(_this__u8e3s4, gsCtx);
}
function get_draugHunter($context_GameState_t6qee5) {
  _init_properties_Draug_kt__xdtsoj();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Draug) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function set_draugCorruptionLevelImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Draug_kt__xdtsoj();
  setImplProperty(gsiCtx, _this__u8e3s4, get_draugCorruptionLevelKey(), new IntWrapper(value));
}
function get_draugCorruptionLevelImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Draug_kt__xdtsoj();
  return getDraugCorruptionLevelImpl(_this__u8e3s4, gsiCtx);
}
function set_draugWillRespawnImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Draug_kt__xdtsoj();
  setImplProperty(gsiCtx, _this__u8e3s4, get_draugWillRespawnKey(), new BooleanWrapper(value));
}
function getDraugWillRespawnImpl(_this__u8e3s4, gameState) {
  _init_properties_Draug_kt__xdtsoj();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_draugWillRespawnKey()).j3w_1;
}
var properties_initialized_Draug_kt_839hsb;
function _init_properties_Draug_kt__xdtsoj() {
  if (!properties_initialized_Draug_kt_839hsb) {
    properties_initialized_Draug_kt_839hsb = true;
    draugCorruptionLevelKey = _GeneralMapKey___init__impl__zdmbea('draugCorruption');
    draugWillRespawnKey = _GeneralMapKey___init__impl__zdmbea('draugWillRespawn');
  }
}
var Companion_instance_154;
function Companion_getInstance_155() {
  return Companion_instance_154;
}
function EventItselfSource$Companion$$childSerializers$_anonymous__dvzqv2() {
  return Companion_instance_295.a2g();
}
var Companion_instance_155;
function Companion_getInstance_156() {
  if (Companion_instance_155 === VOID)
    new Companion_155();
  return Companion_instance_155;
}
var $serializer_instance_133;
function $serializer_getInstance_133() {
  if ($serializer_instance_133 === VOID)
    new $serializer_133();
  return $serializer_instance_133;
}
function _get_$cachedSerializer__te6jhj_127($this) {
  return $this.p3w_1.k3();
}
function ClaimRuinEffectSource$_anonymous__c0lcp() {
  var tmp = ClaimRuinEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ClaimRuinEffectSource', tmp, tmp$ret$0);
}
var ClaimRuinEffectSource_instance;
function ClaimRuinEffectSource_getInstance() {
  if (ClaimRuinEffectSource_instance === VOID)
    new ClaimRuinEffectSource();
  return ClaimRuinEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_128($this) {
  return $this.q3w_1.k3();
}
function PossibleTrapEffectSource$_anonymous__q0xzf7() {
  var tmp = PossibleTrapEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleTrapEffectSource', tmp, tmp$ret$0);
}
var PossibleTrapEffectSource_instance;
function PossibleTrapEffectSource_getInstance() {
  if (PossibleTrapEffectSource_instance === VOID)
    new PossibleTrapEffectSource();
  return PossibleTrapEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_129($this) {
  return $this.r3w_1.k3();
}
function PossibleDreamerMaskEffectSource$_anonymous__x7usyo() {
  var tmp = PossibleDreamerMaskEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleDreamerMaskEffectSource', tmp, tmp$ret$0);
}
var PossibleDreamerMaskEffectSource_instance;
function PossibleDreamerMaskEffectSource_getInstance() {
  if (PossibleDreamerMaskEffectSource_instance === VOID)
    new PossibleDreamerMaskEffectSource();
  return PossibleDreamerMaskEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_130($this) {
  return $this.t3w_1.k3();
}
function PossibleEsmeriasStrandEffectSource$_anonymous__lfma2t() {
  var tmp = PossibleEsmeriasStrandEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleEsmeriasStrandEffectSource', tmp, tmp$ret$0);
}
var PossibleEsmeriasStrandEffectSource_instance;
function PossibleEsmeriasStrandEffectSource_getInstance() {
  if (PossibleEsmeriasStrandEffectSource_instance === VOID)
    new PossibleEsmeriasStrandEffectSource();
  return PossibleEsmeriasStrandEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_131($this) {
  return $this.u3w_1.k3();
}
function PossibleFlareEffectSource$_anonymous__v4ngge() {
  var tmp = PossibleFlareEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleFlareEffectSource', tmp, tmp$ret$0);
}
var PossibleFlareEffectSource_instance;
function PossibleFlareEffectSource_getInstance() {
  if (PossibleFlareEffectSource_instance === VOID)
    new PossibleFlareEffectSource();
  return PossibleFlareEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_132($this) {
  return $this.v3w_1.k3();
}
function PossibleIntuitionEffectSource$_anonymous__6rrawr() {
  var tmp = PossibleIntuitionEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleIntuitionEffectSource', tmp, tmp$ret$0);
}
var PossibleIntuitionEffectSource_instance;
function PossibleIntuitionEffectSource_getInstance() {
  if (PossibleIntuitionEffectSource_instance === VOID)
    new PossibleIntuitionEffectSource();
  return PossibleIntuitionEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_133($this) {
  return $this.w3w_1.k3();
}
function PossibleSmokeBombEffectSource$_anonymous__zaphzp() {
  var tmp = PossibleSmokeBombEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleSmokeBombEffectSource', tmp, tmp$ret$0);
}
var PossibleSmokeBombEffectSource_instance;
function PossibleSmokeBombEffectSource_getInstance() {
  if (PossibleSmokeBombEffectSource_instance === VOID)
    new PossibleSmokeBombEffectSource();
  return PossibleSmokeBombEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_134($this) {
  return $this.x3w_1.k3();
}
function PossibleSuddenMistEffectSource$_anonymous__6sklou() {
  var tmp = PossibleSuddenMistEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleSuddenMistEffectSource', tmp, tmp$ret$0);
}
var PossibleSuddenMistEffectSource_instance;
function PossibleSuddenMistEffectSource_getInstance() {
  if (PossibleSuddenMistEffectSource_instance === VOID)
    new PossibleSuddenMistEffectSource();
  return PossibleSuddenMistEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_135($this) {
  return $this.y3w_1.k3();
}
function PossibleWorldShiftEffectSource$_anonymous__ah1pkm() {
  var tmp = PossibleWorldShiftEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleWorldShiftEffectSource', tmp, tmp$ret$0);
}
var PossibleWorldShiftEffectSource_instance;
function PossibleWorldShiftEffectSource_getInstance() {
  if (PossibleWorldShiftEffectSource_instance === VOID)
    new PossibleWorldShiftEffectSource();
  return PossibleWorldShiftEffectSource_instance;
}
var Companion_instance_156;
function Companion_getInstance_157() {
  return Companion_instance_156;
}
function get_fylgjaFlightWasUsedThisTurnKey() {
  _init_properties_Eivind_kt__t78awd();
  return fylgjaFlightWasUsedThisTurnKey;
}
var fylgjaFlightWasUsedThisTurnKey;
function _get_$cachedSerializer__te6jhj_136($this) {
  return $this.b3x_1.k3();
}
function Eivind$_anonymous__2aa1oq() {
  var tmp = Eivind_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Eivind', tmp, tmp$ret$0);
}
var Eivind_instance;
function Eivind_getInstance() {
  if (Eivind_instance === VOID)
    new Eivind();
  return Eivind_instance;
}
function _get_$cachedSerializer__te6jhj_137($this) {
  return $this.c3x_1.k3();
}
function SkyMasterUpgrade$_anonymous__1nuopq() {
  var tmp = SkyMasterUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SkyMasterUpgrade', tmp, tmp$ret$0);
}
var SkyMasterUpgrade_instance;
function SkyMasterUpgrade_getInstance() {
  if (SkyMasterUpgrade_instance === VOID)
    new SkyMasterUpgrade();
  return SkyMasterUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_138($this) {
  return $this.d3x_1.k3();
}
function RopePullUpgrade$_anonymous__wurkr6() {
  var tmp = RopePullUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RopePullUpgrade', tmp, tmp$ret$0);
}
var RopePullUpgrade_instance;
function RopePullUpgrade_getInstance() {
  if (RopePullUpgrade_instance === VOID)
    new RopePullUpgrade();
  return RopePullUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_139($this) {
  return $this.e3x_1.k3();
}
function ReachUpgrade$_anonymous__p7kx5e() {
  var tmp = ReachUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ReachUpgrade', tmp, tmp$ret$0);
}
var ReachUpgrade_instance;
function ReachUpgrade_getInstance() {
  if (ReachUpgrade_instance === VOID)
    new ReachUpgrade();
  return ReachUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_140($this) {
  return $this.f3x_1.k3();
}
function FylgjaFlightEffectSource$_anonymous__bdmycq() {
  var tmp = FylgjaFlightEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FylgjaFlightEffectSource', tmp, tmp$ret$0);
}
var FylgjaFlightEffectSource_instance;
function FylgjaFlightEffectSource_getInstance() {
  if (FylgjaFlightEffectSource_instance === VOID)
    new FylgjaFlightEffectSource();
  return FylgjaFlightEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_141($this) {
  return $this.g3x_1.k3();
}
function SummonFylgjaEffectSource$_anonymous__ysk0rf() {
  var tmp = SummonFylgjaEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonFylgjaEffectSource', tmp, tmp$ret$0);
}
var SummonFylgjaEffectSource_instance;
function SummonFylgjaEffectSource_getInstance() {
  if (SummonFylgjaEffectSource_instance === VOID)
    new SummonFylgjaEffectSource();
  return SummonFylgjaEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_142($this) {
  return $this.j3x_1.k3();
}
function GrapplingHookCard$_anonymous__qlj1w8() {
  var tmp = GrapplingHookCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('GrapplingHookCard', tmp, tmp$ret$0);
}
var GrapplingHookCard_instance;
function GrapplingHookCard_getInstance() {
  if (GrapplingHookCard_instance === VOID)
    new GrapplingHookCard();
  return GrapplingHookCard_instance;
}
function _get_$cachedSerializer__te6jhj_143($this) {
  return $this.m3x_1.k3();
}
function AviationCard$_anonymous__1mdgca() {
  var tmp = AviationCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AviationCard', tmp, tmp$ret$0);
}
var AviationCard_instance;
function AviationCard_getInstance() {
  if (AviationCard_instance === VOID)
    new AviationCard();
  return AviationCard_instance;
}
function _get_$cachedSerializer__te6jhj_144($this) {
  return $this.o3x_1.k3();
}
function Fylgja$_anonymous__4agmj6() {
  var tmp = Fylgja_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Fylgja', tmp, tmp$ret$0);
}
var Fylgja_instance;
function Fylgja_getInstance() {
  if (Fylgja_instance === VOID)
    new Fylgja();
  return Fylgja_instance;
}
function get_eivindHunter($context_GameState_t6qee5) {
  _init_properties_Eivind_kt__t78awd();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Eivind) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function FylgjaFlightStatement$Companion$$childSerializers$_anonymous__ci6ids() {
  var tmp = Fylgja_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return $serializer_364.y2o(ObjectSerializer.l1c('Fylgja', tmp, tmp$ret$0));
}
var Companion_instance_157;
function Companion_getInstance_158() {
  if (Companion_instance_157 === VOID)
    new Companion_157();
  return Companion_instance_157;
}
var $serializer_instance_134;
function $serializer_getInstance_134() {
  if ($serializer_instance_134 === VOID)
    new $serializer_134();
  return $serializer_instance_134;
}
function _get_$cachedSerializer__te6jhj_145($this) {
  return $this.v3x_1.k3();
}
function SummonFylgjaStatement$_anonymous__pkwkc2() {
  var tmp = SummonFylgjaStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonFylgjaStatement', tmp, tmp$ret$0);
}
var SummonFylgjaStatement_instance;
function SummonFylgjaStatement_getInstance() {
  if (SummonFylgjaStatement_instance === VOID)
    new SummonFylgjaStatement();
  return SummonFylgjaStatement_instance;
}
var Companion_instance_158;
function Companion_getInstance_159() {
  return Companion_instance_158;
}
var $serializer_instance_135;
function $serializer_getInstance_135() {
  if ($serializer_instance_135 === VOID)
    new $serializer_135();
  return $serializer_instance_135;
}
function set_fylgjaFlightWasUsedThisTurnImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Eivind_kt__t78awd();
  gsiCtx.j39(_this__u8e3s4.r2w_1, get_fylgjaFlightWasUsedThisTurnKey(), new BooleanWrapper(value), new BooleanWrapper(false));
}
var properties_initialized_Eivind_kt_jxfwtr;
function _init_properties_Eivind_kt__t78awd() {
  if (!properties_initialized_Eivind_kt_jxfwtr) {
    properties_initialized_Eivind_kt_jxfwtr = true;
    fylgjaFlightWasUsedThisTurnKey = _GeneralMapKey___init__impl__zdmbea('fylgjaFlightWasUsedThisTurn');
  }
}
function _EntityId___init__impl__cq1mhp(id) {
  return id;
}
function _EntityId___get_id__impl__v6colh($this) {
  return $this;
}
var Companion_instance_159;
function Companion_getInstance_160() {
  return Companion_instance_159;
}
var $serializer_instance_136;
function $serializer_getInstance_136() {
  if ($serializer_instance_136 === VOID)
    new $serializer_136();
  return $serializer_instance_136;
}
function EntityId__toString_impl_njecar($this) {
  return 'EntityId(id=' + $this + ')';
}
function EntityId__hashCode_impl_1s8fhw($this) {
  return $this;
}
function EntityId__equals_impl_5w8h0w($this, other) {
  if (!(other instanceof EntityId))
    return false;
  if (!($this === other.c3y_1))
    return false;
  return true;
}
function get_esmeriaMesmeriseTargetKey() {
  _init_properties_EsmeriaBeast_kt__a5wucl();
  return esmeriaMesmeriseTargetKey;
}
var esmeriaMesmeriseTargetKey;
function _get_$cachedSerializer__te6jhj_146($this) {
  return $this.e3y_1.k3();
}
function EndlessStruggleUpgrade$_anonymous__91bmb8() {
  var tmp = EndlessStruggleUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EndlessStruggleUpgrade', tmp, tmp$ret$0);
}
var EndlessStruggleUpgrade_instance;
function EndlessStruggleUpgrade_getInstance() {
  if (EndlessStruggleUpgrade_instance === VOID)
    new EndlessStruggleUpgrade();
  return EndlessStruggleUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_147($this) {
  return $this.f3y_1.k3();
}
function AccursedWrathUpgrade$_anonymous__2u8onz() {
  var tmp = AccursedWrathUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AccursedWrathUpgrade', tmp, tmp$ret$0);
}
var AccursedWrathUpgrade_instance;
function AccursedWrathUpgrade_getInstance() {
  if (AccursedWrathUpgrade_instance === VOID)
    new AccursedWrathUpgrade();
  return AccursedWrathUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_148($this) {
  return $this.g3y_1.k3();
}
function KillingsSpreeUpgrade$_anonymous__vcafup() {
  var tmp = KillingsSpreeUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('KillingsSpreeUpgrade', tmp, tmp$ret$0);
}
var KillingsSpreeUpgrade_instance;
function KillingsSpreeUpgrade_getInstance() {
  if (KillingsSpreeUpgrade_instance === VOID)
    new KillingsSpreeUpgrade();
  return KillingsSpreeUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_149($this) {
  return $this.h3y_1.k3();
}
function SinisterActUpgrade$_anonymous__i4b3e6() {
  var tmp = SinisterActUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SinisterActUpgrade', tmp, tmp$ret$0);
}
var SinisterActUpgrade_instance;
function SinisterActUpgrade_getInstance() {
  if (SinisterActUpgrade_instance === VOID)
    new SinisterActUpgrade();
  return SinisterActUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_150($this) {
  return $this.i3y_1.k3();
}
function MesmeriseUpgrade$_anonymous__ip2w89() {
  var tmp = MesmeriseUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MesmeriseUpgrade', tmp, tmp$ret$0);
}
var MesmeriseUpgrade_instance;
function MesmeriseUpgrade_getInstance() {
  if (MesmeriseUpgrade_instance === VOID)
    new MesmeriseUpgrade();
  return MesmeriseUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_151($this) {
  return $this.j3y_1.k3();
}
function TrueInstinctEsmeriaBeastUpgrade$_anonymous__fow6ow() {
  var tmp = TrueInstinctEsmeriaBeastUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TrueInstinctEsmeriaBeastUpgrade', tmp, tmp$ret$0);
}
var TrueInstinctEsmeriaBeastUpgrade_instance;
function TrueInstinctEsmeriaBeastUpgrade_getInstance() {
  if (TrueInstinctEsmeriaBeastUpgrade_instance === VOID)
    new TrueInstinctEsmeriaBeastUpgrade();
  return TrueInstinctEsmeriaBeastUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_152($this) {
  return $this.l3y_1.k3();
}
function EsmeriaBeast$_anonymous__kbluzg() {
  var tmp = EsmeriaBeast_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EsmeriaBeast', tmp, tmp$ret$0);
}
var EsmeriaBeast_instance;
function EsmeriaBeast_getInstance() {
  if (EsmeriaBeast_instance === VOID)
    new EsmeriaBeast();
  return EsmeriaBeast_instance;
}
function _get_$cachedSerializer__te6jhj_153($this) {
  return $this.n3y_1.k3();
}
function ChangelingType$_anonymous__7gpviv() {
  var tmp = ChangelingType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ChangelingType', tmp, tmp$ret$0);
}
var ChangelingType_instance;
function ChangelingType_getInstance() {
  if (ChangelingType_instance === VOID)
    new ChangelingType();
  return ChangelingType_instance;
}
function _get_$cachedSerializer__te6jhj_154($this) {
  return $this.p3y_1.k3();
}
function SummonChangelingCard$_anonymous__30wl6o() {
  var tmp = SummonChangelingCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonChangelingCard', tmp, tmp$ret$0);
}
var SummonChangelingCard_instance;
function SummonChangelingCard_getInstance() {
  if (SummonChangelingCard_instance === VOID)
    new SummonChangelingCard();
  return SummonChangelingCard_instance;
}
function _get_$cachedSerializer__te6jhj_155($this) {
  return $this.s3y_1.k3();
}
function MurderCard$_anonymous__9mviqo() {
  var tmp = MurderCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MurderCard', tmp, tmp$ret$0);
}
var MurderCard_instance;
function MurderCard_getInstance() {
  if (MurderCard_instance === VOID)
    new MurderCard();
  return MurderCard_instance;
}
function _get_$cachedSerializer__te6jhj_156($this) {
  return $this.v3y_1.k3();
}
function StalkCard$_anonymous__l6lyns() {
  var tmp = StalkCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('StalkCard', tmp, tmp$ret$0);
}
var StalkCard_instance;
function StalkCard_getInstance() {
  if (StalkCard_instance === VOID)
    new StalkCard();
  return StalkCard_instance;
}
function _get_$cachedSerializer__te6jhj_157($this) {
  return $this.y3y_1.k3();
}
function DeceiveCard$_anonymous__yukmmq() {
  var tmp = DeceiveCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DeceiveCard', tmp, tmp$ret$0);
}
var DeceiveCard_instance;
function DeceiveCard_getInstance() {
  if (DeceiveCard_instance === VOID)
    new DeceiveCard();
  return DeceiveCard_instance;
}
function HauntStatement$Companion$$childSerializers$_anonymous__4wa9dp() {
  var tmp = ChangelingType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return $serializer_364.y2o(ObjectSerializer.l1c('ChangelingType', tmp, tmp$ret$0));
}
var Companion_instance_160;
function Companion_getInstance_161() {
  if (Companion_instance_160 === VOID)
    new Companion_160();
  return Companion_instance_160;
}
var $serializer_instance_137;
function $serializer_getInstance_137() {
  if ($serializer_instance_137 === VOID)
    new $serializer_137();
  return $serializer_instance_137;
}
function DeceiveStatement$Companion$$childSerializers$_anonymous__msbals() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_161;
function Companion_getInstance_162() {
  if (Companion_instance_161 === VOID)
    new Companion_161();
  return Companion_instance_161;
}
var $serializer_instance_138;
function $serializer_getInstance_138() {
  if ($serializer_instance_138 === VOID)
    new $serializer_138();
  return $serializer_instance_138;
}
function _get_$cachedSerializer__te6jhj_158($this) {
  return $this.j3z_1.k3();
}
function CardToCopyForDeceiveQuestionContext$_anonymous__16pb3u() {
  var tmp = CardToCopyForDeceiveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CardToCopyForDeceiveQuestionContext', tmp, tmp$ret$0);
}
var CardToCopyForDeceiveQuestionContext_instance;
function CardToCopyForDeceiveQuestionContext_getInstance() {
  if (CardToCopyForDeceiveQuestionContext_instance === VOID)
    new CardToCopyForDeceiveQuestionContext();
  return CardToCopyForDeceiveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_159($this) {
  return $this.k3z_1.k3();
}
function ChooseMesmeriseTargetStatement$_anonymous__ivvwgy() {
  var tmp = ChooseMesmeriseTargetStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ChooseMesmeriseTargetStatement', tmp, tmp$ret$0);
}
var ChooseMesmeriseTargetStatement_instance;
function ChooseMesmeriseTargetStatement_getInstance() {
  if (ChooseMesmeriseTargetStatement_instance === VOID)
    new ChooseMesmeriseTargetStatement();
  return ChooseMesmeriseTargetStatement_instance;
}
function get_mesmerizedHunter($context_GameState_t6qee5) {
  _init_properties_EsmeriaBeast_kt__a5wucl();
  var tmp0_safe_receiver = get_esmeriaBeastOrNull($context_GameState_t6qee5);
  return tmp0_safe_receiver == null ? null : get_esmeriaMesmeriseTarget($context_GameState_t6qee5, tmp0_safe_receiver);
}
function MesmeriseChooseEvent$Companion$$childSerializers$_anonymous__18fgfx() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_162;
function Companion_getInstance_163() {
  if (Companion_instance_162 === VOID)
    new Companion_162();
  return Companion_instance_162;
}
var $serializer_instance_139;
function $serializer_getInstance_139() {
  if ($serializer_instance_139 === VOID)
    new $serializer_139();
  return $serializer_instance_139;
}
function get_esmeriaBeastOrNull($context_GameState_t6qee5) {
  _init_properties_EsmeriaBeast_kt__a5wucl();
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof EsmeriaBeast) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return singleOrNull(destination);
}
function get_esmeriaMesmeriseTarget(gsCtx, _this__u8e3s4) {
  _init_properties_EsmeriaBeast_kt__a5wucl();
  return getEsmeriaMesmeriseTargetImpl(_this__u8e3s4, gsCtx);
}
function set_esmeriaMesmeriseTargetImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_EsmeriaBeast_kt__a5wucl();
  gsiCtx.j39(_this__u8e3s4.r2w_1, get_esmeriaMesmeriseTargetKey(), new ObjectOnBoardWrapper(value), new ObjectOnBoardWrapper(null));
}
function get_esmeriaBeast($context_GameState_t6qee5) {
  _init_properties_EsmeriaBeast_kt__a5wucl();
  var tmp0_elvis_lhs = get_esmeriaBeastOrNull($context_GameState_t6qee5);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'No Esmeria on board';
    throw IllegalStateException.o(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function getEsmeriaMesmeriseTargetImpl(_this__u8e3s4, gameState) {
  _init_properties_EsmeriaBeast_kt__a5wucl();
  // Inline function 'kotlin.with' call
  var tmp = getGeneralPropertyWithDefault(_this__u8e3s4.l39(gameState), get_esmeriaMesmeriseTargetKey(), new ObjectOnBoardWrapper(null)).i3f_1;
  return (tmp == null ? true : tmp instanceof ObjectOnBoard) ? tmp : THROW_CCE();
}
var properties_initialized_EsmeriaBeast_kt_5ksgtf;
function _init_properties_EsmeriaBeast_kt__a5wucl() {
  if (!properties_initialized_EsmeriaBeast_kt_5ksgtf) {
    properties_initialized_EsmeriaBeast_kt_5ksgtf = true;
    esmeriaMesmeriseTargetKey = _GeneralMapKey___init__impl__zdmbea('esmeriaMesmeriseTarget');
  }
}
function get_blueDraftActionCardWasPlayedKey() {
  _init_properties_EsmeriaHuntress_kt__7mqo9k();
  return blueDraftActionCardWasPlayedKey;
}
var blueDraftActionCardWasPlayedKey;
function _get_$cachedSerializer__te6jhj_160($this) {
  return $this.r3z_1.k3();
}
function EsmeriaHuntress$_anonymous__yv822b() {
  var tmp = EsmeriaHuntress_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EsmeriaHuntress', tmp, tmp$ret$0);
}
var EsmeriaHuntress_instance;
function EsmeriaHuntress_getInstance() {
  if (EsmeriaHuntress_instance === VOID)
    new EsmeriaHuntress();
  return EsmeriaHuntress_instance;
}
function _get_$cachedSerializer__te6jhj_161($this) {
  return $this.s3z_1.k3();
}
function HuntmasterUpgrade$_anonymous__ilf4kw() {
  var tmp = HuntmasterUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HuntmasterUpgrade', tmp, tmp$ret$0);
}
var HuntmasterUpgrade_instance;
function HuntmasterUpgrade_getInstance() {
  if (HuntmasterUpgrade_instance === VOID)
    new HuntmasterUpgrade();
  return HuntmasterUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_162($this) {
  return $this.t3z_1.k3();
}
function BlackStarUpgrade$_anonymous__ggeyjw() {
  var tmp = BlackStarUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BlackStarUpgrade', tmp, tmp$ret$0);
}
var BlackStarUpgrade_instance;
function BlackStarUpgrade_getInstance() {
  if (BlackStarUpgrade_instance === VOID)
    new BlackStarUpgrade();
  return BlackStarUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_163($this) {
  return $this.u3z_1.k3();
}
function PredictUpgrade$_anonymous__jewzos() {
  var tmp = PredictUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PredictUpgrade', tmp, tmp$ret$0);
}
var PredictUpgrade_instance;
function PredictUpgrade_getInstance() {
  if (PredictUpgrade_instance === VOID)
    new PredictUpgrade();
  return PredictUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_164($this) {
  return $this.v3z_1.k3();
}
function TrueInstinctEsmeriaHuntressUpgrade$_anonymous__amlkmz() {
  var tmp = TrueInstinctEsmeriaHuntressUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TrueInstinctEsmeriaHuntressUpgrade', tmp, tmp$ret$0);
}
var TrueInstinctEsmeriaHuntressUpgrade_instance;
function TrueInstinctEsmeriaHuntressUpgrade_getInstance() {
  if (TrueInstinctEsmeriaHuntressUpgrade_instance === VOID)
    new TrueInstinctEsmeriaHuntressUpgrade();
  return TrueInstinctEsmeriaHuntressUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_165($this) {
  return $this.y3z_1.k3();
}
function UnnaturalResolveCard$_anonymous__ziiouj() {
  var tmp = UnnaturalResolveCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UnnaturalResolveCard', tmp, tmp$ret$0);
}
var UnnaturalResolveCard_instance;
function UnnaturalResolveCard_getInstance() {
  if (UnnaturalResolveCard_instance === VOID)
    new UnnaturalResolveCard();
  return UnnaturalResolveCard_instance;
}
function _get_$cachedSerializer__te6jhj_166($this) {
  return $this.b40_1.k3();
}
function DelegateCard$_anonymous__pucgma() {
  var tmp = DelegateCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DelegateCard', tmp, tmp$ret$0);
}
var DelegateCard_instance;
function DelegateCard_getInstance() {
  if (DelegateCard_instance === VOID)
    new DelegateCard();
  return DelegateCard_instance;
}
function UnnaturalResolveStatement$Companion$$childSerializers$_anonymous__3qrqpj() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_163;
function Companion_getInstance_164() {
  if (Companion_instance_163 === VOID)
    new Companion_163();
  return Companion_instance_163;
}
var $serializer_instance_140;
function $serializer_getInstance_140() {
  if ($serializer_instance_140 === VOID)
    new $serializer_140();
  return $serializer_instance_140;
}
function _get_$cachedSerializer__te6jhj_167($this) {
  return $this.h40_1.k3();
}
function BlackStarStatement$_anonymous__dopi93() {
  var tmp = BlackStarStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BlackStarStatement', tmp, tmp$ret$0);
}
var BlackStarStatement_instance;
function BlackStarStatement_getInstance() {
  if (BlackStarStatement_instance === VOID)
    new BlackStarStatement();
  return BlackStarStatement_instance;
}
function ChangeBlueDraftActionCardWasPlayedStatusEvent$Companion$$childSerializers$_anonymous__pk1odb() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_92.a2g()));
}
var Companion_instance_164;
function Companion_getInstance_165() {
  if (Companion_instance_164 === VOID)
    new Companion_164();
  return Companion_instance_164;
}
var $serializer_instance_141;
function $serializer_getInstance_141() {
  if ($serializer_instance_141 === VOID)
    new $serializer_141();
  return $serializer_instance_141;
}
function set_blueDraftActionCardWasPlayedImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_EsmeriaHuntress_kt__7mqo9k();
  gsiCtx.j39(_this__u8e3s4.r2w_1, get_blueDraftActionCardWasPlayedKey(), new BooleanWrapper(value), new BooleanWrapper(false));
}
var properties_initialized_EsmeriaHuntress_kt_6e2koq;
function _init_properties_EsmeriaHuntress_kt__7mqo9k() {
  if (!properties_initialized_EsmeriaHuntress_kt_6e2koq) {
    properties_initialized_EsmeriaHuntress_kt_6e2koq = true;
    blueDraftActionCardWasPlayedKey = _GeneralMapKey___init__impl__zdmbea('blueDraftActionCardWasPlayed');
  }
}
function _get_$cachedSerializer__te6jhj_168($this) {
  return $this.o40_1.k3();
}
function BloodLustUpgrade$_anonymous__q2rvmp() {
  var tmp = BloodLustUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BloodLustUpgrade', tmp, tmp$ret$0);
}
var BloodLustUpgrade_instance;
function BloodLustUpgrade_getInstance() {
  if (BloodLustUpgrade_instance === VOID)
    new BloodLustUpgrade();
  return BloodLustUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_169($this) {
  return $this.p40_1.k3();
}
function EnragedUpgrade$_anonymous__qit8i1() {
  var tmp = EnragedUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EnragedUpgrade', tmp, tmp$ret$0);
}
var EnragedUpgrade_instance;
function EnragedUpgrade_getInstance() {
  if (EnragedUpgrade_instance === VOID)
    new EnragedUpgrade();
  return EnragedUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_170($this) {
  return $this.q40_1.k3();
}
function GreatHowlUpgrade$_anonymous__yv0tl0() {
  var tmp = GreatHowlUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('GreatHowlUpgrade', tmp, tmp$ret$0);
}
var GreatHowlUpgrade_instance;
function GreatHowlUpgrade_getInstance() {
  if (GreatHowlUpgrade_instance === VOID)
    new GreatHowlUpgrade();
  return GreatHowlUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_171($this) {
  return $this.r40_1.k3();
}
function HuntingGroundsUpgrade$_anonymous__b83iaw() {
  var tmp = HuntingGroundsUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HuntingGroundsUpgrade', tmp, tmp$ret$0);
}
var HuntingGroundsUpgrade_instance;
function HuntingGroundsUpgrade_getInstance() {
  if (HuntingGroundsUpgrade_instance === VOID)
    new HuntingGroundsUpgrade();
  return HuntingGroundsUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_172($this) {
  return $this.s40_1.k3();
}
function KinsPursuitUpgrade$_anonymous__4q60tu() {
  var tmp = KinsPursuitUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('KinsPursuitUpgrade', tmp, tmp$ret$0);
}
var KinsPursuitUpgrade_instance;
function KinsPursuitUpgrade_getInstance() {
  if (KinsPursuitUpgrade_instance === VOID)
    new KinsPursuitUpgrade();
  return KinsPursuitUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_173($this) {
  return $this.t40_1.k3();
}
function NaturalInstinctUpgrade$_anonymous__mbgnc0() {
  var tmp = NaturalInstinctUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NaturalInstinctUpgrade', tmp, tmp$ret$0);
}
var NaturalInstinctUpgrade_instance;
function NaturalInstinctUpgrade_getInstance() {
  if (NaturalInstinctUpgrade_instance === VOID)
    new NaturalInstinctUpgrade();
  return NaturalInstinctUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_174($this) {
  return $this.u40_1.k3();
}
function CullingUpgrade$_anonymous__k4piq3() {
  var tmp = CullingUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CullingUpgrade', tmp, tmp$ret$0);
}
var CullingUpgrade_instance;
function CullingUpgrade_getInstance() {
  if (CullingUpgrade_instance === VOID)
    new CullingUpgrade();
  return CullingUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_175($this) {
  return $this.w40_1.k3();
}
function Fangrir$_anonymous__adbi5s() {
  var tmp = Fangrir_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Fangrir', tmp, tmp$ret$0);
}
var Fangrir_instance;
function Fangrir_getInstance() {
  if (Fangrir_instance === VOID)
    new Fangrir();
  return Fangrir_instance;
}
function _get_$cachedSerializer__te6jhj_176($this) {
  return $this.z40_1.k3();
}
function WolfType$_anonymous__fdy7dh() {
  var tmp = WolfType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WolfType', tmp, tmp$ret$0);
}
var WolfType_instance;
function WolfType_getInstance() {
  if (WolfType_instance === VOID)
    new WolfType();
  return WolfType_instance;
}
function _get_$cachedSerializer__te6jhj_177($this) {
  return $this.b41_1.k3();
}
function SummonWolfCard$_anonymous__knmyp8() {
  var tmp = SummonWolfCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonWolfCard', tmp, tmp$ret$0);
}
var SummonWolfCard_instance;
function SummonWolfCard_getInstance() {
  if (SummonWolfCard_instance === VOID)
    new SummonWolfCard();
  return SummonWolfCard_instance;
}
function _get_$cachedSerializer__te6jhj_178($this) {
  return $this.e41_1.k3();
}
function LurkCard$_anonymous__ll53qd() {
  var tmp = LurkCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LurkCard', tmp, tmp$ret$0);
}
var LurkCard_instance;
function LurkCard_getInstance() {
  if (LurkCard_instance === VOID)
    new LurkCard();
  return LurkCard_instance;
}
function _get_$cachedSerializer__te6jhj_179($this) {
  return $this.h41_1.k3();
}
function PreyUponCard$_anonymous__k3wig9() {
  var tmp = PreyUponCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PreyUponCard', tmp, tmp$ret$0);
}
var PreyUponCard_instance;
function PreyUponCard_getInstance() {
  if (PreyUponCard_instance === VOID)
    new PreyUponCard();
  return PreyUponCard_instance;
}
function _get_$cachedSerializer__te6jhj_180($this) {
  return $this.k41_1.k3();
}
function GatherThePackCard$_anonymous__z81ozs() {
  var tmp = GatherThePackCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('GatherThePackCard', tmp, tmp$ret$0);
}
var GatherThePackCard_instance;
function GatherThePackCard_getInstance() {
  if (GatherThePackCard_instance === VOID)
    new GatherThePackCard();
  return GatherThePackCard_instance;
}
function _get_$cachedSerializer__te6jhj_181($this) {
  return $this.l41_1.k3();
}
function GreatHowlStatement$_anonymous__cg5tfz() {
  var tmp = GreatHowlStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('GreatHowlStatement', tmp, tmp$ret$0);
}
var GreatHowlStatement_instance;
function GreatHowlStatement_getInstance() {
  if (GreatHowlStatement_instance === VOID)
    new GreatHowlStatement();
  return GreatHowlStatement_instance;
}
function _get_$cachedSerializer__te6jhj_182($this) {
  return $this.n41_1.k3();
}
function Fara$_anonymous__x5porx() {
  var tmp = Fara_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Fara', tmp, tmp$ret$0);
}
var Fara_instance;
function Fara_getInstance() {
  if (Fara_instance === VOID)
    new Fara();
  return Fara_instance;
}
function _get_$cachedSerializer__te6jhj_183($this) {
  return $this.o41_1.k3();
}
function IgniteUpgrade$_anonymous__ofjxlx() {
  var tmp = IgniteUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('IgniteUpgrade', tmp, tmp$ret$0);
}
var IgniteUpgrade_instance;
function IgniteUpgrade_getInstance() {
  if (IgniteUpgrade_instance === VOID)
    new IgniteUpgrade();
  return IgniteUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_184($this) {
  return $this.p41_1.k3();
}
function FlingUpgrade$_anonymous__t7fyvd() {
  var tmp = FlingUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FlingUpgrade', tmp, tmp$ret$0);
}
var FlingUpgrade_instance;
function FlingUpgrade_getInstance() {
  if (FlingUpgrade_instance === VOID)
    new FlingUpgrade();
  return FlingUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_185($this) {
  return $this.q41_1.k3();
}
function DarkFlameUpgrade$_anonymous__7lyox4() {
  var tmp = DarkFlameUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DarkFlameUpgrade', tmp, tmp$ret$0);
}
var DarkFlameUpgrade_instance;
function DarkFlameUpgrade_getInstance() {
  if (DarkFlameUpgrade_instance === VOID)
    new DarkFlameUpgrade();
  return DarkFlameUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_186($this) {
  return $this.r41_1.k3();
}
function RebirthByFireUpgrade$_anonymous__7i9jv0() {
  var tmp = RebirthByFireUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RebirthByFireUpgrade', tmp, tmp$ret$0);
}
var RebirthByFireUpgrade_instance;
function RebirthByFireUpgrade_getInstance() {
  if (RebirthByFireUpgrade_instance === VOID)
    new RebirthByFireUpgrade();
  return RebirthByFireUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_187($this) {
  return $this.v41_1.k3();
}
function FlameRapierCard$_anonymous__cdodrz() {
  var tmp = FlameRapierCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FlameRapierCard', tmp, tmp$ret$0);
}
var FlameRapierCard_instance;
function FlameRapierCard_getInstance() {
  if (FlameRapierCard_instance === VOID)
    new FlameRapierCard();
  return FlameRapierCard_instance;
}
function _get_$cachedSerializer__te6jhj_188($this) {
  return $this.y41_1.k3();
}
function OverloadedFlameRapierCard$_anonymous__2klavs() {
  var tmp = OverloadedFlameRapierCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OverloadedFlameRapierCard', tmp, tmp$ret$0);
}
var OverloadedFlameRapierCard_instance;
function OverloadedFlameRapierCard_getInstance() {
  if (OverloadedFlameRapierCard_instance === VOID)
    new OverloadedFlameRapierCard();
  return OverloadedFlameRapierCard_instance;
}
function FlameRapierStatement$Companion$$childSerializers$_anonymous__av2n0d() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_165;
function Companion_getInstance_166() {
  if (Companion_instance_165 === VOID)
    new Companion_165();
  return Companion_instance_165;
}
var $serializer_instance_142;
function $serializer_getInstance_142() {
  if ($serializer_instance_142 === VOID)
    new $serializer_142();
  return $serializer_instance_142;
}
function OverloadedFlameRapierMovementStatement$Companion$$childSerializers$_anonymous__gczn9j() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_166;
function Companion_getInstance_167() {
  if (Companion_instance_166 === VOID)
    new Companion_166();
  return Companion_instance_166;
}
var $serializer_instance_143;
function $serializer_getInstance_143() {
  if ($serializer_instance_143 === VOID)
    new $serializer_143();
  return $serializer_instance_143;
}
function get_featheredKingWasRebornKey() {
  _init_properties_FeatheredKing_kt__d8giih();
  return featheredKingWasRebornKey;
}
var featheredKingWasRebornKey;
function _get_$cachedSerializer__te6jhj_189($this) {
  return $this.j42_1.k3();
}
function ResurrectionUpgrade$_anonymous__iappvm() {
  var tmp = ResurrectionUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ResurrectionUpgrade', tmp, tmp$ret$0);
}
var ResurrectionUpgrade_instance;
function ResurrectionUpgrade_getInstance() {
  if (ResurrectionUpgrade_instance === VOID)
    new ResurrectionUpgrade();
  return ResurrectionUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_190($this) {
  return $this.k42_1.k3();
}
function OverlordUpgrade$_anonymous__3pw22k() {
  var tmp = OverlordUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OverlordUpgrade', tmp, tmp$ret$0);
}
var OverlordUpgrade_instance;
function OverlordUpgrade_getInstance() {
  if (OverlordUpgrade_instance === VOID)
    new OverlordUpgrade();
  return OverlordUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_191($this) {
  return $this.l42_1.k3();
}
function RegalUpgrade$_anonymous__217bba() {
  var tmp = RegalUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RegalUpgrade', tmp, tmp$ret$0);
}
var RegalUpgrade_instance;
function RegalUpgrade_getInstance() {
  if (RegalUpgrade_instance === VOID)
    new RegalUpgrade();
  return RegalUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_192($this) {
  return $this.m42_1.k3();
}
function ProminenceUpgrade$_anonymous__2wk9hx() {
  var tmp = ProminenceUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ProminenceUpgrade', tmp, tmp$ret$0);
}
var ProminenceUpgrade_instance;
function ProminenceUpgrade_getInstance() {
  if (ProminenceUpgrade_instance === VOID)
    new ProminenceUpgrade();
  return ProminenceUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_193($this) {
  return $this.n42_1.k3();
}
function EndlessDreamUpgrade$_anonymous__oytyxi() {
  var tmp = EndlessDreamUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EndlessDreamUpgrade', tmp, tmp$ret$0);
}
var EndlessDreamUpgrade_instance;
function EndlessDreamUpgrade_getInstance() {
  if (EndlessDreamUpgrade_instance === VOID)
    new EndlessDreamUpgrade();
  return EndlessDreamUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_194($this) {
  return $this.o42_1.k3();
}
function WorshipUpgrade$_anonymous__4ygknj() {
  var tmp = WorshipUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WorshipUpgrade', tmp, tmp$ret$0);
}
var WorshipUpgrade_instance;
function WorshipUpgrade_getInstance() {
  if (WorshipUpgrade_instance === VOID)
    new WorshipUpgrade();
  return WorshipUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_195($this) {
  return $this.p42_1.k3();
}
function MartyrUpgrade$_anonymous__gteu3u() {
  var tmp = MartyrUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MartyrUpgrade', tmp, tmp$ret$0);
}
var MartyrUpgrade_instance;
function MartyrUpgrade_getInstance() {
  if (MartyrUpgrade_instance === VOID)
    new MartyrUpgrade();
  return MartyrUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_196($this) {
  return $this.q42_1.k3();
}
function SoulCollectorUpgrade$_anonymous__yfslcb() {
  var tmp = SoulCollectorUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SoulCollectorUpgrade', tmp, tmp$ret$0);
}
var SoulCollectorUpgrade_instance;
function SoulCollectorUpgrade_getInstance() {
  if (SoulCollectorUpgrade_instance === VOID)
    new SoulCollectorUpgrade();
  return SoulCollectorUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_197($this) {
  return $this.r42_1.k3();
}
function FeatheredKing$_anonymous__smy5i6() {
  var tmp = FeatheredKing_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FeatheredKing', tmp, tmp$ret$0);
}
var FeatheredKing_instance;
function FeatheredKing_getInstance() {
  if (FeatheredKing_instance === VOID)
    new FeatheredKing();
  return FeatheredKing_instance;
}
function DevotionStatement$Companion$$childSerializers$_anonymous__oycrdj() {
  var tmp = DreamerType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return $serializer_364.y2o(ObjectSerializer.l1c('DreamerType', tmp, tmp$ret$0));
}
var Companion_instance_167;
function Companion_getInstance_168() {
  if (Companion_instance_167 === VOID)
    new Companion_167();
  return Companion_instance_167;
}
var $serializer_instance_144;
function $serializer_getInstance_144() {
  if ($serializer_instance_144 === VOID)
    new $serializer_144();
  return $serializer_instance_144;
}
function _get_$cachedSerializer__te6jhj_198($this) {
  return $this.x42_1.k3();
}
function ResurrectionStatement$_anonymous__jnbfpt() {
  var tmp = ResurrectionStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ResurrectionStatement', tmp, tmp$ret$0);
}
var ResurrectionStatement_instance;
function ResurrectionStatement_getInstance() {
  if (ResurrectionStatement_instance === VOID)
    new ResurrectionStatement();
  return ResurrectionStatement_instance;
}
function get_isReborn(gsCtx, _this__u8e3s4) {
  _init_properties_FeatheredKing_kt__d8giih();
  return getIsRebornImpl(_this__u8e3s4, gsCtx);
}
function get_featheredKingBeast($context_GameState_t6qee5) {
  _init_properties_FeatheredKing_kt__d8giih();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof FeatheredKing) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function _get_$cachedSerializer__te6jhj_199($this) {
  return $this.z42_1.k3();
}
function DreamerType$_anonymous__p415u5() {
  var tmp = DreamerType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DreamerType', tmp, tmp$ret$0);
}
var DreamerType_instance;
function DreamerType_getInstance() {
  if (DreamerType_instance === VOID)
    new DreamerType();
  return DreamerType_instance;
}
function _get_$cachedSerializer__te6jhj_200($this) {
  return $this.c43_1.k3();
}
function SummonDreamerCard$_anonymous__mwmiug() {
  var tmp = SummonDreamerCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonDreamerCard', tmp, tmp$ret$0);
}
var SummonDreamerCard_instance;
function SummonDreamerCard_getInstance() {
  if (SummonDreamerCard_instance === VOID)
    new SummonDreamerCard();
  return SummonDreamerCard_instance;
}
function _get_$cachedSerializer__te6jhj_201($this) {
  return $this.f43_1.k3();
}
function UnwillingSacrificeCard$_anonymous__rmc6k3() {
  var tmp = UnwillingSacrificeCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UnwillingSacrificeCard', tmp, tmp$ret$0);
}
var UnwillingSacrificeCard_instance;
function UnwillingSacrificeCard_getInstance() {
  if (UnwillingSacrificeCard_instance === VOID)
    new UnwillingSacrificeCard();
  return UnwillingSacrificeCard_instance;
}
function _get_$cachedSerializer__te6jhj_202($this) {
  return $this.i43_1.k3();
}
function UnburdenCard$_anonymous__dpmixs() {
  var tmp = UnburdenCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UnburdenCard', tmp, tmp$ret$0);
}
var UnburdenCard_instance;
function UnburdenCard_getInstance() {
  if (UnburdenCard_instance === VOID)
    new UnburdenCard();
  return UnburdenCard_instance;
}
function _get_$cachedSerializer__te6jhj_203($this) {
  return $this.l43_1.k3();
}
function UpriseCard$_anonymous__z00t31() {
  var tmp = UpriseCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UpriseCard', tmp, tmp$ret$0);
}
var UpriseCard_instance;
function UpriseCard_getInstance() {
  if (UpriseCard_instance === VOID)
    new UpriseCard();
  return UpriseCard_instance;
}
function getIsRebornImpl(_this__u8e3s4, gameState) {
  _init_properties_FeatheredKing_kt__d8giih();
  // Inline function 'kotlin.with' call
  return getGeneralPropertyWithDefault(_this__u8e3s4.l39(gameState), get_featheredKingWasRebornKey(), new BooleanWrapper(false)).j3w_1;
}
function StealGrudgeFromNearbyHunterStatement$Companion$$childSerializers$_anonymous__5294ph() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_168;
function Companion_getInstance_169() {
  if (Companion_instance_168 === VOID)
    new Companion_168();
  return Companion_instance_168;
}
var $serializer_instance_145;
function $serializer_getInstance_145() {
  if ($serializer_instance_145 === VOID)
    new $serializer_145();
  return $serializer_instance_145;
}
function UpriseUpgradedStatement$Companion$$childSerializers$_anonymous__o5jsrr() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_169;
function Companion_getInstance_170() {
  if (Companion_instance_169 === VOID)
    new Companion_169();
  return Companion_instance_169;
}
var $serializer_instance_146;
function $serializer_getInstance_146() {
  if ($serializer_instance_146 === VOID)
    new $serializer_146();
  return $serializer_instance_146;
}
function _get_$cachedSerializer__te6jhj_204($this) {
  return $this.w43_1.k3();
}
function DreamerToSacrificeQuestionContext$_anonymous__usf98s() {
  var tmp = DreamerToSacrificeQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DreamerToSacrificeQuestionContext', tmp, tmp$ret$0);
}
var DreamerToSacrificeQuestionContext_instance;
function DreamerToSacrificeQuestionContext_getInstance() {
  if (DreamerToSacrificeQuestionContext_instance === VOID)
    new DreamerToSacrificeQuestionContext();
  return DreamerToSacrificeQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_205($this) {
  return $this.x43_1.k3();
}
function HunterToStealGrudgeQuestionContext$_anonymous__9mnjra() {
  var tmp = HunterToStealGrudgeQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToStealGrudgeQuestionContext', tmp, tmp$ret$0);
}
var HunterToStealGrudgeQuestionContext_instance;
function HunterToStealGrudgeQuestionContext_getInstance() {
  if (HunterToStealGrudgeQuestionContext_instance === VOID)
    new HunterToStealGrudgeQuestionContext();
  return HunterToStealGrudgeQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_206($this) {
  return $this.y43_1.k3();
}
function RedirectDamageToDreamerStatement$_anonymous__3p47te() {
  var tmp = RedirectDamageToDreamerStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RedirectDamageToDreamerStatement', tmp, tmp$ret$0);
}
var RedirectDamageToDreamerStatement_instance;
function RedirectDamageToDreamerStatement_getInstance() {
  if (RedirectDamageToDreamerStatement_instance === VOID)
    new RedirectDamageToDreamerStatement();
  return RedirectDamageToDreamerStatement_instance;
}
function SacrificeToPlayDoubleDarkStatement$Companion$$childSerializers$_anonymous__69lnm() {
  return Companion_instance_148.a2g();
}
var Companion_instance_170;
function Companion_getInstance_171() {
  if (Companion_instance_170 === VOID)
    new Companion_170();
  return Companion_instance_170;
}
var $serializer_instance_147;
function $serializer_getInstance_147() {
  if ($serializer_instance_147 === VOID)
    new $serializer_147();
  return $serializer_instance_147;
}
var Companion_instance_171;
function Companion_getInstance_172() {
  return Companion_instance_171;
}
var $serializer_instance_148;
function $serializer_getInstance_148() {
  if ($serializer_instance_148 === VOID)
    new $serializer_148();
  return $serializer_instance_148;
}
function set_isRebornImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_FeatheredKing_kt__d8giih();
  gsiCtx.j39(_this__u8e3s4.r2w_1, get_featheredKingWasRebornKey(), new BooleanWrapper(value), new BooleanWrapper(false));
}
var properties_initialized_FeatheredKing_kt_pvb1mx;
function _init_properties_FeatheredKing_kt__d8giih() {
  if (!properties_initialized_FeatheredKing_kt_pvb1mx) {
    properties_initialized_FeatheredKing_kt_pvb1mx = true;
    featheredKingWasRebornKey = _GeneralMapKey___init__impl__zdmbea('featheredKingWasReborn');
  }
}
function get_primaryLocations() {
  _init_properties_GameMap_kt__rizqqw();
  return primaryLocations;
}
var primaryLocations;
var Zone_Barum_instance;
var Zone_Vildmark_instance;
var Zone_NewElda_instance;
var Zone_Jarlland_instance;
var Zone_Thealis_instance;
var Zone_Achur_instance;
var Zone_Elysur_instance;
var Zone_Myrna_instance;
function values_1() {
  return [Zone_Barum_getInstance(), Zone_Vildmark_getInstance(), Zone_NewElda_getInstance(), Zone_Jarlland_getInstance(), Zone_Thealis_getInstance(), Zone_Achur_getInstance(), Zone_Elysur_getInstance(), Zone_Myrna_getInstance()];
}
var Zone_entriesInitialized;
function Zone_initEntries() {
  if (Zone_entriesInitialized)
    return Unit_instance;
  Zone_entriesInitialized = true;
  Zone_Barum_instance = new Zone('Barum', 0);
  Zone_Vildmark_instance = new Zone('Vildmark', 1);
  Zone_NewElda_instance = new Zone('NewElda', 2);
  Zone_Jarlland_instance = new Zone('Jarlland', 3);
  Zone_Thealis_instance = new Zone('Thealis', 4);
  Zone_Achur_instance = new Zone('Achur', 5);
  Zone_Elysur_instance = new Zone('Elysur', 6);
  Zone_Myrna_instance = new Zone('Myrna', 7);
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk() {
  return createSimpleEnumSerializer('steelart.beast.GameMapId', values_3());
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_0() {
  return new LinkedHashSetSerializer(createSimpleEnumSerializer('steelart.beast.Zone', values_1()));
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_1() {
  return new LinkedHashMapSerializer($serializer_getInstance_100(), $serializer_getInstance_150());
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_2() {
  return new LinkedHashMapSerializer($serializer_getInstance_151(), $serializer_getInstance_151());
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_3() {
  return new LinkedHashSetSerializer(new LinkedHashSetSerializer($serializer_getInstance_100()));
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_4() {
  return new LinkedHashMapSerializer($serializer_getInstance_100(), createSimpleEnumSerializer('steelart.beast.Zone', values_1()));
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_5() {
  return new LinkedHashMapSerializer($serializer_getInstance_151(), $serializer_getInstance_151());
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_6() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_7() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
function GameMapImpl$Companion$$childSerializers$_anonymous__tqzzfk_8() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_172;
function Companion_getInstance_173() {
  if (Companion_instance_172 === VOID)
    new Companion_172();
  return Companion_instance_172;
}
var $serializer_instance_149;
function $serializer_getInstance_149() {
  if ($serializer_instance_149 === VOID)
    new $serializer_149();
  return $serializer_instance_149;
}
function LocationInit$Companion$$childSerializers$_anonymous__66pi2t() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
function LocationInit$Companion$$childSerializers$_anonymous__66pi2t_0() {
  return new ArrayListSerializer(Companion_instance_423.a2g());
}
var Companion_instance_173;
function Companion_getInstance_174() {
  if (Companion_instance_173 === VOID)
    new Companion_173();
  return Companion_instance_173;
}
var $serializer_instance_150;
function $serializer_getInstance_150() {
  if ($serializer_instance_150 === VOID)
    new $serializer_150();
  return $serializer_instance_150;
}
var LocationType_Settlement_instance;
var LocationType_Swamp_instance;
var LocationType_Forest_instance;
var LocationType_Cave_instance;
var LocationType_AbyssalSwamp_instance;
var LocationType_AbyssalForest_instance;
var LocationType_AbyssalCave_instance;
var LocationType_LivingWeb_instance;
var LocationType_CaveAndForest_instance;
var LocationType_SwampAndForest_instance;
var LocationType_SwampAndCave_instance;
var LocationType_LairOfTheBeast_instance;
var LocationType_None_instance;
function values_2() {
  return [LocationType_Settlement_getInstance(), LocationType_Swamp_getInstance(), LocationType_Forest_getInstance(), LocationType_Cave_getInstance(), LocationType_AbyssalSwamp_getInstance(), LocationType_AbyssalForest_getInstance(), LocationType_AbyssalCave_getInstance(), LocationType_LivingWeb_getInstance(), LocationType_CaveAndForest_getInstance(), LocationType_SwampAndForest_getInstance(), LocationType_SwampAndCave_getInstance(), LocationType_LairOfTheBeast_getInstance(), LocationType_None_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_2());
  return $ENTRIES;
}
var LocationType_entriesInitialized;
function LocationType_initEntries() {
  if (LocationType_entriesInitialized)
    return Unit_instance;
  LocationType_entriesInitialized = true;
  LocationType_Settlement_instance = new LocationType$Settlement();
  LocationType_Swamp_instance = new LocationType$Swamp();
  LocationType_Forest_instance = new LocationType$Forest();
  LocationType_Cave_instance = new LocationType$Cave();
  LocationType_AbyssalSwamp_instance = new LocationType$AbyssalSwamp();
  LocationType_AbyssalForest_instance = new LocationType$AbyssalForest();
  LocationType_AbyssalCave_instance = new LocationType$AbyssalCave();
  LocationType_LivingWeb_instance = new LocationType$LivingWeb();
  LocationType_CaveAndForest_instance = new LocationType$CaveAndForest();
  LocationType_SwampAndForest_instance = new LocationType$SwampAndForest();
  LocationType_SwampAndCave_instance = new LocationType$SwampAndCave();
  LocationType_LairOfTheBeast_instance = new LocationType$LairOfTheBeast();
  LocationType_None_instance = new LocationType$None();
}
var $ENTRIES;
var GameMapId_NorthernExpanse_instance;
var GameMapId_DrenchedLands_instance;
var GameMapId_UpperShatteredIsles_instance;
var GameMapId_LowerShatteredIsles_instance;
function values_3() {
  return [GameMapId_NorthernExpanse_getInstance(), GameMapId_DrenchedLands_getInstance(), GameMapId_UpperShatteredIsles_getInstance(), GameMapId_LowerShatteredIsles_getInstance()];
}
var GameMapId_entriesInitialized;
function GameMapId_initEntries() {
  if (GameMapId_entriesInitialized)
    return Unit_instance;
  GameMapId_entriesInitialized = true;
  GameMapId_NorthernExpanse_instance = new GameMapId('NorthernExpanse', 0);
  GameMapId_DrenchedLands_instance = new GameMapId('DrenchedLands', 1);
  GameMapId_UpperShatteredIsles_instance = new GameMapId('UpperShatteredIsles', 2);
  GameMapId_LowerShatteredIsles_instance = new GameMapId('LowerShatteredIsles', 3);
}
var Companion_instance_174;
function Companion_getInstance_175() {
  return Companion_instance_174;
}
var $serializer_instance_151;
function $serializer_getInstance_151() {
  if ($serializer_instance_151 === VOID)
    new $serializer_151();
  return $serializer_instance_151;
}
function positionsUpToDistance($context_GameState_t6qee5, _this__u8e3s4, distance) {
  _init_properties_GameMap_kt__rizqqw();
  return positionsUpToDistance_0($context_GameState_t6qee5, _this__u8e3s4.s2w($context_GameState_t6qee5), distance, _this__u8e3s4.l32($context_GameState_t6qee5));
}
function get_nearbyPositions($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_GameMap_kt__rizqqw();
  return positionsUpToDistance_0($context_GameState_t6qee5, _this__u8e3s4.s2w($context_GameState_t6qee5), 1, _this__u8e3s4.l32($context_GameState_t6qee5));
}
function direction(_this__u8e3s4, from, to) {
  _init_properties_GameMap_kt__rizqqw();
  var tmp0 = Companion_getInstance_114().j3l_1;
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.singleOrNull' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp = _this__u8e3s4.h47().c45(from, element, true);
      if (equals(tmp == null ? null : new BoardPosition(tmp), new BoardPosition(to))) {
        if (found) {
          tmp$ret$0 = null;
          break $l$block_0;
        }
        single = element;
        found = true;
      }
    }
    if (!found) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    tmp$ret$0 = single;
  }
  return tmp$ret$0;
}
function toLocationsInitMap(topLeft, bottomRight, mapField) {
  _init_properties_GameMap_kt__rizqqw();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var locationsInit = LinkedHashMap.m7();
  var i = 0;
  var inductionVariable = _BoardPosition___get_y__impl__tale2e(topLeft);
  var last = _BoardPosition___get_y__impl__tale2e(bottomRight);
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = _BoardPosition___get_x__impl__gyx07(topLeft);
      var last_0 = _BoardPosition___get_x__impl__gyx07(bottomRight);
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var locationInit = mapField.u2(i);
          if (!(locationInit == null)) {
            // Inline function 'kotlin.collections.set' call
            var key = new BoardPosition(_BoardPosition___init__impl__1nizgq_0(x, y));
            locationsInit.b5(key, locationInit);
          }
          i = i + 1 | 0;
        }
         while (!(x === last_0));
    }
     while (!(y === last));
  return locationsInit;
}
function newConnectionsToNonStandard(newConnections) {
  _init_properties_GameMap_kt__rizqqw();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var nonStandardConnections = LinkedHashMap.m7();
  var _iterator__ex2g4s = newConnections.p1();
  while (_iterator__ex2g4s.q1()) {
    var newConnection = _iterator__ex2g4s.r1();
    var inductionVariable = 0;
    if (inductionVariable < 2)
      do {
        var current = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var another = (current + 1 | 0) % 2 | 0;
        var tmp2 = newConnection[current];
        // Inline function 'kotlin.collections.set' call
        var value = newConnection[another];
        nonStandardConnections.b5(tmp2, value);
      }
       while (inductionVariable < 2);
  }
  return nonStandardConnections;
}
function get_filterMayBeTransformed($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_GameMap_kt__rizqqw();
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var it = element.r2v_1;
    if (get_gameRules($context_GameState_t6qee5).t3a($context_GameState_t6qee5, it)) {
      destination.d2(element);
    }
  }
  return destination;
}
function positionsUpToDistance_0($context_GameState_t6qee5, position, distance, locationType) {
  _init_properties_GameMap_kt__rizqqw();
  if (distance === 0) {
    return setOf(new BoardPosition(position));
  }
  var result = mutableSetOf([new BoardPosition(position)]);
  var newPositions = result;
  var inductionVariable = 1;
  if (inductionVariable <= distance)
    do {
      var d = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mutableSetOf' call
      var add = LinkedHashSet.v2();
      var _iterator__ex2g4s = newPositions.p1();
      while (_iterator__ex2g4s.q1()) {
        var newPosition = _iterator__ex2g4s.r1().r2v_1;
        add.t2(adjacentPositions($context_GameState_t6qee5, newPosition, locationType));
      }
      result.t2(add);
      newPositions = add;
    }
     while (!(d === distance));
  return result;
}
function adjacentPositions($context_GameState_t6qee5, position, locationType) {
  _init_properties_GameMap_kt__rizqqw();
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = Companion_getInstance_114().j3l_1;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp = nearLocationPosition($context_GameState_t6qee5, position, element, locationType);
    var tmp0_safe_receiver = tmp == null ? null : new BoardPosition(tmp);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return toSet(destination);
}
function nearLocationPosition($context_GameState_t6qee5, position, direction, locationType) {
  _init_properties_GameMap_kt__rizqqw();
  return get_gameRules($context_GameState_t6qee5).d3b($context_GameState_t6qee5, position, direction, locationType);
}
function anyAdjacentPositions(_this__u8e3s4, position) {
  _init_properties_GameMap_kt__rizqqw();
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = Companion_getInstance_114().j3l_1;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp = _this__u8e3s4.c45(position, element, true);
    var tmp0_safe_receiver = tmp == null ? null : new BoardPosition(tmp);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return toSet(destination);
}
function forBeast($context_GameState_t6qee5, _this__u8e3s4, beast) {
  _init_properties_GameMap_kt__rizqqw();
  return new StaticNearbyAdjuster(_this__u8e3s4, beast.l32($context_GameState_t6qee5));
}
function Zone_Barum_getInstance() {
  Zone_initEntries();
  return Zone_Barum_instance;
}
function Zone_Vildmark_getInstance() {
  Zone_initEntries();
  return Zone_Vildmark_instance;
}
function Zone_NewElda_getInstance() {
  Zone_initEntries();
  return Zone_NewElda_instance;
}
function Zone_Jarlland_getInstance() {
  Zone_initEntries();
  return Zone_Jarlland_instance;
}
function Zone_Thealis_getInstance() {
  Zone_initEntries();
  return Zone_Thealis_instance;
}
function Zone_Achur_getInstance() {
  Zone_initEntries();
  return Zone_Achur_instance;
}
function Zone_Elysur_getInstance() {
  Zone_initEntries();
  return Zone_Elysur_instance;
}
function Zone_Myrna_getInstance() {
  Zone_initEntries();
  return Zone_Myrna_instance;
}
function LocationType_Settlement_getInstance() {
  LocationType_initEntries();
  return LocationType_Settlement_instance;
}
function LocationType_Swamp_getInstance() {
  LocationType_initEntries();
  return LocationType_Swamp_instance;
}
function LocationType_Forest_getInstance() {
  LocationType_initEntries();
  return LocationType_Forest_instance;
}
function LocationType_Cave_getInstance() {
  LocationType_initEntries();
  return LocationType_Cave_instance;
}
function LocationType_AbyssalSwamp_getInstance() {
  LocationType_initEntries();
  return LocationType_AbyssalSwamp_instance;
}
function LocationType_AbyssalForest_getInstance() {
  LocationType_initEntries();
  return LocationType_AbyssalForest_instance;
}
function LocationType_AbyssalCave_getInstance() {
  LocationType_initEntries();
  return LocationType_AbyssalCave_instance;
}
function LocationType_LivingWeb_getInstance() {
  LocationType_initEntries();
  return LocationType_LivingWeb_instance;
}
function LocationType_CaveAndForest_getInstance() {
  LocationType_initEntries();
  return LocationType_CaveAndForest_instance;
}
function LocationType_SwampAndForest_getInstance() {
  LocationType_initEntries();
  return LocationType_SwampAndForest_instance;
}
function LocationType_SwampAndCave_getInstance() {
  LocationType_initEntries();
  return LocationType_SwampAndCave_instance;
}
function LocationType_LairOfTheBeast_getInstance() {
  LocationType_initEntries();
  return LocationType_LairOfTheBeast_instance;
}
function LocationType_None_getInstance() {
  LocationType_initEntries();
  return LocationType_None_instance;
}
function GameMapId_NorthernExpanse_getInstance() {
  GameMapId_initEntries();
  return GameMapId_NorthernExpanse_instance;
}
function GameMapId_DrenchedLands_getInstance() {
  GameMapId_initEntries();
  return GameMapId_DrenchedLands_instance;
}
function GameMapId_UpperShatteredIsles_getInstance() {
  GameMapId_initEntries();
  return GameMapId_UpperShatteredIsles_instance;
}
function GameMapId_LowerShatteredIsles_getInstance() {
  GameMapId_initEntries();
  return GameMapId_LowerShatteredIsles_instance;
}
var properties_initialized_GameMap_kt_8lvwl6;
function _init_properties_GameMap_kt__rizqqw() {
  if (!properties_initialized_GameMap_kt_8lvwl6) {
    properties_initialized_GameMap_kt_8lvwl6 = true;
    primaryLocations = listOf_0([LocationType_Settlement_getInstance(), LocationType_Swamp_getInstance(), LocationType_Forest_getInstance(), LocationType_Cave_getInstance()]);
  }
}
var Companion_instance_175;
function Companion_getInstance_176() {
  return Companion_instance_175;
}
var Companion_instance_176;
function Companion_getInstance_177() {
  return Companion_instance_176;
}
var $serializer_instance_152;
function $serializer_getInstance_152() {
  if ($serializer_instance_152 === VOID)
    new $serializer_152();
  return $serializer_instance_152;
}
function BeastMovementCardQuestion$Companion$$childSerializers$_anonymous__umuinu() {
  return new LinkedHashSetSerializer($serializer_getInstance_172());
}
function BeastMovementCardQuestion$Companion$$childSerializers$_anonymous__umuinu_0() {
  return Companion_instance_197.a2g();
}
var Companion_instance_177;
function Companion_getInstance_178() {
  if (Companion_instance_177 === VOID)
    new Companion_177();
  return Companion_instance_177;
}
var $serializer_instance_153;
function $serializer_getInstance_153() {
  if ($serializer_instance_153 === VOID)
    new $serializer_153();
  return $serializer_instance_153;
}
function _get_$cachedSerializer__te6jhj_207($this) {
  return $this.w47_1.k3();
}
function PlayOverloadedQuestion$_anonymous__uokst8() {
  var tmp = PlayOverloadedQuestion_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PlayOverloadedQuestion', tmp, tmp$ret$0);
}
var PlayOverloadedQuestion_instance;
function PlayOverloadedQuestion_getInstance() {
  if (PlayOverloadedQuestion_instance === VOID)
    new PlayOverloadedQuestion();
  return PlayOverloadedQuestion_instance;
}
function _get_$cachedSerializer__te6jhj_208($this) {
  return $this.x47_1.k3();
}
function RevealToMoveQuestion$_anonymous__dh7t1k() {
  var tmp = RevealToMoveQuestion_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RevealToMoveQuestion', tmp, tmp$ret$0);
}
var RevealToMoveQuestion_instance;
function RevealToMoveQuestion_getInstance() {
  if (RevealToMoveQuestion_instance === VOID)
    new RevealToMoveQuestion();
  return RevealToMoveQuestion_instance;
}
var Companion_instance_178;
function Companion_getInstance_179() {
  return Companion_instance_178;
}
var $serializer_instance_154;
function $serializer_getInstance_154() {
  if ($serializer_instance_154 === VOID)
    new $serializer_154();
  return $serializer_instance_154;
}
function _get_$cachedSerializer__te6jhj_209($this) {
  return $this.c48_1.k3();
}
function CardPlayColorQuestion$_anonymous__jlung2() {
  var tmp = CardPlayColorQuestion_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CardPlayColorQuestion', tmp, tmp$ret$0);
}
var CardPlayColorQuestion_instance;
function CardPlayColorQuestion_getInstance() {
  if (CardPlayColorQuestion_instance === VOID)
    new CardPlayColorQuestion();
  return CardPlayColorQuestion_instance;
}
function ChooseCardOnDraftQuestion$Companion$$childSerializers$_anonymous__yd84yx() {
  return new LinkedHashSetSerializer(Companion_instance_442.a2g());
}
var Companion_instance_179;
function Companion_getInstance_180() {
  if (Companion_instance_179 === VOID)
    new Companion_179();
  return Companion_instance_179;
}
var $serializer_instance_155;
function $serializer_getInstance_155() {
  if ($serializer_instance_155 === VOID)
    new $serializer_155();
  return $serializer_instance_155;
}
function ChooseCardsQuestion$Companion$$childSerializers$_anonymous__c4ninc() {
  return new LinkedHashSetSerializer(Companion_instance_442.a2g());
}
function ChooseCardsQuestion$Companion$$childSerializers$_anonymous__c4ninc_0() {
  return Companion_instance_200.a2g();
}
var Companion_instance_180;
function Companion_getInstance_181() {
  if (Companion_instance_180 === VOID)
    new Companion_180();
  return Companion_instance_180;
}
var $serializer_instance_156;
function $serializer_getInstance_156() {
  if ($serializer_instance_156 === VOID)
    new $serializer_156();
  return $serializer_instance_156;
}
function ChooseCharacterQuestion$Companion$$childSerializers$_anonymous__rg1w8e() {
  return new LinkedHashSetSerializer(Companion_instance_128.a2g());
}
var Companion_instance_181;
function Companion_getInstance_182() {
  if (Companion_instance_181 === VOID)
    new Companion_181();
  return Companion_instance_181;
}
var $serializer_instance_157;
function $serializer_getInstance_157() {
  if ($serializer_instance_157 === VOID)
    new $serializer_157();
  return $serializer_instance_157;
}
function _get_$cachedSerializer__te6jhj_210($this) {
  return $this.t48_1.k3();
}
function ContinueAfterRecoveryQuestion$_anonymous__vcbvd() {
  var tmp = ContinueAfterRecoveryQuestion_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp, tmp$ret$0);
}
var ContinueAfterRecoveryQuestion_instance;
function ContinueAfterRecoveryQuestion_getInstance() {
  if (ContinueAfterRecoveryQuestion_instance === VOID)
    new ContinueAfterRecoveryQuestion();
  return ContinueAfterRecoveryQuestion_instance;
}
function DestinationQuestion$Companion$$childSerializers$_anonymous__xe82wa() {
  return new LinkedHashSetSerializer($serializer_getInstance_102());
}
function DestinationQuestion$Companion$$childSerializers$_anonymous__xe82wa_0() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function DestinationQuestion$Companion$$childSerializers$_anonymous__xe82wa_1() {
  return new ArrayListSerializer($serializer_getInstance_100());
}
var Companion_instance_182;
function Companion_getInstance_183() {
  if (Companion_instance_182 === VOID)
    new Companion_182();
  return Companion_instance_182;
}
var $serializer_instance_158;
function $serializer_getInstance_158() {
  if ($serializer_instance_158 === VOID)
    new $serializer_158();
  return $serializer_instance_158;
}
function GrapnelQuestion$Companion$$childSerializers$_anonymous__66h09j() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_183;
function Companion_getInstance_184() {
  if (Companion_instance_183 === VOID)
    new Companion_183();
  return Companion_instance_183;
}
var $serializer_instance_159;
function $serializer_getInstance_159() {
  if ($serializer_instance_159 === VOID)
    new $serializer_159();
  return $serializer_instance_159;
}
function LocationQuestion$Companion$$childSerializers$_anonymous__esqxld() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
function LocationQuestion$Companion$$childSerializers$_anonymous__esqxld_0() {
  return Companion_instance_202.a2g();
}
var Companion_instance_184;
function Companion_getInstance_185() {
  if (Companion_instance_184 === VOID)
    new Companion_184();
  return Companion_instance_184;
}
var $serializer_instance_160;
function $serializer_getInstance_160() {
  if ($serializer_instance_160 === VOID)
    new $serializer_160();
  return $serializer_instance_160;
}
function PlaceNewObjectQuestion$Companion$$childSerializers$_anonymous__jk1a3w() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
function PlaceNewObjectQuestion$Companion$$childSerializers$_anonymous__jk1a3w_0() {
  return Companion_instance_420.a2g();
}
var Companion_instance_185;
function Companion_getInstance_186() {
  if (Companion_instance_185 === VOID)
    new Companion_185();
  return Companion_instance_185;
}
var $serializer_instance_161;
function $serializer_getInstance_161() {
  if ($serializer_instance_161 === VOID)
    new $serializer_161();
  return $serializer_instance_161;
}
function SearchLocationQuestion$Companion$$childSerializers$_anonymous__mt5aop() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_186;
function Companion_getInstance_187() {
  if (Companion_instance_186 === VOID)
    new Companion_186();
  return Companion_instance_186;
}
var $serializer_instance_162;
function $serializer_getInstance_162() {
  if ($serializer_instance_162 === VOID)
    new $serializer_162();
  return $serializer_instance_162;
}
function TransformLocationQuestion$Companion$$childSerializers$_anonymous__a36kf1() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_187;
function Companion_getInstance_188() {
  if (Companion_instance_187 === VOID)
    new Companion_187();
  return Companion_instance_187;
}
var $serializer_instance_163;
function $serializer_getInstance_163() {
  if ($serializer_instance_163 === VOID)
    new $serializer_163();
  return $serializer_instance_163;
}
function LocationTypeQuestion$Companion$$childSerializers$_anonymous__34stpn() {
  return new LinkedHashSetSerializer(createSimpleEnumSerializer('steelart.beast.LocationType', values_2()));
}
var Companion_instance_188;
function Companion_getInstance_189() {
  if (Companion_instance_188 === VOID)
    new Companion_188();
  return Companion_instance_188;
}
var $serializer_instance_164;
function $serializer_getInstance_164() {
  if ($serializer_instance_164 === VOID)
    new $serializer_164();
  return $serializer_instance_164;
}
function ObjectsGameQuestion$Companion$$childSerializers$_anonymous__myxfem() {
  return Companion_instance_203.a2g();
}
var Companion_instance_189;
function Companion_getInstance_190() {
  if (Companion_instance_189 === VOID)
    new Companion_189();
  return Companion_instance_189;
}
function PhaseRecoveryQuestion$Companion$$childSerializers$_anonymous__psknck() {
  return new LinkedHashSetSerializer(Companion_instance_225.a2g());
}
var Companion_instance_190;
function Companion_getInstance_191() {
  if (Companion_instance_190 === VOID)
    new Companion_190();
  return Companion_instance_190;
}
var $serializer_instance_165;
function $serializer_getInstance_165() {
  if ($serializer_instance_165 === VOID)
    new $serializer_166();
  return $serializer_instance_165;
}
function PlayCardInTurnQuestion$Companion$$childSerializers$_anonymous__m6osim() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function PlayCardInTurnQuestion$Companion$$childSerializers$_anonymous__m6osim_0() {
  return new LinkedHashSetSerializer(Companion_instance_204.a2g());
}
var Companion_instance_191;
function Companion_getInstance_192() {
  if (Companion_instance_191 === VOID)
    new Companion_191();
  return Companion_instance_191;
}
var $serializer_instance_166;
function $serializer_getInstance_166() {
  if ($serializer_instance_166 === VOID)
    new $serializer_167();
  return $serializer_instance_166;
}
function StatementQuestion$Companion$$childSerializers$_anonymous__5u48l() {
  return new LinkedHashSetSerializer(Companion_instance.a2g());
}
var Companion_instance_192;
function Companion_getInstance_193() {
  if (Companion_instance_192 === VOID)
    new Companion_192();
  return Companion_instance_192;
}
var $serializer_instance_167;
function $serializer_getInstance_167() {
  if ($serializer_instance_167 === VOID)
    new $serializer_168();
  return $serializer_instance_167;
}
var Companion_instance_193;
function Companion_getInstance_194() {
  return Companion_instance_193;
}
var $serializer_instance_168;
function $serializer_getInstance_168() {
  if ($serializer_instance_168 === VOID)
    new $serializer_169();
  return $serializer_instance_168;
}
function TriggersQuestion$Companion$$childSerializers$_anonymous__6j62s7() {
  return new LinkedHashSetSerializer($serializer_getInstance_173());
}
function TriggersQuestion$Companion$$childSerializers$_anonymous__6j62s7_0() {
  return new LinkedHashSetSerializer($serializer_getInstance_174());
}
var Companion_instance_194;
function Companion_getInstance_195() {
  if (Companion_instance_194 === VOID)
    new Companion_194();
  return Companion_instance_194;
}
var $serializer_instance_169;
function $serializer_getInstance_169() {
  if ($serializer_instance_169 === VOID)
    new $serializer_170();
  return $serializer_instance_169;
}
function UpgradeQuestion$Companion$$childSerializers$_anonymous__vz6coo() {
  return new LinkedHashSetSerializer(Companion_instance_129.a2g());
}
function UpgradeQuestion$Companion$$childSerializers$_anonymous__vz6coo_0() {
  return Companion_instance_207.a2g();
}
var Companion_instance_195;
function Companion_getInstance_196() {
  if (Companion_instance_195 === VOID)
    new Companion_195();
  return Companion_instance_195;
}
var $serializer_instance_170;
function $serializer_getInstance_170() {
  if ($serializer_instance_170 === VOID)
    new $serializer_171();
  return $serializer_instance_170;
}
function ZoneQuestion$Companion$$childSerializers$_anonymous__mme0zs() {
  return new LinkedHashSetSerializer(createSimpleEnumSerializer('steelart.beast.Zone', values_1()));
}
var Companion_instance_196;
function Companion_getInstance_197() {
  if (Companion_instance_196 === VOID)
    new Companion_196();
  return Companion_instance_196;
}
var $serializer_instance_171;
function $serializer_getInstance_171() {
  if ($serializer_instance_171 === VOID)
    new $serializer_172();
  return $serializer_instance_171;
}
var Companion_instance_197;
function Companion_getInstance_198() {
  return Companion_instance_197;
}
function BeastMovementCardVariant$Companion$$childSerializers$_anonymous__ee5na5() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_198;
function Companion_getInstance_199() {
  if (Companion_instance_198 === VOID)
    new Companion_198();
  return Companion_instance_198;
}
var $serializer_instance_172;
function $serializer_getInstance_172() {
  if ($serializer_instance_172 === VOID)
    new $serializer_173();
  return $serializer_instance_172;
}
function _get_$cachedSerializer__te6jhj_211($this) {
  return $this.g4c_1.k3();
}
function BeastMovementCardQuestionContext$_anonymous__5lowbw() {
  var tmp = BeastMovementCardQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeastMovementCardQuestionContext', tmp, tmp$ret$0);
}
var BeastMovementCardQuestionContext_instance;
function BeastMovementCardQuestionContext_getInstance() {
  if (BeastMovementCardQuestionContext_instance === VOID)
    new BeastMovementCardQuestionContext();
  return BeastMovementCardQuestionContext_instance;
}
var Companion_instance_199;
function Companion_getInstance_200() {
  return Companion_instance_199;
}
var Companion_instance_200;
function Companion_getInstance_201() {
  return Companion_instance_200;
}
var Companion_instance_201;
function Companion_getInstance_202() {
  return Companion_instance_201;
}
var Companion_instance_202;
function Companion_getInstance_203() {
  return Companion_instance_202;
}
var Companion_instance_203;
function Companion_getInstance_204() {
  return Companion_instance_203;
}
var Companion_instance_204;
function Companion_getInstance_205() {
  return Companion_instance_204;
}
function TriggerOption$Companion$$childSerializers$_anonymous__aop2ar() {
  return Companion_instance_154.a2g();
}
function TriggerOption$Companion$$childSerializers$_anonymous__aop2ar_0() {
  return Companion_instance.a2g();
}
function TriggerOption$Companion$$childSerializers$_anonymous__aop2ar_1() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function TriggerOption$Companion$$childSerializers$_anonymous__aop2ar_2() {
  return Companion_instance_213.a2g();
}
var Companion_instance_205;
function Companion_getInstance_206() {
  if (Companion_instance_205 === VOID)
    new Companion_205();
  return Companion_instance_205;
}
var $serializer_instance_173;
function $serializer_getInstance_173() {
  if ($serializer_instance_173 === VOID)
    new $serializer_174();
  return $serializer_instance_173;
}
function TheoreticalTrigger$Companion$$childSerializers$_anonymous__d5c9sq() {
  return Companion_instance_154.a2g();
}
function TheoreticalTrigger$Companion$$childSerializers$_anonymous__d5c9sq_0() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_206;
function Companion_getInstance_207() {
  if (Companion_instance_206 === VOID)
    new Companion_206();
  return Companion_instance_206;
}
var $serializer_instance_174;
function $serializer_getInstance_174() {
  if ($serializer_instance_174 === VOID)
    new $serializer_175();
  return $serializer_instance_174;
}
var Companion_instance_207;
function Companion_getInstance_208() {
  return Companion_instance_207;
}
function _get_$cachedSerializer__te6jhj_212($this) {
  return $this.v4c_1.k3();
}
function ArsenalCardToGainQuestionContext$_anonymous__25w4r6() {
  var tmp = ArsenalCardToGainQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ArsenalCardToGainQuestionContext', tmp, tmp$ret$0);
}
var ArsenalCardToGainQuestionContext_instance;
function ArsenalCardToGainQuestionContext_getInstance() {
  if (ArsenalCardToGainQuestionContext_instance === VOID)
    new ArsenalCardToGainQuestionContext();
  return ArsenalCardToGainQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_213($this) {
  return $this.w4c_1.k3();
}
function BeastlyTalentToPlayQuestionContext$_anonymous__o3p7jf() {
  var tmp = BeastlyTalentToPlayQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeastlyTalentToPlayQuestionContext', tmp, tmp$ret$0);
}
var BeastlyTalentToPlayQuestionContext_instance;
function BeastlyTalentToPlayQuestionContext_getInstance() {
  if (BeastlyTalentToPlayQuestionContext_instance === VOID)
    new BeastlyTalentToPlayQuestionContext();
  return BeastlyTalentToPlayQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_214($this) {
  return $this.x4c_1.k3();
}
function CardToDiscardQuestionContext$_anonymous__9w2in5() {
  var tmp = CardToDiscardQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CardToDiscardQuestionContext', tmp, tmp$ret$0);
}
var CardToDiscardQuestionContext_instance;
function CardToDiscardQuestionContext_getInstance() {
  if (CardToDiscardQuestionContext_instance === VOID)
    new CardToDiscardQuestionContext();
  return CardToDiscardQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_215($this) {
  return $this.y4c_1.k3();
}
function DiscardedAbilityCardToRetrieveQuestionContext$_anonymous__10zrtq() {
  var tmp = DiscardedAbilityCardToRetrieveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DiscardedAbilityCardToRetrieveQuestionContext', tmp, tmp$ret$0);
}
var DiscardedAbilityCardToRetrieveQuestionContext_instance;
function DiscardedAbilityCardToRetrieveQuestionContext_getInstance() {
  if (DiscardedAbilityCardToRetrieveQuestionContext_instance === VOID)
    new DiscardedAbilityCardToRetrieveQuestionContext();
  return DiscardedAbilityCardToRetrieveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_216($this) {
  return $this.z4c_1.k3();
}
function DiscardedDraftActionCardToRetrieveQuestionContext$_anonymous__ymvqgh() {
  var tmp = DiscardedDraftActionCardToRetrieveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DiscardedDraftActionCardToRetrieveQuestionContext', tmp, tmp$ret$0);
}
var DiscardedDraftActionCardToRetrieveQuestionContext_instance;
function DiscardedDraftActionCardToRetrieveQuestionContext_getInstance() {
  if (DiscardedDraftActionCardToRetrieveQuestionContext_instance === VOID)
    new DiscardedDraftActionCardToRetrieveQuestionContext();
  return DiscardedDraftActionCardToRetrieveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_217($this) {
  return $this.a4d_1.k3();
}
function HunterItemToPlayQuestionContext$_anonymous__g2p3bk() {
  var tmp = HunterItemToPlayQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterItemToPlayQuestionContext', tmp, tmp$ret$0);
}
var HunterItemToPlayQuestionContext_instance;
function HunterItemToPlayQuestionContext_getInstance() {
  if (HunterItemToPlayQuestionContext_instance === VOID)
    new HunterItemToPlayQuestionContext();
  return HunterItemToPlayQuestionContext_instance;
}
var Companion_instance_208;
function Companion_getInstance_209() {
  return Companion_instance_208;
}
var $serializer_instance_175;
function $serializer_getInstance_175() {
  if ($serializer_instance_175 === VOID)
    new $serializer_176();
  return $serializer_instance_175;
}
function _get_$cachedSerializer__te6jhj_218($this) {
  return $this.f4d_1.k3();
}
function UnusedDraftActionCardToRetrieveQuestionContext$_anonymous__qs0jue() {
  var tmp = UnusedDraftActionCardToRetrieveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UnusedDraftActionCardToRetrieveQuestionContext', tmp, tmp$ret$0);
}
var UnusedDraftActionCardToRetrieveQuestionContext_instance;
function UnusedDraftActionCardToRetrieveQuestionContext_getInstance() {
  if (UnusedDraftActionCardToRetrieveQuestionContext_instance === VOID)
    new UnusedDraftActionCardToRetrieveQuestionContext();
  return UnusedDraftActionCardToRetrieveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_219($this) {
  return $this.g4d_1.k3();
}
function AshRuinLocationQuestionContext$_anonymous__4sjren() {
  var tmp = AshRuinLocationQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AshRuinLocationQuestionContext', tmp, tmp$ret$0);
}
var AshRuinLocationQuestionContext_instance;
function AshRuinLocationQuestionContext_getInstance() {
  if (AshRuinLocationQuestionContext_instance === VOID)
    new AshRuinLocationQuestionContext();
  return AshRuinLocationQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_220($this) {
  return $this.h4d_1.k3();
}
function AnimalToMoveQuestionContext$_anonymous__w3vv3e() {
  var tmp = AnimalToMoveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AnimalToMoveQuestionContext', tmp, tmp$ret$0);
}
var AnimalToMoveQuestionContext_instance;
function AnimalToMoveQuestionContext_getInstance() {
  if (AnimalToMoveQuestionContext_instance === VOID)
    new AnimalToMoveQuestionContext();
  return AnimalToMoveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_221($this) {
  return $this.i4d_1.k3();
}
function AttackTargetQuestionContext$_anonymous__rgn04n() {
  var tmp = AttackTargetQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AttackTargetQuestionContext', tmp, tmp$ret$0);
}
var AttackTargetQuestionContext_instance;
function AttackTargetQuestionContext_getInstance() {
  if (AttackTargetQuestionContext_instance === VOID)
    new AttackTargetQuestionContext();
  return AttackTargetQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_222($this) {
  return $this.j4d_1.k3();
}
function BeastToGainBeastlyTalentQuestionContext$_anonymous__p859fx() {
  var tmp = BeastToGainBeastlyTalentQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeastToGainBeastlyTalentQuestionContext', tmp, tmp$ret$0);
}
var BeastToGainBeastlyTalentQuestionContext_instance;
function BeastToGainBeastlyTalentQuestionContext_getInstance() {
  if (BeastToGainBeastlyTalentQuestionContext_instance === VOID)
    new BeastToGainBeastlyTalentQuestionContext();
  return BeastToGainBeastlyTalentQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_223($this) {
  return $this.k4d_1.k3();
}
function BeastToPerformEffectQuestionContext$_anonymous__5xo8q() {
  var tmp = BeastToPerformEffectQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeastToPerformEffectQuestionContext', tmp, tmp$ret$0);
}
var BeastToPerformEffectQuestionContext_instance;
function BeastToPerformEffectQuestionContext_getInstance() {
  if (BeastToPerformEffectQuestionContext_instance === VOID)
    new BeastToPerformEffectQuestionContext();
  return BeastToPerformEffectQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_224($this) {
  return $this.l4d_1.k3();
}
function BeingRelocatingByGrapnelQuestionContext$_anonymous__mmivm7() {
  var tmp = BeingRelocatingByGrapnelQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeingRelocatingByGrapnelQuestionContext', tmp, tmp$ret$0);
}
var BeingRelocatingByGrapnelQuestionContext_instance;
function BeingRelocatingByGrapnelQuestionContext_getInstance() {
  if (BeingRelocatingByGrapnelQuestionContext_instance === VOID)
    new BeingRelocatingByGrapnelQuestionContext();
  return BeingRelocatingByGrapnelQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_225($this) {
  return $this.m4d_1.k3();
}
function BeingToMoveAlongsideQuestionContext$_anonymous__oxobx3() {
  var tmp = BeingToMoveAlongsideQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeingToMoveAlongsideQuestionContext', tmp, tmp$ret$0);
}
var BeingToMoveAlongsideQuestionContext_instance;
function BeingToMoveAlongsideQuestionContext_getInstance() {
  if (BeingToMoveAlongsideQuestionContext_instance === VOID)
    new BeingToMoveAlongsideQuestionContext();
  return BeingToMoveAlongsideQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_226($this) {
  return $this.n4d_1.k3();
}
function BeingToMoveByRuinQuestionContext$_anonymous__hs6v2w() {
  var tmp = BeingToMoveByRuinQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeingToMoveByRuinQuestionContext', tmp, tmp$ret$0);
}
var BeingToMoveByRuinQuestionContext_instance;
function BeingToMoveByRuinQuestionContext_getInstance() {
  if (BeingToMoveByRuinQuestionContext_instance === VOID)
    new BeingToMoveByRuinQuestionContext();
  return BeingToMoveByRuinQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_227($this) {
  return $this.o4d_1.k3();
}
function BoarToMoveQuestionContext$_anonymous__3zd048() {
  var tmp = BoarToMoveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BoarToMoveQuestionContext', tmp, tmp$ret$0);
}
var BoarToMoveQuestionContext_instance;
function BoarToMoveQuestionContext_getInstance() {
  if (BoarToMoveQuestionContext_instance === VOID)
    new BoarToMoveQuestionContext();
  return BoarToMoveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_228($this) {
  return $this.p4d_1.k3();
}
function FarmerToNobleQuestionContext$_anonymous__wr9je2() {
  var tmp = FarmerToNobleQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FarmerToNobleQuestionContext', tmp, tmp$ret$0);
}
var FarmerToNobleQuestionContext_instance;
function FarmerToNobleQuestionContext_getInstance() {
  if (FarmerToNobleQuestionContext_instance === VOID)
    new FarmerToNobleQuestionContext();
  return FarmerToNobleQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_229($this) {
  return $this.q4d_1.k3();
}
function HandInspectTargetQuestionContext$_anonymous__9nbmck() {
  var tmp = HandInspectTargetQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HandInspectTargetQuestionContext', tmp, tmp$ret$0);
}
var HandInspectTargetQuestionContext_instance;
function HandInspectTargetQuestionContext_getInstance() {
  if (HandInspectTargetQuestionContext_instance === VOID)
    new HandInspectTargetQuestionContext();
  return HandInspectTargetQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_230($this) {
  return $this.r4d_1.k3();
}
function HunterToGiveChainGrapnelQuestionContext$_anonymous__93at1o() {
  var tmp = HunterToGiveChainGrapnelQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToGiveChainGrapnelQuestionContext', tmp, tmp$ret$0);
}
var HunterToGiveChainGrapnelQuestionContext_instance;
function HunterToGiveChainGrapnelQuestionContext_getInstance() {
  if (HunterToGiveChainGrapnelQuestionContext_instance === VOID)
    new HunterToGiveChainGrapnelQuestionContext();
  return HunterToGiveChainGrapnelQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_231($this) {
  return $this.s4d_1.k3();
}
function HunterToMesmeriseQuestionContext$_anonymous__rrpnbj() {
  var tmp = HunterToMesmeriseQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToMesmeriseQuestionContext', tmp, tmp$ret$0);
}
var HunterToMesmeriseQuestionContext_instance;
function HunterToMesmeriseQuestionContext_getInstance() {
  if (HunterToMesmeriseQuestionContext_instance === VOID)
    new HunterToMesmeriseQuestionContext();
  return HunterToMesmeriseQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_232($this) {
  return $this.t4d_1.k3();
}
function HunterToMoveQuestionContext$_anonymous__f0t6au() {
  var tmp = HunterToMoveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToMoveQuestionContext', tmp, tmp$ret$0);
}
var HunterToMoveQuestionContext_instance;
function HunterToMoveQuestionContext_getInstance() {
  if (HunterToMoveQuestionContext_instance === VOID)
    new HunterToMoveQuestionContext();
  return HunterToMoveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_233($this) {
  return $this.u4d_1.k3();
}
function HunterToPerformEffectQuestionContext$_anonymous__eljhnf() {
  var tmp = HunterToPerformEffectQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToPerformEffectQuestionContext', tmp, tmp$ret$0);
}
var HunterToPerformEffectQuestionContext_instance;
function HunterToPerformEffectQuestionContext_getInstance() {
  if (HunterToPerformEffectQuestionContext_instance === VOID)
    new HunterToPerformEffectQuestionContext();
  return HunterToPerformEffectQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_234($this) {
  return $this.v4d_1.k3();
}
function HunterToRelocateQuestionContext$_anonymous__c2dff2() {
  var tmp = HunterToRelocateQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToRelocateQuestionContext', tmp, tmp$ret$0);
}
var HunterToRelocateQuestionContext_instance;
function HunterToRelocateQuestionContext_getInstance() {
  if (HunterToRelocateQuestionContext_instance === VOID)
    new HunterToRelocateQuestionContext();
  return HunterToRelocateQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_235($this) {
  return $this.w4d_1.k3();
}
function HunterToResolveRuinQuestionContext$_anonymous__huz2yv() {
  var tmp = HunterToResolveRuinQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToResolveRuinQuestionContext', tmp, tmp$ret$0);
}
var HunterToResolveRuinQuestionContext_instance;
function HunterToResolveRuinQuestionContext_getInstance() {
  if (HunterToResolveRuinQuestionContext_instance === VOID)
    new HunterToResolveRuinQuestionContext();
  return HunterToResolveRuinQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_236($this) {
  return $this.x4d_1.k3();
}
function HunterToReturnQuestionContext$_anonymous__rv4ic9() {
  var tmp = HunterToReturnQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToReturnQuestionContext', tmp, tmp$ret$0);
}
var HunterToReturnQuestionContext_instance;
function HunterToReturnQuestionContext_getInstance() {
  if (HunterToReturnQuestionContext_instance === VOID)
    new HunterToReturnQuestionContext();
  return HunterToReturnQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_237($this) {
  return $this.y4d_1.k3();
}
function HunterToSkipNextTurnQuestionContext$_anonymous__z8p0ug() {
  var tmp = HunterToSkipNextTurnQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterToSkipNextTurnQuestionContext', tmp, tmp$ret$0);
}
var HunterToSkipNextTurnQuestionContext_instance;
function HunterToSkipNextTurnQuestionContext_getInstance() {
  if (HunterToSkipNextTurnQuestionContext_instance === VOID)
    new HunterToSkipNextTurnQuestionContext();
  return HunterToSkipNextTurnQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_238($this) {
  return $this.z4d_1.k3();
}
function NobleToFarmerQuestionContext$_anonymous__d4sina() {
  var tmp = NobleToFarmerQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NobleToFarmerQuestionContext', tmp, tmp$ret$0);
}
var NobleToFarmerQuestionContext_instance;
function NobleToFarmerQuestionContext_getInstance() {
  if (NobleToFarmerQuestionContext_instance === VOID)
    new NobleToFarmerQuestionContext();
  return NobleToFarmerQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_239($this) {
  return $this.a4e_1.k3();
}
function OutpostToReplaceQuestionContext$_anonymous__o8rzfd() {
  var tmp = OutpostToReplaceQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OutpostToReplaceQuestionContext', tmp, tmp$ret$0);
}
var OutpostToReplaceQuestionContext_instance;
function OutpostToReplaceQuestionContext_getInstance() {
  if (OutpostToReplaceQuestionContext_instance === VOID)
    new OutpostToReplaceQuestionContext();
  return OutpostToReplaceQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_240($this) {
  return $this.b4e_1.k3();
}
function SettlerQuestionContext$_anonymous__fj98qd() {
  var tmp = SettlerQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SettlerQuestionContext', tmp, tmp$ret$0);
}
var SettlerQuestionContext_instance;
function SettlerQuestionContext_getInstance() {
  if (SettlerQuestionContext_instance === VOID)
    new SettlerQuestionContext();
  return SettlerQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_241($this) {
  return $this.c4e_1.k3();
}
function SettlerToMoveQuestionContext$_anonymous__n54af5() {
  var tmp = SettlerToMoveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SettlerToMoveQuestionContext', tmp, tmp$ret$0);
}
var SettlerToMoveQuestionContext_instance;
function SettlerToMoveQuestionContext_getInstance() {
  if (SettlerToMoveQuestionContext_instance === VOID)
    new SettlerToMoveQuestionContext();
  return SettlerToMoveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_242($this) {
  return $this.d4e_1.k3();
}
function SummonToActivateQuestionContext$_anonymous__4ojpfn() {
  var tmp = SummonToActivateQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonToActivateQuestionContext', tmp, tmp$ret$0);
}
var SummonToActivateQuestionContext_instance;
function SummonToActivateQuestionContext_getInstance() {
  if (SummonToActivateQuestionContext_instance === VOID)
    new SummonToActivateQuestionContext();
  return SummonToActivateQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_243($this) {
  return $this.e4e_1.k3();
}
function SummonToAttackWithQuestionContext$_anonymous__ea30rc() {
  var tmp = SummonToAttackWithQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonToAttackWithQuestionContext', tmp, tmp$ret$0);
}
var SummonToAttackWithQuestionContext_instance;
function SummonToAttackWithQuestionContext_getInstance() {
  if (SummonToAttackWithQuestionContext_instance === VOID)
    new SummonToAttackWithQuestionContext();
  return SummonToAttackWithQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_244($this) {
  return $this.f4e_1.k3();
}
function SummonToMoveQuestionContext$_anonymous__ohb21n() {
  var tmp = SummonToMoveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonToMoveQuestionContext', tmp, tmp$ret$0);
}
var SummonToMoveQuestionContext_instance;
function SummonToMoveQuestionContext_getInstance() {
  if (SummonToMoveQuestionContext_instance === VOID)
    new SummonToMoveQuestionContext();
  return SummonToMoveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_245($this) {
  return $this.g4e_1.k3();
}
function SummonToReplaceQuestionContext$_anonymous__6nee06() {
  var tmp = SummonToReplaceQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonToReplaceQuestionContext', tmp, tmp$ret$0);
}
var SummonToReplaceQuestionContext_instance;
function SummonToReplaceQuestionContext_getInstance() {
  if (SummonToReplaceQuestionContext_instance === VOID)
    new SummonToReplaceQuestionContext();
  return SummonToReplaceQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_246($this) {
  return $this.h4e_1.k3();
}
function SummonToSacrificeForRuinQuestionContext$_anonymous__tv0qly() {
  var tmp = SummonToSacrificeForRuinQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonToSacrificeForRuinQuestionContext', tmp, tmp$ret$0);
}
var SummonToSacrificeForRuinQuestionContext_instance;
function SummonToSacrificeForRuinQuestionContext_getInstance() {
  if (SummonToSacrificeForRuinQuestionContext_instance === VOID)
    new SummonToSacrificeForRuinQuestionContext();
  return SummonToSacrificeForRuinQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_247($this) {
  return $this.i4e_1.k3();
}
function TargetToBlockDamageForQuestionContext$_anonymous__ldm72f() {
  var tmp = TargetToBlockDamageForQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TargetToBlockDamageForQuestionContext', tmp, tmp$ret$0);
}
var TargetToBlockDamageForQuestionContext_instance;
function TargetToBlockDamageForQuestionContext_getInstance() {
  if (TargetToBlockDamageForQuestionContext_instance === VOID)
    new TargetToBlockDamageForQuestionContext();
  return TargetToBlockDamageForQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_248($this) {
  return $this.j4e_1.k3();
}
function TargetToDamageQuestionContext$_anonymous__qo8co9() {
  var tmp = TargetToDamageQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TargetToDamageQuestionContext', tmp, tmp$ret$0);
}
var TargetToDamageQuestionContext_instance;
function TargetToDamageQuestionContext_getInstance() {
  if (TargetToDamageQuestionContext_instance === VOID)
    new TargetToDamageQuestionContext();
  return TargetToDamageQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_249($this) {
  return $this.k4e_1.k3();
}
function TargetToHealQuestionContext$_anonymous__n8f0aq() {
  var tmp = TargetToHealQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TargetToHealQuestionContext', tmp, tmp$ret$0);
}
var TargetToHealQuestionContext_instance;
function TargetToHealQuestionContext_getInstance() {
  if (TargetToHealQuestionContext_instance === VOID)
    new TargetToHealQuestionContext();
  return TargetToHealQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_250($this) {
  return $this.l4e_1.k3();
}
function TargetToMoveQuestionContext$_anonymous__69t77v() {
  var tmp = TargetToMoveQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TargetToMoveQuestionContext', tmp, tmp$ret$0);
}
var TargetToMoveQuestionContext_instance;
function TargetToMoveQuestionContext_getInstance() {
  if (TargetToMoveQuestionContext_instance === VOID)
    new TargetToMoveQuestionContext();
  return TargetToMoveQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_251($this) {
  return $this.m4e_1.k3();
}
function TargetToPullQuestionContext$_anonymous__a77sch() {
  var tmp = TargetToPullQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TargetToPullQuestionContext', tmp, tmp$ret$0);
}
var TargetToPullQuestionContext_instance;
function TargetToPullQuestionContext_getInstance() {
  if (TargetToPullQuestionContext_instance === VOID)
    new TargetToPullQuestionContext();
  return TargetToPullQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_252($this) {
  return $this.n4e_1.k3();
}
function TargetToSpendAncientPowersOnQuestionContext$_anonymous__pqxmov() {
  var tmp = TargetToSpendAncientPowersOnQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TargetToSpendAncientPowersOnQuestionContext', tmp, tmp$ret$0);
}
var TargetToSpendAncientPowersOnQuestionContext_instance;
function TargetToSpendAncientPowersOnQuestionContext_getInstance() {
  if (TargetToSpendAncientPowersOnQuestionContext_instance === VOID)
    new TargetToSpendAncientPowersOnQuestionContext();
  return TargetToSpendAncientPowersOnQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_253($this) {
  return $this.o4e_1.k3();
}
function VictimToProtectQuestionContext$_anonymous__kqb2km() {
  var tmp = VictimToProtectQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('VictimToProtectQuestionContext', tmp, tmp$ret$0);
}
var VictimToProtectQuestionContext_instance;
function VictimToProtectQuestionContext_getInstance() {
  if (VictimToProtectQuestionContext_instance === VOID)
    new VictimToProtectQuestionContext();
  return VictimToProtectQuestionContext_instance;
}
function DiscardToMoveVariant$Companion$$childSerializers$_anonymous__gb77bl() {
  return Companion_instance_442.a2g();
}
var Companion_instance_209;
function Companion_getInstance_210() {
  if (Companion_instance_209 === VOID)
    new Companion_209();
  return Companion_instance_209;
}
var $serializer_instance_176;
function $serializer_getInstance_176() {
  if ($serializer_instance_176 === VOID)
    new $serializer_177();
  return $serializer_instance_176;
}
function DiscardToUseBoatVariant$Companion$$childSerializers$_anonymous__3ioslp() {
  return Companion_instance_442.a2g();
}
var Companion_instance_210;
function Companion_getInstance_211() {
  if (Companion_instance_210 === VOID)
    new Companion_210();
  return Companion_instance_210;
}
var $serializer_instance_177;
function $serializer_getInstance_177() {
  if ($serializer_instance_177 === VOID)
    new $serializer_178();
  return $serializer_instance_177;
}
function _get_$cachedSerializer__te6jhj_254($this) {
  return $this.z4e_1.k3();
}
function PassVariant$_anonymous__6jdeqr() {
  var tmp = PassVariant_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PassVariant', tmp, tmp$ret$0);
}
var PassVariant_instance;
function PassVariant_getInstance() {
  if (PassVariant_instance === VOID)
    new PassVariant();
  return PassVariant_instance;
}
function PlayCardVariant$Companion$$childSerializers$_anonymous__ljwk4p() {
  return Companion_instance_438.a2g();
}
var Companion_instance_211;
function Companion_getInstance_212() {
  if (Companion_instance_211 === VOID)
    new Companion_211();
  return Companion_instance_211;
}
var $serializer_instance_178;
function $serializer_getInstance_178() {
  if ($serializer_instance_178 === VOID)
    new $serializer_179();
  return $serializer_instance_178;
}
function TriggerOptionRequirement$CardRequirement$Companion$$childSerializers$_anonymous__88rt23() {
  return Companion_instance_442.a2g();
}
var Companion_instance_212;
function Companion_getInstance_213() {
  if (Companion_instance_212 === VOID)
    new Companion_212();
  return Companion_instance_212;
}
var $serializer_instance_179;
function $serializer_getInstance_179() {
  if ($serializer_instance_179 === VOID)
    new $serializer_180();
  return $serializer_instance_179;
}
function _get_$cachedSerializer__te6jhj_255($this) {
  return $this.l4f_1.k3();
}
function TriggerOptionRequirement$Optional$_anonymous__w11tux() {
  var tmp = Optional_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OptionalTriggerOptionRequirement', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_256($this) {
  return $this.m4f_1.k3();
}
function TriggerOptionRequirement$Mandatory$_anonymous__37bbws() {
  var tmp = Mandatory_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MandatoryTriggerOptionRequirement', tmp, tmp$ret$0);
}
var Optional_instance;
function Optional_getInstance() {
  if (Optional_instance === VOID)
    new Optional();
  return Optional_instance;
}
var Mandatory_instance;
function Mandatory_getInstance() {
  if (Mandatory_instance === VOID)
    new Mandatory();
  return Mandatory_instance;
}
var Companion_instance_213;
function Companion_getInstance_214() {
  return Companion_instance_213;
}
function get_beastsGameTeam() {
  _init_properties_GameRules_kt__8r792r();
  return beastsGameTeam;
}
var beastsGameTeam;
function get_huntersGameTeam() {
  _init_properties_GameRules_kt__8r792r();
  return huntersGameTeam;
}
var huntersGameTeam;
function get_anyGameTeamMarker() {
  _init_properties_GameRules_kt__8r792r();
  return anyGameTeamMarker;
}
var anyGameTeamMarker;
function get_observerGameTeamMarker() {
  _init_properties_GameRules_kt__8r792r();
  return observerGameTeamMarker;
}
var observerGameTeamMarker;
function get_fullObserverGameTeamMarker() {
  _init_properties_GameRules_kt__8r792r();
  return fullObserverGameTeamMarker;
}
var fullObserverGameTeamMarker;
function get_baseGameDraftActionCards() {
  _init_properties_GameRules_kt__8r792r();
  return baseGameDraftActionCards;
}
var baseGameDraftActionCards;
function get_baseGameBeastTalentCards() {
  _init_properties_GameRules_kt__8r792r();
  return baseGameBeastTalentCards;
}
var baseGameBeastTalentCards;
function get_baseGameHunterItemCards() {
  _init_properties_GameRules_kt__8r792r();
  return baseGameHunterItemCards;
}
var baseGameHunterItemCards;
var BeastGameExpansions_ShatteredIsles_instance;
var BeastGameExpansions_TheGreatHunt_instance;
var BeastGameExpansions_Ashfall_instance;
function values_4() {
  return [BeastGameExpansions_ShatteredIsles_getInstance(), BeastGameExpansions_TheGreatHunt_getInstance(), BeastGameExpansions_Ashfall_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_4());
  return $ENTRIES_0;
}
var BeastGameExpansions_entriesInitialized;
function BeastGameExpansions_initEntries() {
  if (BeastGameExpansions_entriesInitialized)
    return Unit_instance;
  BeastGameExpansions_entriesInitialized = true;
  BeastGameExpansions_ShatteredIsles_instance = new BeastGameExpansions('ShatteredIsles', 0);
  BeastGameExpansions_TheGreatHunt_instance = new BeastGameExpansions('TheGreatHunt', 1);
  BeastGameExpansions_Ashfall_instance = new BeastGameExpansions('Ashfall', 2);
}
var $ENTRIES_0;
var Companion_instance_214;
function Companion_getInstance_215() {
  return Companion_instance_214;
}
function _get_$cachedSerializer__te6jhj_257($this) {
  return $this.n4f_1.k3();
}
function ClassicGameRules$Companion$_anonymous__2qk93w() {
  var tmp = getKClass(ClassicGameRules);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(ArrivalOfTheTitanContract), getKClass(AshfallUnlikelyAllianceContract), getKClass(AttackOnTheNorthernSettlementsContract), getKClass(DisturbanceOfTheNorthernGodsContract), getKClass(GreatCleansingContract), getKClass(PactLongForgottenContract), getKClass(RecoveryTestContract), getKClass(SecretsFromALostAgeContract), getKClass(ShipwreckContract), getKClass(UnleashingTheAbyssContract), getKClass(UnlikelyAllianceContract), getKClass(RegentOfRuinsContract)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_71(), $serializer_getInstance_75(), $serializer_getInstance_81(), $serializer_getInstance_126(), $serializer_getInstance_321(), $serializer_getInstance_371(), $serializer_getInstance_374(), $serializer_getInstance_397(), $serializer_getInstance_398(), $serializer_getInstance_409(), $serializer_getInstance_410(), $serializer_getInstance_380()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [];
  return SealedClassSerializer.i10('ClassicGameRules', tmp, tmp_0, tmp_1, tmp$ret$6);
}
var Companion_instance_215;
function Companion_getInstance_216() {
  if (Companion_instance_215 === VOID)
    new Companion_215();
  return Companion_instance_215;
}
function _get_$cachedSerializer__te6jhj_258($this) {
  return $this.f3a_1.k3();
}
function BeastBalanceVersion$Companion$_anonymous__9e3ki4() {
  return createSimpleEnumSerializer('steelart.beast.BeastBalanceVersion', values_5());
}
var BeastBalanceVersion_OfficialV1_instance;
var BeastBalanceVersion_OfficialV2_instance;
var Companion_instance_216;
function Companion_getInstance_217() {
  BeastBalanceVersion_initEntries();
  if (Companion_instance_216 === VOID)
    new Companion_216();
  return Companion_instance_216;
}
function values_5() {
  return [BeastBalanceVersion_OfficialV1_getInstance(), BeastBalanceVersion_OfficialV2_getInstance()];
}
function get_entries_1() {
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_5());
  return $ENTRIES_1;
}
var BeastBalanceVersion_entriesInitialized;
function BeastBalanceVersion_initEntries() {
  if (BeastBalanceVersion_entriesInitialized)
    return Unit_instance;
  BeastBalanceVersion_entriesInitialized = true;
  BeastBalanceVersion_OfficialV1_instance = new BeastBalanceVersion('OfficialV1', 0);
  BeastBalanceVersion_OfficialV2_instance = new BeastBalanceVersion('OfficialV2', 1);
  Companion_getInstance_217();
}
var $ENTRIES_1;
function _get_$cachedSerializer__te6jhj_259($this) {
  return $this.s4f_1.k3();
}
function KillingSettlersClassicGameRules$Companion$_anonymous__xdoej0() {
  var tmp = getKClass(KillingSettlersClassicGameRules);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(ArrivalOfTheTitanContract), getKClass(AshfallUnlikelyAllianceContract), getKClass(AttackOnTheNorthernSettlementsContract), getKClass(DisturbanceOfTheNorthernGodsContract), getKClass(GreatCleansingContract), getKClass(PactLongForgottenContract), getKClass(RecoveryTestContract), getKClass(SecretsFromALostAgeContract), getKClass(ShipwreckContract), getKClass(UnleashingTheAbyssContract), getKClass(UnlikelyAllianceContract)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_71(), $serializer_getInstance_75(), $serializer_getInstance_81(), $serializer_getInstance_126(), $serializer_getInstance_321(), $serializer_getInstance_371(), $serializer_getInstance_374(), $serializer_getInstance_397(), $serializer_getInstance_398(), $serializer_getInstance_409(), $serializer_getInstance_410()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [];
  return SealedClassSerializer.i10('KillingSettlersClassicGameRules', tmp, tmp_0, tmp_1, tmp$ret$6);
}
var Companion_instance_217;
function Companion_getInstance_218() {
  if (Companion_instance_217 === VOID)
    new Companion_217();
  return Companion_instance_217;
}
function GameRulesParameters$Companion$$childSerializers$_anonymous__b23c05() {
  return Companion_getInstance_217().a2g();
}
var Companion_instance_218;
function Companion_getInstance_219() {
  if (Companion_instance_218 === VOID)
    new Companion_218();
  return Companion_instance_218;
}
var $serializer_instance_180;
function $serializer_getInstance_180() {
  if ($serializer_instance_180 === VOID)
    new $serializer_181();
  return $serializer_instance_180;
}
function GameContentVersion$Companion$$childSerializers$_anonymous__ggb893() {
  return new LinkedHashSetSerializer(createSimpleEnumSerializer('steelart.beast.BeastGameExpansions', values_4()));
}
var Companion_instance_219;
function Companion_getInstance_220() {
  if (Companion_instance_219 === VOID)
    new Companion_219();
  return Companion_instance_219;
}
var $serializer_instance_181;
function $serializer_getInstance_181() {
  if ($serializer_instance_181 === VOID)
    new $serializer_182();
  return $serializer_instance_181;
}
var Companion_instance_220;
function Companion_getInstance_221() {
  return Companion_instance_220;
}
var $serializer_instance_182;
function $serializer_getInstance_182() {
  if ($serializer_instance_182 === VOID)
    new $serializer_183();
  return $serializer_instance_182;
}
var NightRewardStatus_InvalidNightNumber_instance;
var NightRewardStatus_NightWasPassed_instance;
var NightRewardStatus_NotGained_instance;
var NightRewardStatus_RewardFailed_instance;
var NightRewardStatus_ExpectedReward_instance;
var NightRewardStatus_EnsuredReward_instance;
var NightRewardStatus_entriesInitialized;
function NightRewardStatus_initEntries() {
  if (NightRewardStatus_entriesInitialized)
    return Unit_instance;
  NightRewardStatus_entriesInitialized = true;
  NightRewardStatus_InvalidNightNumber_instance = new NightRewardStatus('InvalidNightNumber', 0);
  NightRewardStatus_NightWasPassed_instance = new NightRewardStatus('NightWasPassed', 1);
  NightRewardStatus_NotGained_instance = new NightRewardStatus('NotGained', 2);
  NightRewardStatus_RewardFailed_instance = new NightRewardStatus('RewardFailed', 3);
  NightRewardStatus_ExpectedReward_instance = new NightRewardStatus('ExpectedReward', 4);
  NightRewardStatus_EnsuredReward_instance = new NightRewardStatus('EnsuredReward', 5);
}
function _GameTeam___init__impl__xtwsj2(teamId) {
  return teamId;
}
function _GameTeam___get_teamId__impl__chxeb3($this) {
  return $this;
}
var Companion_instance_221;
function Companion_getInstance_222() {
  return Companion_instance_221;
}
var $serializer_instance_183;
function $serializer_getInstance_183() {
  if ($serializer_instance_183 === VOID)
    new $serializer_184();
  return $serializer_instance_183;
}
function GameTeam__toString_impl_wfw0a6($this) {
  return 'GameTeam(teamId=' + $this + ')';
}
function GameTeam__hashCode_impl_gu24w3($this) {
  return $this;
}
function GameTeam__equals_impl_fenwin($this, other) {
  if (!(other instanceof GameTeam))
    return false;
  if (!($this === other.r3p_1))
    return false;
  return true;
}
function ensuredOrNotGainedRewardStatus(isEnsured) {
  _init_properties_GameRules_kt__8r792r();
  return isEnsured ? NightRewardStatus_EnsuredReward_getInstance() : NightRewardStatus_NotGained_getInstance();
}
function expectedOrNotGainedRewardStatus(isExpected) {
  _init_properties_GameRules_kt__8r792r();
  return isExpected ? NightRewardStatus_ExpectedReward_getInstance() : NightRewardStatus_NotGained_getInstance();
}
function get_gameMap_0(_this__u8e3s4) {
  _init_properties_GameRules_kt__8r792r();
  var tmp;
  switch (_this__u8e3s4.h3a().w1_1) {
    case 0:
      tmp = get_gameContentVersion(_this__u8e3s4).h4g() ? get_ashfallNorthernExpanse() : get_northernExpanseMap();
      break;
    case 1:
      tmp = get_gameContentVersion(_this__u8e3s4).h4g() ? get_ashfallDrenchedLands() : get_drenchedLandsMap();
      break;
    case 2:
      tmp = get_upperShatteredIslesMap();
      break;
    case 3:
      tmp = get_lowerShatteredIslesMap();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
var Companion_instance_222;
function Companion_getInstance_223() {
  return Companion_instance_222;
}
function PlayerTurnPhase$Companion$$childSerializers$_anonymous__y61okz() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_223;
function Companion_getInstance_224() {
  if (Companion_instance_223 === VOID)
    new Companion_223();
  return Companion_instance_223;
}
var $serializer_instance_184;
function $serializer_getInstance_184() {
  if ($serializer_instance_184 === VOID)
    new $serializer_185();
  return $serializer_instance_184;
}
var Companion_instance_224;
function Companion_getInstance_225() {
  return Companion_instance_224;
}
function get_usesAshfallMapFeatures(_this__u8e3s4) {
  _init_properties_GameRules_kt__8r792r();
  return get_gameContentVersion(_this__u8e3s4).h4g() && setOf_0([GameMapId_NorthernExpanse_getInstance(), GameMapId_DrenchedLands_getInstance()]).w2(_this__u8e3s4.h3a());
}
function ensuredExpectedOrNotGainedRewardStatus(isEnsured, isExpected) {
  _init_properties_GameRules_kt__8r792r();
  return isEnsured ? NightRewardStatus_EnsuredReward_getInstance() : isExpected ? NightRewardStatus_ExpectedReward_getInstance() : NightRewardStatus_NotGained_getInstance();
}
function expectedOrFailedRewardStatus(isExpected) {
  _init_properties_GameRules_kt__8r792r();
  return isExpected ? NightRewardStatus_ExpectedReward_getInstance() : NightRewardStatus_RewardFailed_getInstance();
}
function get_balanceVersion(_this__u8e3s4) {
  _init_properties_GameRules_kt__8r792r();
  return _this__u8e3s4.c3a().w4f_1;
}
var Companion_instance_225;
function Companion_getInstance_226() {
  return Companion_instance_225;
}
var ValueId_SheepHP_instance;
var ValueId_SheepReward_instance;
var ValueId_BoarHP_instance;
var ValueId_BoarReward_instance;
var ValueId_BearHP_instance;
var ValueId_TigerHP_instance;
var ValueId_BearReward_instance;
var ValueId_FarmerHP_instance;
var ValueId_FarmerReward_instance;
var ValueId_NobleHP_instance;
var ValueId_NobleReward_instance;
var ValueId_WatchtowerHP_instance;
var ValueId_SummonHP_instance;
var ValueId_MaxTrapsNumberInZone_instance;
var ValueId_entriesInitialized;
function ValueId_initEntries() {
  if (ValueId_entriesInitialized)
    return Unit_instance;
  ValueId_entriesInitialized = true;
  ValueId_SheepHP_instance = new ValueId('SheepHP', 0);
  ValueId_SheepReward_instance = new ValueId('SheepReward', 1);
  ValueId_BoarHP_instance = new ValueId('BoarHP', 2);
  ValueId_BoarReward_instance = new ValueId('BoarReward', 3);
  ValueId_BearHP_instance = new ValueId('BearHP', 4);
  ValueId_TigerHP_instance = new ValueId('TigerHP', 5);
  ValueId_BearReward_instance = new ValueId('BearReward', 6);
  ValueId_FarmerHP_instance = new ValueId('FarmerHP', 7);
  ValueId_FarmerReward_instance = new ValueId('FarmerReward', 8);
  ValueId_NobleHP_instance = new ValueId('NobleHP', 9);
  ValueId_NobleReward_instance = new ValueId('NobleReward', 10);
  ValueId_WatchtowerHP_instance = new ValueId('WatchtowerHP', 11);
  ValueId_SummonHP_instance = new ValueId('SummonHP', 12);
  ValueId_MaxTrapsNumberInZone_instance = new ValueId('MaxTrapsNumberInZone', 13);
}
function getHunterItemCardDeck(hasShatteredIsles) {
  _init_properties_GameRules_kt__8r792r();
  return plus_2(get_baseGameHunterItemCards(), listOfIf(hasShatteredIsles, [new ExpeditionMapCard(0), new ExpeditionMapCard(1), new RitualTrapCard(0), new RitualTrapCard(1), new SacredRichesCard(0), new SacredRichesCard(1), new DreamerMaskCard(0), new DreamerMaskCard(1), BansheesLureCard_getInstance(), ChainGrapnelCard_getInstance(), EsmeriasStrandCard_getInstance(), SpyglassCard_getInstance(), WarhogsTuskCard_getInstance()]));
}
function get_gameContentVersion(_this__u8e3s4) {
  _init_properties_GameRules_kt__8r792r();
  return _this__u8e3s4.c3a().x4f_1;
}
function getBeastTalentCardDeck(hasShatteredIsles) {
  _init_properties_GameRules_kt__8r792r();
  return plus_2(get_baseGameBeastTalentCards(), listOfIf(hasShatteredIsles, [new WorldShiftCard(0), new WorldShiftCard(1), new FeastCard(0), new FeastCard(1), new FlourishCard(0), new FlourishCard(1), new MirrorStepCard(0), new MirrorStepCard(1), FuryCard_getInstance(), ShatterCard_getInstance(), SuddenMistCard_getInstance(), SwarmCard_getInstance()]));
}
function getDraftActionCardDeck(hasShatteredIsles) {
  _init_properties_GameRules_kt__8r792r();
  return plus_2(get_baseGameDraftActionCards(), listOfIf(hasShatteredIsles, [DisplaceCard_getInstance(), DarkOfferingsCard_getInstance(), GlimpseCard_getInstance(), StrideCard_getInstance()]));
}
var Companion_instance_226;
function Companion_getInstance_227() {
  return Companion_instance_226;
}
var $serializer_instance_185;
function $serializer_getInstance_185() {
  if ($serializer_instance_185 === VOID)
    new $serializer_186();
  return $serializer_instance_185;
}
function _get_$cachedSerializer__te6jhj_260($this) {
  return $this.e4h_1.k3();
}
function StartOfDayPhase$_anonymous__voo9un() {
  var tmp = StartOfDayPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('StartOfDayPhase', tmp, tmp$ret$0);
}
var StartOfDayPhase_instance;
function StartOfDayPhase_getInstance() {
  if (StartOfDayPhase_instance === VOID)
    new StartOfDayPhase();
  return StartOfDayPhase_instance;
}
function get_isValidBeastAttackTarget($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_GameRules_kt__8r792r();
  var tmp;
  var tmp_0 = get_objectType($context_GameState_t6qee5, _this__u8e3s4);
  if (!isInterface(tmp_0, SummonType)) {
    var tmp_1 = get_objectType($context_GameState_t6qee5, _this__u8e3s4);
    tmp = !isInterface(tmp_1, BeastCharacter);
  } else {
    tmp = false;
  }
  return tmp;
}
function CardApplyingScope$Companion$$childSerializers$_anonymous__dsrhba() {
  return Companion_instance_442.a2g();
}
function CardApplyingScope$Companion$$childSerializers$_anonymous__dsrhba_0() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function CardApplyingScope$Companion$$childSerializers$_anonymous__dsrhba_1() {
  return Companion_instance.a2g();
}
var Companion_instance_227;
function Companion_getInstance_228() {
  if (Companion_instance_227 === VOID)
    new Companion_227();
  return Companion_instance_227;
}
var $serializer_instance_186;
function $serializer_getInstance_186() {
  if ($serializer_instance_186 === VOID)
    new $serializer_187();
  return $serializer_instance_186;
}
function CardResolvingScope$Companion$$childSerializers$_anonymous__s2k8nj() {
  return Companion_instance_442.a2g();
}
function CardResolvingScope$Companion$$childSerializers$_anonymous__s2k8nj_0() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function CardResolvingScope$Companion$$childSerializers$_anonymous__s2k8nj_1() {
  return Companion_instance_296.a2g();
}
var Companion_instance_228;
function Companion_getInstance_229() {
  if (Companion_instance_228 === VOID)
    new Companion_228();
  return Companion_instance_228;
}
var $serializer_instance_187;
function $serializer_getInstance_187() {
  if ($serializer_instance_187 === VOID)
    new $serializer_188();
  return $serializer_instance_187;
}
function ControllingActorScope$Companion$$childSerializers$_anonymous__acw4ko() {
  return Companion_instance_133.a2g();
}
var Companion_instance_229;
function Companion_getInstance_230() {
  if (Companion_instance_229 === VOID)
    new Companion_229();
  return Companion_instance_229;
}
var $serializer_instance_188;
function $serializer_getInstance_188() {
  if ($serializer_instance_188 === VOID)
    new $serializer_189();
  return $serializer_instance_188;
}
function EffectsAfterEventScope$Companion$$childSerializers$_anonymous__72pm0m() {
  return Companion_instance_295.a2g();
}
var Companion_instance_230;
function Companion_getInstance_231() {
  if (Companion_instance_230 === VOID)
    new Companion_230();
  return Companion_instance_230;
}
var $serializer_instance_189;
function $serializer_getInstance_189() {
  if ($serializer_instance_189 === VOID)
    new $serializer_190();
  return $serializer_instance_189;
}
function EventTriggeredByEffectSourceScope$Companion$$childSerializers$_anonymous__e981va() {
  return Companion_instance_154.a2g();
}
var Companion_instance_231;
function Companion_getInstance_232() {
  if (Companion_instance_231 === VOID)
    new Companion_231();
  return Companion_instance_231;
}
var $serializer_instance_190;
function $serializer_getInstance_190() {
  if ($serializer_instance_190 === VOID)
    new $serializer_191();
  return $serializer_instance_190;
}
function EffectRecoveryScope$Companion$$childSerializers$_anonymous__b4jt0() {
  return Companion_instance_222.a2g();
}
var Companion_instance_232;
function Companion_getInstance_233() {
  if (Companion_instance_232 === VOID)
    new Companion_232();
  return Companion_instance_232;
}
var $serializer_instance_191;
function $serializer_getInstance_191() {
  if ($serializer_instance_191 === VOID)
    new $serializer_192();
  return $serializer_instance_191;
}
function _get_$cachedSerializer__te6jhj_261($this) {
  return $this.m4i_1.k3();
}
function FullPreGamePhase$_anonymous__aco0ta() {
  var tmp = FullPreGamePhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FullPreGamePhase', tmp, tmp$ret$0);
}
var FullPreGamePhase_instance;
function FullPreGamePhase_getInstance() {
  if (FullPreGamePhase_instance === VOID)
    new FullPreGamePhase();
  return FullPreGamePhase_instance;
}
function _get_$cachedSerializer__te6jhj_262($this) {
  return $this.n4i_1.k3();
}
function InitialPhase$_anonymous__emsibk() {
  var tmp = InitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('InitialPhase', tmp, tmp$ret$0);
}
var InitialPhase_instance;
function InitialPhase_getInstance() {
  if (InitialPhase_instance === VOID)
    new InitialPhase();
  return InitialPhase_instance;
}
function _get_$cachedSerializer__te6jhj_263($this) {
  return $this.o4i_1.k3();
}
function NightPhase$_anonymous__jx0auk() {
  var tmp = NightPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NightPhase', tmp, tmp$ret$0);
}
var NightPhase_instance;
function NightPhase_getInstance() {
  if (NightPhase_instance === VOID)
    new NightPhase();
  return NightPhase_instance;
}
function _get_$cachedSerializer__te6jhj_264($this) {
  return $this.p4i_1.k3();
}
function NonePhase$_anonymous__z4i644() {
  var tmp = NonePhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NonePhase', tmp, tmp$ret$0);
}
var NonePhase_instance;
function NonePhase_getInstance() {
  if (NonePhase_instance === VOID)
    new NonePhase();
  return NonePhase_instance;
}
function _get_$cachedSerializer__te6jhj_265($this) {
  return $this.q4i_1.k3();
}
function PreGamePhase$_anonymous__vmahzl() {
  var tmp = PreGamePhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PreGamePhase', tmp, tmp$ret$0);
}
var PreGamePhase_instance;
function PreGamePhase_getInstance() {
  if (PreGamePhase_instance === VOID)
    new PreGamePhase();
  return PreGamePhase_instance;
}
function PhaseRecoveryScope$Companion$$childSerializers$_anonymous__k24kyu() {
  return Companion_instance_225.a2g();
}
var Companion_instance_233;
function Companion_getInstance_234() {
  if (Companion_instance_233 === VOID)
    new Companion_233();
  return Companion_instance_233;
}
var $serializer_instance_192;
function $serializer_getInstance_192() {
  if ($serializer_instance_192 === VOID)
    new $serializer_193();
  return $serializer_instance_192;
}
var Companion_instance_234;
function Companion_getInstance_235() {
  return Companion_instance_234;
}
var $serializer_instance_193;
function $serializer_getInstance_193() {
  if ($serializer_instance_193 === VOID)
    new $serializer_194();
  return $serializer_instance_193;
}
var Companion_instance_235;
function Companion_getInstance_236() {
  return Companion_instance_235;
}
var $serializer_instance_194;
function $serializer_getInstance_194() {
  if ($serializer_instance_194 === VOID)
    new $serializer_195();
  return $serializer_instance_194;
}
function ReactionCardScope$Companion$$childSerializers$_anonymous__20ew7l() {
  return Companion_instance_442.a2g();
}
var Companion_instance_236;
function Companion_getInstance_237() {
  if (Companion_instance_236 === VOID)
    new Companion_236();
  return Companion_instance_236;
}
var $serializer_instance_195;
function $serializer_getInstance_195() {
  if ($serializer_instance_195 === VOID)
    new $serializer_196();
  return $serializer_instance_195;
}
function RevealedTriggerSource$Companion$$childSerializers$_anonymous__qbknr7() {
  return new ArrayListSerializer($serializer_getInstance_173());
}
var Companion_instance_237;
function Companion_getInstance_238() {
  if (Companion_instance_237 === VOID)
    new Companion_237();
  return Companion_instance_237;
}
var $serializer_instance_196;
function $serializer_getInstance_196() {
  if ($serializer_instance_196 === VOID)
    new $serializer_197();
  return $serializer_instance_196;
}
function TurnStageScope$Companion$$childSerializers$_anonymous__mz1w6h() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_238;
function Companion_getInstance_239() {
  if (Companion_instance_238 === VOID)
    new Companion_238();
  return Companion_instance_238;
}
var $serializer_instance_197;
function $serializer_getInstance_197() {
  if ($serializer_instance_197 === VOID)
    new $serializer_198();
  return $serializer_instance_197;
}
var Companion_instance_239;
function Companion_getInstance_240() {
  return Companion_instance_239;
}
function ruinsControlled(_this__u8e3s4, team) {
  _init_properties_GameRules_kt__8r792r();
  var tmp0 = _this__u8e3s4.u4j().y4();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (element.r3p_1 === team) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$0 = count;
  }
  return tmp$ret$0;
}
function get_isClassicTwoSheepOrBoarCompleted(_this__u8e3s4) {
  _init_properties_GameRules_kt__8r792r();
  return isTwoSheepOrAnimalCompleted(_this__u8e3s4, BoarType_getInstance());
}
function isTwoSheepOrAnimalCompleted($context_GameState_t6qee5, animalType) {
  _init_properties_GameRules_kt__8r792r();
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_destroyRecords($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.p3a_1 === get_beastsGameTeam()) {
      destination.d2(element);
    }
  }
  var killings = destination;
  var tmp;
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp_0;
    if (isInterface(killings, Collection)) {
      tmp_0 = killings.n1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$3 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s_0 = killings.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (equals(get_objectType($context_GameState_t6qee5, element_0.o3a_1), SheepType_getInstance())) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$3 = count;
  }
  if (tmp$ret$3 >= 2) {
    tmp = true;
  } else {
    var tmp$ret$5;
    $l$block_1: {
      // Inline function 'kotlin.collections.any' call
      var tmp_1;
      if (isInterface(killings, Collection)) {
        tmp_1 = killings.n1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$5 = false;
        break $l$block_1;
      }
      var _iterator__ex2g4s_1 = killings.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        if (equals(get_objectType($context_GameState_t6qee5, element_1.o3a_1), animalType)) {
          tmp$ret$5 = true;
          break $l$block_1;
        }
      }
      tmp$ret$5 = false;
    }
    tmp = tmp$ret$5;
  }
  return tmp;
}
function get_isTwoSheepOrTigerCompleted(_this__u8e3s4) {
  _init_properties_GameRules_kt__8r792r();
  return isTwoSheepOrAnimalCompleted(_this__u8e3s4, TigerType_getInstance());
}
function get_isObserver(_this__u8e3s4) {
  _init_properties_GameRules_kt__8r792r();
  return _this__u8e3s4 === get_observerGameTeamMarker() || _this__u8e3s4 === get_fullObserverGameTeamMarker();
}
function availableBeasts(gameContentVersion) {
  _init_properties_GameRules_kt__8r792r();
  return plus_2(plus_2(plus_2(listOf_0([Fangrir_getInstance(), Mara_getInstance(), Hogbad_getInstance(), Raaga_getInstance(), EsmeriaBeast_getInstance(), Bolgin_getInstance()]), listOfIf(gameContentVersion.q3d_1.w2(BeastGameExpansions_ShatteredIsles_getInstance()), [Vacker_getInstance(), Thalduk_getInstance(), Akkeron_getInstance()])), listOfIf(gameContentVersion.q3d_1.w2(BeastGameExpansions_TheGreatHunt_getInstance()), [FeatheredKing_getInstance()])), listOfIf(gameContentVersion.q3d_1.w2(BeastGameExpansions_Ashfall_getInstance()), [Rhagner_getInstance(), Lydan_getInstance(), Omma_getInstance(), Urgull_getInstance()]));
}
function availableHunters(gameContentVersion) {
  _init_properties_GameRules_kt__8r792r();
  return plus_2(plus_2(plus_2(listOf_0([Helga_getInstance(), Varja_getInstance(), Iona_getInstance(), Krim_getInstance(), Assar_getInstance(), Grimgeir_getInstance()]), listOfIf(gameContentVersion.q3d_1.w2(BeastGameExpansions_ShatteredIsles_getInstance()), [Eivind_getInstance(), Valdi_getInstance(), Fara_getInstance()])), listOfIf(gameContentVersion.q3d_1.w2(BeastGameExpansions_TheGreatHunt_getInstance()), [EsmeriaHuntress_getInstance()])), listOfIf(gameContentVersion.q3d_1.w2(BeastGameExpansions_Ashfall_getInstance()), [Draug_getInstance(), Nora_getInstance(), Bram_getInstance(), Sigrid_getInstance()]));
}
function withGameContentVersion(_this__u8e3s4, gameContentVersion) {
  _init_properties_GameRules_kt__8r792r();
  if (get_gameContentVersion(_this__u8e3s4).equals(gameContentVersion)) {
    return _this__u8e3s4;
  }
  return _this__u8e3s4.u3a(_this__u8e3s4.c3a().d4g(VOID, gameContentVersion));
}
function get_anotherTeam(_this__u8e3s4) {
  _init_properties_GameRules_kt__8r792r();
  return _this__u8e3s4 === get_beastsGameTeam() ? get_huntersGameTeam() : get_beastsGameTeam();
}
function BeastGameExpansions_ShatteredIsles_getInstance() {
  BeastGameExpansions_initEntries();
  return BeastGameExpansions_ShatteredIsles_instance;
}
function BeastGameExpansions_TheGreatHunt_getInstance() {
  BeastGameExpansions_initEntries();
  return BeastGameExpansions_TheGreatHunt_instance;
}
function BeastGameExpansions_Ashfall_getInstance() {
  BeastGameExpansions_initEntries();
  return BeastGameExpansions_Ashfall_instance;
}
function BeastBalanceVersion_OfficialV1_getInstance() {
  BeastBalanceVersion_initEntries();
  return BeastBalanceVersion_OfficialV1_instance;
}
function BeastBalanceVersion_OfficialV2_getInstance() {
  BeastBalanceVersion_initEntries();
  return BeastBalanceVersion_OfficialV2_instance;
}
function NightRewardStatus_InvalidNightNumber_getInstance() {
  NightRewardStatus_initEntries();
  return NightRewardStatus_InvalidNightNumber_instance;
}
function NightRewardStatus_NightWasPassed_getInstance() {
  NightRewardStatus_initEntries();
  return NightRewardStatus_NightWasPassed_instance;
}
function NightRewardStatus_NotGained_getInstance() {
  NightRewardStatus_initEntries();
  return NightRewardStatus_NotGained_instance;
}
function NightRewardStatus_RewardFailed_getInstance() {
  NightRewardStatus_initEntries();
  return NightRewardStatus_RewardFailed_instance;
}
function NightRewardStatus_ExpectedReward_getInstance() {
  NightRewardStatus_initEntries();
  return NightRewardStatus_ExpectedReward_instance;
}
function NightRewardStatus_EnsuredReward_getInstance() {
  NightRewardStatus_initEntries();
  return NightRewardStatus_EnsuredReward_instance;
}
function ValueId_SheepHP_getInstance() {
  ValueId_initEntries();
  return ValueId_SheepHP_instance;
}
function ValueId_BoarHP_getInstance() {
  ValueId_initEntries();
  return ValueId_BoarHP_instance;
}
function ValueId_BearHP_getInstance() {
  ValueId_initEntries();
  return ValueId_BearHP_instance;
}
function ValueId_TigerHP_getInstance() {
  ValueId_initEntries();
  return ValueId_TigerHP_instance;
}
function ValueId_FarmerHP_getInstance() {
  ValueId_initEntries();
  return ValueId_FarmerHP_instance;
}
function ValueId_NobleHP_getInstance() {
  ValueId_initEntries();
  return ValueId_NobleHP_instance;
}
function ValueId_WatchtowerHP_getInstance() {
  ValueId_initEntries();
  return ValueId_WatchtowerHP_instance;
}
function ValueId_SummonHP_getInstance() {
  ValueId_initEntries();
  return ValueId_SummonHP_instance;
}
function ValueId_MaxTrapsNumberInZone_getInstance() {
  ValueId_initEntries();
  return ValueId_MaxTrapsNumberInZone_instance;
}
var properties_initialized_GameRules_kt_m82wad;
function _init_properties_GameRules_kt__8r792r() {
  if (!properties_initialized_GameRules_kt_m82wad) {
    properties_initialized_GameRules_kt_m82wad = true;
    beastsGameTeam = _GameTeam___init__impl__xtwsj2(0);
    huntersGameTeam = _GameTeam___init__impl__xtwsj2(1);
    anyGameTeamMarker = _GameTeam___init__impl__xtwsj2(-1);
    observerGameTeamMarker = _GameTeam___init__impl__xtwsj2(-100);
    fullObserverGameTeamMarker = _GameTeam___init__impl__xtwsj2(-101);
    baseGameDraftActionCards = listOf_0([RushCard_getInstance(), DashCard_getInstance(), AnimateCard_getInstance(), EnsnareCard_getInstance(), BolsterCard_getInstance(), AvariceCard_getInstance(), PursuitCard_getInstance(), AdaptCard_getInstance(), HiddenPassageCard_getInstance(), HasteCard_getInstance(), DarkDealingsCard_getInstance(), ProwlCard_getInstance(), DarkRitualsCard_getInstance(), InciteCard_getInstance(), UnearthCard_getInstance(), ChargeCard_getInstance()]);
    baseGameBeastTalentCards = listOf_0([new EvolveCard(0), new EvolveCard(1), new EvolveCard(2), new UnbendingWillCard(0), new UnbendingWillCard(1), new BrutalityCard(0), new BrutalityCard(1), new RageCard(0), new RageCard(1), new StrangeSummonsCard(0), new StrangeSummonsCard(1), new IntuitionCard(0), new IntuitionCard(1), new HatredCard(0), new HatredCard(1), new DisperseCard(0), new DisperseCard(1), new InsidiousGrowthCard(0), new InsidiousGrowthCard(1), new RoamCard(0), new RoamCard(1), new SprawlCard(0), new SprawlCard(1), DisappearCard_getInstance(), AbruptDecayCard_getInstance()]);
    baseGameHunterItemCards = listOf_0([new FlareCard(0), new FlareCard(1), new SmokeBombCard(0), new SmokeBombCard(1), new HexingTrapCard(0), new HexingTrapCard(1), new HexingTrapCard(2), new FireTrapCard(0), new FireTrapCard(1), new FireTrapCard(2), new ShriekerTrapCard(0), new ShriekerTrapCard(1), new OutpostCard(0), new OutpostCard(1), new WolfsbaneCard(0), new WolfsbaneCard(1), new HuntersRestCard(0), new HuntersRestCard(1), new HuntersBellCard(0), new HuntersBellCard(1), new HuntersPassageCard(0), new HuntersPassageCard(1), GrapeshotCard_getInstance(), AurorasPassage_getInstance(), BladeOfValhCard_getInstance()]);
  }
}
function GameSetupState$Companion$$childSerializers$_anonymous__57vero() {
  return Companion_instance_214.a2g();
}
function GameSetupState$Companion$$childSerializers$_anonymous__57vero_0() {
  return Companion_getInstance_217().a2g();
}
function GameSetupState$Companion$$childSerializers$_anonymous__57vero_1() {
  return new ArrayListSerializer(Companion_instance_92.a2g());
}
function GameSetupState$Companion$$childSerializers$_anonymous__57vero_2() {
  return new ArrayListSerializer(Companion_instance_380.a2g());
}
var Companion_instance_240;
function Companion_getInstance_241() {
  if (Companion_instance_240 === VOID)
    new Companion_240();
  return Companion_instance_240;
}
var $serializer_instance_198;
function $serializer_getInstance_198() {
  if ($serializer_instance_198 === VOID)
    new $serializer_199();
  return $serializer_instance_198;
}
function DestroyRecord$Companion$$childSerializers$_anonymous__6kjatb() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function DestroyRecord$Companion$$childSerializers$_anonymous__6kjatb_0() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function DestroyRecord$Companion$$childSerializers$_anonymous__6kjatb_1() {
  return createSimpleEnumSerializer('steelart.beast.DestroyReason', values_7());
}
var Companion_instance_241;
function Companion_getInstance_242() {
  if (Companion_instance_241 === VOID)
    new Companion_241();
  return Companion_instance_241;
}
var $serializer_instance_199;
function $serializer_getInstance_199() {
  if ($serializer_instance_199 === VOID)
    new $serializer_200();
  return $serializer_instance_199;
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn() {
  return Companion_instance_214.a2g();
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_0() {
  return new ArrayListSerializer(Companion_instance_222.a2g());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_1() {
  return Companion_instance_225.a2g();
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_2() {
  return new LinkedHashMapSerializer($serializer_getInstance_136(), $serializer_getInstance_308());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_3() {
  return new ArrayListSerializer($serializer_364.y2o(Companion_instance_128.a2g()));
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_4() {
  return new LinkedHashMapSerializer($serializer_getInstance_100(), createSimpleEnumSerializer('steelart.beast.LocationType', values_2()));
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_5() {
  return new LinkedHashSetSerializer(Companion_instance_442.a2g());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_6() {
  return new LinkedHashMapSerializer(Companion_instance_442.a2g(), get_nullable($serializer_getInstance_100()));
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_7() {
  return new LinkedHashSetSerializer(Companion_instance_442.a2g());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_8() {
  return new LinkedHashSetSerializer(Companion_instance_146.a2g());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_9() {
  return new LinkedHashSetSerializer(Companion_instance_146.a2g());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_10() {
  return new LinkedHashSetSerializer(Companion_instance_129.a2g());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_11() {
  return new LinkedHashSetSerializer(Companion_instance_130.a2g());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_12() {
  return new ArrayListSerializer($serializer_getInstance_124());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_13() {
  return new LinkedHashMapSerializer(createSimpleEnumSerializer('steelart.beast.Zone', values_1()), new LinkedHashSetSerializer(Companion_instance_399.a2g()));
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_14() {
  return new LinkedHashMapSerializer(Companion_instance_399.a2g(), $serializer_getInstance_342());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_15() {
  return new LinkedHashMapSerializer(Companion_instance_81.a2g(), $serializer_getInstance_100());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_16() {
  return new LinkedHashMapSerializer($serializer_getInstance_100(), $serializer_getInstance_183());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_17() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_18() {
  return new ArrayListSerializer($serializer_getInstance_199());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_19() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function GameStateImpl$Companion$$childSerializers$_anonymous__ogn0tn_20() {
  return new LinkedHashMapSerializer($serializer_getInstance_183(), $serializer_getInstance_206());
}
function nextEntryId($this) {
  // Inline function 'kotlin.also' call
  var this_0 = new EntityId(_EntityId___init__impl__cq1mhp($this.i39_1));
  this_0.c3y_1;
  $this.i39_1 = $this.i39_1 + 1 | 0;
  return this_0.c3y_1;
}
var Companion_instance_242;
function Companion_getInstance_243() {
  if (Companion_instance_242 === VOID)
    new Companion_242();
  return Companion_instance_242;
}
var $serializer_instance_200;
function $serializer_getInstance_200() {
  if ($serializer_instance_200 === VOID)
    new $serializer_201();
  return $serializer_instance_200;
}
function get_locationType($context_GameState_t6qee5, _this__u8e3s4) {
  return ensureNotNull(get_locationTypes($context_GameState_t6qee5).w4(new BoardPosition(_this__u8e3s4)));
}
var Companion_instance_243;
function Companion_getInstance_244() {
  return Companion_instance_243;
}
var $serializer_instance_201;
function $serializer_getInstance_201() {
  if ($serializer_instance_201 === VOID)
    new $serializer_202();
  return $serializer_instance_201;
}
function DraftState$Companion$$childSerializers$_anonymous__w7cg56() {
  return new ArrayListSerializer(new LinkedHashSetSerializer(Companion_instance_146.a2g()));
}
function DraftState$Companion$$childSerializers$_anonymous__w7cg56_0() {
  return new ArrayListSerializer(new ArrayListSerializer(Companion_instance_146.a2g()));
}
function DraftState$Companion$$childSerializers$_anonymous__w7cg56_1() {
  return new ArrayListSerializer(new LinkedHashSetSerializer(Companion_instance_146.a2g()));
}
function DraftState$Companion$$childSerializers$_anonymous__w7cg56_2() {
  return new LinkedHashSetSerializer(IntSerializer_getInstance());
}
function DraftState$Companion$$childSerializers$_anonymous__w7cg56_3() {
  return Companion_getInstance_250().a2g();
}
var Companion_instance_244;
function Companion_getInstance_245() {
  if (Companion_instance_244 === VOID)
    new Companion_244();
  return Companion_instance_244;
}
var $serializer_instance_202;
function $serializer_getInstance_202() {
  if ($serializer_instance_202 === VOID)
    new $serializer_203();
  return $serializer_instance_202;
}
function HunterItems$Companion$$childSerializers$_anonymous__fgtnli() {
  return new ArrayListSerializer(Companion_instance_388.a2g());
}
function HunterItems$Companion$$childSerializers$_anonymous__fgtnli_0() {
  return new LinkedHashSetSerializer(Companion_instance_388.a2g());
}
function HunterItems$Companion$$childSerializers$_anonymous__fgtnli_1() {
  return new ArrayListSerializer(Companion_instance_388.a2g());
}
var Companion_instance_245;
function Companion_getInstance_246() {
  if (Companion_instance_245 === VOID)
    new Companion_245();
  return Companion_instance_245;
}
var $serializer_instance_203;
function $serializer_getInstance_203() {
  if ($serializer_instance_203 === VOID)
    new $serializer_204();
  return $serializer_instance_203;
}
function BeastlyTalents$Companion$$childSerializers$_anonymous__v0o6q9() {
  return new ArrayListSerializer(Companion_instance_97.a2g());
}
function BeastlyTalents$Companion$$childSerializers$_anonymous__v0o6q9_0() {
  return new LinkedHashSetSerializer(Companion_instance_97.a2g());
}
function BeastlyTalents$Companion$$childSerializers$_anonymous__v0o6q9_1() {
  return new ArrayListSerializer(Companion_instance_97.a2g());
}
var Companion_instance_246;
function Companion_getInstance_247() {
  if (Companion_instance_246 === VOID)
    new Companion_246();
  return Companion_instance_246;
}
var $serializer_instance_204;
function $serializer_getInstance_204() {
  if ($serializer_instance_204 === VOID)
    new $serializer_205();
  return $serializer_instance_204;
}
function AshRuins$Companion$$childSerializers$_anonymous__vsmytn() {
  return new ArrayListSerializer(Companion_instance_82.a2g());
}
function AshRuins$Companion$$childSerializers$_anonymous__vsmytn_0() {
  return new LinkedHashSetSerializer(Companion_instance_82.a2g());
}
function AshRuins$Companion$$childSerializers$_anonymous__vsmytn_1() {
  return new ArrayListSerializer(Companion_instance_82.a2g());
}
var Companion_instance_247;
function Companion_getInstance_248() {
  if (Companion_instance_247 === VOID)
    new Companion_247();
  return Companion_instance_247;
}
var $serializer_instance_205;
function $serializer_getInstance_205() {
  if ($serializer_instance_205 === VOID)
    new $serializer_206();
  return $serializer_instance_205;
}
function KnownInfo$Companion$$childSerializers$_anonymous__2q1srd() {
  return new LinkedHashMapSerializer(Companion_instance_250.a2g(), new LinkedHashSetSerializer(Companion_instance_442.a2g()));
}
var Companion_instance_248;
function Companion_getInstance_249() {
  if (Companion_instance_248 === VOID)
    new Companion_248();
  return Companion_instance_248;
}
var $serializer_instance_206;
function $serializer_getInstance_206() {
  if ($serializer_instance_206 === VOID)
    new $serializer_207();
  return $serializer_instance_206;
}
var ArsenalType_BeastsArsenal_instance;
var ArsenalType_HuntersArsenal_instance;
var ArsenalType_AshRuinsArsenal_instance;
function values_6() {
  return [ArsenalType_BeastsArsenal_getInstance(), ArsenalType_HuntersArsenal_getInstance(), ArsenalType_AshRuinsArsenal_getInstance()];
}
function get_entries_2() {
  if ($ENTRIES_2 == null)
    $ENTRIES_2 = enumEntries(values_6());
  return $ENTRIES_2;
}
var ArsenalType_entriesInitialized;
function ArsenalType_initEntries() {
  if (ArsenalType_entriesInitialized)
    return Unit_instance;
  ArsenalType_entriesInitialized = true;
  ArsenalType_BeastsArsenal_instance = new ArsenalType('BeastsArsenal', 0);
  ArsenalType_HuntersArsenal_instance = new ArsenalType('HuntersArsenal', 1);
  ArsenalType_AshRuinsArsenal_instance = new ArsenalType('AshRuinsArsenal', 2);
}
var $ENTRIES_2;
var DestroyReason_DestroyByDamage_instance;
var DestroyReason_ObjectWillBeReplaced_instance;
function values_7() {
  return [DestroyReason_DestroyByDamage_getInstance(), DestroyReason_ObjectWillBeReplaced_getInstance()];
}
var DestroyReason_entriesInitialized;
function DestroyReason_initEntries() {
  if (DestroyReason_entriesInitialized)
    return Unit_instance;
  DestroyReason_entriesInitialized = true;
  DestroyReason_DestroyByDamage_instance = new DestroyReason('DestroyByDamage', 0);
  DestroyReason_ObjectWillBeReplaced_instance = new DestroyReason('ObjectWillBeReplaced', 1);
}
function _get_$cachedSerializer__te6jhj_266($this) {
  return $this.k4m_1.k3();
}
function TwoPlayerDraftStage$Companion$_anonymous__prcwg5() {
  return createSimpleEnumSerializer('steelart.beast.TwoPlayerDraftStage', values_8());
}
var TwoPlayerDraftStage_Collecting_instance;
var TwoPlayerDraftStage_Dividing_instance;
function values_8() {
  return [TwoPlayerDraftStage_Collecting_getInstance(), TwoPlayerDraftStage_Dividing_getInstance()];
}
var Companion_instance_249;
function Companion_getInstance_250() {
  TwoPlayerDraftStage_initEntries();
  if (Companion_instance_249 === VOID)
    new Companion_249();
  return Companion_instance_249;
}
var TwoPlayerDraftStage_entriesInitialized;
function TwoPlayerDraftStage_initEntries() {
  if (TwoPlayerDraftStage_entriesInitialized)
    return Unit_instance;
  TwoPlayerDraftStage_entriesInitialized = true;
  TwoPlayerDraftStage_Collecting_instance = new TwoPlayerDraftStage('Collecting', 0);
  TwoPlayerDraftStage_Dividing_instance = new TwoPlayerDraftStage('Dividing', 1);
  Companion_getInstance_250();
}
function get_aliveHunters(_this__u8e3s4) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_allHunters(_this__u8e3s4);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (get_isAlive(_this__u8e3s4, element)) {
      destination.d2(element);
    }
  }
  return destination;
}
function objectsAt(_this__u8e3s4, position) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = _this__u8e3s4.f4l();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.s2w(_this__u8e3s4) === position) {
      destination.d2(element);
    }
  }
  return destination;
}
function get_isSharedBeastHpGame($context_GameState_t6qee5) {
  return get_gameRules($context_GameState_t6qee5).j3a() === 2;
}
function get_place($context_GameState_t6qee5, _this__u8e3s4) {
  var tmp0_elvis_lhs = get_placeOrNull($context_GameState_t6qee5, _this__u8e3s4);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'No place found for card ' + toString(_this__u8e3s4);
    throw IllegalStateException.o(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function calculateCheckCode(_this__u8e3s4) {
  return new GameStateCheckCode(stableHashCode(_this__u8e3s4));
}
function get_allHunters(_this__u8e3s4) {
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = _this__u8e3s4.h4k();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType(_this__u8e3s4, element);
      if (isInterface(tmp, HunterCharacter)) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return destination;
}
function get_placeOrNull(gameState, _this__u8e3s4) {
  var card = _this__u8e3s4;
  if (get_cardsInPlay(gameState).u4(card)) {
    return InPlayPlace_getInstance();
  }
  if (gameState.j4k().w2(card)) {
    return PendingTriggerPlace_getInstance();
  }
  var _iterator__ex2g4s = get_charactersInOrder(gameState).p1();
  while (_iterator__ex2g4s.q1()) {
    var characterObject = _iterator__ex2g4s.r1();
    if (get_hand(gameState, characterObject).w2(card)) {
      return new HandPlace(characterObject);
    }
    if (get_discardedAbilityCards(gameState, characterObject).w2(card)) {
      return DiscardPlace_getInstance();
    }
  }
  if (contains(get_discardedDraftActionCards(gameState), card)) {
    return DiscardPlace_getInstance();
  }
  var tmp0_safe_receiver = get_draftState(gameState);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var iterator = get_charactersInOrder(gameState).p1();
    var index = 0;
    while (iterator.q1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var character = iterator.r1();
      if (contains(tmp0_safe_receiver.o4m_1.u2(index_0), card))
        return new DraftOfferPlace(character);
      if (contains(tmp0_safe_receiver.p4m_1.u2(index_0), card))
        return new DraftPickedPlace(character);
      if (contains(tmp0_safe_receiver.q4m_1.u2(index_0), card))
        return new DraftRemovedPlace(character);
    }
  }
  if (contains(get_unusedDraftActionCards(gameState), card)) {
    return UnusedDraftActionCardPlace_getInstance();
  }
  var _iterator__ex2g4s_0 = get_entries_2().p1();
  while (_iterator__ex2g4s_0.q1()) {
    var arsenalType = _iterator__ex2g4s_0.r1();
    var arsenal = getArsenal(gameState, arsenalType);
    if (contains(arsenal.h4n(), card)) {
      return DiscardPlace_getInstance();
    }
    if (contains(arsenal.e36(), card)) {
      return RevealedArsenalPlace_getInstance();
    }
    if (contains(arsenal.d36(), card)) {
      return ComingArsenalPlace_getInstance();
    }
  }
  // Inline function 'kotlin.collections.get' call
  var this_0 = get_placedTrapsFullInfo(gameState);
  var tmp1_safe_receiver = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w4(card);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return new TrapZonePlace(tmp1_safe_receiver.g4o_1);
  }
  return null;
}
function characterObject(_this__u8e3s4, character) {
  // Inline function 'kotlin.collections.single' call
  var single = null;
  var found = false;
  var _iterator__ex2g4s = _this__u8e3s4.h4k().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (equals(get_objectType(_this__u8e3s4, element), character)) {
      if (found)
        throw IllegalArgumentException.h2('Collection contains more than one matching element.');
      single = element;
      found = true;
    }
  }
  if (!found)
    throw NoSuchElementException.a2('Collection contains no element matching the predicate.');
  return single;
}
function get_sharedBeastHp(_this__u8e3s4) {
  return get_maxSharedBeastHp(_this__u8e3s4) - get_sharedBeastWounds(_this__u8e3s4) | 0;
}
function get_aliveBeasts(_this__u8e3s4) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = _this__u8e3s4.h4k();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (get_isAlive(_this__u8e3s4, element)) {
      destination.d2(element);
    }
  }
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var tmp$ret$9;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType(_this__u8e3s4, element_0);
      if (isInterface(tmp, BeastCharacter)) {
        tmp$ret$9 = element_0 instanceof ObjectOnBoard ? element_0 : THROW_CCE();
        break $l$block;
      }
      tmp$ret$9 = null;
    }
    var tmp0_safe_receiver = tmp$ret$9;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.d2(tmp0_safe_receiver);
    }
  }
  return destination_0;
}
function get_settlements(_this__u8e3s4) {
  // Inline function 'kotlin.collections.filterValues' call
  var this_0 = _this__u8e3s4.i4k();
  var result = LinkedHashMap.m7();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this_0.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var entry = _iterator__ex2g4s.r1();
    if (entry.k3().equals(LocationType_Settlement_getInstance())) {
      result.b5(entry.j3(), entry.k3());
    }
  }
  return result.x4();
}
function get_maxSharedBeastHp($context_GameState_t6qee5) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = get_aliveBeasts_0($context_GameState_t6qee5).p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp = sum;
    sum = tmp + get_objectType($context_GameState_t6qee5, element).n2z($context_GameState_t6qee5) | 0;
  }
  return sum - 2 | 0;
}
function get_sharedBeastWounds($context_GameState_t6qee5) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = get_aliveBeasts_0($context_GameState_t6qee5).p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp = sum;
    sum = tmp + get_wounds($context_GameState_t6qee5, element) | 0;
  }
  return sum;
}
function get_allBoats($context_GameState_t6qee5) {
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof BoatType) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return destination;
}
function get_allWatchtowers(_this__u8e3s4) {
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = _this__u8e3s4.f4l();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType(_this__u8e3s4, element);
      if (tmp instanceof WatchtowerType) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return destination;
}
function get_fullArsenalDeck($context_GameState_t6qee5, _this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.w1_1) {
    case 1:
      tmp = get_gameRules($context_GameState_t6qee5).y3a();
      break;
    case 0:
      tmp = get_gameRules($context_GameState_t6qee5).z3a();
      break;
    case 2:
      tmp = get_gameRules($context_GameState_t6qee5).a3b();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function get_arsenalType($context_GameState_t6qee5, _this__u8e3s4) {
  var tmp0_subject = get_gameTeam($context_GameState_t6qee5, _this__u8e3s4);
  var tmp;
  if (tmp0_subject === get_beastsGameTeam()) {
    tmp = ArsenalType_BeastsArsenal_getInstance();
  } else if (tmp0_subject === get_huntersGameTeam()) {
    tmp = ArsenalType_HuntersArsenal_getInstance();
  } else {
    // Inline function 'kotlin.error' call
    var message = 'No arsenal type for ' + _this__u8e3s4.toString();
    throw IllegalStateException.o(toString(message));
  }
  return tmp;
}
function ArsenalType_BeastsArsenal_getInstance() {
  ArsenalType_initEntries();
  return ArsenalType_BeastsArsenal_instance;
}
function ArsenalType_HuntersArsenal_getInstance() {
  ArsenalType_initEntries();
  return ArsenalType_HuntersArsenal_instance;
}
function ArsenalType_AshRuinsArsenal_getInstance() {
  ArsenalType_initEntries();
  return ArsenalType_AshRuinsArsenal_instance;
}
function DestroyReason_DestroyByDamage_getInstance() {
  DestroyReason_initEntries();
  return DestroyReason_DestroyByDamage_instance;
}
function DestroyReason_ObjectWillBeReplaced_getInstance() {
  DestroyReason_initEntries();
  return DestroyReason_ObjectWillBeReplaced_instance;
}
function TwoPlayerDraftStage_Collecting_getInstance() {
  TwoPlayerDraftStage_initEntries();
  return TwoPlayerDraftStage_Collecting_instance;
}
function TwoPlayerDraftStage_Dividing_getInstance() {
  TwoPlayerDraftStage_initEntries();
  return TwoPlayerDraftStage_Dividing_instance;
}
function get_skipNextTurnKey() {
  _init_properties_GameStateChange_kt__qbnioz();
  return skipNextTurnKey;
}
var skipNextTurnKey;
var Companion_instance_250;
function Companion_getInstance_251() {
  return Companion_instance_250;
}
function _get_$cachedSerializer__te6jhj_267($this) {
  return $this.l4o_1.k3();
}
function ComingArsenalPlace$_anonymous__plposl() {
  var tmp = ComingArsenalPlace_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ComingArsenalPlace', tmp, tmp$ret$0);
}
var ComingArsenalPlace_instance;
function ComingArsenalPlace_getInstance() {
  if (ComingArsenalPlace_instance === VOID)
    new ComingArsenalPlace();
  return ComingArsenalPlace_instance;
}
function _get_$cachedSerializer__te6jhj_268($this) {
  return $this.m4o_1.k3();
}
function DiscardPlace$_anonymous__xq6rf2() {
  var tmp = DiscardPlace_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DiscardPlace', tmp, tmp$ret$0);
}
var DiscardPlace_instance;
function DiscardPlace_getInstance() {
  if (DiscardPlace_instance === VOID)
    new DiscardPlace();
  return DiscardPlace_instance;
}
function DraftOfferPlace$Companion$$childSerializers$_anonymous__ght8ta() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_251;
function Companion_getInstance_252() {
  if (Companion_instance_251 === VOID)
    new Companion_251();
  return Companion_instance_251;
}
var $serializer_instance_207;
function $serializer_getInstance_207() {
  if ($serializer_instance_207 === VOID)
    new $serializer_208();
  return $serializer_instance_207;
}
function DraftPickedPlace$Companion$$childSerializers$_anonymous__61i47w() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_252;
function Companion_getInstance_253() {
  if (Companion_instance_252 === VOID)
    new Companion_252();
  return Companion_instance_252;
}
var $serializer_instance_208;
function $serializer_getInstance_208() {
  if ($serializer_instance_208 === VOID)
    new $serializer_209();
  return $serializer_instance_208;
}
function DraftRemovedPlace$Companion$$childSerializers$_anonymous__wv89jy() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_253;
function Companion_getInstance_254() {
  if (Companion_instance_253 === VOID)
    new Companion_253();
  return Companion_instance_253;
}
var $serializer_instance_209;
function $serializer_getInstance_209() {
  if ($serializer_instance_209 === VOID)
    new $serializer_210();
  return $serializer_instance_209;
}
function HandPlace$Companion$$childSerializers$_anonymous__885isu() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_254;
function Companion_getInstance_255() {
  if (Companion_instance_254 === VOID)
    new Companion_254();
  return Companion_instance_254;
}
var $serializer_instance_210;
function $serializer_getInstance_210() {
  if ($serializer_instance_210 === VOID)
    new $serializer_211();
  return $serializer_instance_210;
}
function _get_$cachedSerializer__te6jhj_269($this) {
  return $this.h4p_1.k3();
}
function InPlayPlace$_anonymous__c28ho7() {
  var tmp = InPlayPlace_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('InPlayPlace', tmp, tmp$ret$0);
}
var InPlayPlace_instance;
function InPlayPlace_getInstance() {
  if (InPlayPlace_instance === VOID)
    new InPlayPlace();
  return InPlayPlace_instance;
}
function _get_$cachedSerializer__te6jhj_270($this) {
  return $this.i4p_1.k3();
}
function PendingTriggerPlace$_anonymous__ng7fsh() {
  var tmp = PendingTriggerPlace_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PendingTriggerPlace', tmp, tmp$ret$0);
}
var PendingTriggerPlace_instance;
function PendingTriggerPlace_getInstance() {
  if (PendingTriggerPlace_instance === VOID)
    new PendingTriggerPlace();
  return PendingTriggerPlace_instance;
}
function _get_$cachedSerializer__te6jhj_271($this) {
  return $this.j4p_1.k3();
}
function RevealedArsenalPlace$_anonymous__e2zuxm() {
  var tmp = RevealedArsenalPlace_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RevealedArsenalPlace', tmp, tmp$ret$0);
}
var RevealedArsenalPlace_instance;
function RevealedArsenalPlace_getInstance() {
  if (RevealedArsenalPlace_instance === VOID)
    new RevealedArsenalPlace();
  return RevealedArsenalPlace_instance;
}
function TrapZonePlace$Companion$$childSerializers$_anonymous__372pwk() {
  return createSimpleEnumSerializer('steelart.beast.Zone', values_1());
}
var Companion_instance_255;
function Companion_getInstance_256() {
  if (Companion_instance_255 === VOID)
    new Companion_255();
  return Companion_instance_255;
}
var $serializer_instance_211;
function $serializer_getInstance_211() {
  if ($serializer_instance_211 === VOID)
    new $serializer_212();
  return $serializer_instance_211;
}
function _get_$cachedSerializer__te6jhj_272($this) {
  return $this.p4p_1.k3();
}
function UnusedDraftActionCardPlace$_anonymous__nrr5of() {
  var tmp = UnusedDraftActionCardPlace_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UnusedDraftActionCardPlace', tmp, tmp$ret$0);
}
var UnusedDraftActionCardPlace_instance;
function UnusedDraftActionCardPlace_getInstance() {
  if (UnusedDraftActionCardPlace_instance === VOID)
    new UnusedDraftActionCardPlace();
  return UnusedDraftActionCardPlace_instance;
}
var Companion_instance_256;
function Companion_getInstance_257() {
  return Companion_instance_256;
}
function AddTrapInfoChange$Companion$$childSerializers$_anonymous__3x6wte() {
  return Companion_instance_399.a2g();
}
function AddTrapInfoChange$Companion$$childSerializers$_anonymous__3x6wte_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
function AddTrapInfoChange$Companion$$childSerializers$_anonymous__3x6wte_1() {
  return createSimpleEnumSerializer('steelart.beast.Zone', values_1());
}
function AddTrapInfoChange$Companion$$childSerializers$_anonymous__3x6wte_2() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_257;
function Companion_getInstance_258() {
  if (Companion_instance_257 === VOID)
    new Companion_257();
  return Companion_instance_257;
}
var $serializer_instance_212;
function $serializer_getInstance_212() {
  if ($serializer_instance_212 === VOID)
    new $serializer_213();
  return $serializer_instance_212;
}
function AncientPowersChangeEvent$Companion$$childSerializers$_anonymous__ktlhye() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_258;
function Companion_getInstance_259() {
  if (Companion_instance_258 === VOID)
    new Companion_258();
  return Companion_instance_258;
}
var $serializer_instance_213;
function $serializer_getInstance_213() {
  if ($serializer_instance_213 === VOID)
    new $serializer_214();
  return $serializer_instance_213;
}
function DamageBlockChange$Companion$$childSerializers$_anonymous__l280g4() {
  return new ArrayListSerializer($serializer_getInstance_124());
}
var Companion_instance_259;
function Companion_getInstance_260() {
  if (Companion_instance_259 === VOID)
    new Companion_259();
  return Companion_instance_259;
}
var $serializer_instance_214;
function $serializer_getInstance_214() {
  if ($serializer_instance_214 === VOID)
    new $serializer_215();
  return $serializer_instance_214;
}
function FirePositionsChange$Companion$$childSerializers$_anonymous__2iy0ca() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_260;
function Companion_getInstance_261() {
  if (Companion_instance_260 === VOID)
    new Companion_260();
  return Companion_instance_260;
}
var $serializer_instance_215;
function $serializer_getInstance_215() {
  if ($serializer_instance_215 === VOID)
    new $serializer_216();
  return $serializer_instance_215;
}
function GameScopesChangeEvent$Companion$$childSerializers$_anonymous__z8deun() {
  return new ArrayListSerializer(Companion_instance_222.a2g());
}
var Companion_instance_261;
function Companion_getInstance_262() {
  if (Companion_instance_261 === VOID)
    new Companion_261();
  return Companion_instance_261;
}
var $serializer_instance_216;
function $serializer_getInstance_216() {
  if ($serializer_instance_216 === VOID)
    new $serializer_217();
  return $serializer_instance_216;
}
function KnownCardsInfoChangeEvent$Companion$$childSerializers$_anonymous__gqqrwy() {
  return new LinkedHashSetSerializer(Companion_instance_442.a2g());
}
function KnownCardsInfoChangeEvent$Companion$$childSerializers$_anonymous__gqqrwy_0() {
  return Companion_instance_250.a2g();
}
function KnownCardsInfoChangeEvent$Companion$$childSerializers$_anonymous__gqqrwy_1() {
  return createSimpleEnumSerializer('steelart.utils.CollectionOperation', values_16());
}
var Companion_instance_262;
function Companion_getInstance_263() {
  if (Companion_instance_262 === VOID)
    new Companion_262();
  return Companion_instance_262;
}
var $serializer_instance_217;
function $serializer_getInstance_217() {
  if ($serializer_instance_217 === VOID)
    new $serializer_218();
  return $serializer_instance_217;
}
function OpenArsenalCardsToDealChangeNumberEvent$Companion$$childSerializers$_anonymous__rsbhd3() {
  return createSimpleEnumSerializer('steelart.beast.ArsenalType', values_6());
}
var Companion_instance_263;
function Companion_getInstance_264() {
  if (Companion_instance_263 === VOID)
    new Companion_263();
  return Companion_instance_263;
}
var $serializer_instance_218;
function $serializer_getInstance_218() {
  if ($serializer_instance_218 === VOID)
    new $serializer_219();
  return $serializer_instance_218;
}
function RemoveTrapInfoChange$Companion$$childSerializers$_anonymous__u11f23() {
  return Companion_instance_399.a2g();
}
var Companion_instance_264;
function Companion_getInstance_265() {
  if (Companion_instance_264 === VOID)
    new Companion_264();
  return Companion_instance_264;
}
var $serializer_instance_219;
function $serializer_getInstance_219() {
  if ($serializer_instance_219 === VOID)
    new $serializer_220();
  return $serializer_instance_219;
}
var Companion_instance_265;
function Companion_getInstance_266() {
  return Companion_instance_265;
}
var $serializer_instance_220;
function $serializer_getInstance_220() {
  if ($serializer_instance_220 === VOID)
    new $serializer_221();
  return $serializer_instance_220;
}
function SetBeastMovementInfoAndTrailsChange$Companion$$childSerializers$_anonymous__zc6rlc() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function SetBeastMovementInfoAndTrailsChange$Companion$$childSerializers$_anonymous__zc6rlc_0() {
  return new ArrayListSerializer($serializer_getInstance_82());
}
function SetBeastMovementInfoAndTrailsChange$Companion$$childSerializers$_anonymous__zc6rlc_1() {
  return new ArrayListSerializer($serializer_getInstance_83());
}
function SetBeastMovementInfoAndTrailsChange$Companion$$childSerializers$_anonymous__zc6rlc_2() {
  return new LinkedHashMapSerializer($serializer_getInstance_100(), IntSerializer_getInstance());
}
var Companion_instance_266;
function Companion_getInstance_267() {
  if (Companion_instance_266 === VOID)
    new Companion_266();
  return Companion_instance_266;
}
var $serializer_instance_221;
function $serializer_getInstance_221() {
  if ($serializer_instance_221 === VOID)
    new $serializer_222();
  return $serializer_instance_221;
}
var Companion_instance_267;
function Companion_getInstance_268() {
  return Companion_instance_267;
}
var $serializer_instance_222;
function $serializer_getInstance_222() {
  if ($serializer_instance_222 === VOID)
    new $serializer_223();
  return $serializer_instance_222;
}
var Companion_instance_268;
function Companion_getInstance_269() {
  return Companion_instance_268;
}
var $serializer_instance_223;
function $serializer_getInstance_223() {
  if ($serializer_instance_223 === VOID)
    new $serializer_224();
  return $serializer_instance_223;
}
function SetCurrentPhaseEvent$Companion$$childSerializers$_anonymous__vyh9o4() {
  return Companion_instance_225.a2g();
}
var Companion_instance_269;
function Companion_getInstance_270() {
  if (Companion_instance_269 === VOID)
    new Companion_269();
  return Companion_instance_269;
}
var $serializer_instance_224;
function $serializer_getInstance_224() {
  if ($serializer_instance_224 === VOID)
    new $serializer_225();
  return $serializer_instance_224;
}
var Companion_instance_270;
function Companion_getInstance_271() {
  return Companion_instance_270;
}
var $serializer_instance_225;
function $serializer_getInstance_225() {
  if ($serializer_instance_225 === VOID)
    new $serializer_226();
  return $serializer_instance_225;
}
function SkipNextTurnStatusChangeEvent$Companion$$childSerializers$_anonymous__8vvs9t() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_271;
function Companion_getInstance_272() {
  if (Companion_instance_271 === VOID)
    new Companion_271();
  return Companion_instance_271;
}
var $serializer_instance_226;
function $serializer_getInstance_226() {
  if ($serializer_instance_226 === VOID)
    new $serializer_227();
  return $serializer_instance_226;
}
function TrailsRevealedChange$Companion$$childSerializers$_anonymous__4t2pun() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function TrailsRevealedChange$Companion$$childSerializers$_anonymous__4t2pun_0() {
  return new LinkedHashMapSerializer($serializer_getInstance_100(), IntSerializer_getInstance());
}
var Companion_instance_272;
function Companion_getInstance_273() {
  if (Companion_instance_272 === VOID)
    new Companion_272();
  return Companion_instance_272;
}
var $serializer_instance_227;
function $serializer_getInstance_227() {
  if ($serializer_instance_227 === VOID)
    new $serializer_228();
  return $serializer_instance_227;
}
function TransformSimpleObjectChangeEvent$Companion$$childSerializers$_anonymous__hfpi6b() {
  return $serializer_364.y2o(Companion_instance_423.a2g());
}
function TransformSimpleObjectChangeEvent$Companion$$childSerializers$_anonymous__hfpi6b_0() {
  return Companion_instance_423.a2g();
}
var Companion_instance_273;
function Companion_getInstance_274() {
  if (Companion_instance_273 === VOID)
    new Companion_273();
  return Companion_instance_273;
}
var $serializer_instance_228;
function $serializer_getInstance_228() {
  if ($serializer_instance_228 === VOID)
    new $serializer_229();
  return $serializer_instance_228;
}
function ArmorChange$Companion$$childSerializers$_anonymous__flcknv() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_274;
function Companion_getInstance_275() {
  if (Companion_instance_274 === VOID)
    new Companion_274();
  return Companion_instance_274;
}
var $serializer_instance_229;
function $serializer_getInstance_229() {
  if ($serializer_instance_229 === VOID)
    new $serializer_230();
  return $serializer_instance_229;
}
function AddObjectChange$Companion$$childSerializers$_anonymous__bsmrae() {
  return Companion_instance_420.a2g();
}
var Companion_instance_275;
function Companion_getInstance_276() {
  if (Companion_instance_275 === VOID)
    new Companion_275();
  return Companion_instance_275;
}
var $serializer_instance_230;
function $serializer_getInstance_230() {
  if ($serializer_instance_230 === VOID)
    new $serializer_231();
  return $serializer_instance_230;
}
function _get_$cachedSerializer__te6jhj_273($this) {
  return $this.z4t_1.k3();
}
function AddNewCharacterToOrderChange$_anonymous__sr8rzy() {
  var tmp = AddNewCharacterToOrderChange_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AddNewCharacterToOrderChange', tmp, tmp$ret$0);
}
var AddNewCharacterToOrderChange_instance;
function AddNewCharacterToOrderChange_getInstance() {
  if (AddNewCharacterToOrderChange_instance === VOID)
    new AddNewCharacterToOrderChange();
  return AddNewCharacterToOrderChange_instance;
}
function HpChange$Companion$$childSerializers$_anonymous__ytsazy() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_276;
function Companion_getInstance_277() {
  if (Companion_instance_276 === VOID)
    new Companion_276();
  return Companion_instance_276;
}
var $serializer_instance_231;
function $serializer_getInstance_231() {
  if ($serializer_instance_231 === VOID)
    new $serializer_232();
  return $serializer_instance_231;
}
var Companion_instance_277;
function Companion_getInstance_278() {
  return Companion_instance_277;
}
var $serializer_instance_232;
function $serializer_getInstance_232() {
  if ($serializer_instance_232 === VOID)
    new $serializer_233();
  return $serializer_instance_232;
}
function FirstPassPlayerChange$Companion$$childSerializers$_anonymous__v2dqm0() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_278;
function Companion_getInstance_279() {
  if (Companion_instance_278 === VOID)
    new Companion_278();
  return Companion_instance_278;
}
var $serializer_instance_233;
function $serializer_getInstance_233() {
  if ($serializer_instance_233 === VOID)
    new $serializer_234();
  return $serializer_instance_233;
}
function DestroyedChange$Companion$$childSerializers$_anonymous__nkgbb5() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function DestroyedChange$Companion$$childSerializers$_anonymous__nkgbb5_0() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function DestroyedChange$Companion$$childSerializers$_anonymous__nkgbb5_1() {
  return createSimpleEnumSerializer('steelart.beast.DestroyReason', values_7());
}
var Companion_instance_279;
function Companion_getInstance_280() {
  if (Companion_instance_279 === VOID)
    new Companion_279();
  return Companion_instance_279;
}
var $serializer_instance_234;
function $serializer_getInstance_234() {
  if ($serializer_instance_234 === VOID)
    new $serializer_235();
  return $serializer_instance_234;
}
function CardsMoveChange$Companion$$childSerializers$_anonymous__bojyuy() {
  return Companion_instance_250.a2g();
}
function CardsMoveChange$Companion$$childSerializers$_anonymous__bojyuy_0() {
  return Companion_instance_250.a2g();
}
function CardsMoveChange$Companion$$childSerializers$_anonymous__bojyuy_1() {
  return new LinkedHashSetSerializer(Companion_instance_442.a2g());
}
var Companion_instance_280;
function Companion_getInstance_281() {
  if (Companion_instance_280 === VOID)
    new Companion_280();
  return Companion_instance_280;
}
var $serializer_instance_235;
function $serializer_getInstance_235() {
  if ($serializer_instance_235 === VOID)
    new $serializer_236();
  return $serializer_instance_235;
}
function CardsMoveChange$revertChange$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.pm_1;
  var tmp$ret$2 = b.pm_1;
  return compareValues(tmp, tmp$ret$2);
}
function GrudgesChange$Companion$$childSerializers$_anonymous__5sampt() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_281;
function Companion_getInstance_282() {
  if (Companion_instance_281 === VOID)
    new Companion_281();
  return Companion_instance_281;
}
var $serializer_instance_236;
function $serializer_getInstance_236() {
  if ($serializer_instance_236 === VOID)
    new $serializer_237();
  return $serializer_instance_236;
}
function MovementChange$Companion$$childSerializers$_anonymous__yjbxud() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function MovementChange$Companion$$childSerializers$_anonymous__yjbxud_0() {
  return new ArrayListSerializer($serializer_getInstance_100());
}
var Companion_instance_282;
function Companion_getInstance_283() {
  if (Companion_instance_282 === VOID)
    new Companion_282();
  return Companion_instance_282;
}
var $serializer_instance_237;
function $serializer_getInstance_237() {
  if ($serializer_instance_237 === VOID)
    new $serializer_238();
  return $serializer_instance_237;
}
function BeastMovementInfoChange$Companion$$childSerializers$_anonymous__syf3oi() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function BeastMovementInfoChange$Companion$$childSerializers$_anonymous__syf3oi_0() {
  return new ArrayListSerializer($serializer_getInstance_82());
}
var Companion_instance_283;
function Companion_getInstance_284() {
  if (Companion_instance_283 === VOID)
    new Companion_283();
  return Companion_instance_283;
}
var $serializer_instance_238;
function $serializer_getInstance_238() {
  if ($serializer_instance_238 === VOID)
    new $serializer_239();
  return $serializer_instance_238;
}
function RemoveUpgradeChange$Companion$$childSerializers$_anonymous__b7r332() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function RemoveUpgradeChange$Companion$$childSerializers$_anonymous__b7r332_0() {
  return Companion_instance_129.a2g();
}
var Companion_instance_284;
function Companion_getInstance_285() {
  if (Companion_instance_284 === VOID)
    new Companion_284();
  return Companion_instance_284;
}
var $serializer_instance_239;
function $serializer_getInstance_239() {
  if ($serializer_instance_239 === VOID)
    new $serializer_240();
  return $serializer_instance_239;
}
function ResurrectObjectChange$Companion$$childSerializers$_anonymous__riwyi() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_285;
function Companion_getInstance_286() {
  if (Companion_instance_285 === VOID)
    new Companion_285();
  return Companion_instance_285;
}
var $serializer_instance_240;
function $serializer_getInstance_240() {
  if ($serializer_instance_240 === VOID)
    new $serializer_241();
  return $serializer_instance_240;
}
function ClearingAfterRevealChange$Companion$$childSerializers$_anonymous__6h6zy2() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_286;
function Companion_getInstance_287() {
  if (Companion_instance_286 === VOID)
    new Companion_286();
  return Companion_instance_286;
}
var $serializer_instance_241;
function $serializer_getInstance_241() {
  if ($serializer_instance_241 === VOID)
    new $serializer_242();
  return $serializer_instance_241;
}
function RevealLastMovementsChange$Companion$$childSerializers$_anonymous__9j4cjr() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function RevealLastMovementsChange$Companion$$childSerializers$_anonymous__9j4cjr_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
var Companion_instance_287;
function Companion_getInstance_288() {
  if (Companion_instance_287 === VOID)
    new Companion_287();
  return Companion_instance_287;
}
var $serializer_instance_242;
function $serializer_getInstance_242() {
  if ($serializer_instance_242 === VOID)
    new $serializer_243();
  return $serializer_instance_242;
}
function TransformLocationsChange$Companion$$childSerializers$_anonymous__y4dqbc() {
  return new LinkedHashMapSerializer($serializer_getInstance_100(), createSimpleEnumSerializer('steelart.beast.LocationType', values_2()));
}
var Companion_instance_288;
function Companion_getInstance_289() {
  if (Companion_instance_288 === VOID)
    new Companion_288();
  return Companion_instance_288;
}
var $serializer_instance_243;
function $serializer_getInstance_243() {
  if ($serializer_instance_243 === VOID)
    new $serializer_244();
  return $serializer_instance_243;
}
function UpgradeChange$Companion$$childSerializers$_anonymous__nehif6() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function UpgradeChange$Companion$$childSerializers$_anonymous__nehif6_0() {
  return Companion_instance_129.a2g();
}
var Companion_instance_289;
function Companion_getInstance_290() {
  if (Companion_instance_289 === VOID)
    new Companion_289();
  return Companion_instance_289;
}
var $serializer_instance_244;
function $serializer_getInstance_244() {
  if ($serializer_instance_244 === VOID)
    new $serializer_245();
  return $serializer_instance_244;
}
function RevertAfterClearingAfterRevealChange$Companion$$childSerializers$_anonymous__f8335q() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function RevertAfterClearingAfterRevealChange$Companion$$childSerializers$_anonymous__f8335q_0() {
  return new ArrayListSerializer($serializer_getInstance_82());
}
function RevertAfterClearingAfterRevealChange$Companion$$childSerializers$_anonymous__f8335q_1() {
  return new ArrayListSerializer($serializer_getInstance_83());
}
function RevertAfterClearingAfterRevealChange$Companion$$childSerializers$_anonymous__f8335q_2() {
  return new LinkedHashMapSerializer($serializer_getInstance_100(), IntSerializer_getInstance());
}
var Companion_instance_290;
function Companion_getInstance_291() {
  if (Companion_instance_290 === VOID)
    new Companion_290();
  return Companion_instance_290;
}
var $serializer_instance_245;
function $serializer_getInstance_245() {
  if ($serializer_instance_245 === VOID)
    new $serializer_246();
  return $serializer_instance_245;
}
function _get_$cachedSerializer__te6jhj_274($this) {
  return $this.u4x_1.k3();
}
function RevertForAddNewCharacterToOrderChange$_anonymous__j1ua93() {
  var tmp = RevertForAddNewCharacterToOrderChange_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RevertForAddNewCharacterToOrderChange', tmp, tmp$ret$0);
}
var RevertForAddNewCharacterToOrderChange_instance;
function RevertForAddNewCharacterToOrderChange_getInstance() {
  if (RevertForAddNewCharacterToOrderChange_instance === VOID)
    new RevertForAddNewCharacterToOrderChange();
  return RevertForAddNewCharacterToOrderChange_instance;
}
function _get_$cachedSerializer__te6jhj_275($this) {
  return $this.v4x_1.k3();
}
function RevertForAddObjectChange$_anonymous__iqivyk() {
  var tmp = RevertForAddObjectChange_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RevertForAddObjectChange', tmp, tmp$ret$0);
}
var RevertForAddObjectChange_instance;
function RevertForAddObjectChange_getInstance() {
  if (RevertForAddObjectChange_instance === VOID)
    new RevertForAddObjectChange();
  return RevertForAddObjectChange_instance;
}
function RevertForBeastMovementInfoChange$Companion$$childSerializers$_anonymous__w6pcil() {
  return new ArrayListSerializer($serializer_getInstance_82());
}
function RevertForBeastMovementInfoChange$Companion$$childSerializers$_anonymous__w6pcil_0() {
  return new ArrayListSerializer($serializer_getInstance_83());
}
var Companion_instance_291;
function Companion_getInstance_292() {
  if (Companion_instance_291 === VOID)
    new Companion_291();
  return Companion_instance_291;
}
var $serializer_instance_246;
function $serializer_getInstance_246() {
  if ($serializer_instance_246 === VOID)
    new $serializer_247();
  return $serializer_instance_246;
}
function _get_$cachedSerializer__te6jhj_276($this) {
  return $this.d4y_1.k3();
}
function RevertForDestroyedChange$_anonymous__f3cwc3() {
  var tmp = RevertForDestroyedChange_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RevertForDestroyedChange', tmp, tmp$ret$0);
}
var RevertForDestroyedChange_instance;
function RevertForDestroyedChange_getInstance() {
  if (RevertForDestroyedChange_instance === VOID)
    new RevertForDestroyedChange();
  return RevertForDestroyedChange_instance;
}
var Companion_instance_292;
function Companion_getInstance_293() {
  return Companion_instance_292;
}
var $serializer_instance_247;
function $serializer_getInstance_247() {
  if ($serializer_instance_247 === VOID)
    new $serializer_248();
  return $serializer_instance_247;
}
function RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo() {
  return Companion_instance_250.a2g();
}
function RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_0() {
  return Companion_instance_250.a2g();
}
function RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_1() {
  return new LinkedHashSetSerializer(Companion_instance_442.a2g());
}
function RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_2() {
  return new ArrayListSerializer(Companion_instance_388.a2g());
}
function RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_3() {
  return new ArrayListSerializer(Companion_instance_97.a2g());
}
function RevertForRandomArsenalCardsMoveChange$Companion$$childSerializers$_anonymous__dh5xjo_4() {
  return new ArrayListSerializer(Companion_instance_82.a2g());
}
var Companion_instance_293;
function Companion_getInstance_294() {
  if (Companion_instance_293 === VOID)
    new Companion_293();
  return Companion_instance_293;
}
var $serializer_instance_248;
function $serializer_getInstance_248() {
  if ($serializer_instance_248 === VOID)
    new $serializer_249();
  return $serializer_instance_248;
}
function RevertForResurrectObjectChange$Companion$$childSerializers$_anonymous__65ndcv() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_294;
function Companion_getInstance_295() {
  if (Companion_instance_294 === VOID)
    new Companion_294();
  return Companion_instance_294;
}
var $serializer_instance_249;
function $serializer_getInstance_249() {
  if ($serializer_instance_249 === VOID)
    new $serializer_250();
  return $serializer_instance_249;
}
function set_skipNextTurnImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_GameStateChange_kt__qbnioz();
  gsiCtx.j39(_this__u8e3s4.r2w_1, get_skipNextTurnKey(), new BooleanWrapper(value), new BooleanWrapper(false));
}
function get_skipNextTurn(gsCtx, _this__u8e3s4) {
  _init_properties_GameStateChange_kt__qbnioz();
  return getSkipNextTurnImpl(_this__u8e3s4, gsCtx);
}
function getSkipNextTurnImpl(_this__u8e3s4, gameState) {
  _init_properties_GameStateChange_kt__qbnioz();
  // Inline function 'kotlin.with' call
  return getGeneralPropertyWithDefault(_this__u8e3s4.l39(gameState), get_skipNextTurnKey(), new BooleanWrapper(false)).j3w_1;
}
var properties_initialized_GameStateChange_kt_gngbvj;
function _init_properties_GameStateChange_kt__qbnioz() {
  if (!properties_initialized_GameStateChange_kt_gngbvj) {
    properties_initialized_GameStateChange_kt_gngbvj = true;
    skipNextTurnKey = _GeneralMapKey___init__impl__zdmbea('skipNextTurn');
  }
}
function get_currentDayNumber(gsCtx) {
  return gsCtx.e4k();
}
function get_destroyRecords(gsCtx) {
  return gsCtx.z4k();
}
function get_destroyedObjects(gsCtx) {
  return gsCtx.g4l();
}
function get_ruinClaimingMap(gsCtx) {
  return gsCtx.u4j();
}
function direction_0(gsCtx, from, to) {
  return direction(gsCtx, from, to);
}
function get_gameScopes(gsCtx) {
  return gsCtx.c3r();
}
function get_aliveHunters_0(gsCtx) {
  return get_aliveHunters(gsCtx);
}
function get_allObjectOnBoard(gsCtx) {
  return gsCtx.f4l();
}
function get_damageDealtToBeasts(gsCtx) {
  return gsCtx.i4l();
}
function ruinsControlled_0(gsCtx, team) {
  return ruinsControlled(gsCtx, team);
}
function get_charactersInOrder(gsCtx) {
  return gsCtx.h4k();
}
function get_isClassicTwoSheepOrBoarCompleted_0(gsCtx) {
  return get_isClassicTwoSheepOrBoarCompleted(gsCtx);
}
function get_pumpedUpgrades(gsCtx) {
  return gsCtx.s4k();
}
function get_gameRules(gsCtx) {
  return gsCtx.x40();
}
function objectsAt_0(gsCtx, position) {
  return objectsAt(gsCtx, position);
}
function get_locationTypes(gsCtx) {
  return gsCtx.i4k();
}
function get_damageBlocked(gsCtx) {
  return gsCtx.v4k();
}
function get_submittedCurrentDamage(gsCtx) {
  return gsCtx.u4k();
}
function get_firstCharacterPassed(gsCtx) {
  return gsCtx.a4l();
}
function get_sharedBeastHp_0(gsCtx) {
  return get_sharedBeastHp(gsCtx);
}
function get_aliveBeasts_0(gsCtx) {
  return get_aliveBeasts(gsCtx);
}
function get_draftState(gsCtx) {
  return gsCtx.n4k();
}
function getArsenal(gsCtx, arsenalType) {
  return gsCtx.m4l(arsenalType);
}
function get_discardedDraftActionCards(gsCtx) {
  return gsCtx.l4k();
}
function get_cardsInPlay(gsCtx) {
  return gsCtx.k4k();
}
function get_unusedDraftActionCards(gsCtx) {
  return gsCtx.m4k();
}
function get_placedTrapsCardsInfo(gsCtx) {
  return gsCtx.w4k();
}
function get_currentTurnNumber(gsCtx) {
  return gsCtx.f4k();
}
function get_placedTrapsFullInfo(gsCtx) {
  return gsCtx.x4k();
}
function get_gameMap_1(gsCtx) {
  return gsCtx.h47();
}
function get_hunterItems(gsCtx) {
  return gsCtx.o4k();
}
function get_isTwoSheepOrTigerCompleted_0(gsCtx) {
  return get_isTwoSheepOrTigerCompleted(gsCtx);
}
function apply(gsiCtx, _this__u8e3s4) {
  // Inline function 'kotlin.with' call
  _this__u8e3s4.m37(gsiCtx);
  return Unit_instance;
}
function isActiveCharacter_0(gsCtx, characterObject) {
  return isActiveCharacter(gsCtx, characterObject);
}
function get_beastlyTalents(gsCtx) {
  return gsCtx.p4k();
}
function get_settlements_0(gsCtx) {
  return get_settlements(gsCtx);
}
function get_knownInfo(gsCtx) {
  return gsCtx.c4l();
}
function get_phase(gsCtx) {
  return gsCtx.d4k();
}
function get_playedCardsNumber(gsCtx) {
  return gsCtx.b4l();
}
function get_useRandomPickOnArsenal(gsCtx) {
  return gsCtx.e4l();
}
function get_lastAddedObject(gsCtx) {
  return gsCtx.l4l();
}
function get_isReplayOpenGame(gsCtx) {
  return gsCtx.d4l();
}
function get_allAliveAndDestroyedObjects(gsCtx) {
  return gsCtx.h4l();
}
function get_revision(gsCtx) {
  return gsCtx.g4k();
}
function get_chargedUpgrades(gsCtx) {
  return gsCtx.t4k();
}
function get_remainAncientPowers(gsCtx) {
  return gsCtx.r4k();
}
var Companion_instance_295;
function Companion_getInstance_296() {
  return Companion_instance_295;
}
function _get_$cachedSerializer__te6jhj_277($this) {
  return $this.a4z_1.k3();
}
function ResolvingKind$PlayedRedCard$_anonymous__f7irm8() {
  var tmp = PlayedRedCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PlayedRedCard', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_278($this) {
  return $this.b4z_1.k3();
}
function ResolvingKind$PlayedBlueCard$_anonymous__b9cpsj() {
  var tmp = PlayedBlueCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PlayedBlueCard', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_279($this) {
  return $this.c4z_1.k3();
}
function ResolvingKind$BonusCard$_anonymous__mcmfl() {
  var tmp = BonusCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BonusCard', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_280($this) {
  return $this.d4z_1.k3();
}
function ResolvingKind$Reaction$_anonymous__to5413() {
  var tmp = Reaction_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Reaction', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_281($this) {
  return $this.e4z_1.k3();
}
function ResolvingKind$Trap$_anonymous__q4gvtv() {
  var tmp = Trap_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Trap', tmp, tmp$ret$0);
}
var PlayedRedCard_instance;
function PlayedRedCard_getInstance() {
  if (PlayedRedCard_instance === VOID)
    new PlayedRedCard();
  return PlayedRedCard_instance;
}
var PlayedBlueCard_instance;
function PlayedBlueCard_getInstance() {
  if (PlayedBlueCard_instance === VOID)
    new PlayedBlueCard();
  return PlayedBlueCard_instance;
}
var BonusCard_instance;
function BonusCard_getInstance() {
  if (BonusCard_instance === VOID)
    new BonusCard();
  return BonusCard_instance;
}
var Reaction_instance;
function Reaction_getInstance() {
  if (Reaction_instance === VOID)
    new Reaction();
  return Reaction_instance;
}
var Trap_instance;
function Trap_getInstance() {
  if (Trap_instance === VOID)
    new Trap();
  return Trap_instance;
}
var Companion_instance_296;
function Companion_getInstance_297() {
  return Companion_instance_296;
}
function AddArmorEvent$Companion$$childSerializers$_anonymous__20emvi() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_420.a2g()));
}
var Companion_instance_297;
function Companion_getInstance_298() {
  if (Companion_instance_297 === VOID)
    new Companion_297();
  return Companion_instance_297;
}
var $serializer_instance_250;
function $serializer_getInstance_250() {
  if ($serializer_instance_250 === VOID)
    new $serializer_251();
  return $serializer_instance_250;
}
function AddCharacterInOrderEvent$Companion$$childSerializers$_anonymous__s0y07l() {
  return Companion_instance_128.a2g();
}
var Companion_instance_298;
function Companion_getInstance_299() {
  if (Companion_instance_298 === VOID)
    new Companion_298();
  return Companion_instance_298;
}
var $serializer_instance_251;
function $serializer_getInstance_251() {
  if ($serializer_instance_251 === VOID)
    new $serializer_252();
  return $serializer_instance_251;
}
function AddFirePositionEvent$Companion$$childSerializers$_anonymous__kjnhio() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_299;
function Companion_getInstance_300() {
  if (Companion_instance_299 === VOID)
    new Companion_299();
  return Companion_instance_299;
}
var $serializer_instance_252;
function $serializer_getInstance_252() {
  if ($serializer_instance_252 === VOID)
    new $serializer_253();
  return $serializer_instance_252;
}
var Companion_instance_300;
function Companion_getInstance_301() {
  return Companion_instance_300;
}
var $serializer_instance_253;
function $serializer_getInstance_253() {
  if ($serializer_instance_253 === VOID)
    new $serializer_254();
  return $serializer_instance_253;
}
function CharacterPassed$Companion$$childSerializers$_anonymous__6bstip() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_301;
function Companion_getInstance_302() {
  if (Companion_instance_301 === VOID)
    new Companion_301();
  return Companion_instance_301;
}
var $serializer_instance_254;
function $serializer_getInstance_254() {
  if ($serializer_instance_254 === VOID)
    new $serializer_255();
  return $serializer_instance_254;
}
var Companion_instance_302;
function Companion_getInstance_303() {
  return Companion_instance_302;
}
var $serializer_instance_255;
function $serializer_getInstance_255() {
  if ($serializer_instance_255 === VOID)
    new $serializer_256();
  return $serializer_instance_255;
}
function DiscardAfterCharactersDeathEvent$Companion$$childSerializers$_anonymous__z5kckc() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_128.a2g()));
}
var Companion_instance_303;
function Companion_getInstance_304() {
  if (Companion_instance_303 === VOID)
    new Companion_303();
  return Companion_instance_303;
}
var $serializer_instance_256;
function $serializer_getInstance_256() {
  if ($serializer_instance_256 === VOID)
    new $serializer_257();
  return $serializer_instance_256;
}
function DiscardTrapsEvent$Companion$$childSerializers$_anonymous__mg6rx4() {
  return createSimpleEnumSerializer('steelart.beast.Zone', values_1());
}
function DiscardTrapsEvent$Companion$$childSerializers$_anonymous__mg6rx4_0() {
  return new LinkedHashSetSerializer(Companion_instance_399.a2g());
}
var Companion_instance_304;
function Companion_getInstance_305() {
  if (Companion_instance_304 === VOID)
    new Companion_304();
  return Companion_instance_304;
}
var $serializer_instance_257;
function $serializer_getInstance_257() {
  if ($serializer_instance_257 === VOID)
    new $serializer_258();
  return $serializer_instance_257;
}
function DraftResultEvent$Companion$$childSerializers$_anonymous__1hq0pa() {
  return new LinkedHashMapSerializer($serializer_getInstance_183(), $serializer_getInstance_206());
}
var Companion_instance_305;
function Companion_getInstance_306() {
  if (Companion_instance_305 === VOID)
    new Companion_305();
  return Companion_instance_305;
}
var $serializer_instance_258;
function $serializer_getInstance_258() {
  if ($serializer_instance_258 === VOID)
    new $serializer_259();
  return $serializer_instance_258;
}
var Companion_instance_306;
function Companion_getInstance_307() {
  return Companion_instance_306;
}
var $serializer_instance_259;
function $serializer_getInstance_259() {
  if ($serializer_instance_259 === VOID)
    new $serializer_260();
  return $serializer_instance_259;
}
function GainOpenArsenalCardEvent$Companion$$childSerializers$_anonymous__p4exl9() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function GainOpenArsenalCardEvent$Companion$$childSerializers$_anonymous__p4exl9_0() {
  return createSimpleEnumSerializer('steelart.beast.ArsenalType', values_6());
}
function GainOpenArsenalCardEvent$Companion$$childSerializers$_anonymous__p4exl9_1() {
  return Companion_instance_442.a2g();
}
var Companion_instance_307;
function Companion_getInstance_308() {
  if (Companion_instance_307 === VOID)
    new Companion_307();
  return Companion_instance_307;
}
var $serializer_instance_260;
function $serializer_getInstance_260() {
  if ($serializer_instance_260 === VOID)
    new $serializer_261();
  return $serializer_instance_260;
}
function GainUnknownArsenalCardEvent$Companion$$childSerializers$_anonymous__bnsmzv() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function GainUnknownArsenalCardEvent$Companion$$childSerializers$_anonymous__bnsmzv_0() {
  return createSimpleEnumSerializer('steelart.beast.ArsenalType', values_6());
}
var Companion_instance_308;
function Companion_getInstance_309() {
  if (Companion_instance_308 === VOID)
    new Companion_308();
  return Companion_instance_308;
}
var $serializer_instance_261;
function $serializer_getInstance_261() {
  if ($serializer_instance_261 === VOID)
    new $serializer_262();
  return $serializer_instance_261;
}
function GainGrudgesEvent$Companion$$childSerializers$_anonymous__7eimmk() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_128.a2g()));
}
var Companion_instance_309;
function Companion_getInstance_310() {
  if (Companion_instance_309 === VOID)
    new Companion_309();
  return Companion_instance_309;
}
var $serializer_instance_262;
function $serializer_getInstance_262() {
  if ($serializer_instance_262 === VOID)
    new $serializer_263();
  return $serializer_instance_262;
}
function AshRuinPositionChangeEvent$Companion$$childSerializers$_anonymous__rexmcn() {
  return Companion_instance_81.a2g();
}
var Companion_instance_310;
function Companion_getInstance_311() {
  if (Companion_instance_310 === VOID)
    new Companion_310();
  return Companion_instance_310;
}
var $serializer_instance_263;
function $serializer_getInstance_263() {
  if ($serializer_instance_263 === VOID)
    new $serializer_264();
  return $serializer_instance_263;
}
function AshRuinReplacementChangeEvent$Companion$$childSerializers$_anonymous__c58d9w() {
  return Companion_instance_81.a2g();
}
function AshRuinReplacementChangeEvent$Companion$$childSerializers$_anonymous__c58d9w_0() {
  return Companion_instance_81.a2g();
}
var Companion_instance_311;
function Companion_getInstance_312() {
  if (Companion_instance_311 === VOID)
    new Companion_311();
  return Companion_instance_311;
}
var $serializer_instance_264;
function $serializer_getInstance_264() {
  if ($serializer_instance_264 === VOID)
    new $serializer_265();
  return $serializer_instance_264;
}
function ChargingUpgradeChangeEvent$Companion$$childSerializers$_anonymous__6r7jd7() {
  return Companion_instance_130.a2g();
}
var Companion_instance_312;
function Companion_getInstance_313() {
  if (Companion_instance_312 === VOID)
    new Companion_312();
  return Companion_instance_312;
}
var $serializer_instance_265;
function $serializer_getInstance_265() {
  if ($serializer_instance_265 === VOID)
    new $serializer_266();
  return $serializer_instance_265;
}
var Companion_instance_313;
function Companion_getInstance_314() {
  return Companion_instance_313;
}
var $serializer_instance_266;
function $serializer_getInstance_266() {
  if ($serializer_instance_266 === VOID)
    new $serializer_267();
  return $serializer_instance_266;
}
function DuplicateCardEffectChangeEvent$Companion$$childSerializers$_anonymous__jxuq0c() {
  return Companion_instance_442.a2g();
}
var Companion_instance_314;
function Companion_getInstance_315() {
  if (Companion_instance_314 === VOID)
    new Companion_314();
  return Companion_instance_314;
}
var $serializer_instance_267;
function $serializer_getInstance_267() {
  if ($serializer_instance_267 === VOID)
    new $serializer_268();
  return $serializer_instance_267;
}
var Companion_instance_315;
function Companion_getInstance_316() {
  return Companion_instance_315;
}
var $serializer_instance_268;
function $serializer_getInstance_268() {
  if ($serializer_instance_268 === VOID)
    new $serializer_269();
  return $serializer_instance_268;
}
var Companion_instance_316;
function Companion_getInstance_317() {
  return Companion_instance_316;
}
var $serializer_instance_269;
function $serializer_getInstance_269() {
  if ($serializer_instance_269 === VOID)
    new $serializer_270();
  return $serializer_instance_269;
}
function GeneralCardMoveEvent$Companion$$childSerializers$_anonymous__v54qg7() {
  return new LinkedHashSetSerializer(Companion_instance_442.a2g());
}
function GeneralCardMoveEvent$Companion$$childSerializers$_anonymous__v54qg7_0() {
  return Companion_instance_250.a2g();
}
var Companion_instance_317;
function Companion_getInstance_318() {
  if (Companion_instance_317 === VOID)
    new Companion_317();
  return Companion_instance_317;
}
var $serializer_instance_270;
function $serializer_getInstance_270() {
  if ($serializer_instance_270 === VOID)
    new $serializer_271();
  return $serializer_instance_270;
}
function HealEvent$Companion$$childSerializers$_anonymous__2xkgyg() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_420.a2g()));
}
var Companion_instance_318;
function Companion_getInstance_319() {
  if (Companion_instance_318 === VOID)
    new Companion_318();
  return Companion_instance_318;
}
var $serializer_instance_271;
function $serializer_getInstance_271() {
  if ($serializer_instance_271 === VOID)
    new $serializer_272();
  return $serializer_instance_271;
}
var Companion_instance_319;
function Companion_getInstance_320() {
  return Companion_instance_319;
}
var $serializer_instance_272;
function $serializer_getInstance_272() {
  if ($serializer_instance_272 === VOID)
    new $serializer_273();
  return $serializer_instance_272;
}
var Companion_instance_320;
function Companion_getInstance_321() {
  return Companion_instance_320;
}
var $serializer_instance_273;
function $serializer_getInstance_273() {
  if ($serializer_instance_273 === VOID)
    new $serializer_274();
  return $serializer_instance_273;
}
function CardWasResolvedEvent$Companion$$childSerializers$_anonymous__pqnhun() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function CardWasResolvedEvent$Companion$$childSerializers$_anonymous__pqnhun_0() {
  return Companion_instance_442.a2g();
}
function CardWasResolvedEvent$Companion$$childSerializers$_anonymous__pqnhun_1() {
  return Companion_instance_296.a2g();
}
var Companion_instance_321;
function Companion_getInstance_322() {
  if (Companion_instance_321 === VOID)
    new Companion_321();
  return Companion_instance_321;
}
var $serializer_instance_274;
function $serializer_getInstance_274() {
  if ($serializer_instance_274 === VOID)
    new $serializer_275();
  return $serializer_instance_274;
}
function DamageResolvedEvent$Companion$$childSerializers$_anonymous__vp32eh() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_420.a2g()));
}
var Companion_instance_322;
function Companion_getInstance_323() {
  if (Companion_instance_322 === VOID)
    new Companion_322();
  return Companion_instance_322;
}
var $serializer_instance_275;
function $serializer_getInstance_275() {
  if ($serializer_instance_275 === VOID)
    new $serializer_276();
  return $serializer_instance_275;
}
function EndPhaseEvent$Companion$$childSerializers$_anonymous__a98ua8() {
  return Companion_instance_225.a2g();
}
var Companion_instance_323;
function Companion_getInstance_324() {
  if (Companion_instance_323 === VOID)
    new Companion_323();
  return Companion_instance_323;
}
var $serializer_instance_276;
function $serializer_getInstance_276() {
  if ($serializer_instance_276 === VOID)
    new $serializer_277();
  return $serializer_instance_276;
}
function GameQuestionIsComingEvent$Companion$$childSerializers$_anonymous__tdnmml() {
  return Companion_instance_134.a2g();
}
var Companion_instance_324;
function Companion_getInstance_325() {
  if (Companion_instance_324 === VOID)
    new Companion_324();
  return Companion_instance_324;
}
var $serializer_instance_277;
function $serializer_getInstance_277() {
  if ($serializer_instance_277 === VOID)
    new $serializer_278();
  return $serializer_instance_277;
}
function _get_$cachedSerializer__te6jhj_282($this) {
  return $this.h55_1.k3();
}
function NothingEvent$_anonymous__ppsebu() {
  var tmp = NothingEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NothingEvent', tmp, tmp$ret$0);
}
var NothingEvent_instance;
function NothingEvent_getInstance() {
  if (NothingEvent_instance === VOID)
    new NothingEvent();
  return NothingEvent_instance;
}
var Companion_instance_325;
function Companion_getInstance_326() {
  return Companion_instance_325;
}
var $serializer_instance_278;
function $serializer_getInstance_278() {
  if ($serializer_instance_278 === VOID)
    new $serializer_279();
  return $serializer_instance_278;
}
function SearchForBeastEvent$Companion$$childSerializers$_anonymous__muv8qa() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_326;
function Companion_getInstance_327() {
  if (Companion_instance_326 === VOID)
    new Companion_326();
  return Companion_instance_326;
}
var $serializer_instance_279;
function $serializer_getInstance_279() {
  if ($serializer_instance_279 === VOID)
    new $serializer_280();
  return $serializer_instance_279;
}
var Companion_instance_327;
function Companion_getInstance_328() {
  return Companion_instance_327;
}
var $serializer_instance_280;
function $serializer_getInstance_280() {
  if ($serializer_instance_280 === VOID)
    new $serializer_281();
  return $serializer_instance_280;
}
function MoveCardToDiscardEvent$Companion$$childSerializers$_anonymous__9pzxxu() {
  return Companion_instance_250.a2g();
}
function MoveCardToDiscardEvent$Companion$$childSerializers$_anonymous__9pzxxu_0() {
  return Companion_instance_442.a2g();
}
var Companion_instance_328;
function Companion_getInstance_329() {
  if (Companion_instance_328 === VOID)
    new Companion_328();
  return Companion_instance_328;
}
var $serializer_instance_281;
function $serializer_getInstance_281() {
  if ($serializer_instance_281 === VOID)
    new $serializer_282();
  return $serializer_instance_281;
}
function MovementEvent$Companion$$childSerializers$_anonymous__ynfxz5() {
  return new LinkedHashSetSerializer(Companion_instance_353.a2g());
}
var Companion_instance_329;
function Companion_getInstance_330() {
  if (Companion_instance_329 === VOID)
    new Companion_329();
  return Companion_instance_329;
}
var $serializer_instance_282;
function $serializer_getInstance_282() {
  if ($serializer_instance_282 === VOID)
    new $serializer_283();
  return $serializer_instance_282;
}
function NewSimpleObjectEvent$Companion$$childSerializers$_anonymous__j35v33() {
  return Companion_instance_420.a2g();
}
var Companion_instance_330;
function Companion_getInstance_331() {
  if (Companion_instance_330 === VOID)
    new Companion_330();
  return Companion_instance_330;
}
var $serializer_instance_283;
function $serializer_getInstance_283() {
  if ($serializer_instance_283 === VOID)
    new $serializer_284();
  return $serializer_instance_283;
}
function ObjectRemoveForReplacingEvent$Companion$$childSerializers$_anonymous__4f1rln() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_331;
function Companion_getInstance_332() {
  if (Companion_instance_331 === VOID)
    new Companion_331();
  return Companion_instance_331;
}
var $serializer_instance_284;
function $serializer_getInstance_284() {
  if ($serializer_instance_284 === VOID)
    new $serializer_285();
  return $serializer_instance_284;
}
function PickCardsFromDeadCharacterEvent$Companion$$childSerializers$_anonymous__25im5z() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function PickCardsFromDeadCharacterEvent$Companion$$childSerializers$_anonymous__25im5z_0() {
  return new LinkedHashMapSerializer($serializer_364.y2o(Companion_instance_380.a2g()), Companion_instance_146.a2g());
}
var Companion_instance_332;
function Companion_getInstance_333() {
  if (Companion_instance_332 === VOID)
    new Companion_332();
  return Companion_instance_332;
}
var $serializer_instance_285;
function $serializer_getInstance_285() {
  if ($serializer_instance_285 === VOID)
    new $serializer_286();
  return $serializer_instance_285;
}
function RemoveFirePositionsEvent$Companion$$childSerializers$_anonymous__69qh7k() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_333;
function Companion_getInstance_334() {
  if (Companion_instance_333 === VOID)
    new Companion_333();
  return Companion_instance_333;
}
var $serializer_instance_286;
function $serializer_getInstance_286() {
  if ($serializer_instance_286 === VOID)
    new $serializer_287();
  return $serializer_instance_286;
}
function RemoveUpgradeEvent$Companion$$childSerializers$_anonymous__vlvec8() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function RemoveUpgradeEvent$Companion$$childSerializers$_anonymous__vlvec8_0() {
  return Companion_instance_129.a2g();
}
var Companion_instance_334;
function Companion_getInstance_335() {
  if (Companion_instance_334 === VOID)
    new Companion_334();
  return Companion_instance_334;
}
var $serializer_instance_287;
function $serializer_getInstance_287() {
  if ($serializer_instance_287 === VOID)
    new $serializer_288();
  return $serializer_instance_287;
}
function _get_$cachedSerializer__te6jhj_283($this) {
  return $this.t57_1.k3();
}
function ReplayIsFinishedEvent$_anonymous__y8bsjk() {
  var tmp = ReplayIsFinishedEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ReplayIsFinishedEvent', tmp, tmp$ret$0);
}
var ReplayIsFinishedEvent_instance;
function ReplayIsFinishedEvent_getInstance() {
  if (ReplayIsFinishedEvent_instance === VOID)
    new ReplayIsFinishedEvent();
  return ReplayIsFinishedEvent_instance;
}
function ReplayNotificationEvent$Companion$$childSerializers$_anonymous__rg6va6() {
  return Companion_instance_356.a2g();
}
var Companion_instance_335;
function Companion_getInstance_336() {
  if (Companion_instance_335 === VOID)
    new Companion_335();
  return Companion_instance_335;
}
var $serializer_instance_288;
function $serializer_getInstance_288() {
  if ($serializer_instance_288 === VOID)
    new $serializer_289();
  return $serializer_instance_288;
}
function _get_$cachedSerializer__te6jhj_284($this) {
  return $this.z57_1.k3();
}
function RestoreArsenalEvent$_anonymous__ua52or() {
  var tmp = RestoreArsenalEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RestoreArsenalEvent', tmp, tmp$ret$0);
}
var RestoreArsenalEvent_instance;
function RestoreArsenalEvent_getInstance() {
  if (RestoreArsenalEvent_instance === VOID)
    new RestoreArsenalEvent();
  return RestoreArsenalEvent_instance;
}
function _get_$cachedSerializer__te6jhj_285($this) {
  return $this.a58_1.k3();
}
function RestoreStuffEvent$_anonymous__gogx7h() {
  var tmp = RestoreStuffEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RestoreStuffEvent', tmp, tmp$ret$0);
}
var RestoreStuffEvent_instance;
function RestoreStuffEvent_getInstance() {
  if (RestoreStuffEvent_instance === VOID)
    new RestoreStuffEvent();
  return RestoreStuffEvent_instance;
}
function RestoringHunterAfterDeathEvent$Companion$$childSerializers$_anonymous__ikzlub() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_336;
function Companion_getInstance_337() {
  if (Companion_instance_336 === VOID)
    new Companion_336();
  return Companion_instance_336;
}
var $serializer_instance_289;
function $serializer_getInstance_289() {
  if ($serializer_instance_289 === VOID)
    new $serializer_290();
  return $serializer_instance_289;
}
function RetrieveCardEvent$Companion$$childSerializers$_anonymous__uh7w2s() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function RetrieveCardEvent$Companion$$childSerializers$_anonymous__uh7w2s_0() {
  return Companion_instance_442.a2g();
}
var Companion_instance_337;
function Companion_getInstance_338() {
  if (Companion_instance_337 === VOID)
    new Companion_337();
  return Companion_instance_337;
}
var $serializer_instance_290;
function $serializer_getInstance_290() {
  if ($serializer_instance_290 === VOID)
    new $serializer_291();
  return $serializer_instance_290;
}
function RevealBeastEvent$Companion$$childSerializers$_anonymous__mz9v5u() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_338;
function Companion_getInstance_339() {
  if (Companion_instance_338 === VOID)
    new Companion_338();
  return Companion_instance_338;
}
var $serializer_instance_291;
function $serializer_getInstance_291() {
  if ($serializer_instance_291 === VOID)
    new $serializer_292();
  return $serializer_instance_291;
}
function RevealLastMovementsEvent$Companion$$childSerializers$_anonymous__pq9rld() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_339;
function Companion_getInstance_340() {
  if (Companion_instance_339 === VOID)
    new Companion_339();
  return Companion_instance_339;
}
var $serializer_instance_292;
function $serializer_getInstance_292() {
  if ($serializer_instance_292 === VOID)
    new $serializer_293();
  return $serializer_instance_292;
}
function RevealLeadsToLocationTypeEvent$Companion$$childSerializers$_anonymous__5vd1l0() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function RevealLeadsToLocationTypeEvent$Companion$$childSerializers$_anonymous__5vd1l0_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
var Companion_instance_340;
function Companion_getInstance_341() {
  if (Companion_instance_340 === VOID)
    new Companion_340();
  return Companion_instance_340;
}
var $serializer_instance_293;
function $serializer_getInstance_293() {
  if ($serializer_instance_293 === VOID)
    new $serializer_294();
  return $serializer_instance_293;
}
function RevealMovementCardEvent$Companion$$childSerializers$_anonymous__sa3e4c() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_341;
function Companion_getInstance_342() {
  if (Companion_instance_341 === VOID)
    new Companion_341();
  return Companion_instance_341;
}
var $serializer_instance_294;
function $serializer_getInstance_294() {
  if ($serializer_instance_294 === VOID)
    new $serializer_295();
  return $serializer_instance_294;
}
function RevertLastBeastMovementEvent$Companion$$childSerializers$_anonymous__zasyck() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_342;
function Companion_getInstance_343() {
  if (Companion_instance_342 === VOID)
    new Companion_342();
  return Companion_instance_342;
}
var $serializer_instance_295;
function $serializer_getInstance_295() {
  if ($serializer_instance_295 === VOID)
    new $serializer_296();
  return $serializer_instance_295;
}
function SetTrapEvent$Companion$$childSerializers$_anonymous__f953b3() {
  return Companion_instance_399.a2g();
}
function SetTrapEvent$Companion$$childSerializers$_anonymous__f953b3_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
function SetTrapEvent$Companion$$childSerializers$_anonymous__f953b3_1() {
  return createSimpleEnumSerializer('steelart.beast.Zone', values_1());
}
function SetTrapEvent$Companion$$childSerializers$_anonymous__f953b3_2() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_343;
function Companion_getInstance_344() {
  if (Companion_instance_343 === VOID)
    new Companion_343();
  return Companion_instance_343;
}
var $serializer_instance_296;
function $serializer_getInstance_296() {
  if ($serializer_instance_296 === VOID)
    new $serializer_297();
  return $serializer_instance_296;
}
function SpendGrudgesEvent$Companion$$childSerializers$_anonymous__67zgfh() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
var Companion_instance_344;
function Companion_getInstance_345() {
  if (Companion_instance_344 === VOID)
    new Companion_344();
  return Companion_instance_344;
}
var $serializer_instance_297;
function $serializer_getInstance_297() {
  if ($serializer_instance_297 === VOID)
    new $serializer_298();
  return $serializer_instance_297;
}
function StartPhaseEvent$Companion$$childSerializers$_anonymous__xdz5h3() {
  return Companion_instance_225.a2g();
}
var Companion_instance_345;
function Companion_getInstance_346() {
  if (Companion_instance_345 === VOID)
    new Companion_345();
  return Companion_instance_345;
}
var $serializer_instance_298;
function $serializer_getInstance_298() {
  if ($serializer_instance_298 === VOID)
    new $serializer_299();
  return $serializer_instance_298;
}
function StartResolveCardEvent$Companion$$childSerializers$_anonymous__baxwqy() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function StartResolveCardEvent$Companion$$childSerializers$_anonymous__baxwqy_0() {
  return Companion_instance_250.a2g();
}
function StartResolveCardEvent$Companion$$childSerializers$_anonymous__baxwqy_1() {
  return Companion_instance_442.a2g();
}
function StartResolveCardEvent$Companion$$childSerializers$_anonymous__baxwqy_2() {
  return Companion_instance_296.a2g();
}
var Companion_instance_346;
function Companion_getInstance_347() {
  if (Companion_instance_346 === VOID)
    new Companion_346();
  return Companion_instance_346;
}
var $serializer_instance_299;
function $serializer_getInstance_299() {
  if ($serializer_instance_299 === VOID)
    new $serializer_300();
  return $serializer_instance_299;
}
var Companion_instance_347;
function Companion_getInstance_348() {
  return Companion_instance_347;
}
var $serializer_instance_300;
function $serializer_getInstance_300() {
  if ($serializer_instance_300 === VOID)
    new $serializer_301();
  return $serializer_instance_300;
}
var Companion_instance_348;
function Companion_getInstance_349() {
  return Companion_instance_348;
}
var $serializer_instance_301;
function $serializer_getInstance_301() {
  if ($serializer_instance_301 === VOID)
    new $serializer_302();
  return $serializer_instance_301;
}
function TrailsRevealedEvent$Companion$$childSerializers$_anonymous__xox2d3() {
  return new LinkedHashMapSerializer($serializer_364.y2o(Companion_instance_92.a2g()), new LinkedHashMapSerializer($serializer_getInstance_100(), IntSerializer_getInstance()));
}
var Companion_instance_349;
function Companion_getInstance_350() {
  if (Companion_instance_349 === VOID)
    new Companion_349();
  return Companion_instance_349;
}
var $serializer_instance_302;
function $serializer_getInstance_302() {
  if ($serializer_instance_302 === VOID)
    new $serializer_303();
  return $serializer_instance_302;
}
function TransformLocationsEvent$Companion$$childSerializers$_anonymous__iljqbi() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
function TransformLocationsEvent$Companion$$childSerializers$_anonymous__iljqbi_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
var Companion_instance_350;
function Companion_getInstance_351() {
  if (Companion_instance_350 === VOID)
    new Companion_350();
  return Companion_instance_350;
}
var $serializer_instance_303;
function $serializer_getInstance_303() {
  if ($serializer_instance_303 === VOID)
    new $serializer_304();
  return $serializer_instance_303;
}
function UpgradeEvent$Companion$$childSerializers$_anonymous__kjl584() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function UpgradeEvent$Companion$$childSerializers$_anonymous__kjl584_0() {
  return Companion_instance_129.a2g();
}
var Companion_instance_351;
function Companion_getInstance_352() {
  if (Companion_instance_351 === VOID)
    new Companion_351();
  return Companion_instance_351;
}
var $serializer_instance_304;
function $serializer_getInstance_304() {
  if ($serializer_instance_304 === VOID)
    new $serializer_305();
  return $serializer_instance_304;
}
function inPlayPosition($context_GameState_t6qee5, _this__u8e3s4) {
  var tmp = get_cardsInPlay($context_GameState_t6qee5).w4(_this__u8e3s4);
  return tmp == null ? null : tmp.r2v_1;
}
function _get_$cachedSerializer__te6jhj_286($this) {
  return $this.s5b_1.k3();
}
function MarkerGameStateEvent$Companion$_anonymous__asbmhy() {
  var tmp = getKClass(MarkerGameStateEvent);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(AssignDamageEvent), getKClass(CardWasResolvedEvent), getKClass(DamageResolvedEvent), getKClass(EndPhaseEvent), getKClass(GameQuestionIsComingEvent), getKClass(NothingEvent), getKClass(RewardAchieved), getKClass(SearchForBeastEvent), getKClass(SigridCreatureLungedEvent)];
  var tmp_1 = $serializer_getInstance_273();
  var tmp_2 = $serializer_getInstance_274();
  var tmp_3 = $serializer_getInstance_275();
  var tmp_4 = $serializer_getInstance_276();
  var tmp_5 = $serializer_getInstance_277();
  var tmp_6 = NothingEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [];
  var tmp_7 = ObjectSerializer.l1c('NothingEvent', tmp_6, tmp$ret$3);
  var tmp_8 = $serializer_getInstance_278();
  var tmp_9 = $serializer_getInstance_279();
  var tmp_10 = SigridCreatureLungedEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_11 = [tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_7, tmp_8, tmp_9, ObjectSerializer.l1c('SigridCreatureLungedEvent', tmp_10, tmp$ret$6)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$12 = [];
  return SealedClassSerializer.i10('MarkerGameStateEvent', tmp, tmp_0, tmp_11, tmp$ret$12);
}
var Companion_instance_352;
function Companion_getInstance_353() {
  if (Companion_instance_352 === VOID)
    new Companion_352();
  return Companion_instance_352;
}
var Companion_instance_353;
function Companion_getInstance_354() {
  return Companion_instance_353;
}
function OpenObjectMovement$Companion$$childSerializers$_anonymous__1efvw2() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function OpenObjectMovement$Companion$$childSerializers$_anonymous__1efvw2_0() {
  return new ArrayListSerializer($serializer_getInstance_100());
}
var Companion_instance_354;
function Companion_getInstance_355() {
  if (Companion_instance_354 === VOID)
    new Companion_354();
  return Companion_instance_354;
}
var $serializer_instance_305;
function $serializer_getInstance_305() {
  if ($serializer_instance_305 === VOID)
    new $serializer_306();
  return $serializer_instance_305;
}
function HiddenBeastMovement$Companion$$childSerializers$_anonymous__uv3w3e() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function HiddenBeastMovement$Companion$$childSerializers$_anonymous__uv3w3e_0() {
  return new ArrayListSerializer($serializer_getInstance_82());
}
var Companion_instance_355;
function Companion_getInstance_356() {
  if (Companion_instance_355 === VOID)
    new Companion_355();
  return Companion_instance_355;
}
var $serializer_instance_306;
function $serializer_getInstance_306() {
  if ($serializer_instance_306 === VOID)
    new $serializer_307();
  return $serializer_instance_306;
}
var Companion_instance_356;
function Companion_getInstance_357() {
  return Companion_instance_356;
}
var Companion_instance_357;
function Companion_getInstance_358() {
  return Companion_instance_357;
}
var $serializer_instance_307;
function $serializer_getInstance_307() {
  if ($serializer_instance_307 === VOID)
    new $serializer_308();
  return $serializer_instance_307;
}
var Companion_instance_358;
function Companion_getInstance_359() {
  return Companion_instance_358;
}
function outpostEvent(position) {
  return new NewSimpleObjectEvent(WatchtowerType_getInstance(), position);
}
function MovementEvent_0($context_GameState_t6qee5, movedObject, newPosition, isRelocation, isPull) {
  isRelocation = isRelocation === VOID ? false : isRelocation;
  isPull = isPull === VOID ? false : isPull;
  return new MovementEvent(setOf(new OpenObjectMovement(movedObject, pathWhenRelocating($context_GameState_t6qee5, movedObject, newPosition), isRelocation)), isPull);
}
function applyAllChanges($context_GameStateImpl_x43bj1, $context_GameRuntimeDiagnostics_htysfc, _this__u8e3s4) {
  var changes = withStateRuntime_0($context_GameStateImpl_x43bj1, $context_GameRuntimeDiagnostics_htysfc, applyAllChanges$lambda(_this__u8e3s4));
  var _iterator__ex2g4s = changes.p1();
  while (_iterator__ex2g4s.q1()) {
    var change = _iterator__ex2g4s.r1();
    apply($context_GameStateImpl_x43bj1, change);
  }
}
function pathWhenRelocating($context_GameState_t6qee5, movedObject, newPosition) {
  var startPosition = movedObject.s2w($context_GameState_t6qee5);
  return get_gameMap_1($context_GameState_t6qee5).b45().w2(new BoardPosition(startPosition)) ? listOf_0([new BoardPosition(startPosition), new BoardPosition(newPosition)]) : listOf(new BoardPosition(newPosition));
}
function applyAllChanges$lambda($this_applyAllChanges) {
  return ($this$withStateRuntime) => $this_applyAllChanges.o37($this$withStateRuntime);
}
var PrintingGameRuntimeDiagnostics_instance;
function PrintingGameRuntimeDiagnostics_getInstance() {
  return PrintingGameRuntimeDiagnostics_instance;
}
function reportWarning(runtime, warning, cause) {
  cause = cause === VOID ? null : cause;
  runtime.f5c(warning, cause);
}
function withStateRuntime(runtime, _this__u8e3s4, block) {
  // Inline function 'kotlin.with' call
  return block(new CombinedRuntime(_this__u8e3s4, runtime));
}
function withDiagnostics(_this__u8e3s4, diagnostics) {
  return new CombinedRuntime(_this__u8e3s4, diagnostics);
}
function withStateRuntime_0(state, runtime, block) {
  // Inline function 'kotlin.with' call
  return block(new CombinedRuntime(state, runtime));
}
function getGeneralPropertyWithDefault(impl, key, default_0) {
  var tmp0_safe_receiver = impl.v4l_1.w4(new GeneralMapKey(key));
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = isInterface(tmp0_safe_receiver, GeneralObjectProperty) ? tmp0_safe_receiver : THROW_CCE();
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? default_0 : tmp1_elvis_lhs;
}
function GeneralObjectImpl$Companion$$childSerializers$_anonymous__se0twj() {
  return new LinkedHashMapSerializer($serializer_310.k5c(Companion_instance_369.a2g()), Companion_instance_369.a2g());
}
var Companion_instance_359;
function Companion_getInstance_360() {
  if (Companion_instance_359 === VOID)
    new Companion_359();
  return Companion_instance_359;
}
var $serializer_instance_308;
function $serializer_getInstance_308() {
  if ($serializer_instance_308 === VOID)
    new $serializer_309();
  return $serializer_instance_308;
}
function withGeneralProperty(_this__u8e3s4, key, value) {
  return _this__u8e3s4.s5c(VOID, plus_3(_this__u8e3s4.v4l_1, to(new GeneralMapKey(key), value)));
}
function withGeneralPropertyWithDefault(_this__u8e3s4, key, value, default_0) {
  var tmp;
  if (equals(default_0, value)) {
    tmp = minus(_this__u8e3s4.v4l_1, new GeneralMapKey(key));
  } else {
    tmp = plus_3(_this__u8e3s4.v4l_1, to(new GeneralMapKey(key), value));
  }
  var updatedProperties = tmp;
  return _this__u8e3s4.s5c(VOID, updatedProperties);
}
function getGeneralProperty(impl, key) {
  var tmp = impl.v4l_1.w4(new GeneralMapKey(key));
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, GeneralObjectProperty) : false) ? tmp : null;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'Not initialized property ' + GeneralMapKey__toString_impl_sepxnu(key) + ' in ' + impl.toString();
    throw IllegalStateException.o(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function _GeneralMapKey___init__impl__zdmbea(key) {
  return key;
}
function _GeneralMapKey___get_key__impl__tk32ss($this) {
  return $this;
}
var Companion_instance_360;
function Companion_getInstance_361() {
  return Companion_instance_360;
}
function GeneralMapKey__toString_impl_sepxnu($this) {
  return 'GeneralMapKey(key=' + $this + ')';
}
function GeneralMapKey__hashCode_impl_kv87if($this) {
  return getStringHashCode($this);
}
function GeneralMapKey__equals_impl_lbn93x($this, other) {
  if (!(other instanceof GeneralMapKey))
    return false;
  if (!($this === other.v5c_1))
    return false;
  return true;
}
function BoardPositionSetWrapper$Companion$$childSerializers$_anonymous__oqunt6() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_361;
function Companion_getInstance_362() {
  if (Companion_instance_361 === VOID)
    new Companion_361();
  return Companion_instance_361;
}
var $serializer_instance_309;
function $serializer_getInstance_309() {
  if ($serializer_instance_309 === VOID)
    new $serializer_311();
  return $serializer_instance_309;
}
var Companion_instance_362;
function Companion_getInstance_363() {
  return Companion_instance_362;
}
var $serializer_instance_310;
function $serializer_getInstance_310() {
  if ($serializer_instance_310 === VOID)
    new $serializer_312();
  return $serializer_instance_310;
}
var Companion_instance_363;
function Companion_getInstance_364() {
  return Companion_instance_363;
}
var $serializer_instance_311;
function $serializer_getInstance_311() {
  if ($serializer_instance_311 === VOID)
    new $serializer_313();
  return $serializer_instance_311;
}
var Companion_instance_364;
function Companion_getInstance_365() {
  if (Companion_instance_364 === VOID)
    new Companion_364();
  return Companion_instance_364;
}
function init(_this__u8e3s4, value) {
  return new GeneralMapKeyAndInit(_this__u8e3s4, value);
}
var Companion_instance_365;
function Companion_getInstance_366() {
  return Companion_instance_365;
}
var $serializer_instance_312;
function $serializer_getInstance_312() {
  if ($serializer_instance_312 === VOID)
    new $serializer_315();
  return $serializer_instance_312;
}
function BeastPathStepListWrapper$Companion$$childSerializers$_anonymous__yr6dl1() {
  return new ArrayListSerializer($serializer_getInstance_82());
}
var Companion_instance_366;
function Companion_getInstance_367() {
  if (Companion_instance_366 === VOID)
    new Companion_366();
  return Companion_instance_366;
}
var $serializer_instance_313;
function $serializer_getInstance_313() {
  if ($serializer_instance_313 === VOID)
    new $serializer_316();
  return $serializer_instance_313;
}
function MovementAndStateListWrapper$Companion$$childSerializers$_anonymous__xtboyq() {
  return new ArrayListSerializer($serializer_getInstance_83());
}
var Companion_instance_367;
function Companion_getInstance_368() {
  if (Companion_instance_367 === VOID)
    new Companion_367();
  return Companion_instance_367;
}
var $serializer_instance_314;
function $serializer_getInstance_314() {
  if ($serializer_instance_314 === VOID)
    new $serializer_317();
  return $serializer_instance_314;
}
function BoardPositionToIntMapWrapper$Companion$$childSerializers$_anonymous__fjbp66() {
  return new LinkedHashMapSerializer($serializer_getInstance_100(), IntSerializer_getInstance());
}
var Companion_instance_368;
function Companion_getInstance_369() {
  if (Companion_instance_368 === VOID)
    new Companion_368();
  return Companion_instance_368;
}
var $serializer_instance_315;
function $serializer_getInstance_315() {
  if ($serializer_instance_315 === VOID)
    new $serializer_318();
  return $serializer_instance_315;
}
var Companion_instance_369;
function Companion_getInstance_370() {
  return Companion_instance_369;
}
var Companion_instance_370;
function Companion_getInstance_371() {
  return Companion_instance_370;
}
var $serializer_instance_316;
function $serializer_getInstance_316() {
  if ($serializer_instance_316 === VOID)
    new $serializer_319();
  return $serializer_instance_316;
}
function PlayableCardSetWrapper$Companion$$childSerializers$_anonymous__ankcud() {
  return new LinkedHashSetSerializer(Companion_instance_442.a2g());
}
var Companion_instance_371;
function Companion_getInstance_372() {
  if (Companion_instance_371 === VOID)
    new Companion_371();
  return Companion_instance_371;
}
var $serializer_instance_317;
function $serializer_getInstance_317() {
  if ($serializer_instance_317 === VOID)
    new $serializer_320();
  return $serializer_instance_317;
}
function init_0(_this__u8e3s4, value) {
  return new GeneralMapKeyAndInit(_this__u8e3s4, new IntWrapper(value));
}
function PlayableCardToIntMapWrapper$Companion$$childSerializers$_anonymous__ajmb4t() {
  return new LinkedHashMapSerializer(Companion_instance_442.a2g(), IntSerializer_getInstance());
}
var Companion_instance_372;
function Companion_getInstance_373() {
  if (Companion_instance_372 === VOID)
    new Companion_372();
  return Companion_instance_372;
}
var $serializer_instance_318;
function $serializer_getInstance_318() {
  if ($serializer_instance_318 === VOID)
    new $serializer_321();
  return $serializer_instance_318;
}
function PlayableCardToLocationTypeMapWrapper$Companion$$childSerializers$_anonymous__e4scq3() {
  return new LinkedHashMapSerializer(Companion_instance_442.a2g(), createSimpleEnumSerializer('steelart.beast.LocationType', values_2()));
}
var Companion_instance_373;
function Companion_getInstance_374() {
  if (Companion_instance_373 === VOID)
    new Companion_373();
  return Companion_instance_373;
}
var $serializer_instance_319;
function $serializer_getInstance_319() {
  if ($serializer_instance_319 === VOID)
    new $serializer_322();
  return $serializer_instance_319;
}
function SnareTypeWrapper$Companion$$childSerializers$_anonymous__7uoave() {
  return Companion_getInstance_437().a2g();
}
var Companion_instance_374;
function Companion_getInstance_375() {
  if (Companion_instance_374 === VOID)
    new Companion_374();
  return Companion_instance_374;
}
var $serializer_instance_320;
function $serializer_getInstance_320() {
  if ($serializer_instance_320 === VOID)
    new $serializer_323();
  return $serializer_instance_320;
}
var Companion_instance_375;
function Companion_getInstance_376() {
  return Companion_instance_375;
}
var $serializer_instance_321;
function $serializer_getInstance_321() {
  if ($serializer_instance_321 === VOID)
    new $serializer_324();
  return $serializer_instance_321;
}
function _get_$cachedSerializer__te6jhj_287($this) {
  return $this.k5f_1.k3();
}
function GreatCleansingInitialPhase$_anonymous__r4dnsb() {
  var tmp = GreatCleansingInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('GreatCleansingInitialPhase', tmp, tmp$ret$0);
}
var GreatCleansingInitialPhase_instance;
function GreatCleansingInitialPhase_getInstance() {
  if (GreatCleansingInitialPhase_instance === VOID)
    new GreatCleansingInitialPhase();
  return GreatCleansingInitialPhase_instance;
}
function _get_$cachedSerializer__te6jhj_288($this) {
  return $this.m5f_1.k3();
}
function Grimgeir$_anonymous__knohoh() {
  var tmp = Grimgeir_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Grimgeir', tmp, tmp$ret$0);
}
var Grimgeir_instance;
function Grimgeir_getInstance() {
  if (Grimgeir_instance === VOID)
    new Grimgeir();
  return Grimgeir_instance;
}
function _get_$cachedSerializer__te6jhj_289($this) {
  return $this.n5f_1.k3();
}
function WatchtowerPassageUpgrade$_anonymous__kdfxyn() {
  var tmp = WatchtowerPassageUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WatchtowerPassageUpgrade', tmp, tmp$ret$0);
}
var WatchtowerPassageUpgrade_instance;
function WatchtowerPassageUpgrade_getInstance() {
  if (WatchtowerPassageUpgrade_instance === VOID)
    new WatchtowerPassageUpgrade();
  return WatchtowerPassageUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_290($this) {
  return $this.o5f_1.k3();
}
function RefugeUpgrade$_anonymous__ml9akb() {
  var tmp = RefugeUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RefugeUpgrade', tmp, tmp$ret$0);
}
var RefugeUpgrade_instance;
function RefugeUpgrade_getInstance() {
  if (RefugeUpgrade_instance === VOID)
    new RefugeUpgrade();
  return RefugeUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_291($this) {
  return $this.p5f_1.k3();
}
function TownswatchUpgrade$_anonymous__rzbro7() {
  var tmp = TownswatchUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TownswatchUpgrade', tmp, tmp$ret$0);
}
var TownswatchUpgrade_instance;
function TownswatchUpgrade_getInstance() {
  if (TownswatchUpgrade_instance === VOID)
    new TownswatchUpgrade();
  return TownswatchUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_292($this) {
  return $this.q5f_1.k3();
}
function DefenderUpgrade$_anonymous__x6yhu() {
  var tmp = DefenderUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DefenderUpgrade', tmp, tmp$ret$0);
}
var DefenderUpgrade_instance;
function DefenderUpgrade_getInstance() {
  if (DefenderUpgrade_instance === VOID)
    new DefenderUpgrade();
  return DefenderUpgrade_instance;
}
function DefenderWithChoiceAction$Companion$$childSerializers$_anonymous__uj2422() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_420.a2g()));
}
var Companion_instance_376;
function Companion_getInstance_377() {
  if (Companion_instance_376 === VOID)
    new Companion_376();
  return Companion_instance_376;
}
var $serializer_instance_322;
function $serializer_getInstance_322() {
  if ($serializer_instance_322 === VOID)
    new $serializer_325();
  return $serializer_instance_322;
}
function RelocationToWatchtowerStatement$Companion$$childSerializers$_anonymous__d16diw() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_377;
function Companion_getInstance_378() {
  if (Companion_instance_377 === VOID)
    new Companion_377();
  return Companion_instance_377;
}
var $serializer_instance_323;
function $serializer_getInstance_323() {
  if ($serializer_instance_323 === VOID)
    new $serializer_326();
  return $serializer_instance_323;
}
function _get_$cachedSerializer__te6jhj_293($this) {
  return $this.d5g_1.k3();
}
function CleaverCard$_anonymous__9oeasp() {
  var tmp = CleaverCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CleaverCard', tmp, tmp$ret$0);
}
var CleaverCard_instance;
function CleaverCard_getInstance() {
  if (CleaverCard_instance === VOID)
    new CleaverCard();
  return CleaverCard_instance;
}
function _get_$cachedSerializer__te6jhj_294($this) {
  return $this.e5g_1.k3();
}
function Helga$_anonymous__lysu3y() {
  var tmp = Helga_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Helga', tmp, tmp$ret$0);
}
var Helga_instance;
function Helga_getInstance() {
  if (Helga_instance === VOID)
    new Helga();
  return Helga_instance;
}
function _get_$cachedSerializer__te6jhj_295($this) {
  return $this.f5g_1.k3();
}
function TormentingVisionsUpgrade$_anonymous__j7zcgp() {
  var tmp = TormentingVisionsUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TormentingVisionsUpgrade', tmp, tmp$ret$0);
}
var TormentingVisionsUpgrade_instance;
function TormentingVisionsUpgrade_getInstance() {
  if (TormentingVisionsUpgrade_instance === VOID)
    new TormentingVisionsUpgrade();
  return TormentingVisionsUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_296($this) {
  return $this.g5g_1.k3();
}
function SoothsayerUpgrade$_anonymous__phq8j0() {
  var tmp = SoothsayerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SoothsayerUpgrade', tmp, tmp$ret$0);
}
var SoothsayerUpgrade_instance;
function SoothsayerUpgrade_getInstance() {
  if (SoothsayerUpgrade_instance === VOID)
    new SoothsayerUpgrade();
  return SoothsayerUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_297($this) {
  return $this.h5g_1.k3();
}
function ClairvoyantUpgrade$_anonymous__f3z7a5() {
  var tmp = ClairvoyantUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ClairvoyantUpgrade', tmp, tmp$ret$0);
}
var ClairvoyantUpgrade_instance;
function ClairvoyantUpgrade_getInstance() {
  if (ClairvoyantUpgrade_instance === VOID)
    new ClairvoyantUpgrade();
  return ClairvoyantUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_298($this) {
  return $this.i5g_1.k3();
}
function AncientBondUpgrade$_anonymous__3ft57u() {
  var tmp = AncientBondUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AncientBondUpgrade', tmp, tmp$ret$0);
}
var AncientBondUpgrade_instance;
function AncientBondUpgrade_getInstance() {
  if (AncientBondUpgrade_instance === VOID)
    new AncientBondUpgrade();
  return AncientBondUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_299($this) {
  return $this.l5g_1.k3();
}
function SeerCard$_anonymous__scyi1k() {
  var tmp = SeerCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SeerCard', tmp, tmp$ret$0);
}
var SeerCard_instance;
function SeerCard_getInstance() {
  if (SeerCard_instance === VOID)
    new SeerCard();
  return SeerCard_instance;
}
function get_helgaHunter($context_GameState_t6qee5) {
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Helga) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function _get_$cachedSerializer__te6jhj_300($this) {
  return $this.m5g_1.k3();
}
function RampageousUpgrade$_anonymous__6zyhx() {
  var tmp = RampageousUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RampageousUpgrade', tmp, tmp$ret$0);
}
var RampageousUpgrade_instance;
function RampageousUpgrade_getInstance() {
  if (RampageousUpgrade_instance === VOID)
    new RampageousUpgrade();
  return RampageousUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_301($this) {
  return $this.n5g_1.k3();
}
function InfernalTusksUpgrade$_anonymous__yn2u52() {
  var tmp = InfernalTusksUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('InfernalTusksUpgrade', tmp, tmp$ret$0);
}
var InfernalTusksUpgrade_instance;
function InfernalTusksUpgrade_getInstance() {
  if (InfernalTusksUpgrade_instance === VOID)
    new InfernalTusksUpgrade();
  return InfernalTusksUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_302($this) {
  return $this.o5g_1.k3();
}
function HordesMarchUpgrade$_anonymous__3f5895() {
  var tmp = HordesMarchUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HordesMarchUpgrade', tmp, tmp$ret$0);
}
var HordesMarchUpgrade_instance;
function HordesMarchUpgrade_getInstance() {
  if (HordesMarchUpgrade_instance === VOID)
    new HordesMarchUpgrade();
  return HordesMarchUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_303($this) {
  return $this.p5g_1.k3();
}
function WildOdeUpgrade$_anonymous__r4sw2n() {
  var tmp = WildOdeUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WildOdeUpgrade', tmp, tmp$ret$0);
}
var WildOdeUpgrade_instance;
function WildOdeUpgrade_getInstance() {
  if (WildOdeUpgrade_instance === VOID)
    new WildOdeUpgrade();
  return WildOdeUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_304($this) {
  return $this.q5g_1.k3();
}
function ChiefsCommandUpgrade$_anonymous__rdo1go() {
  var tmp = ChiefsCommandUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ChiefsCommandUpgrade', tmp, tmp$ret$0);
}
var ChiefsCommandUpgrade_instance;
function ChiefsCommandUpgrade_getInstance() {
  if (ChiefsCommandUpgrade_instance === VOID)
    new ChiefsCommandUpgrade();
  return ChiefsCommandUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_305($this) {
  return $this.r5g_1.k3();
}
function PrimalInstinctsUpgrade$_anonymous__44nom7() {
  var tmp = PrimalInstinctsUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PrimalInstinctsUpgrade', tmp, tmp$ret$0);
}
var PrimalInstinctsUpgrade_instance;
function PrimalInstinctsUpgrade_getInstance() {
  if (PrimalInstinctsUpgrade_instance === VOID)
    new PrimalInstinctsUpgrade();
  return PrimalInstinctsUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_306($this) {
  return $this.s5g_1.k3();
}
function AmassUpgrade$_anonymous__msv2z4() {
  var tmp = AmassUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AmassUpgrade', tmp, tmp$ret$0);
}
var AmassUpgrade_instance;
function AmassUpgrade_getInstance() {
  if (AmassUpgrade_instance === VOID)
    new AmassUpgrade();
  return AmassUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_307($this) {
  return $this.u5g_1.k3();
}
function Hogbad$_anonymous__1ae4j2() {
  var tmp = Hogbad_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Hogbad', tmp, tmp$ret$0);
}
var Hogbad_instance;
function Hogbad_getInstance() {
  if (Hogbad_instance === VOID)
    new Hogbad();
  return Hogbad_instance;
}
function _get_$cachedSerializer__te6jhj_308($this) {
  return $this.v5g_1.k3();
}
function BoarToTransformQuestionContext$_anonymous__58grcv() {
  var tmp = BoarToTransformQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BoarToTransformQuestionContext', tmp, tmp$ret$0);
}
var BoarToTransformQuestionContext_instance;
function BoarToTransformQuestionContext_getInstance() {
  if (BoarToTransformQuestionContext_instance === VOID)
    new BoarToTransformQuestionContext();
  return BoarToTransformQuestionContext_instance;
}
function AmassTransformationStatement$Companion$$childSerializers$_anonymous__7zd5y1() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_378;
function Companion_getInstance_379() {
  if (Companion_instance_378 === VOID)
    new Companion_378();
  return Companion_instance_378;
}
var $serializer_instance_324;
function $serializer_getInstance_324() {
  if ($serializer_instance_324 === VOID)
    new $serializer_327();
  return $serializer_instance_324;
}
function _get_$cachedSerializer__te6jhj_309($this) {
  return $this.b5h_1.k3();
}
function ChiefsCommandStatement$_anonymous__if0dq3() {
  var tmp = ChiefsCommandStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ChiefsCommandStatement', tmp, tmp$ret$0);
}
var ChiefsCommandStatement_instance;
function ChiefsCommandStatement_getInstance() {
  if (ChiefsCommandStatement_instance === VOID)
    new ChiefsCommandStatement();
  return ChiefsCommandStatement_instance;
}
function _get_$cachedSerializer__te6jhj_310($this) {
  return $this.c5h_1.k3();
}
function PrimalInstinctsStatement$_anonymous__le5bgu() {
  var tmp = PrimalInstinctsStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PrimalInstinctsStatement', tmp, tmp$ret$0);
}
var PrimalInstinctsStatement_instance;
function PrimalInstinctsStatement_getInstance() {
  if (PrimalInstinctsStatement_instance === VOID)
    new PrimalInstinctsStatement();
  return PrimalInstinctsStatement_instance;
}
function PushStatement$Companion$$childSerializers$_anonymous__eaa1aj() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_379;
function Companion_getInstance_380() {
  if (Companion_instance_379 === VOID)
    new Companion_379();
  return Companion_instance_379;
}
var $serializer_instance_325;
function $serializer_getInstance_325() {
  if ($serializer_instance_325 === VOID)
    new $serializer_328();
  return $serializer_instance_325;
}
function _get_$cachedSerializer__te6jhj_311($this) {
  return $this.k5h_1.k3();
}
function WarhogType$_anonymous__9c2f2z() {
  var tmp = WarhogType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WarhogType', tmp, tmp$ret$0);
}
var WarhogType_instance;
function WarhogType_getInstance() {
  if (WarhogType_instance === VOID)
    new WarhogType();
  return WarhogType_instance;
}
function _get_$cachedSerializer__te6jhj_312($this) {
  return $this.n5h_1.k3();
}
function RambleCard$_anonymous__ogxyqy() {
  var tmp = RambleCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RambleCard', tmp, tmp$ret$0);
}
var RambleCard_instance;
function RambleCard_getInstance() {
  if (RambleCard_instance === VOID)
    new RambleCard();
  return RambleCard_instance;
}
function _get_$cachedSerializer__te6jhj_313($this) {
  return $this.q5h_1.k3();
}
function StampedeCard$_anonymous__uu04t8() {
  var tmp = StampedeCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('StampedeCard', tmp, tmp$ret$0);
}
var StampedeCard_instance;
function StampedeCard_getInstance() {
  if (StampedeCard_instance === VOID)
    new StampedeCard();
  return StampedeCard_instance;
}
function _get_$cachedSerializer__te6jhj_314($this) {
  return $this.s5h_1.k3();
}
function SummonWarhogCard$_anonymous__3r00ky() {
  var tmp = SummonWarhogCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonWarhogCard', tmp, tmp$ret$0);
}
var SummonWarhogCard_instance;
function SummonWarhogCard_getInstance() {
  if (SummonWarhogCard_instance === VOID)
    new SummonWarhogCard();
  return SummonWarhogCard_instance;
}
function _get_$cachedSerializer__te6jhj_315($this) {
  return $this.v5h_1.k3();
}
function TuskCard$_anonymous__l4vy1a() {
  var tmp = TuskCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TuskCard', tmp, tmp$ret$0);
}
var TuskCard_instance;
function TuskCard_getInstance() {
  if (TuskCard_instance === VOID)
    new TuskCard();
  return TuskCard_instance;
}
var Companion_instance_380;
function Companion_getInstance_381() {
  return Companion_instance_380;
}
function TrackCard$Companion$$childSerializers$_anonymous__fc705t() {
  return Companion_instance_380.a2g();
}
function TrackCard$Companion$$childSerializers$_anonymous__fc705t_0() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_381;
function Companion_getInstance_382() {
  if (Companion_instance_381 === VOID)
    new Companion_381();
  return Companion_instance_381;
}
var $serializer_instance_326;
function $serializer_getInstance_326() {
  if ($serializer_instance_326 === VOID)
    new $serializer_329();
  return $serializer_instance_326;
}
function HuntCard$Companion$$childSerializers$_anonymous__xctvyx() {
  return Companion_instance_380.a2g();
}
function HuntCard$Companion$$childSerializers$_anonymous__xctvyx_0() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_382;
function Companion_getInstance_383() {
  if (Companion_instance_382 === VOID)
    new Companion_382();
  return Companion_instance_382;
}
var $serializer_instance_327;
function $serializer_getInstance_327() {
  if ($serializer_instance_327 === VOID)
    new $serializer_330();
  return $serializer_instance_327;
}
var Companion_instance_383;
function Companion_getInstance_384() {
  return Companion_instance_383;
}
var Companion_instance_384;
function Companion_getInstance_385() {
  return Companion_instance_384;
}
var $serializer_instance_328;
function $serializer_getInstance_328() {
  if ($serializer_instance_328 === VOID)
    new $serializer_331();
  return $serializer_instance_328;
}
var Companion_instance_385;
function Companion_getInstance_386() {
  return Companion_instance_385;
}
var $serializer_instance_329;
function $serializer_getInstance_329() {
  if ($serializer_instance_329 === VOID)
    new $serializer_332();
  return $serializer_instance_329;
}
function _get_$cachedSerializer__te6jhj_316($this) {
  return $this.q5i_1.k3();
}
function EsmeriasStrandCard$_anonymous__e06ouq() {
  var tmp = EsmeriasStrandCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EsmeriasStrandCard', tmp, tmp$ret$0);
}
var EsmeriasStrandCard_instance;
function EsmeriasStrandCard_getInstance() {
  if (EsmeriasStrandCard_instance === VOID)
    new EsmeriasStrandCard();
  return EsmeriasStrandCard_instance;
}
var Companion_instance_386;
function Companion_getInstance_387() {
  return Companion_instance_386;
}
var $serializer_instance_330;
function $serializer_getInstance_330() {
  if ($serializer_instance_330 === VOID)
    new $serializer_333();
  return $serializer_instance_330;
}
var Companion_instance_387;
function Companion_getInstance_388() {
  return Companion_instance_387;
}
var $serializer_instance_331;
function $serializer_getInstance_331() {
  if ($serializer_instance_331 === VOID)
    new $serializer_334();
  return $serializer_instance_331;
}
var Companion_instance_388;
function Companion_getInstance_389() {
  return Companion_instance_388;
}
var Companion_instance_389;
function Companion_getInstance_390() {
  return Companion_instance_389;
}
var $serializer_instance_332;
function $serializer_getInstance_332() {
  if ($serializer_instance_332 === VOID)
    new $serializer_335();
  return $serializer_instance_332;
}
var Companion_instance_390;
function Companion_getInstance_391() {
  return Companion_instance_390;
}
var $serializer_instance_333;
function $serializer_getInstance_333() {
  if ($serializer_instance_333 === VOID)
    new $serializer_336();
  return $serializer_instance_333;
}
function OutpostCard$Companion$$childSerializers$_anonymous__vydq5w() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_391;
function Companion_getInstance_392() {
  if (Companion_instance_391 === VOID)
    new Companion_391();
  return Companion_instance_391;
}
var $serializer_instance_334;
function $serializer_getInstance_334() {
  if ($serializer_instance_334 === VOID)
    new $serializer_337();
  return $serializer_instance_334;
}
function WolfsbaneCard$Companion$$childSerializers$_anonymous__vyq2eb() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_392;
function Companion_getInstance_393() {
  if (Companion_instance_392 === VOID)
    new Companion_392();
  return Companion_instance_392;
}
var $serializer_instance_335;
function $serializer_getInstance_335() {
  if ($serializer_instance_335 === VOID)
    new $serializer_338();
  return $serializer_instance_335;
}
function HuntersRestCard$Companion$$childSerializers$_anonymous__5h3u7h() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_393;
function Companion_getInstance_394() {
  if (Companion_instance_393 === VOID)
    new Companion_393();
  return Companion_instance_393;
}
var $serializer_instance_336;
function $serializer_getInstance_336() {
  if ($serializer_instance_336 === VOID)
    new $serializer_339();
  return $serializer_instance_336;
}
function HuntersBellCard$Companion$$childSerializers$_anonymous__v4z7hg() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
var Companion_instance_394;
function Companion_getInstance_395() {
  if (Companion_instance_394 === VOID)
    new Companion_394();
  return Companion_instance_394;
}
var $serializer_instance_337;
function $serializer_getInstance_337() {
  if ($serializer_instance_337 === VOID)
    new $serializer_340();
  return $serializer_instance_337;
}
function HuntersPassageCard$Companion$$childSerializers$_anonymous__cp76n5() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_395;
function Companion_getInstance_396() {
  if (Companion_instance_395 === VOID)
    new Companion_395();
  return Companion_instance_395;
}
var $serializer_instance_338;
function $serializer_getInstance_338() {
  if ($serializer_instance_338 === VOID)
    new $serializer_341();
  return $serializer_instance_338;
}
function _get_$cachedSerializer__te6jhj_317($this) {
  return $this.m5k_1.k3();
}
function GrapeshotCard$_anonymous__7pou8y() {
  var tmp = GrapeshotCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('GrapeshotCard', tmp, tmp$ret$0);
}
var GrapeshotCard_instance;
function GrapeshotCard_getInstance() {
  if (GrapeshotCard_instance === VOID)
    new GrapeshotCard();
  return GrapeshotCard_instance;
}
function _get_$cachedSerializer__te6jhj_318($this) {
  return $this.o5k_1.k3();
}
function AurorasPassage$_anonymous__e6uq90() {
  var tmp = AurorasPassage_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AurorasPassage', tmp, tmp$ret$0);
}
var AurorasPassage_instance;
function AurorasPassage_getInstance() {
  if (AurorasPassage_instance === VOID)
    new AurorasPassage();
  return AurorasPassage_instance;
}
function _get_$cachedSerializer__te6jhj_319($this) {
  return $this.q5k_1.k3();
}
function BladeOfValhCard$_anonymous__up63z() {
  var tmp = BladeOfValhCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BladeOfValhCard', tmp, tmp$ret$0);
}
var BladeOfValhCard_instance;
function BladeOfValhCard_getInstance() {
  if (BladeOfValhCard_instance === VOID)
    new BladeOfValhCard();
  return BladeOfValhCard_instance;
}
function ExpeditionMapCard$Companion$$childSerializers$_anonymous__uqm6e9() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Companion_instance_396;
function Companion_getInstance_397() {
  if (Companion_instance_396 === VOID)
    new Companion_396();
  return Companion_instance_396;
}
var $serializer_instance_339;
function $serializer_getInstance_339() {
  if ($serializer_instance_339 === VOID)
    new $serializer_342();
  return $serializer_instance_339;
}
var Companion_instance_397;
function Companion_getInstance_398() {
  return Companion_instance_397;
}
var $serializer_instance_340;
function $serializer_getInstance_340() {
  if ($serializer_instance_340 === VOID)
    new $serializer_343();
  return $serializer_instance_340;
}
function SacredRichesCard$Companion$$childSerializers$_anonymous__ek42fg() {
  var tmp = Split_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Split', tmp, tmp$ret$0);
}
var Companion_instance_398;
function Companion_getInstance_399() {
  if (Companion_instance_398 === VOID)
    new Companion_398();
  return Companion_instance_398;
}
var $serializer_instance_341;
function $serializer_getInstance_341() {
  if ($serializer_instance_341 === VOID)
    new $serializer_344();
  return $serializer_instance_341;
}
function _get_$cachedSerializer__te6jhj_320($this) {
  return $this.i5l_1.k3();
}
function BansheesLureCard$_anonymous__bta3ok() {
  var tmp = BansheesLureCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BansheesLureCard', tmp, tmp$ret$0);
}
var BansheesLureCard_instance;
function BansheesLureCard_getInstance() {
  if (BansheesLureCard_instance === VOID)
    new BansheesLureCard();
  return BansheesLureCard_instance;
}
function _get_$cachedSerializer__te6jhj_321($this) {
  return $this.k5l_1.k3();
}
function ChainGrapnelCard$_anonymous__hyfwrx() {
  var tmp = ChainGrapnelCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ChainGrapnelCard', tmp, tmp$ret$0);
}
var ChainGrapnelCard_instance;
function ChainGrapnelCard_getInstance() {
  if (ChainGrapnelCard_instance === VOID)
    new ChainGrapnelCard();
  return ChainGrapnelCard_instance;
}
function _get_$cachedSerializer__te6jhj_322($this) {
  return $this.m5l_1.k3();
}
function SpyglassCard$_anonymous__m7lpwn() {
  var tmp = SpyglassCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SpyglassCard', tmp, tmp$ret$0);
}
var SpyglassCard_instance;
function SpyglassCard_getInstance() {
  if (SpyglassCard_instance === VOID)
    new SpyglassCard();
  return SpyglassCard_instance;
}
function _get_$cachedSerializer__te6jhj_323($this) {
  return $this.o5l_1.k3();
}
function WarhogsTuskCard$_anonymous__5immi5() {
  var tmp = WarhogsTuskCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WarhogsTuskCard', tmp, tmp$ret$0);
}
var WarhogsTuskCard_instance;
function WarhogsTuskCard_getInstance() {
  if (WarhogsTuskCard_instance === VOID)
    new WarhogsTuskCard();
  return WarhogsTuskCard_instance;
}
var Companion_instance_399;
function Companion_getInstance_400() {
  return Companion_instance_399;
}
function PlacedTrap$Companion$$childSerializers$_anonymous__ilw7og() {
  return createSimpleEnumSerializer('steelart.beast.Zone', values_1());
}
function PlacedTrap$Companion$$childSerializers$_anonymous__ilw7og_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
function PlacedTrap$Companion$$childSerializers$_anonymous__ilw7og_1() {
  return Companion_instance_399.a2g();
}
function PlacedTrap$Companion$$childSerializers$_anonymous__ilw7og_2() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_400;
function Companion_getInstance_401() {
  if (Companion_instance_400 === VOID)
    new Companion_400();
  return Companion_instance_400;
}
var $serializer_instance_342;
function $serializer_getInstance_342() {
  if ($serializer_instance_342 === VOID)
    new $serializer_345();
  return $serializer_instance_342;
}
var Companion_instance_401;
function Companion_getInstance_402() {
  return Companion_instance_401;
}
var $serializer_instance_343;
function $serializer_getInstance_343() {
  if ($serializer_instance_343 === VOID)
    new $serializer_346();
  return $serializer_instance_343;
}
function get_maxTrapsInZone($context_GameState_t6qee5) {
  return get_gameRules($context_GameState_t6qee5).e3b(ValueId_MaxTrapsNumberInZone_getInstance(), 3);
}
function _get_$cachedSerializer__te6jhj_324($this) {
  return $this.y5l_1.k3();
}
function Iona$_anonymous__v5d2pq() {
  var tmp = Iona_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Iona', tmp, tmp$ret$0);
}
var Iona_instance;
function Iona_getInstance() {
  if (Iona_instance === VOID)
    new Iona();
  return Iona_instance;
}
function _get_$cachedSerializer__te6jhj_325($this) {
  return $this.z5l_1.k3();
}
function JointEffortUpgrade$_anonymous__ihru4v() {
  var tmp = JointEffortUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('JointEffortUpgrade', tmp, tmp$ret$0);
}
var JointEffortUpgrade_instance;
function JointEffortUpgrade_getInstance() {
  if (JointEffortUpgrade_instance === VOID)
    new JointEffortUpgrade();
  return JointEffortUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_326($this) {
  return $this.a5m_1.k3();
}
function BallistaUpgrade$_anonymous__mclor3() {
  var tmp = BallistaUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BallistaUpgrade', tmp, tmp$ret$0);
}
var BallistaUpgrade_instance;
function BallistaUpgrade_getInstance() {
  if (BallistaUpgrade_instance === VOID)
    new BallistaUpgrade();
  return BallistaUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_327($this) {
  return $this.b5m_1.k3();
}
function CrepuscularUpgrade$_anonymous__obmjma() {
  var tmp = CrepuscularUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CrepuscularUpgrade', tmp, tmp$ret$0);
}
var CrepuscularUpgrade_instance;
function CrepuscularUpgrade_getInstance() {
  if (CrepuscularUpgrade_instance === VOID)
    new CrepuscularUpgrade();
  return CrepuscularUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_328($this) {
  return $this.c5m_1.k3();
}
function AncientCallingUpgrade$_anonymous__26yglj() {
  var tmp = AncientCallingUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AncientCallingUpgrade', tmp, tmp$ret$0);
}
var AncientCallingUpgrade_instance;
function AncientCallingUpgrade_getInstance() {
  if (AncientCallingUpgrade_instance === VOID)
    new AncientCallingUpgrade();
  return AncientCallingUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_329($this) {
  return $this.f5m_1.k3();
}
function SilverArrowCard$_anonymous__ezwgrv() {
  var tmp = SilverArrowCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SilverArrowCard', tmp, tmp$ret$0);
}
var SilverArrowCard_instance;
function SilverArrowCard_getInstance() {
  if (SilverArrowCard_instance === VOID)
    new SilverArrowCard();
  return SilverArrowCard_instance;
}
function get_ionaHunter($context_GameState_t6qee5) {
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Iona) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function _get_$cachedSerializer__te6jhj_330($this) {
  return $this.g5m_1.k3();
}
function NearSummonsAndBeastAttackModifier$_anonymous__7yu7q2() {
  var tmp = NearSummonsAndBeastAttackModifier_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NearSummonsAndBeastAttackModifier', tmp, tmp$ret$0);
}
var NearSummonsAndBeastAttackModifier_instance;
function NearSummonsAndBeastAttackModifier_getInstance() {
  if (NearSummonsAndBeastAttackModifier_instance === VOID)
    new NearSummonsAndBeastAttackModifier();
  return NearSummonsAndBeastAttackModifier_instance;
}
function _get_$cachedSerializer__te6jhj_331($this) {
  return $this.h5m_1.k3();
}
function Krim$_anonymous__ac5qb8() {
  var tmp = Krim_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Krim', tmp, tmp$ret$0);
}
var Krim_instance;
function Krim_getInstance() {
  if (Krim_instance === VOID)
    new Krim();
  return Krim_instance;
}
function _get_$cachedSerializer__te6jhj_332($this) {
  return $this.i5m_1.k3();
}
function ScavengerUpgrade$_anonymous__bcj2o1() {
  var tmp = ScavengerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ScavengerUpgrade', tmp, tmp$ret$0);
}
var ScavengerUpgrade_instance;
function ScavengerUpgrade_getInstance() {
  if (ScavengerUpgrade_instance === VOID)
    new ScavengerUpgrade();
  return ScavengerUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_333($this) {
  return $this.j5m_1.k3();
}
function TrapLauncherUpgrade$_anonymous__x3nh08() {
  var tmp = TrapLauncherUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TrapLauncherUpgrade', tmp, tmp$ret$0);
}
var TrapLauncherUpgrade_instance;
function TrapLauncherUpgrade_getInstance() {
  if (TrapLauncherUpgrade_instance === VOID)
    new TrapLauncherUpgrade();
  return TrapLauncherUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_334($this) {
  return $this.k5m_1.k3();
}
function PortableWorkshopUpgrade$_anonymous__m8y999() {
  var tmp = PortableWorkshopUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PortableWorkshopUpgrade', tmp, tmp$ret$0);
}
var PortableWorkshopUpgrade_instance;
function PortableWorkshopUpgrade_getInstance() {
  if (PortableWorkshopUpgrade_instance === VOID)
    new PortableWorkshopUpgrade();
  return PortableWorkshopUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_335($this) {
  return $this.l5m_1.k3();
}
function ResourcefulnessUpgrade$_anonymous__xd16n3() {
  var tmp = ResourcefulnessUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ResourcefulnessUpgrade', tmp, tmp$ret$0);
}
var ResourcefulnessUpgrade_instance;
function ResourcefulnessUpgrade_getInstance() {
  if (ResourcefulnessUpgrade_instance === VOID)
    new ResourcefulnessUpgrade();
  return ResourcefulnessUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_336($this) {
  return $this.m5m_1.k3();
}
function TrapToPlayForTrapmasterQuestionContext$_anonymous__azu392() {
  var tmp = TrapToPlayForTrapmasterQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TrapToPlayForTrapmasterQuestionContext', tmp, tmp$ret$0);
}
var TrapToPlayForTrapmasterQuestionContext_instance;
function TrapToPlayForTrapmasterQuestionContext_getInstance() {
  if (TrapToPlayForTrapmasterQuestionContext_instance === VOID)
    new TrapToPlayForTrapmasterQuestionContext();
  return TrapToPlayForTrapmasterQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_337($this) {
  return $this.n5m_1.k3();
}
function ResourcefulnessUpgradeStatement$_anonymous__8pb0zm() {
  var tmp = ResourcefulnessUpgradeStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ResourcefulnessUpgradeStatement', tmp, tmp$ret$0);
}
var ResourcefulnessUpgradeStatement_instance;
function ResourcefulnessUpgradeStatement_getInstance() {
  if (ResourcefulnessUpgradeStatement_instance === VOID)
    new ResourcefulnessUpgradeStatement();
  return ResourcefulnessUpgradeStatement_instance;
}
function TrapmasterStatement$Companion$$childSerializers$_anonymous__u7s4ju() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_402;
function Companion_getInstance_403() {
  if (Companion_instance_402 === VOID)
    new Companion_402();
  return Companion_instance_402;
}
var $serializer_instance_344;
function $serializer_getInstance_344() {
  if ($serializer_instance_344 === VOID)
    new $serializer_347();
  return $serializer_instance_344;
}
function _get_$cachedSerializer__te6jhj_338($this) {
  return $this.w5m_1.k3();
}
function TrapmasterCard$_anonymous__91cd7c() {
  var tmp = TrapmasterCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TrapmasterCard', tmp, tmp$ret$0);
}
var TrapmasterCard_instance;
function TrapmasterCard_getInstance() {
  if (TrapmasterCard_instance === VOID)
    new TrapmasterCard();
  return TrapmasterCard_instance;
}
function get_lowerShatteredIslesMap() {
  _init_properties_LowerShatteredIslesMap_kt__p50zlp();
  return lowerShatteredIslesMap;
}
var lowerShatteredIslesMap;
var LowerShatteredSettlements_instance;
function LowerShatteredSettlements_getInstance() {
  if (LowerShatteredSettlements_instance === VOID)
    new LowerShatteredSettlements();
  return LowerShatteredSettlements_instance;
}
var LowerShatteredRuins_instance;
function LowerShatteredRuins_getInstance() {
  if (LowerShatteredRuins_instance === VOID)
    new LowerShatteredRuins();
  return LowerShatteredRuins_instance;
}
function createLowerShatteredIsles() {
  _init_properties_LowerShatteredIslesMap_kt__p50zlp();
  var topLeft = _BoardPosition___init__impl__1nizgq_0(-4, -4);
  var bottomRight = _BoardPosition___init__impl__1nizgq_0(4, 4);
  var lowerShatteredIslesData = lowerShatteredIslesMapField();
  var locationsInit = toLocationsInitMap(topLeft, bottomRight, lowerShatteredIslesData);
  var removedConnections = setOf_0([setOf_0([new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-3, 1)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-2, 1))]), setOf_0([new BoardPosition(_BoardPosition___init__impl__1nizgq_0(0, -3)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(0, -2))])]);
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.p2();
  createLowerShatteredIsles$addPath(this_0, -2, 0, Companion_getInstance_114().f3l_1, -3, -1, Companion_getInstance_114().g3l_1);
  var inductionVariable = -4;
  if (inductionVariable <= -2)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      createLowerShatteredIsles$addPath(this_0, -3, y, Companion_getInstance_114().g3l_1, -1, y, Companion_getInstance_114().i3l_1);
    }
     while (inductionVariable <= -2);
  var inductionVariable_0 = -1;
  if (inductionVariable_0 <= 2)
    do {
      var x = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      createLowerShatteredIsles$addPath(this_0, x, -2, Companion_getInstance_114().h3l_1, x, 0, Companion_getInstance_114().f3l_1);
    }
     while (inductionVariable_0 <= 2);
  var inductionVariable_1 = -4;
  if (inductionVariable_1 <= -1)
    do {
      var x_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      createLowerShatteredIsles$addPath(this_0, x_0, 1, Companion_getInstance_114().h3l_1, x_0, 3, Companion_getInstance_114().f3l_1);
    }
     while (inductionVariable_1 <= -1);
  createLowerShatteredIsles$addPath(this_0, -4, 3, Companion_getInstance_114().h3l_1, -3, 4, Companion_getInstance_114().i3l_1);
  createLowerShatteredIsles$addPath(this_0, 3, 1, Companion_getInstance_114().g3l_1, 4, 2, Companion_getInstance_114().f3l_1);
  createLowerShatteredIsles$addPath(this_0, 3, 3, Companion_getInstance_114().g3l_1, 4, 2, Companion_getInstance_114().h3l_1);
  var tmp$ret$0 = this_0.g9();
  var nonStandardConnections = newConnectionsToNonStandard(tmp$ret$0);
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_1 = ArrayList.p2();
  createLowerShatteredIsles$addPath(this_1, 1, -4, Companion_getInstance_114().f3l_1, -4, 0, Companion_getInstance_114().i3l_1);
  createLowerShatteredIsles$addPath(this_1, -4, 3, Companion_getInstance_114().i3l_1, 1, 4, Companion_getInstance_114().h3l_1);
  createLowerShatteredIsles$addPath(this_1, 3, 3, Companion_getInstance_114().h3l_1, 2, -3, Companion_getInstance_114().g3l_1);
  createLowerShatteredIsles$addPath(this_1, 2, -4, Companion_getInstance_114().g3l_1, 3, 1, Companion_getInstance_114().f3l_1);
  var tmp$ret$4 = this_1.g9();
  var hiddenPathConnections = newConnectionsToNonStandard(tmp$ret$4);
  // Inline function 'kotlin.collections.mutableMapOf' call
  var zoneMap = LinkedHashMap.m7();
  var _iterator__ex2g4s = locationsInit.x4().p1();
  $l$loop: while (_iterator__ex2g4s.q1()) {
    var position = _iterator__ex2g4s.r1().r2v_1;
    if (position === _BoardPosition___init__impl__1nizgq_0(0, 0))
      continue $l$loop;
    var tmp2 = new BoardPosition(position);
    // Inline function 'kotlin.collections.set' call
    var value = _BoardPosition___get_y__impl__tale2e(position) <= -2 ? Zone_Achur_getInstance() : _BoardPosition___get_x__impl__gyx07(position) < 0 || position === _BoardPosition___init__impl__1nizgq_0(0, 3) || position === _BoardPosition___init__impl__1nizgq_0(0, 4) ? Zone_Elysur_getInstance() : Zone_Myrna_getInstance();
    zoneMap.b5(tmp2, value);
  }
  return new GameMapImpl(GameMapId_LowerShatteredIsles_getInstance(), setOf_0([Zone_Achur_getInstance(), Zone_Elysur_getInstance(), Zone_Myrna_getInstance()]), topLeft, bottomRight, locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, setOf_0([new BoardPosition(LowerShatteredSettlements_getInstance().o3b_1), new BoardPosition(LowerShatteredSettlements_getInstance().p3b_1), new BoardPosition(LowerShatteredSettlements_getInstance().q3b_1), new BoardPosition(LowerShatteredSettlements_getInstance().r3b_1), new BoardPosition(LowerShatteredSettlements_getInstance().s3b_1)]), emptySet(), setOf_0([new BoardPosition(LowerShatteredRuins_getInstance().x5m_1), new BoardPosition(LowerShatteredRuins_getInstance().y5m_1), new BoardPosition(LowerShatteredRuins_getInstance().z5m_1)]));
}
function lowerShatteredIslesMapField() {
  _init_properties_LowerShatteredIslesMap_kt__p50zlp();
  var st = LocationType_Settlement_getInstance();
  var sm = LocationType_Swamp_getInstance();
  var ft = LocationType_Forest_getInstance();
  var cv = LocationType_Cave_getInstance();
  var cf = LocationType_CaveAndForest_getInstance();
  var sf = LocationType_SwampAndForest_getInstance();
  var sc = LocationType_SwampAndCave_getInstance();
  var none = null;
  var shee = SheepType_getInstance();
  var boar = BoarType_getInstance();
  var tigr = TigerType_getInstance();
  var farm = FarmerType_getInstance();
  var nobl = NobleType_getInstance();
  var nullLocation = null;
  var beastOfLair0 = lowerShatteredIslesMapField$li(LocationType_LairOfTheBeast_getInstance(), null);
  return listOf_0([lowerShatteredIslesMapField$li(ft, none), lowerShatteredIslesMapField$li(sf, boar), nullLocation, lowerShatteredIslesMapField$li(cv, shee), lowerShatteredIslesMapField$li(sm, shee), lowerShatteredIslesMapField$li(ft, none), lowerShatteredIslesMapField$li(st, nobl), nullLocation, nullLocation, lowerShatteredIslesMapField$li(st, farm), lowerShatteredIslesMapField$li(cv, shee), nullLocation, lowerShatteredIslesMapField$li(ft, shee), lowerShatteredIslesMapField$li(ft, shee), lowerShatteredIslesMapField$li(cv, boar), lowerShatteredIslesMapField$li(sm, none), nullLocation, nullLocation, lowerShatteredIslesMapField$li(sm, none), lowerShatteredIslesMapField$li(ft, shee), nullLocation, lowerShatteredIslesMapField$li(sm, shee), lowerShatteredIslesMapField$li(ft, none), lowerShatteredIslesMapField$li(cv, shee), lowerShatteredIslesMapField$li(sm, tigr), nullLocation, nullLocation, lowerShatteredIslesMapField$li(ft, tigr), lowerShatteredIslesMapField$li(sm, none), nullLocation, nullLocation, nullLocation, nullLocation, nullLocation, nullLocation, nullLocation, lowerShatteredIslesMapField$li(ft, none), lowerShatteredIslesMapField$li(cv, shee), lowerShatteredIslesMapField$li(ft, shee), lowerShatteredIslesMapField$li(cv, none), beastOfLair0, lowerShatteredIslesMapField$li(sm, none), lowerShatteredIslesMapField$li(ft, none), nullLocation, nullLocation, lowerShatteredIslesMapField$li(sm, boar), lowerShatteredIslesMapField$li(st, nobl), lowerShatteredIslesMapField$li(cv, shee), lowerShatteredIslesMapField$li(sm, shee), lowerShatteredIslesMapField$li(cv, none), lowerShatteredIslesMapField$li(cv, shee), lowerShatteredIslesMapField$li(sm, shee), lowerShatteredIslesMapField$li(st, nobl), nullLocation, nullLocation, nullLocation, nullLocation, nullLocation, lowerShatteredIslesMapField$li(ft, shee), lowerShatteredIslesMapField$li(sm, shee), lowerShatteredIslesMapField$li(ft, shee), lowerShatteredIslesMapField$li(cf, boar), lowerShatteredIslesMapField$li(cv, shee), lowerShatteredIslesMapField$li(cv, none), lowerShatteredIslesMapField$li(ft, none), lowerShatteredIslesMapField$li(sc, boar), lowerShatteredIslesMapField$li(ft, shee), lowerShatteredIslesMapField$li(sm, none), lowerShatteredIslesMapField$li(ft, boar), lowerShatteredIslesMapField$li(sm, shee), lowerShatteredIslesMapField$li(sm, none), nullLocation, nullLocation, lowerShatteredIslesMapField$li(cv, none), lowerShatteredIslesMapField$li(sm, shee), lowerShatteredIslesMapField$li(ft, shee), lowerShatteredIslesMapField$li(st, farm), lowerShatteredIslesMapField$li(cv, none), lowerShatteredIslesMapField$li(cv, tigr), nullLocation, nullLocation]);
}
function createLowerShatteredIsles$addPath(_this__u8e3s4, x1, y1, d1, x2, y2, d2) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(x1, y1), d1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(x2, y2), d2)];
  return _this__u8e3s4.d2(tmp$ret$0);
}
function lowerShatteredIslesMapField$li(type, sot) {
  sot = sot === VOID ? null : sot;
  var tmp;
  if (sot == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = listOf(sot);
  }
  var tmp1_elvis_lhs = tmp;
  return new LocationInit(type, tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs);
}
var properties_initialized_LowerShatteredIslesMap_kt_f0je4l;
function _init_properties_LowerShatteredIslesMap_kt__p50zlp() {
  if (!properties_initialized_LowerShatteredIslesMap_kt_f0je4l) {
    properties_initialized_LowerShatteredIslesMap_kt_f0je4l = true;
    lowerShatteredIslesMap = createLowerShatteredIsles();
  }
}
function get_lydanHarvestKey() {
  _init_properties_Lydan_kt__uofwqa();
  return lydanHarvestKey;
}
var lydanHarvestKey;
function _get_$cachedSerializer__te6jhj_339($this) {
  return $this.a5n_1.k3();
}
function BeyondTheVeilUpgrade$_anonymous__z0sr69() {
  var tmp = BeyondTheVeilUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeyondTheVeilUpgrade', tmp, tmp$ret$0);
}
var BeyondTheVeilUpgrade_instance;
function BeyondTheVeilUpgrade_getInstance() {
  if (BeyondTheVeilUpgrade_instance === VOID)
    new BeyondTheVeilUpgrade();
  return BeyondTheVeilUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_340($this) {
  return $this.b5n_1.k3();
}
function AbundanceUpgrade$_anonymous__gukhys() {
  var tmp = AbundanceUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AbundanceUpgrade', tmp, tmp$ret$0);
}
var AbundanceUpgrade_instance;
function AbundanceUpgrade_getInstance() {
  if (AbundanceUpgrade_instance === VOID)
    new AbundanceUpgrade();
  return AbundanceUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_341($this) {
  return $this.c5n_1.k3();
}
function ReuniteUpgrade$_anonymous__ynud07() {
  var tmp = ReuniteUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ReuniteUpgrade', tmp, tmp$ret$0);
}
var ReuniteUpgrade_instance;
function ReuniteUpgrade_getInstance() {
  if (ReuniteUpgrade_instance === VOID)
    new ReuniteUpgrade();
  return ReuniteUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_342($this) {
  return $this.d5n_1.k3();
}
function DoomCallUpgrade$_anonymous__yf3r32() {
  var tmp = DoomCallUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DoomCallUpgrade', tmp, tmp$ret$0);
}
var DoomCallUpgrade_instance;
function DoomCallUpgrade_getInstance() {
  if (DoomCallUpgrade_instance === VOID)
    new DoomCallUpgrade();
  return DoomCallUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_343($this) {
  return $this.e5n_1.k3();
}
function FleshboundUpgrade$_anonymous__xh47mj() {
  var tmp = FleshboundUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FleshboundUpgrade', tmp, tmp$ret$0);
}
var FleshboundUpgrade_instance;
function FleshboundUpgrade_getInstance() {
  if (FleshboundUpgrade_instance === VOID)
    new FleshboundUpgrade();
  return FleshboundUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_344($this) {
  return $this.f5n_1.k3();
}
function SpiritboundUpgrade$_anonymous__mp9yqw() {
  var tmp = SpiritboundUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SpiritboundUpgrade', tmp, tmp$ret$0);
}
var SpiritboundUpgrade_instance;
function SpiritboundUpgrade_getInstance() {
  if (SpiritboundUpgrade_instance === VOID)
    new SpiritboundUpgrade();
  return SpiritboundUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_345($this) {
  return $this.i5n_1.k3();
}
function Lydan$_anonymous__tk065v() {
  var tmp = Lydan_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Lydan', tmp, tmp$ret$0);
}
var Lydan_instance;
function Lydan_getInstance() {
  if (Lydan_instance === VOID)
    new Lydan();
  return Lydan_instance;
}
function _get_$cachedSerializer__te6jhj_346($this) {
  return $this.j5n_1.k3();
}
function YeltrDeathDamageSource$_anonymous__5n0srb() {
  var tmp = YeltrDeathDamageSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('YeltrDeathDamageSource', tmp, tmp$ret$0);
}
var YeltrDeathDamageSource_instance;
function YeltrDeathDamageSource_getInstance() {
  if (YeltrDeathDamageSource_instance === VOID)
    new YeltrDeathDamageSource();
  return YeltrDeathDamageSource_instance;
}
function _get_$cachedSerializer__te6jhj_347($this) {
  return $this.k5n_1.k3();
}
function YeltrReapDamageSource$_anonymous__bfwvhp() {
  var tmp = YeltrReapDamageSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('YeltrReapDamageSource', tmp, tmp$ret$0);
}
var YeltrReapDamageSource_instance;
function YeltrReapDamageSource_getInstance() {
  if (YeltrReapDamageSource_instance === VOID)
    new YeltrReapDamageSource();
  return YeltrReapDamageSource_instance;
}
function _get_$cachedSerializer__te6jhj_348($this) {
  return $this.l5n_1.k3();
}
function LydanInitialHarvestEffectSource$_anonymous__pvwtcu() {
  var tmp = LydanInitialHarvestEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LydanInitialHarvestEffectSource', tmp, tmp$ret$0);
}
var LydanInitialHarvestEffectSource_instance;
function LydanInitialHarvestEffectSource_getInstance() {
  if (LydanInitialHarvestEffectSource_instance === VOID)
    new LydanInitialHarvestEffectSource();
  return LydanInitialHarvestEffectSource_instance;
}
var Companion_instance_403;
function Companion_getInstance_404() {
  return Companion_instance_403;
}
var $serializer_instance_345;
function $serializer_getInstance_345() {
  if ($serializer_instance_345 === VOID)
    new $serializer_348();
  return $serializer_instance_345;
}
function BeyondTheVeilPreventYeltrDamageStatement$Companion$$childSerializers$_anonymous__bxv61w() {
  var tmp = YeltrType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return $serializer_364.y2o(ObjectSerializer.l1c('YeltrType', tmp, tmp$ret$0));
}
var Companion_instance_404;
function Companion_getInstance_405() {
  if (Companion_instance_404 === VOID)
    new Companion_404();
  return Companion_instance_404;
}
var $serializer_instance_346;
function $serializer_getInstance_346() {
  if ($serializer_instance_346 === VOID)
    new $serializer_349();
  return $serializer_instance_346;
}
function BoltAndRecallStatement$Companion$$childSerializers$_anonymous__agwiqa() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_405;
function Companion_getInstance_406() {
  if (Companion_instance_405 === VOID)
    new Companion_405();
  return Companion_instance_405;
}
var $serializer_instance_347;
function $serializer_getInstance_347() {
  if ($serializer_instance_347 === VOID)
    new $serializer_350();
  return $serializer_instance_347;
}
function ReapStatement$Companion$$childSerializers$_anonymous__h6kh37() {
  var tmp = YeltrType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return $serializer_364.y2o(ObjectSerializer.l1c('YeltrType', tmp, tmp$ret$0));
}
var Companion_instance_406;
function Companion_getInstance_407() {
  if (Companion_instance_406 === VOID)
    new Companion_406();
  return Companion_instance_406;
}
var $serializer_instance_348;
function $serializer_getInstance_348() {
  if ($serializer_instance_348 === VOID)
    new $serializer_351();
  return $serializer_instance_348;
}
function SoulReapStatement$Companion$$childSerializers$_anonymous__addyuo() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_407;
function Companion_getInstance_408() {
  if (Companion_instance_407 === VOID)
    new Companion_407();
  return Companion_instance_407;
}
var $serializer_instance_349;
function $serializer_getInstance_349() {
  if ($serializer_instance_349 === VOID)
    new $serializer_352();
  return $serializer_instance_349;
}
function SummonYeltrStatement$Companion$$childSerializers$_anonymous__c2h1ko() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_408;
function Companion_getInstance_409() {
  if (Companion_instance_408 === VOID)
    new Companion_408();
  return Companion_instance_408;
}
var $serializer_instance_350;
function $serializer_getInstance_350() {
  if ($serializer_instance_350 === VOID)
    new $serializer_353();
  return $serializer_instance_350;
}
function ToothAndSeverStatement$Companion$$childSerializers$_anonymous__lky0oz() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_409;
function Companion_getInstance_410() {
  if (Companion_instance_409 === VOID)
    new Companion_409();
  return Companion_instance_409;
}
var $serializer_instance_351;
function $serializer_getInstance_351() {
  if ($serializer_instance_351 === VOID)
    new $serializer_354();
  return $serializer_instance_351;
}
var Companion_instance_410;
function Companion_getInstance_411() {
  return Companion_instance_410;
}
var $serializer_instance_352;
function $serializer_getInstance_352() {
  if ($serializer_instance_352 === VOID)
    new $serializer_355();
  return $serializer_instance_352;
}
var Companion_instance_411;
function Companion_getInstance_412() {
  return Companion_instance_411;
}
var $serializer_instance_353;
function $serializer_getInstance_353() {
  if ($serializer_instance_353 === VOID)
    new $serializer_356();
  return $serializer_instance_353;
}
function _get_$cachedSerializer__te6jhj_349($this) {
  return $this.e5p_1.k3();
}
function YeltrType$_anonymous__ft9ahr() {
  var tmp = YeltrType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('YeltrType', tmp, tmp$ret$0);
}
var YeltrType_instance;
function YeltrType_getInstance() {
  if (YeltrType_instance === VOID)
    new YeltrType();
  return YeltrType_instance;
}
function _get_$cachedSerializer__te6jhj_350($this) {
  return $this.h5p_1.k3();
}
function BoltAndRecallCard$_anonymous__8mbjkc() {
  var tmp = BoltAndRecallCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BoltAndRecallCard', tmp, tmp$ret$0);
}
var BoltAndRecallCard_instance;
function BoltAndRecallCard_getInstance() {
  if (BoltAndRecallCard_instance === VOID)
    new BoltAndRecallCard();
  return BoltAndRecallCard_instance;
}
function _get_$cachedSerializer__te6jhj_351($this) {
  return $this.k5p_1.k3();
}
function SoulReapCard$_anonymous__wwz1qm() {
  var tmp = SoulReapCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SoulReapCard', tmp, tmp$ret$0);
}
var SoulReapCard_instance;
function SoulReapCard_getInstance() {
  if (SoulReapCard_instance === VOID)
    new SoulReapCard();
  return SoulReapCard_instance;
}
function _get_$cachedSerializer__te6jhj_352($this) {
  return $this.n5p_1.k3();
}
function SummonYeltrCard$_anonymous__dj84ye() {
  var tmp = SummonYeltrCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonYeltrCard', tmp, tmp$ret$0);
}
var SummonYeltrCard_instance;
function SummonYeltrCard_getInstance() {
  if (SummonYeltrCard_instance === VOID)
    new SummonYeltrCard();
  return SummonYeltrCard_instance;
}
function _get_$cachedSerializer__te6jhj_353($this) {
  return $this.q5p_1.k3();
}
function ToothAndSeverCard$_anonymous__eks70b() {
  var tmp = ToothAndSeverCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ToothAndSeverCard', tmp, tmp$ret$0);
}
var ToothAndSeverCard_instance;
function ToothAndSeverCard_getInstance() {
  if (ToothAndSeverCard_instance === VOID)
    new ToothAndSeverCard();
  return ToothAndSeverCard_instance;
}
function get_lydanYeltr($context_GameState_t6qee5) {
  _init_properties_Lydan_kt__uofwqa();
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof YeltrType) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  var tmp$ret$9;
  $l$block_1: {
    // Inline function 'kotlin.collections.singleOrNull' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s_0 = destination.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (get_isAlive($context_GameState_t6qee5, element_0)) {
        if (found) {
          tmp$ret$9 = null;
          break $l$block_1;
        }
        single = element_0;
        found = true;
      }
    }
    if (!found) {
      tmp$ret$9 = null;
      break $l$block_1;
    }
    tmp$ret$9 = single;
  }
  return tmp$ret$9;
}
function get_lydanBeast($context_GameState_t6qee5) {
  _init_properties_Lydan_kt__uofwqa();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Lydan) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function get_lydanHarvest(gsCtx, _this__u8e3s4) {
  _init_properties_Lydan_kt__uofwqa();
  return getLydanHarvestImpl(_this__u8e3s4, gsCtx);
}
function get_lydanHarvestCapacityLeft($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_Lydan_kt__uofwqa();
  return coerceAtLeast(6 - get_lydanHarvest($context_GameState_t6qee5, _this__u8e3s4) | 0, 0);
}
function set_lydanHarvestImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Lydan_kt__uofwqa();
  setImplProperty(gsiCtx, _this__u8e3s4, get_lydanHarvestKey(), new IntWrapper(value));
}
function get_lydanHarvestImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Lydan_kt__uofwqa();
  return getLydanHarvestImpl(_this__u8e3s4, gsiCtx);
}
function getLydanHarvestImpl(_this__u8e3s4, gameState) {
  _init_properties_Lydan_kt__uofwqa();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_lydanHarvestKey()).t3p_1;
}
var properties_initialized_Lydan_kt_cm9jtg;
function _init_properties_Lydan_kt__uofwqa() {
  if (!properties_initialized_Lydan_kt_cm9jtg) {
    properties_initialized_Lydan_kt_cm9jtg = true;
    lydanHarvestKey = _GeneralMapKey___init__impl__zdmbea('lydanHarvest');
  }
}
function _get_$cachedSerializer__te6jhj_354($this) {
  return $this.r5p_1.k3();
}
function DeathsLamentUpgrade$_anonymous__7lrdot() {
  var tmp = DeathsLamentUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DeathsLamentUpgrade', tmp, tmp$ret$0);
}
var DeathsLamentUpgrade_instance;
function DeathsLamentUpgrade_getInstance() {
  if (DeathsLamentUpgrade_instance === VOID)
    new DeathsLamentUpgrade();
  return DeathsLamentUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_355($this) {
  return $this.s5p_1.k3();
}
function SoulHarvestUpgrade$_anonymous__yuxor5() {
  var tmp = SoulHarvestUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SoulHarvestUpgrade', tmp, tmp$ret$0);
}
var SoulHarvestUpgrade_instance;
function SoulHarvestUpgrade_getInstance() {
  if (SoulHarvestUpgrade_instance === VOID)
    new SoulHarvestUpgrade();
  return SoulHarvestUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_356($this) {
  return $this.t5p_1.k3();
}
function PandemoniumUpgrade$_anonymous__9gn6fi() {
  var tmp = PandemoniumUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PandemoniumUpgrade', tmp, tmp$ret$0);
}
var PandemoniumUpgrade_instance;
function PandemoniumUpgrade_getInstance() {
  if (PandemoniumUpgrade_instance === VOID)
    new PandemoniumUpgrade();
  return PandemoniumUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_357($this) {
  return $this.u5p_1.k3();
}
function SongOfTemptationUpgrade$_anonymous__dvuwsc() {
  var tmp = SongOfTemptationUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SongOfTemptationUpgrade', tmp, tmp$ret$0);
}
var SongOfTemptationUpgrade_instance;
function SongOfTemptationUpgrade_getInstance() {
  if (SongOfTemptationUpgrade_instance === VOID)
    new SongOfTemptationUpgrade();
  return SongOfTemptationUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_358($this) {
  return $this.v5p_1.k3();
}
function VanishUpgrade$_anonymous__928k22() {
  var tmp = VanishUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('VanishUpgrade', tmp, tmp$ret$0);
}
var VanishUpgrade_instance;
function VanishUpgrade_getInstance() {
  if (VanishUpgrade_instance === VOID)
    new VanishUpgrade();
  return VanishUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_359($this) {
  return $this.w5p_1.k3();
}
function VoidPresenceUpgrade$_anonymous__cdm4eu() {
  var tmp = VoidPresenceUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('VoidPresenceUpgrade', tmp, tmp$ret$0);
}
var VoidPresenceUpgrade_instance;
function VoidPresenceUpgrade_getInstance() {
  if (VoidPresenceUpgrade_instance === VOID)
    new VoidPresenceUpgrade();
  return VoidPresenceUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_360($this) {
  return $this.x5p_1.k3();
}
function FearTheNightUpgrade$_anonymous__tspyj2() {
  var tmp = FearTheNightUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FearTheNightUpgrade', tmp, tmp$ret$0);
}
var FearTheNightUpgrade_instance;
function FearTheNightUpgrade_getInstance() {
  if (FearTheNightUpgrade_instance === VOID)
    new FearTheNightUpgrade();
  return FearTheNightUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_361($this) {
  return $this.z5p_1.k3();
}
function Mara$_anonymous__l8b9n8() {
  var tmp = Mara_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Mara', tmp, tmp$ret$0);
}
var Mara_instance;
function Mara_getInstance() {
  if (Mara_instance === VOID)
    new Mara();
  return Mara_instance;
}
function _get_$cachedSerializer__te6jhj_362($this) {
  return $this.c5q_1.k3();
}
function FeedCard$_anonymous__g0dq0n() {
  var tmp = FeedCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FeedCard', tmp, tmp$ret$0);
}
var FeedCard_instance;
function FeedCard_getInstance() {
  if (FeedCard_instance === VOID)
    new FeedCard();
  return FeedCard_instance;
}
function RelocateToBansheeAndRevealStatement$Companion$$childSerializers$_anonymous__g7ck1x() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_412;
function Companion_getInstance_413() {
  if (Companion_instance_412 === VOID)
    new Companion_412();
  return Companion_instance_412;
}
var $serializer_instance_354;
function $serializer_getInstance_354() {
  if ($serializer_instance_354 === VOID)
    new $serializer_357();
  return $serializer_instance_354;
}
function VanishStatement$Companion$$childSerializers$_anonymous__qwhzgq() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_413;
function Companion_getInstance_414() {
  if (Companion_instance_413 === VOID)
    new Companion_413();
  return Companion_instance_413;
}
var $serializer_instance_355;
function $serializer_getInstance_355() {
  if ($serializer_instance_355 === VOID)
    new $serializer_358();
  return $serializer_instance_355;
}
function _get_$cachedSerializer__te6jhj_363($this) {
  return $this.o5q_1.k3();
}
function BansheeType$_anonymous__hqzdkp() {
  var tmp = BansheeType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BansheeType', tmp, tmp$ret$0);
}
var BansheeType_instance;
function BansheeType_getInstance() {
  if (BansheeType_instance === VOID)
    new BansheeType();
  return BansheeType_instance;
}
function _get_$cachedSerializer__te6jhj_364($this) {
  return $this.r5q_1.k3();
}
function FlickerCard$_anonymous__6xd433() {
  var tmp = FlickerCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FlickerCard', tmp, tmp$ret$0);
}
var FlickerCard_instance;
function FlickerCard_getInstance() {
  if (FlickerCard_instance === VOID)
    new FlickerCard();
  return FlickerCard_instance;
}
function _get_$cachedSerializer__te6jhj_365($this) {
  return $this.v5q_1.k3();
}
function ObscureTalentCard$_anonymous__fll186() {
  var tmp = ObscureTalentCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ObscureTalentCard', tmp, tmp$ret$0);
}
var ObscureTalentCard_instance;
function ObscureTalentCard_getInstance() {
  if (ObscureTalentCard_instance === VOID)
    new ObscureTalentCard();
  return ObscureTalentCard_instance;
}
function _get_$cachedSerializer__te6jhj_366($this) {
  return $this.y5q_1.k3();
}
function ShadowStepCard$_anonymous__g3c0ij() {
  var tmp = ShadowStepCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ShadowStepCard', tmp, tmp$ret$0);
}
var ShadowStepCard_instance;
function ShadowStepCard_getInstance() {
  if (ShadowStepCard_instance === VOID)
    new ShadowStepCard();
  return ShadowStepCard_instance;
}
function _get_$cachedSerializer__te6jhj_367($this) {
  return $this.a5r_1.k3();
}
function Nora$_anonymous__z92xnd() {
  var tmp = Nora_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Nora', tmp, tmp$ret$0);
}
var Nora_instance;
function Nora_getInstance() {
  if (Nora_instance === VOID)
    new Nora();
  return Nora_instance;
}
function _get_$cachedSerializer__te6jhj_368($this) {
  return $this.b5r_1.k3();
}
function AwarenessUpgrade$_anonymous__9q9cxc() {
  var tmp = AwarenessUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AwarenessUpgrade', tmp, tmp$ret$0);
}
var AwarenessUpgrade_instance;
function AwarenessUpgrade_getInstance() {
  if (AwarenessUpgrade_instance === VOID)
    new AwarenessUpgrade();
  return AwarenessUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_369($this) {
  return $this.c5r_1.k3();
}
function RevengeOfTheSheepUpgrade$_anonymous__7uljxi() {
  var tmp = RevengeOfTheSheepUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RevengeOfTheSheepUpgrade', tmp, tmp$ret$0);
}
var RevengeOfTheSheepUpgrade_instance;
function RevengeOfTheSheepUpgrade_getInstance() {
  if (RevengeOfTheSheepUpgrade_instance === VOID)
    new RevengeOfTheSheepUpgrade();
  return RevengeOfTheSheepUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_370($this) {
  return $this.d5r_1.k3();
}
function WildbondUpgrade$_anonymous__ymor3s() {
  var tmp = WildbondUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WildbondUpgrade', tmp, tmp$ret$0);
}
var WildbondUpgrade_instance;
function WildbondUpgrade_getInstance() {
  if (WildbondUpgrade_instance === VOID)
    new WildbondUpgrade();
  return WildbondUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_371($this) {
  return $this.e5r_1.k3();
}
function BeastTongueUpgrade$_anonymous__yh2mm6() {
  var tmp = BeastTongueUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeastTongueUpgrade', tmp, tmp$ret$0);
}
var BeastTongueUpgrade_instance;
function BeastTongueUpgrade_getInstance() {
  if (BeastTongueUpgrade_instance === VOID)
    new BeastTongueUpgrade();
  return BeastTongueUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_372($this) {
  return $this.f5r_1.k3();
}
function AnimalToSearchWithQuestionContext$_anonymous__34wnf1() {
  var tmp = AnimalToSearchWithQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AnimalToSearchWithQuestionContext', tmp, tmp$ret$0);
}
var AnimalToSearchWithQuestionContext_instance;
function AnimalToSearchWithQuestionContext_getInstance() {
  if (AnimalToSearchWithQuestionContext_instance === VOID)
    new AnimalToSearchWithQuestionContext();
  return AnimalToSearchWithQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_373($this) {
  return $this.g5r_1.k3();
}
function SheepForMoveAndAttackQuestionContext$_anonymous__mur5ea() {
  var tmp = SheepForMoveAndAttackQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SheepForMoveAndAttackQuestionContext', tmp, tmp$ret$0);
}
var SheepForMoveAndAttackQuestionContext_instance;
function SheepForMoveAndAttackQuestionContext_getInstance() {
  if (SheepForMoveAndAttackQuestionContext_instance === VOID)
    new SheepForMoveAndAttackQuestionContext();
  return SheepForMoveAndAttackQuestionContext_instance;
}
function AttackBySheepStatement$Companion$$childSerializers$_anonymous__9s14uh() {
  var tmp = SheepType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return $serializer_364.y2o(ObjectSerializer.l1c('SheepType', tmp, tmp$ret$0));
}
var Companion_instance_414;
function Companion_getInstance_415() {
  if (Companion_instance_414 === VOID)
    new Companion_414();
  return Companion_instance_414;
}
var $serializer_instance_356;
function $serializer_getInstance_356() {
  if ($serializer_instance_356 === VOID)
    new $serializer_359();
  return $serializer_instance_356;
}
function HerdStatement$Companion$$childSerializers$_anonymous__8cgmcq() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_415;
function Companion_getInstance_416() {
  if (Companion_instance_415 === VOID)
    new Companion_415();
  return Companion_instance_415;
}
var $serializer_instance_357;
function $serializer_getInstance_357() {
  if ($serializer_instance_357 === VOID)
    new $serializer_360();
  return $serializer_instance_357;
}
function MountStatement$Companion$$childSerializers$_anonymous__boibsc() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_416;
function Companion_getInstance_417() {
  if (Companion_instance_416 === VOID)
    new Companion_416();
  return Companion_instance_416;
}
var $serializer_instance_358;
function $serializer_getInstance_358() {
  if ($serializer_instance_358 === VOID)
    new $serializer_361();
  return $serializer_instance_358;
}
function MoveWithAnimalStatement$Companion$$childSerializers$_anonymous__b0aq0i() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_417;
function Companion_getInstance_418() {
  if (Companion_instance_417 === VOID)
    new Companion_417();
  return Companion_instance_417;
}
var $serializer_instance_359;
function $serializer_getInstance_359() {
  if ($serializer_instance_359 === VOID)
    new $serializer_362();
  return $serializer_instance_359;
}
function RevengeOfTheSheepStatement$Companion$$childSerializers$_anonymous__wjnqqi() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_418;
function Companion_getInstance_419() {
  if (Companion_instance_418 === VOID)
    new Companion_418();
  return Companion_instance_418;
}
var $serializer_instance_360;
function $serializer_getInstance_360() {
  if ($serializer_instance_360 === VOID)
    new $serializer_363();
  return $serializer_instance_360;
}
function _get_$cachedSerializer__te6jhj_374($this) {
  return $this.i5s_1.k3();
}
function HerdCard$_anonymous__17pgzs() {
  var tmp = HerdCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HerdCard', tmp, tmp$ret$0);
}
var HerdCard_instance;
function HerdCard_getInstance() {
  if (HerdCard_instance === VOID)
    new HerdCard();
  return HerdCard_instance;
}
function _get_$cachedSerializer__te6jhj_375($this) {
  return $this.l5s_1.k3();
}
function MountCard$_anonymous__5tiv2m() {
  var tmp = MountCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MountCard', tmp, tmp$ret$0);
}
var MountCard_instance;
function MountCard_getInstance() {
  if (MountCard_instance === VOID)
    new MountCard();
  return MountCard_instance;
}
function get_ashfallNorthernExpanse() {
  _init_properties_NorthernExpanseMap_kt__yvo0t8();
  return ashfallNorthernExpanse;
}
var ashfallNorthernExpanse;
function get_northernExpanseMap() {
  _init_properties_NorthernExpanseMap_kt__yvo0t8();
  return northernExpanseMap;
}
var northernExpanseMap;
function get_ashfallDrenchedLands() {
  _init_properties_NorthernExpanseMap_kt__yvo0t8();
  return ashfallDrenchedLands;
}
var ashfallDrenchedLands;
function get_drenchedLandsMap() {
  _init_properties_NorthernExpanseMap_kt__yvo0t8();
  return drenchedLandsMap;
}
var drenchedLandsMap;
var allAshfallBoatPositions;
var NorthernNamedSettlements_instance;
function NorthernNamedSettlements_getInstance() {
  if (NorthernNamedSettlements_instance === VOID)
    new NorthernNamedSettlements();
  return NorthernNamedSettlements_instance;
}
function createNorthernExpanseWithHiddenPath() {
  _init_properties_NorthernExpanseMap_kt__yvo0t8();
  var topLeft = _BoardPosition___init__impl__1nizgq_0(-5, -4);
  var bottomRight = _BoardPosition___init__impl__1nizgq_0(5, 4);
  var northernExpanseMapField_0 = northernExpanseMapField();
  var locationsInit = toLocationsInitMap(topLeft, bottomRight, northernExpanseMapField_0);
  var removedConnections = setOf_0([setOf_0([new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-4, -3)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-3, -3))]), setOf_0([new BoardPosition(_BoardPosition___init__impl__1nizgq_0(3, -2)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(4, -2))])]);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-1, 0), Companion_getInstance_114().i3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-2, -1), Companion_getInstance_114().h3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-5, 1), Companion_getInstance_114().f3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-5, -1), Companion_getInstance_114().h3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-4, 1), Companion_getInstance_114().f3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-4, -1), Companion_getInstance_114().h3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-3, 1), Companion_getInstance_114().f3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-3, -1), Companion_getInstance_114().h3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_3 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(3, -1), Companion_getInstance_114().g3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(4, -2), Companion_getInstance_114().i3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_4 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(3, 1), Companion_getInstance_114().f3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(3, -1), Companion_getInstance_114().h3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_5 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(4, 0), Companion_getInstance_114().f3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(4, -2), Companion_getInstance_114().h3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_6 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(5, 0), Companion_getInstance_114().f3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(5, -2), Companion_getInstance_114().h3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$24 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-1, 4), Companion_getInstance_114().g3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(1, 4), Companion_getInstance_114().i3l_1)];
  var newConnections = listOf_0([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp$ret$24]);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_7 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-3, -4), Companion_getInstance_114().f3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-5, -1), Companion_getInstance_114().i3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_8 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-1, -4), Companion_getInstance_114().g3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(1, -4), Companion_getInstance_114().i3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_9 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(3, -4), Companion_getInstance_114().f3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(5, -2), Companion_getInstance_114().g3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_10 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-5, 3), Companion_getInstance_114().i3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-1, 4), Companion_getInstance_114().h3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_11 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(2, 4), Companion_getInstance_114().h3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(5, 2), Companion_getInstance_114().g3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$42 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-2, 1), Companion_getInstance_114().f3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(1, 3), Companion_getInstance_114().i3l_1)];
  var hiddenPathConnections = newConnectionsToNonStandard(listOf_0([tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp$ret$42]));
  var nonStandardConnections = newConnectionsToNonStandard(newConnections);
  // Inline function 'kotlin.collections.mutableMapOf' call
  var zoneMap = LinkedHashMap.m7();
  var inductionVariable = _BoardPosition___get_y__impl__tale2e(topLeft);
  var last = _BoardPosition___get_y__impl__tale2e(bottomRight);
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = _BoardPosition___get_x__impl__gyx07(topLeft);
      var last_0 = _BoardPosition___get_x__impl__gyx07(bottomRight);
      if (inductionVariable_0 <= last_0)
        $l$loop_0: do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var position = _BoardPosition___init__impl__1nizgq_0(x, y);
          if (locationsInit.w4(new BoardPosition(position)) == null) {
            continue $l$loop_0;
          }
          if (x === 0 && y === 0)
            continue $l$loop_0;
          var tmp2 = new BoardPosition(position);
          var tmp_12;
          if (y === 0 && x >= 4) {
            tmp_12 = Zone_Jarlland_getInstance();
          } else if (y <= 0) {
            var tmp_13;
            if (x < 0 || (x === 0 && y === -1)) {
              tmp_13 = Zone_Barum_getInstance();
            } else {
              tmp_13 = Zone_Vildmark_getInstance();
            }
            tmp_12 = tmp_13;
          } else {
            var tmp_14;
            if (x <= 0) {
              tmp_14 = Zone_NewElda_getInstance();
            } else {
              tmp_14 = Zone_Jarlland_getInstance();
            }
            tmp_12 = tmp_14;
          }
          // Inline function 'kotlin.collections.set' call
          var value = tmp_12;
          zoneMap.b5(tmp2, value);
        }
         while (!(x === last_0));
    }
     while (!(y === last));
  var zones = setOf_0([Zone_Barum_getInstance(), Zone_Vildmark_getInstance(), Zone_NewElda_getInstance(), Zone_Jarlland_getInstance()]);
  return new GameMapImpl(GameMapId_NorthernExpanse_getInstance(), zones, topLeft, bottomRight, locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, setOf_0([new BoardPosition(NorthernNamedSettlements_getInstance().m5s_1), new BoardPosition(NorthernNamedSettlements_getInstance().n5s_1), new BoardPosition(NorthernNamedSettlements_getInstance().o5s_1), new BoardPosition(NorthernNamedSettlements_getInstance().p5s_1), new BoardPosition(NorthernNamedSettlements_getInstance().q5s_1), new BoardPosition(NorthernNamedSettlements_getInstance().r5s_1), new BoardPosition(NorthernNamedSettlements_getInstance().s5s_1)]), setOf_0([new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-2, -3)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(2, -3)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-4, 1)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(4, 1))]), toSet(get_ashfallRuinPositionsByZone().y4()));
}
function drenchedLandsMapWithHiddenPath() {
  _init_properties_NorthernExpanseMap_kt__yvo0t8();
  var zones = setOf_0([Zone_Barum_getInstance(), Zone_Vildmark_getInstance()]);
  var baseMap = get_ashfallNorthernExpanse();
  // Inline function 'kotlin.collections.filterKeys' call
  var this_0 = baseMap.p44_1;
  var result = LinkedHashMap.m7();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this_0.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var entry = _iterator__ex2g4s.r1();
    var p = entry.j3().r2v_1;
    if (drenchedLandsMapWithHiddenPath$isFitPosition(p)) {
      result.b5(entry.j3(), entry.k3());
    }
  }
  var locationsInit = toMutableMap(result);
  var tmp2 = new BoardPosition(_BoardPosition___init__impl__1nizgq_0(2, 0));
  // Inline function 'kotlin.collections.set' call
  var value = new LocationInit(LocationType_Cave_getInstance(), listOf(SheepType_getInstance()));
  locationsInit.b5(tmp2, value);
  var tmp2_0 = new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-3, -1));
  // Inline function 'kotlin.collections.set' call
  var value_0 = new LocationInit(LocationType_Settlement_getInstance(), listOf(NobleType_getInstance()));
  locationsInit.b5(tmp2_0, value_0);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-1, 0), Companion_getInstance_114().i3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(-2, -1), Companion_getInstance_114().h3l_1)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(3, -1), Companion_getInstance_114().g3l_1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(4, -2), Companion_getInstance_114().i3l_1)];
  var newConnections = setOf_0([tmp, tmp$ret$8]);
  var nonStandardConnections = newConnectionsToNonStandard(newConnections);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = baseMap.t44_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = LinkedHashMap.m7();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = tmp0.i3().p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element = _iterator__ex2g4s_0.r1();
    if (!(baseMap.p44_1.w4(new BoardPosition(element.j3().d45_1)) == null)) {
      destination.b5(element.j3(), element.k3());
    }
  }
  var hiddenPathConnections = toMap(destination);
  var tmp_0 = GameMapId_DrenchedLands_getInstance();
  var tmp_1 = _BoardPosition___init__impl__1nizgq_0(_BoardPosition___get_x__impl__gyx07(baseMap.o44_1), 0);
  var tmp_2 = toMap(locationsInit);
  var tmp_3 = setOf_0([new BoardPosition(NorthernNamedSettlements_getInstance().m5s_1), new BoardPosition(NorthernNamedSettlements_getInstance().n5s_1), new BoardPosition(NorthernNamedSettlements_getInstance().q5s_1)]);
  var tmp_4 = setOf_0([new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-2, -3)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(2, -3))]);
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = zones.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_0 = _iterator__ex2g4s_1.r1();
    var tmp0_safe_receiver = get_ashfallRuinPositionsByZone().w4(element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.d2(tmp0_safe_receiver);
    }
  }
  return new GameMapImpl(tmp_0, zones, baseMap.n44_1, tmp_1, tmp_2, nonStandardConnections, baseMap.r44_1, baseMap.s44_1, hiddenPathConnections, tmp_3, tmp_4, toSet(destination_0));
}
function northernExpanseMapField() {
  _init_properties_NorthernExpanseMap_kt__yvo0t8();
  var st = LocationType_Settlement_getInstance();
  var sm = LocationType_Swamp_getInstance();
  var ft = LocationType_Forest_getInstance();
  var cv = LocationType_Cave_getInstance();
  var none = null;
  var ship = SheepType_getInstance();
  var boar = BoarType_getInstance();
  var bear = BearType_getInstance();
  var farm = FarmerType_getInstance();
  var nobl = NobleType_getInstance();
  var nullLocation = null;
  var beastOfLair0 = northernExpanseMapField$li(LocationType_LairOfTheBeast_getInstance(), null);
  return listOf_0([northernExpanseMapField$li(ft, bear), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(cv, ship), northernExpanseMapField$li(cv, boar), nullLocation, northernExpanseMapField$li(ft, none), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(cv, ship), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(cv, bear), northernExpanseMapField$li(ft, boar), northernExpanseMapField$li(cv, ship), northernExpanseMapField$li(ft, none), northernExpanseMapField$li(ft, ship), northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(st, farm), northernExpanseMapField$li(ft, ship), northernExpanseMapField$li(ft, boar), northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(cv, boar), northernExpanseMapField$li(ft, none), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(cv, ship), northernExpanseMapField$li(ft, none), northernExpanseMapField$li(cv, boar), northernExpanseMapField$li(cv, ship), northernExpanseMapField$li(sm, boar), northernExpanseMapField$li(ft, ship), northernExpanseMapField$li(st, nobl), northernExpanseMapField$li(ft, none), northernExpanseMapField$li(ft, ship), northernExpanseMapField$li(ft, none), northernExpanseMapField$li(sm, boar), northernExpanseMapField$li(st, farm), northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(ft, ship), northernExpanseMapField$li(cv, none), northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(cv, boar), nullLocation, nullLocation, nullLocation, nullLocation, nullLocation, nullLocation, northernExpanseMapField$li(cv, none), beastOfLair0, northernExpanseMapField$li(ft, none), northernExpanseMapField$li(cv, none), nullLocation, northernExpanseMapField$li(cv, ship), northernExpanseMapField$li(sm, boar), northernExpanseMapField$li(cv, none), northernExpanseMapField$li(ft, ship), northernExpanseMapField$li(ft, none), northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(ft, ship), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(cv, ship), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(ft, ship), northernExpanseMapField$li(ft, none), northernExpanseMapField$li(cv, ship), northernExpanseMapField$li(cv, boar), northernExpanseMapField$li(cv, none), northernExpanseMapField$li(st, farm), northernExpanseMapField$li(ft, boar), northernExpanseMapField$li(cv, ship), northernExpanseMapField$li(cv, none), northernExpanseMapField$li(st, farm), northernExpanseMapField$li(ft, boar), northernExpanseMapField$li(cv, boar), northernExpanseMapField$li(cv, none), northernExpanseMapField$li(ft, none), northernExpanseMapField$li(st, nobl), northernExpanseMapField$li(sm, boar), northernExpanseMapField$li(ft, none), northernExpanseMapField$li(ft, boar), nullLocation, northernExpanseMapField$li(sm, boar), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(st, nobl), northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(sm, bear), northernExpanseMapField$li(sm, none), northernExpanseMapField$li(cv, boar), northernExpanseMapField$li(cv, none), northernExpanseMapField$li(sm, none), nullLocation, northernExpanseMapField$li(sm, ship), northernExpanseMapField$li(cv, none), northernExpanseMapField$li(ft, boar), northernExpanseMapField$li(cv, none), northernExpanseMapField$li(cv, bear)]);
}
function drenchedLandsMapWithHiddenPath$isFitPosition(p) {
  return _BoardPosition___get_y__impl__tale2e(p) === 0 ? _BoardPosition___get_x__impl__gyx07(p) > -2 && _BoardPosition___get_x__impl__gyx07(p) < 3 : _BoardPosition___get_y__impl__tale2e(p) < 0;
}
function northernExpanseMapField$li(type, sot) {
  var tmp;
  if (sot == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = listOf(sot);
  }
  var tmp1_elvis_lhs = tmp;
  return new LocationInit(type, tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs);
}
var properties_initialized_NorthernExpanseMap_kt_o9030i;
function _init_properties_NorthernExpanseMap_kt__yvo0t8() {
  if (!properties_initialized_NorthernExpanseMap_kt_o9030i) {
    properties_initialized_NorthernExpanseMap_kt_o9030i = true;
    ashfallNorthernExpanse = createNorthernExpanseWithHiddenPath();
    northernExpanseMap = get_ashfallNorthernExpanse().g45(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, emptyMap(), VOID, VOID, emptySet());
    ashfallDrenchedLands = drenchedLandsMapWithHiddenPath();
    drenchedLandsMap = get_ashfallDrenchedLands().g45(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, emptyMap(), VOID, VOID, emptySet());
    allAshfallBoatPositions = setOf_0([new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-4, -2)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(3, -3)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-3, 3)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(3, 1))]);
  }
}
function get_objectTypeKey() {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return objectTypeKey;
}
var objectTypeKey;
function get_positionKey() {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return positionKey;
}
var positionKey;
function get_woundKey() {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return woundKey;
}
var woundKey;
function get_armorKey() {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return armorKey;
}
var armorKey;
function get_destroyRecordIndexKey() {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return destroyRecordIndexKey;
}
var destroyRecordIndexKey;
function get_isAliveKey() {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return isAliveKey;
}
var isAliveKey;
function get_initialPositionKey() {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return initialPositionKey;
}
var initialPositionKey;
var Companion_instance_419;
function Companion_getInstance_420() {
  if (Companion_instance_419 === VOID)
    new Companion_419();
  return Companion_instance_419;
}
var Companion_instance_420;
function Companion_getInstance_421() {
  return Companion_instance_420;
}
function get_objectType($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  var tmp = get_implProperty($context_GameState_t6qee5, _this__u8e3s4, get_objectTypeKey());
  return isInterface(tmp, ObjectOnBoardType) ? tmp : THROW_CCE();
}
function get_initialPosition($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return get_implProperty($context_GameState_t6qee5, _this__u8e3s4, get_initialPositionKey()).t3g_1;
}
function get_destroyRecord($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  // Inline function 'kotlin.takeIf' call
  var this_0 = get_destroyRecordIndex($context_GameState_t6qee5, _this__u8e3s4);
  var tmp;
  if (this_0 >= 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = get_destroyRecords($context_GameState_t6qee5).u2(tmp0_safe_receiver);
  }
  return tmp_0;
}
function get_isAlive($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return get_destroyRecordIndex($context_GameState_t6qee5, _this__u8e3s4) === -1;
}
function get_implProperty(gsCtx, objectOnBoard, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return getGeneralProperty(gsCtx.j4l(objectOnBoard.r2w_1), _this__u8e3s4);
}
function get_isDead($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return !get_isAlive($context_GameState_t6qee5, _this__u8e3s4);
}
function get_armor(gsCtx, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return getArmorImpl(_this__u8e3s4, gsCtx);
}
function get_hp($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return get_objectType($context_GameState_t6qee5, _this__u8e3s4).n2z($context_GameState_t6qee5) - get_wounds($context_GameState_t6qee5, _this__u8e3s4) | 0;
}
function get_wounds(gsCtx, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return getWoundsImpl(_this__u8e3s4, gsCtx);
}
var Companion_instance_421;
function Companion_getInstance_422() {
  return Companion_instance_421;
}
function setImplProperty(gsiCtx, objectOnBoard, _this__u8e3s4, value) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  gsiCtx.d4m(objectOnBoard.r2w_1, _this__u8e3s4, value);
}
function isAnimalSettlerOrHunter($context_GameState_t6qee5, board) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  // Inline function 'kotlin.let' call
  var type = get_objectType($context_GameState_t6qee5, board);
  var tmp;
  var tmp_0;
  if (isInterface(type, AnimalType)) {
    tmp_0 = true;
  } else {
    tmp_0 = isInterface(type, SettlerType);
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = isInterface(type, HunterCharacter);
  }
  return tmp;
}
function getPositionImpl(_this__u8e3s4, gameState) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_positionKey()).t3g_1;
}
function get_destroyRecordIndex(gsCtx, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return getDestroyRecordIndexImpl(_this__u8e3s4, gsCtx);
}
function get_isAliveType(_this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  var tmp;
  if (!equals(_this__u8e3s4, WatchtowerType_getInstance()) && !equals(_this__u8e3s4, BoatType_getInstance())) {
    tmp = !(_this__u8e3s4 instanceof BarrierSideType);
  } else {
    tmp = false;
  }
  return tmp;
}
function getArmorImpl(_this__u8e3s4, gameState) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_armorKey()).t3p_1;
}
function getWoundsImpl(_this__u8e3s4, gameState) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_woundKey()).t3p_1;
}
function getDestroyRecordIndexImpl(_this__u8e3s4, gameState) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_destroyRecordIndexKey()).t3p_1;
}
function resetObjectType($context_GameStateImpl_x43bj1, _this__u8e3s4, newType) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  setImplProperty($context_GameStateImpl_x43bj1, _this__u8e3s4, get_objectTypeKey(), newType);
}
function set_armorImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  setImplProperty(gsiCtx, _this__u8e3s4, get_armorKey(), new IntWrapper(value));
}
function get_armorImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return getArmorImpl(_this__u8e3s4, gsiCtx);
}
function set_woundsImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  var tmp;
  var tmp_0;
  if (get_isSharedBeastHpGame(gsiCtx)) {
    var tmp_1 = get_objectType(gsiCtx, _this__u8e3s4);
    tmp_0 = isInterface(tmp_1, BeastCharacter);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = get_aliveBeasts_0(gsiCtx).p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp_2 = sum;
      sum = tmp_2 + (element.equals(_this__u8e3s4) ? value : get_wounds(gsiCtx, element)) | 0;
    }
    tmp = sum >= 0;
  } else {
    tmp = false;
  }
  var isAllowedSharedBeastOverheal = tmp;
  // Inline function 'kotlin.require' call
  if (!(value >= 0 || isAllowedSharedBeastOverheal)) {
    var message = 'Wounds cannot be negative';
    throw IllegalArgumentException.h2(toString(message));
  }
  setImplProperty(gsiCtx, _this__u8e3s4, get_woundKey(), new IntWrapper(value));
}
function get_woundsImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  return getWoundsImpl(_this__u8e3s4, gsiCtx);
}
function set_destroyRecordIndexImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_ObjectOnBoard_kt__hc6bh2();
  setImplProperty(gsiCtx, _this__u8e3s4, get_destroyRecordIndexKey(), new IntWrapper(value));
}
var properties_initialized_ObjectOnBoard_kt_wedv48;
function _init_properties_ObjectOnBoard_kt__hc6bh2() {
  if (!properties_initialized_ObjectOnBoard_kt_wedv48) {
    properties_initialized_ObjectOnBoard_kt_wedv48 = true;
    objectTypeKey = _GeneralMapKey___init__impl__zdmbea('objectType');
    positionKey = _GeneralMapKey___init__impl__zdmbea('position');
    woundKey = _GeneralMapKey___init__impl__zdmbea('wounds');
    armorKey = _GeneralMapKey___init__impl__zdmbea('shields');
    destroyRecordIndexKey = _GeneralMapKey___init__impl__zdmbea('destroyRecord');
    isAliveKey = _GeneralMapKey___init__impl__zdmbea('isAlive');
    initialPositionKey = _GeneralMapKey___init__impl__zdmbea('initialPosition');
  }
}
function _get_$cachedSerializer__te6jhj_376($this) {
  return $this.x5s_1.k3();
}
function SheepType$_anonymous__u6ndsu() {
  var tmp = SheepType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SheepType', tmp, tmp$ret$0);
}
var SheepType_instance;
function SheepType_getInstance() {
  if (SheepType_instance === VOID)
    new SheepType();
  return SheepType_instance;
}
var Companion_instance_422;
function Companion_getInstance_423() {
  return Companion_instance_422;
}
var Companion_instance_423;
function Companion_getInstance_424() {
  return Companion_instance_423;
}
function _get_$cachedSerializer__te6jhj_377($this) {
  return $this.y5s_1.k3();
}
function NobleType$_anonymous__t5kjh() {
  var tmp = NobleType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NobleType', tmp, tmp$ret$0);
}
var NobleType_instance;
function NobleType_getInstance() {
  if (NobleType_instance === VOID)
    new NobleType();
  return NobleType_instance;
}
function _get_$cachedSerializer__te6jhj_378($this) {
  return $this.z5s_1.k3();
}
function FarmerType$_anonymous__6wzja() {
  var tmp = FarmerType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FarmerType', tmp, tmp$ret$0);
}
var FarmerType_instance;
function FarmerType_getInstance() {
  if (FarmerType_instance === VOID)
    new FarmerType();
  return FarmerType_instance;
}
function _get_$cachedSerializer__te6jhj_379($this) {
  return $this.a5t_1.k3();
}
function BoatType$_anonymous__ctibwj() {
  var tmp = BoatType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BoatType', tmp, tmp$ret$0);
}
var BoatType_instance;
function BoatType_getInstance() {
  if (BoatType_instance === VOID)
    new BoatType();
  return BoatType_instance;
}
function _get_$cachedSerializer__te6jhj_380($this) {
  return $this.b5t_1.k3();
}
function BoarType$_anonymous__vxxwzj() {
  var tmp = BoarType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BoarType', tmp, tmp$ret$0);
}
var BoarType_instance;
function BoarType_getInstance() {
  if (BoarType_instance === VOID)
    new BoarType();
  return BoarType_instance;
}
function _get_$cachedSerializer__te6jhj_381($this) {
  return $this.c5t_1.k3();
}
function TigerType$_anonymous__ra4vzy() {
  var tmp = TigerType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TigerType', tmp, tmp$ret$0);
}
var TigerType_instance;
function TigerType_getInstance() {
  if (TigerType_instance === VOID)
    new TigerType();
  return TigerType_instance;
}
var Companion_instance_424;
function Companion_getInstance_425() {
  return Companion_instance_424;
}
var Companion_instance_425;
function Companion_getInstance_426() {
  return Companion_instance_425;
}
var Companion_instance_426;
function Companion_getInstance_427() {
  return Companion_instance_426;
}
var $serializer_instance_361;
function $serializer_getInstance_361() {
  if ($serializer_instance_361 === VOID)
    new $serializer_365();
  return $serializer_instance_361;
}
function _get_$cachedSerializer__te6jhj_382($this) {
  return $this.g5t_1.k3();
}
function WatchtowerType$_anonymous__jt3mxv() {
  var tmp = WatchtowerType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WatchtowerType', tmp, tmp$ret$0);
}
var WatchtowerType_instance;
function WatchtowerType_getInstance() {
  if (WatchtowerType_instance === VOID)
    new WatchtowerType();
  return WatchtowerType_instance;
}
function _get_$cachedSerializer__te6jhj_383($this) {
  return $this.h5t_1.k3();
}
function BearType$_anonymous__yceea1() {
  var tmp = BearType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BearType', tmp, tmp$ret$0);
}
var BearType_instance;
function BearType_getInstance() {
  if (BearType_instance === VOID)
    new BearType();
  return BearType_instance;
}
function get_eyeIsHazedKey() {
  _init_properties_Omma_kt__b4ct4e();
  return eyeIsHazedKey;
}
var eyeIsHazedKey;
function get_snareTypeKey() {
  _init_properties_Omma_kt__b4ct4e();
  return snareTypeKey;
}
var snareTypeKey;
function get_trapPositionsKey() {
  _init_properties_Omma_kt__b4ct4e();
  return trapPositionsKey;
}
var trapPositionsKey;
function _get_$cachedSerializer__te6jhj_384($this) {
  return $this.i5t_1.k3();
}
function DistractionUpgrade$_anonymous__azz5y5() {
  var tmp = DistractionUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DistractionUpgrade', tmp, tmp$ret$0);
}
var DistractionUpgrade_instance;
function DistractionUpgrade_getInstance() {
  if (DistractionUpgrade_instance === VOID)
    new DistractionUpgrade();
  return DistractionUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_385($this) {
  return $this.j5t_1.k3();
}
function DoubleUpgrade$_anonymous__6o0yoc() {
  var tmp = DoubleUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DoubleUpgrade', tmp, tmp$ret$0);
}
var DoubleUpgrade_instance;
function DoubleUpgrade_getInstance() {
  if (DoubleUpgrade_instance === VOID)
    new DoubleUpgrade();
  return DoubleUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_386($this) {
  return $this.k5t_1.k3();
}
function ThickMistUpgrade$_anonymous__2s4o8b() {
  var tmp = ThickMistUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ThickMistUpgrade', tmp, tmp$ret$0);
}
var ThickMistUpgrade_instance;
function ThickMistUpgrade_getInstance() {
  if (ThickMistUpgrade_instance === VOID)
    new ThickMistUpgrade();
  return ThickMistUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_387($this) {
  return $this.l5t_1.k3();
}
function NightbindUpgrade$_anonymous__t1wj3k() {
  var tmp = NightbindUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NightbindUpgrade', tmp, tmp$ret$0);
}
var NightbindUpgrade_instance;
function NightbindUpgrade_getInstance() {
  if (NightbindUpgrade_instance === VOID)
    new NightbindUpgrade();
  return NightbindUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_388($this) {
  return $this.m5t_1.k3();
}
function CursedLandUpgrade$_anonymous__99ke5k() {
  var tmp = CursedLandUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CursedLandUpgrade', tmp, tmp$ret$0);
}
var CursedLandUpgrade_instance;
function CursedLandUpgrade_getInstance() {
  if (CursedLandUpgrade_instance === VOID)
    new CursedLandUpgrade();
  return CursedLandUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_389($this) {
  return $this.o5t_1.k3();
}
function Omma$_anonymous__iqznrv() {
  var tmp = Omma_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Omma', tmp, tmp$ret$0);
}
var Omma_instance;
function Omma_getInstance() {
  if (Omma_instance === VOID)
    new Omma();
  return Omma_instance;
}
function _get_$cachedSerializer__te6jhj_390($this) {
  return $this.p5t_1.k3();
}
function PossibleMistShroudEffectSource$_anonymous__4i0dy4() {
  var tmp = PossibleMistShroudEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleMistShroudEffectSource', tmp, tmp$ret$0);
}
var PossibleMistShroudEffectSource_instance;
function PossibleMistShroudEffectSource_getInstance() {
  if (PossibleMistShroudEffectSource_instance === VOID)
    new PossibleMistShroudEffectSource();
  return PossibleMistShroudEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_391($this) {
  return $this.q5t_1.k3();
}
function PossibleSnareEffectSource$_anonymous__wlovcz() {
  var tmp = PossibleSnareEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleSnareEffectSource', tmp, tmp$ret$0);
}
var PossibleSnareEffectSource_instance;
function PossibleSnareEffectSource_getInstance() {
  if (PossibleSnareEffectSource_instance === VOID)
    new PossibleSnareEffectSource();
  return PossibleSnareEffectSource_instance;
}
function SnareTypeQuestion$Companion$$childSerializers$_anonymous__y3ocr3() {
  return new LinkedHashSetSerializer(Companion_getInstance_437().a2g());
}
var Companion_instance_427;
function Companion_getInstance_428() {
  if (Companion_instance_427 === VOID)
    new Companion_427();
  return Companion_instance_427;
}
var $serializer_instance_362;
function $serializer_getInstance_362() {
  if ($serializer_instance_362 === VOID)
    new $serializer_366();
  return $serializer_instance_362;
}
function _get_$cachedSerializer__te6jhj_392($this) {
  return $this.w5t_1.k3();
}
function HunterItemToDiscardFromArsenalQuestionContext$_anonymous__aec0dm() {
  var tmp = HunterItemToDiscardFromArsenalQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterItemToDiscardFromArsenalQuestionContext', tmp, tmp$ret$0);
}
var HunterItemToDiscardFromArsenalQuestionContext_instance;
function HunterItemToDiscardFromArsenalQuestionContext_getInstance() {
  if (HunterItemToDiscardFromArsenalQuestionContext_instance === VOID)
    new HunterItemToDiscardFromArsenalQuestionContext();
  return HunterItemToDiscardFromArsenalQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_393($this) {
  return $this.x5t_1.k3();
}
function SnareLocationQuestionContext$_anonymous__a4l9oc() {
  var tmp = SnareLocationQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SnareLocationQuestionContext', tmp, tmp$ret$0);
}
var SnareLocationQuestionContext_instance;
function SnareLocationQuestionContext_getInstance() {
  if (SnareLocationQuestionContext_instance === VOID)
    new SnareLocationQuestionContext();
  return SnareLocationQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_394($this) {
  return $this.y5t_1.k3();
}
function SnareTrapLocationQuestionContext$_anonymous__ajjrqh() {
  var tmp = SnareTrapLocationQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SnareTrapLocationQuestionContext', tmp, tmp$ret$0);
}
var SnareTrapLocationQuestionContext_instance;
function SnareTrapLocationQuestionContext_getInstance() {
  if (SnareTrapLocationQuestionContext_instance === VOID)
    new SnareTrapLocationQuestionContext();
  return SnareTrapLocationQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_395($this) {
  return $this.z5t_1.k3();
}
function HunterTrappedBySnareQuestionContext$_anonymous__1rst3i() {
  var tmp = HunterTrappedBySnareQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HunterTrappedBySnareQuestionContext', tmp, tmp$ret$0);
}
var HunterTrappedBySnareQuestionContext_instance;
function HunterTrappedBySnareQuestionContext_getInstance() {
  if (HunterTrappedBySnareQuestionContext_instance === VOID)
    new HunterTrappedBySnareQuestionContext();
  return HunterTrappedBySnareQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_396($this) {
  return $this.a5u_1.k3();
}
function SnareToReplaceQuestionContext$_anonymous__e6akcy() {
  var tmp = SnareToReplaceQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SnareToReplaceQuestionContext', tmp, tmp$ret$0);
}
var SnareToReplaceQuestionContext_instance;
function SnareToReplaceQuestionContext_getInstance() {
  if (SnareToReplaceQuestionContext_instance === VOID)
    new SnareToReplaceQuestionContext();
  return SnareToReplaceQuestionContext_instance;
}
function ActivateSnareStatement$Companion$$childSerializers$_anonymous__5wm3up() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
function ActivateSnareStatement$Companion$$childSerializers$_anonymous__5wm3up_0() {
  var tmp = SnareTokenType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return $serializer_364.y2o(ObjectSerializer.l1c('SnareTokenType', tmp, tmp$ret$0));
}
var Companion_instance_428;
function Companion_getInstance_429() {
  if (Companion_instance_428 === VOID)
    new Companion_428();
  return Companion_instance_428;
}
var $serializer_instance_363;
function $serializer_getInstance_363() {
  if ($serializer_instance_363 === VOID)
    new $serializer_367();
  return $serializer_instance_363;
}
function MistShroudReactionStatement$Companion$$childSerializers$_anonymous__auocse() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
function MistShroudReactionStatement$Companion$$childSerializers$_anonymous__auocse_0() {
  var tmp = MistShroudCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MistShroudCard', tmp, tmp$ret$0);
}
function MistShroudReactionStatement$Companion$$childSerializers$_anonymous__auocse_1() {
  return Companion_instance_438.a2g();
}
var Companion_instance_429;
function Companion_getInstance_430() {
  if (Companion_instance_429 === VOID)
    new Companion_429();
  return Companion_instance_429;
}
var $serializer_instance_364;
function $serializer_getInstance_364() {
  if ($serializer_instance_364 === VOID)
    new $serializer_368();
  return $serializer_instance_364;
}
function DiscardHunterItemFromArsenalStatement$Companion$$childSerializers$_anonymous__gg0ei() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_430;
function Companion_getInstance_431() {
  if (Companion_instance_430 === VOID)
    new Companion_430();
  return Companion_instance_430;
}
var $serializer_instance_365;
function $serializer_getInstance_365() {
  if ($serializer_instance_365 === VOID)
    new $serializer_369();
  return $serializer_instance_365;
}
function DismemberStatement$Companion$$childSerializers$_anonymous__by7hxf() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_431;
function Companion_getInstance_432() {
  if (Companion_instance_431 === VOID)
    new Companion_431();
  return Companion_instance_431;
}
var $serializer_instance_366;
function $serializer_getInstance_366() {
  if ($serializer_instance_366 === VOID)
    new $serializer_370();
  return $serializer_instance_366;
}
function HazeStatement$Companion$$childSerializers$_anonymous__fotfup() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_432;
function Companion_getInstance_433() {
  if (Companion_instance_432 === VOID)
    new Companion_432();
  return Companion_instance_432;
}
var $serializer_instance_367;
function $serializer_getInstance_367() {
  if ($serializer_instance_367 === VOID)
    new $serializer_371();
  return $serializer_instance_367;
}
function PlaceSnareStatement$Companion$$childSerializers$_anonymous__g3nn4j() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_433;
function Companion_getInstance_434() {
  if (Companion_instance_433 === VOID)
    new Companion_433();
  return Companion_instance_433;
}
var $serializer_instance_368;
function $serializer_getInstance_368() {
  if ($serializer_instance_368 === VOID)
    new $serializer_372();
  return $serializer_instance_368;
}
function _get_$cachedSerializer__te6jhj_397($this) {
  return $this.i5v_1.k3();
}
function SnareTokenType$_anonymous__8p5i5() {
  var tmp = SnareTokenType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SnareTokenType', tmp, tmp$ret$0);
}
var SnareTokenType_instance;
function SnareTokenType_getInstance() {
  if (SnareTokenType_instance === VOID)
    new SnareTokenType();
  return SnareTokenType_instance;
}
function get_hazePositions($context_GameState_t6qee5) {
  _init_properties_Omma_kt__b4ct4e();
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof EyeType) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (get_isAlive($context_GameState_t6qee5, element_0) && get_isHazed($context_GameState_t6qee5, element_0)) {
      destination_0.d2(element_0);
    }
  }
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_1 = ArrayList.p2();
  var _iterator__ex2g4s_1 = destination_0.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_1 = _iterator__ex2g4s_1.r1();
    var list = get_nearbyPositions($context_GameState_t6qee5, element_1);
    addAll(destination_1, list);
  }
  return toSet(destination_1);
}
function SetEyeHazeStatusChangeEvent$Companion$$childSerializers$_anonymous__c3qwyj() {
  var tmp = EyeType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return new LinkedHashMapSerializer($serializer_364.y2o(ObjectSerializer.l1c('EyeType', tmp, tmp$ret$0)), BooleanSerializer_getInstance());
}
var Companion_instance_434;
function Companion_getInstance_435() {
  if (Companion_instance_434 === VOID)
    new Companion_434();
  return Companion_instance_434;
}
var $serializer_instance_369;
function $serializer_getInstance_369() {
  if ($serializer_instance_369 === VOID)
    new $serializer_373();
  return $serializer_instance_369;
}
function SetSnareMetadataChangeEvent$Companion$$childSerializers$_anonymous__ubhx9i() {
  var tmp = SnareTokenType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return $serializer_364.y2o(ObjectSerializer.l1c('SnareTokenType', tmp, tmp$ret$0));
}
function SetSnareMetadataChangeEvent$Companion$$childSerializers$_anonymous__ubhx9i_0() {
  return Companion_getInstance_437().a2g();
}
function SetSnareMetadataChangeEvent$Companion$$childSerializers$_anonymous__ubhx9i_1() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_435;
function Companion_getInstance_436() {
  if (Companion_instance_435 === VOID)
    new Companion_435();
  return Companion_instance_435;
}
var $serializer_instance_370;
function $serializer_getInstance_370() {
  if ($serializer_instance_370 === VOID)
    new $serializer_374();
  return $serializer_instance_370;
}
function _get_$cachedSerializer__te6jhj_398($this) {
  return $this.w5v_1.k3();
}
function EyeType$_anonymous__u19uno() {
  var tmp = EyeType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EyeType', tmp, tmp$ret$0);
}
var EyeType_instance;
function EyeType_getInstance() {
  if (EyeType_instance === VOID)
    new EyeType();
  return EyeType_instance;
}
function _get_$cachedSerializer__te6jhj_399($this) {
  return $this.x5v_1.k3();
}
function DismemberCard$_anonymous__uvvghr() {
  var tmp = DismemberCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DismemberCard', tmp, tmp$ret$0);
}
var DismemberCard_instance;
function DismemberCard_getInstance() {
  if (DismemberCard_instance === VOID)
    new DismemberCard();
  return DismemberCard_instance;
}
function _get_$cachedSerializer__te6jhj_400($this) {
  return $this.y5v_1.k3();
}
function SpookCard$_anonymous__gbskkn() {
  var tmp = SpookCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SpookCard', tmp, tmp$ret$0);
}
var SpookCard_instance;
function SpookCard_getInstance() {
  if (SpookCard_instance === VOID)
    new SpookCard();
  return SpookCard_instance;
}
function _get_$cachedSerializer__te6jhj_401($this) {
  return $this.a5w_1.k3();
}
function SummonEyeCard$_anonymous__i67n87() {
  var tmp = SummonEyeCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonEyeCard', tmp, tmp$ret$0);
}
var SummonEyeCard_instance;
function SummonEyeCard_getInstance() {
  if (SummonEyeCard_instance === VOID)
    new SummonEyeCard();
  return SummonEyeCard_instance;
}
function _get_$cachedSerializer__te6jhj_402($this) {
  return $this.b5w_1.k3();
}
function MistShroudCard$_anonymous__m5okq1() {
  var tmp = MistShroudCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MistShroudCard', tmp, tmp$ret$0);
}
var MistShroudCard_instance;
function MistShroudCard_getInstance() {
  if (MistShroudCard_instance === VOID)
    new MistShroudCard();
  return MistShroudCard_instance;
}
function _get_$cachedSerializer__te6jhj_403($this) {
  return $this.u5e_1.k3();
}
function SnareType$Companion$_anonymous__17a604() {
  return createSimpleEnumSerializer('steelart.beast.SnareType', values_9());
}
var SnareType_Graveyard_instance;
var SnareType_Talent_instance;
var SnareType_Animate_instance;
function values_9() {
  return [SnareType_Graveyard_getInstance(), SnareType_Talent_getInstance(), SnareType_Animate_getInstance()];
}
function get_entries_3() {
  if ($ENTRIES_3 == null)
    $ENTRIES_3 = enumEntries(values_9());
  return $ENTRIES_3;
}
var Companion_instance_436;
function Companion_getInstance_437() {
  SnareType_initEntries();
  if (Companion_instance_436 === VOID)
    new Companion_436();
  return Companion_instance_436;
}
var SnareType_entriesInitialized;
function SnareType_initEntries() {
  if (SnareType_entriesInitialized)
    return Unit_instance;
  SnareType_entriesInitialized = true;
  SnareType_Graveyard_instance = new SnareType('Graveyard', 0);
  SnareType_Talent_instance = new SnareType('Talent', 1);
  SnareType_Animate_instance = new SnareType('Animate', 2);
  Companion_getInstance_437();
}
var $ENTRIES_3;
function get_isHazed(gsCtx, _this__u8e3s4) {
  _init_properties_Omma_kt__b4ct4e();
  return getIsHazedImpl(_this__u8e3s4, gsCtx);
}
function set_isHazedImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Omma_kt__b4ct4e();
  gsiCtx.j39(_this__u8e3s4.r2w_1, get_eyeIsHazedKey(), new BooleanWrapper(value), new BooleanWrapper(false));
}
function set_snareTypeImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Omma_kt__b4ct4e();
  setImplProperty(gsiCtx, _this__u8e3s4, get_snareTypeKey(), new SnareTypeWrapper(value));
}
function set_trapPositionsImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Omma_kt__b4ct4e();
  setImplProperty(gsiCtx, _this__u8e3s4, get_trapPositionsKey(), new BoardPositionSetWrapper(value));
}
function get_snareType(gsCtx, _this__u8e3s4) {
  _init_properties_Omma_kt__b4ct4e();
  return getSnareTypeImpl(_this__u8e3s4, gsCtx);
}
function get_trapPositions(gsCtx, _this__u8e3s4) {
  _init_properties_Omma_kt__b4ct4e();
  return getTrapPositionsImpl(_this__u8e3s4, gsCtx);
}
function getIsHazedImpl(_this__u8e3s4, gameState) {
  _init_properties_Omma_kt__b4ct4e();
  // Inline function 'kotlin.with' call
  return getGeneralPropertyWithDefault(_this__u8e3s4.l39(gameState), get_eyeIsHazedKey(), new BooleanWrapper(false)).j3w_1;
}
function getSnareTypeImpl(_this__u8e3s4, gameState) {
  _init_properties_Omma_kt__b4ct4e();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_snareTypeKey()).y5e_1;
}
function getTrapPositionsImpl(_this__u8e3s4, gameState) {
  _init_properties_Omma_kt__b4ct4e();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_trapPositionsKey()).k39_1;
}
function get_allSnaresOnMap($context_GameState_t6qee5) {
  _init_properties_Omma_kt__b4ct4e();
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof SnareTokenType) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (get_isAlive($context_GameState_t6qee5, element_0)) {
      destination_0.d2(element_0);
    }
  }
  return toSet(destination_0);
}
function SnareType_Graveyard_getInstance() {
  SnareType_initEntries();
  return SnareType_Graveyard_instance;
}
function SnareType_Talent_getInstance() {
  SnareType_initEntries();
  return SnareType_Talent_instance;
}
function SnareType_Animate_getInstance() {
  SnareType_initEntries();
  return SnareType_Animate_instance;
}
var properties_initialized_Omma_kt_j7a12s;
function _init_properties_Omma_kt__b4ct4e() {
  if (!properties_initialized_Omma_kt_j7a12s) {
    properties_initialized_Omma_kt_j7a12s = true;
    eyeIsHazedKey = _GeneralMapKey___init__impl__zdmbea('eyeIsHazed');
    snareTypeKey = _GeneralMapKey___init__impl__zdmbea('snareType');
    trapPositionsKey = _GeneralMapKey___init__impl__zdmbea('trapPositions');
  }
}
var Companion_instance_437;
function Companion_getInstance_438() {
  return Companion_instance_437;
}
var $serializer_instance_371;
function $serializer_getInstance_371() {
  if ($serializer_instance_371 === VOID)
    new $serializer_375();
  return $serializer_instance_371;
}
function _get_$cachedSerializer__te6jhj_404($this) {
  return $this.m5w_1.k3();
}
function PactLongForgottenInitialPhase$_anonymous__ctxqn0() {
  var tmp = PactLongForgottenInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PactLongForgottenInitialPhase', tmp, tmp$ret$0);
}
var PactLongForgottenInitialPhase_instance;
function PactLongForgottenInitialPhase_getInstance() {
  if (PactLongForgottenInitialPhase_instance === VOID)
    new PactLongForgottenInitialPhase();
  return PactLongForgottenInitialPhase_instance;
}
var Companion_instance_438;
function Companion_getInstance_439() {
  return Companion_instance_438;
}
function _get_$cachedSerializer__te6jhj_405($this) {
  return $this.p5w_1.k3();
}
function CardPlayColor$Split$_anonymous__8r29y6() {
  var tmp = Split_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Split', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_406($this) {
  return $this.s5w_1.k3();
}
function CardPlayColor$Red$_anonymous__6jzbl7() {
  var tmp = Red_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Red', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_407($this) {
  return $this.v5w_1.k3();
}
function CardPlayColor$Blue$_anonymous__33dft4() {
  var tmp = Blue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Blue', tmp, tmp$ret$0);
}
var Split_instance;
function Split_getInstance() {
  if (Split_instance === VOID)
    new Split();
  return Split_instance;
}
var Red_instance;
function Red_getInstance() {
  if (Red_instance === VOID)
    new Red();
  return Red_instance;
}
var Blue_instance;
function Blue_getInstance() {
  if (Blue_instance === VOID)
    new Blue();
  return Blue_instance;
}
var Companion_instance_439;
function Companion_getInstance_440() {
  return Companion_instance_439;
}
var Companion_instance_440;
function Companion_getInstance_441() {
  return Companion_instance_440;
}
var Companion_instance_441;
function Companion_getInstance_442() {
  return Companion_instance_441;
}
var Companion_instance_442;
function Companion_getInstance_443() {
  return Companion_instance_442;
}
var Companion_instance_443;
function Companion_getInstance_444() {
  return Companion_instance_443;
}
function _get_$cachedSerializer__te6jhj_408($this) {
  return $this.w5w_1.k3();
}
function WrathOfEirtirUpgrade$_anonymous__waw1ln() {
  var tmp = WrathOfEirtirUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('WrathOfEirtirUpgrade', tmp, tmp$ret$0);
}
var WrathOfEirtirUpgrade_instance;
function WrathOfEirtirUpgrade_getInstance() {
  if (WrathOfEirtirUpgrade_instance === VOID)
    new WrathOfEirtirUpgrade();
  return WrathOfEirtirUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_409($this) {
  return $this.x5w_1.k3();
}
function LeviathanUpgrade$_anonymous__onnb1t() {
  var tmp = LeviathanUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LeviathanUpgrade', tmp, tmp$ret$0);
}
var LeviathanUpgrade_instance;
function LeviathanUpgrade_getInstance() {
  if (LeviathanUpgrade_instance === VOID)
    new LeviathanUpgrade();
  return LeviathanUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_410($this) {
  return $this.y5w_1.k3();
}
function MendrsFuryUpgrade$_anonymous__9p22tc() {
  var tmp = MendrsFuryUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MendrsFuryUpgrade', tmp, tmp$ret$0);
}
var MendrsFuryUpgrade_instance;
function MendrsFuryUpgrade_getInstance() {
  if (MendrsFuryUpgrade_instance === VOID)
    new MendrsFuryUpgrade();
  return MendrsFuryUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_411($this) {
  return $this.z5w_1.k3();
}
function DrownerUpgrade$_anonymous__w7dctc() {
  var tmp = DrownerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DrownerUpgrade', tmp, tmp$ret$0);
}
var DrownerUpgrade_instance;
function DrownerUpgrade_getInstance() {
  if (DrownerUpgrade_instance === VOID)
    new DrownerUpgrade();
  return DrownerUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_412($this) {
  return $this.a5x_1.k3();
}
function TorrentialUpgrade$_anonymous__wsz9cx() {
  var tmp = TorrentialUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TorrentialUpgrade', tmp, tmp$ret$0);
}
var TorrentialUpgrade_instance;
function TorrentialUpgrade_getInstance() {
  if (TorrentialUpgrade_instance === VOID)
    new TorrentialUpgrade();
  return TorrentialUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_413($this) {
  return $this.b5x_1.k3();
}
function DevourerUpgrade$_anonymous__z7ug7z() {
  var tmp = DevourerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DevourerUpgrade', tmp, tmp$ret$0);
}
var DevourerUpgrade_instance;
function DevourerUpgrade_getInstance() {
  if (DevourerUpgrade_instance === VOID)
    new DevourerUpgrade();
  return DevourerUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_414($this) {
  return $this.c5x_1.k3();
}
function FatalGazeUpgrade$_anonymous__bkjnbw() {
  var tmp = FatalGazeUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FatalGazeUpgrade', tmp, tmp$ret$0);
}
var FatalGazeUpgrade_instance;
function FatalGazeUpgrade_getInstance() {
  if (FatalGazeUpgrade_instance === VOID)
    new FatalGazeUpgrade();
  return FatalGazeUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_415($this) {
  return $this.e5x_1.k3();
}
function Raaga$_anonymous__we9sgl() {
  var tmp = Raaga_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Raaga', tmp, tmp$ret$0);
}
var Raaga_instance;
function Raaga_getInstance() {
  if (Raaga_instance === VOID)
    new Raaga();
  return Raaga_instance;
}
function RaagaSlitherStatement$Companion$$childSerializers$_anonymous__kq9hs0() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_444;
function Companion_getInstance_445() {
  if (Companion_instance_444 === VOID)
    new Companion_444();
  return Companion_instance_444;
}
var $serializer_instance_372;
function $serializer_getInstance_372() {
  if ($serializer_instance_372 === VOID)
    new $serializer_376();
  return $serializer_instance_372;
}
function RaagaHydraStatement$Companion$$childSerializers$_anonymous__r74jpr() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_445;
function Companion_getInstance_446() {
  if (Companion_instance_445 === VOID)
    new Companion_445();
  return Companion_instance_445;
}
var $serializer_instance_373;
function $serializer_getInstance_373() {
  if ($serializer_instance_373 === VOID)
    new $serializer_377();
  return $serializer_instance_373;
}
function _get_$cachedSerializer__te6jhj_416($this) {
  return $this.q5x_1.k3();
}
function BasiliskType$_anonymous__1yfyb1() {
  var tmp = BasiliskType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BasiliskType', tmp, tmp$ret$0);
}
var BasiliskType_instance;
function BasiliskType_getInstance() {
  if (BasiliskType_instance === VOID)
    new BasiliskType();
  return BasiliskType_instance;
}
function _get_$cachedSerializer__te6jhj_417($this) {
  return $this.t5x_1.k3();
}
function FloodCard$_anonymous__go9vqh() {
  var tmp = FloodCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('FloodCard', tmp, tmp$ret$0);
}
var FloodCard_instance;
function FloodCard_getInstance() {
  if (FloodCard_instance === VOID)
    new FloodCard();
  return FloodCard_instance;
}
function _get_$cachedSerializer__te6jhj_418($this) {
  return $this.w5x_1.k3();
}
function HydraCard$_anonymous__agqewr() {
  var tmp = HydraCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HydraCard', tmp, tmp$ret$0);
}
var HydraCard_instance;
function HydraCard_getInstance() {
  if (HydraCard_instance === VOID)
    new HydraCard();
  return HydraCard_instance;
}
function _get_$cachedSerializer__te6jhj_419($this) {
  return $this.z5x_1.k3();
}
function SlitherCard$_anonymous__pfx5zq() {
  var tmp = SlitherCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SlitherCard', tmp, tmp$ret$0);
}
var SlitherCard_instance;
function SlitherCard_getInstance() {
  if (SlitherCard_instance === VOID)
    new SlitherCard();
  return SlitherCard_instance;
}
function _get_$cachedSerializer__te6jhj_420($this) {
  return $this.b5y_1.k3();
}
function SummonBasiliskCard$_anonymous__6xv29w() {
  var tmp = SummonBasiliskCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonBasiliskCard', tmp, tmp$ret$0);
}
var SummonBasiliskCard_instance;
function SummonBasiliskCard_getInstance() {
  if (SummonBasiliskCard_instance === VOID)
    new SummonBasiliskCard();
  return SummonBasiliskCard_instance;
}
function _get_$cachedSerializer__te6jhj_421($this) {
  return $this.c5y_1.k3();
}
function PetrifyAttackModifier$_anonymous__s79n5d() {
  var tmp = PetrifyAttackModifier_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PetrifyAttackModifier', tmp, tmp$ret$0);
}
var PetrifyAttackModifier_instance;
function PetrifyAttackModifier_getInstance() {
  if (PetrifyAttackModifier_instance === VOID)
    new PetrifyAttackModifier();
  return PetrifyAttackModifier_instance;
}
var Companion_instance_446;
function Companion_getInstance_447() {
  return Companion_instance_446;
}
var $serializer_instance_374;
function $serializer_getInstance_374() {
  if ($serializer_instance_374 === VOID)
    new $serializer_378();
  return $serializer_instance_374;
}
function RecoveryTestForEachHunterStatement$Companion$$childSerializers$_anonymous__p1dp4y() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_380.a2g()));
}
function RecoveryTestForEachHunterStatement$Companion$$childSerializers$_anonymous__p1dp4y_0() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_447;
function Companion_getInstance_448() {
  if (Companion_instance_447 === VOID)
    new Companion_447();
  return Companion_instance_447;
}
var $serializer_instance_375;
function $serializer_getInstance_375() {
  if ($serializer_instance_375 === VOID)
    new $serializer_379();
  return $serializer_instance_375;
}
function RecoveryTestStatement$Companion$$childSerializers$_anonymous__5mxeym() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function RecoveryTestStatement$Companion$$childSerializers$_anonymous__5mxeym_0() {
  return Companion_getInstance_453().a2g();
}
var Companion_instance_448;
function Companion_getInstance_449() {
  if (Companion_instance_448 === VOID)
    new Companion_448();
  return Companion_instance_448;
}
var $serializer_instance_376;
function $serializer_getInstance_376() {
  if ($serializer_instance_376 === VOID)
    new $serializer_380();
  return $serializer_instance_376;
}
function _get_$cachedSerializer__te6jhj_422($this) {
  return $this.w5y_1.k3();
}
function RecoveryTestInitialPhase$_anonymous__1amq07() {
  var tmp = RecoveryTestInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RecoveryTestInitialPhase', tmp, tmp$ret$0);
}
var RecoveryTestInitialPhase_instance;
function RecoveryTestInitialPhase_getInstance() {
  if (RecoveryTestInitialPhase_instance === VOID)
    new RecoveryTestInitialPhase();
  return RecoveryTestInitialPhase_instance;
}
function RecoveryTestEvent$Companion$$childSerializers$_anonymous__l5icvd() {
  return $serializer_364.y2o(Companion_instance_128.a2g());
}
function RecoveryTestEvent$Companion$$childSerializers$_anonymous__l5icvd_0() {
  return Companion_getInstance_453().a2g();
}
var Companion_instance_449;
function Companion_getInstance_450() {
  if (Companion_instance_449 === VOID)
    new Companion_449();
  return Companion_instance_449;
}
var $serializer_instance_377;
function $serializer_getInstance_377() {
  if ($serializer_instance_377 === VOID)
    new $serializer_381();
  return $serializer_instance_377;
}
function _get_$cachedSerializer__te6jhj_423($this) {
  return $this.d5z_1.k3();
}
function RecoveryTestFailingEvent$_anonymous__ol2ayu() {
  var tmp = RecoveryTestFailingEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RecoveryTestFailingEvent', tmp, tmp$ret$0);
}
var RecoveryTestFailingEvent_instance;
function RecoveryTestFailingEvent_getInstance() {
  if (RecoveryTestFailingEvent_instance === VOID)
    new RecoveryTestFailingEvent();
  return RecoveryTestFailingEvent_instance;
}
function RecoveryTestBeastCard$Companion$$childSerializers$_anonymous__chal42() {
  return Companion_getInstance_453().a2g();
}
var Companion_instance_450;
function Companion_getInstance_451() {
  if (Companion_instance_450 === VOID)
    new Companion_450();
  return Companion_instance_450;
}
var $serializer_instance_378;
function $serializer_getInstance_378() {
  if ($serializer_instance_378 === VOID)
    new $serializer_382();
  return $serializer_instance_378;
}
function _get_$cachedSerializer__te6jhj_424($this) {
  return $this.k5z_1.k3();
}
function RecoveryTestBeastReaction$_anonymous__40vone() {
  var tmp = RecoveryTestBeastReaction_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RecoveryTestBeastReaction', tmp, tmp$ret$0);
}
var RecoveryTestBeastReaction_instance;
function RecoveryTestBeastReaction_getInstance() {
  if (RecoveryTestBeastReaction_instance === VOID)
    new RecoveryTestBeastReaction();
  return RecoveryTestBeastReaction_instance;
}
function _get_$cachedSerializer__te6jhj_425($this) {
  return $this.l5z_1.k3();
}
function RecoveryTestNightlyRewardsFailureCard$_anonymous__uxcy1p() {
  var tmp = RecoveryTestNightlyRewardsFailureCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RecoveryTestNightlyRewardsFailureCard', tmp, tmp$ret$0);
}
var RecoveryTestNightlyRewardsFailureCard_instance;
function RecoveryTestNightlyRewardsFailureCard_getInstance() {
  if (RecoveryTestNightlyRewardsFailureCard_instance === VOID)
    new RecoveryTestNightlyRewardsFailureCard();
  return RecoveryTestNightlyRewardsFailureCard_instance;
}
function _get_$cachedSerializer__te6jhj_426($this) {
  return $this.o5z_1.k3();
}
function RecoveryTestPhaseFailureCard$_anonymous__th1umn() {
  var tmp = RecoveryTestPhaseFailureCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RecoveryTestPhaseFailureCard', tmp, tmp$ret$0);
}
var RecoveryTestPhaseFailureCard_instance;
function RecoveryTestPhaseFailureCard_getInstance() {
  if (RecoveryTestPhaseFailureCard_instance === VOID)
    new RecoveryTestPhaseFailureCard();
  return RecoveryTestPhaseFailureCard_instance;
}
function _get_$cachedSerializer__te6jhj_427($this) {
  return $this.p5z_1.k3();
}
function RecoveryTestTeamRewardFailureCard$_anonymous__yeiewg() {
  var tmp = RecoveryTestTeamRewardFailureCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RecoveryTestTeamRewardFailureCard', tmp, tmp$ret$0);
}
var RecoveryTestTeamRewardFailureCard_instance;
function RecoveryTestTeamRewardFailureCard_getInstance() {
  if (RecoveryTestTeamRewardFailureCard_instance === VOID)
    new RecoveryTestTeamRewardFailureCard();
  return RecoveryTestTeamRewardFailureCard_instance;
}
function RecoveryTestHunterCard$Companion$$childSerializers$_anonymous__tpkytv() {
  return Companion_getInstance_453().a2g();
}
var Companion_instance_451;
function Companion_getInstance_452() {
  if (Companion_instance_451 === VOID)
    new Companion_451();
  return Companion_instance_451;
}
var $serializer_instance_379;
function $serializer_getInstance_379() {
  if ($serializer_instance_379 === VOID)
    new $serializer_383();
  return $serializer_instance_379;
}
function _get_$cachedSerializer__te6jhj_428($this) {
  return $this.v5z_1.k3();
}
function RecoveryTestHunterReaction$_anonymous__qdbvyx() {
  var tmp = RecoveryTestHunterReaction_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RecoveryTestHunterReaction', tmp, tmp$ret$0);
}
var RecoveryTestHunterReaction_instance;
function RecoveryTestHunterReaction_getInstance() {
  if (RecoveryTestHunterReaction_instance === VOID)
    new RecoveryTestHunterReaction();
  return RecoveryTestHunterReaction_instance;
}
function get_recoveryTestHunterCards() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_entries_4();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = new RecoveryTestHunterCard(item);
    destination.d2(tmp$ret$2);
  }
  return plus_1(destination, RecoveryTestHunterReaction_getInstance());
}
function get_recoveryTestBeastCards() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_entries_4();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = new RecoveryTestBeastCard(item);
    destination.d2(tmp$ret$2);
  }
  return plus_2(plus_1(destination, RecoveryTestBeastReaction_getInstance()), listOf_0([RecoveryTestPhaseFailureCard_getInstance(), RecoveryTestNightlyRewardsFailureCard_getInstance(), RecoveryTestTeamRewardFailureCard_getInstance()]));
}
function _get_$cachedSerializer__te6jhj_429($this) {
  return $this.p5y_1.k3();
}
function RecoveryTestFailure$Companion$_anonymous__hrnpo4() {
  return createSimpleEnumSerializer('steelart.beast.RecoveryTestFailure', values_10());
}
var RecoveryTestFailure_Statement_instance;
var RecoveryTestFailure_PartialStatement_instance;
var RecoveryTestFailure_NestedStatement_instance;
var RecoveryTestFailure_CardResolution_instance;
var RecoveryTestFailure_EventHandler_instance;
var RecoveryTestFailure_AutomaticEvents_instance;
var RecoveryTestFailure_EventEffects_instance;
var RecoveryTestFailure_Trigger_instance;
var RecoveryTestFailure_EachHunter_instance;
function values_10() {
  return [RecoveryTestFailure_Statement_getInstance(), RecoveryTestFailure_PartialStatement_getInstance(), RecoveryTestFailure_NestedStatement_getInstance(), RecoveryTestFailure_CardResolution_getInstance(), RecoveryTestFailure_EventHandler_getInstance(), RecoveryTestFailure_AutomaticEvents_getInstance(), RecoveryTestFailure_EventEffects_getInstance(), RecoveryTestFailure_Trigger_getInstance(), RecoveryTestFailure_EachHunter_getInstance()];
}
function get_entries_4() {
  if ($ENTRIES_4 == null)
    $ENTRIES_4 = enumEntries(values_10());
  return $ENTRIES_4;
}
var Companion_instance_452;
function Companion_getInstance_453() {
  RecoveryTestFailure_initEntries();
  if (Companion_instance_452 === VOID)
    new Companion_452();
  return Companion_instance_452;
}
var RecoveryTestFailure_entriesInitialized;
function RecoveryTestFailure_initEntries() {
  if (RecoveryTestFailure_entriesInitialized)
    return Unit_instance;
  RecoveryTestFailure_entriesInitialized = true;
  RecoveryTestFailure_Statement_instance = new RecoveryTestFailure('Statement', 0, 'Statement failure', 'Fail before changing state.');
  RecoveryTestFailure_PartialStatement_instance = new RecoveryTestFailure('PartialStatement', 1, 'Partial statement', 'Gain 1 Grudge, then fail. The Grudge remains.');
  RecoveryTestFailure_NestedStatement_instance = new RecoveryTestFailure('NestedStatement', 2, 'Nested statement', 'Gain 1 Grudge and fail in a child statement; after repair, gain 10 more.');
  RecoveryTestFailure_CardResolution_instance = new RecoveryTestFailure('CardResolution', 3, 'Card resolution', "Fail while building the played card's statement. The card still finishes resolving.");
  RecoveryTestFailure_EventHandler_instance = new RecoveryTestFailure('EventHandler', 4, 'Event handler', 'Commit 1 Grudge, fail in an automatic handler; the next handler grants 10.');
  RecoveryTestFailure_AutomaticEvents_instance = new RecoveryTestFailure('AutomaticEvents', 5, 'Automatic events', 'Commit 1 Grudge, then grant 1 in a handler before an event fails. After recovery, grant the remaining 100; the next handler grants 10.');
  RecoveryTestFailure_EventEffects_instance = new RecoveryTestFailure('EventEffects', 6, 'Event effects', 'Commit 1 Grudge, then fail collecting triggers. Abandon the remaining event effects.');
  RecoveryTestFailure_Trigger_instance = new RecoveryTestFailure('Trigger', 7, 'Trigger', 'Commit 1 Grudge, then offer the diagnostic reaction from hand. Its effect fails after gaining 1.');
  RecoveryTestFailure_EachHunter_instance = new RecoveryTestFailure('EachHunter', 8, 'Each Hunter', "Each Hunter gains 1 Grudge. The first Hunter's attempt then fails; the others can continue.");
  Companion_getInstance_453();
}
var $ENTRIES_4;
var Companion_instance_453;
function Companion_getInstance_454() {
  return Companion_instance_453;
}
var Companion_instance_454;
function Companion_getInstance_455() {
  return Companion_instance_454;
}
function RecoveryTestFailure_Statement_getInstance() {
  RecoveryTestFailure_initEntries();
  return RecoveryTestFailure_Statement_instance;
}
function RecoveryTestFailure_PartialStatement_getInstance() {
  RecoveryTestFailure_initEntries();
  return RecoveryTestFailure_PartialStatement_instance;
}
function RecoveryTestFailure_NestedStatement_getInstance() {
  RecoveryTestFailure_initEntries();
  return RecoveryTestFailure_NestedStatement_instance;
}
function RecoveryTestFailure_CardResolution_getInstance() {
  RecoveryTestFailure_initEntries();
  return RecoveryTestFailure_CardResolution_instance;
}
function RecoveryTestFailure_EventHandler_getInstance() {
  RecoveryTestFailure_initEntries();
  return RecoveryTestFailure_EventHandler_instance;
}
function RecoveryTestFailure_AutomaticEvents_getInstance() {
  RecoveryTestFailure_initEntries();
  return RecoveryTestFailure_AutomaticEvents_instance;
}
function RecoveryTestFailure_EventEffects_getInstance() {
  RecoveryTestFailure_initEntries();
  return RecoveryTestFailure_EventEffects_instance;
}
function RecoveryTestFailure_Trigger_getInstance() {
  RecoveryTestFailure_initEntries();
  return RecoveryTestFailure_Trigger_instance;
}
function RecoveryTestFailure_EachHunter_getInstance() {
  RecoveryTestFailure_initEntries();
  return RecoveryTestFailure_EachHunter_instance;
}
function get_regentBeastDominionKey() {
  _init_properties_RegentOfRuinsContract_kt__8aijxf();
  return regentBeastDominionKey;
}
var regentBeastDominionKey;
function get_regentHunterDominionKey() {
  _init_properties_RegentOfRuinsContract_kt__8aijxf();
  return regentHunterDominionKey;
}
var regentHunterDominionKey;
var Companion_instance_455;
function Companion_getInstance_456() {
  return Companion_instance_455;
}
var $serializer_instance_380;
function $serializer_getInstance_380() {
  if ($serializer_instance_380 === VOID)
    new $serializer_384();
  return $serializer_instance_380;
}
function _get_$cachedSerializer__te6jhj_430($this) {
  return $this.j60_1.k3();
}
function RegentOfRuinsInitialPhase$_anonymous__4wblhf() {
  var tmp = RegentOfRuinsInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RegentOfRuinsInitialPhase', tmp, tmp$ret$0);
}
var RegentOfRuinsInitialPhase_instance;
function RegentOfRuinsInitialPhase_getInstance() {
  if (RegentOfRuinsInitialPhase_instance === VOID)
    new RegentOfRuinsInitialPhase();
  return RegentOfRuinsInitialPhase_instance;
}
var Companion_instance_456;
function Companion_getInstance_457() {
  return Companion_instance_456;
}
var $serializer_instance_381;
function $serializer_getInstance_381() {
  if ($serializer_instance_381 === VOID)
    new $serializer_385();
  return $serializer_instance_381;
}
function get_regentHunterDominion(gsCtx) {
  _init_properties_RegentOfRuinsContract_kt__8aijxf();
  return getRegentHunterDominionImpl(gsCtx);
}
function set_regentBeastDominionImpl(gsiCtx, value) {
  _init_properties_RegentOfRuinsContract_kt__8aijxf();
  // Inline function 'kotlin.require' call
  if (!(value >= 0)) {
    var message = 'Beast Dominion cannot be negative';
    throw IllegalArgumentException.h2(toString(message));
  }
  gsiCtx.e4m(get_regentBeastDominionKey(), new IntWrapper(value), new IntWrapper(0));
}
function get_regentBeastDominion(gsCtx) {
  _init_properties_RegentOfRuinsContract_kt__8aijxf();
  return getRegentBeastDominionImpl(gsCtx);
}
function set_regentHunterDominionImpl(gsiCtx, value) {
  _init_properties_RegentOfRuinsContract_kt__8aijxf();
  // Inline function 'kotlin.require' call
  if (!(value >= 0)) {
    var message = 'Hunter Dominion cannot be negative';
    throw IllegalArgumentException.h2(toString(message));
  }
  gsiCtx.e4m(get_regentHunterDominionKey(), new IntWrapper(value), new IntWrapper(0));
}
function getRegentHunterDominionImpl(gameState) {
  _init_properties_RegentOfRuinsContract_kt__8aijxf();
  // Inline function 'kotlin.with' call
  return getGeneralPropertyWithDefault(gameState.k4l(), get_regentHunterDominionKey(), new IntWrapper(0)).t3p_1;
}
function getRegentBeastDominionImpl(gameState) {
  _init_properties_RegentOfRuinsContract_kt__8aijxf();
  // Inline function 'kotlin.with' call
  return getGeneralPropertyWithDefault(gameState.k4l(), get_regentBeastDominionKey(), new IntWrapper(0)).t3p_1;
}
var properties_initialized_RegentOfRuinsContract_kt_y3uvz;
function _init_properties_RegentOfRuinsContract_kt__8aijxf() {
  if (!properties_initialized_RegentOfRuinsContract_kt_y3uvz) {
    properties_initialized_RegentOfRuinsContract_kt_y3uvz = true;
    regentBeastDominionKey = _GeneralMapKey___init__impl__zdmbea('regentBeastDominion');
    regentHunterDominionKey = _GeneralMapKey___init__impl__zdmbea('regentHunterDominion');
  }
}
function get_rhagnerHoardLevelsKey() {
  _init_properties_Rhagner_kt__s8qtn1();
  return rhagnerHoardLevelsKey;
}
var rhagnerHoardLevelsKey;
function _get_$cachedSerializer__te6jhj_431($this) {
  return $this.p60_1.k3();
}
function AbyssalHellFireUpgrade$_anonymous__cz7x75() {
  var tmp = AbyssalHellFireUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AbyssalHellFireUpgrade', tmp, tmp$ret$0);
}
var AbyssalHellFireUpgrade_instance;
function AbyssalHellFireUpgrade_getInstance() {
  if (AbyssalHellFireUpgrade_instance === VOID)
    new AbyssalHellFireUpgrade();
  return AbyssalHellFireUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_432($this) {
  return $this.q60_1.k3();
}
function BurnUpgrade$_anonymous__bvcp86() {
  var tmp = BurnUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BurnUpgrade', tmp, tmp$ret$0);
}
var BurnUpgrade_instance;
function BurnUpgrade_getInstance() {
  if (BurnUpgrade_instance === VOID)
    new BurnUpgrade();
  return BurnUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_433($this) {
  return $this.r60_1.k3();
}
function DraconicBondsUpgrade$_anonymous__1movaa() {
  var tmp = DraconicBondsUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DraconicBondsUpgrade', tmp, tmp$ret$0);
}
var DraconicBondsUpgrade_instance;
function DraconicBondsUpgrade_getInstance() {
  if (DraconicBondsUpgrade_instance === VOID)
    new DraconicBondsUpgrade();
  return DraconicBondsUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_434($this) {
  return $this.s60_1.k3();
}
function AngerUpgrade$_anonymous__xj49c2() {
  var tmp = AngerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AngerUpgrade', tmp, tmp$ret$0);
}
var AngerUpgrade_instance;
function AngerUpgrade_getInstance() {
  if (AngerUpgrade_instance === VOID)
    new AngerUpgrade();
  return AngerUpgrade_instance;
}
var Companion_instance_457;
function Companion_getInstance_458() {
  return Companion_instance_457;
}
function _get_$cachedSerializer__te6jhj_435($this) {
  return $this.u60_1.k3();
}
function IncinerateCard$_anonymous__pdhfgl() {
  var tmp = IncinerateCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('IncinerateCard', tmp, tmp$ret$0);
}
var IncinerateCard_instance;
function IncinerateCard_getInstance() {
  if (IncinerateCard_instance === VOID)
    new IncinerateCard();
  return IncinerateCard_instance;
}
function _get_$cachedSerializer__te6jhj_436($this) {
  return $this.w60_1.k3();
}
function RiseCard$_anonymous__povwv6() {
  var tmp = RiseCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RiseCard', tmp, tmp$ret$0);
}
var RiseCard_instance;
function RiseCard_getInstance() {
  if (RiseCard_instance === VOID)
    new RiseCard();
  return RiseCard_instance;
}
function _get_$cachedSerializer__te6jhj_437($this) {
  return $this.y60_1.k3();
}
function ScorchedEarthCard$_anonymous__f30vkk() {
  var tmp = ScorchedEarthCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ScorchedEarthCard', tmp, tmp$ret$0);
}
var ScorchedEarthCard_instance;
function ScorchedEarthCard_getInstance() {
  if (ScorchedEarthCard_instance === VOID)
    new ScorchedEarthCard();
  return ScorchedEarthCard_instance;
}
function _get_$cachedSerializer__te6jhj_438($this) {
  return $this.a61_1.k3();
}
function SummonLindwyrmCard$_anonymous__3zp46i() {
  var tmp = SummonLindwyrmCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonLindwyrmCard', tmp, tmp$ret$0);
}
var SummonLindwyrmCard_instance;
function SummonLindwyrmCard_getInstance() {
  if (SummonLindwyrmCard_instance === VOID)
    new SummonLindwyrmCard();
  return SummonLindwyrmCard_instance;
}
function _get_$cachedSerializer__te6jhj_439($this) {
  return $this.d61_1.k3();
}
function Rhagner$_anonymous__bcpzdk() {
  var tmp = Rhagner_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Rhagner', tmp, tmp$ret$0);
}
var Rhagner_instance;
function Rhagner_getInstance() {
  if (Rhagner_instance === VOID)
    new Rhagner();
  return Rhagner_instance;
}
function _get_$cachedSerializer__te6jhj_440($this) {
  return $this.e61_1.k3();
}
function RhagnerGainHoardEffectSource$_anonymous__rnjdrx() {
  var tmp = RhagnerGainHoardEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RhagnerGainHoardEffectSource', tmp, tmp$ret$0);
}
var RhagnerGainHoardEffectSource_instance;
function RhagnerGainHoardEffectSource_getInstance() {
  if (RhagnerGainHoardEffectSource_instance === VOID)
    new RhagnerGainHoardEffectSource();
  return RhagnerGainHoardEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_441($this) {
  return $this.f61_1.k3();
}
function RhagnerReduceHoardEffectSource$_anonymous__mwtpvo() {
  var tmp = RhagnerReduceHoardEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RhagnerReduceHoardEffectSource', tmp, tmp$ret$0);
}
var RhagnerReduceHoardEffectSource_instance;
function RhagnerReduceHoardEffectSource_getInstance() {
  if (RhagnerReduceHoardEffectSource_instance === VOID)
    new RhagnerReduceHoardEffectSource();
  return RhagnerReduceHoardEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_442($this) {
  return $this.g61_1.k3();
}
function RhagnerCardGainHoardQuestionContext$_anonymous__gdd4wc() {
  var tmp = RhagnerCardGainHoardQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RhagnerCardGainHoardQuestionContext', tmp, tmp$ret$0);
}
var RhagnerCardGainHoardQuestionContext_instance;
function RhagnerCardGainHoardQuestionContext_getInstance() {
  if (RhagnerCardGainHoardQuestionContext_instance === VOID)
    new RhagnerCardGainHoardQuestionContext();
  return RhagnerCardGainHoardQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_443($this) {
  return $this.h61_1.k3();
}
function RhagnerCardLoseHoardQuestionContext$_anonymous__qfibue() {
  var tmp = RhagnerCardLoseHoardQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RhagnerCardLoseHoardQuestionContext', tmp, tmp$ret$0);
}
var RhagnerCardLoseHoardQuestionContext_instance;
function RhagnerCardLoseHoardQuestionContext_getInstance() {
  if (RhagnerCardLoseHoardQuestionContext_instance === VOID)
    new RhagnerCardLoseHoardQuestionContext();
  return RhagnerCardLoseHoardQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_444($this) {
  return $this.i61_1.k3();
}
function LocationForFireQuestionContext$_anonymous__t7qf48() {
  var tmp = LocationForFireQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LocationForFireQuestionContext', tmp, tmp$ret$0);
}
var LocationForFireQuestionContext_instance;
function LocationForFireQuestionContext_getInstance() {
  if (LocationForFireQuestionContext_instance === VOID)
    new LocationForFireQuestionContext();
  return LocationForFireQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_445($this) {
  return $this.j61_1.k3();
}
function LocationToIncinerateQuestionContext$_anonymous__g9lrxc() {
  var tmp = LocationToIncinerateQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LocationToIncinerateQuestionContext', tmp, tmp$ret$0);
}
var LocationToIncinerateQuestionContext_instance;
function LocationToIncinerateQuestionContext_getInstance() {
  if (LocationToIncinerateQuestionContext_instance === VOID)
    new LocationToIncinerateQuestionContext();
  return LocationToIncinerateQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_446($this) {
  return $this.k61_1.k3();
}
function LocationToTransformAndFireQuestionContext$_anonymous__h6ok73() {
  var tmp = LocationToTransformAndFireQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LocationToTransformAndFireQuestionContext', tmp, tmp$ret$0);
}
var LocationToTransformAndFireQuestionContext_instance;
function LocationToTransformAndFireQuestionContext_getInstance() {
  if (LocationToTransformAndFireQuestionContext_instance === VOID)
    new LocationToTransformAndFireQuestionContext();
  return LocationToTransformAndFireQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_447($this) {
  return $this.l61_1.k3();
}
function SummonToSacrificeQuestionContext$_anonymous__lquv43() {
  var tmp = SummonToSacrificeQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonToSacrificeQuestionContext', tmp, tmp$ret$0);
}
var SummonToSacrificeQuestionContext_instance;
function SummonToSacrificeQuestionContext_getInstance() {
  if (SummonToSacrificeQuestionContext_instance === VOID)
    new SummonToSacrificeQuestionContext();
  return SummonToSacrificeQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_448($this) {
  return $this.m61_1.k3();
}
function TargetToRunFromFireQuestionContext$_anonymous__ucb6rx() {
  var tmp = TargetToRunFromFireQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TargetToRunFromFireQuestionContext', tmp, tmp$ret$0);
}
var TargetToRunFromFireQuestionContext_instance;
function TargetToRunFromFireQuestionContext_getInstance() {
  if (TargetToRunFromFireQuestionContext_instance === VOID)
    new TargetToRunFromFireQuestionContext();
  return TargetToRunFromFireQuestionContext_instance;
}
function AbyssalHellFireStatement$Companion$$childSerializers$_anonymous__tvw9xt() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_458;
function Companion_getInstance_459() {
  if (Companion_instance_458 === VOID)
    new Companion_458();
  return Companion_instance_458;
}
var $serializer_instance_382;
function $serializer_getInstance_382() {
  if ($serializer_instance_382 === VOID)
    new $serializer_386();
  return $serializer_instance_382;
}
function IncinerateHoardStatement$Companion$$childSerializers$_anonymous__vy8gw5() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_459;
function Companion_getInstance_460() {
  if (Companion_instance_459 === VOID)
    new Companion_459();
  return Companion_instance_459;
}
var $serializer_instance_383;
function $serializer_getInstance_383() {
  if ($serializer_instance_383 === VOID)
    new $serializer_387();
  return $serializer_instance_383;
}
function IncinerateStatement$Companion$$childSerializers$_anonymous__fbteyr() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_460;
function Companion_getInstance_461() {
  if (Companion_instance_460 === VOID)
    new Companion_460();
  return Companion_instance_460;
}
var $serializer_instance_384;
function $serializer_getInstance_384() {
  if ($serializer_instance_384 === VOID)
    new $serializer_388();
  return $serializer_instance_384;
}
function RunFromFireStatement$Companion$$childSerializers$_anonymous__t140re() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_461;
function Companion_getInstance_462() {
  if (Companion_instance_461 === VOID)
    new Companion_461();
  return Companion_instance_461;
}
var $serializer_instance_385;
function $serializer_getInstance_385() {
  if ($serializer_instance_385 === VOID)
    new $serializer_389();
  return $serializer_instance_385;
}
function PlaceFireTokenOnNearbyStatement$Companion$$childSerializers$_anonymous__mvhz6d() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_462;
function Companion_getInstance_463() {
  if (Companion_instance_462 === VOID)
    new Companion_462();
  return Companion_instance_462;
}
var $serializer_instance_386;
function $serializer_getInstance_386() {
  if ($serializer_instance_386 === VOID)
    new $serializer_390();
  return $serializer_instance_386;
}
function PlaceFireTokensStatement$Companion$$childSerializers$_anonymous__odt5ua() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
function PlaceFireTokensStatement$Companion$$childSerializers$_anonymous__odt5ua_0() {
  return new LinkedHashSetSerializer($serializer_getInstance_100());
}
var Companion_instance_463;
function Companion_getInstance_464() {
  if (Companion_instance_463 === VOID)
    new Companion_463();
  return Companion_instance_463;
}
var $serializer_instance_387;
function $serializer_getInstance_387() {
  if ($serializer_instance_387 === VOID)
    new $serializer_391();
  return $serializer_instance_387;
}
var Companion_instance_464;
function Companion_getInstance_465() {
  return Companion_instance_464;
}
var $serializer_instance_388;
function $serializer_getInstance_388() {
  if ($serializer_instance_388 === VOID)
    new $serializer_392();
  return $serializer_instance_388;
}
function RiseHoardStatement$Companion$$childSerializers$_anonymous__ue7yzm() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_465;
function Companion_getInstance_466() {
  if (Companion_instance_465 === VOID)
    new Companion_465();
  return Companion_instance_465;
}
var $serializer_instance_389;
function $serializer_getInstance_389() {
  if ($serializer_instance_389 === VOID)
    new $serializer_393();
  return $serializer_instance_389;
}
function RiseStatement$Companion$$childSerializers$_anonymous__mz3igs() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_466;
function Companion_getInstance_467() {
  if (Companion_instance_466 === VOID)
    new Companion_466();
  return Companion_instance_466;
}
var $serializer_instance_390;
function $serializer_getInstance_390() {
  if ($serializer_instance_390 === VOID)
    new $serializer_394();
  return $serializer_instance_390;
}
function ScorchedEarthHoardStatement$Companion$$childSerializers$_anonymous__qdlsb8() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_467;
function Companion_getInstance_468() {
  if (Companion_instance_467 === VOID)
    new Companion_467();
  return Companion_instance_467;
}
var $serializer_instance_391;
function $serializer_getInstance_391() {
  if ($serializer_instance_391 === VOID)
    new $serializer_395();
  return $serializer_instance_391;
}
function ScorchedEarthStatement$Companion$$childSerializers$_anonymous__3ii55a() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_468;
function Companion_getInstance_469() {
  if (Companion_instance_468 === VOID)
    new Companion_468();
  return Companion_instance_468;
}
var $serializer_instance_392;
function $serializer_getInstance_392() {
  if ($serializer_instance_392 === VOID)
    new $serializer_396();
  return $serializer_instance_392;
}
function SummonLindwyrmHoardStatement$Companion$$childSerializers$_anonymous__3gw0k6() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_469;
function Companion_getInstance_470() {
  if (Companion_instance_469 === VOID)
    new Companion_469();
  return Companion_instance_469;
}
var $serializer_instance_393;
function $serializer_getInstance_393() {
  if ($serializer_instance_393 === VOID)
    new $serializer_397();
  return $serializer_instance_393;
}
function SummonLindwyrmStatement$Companion$$childSerializers$_anonymous__25d1xo() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_470;
function Companion_getInstance_471() {
  if (Companion_instance_470 === VOID)
    new Companion_470();
  return Companion_instance_470;
}
var $serializer_instance_394;
function $serializer_getInstance_394() {
  if ($serializer_instance_394 === VOID)
    new $serializer_398();
  return $serializer_instance_394;
}
function RhagnerHoardChangeEvent$Companion$$childSerializers$_anonymous__ialzqr() {
  return Companion_instance_457.a2g();
}
var Companion_instance_471;
function Companion_getInstance_472() {
  if (Companion_instance_471 === VOID)
    new Companion_471();
  return Companion_instance_471;
}
var $serializer_instance_395;
function $serializer_getInstance_395() {
  if ($serializer_instance_395 === VOID)
    new $serializer_399();
  return $serializer_instance_395;
}
function _get_$cachedSerializer__te6jhj_449($this) {
  return $this.j64_1.k3();
}
function LindwyrmType$_anonymous__zpzsd() {
  var tmp = LindwyrmType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LindwyrmType', tmp, tmp$ret$0);
}
var LindwyrmType_instance;
function LindwyrmType_getInstance() {
  if (LindwyrmType_instance === VOID)
    new LindwyrmType();
  return LindwyrmType_instance;
}
function get_rhagnerBeast($context_GameState_t6qee5) {
  _init_properties_Rhagner_kt__s8qtn1();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Rhagner) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function hoardLevel($context_GameState_t6qee5, _this__u8e3s4, card) {
  _init_properties_Rhagner_kt__s8qtn1();
  return ensureNotNull(get_rhagnerHoardLevels($context_GameState_t6qee5, _this__u8e3s4).w4(card));
}
function setHoardLevel($context_GameStateImpl_x43bj1, _this__u8e3s4, card, value) {
  _init_properties_Rhagner_kt__s8qtn1();
  set_rhagnerHoardLevelsImpl($context_GameStateImpl_x43bj1, _this__u8e3s4, plus_3(get_rhagnerHoardLevelsImpl($context_GameStateImpl_x43bj1, _this__u8e3s4), to(card, value)));
}
function set_rhagnerHoardLevelsImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Rhagner_kt__s8qtn1();
  setImplProperty(gsiCtx, _this__u8e3s4, get_rhagnerHoardLevelsKey(), new PlayableCardToIntMapWrapper(toMap(value)));
}
function get_rhagnerHoardLevelsImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Rhagner_kt__s8qtn1();
  return getRhagnerHoardLevelsImpl(_this__u8e3s4, gsiCtx);
}
function get_rhagnerHoardLevels(gsCtx, _this__u8e3s4) {
  _init_properties_Rhagner_kt__s8qtn1();
  return getRhagnerHoardLevelsImpl(_this__u8e3s4, gsCtx);
}
function getRhagnerHoardLevelsImpl(_this__u8e3s4, gameState) {
  _init_properties_Rhagner_kt__s8qtn1();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_rhagnerHoardLevelsKey()).n5e_1;
}
var Companion_instance_472;
function Companion_getInstance_473() {
  return Companion_instance_472;
}
var $serializer_instance_396;
function $serializer_getInstance_396() {
  if ($serializer_instance_396 === VOID)
    new $serializer_400();
  return $serializer_instance_396;
}
var properties_initialized_Rhagner_kt_dt9m29;
function _init_properties_Rhagner_kt__s8qtn1() {
  if (!properties_initialized_Rhagner_kt_dt9m29) {
    properties_initialized_Rhagner_kt_dt9m29 = true;
    rhagnerHoardLevelsKey = _GeneralMapKey___init__impl__zdmbea('rhagnerHoardLevels');
  }
}
var Companion_instance_473;
function Companion_getInstance_474() {
  return Companion_instance_473;
}
var $serializer_instance_397;
function $serializer_getInstance_397() {
  if ($serializer_instance_397 === VOID)
    new $serializer_401();
  return $serializer_instance_397;
}
function _get_$cachedSerializer__te6jhj_450($this) {
  return $this.y64_1.k3();
}
function SecretsFromALostAgeInitialPhase$_anonymous__n3dhpj() {
  var tmp = SecretsFromALostAgeInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SecretsFromALostAgeInitialPhase', tmp, tmp$ret$0);
}
var SecretsFromALostAgeInitialPhase_instance;
function SecretsFromALostAgeInitialPhase_getInstance() {
  if (SecretsFromALostAgeInitialPhase_instance === VOID)
    new SecretsFromALostAgeInitialPhase();
  return SecretsFromALostAgeInitialPhase_instance;
}
function get_settlerWasMovedOnHunterTurnKey() {
  _init_properties_ShipwreckContract_kt__x1sre2();
  return settlerWasMovedOnHunterTurnKey;
}
var settlerWasMovedOnHunterTurnKey;
var Companion_instance_474;
function Companion_getInstance_475() {
  return Companion_instance_474;
}
var $serializer_instance_398;
function $serializer_getInstance_398() {
  if ($serializer_instance_398 === VOID)
    new $serializer_402();
  return $serializer_instance_398;
}
function _get_$cachedSerializer__te6jhj_451($this) {
  return $this.j65_1.k3();
}
function ShipwreckRedDraftActionCardEffectSource$_anonymous__ern0m9() {
  var tmp = ShipwreckRedDraftActionCardEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ShipwreckRedDraftActionCardEffectSource', tmp, tmp$ret$0);
}
var ShipwreckRedDraftActionCardEffectSource_instance;
function ShipwreckRedDraftActionCardEffectSource_getInstance() {
  if (ShipwreckRedDraftActionCardEffectSource_instance === VOID)
    new ShipwreckRedDraftActionCardEffectSource();
  return ShipwreckRedDraftActionCardEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_452($this) {
  return $this.k65_1.k3();
}
function ShipwreckSettlerMovementStatement$_anonymous__ggs1ig() {
  var tmp = ShipwreckSettlerMovementStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ShipwreckSettlerMovementStatement', tmp, tmp$ret$0);
}
var ShipwreckSettlerMovementStatement_instance;
function ShipwreckSettlerMovementStatement_getInstance() {
  if (ShipwreckSettlerMovementStatement_instance === VOID)
    new ShipwreckSettlerMovementStatement();
  return ShipwreckSettlerMovementStatement_instance;
}
function _get_$cachedSerializer__te6jhj_453($this) {
  return $this.l65_1.k3();
}
function ShipwreckInitialPhase$_anonymous__d8tqyy() {
  var tmp = ShipwreckInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ShipwreckInitialPhase', tmp, tmp$ret$0);
}
var ShipwreckInitialPhase_instance;
function ShipwreckInitialPhase_getInstance() {
  if (ShipwreckInitialPhase_instance === VOID)
    new ShipwreckInitialPhase();
  return ShipwreckInitialPhase_instance;
}
function ChangeSettlersMovedStatusEvent$Companion$$childSerializers$_anonymous__t7n4iv() {
  return new LinkedHashSetSerializer($serializer_364.y2o(Companion_instance_422.a2g()));
}
var Companion_instance_475;
function Companion_getInstance_476() {
  if (Companion_instance_475 === VOID)
    new Companion_475();
  return Companion_instance_475;
}
var $serializer_instance_399;
function $serializer_getInstance_399() {
  if ($serializer_instance_399 === VOID)
    new $serializer_403();
  return $serializer_instance_399;
}
function set_settlerWasMovedOnHunterTurnImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_ShipwreckContract_kt__x1sre2();
  gsiCtx.j39(_this__u8e3s4.r2w_1, get_settlerWasMovedOnHunterTurnKey(), new BooleanWrapper(value), new BooleanWrapper(false));
}
var properties_initialized_ShipwreckContract_kt_r8zgnc;
function _init_properties_ShipwreckContract_kt__x1sre2() {
  if (!properties_initialized_ShipwreckContract_kt_r8zgnc) {
    properties_initialized_ShipwreckContract_kt_r8zgnc = true;
    settlerWasMovedOnHunterTurnKey = _GeneralMapKey___init__impl__zdmbea('settlerWasMovedOnHunterTurn');
  }
}
var sigridPactTerrains;
function get_sigridPactsKey() {
  _init_properties_Sigrid_kt__ysbo5g();
  return sigridPactsKey;
}
var sigridPactsKey;
function get_sigridCreatureLungedThisTurnKey() {
  _init_properties_Sigrid_kt__ysbo5g();
  return sigridCreatureLungedThisTurnKey;
}
var sigridCreatureLungedThisTurnKey;
function get_sigridAbilityCards() {
  _init_properties_Sigrid_kt__ysbo5g();
  return sigridAbilityCards;
}
var sigridAbilityCards;
function _get_$cachedSerializer__te6jhj_454($this) {
  return $this.u65_1.k3();
}
function Sigrid$_anonymous__hn1iv9() {
  var tmp = Sigrid_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Sigrid', tmp, tmp$ret$0);
}
var Sigrid_instance;
function Sigrid_getInstance() {
  if (Sigrid_instance === VOID)
    new Sigrid();
  return Sigrid_instance;
}
function _get_$cachedSerializer__te6jhj_455($this) {
  return $this.v65_1.k3();
}
function EcholocationUpgrade$_anonymous__7uirsl() {
  var tmp = EcholocationUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EcholocationUpgrade', tmp, tmp$ret$0);
}
var EcholocationUpgrade_instance;
function EcholocationUpgrade_getInstance() {
  if (EcholocationUpgrade_instance === VOID)
    new EcholocationUpgrade();
  return EcholocationUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_456($this) {
  return $this.w65_1.k3();
}
function SwapUpgrade$_anonymous__8dy4c2() {
  var tmp = SwapUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SwapUpgrade', tmp, tmp$ret$0);
}
var SwapUpgrade_instance;
function SwapUpgrade_getInstance() {
  if (SwapUpgrade_instance === VOID)
    new SwapUpgrade();
  return SwapUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_457($this) {
  return $this.x65_1.k3();
}
function PactReversalUpgrade$_anonymous__kjb9gr() {
  var tmp = PactReversalUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PactReversalUpgrade', tmp, tmp$ret$0);
}
var PactReversalUpgrade_instance;
function PactReversalUpgrade_getInstance() {
  if (PactReversalUpgrade_instance === VOID)
    new PactReversalUpgrade();
  return PactReversalUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_458($this) {
  return $this.y65_1.k3();
}
function SigridCreatureDeathEffectSource$_anonymous__9w7vle() {
  var tmp = SigridCreatureDeathEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SigridCreatureDeathEffectSource', tmp, tmp$ret$0);
}
var SigridCreatureDeathEffectSource_instance;
function SigridCreatureDeathEffectSource_getInstance() {
  if (SigridCreatureDeathEffectSource_instance === VOID)
    new SigridCreatureDeathEffectSource();
  return SigridCreatureDeathEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_459($this) {
  return $this.z65_1.k3();
}
function SigridCreatureLungeEffectSource$_anonymous__xerxj1() {
  var tmp = SigridCreatureLungeEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SigridCreatureLungeEffectSource', tmp, tmp$ret$0);
}
var SigridCreatureLungeEffectSource_instance;
function SigridCreatureLungeEffectSource_getInstance() {
  if (SigridCreatureLungeEffectSource_instance === VOID)
    new SigridCreatureLungeEffectSource();
  return SigridCreatureLungeEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_460($this) {
  return $this.a66_1.k3();
}
function SigridSummonCreatureEffectSource$_anonymous__u7wsdr() {
  var tmp = SigridSummonCreatureEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SigridSummonCreatureEffectSource', tmp, tmp$ret$0);
}
var SigridSummonCreatureEffectSource_instance;
function SigridSummonCreatureEffectSource_getInstance() {
  if (SigridSummonCreatureEffectSource_instance === VOID)
    new SigridSummonCreatureEffectSource();
  return SigridSummonCreatureEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_461($this) {
  return $this.b66_1.k3();
}
function SigridPactCardQuestionContext$_anonymous__d53xic() {
  var tmp = SigridPactCardQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SigridPactCardQuestionContext', tmp, tmp$ret$0);
}
var SigridPactCardQuestionContext_instance;
function SigridPactCardQuestionContext_getInstance() {
  if (SigridPactCardQuestionContext_instance === VOID)
    new SigridPactCardQuestionContext();
  return SigridPactCardQuestionContext_instance;
}
function SigridAttackAllNearbyLocationsStatement$Companion$$childSerializers$_anonymous__701kxv() {
  return Companion_instance_138.a2g();
}
function SigridAttackAllNearbyLocationsStatement$Companion$$childSerializers$_anonymous__701kxv_0() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_476;
function Companion_getInstance_477() {
  if (Companion_instance_476 === VOID)
    new Companion_476();
  return Companion_instance_476;
}
var $serializer_instance_400;
function $serializer_getInstance_400() {
  if ($serializer_instance_400 === VOID)
    new $serializer_404();
  return $serializer_instance_400;
}
function _get_$cachedSerializer__te6jhj_462($this) {
  return $this.i66_1.k3();
}
function SigridCreatureLungeStatement$_anonymous__lw2n3k() {
  var tmp = SigridCreatureLungeStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SigridCreatureLungeStatement', tmp, tmp$ret$0);
}
var SigridCreatureLungeStatement_instance;
function SigridCreatureLungeStatement_getInstance() {
  if (SigridCreatureLungeStatement_instance === VOID)
    new SigridCreatureLungeStatement();
  return SigridCreatureLungeStatement_instance;
}
function _get_$cachedSerializer__te6jhj_463($this) {
  return $this.j66_1.k3();
}
function SigridPactReversalStatement$_anonymous__do2a6s() {
  var tmp = SigridPactReversalStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SigridPactReversalStatement', tmp, tmp$ret$0);
}
var SigridPactReversalStatement_instance;
function SigridPactReversalStatement_getInstance() {
  if (SigridPactReversalStatement_instance === VOID)
    new SigridPactReversalStatement();
  return SigridPactReversalStatement_instance;
}
function SigridSearchAllNearbyLocationsStatement$Companion$$childSerializers$_anonymous__wg2ujh() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_477;
function Companion_getInstance_478() {
  if (Companion_instance_477 === VOID)
    new Companion_477();
  return Companion_instance_477;
}
var $serializer_instance_401;
function $serializer_getInstance_401() {
  if ($serializer_instance_401 === VOID)
    new $serializer_405();
  return $serializer_instance_401;
}
function _get_$cachedSerializer__te6jhj_464($this) {
  return $this.p66_1.k3();
}
function SummonCreatureStatement$_anonymous__6onuk8() {
  var tmp = SummonCreatureStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonCreatureStatement', tmp, tmp$ret$0);
}
var SummonCreatureStatement_instance;
function SummonCreatureStatement_getInstance() {
  if (SummonCreatureStatement_instance === VOID)
    new SummonCreatureStatement();
  return SummonCreatureStatement_instance;
}
function SigridPactChangeEvent$Companion$$childSerializers$_anonymous__2izx3y() {
  return Companion_instance_480.a2g();
}
function SigridPactChangeEvent$Companion$$childSerializers$_anonymous__2izx3y_0() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
var Companion_instance_478;
function Companion_getInstance_479() {
  if (Companion_instance_478 === VOID)
    new Companion_478();
  return Companion_instance_478;
}
var $serializer_instance_402;
function $serializer_getInstance_402() {
  if ($serializer_instance_402 === VOID)
    new $serializer_406();
  return $serializer_instance_402;
}
var Companion_instance_479;
function Companion_getInstance_480() {
  return Companion_instance_479;
}
var $serializer_instance_403;
function $serializer_getInstance_403() {
  if ($serializer_instance_403 === VOID)
    new $serializer_407();
  return $serializer_instance_403;
}
function _get_$cachedSerializer__te6jhj_465($this) {
  return $this.a67_1.k3();
}
function SigridCreatureLungedEvent$_anonymous__5jadpj() {
  var tmp = SigridCreatureLungedEvent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SigridCreatureLungedEvent', tmp, tmp$ret$0);
}
var SigridCreatureLungedEvent_instance;
function SigridCreatureLungedEvent_getInstance() {
  if (SigridCreatureLungedEvent_instance === VOID)
    new SigridCreatureLungedEvent();
  return SigridCreatureLungedEvent_instance;
}
function _get_$cachedSerializer__te6jhj_466($this) {
  return $this.c67_1.k3();
}
function CreatureType$_anonymous__t2c2pu() {
  var tmp = CreatureType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CreatureType', tmp, tmp$ret$0);
}
var CreatureType_instance;
function CreatureType_getInstance() {
  if (CreatureType_instance === VOID)
    new CreatureType();
  return CreatureType_instance;
}
function _get_$cachedSerializer__te6jhj_467($this) {
  return $this.e67_1.k3();
}
function TraitorsHuntCard$_anonymous__g05hym() {
  var tmp = TraitorsHuntCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TraitorsHuntCard', tmp, tmp$ret$0);
}
var TraitorsHuntCard_instance;
function TraitorsHuntCard_getInstance() {
  if (TraitorsHuntCard_instance === VOID)
    new TraitorsHuntCard();
  return TraitorsHuntCard_instance;
}
function _get_$cachedSerializer__te6jhj_468($this) {
  return $this.g67_1.k3();
}
function BondedTrackCard$_anonymous__itqr4y() {
  var tmp = BondedTrackCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BondedTrackCard', tmp, tmp$ret$0);
}
var BondedTrackCard_instance;
function BondedTrackCard_getInstance() {
  if (BondedTrackCard_instance === VOID)
    new BondedTrackCard();
  return BondedTrackCard_instance;
}
function _get_$cachedSerializer__te6jhj_469($this) {
  return $this.i67_1.k3();
}
function ScroungeCard$_anonymous__sn5mqr() {
  var tmp = ScroungeCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ScroungeCard', tmp, tmp$ret$0);
}
var ScroungeCard_instance;
function ScroungeCard_getInstance() {
  if (ScroungeCard_instance === VOID)
    new ScroungeCard();
  return ScroungeCard_instance;
}
var Companion_instance_480;
function Companion_getInstance_481() {
  return Companion_instance_480;
}
function get_creatureCompanion($context_GameState_t6qee5) {
  _init_properties_Sigrid_kt__ysbo5g();
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof CreatureType) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return singleOrNull(destination);
}
function get_sigridHunter($context_GameState_t6qee5) {
  _init_properties_Sigrid_kt__ysbo5g();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Sigrid) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function get_sigridCreatureLungedThisTurn(gsCtx, _this__u8e3s4) {
  _init_properties_Sigrid_kt__ysbo5g();
  return getSigridCreatureLungedThisTurnImpl(_this__u8e3s4, gsCtx);
}
function setSigridPact($context_GameStateImpl_x43bj1, _this__u8e3s4, card, terrain) {
  _init_properties_Sigrid_kt__ysbo5g();
  set_sigridPactsImpl($context_GameStateImpl_x43bj1, _this__u8e3s4, terrain == null ? minus(get_sigridPactsImpl($context_GameStateImpl_x43bj1, _this__u8e3s4), card) : plus_3(get_sigridPactsImpl($context_GameStateImpl_x43bj1, _this__u8e3s4), to(card, terrain)));
}
function pactTerrain($context_GameState_t6qee5, _this__u8e3s4, card) {
  _init_properties_Sigrid_kt__ysbo5g();
  return get_sigridPacts($context_GameState_t6qee5, _this__u8e3s4).w4(card);
}
function set_sigridCreatureLungedThisTurnImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Sigrid_kt__ysbo5g();
  setImplProperty(gsiCtx, _this__u8e3s4, get_sigridCreatureLungedThisTurnKey(), new BooleanWrapper(value));
}
function getSigridCreatureLungedThisTurnImpl(_this__u8e3s4, gameState) {
  _init_properties_Sigrid_kt__ysbo5g();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_sigridCreatureLungedThisTurnKey()).j3w_1;
}
function set_sigridPactsImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Sigrid_kt__ysbo5g();
  setImplProperty(gsiCtx, _this__u8e3s4, get_sigridPactsKey(), new PlayableCardToLocationTypeMapWrapper(toMap(value)));
}
function get_sigridPactsImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Sigrid_kt__ysbo5g();
  return getSigridPactsImpl(_this__u8e3s4, gsiCtx);
}
function get_sigridPacts(gsCtx, _this__u8e3s4) {
  _init_properties_Sigrid_kt__ysbo5g();
  return getSigridPactsImpl(_this__u8e3s4, gsCtx);
}
function getSigridPactsImpl(_this__u8e3s4, gameState) {
  _init_properties_Sigrid_kt__ysbo5g();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_sigridPactsKey()).s5e_1;
}
var properties_initialized_Sigrid_kt_f4acv2;
function _init_properties_Sigrid_kt__ysbo5g() {
  if (!properties_initialized_Sigrid_kt_f4acv2) {
    properties_initialized_Sigrid_kt_f4acv2 = true;
    sigridPactTerrains = setOf_0([LocationType_Swamp_getInstance(), LocationType_Forest_getInstance(), LocationType_Cave_getInstance()]);
    sigridPactsKey = _GeneralMapKey___init__impl__zdmbea('sigridPacts');
    sigridCreatureLungedThisTurnKey = _GeneralMapKey___init__impl__zdmbea('sigridCreatureLungedThisTurn');
    sigridAbilityCards = setOf_0([ScroungeCard_getInstance(), BondedTrackCard_getInstance(), TraitorsHuntCard_getInstance()]);
  }
}
function _get_$cachedSerializer__te6jhj_470($this) {
  return $this.j67_1.k3();
}
function CloudShiftUpgrade$_anonymous__b7y0s8() {
  var tmp = CloudShiftUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CloudShiftUpgrade', tmp, tmp$ret$0);
}
var CloudShiftUpgrade_instance;
function CloudShiftUpgrade_getInstance() {
  if (CloudShiftUpgrade_instance === VOID)
    new CloudShiftUpgrade();
  return CloudShiftUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_471($this) {
  return $this.k67_1.k3();
}
function BehornedUpgrade$_anonymous__de7ujk() {
  var tmp = BehornedUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BehornedUpgrade', tmp, tmp$ret$0);
}
var BehornedUpgrade_instance;
function BehornedUpgrade_getInstance() {
  if (BehornedUpgrade_instance === VOID)
    new BehornedUpgrade();
  return BehornedUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_472($this) {
  return $this.l67_1.k3();
}
function StormBringerUpgrade$_anonymous__82st4h() {
  var tmp = StormBringerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('StormBringerUpgrade', tmp, tmp$ret$0);
}
var StormBringerUpgrade_instance;
function StormBringerUpgrade_getInstance() {
  if (StormBringerUpgrade_instance === VOID)
    new StormBringerUpgrade();
  return StormBringerUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_473($this) {
  return $this.m67_1.k3();
}
function EruptionUpgrade$_anonymous__a7ip8p() {
  var tmp = EruptionUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EruptionUpgrade', tmp, tmp$ret$0);
}
var EruptionUpgrade_instance;
function EruptionUpgrade_getInstance() {
  if (EruptionUpgrade_instance === VOID)
    new EruptionUpgrade();
  return EruptionUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_474($this) {
  return $this.n67_1.k3();
}
function SuddenShockUpgrade$_anonymous__q2m9ke() {
  var tmp = SuddenShockUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SuddenShockUpgrade', tmp, tmp$ret$0);
}
var SuddenShockUpgrade_instance;
function SuddenShockUpgrade_getInstance() {
  if (SuddenShockUpgrade_instance === VOID)
    new SuddenShockUpgrade();
  return SuddenShockUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_475($this) {
  return $this.o67_1.k3();
}
function DischargeUpgrade$_anonymous__lqein1() {
  var tmp = DischargeUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DischargeUpgrade', tmp, tmp$ret$0);
}
var DischargeUpgrade_instance;
function DischargeUpgrade_getInstance() {
  if (DischargeUpgrade_instance === VOID)
    new DischargeUpgrade();
  return DischargeUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_476($this) {
  return $this.p67_1.k3();
}
function StarFallUpgrade$_anonymous__vcvjrs() {
  var tmp = StarFallUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('StarFallUpgrade', tmp, tmp$ret$0);
}
var StarFallUpgrade_instance;
function StarFallUpgrade_getInstance() {
  if (StarFallUpgrade_instance === VOID)
    new StarFallUpgrade();
  return StarFallUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_477($this) {
  return $this.r67_1.k3();
}
function Thalduk$_anonymous__4g4ckc() {
  var tmp = Thalduk_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Thalduk', tmp, tmp$ret$0);
}
var Thalduk_instance;
function Thalduk_getInstance() {
  if (Thalduk_instance === VOID)
    new Thalduk();
  return Thalduk_instance;
}
function _get_$cachedSerializer__te6jhj_478($this) {
  return $this.s67_1.k3();
}
function PossibleBleatEffectSource$_anonymous__uuzunm() {
  var tmp = PossibleBleatEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PossibleBleatEffectSource', tmp, tmp$ret$0);
}
var PossibleBleatEffectSource_instance;
function PossibleBleatEffectSource_getInstance() {
  if (PossibleBleatEffectSource_instance === VOID)
    new PossibleBleatEffectSource();
  return PossibleBleatEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_479($this) {
  return $this.t67_1.k3();
}
function ActorForRamQuestionContext$_anonymous__k5a2x4() {
  var tmp = ActorForRamQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ActorForRamQuestionContext', tmp, tmp$ret$0);
}
var ActorForRamQuestionContext_instance;
function ActorForRamQuestionContext_getInstance() {
  if (ActorForRamQuestionContext_instance === VOID)
    new ActorForRamQuestionContext();
  return ActorForRamQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_480($this) {
  return $this.u67_1.k3();
}
function TargetToRamQuestionContext$_anonymous__9alkm8() {
  var tmp = TargetToRamQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TargetToRamQuestionContext', tmp, tmp$ret$0);
}
var TargetToRamQuestionContext_instance;
function TargetToRamQuestionContext_getInstance() {
  if (TargetToRamQuestionContext_instance === VOID)
    new TargetToRamQuestionContext();
  return TargetToRamQuestionContext_instance;
}
function BleatCardTriggerStatement$Companion$$childSerializers$_anonymous__6l5wln() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_481;
function Companion_getInstance_482() {
  if (Companion_instance_481 === VOID)
    new Companion_481();
  return Companion_instance_481;
}
var $serializer_instance_404;
function $serializer_getInstance_404() {
  if ($serializer_instance_404 === VOID)
    new $serializer_408();
  return $serializer_instance_404;
}
function DischargeStatement$Companion$$childSerializers$_anonymous__1q3jc3() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_482;
function Companion_getInstance_483() {
  if (Companion_instance_482 === VOID)
    new Companion_482();
  return Companion_instance_482;
}
var $serializer_instance_405;
function $serializer_getInstance_405() {
  if ($serializer_instance_405 === VOID)
    new $serializer_409();
  return $serializer_instance_405;
}
function _get_$cachedSerializer__te6jhj_481($this) {
  return $this.f68_1.k3();
}
function EruptionEffectStatement$_anonymous__vdw00b() {
  var tmp = EruptionEffectStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EruptionEffectStatement', tmp, tmp$ret$0);
}
var EruptionEffectStatement_instance;
function EruptionEffectStatement_getInstance() {
  if (EruptionEffectStatement_instance === VOID)
    new EruptionEffectStatement();
  return EruptionEffectStatement_instance;
}
function RamAnotherTargetStatement$Companion$$childSerializers$_anonymous__tatpox() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_483;
function Companion_getInstance_484() {
  if (Companion_instance_483 === VOID)
    new Companion_483();
  return Companion_instance_483;
}
var $serializer_instance_406;
function $serializer_getInstance_406() {
  if ($serializer_instance_406 === VOID)
    new $serializer_410();
  return $serializer_instance_406;
}
function RevealToMoveStatement$Companion$$childSerializers$_anonymous__wvg5ws() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_484;
function Companion_getInstance_485() {
  if (Companion_instance_484 === VOID)
    new Companion_484();
  return Companion_instance_484;
}
var $serializer_instance_407;
function $serializer_getInstance_407() {
  if ($serializer_instance_407 === VOID)
    new $serializer_411();
  return $serializer_instance_407;
}
function SuddenShockStatement$Companion$$childSerializers$_anonymous__eilea() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_485;
function Companion_getInstance_486() {
  if (Companion_instance_485 === VOID)
    new Companion_485();
  return Companion_instance_485;
}
var $serializer_instance_408;
function $serializer_getInstance_408() {
  if ($serializer_instance_408 === VOID)
    new $serializer_412();
  return $serializer_instance_408;
}
function _get_$cachedSerializer__te6jhj_482($this) {
  return $this.w68_1.k3();
}
function YagiType$_anonymous__867no3() {
  var tmp = YagiType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('YagiType', tmp, tmp$ret$0);
}
var YagiType_instance;
function YagiType_getInstance() {
  if (YagiType_instance === VOID)
    new YagiType();
  return YagiType_instance;
}
function _get_$cachedSerializer__te6jhj_483($this) {
  return $this.x68_1.k3();
}
function AcclivityCard$_anonymous__pz0dyp() {
  var tmp = AcclivityCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AcclivityCard', tmp, tmp$ret$0);
}
var AcclivityCard_instance;
function AcclivityCard_getInstance() {
  if (AcclivityCard_instance === VOID)
    new AcclivityCard();
  return AcclivityCard_instance;
}
function _get_$cachedSerializer__te6jhj_484($this) {
  return $this.y68_1.k3();
}
function OverloadedStormCard$_anonymous__tao4a1() {
  var tmp = OverloadedStormCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OverloadedStormCard', tmp, tmp$ret$0);
}
var OverloadedStormCard_instance;
function OverloadedStormCard_getInstance() {
  if (OverloadedStormCard_instance === VOID)
    new OverloadedStormCard();
  return OverloadedStormCard_instance;
}
function _get_$cachedSerializer__te6jhj_485($this) {
  return $this.a69_1.k3();
}
function StormCard$_anonymous__ff9fjy() {
  var tmp = StormCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('StormCard', tmp, tmp$ret$0);
}
var StormCard_instance;
function StormCard_getInstance() {
  if (StormCard_instance === VOID)
    new StormCard();
  return StormCard_instance;
}
function _get_$cachedSerializer__te6jhj_486($this) {
  return $this.c69_1.k3();
}
function SummonYagiCard$_anonymous__2wiwcc() {
  var tmp = SummonYagiCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonYagiCard', tmp, tmp$ret$0);
}
var SummonYagiCard_instance;
function SummonYagiCard_getInstance() {
  if (SummonYagiCard_instance === VOID)
    new SummonYagiCard();
  return SummonYagiCard_instance;
}
function _get_$cachedSerializer__te6jhj_487($this) {
  return $this.d69_1.k3();
}
function BleatCard$_anonymous__ccio0p() {
  var tmp = BleatCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BleatCard', tmp, tmp$ret$0);
}
var BleatCard_instance;
function BleatCard_getInstance() {
  if (BleatCard_instance === VOID)
    new BleatCard();
  return BleatCard_instance;
}
var Companion_instance_486;
function Companion_getInstance_487() {
  return Companion_instance_486;
}
var $serializer_instance_409;
function $serializer_getInstance_409() {
  if ($serializer_instance_409 === VOID)
    new $serializer_413();
  return $serializer_instance_409;
}
function _get_$cachedSerializer__te6jhj_488($this) {
  return $this.o69_1.k3();
}
function UnleashingTheAbyssInitialPhase$_anonymous__bwg7l1() {
  var tmp = UnleashingTheAbyssInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UnleashingTheAbyssInitialPhase', tmp, tmp$ret$0);
}
var UnleashingTheAbyssInitialPhase_instance;
function UnleashingTheAbyssInitialPhase_getInstance() {
  if (UnleashingTheAbyssInitialPhase_instance === VOID)
    new UnleashingTheAbyssInitialPhase();
  return UnleashingTheAbyssInitialPhase_instance;
}
var Companion_instance_487;
function Companion_getInstance_488() {
  return Companion_instance_487;
}
var $serializer_instance_410;
function $serializer_getInstance_410() {
  if ($serializer_instance_410 === VOID)
    new $serializer_414();
  return $serializer_instance_410;
}
var Companion_instance_488;
function Companion_getInstance_489() {
  return Companion_instance_488;
}
var $serializer_instance_411;
function $serializer_getInstance_411() {
  if ($serializer_instance_411 === VOID)
    new $serializer_415();
  return $serializer_instance_411;
}
var Companion_instance_489;
function Companion_getInstance_490() {
  return Companion_instance_489;
}
var $serializer_instance_412;
function $serializer_getInstance_412() {
  if ($serializer_instance_412 === VOID)
    new $serializer_416();
  return $serializer_instance_412;
}
function _get_$cachedSerializer__te6jhj_489($this) {
  return $this.i6a_1.k3();
}
function UnlikelyAllianceInitialPhase$_anonymous__s4wdw() {
  var tmp = UnlikelyAllianceInitialPhase_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UnlikelyAllianceInitialPhase', tmp, tmp$ret$0);
}
var UnlikelyAllianceInitialPhase_instance;
function UnlikelyAllianceInitialPhase_getInstance() {
  if (UnlikelyAllianceInitialPhase_instance === VOID)
    new UnlikelyAllianceInitialPhase();
  return UnlikelyAllianceInitialPhase_instance;
}
function get_upperShatteredIslesMap() {
  _init_properties_UpperShatteredIslesMap_kt__nwubwi();
  return upperShatteredIslesMap;
}
var upperShatteredIslesMap;
var UpperShatteredRuins_instance;
function UpperShatteredRuins_getInstance() {
  if (UpperShatteredRuins_instance === VOID)
    new UpperShatteredRuins();
  return UpperShatteredRuins_instance;
}
function createUpperShatteredIsles() {
  _init_properties_UpperShatteredIslesMap_kt__nwubwi();
  var topLeft = _BoardPosition___init__impl__1nizgq_0(-2, -4);
  var bottomRight = _BoardPosition___init__impl__1nizgq_0(3, 3);
  var mapField = upperShatteredIslesMapField();
  var locationsInit = toLocationsInitMap(topLeft, bottomRight, mapField);
  var removedConnections = setOf(setOf_0([new BoardPosition(_BoardPosition___init__impl__1nizgq_0(-1, 0)), new BoardPosition(_BoardPosition___init__impl__1nizgq_0(0, 0))]));
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.p2();
  createUpperShatteredIsles$addPath(this_0, -2, -3, Companion_getInstance_114().f3l_1, -1, -4, Companion_getInstance_114().i3l_1);
  var inductionVariable = -3;
  if (inductionVariable <= -1)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      createUpperShatteredIsles$addPath(this_0, 0, y, Companion_getInstance_114().g3l_1, 2, y, Companion_getInstance_114().i3l_1);
    }
     while (inductionVariable <= -1);
  var inductionVariable_0 = 2;
  if (inductionVariable_0 <= 3)
    do {
      var x = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      createUpperShatteredIsles$addPath(this_0, x, -1, Companion_getInstance_114().h3l_1, x, 1, Companion_getInstance_114().f3l_1);
    }
     while (inductionVariable_0 <= 3);
  createUpperShatteredIsles$addPath(this_0, 2, 3, Companion_getInstance_114().g3l_1, 3, 2, Companion_getInstance_114().h3l_1);
  var tmp$ret$0 = this_0.g9();
  var nonStandardConnections = newConnectionsToNonStandard(tmp$ret$0);
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_1 = ArrayList.p2();
  createUpperShatteredIsles$addPath(this_1, 0, -4, Companion_getInstance_114().f3l_1, 3, -1, Companion_getInstance_114().g3l_1);
  createUpperShatteredIsles$addPath(this_1, -2, -2, Companion_getInstance_114().i3l_1, -2, 1, Companion_getInstance_114().f3l_1);
  createUpperShatteredIsles$addPath(this_1, -1, 3, Companion_getInstance_114().h3l_1, 3, 2, Companion_getInstance_114().g3l_1);
  var tmp$ret$4 = this_1.g9();
  var hiddenPathConnections = newConnectionsToNonStandard(tmp$ret$4);
  // Inline function 'kotlin.collections.mutableMapOf' call
  var zoneMap = LinkedHashMap.m7();
  var inductionVariable_1 = _BoardPosition___get_y__impl__tale2e(topLeft);
  var last = _BoardPosition___get_y__impl__tale2e(bottomRight);
  if (inductionVariable_1 <= last)
    do {
      var y_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = _BoardPosition___get_x__impl__gyx07(topLeft);
      var last_0 = _BoardPosition___get_x__impl__gyx07(bottomRight);
      if (inductionVariable_2 <= last_0)
        $l$loop_0: do {
          var x_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var position = _BoardPosition___init__impl__1nizgq_0(x_0, y_0);
          if (locationsInit.w4(new BoardPosition(position)) == null) {
            continue $l$loop_0;
          }
          if (x_0 === 0 && y_0 === 0)
            continue $l$loop_0;
          var tmp2 = new BoardPosition(position);
          var tmp;
          if (y_0 < 0) {
            tmp = Zone_Thealis_getInstance();
          } else {
            tmp = Zone_Achur_getInstance();
          }
          // Inline function 'kotlin.collections.set' call
          var value = tmp;
          zoneMap.b5(tmp2, value);
        }
         while (!(x_0 === last_0));
    }
     while (!(y_0 === last));
  var zones = setOf_0([Zone_Thealis_getInstance(), Zone_Achur_getInstance()]);
  return new GameMapImpl(GameMapId_UpperShatteredIsles_getInstance(), zones, topLeft, bottomRight, locationsInit, nonStandardConnections, removedConnections, zoneMap, hiddenPathConnections, setOf_0([new BoardPosition(UpperShatteredSettlements_getInstance().m6a_1), new BoardPosition(UpperShatteredSettlements_getInstance().n6a_1), new BoardPosition(UpperShatteredSettlements_getInstance().o6a_1)]), emptySet(), setOf_0([new BoardPosition(UpperShatteredRuins_getInstance().j6a_1), new BoardPosition(UpperShatteredRuins_getInstance().k6a_1), new BoardPosition(UpperShatteredRuins_getInstance().l6a_1)]));
}
function upperShatteredIslesMapField() {
  _init_properties_UpperShatteredIslesMap_kt__nwubwi();
  var st = LocationType_Settlement_getInstance();
  var sm = LocationType_Swamp_getInstance();
  var ft = LocationType_Forest_getInstance();
  var cv = LocationType_Cave_getInstance();
  var cf = LocationType_CaveAndForest_getInstance();
  var sf = LocationType_SwampAndForest_getInstance();
  var sc = LocationType_SwampAndCave_getInstance();
  var none = null;
  var ship = SheepType_getInstance();
  var boar = BoarType_getInstance();
  var tigr = TigerType_getInstance();
  var farm = FarmerType_getInstance();
  var nobl = NobleType_getInstance();
  var nullLocation = null;
  var beastOfLair0 = upperShatteredIslesMapField$li(LocationType_LairOfTheBeast_getInstance(), null);
  return listOf_0([nullLocation, upperShatteredIslesMapField$li(sm, boar), upperShatteredIslesMapField$li(cv, none), nullLocation, nullLocation, nullLocation, upperShatteredIslesMapField$li(ft, tigr), upperShatteredIslesMapField$li(st, nobl), upperShatteredIslesMapField$li(sm, ship), nullLocation, upperShatteredIslesMapField$li(ft, ship), upperShatteredIslesMapField$li(cv, tigr), upperShatteredIslesMapField$li(ft, ship), upperShatteredIslesMapField$li(cv, none), upperShatteredIslesMapField$li(ft, ship), nullLocation, upperShatteredIslesMapField$li(sm, ship), upperShatteredIslesMapField$li(ft, boar), upperShatteredIslesMapField$li(sm, none), upperShatteredIslesMapField$li(sc, ship), upperShatteredIslesMapField$li(sm, none), nullLocation, upperShatteredIslesMapField$li(cv, ship), upperShatteredIslesMapField$li(cv, ship), nullLocation, upperShatteredIslesMapField$li(cv, boar), beastOfLair0, nullLocation, nullLocation, nullLocation, upperShatteredIslesMapField$li(ft, none), upperShatteredIslesMapField$li(sf, ship), upperShatteredIslesMapField$li(cv, none), upperShatteredIslesMapField$li(sm, ship), upperShatteredIslesMapField$li(ft, none), upperShatteredIslesMapField$li(st, nobl), upperShatteredIslesMapField$li(st, farm), upperShatteredIslesMapField$li(cv, ship), upperShatteredIslesMapField$li(cf, ship), upperShatteredIslesMapField$li(ft, ship), upperShatteredIslesMapField$li(sm, boar), upperShatteredIslesMapField$li(sm, ship), upperShatteredIslesMapField$li(sm, tigr), upperShatteredIslesMapField$li(sm, none), upperShatteredIslesMapField$li(cv, ship), upperShatteredIslesMapField$li(ft, boar), upperShatteredIslesMapField$li(cv, none), nullLocation]);
}
var UpperShatteredSettlements_instance;
function UpperShatteredSettlements_getInstance() {
  if (UpperShatteredSettlements_instance === VOID)
    new UpperShatteredSettlements();
  return UpperShatteredSettlements_instance;
}
function createUpperShatteredIsles$addPath(_this__u8e3s4, x1, y1, d1, x2, y2, d2) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(x1, y1), d1), new PositionAndDirection(_BoardPosition___init__impl__1nizgq_0(x2, y2), d2)];
  return _this__u8e3s4.d2(tmp$ret$0);
}
function upperShatteredIslesMapField$li(type, sot) {
  var tmp;
  if (sot == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = listOf(sot);
  }
  var tmp1_elvis_lhs = tmp;
  return new LocationInit(type, tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs);
}
var properties_initialized_UpperShatteredIslesMap_kt_rt774s;
function _init_properties_UpperShatteredIslesMap_kt__nwubwi() {
  if (!properties_initialized_UpperShatteredIslesMap_kt_rt774s) {
    properties_initialized_UpperShatteredIslesMap_kt_rt774s = true;
    upperShatteredIslesMap = createUpperShatteredIsles();
  }
}
function get_remainMoltEggsOnCounterKey() {
  _init_properties_Urgull_kt__jduhnv();
  return remainMoltEggsOnCounterKey;
}
var remainMoltEggsOnCounterKey;
function _get_$cachedSerializer__te6jhj_490($this) {
  return $this.p6a_1.k3();
}
function BroodswellUpgrade$_anonymous__sfkipk() {
  var tmp = BroodswellUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BroodswellUpgrade', tmp, tmp$ret$0);
}
var BroodswellUpgrade_instance;
function BroodswellUpgrade_getInstance() {
  if (BroodswellUpgrade_instance === VOID)
    new BroodswellUpgrade();
  return BroodswellUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_491($this) {
  return $this.q6a_1.k3();
}
function RuptureSeedsUpgrade$_anonymous__d62t3w() {
  var tmp = RuptureSeedsUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('RuptureSeedsUpgrade', tmp, tmp$ret$0);
}
var RuptureSeedsUpgrade_instance;
function RuptureSeedsUpgrade_getInstance() {
  if (RuptureSeedsUpgrade_instance === VOID)
    new RuptureSeedsUpgrade();
  return RuptureSeedsUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_492($this) {
  return $this.r6a_1.k3();
}
function InfestUrgullUpgrade$_anonymous__elehdh() {
  var tmp = InfestUrgullUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('InfestUrgullUpgrade', tmp, tmp$ret$0);
}
var InfestUrgullUpgrade_instance;
function InfestUrgullUpgrade_getInstance() {
  if (InfestUrgullUpgrade_instance === VOID)
    new InfestUrgullUpgrade();
  return InfestUrgullUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_493($this) {
  return $this.s6a_1.k3();
}
function LairUpgrade$_anonymous__j0za61() {
  var tmp = LairUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LairUpgrade', tmp, tmp$ret$0);
}
var LairUpgrade_instance;
function LairUpgrade_getInstance() {
  if (LairUpgrade_instance === VOID)
    new LairUpgrade();
  return LairUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_494($this) {
  return $this.t6a_1.k3();
}
function Urgull$_anonymous__g3tjyk() {
  var tmp = Urgull_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Urgull', tmp, tmp$ret$0);
}
var Urgull_instance;
function Urgull_getInstance() {
  if (Urgull_instance === VOID)
    new Urgull();
  return Urgull_instance;
}
function _get_$cachedSerializer__te6jhj_495($this) {
  return $this.u6a_1.k3();
}
function UrgullHatchDamageSource$_anonymous__ax9vu0() {
  var tmp = UrgullHatchDamageSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UrgullHatchDamageSource', tmp, tmp$ret$0);
}
var UrgullHatchDamageSource_instance;
function UrgullHatchDamageSource_getInstance() {
  if (UrgullHatchDamageSource_instance === VOID)
    new UrgullHatchDamageSource();
  return UrgullHatchDamageSource_instance;
}
function _get_$cachedSerializer__te6jhj_496($this) {
  return $this.v6a_1.k3();
}
function UrgullMoltRewardEffectSource$_anonymous__w8a1q1() {
  var tmp = UrgullMoltRewardEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UrgullMoltRewardEffectSource', tmp, tmp$ret$0);
}
var UrgullMoltRewardEffectSource_instance;
function UrgullMoltRewardEffectSource_getInstance() {
  if (UrgullMoltRewardEffectSource_instance === VOID)
    new UrgullMoltRewardEffectSource();
  return UrgullMoltRewardEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_497($this) {
  return $this.w6a_1.k3();
}
function PlaceHatchlingWithInfestQuestion$_anonymous__ktt4wn() {
  var tmp = PlaceHatchlingWithInfestQuestion_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp, tmp$ret$0);
}
var PlaceHatchlingWithInfestQuestion_instance;
function PlaceHatchlingWithInfestQuestion_getInstance() {
  if (PlaceHatchlingWithInfestQuestion_instance === VOID)
    new PlaceHatchlingWithInfestQuestion();
  return PlaceHatchlingWithInfestQuestion_instance;
}
var Companion_instance_490;
function Companion_getInstance_491() {
  return Companion_instance_490;
}
var $serializer_instance_413;
function $serializer_getInstance_413() {
  if ($serializer_instance_413 === VOID)
    new $serializer_417();
  return $serializer_instance_413;
}
function _get_$cachedSerializer__te6jhj_498($this) {
  return $this.b6b_1.k3();
}
function LocationForLivingWebQuestionContext$_anonymous__qtdgo5() {
  var tmp = LocationForLivingWebQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('LocationForLivingWebQuestionContext', tmp, tmp$ret$0);
}
var LocationForLivingWebQuestionContext_instance;
function LocationForLivingWebQuestionContext_getInstance() {
  if (LocationForLivingWebQuestionContext_instance === VOID)
    new LocationForLivingWebQuestionContext();
  return LocationForLivingWebQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_499($this) {
  return $this.c6b_1.k3();
}
function EggToHatchQuestionContext$_anonymous__k4emj2() {
  var tmp = EggToHatchQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EggToHatchQuestionContext', tmp, tmp$ret$0);
}
var EggToHatchQuestionContext_instance;
function EggToHatchQuestionContext_getInstance() {
  if (EggToHatchQuestionContext_instance === VOID)
    new EggToHatchQuestionContext();
  return EggToHatchQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_500($this) {
  return $this.d6b_1.k3();
}
function EggToReturnToMoltQuestionContext$_anonymous__ncfqv1() {
  var tmp = EggToReturnToMoltQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EggToReturnToMoltQuestionContext', tmp, tmp$ret$0);
}
var EggToReturnToMoltQuestionContext_instance;
function EggToReturnToMoltQuestionContext_getInstance() {
  if (EggToReturnToMoltQuestionContext_instance === VOID)
    new EggToReturnToMoltQuestionContext();
  return EggToReturnToMoltQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_501($this) {
  return $this.e6b_1.k3();
}
function HatchlingToReplaceQuestionContext$_anonymous__421xrj() {
  var tmp = HatchlingToReplaceQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HatchlingToReplaceQuestionContext', tmp, tmp$ret$0);
}
var HatchlingToReplaceQuestionContext_instance;
function HatchlingToReplaceQuestionContext_getInstance() {
  if (HatchlingToReplaceQuestionContext_instance === VOID)
    new HatchlingToReplaceQuestionContext();
  return HatchlingToReplaceQuestionContext_instance;
}
function _get_$cachedSerializer__te6jhj_502($this) {
  return $this.f6b_1.k3();
}
function UrgullMoltEggsToReturnQuestionContext$_anonymous__h74cho() {
  var tmp = UrgullMoltEggsToReturnQuestionContext_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('UrgullMoltEggsToReturnQuestionContext', tmp, tmp$ret$0);
}
var UrgullMoltEggsToReturnQuestionContext_instance;
function UrgullMoltEggsToReturnQuestionContext_getInstance() {
  if (UrgullMoltEggsToReturnQuestionContext_instance === VOID)
    new UrgullMoltEggsToReturnQuestionContext();
  return UrgullMoltEggsToReturnQuestionContext_instance;
}
function BroodswellStatement$Companion$$childSerializers$_anonymous__wyg2a0() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_491;
function Companion_getInstance_492() {
  if (Companion_instance_491 === VOID)
    new Companion_491();
  return Companion_instance_491;
}
var $serializer_instance_414;
function $serializer_getInstance_414() {
  if ($serializer_instance_414 === VOID)
    new $serializer_418();
  return $serializer_instance_414;
}
function HatchEggStatement$Companion$$childSerializers$_anonymous__tc8u1s() {
  var tmp = EggType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return $serializer_364.y2o(ObjectSerializer.l1c('EggType', tmp, tmp$ret$0));
}
var Companion_instance_492;
function Companion_getInstance_493() {
  if (Companion_instance_492 === VOID)
    new Companion_492();
  return Companion_instance_492;
}
var $serializer_instance_415;
function $serializer_getInstance_415() {
  if ($serializer_instance_415 === VOID)
    new $serializer_419();
  return $serializer_instance_415;
}
function OvipunctureStatement$Companion$$childSerializers$_anonymous__cgc251() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_493;
function Companion_getInstance_494() {
  if (Companion_instance_493 === VOID)
    new Companion_493();
  return Companion_instance_493;
}
var $serializer_instance_416;
function $serializer_getInstance_416() {
  if ($serializer_instance_416 === VOID)
    new $serializer_420();
  return $serializer_instance_416;
}
var Companion_instance_494;
function Companion_getInstance_495() {
  return Companion_instance_494;
}
var $serializer_instance_417;
function $serializer_getInstance_417() {
  if ($serializer_instance_417 === VOID)
    new $serializer_421();
  return $serializer_instance_417;
}
function PlaceLivingWebNearbyStatement$Companion$$childSerializers$_anonymous__qp4w72() {
  return $serializer_364.y2o(Companion_instance_420.a2g());
}
var Companion_instance_495;
function Companion_getInstance_496() {
  if (Companion_instance_495 === VOID)
    new Companion_495();
  return Companion_instance_495;
}
var $serializer_instance_418;
function $serializer_getInstance_418() {
  if ($serializer_instance_418 === VOID)
    new $serializer_422();
  return $serializer_instance_418;
}
function PlaceUrgullEggOnOwnLocationStatement$Companion$$childSerializers$_anonymous__qsarpg() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_496;
function Companion_getInstance_497() {
  if (Companion_instance_496 === VOID)
    new Companion_496();
  return Companion_instance_496;
}
var $serializer_instance_419;
function $serializer_getInstance_419() {
  if ($serializer_instance_419 === VOID)
    new $serializer_423();
  return $serializer_instance_419;
}
function _get_$cachedSerializer__te6jhj_503($this) {
  return $this.l6c_1.k3();
}
function EggType$_anonymous__ggisso() {
  var tmp = EggType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EggType', tmp, tmp$ret$0);
}
var EggType_instance;
function EggType_getInstance() {
  if (EggType_instance === VOID)
    new EggType();
  return EggType_instance;
}
function _get_$cachedSerializer__te6jhj_504($this) {
  return $this.n6c_1.k3();
}
function HatchlingType$_anonymous__nakqyv() {
  var tmp = HatchlingType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HatchlingType', tmp, tmp$ret$0);
}
var HatchlingType_instance;
function HatchlingType_getInstance() {
  if (HatchlingType_instance === VOID)
    new HatchlingType();
  return HatchlingType_instance;
}
var Companion_instance_497;
function Companion_getInstance_498() {
  return Companion_instance_497;
}
var $serializer_instance_420;
function $serializer_getInstance_420() {
  if ($serializer_instance_420 === VOID)
    new $serializer_424();
  return $serializer_instance_420;
}
function _get_$cachedSerializer__te6jhj_505($this) {
  return $this.u6c_1.k3();
}
function NestCard$_anonymous__i4tdip() {
  var tmp = NestCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NestCard', tmp, tmp$ret$0);
}
var NestCard_instance;
function NestCard_getInstance() {
  if (NestCard_instance === VOID)
    new NestCard();
  return NestCard_instance;
}
function _get_$cachedSerializer__te6jhj_506($this) {
  return $this.w6c_1.k3();
}
function OverloadedNestCard$_anonymous__sjhkuu() {
  var tmp = OverloadedNestCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OverloadedNestCard', tmp, tmp$ret$0);
}
var OverloadedNestCard_instance;
function OverloadedNestCard_getInstance() {
  if (OverloadedNestCard_instance === VOID)
    new OverloadedNestCard();
  return OverloadedNestCard_instance;
}
function _get_$cachedSerializer__te6jhj_507($this) {
  return $this.y6c_1.k3();
}
function OvipunctureCard$_anonymous__t055zr() {
  var tmp = OvipunctureCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OvipunctureCard', tmp, tmp$ret$0);
}
var OvipunctureCard_instance;
function OvipunctureCard_getInstance() {
  if (OvipunctureCard_instance === VOID)
    new OvipunctureCard();
  return OvipunctureCard_instance;
}
function _get_$cachedSerializer__te6jhj_508($this) {
  return $this.a6d_1.k3();
}
function SilkCard$_anonymous__fh71hu() {
  var tmp = SilkCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SilkCard', tmp, tmp$ret$0);
}
var SilkCard_instance;
function SilkCard_getInstance() {
  if (SilkCard_instance === VOID)
    new SilkCard();
  return SilkCard_instance;
}
function _get_$cachedSerializer__te6jhj_509($this) {
  return $this.c6d_1.k3();
}
function SummonEggCard$_anonymous__vqyp37() {
  var tmp = SummonEggCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonEggCard', tmp, tmp$ret$0);
}
var SummonEggCard_instance;
function SummonEggCard_getInstance() {
  if (SummonEggCard_instance === VOID)
    new SummonEggCard();
  return SummonEggCard_instance;
}
function get_urgullBeast($context_GameState_t6qee5) {
  _init_properties_Urgull_kt__jduhnv();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Urgull) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function get_urgullHatchlingsOnMap($context_GameState_t6qee5) {
  _init_properties_Urgull_kt__jduhnv();
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_allObjectOnBoard($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof HatchlingType) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (get_isAlive($context_GameState_t6qee5, element_0)) {
      destination_0.d2(element_0);
    }
  }
  return toSet(destination_0);
}
function get_urgullCanPlaceEggs($context_GameState_t6qee5) {
  _init_properties_Urgull_kt__jduhnv();
  return get_remainMoltEggsOnCounter($context_GameState_t6qee5, get_urgullBeast($context_GameState_t6qee5)) > 0;
}
function set_remainMoltEggsOnCounterImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Urgull_kt__jduhnv();
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(0 <= value ? value <= 7 : false)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException.h2(toString(message));
  }
  setImplProperty(gsiCtx, _this__u8e3s4, get_remainMoltEggsOnCounterKey(), new IntWrapper(value));
}
function get_remainMoltEggsOnCounterImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Urgull_kt__jduhnv();
  return getRemainMoltEggsOnCounterImpl(_this__u8e3s4, gsiCtx);
}
function get_remainMoltEggsOnCounter(gsCtx, _this__u8e3s4) {
  _init_properties_Urgull_kt__jduhnv();
  return getRemainMoltEggsOnCounterImpl(_this__u8e3s4, gsCtx);
}
function getRemainMoltEggsOnCounterImpl(_this__u8e3s4, gameState) {
  _init_properties_Urgull_kt__jduhnv();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_remainMoltEggsOnCounterKey()).t3p_1;
}
var properties_initialized_Urgull_kt_r4axyl;
function _init_properties_Urgull_kt__jduhnv() {
  if (!properties_initialized_Urgull_kt_r4axyl) {
    properties_initialized_Urgull_kt_r4axyl = true;
    remainMoltEggsOnCounterKey = _GeneralMapKey___init__impl__zdmbea('remainMoltEggsOnCounter');
  }
}
function get_drainedSoulsKey() {
  _init_properties_Vacker_kt__p46na8();
  return drainedSoulsKey;
}
var drainedSoulsKey;
function _get_$cachedSerializer__te6jhj_510($this) {
  return $this.d6d_1.k3();
}
function MirrorBeastUpgrade$_anonymous__cc50or() {
  var tmp = MirrorBeastUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MirrorBeastUpgrade', tmp, tmp$ret$0);
}
var MirrorBeastUpgrade_instance;
function MirrorBeastUpgrade_getInstance() {
  if (MirrorBeastUpgrade_instance === VOID)
    new MirrorBeastUpgrade();
  return MirrorBeastUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_511($this) {
  return $this.e6d_1.k3();
}
function GoldenBeakUpgrade$_anonymous__tyl3nz() {
  var tmp = GoldenBeakUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('GoldenBeakUpgrade', tmp, tmp$ret$0);
}
var GoldenBeakUpgrade_instance;
function GoldenBeakUpgrade_getInstance() {
  if (GoldenBeakUpgrade_instance === VOID)
    new GoldenBeakUpgrade();
  return GoldenBeakUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_512($this) {
  return $this.f6d_1.k3();
}
function SoulHarvestVackerUpgrade$_anonymous__cnkv3l() {
  var tmp = SoulHarvestVackerUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SoulHarvestVackerUpgrade', tmp, tmp$ret$0);
}
var SoulHarvestVackerUpgrade_instance;
function SoulHarvestVackerUpgrade_getInstance() {
  if (SoulHarvestVackerUpgrade_instance === VOID)
    new SoulHarvestVackerUpgrade();
  return SoulHarvestVackerUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_513($this) {
  return $this.g6d_1.k3();
}
function SwiftKillUpgrade$_anonymous__l3mpvw() {
  var tmp = SwiftKillUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SwiftKillUpgrade', tmp, tmp$ret$0);
}
var SwiftKillUpgrade_instance;
function SwiftKillUpgrade_getInstance() {
  if (SwiftKillUpgrade_instance === VOID)
    new SwiftKillUpgrade();
  return SwiftKillUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_514($this) {
  return $this.h6d_1.k3();
}
function EntrancingUpgrade$_anonymous__nbstta() {
  var tmp = EntrancingUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EntrancingUpgrade', tmp, tmp$ret$0);
}
var EntrancingUpgrade_instance;
function EntrancingUpgrade_getInstance() {
  if (EntrancingUpgrade_instance === VOID)
    new EntrancingUpgrade();
  return EntrancingUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_515($this) {
  return $this.i6d_1.k3();
}
function ReveranceUpgrade$_anonymous__upc5ju() {
  var tmp = ReveranceUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ReveranceUpgrade', tmp, tmp$ret$0);
}
var ReveranceUpgrade_instance;
function ReveranceUpgrade_getInstance() {
  if (ReveranceUpgrade_instance === VOID)
    new ReveranceUpgrade();
  return ReveranceUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_516($this) {
  return $this.k6d_1.k3();
}
function Vacker$_anonymous__uyr9nb() {
  var tmp = Vacker_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Vacker', tmp, tmp$ret$0);
}
var Vacker_instance;
function Vacker_getInstance() {
  if (Vacker_instance === VOID)
    new Vacker();
  return Vacker_instance;
}
function _get_$cachedSerializer__te6jhj_517($this) {
  return $this.l6d_1.k3();
}
function AllureSoulChangedDamageSource$_anonymous__1m1vyl() {
  var tmp = AllureSoulChangedDamageSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AllureSoulChangedDamageSource', tmp, tmp$ret$0);
}
var AllureSoulChangedDamageSource_instance;
function AllureSoulChangedDamageSource_getInstance() {
  if (AllureSoulChangedDamageSource_instance === VOID)
    new AllureSoulChangedDamageSource();
  return AllureSoulChangedDamageSource_instance;
}
function _get_$cachedSerializer__te6jhj_518($this) {
  return $this.m6d_1.k3();
}
function AllureKillEffectSource$_anonymous__guz8g6() {
  var tmp = AllureKillEffectSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AllureKillEffectSource', tmp, tmp$ret$0);
}
var AllureKillEffectSource_instance;
function AllureKillEffectSource_getInstance() {
  if (AllureKillEffectSource_instance === VOID)
    new AllureKillEffectSource();
  return AllureKillEffectSource_instance;
}
function _get_$cachedSerializer__te6jhj_519($this) {
  return $this.n6d_1.k3();
}
function SoulsChangeSource$_anonymous__6yqus4() {
  var tmp = SoulsChangeSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SoulsChangeSource', tmp, tmp$ret$0);
}
var SoulsChangeSource_instance;
function SoulsChangeSource_getInstance() {
  if (SoulsChangeSource_instance === VOID)
    new SoulsChangeSource();
  return SoulsChangeSource_instance;
}
function AllureKillSoulBonusStatement$Companion$$childSerializers$_anonymous__kmu4zi() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_498;
function Companion_getInstance_499() {
  if (Companion_instance_498 === VOID)
    new Companion_498();
  return Companion_instance_498;
}
var $serializer_instance_421;
function $serializer_getInstance_421() {
  if ($serializer_instance_421 === VOID)
    new $serializer_425();
  return $serializer_instance_421;
}
function AllureStatement$Companion$$childSerializers$_anonymous__49opsu() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_499;
function Companion_getInstance_500() {
  if (Companion_instance_499 === VOID)
    new Companion_499();
  return Companion_instance_499;
}
var $serializer_instance_422;
function $serializer_getInstance_422() {
  if ($serializer_instance_422 === VOID)
    new $serializer_426();
  return $serializer_instance_422;
}
function BeholdStatement$Companion$$childSerializers$_anonymous__lcny3h() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_500;
function Companion_getInstance_501() {
  if (Companion_instance_500 === VOID)
    new Companion_500();
  return Companion_instance_500;
}
var $serializer_instance_423;
function $serializer_getInstance_423() {
  if ($serializer_instance_423 === VOID)
    new $serializer_427();
  return $serializer_instance_423;
}
function EludeStatement$Companion$$childSerializers$_anonymous__7fxgve() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_501;
function Companion_getInstance_502() {
  if (Companion_instance_501 === VOID)
    new Companion_501();
  return Companion_instance_501;
}
var $serializer_instance_424;
function $serializer_getInstance_424() {
  if ($serializer_instance_424 === VOID)
    new $serializer_428();
  return $serializer_instance_424;
}
function SoulStealStatement$Companion$$childSerializers$_anonymous__o0jtkn() {
  return $serializer_364.y2o(Companion_instance_424.a2g());
}
var Companion_instance_502;
function Companion_getInstance_503() {
  if (Companion_instance_502 === VOID)
    new Companion_502();
  return Companion_instance_502;
}
var $serializer_instance_425;
function $serializer_getInstance_425() {
  if ($serializer_instance_425 === VOID)
    new $serializer_429();
  return $serializer_instance_425;
}
function SummonAdmirerStatement$Companion$$childSerializers$_anonymous__1i6psq() {
  return $serializer_364.y2o(Companion_instance_92.a2g());
}
var Companion_instance_503;
function Companion_getInstance_504() {
  if (Companion_instance_503 === VOID)
    new Companion_503();
  return Companion_instance_503;
}
var $serializer_instance_426;
function $serializer_getInstance_426() {
  if ($serializer_instance_426 === VOID)
    new $serializer_430();
  return $serializer_instance_426;
}
var Companion_instance_504;
function Companion_getInstance_505() {
  return Companion_instance_504;
}
var $serializer_instance_427;
function $serializer_getInstance_427() {
  if ($serializer_instance_427 === VOID)
    new $serializer_431();
  return $serializer_instance_427;
}
function _get_$cachedSerializer__te6jhj_520($this) {
  return $this.b6f_1.k3();
}
function AdmirerType$_anonymous__4xgarn() {
  var tmp = AdmirerType_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AdmirerType', tmp, tmp$ret$0);
}
var AdmirerType_instance;
function AdmirerType_getInstance() {
  if (AdmirerType_instance === VOID)
    new AdmirerType();
  return AdmirerType_instance;
}
function _get_$cachedSerializer__te6jhj_521($this) {
  return $this.d6f_1.k3();
}
function AllureCard$_anonymous__gcn4ao() {
  var tmp = AllureCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('AllureCard', tmp, tmp$ret$0);
}
var AllureCard_instance;
function AllureCard_getInstance() {
  if (AllureCard_instance === VOID)
    new AllureCard();
  return AllureCard_instance;
}
function _get_$cachedSerializer__te6jhj_522($this) {
  return $this.e6f_1.k3();
}
function BeholdCard$_anonymous__3iikm3() {
  var tmp = BeholdCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BeholdCard', tmp, tmp$ret$0);
}
var BeholdCard_instance;
function BeholdCard_getInstance() {
  if (BeholdCard_instance === VOID)
    new BeholdCard();
  return BeholdCard_instance;
}
function _get_$cachedSerializer__te6jhj_523($this) {
  return $this.g6f_1.k3();
}
function EludeCard$_anonymous__srscso() {
  var tmp = EludeCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('EludeCard', tmp, tmp$ret$0);
}
var EludeCard_instance;
function EludeCard_getInstance() {
  if (EludeCard_instance === VOID)
    new EludeCard();
  return EludeCard_instance;
}
function _get_$cachedSerializer__te6jhj_524($this) {
  return $this.h6f_1.k3();
}
function SummonAdmirerCard$_anonymous__i302iw() {
  var tmp = SummonAdmirerCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SummonAdmirerCard', tmp, tmp$ret$0);
}
var SummonAdmirerCard_instance;
function SummonAdmirerCard_getInstance() {
  if (SummonAdmirerCard_instance === VOID)
    new SummonAdmirerCard();
  return SummonAdmirerCard_instance;
}
function get_activeSouls($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_Vacker_kt__p46na8();
  return (8 - get_drainedSouls($context_GameState_t6qee5, _this__u8e3s4) | 0) - sum(get_foundTrails($context_GameState_t6qee5, _this__u8e3s4).y4()) | 0;
}
function get_vackerBeast($context_GameState_t6qee5) {
  _init_properties_Vacker_kt__p46na8();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Vacker) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function set_drainedSoulsImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Vacker_kt__p46na8();
  setImplProperty(gsiCtx, _this__u8e3s4, get_drainedSoulsKey(), new IntWrapper(value));
}
function get_drainedSoulsImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Vacker_kt__p46na8();
  return getDrainedSoulsImpl(_this__u8e3s4, gsiCtx);
}
function get_drainedSouls(gsCtx, _this__u8e3s4) {
  _init_properties_Vacker_kt__p46na8();
  return getDrainedSoulsImpl(_this__u8e3s4, gsCtx);
}
function getDrainedSoulsImpl(_this__u8e3s4, gameState) {
  _init_properties_Vacker_kt__p46na8();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_drainedSoulsKey()).t3p_1;
}
var properties_initialized_Vacker_kt_sq7dxa;
function _init_properties_Vacker_kt__p46na8() {
  if (!properties_initialized_Vacker_kt_sq7dxa) {
    properties_initialized_Vacker_kt_sq7dxa = true;
    drainedSoulsKey = _GeneralMapKey___init__impl__zdmbea('drainedSouls');
  }
}
function get_valdiBloodKey() {
  _init_properties_Valdi_kt__b5952s();
  return valdiBloodKey;
}
var valdiBloodKey;
function _get_$cachedSerializer__te6jhj_525($this) {
  return $this.k6f_1.k3();
}
function Valdi$_anonymous__ra97wv() {
  var tmp = Valdi_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Valdi', tmp, tmp$ret$0);
}
var Valdi_instance;
function Valdi_getInstance() {
  if (Valdi_instance === VOID)
    new Valdi();
  return Valdi_instance;
}
function _get_$cachedSerializer__te6jhj_526($this) {
  return $this.l6f_1.k3();
}
function InfusionUpgrade$_anonymous__7azrj8() {
  var tmp = InfusionUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('InfusionUpgrade', tmp, tmp$ret$0);
}
var InfusionUpgrade_instance;
function InfusionUpgrade_getInstance() {
  if (InfusionUpgrade_instance === VOID)
    new InfusionUpgrade();
  return InfusionUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_527($this) {
  return $this.m6f_1.k3();
}
function BloodCraftUpgrade$_anonymous__7aqxi9() {
  var tmp = BloodCraftUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BloodCraftUpgrade', tmp, tmp$ret$0);
}
var BloodCraftUpgrade_instance;
function BloodCraftUpgrade_getInstance() {
  if (BloodCraftUpgrade_instance === VOID)
    new BloodCraftUpgrade();
  return BloodCraftUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_528($this) {
  return $this.n6f_1.k3();
}
function DissectionUpgrade$_anonymous__9q9tke() {
  var tmp = DissectionUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('DissectionUpgrade', tmp, tmp$ret$0);
}
var DissectionUpgrade_instance;
function DissectionUpgrade_getInstance() {
  if (DissectionUpgrade_instance === VOID)
    new DissectionUpgrade();
  return DissectionUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_529($this) {
  return $this.o6f_1.k3();
}
function ExtractUpgrade$_anonymous__69uqd8() {
  var tmp = ExtractUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ExtractUpgrade', tmp, tmp$ret$0);
}
var ExtractUpgrade_instance;
function ExtractUpgrade_getInstance() {
  if (ExtractUpgrade_instance === VOID)
    new ExtractUpgrade();
  return ExtractUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_530($this) {
  return $this.p6f_1.k3();
}
function ValdiBloodKillSource$_anonymous__bugljq() {
  var tmp = ValdiBloodKillSource_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ValdiBloodKillSource', tmp, tmp$ret$0);
}
var ValdiBloodKillSource_instance;
function ValdiBloodKillSource_getInstance() {
  if (ValdiBloodKillSource_instance === VOID)
    new ValdiBloodKillSource();
  return ValdiBloodKillSource_instance;
}
var Companion_instance_505;
function Companion_getInstance_506() {
  return Companion_instance_505;
}
var $serializer_instance_428;
function $serializer_getInstance_428() {
  if ($serializer_instance_428 === VOID)
    new $serializer_432();
  return $serializer_instance_428;
}
function BloodHuntStatement$Companion$$childSerializers$_anonymous__qjo6i0() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_506;
function Companion_getInstance_507() {
  if (Companion_instance_506 === VOID)
    new Companion_506();
  return Companion_instance_506;
}
var $serializer_instance_429;
function $serializer_getInstance_429() {
  if ($serializer_instance_429 === VOID)
    new $serializer_433();
  return $serializer_instance_429;
}
function BloodTrackStatement$Companion$$childSerializers$_anonymous__jrpeac() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_507;
function Companion_getInstance_508() {
  if (Companion_instance_507 === VOID)
    new Companion_507();
  return Companion_instance_507;
}
var $serializer_instance_430;
function $serializer_getInstance_430() {
  if ($serializer_instance_430 === VOID)
    new $serializer_434();
  return $serializer_instance_430;
}
function _get_$cachedSerializer__te6jhj_531($this) {
  return $this.e6g_1.k3();
}
function ExtractStatement$_anonymous__3evkdl() {
  var tmp = ExtractStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('ExtractStatement', tmp, tmp$ret$0);
}
var ExtractStatement_instance;
function ExtractStatement_getInstance() {
  if (ExtractStatement_instance === VOID)
    new ExtractStatement();
  return ExtractStatement_instance;
}
function _get_$cachedSerializer__te6jhj_532($this) {
  return $this.f6g_1.k3();
}
function InfusionUpgradeStatement$_anonymous__x7haqj() {
  var tmp = InfusionUpgradeStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('InfusionUpgradeStatement', tmp, tmp$ret$0);
}
var InfusionUpgradeStatement_instance;
function InfusionUpgradeStatement_getInstance() {
  if (InfusionUpgradeStatement_instance === VOID)
    new InfusionUpgradeStatement();
  return InfusionUpgradeStatement_instance;
}
var Companion_instance_508;
function Companion_getInstance_509() {
  return Companion_instance_508;
}
var $serializer_instance_431;
function $serializer_getInstance_431() {
  if ($serializer_instance_431 === VOID)
    new $serializer_435();
  return $serializer_instance_431;
}
function _get_$cachedSerializer__te6jhj_533($this) {
  return $this.m6g_1.k3();
}
function BloodHuntCard$_anonymous__ohw6ka() {
  var tmp = BloodHuntCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BloodHuntCard', tmp, tmp$ret$0);
}
var BloodHuntCard_instance;
function BloodHuntCard_getInstance() {
  if (BloodHuntCard_instance === VOID)
    new BloodHuntCard();
  return BloodHuntCard_instance;
}
function _get_$cachedSerializer__te6jhj_534($this) {
  return $this.p6g_1.k3();
}
function IncisionCard$_anonymous__606z3b() {
  var tmp = IncisionCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('IncisionCard', tmp, tmp$ret$0);
}
var IncisionCard_instance;
function IncisionCard_getInstance() {
  if (IncisionCard_instance === VOID)
    new IncisionCard();
  return IncisionCard_instance;
}
function _get_$cachedSerializer__te6jhj_535($this) {
  return $this.s6g_1.k3();
}
function BloodTrackCard$_anonymous__a5tjxy() {
  var tmp = BloodTrackCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('BloodTrackCard', tmp, tmp$ret$0);
}
var BloodTrackCard_instance;
function BloodTrackCard_getInstance() {
  if (BloodTrackCard_instance === VOID)
    new BloodTrackCard();
  return BloodTrackCard_instance;
}
function get_valdiHunter($context_GameState_t6qee5) {
  _init_properties_Valdi_kt__b5952s();
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Valdi) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function set_valdiBloodImpl(gsiCtx, _this__u8e3s4, value) {
  _init_properties_Valdi_kt__b5952s();
  setImplProperty(gsiCtx, _this__u8e3s4, get_valdiBloodKey(), new IntWrapper(value));
}
function get_valdiBloodImpl(gsiCtx, _this__u8e3s4) {
  _init_properties_Valdi_kt__b5952s();
  return getValdiBloodImpl(_this__u8e3s4, gsiCtx);
}
function get_valdiBlood(gsCtx, _this__u8e3s4) {
  _init_properties_Valdi_kt__b5952s();
  return getValdiBloodImpl(_this__u8e3s4, gsCtx);
}
function SetValdiBloodEvent$Companion$$childSerializers$_anonymous__8g4m3e() {
  return Companion_instance_256.a2g();
}
var Companion_instance_509;
function Companion_getInstance_510() {
  if (Companion_instance_509 === VOID)
    new Companion_509();
  return Companion_instance_509;
}
var $serializer_instance_432;
function $serializer_getInstance_432() {
  if ($serializer_instance_432 === VOID)
    new $serializer_436();
  return $serializer_instance_432;
}
function _get_$cachedSerializer__te6jhj_536($this) {
  return $this.a6h_1.k3();
}
function OnlyAnimalsAttackModifier$_anonymous__ehrg6r() {
  var tmp = OnlyAnimalsAttackModifier_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('OnlyAnimalsAttackModifier', tmp, tmp$ret$0);
}
var OnlyAnimalsAttackModifier_instance;
function OnlyAnimalsAttackModifier_getInstance() {
  if (OnlyAnimalsAttackModifier_instance === VOID)
    new OnlyAnimalsAttackModifier();
  return OnlyAnimalsAttackModifier_instance;
}
function getValdiBloodImpl(_this__u8e3s4, gameState) {
  _init_properties_Valdi_kt__b5952s();
  // Inline function 'kotlin.with' call
  return get_implProperty(gameState, _this__u8e3s4, get_valdiBloodKey()).t3p_1;
}
var properties_initialized_Valdi_kt_1siel2;
function _init_properties_Valdi_kt__b5952s() {
  if (!properties_initialized_Valdi_kt_1siel2) {
    properties_initialized_Valdi_kt_1siel2 = true;
    valdiBloodKey = _GeneralMapKey___init__impl__zdmbea('valdiBlood');
  }
}
function _get_$cachedSerializer__te6jhj_537($this) {
  return $this.c6h_1.k3();
}
function Varja$_anonymous__ngveyv() {
  var tmp = Varja_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Varja', tmp, tmp$ret$0);
}
var Varja_instance;
function Varja_getInstance() {
  if (Varja_instance === VOID)
    new Varja();
  return Varja_instance;
}
function _get_$cachedSerializer__te6jhj_538($this) {
  return $this.d6h_1.k3();
}
function HornOfValhUpgrade$_anonymous__k8m138() {
  var tmp = HornOfValhUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HornOfValhUpgrade', tmp, tmp$ret$0);
}
var HornOfValhUpgrade_instance;
function HornOfValhUpgrade_getInstance() {
  if (HornOfValhUpgrade_instance === VOID)
    new HornOfValhUpgrade();
  return HornOfValhUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_539($this) {
  return $this.e6h_1.k3();
}
function HuntersBaneUpgrade$_anonymous__pum4w4() {
  var tmp = HuntersBaneUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HuntersBaneUpgrade', tmp, tmp$ret$0);
}
var HuntersBaneUpgrade_instance;
function HuntersBaneUpgrade_getInstance() {
  if (HuntersBaneUpgrade_instance === VOID)
    new HuntersBaneUpgrade();
  return HuntersBaneUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_540($this) {
  return $this.f6h_1.k3();
}
function HeroicSpeechUpgrade$_anonymous__26tbwv() {
  var tmp = HeroicSpeechUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HeroicSpeechUpgrade', tmp, tmp$ret$0);
}
var HeroicSpeechUpgrade_instance;
function HeroicSpeechUpgrade_getInstance() {
  if (HeroicSpeechUpgrade_instance === VOID)
    new HeroicSpeechUpgrade();
  return HeroicSpeechUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_541($this) {
  return $this.g6h_1.k3();
}
function TacticalManouverUpgrade$_anonymous__c4vi2p() {
  var tmp = TacticalManouverUpgrade_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('TacticalManouverUpgrade', tmp, tmp$ret$0);
}
var TacticalManouverUpgrade_instance;
function TacticalManouverUpgrade_getInstance() {
  if (TacticalManouverUpgrade_instance === VOID)
    new TacticalManouverUpgrade();
  return TacticalManouverUpgrade_instance;
}
function _get_$cachedSerializer__te6jhj_542($this) {
  return $this.i6h_1.k3();
}
function MoveAllSettlersAndHuntersByVarja$_anonymous__4bik7s() {
  var tmp = MoveAllSettlersAndHuntersByVarja_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('MoveAllSettlersAndHuntersByVarja', tmp, tmp$ret$0);
}
var MoveAllSettlersAndHuntersByVarja_instance;
function MoveAllSettlersAndHuntersByVarja_getInstance() {
  if (MoveAllSettlersAndHuntersByVarja_instance === VOID)
    new MoveAllSettlersAndHuntersByVarja();
  return MoveAllSettlersAndHuntersByVarja_instance;
}
function CommandCardStatement$Companion$$childSerializers$_anonymous__p1hn5i() {
  return $serializer_364.y2o(Companion_instance_380.a2g());
}
var Companion_instance_510;
function Companion_getInstance_511() {
  if (Companion_instance_510 === VOID)
    new Companion_510();
  return Companion_instance_510;
}
var $serializer_instance_433;
function $serializer_getInstance_433() {
  if ($serializer_instance_433 === VOID)
    new $serializer_437();
  return $serializer_instance_433;
}
function _get_$cachedSerializer__te6jhj_543($this) {
  return $this.o6h_1.k3();
}
function HeroicSpeechStatement$_anonymous__w0n1lu() {
  var tmp = HeroicSpeechStatement_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('HeroicSpeechStatement', tmp, tmp$ret$0);
}
var HeroicSpeechStatement_instance;
function HeroicSpeechStatement_getInstance() {
  if (HeroicSpeechStatement_instance === VOID)
    new HeroicSpeechStatement();
  return HeroicSpeechStatement_instance;
}
function _get_$cachedSerializer__te6jhj_544($this) {
  return $this.r6h_1.k3();
}
function CommandCard$_anonymous__mq8q5g() {
  var tmp = CommandCard_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('CommandCard', tmp, tmp$ret$0);
}
var CommandCard_instance;
function CommandCard_getInstance() {
  if (CommandCard_instance === VOID)
    new CommandCard();
  return CommandCard_instance;
}
function _get_$cachedSerializer__te6jhj_545($this) {
  return $this.s6h_1.k3();
}
function ChooseAndMoveByVarja$Companion$_anonymous__vces5j() {
  var tmp = getKClass(ChooseAndMoveByVarja);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(MoveAllSettlersAndHuntersByVarja)];
  var tmp_1 = MoveAllSettlersAndHuntersByVarja_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = [ObjectSerializer.l1c('MoveAllSettlersAndHuntersByVarja', tmp_1, tmp$ret$3)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$9 = [];
  return SealedClassSerializer.i10('ChooseAndMoveByVarja', tmp, tmp_0, tmp_2, tmp$ret$9);
}
var Companion_instance_511;
function Companion_getInstance_512() {
  if (Companion_instance_511 === VOID)
    new Companion_511();
  return Companion_instance_511;
}
function get_varjaHunter($context_GameState_t6qee5) {
  // Inline function 'steelart.beast.singletonCharacter' call
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (tmp instanceof Varja) {
        tmp$ret$7 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return single(destination);
}
function *applyGameStateRevertChanges_1($this, revertChanges, previousRevision, previousCheckCode, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = $this.t6h();
  var _iterator__ex2g4s = revertChanges.p1();
  while (_iterator__ex2g4s.q1()) {
    var revertChange = _iterator__ex2g4s.r1();
    apply($this$with, revertChange);
  }
  $this$with.g38_1 = previousRevision;
  if (!(previousCheckCode == null)) {
    var checkCode = calculateCheckCode($this$with);
    if (!checkCode.equals(previousCheckCode)) {
      yield* $this.u6h('Check code from server = ' + checkCode.toString() + ' is not equal to local ' + previousCheckCode.toString(), $completion);
    }
  }
  $this.v6h($this.t6h().y4l());
  return Unit_instance;
}
function CurrentAndOldStateHolder$applyGameStateChanges$lambda($event) {
  return ($this$withStateRuntime) => $event.o37($this$withStateRuntime);
}
function _get_$cachedSerializer__te6jhj_546($this) {
  return $this.o6i_1.k3();
}
function BeastClientFeature$Companion$_anonymous__5v4bgd() {
  return createSimpleEnumSerializer('steelart.beast.network.BeastClientFeature', values_11());
}
var BeastClientFeature_Onboarding_instance;
var BeastClientFeature_NetworkPlay_instance;
var BeastClientFeature_Sandbox_instance;
function values_11() {
  return [BeastClientFeature_Onboarding_getInstance(), BeastClientFeature_NetworkPlay_getInstance(), BeastClientFeature_Sandbox_getInstance()];
}
function get_entries_5() {
  if ($ENTRIES_5 == null)
    $ENTRIES_5 = enumEntries(values_11());
  return $ENTRIES_5;
}
var Companion_instance_512;
function Companion_getInstance_513() {
  BeastClientFeature_initEntries();
  if (Companion_instance_512 === VOID)
    new Companion_512();
  return Companion_instance_512;
}
var BeastClientFeature_entriesInitialized;
function BeastClientFeature_initEntries() {
  if (BeastClientFeature_entriesInitialized)
    return Unit_instance;
  BeastClientFeature_entriesInitialized = true;
  BeastClientFeature_Onboarding_instance = new BeastClientFeature('Onboarding', 0);
  BeastClientFeature_NetworkPlay_instance = new BeastClientFeature('NetworkPlay', 1);
  BeastClientFeature_Sandbox_instance = new BeastClientFeature('Sandbox', 2);
  Companion_getInstance_513();
}
var $ENTRIES_5;
function BeastAuthenticationCapabilities$Companion$$childSerializers$_anonymous__p1nmn1() {
  return new LinkedHashSetSerializer(createSimpleEnumSerializer('steelart.beast.BeastGameExpansions', values_4()));
}
var Companion_instance_513;
function Companion_getInstance_514() {
  if (Companion_instance_513 === VOID)
    new Companion_513();
  return Companion_instance_513;
}
var $serializer_instance_434;
function $serializer_getInstance_434() {
  if ($serializer_instance_434 === VOID)
    new $serializer_438();
  return $serializer_instance_434;
}
var Companion_instance_514;
function Companion_getInstance_515() {
  return Companion_instance_514;
}
var $serializer_instance_435;
function $serializer_getInstance_435() {
  if ($serializer_instance_435 === VOID)
    new $serializer_439();
  return $serializer_instance_435;
}
function _get_$cachedSerializer__te6jhj_547($this) {
  return $this.e6j_1.k3();
}
function BeastLoginResult$Failure$_anonymous__52qr2i() {
  var tmp = Failure_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Failure', tmp, tmp$ret$0);
}
var Failure_instance;
function Failure_getInstance() {
  if (Failure_instance === VOID)
    new Failure();
  return Failure_instance;
}
var Companion_instance_515;
function Companion_getInstance_516() {
  return Companion_instance_515;
}
var Companion_instance_516;
function Companion_getInstance_517() {
  return Companion_instance_516;
}
var $serializer_instance_436;
function $serializer_getInstance_436() {
  if ($serializer_instance_436 === VOID)
    new $serializer_440();
  return $serializer_instance_436;
}
function _get_$cachedSerializer__te6jhj_548($this) {
  return $this.j6j_1.k3();
}
function BeastSessionState$Unauthenticated$_anonymous__sb6uph() {
  var tmp = Unauthenticated_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Unauthenticated', tmp, tmp$ret$0);
}
var Unauthenticated_instance;
function Unauthenticated_getInstance() {
  if (Unauthenticated_instance === VOID)
    new Unauthenticated();
  return Unauthenticated_instance;
}
var Companion_instance_517;
function Companion_getInstance_518() {
  return Companion_instance_517;
}
function BeastClientConfiguration$Companion$$childSerializers$_anonymous__q7dzvm() {
  return new LinkedHashSetSerializer(Companion_getInstance_513().a2g());
}
function BeastClientConfiguration$Companion$$childSerializers$_anonymous__q7dzvm_0() {
  return new LinkedHashSetSerializer(createSimpleEnumSerializer('steelart.beast.BeastGameExpansions', values_4()));
}
var Companion_instance_518;
function Companion_getInstance_519() {
  if (Companion_instance_518 === VOID)
    new Companion_518();
  return Companion_instance_518;
}
var $serializer_instance_437;
function $serializer_getInstance_437() {
  if ($serializer_instance_437 === VOID)
    new $serializer_441();
  return $serializer_instance_437;
}
var Companion_instance_519;
function Companion_getInstance_520() {
  return Companion_instance_519;
}
var $serializer_instance_438;
function $serializer_getInstance_438() {
  if ($serializer_instance_438 === VOID)
    new $serializer_442();
  return $serializer_instance_438;
}
function BeastClientFeature_Onboarding_getInstance() {
  BeastClientFeature_initEntries();
  return BeastClientFeature_Onboarding_instance;
}
function BeastClientFeature_NetworkPlay_getInstance() {
  BeastClientFeature_initEntries();
  return BeastClientFeature_NetworkPlay_instance;
}
function BeastClientFeature_Sandbox_getInstance() {
  BeastClientFeature_initEntries();
  return BeastClientFeature_Sandbox_instance;
}
var Companion_instance_520;
function Companion_getInstance_521() {
  return Companion_instance_520;
}
var $serializer_instance_439;
function $serializer_getInstance_439() {
  if ($serializer_instance_439 === VOID)
    new $serializer_443();
  return $serializer_instance_439;
}
function get_onboardingReplayCode() {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  return onboardingReplayCode;
}
var onboardingReplayCode;
function get_quixoteTournamentGame3() {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  return quixoteTournamentGame3;
}
var quixoteTournamentGame3;
function get_quixoteTournamentGame4() {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  return quixoteTournamentGame4;
}
var quixoteTournamentGame4;
function get_quixoteTournamentGame9() {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  return quixoteTournamentGame9;
}
var quixoteTournamentGame9;
function get_quixoteTournamentGames() {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  return quixoteTournamentGames;
}
var quixoteTournamentGames;
function get_terminalInfoSourceCursor() {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  return terminalInfoSourceCursor;
}
var terminalInfoSourceCursor;
function get_incorrectServerStateInfoSourceCursor() {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  return incorrectServerStateInfoSourceCursor;
}
var incorrectServerStateInfoSourceCursor;
function get_canceledSessionInfoSourceCursor() {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  return canceledSessionInfoSourceCursor;
}
var canceledSessionInfoSourceCursor;
var Companion_instance_521;
function Companion_getInstance_522() {
  return Companion_instance_521;
}
var $serializer_instance_440;
function $serializer_getInstance_440() {
  if ($serializer_instance_440 === VOID)
    new $serializer_444();
  return $serializer_instance_440;
}
var Companion_instance_522;
function Companion_getInstance_523() {
  return Companion_instance_522;
}
var $serializer_instance_441;
function $serializer_getInstance_441() {
  if ($serializer_instance_441 === VOID)
    new $serializer_445();
  return $serializer_instance_441;
}
var ConnectionStatus_Connected_instance;
var ConnectionStatus_Disconnected_instance;
var ConnectionStatus_entriesInitialized;
function ConnectionStatus_initEntries() {
  if (ConnectionStatus_entriesInitialized)
    return Unit_instance;
  ConnectionStatus_entriesInitialized = true;
  ConnectionStatus_Connected_instance = new ConnectionStatus('Connected', 0);
  ConnectionStatus_Disconnected_instance = new ConnectionStatus('Disconnected', 1);
}
function ActiveGameSessions$Companion$$childSerializers$_anonymous__d8uq1h() {
  return new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_457());
}
var Companion_instance_523;
function Companion_getInstance_524() {
  if (Companion_instance_523 === VOID)
    new Companion_523();
  return Companion_instance_523;
}
var $serializer_instance_442;
function $serializer_getInstance_442() {
  if ($serializer_instance_442 === VOID)
    new $serializer_446();
  return $serializer_instance_442;
}
function LobbyList$Companion$$childSerializers$_anonymous__tx2q52() {
  return new ArrayListSerializer($serializer_getInstance_458());
}
var Companion_instance_524;
function Companion_getInstance_525() {
  if (Companion_instance_524 === VOID)
    new Companion_524();
  return Companion_instance_524;
}
var $serializer_instance_443;
function $serializer_getInstance_443() {
  if ($serializer_instance_443 === VOID)
    new $serializer_447();
  return $serializer_instance_443;
}
var Companion_instance_525;
function Companion_getInstance_526() {
  return Companion_instance_525;
}
var $serializer_instance_444;
function $serializer_getInstance_444() {
  if ($serializer_instance_444 === VOID)
    new $serializer_448();
  return $serializer_instance_444;
}
function ResumeDuelGameResult$Terminal$Companion$$childSerializers$_anonymous__9wvq82() {
  return createSimpleEnumSerializer('steelart.beast.network.GameStatus', values_13());
}
var Companion_instance_526;
function Companion_getInstance_527() {
  if (Companion_instance_526 === VOID)
    new Companion_526();
  return Companion_instance_526;
}
var $serializer_instance_445;
function $serializer_getInstance_445() {
  if ($serializer_instance_445 === VOID)
    new $serializer_449();
  return $serializer_instance_445;
}
function _get_$cachedSerializer__te6jhj_549($this) {
  return $this.x6m_1.k3();
}
function ResumeDuelGameResult$NotFound$_anonymous__52vl4o() {
  var tmp = NotFound_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NotFound', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_550($this) {
  return $this.y6m_1.k3();
}
function ResumeDuelGameResult$Forbidden$_anonymous__k4xeby() {
  var tmp = Forbidden_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Forbidden', tmp, tmp$ret$0);
}
var NotFound_instance;
function NotFound_getInstance() {
  if (NotFound_instance === VOID)
    new NotFound();
  return NotFound_instance;
}
var Forbidden_instance;
function Forbidden_getInstance() {
  if (Forbidden_instance === VOID)
    new Forbidden();
  return Forbidden_instance;
}
var Companion_instance_527;
function Companion_getInstance_528() {
  return Companion_instance_527;
}
function CompletedGame$Companion$$childSerializers$_anonymous__365cb1() {
  return createSimpleEnumSerializer('steelart.beast.network.GameStatus', values_13());
}
function CompletedGame$Companion$$childSerializers$_anonymous__365cb1_0() {
  return Companion_instance_214.a2g();
}
function CompletedGame$Companion$$childSerializers$_anonymous__365cb1_1() {
  return new ArrayListSerializer(Companion_instance_128.a2g());
}
var Companion_instance_528;
function Companion_getInstance_529() {
  if (Companion_instance_528 === VOID)
    new Companion_528();
  return Companion_instance_528;
}
var $serializer_instance_446;
function $serializer_getInstance_446() {
  if ($serializer_instance_446 === VOID)
    new $serializer_450();
  return $serializer_instance_446;
}
var Companion_instance_529;
function Companion_getInstance_530() {
  return Companion_instance_529;
}
var $serializer_instance_447;
function $serializer_getInstance_447() {
  if ($serializer_instance_447 === VOID)
    new $serializer_451();
  return $serializer_instance_447;
}
function BeastResourceLookupRequest$Companion$$childSerializers$_anonymous__lswh6q() {
  return Companion_getInstance_548().a2g();
}
var Companion_instance_530;
function Companion_getInstance_531() {
  if (Companion_instance_530 === VOID)
    new Companion_530();
  return Companion_instance_530;
}
var $serializer_instance_448;
function $serializer_getInstance_448() {
  if ($serializer_instance_448 === VOID)
    new $serializer_452();
  return $serializer_instance_448;
}
function _get_$cachedSerializer__te6jhj_551($this) {
  return $this.y6n_1.k3();
}
function ReplaySharingStatus$Companion$_anonymous__flthvs() {
  return createSimpleEnumSerializer('steelart.beast.network.ReplaySharingStatus', values_12());
}
var ReplaySharingStatus_Unavailable_instance;
var ReplaySharingStatus_Pending_instance;
var ReplaySharingStatus_Declined_instance;
var ReplaySharingStatus_Shared_instance;
function values_12() {
  return [ReplaySharingStatus_Unavailable_getInstance(), ReplaySharingStatus_Pending_getInstance(), ReplaySharingStatus_Declined_getInstance(), ReplaySharingStatus_Shared_getInstance()];
}
var Companion_instance_531;
function Companion_getInstance_532() {
  ReplaySharingStatus_initEntries();
  if (Companion_instance_531 === VOID)
    new Companion_531();
  return Companion_instance_531;
}
var ReplaySharingStatus_entriesInitialized;
function ReplaySharingStatus_initEntries() {
  if (ReplaySharingStatus_entriesInitialized)
    return Unit_instance;
  ReplaySharingStatus_entriesInitialized = true;
  ReplaySharingStatus_Unavailable_instance = new ReplaySharingStatus('Unavailable', 0);
  ReplaySharingStatus_Pending_instance = new ReplaySharingStatus('Pending', 1);
  ReplaySharingStatus_Declined_instance = new ReplaySharingStatus('Declined', 2);
  ReplaySharingStatus_Shared_instance = new ReplaySharingStatus('Shared', 3);
  Companion_getInstance_532();
}
var Companion_instance_532;
function Companion_getInstance_533() {
  return Companion_instance_532;
}
var $serializer_instance_449;
function $serializer_getInstance_449() {
  if ($serializer_instance_449 === VOID)
    new $serializer_453();
  return $serializer_instance_449;
}
function _get_$cachedSerializer__te6jhj_552($this) {
  return $this.e6o_1.k3();
}
function ReconnectSandboxResult$PermissionError$_anonymous__m59305() {
  var tmp = PermissionError_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PermissionError', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_553($this) {
  return $this.f6o_1.k3();
}
function ReconnectSandboxResult$SandboxGameWasNotFound$_anonymous__h0cgxt() {
  var tmp = SandboxGameWasNotFound_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SandboxGameWasNotFound', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_554($this) {
  return $this.g6o_1.k3();
}
function ReconnectSandboxResult$SandboxGameWasCanceled$_anonymous__crvey1() {
  var tmp = SandboxGameWasCanceled_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SandboxGameWasCanceled', tmp, tmp$ret$0);
}
var Companion_instance_533;
function Companion_getInstance_534() {
  return Companion_instance_533;
}
var $serializer_instance_450;
function $serializer_getInstance_450() {
  if ($serializer_instance_450 === VOID)
    new $serializer_454();
  return $serializer_instance_450;
}
function ReconnectSandboxResult$ReconnectSandboxPlaying$Companion$$childSerializers$_anonymous__1ew57h() {
  return Companion_instance_214.a2g();
}
var Companion_instance_534;
function Companion_getInstance_535() {
  if (Companion_instance_534 === VOID)
    new Companion_534();
  return Companion_instance_534;
}
var $serializer_instance_451;
function $serializer_getInstance_451() {
  if ($serializer_instance_451 === VOID)
    new $serializer_455();
  return $serializer_instance_451;
}
var PermissionError_instance;
function PermissionError_getInstance() {
  if (PermissionError_instance === VOID)
    new PermissionError();
  return PermissionError_instance;
}
var SandboxGameWasNotFound_instance;
function SandboxGameWasNotFound_getInstance() {
  if (SandboxGameWasNotFound_instance === VOID)
    new SandboxGameWasNotFound();
  return SandboxGameWasNotFound_instance;
}
var SandboxGameWasCanceled_instance;
function SandboxGameWasCanceled_getInstance() {
  if (SandboxGameWasCanceled_instance === VOID)
    new SandboxGameWasCanceled();
  return SandboxGameWasCanceled_instance;
}
var Companion_instance_535;
function Companion_getInstance_536() {
  return Companion_instance_535;
}
var Companion_instance_536;
function Companion_getInstance_537() {
  return Companion_instance_536;
}
var $serializer_instance_452;
function $serializer_getInstance_452() {
  if ($serializer_instance_452 === VOID)
    new $serializer_456();
  return $serializer_instance_452;
}
var Companion_instance_537;
function Companion_getInstance_538() {
  return Companion_instance_537;
}
var $serializer_instance_453;
function $serializer_getInstance_453() {
  if ($serializer_instance_453 === VOID)
    new $serializer_457();
  return $serializer_instance_453;
}
var Companion_instance_538;
function Companion_getInstance_539() {
  return Companion_instance_538;
}
var $serializer_instance_454;
function $serializer_getInstance_454() {
  if ($serializer_instance_454 === VOID)
    new $serializer_458();
  return $serializer_instance_454;
}
var Companion_instance_539;
function Companion_getInstance_540() {
  return Companion_instance_539;
}
function GamePresence$Companion$$childSerializers$_anonymous__vcuggz() {
  return new LinkedHashMapSerializer($serializer_getInstance_183(), new ArrayListSerializer($serializer_getInstance_463()));
}
var Companion_instance_540;
function Companion_getInstance_541() {
  if (Companion_instance_540 === VOID)
    new Companion_540();
  return Companion_instance_540;
}
var $serializer_instance_455;
function $serializer_getInstance_455() {
  if ($serializer_instance_455 === VOID)
    new $serializer_459();
  return $serializer_instance_455;
}
function _get_$cachedSerializer__te6jhj_555($this) {
  return $this.l6p_1.k3();
}
function RequestRevertTurnResult$Success$_anonymous__pimi3v() {
  var tmp = Success_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('Success', tmp, tmp$ret$0);
}
var Companion_instance_541;
function Companion_getInstance_542() {
  return Companion_instance_541;
}
var $serializer_instance_456;
function $serializer_getInstance_456() {
  if ($serializer_instance_456 === VOID)
    new $serializer_460();
  return $serializer_instance_456;
}
var Success_instance;
function Success_getInstance() {
  if (Success_instance === VOID)
    new Success_0();
  return Success_instance;
}
var Companion_instance_542;
function Companion_getInstance_543() {
  return Companion_instance_542;
}
var WhatWillBeReapply_NoStateBefore_instance;
var WhatWillBeReapply_InitialStateNotification_instance;
var WhatWillBeReapply_GameNotification_instance;
var WhatWillBeReapply_GameQuestion_instance;
var WhatWillBeReapply_entriesInitialized;
function WhatWillBeReapply_initEntries() {
  if (WhatWillBeReapply_entriesInitialized)
    return Unit_instance;
  WhatWillBeReapply_entriesInitialized = true;
  WhatWillBeReapply_NoStateBefore_instance = new WhatWillBeReapply('NoStateBefore', 0);
  WhatWillBeReapply_InitialStateNotification_instance = new WhatWillBeReapply('InitialStateNotification', 1);
  WhatWillBeReapply_GameNotification_instance = new WhatWillBeReapply('GameNotification', 2);
  WhatWillBeReapply_GameQuestion_instance = new WhatWillBeReapply('GameQuestion', 3);
}
function ActiveDuelSession$Companion$$childSerializers$_anonymous__ccr7pu() {
  return new LinkedHashSetSerializer($serializer_getInstance_183());
}
var Companion_instance_543;
function Companion_getInstance_544() {
  if (Companion_instance_543 === VOID)
    new Companion_543();
  return Companion_instance_543;
}
var $serializer_instance_457;
function $serializer_getInstance_457() {
  if ($serializer_instance_457 === VOID)
    new $serializer_461();
  return $serializer_instance_457;
}
function LobbyInfo$Companion$$childSerializers$_anonymous__ouvsue() {
  return Companion_instance_214.a2g();
}
function LobbyInfo$Companion$$childSerializers$_anonymous__ouvsue_0() {
  return new LinkedHashMapSerializer($serializer_getInstance_183(), new LinkedHashSetSerializer(StringSerializer_getInstance()));
}
var Companion_instance_544;
function Companion_getInstance_545() {
  if (Companion_instance_544 === VOID)
    new Companion_544();
  return Companion_instance_544;
}
var $serializer_instance_458;
function $serializer_getInstance_458() {
  if ($serializer_instance_458 === VOID)
    new $serializer_462();
  return $serializer_instance_458;
}
var Companion_instance_545;
function Companion_getInstance_546() {
  return Companion_instance_545;
}
function ClientSetup$Companion$$childSerializers$_anonymous__h03ifc() {
  return Companion_instance_214.a2g();
}
var Companion_instance_546;
function Companion_getInstance_547() {
  if (Companion_instance_546 === VOID)
    new Companion_546();
  return Companion_instance_546;
}
var $serializer_instance_459;
function $serializer_getInstance_459() {
  if ($serializer_instance_459 === VOID)
    new $serializer_463();
  return $serializer_instance_459;
}
var GameStatus_Active_instance;
var GameStatus_Finished_instance;
var GameStatus_Canceled_instance;
var GameStatus_Failed_instance;
function values_13() {
  return [GameStatus_Active_getInstance(), GameStatus_Finished_getInstance(), GameStatus_Canceled_getInstance(), GameStatus_Failed_getInstance()];
}
var GameStatus_entriesInitialized;
function GameStatus_initEntries() {
  if (GameStatus_entriesInitialized)
    return Unit_instance;
  GameStatus_entriesInitialized = true;
  GameStatus_Active_instance = new GameStatus('Active', 0);
  GameStatus_Finished_instance = new GameStatus('Finished', 1);
  GameStatus_Canceled_instance = new GameStatus('Canceled', 2);
  GameStatus_Failed_instance = new GameStatus('Failed', 3);
}
function _get_$cachedSerializer__te6jhj_556($this) {
  return $this.p6n_1.k3();
}
function BeastResourceKind$Companion$_anonymous__isew4y() {
  return createSimpleEnumSerializer('steelart.beast.network.BeastResourceKind', values_14());
}
var BeastResourceKind_Game_instance;
var BeastResourceKind_Replay_instance;
function values_14() {
  return [BeastResourceKind_Game_getInstance(), BeastResourceKind_Replay_getInstance()];
}
var Companion_instance_547;
function Companion_getInstance_548() {
  BeastResourceKind_initEntries();
  if (Companion_instance_547 === VOID)
    new Companion_547();
  return Companion_instance_547;
}
var BeastResourceKind_entriesInitialized;
function BeastResourceKind_initEntries() {
  if (BeastResourceKind_entriesInitialized)
    return Unit_instance;
  BeastResourceKind_entriesInitialized = true;
  BeastResourceKind_Game_instance = new BeastResourceKind('Game', 0);
  BeastResourceKind_Replay_instance = new BeastResourceKind('Replay', 1);
  Companion_getInstance_548();
}
var Companion_instance_548;
function Companion_getInstance_549() {
  return Companion_instance_548;
}
var $serializer_instance_460;
function $serializer_getInstance_460() {
  if ($serializer_instance_460 === VOID)
    new $serializer_464();
  return $serializer_instance_460;
}
function PingLocationTypeElement$Companion$$childSerializers$_anonymous__fg2ehb() {
  return createSimpleEnumSerializer('steelart.beast.LocationType', values_2());
}
var Companion_instance_549;
function Companion_getInstance_550() {
  if (Companion_instance_549 === VOID)
    new Companion_549();
  return Companion_instance_549;
}
var $serializer_instance_461;
function $serializer_getInstance_461() {
  if ($serializer_instance_461 === VOID)
    new $serializer_465();
  return $serializer_instance_461;
}
function PingPlayableCardElement$Companion$$childSerializers$_anonymous__enuc4e() {
  return Companion_instance_442.a2g();
}
var Companion_instance_550;
function Companion_getInstance_551() {
  if (Companion_instance_550 === VOID)
    new Companion_550();
  return Companion_instance_550;
}
var $serializer_instance_462;
function $serializer_getInstance_462() {
  if ($serializer_instance_462 === VOID)
    new $serializer_466();
  return $serializer_instance_462;
}
var Companion_instance_551;
function Companion_getInstance_552() {
  return Companion_instance_551;
}
var $serializer_instance_463;
function $serializer_getInstance_463() {
  if ($serializer_instance_463 === VOID)
    new $serializer_467();
  return $serializer_instance_463;
}
var Companion_instance_552;
function Companion_getInstance_553() {
  return Companion_instance_552;
}
var $serializer_instance_464;
function $serializer_getInstance_464() {
  if ($serializer_instance_464 === VOID)
    new $serializer_468();
  return $serializer_instance_464;
}
function _get_$cachedSerializer__te6jhj_557($this) {
  return $this.u6r_1.k3();
}
function NotFoundSetupSession$_anonymous__bfd6z5() {
  var tmp = NotFoundSetupSession_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('NotFoundSetupSession', tmp, tmp$ret$0);
}
var NotFoundSetupSession_instance;
function NotFoundSetupSession_getInstance() {
  if (NotFoundSetupSession_instance === VOID)
    new NotFoundSetupSession();
  return NotFoundSetupSession_instance;
}
function SetupEnded$Companion$$childSerializers$_anonymous__mg597x() {
  return Companion_getInstance_556().a2g();
}
var Companion_instance_553;
function Companion_getInstance_554() {
  if (Companion_instance_553 === VOID)
    new Companion_553();
  return Companion_instance_553;
}
var $serializer_instance_465;
function $serializer_getInstance_465() {
  if ($serializer_instance_465 === VOID)
    new $serializer_469();
  return $serializer_instance_465;
}
var Companion_instance_554;
function Companion_getInstance_555() {
  return Companion_instance_554;
}
var $serializer_instance_466;
function $serializer_getInstance_466() {
  if ($serializer_instance_466 === VOID)
    new $serializer_470();
  return $serializer_instance_466;
}
function _get_$cachedSerializer__te6jhj_558($this) {
  return $this.v6r_1.k3();
}
function SetupTerminalStatus$Companion$_anonymous__avviho() {
  return createSimpleEnumSerializer('steelart.beast.network.SetupTerminalStatus', values_15());
}
var SetupTerminalStatus_Canceled_instance;
var SetupTerminalStatus_Failed_instance;
function values_15() {
  return [SetupTerminalStatus_Canceled_getInstance(), SetupTerminalStatus_Failed_getInstance()];
}
var Companion_instance_555;
function Companion_getInstance_556() {
  SetupTerminalStatus_initEntries();
  if (Companion_instance_555 === VOID)
    new Companion_555();
  return Companion_instance_555;
}
var SetupTerminalStatus_entriesInitialized;
function SetupTerminalStatus_initEntries() {
  if (SetupTerminalStatus_entriesInitialized)
    return Unit_instance;
  SetupTerminalStatus_entriesInitialized = true;
  SetupTerminalStatus_Canceled_instance = new SetupTerminalStatus('Canceled', 0);
  SetupTerminalStatus_Failed_instance = new SetupTerminalStatus('Failed', 1);
  Companion_getInstance_556();
}
function ServerDuelSetupGameData$Companion$$childSerializers$_anonymous__pbube4() {
  return Companion_instance_214.a2g();
}
function ServerDuelSetupGameData$Companion$$childSerializers$_anonymous__pbube4_0() {
  return new LinkedHashMapSerializer($serializer_getInstance_183(), new LinkedHashSetSerializer(StringSerializer_getInstance()));
}
function ServerDuelSetupGameData$Companion$$childSerializers$_anonymous__pbube4_1() {
  return new ArrayListSerializer($serializer_getInstance_468());
}
var Companion_instance_556;
function Companion_getInstance_557() {
  if (Companion_instance_556 === VOID)
    new Companion_556();
  return Companion_instance_556;
}
var $serializer_instance_467;
function $serializer_getInstance_467() {
  if ($serializer_instance_467 === VOID)
    new $serializer_471();
  return $serializer_instance_467;
}
var Companion_instance_557;
function Companion_getInstance_558() {
  return Companion_instance_557;
}
var $serializer_instance_468;
function $serializer_getInstance_468() {
  if ($serializer_instance_468 === VOID)
    new $serializer_472();
  return $serializer_instance_468;
}
var Companion_instance_558;
function Companion_getInstance_559() {
  return Companion_instance_558;
}
var $serializer_instance_469;
function $serializer_getInstance_469() {
  if ($serializer_instance_469 === VOID)
    new $serializer_473();
  return $serializer_instance_469;
}
function get_canBeUsedForResume(_this__u8e3s4) {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  return _this__u8e3s4.k6k_1 >= 0;
}
function get_clientSetupOrNull(_this__u8e3s4) {
  _init_properties_ServerDrivenConfiguration_kt__zbvyir();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof Resumed ? _this__u8e3s4 : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p6m_1;
}
function _get_currentState__wsfiyb($this) {
  var tmp = $this.m6t_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('currentState');
  }
}
function ConnectionStatus_Connected_getInstance() {
  ConnectionStatus_initEntries();
  return ConnectionStatus_Connected_instance;
}
function ConnectionStatus_Disconnected_getInstance() {
  ConnectionStatus_initEntries();
  return ConnectionStatus_Disconnected_instance;
}
function ReplaySharingStatus_Unavailable_getInstance() {
  ReplaySharingStatus_initEntries();
  return ReplaySharingStatus_Unavailable_instance;
}
function ReplaySharingStatus_Pending_getInstance() {
  ReplaySharingStatus_initEntries();
  return ReplaySharingStatus_Pending_instance;
}
function ReplaySharingStatus_Declined_getInstance() {
  ReplaySharingStatus_initEntries();
  return ReplaySharingStatus_Declined_instance;
}
function ReplaySharingStatus_Shared_getInstance() {
  ReplaySharingStatus_initEntries();
  return ReplaySharingStatus_Shared_instance;
}
function WhatWillBeReapply_NoStateBefore_getInstance() {
  WhatWillBeReapply_initEntries();
  return WhatWillBeReapply_NoStateBefore_instance;
}
function WhatWillBeReapply_InitialStateNotification_getInstance() {
  WhatWillBeReapply_initEntries();
  return WhatWillBeReapply_InitialStateNotification_instance;
}
function WhatWillBeReapply_GameNotification_getInstance() {
  WhatWillBeReapply_initEntries();
  return WhatWillBeReapply_GameNotification_instance;
}
function WhatWillBeReapply_GameQuestion_getInstance() {
  WhatWillBeReapply_initEntries();
  return WhatWillBeReapply_GameQuestion_instance;
}
function GameStatus_Active_getInstance() {
  GameStatus_initEntries();
  return GameStatus_Active_instance;
}
function GameStatus_Finished_getInstance() {
  GameStatus_initEntries();
  return GameStatus_Finished_instance;
}
function GameStatus_Canceled_getInstance() {
  GameStatus_initEntries();
  return GameStatus_Canceled_instance;
}
function GameStatus_Failed_getInstance() {
  GameStatus_initEntries();
  return GameStatus_Failed_instance;
}
function BeastResourceKind_Game_getInstance() {
  BeastResourceKind_initEntries();
  return BeastResourceKind_Game_instance;
}
function BeastResourceKind_Replay_getInstance() {
  BeastResourceKind_initEntries();
  return BeastResourceKind_Replay_instance;
}
function SetupTerminalStatus_Canceled_getInstance() {
  SetupTerminalStatus_initEntries();
  return SetupTerminalStatus_Canceled_instance;
}
function SetupTerminalStatus_Failed_getInstance() {
  SetupTerminalStatus_initEntries();
  return SetupTerminalStatus_Failed_instance;
}
var properties_initialized_ServerDrivenConfiguration_kt_hcw3r5;
function _init_properties_ServerDrivenConfiguration_kt__zbvyir() {
  if (!properties_initialized_ServerDrivenConfiguration_kt_hcw3r5) {
    properties_initialized_ServerDrivenConfiguration_kt_hcw3r5 = true;
    onboardingReplayCode = new GameCode('tutorial');
    quixoteTournamentGame3 = new GameCode('qui01003');
    quixoteTournamentGame4 = new GameCode('qui01004');
    quixoteTournamentGame9 = new GameCode('qui01009');
    quixoteTournamentGames = listOf_0([get_quixoteTournamentGame3(), get_quixoteTournamentGame4(), get_quixoteTournamentGame9()]);
    terminalInfoSourceCursor = new InfoSourceCursor(new Long(-1, -1), -1);
    incorrectServerStateInfoSourceCursor = new InfoSourceCursor(new Long(-1, -1), -2);
    canceledSessionInfoSourceCursor = new InfoSourceCursor(new Long(-1, -1), -3);
  }
}
var GameIsNotFound_instance;
function GameIsNotFound_getInstance() {
  return GameIsNotFound_instance;
}
var IncompleteGame_instance;
function IncompleteGame_getInstance() {
  return IncompleteGame_instance;
}
function *checkReplayFromServer(diagnostics, serverDrivenConfiguration, gameCode, $completion) {
  var beastsAgent = new SimpleReplayFullClientAgent(diagnostics);
  var huntersAgent = new SimpleReplayFullClientAgent(diagnostics);
  yield* serverDrivenConfiguration.i6l(beastsAgent, get_beastsGameTeam(), $completion);
  yield* serverDrivenConfiguration.i6l(huntersAgent, get_huntersGameTeam(), $completion);
  var tmp0_elvis_lhs = yield* serverDrivenConfiguration.n6l(gameCode, false, $completion);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return GameIsNotFound_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var replayDriver = tmp;
  try {
    yield* replayDriver.v6t($completion);
    var tmp1_elvis_lhs = beastsAgent.l6t_1;
    var tmp_0;
    var tmp_1 = tmp1_elvis_lhs;
    if ((tmp_1 == null ? null : new GameTeam(tmp_1)) == null) {
      tmp_0 = huntersAgent.l6t_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var winner = tmp_0;
    var tmp_2;
    var tmp_3 = winner;
    if (!((tmp_3 == null ? null : new GameTeam(tmp_3)) == null)) {
      tmp_2 = new GameIsEnded(winner);
    } else {
      tmp_2 = IncompleteGame_instance;
    }
    return tmp_2;
  } catch ($p) {
    if ($p instanceof ReplayIsFinishedException) {
      var _unused_var__etf5q3 = $p;
      return IncompleteGame_instance;
    } else {
      if ($p instanceof EndOfGameException) {
        var e = $p;
        return new GameIsEnded(e.x6t_1);
      } else {
        if ($p instanceof CancellationException) {
          var e_0 = $p;
          throw e_0;
        } else {
          if ($p instanceof Error) {
            var e_1 = $p;
            return new ExceptionInReplaying(e_1);
          } else {
            throw $p;
          }
        }
      }
    }
  }
}
var Companion_instance_559;
function Companion_getInstance_560() {
  return Companion_instance_559;
}
var $serializer_instance_470;
function $serializer_getInstance_470() {
  if ($serializer_instance_470 === VOID)
    new $serializer_474();
  return $serializer_instance_470;
}
var Companion_instance_560;
function Companion_getInstance_561() {
  return Companion_instance_560;
}
var $serializer_instance_471;
function $serializer_getInstance_471() {
  if ($serializer_instance_471 === VOID)
    new $serializer_475();
  return $serializer_instance_471;
}
var Companion_instance_561;
function Companion_getInstance_562() {
  return Companion_instance_561;
}
function displayText(_this__u8e3s4, nowEpochMilliseconds) {
  var tmp;
  if (_this__u8e3s4 instanceof Announcement) {
    tmp = _this__u8e3s4.b6u_1;
  } else {
    if (_this__u8e3s4 instanceof Maintenance) {
      var remaining = subtract(_this__u8e3s4.g6u_1, nowEpochMilliseconds);
      var tmp_0;
      if (equalsLong(_this__u8e3s4.h6u_1, new Long(-1, -1))) {
        tmp_0 = 'Estimated duration is currently unknown.';
      } else {
        tmp_0 = 'Expected duration: about ' + formatMaintenanceTime(_this__u8e3s4.h6u_1) + '.';
      }
      var estimate = tmp_0;
      var details = estimate + ' Temporary connection issues are expected.';
      var tmp_1;
      if (compare(remaining, new Long(0, 0)) > 0) {
        // Inline function 'kotlin.Long.div' call
        var tmp0 = divide(remaining, fromInt(1000));
        var tmp_2;
        // Inline function 'kotlin.Long.rem' call
        var tmp$ret$1 = modulo(remaining, fromInt(1000));
        if (equalsLong(tmp$ret$1, new Long(0, 0))) {
          tmp_2 = 0;
        } else {
          tmp_2 = 1;
        }
        // Inline function 'kotlin.Long.plus' call
        var other = tmp_2;
        var seconds = add(tmp0, fromInt(other));
        tmp_1 = 'Server maintenance starts in ' + formatMaintenanceTime(seconds) + '. ' + details;
      } else {
        tmp_1 = 'Server maintenance is due. ' + details;
      }
      tmp = tmp_1;
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function formatMaintenanceTime(totalSeconds) {
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.p2();
  // Inline function 'kotlin.Long.div' call
  var tmp$ret$4 = divide(totalSeconds, fromInt(3600));
  formatMaintenanceTime$addUnit(this_0, tmp$ret$4, 'hour');
  // Inline function 'kotlin.Long.div' call
  // Inline function 'kotlin.Long.rem' call
  var this_1 = divide(totalSeconds, fromInt(60));
  var tmp$ret$6 = modulo(this_1, fromInt(60));
  formatMaintenanceTime$addUnit(this_0, tmp$ret$6, 'minute');
  // Inline function 'kotlin.Long.rem' call
  var tmp$ret$7 = modulo(totalSeconds, fromInt(60));
  formatMaintenanceTime$addUnit(this_0, tmp$ret$7, 'second');
  var tmp$ret$0 = this_0.g9();
  return joinToString(tmp$ret$0, ' ');
}
function formatMaintenanceTime$addUnit($this_buildList, value, unit) {
  if (compare(value, new Long(0, 0)) > 0) {
    $this_buildList.d2(value.toString() + ' ' + unit + (equalsLong(value, new Long(1, 0)) ? '' : 's'));
  }
}
function BeastUserSettingValues$Companion$$childSerializers$_anonymous__53cu9u() {
  return new LinkedHashMapSerializer($serializer_getInstance_474(), StringSerializer_getInstance());
}
function _BeastUserSettingValues___init__impl__8n6syv(values) {
  return values;
}
function _BeastUserSettingValues___get_values__impl__oxd02m($this) {
  return $this;
}
var Companion_instance_562;
function Companion_getInstance_563() {
  if (Companion_instance_562 === VOID)
    new Companion_562();
  return Companion_instance_562;
}
var $serializer_instance_472;
function $serializer_getInstance_472() {
  if ($serializer_instance_472 === VOID)
    new $serializer_476();
  return $serializer_instance_472;
}
function BeastUserSettingValues__toString_impl_duqbrb($this) {
  return 'BeastUserSettingValues(values=' + toString($this) + ')';
}
function BeastUserSettingValues__hashCode_impl_zf7tey($this) {
  return hashCode($this);
}
function BeastUserSettingValues__equals_impl_rue0li($this, other) {
  if (!(other instanceof BeastUserSettingValues))
    return false;
  var tmp0_other_with_cast = other.o6u_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function BeastUserSettingsPatch$Companion$$childSerializers$_anonymous__l7dsep() {
  return new LinkedHashSetSerializer($serializer_getInstance_474());
}
var Companion_instance_563;
function Companion_getInstance_564() {
  if (Companion_instance_563 === VOID)
    new Companion_563();
  return Companion_instance_563;
}
var $serializer_instance_473;
function $serializer_getInstance_473() {
  if ($serializer_instance_473 === VOID)
    new $serializer_477();
  return $serializer_instance_473;
}
function _BeastUserSettingId___init__impl__l8z068(value) {
  return value;
}
function _BeastUserSettingId___get_value__impl__836oj0($this) {
  return $this;
}
var Companion_instance_564;
function Companion_getInstance_565() {
  return Companion_instance_564;
}
var $serializer_instance_474;
function $serializer_getInstance_474() {
  if ($serializer_instance_474 === VOID)
    new $serializer_478();
  return $serializer_instance_474;
}
function BeastUserSettingId__toString_impl_h8i31c($this) {
  return 'BeastUserSettingId(value=' + $this + ')';
}
function BeastUserSettingId__hashCode_impl_4intrj($this) {
  return getStringHashCode($this);
}
function BeastUserSettingId__equals_impl_kzaj0z($this, other) {
  if (!(other instanceof BeastUserSettingId))
    return false;
  if (!($this === other.y6u_1))
    return false;
  return true;
}
function Boolean$toString$ref() {
  return constructCallableReference((p0) => p0.toString(), 1, 0, 17, 'toString');
}
function toBooleanStrictOrNull$ref() {
  return constructCallableReference((p0) => toBooleanStrictOrNull(p0), 1, 0, 18, 'toBooleanStrictOrNull');
}
var BeastUserSettings_instance;
function BeastUserSettings_getInstance() {
  if (BeastUserSettings_instance === VOID)
    new BeastUserSettings();
  return BeastUserSettings_instance;
}
function replayTimeline(checkpoints) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap.m7();
  var _iterator__ex2g4s = checkpoints.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var key = element.t6v();
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.w4(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList.p2();
      destination.b5(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.d2(element);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination.i3();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = replayTimeline$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$6);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    // Inline function 'kotlin.collections.component1' call
    var day = item.j3();
    // Inline function 'kotlin.collections.component2' call
    var dayCheckpoints = item.k3();
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_1 = ArrayList.p2();
    var _iterator__ex2g4s_1 = dayCheckpoints.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var element_0 = _iterator__ex2g4s_1.r1();
      if (element_0 instanceof Dawn) {
        destination_1.d2(element_0);
      }
    }
    var dawn = firstOrNull(destination_1);
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_2 = ArrayList.p2();
    var _iterator__ex2g4s_2 = dayCheckpoints.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var element_1 = _iterator__ex2g4s_2.r1();
      if (element_1 instanceof Night) {
        destination_2.d2(element_1);
      }
    }
    var night = firstOrNull(destination_2);
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_3 = ArrayList.p2();
    var _iterator__ex2g4s_3 = dayCheckpoints.p1();
    while (_iterator__ex2g4s_3.q1()) {
      var element_2 = _iterator__ex2g4s_3.r1();
      if (element_2 instanceof Turn) {
        destination_3.d2(element_2);
      }
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_4 = LinkedHashMap.m7();
    var _iterator__ex2g4s_4 = destination_3.p1();
    while (_iterator__ex2g4s_4.q1()) {
      var element_3 = _iterator__ex2g4s_4.r1();
      var key_0 = element_3.w6v_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value_0 = destination_4.w4(key_0);
      var tmp_1;
      if (value_0 == null) {
        var answer_0 = ArrayList.p2();
        destination_4.b5(key_0, answer_0);
        tmp_1 = answer_0;
      } else {
        tmp_1 = value_0;
      }
      var list_0 = tmp_1;
      list_0.d2(element_3);
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_2 = destination_4.i3();
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = replayTimeline$lambda_0;
    var tmp$ret$24 = new sam$kotlin_Comparator$0_0(tmp_2);
    // Inline function 'kotlin.collections.map' call
    var this_3 = sortedWith(this_2, tmp$ret$24);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList.n2(collectionSizeOrDefault(this_3, 10));
    var _iterator__ex2g4s_5 = this_3.p1();
    while (_iterator__ex2g4s_5.q1()) {
      var item_0 = _iterator__ex2g4s_5.r1();
      // Inline function 'kotlin.collections.component1' call
      var turn = item_0.j3();
      // Inline function 'kotlin.collections.component2' call
      var characterCheckpoints = item_0.k3();
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_6 = ArrayList.n2(collectionSizeOrDefault(characterCheckpoints, 10));
      var _iterator__ex2g4s_6 = characterCheckpoints.p1();
      while (_iterator__ex2g4s_6.q1()) {
        var item_1 = _iterator__ex2g4s_6.r1();
        var tmp$ret$32 = new ReplayTimelineCharacter(item_1.x6v_1, item_1.v6v_1);
        destination_6.d2(tmp$ret$32);
      }
      // Inline function 'kotlin.collections.distinctBy' call
      var set = HashSet.mb();
      var list_1 = ArrayList.p2();
      var _iterator__ex2g4s_7 = destination_6.p1();
      while (_iterator__ex2g4s_7.q1()) {
        var e = _iterator__ex2g4s_7.r1();
        var key_1 = e.p6v_1;
        if (set.d2(key_1)) {
          list_1.d2(e);
        }
      }
      var tmp$ret$27 = new ReplayTimelineTurn(turn, list_1);
      destination_5.d2(tmp$ret$27);
    }
    var turns = destination_5;
    var tmp_3 = dawn == null ? null : dawn.s6v_1;
    var tmp$ret$9 = new ReplayTimelineDay(day, tmp_3, turns, night == null ? null : night.z6v_1);
    destination_0.d2(tmp$ret$9);
  }
  var days = destination_0;
  return new ReplayTimeline(days);
}
function replayTimelineFromSavedAnswers(predefinedAnswers, characterByObject) {
  // Inline function 'kotlin.collections.mapIndexedNotNull' call
  // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = predefinedAnswers.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp;
    if (item instanceof StartPhaseMarker) {
      var tmp1_subject = item.d6w_1;
      var tmp_0;
      if (tmp1_subject instanceof DawnPhase) {
        tmp_0 = new Dawn(item.e6w_1, index_0);
      } else {
        if (equals(tmp1_subject, NightPhase_getInstance())) {
          tmp_0 = new Night(item.e6w_1, index_0);
        } else {
          tmp_0 = null;
        }
      }
      tmp = tmp_0;
    } else {
      if (item instanceof StartTurnReplayMarker) {
        var tmp2_safe_receiver = characterByObject(item.b6w_1);
        var tmp_1;
        if (tmp2_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = new Turn(item.a6w_1, index_0, item.c6w_1, tmp2_safe_receiver);
        }
        tmp = tmp_1;
      } else {
        tmp = null;
      }
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  var checkpoints = destination;
  return replayTimeline(checkpoints);
}
function replayTimeline$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.j3();
  var tmp$ret$2 = b.j3();
  return compareValues(tmp, tmp$ret$2);
}
function replayTimeline$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.j3();
  var tmp$ret$2 = b.j3();
  return compareValues(tmp, tmp$ret$2);
}
var Companion_instance_565;
function Companion_getInstance_566() {
  return Companion_instance_565;
}
var $serializer_instance_475;
function $serializer_getInstance_475() {
  if ($serializer_instance_475 === VOID)
    new $serializer_479();
  return $serializer_instance_475;
}
function _get_$cachedSerializer__te6jhj_559($this) {
  return $this.q6w_1.k3();
}
function SandboxInitApplyEventResult$SandboxInitWasNotFound$_anonymous__1g2bbi() {
  var tmp = SandboxInitWasNotFound_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SandboxInitWasNotFound', tmp, tmp$ret$0);
}
var Companion_instance_566;
function Companion_getInstance_567() {
  return Companion_instance_566;
}
var $serializer_instance_476;
function $serializer_getInstance_476() {
  if ($serializer_instance_476 === VOID)
    new $serializer_480();
  return $serializer_instance_476;
}
var Companion_instance_567;
function Companion_getInstance_568() {
  return Companion_instance_567;
}
var $serializer_instance_477;
function $serializer_getInstance_477() {
  if ($serializer_instance_477 === VOID)
    new $serializer_481();
  return $serializer_instance_477;
}
function _get_$cachedSerializer__te6jhj_560($this) {
  return $this.z6w_1.k3();
}
function SandboxInitApplyEventResult$SandboxInitInvalidCheckCodes$_anonymous__dkso0l() {
  var tmp = SandboxInitInvalidCheckCodes_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SandboxInitInvalidCheckCodes', tmp, tmp$ret$0);
}
var Companion_instance_568;
function Companion_getInstance_569() {
  return Companion_instance_568;
}
var $serializer_instance_478;
function $serializer_getInstance_478() {
  if ($serializer_instance_478 === VOID)
    new $serializer_482();
  return $serializer_instance_478;
}
var SandboxInitWasNotFound_instance;
function SandboxInitWasNotFound_getInstance() {
  if (SandboxInitWasNotFound_instance === VOID)
    new SandboxInitWasNotFound();
  return SandboxInitWasNotFound_instance;
}
var SandboxInitInvalidCheckCodes_instance;
function SandboxInitInvalidCheckCodes_getInstance() {
  if (SandboxInitInvalidCheckCodes_instance === VOID)
    new SandboxInitInvalidCheckCodes();
  return SandboxInitInvalidCheckCodes_instance;
}
var Companion_instance_569;
function Companion_getInstance_570() {
  return Companion_instance_569;
}
function SandboxStartParams$Companion$$childSerializers$_anonymous__kvx71l() {
  return Companion_instance_225.a2g();
}
var Companion_instance_570;
function Companion_getInstance_571() {
  if (Companion_instance_570 === VOID)
    new Companion_570();
  return Companion_instance_570;
}
var $serializer_instance_479;
function $serializer_getInstance_479() {
  if ($serializer_instance_479 === VOID)
    new $serializer_483();
  return $serializer_instance_479;
}
var Companion_instance_571;
function Companion_getInstance_572() {
  return Companion_instance_571;
}
var $serializer_instance_480;
function $serializer_getInstance_480() {
  if ($serializer_instance_480 === VOID)
    new $serializer_484();
  return $serializer_instance_480;
}
function _get_$cachedSerializer__te6jhj_561($this) {
  return $this.o6x_1.k3();
}
function StartSandboxResult$SandboxInitInvalidCheckCodes$_anonymous__ri70y1() {
  var tmp = SandboxInitInvalidCheckCodes_getInstance_0();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SandboxInitInvalidCheckCodes', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_562($this) {
  return $this.p6x_1.k3();
}
function StartSandboxResult$SandboxInitWasNotFound$_anonymous__xacoz0() {
  var tmp = SandboxInitWasNotFound_getInstance_0();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('SandboxInitWasNotFound', tmp, tmp$ret$0);
}
var SandboxInitInvalidCheckCodes_instance_0;
function SandboxInitInvalidCheckCodes_getInstance_0() {
  if (SandboxInitInvalidCheckCodes_instance_0 === VOID)
    new SandboxInitInvalidCheckCodes_0();
  return SandboxInitInvalidCheckCodes_instance_0;
}
var SandboxInitWasNotFound_instance_0;
function SandboxInitWasNotFound_getInstance_0() {
  if (SandboxInitWasNotFound_instance_0 === VOID)
    new SandboxInitWasNotFound_0();
  return SandboxInitWasNotFound_instance_0;
}
var Companion_instance_572;
function Companion_getInstance_573() {
  return Companion_instance_572;
}
function get_theLastAppliedMapUiScalingAndPosition() {
  _init_properties_SavedAnswersSource_kt__ck24mv();
  return theLastAppliedMapUiScalingAndPosition;
}
var theLastAppliedMapUiScalingAndPosition;
var replayAnswerShortcuts;
var AnotherAnswerReaction_ForbidOtherVariants_instance;
var AnotherAnswerReaction_ReshowVariants_instance;
var AnotherAnswerReaction_AllowOtherAnswers_instance;
var AnotherAnswerReaction_entriesInitialized;
function AnotherAnswerReaction_initEntries() {
  if (AnotherAnswerReaction_entriesInitialized)
    return Unit_instance;
  AnotherAnswerReaction_entriesInitialized = true;
  AnotherAnswerReaction_ForbidOtherVariants_instance = new AnotherAnswerReaction('ForbidOtherVariants', 0);
  AnotherAnswerReaction_ReshowVariants_instance = new AnotherAnswerReaction('ReshowVariants', 1);
  AnotherAnswerReaction_AllowOtherAnswers_instance = new AnotherAnswerReaction('AllowOtherAnswers', 2);
}
function _get_$cachedSerializer__te6jhj_563($this) {
  return $this.v6x_1.k3();
}
function PursuitHunterSearchAndAttackAnswer$_anonymous__9yawh0() {
  var tmp = PursuitHunterSearchAndAttackAnswer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PursuitHunterSearchAndAttackAnswer', tmp, tmp$ret$0);
}
var PursuitHunterSearchAndAttackAnswer_instance;
function PursuitHunterSearchAndAttackAnswer_getInstance() {
  if (PursuitHunterSearchAndAttackAnswer_instance === VOID)
    new PursuitHunterSearchAndAttackAnswer();
  return PursuitHunterSearchAndAttackAnswer_instance;
}
function _get_$cachedSerializer__te6jhj_564($this) {
  return $this.w6x_1.k3();
}
function PursuitHunterGainItemAndAttackSummon$_anonymous__uabef7() {
  var tmp = PursuitHunterGainItemAndAttackSummon_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('PursuitHunterGainItemAndAttackSummon', tmp, tmp$ret$0);
}
var PursuitHunterGainItemAndAttackSummon_instance;
function PursuitHunterGainItemAndAttackSummon_getInstance() {
  if (PursuitHunterGainItemAndAttackSummon_instance === VOID)
    new PursuitHunterGainItemAndAttackSummon();
  return PursuitHunterGainItemAndAttackSummon_instance;
}
var AnimationInsertionType_BeforeAnswerDialog_instance;
var AnimationInsertionType_JustBeforeAnswer_instance;
var AnimationInsertionType_AfterAnswer_instance;
var AnimationInsertionType_entriesInitialized;
function AnimationInsertionType_initEntries() {
  if (AnimationInsertionType_entriesInitialized)
    return Unit_instance;
  AnimationInsertionType_entriesInitialized = true;
  AnimationInsertionType_BeforeAnswerDialog_instance = new AnimationInsertionType('BeforeAnswerDialog', 0);
  AnimationInsertionType_JustBeforeAnswer_instance = new AnimationInsertionType('JustBeforeAnswer', 1);
  AnimationInsertionType_AfterAnswer_instance = new AnimationInsertionType('AfterAnswer', 2);
}
function AnotherAnswerReaction_ForbidOtherVariants_getInstance() {
  AnotherAnswerReaction_initEntries();
  return AnotherAnswerReaction_ForbidOtherVariants_instance;
}
function AnotherAnswerReaction_ReshowVariants_getInstance() {
  AnotherAnswerReaction_initEntries();
  return AnotherAnswerReaction_ReshowVariants_instance;
}
function AnotherAnswerReaction_AllowOtherAnswers_getInstance() {
  AnotherAnswerReaction_initEntries();
  return AnotherAnswerReaction_AllowOtherAnswers_instance;
}
function AnimationInsertionType_BeforeAnswerDialog_getInstance() {
  AnimationInsertionType_initEntries();
  return AnimationInsertionType_BeforeAnswerDialog_instance;
}
function AnimationInsertionType_JustBeforeAnswer_getInstance() {
  AnimationInsertionType_initEntries();
  return AnimationInsertionType_JustBeforeAnswer_instance;
}
function AnimationInsertionType_AfterAnswer_getInstance() {
  AnimationInsertionType_initEntries();
  return AnimationInsertionType_AfterAnswer_instance;
}
var properties_initialized_SavedAnswersSource_kt_kffd85;
function _init_properties_SavedAnswersSource_kt__ck24mv() {
  if (!properties_initialized_SavedAnswersSource_kt_kffd85) {
    properties_initialized_SavedAnswersSource_kt_kffd85 = true;
    // Inline function 'kotlin.collections.mutableMapOf' call
    theLastAppliedMapUiScalingAndPosition = LinkedHashMap.m7();
    replayAnswerShortcuts = mapOf([to(PursuitHunterSearchAndAttackAnswer_getInstance().a2g().dz().g10(), PursuitHunterSearchAndAttackAnswer_getInstance()), to(PursuitHunterGainItemAndAttackSummon_getInstance().a2g().dz().g10(), PursuitHunterGainItemAndAttackSummon_getInstance())]);
  }
}
function ruinName($this, $context_GameState_t6qee5, position) {
  var tmp0_safe_receiver = $this.y6z_1.w4(get_gameMap_1($context_GameState_t6qee5).y44());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4(new BoardPosition(position));
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp1_safe_receiver + 'Ruin';
  }
  return tmp;
}
function stableHashCode(gameStateImpl) {
  var result = {_v: 1};
  stableHashCode$combine_0(result, get_balanceVersion(gameStateImpl.y37_1).v1_1);
  stableHashCode$combine_0(result, get_gameContentVersion(gameStateImpl.y37_1));
  stableHashCode$combine_0(result, gameStateImpl.y37_1.h3a());
  stableHashCode$combine_0(result, gameStateImpl.y37_1.c3a().y4f_1);
  stableHashCode$combine_0(result, gameStateImpl.y37_1.c3a().z4f_1);
  stableHashCode$combine_0(result, gameStateImpl.y37_1.c3a().a4g_1);
  stableHashCode$combineList(result, gameStateImpl.c38_1);
  stableHashCode$combine_0(result, gameStateImpl.d38_1);
  stableHashCode$combine(result, gameStateImpl.e38_1);
  stableHashCode$combine(result, gameStateImpl.f38_1);
  stableHashCode$combine(result, gameStateImpl.g38_1);
  stableHashCode$combineMap(result, gameStateImpl.j38_1);
  stableHashCode$combineMap(result, gameStateImpl.l38_1);
  stableHashCode$combineSet(result, gameStateImpl.m38_1);
  stableHashCode$combineSet(result, gameStateImpl.k38_1);
  stableHashCode$combineSet(result, gameStateImpl.n38_1);
  stableHashCode$combineSet(result, gameStateImpl.o38_1);
  var draft = gameStateImpl.p38_1;
  stableHashCode$combine_0(result, !(draft == null));
  if (!(draft == null)) {
    stableHashCode$combineList(result, draft.o4m_1, stableHashCode$lambda);
    stableHashCode$combineList(result, draft.p4m_1, stableHashCode$lambda_0);
    stableHashCode$combineList(result, draft.q4m_1, stableHashCode$lambda_1);
    stableHashCode$combineSet(result, draft.r4m_1);
    stableHashCode$combine_0(result, draft.s4m_1);
    if (draft.t4m_1) {
      stableHashCode$combine(result, 1);
    }
    var tmp0_safe_receiver = draft.u4m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      stableHashCode$combine(result, 10 + tmp0_safe_receiver.w1_1 | 0);
    }
  }
  stableHashCode$combine(result, gameStateImpl.q38_1);
  stableHashCode$combineSet(result, gameStateImpl.r38_1);
  stableHashCode$combineSet(result, gameStateImpl.s38_1);
  stableHashCode$combine(result, stableHashCode$combineDealingDamage(gameStateImpl.t38_1));
  var tmp = gameStateImpl.u38_1;
  stableHashCode$combineList(result, tmp, stableHashCode$lambda_2);
  var tmp_0 = gameStateImpl.v38_1;
  var tmp_1 = stableHashCode$lambda_3;
  stableHashCode$combineMap(result, tmp_0, tmp_1, stableHashCode$lambda_4);
  var tmp_2 = gameStateImpl.w38_1;
  var tmp_3 = stableHashCode$lambda_5;
  stableHashCode$combineMap(result, tmp_2, tmp_3, stableHashCode$lambda_6);
  stableHashCode$combineMap(result, gameStateImpl.x38_1);
  stableHashCode$combineMap(result, gameStateImpl.y38_1);
  stableHashCode$combineSet(result, gameStateImpl.z38_1);
  var tmp_4 = gameStateImpl.a39_1;
  stableHashCode$combineList(result, tmp_4, stableHashCode$lambda_7);
  var tmp1_safe_receiver = gameStateImpl.b39_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r2w_1;
  var tmp_5;
  var tmp_6 = tmp2_safe_receiver;
  if ((tmp_6 == null ? null : new EntityId(tmp_6)) == null) {
    tmp_5 = null;
  } else {
    tmp_5 = _EntityId___get_id__impl__v6colh(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_5;
  stableHashCode$combine(result, tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs);
  stableHashCode$combine(result, gameStateImpl.c39_1);
  var tmp_7 = gameStateImpl.d39_1;
  var tmp_8 = stableHashCode$lambda_8;
  stableHashCode$combineMap(result, tmp_7, tmp_8, stableHashCode$lambda_9);
  stableHashCode$combine_0(result, gameStateImpl.e39_1);
  stableHashCode$combine_0(result, gameStateImpl.f39_1);
  stableHashCode$combine(result, gameStateImpl.i39_1);
  stableHashCode$combine(result, gameStateImpl.g39_1);
  stableHashCode$combineArsenalDecks(result, gameStateImpl.z37_1);
  stableHashCode$combineArsenalDecks(result, gameStateImpl.a38_1);
  stableHashCode$combineArsenalDecks(result, gameStateImpl.b38_1);
  var tmp_9 = gameStateImpl.i38_1;
  stableHashCode$combineList(result, tmp_9, stableHashCode$lambda_10);
  stableHashCode$combine(result, stableHashCode$objectHash(gameStateImpl.h39_1));
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = gameStateImpl.h38_1.i3();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_10 = stableHashCode$lambda_11;
  var tmp$ret$3 = new sam$kotlin_Comparator$0_1(tmp_10);
  var sortedObjects = sortedWith(this_0, tmp$ret$3);
  stableHashCode$combineList(result, sortedObjects, stableHashCode$lambda_12);
  return result._v;
}
function stableHashCode$combineList$lambda(it) {
  return stableHashCode$getStableHash(it);
}
function stableHashCode$combineSet$lambda(it) {
  return stableHashCode$getStableHash(it);
}
function stableHashCode$combineMap$lambda(it) {
  return stableHashCode$getStableHash(it);
}
function stableHashCode$combineMap$lambda_0(it) {
  return stableHashCode$getStableHash(it);
}
function stableHashCode$combine(result, hash) {
  result._v = imul(31, result._v) + hash | 0;
}
function stableHashCode$getStableHash(obj) {
  var tmp;
  if (obj == null) {
    tmp = 0;
  } else {
    if (typeof obj === 'number') {
      tmp = obj;
    } else {
      if (typeof obj === 'string') {
        tmp = getStringHashCode(obj);
      } else {
        tmp = getStringHashCode(toString(obj));
      }
    }
  }
  return tmp;
}
function stableHashCode$combine_0(result, obj) {
  stableHashCode$combine(result, stableHashCode$getStableHash(obj));
}
function stableHashCode$combineList(result, list, elementHash) {
  var tmp;
  if (elementHash === VOID) {
    tmp = stableHashCode$combineList$lambda;
  } else {
    tmp = elementHash;
  }
  elementHash = tmp;
  var listHash = 1;
  var _iterator__ex2g4s = list.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    listHash = imul(31, listHash) + elementHash(element) | 0;
  }
  stableHashCode$combine(result, listHash);
}
function stableHashCode$combineSet(result, set, elementHash) {
  var tmp;
  if (elementHash === VOID) {
    tmp = stableHashCode$combineSet$lambda;
  } else {
    tmp = elementHash;
  }
  elementHash = tmp;
  var setHash = 0;
  var _iterator__ex2g4s = set.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    setHash = setHash + elementHash(element) | 0;
  }
  stableHashCode$combine(result, count(set));
  stableHashCode$combine(result, setHash);
}
function stableHashCode$combineMap(result, map, keyHash, valueHash) {
  var tmp;
  if (keyHash === VOID) {
    tmp = stableHashCode$combineMap$lambda;
  } else {
    tmp = keyHash;
  }
  keyHash = tmp;
  var tmp_0;
  if (valueHash === VOID) {
    tmp_0 = stableHashCode$combineMap$lambda_0;
  } else {
    tmp_0 = valueHash;
  }
  valueHash = tmp_0;
  var mapHash = 0;
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = map.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.j3();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.k3();
    mapHash = mapHash + (keyHash(key) ^ valueHash(value)) | 0;
  }
  stableHashCode$combine(result, mapHash);
}
function stableHashCode$combineArsenalDecks(result, decks) {
  var decksHash = 1;
  var comingHash = 1;
  var _iterator__ex2g4s = decks.d36().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    comingHash = imul(31, comingHash) + stableHashCode$getStableHash(element) | 0;
  }
  decksHash = imul(31, decksHash) + comingHash | 0;
  var openHash = 0;
  var _iterator__ex2g4s_0 = decks.e36().p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    openHash = openHash + stableHashCode$getStableHash(element_0) | 0;
  }
  decksHash = imul(31, decksHash) + openHash | 0;
  var discardedHash = 1;
  var _iterator__ex2g4s_1 = decks.h4n().p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_1 = _iterator__ex2g4s_1.r1();
    discardedHash = imul(31, discardedHash) + stableHashCode$getStableHash(element_1) | 0;
  }
  decksHash = imul(31, decksHash) + discardedHash | 0;
  decksHash = imul(31, decksHash) + decks.i4n() | 0;
  stableHashCode$combine(result, decksHash);
}
function stableHashCode$combineProperty(property) {
  if (property == null)
    return 0;
  var tmp;
  if (property instanceof PlayableCardSetWrapper) {
    var setHash = 0;
    var _iterator__ex2g4s = property.s3p_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var card = _iterator__ex2g4s.r1();
      setHash = setHash + stableHashCode$getStableHash(card) | 0;
    }
    tmp = setHash;
  } else {
    if (property instanceof MovementAndStateListWrapper) {
      var listHash = 1;
      var _iterator__ex2g4s_0 = property.r3g_1.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var ms = _iterator__ex2g4s_0.r1();
        var msHash = 1;
        var movsHash = 1;
        var _iterator__ex2g4s_1 = ms.i3g_1.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var m = _iterator__ex2g4s_1.r1();
          movsHash = imul(31, movsHash) + stableHashCode$getStableHash(m) | 0;
        }
        msHash = imul(31, msHash) + movsHash | 0;
        msHash = imul(31, msHash) + stableHashCode$getStableHash(ms.k3g_1) | 0;
        msHash = imul(31, msHash) + stableHashCode$getStableHash(ms.j3g_1) | 0;
        listHash = imul(31, listHash) + msHash | 0;
      }
      tmp = listHash;
    } else {
      if (property instanceof BoardPositionToIntMapWrapper) {
        var mapHash = 0;
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_2 = property.q3g_1.i3().p1();
        while (_iterator__ex2g4s_2.q1()) {
          var _destruct__k2r9zo = _iterator__ex2g4s_2.r1();
          // Inline function 'kotlin.collections.component1' call
          var pos = _destruct__k2r9zo.j3().r2v_1;
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.k3();
          mapHash = mapHash + (stableHashCode$getStableHash(new BoardPosition(pos)) ^ stableHashCode$getStableHash(value)) | 0;
        }
        tmp = mapHash;
      } else {
        if (property instanceof BoardPositionSetWrapper) {
          var setHash_0 = 0;
          var _iterator__ex2g4s_3 = property.k39_1.p1();
          while (_iterator__ex2g4s_3.q1()) {
            var position = _iterator__ex2g4s_3.r1().r2v_1;
            setHash_0 = setHash_0 + stableHashCode$getStableHash(new BoardPosition(position)) | 0;
          }
          tmp = setHash_0;
        } else {
          if (property instanceof BeastPathStepListWrapper) {
            var listHash_0 = 1;
            var _iterator__ex2g4s_4 = property.s3g_1.p1();
            while (_iterator__ex2g4s_4.q1()) {
              var step = _iterator__ex2g4s_4.r1();
              var stepHash = 1;
              var movsHash_0 = 1;
              var _iterator__ex2g4s_5 = step.x3f_1.p1();
              while (_iterator__ex2g4s_5.q1()) {
                var mov = _iterator__ex2g4s_5.r1();
                var movHash = 1;
                movHash = imul(31, movHash) + stableHashCode$getStableHash(new BoardPosition(mov.v3g_1)) | 0;
                movHash = imul(31, movHash) + stableHashCode$getStableHash(mov.w3g_1) | 0;
                movsHash_0 = imul(31, movsHash_0) + movHash | 0;
              }
              stepHash = imul(31, stepHash) + movsHash_0 | 0;
              stepHash = imul(31, stepHash) + stableHashCode$getStableHash(step.y3f_1) | 0;
              listHash_0 = imul(31, listHash_0) + stepHash | 0;
            }
            tmp = listHash_0;
          } else {
            if (property instanceof BoardPositionWrapper) {
              tmp = stableHashCode$getStableHash(new BoardPosition(property.t3g_1));
            } else {
              if (property instanceof SnareTypeWrapper) {
                tmp = stableHashCode$getStableHash(property.y5e_1);
              } else {
                if (property instanceof IntWrapper) {
                  tmp = stableHashCode$getStableHash(property.t3p_1);
                } else {
                  if (property instanceof BooleanWrapper) {
                    tmp = stableHashCode$getStableHash(property.j3w_1);
                  } else {
                    if (property instanceof ObjectOnBoardWrapper) {
                      var tmp1_safe_receiver = property.i3f_1;
                      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r2w_1;
                      var tmp_0;
                      var tmp_1 = tmp2_safe_receiver;
                      if ((tmp_1 == null ? null : new EntityId(tmp_1)) == null) {
                        tmp_0 = null;
                      } else {
                        tmp_0 = _EntityId___get_id__impl__v6colh(tmp2_safe_receiver);
                      }
                      var tmp3_elvis_lhs = tmp_0;
                      tmp = tmp3_elvis_lhs == null ? -1 : tmp3_elvis_lhs;
                    } else {
                      tmp = stableHashCode$getStableHash(property);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function stableHashCode$combineDealingDamage(dd) {
  if (dd == null)
    return 0;
  var ddHash = 1;
  ddHash = imul(31, ddHash) + stableHashCode$getStableHash(dd.a3s_1) | 0;
  ddHash = imul(31, ddHash) + stableHashCode$getStableHash(dd.b3s_1) | 0;
  ddHash = imul(31, ddHash) + stableHashCode$getStableHash(dd.c3s_1) | 0;
  var tmp = imul(31, ddHash);
  var tmp0_safe_receiver = dd.d3s_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2w_1;
  var tmp_0;
  var tmp_1 = tmp1_safe_receiver;
  if ((tmp_1 == null ? null : new EntityId(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = _EntityId___get_id__impl__v6colh(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp_0;
  ddHash = tmp + (tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs) | 0;
  var instancesHash = 0;
  var _iterator__ex2g4s = dd.e3s_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var instance = _iterator__ex2g4s.r1();
    var instHash = 1;
    instHash = imul(31, instHash) + _EntityId___get_id__impl__v6colh(instance.r3s_1.r2w_1) | 0;
    instHash = imul(31, instHash) + instance.s3s_1 | 0;
    var tmp_2 = imul(31, instHash);
    var tmp_3 = instance.t3s_1;
    instHash = tmp_2 + stableHashCode$getStableHash(tmp_3 == null ? null : new BoardPosition(tmp_3)) | 0;
    instancesHash = instancesHash + instHash | 0;
  }
  ddHash = imul(31, ddHash) + instancesHash | 0;
  return ddHash;
}
function stableHashCode$lambda(cards) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = cards.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp = sum;
    sum = tmp + stableHashCode$getStableHash(element) | 0;
  }
  return sum;
}
function stableHashCode$lambda_0(cards) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = cards.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var hash = accumulator;
    accumulator = imul(31, hash) + stableHashCode$getStableHash(element) | 0;
  }
  return accumulator;
}
function stableHashCode$lambda_1(cards) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = cards.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp = sum;
    sum = tmp + stableHashCode$getStableHash(element) | 0;
  }
  return sum;
}
function stableHashCode$lambda_2(db) {
  var dbHash = 1;
  dbHash = imul(31, dbHash) + _EntityId___get_id__impl__v6colh(db.l3s_1.r2w_1) | 0;
  dbHash = imul(31, dbHash) + db.m3s_1 | 0;
  return dbHash;
}
function stableHashCode$lambda_3(it) {
  return stableHashCode$getStableHash(it);
}
function stableHashCode$lambda_4(it) {
  var setHash = 0;
  var _iterator__ex2g4s = it.p1();
  while (_iterator__ex2g4s.q1()) {
    var e = _iterator__ex2g4s.r1();
    setHash = setHash + stableHashCode$getStableHash(e) | 0;
  }
  return setHash;
}
function stableHashCode$lambda_5(it) {
  return stableHashCode$getStableHash(it);
}
function stableHashCode$lambda_6(pt) {
  var ptHash = 1;
  ptHash = imul(31, ptHash) + stableHashCode$getStableHash(pt.g4o_1) | 0;
  ptHash = imul(31, ptHash) + stableHashCode$getStableHash(pt.h4o_1) | 0;
  ptHash = imul(31, ptHash) + stableHashCode$getStableHash(pt.i4o_1) | 0;
  ptHash = imul(31, ptHash) + _EntityId___get_id__impl__v6colh(pt.j4o_1.r2w_1) | 0;
  ptHash = imul(31, ptHash) + pt.k4o_1 | 0;
  return ptHash;
}
function stableHashCode$lambda_7(dr) {
  var drHash = 1;
  drHash = imul(31, drHash) + _EntityId___get_id__impl__v6colh(dr.o3a_1.r2w_1) | 0;
  drHash = imul(31, drHash) + stableHashCode$getStableHash(new GameTeam(dr.p3a_1)) | 0;
  var tmp = imul(31, drHash);
  var tmp0_safe_receiver = dr.q3a_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2w_1;
  var tmp_0;
  var tmp_1 = tmp1_safe_receiver;
  if ((tmp_1 == null ? null : new EntityId(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = _EntityId___get_id__impl__v6colh(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp_0;
  drHash = tmp + (tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs) | 0;
  drHash = imul(31, drHash) + dr.r3a_1 | 0;
  drHash = imul(31, drHash) + stableHashCode$getStableHash(dr.s3a_1) | 0;
  return drHash;
}
function stableHashCode$lambda_8(it) {
  return stableHashCode$getStableHash(it);
}
function stableHashCode$lambda_9(knownInfo) {
  var knownInfoHash = 0;
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = knownInfo.e4o_1.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var place = _destruct__k2r9zo.j3();
    // Inline function 'kotlin.collections.component2' call
    var cards = _destruct__k2r9zo.k3();
    var setHash = 0;
    var _iterator__ex2g4s_0 = cards.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var card = _iterator__ex2g4s_0.r1();
      setHash = setHash + stableHashCode$getStableHash(card) | 0;
    }
    knownInfoHash = knownInfoHash + (stableHashCode$getStableHash(place) ^ setHash) | 0;
  }
  return knownInfoHash;
}
function stableHashCode$lambda_10(it) {
  return _EntityId___get_id__impl__v6colh(it.r2w_1);
}
function stableHashCode$objectHash(impl) {
  var hash = 31 + _EntityId___get_id__impl__v6colh(impl.u4l_1) | 0;
  var propertiesHash = 0;
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = impl.v4l_1.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.j3().v5c_1;
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.k3();
    propertiesHash = propertiesHash + (stableHashCode$getStableHash(_GeneralMapKey___get_key__impl__tk32ss(key)) ^ stableHashCode$combineProperty(value)) | 0;
  }
  hash = imul(31, hash) + propertiesHash | 0;
  return hash;
}
function stableHashCode$lambda_11(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = _EntityId___get_id__impl__v6colh(a.j3().c3y_1);
  var tmp$ret$2 = _EntityId___get_id__impl__v6colh(b.j3().c3y_1);
  return compareValues(tmp, tmp$ret$2);
}
function stableHashCode$lambda_12(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var id = _destruct__k2r9zo.j3().c3y_1;
  // Inline function 'kotlin.collections.component2' call
  var impl = _destruct__k2r9zo.k3();
  return imul(31, _EntityId___get_id__impl__v6colh(id)) + stableHashCode$objectHash(impl) | 0;
}
function defaultAnswer($context_GameStateRuntime_604ce3, gameQuestion, mayNothing) {
  var tmp;
  var tmp_0;
  if (mayNothing) {
    tmp_0 = gameQuestion instanceof StatementQuestion;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp0 = gameQuestion.d4b_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(tmp0, Collection)) {
        tmp_1 = tmp0.n1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.o2o($context_GameStateRuntime_604ce3)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp = tmp$ret$0;
  } else {
    tmp = false;
  }
  if (tmp) {
    return new DefaultAnswer(null);
  }
  var tmp0_safe_receiver = defaultAnswerImpl($context_GameStateRuntime_604ce3, gameQuestion, mayNothing);
  var tmp_2;
  if (tmp0_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = new DefaultAnswer(tmp0_safe_receiver);
  }
  return tmp_2;
}
function defaultAnswerImpl($context_GameStateRuntime_604ce3, gameQuestion, mayNothing) {
  var tmp = gameQuestion.t3o();
  if (tmp instanceof BeingToMoveAlongsideQuestionContext) {
    return null;
  }
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    var singleVariant = singleOrNull_0(gameQuestion.y4a_1);
    if (equals(singleVariant, PassVariant_getInstance())) {
      return singleVariant;
    }
  }
  if (gameQuestion instanceof StatementQuestion) {
    var variants = gameQuestion.d4b_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = variants.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp_0;
        if (element instanceof GainGrudgeStatement) {
          tmp_0 = true;
        } else {
          var tmp_1;
          if (element instanceof GainAncientPowerStatement) {
            tmp_1 = get_remainAncientPowers($context_GameStateRuntime_604ce3) >= 0;
          } else {
            tmp_1 = false;
          }
          tmp_0 = tmp_1;
        }
        if (tmp_0) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var tmp_2;
    var tmp_3;
    var tmp_4;
    if (variants.s2() === 2) {
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.collections.all' call
        var tmp_5;
        if (isInterface(variants, Collection)) {
          tmp_5 = variants.n1();
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          tmp$ret$4 = true;
          break $l$block_1;
        }
        var _iterator__ex2g4s_0 = variants.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (!(element_0 instanceof InAnyOrderStatement)) {
            tmp$ret$4 = false;
            break $l$block_1;
          }
        }
        tmp$ret$4 = true;
      }
      tmp_4 = tmp$ret$4;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      var tmp$ret$6;
      $l$block_5: {
        // Inline function 'kotlin.collections.any' call
        var tmp_6;
        if (isInterface(variants, Collection)) {
          tmp_6 = variants.n1();
        } else {
          tmp_6 = false;
        }
        if (tmp_6) {
          tmp$ret$6 = false;
          break $l$block_5;
        }
        var _iterator__ex2g4s_1 = variants.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var element_1 = _iterator__ex2g4s_1.r1();
          var tmp0 = (element_1 instanceof InAnyOrderStatement ? element_1 : THROW_CCE()).v2o($context_GameStateRuntime_604ce3);
          var tmp$ret$8;
          $l$block_4: {
            // Inline function 'kotlin.collections.any' call
            var tmp_7;
            if (isInterface(tmp0, Collection)) {
              tmp_7 = tmp0.n1();
            } else {
              tmp_7 = false;
            }
            if (tmp_7) {
              tmp$ret$8 = false;
              break $l$block_4;
            }
            var _iterator__ex2g4s_2 = tmp0.p1();
            while (_iterator__ex2g4s_2.q1()) {
              var element_2 = _iterator__ex2g4s_2.r1();
              if (element_2 instanceof SearchForBeastStatement) {
                tmp$ret$8 = true;
                break $l$block_4;
              }
            }
            tmp$ret$8 = false;
          }
          if (tmp$ret$8) {
            tmp$ret$6 = true;
            break $l$block_5;
          }
        }
        tmp$ret$6 = false;
      }
      tmp_3 = tmp$ret$6;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      var tmp$ret$10;
      $l$block_9: {
        // Inline function 'kotlin.collections.any' call
        var tmp_8;
        if (isInterface(variants, Collection)) {
          tmp_8 = variants.n1();
        } else {
          tmp_8 = false;
        }
        if (tmp_8) {
          tmp$ret$10 = false;
          break $l$block_9;
        }
        var _iterator__ex2g4s_3 = variants.p1();
        while (_iterator__ex2g4s_3.q1()) {
          var element_3 = _iterator__ex2g4s_3.r1();
          var tmp0_0 = (element_3 instanceof InAnyOrderStatement ? element_3 : THROW_CCE()).v2o($context_GameStateRuntime_604ce3);
          var tmp$ret$12;
          $l$block_8: {
            // Inline function 'kotlin.collections.any' call
            var tmp_9;
            if (isInterface(tmp0_0, Collection)) {
              tmp_9 = tmp0_0.n1();
            } else {
              tmp_9 = false;
            }
            if (tmp_9) {
              tmp$ret$12 = false;
              break $l$block_8;
            }
            var _iterator__ex2g4s_4 = tmp0_0.p1();
            while (_iterator__ex2g4s_4.q1()) {
              var element_4 = _iterator__ex2g4s_4.r1();
              if (element_4 instanceof GainHunterItemStatement) {
                tmp$ret$12 = true;
                break $l$block_8;
              }
            }
            tmp$ret$12 = false;
          }
          if (tmp$ret$12) {
            tmp$ret$10 = true;
            break $l$block_9;
          }
        }
        tmp$ret$10 = false;
      }
      tmp_2 = tmp$ret$10;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(collectionSizeOrDefault(variants, 10));
      var _iterator__ex2g4s_5 = variants.p1();
      while (_iterator__ex2g4s_5.q1()) {
        var item = _iterator__ex2g4s_5.r1();
        var tmp$ret$16 = (item instanceof InAnyOrderStatement ? item : THROW_CCE()).v2o($context_GameStateRuntime_604ce3);
        destination.d2(tmp$ret$16);
      }
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0_1 = flatten(destination);
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination_0 = ArrayList.p2();
      var _iterator__ex2g4s_6 = tmp0_1.p1();
      while (_iterator__ex2g4s_6.q1()) {
        var element_5 = _iterator__ex2g4s_6.r1();
        if (element_5 instanceof GainHunterItemStatement) {
          destination_0.d2(element_5);
        }
      }
      var hunter = single_0(single(destination_0).k2p_1);
      // Inline function 'kotlin.collections.filter' call
      var tmp0_2 = get_aliveBeasts_0($context_GameStateRuntime_604ce3);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_1 = ArrayList.p2();
      var _iterator__ex2g4s_7 = tmp0_2.p1();
      while (_iterator__ex2g4s_7.q1()) {
        var element_6 = _iterator__ex2g4s_7.r1();
        if (get_isRevealed($context_GameStateRuntime_604ce3, element_6)) {
          destination_1.d2(element_6);
        }
      }
      var tmp$ret$22;
      $l$block_11: {
        // Inline function 'kotlin.collections.any' call
        var tmp_10;
        if (isInterface(destination_1, Collection)) {
          tmp_10 = destination_1.n1();
        } else {
          tmp_10 = false;
        }
        if (tmp_10) {
          tmp$ret$22 = false;
          break $l$block_11;
        }
        var _iterator__ex2g4s_8 = destination_1.p1();
        while (_iterator__ex2g4s_8.q1()) {
          var element_7 = _iterator__ex2g4s_8.r1();
          if (element_7.s2w($context_GameStateRuntime_604ce3) === hunter.s2w($context_GameStateRuntime_604ce3)) {
            tmp$ret$22 = true;
            break $l$block_11;
          }
        }
        tmp$ret$22 = false;
      }
      var mayAttackBeast = tmp$ret$22;
      // Inline function 'kotlin.collections.filter' call
      var tmp0_3 = get_aliveBeasts_0($context_GameStateRuntime_604ce3);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList.p2();
      var _iterator__ex2g4s_9 = tmp0_3.p1();
      while (_iterator__ex2g4s_9.q1()) {
        var element_8 = _iterator__ex2g4s_9.r1();
        if (get_isHidden($context_GameStateRuntime_604ce3, element_8)) {
          destination_2.d2(element_8);
        }
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList.n2(collectionSizeOrDefault(destination_2, 10));
      var _iterator__ex2g4s_10 = destination_2.p1();
      while (_iterator__ex2g4s_10.q1()) {
        var item_0 = _iterator__ex2g4s_10.r1();
        var tmp$ret$29 = plus_0(get_foundTrails($context_GameStateRuntime_604ce3, item_0).x4(), new BoardPosition(get_lastSeenPosition($context_GameStateRuntime_604ce3, item_0)));
        destination_3.d2(tmp$ret$29);
      }
      var mayTrySearch = flatten(destination_3).w2(new BoardPosition(hunter.s2w($context_GameStateRuntime_604ce3)));
      if (!mayAttackBeast && !mayTrySearch) {
        // Inline function 'kotlin.collections.single' call
        var single_1 = null;
        var found = false;
        var _iterator__ex2g4s_11 = variants.p1();
        while (_iterator__ex2g4s_11.q1()) {
          var element_9 = _iterator__ex2g4s_11.r1();
          var tmp0_4 = (element_9 instanceof InAnyOrderStatement ? element_9 : THROW_CCE()).v2o($context_GameStateRuntime_604ce3);
          var tmp$ret$32;
          $l$block_13: {
            // Inline function 'kotlin.collections.any' call
            var tmp_11;
            if (isInterface(tmp0_4, Collection)) {
              tmp_11 = tmp0_4.n1();
            } else {
              tmp_11 = false;
            }
            if (tmp_11) {
              tmp$ret$32 = false;
              break $l$block_13;
            }
            var _iterator__ex2g4s_12 = tmp0_4.p1();
            while (_iterator__ex2g4s_12.q1()) {
              var element_10 = _iterator__ex2g4s_12.r1();
              if (element_10 instanceof GainHunterItemStatement) {
                tmp$ret$32 = true;
                break $l$block_13;
              }
            }
            tmp$ret$32 = false;
          }
          if (tmp$ret$32) {
            if (found)
              throw IllegalArgumentException.h2('Collection contains more than one matching element.');
            single_1 = element_9;
            found = true;
          }
        }
        if (!found)
          throw NoSuchElementException.a2('Collection contains no element matching the predicate.');
        return single_1;
      }
    }
    var tmp$ret$34;
    $l$block_15: {
      // Inline function 'kotlin.collections.singleOrNull' call
      var single_2 = null;
      var found_0 = false;
      var _iterator__ex2g4s_13 = variants.p1();
      while (_iterator__ex2g4s_13.q1()) {
        var element_11 = _iterator__ex2g4s_13.r1();
        if (element_11.o2o($context_GameStateRuntime_604ce3)) {
          if (found_0) {
            tmp$ret$34 = null;
            break $l$block_15;
          }
          single_2 = element_11;
          found_0 = true;
        }
      }
      if (!found_0) {
        tmp$ret$34 = null;
        break $l$block_15;
      }
      tmp$ret$34 = single_2;
    }
    var singleVariantWithEffect = tmp$ret$34;
    if (!(singleVariantWithEffect == null)) {
      var tmp_12;
      var tmp_13;
      if (singleVariantWithEffect instanceof SearchForBeastStatement) {
        var tmp_14 = singleOrNull_0(minus_0(variants, singleVariantWithEffect));
        tmp_13 = tmp_14 instanceof AttackStatement;
      } else {
        tmp_13 = false;
      }
      if (tmp_13) {
        var tmp0_5 = objectsAt_0($context_GameStateRuntime_604ce3, singleVariantWithEffect.o34_1.s2w($context_GameStateRuntime_604ce3));
        var tmp$ret$36;
        $l$block_17: {
          // Inline function 'kotlin.collections.none' call
          var tmp_15;
          if (isInterface(tmp0_5, Collection)) {
            tmp_15 = tmp0_5.n1();
          } else {
            tmp_15 = false;
          }
          if (tmp_15) {
            tmp$ret$36 = true;
            break $l$block_17;
          }
          var _iterator__ex2g4s_14 = tmp0_5.p1();
          while (_iterator__ex2g4s_14.q1()) {
            var element_12 = _iterator__ex2g4s_14.r1();
            var tmp_16 = get_objectType($context_GameStateRuntime_604ce3, element_12);
            if (isInterface(tmp_16, SummonType)) {
              tmp$ret$36 = false;
              break $l$block_17;
            }
          }
          tmp$ret$36 = true;
        }
        tmp_12 = tmp$ret$36;
      } else {
        tmp_12 = false;
      }
      if (tmp_12) {
        return singleVariantWithEffect;
      }
      var tmp_17;
      if (singleVariantWithEffect instanceof MovementStepByStepStatement) {
        var tmp_18 = get_objectType($context_GameStateRuntime_604ce3, singleVariantWithEffect.f2p());
        tmp_17 = !isInterface(tmp_18, BeastCharacter);
      } else {
        tmp_17 = false;
      }
      if (tmp_17) {
        return singleVariantWithEffect;
      }
      if (canBeAppliedByDefaultAsSingleVariant($context_GameStateRuntime_604ce3, singleVariantWithEffect)) {
        return singleVariantWithEffect;
      }
      var lastScope = lastOrNull(get_gameScopes($context_GameStateRuntime_604ce3));
      var tmp_19;
      if (lastScope instanceof CardApplyingScope) {
        var tmp_20;
        if (equals(setOf(lastScope.k4h_1), variants)) {
          tmp_20 = true;
        } else {
          // Inline function 'kotlin.let' call
          var it = lastScope.k4h_1;
          var tmp_21;
          if (it instanceof InAnyOrderStatement) {
            tmp_21 = equals(it.v2o($context_GameStateRuntime_604ce3), variants);
          } else {
            tmp_21 = false;
          }
          tmp_20 = tmp_21;
        }
        tmp_19 = tmp_20;
      } else {
        tmp_19 = false;
      }
      if (tmp_19) {
        return singleVariantWithEffect;
      }
    }
  }
  if (gameQuestion.s3o().s2() === 1 && mayNothing) {
    var defaultAnswer = single_0(gameQuestion.s3o());
    if (gameQuestion instanceof ObjectsGameQuestion) {
      var lastScope_0 = lastOrNull(get_gameScopes($context_GameStateRuntime_604ce3));
      var tmp_22;
      var tmp_23;
      var tmp_24;
      if (lastScope_0 instanceof AttackStatement) {
        tmp_24 = true;
      } else {
        var tmp_25;
        if (lastScope_0 instanceof ReactionCardScope) {
          var tmp_26 = lastScope_0.h4j_1;
          tmp_25 = tmp_26 instanceof SmokeBombCard;
        } else {
          tmp_25 = false;
        }
        tmp_24 = tmp_25;
      }
      if (tmp_24) {
        tmp_23 = true;
      } else {
        var tmp_27;
        if (lastScope_0 instanceof CardApplyingScope) {
          var tmp_28 = lastScope_0.k4h_1;
          tmp_27 = tmp_28 instanceof AttackStatement;
        } else {
          tmp_27 = false;
        }
        tmp_23 = tmp_27;
      }
      if (tmp_23) {
        tmp_22 = true;
      } else {
        var tmp_29;
        if (!(lastScope_0 == null) ? isInterface(lastScope_0, ActionStatement) : false) {
          tmp_29 = canBeAppliedByDefaultAsSingleVariant($context_GameStateRuntime_604ce3, lastScope_0);
        } else {
          tmp_29 = false;
        }
        tmp_22 = tmp_29;
      }
      if (tmp_22) {
        return defaultAnswer;
      }
    }
    if (gameQuestion instanceof StatementQuestion) {
      if (canBeAppliedByDefaultAsSingleVariant($context_GameStateRuntime_604ce3, (!(defaultAnswer == null) ? isInterface(defaultAnswer, ActionStatement) : false) ? defaultAnswer : THROW_CCE())) {
        return defaultAnswer;
      }
    }
    var tmp_30;
    if (defaultAnswer instanceof TriggerOption) {
      tmp_30 = canBeAppliedByDefaultAsSingleVariant($context_GameStateRuntime_604ce3, defaultAnswer.l4c_1);
    } else {
      tmp_30 = false;
    }
    if (tmp_30) {
      return defaultAnswer;
    }
  }
  return null;
}
function canBeAppliedByDefaultAsSingleVariant($context_GameStateRuntime_604ce3, _this__u8e3s4) {
  if (!_this__u8e3s4.n2o($context_GameStateRuntime_604ce3))
    return false;
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof GainHunterItemStatement) {
    tmp_0 = true;
  } else {
    var tmp_1;
    if (_this__u8e3s4 instanceof GainBeastlyTalentStatement) {
      tmp_1 = true;
    } else {
      tmp_1 = _this__u8e3s4 instanceof RevealLastMovementsStatement;
    }
    tmp_0 = tmp_1;
  }
  if (tmp_0) {
    tmp = true;
  } else {
    if (_this__u8e3s4 instanceof AttackStatement) {
      var tmp_2;
      var tmp_3 = get_objectType($context_GameStateRuntime_604ce3, _this__u8e3s4.k2q_1);
      if (!isInterface(tmp_3, BeastCharacter)) {
        var tmp_4 = get_objectType($context_GameStateRuntime_604ce3, _this__u8e3s4.k2q_1);
        tmp_2 = !isInterface(tmp_4, SummonType);
      } else {
        tmp_2 = false;
      }
      tmp = tmp_2;
    } else {
      if (_this__u8e3s4 instanceof BeastMovementStatement) {
        var tmp0 = objectsAt_0($context_GameStateRuntime_604ce3, _this__u8e3s4.f2p().s2w($context_GameStateRuntime_604ce3));
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.none' call
          var tmp_5;
          if (isInterface(tmp0, Collection)) {
            tmp_5 = tmp0.n1();
          } else {
            tmp_5 = false;
          }
          if (tmp_5) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            var tmp_6 = get_objectType($context_GameStateRuntime_604ce3, element);
            if (isInterface(tmp_6, HumanKindType)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof HealNearbyHuntersAndSettlersStatement) {
          tmp = true;
        } else {
          if (_this__u8e3s4 instanceof MoveSeveralHuntersStatement) {
            tmp = true;
          } else {
            if (_this__u8e3s4 instanceof MovementStepByStepStatement) {
              tmp = true;
            } else {
              if (_this__u8e3s4 instanceof RetrieveDiscardedAbilityStatement) {
                tmp = true;
              } else {
                if (_this__u8e3s4 instanceof GreatHowlStatement) {
                  tmp = true;
                } else {
                  if (_this__u8e3s4 instanceof SummonMovesStatement) {
                    tmp = true;
                  } else {
                    if (_this__u8e3s4 instanceof InAnyOrderStatement) {
                      var tmp1_safe_receiver = singleOrNull_0(_this__u8e3s4.v2o($context_GameStateRuntime_604ce3));
                      tmp = (tmp1_safe_receiver == null ? null : canBeAppliedByDefaultAsSingleVariant($context_GameStateRuntime_604ce3, tmp1_safe_receiver)) === true;
                    } else {
                      tmp = false;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function get_JsonFormat() {
  _init_properties_commonUtils_kt__cpkws4();
  return JsonFormat;
}
var JsonFormat;
function toLinkedSet(_this__u8e3s4) {
  _init_properties_commonUtils_kt__cpkws4();
  return LinkedHashSet.z2(_this__u8e3s4);
}
function listOfIf(p, elements) {
  _init_properties_commonUtils_kt__cpkws4();
  var tmp;
  var tmp_0;
  if (p) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    tmp_0 = !(elements.length === 0);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = asList(elements);
  } else {
    tmp = emptyList();
  }
  return tmp;
}
function withAddOrRemove(_this__u8e3s4, e, operation) {
  _init_properties_commonUtils_kt__cpkws4();
  // Inline function 'kotlin.apply' call
  var this_0 = toLinkedSet(_this__u8e3s4);
  addOrRemove(this_0, e, operation);
  return this_0;
}
var CollectionOperation_Add_instance;
var CollectionOperation_Remove_instance;
function values_16() {
  return [CollectionOperation_Add_getInstance(), CollectionOperation_Remove_getInstance()];
}
var CollectionOperation_entriesInitialized;
function CollectionOperation_initEntries() {
  if (CollectionOperation_entriesInitialized)
    return Unit_instance;
  CollectionOperation_entriesInitialized = true;
  CollectionOperation_Add_instance = new CollectionOperation('Add', 0);
  CollectionOperation_Remove_instance = new CollectionOperation('Remove', 1);
}
function addOrRemove(_this__u8e3s4, e, operation) {
  _init_properties_commonUtils_kt__cpkws4();
  switch (operation.w1_1) {
    case 0:
      // Inline function 'kotlin.also' call

      // Inline function 'kotlin.require' call

      if (!_this__u8e3s4.d2(e)) {
        var message = 'Duplicating ' + toString_0(e) + ' in ' + toString(_this__u8e3s4);
        throw IllegalArgumentException.h2(toString(message));
      }

      break;
    case 1:
      // Inline function 'kotlin.also' call

      // Inline function 'kotlin.require' call

      if (!_this__u8e3s4.z4(e)) {
        var message_0 = 'There was no element ' + toString_0(e) + ' in ' + toString(_this__u8e3s4);
        throw IllegalArgumentException.h2(toString(message_0));
      }

      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function withAddOrRemove_0(_this__u8e3s4, e, operation) {
  _init_properties_commonUtils_kt__cpkws4();
  // Inline function 'kotlin.apply' call
  var this_0 = toMutableList(_this__u8e3s4);
  addOrRemove(this_0, e, operation);
  return this_0;
}
function get(_this__u8e3s4, index) {
  _init_properties_commonUtils_kt__cpkws4();
  var iterator = _this__u8e3s4.p1();
  var index_0 = 0;
  while (iterator.q1()) {
    var i = index_0;
    index_0 = index_0 + 1 | 0;
    var e = iterator.r1();
    if (i === index)
      return e;
  }
  // Inline function 'kotlin.error' call
  var message = 'No element with index ' + index;
  throw IllegalStateException.o(toString(message));
}
function splitCamelCase(_this__u8e3s4) {
  _init_properties_commonUtils_kt__cpkws4();
  return joinToString(Regex.hi('(?<=[a-zA-Z])(?=[A-Z])').ti(_this__u8e3s4), ' ');
}
function *waitWithPossibilityToCancel(stopping, action, $completion) {
  var tmp;
  if (action === VOID) {
    tmp = waitWithPossibilityToCancel$slambda();
  } else {
    tmp = action;
  }
  action = tmp;
  try {
    yield* coroutineScope(waitWithPossibilityToCancel$slambda_0(action, stopping), $completion);
  } catch ($p) {
    if ($p instanceof WaitingIsCanceledException) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function JsonFormat$lambda($this$Json) {
  _init_properties_commonUtils_kt__cpkws4();
  $this$Json.v2e_1 = true;
  return Unit_instance;
}
function waitWithPossibilityToCancel$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function waitWithPossibilityToCancel$slambda$slambda($action) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $action($completion);
    throw WaitingIsCanceledException.m71();
  }, 1);
}
function waitWithPossibilityToCancel$slambda$slambda_0($stopping) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $stopping.m1q($completion);
    throw WaitingIsCanceledException.m71();
  }, 1);
}
function waitWithPossibilityToCancel$slambda_0($action, $stopping) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    launch($this$coroutineScope, VOID, VOID, waitWithPossibilityToCancel$slambda$slambda($action));
    return launch($this$coroutineScope, VOID, VOID, waitWithPossibilityToCancel$slambda$slambda_0($stopping));
  }, 1);
}
function CollectionOperation_Add_getInstance() {
  CollectionOperation_initEntries();
  return CollectionOperation_Add_instance;
}
function CollectionOperation_Remove_getInstance() {
  CollectionOperation_initEntries();
  return CollectionOperation_Remove_instance;
}
var properties_initialized_commonUtils_kt_3mpqju;
function _init_properties_commonUtils_kt__cpkws4() {
  if (!properties_initialized_commonUtils_kt_3mpqju) {
    properties_initialized_commonUtils_kt_3mpqju = true;
    JsonFormat = Json(VOID, JsonFormat$lambda);
  }
}
//region block: post-declaration
initMetadataForCompanion(Companion, VOID, [SerializerFactory]);
initMetadataForInterface(TurnVariant, 'TurnVariant', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_205});
initMetadataForInterface(GameScope, 'GameScope', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_223});
initMetadataForInterface(ItselfGameScope, 'ItselfGameScope', VOID, VOID, [GameScope], VOID, VOID, {0: Companion_getInstance_240});
initMetadataForInterface(ActionStatement, 'ActionStatement', VOID, VOID, [TurnVariant, ItselfGameScope], VOID, VOID, {0: Companion_getInstance_0});
initMetadataForCompanion(Companion_0);
protoOf($serializer).z1b = typeParametersSerializers;
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(InAnyOrderStatement).n2o = canBeApplied;
initMetadataForClass(InAnyOrderStatement, 'InAnyOrderStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_1);
protoOf($serializer_0).z1b = typeParametersSerializers;
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(ObjectMovementStatement, 'ObjectMovementStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: Companion_getInstance_75});
protoOf(MovementStepByStepStatement).n2o = canBeApplied;
protoOf(MovementStepByStepStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(MovementStepByStepStatement, 'MovementStepByStepStatement', VOID, VOID, [ObjectMovementStatement], VOID, VOID, {0: Companion_getInstance_15});
initMetadataForClass(MovementUptoFixedStepsStatement, 'MovementUptoFixedStepsStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_2);
protoOf($serializer_1).z1b = typeParametersSerializers;
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PerformForEachHunter).n2o = canBeApplied;
initMetadataForClass(PerformForEachHunter, 'PerformForEachHunter', VOID, VOID, [ActionStatement], VOID, VOID, {0: Companion_getInstance_74});
initMetadataForClass(GainHunterItemStatement, 'GainHunterItemStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_3);
protoOf($serializer_2).z1b = typeParametersSerializers;
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ThenActionStatement, 'ThenActionStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_4);
protoOf($serializer_3).z1b = typeParametersSerializers;
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(TransformAllNearbyStatement).n2o = canBeApplied;
protoOf(TransformAllNearbyStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(TransformAllNearbyStatement, 'TransformAllNearbyStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_5);
protoOf($serializer_4).z1b = typeParametersSerializers;
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BeastMovementStatement).n2o = canBeApplied;
protoOf(BeastMovementStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BeastMovementStatement, 'BeastMovementStatement', VOID, VOID, [ObjectMovementStatement], VOID, VOID, {0: Companion_getInstance_8});
initMetadataForClass(SimpleBeastMovementStatement, 'SimpleBeastMovementStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForCompanion(Companion_6);
protoOf($serializer_5).z1b = typeParametersSerializers;
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AttackStatement).n2o = canBeApplied;
initMetadataForClass(AttackStatement, 'AttackStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_7, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_8);
protoOf($serializer_6).z1b = typeParametersSerializers;
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(ChooseOneOfStatementBase, 'ChooseOneOfStatementBase', VOID, VOID, [ActionStatement]);
protoOf(ChooseOneOfStatement).n2o = canBeApplied_0;
protoOf(ChooseOneOfStatement).o2o = canBeAppliedAndHaveEffect_0;
initMetadataForClass(ChooseOneOfStatement, 'ChooseOneOfStatement', VOID, VOID, [ChooseOneOfStatementBase], VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForCompanion(Companion_9);
protoOf($serializer_7).z1b = typeParametersSerializers;
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GrapnelStatement).n2o = canBeApplied;
protoOf(GrapnelStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(GrapnelStatement, 'GrapnelStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_10);
protoOf($serializer_8).z1b = typeParametersSerializers;
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RetrieveDiscardedAbilityStatement).n2o = canBeApplied;
initMetadataForClass(RetrieveDiscardedAbilityStatement, 'RetrieveDiscardedAbilityStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_8});
protoOf(DiscardPlacedTrapStatement).n2o = canBeApplied;
protoOf(DiscardPlacedTrapStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(DiscardPlacedTrapStatement, 'DiscardPlacedTrapStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: DiscardPlacedTrapStatement_getInstance});
initMetadataForCompanion(Companion_11);
protoOf($serializer_9).z1b = typeParametersSerializers;
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(TransformLocationsStatement).n2o = canBeApplied;
protoOf(TransformLocationsStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(TransformLocationsStatement, 'TransformLocationsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForCompanion(Companion_12);
protoOf($serializer_10).z1b = typeParametersSerializers;
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MoveSeveralHuntersStatement, 'MoveSeveralHuntersStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_13);
protoOf($serializer_11).z1b = typeParametersSerializers;
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(MoveEverySummonStatement).n2o = canBeApplied;
protoOf(MoveEverySummonStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(MoveEverySummonStatement, 'MoveEverySummonStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForCompanion(Companion_14, VOID, [SerializerFactory]);
protoOf(AbruptDecayActionStatement).n2o = canBeApplied;
initMetadataForObject(AbruptDecayActionStatement, 'AbruptDecayActionStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: AbruptDecayActionStatement_getInstance});
initMetadataForCompanion(Companion_15);
protoOf($serializer_12).z1b = typeParametersSerializers;
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ActivateSummonsStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ActivateSummonsStatement, 'ActivateSummonsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_12});
initMetadataForCompanion(Companion_16);
protoOf($serializer_13).z1b = typeParametersSerializers;
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ActivateTrapStatement).n2o = canBeApplied;
protoOf(ActivateTrapStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ActivateTrapStatement, 'ActivateTrapStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_13});
initMetadataForCompanion(Companion_17);
protoOf($serializer_14).z1b = typeParametersSerializers;
initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(ApplyingReactionStatement, 'ApplyingReactionStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: Companion_getInstance_73});
protoOf(DreamerMaskReactionStatement).n2o = canBeApplied;
protoOf(DreamerMaskReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(DreamerMaskReactionStatement, 'DreamerMaskReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_14});
initMetadataForCompanion(Companion_18);
protoOf($serializer_15).z1b = typeParametersSerializers;
initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(EsmeriasStrandReactionStatement).n2o = canBeApplied;
protoOf(EsmeriasStrandReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(EsmeriasStrandReactionStatement, 'EsmeriasStrandReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_15});
initMetadataForCompanion(Companion_19);
protoOf($serializer_16).z1b = typeParametersSerializers;
initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(FlareReactionStatement).n2o = canBeApplied;
protoOf(FlareReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(FlareReactionStatement, 'FlareReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_16});
initMetadataForCompanion(Companion_20);
protoOf($serializer_17).z1b = typeParametersSerializers;
initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(IntuitionReactionStatement).n2o = canBeApplied;
protoOf(IntuitionReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(IntuitionReactionStatement, 'IntuitionReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_17});
initMetadataForCompanion(Companion_21);
protoOf($serializer_18).z1b = typeParametersSerializers;
initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlayCardAsReactionStatement).n2o = canBeApplied;
protoOf(PlayCardAsReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlayCardAsReactionStatement, 'PlayCardAsReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_18});
initMetadataForCompanion(Companion_22);
protoOf($serializer_19).z1b = typeParametersSerializers;
initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SmokebombReactionStatement).n2o = canBeApplied;
protoOf(SmokebombReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SmokebombReactionStatement, 'SmokebombReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_19});
initMetadataForCompanion(Companion_23);
protoOf($serializer_20).z1b = typeParametersSerializers;
initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SuddenMistReactionStatement).n2o = canBeApplied;
protoOf(SuddenMistReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SuddenMistReactionStatement, 'SuddenMistReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_20});
initMetadataForCompanion(Companion_24);
protoOf($serializer_21).z1b = typeParametersSerializers;
initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(WorldShiftReactionStatement).n2o = canBeApplied;
protoOf(WorldShiftReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(WorldShiftReactionStatement, 'WorldShiftReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_21});
protoOf(CannotBePlayedStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(CannotBePlayedStatement, 'CannotBePlayedStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: CannotBePlayedStatement_getInstance});
initMetadataForCompanion(Companion_25);
protoOf($serializer_22).z1b = typeParametersSerializers;
initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChainGrapnelStatement).n2o = canBeApplied;
protoOf(ChainGrapnelStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ChainGrapnelStatement, 'ChainGrapnelStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_22});
initMetadataForCompanion(Companion_26);
protoOf($serializer_23).z1b = typeParametersSerializers;
initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChargeUpgradeStatement).n2o = canBeApplied;
protoOf(ChargeUpgradeStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ChargeUpgradeStatement, 'ChargeUpgradeStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_23});
initMetadataForCompanion(Companion_27);
protoOf($serializer_24).z1b = typeParametersSerializers;
initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChooseAndPlayOneCard).n2o = canBeApplied;
protoOf(ChooseAndPlayOneCard).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ChooseAndPlayOneCard, 'ChooseAndPlayOneCard', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_24});
initMetadataForCompanion(Companion_28);
protoOf($serializer_25).z1b = typeParametersSerializers;
initMetadataForObject($serializer_25, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ClaimRuinStatement).n2o = canBeApplied;
protoOf(ClaimRuinStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ClaimRuinStatement, 'ClaimRuinStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_25});
initMetadataForCompanion(Companion_29);
protoOf($serializer_26).z1b = typeParametersSerializers;
initMetadataForObject($serializer_26, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(OptionalStatement).n2o = canBeApplied_0;
initMetadataForClass(OptionalStatement, 'OptionalStatement', VOID, VOID, [ChooseOneOfStatementBase], VOID, VOID, {0: $serializer_getInstance_26});
initMetadataForCompanion(Companion_30);
protoOf($serializer_27).z1b = typeParametersSerializers;
initMetadataForObject($serializer_27, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SummonSignStatement).n2o = canBeApplied_0;
protoOf(SummonSignStatement).o2o = canBeAppliedAndHaveEffect_0;
initMetadataForClass(SummonSignStatement, 'SummonSignStatement', VOID, VOID, [ChooseOneOfStatementBase], VOID, VOID, {0: $serializer_getInstance_27});
initMetadataForCompanion(Companion_31);
protoOf($serializer_28).z1b = typeParametersSerializers;
initMetadataForObject($serializer_28, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(CopyCardStatement).n2o = canBeApplied;
protoOf(CopyCardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(CopyCardStatement, 'CopyCardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_28});
initMetadataForCompanion(Companion_32);
protoOf($serializer_29).z1b = typeParametersSerializers;
initMetadataForObject($serializer_29, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DealDamageToSummonsStatement).n2o = canBeApplied;
initMetadataForClass(DealDamageToSummonsStatement, 'DealDamageToSummonsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_29});
initMetadataForCompanion(Companion_33);
protoOf($serializer_30).z1b = typeParametersSerializers;
initMetadataForObject($serializer_30, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DiscardCardsStatement).n2o = canBeApplied;
protoOf(DiscardCardsStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(DiscardCardsStatement, 'DiscardCardsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_30});
initMetadataForCompanion(Companion_34);
protoOf($serializer_31).z1b = typeParametersSerializers;
initMetadataForObject($serializer_31, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DisplaceTransformLocationsStatement).n2o = canBeApplied;
protoOf(DisplaceTransformLocationsStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(DisplaceTransformLocationsStatement, 'DisplaceTransformLocationsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_31});
protoOf(EmptyStatement).n2o = canBeApplied;
protoOf(EmptyStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(EmptyStatement, 'EmptyStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: EmptyStatement_getInstance});
initMetadataForCompanion(Companion_35);
protoOf($serializer_32).z1b = typeParametersSerializers;
initMetadataForObject($serializer_32, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(EnsnareStatement).n2o = canBeApplied;
protoOf(EnsnareStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(EnsnareStatement, 'EnsnareStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_32});
initMetadataForCompanion(Companion_36);
protoOf($serializer_33).z1b = typeParametersSerializers;
initMetadataForObject($serializer_33, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(FlourishStatement).n2o = canBeApplied;
protoOf(FlourishStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(FlourishStatement, 'FlourishStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_33});
initMetadataForCompanion(Companion_37);
protoOf($serializer_34).z1b = typeParametersSerializers;
initMetadataForObject($serializer_34, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GainAncientPowerStatement).n2o = canBeApplied;
protoOf(GainAncientPowerStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(GainAncientPowerStatement, 'GainAncientPowerStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_34});
initMetadataForCompanion(Companion_38);
protoOf($serializer_35).z1b = typeParametersSerializers;
initMetadataForObject($serializer_35, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GainBeastlyTalentStatement).n2o = canBeApplied;
initMetadataForClass(GainBeastlyTalentStatement, 'GainBeastlyTalentStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_35});
initMetadataForCompanion(Companion_39);
protoOf($serializer_36).z1b = typeParametersSerializers;
initMetadataForObject($serializer_36, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GainGrudgeStatement).n2o = canBeApplied;
protoOf(GainGrudgeStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(GainGrudgeStatement, 'GainGrudgeStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_36});
initMetadataForCompanion(Companion_40);
protoOf($serializer_37).z1b = typeParametersSerializers;
initMetadataForObject($serializer_37, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GainRandomUnusedDraftActionCardStatement).n2o = canBeApplied;
protoOf(GainRandomUnusedDraftActionCardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(GainRandomUnusedDraftActionCardStatement, 'GainRandomUnusedDraftActionCardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_37});
initMetadataForCompanion(Companion_41);
protoOf($serializer_38).z1b = typeParametersSerializers;
initMetadataForObject($serializer_38, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GlimpsBeastsStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(GlimpsBeastsStatement, 'GlimpsBeastsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_38});
initMetadataForCompanion(Companion_42);
protoOf($serializer_39).z1b = typeParametersSerializers;
initMetadataForObject($serializer_39, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GlipsHuntersStatement).n2o = canBeApplied;
protoOf(GlipsHuntersStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(GlipsHuntersStatement, 'GlipsHuntersStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_39});
initMetadataForCompanion(Companion_43);
protoOf($serializer_40).z1b = typeParametersSerializers;
initMetadataForObject($serializer_40, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(HealNearHunterStatement).n2o = canBeApplied;
protoOf(HealNearHunterStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(HealNearHunterStatement, 'HealNearHunterStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_40});
initMetadataForCompanion(Companion_44);
protoOf($serializer_41).z1b = typeParametersSerializers;
initMetadataForObject($serializer_41, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(HealNearbyHuntersAndSettlersStatement).n2o = canBeApplied;
initMetadataForClass(HealNearbyHuntersAndSettlersStatement, 'HealNearbyHuntersAndSettlersStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_41});
initMetadataForCompanion(Companion_45);
protoOf($serializer_42).z1b = typeParametersSerializers;
initMetadataForObject($serializer_42, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(LureStatement).n2o = canBeApplied;
protoOf(LureStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(LureStatement, 'LureStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_42});
initMetadataForCompanion(Companion_46);
protoOf($serializer_43).z1b = typeParametersSerializers;
initMetadataForObject($serializer_43, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(MoveAnimalStatement).n2o = canBeApplied;
protoOf(MoveAnimalStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(MoveAnimalStatement, 'MoveAnimalStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_43});
initMetadataForCompanion(Companion_47);
protoOf($serializer_44).z1b = typeParametersSerializers;
initMetadataForObject($serializer_44, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastMovesDependingOnHuntersStatement, 'BeastMovesDependingOnHuntersStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_44});
initMetadataForCompanion(Companion_48);
protoOf($serializer_45).z1b = typeParametersSerializers;
initMetadataForObject($serializer_45, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastMovesDependingOnSummonsNumberStatement, 'BeastMovesDependingOnSummonsNumberStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_45});
initMetadataForCompanion(Companion_49);
protoOf($serializer_46).z1b = typeParametersSerializers;
initMetadataForObject($serializer_46, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastMovesSameZoneStatement, 'BeastMovesSameZoneStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_46});
initMetadataForCompanion(Companion_50);
protoOf($serializer_47).z1b = typeParametersSerializers;
initMetadataForObject($serializer_47, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FixedDirectionBeastMovementStatement, 'FixedDirectionBeastMovementStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_47});
initMetadataForCompanion(Companion_51);
protoOf($serializer_48).z1b = typeParametersSerializers;
initMetadataForObject($serializer_48, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TrackStatement, 'TrackStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_48});
initMetadataForCompanion(Companion_52);
protoOf($serializer_49).z1b = typeParametersSerializers;
initMetadataForObject($serializer_49, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(WarhogsTuskStatement, 'WarhogsTuskStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_49});
initMetadataForCompanion(Companion_53);
protoOf($serializer_50).z1b = typeParametersSerializers;
initMetadataForObject($serializer_50, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RelocationInRangeStatement).n2o = canBeApplied;
protoOf(RelocationInRangeStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RelocationInRangeStatement, 'RelocationInRangeStatement', VOID, VOID, [ObjectMovementStatement], VOID, VOID, {0: $serializer_getInstance_50});
initMetadataForCompanion(Companion_54);
protoOf($serializer_51).z1b = typeParametersSerializers;
initMetadataForObject($serializer_51, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(OverloadedShatterStatement).n2o = canBeApplied;
protoOf(OverloadedShatterStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(OverloadedShatterStatement, 'OverloadedShatterStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_51});
initMetadataForCompanion(Companion_55);
protoOf($serializer_52).z1b = typeParametersSerializers;
initMetadataForObject($serializer_52, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AvariceCardHuntersStatement, 'AvariceCardHuntersStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_52});
initMetadataForCompanion(Companion_56);
protoOf($serializer_53).z1b = typeParametersSerializers;
initMetadataForObject($serializer_53, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RetrieveDiscardedAbilitiesStatement, 'RetrieveDiscardedAbilitiesStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_53});
initMetadataForCompanion(Companion_57);
protoOf($serializer_54).z1b = typeParametersSerializers;
initMetadataForObject($serializer_54, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceNewSummonBaseStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlaceNewSummonBaseStatement, 'PlaceNewSummonBaseStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: Companion_getInstance_76});
initMetadataForClass(PlaceNewSummonNearbyStatement, 'PlaceNewSummonNearbyStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_54});
initMetadataForCompanion(Companion_58);
protoOf($serializer_55).z1b = typeParametersSerializers;
initMetadataForObject($serializer_55, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlaceNewSummonOnLocationsStatement, 'PlaceNewSummonOnLocationsStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_55});
initMetadataForCompanion(Companion_59);
protoOf($serializer_56).z1b = typeParametersSerializers;
initMetadataForObject($serializer_56, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlaceNewSummonStatement, 'PlaceNewSummonStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_56});
initMetadataForCompanion(Companion_60);
protoOf($serializer_57).z1b = typeParametersSerializers;
initMetadataForObject($serializer_57, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceOutpostStatement).n2o = canBeApplied;
protoOf(PlaceOutpostStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlaceOutpostStatement, 'PlaceOutpostStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_57});
initMetadataForCompanion(Companion_61);
protoOf($serializer_58).z1b = typeParametersSerializers;
initMetadataForObject($serializer_58, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ReceiveSelfDamageStatement).n2o = canBeApplied;
protoOf(ReceiveSelfDamageStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ReceiveSelfDamageStatement, 'ReceiveSelfDamageStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_58});
protoOf(RelocateOneHunterToAnother).n2o = canBeApplied;
initMetadataForObject(RelocateOneHunterToAnother, 'RelocateOneHunterToAnother', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: RelocateOneHunterToAnother_getInstance});
initMetadataForCompanion(Companion_62);
protoOf($serializer_59).z1b = typeParametersSerializers;
initMetadataForObject($serializer_59, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RelocationToSettlementStatement).n2o = canBeApplied;
initMetadataForClass(RelocationToSettlementStatement, 'RelocationToSettlementStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_59});
initMetadataForCompanion(Companion_63);
protoOf($serializer_60).z1b = typeParametersSerializers;
initMetadataForObject($serializer_60, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RetrieveDiscardedDraftActionCardStatement).n2o = canBeApplied;
protoOf(RetrieveDiscardedDraftActionCardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RetrieveDiscardedDraftActionCardStatement, 'RetrieveDiscardedDraftActionCardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_60});
initMetadataForCompanion(Companion_64);
protoOf($serializer_61).z1b = typeParametersSerializers;
initMetadataForObject($serializer_61, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RetrieveUnusedCardStatement).n2o = canBeApplied;
protoOf(RetrieveUnusedCardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RetrieveUnusedCardStatement, 'RetrieveUnusedCardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_61});
initMetadataForCompanion(Companion_65);
protoOf($serializer_62).z1b = typeParametersSerializers;
initMetadataForObject($serializer_62, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RevealLastMovementsStatement).n2o = canBeApplied;
protoOf(RevealLastMovementsStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RevealLastMovementsStatement, 'RevealLastMovementsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_62});
initMetadataForCompanion(Companion_66);
protoOf($serializer_63).z1b = typeParametersSerializers;
initMetadataForObject($serializer_63, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SearchForBeastStatement).n2o = canBeApplied;
initMetadataForClass(SearchForBeastStatement, 'SearchForBeastStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_63});
initMetadataForCompanion(Companion_67);
protoOf($serializer_64).z1b = typeParametersSerializers;
initMetadataForObject($serializer_64, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SetTrapStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SetTrapStatement, 'SetTrapStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_64});
initMetadataForCompanion(Companion_68);
protoOf($serializer_65).z1b = typeParametersSerializers;
initMetadataForObject($serializer_65, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(StrideHuntersStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(StrideHuntersStatement, 'StrideHuntersStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_65});
initMetadataForCompanion(Companion_69);
protoOf($serializer_66).z1b = typeParametersSerializers;
initMetadataForObject($serializer_66, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SummonMovesStatement).n2o = canBeApplied;
protoOf(SummonMovesStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SummonMovesStatement, 'SummonMovesStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_66});
protoOf(SwarmAttackStatement).n2o = canBeApplied;
protoOf(SwarmAttackStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(SwarmAttackStatement, 'SwarmAttackStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: SwarmAttackStatement_getInstance});
initMetadataForCompanion(Companion_70);
protoOf($serializer_67).z1b = typeParametersSerializers;
initMetadataForObject($serializer_67, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(UpgradeStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(UpgradeStatement, 'UpgradeStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_67});
initMetadataForCompanion(Companion_71, VOID, [SerializerFactory]);
initMetadataForInterface(AttackModifier, 'AttackModifier', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_72});
initMetadataForObject(ChooseSettlerForFlareScope, 'ChooseSettlerForFlareScope', VOID, VOID, [ItselfGameScope, SerializerFactory], VOID, VOID, {0: ChooseSettlerForFlareScope_getInstance});
initMetadataForObject(BonusDamageAttackModifier, 'BonusDamageAttackModifier', VOID, VOID, [AttackModifier, SerializerFactory], VOID, VOID, {0: BonusDamageAttackModifier_getInstance});
initMetadataForObject(OnlyNearSummonsAttackModifier, 'OnlyNearSummonsAttackModifier', VOID, VOID, [AttackModifier, SerializerFactory], VOID, VOID, {0: OnlyNearSummonsAttackModifier_getInstance});
initMetadataForCompanion(Companion_72, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_73, VOID, [SerializerFactory]);
initMetadataForObject(JustNearbyAttackModifier, 'JustNearbyAttackModifier', VOID, VOID, [AttackModifier, SerializerFactory], VOID, VOID, {0: JustNearbyAttackModifier_getInstance});
initMetadataForCompanion(Companion_74, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_75, VOID, [SerializerFactory]);
initMetadataForInterface(EffectSource, 'EffectSource', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_155});
initMetadataForInterface(CharacterUpgrade, 'CharacterUpgrade', VOID, VOID, [EffectSource], VOID, VOID, {0: Companion_getInstance_130});
protoOf(VoidCallUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(VoidCallUpgrade, 'VoidCallUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: VoidCallUpgrade_getInstance});
protoOf(AbyssalBeastUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AbyssalBeastUpgrade, 'AbyssalBeastUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AbyssalBeastUpgrade_getInstance});
protoOf(EchoUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(EchoUpgrade, 'EchoUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: EchoUpgrade_getInstance});
protoOf(EternityUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(EternityUpgrade, 'EternityUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: EternityUpgrade_getInstance});
protoOf(VoidStepUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(VoidStepUpgrade, 'VoidStepUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: VoidStepUpgrade_getInstance});
protoOf(DarkSpawnUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DarkSpawnUpgrade, 'DarkSpawnUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DarkSpawnUpgrade_getInstance});
protoOf(VoidCallStatement).n2o = canBeApplied;
protoOf(VoidCallStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(VoidCallStatement, 'VoidCallStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: VoidCallStatement_getInstance});
protoOf(AbyssalBeastStatement).n2o = canBeApplied;
protoOf(AbyssalBeastStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(AbyssalBeastStatement, 'AbyssalBeastStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: AbyssalBeastStatement_getInstance});
initMetadataForInterface(GeneralObjectProperty, 'GeneralObjectProperty', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_370});
initMetadataForInterface(ObjectOnBoardType, 'ObjectOnBoardType', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: Companion_getInstance_421});
initMetadataForInterface(Character, 'Character', VOID, VOID, [ObjectOnBoardType], VOID, VOID, {0: Companion_getInstance_129});
initMetadataForInterface(BeastCharacter, 'BeastCharacter', VOID, VOID, [Character], VOID, VOID, {0: Companion_getInstance_93});
protoOf(Akkeron).t36 = get_summonTypes;
protoOf(Akkeron).u36 = get_summonLimit;
protoOf(Akkeron).q2s = get_activatableSummonsOnMap;
protoOf(Akkeron).v36 = getInitList_1;
protoOf(Akkeron).w36 = modificationNumber;
initMetadataForObject(Akkeron, 'Akkeron', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Akkeron_getInstance});
initMetadataForCompanion(Companion_76);
protoOf($serializer_68).z1b = typeParametersSerializers;
initMetadataForObject($serializer_68, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AbyssalPullStatement).n2o = canBeApplied;
protoOf(AbyssalPullStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(AbyssalPullStatement, 'AbyssalPullStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_68});
initMetadataForCompanion(Companion_77);
protoOf($serializer_69).z1b = typeParametersSerializers;
initMetadataForObject($serializer_69, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(VoidStatement, 'VoidStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_69});
initMetadataForCompanion(Companion_78);
protoOf($serializer_70).z1b = typeParametersSerializers;
initMetadataForObject($serializer_70, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(GameStateEvent, 'GameStateEvent', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_296});
initMetadataForInterface(GameStateChange, 'GameStateChange', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_257});
initMetadataForInterface(GameStateChangeEvent, 'GameStateChangeEvent', VOID, VOID, [GameStateEvent, GameStateChange]);
initMetadataForInterface(TechnicalGameStateChangeEvent, 'TechnicalGameStateChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: Companion_getInstance_359});
protoOf(AkkeronEternityTransformedPositionsChangeEvent).o37 = stateChanges_0;
initMetadataForClass(AkkeronEternityTransformedPositionsChangeEvent, 'AkkeronEternityTransformedPositionsChangeEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_70});
initMetadataForInterface(SimpleObjectType, 'SimpleObjectType', VOID, VOID, [ObjectOnBoardType], VOID, VOID, {0: Companion_getInstance_424});
initMetadataForInterface(SummonType, 'SummonType', VOID, VOID, [SimpleObjectType], VOID, VOID, {0: Companion_getInstance_425});
protoOf(AbominationType).r36 = get_preferredLocation_0;
protoOf(AbominationType).n2z = get_maxHP;
protoOf(AbominationType).v36 = getInitList;
initMetadataForObject(AbominationType, 'AbominationType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: AbominationType_getInstance});
initMetadataForInterface(PlayableCard, 'PlayableCard', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: Companion_getInstance_443});
initMetadataForInterface(PlayableInTurnCard, 'PlayableInTurnCard', VOID, VOID, [PlayableCard], VOID, VOID, {0: Companion_getInstance_439});
initMetadataForInterface(AbilityCard, 'AbilityCard', VOID, VOID, [PlayableCard], VOID, VOID, {0: Companion_getInstance_442});
protoOf(ConsumeCard).u37 = get_number;
initMetadataForObject(ConsumeCard, 'ConsumeCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: ConsumeCard_getInstance});
protoOf(CorruptCard).u37 = get_number;
initMetadataForObject(CorruptCard, 'CorruptCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: CorruptCard_getInstance});
protoOf(DefileCard).u37 = get_number;
initMetadataForObject(DefileCard, 'DefileCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: DefileCard_getInstance});
protoOf(VoidCard).u37 = get_number;
initMetadataForObject(VoidCard, 'VoidCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: VoidCard_getInstance});
initMetadataForCompanion(Companion_79);
protoOf($serializer_71).z1b = typeParametersSerializers;
initMetadataForObject($serializer_71, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(GameRules, 'GameRules', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_215});
protoOf(ClassicGameRules).e3b = value;
protoOf(ClassicGameRules).t3a = canTransformLocation;
initMetadataForClass(ClassicGameRules, 'ClassicGameRules', VOID, VOID, [GameRules], VOID, VOID, {0: Companion_getInstance_216});
initMetadataForClass(KillingSettlersClassicGameRules, 'KillingSettlersClassicGameRules', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_218});
initMetadataForClass(ArrivalOfTheTitanContract, 'ArrivalOfTheTitanContract', ArrivalOfTheTitanContract.d3a, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_71});
initMetadataForInterface(GamePhase, 'GamePhase', VOID, VOID, [ItselfGameScope], VOID, VOID, {0: Companion_getInstance_226});
initMetadataForInterface(ContractInitPhase, 'ContractInitPhase', VOID, VOID, [GamePhase], VOID, VOID, {0: Companion_getInstance_225});
initMetadataForObject(ArrivalOfTheTitanInitialPhase, 'ArrivalOfTheTitanInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: ArrivalOfTheTitanInitialPhase_getInstance});
initMetadataForObject(ArrivalOfTheTitanSettlementClaimingSource, 'ArrivalOfTheTitanSettlementClaimingSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: ArrivalOfTheTitanSettlementClaimingSource_getInstance});
initMetadataForObject(ArrivalOfTheTitanSettlerMoveEffectSource, 'ArrivalOfTheTitanSettlerMoveEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: ArrivalOfTheTitanSettlerMoveEffectSource_getInstance});
initMetadataForCompanion(Companion_80);
protoOf($serializer_72).z1b = typeParametersSerializers;
initMetadataForObject($serializer_72, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ArrivalOfTheTitanHuntersTeamBonusMoveStatement).n2o = canBeApplied;
protoOf(ArrivalOfTheTitanHuntersTeamBonusMoveStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ArrivalOfTheTitanHuntersTeamBonusMoveStatement, 'ArrivalOfTheTitanHuntersTeamBonusMoveStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_72});
initMetadataForCompanion(Companion_81, VOID, [SerializerFactory]);
initMetadataForInterface(ArsenalCard, 'ArsenalCard', VOID, VOID, [PlayableCard], VOID, VOID, {0: Companion_getInstance_440});
initMetadataForInterface(AshRuinCard, 'AshRuinCard', VOID, VOID, [ArsenalCard], VOID, VOID, {0: Companion_getInstance_83});
initMetadataForInterface(AshRuin, 'AshRuin', VOID, VOID, [AshRuinCard, PlayableInTurnCard], VOID, VOID, {0: Companion_getInstance_82});
protoOf(Ruin1).u37 = get_number;
initMetadataForObject(Ruin1, 'Ruin1', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin1_getInstance});
protoOf(Ruin2).u37 = get_number;
initMetadataForObject(Ruin2, 'Ruin2', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin2_getInstance});
protoOf(Ruin3).u37 = get_number;
initMetadataForObject(Ruin3, 'Ruin3', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin3_getInstance});
protoOf(Ruin4).u37 = get_number;
initMetadataForObject(Ruin4, 'Ruin4', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin4_getInstance});
protoOf(Ruin5).u37 = get_number;
initMetadataForObject(Ruin5, 'Ruin5', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin5_getInstance});
protoOf(Ruin6).u37 = get_number;
initMetadataForObject(Ruin6, 'Ruin6', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin6_getInstance});
protoOf(Ruin7).u37 = get_number;
initMetadataForObject(Ruin7, 'Ruin7', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin7_getInstance});
protoOf(Ruin8).u37 = get_number;
initMetadataForObject(Ruin8, 'Ruin8', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin8_getInstance});
protoOf(Ruin9).u37 = get_number;
initMetadataForObject(Ruin9, 'Ruin9', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin9_getInstance});
protoOf(Ruin10).u37 = get_number;
initMetadataForObject(Ruin10, 'Ruin10', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin10_getInstance});
protoOf(Ruin11).u37 = get_number;
initMetadataForObject(Ruin11, 'Ruin11', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin11_getInstance});
protoOf(Ruin12).u37 = get_number;
initMetadataForObject(Ruin12, 'Ruin12', VOID, VOID, [AshRuin, SerializerFactory], VOID, VOID, {0: Ruin12_getInstance});
initMetadataForCompanion(Companion_82, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_83);
protoOf($serializer_73).z1b = typeParametersSerializers;
initMetadataForObject($serializer_73, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlayAshRuinStatement).n2o = canBeApplied;
protoOf(PlayAshRuinStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlayAshRuinStatement, 'PlayAshRuinStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_73});
initMetadataForCompanion(Companion_84);
protoOf($serializer_74).z1b = typeParametersSerializers;
initMetadataForObject($serializer_74, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(UnknownCard, 'UnknownCard', VOID, VOID, [PlayableCard], VOID, VOID, {0: Companion_getInstance_441});
initMetadataForClass(UnknownAshRuinCard, 'UnknownAshRuinCard', VOID, VOID, [AshRuinCard, UnknownCard], VOID, VOID, {0: $serializer_getInstance_74});
initMetadataForInterface(QuestionContext, 'QuestionContext', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_198});
initMetadataForInterface(CardQuestionContext, 'CardQuestionContext', VOID, VOID, [QuestionContext], VOID, VOID, {0: Companion_getInstance_201});
initMetadataForObject(HunterItemToExchangeByRuinQuestionContext, 'HunterItemToExchangeByRuinQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: HunterItemToExchangeByRuinQuestionContext_getInstance});
initMetadataForObject(HunterItemToGiveByRuinQuestionContext, 'HunterItemToGiveByRuinQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: HunterItemToGiveByRuinQuestionContext_getInstance});
initMetadataForInterface(LocationQuestionContext, 'LocationQuestionContext', VOID, VOID, [QuestionContext], VOID, VOID, {0: Companion_getInstance_203});
initMetadataForObject(LocationsToCheckForBeastByRuinQuestionContext, 'LocationsToCheckForBeastByRuinQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: LocationsToCheckForBeastByRuinQuestionContext_getInstance});
initMetadataForObject(SameHabitatRelocationByRuinQuestionContext, 'SameHabitatRelocationByRuinQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: SameHabitatRelocationByRuinQuestionContext_getInstance});
initMetadataForInterface(TargetQuestionContext, 'TargetQuestionContext', VOID, VOID, [QuestionContext], VOID, VOID, {0: Companion_getInstance_204});
initMetadataForObject(HunterToGiveItemByRuinQuestionContext, 'HunterToGiveItemByRuinQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToGiveItemByRuinQuestionContext_getInstance});
initMetadataForObject(HunterToReceiveItemByRuinQuestionContext, 'HunterToReceiveItemByRuinQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToReceiveItemByRuinQuestionContext_getInstance});
initMetadataForCompanion(Companion_85);
protoOf($serializer_75).z1b = typeParametersSerializers;
initMetadataForObject($serializer_75, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AshfallUnlikelyAllianceContract, 'AshfallUnlikelyAllianceContract', AshfallUnlikelyAllianceContract.u3d, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_75});
initMetadataForObject(AshfallUnlikelyAllianceInitialPhase, 'AshfallUnlikelyAllianceInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: AshfallUnlikelyAllianceInitialPhase_getInstance});
initMetadataForCompanion(Companion_86);
protoOf($serializer_76).z1b = typeParametersSerializers;
initMetadataForObject($serializer_76, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AshfallAttackOrSummonFromRuinStatement).n2o = canBeApplied;
protoOf(AshfallAttackOrSummonFromRuinStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(AshfallAttackOrSummonFromRuinStatement, 'AshfallAttackOrSummonFromRuinStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_76});
initMetadataForCompanion(Companion_87);
protoOf($serializer_77).z1b = typeParametersSerializers;
initMetadataForObject($serializer_77, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AshfallEachBeastAndSummonMoves).n2o = canBeApplied;
protoOf(AshfallEachBeastAndSummonMoves).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(AshfallEachBeastAndSummonMoves, 'AshfallEachBeastAndSummonMoves', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_77});
initMetadataForInterface(HumanKindType, 'HumanKindType', VOID, VOID, [ObjectOnBoardType], VOID, VOID, {0: Companion_getInstance_422});
initMetadataForInterface(HunterCharacter, 'HunterCharacter', VOID, VOID, [Character, HumanKindType], VOID, VOID, {0: Companion_getInstance_381});
protoOf(Assar).i3e = get_hunterCompanionType;
protoOf(Assar).w36 = modificationNumber;
protoOf(Assar).r36 = get_preferredLocation_1;
initMetadataForObject(Assar, 'Assar', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Assar_getInstance});
protoOf(ResonanceUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ResonanceUpgrade, 'ResonanceUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ResonanceUpgrade_getInstance});
protoOf(ExceptionalTrackerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ExceptionalTrackerUpgrade, 'ExceptionalTrackerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ExceptionalTrackerUpgrade_getInstance});
protoOf(SeekerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SeekerUpgrade, 'SeekerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SeekerUpgrade_getInstance});
protoOf(ExploreUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ExploreUpgrade, 'ExploreUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ExploreUpgrade_getInstance});
protoOf(ScoutCard).u37 = get_number;
initMetadataForObject(ScoutCard, 'ScoutCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: ScoutCard_getInstance});
protoOf(ResonanceChooseStatement).n2o = canBeApplied;
protoOf(ResonanceChooseStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(ResonanceChooseStatement, 'ResonanceChooseStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: ResonanceChooseStatement_getInstance});
initMetadataForCompanion(Companion_88);
protoOf($serializer_78).z1b = typeParametersSerializers;
initMetadataForObject($serializer_78, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ScoutStatement).n2o = canBeApplied;
protoOf(ScoutStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ScoutStatement, 'ScoutStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_78});
initMetadataForObject(HunterToCopyFirstRedCardQuestionContext, 'HunterToCopyFirstRedCardQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToCopyFirstRedCardQuestionContext_getInstance});
initMetadataForCompanion(Companion_89);
protoOf($serializer_79).z1b = typeParametersSerializers;
initMetadataForObject($serializer_79, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChangeRedDraftActionCardWasPlayedStatusEvent).o37 = stateChanges_0;
initMetadataForClass(ChangeRedDraftActionCardWasPlayedStatusEvent, 'ChangeRedDraftActionCardWasPlayedStatusEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_79});
initMetadataForCompanion(Companion_90);
protoOf($serializer_80).z1b = typeParametersSerializers;
initMetadataForObject($serializer_80, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ResonanceChooseEvent).o37 = stateChanges_0;
initMetadataForClass(ResonanceChooseEvent, 'ResonanceChooseEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_80});
initMetadataForCompanion(Companion_91);
protoOf($serializer_81).z1b = typeParametersSerializers;
initMetadataForObject($serializer_81, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AttackOnTheNorthernSettlementsContract, 'AttackOnTheNorthernSettlementsContract', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_81});
initMetadataForObject(AttackOnTheNorthernSettlementsInitialPhase, 'AttackOnTheNorthernSettlementsInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: AttackOnTheNorthernSettlementsInitialPhase_getInstance});
initMetadataForCompanion(Companion_92, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_93);
protoOf($serializer_82).z1b = typeParametersSerializers;
initMetadataForObject($serializer_82, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastPathStep, 'BeastPathStep', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_82});
initMetadataForCompanion(Companion_94);
protoOf($serializer_83).z1b = typeParametersSerializers;
initMetadataForObject($serializer_83, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MovementAndState, 'MovementAndState', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_83});
initMetadataForClass(possibleTrailMaxCounts$$inlined$groupingBy$1);
initMetadataForCompanion(Companion_95);
protoOf($serializer_84).z1b = typeParametersSerializers;
initMetadataForObject($serializer_84, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(BeastlyTalentCard, 'BeastlyTalentCard', VOID, VOID, [ArsenalCard], VOID, VOID, {0: Companion_getInstance_98});
initMetadataForClass(IntuitionCard, 'IntuitionCard', VOID, VOID, [BeastlyTalentCard, PlayableCard], VOID, VOID, {0: $serializer_getInstance_84});
protoOf(SuddenMistCard).u37 = get_number;
initMetadataForObject(SuddenMistCard, 'SuddenMistCard', VOID, VOID, [BeastlyTalentCard, PlayableCard, SerializerFactory], VOID, VOID, {0: SuddenMistCard_getInstance});
initMetadataForCompanion(Companion_96);
protoOf($serializer_85).z1b = typeParametersSerializers;
initMetadataForObject($serializer_85, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(WorldShiftCard, 'WorldShiftCard', VOID, VOID, [BeastlyTalentCard, PlayableCard], VOID, VOID, {0: $serializer_getInstance_85});
initMetadataForCompanion(Companion_97, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_98);
protoOf($serializer_86).z1b = typeParametersSerializers;
initMetadataForObject($serializer_86, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EvolveCard, 'EvolveCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_86});
initMetadataForCompanion(Companion_99);
protoOf($serializer_87).z1b = typeParametersSerializers;
initMetadataForObject($serializer_87, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UnbendingWillCard, 'UnbendingWillCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_87});
initMetadataForCompanion(Companion_100);
protoOf($serializer_88).z1b = typeParametersSerializers;
initMetadataForObject($serializer_88, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BrutalityCard, 'BrutalityCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_88});
initMetadataForCompanion(Companion_101);
protoOf($serializer_89).z1b = typeParametersSerializers;
initMetadataForObject($serializer_89, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RageCard, 'RageCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_89});
initMetadataForCompanion(Companion_102);
protoOf($serializer_90).z1b = typeParametersSerializers;
initMetadataForObject($serializer_90, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(StrangeSummonsCard, 'StrangeSummonsCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_90});
initMetadataForCompanion(Companion_103);
protoOf($serializer_91).z1b = typeParametersSerializers;
initMetadataForObject($serializer_91, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HatredCard, 'HatredCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_91});
initMetadataForCompanion(Companion_104);
protoOf($serializer_92).z1b = typeParametersSerializers;
initMetadataForObject($serializer_92, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DisperseCard, 'DisperseCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_92});
initMetadataForCompanion(Companion_105);
protoOf($serializer_93).z1b = typeParametersSerializers;
initMetadataForObject($serializer_93, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(InsidiousGrowthCard, 'InsidiousGrowthCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_93});
initMetadataForCompanion(Companion_106);
protoOf($serializer_94).z1b = typeParametersSerializers;
initMetadataForObject($serializer_94, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RoamCard, 'RoamCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_94});
initMetadataForCompanion(Companion_107);
protoOf($serializer_95).z1b = typeParametersSerializers;
initMetadataForObject($serializer_95, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SprawlCard, 'SprawlCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_95});
protoOf(DisappearCard).u37 = get_number;
initMetadataForObject(DisappearCard, 'DisappearCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard, SerializerFactory], VOID, VOID, {0: DisappearCard_getInstance});
protoOf(AbruptDecayCard).u37 = get_number;
initMetadataForObject(AbruptDecayCard, 'AbruptDecayCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard, SerializerFactory], VOID, VOID, {0: AbruptDecayCard_getInstance});
initMetadataForCompanion(Companion_108);
protoOf($serializer_96).z1b = typeParametersSerializers;
initMetadataForObject($serializer_96, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FeastCard, 'FeastCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_96});
initMetadataForCompanion(Companion_109);
protoOf($serializer_97).z1b = typeParametersSerializers;
initMetadataForObject($serializer_97, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FlourishCard, 'FlourishCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_97});
initMetadataForCompanion(Companion_110);
protoOf($serializer_98).z1b = typeParametersSerializers;
initMetadataForObject($serializer_98, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MirrorStepCard, 'MirrorStepCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard], VOID, VOID, {0: $serializer_getInstance_98});
protoOf(FuryCard).u37 = get_number;
initMetadataForObject(FuryCard, 'FuryCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard, SerializerFactory], VOID, VOID, {0: FuryCard_getInstance});
protoOf(ShatterCard).u37 = get_number;
initMetadataForObject(ShatterCard, 'ShatterCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard, SerializerFactory], VOID, VOID, {0: ShatterCard_getInstance});
protoOf(SwarmCard).u37 = get_number;
initMetadataForObject(SwarmCard, 'SwarmCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard, SerializerFactory], VOID, VOID, {0: SwarmCard_getInstance});
initMetadataForCompanion(Companion_111);
protoOf($serializer_99).z1b = typeParametersSerializers;
initMetadataForObject($serializer_99, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UnknownBeastlyTalentCard, 'UnknownBeastlyTalentCard', VOID, VOID, [BeastlyTalentCard, UnknownCard], VOID, VOID, {0: $serializer_getInstance_99});
initMetadataForInterface(OverloadedCard, 'OverloadedCard', VOID, VOID, [PlayableInTurnCard], VOID, VOID, {0: Companion_getInstance_444});
protoOf(OverloadedFuryCard).u37 = get_number;
initMetadataForObject(OverloadedFuryCard, 'OverloadedFuryCard', VOID, VOID, [OverloadedCard, PlayableInTurnCard, BeastlyTalentCard, SerializerFactory], VOID, VOID, {0: OverloadedFuryCard_getInstance});
protoOf(OverloadedShatterCard).u37 = get_number;
initMetadataForObject(OverloadedShatterCard, 'OverloadedShatterCard', VOID, VOID, [OverloadedCard, PlayableInTurnCard, BeastlyTalentCard, SerializerFactory], VOID, VOID, {0: OverloadedShatterCard_getInstance});
initMetadataForObject(FeastCardAttackModifier, 'FeastCardAttackModifier', VOID, VOID, [AttackModifier, SerializerFactory], VOID, VOID, {0: FeastCardAttackModifier_getInstance});
initMetadataForCompanion(Companion_112);
protoOf($serializer_100).z1b = typeParametersSerializers;
initMetadataForObject($serializer_100, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BoardPosition, 'BoardPosition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_100});
initMetadataForCompanion(Companion_113);
protoOf($serializer_101).z1b = typeParametersSerializers;
initMetadataForObject($serializer_101, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(StepMovement, 'StepMovement', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_116});
initMetadataForClass(Direction, 'Direction', VOID, VOID, [StepMovement], VOID, VOID, {0: $serializer_getInstance_101});
initMetadataForCompanion(Companion_114);
protoOf($serializer_102).z1b = typeParametersSerializers;
initMetadataForObject($serializer_102, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MovementToLocation, 'MovementToLocation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_102});
initMetadataForClass(MovementType, 'MovementType');
initMetadataForCompanion(Companion_115, VOID, [SerializerFactory]);
initMetadataForObject(NoMovement, 'NoMovement', VOID, VOID, [StepMovement, SerializerFactory], VOID, VOID, {0: NoMovement_getInstance});
initMetadataForCompanion(Companion_116);
protoOf($serializer_103).z1b = typeParametersSerializers;
initMetadataForObject($serializer_103, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RelocationStep, 'RelocationStep', VOID, VOID, [StepMovement], VOID, VOID, {0: $serializer_getInstance_103});
protoOf(InfestationUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(InfestationUpgrade, 'InfestationUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: InfestationUpgrade_getInstance});
protoOf(WitheringMawUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(WitheringMawUpgrade, 'WitheringMawUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: WitheringMawUpgrade_getInstance});
protoOf(UnendingHungerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(UnendingHungerUpgrade, 'UnendingHungerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: UnendingHungerUpgrade_getInstance});
protoOf(BlightUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BlightUpgrade, 'BlightUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BlightUpgrade_getInstance});
protoOf(ExpandTheMarshUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ExpandTheMarshUpgrade, 'ExpandTheMarshUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ExpandTheMarshUpgrade_getInstance});
protoOf(LurkingDeadUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(LurkingDeadUpgrade, 'LurkingDeadUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: LurkingDeadUpgrade_getInstance});
protoOf(CascadeUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(CascadeUpgrade, 'CascadeUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: CascadeUpgrade_getInstance});
protoOf(Bolgin).t36 = get_summonTypes;
protoOf(Bolgin).q2s = get_activatableSummonsOnMap;
protoOf(Bolgin).v36 = getInitList_1;
protoOf(Bolgin).w36 = modificationNumber;
initMetadataForObject(Bolgin, 'Bolgin', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Bolgin_getInstance});
protoOf(PolypType).r36 = get_preferredLocation_0;
protoOf(PolypType).n2z = get_maxHP;
protoOf(PolypType).v36 = getInitList;
initMetadataForObject(PolypType, 'PolypType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: PolypType_getInstance});
protoOf(SummonPolypCard).u37 = get_number;
initMetadataForObject(SummonPolypCard, 'SummonPolypCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SummonPolypCard_getInstance});
protoOf(BeastlyTongueCard).u37 = get_number;
initMetadataForObject(BeastlyTongueCard, 'BeastlyTongueCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: BeastlyTongueCard_getInstance});
protoOf(EngorgeCard).u37 = get_number;
initMetadataForObject(EngorgeCard, 'EngorgeCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: EngorgeCard_getInstance});
protoOf(LeapCard).u37 = get_number;
initMetadataForObject(LeapCard, 'LeapCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: LeapCard_getInstance});
initMetadataForCompanion(Companion_117);
protoOf($serializer_104).z1b = typeParametersSerializers;
initMetadataForObject($serializer_104, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BurstStatement).n2o = canBeApplied;
protoOf(BurstStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BurstStatement, 'BurstStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_104});
initMetadataForCompanion(Companion_118);
protoOf($serializer_105).z1b = typeParametersSerializers;
initMetadataForObject($serializer_105, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BeastlyTongueStatement).n2o = canBeApplied;
protoOf(BeastlyTongueStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BeastlyTongueStatement, 'BeastlyTongueStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_105});
initMetadataForCompanion(Companion_119);
protoOf($serializer_106).z1b = typeParametersSerializers;
initMetadataForObject($serializer_106, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LeapStatement, 'LeapStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_106});
initMetadataForObject(BurstEffectSource, 'BurstEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: BurstEffectSource_getInstance});
protoOf(Bram).i3e = get_hunterCompanionType;
protoOf(Bram).w36 = modificationNumber;
protoOf(Bram).v36 = getInitList_0;
protoOf(Bram).r36 = get_preferredLocation_1;
initMetadataForObject(Bram, 'Bram', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Bram_getInstance});
protoOf(AbruptAssembleUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AbruptAssembleUpgrade, 'AbruptAssembleUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AbruptAssembleUpgrade_getInstance});
protoOf(MassProductionUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(MassProductionUpgrade, 'MassProductionUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: MassProductionUpgrade_getInstance});
protoOf(LivingBlockadeUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(LivingBlockadeUpgrade, 'LivingBlockadeUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: LivingBlockadeUpgrade_getInstance});
protoOf(TacticalInsightUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(TacticalInsightUpgrade, 'TacticalInsightUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: TacticalInsightUpgrade_getInstance});
protoOf(WardCard).u37 = get_number;
initMetadataForObject(WardCard, 'WardCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: WardCard_getInstance});
protoOf(BindingHuntCard).u37 = get_number;
initMetadataForObject(BindingHuntCard, 'BindingHuntCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: BindingHuntCard_getInstance});
initMetadataForCompanion(Companion_120);
protoOf($serializer_107).z1b = typeParametersSerializers;
initMetadataForObject($serializer_107, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AbruptAssembleStatement).n2o = canBeApplied;
protoOf(AbruptAssembleStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(AbruptAssembleStatement, 'AbruptAssembleStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_107});
initMetadataForCompanion(Companion_121);
protoOf($serializer_108).z1b = typeParametersSerializers;
initMetadataForObject($serializer_108, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(WardStatement).n2o = canBeApplied;
protoOf(WardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(WardStatement, 'WardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_108});
initMetadataForCompanion(Companion_122);
protoOf($serializer_109).z1b = typeParametersSerializers;
initMetadataForObject($serializer_109, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BindingHuntStatement).n2o = canBeApplied;
protoOf(BindingHuntStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BindingHuntStatement, 'BindingHuntStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_109});
initMetadataForObject(BramBarrierCleanupEffectSource, 'BramBarrierCleanupEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: BramBarrierCleanupEffectSource_getInstance});
initMetadataForObject(PossibleBindingHuntEffectSource, 'PossibleBindingHuntEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: PossibleBindingHuntEffectSource_getInstance});
initMetadataForCompanion(Companion_123);
protoOf($serializer_110).z1b = typeParametersSerializers;
initMetadataForObject($serializer_110, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(GameQuestionBase, 'GameQuestionBase');
initMetadataForInterface(GameQuestion, 'GameQuestion', VOID, VOID, [GameQuestionBase], VOID, VOID, {0: Companion_getInstance_176});
initMetadataForInterface(LocationQuestionBase, 'LocationQuestionBase', VOID, VOID, [GameQuestion], VOID, VOID, {0: Companion_getInstance_202});
protoOf(BarrierConnectedLocationQuestion).t3o = get_questionContext;
initMetadataForClass(BarrierConnectedLocationQuestion, 'BarrierConnectedLocationQuestion', VOID, VOID, [LocationQuestionBase], VOID, VOID, {0: $serializer_getInstance_110});
initMetadataForObject(BarrierFirstPositionQuestionContext, 'BarrierFirstPositionQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: BarrierFirstPositionQuestionContext_getInstance});
initMetadataForCompanion(Companion_124);
protoOf($serializer_111).z1b = typeParametersSerializers;
initMetadataForObject($serializer_111, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BindingHuntReactionStatement).n2o = canBeApplied;
protoOf(BindingHuntReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BindingHuntReactionStatement, 'BindingHuntReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_111});
initMetadataForCompanion(Companion_125);
protoOf($serializer_112).z1b = typeParametersSerializers;
initMetadataForObject($serializer_112, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BramWardBarrierStatement).n2o = canBeApplied;
protoOf(BramWardBarrierStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BramWardBarrierStatement, 'BramWardBarrierStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_112});
initMetadataForCompanion(Companion_126);
protoOf($serializer_113).z1b = typeParametersSerializers;
initMetadataForObject($serializer_113, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceBarrierInSameZoneStatement).n2o = canBeApplied;
protoOf(PlaceBarrierInSameZoneStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlaceBarrierInSameZoneStatement, 'PlaceBarrierInSameZoneStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_113});
initMetadataForCompanion(Companion_127);
protoOf($serializer_114).z1b = typeParametersSerializers;
initMetadataForObject($serializer_114, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceBarrierOnLocationsStatement).n2o = canBeApplied;
protoOf(PlaceBarrierOnLocationsStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlaceBarrierOnLocationsStatement, 'PlaceBarrierOnLocationsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_114});
initMetadataForCompanion(Companion_128, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_129, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_130, VOID, [SerializerFactory]);
initMetadataForInterface(ChargingUpgrade, 'ChargingUpgrade', VOID, VOID, [CharacterUpgrade], VOID, VOID, {0: Companion_getInstance_131});
initMetadataForCompanion(Companion_131);
protoOf($serializer_115).z1b = typeParametersSerializers;
initMetadataForObject($serializer_115, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameNotification, 'GameNotification', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_115});
initMetadataForCompanion(Companion_132);
protoOf($serializer_116).z1b = typeParametersSerializers;
initMetadataForObject($serializer_116, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameStateCheckInfo, 'GameStateCheckInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_116});
initMetadataForClass(ReplayIsFinishedException, 'ReplayIsFinishedException', ReplayIsFinishedException.j3q);
initMetadataForCompanion(Companion_133, VOID, [SerializerFactory]);
initMetadataForInterface(ControllingActor, 'ControllingActor', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_134});
initMetadataForCompanion(Companion_134, VOID, [SerializerFactory]);
initMetadataForInterface(ControllingActorWithTeam, 'ControllingActorWithTeam', VOID, VOID, [ControllingActor], VOID, VOID, {0: Companion_getInstance_135});
initMetadataForCompanion(Companion_135);
protoOf($serializer_117).z1b = typeParametersSerializers;
initMetadataForObject($serializer_117, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ControllingByCharacter, 'ControllingByCharacter', VOID, VOID, [ControllingActorWithTeam], VOID, VOID, {0: $serializer_getInstance_117});
initMetadataForCompanion(Companion_136);
protoOf($serializer_118).z1b = typeParametersSerializers;
initMetadataForObject($serializer_118, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ControllingByTeam, 'ControllingByTeam', VOID, VOID, [ControllingActorWithTeam], VOID, VOID, {0: $serializer_getInstance_118});
initMetadataForCompanion(Companion_137);
protoOf($serializer_119).z1b = typeParametersSerializers;
initMetadataForObject($serializer_119, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MesmerizedControlling, 'MesmerizedControlling', VOID, VOID, [ControllingActorWithTeam], VOID, VOID, {0: $serializer_getInstance_119});
initMetadataForObject(ControllingByNothing, 'ControllingByNothing', VOID, VOID, [ControllingActor, SerializerFactory], VOID, VOID, {0: ControllingByNothing_getInstance});
initMetadataForCompanion(Companion_138, VOID, [SerializerFactory]);
initMetadataForInterface(DamageSource, 'DamageSource', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_139});
initMetadataForCompanion(Companion_139);
protoOf($serializer_120).z1b = typeParametersSerializers;
initMetadataForObject($serializer_120, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CardDamageSourceImpl, 'CardDamageSourceImpl', VOID, VOID, [DamageSource], VOID, VOID, {0: $serializer_getInstance_120});
initMetadataForObject(AbyssalSwampRelocationDamage, 'AbyssalSwampRelocationDamage', VOID, VOID, [DamageSource, SerializerFactory], VOID, VOID, {0: AbyssalSwampRelocationDamage_getInstance});
initMetadataForObject(ContractReward, 'ContractReward', VOID, VOID, [DamageSource, SerializerFactory], VOID, VOID, {0: ContractReward_getInstance});
initMetadataForCompanion(Companion_140);
protoOf($serializer_121).z1b = typeParametersSerializers;
initMetadataForObject($serializer_121, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RuinActivation, 'RuinActivation', VOID, VOID, [DamageSource], VOID, VOID, {0: $serializer_getInstance_121});
initMetadataForObject(SandboxDamage, 'SandboxDamage', VOID, VOID, [DamageSource, SerializerFactory], VOID, VOID, {0: SandboxDamage_getInstance});
initMetadataForObject(SummonActivation, 'SummonActivation', VOID, VOID, [DamageSource, SerializerFactory], VOID, VOID, {0: SummonActivation_getInstance});
initMetadataForObject(TrapActivation, 'TrapActivation', VOID, VOID, [DamageSource, SerializerFactory], VOID, VOID, {0: TrapActivation_getInstance});
initMetadataForCompanion(Companion_141);
protoOf($serializer_122).z1b = typeParametersSerializers;
initMetadataForObject($serializer_122, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UpgradeDamageSource, 'UpgradeDamageSource', VOID, VOID, [DamageSource], VOID, VOID, {0: $serializer_getInstance_122});
initMetadataForCompanion(Companion_142);
protoOf($serializer_123).z1b = typeParametersSerializers;
initMetadataForObject($serializer_123, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DealingDamage, 'DealingDamage', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_123});
initMetadataForCompanion(Companion_143);
protoOf($serializer_124).z1b = typeParametersSerializers;
initMetadataForObject($serializer_124, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DamageBlock, 'DamageBlock', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_124});
initMetadataForCompanion(Companion_144);
protoOf($serializer_125).z1b = typeParametersSerializers;
initMetadataForObject($serializer_125, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DamageToTarget, 'DamageToTarget', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_125});
initMetadataForClass(DamageKind, 'DamageKind');
protoOf(installAnswer$5).o1n = cancel$default;
protoOf(installAnswer$5).i1n = invokeOnCompletion$default;
initMetadataForClass(installAnswer$5, VOID, VOID, VOID, [Deferred], [0]);
initMetadataForCompanion(Companion_145);
protoOf($serializer_126).z1b = typeParametersSerializers;
initMetadataForObject($serializer_126, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DisturbanceOfTheNorthernGodsContract, 'DisturbanceOfTheNorthernGodsContract', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_126});
initMetadataForObject(DisturbanceOfTheNorthernGodsInitialPhase, 'DisturbanceOfTheNorthernGodsInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: DisturbanceOfTheNorthernGodsInitialPhase_getInstance});
initMetadataForInterface(DraftActionCard, 'DraftActionCard', VOID, VOID, [PlayableInTurnCard], VOID, VOID, {0: Companion_getInstance_147});
protoOf(AvariceCard).u37 = get_number;
initMetadataForObject(AvariceCard, 'AvariceCard', VOID, VOID, [DraftActionCard, EffectSource, SerializerFactory], VOID, VOID, {0: AvariceCard_getInstance});
initMetadataForInterface(DraftDarkActionCard, 'DraftDarkActionCard', VOID, VOID, [DraftActionCard], VOID, VOID, {0: Companion_getInstance_149});
protoOf(DarkOfferingsCard).u37 = get_number;
initMetadataForObject(DarkOfferingsCard, 'DarkOfferingsCard', VOID, VOID, [DraftDarkActionCard, EffectSource, SerializerFactory], VOID, VOID, {0: DarkOfferingsCard_getInstance});
initMetadataForCompanion(Companion_146, VOID, [SerializerFactory]);
protoOf(RushCard).u37 = get_number;
initMetadataForObject(RushCard, 'RushCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: RushCard_getInstance});
protoOf(DashCard).u37 = get_number;
initMetadataForObject(DashCard, 'DashCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: DashCard_getInstance});
protoOf(AnimateCard).u37 = get_number;
initMetadataForObject(AnimateCard, 'AnimateCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: AnimateCard_getInstance});
protoOf(EnsnareCard).u37 = get_number;
initMetadataForObject(EnsnareCard, 'EnsnareCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: EnsnareCard_getInstance});
protoOf(BolsterCard).u37 = get_number;
initMetadataForObject(BolsterCard, 'BolsterCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: BolsterCard_getInstance});
protoOf(PursuitCard).u37 = get_number;
initMetadataForObject(PursuitCard, 'PursuitCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: PursuitCard_getInstance});
protoOf(AdaptCard).u37 = get_number;
initMetadataForObject(AdaptCard, 'AdaptCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: AdaptCard_getInstance});
protoOf(HiddenPassageCard).u37 = get_number;
initMetadataForObject(HiddenPassageCard, 'HiddenPassageCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: HiddenPassageCard_getInstance});
protoOf(HasteCard).u37 = get_number;
initMetadataForObject(HasteCard, 'HasteCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: HasteCard_getInstance});
protoOf(DarkDealingsCard).u37 = get_number;
initMetadataForObject(DarkDealingsCard, 'DarkDealingsCard', VOID, VOID, [DraftDarkActionCard, SerializerFactory], VOID, VOID, {0: DarkDealingsCard_getInstance});
protoOf(ProwlCard).u37 = get_number;
initMetadataForObject(ProwlCard, 'ProwlCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: ProwlCard_getInstance});
protoOf(DarkRitualsCard).u37 = get_number;
initMetadataForObject(DarkRitualsCard, 'DarkRitualsCard', VOID, VOID, [DraftDarkActionCard, SerializerFactory], VOID, VOID, {0: DarkRitualsCard_getInstance});
protoOf(InciteCard).u37 = get_number;
initMetadataForObject(InciteCard, 'InciteCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: InciteCard_getInstance});
protoOf(UnearthCard).u37 = get_number;
initMetadataForObject(UnearthCard, 'UnearthCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: UnearthCard_getInstance});
protoOf(ChargeCard).u37 = get_number;
initMetadataForObject(ChargeCard, 'ChargeCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: ChargeCard_getInstance});
protoOf(DisplaceCard).u37 = get_number;
initMetadataForObject(DisplaceCard, 'DisplaceCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: DisplaceCard_getInstance});
protoOf(GlimpseCard).u37 = get_number;
initMetadataForObject(GlimpseCard, 'GlimpseCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: GlimpseCard_getInstance});
protoOf(StrideCard).u37 = get_number;
initMetadataForObject(StrideCard, 'StrideCard', VOID, VOID, [DraftActionCard, SerializerFactory], VOID, VOID, {0: StrideCard_getInstance});
initMetadataForCompanion(Companion_147);
protoOf($serializer_127).z1b = typeParametersSerializers;
initMetadataForObject($serializer_127, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(UnknownDraftActionCard).u37 = get_number;
initMetadataForClass(UnknownDraftActionCard, 'UnknownDraftActionCard', VOID, VOID, [DraftActionCard, UnknownCard], VOID, VOID, {0: $serializer_getInstance_127});
initMetadataForCompanion(Companion_148, VOID, [SerializerFactory]);
protoOf(Draug).i3e = get_hunterCompanionType;
protoOf(Draug).w36 = modificationNumber;
protoOf(Draug).r36 = get_preferredLocation_1;
initMetadataForObject(Draug, 'Draug', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Draug_getInstance});
protoOf(BloodlessFuryUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BloodlessFuryUpgrade, 'BloodlessFuryUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BloodlessFuryUpgrade_getInstance});
protoOf(PalebloodAxesUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(PalebloodAxesUpgrade, 'PalebloodAxesUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: PalebloodAxesUpgrade_getInstance});
protoOf(SharedMadnessUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SharedMadnessUpgrade, 'SharedMadnessUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SharedMadnessUpgrade_getInstance});
initMetadataForObject(DraugCardWoundEffectSource, 'DraugCardWoundEffectSource', VOID, VOID, [EffectSource, DamageSource, SerializerFactory], VOID, VOID, {0: DraugCardWoundEffectSource_getInstance});
protoOf(BerserkCard).u37 = get_number;
initMetadataForObject(BerserkCard, 'BerserkCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: BerserkCard_getInstance});
initMetadataForCompanion(Companion_149);
protoOf($serializer_128).z1b = typeParametersSerializers;
initMetadataForObject($serializer_128, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DraugBerserkReactionStatement).n2o = canBeApplied;
protoOf(DraugBerserkReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(DraugBerserkReactionStatement, 'DraugBerserkReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_128});
initMetadataForCompanion(Companion_150);
protoOf($serializer_129).z1b = typeParametersSerializers;
initMetadataForObject($serializer_129, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GainDraugCorruptionStatement).n2o = canBeApplied;
protoOf(GainDraugCorruptionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(GainDraugCorruptionStatement, 'GainDraugCorruptionStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_129});
initMetadataForObject(DraugRespawnEvent, 'DraugRespawnEvent', VOID, VOID, [GameStateEvent, SerializerFactory], VOID, VOID, {0: DraugRespawnEvent_getInstance});
initMetadataForCompanion(Companion_151);
protoOf($serializer_130).z1b = typeParametersSerializers;
initMetadataForObject($serializer_130, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GainDraugCorruptionEvent, 'GainDraugCorruptionEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_130});
initMetadataForCompanion(Companion_152);
protoOf($serializer_131).z1b = typeParametersSerializers;
initMetadataForObject($serializer_131, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DraugCorruptionChangeEvent).o37 = stateChanges_0;
initMetadataForClass(DraugCorruptionChangeEvent, 'DraugCorruptionChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_131});
initMetadataForCompanion(Companion_153);
protoOf($serializer_132).z1b = typeParametersSerializers;
initMetadataForObject($serializer_132, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DraugRespawnStateChangeEvent).o37 = stateChanges_0;
initMetadataForClass(DraugRespawnStateChangeEvent, 'DraugRespawnStateChangeEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_132});
initMetadataForObject(PrepareDraugRespawnEvent, 'PrepareDraugRespawnEvent', VOID, VOID, [GameStateEvent, SerializerFactory], VOID, VOID, {0: PrepareDraugRespawnEvent_getInstance});
initMetadataForCompanion(Companion_154, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_155);
protoOf($serializer_133).z1b = typeParametersSerializers;
initMetadataForObject($serializer_133, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EventItselfSource, 'EventItselfSource', VOID, VOID, [EffectSource], VOID, VOID, {0: $serializer_getInstance_133});
initMetadataForObject(ClaimRuinEffectSource, 'ClaimRuinEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: ClaimRuinEffectSource_getInstance});
initMetadataForObject(PossibleTrapEffectSource, 'PossibleTrapEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: PossibleTrapEffectSource_getInstance});
initMetadataForInterface(ReactionCardTriggerEffectSource, 'ReactionCardTriggerEffectSource', VOID, VOID, [EffectSource], VOID, VOID, {0: Companion_getInstance_157});
initMetadataForObject(PossibleDreamerMaskEffectSource, 'PossibleDreamerMaskEffectSource', VOID, VOID, [ReactionCardTriggerEffectSource, SerializerFactory], VOID, VOID, {0: PossibleDreamerMaskEffectSource_getInstance});
initMetadataForObject(PossibleEsmeriasStrandEffectSource, 'PossibleEsmeriasStrandEffectSource', VOID, VOID, [ReactionCardTriggerEffectSource, SerializerFactory], VOID, VOID, {0: PossibleEsmeriasStrandEffectSource_getInstance});
initMetadataForObject(PossibleFlareEffectSource, 'PossibleFlareEffectSource', VOID, VOID, [ReactionCardTriggerEffectSource, SerializerFactory], VOID, VOID, {0: PossibleFlareEffectSource_getInstance});
initMetadataForObject(PossibleIntuitionEffectSource, 'PossibleIntuitionEffectSource', VOID, VOID, [ReactionCardTriggerEffectSource, SerializerFactory], VOID, VOID, {0: PossibleIntuitionEffectSource_getInstance});
initMetadataForObject(PossibleSmokeBombEffectSource, 'PossibleSmokeBombEffectSource', VOID, VOID, [ReactionCardTriggerEffectSource, SerializerFactory], VOID, VOID, {0: PossibleSmokeBombEffectSource_getInstance});
initMetadataForObject(PossibleSuddenMistEffectSource, 'PossibleSuddenMistEffectSource', VOID, VOID, [ReactionCardTriggerEffectSource, SerializerFactory], VOID, VOID, {0: PossibleSuddenMistEffectSource_getInstance});
initMetadataForObject(PossibleWorldShiftEffectSource, 'PossibleWorldShiftEffectSource', VOID, VOID, [ReactionCardTriggerEffectSource, SerializerFactory], VOID, VOID, {0: PossibleWorldShiftEffectSource_getInstance});
initMetadataForCompanion(Companion_156, VOID, [SerializerFactory]);
protoOf(Eivind).w36 = modificationNumber;
protoOf(Eivind).v36 = getInitList_0;
protoOf(Eivind).r36 = get_preferredLocation_1;
initMetadataForObject(Eivind, 'Eivind', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Eivind_getInstance});
protoOf(SkyMasterUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SkyMasterUpgrade, 'SkyMasterUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SkyMasterUpgrade_getInstance});
protoOf(RopePullUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(RopePullUpgrade, 'RopePullUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: RopePullUpgrade_getInstance});
protoOf(ReachUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ReachUpgrade, 'ReachUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ReachUpgrade_getInstance});
initMetadataForObject(FylgjaFlightEffectSource, 'FylgjaFlightEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: FylgjaFlightEffectSource_getInstance});
initMetadataForObject(SummonFylgjaEffectSource, 'SummonFylgjaEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: SummonFylgjaEffectSource_getInstance});
protoOf(GrapplingHookCard).u37 = get_number;
initMetadataForObject(GrapplingHookCard, 'GrapplingHookCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: GrapplingHookCard_getInstance});
protoOf(AviationCard).u37 = get_number;
initMetadataForObject(AviationCard, 'AviationCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: AviationCard_getInstance});
initMetadataForInterface(HunterCompanionType, 'HunterCompanionType', VOID, VOID, [SimpleObjectType, HumanKindType], VOID, VOID, {0: Companion_getInstance_384});
protoOf(Fylgja).n2z = get_maxHP_0;
protoOf(Fylgja).r36 = get_preferredLocation_1;
protoOf(Fylgja).v36 = getInitList;
initMetadataForObject(Fylgja, 'Fylgja', VOID, VOID, [HunterCompanionType, SerializerFactory], VOID, VOID, {0: Fylgja_getInstance});
initMetadataForCompanion(Companion_157);
protoOf($serializer_134).z1b = typeParametersSerializers;
initMetadataForObject($serializer_134, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(FylgjaFlightStatement).n2o = canBeApplied;
protoOf(FylgjaFlightStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(FylgjaFlightStatement, 'FylgjaFlightStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_134});
protoOf(SummonFylgjaStatement).n2o = canBeApplied;
protoOf(SummonFylgjaStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(SummonFylgjaStatement, 'SummonFylgjaStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: SummonFylgjaStatement_getInstance});
initMetadataForCompanion(Companion_158);
protoOf($serializer_135).z1b = typeParametersSerializers;
initMetadataForObject($serializer_135, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChangeFylgjaFlightWasUsedThisTurnEvent).o37 = stateChanges_0;
initMetadataForClass(ChangeFylgjaFlightWasUsedThisTurnEvent, 'ChangeFylgjaFlightWasUsedThisTurnEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_135});
initMetadataForCompanion(Companion_159);
protoOf($serializer_136).z1b = typeParametersSerializers;
initMetadataForObject($serializer_136, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EntityId, 'EntityId', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_136});
protoOf(EndlessStruggleUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(EndlessStruggleUpgrade, 'EndlessStruggleUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: EndlessStruggleUpgrade_getInstance});
protoOf(AccursedWrathUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AccursedWrathUpgrade, 'AccursedWrathUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AccursedWrathUpgrade_getInstance});
protoOf(KillingsSpreeUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(KillingsSpreeUpgrade, 'KillingsSpreeUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: KillingsSpreeUpgrade_getInstance});
protoOf(SinisterActUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SinisterActUpgrade, 'SinisterActUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SinisterActUpgrade_getInstance});
protoOf(MesmeriseUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(MesmeriseUpgrade, 'MesmeriseUpgrade', VOID, VOID, [ChargingUpgrade, SerializerFactory], VOID, VOID, {0: MesmeriseUpgrade_getInstance});
protoOf(TrueInstinctEsmeriaBeastUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(TrueInstinctEsmeriaBeastUpgrade, 'TrueInstinctEsmeriaBeastUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: TrueInstinctEsmeriaBeastUpgrade_getInstance});
protoOf(EsmeriaBeast).t36 = get_summonTypes;
protoOf(EsmeriaBeast).u36 = get_summonLimit;
protoOf(EsmeriaBeast).q2s = get_activatableSummonsOnMap;
protoOf(EsmeriaBeast).v36 = getInitList_1;
protoOf(EsmeriaBeast).w36 = modificationNumber;
initMetadataForObject(EsmeriaBeast, 'EsmeriaBeast', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: EsmeriaBeast_getInstance});
protoOf(ChangelingType).r36 = get_preferredLocation_0;
protoOf(ChangelingType).n2z = get_maxHP;
protoOf(ChangelingType).v36 = getInitList;
initMetadataForObject(ChangelingType, 'ChangelingType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: ChangelingType_getInstance});
protoOf(SummonChangelingCard).u37 = get_number;
initMetadataForObject(SummonChangelingCard, 'SummonChangelingCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SummonChangelingCard_getInstance});
protoOf(MurderCard).u37 = get_number;
initMetadataForObject(MurderCard, 'MurderCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: MurderCard_getInstance});
protoOf(StalkCard).u37 = get_number;
initMetadataForObject(StalkCard, 'StalkCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: StalkCard_getInstance});
protoOf(DeceiveCard).u37 = get_number;
initMetadataForObject(DeceiveCard, 'DeceiveCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: DeceiveCard_getInstance});
initMetadataForCompanion(Companion_160);
protoOf($serializer_137).z1b = typeParametersSerializers;
initMetadataForObject($serializer_137, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(HauntStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(HauntStatement, 'HauntStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_137});
initMetadataForCompanion(Companion_161);
protoOf($serializer_138).z1b = typeParametersSerializers;
initMetadataForObject($serializer_138, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DeceiveStatement).n2o = canBeApplied;
protoOf(DeceiveStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(DeceiveStatement, 'DeceiveStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_138});
initMetadataForObject(CardToCopyForDeceiveQuestionContext, 'CardToCopyForDeceiveQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: CardToCopyForDeceiveQuestionContext_getInstance});
protoOf(ChooseMesmeriseTargetStatement).n2o = canBeApplied;
protoOf(ChooseMesmeriseTargetStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(ChooseMesmeriseTargetStatement, 'ChooseMesmeriseTargetStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: ChooseMesmeriseTargetStatement_getInstance});
initMetadataForCompanion(Companion_162);
protoOf($serializer_139).z1b = typeParametersSerializers;
initMetadataForObject($serializer_139, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(MesmeriseChooseEvent).o37 = stateChanges_0;
initMetadataForClass(MesmeriseChooseEvent, 'MesmeriseChooseEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_139});
protoOf(EsmeriaHuntress).i3e = get_hunterCompanionType;
protoOf(EsmeriaHuntress).w36 = modificationNumber;
protoOf(EsmeriaHuntress).v36 = getInitList_0;
protoOf(EsmeriaHuntress).r36 = get_preferredLocation_1;
initMetadataForObject(EsmeriaHuntress, 'EsmeriaHuntress', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: EsmeriaHuntress_getInstance});
protoOf(HuntmasterUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(HuntmasterUpgrade, 'HuntmasterUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: HuntmasterUpgrade_getInstance});
protoOf(BlackStarUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BlackStarUpgrade, 'BlackStarUpgrade', VOID, VOID, [ChargingUpgrade, SerializerFactory], VOID, VOID, {0: BlackStarUpgrade_getInstance});
protoOf(PredictUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(PredictUpgrade, 'PredictUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: PredictUpgrade_getInstance});
protoOf(TrueInstinctEsmeriaHuntressUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(TrueInstinctEsmeriaHuntressUpgrade, 'TrueInstinctEsmeriaHuntressUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: TrueInstinctEsmeriaHuntressUpgrade_getInstance});
protoOf(UnnaturalResolveCard).u37 = get_number;
initMetadataForObject(UnnaturalResolveCard, 'UnnaturalResolveCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: UnnaturalResolveCard_getInstance});
protoOf(DelegateCard).u37 = get_number;
initMetadataForObject(DelegateCard, 'DelegateCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: DelegateCard_getInstance});
initMetadataForCompanion(Companion_163);
protoOf($serializer_140).z1b = typeParametersSerializers;
initMetadataForObject($serializer_140, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(UnnaturalResolveStatement).n2o = canBeApplied;
protoOf(UnnaturalResolveStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(UnnaturalResolveStatement, 'UnnaturalResolveStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_140});
protoOf(BlackStarStatement).n2o = canBeApplied;
protoOf(BlackStarStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(BlackStarStatement, 'BlackStarStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: BlackStarStatement_getInstance});
initMetadataForCompanion(Companion_164);
protoOf($serializer_141).z1b = typeParametersSerializers;
initMetadataForObject($serializer_141, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChangeBlueDraftActionCardWasPlayedStatusEvent).o37 = stateChanges_0;
initMetadataForClass(ChangeBlueDraftActionCardWasPlayedStatusEvent, 'ChangeBlueDraftActionCardWasPlayedStatusEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_141});
protoOf(BloodLustUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BloodLustUpgrade, 'BloodLustUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BloodLustUpgrade_getInstance});
protoOf(EnragedUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(EnragedUpgrade, 'EnragedUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: EnragedUpgrade_getInstance});
protoOf(GreatHowlUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(GreatHowlUpgrade, 'GreatHowlUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: GreatHowlUpgrade_getInstance});
protoOf(HuntingGroundsUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(HuntingGroundsUpgrade, 'HuntingGroundsUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: HuntingGroundsUpgrade_getInstance});
protoOf(KinsPursuitUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(KinsPursuitUpgrade, 'KinsPursuitUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: KinsPursuitUpgrade_getInstance});
protoOf(NaturalInstinctUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(NaturalInstinctUpgrade, 'NaturalInstinctUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: NaturalInstinctUpgrade_getInstance});
protoOf(CullingUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(CullingUpgrade, 'CullingUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: CullingUpgrade_getInstance});
protoOf(Fangrir).t36 = get_summonTypes;
protoOf(Fangrir).u36 = get_summonLimit;
protoOf(Fangrir).q2s = get_activatableSummonsOnMap;
protoOf(Fangrir).v36 = getInitList_1;
initMetadataForObject(Fangrir, 'Fangrir', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Fangrir_getInstance});
protoOf(WolfType).r36 = get_preferredLocation_0;
protoOf(WolfType).n2z = get_maxHP;
protoOf(WolfType).v36 = getInitList;
initMetadataForObject(WolfType, 'WolfType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: WolfType_getInstance});
protoOf(SummonWolfCard).u37 = get_number;
initMetadataForObject(SummonWolfCard, 'SummonWolfCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SummonWolfCard_getInstance});
protoOf(LurkCard).u37 = get_number;
initMetadataForObject(LurkCard, 'LurkCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: LurkCard_getInstance});
protoOf(PreyUponCard).u37 = get_number;
initMetadataForObject(PreyUponCard, 'PreyUponCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: PreyUponCard_getInstance});
protoOf(GatherThePackCard).u37 = get_number;
initMetadataForObject(GatherThePackCard, 'GatherThePackCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: GatherThePackCard_getInstance});
protoOf(GreatHowlStatement).n2o = canBeApplied;
protoOf(GreatHowlStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(GreatHowlStatement, 'GreatHowlStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: GreatHowlStatement_getInstance});
protoOf(Fara).i3e = get_hunterCompanionType;
protoOf(Fara).w36 = modificationNumber;
protoOf(Fara).v36 = getInitList_0;
protoOf(Fara).r36 = get_preferredLocation_1;
initMetadataForObject(Fara, 'Fara', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Fara_getInstance});
protoOf(IgniteUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(IgniteUpgrade, 'IgniteUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: IgniteUpgrade_getInstance});
protoOf(FlingUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(FlingUpgrade, 'FlingUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: FlingUpgrade_getInstance});
protoOf(DarkFlameUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DarkFlameUpgrade, 'DarkFlameUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DarkFlameUpgrade_getInstance});
protoOf(RebirthByFireUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(RebirthByFireUpgrade, 'RebirthByFireUpgrade', VOID, VOID, [ChargingUpgrade, SerializerFactory], VOID, VOID, {0: RebirthByFireUpgrade_getInstance});
protoOf(FlameRapierCard).u37 = get_number;
initMetadataForObject(FlameRapierCard, 'FlameRapierCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: FlameRapierCard_getInstance});
protoOf(OverloadedFlameRapierCard).u37 = get_number;
initMetadataForObject(OverloadedFlameRapierCard, 'OverloadedFlameRapierCard', VOID, VOID, [OverloadedCard, PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: OverloadedFlameRapierCard_getInstance});
initMetadataForCompanion(Companion_165);
protoOf($serializer_142).z1b = typeParametersSerializers;
initMetadataForObject($serializer_142, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(FlameRapierStatement).n2o = canBeApplied;
protoOf(FlameRapierStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(FlameRapierStatement, 'FlameRapierStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_142});
initMetadataForCompanion(Companion_166);
protoOf($serializer_143).z1b = typeParametersSerializers;
initMetadataForObject($serializer_143, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(OverloadedFlameRapierMovementStatement, 'OverloadedFlameRapierMovementStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_143});
initMetadataForObject(ResurrectionUpgrade, 'ResurrectionUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ResurrectionUpgrade_getInstance});
initMetadataForObject(OverlordUpgrade, 'OverlordUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: OverlordUpgrade_getInstance});
initMetadataForObject(RegalUpgrade, 'RegalUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: RegalUpgrade_getInstance});
initMetadataForObject(ProminenceUpgrade, 'ProminenceUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ProminenceUpgrade_getInstance});
initMetadataForObject(EndlessDreamUpgrade, 'EndlessDreamUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: EndlessDreamUpgrade_getInstance});
initMetadataForObject(WorshipUpgrade, 'WorshipUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: WorshipUpgrade_getInstance});
initMetadataForObject(MartyrUpgrade, 'MartyrUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: MartyrUpgrade_getInstance});
initMetadataForObject(SoulCollectorUpgrade, 'SoulCollectorUpgrade', VOID, VOID, [ChargingUpgrade, SerializerFactory], VOID, VOID, {0: SoulCollectorUpgrade_getInstance});
protoOf(FeatheredKing).t36 = get_summonTypes;
protoOf(FeatheredKing).q2s = get_activatableSummonsOnMap;
protoOf(FeatheredKing).v36 = getInitList_1;
protoOf(FeatheredKing).w36 = modificationNumber;
initMetadataForObject(FeatheredKing, 'FeatheredKing', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: FeatheredKing_getInstance});
initMetadataForCompanion(Companion_167);
protoOf($serializer_144).z1b = typeParametersSerializers;
initMetadataForObject($serializer_144, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DevotionStatement).n2o = canBeApplied;
protoOf(DevotionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(DevotionStatement, 'DevotionStatement', VOID, VOID, [ActionStatement, DamageSource], VOID, VOID, {0: $serializer_getInstance_144});
protoOf(ResurrectionStatement).n2o = canBeApplied;
protoOf(ResurrectionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(ResurrectionStatement, 'ResurrectionStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: ResurrectionStatement_getInstance});
protoOf(DreamerType).r36 = get_preferredLocation_0;
protoOf(DreamerType).n2z = get_maxHP;
protoOf(DreamerType).v36 = getInitList;
initMetadataForObject(DreamerType, 'DreamerType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: DreamerType_getInstance});
protoOf(SummonDreamerCard).u37 = get_number;
initMetadataForObject(SummonDreamerCard, 'SummonDreamerCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SummonDreamerCard_getInstance});
protoOf(UnwillingSacrificeCard).u37 = get_number;
initMetadataForObject(UnwillingSacrificeCard, 'UnwillingSacrificeCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: UnwillingSacrificeCard_getInstance});
protoOf(UnburdenCard).u37 = get_number;
initMetadataForObject(UnburdenCard, 'UnburdenCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: UnburdenCard_getInstance});
protoOf(UpriseCard).u37 = get_number;
initMetadataForObject(UpriseCard, 'UpriseCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: UpriseCard_getInstance});
initMetadataForCompanion(Companion_168);
protoOf($serializer_145).z1b = typeParametersSerializers;
initMetadataForObject($serializer_145, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(StealGrudgeFromNearbyHunterStatement).n2o = canBeApplied;
protoOf(StealGrudgeFromNearbyHunterStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(StealGrudgeFromNearbyHunterStatement, 'StealGrudgeFromNearbyHunterStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_145});
initMetadataForCompanion(Companion_169);
protoOf($serializer_146).z1b = typeParametersSerializers;
initMetadataForObject($serializer_146, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UpriseUpgradedStatement, 'UpriseUpgradedStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_146});
initMetadataForObject(DreamerToSacrificeQuestionContext, 'DreamerToSacrificeQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: DreamerToSacrificeQuestionContext_getInstance});
initMetadataForObject(HunterToStealGrudgeQuestionContext, 'HunterToStealGrudgeQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToStealGrudgeQuestionContext_getInstance});
protoOf(RedirectDamageToDreamerStatement).n2o = canBeApplied;
protoOf(RedirectDamageToDreamerStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(RedirectDamageToDreamerStatement, 'RedirectDamageToDreamerStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: RedirectDamageToDreamerStatement_getInstance});
initMetadataForCompanion(Companion_170);
protoOf($serializer_147).z1b = typeParametersSerializers;
initMetadataForObject($serializer_147, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SacrificeToPlayDoubleDarkStatement).n2o = canBeApplied;
protoOf(SacrificeToPlayDoubleDarkStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SacrificeToPlayDoubleDarkStatement, 'SacrificeToPlayDoubleDarkStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_147});
initMetadataForCompanion(Companion_171);
protoOf($serializer_148).z1b = typeParametersSerializers;
initMetadataForObject($serializer_148, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChangeFeatheredKingRebornStatusEvent).o37 = stateChanges_0;
initMetadataForClass(ChangeFeatheredKingRebornStatusEvent, 'ChangeFeatheredKingRebornStatusEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_148});
initMetadataForClass(Zone, 'Zone');
initMetadataForCompanion(Companion_172);
protoOf($serializer_149).z1b = typeParametersSerializers;
initMetadataForObject($serializer_149, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(GameMap, 'GameMap');
initMetadataForClass(GameMapImpl, 'GameMapImpl', VOID, VOID, [GameMap], VOID, VOID, {0: $serializer_getInstance_149});
initMetadataForCompanion(Companion_173);
protoOf($serializer_150).z1b = typeParametersSerializers;
initMetadataForObject($serializer_150, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LocationInit, 'LocationInit', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_150});
initMetadataForClass(LocationType, 'LocationType');
initMetadataForClass(LocationType$Settlement, 'Settlement');
initMetadataForClass(LocationType$Swamp, 'Swamp');
initMetadataForClass(LocationType$Forest, 'Forest');
initMetadataForClass(LocationType$Cave, 'Cave');
initMetadataForClass(LocationType$AbyssalSwamp, 'AbyssalSwamp');
initMetadataForClass(LocationType$AbyssalForest, 'AbyssalForest');
initMetadataForClass(LocationType$AbyssalCave, 'AbyssalCave');
initMetadataForClass(LocationType$LivingWeb, 'LivingWeb');
initMetadataForClass(LocationType$CaveAndForest, 'CaveAndForest');
initMetadataForClass(LocationType$SwampAndForest, 'SwampAndForest');
initMetadataForClass(LocationType$SwampAndCave, 'SwampAndCave');
initMetadataForClass(LocationType$LairOfTheBeast, 'LairOfTheBeast');
initMetadataForClass(LocationType$None, 'None');
initMetadataForClass(GameMapId, 'GameMapId');
initMetadataForCompanion(Companion_174);
protoOf($serializer_151).z1b = typeParametersSerializers;
initMetadataForObject($serializer_151, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PositionAndDirection, 'PositionAndDirection', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_151});
initMetadataForClass(StaticNearbyAdjuster, 'StaticNearbyAdjuster');
initMetadataForCompanion(Companion_175, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_176);
protoOf($serializer_152).z1b = typeParametersSerializers;
initMetadataForObject($serializer_152, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AncientPowerNumberQuestion).t3o = get_questionContext;
initMetadataForClass(AncientPowerNumberQuestion, 'AncientPowerNumberQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_152});
initMetadataForCompanion(Companion_177);
protoOf($serializer_153).z1b = typeParametersSerializers;
initMetadataForObject($serializer_153, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastMovementCardQuestion, 'BeastMovementCardQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_153});
initMetadataForInterface(BooleanGameQuestion, 'BooleanGameQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: Companion_getInstance_200});
protoOf(PlayOverloadedQuestion).s3o = get_variants;
protoOf(PlayOverloadedQuestion).t3o = get_questionContext;
initMetadataForObject(PlayOverloadedQuestion, 'PlayOverloadedQuestion', VOID, VOID, [BooleanGameQuestion, SerializerFactory], VOID, VOID, {0: PlayOverloadedQuestion_getInstance});
protoOf(RevealToMoveQuestion).s3o = get_variants;
protoOf(RevealToMoveQuestion).t3o = get_questionContext;
initMetadataForObject(RevealToMoveQuestion, 'RevealToMoveQuestion', VOID, VOID, [BooleanGameQuestion, SerializerFactory], VOID, VOID, {0: RevealToMoveQuestion_getInstance});
initMetadataForCompanion(Companion_178);
protoOf($serializer_154).z1b = typeParametersSerializers;
initMetadataForObject($serializer_154, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(UseVackerSoulsQuestion).s3o = get_variants;
protoOf(UseVackerSoulsQuestion).t3o = get_questionContext;
initMetadataForClass(UseVackerSoulsQuestion, 'UseVackerSoulsQuestion', VOID, VOID, [BooleanGameQuestion], VOID, VOID, {0: $serializer_getInstance_154});
protoOf(CardPlayColorQuestion).t3o = get_questionContext;
initMetadataForObject(CardPlayColorQuestion, 'CardPlayColorQuestion', VOID, VOID, [GameQuestion, SerializerFactory], VOID, VOID, {0: CardPlayColorQuestion_getInstance});
initMetadataForCompanion(Companion_179);
protoOf($serializer_155).z1b = typeParametersSerializers;
initMetadataForObject($serializer_155, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChooseCardOnDraftQuestion).t3o = get_questionContext;
initMetadataForClass(ChooseCardOnDraftQuestion, 'ChooseCardOnDraftQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_155});
initMetadataForCompanion(Companion_180);
protoOf($serializer_156).z1b = typeParametersSerializers;
initMetadataForObject($serializer_156, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ChooseCardsQuestion, 'ChooseCardsQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_156});
initMetadataForCompanion(Companion_181);
protoOf($serializer_157).z1b = typeParametersSerializers;
initMetadataForObject($serializer_157, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChooseCharacterQuestion).t3o = get_questionContext;
initMetadataForClass(ChooseCharacterQuestion, 'ChooseCharacterQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_157});
protoOf(ContinueAfterRecoveryQuestion).t3o = get_questionContext;
initMetadataForObject(ContinueAfterRecoveryQuestion, 'ContinueAfterRecoveryQuestion', VOID, VOID, [GameQuestion, SerializerFactory], VOID, VOID, {0: ContinueAfterRecoveryQuestion_getInstance});
initMetadataForCompanion(Companion_182);
protoOf($serializer_158).z1b = typeParametersSerializers;
initMetadataForObject($serializer_158, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DestinationQuestion).t3o = get_questionContext;
initMetadataForClass(DestinationQuestion, 'DestinationQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_158});
initMetadataForCompanion(Companion_183);
protoOf($serializer_159).z1b = typeParametersSerializers;
initMetadataForObject($serializer_159, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GrapnelQuestion).t3o = get_questionContext;
initMetadataForClass(GrapnelQuestion, 'GrapnelQuestion', VOID, VOID, [LocationQuestionBase], VOID, VOID, {0: $serializer_getInstance_159});
initMetadataForCompanion(Companion_184);
protoOf($serializer_160).z1b = typeParametersSerializers;
initMetadataForObject($serializer_160, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LocationQuestion, 'LocationQuestion', VOID, VOID, [LocationQuestionBase], VOID, VOID, {0: $serializer_getInstance_160});
initMetadataForCompanion(Companion_185);
protoOf($serializer_161).z1b = typeParametersSerializers;
initMetadataForObject($serializer_161, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceNewObjectQuestion).t3o = get_questionContext;
initMetadataForClass(PlaceNewObjectQuestion, 'PlaceNewObjectQuestion', VOID, VOID, [LocationQuestionBase], VOID, VOID, {0: $serializer_getInstance_161});
initMetadataForCompanion(Companion_186);
protoOf($serializer_162).z1b = typeParametersSerializers;
initMetadataForObject($serializer_162, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SearchLocationQuestion).t3o = get_questionContext;
initMetadataForClass(SearchLocationQuestion, 'SearchLocationQuestion', VOID, VOID, [LocationQuestionBase], VOID, VOID, {0: $serializer_getInstance_162});
initMetadataForCompanion(Companion_187);
protoOf($serializer_163).z1b = typeParametersSerializers;
initMetadataForObject($serializer_163, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(TransformLocationQuestion).t3o = get_questionContext;
initMetadataForClass(TransformLocationQuestion, 'TransformLocationQuestion', VOID, VOID, [LocationQuestionBase], VOID, VOID, {0: $serializer_getInstance_163});
initMetadataForCompanion(Companion_188);
protoOf($serializer_164).z1b = typeParametersSerializers;
initMetadataForObject($serializer_164, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(LocationTypeQuestion).t3o = get_questionContext;
initMetadataForClass(LocationTypeQuestion, 'LocationTypeQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_164});
initMetadataForCompanion(Companion_189, VOID, [SerializerFactory]);
initMetadataForClass($serializer_165, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ObjectsGameQuestion, 'ObjectsGameQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: Companion_getInstance_190});
initMetadataForCompanion(Companion_190);
protoOf($serializer_166).z1b = typeParametersSerializers;
initMetadataForObject($serializer_166, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PhaseRecoveryQuestion).t3o = get_questionContext;
initMetadataForClass(PhaseRecoveryQuestion, 'PhaseRecoveryQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_165});
initMetadataForCompanion(Companion_191);
protoOf($serializer_167).z1b = typeParametersSerializers;
initMetadataForObject($serializer_167, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlayCardInTurnQuestion).t3o = get_questionContext;
initMetadataForClass(PlayCardInTurnQuestion, 'PlayCardInTurnQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_166});
initMetadataForCompanion(Companion_192);
protoOf($serializer_168).z1b = typeParametersSerializers;
initMetadataForObject($serializer_168, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(StatementQuestion).t3o = get_questionContext;
initMetadataForClass(StatementQuestion, 'StatementQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_167});
initMetadataForCompanion(Companion_193);
protoOf($serializer_169).z1b = typeParametersSerializers;
initMetadataForObject($serializer_169, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(TrapByNumberQuestion).t3o = get_questionContext;
initMetadataForClass(TrapByNumberQuestion, 'TrapByNumberQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_168});
initMetadataForCompanion(Companion_194);
protoOf($serializer_170).z1b = typeParametersSerializers;
initMetadataForObject($serializer_170, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(TriggersQuestion).t3o = get_questionContext;
initMetadataForClass(TriggersQuestion, 'TriggersQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_169});
initMetadataForCompanion(Companion_195);
protoOf($serializer_171).z1b = typeParametersSerializers;
initMetadataForObject($serializer_171, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UpgradeQuestion, 'UpgradeQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_170});
initMetadataForCompanion(Companion_196);
protoOf($serializer_172).z1b = typeParametersSerializers;
initMetadataForObject($serializer_172, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ZoneQuestion).t3o = get_questionContext;
initMetadataForClass(ZoneQuestion, 'ZoneQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_171});
initMetadataForCompanion(Companion_197, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_198);
protoOf($serializer_173).z1b = typeParametersSerializers;
initMetadataForObject($serializer_173, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastMovementCardVariant, 'BeastMovementCardVariant', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_172});
initMetadataForObject(BeastMovementCardQuestionContext, 'BeastMovementCardQuestionContext', VOID, VOID, [QuestionContext, SerializerFactory], VOID, VOID, {0: BeastMovementCardQuestionContext_getInstance});
initMetadataForCompanion(Companion_199, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_200, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_201, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_202, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_203, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_204, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_205);
protoOf($serializer_174).z1b = typeParametersSerializers;
initMetadataForObject($serializer_174, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TriggerOption, 'TriggerOption', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_173});
initMetadataForCompanion(Companion_206);
protoOf($serializer_175).z1b = typeParametersSerializers;
initMetadataForObject($serializer_175, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TheoreticalTrigger, 'TheoreticalTrigger', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_174});
initMetadataForCompanion(Companion_207, VOID, [SerializerFactory]);
initMetadataForInterface(UpgradeQuestionContext, 'UpgradeQuestionContext', VOID, VOID, [QuestionContext], VOID, VOID, {0: Companion_getInstance_208});
initMetadataForObject(ArsenalCardToGainQuestionContext, 'ArsenalCardToGainQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: ArsenalCardToGainQuestionContext_getInstance});
initMetadataForObject(BeastlyTalentToPlayQuestionContext, 'BeastlyTalentToPlayQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: BeastlyTalentToPlayQuestionContext_getInstance});
initMetadataForObject(CardToDiscardQuestionContext, 'CardToDiscardQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: CardToDiscardQuestionContext_getInstance});
initMetadataForObject(DiscardedAbilityCardToRetrieveQuestionContext, 'DiscardedAbilityCardToRetrieveQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: DiscardedAbilityCardToRetrieveQuestionContext_getInstance});
initMetadataForObject(DiscardedDraftActionCardToRetrieveQuestionContext, 'DiscardedDraftActionCardToRetrieveQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: DiscardedDraftActionCardToRetrieveQuestionContext_getInstance});
initMetadataForObject(HunterItemToPlayQuestionContext, 'HunterItemToPlayQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: HunterItemToPlayQuestionContext_getInstance});
initMetadataForCompanion(Companion_208);
protoOf($serializer_176).z1b = typeParametersSerializers;
initMetadataForObject($serializer_176, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RandomResultQuestionContext, 'RandomResultQuestionContext', VOID, VOID, [CardQuestionContext], VOID, VOID, {0: $serializer_getInstance_175});
initMetadataForObject(UnusedDraftActionCardToRetrieveQuestionContext, 'UnusedDraftActionCardToRetrieveQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: UnusedDraftActionCardToRetrieveQuestionContext_getInstance});
initMetadataForObject(AshRuinLocationQuestionContext, 'AshRuinLocationQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: AshRuinLocationQuestionContext_getInstance});
initMetadataForObject(AnimalToMoveQuestionContext, 'AnimalToMoveQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: AnimalToMoveQuestionContext_getInstance});
initMetadataForObject(AttackTargetQuestionContext, 'AttackTargetQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: AttackTargetQuestionContext_getInstance});
initMetadataForObject(BeastToGainBeastlyTalentQuestionContext, 'BeastToGainBeastlyTalentQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: BeastToGainBeastlyTalentQuestionContext_getInstance});
initMetadataForObject(BeastToPerformEffectQuestionContext, 'BeastToPerformEffectQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: BeastToPerformEffectQuestionContext_getInstance});
initMetadataForObject(BeingRelocatingByGrapnelQuestionContext, 'BeingRelocatingByGrapnelQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: BeingRelocatingByGrapnelQuestionContext_getInstance});
initMetadataForObject(BeingToMoveAlongsideQuestionContext, 'BeingToMoveAlongsideQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: BeingToMoveAlongsideQuestionContext_getInstance});
initMetadataForObject(BeingToMoveByRuinQuestionContext, 'BeingToMoveByRuinQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: BeingToMoveByRuinQuestionContext_getInstance});
initMetadataForObject(BoarToMoveQuestionContext, 'BoarToMoveQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: BoarToMoveQuestionContext_getInstance});
initMetadataForObject(FarmerToNobleQuestionContext, 'FarmerToNobleQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: FarmerToNobleQuestionContext_getInstance});
initMetadataForObject(HandInspectTargetQuestionContext, 'HandInspectTargetQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HandInspectTargetQuestionContext_getInstance});
initMetadataForObject(HunterToGiveChainGrapnelQuestionContext, 'HunterToGiveChainGrapnelQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToGiveChainGrapnelQuestionContext_getInstance});
initMetadataForObject(HunterToMesmeriseQuestionContext, 'HunterToMesmeriseQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToMesmeriseQuestionContext_getInstance});
initMetadataForObject(HunterToMoveQuestionContext, 'HunterToMoveQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToMoveQuestionContext_getInstance});
initMetadataForObject(HunterToPerformEffectQuestionContext, 'HunterToPerformEffectQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToPerformEffectQuestionContext_getInstance});
initMetadataForObject(HunterToRelocateQuestionContext, 'HunterToRelocateQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToRelocateQuestionContext_getInstance});
initMetadataForObject(HunterToResolveRuinQuestionContext, 'HunterToResolveRuinQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToResolveRuinQuestionContext_getInstance});
initMetadataForObject(HunterToReturnQuestionContext, 'HunterToReturnQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToReturnQuestionContext_getInstance});
initMetadataForObject(HunterToSkipNextTurnQuestionContext, 'HunterToSkipNextTurnQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterToSkipNextTurnQuestionContext_getInstance});
initMetadataForObject(NobleToFarmerQuestionContext, 'NobleToFarmerQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: NobleToFarmerQuestionContext_getInstance});
initMetadataForObject(OutpostToReplaceQuestionContext, 'OutpostToReplaceQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: OutpostToReplaceQuestionContext_getInstance});
initMetadataForObject(SettlerQuestionContext, 'SettlerQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SettlerQuestionContext_getInstance});
initMetadataForObject(SettlerToMoveQuestionContext, 'SettlerToMoveQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SettlerToMoveQuestionContext_getInstance});
initMetadataForObject(SummonToActivateQuestionContext, 'SummonToActivateQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SummonToActivateQuestionContext_getInstance});
initMetadataForObject(SummonToAttackWithQuestionContext, 'SummonToAttackWithQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SummonToAttackWithQuestionContext_getInstance});
initMetadataForObject(SummonToMoveQuestionContext, 'SummonToMoveQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SummonToMoveQuestionContext_getInstance});
initMetadataForObject(SummonToReplaceQuestionContext, 'SummonToReplaceQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SummonToReplaceQuestionContext_getInstance});
initMetadataForObject(SummonToSacrificeForRuinQuestionContext, 'SummonToSacrificeForRuinQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SummonToSacrificeForRuinQuestionContext_getInstance});
initMetadataForObject(TargetToBlockDamageForQuestionContext, 'TargetToBlockDamageForQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: TargetToBlockDamageForQuestionContext_getInstance});
initMetadataForObject(TargetToDamageQuestionContext, 'TargetToDamageQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: TargetToDamageQuestionContext_getInstance});
initMetadataForObject(TargetToHealQuestionContext, 'TargetToHealQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: TargetToHealQuestionContext_getInstance});
initMetadataForObject(TargetToMoveQuestionContext, 'TargetToMoveQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: TargetToMoveQuestionContext_getInstance});
initMetadataForObject(TargetToPullQuestionContext, 'TargetToPullQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: TargetToPullQuestionContext_getInstance});
initMetadataForObject(TargetToSpendAncientPowersOnQuestionContext, 'TargetToSpendAncientPowersOnQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: TargetToSpendAncientPowersOnQuestionContext_getInstance});
initMetadataForObject(VictimToProtectQuestionContext, 'VictimToProtectQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: VictimToProtectQuestionContext_getInstance});
initMetadataForCompanion(Companion_209);
protoOf($serializer_177).z1b = typeParametersSerializers;
initMetadataForObject($serializer_177, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DiscardToMoveVariant, 'DiscardToMoveVariant', VOID, VOID, [TurnVariant], VOID, VOID, {0: $serializer_getInstance_176});
initMetadataForCompanion(Companion_210);
protoOf($serializer_178).z1b = typeParametersSerializers;
initMetadataForObject($serializer_178, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DiscardToUseBoatVariant, 'DiscardToUseBoatVariant', VOID, VOID, [TurnVariant], VOID, VOID, {0: $serializer_getInstance_177});
initMetadataForObject(PassVariant, 'PassVariant', VOID, VOID, [TurnVariant, SerializerFactory], VOID, VOID, {0: PassVariant_getInstance});
initMetadataForCompanion(Companion_211);
protoOf($serializer_179).z1b = typeParametersSerializers;
initMetadataForObject($serializer_179, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlayCardVariant, 'PlayCardVariant', VOID, VOID, [TurnVariant], VOID, VOID, {0: $serializer_getInstance_178});
initMetadataForCompanion(Companion_212);
protoOf($serializer_180).z1b = typeParametersSerializers;
initMetadataForObject($serializer_180, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(TriggerOptionRequirement, 'TriggerOptionRequirement', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_214});
initMetadataForClass(CardRequirement, 'CardRequirement', VOID, VOID, [TriggerOptionRequirement], VOID, VOID, {0: $serializer_getInstance_179});
initMetadataForObject(Optional, 'Optional', VOID, VOID, [TriggerOptionRequirement, SerializerFactory], VOID, VOID, {0: Optional_getInstance});
initMetadataForObject(Mandatory, 'Mandatory', VOID, VOID, [TriggerOptionRequirement, SerializerFactory], VOID, VOID, {0: Mandatory_getInstance});
initMetadataForCompanion(Companion_213, VOID, [SerializerFactory]);
initMetadataForClass(BeastGameExpansions, 'BeastGameExpansions');
initMetadataForCompanion(Companion_214, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_215, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_216, VOID, [SerializerFactory]);
initMetadataForClass(BeastBalanceVersion, 'BeastBalanceVersion', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_217});
initMetadataForCompanion(Companion_217, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_218);
protoOf($serializer_181).z1b = typeParametersSerializers;
initMetadataForObject($serializer_181, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameRulesParameters, 'GameRulesParameters', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_180});
initMetadataForCompanion(Companion_219);
protoOf($serializer_182).z1b = typeParametersSerializers;
initMetadataForObject($serializer_182, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameContentVersion, 'GameContentVersion', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_181});
initMetadataForCompanion(Companion_220);
protoOf($serializer_183).z1b = typeParametersSerializers;
initMetadataForObject($serializer_183, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SimpleStartingBonuses, 'SimpleStartingBonuses', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_182});
initMetadataForClass(NightRewardStatus, 'NightRewardStatus');
initMetadataForCompanion(Companion_221);
protoOf($serializer_184).z1b = typeParametersSerializers;
initMetadataForObject($serializer_184, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameTeam, 'GameTeam', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_183});
initMetadataForCompanion(Companion_222, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_223);
protoOf($serializer_185).z1b = typeParametersSerializers;
initMetadataForObject($serializer_185, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlayerTurnPhase, 'PlayerTurnPhase', VOID, VOID, [GamePhase], VOID, VOID, {0: $serializer_getInstance_184});
initMetadataForCompanion(Companion_224, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_225, VOID, [SerializerFactory]);
initMetadataForClass(ValueId, 'ValueId');
initMetadataForCompanion(Companion_226);
protoOf($serializer_186).z1b = typeParametersSerializers;
initMetadataForObject($serializer_186, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DawnPhase, 'DawnPhase', DawnPhase, VOID, [GamePhase], VOID, VOID, {0: $serializer_getInstance_185});
initMetadataForObject(StartOfDayPhase, 'StartOfDayPhase', VOID, VOID, [GamePhase, SerializerFactory], VOID, VOID, {0: StartOfDayPhase_getInstance});
initMetadataForCompanion(Companion_227);
protoOf($serializer_187).z1b = typeParametersSerializers;
initMetadataForObject($serializer_187, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CardApplyingScope, 'CardApplyingScope', VOID, VOID, [GameScope], VOID, VOID, {0: $serializer_getInstance_186});
initMetadataForCompanion(Companion_228);
protoOf($serializer_188).z1b = typeParametersSerializers;
initMetadataForObject($serializer_188, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CardResolvingScope, 'CardResolvingScope', VOID, VOID, [GameScope], VOID, VOID, {0: $serializer_getInstance_187});
initMetadataForCompanion(Companion_229);
protoOf($serializer_189).z1b = typeParametersSerializers;
initMetadataForObject($serializer_189, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ControllingActorScope, 'ControllingActorScope', VOID, VOID, [GameScope], VOID, VOID, {0: $serializer_getInstance_188});
initMetadataForCompanion(Companion_230);
protoOf($serializer_190).z1b = typeParametersSerializers;
initMetadataForObject($serializer_190, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EffectsAfterEventScope, 'EffectsAfterEventScope', VOID, VOID, [GameScope], VOID, VOID, {0: $serializer_getInstance_189});
initMetadataForCompanion(Companion_231);
protoOf($serializer_191).z1b = typeParametersSerializers;
initMetadataForObject($serializer_191, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EventTriggeredByEffectSourceScope, 'EventTriggeredByEffectSourceScope', VOID, VOID, [GameScope], VOID, VOID, {0: $serializer_getInstance_190});
initMetadataForCompanion(Companion_232);
protoOf($serializer_192).z1b = typeParametersSerializers;
initMetadataForObject($serializer_192, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EffectRecoveryScope, 'EffectRecoveryScope', VOID, VOID, [ItselfGameScope], VOID, VOID, {0: $serializer_getInstance_191});
initMetadataForObject(FullPreGamePhase, 'FullPreGamePhase', VOID, VOID, [GamePhase, SerializerFactory], VOID, VOID, {0: FullPreGamePhase_getInstance});
initMetadataForObject(InitialPhase, 'InitialPhase', VOID, VOID, [GamePhase, SerializerFactory], VOID, VOID, {0: InitialPhase_getInstance});
initMetadataForObject(NightPhase, 'NightPhase', VOID, VOID, [GamePhase, SerializerFactory], VOID, VOID, {0: NightPhase_getInstance});
initMetadataForObject(NonePhase, 'NonePhase', VOID, VOID, [GamePhase, SerializerFactory], VOID, VOID, {0: NonePhase_getInstance});
initMetadataForObject(PreGamePhase, 'PreGamePhase', VOID, VOID, [GamePhase, SerializerFactory], VOID, VOID, {0: PreGamePhase_getInstance});
initMetadataForCompanion(Companion_233);
protoOf($serializer_193).z1b = typeParametersSerializers;
initMetadataForObject($serializer_193, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PhaseRecoveryScope, 'PhaseRecoveryScope', VOID, VOID, [ItselfGameScope], VOID, VOID, {0: $serializer_getInstance_192});
initMetadataForCompanion(Companion_234);
protoOf($serializer_194).z1b = typeParametersSerializers;
initMetadataForObject($serializer_194, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TextItselfGameScope, 'TextItselfGameScope', VOID, VOID, [ItselfGameScope], VOID, VOID, {0: $serializer_getInstance_193});
initMetadataForCompanion(Companion_235);
protoOf($serializer_195).z1b = typeParametersSerializers;
initMetadataForObject($serializer_195, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(NightlyRewardScope, 'NightlyRewardScope', VOID, VOID, [GameScope], VOID, VOID, {0: $serializer_getInstance_194});
initMetadataForCompanion(Companion_236);
protoOf($serializer_196).z1b = typeParametersSerializers;
initMetadataForObject($serializer_196, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ReactionCardScope, 'ReactionCardScope', VOID, VOID, [GameScope], VOID, VOID, {0: $serializer_getInstance_195});
initMetadataForCompanion(Companion_237);
protoOf($serializer_197).z1b = typeParametersSerializers;
initMetadataForObject($serializer_197, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevealedTriggerSource, 'RevealedTriggerSource', VOID, VOID, [GameScope], VOID, VOID, {0: $serializer_getInstance_196});
initMetadataForCompanion(Companion_238);
protoOf($serializer_198).z1b = typeParametersSerializers;
initMetadataForObject($serializer_198, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TurnStageScope, 'TurnStageScope', VOID, VOID, [GameScope], VOID, VOID, {0: $serializer_getInstance_197});
initMetadataForCompanion(Companion_239, VOID, [SerializerFactory]);
initMetadataForClass(EndOfGameException, 'EndOfGameException');
initMetadataForCompanion(Companion_240);
protoOf($serializer_199).z1b = typeParametersSerializers;
initMetadataForObject($serializer_199, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameSetupState, 'GameSetupState', GameSetupState, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_198});
initMetadataForInterface(GameState, 'GameState');
initMetadataForCompanion(Companion_241);
protoOf($serializer_200).z1b = typeParametersSerializers;
initMetadataForObject($serializer_200, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DestroyRecord, 'DestroyRecord', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_199});
initMetadataForCompanion(Companion_242);
protoOf($serializer_201).z1b = typeParametersSerializers;
initMetadataForObject($serializer_201, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GameStateImpl).h47 = get_gameMap;
initMetadataForClass(GameStateImpl, 'GameStateImpl', VOID, VOID, [GameState], VOID, VOID, {0: $serializer_getInstance_200});
initMetadataForCompanion(Companion_243);
protoOf($serializer_202).z1b = typeParametersSerializers;
initMetadataForObject($serializer_202, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameStateCheckCode, 'GameStateCheckCode', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_201});
initMetadataForCompanion(Companion_244);
protoOf($serializer_203).z1b = typeParametersSerializers;
initMetadataForObject($serializer_203, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DraftState, 'DraftState', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_202});
initMetadataForCompanion(Companion_245);
protoOf($serializer_204).z1b = typeParametersSerializers;
initMetadataForObject($serializer_204, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HunterItems, 'HunterItems', HunterItems, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_203});
initMetadataForCompanion(Companion_246);
protoOf($serializer_205).z1b = typeParametersSerializers;
initMetadataForObject($serializer_205, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastlyTalents, 'BeastlyTalents', BeastlyTalents, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_204});
initMetadataForCompanion(Companion_247);
protoOf($serializer_206).z1b = typeParametersSerializers;
initMetadataForObject($serializer_206, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AshRuins, 'AshRuins', AshRuins, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_205});
initMetadataForCompanion(Companion_248);
protoOf($serializer_207).z1b = typeParametersSerializers;
initMetadataForObject($serializer_207, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(KnownInfo, 'KnownInfo', KnownInfo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_206});
initMetadataForClass(ArsenalType, 'ArsenalType');
initMetadataForClass(DestroyReason, 'DestroyReason');
initMetadataForCompanion(Companion_249, VOID, [SerializerFactory]);
initMetadataForClass(TwoPlayerDraftStage, 'TwoPlayerDraftStage', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_250});
initMetadataForCompanion(Companion_250, VOID, [SerializerFactory]);
initMetadataForInterface(CardsPlace, 'CardsPlace', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_251});
initMetadataForObject(ComingArsenalPlace, 'ComingArsenalPlace', VOID, VOID, [CardsPlace, SerializerFactory], VOID, VOID, {0: ComingArsenalPlace_getInstance});
initMetadataForObject(DiscardPlace, 'DiscardPlace', VOID, VOID, [CardsPlace, SerializerFactory], VOID, VOID, {0: DiscardPlace_getInstance});
initMetadataForCompanion(Companion_251);
protoOf($serializer_208).z1b = typeParametersSerializers;
initMetadataForObject($serializer_208, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DraftOfferPlace, 'DraftOfferPlace', VOID, VOID, [CardsPlace], VOID, VOID, {0: $serializer_getInstance_207});
initMetadataForCompanion(Companion_252);
protoOf($serializer_209).z1b = typeParametersSerializers;
initMetadataForObject($serializer_209, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DraftPickedPlace, 'DraftPickedPlace', VOID, VOID, [CardsPlace], VOID, VOID, {0: $serializer_getInstance_208});
initMetadataForCompanion(Companion_253);
protoOf($serializer_210).z1b = typeParametersSerializers;
initMetadataForObject($serializer_210, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DraftRemovedPlace, 'DraftRemovedPlace', VOID, VOID, [CardsPlace], VOID, VOID, {0: $serializer_getInstance_209});
initMetadataForCompanion(Companion_254);
protoOf($serializer_211).z1b = typeParametersSerializers;
initMetadataForObject($serializer_211, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HandPlace, 'HandPlace', VOID, VOID, [CardsPlace], VOID, VOID, {0: $serializer_getInstance_210});
initMetadataForObject(InPlayPlace, 'InPlayPlace', VOID, VOID, [CardsPlace, SerializerFactory], VOID, VOID, {0: InPlayPlace_getInstance});
initMetadataForObject(PendingTriggerPlace, 'PendingTriggerPlace', VOID, VOID, [CardsPlace, SerializerFactory], VOID, VOID, {0: PendingTriggerPlace_getInstance});
initMetadataForObject(RevealedArsenalPlace, 'RevealedArsenalPlace', VOID, VOID, [CardsPlace, SerializerFactory], VOID, VOID, {0: RevealedArsenalPlace_getInstance});
initMetadataForCompanion(Companion_255);
protoOf($serializer_212).z1b = typeParametersSerializers;
initMetadataForObject($serializer_212, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TrapZonePlace, 'TrapZonePlace', VOID, VOID, [CardsPlace], VOID, VOID, {0: $serializer_getInstance_211});
initMetadataForObject(UnusedDraftActionCardPlace, 'UnusedDraftActionCardPlace', VOID, VOID, [CardsPlace, SerializerFactory], VOID, VOID, {0: UnusedDraftActionCardPlace_getInstance});
initMetadataForCompanion(Companion_256, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_257);
protoOf($serializer_213).z1b = typeParametersSerializers;
initMetadataForObject($serializer_213, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AddTrapInfoChange).o37 = stateChanges_0;
initMetadataForClass(AddTrapInfoChange, 'AddTrapInfoChange', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_212});
initMetadataForCompanion(Companion_258);
protoOf($serializer_214).z1b = typeParametersSerializers;
initMetadataForObject($serializer_214, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AncientPowersChangeEvent).o37 = stateChanges_0;
initMetadataForClass(AncientPowersChangeEvent, 'AncientPowersChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_213});
initMetadataForCompanion(Companion_259);
protoOf($serializer_215).z1b = typeParametersSerializers;
initMetadataForObject($serializer_215, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DamageBlockChange).o37 = stateChanges_0;
initMetadataForClass(DamageBlockChange, 'DamageBlockChange', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_214});
initMetadataForCompanion(Companion_260);
protoOf($serializer_216).z1b = typeParametersSerializers;
initMetadataForObject($serializer_216, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(FirePositionsChange).o37 = stateChanges_0;
initMetadataForClass(FirePositionsChange, 'FirePositionsChange', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_215});
initMetadataForCompanion(Companion_261);
protoOf($serializer_217).z1b = typeParametersSerializers;
initMetadataForObject($serializer_217, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GameScopesChangeEvent).o37 = stateChanges_0;
initMetadataForClass(GameScopesChangeEvent, 'GameScopesChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_216});
initMetadataForCompanion(Companion_262);
protoOf($serializer_218).z1b = typeParametersSerializers;
initMetadataForObject($serializer_218, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(KnownCardsInfoChangeEvent).o37 = stateChanges_0;
initMetadataForClass(KnownCardsInfoChangeEvent, 'KnownCardsInfoChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_217});
initMetadataForCompanion(Companion_263);
protoOf($serializer_219).z1b = typeParametersSerializers;
initMetadataForObject($serializer_219, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(OpenArsenalCardsToDealChangeNumberEvent).o37 = stateChanges_0;
initMetadataForClass(OpenArsenalCardsToDealChangeNumberEvent, 'OpenArsenalCardsToDealChangeNumberEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_218});
initMetadataForCompanion(Companion_264);
protoOf($serializer_220).z1b = typeParametersSerializers;
initMetadataForObject($serializer_220, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RemoveTrapInfoChange).o37 = stateChanges_0;
initMetadataForClass(RemoveTrapInfoChange, 'RemoveTrapInfoChange', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_219});
initMetadataForCompanion(Companion_265);
protoOf($serializer_221).z1b = typeParametersSerializers;
initMetadataForObject($serializer_221, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RevertForKnownCardsInfoChangeEvent).o37 = stateChanges_0;
initMetadataForClass(RevertForKnownCardsInfoChangeEvent, 'RevertForKnownCardsInfoChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_220});
initMetadataForCompanion(Companion_266);
protoOf($serializer_222).z1b = typeParametersSerializers;
initMetadataForObject($serializer_222, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SetBeastMovementInfoAndTrailsChange).o37 = stateChanges_0;
initMetadataForClass(SetBeastMovementInfoAndTrailsChange, 'SetBeastMovementInfoAndTrailsChange', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_221});
initMetadataForCompanion(Companion_267);
protoOf($serializer_223).z1b = typeParametersSerializers;
initMetadataForObject($serializer_223, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SetDayNumberAndTurnChange).o37 = stateChanges_0;
initMetadataForClass(SetDayNumberAndTurnChange, 'SetDayNumberAndTurnChange', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_222});
initMetadataForCompanion(Companion_268);
protoOf($serializer_224).z1b = typeParametersSerializers;
initMetadataForObject($serializer_224, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SubmittedDamageChange).o37 = stateChanges_0;
initMetadataForClass(SubmittedDamageChange, 'SubmittedDamageChange', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_223});
initMetadataForCompanion(Companion_269);
protoOf($serializer_225).z1b = typeParametersSerializers;
initMetadataForObject($serializer_225, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SetCurrentPhaseEvent).o37 = stateChanges_0;
initMetadataForClass(SetCurrentPhaseEvent, 'SetCurrentPhaseEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_224});
initMetadataForCompanion(Companion_270);
protoOf($serializer_226).z1b = typeParametersSerializers;
initMetadataForObject($serializer_226, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SetPlayingCardNumberChangeEvent).o37 = stateChanges_0;
initMetadataForClass(SetPlayingCardNumberChangeEvent, 'SetPlayingCardNumberChangeEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_225});
initMetadataForCompanion(Companion_271);
protoOf($serializer_227).z1b = typeParametersSerializers;
initMetadataForObject($serializer_227, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SkipNextTurnStatusChangeEvent).o37 = stateChanges_0;
initMetadataForClass(SkipNextTurnStatusChangeEvent, 'SkipNextTurnStatusChangeEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_226});
initMetadataForCompanion(Companion_272);
protoOf($serializer_228).z1b = typeParametersSerializers;
initMetadataForObject($serializer_228, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(TrailsRevealedChange).o37 = stateChanges_0;
initMetadataForClass(TrailsRevealedChange, 'TrailsRevealedChange', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_227});
initMetadataForCompanion(Companion_273);
protoOf($serializer_229).z1b = typeParametersSerializers;
initMetadataForObject($serializer_229, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(TransformSimpleObjectChangeEvent).o37 = stateChanges_0;
initMetadataForClass(TransformSimpleObjectChangeEvent, 'TransformSimpleObjectChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_228});
initMetadataForCompanion(Companion_274);
protoOf($serializer_230).z1b = typeParametersSerializers;
initMetadataForObject($serializer_230, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ArmorChange, 'ArmorChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_229});
initMetadataForCompanion(Companion_275);
protoOf($serializer_231).z1b = typeParametersSerializers;
initMetadataForObject($serializer_231, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AddObjectChange, 'AddObjectChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_230});
initMetadataForObject(AddNewCharacterToOrderChange, 'AddNewCharacterToOrderChange', VOID, VOID, [GameStateChange, SerializerFactory], VOID, VOID, {0: AddNewCharacterToOrderChange_getInstance});
initMetadataForCompanion(Companion_276);
protoOf($serializer_232).z1b = typeParametersSerializers;
initMetadataForObject($serializer_232, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HpChange, 'HpChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_231});
initMetadataForCompanion(Companion_277);
protoOf($serializer_233).z1b = typeParametersSerializers;
initMetadataForObject($serializer_233, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DamageDealtToBeastsChange, 'DamageDealtToBeastsChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_232});
initMetadataForCompanion(Companion_278);
protoOf($serializer_234).z1b = typeParametersSerializers;
initMetadataForObject($serializer_234, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FirstPassPlayerChange, 'FirstPassPlayerChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_233});
initMetadataForCompanion(Companion_279);
protoOf($serializer_235).z1b = typeParametersSerializers;
initMetadataForObject($serializer_235, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DestroyedChange, 'DestroyedChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_234});
initMetadataForCompanion(Companion_280);
protoOf($serializer_236).z1b = typeParametersSerializers;
initMetadataForObject($serializer_236, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(CardsMoveChange, 'CardsMoveChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_235});
initMetadataForCompanion(Companion_281);
protoOf($serializer_237).z1b = typeParametersSerializers;
initMetadataForObject($serializer_237, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GrudgesChange, 'GrudgesChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_236});
initMetadataForCompanion(Companion_282);
protoOf($serializer_238).z1b = typeParametersSerializers;
initMetadataForObject($serializer_238, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MovementChange, 'MovementChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_237});
initMetadataForCompanion(Companion_283);
protoOf($serializer_239).z1b = typeParametersSerializers;
initMetadataForObject($serializer_239, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastMovementInfoChange, 'BeastMovementInfoChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_238});
initMetadataForCompanion(Companion_284);
protoOf($serializer_240).z1b = typeParametersSerializers;
initMetadataForObject($serializer_240, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RemoveUpgradeChange, 'RemoveUpgradeChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_239});
initMetadataForCompanion(Companion_285);
protoOf($serializer_241).z1b = typeParametersSerializers;
initMetadataForObject($serializer_241, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ResurrectObjectChange, 'ResurrectObjectChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_240});
initMetadataForCompanion(Companion_286);
protoOf($serializer_242).z1b = typeParametersSerializers;
initMetadataForObject($serializer_242, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ClearingAfterRevealChange, 'ClearingAfterRevealChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_241});
initMetadataForCompanion(Companion_287);
protoOf($serializer_243).z1b = typeParametersSerializers;
initMetadataForObject($serializer_243, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevealLastMovementsChange, 'RevealLastMovementsChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_242});
initMetadataForCompanion(Companion_288);
protoOf($serializer_244).z1b = typeParametersSerializers;
initMetadataForObject($serializer_244, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TransformLocationsChange, 'TransformLocationsChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_243});
initMetadataForCompanion(Companion_289);
protoOf($serializer_245).z1b = typeParametersSerializers;
initMetadataForObject($serializer_245, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UpgradeChange, 'UpgradeChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_244});
initMetadataForCompanion(Companion_290);
protoOf($serializer_246).z1b = typeParametersSerializers;
initMetadataForObject($serializer_246, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevertAfterClearingAfterRevealChange, 'RevertAfterClearingAfterRevealChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_245});
initMetadataForObject(RevertForAddNewCharacterToOrderChange, 'RevertForAddNewCharacterToOrderChange', VOID, VOID, [GameStateChange, SerializerFactory], VOID, VOID, {0: RevertForAddNewCharacterToOrderChange_getInstance});
initMetadataForObject(RevertForAddObjectChange, 'RevertForAddObjectChange', VOID, VOID, [GameStateChange, SerializerFactory], VOID, VOID, {0: RevertForAddObjectChange_getInstance});
initMetadataForCompanion(Companion_291);
protoOf($serializer_247).z1b = typeParametersSerializers;
initMetadataForObject($serializer_247, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevertForBeastMovementInfoChange, 'RevertForBeastMovementInfoChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_246});
initMetadataForObject(RevertForDestroyedChange, 'RevertForDestroyedChange', VOID, VOID, [GameStateChange, SerializerFactory], VOID, VOID, {0: RevertForDestroyedChange_getInstance});
initMetadataForCompanion(Companion_292);
protoOf($serializer_248).z1b = typeParametersSerializers;
initMetadataForObject($serializer_248, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevertForMovementChange, 'RevertForMovementChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_247});
initMetadataForCompanion(Companion_293);
protoOf($serializer_249).z1b = typeParametersSerializers;
initMetadataForObject($serializer_249, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevertForRandomArsenalCardsMoveChange, 'RevertForRandomArsenalCardsMoveChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_248});
initMetadataForCompanion(Companion_294);
protoOf($serializer_250).z1b = typeParametersSerializers;
initMetadataForObject($serializer_250, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevertForResurrectObjectChange, 'RevertForResurrectObjectChange', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_249});
initMetadataForCompanion(Companion_295, VOID, [SerializerFactory]);
initMetadataForInterface(ResolvingKind, 'ResolvingKind', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_297});
initMetadataForObject(PlayedRedCard, 'PlayedRedCard', VOID, VOID, [ResolvingKind, SerializerFactory], VOID, VOID, {0: PlayedRedCard_getInstance});
initMetadataForObject(PlayedBlueCard, 'PlayedBlueCard', VOID, VOID, [ResolvingKind, SerializerFactory], VOID, VOID, {0: PlayedBlueCard_getInstance});
initMetadataForObject(BonusCard, 'BonusCard', VOID, VOID, [ResolvingKind, SerializerFactory], VOID, VOID, {0: BonusCard_getInstance});
initMetadataForObject(Reaction, 'Reaction', VOID, VOID, [ResolvingKind, SerializerFactory], VOID, VOID, {0: Reaction_getInstance});
initMetadataForObject(Trap, 'Trap', VOID, VOID, [ResolvingKind, SerializerFactory], VOID, VOID, {0: Trap_getInstance});
initMetadataForCompanion(Companion_296, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_297);
protoOf($serializer_251).z1b = typeParametersSerializers;
initMetadataForObject($serializer_251, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AddArmorEvent, 'AddArmorEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_250});
initMetadataForCompanion(Companion_298);
protoOf($serializer_252).z1b = typeParametersSerializers;
initMetadataForObject($serializer_252, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AddCharacterInOrderEvent, 'AddCharacterInOrderEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_251});
initMetadataForCompanion(Companion_299);
protoOf($serializer_253).z1b = typeParametersSerializers;
initMetadataForObject($serializer_253, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AddFirePositionEvent, 'AddFirePositionEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_252});
initMetadataForCompanion(Companion_300);
protoOf($serializer_254).z1b = typeParametersSerializers;
initMetadataForObject($serializer_254, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApplyDamageEvent, 'ApplyDamageEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_253});
initMetadataForCompanion(Companion_301);
protoOf($serializer_255).z1b = typeParametersSerializers;
initMetadataForObject($serializer_255, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CharacterPassed, 'CharacterPassed', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_254});
initMetadataForCompanion(Companion_302);
protoOf($serializer_256).z1b = typeParametersSerializers;
initMetadataForObject($serializer_256, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CheckForDestroyEvent, 'CheckForDestroyEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_255});
initMetadataForCompanion(Companion_303);
protoOf($serializer_257).z1b = typeParametersSerializers;
initMetadataForObject($serializer_257, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DiscardAfterCharactersDeathEvent, 'DiscardAfterCharactersDeathEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_256});
initMetadataForCompanion(Companion_304);
protoOf($serializer_258).z1b = typeParametersSerializers;
initMetadataForObject($serializer_258, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DiscardTrapsEvent, 'DiscardTrapsEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_257});
initMetadataForCompanion(Companion_305);
protoOf($serializer_259).z1b = typeParametersSerializers;
initMetadataForObject($serializer_259, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DraftResultEvent, 'DraftResultEvent', DraftResultEvent, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_258});
initMetadataForCompanion(Companion_306);
protoOf($serializer_260).z1b = typeParametersSerializers;
initMetadataForObject($serializer_260, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(EndOfGameEvent).o37 = stateChanges;
initMetadataForClass(EndOfGameEvent, 'EndOfGameEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_259});
initMetadataForCompanion(Companion_307);
protoOf($serializer_261).z1b = typeParametersSerializers;
initMetadataForObject($serializer_261, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GainOpenArsenalCardEvent, 'GainOpenArsenalCardEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_260});
initMetadataForCompanion(Companion_308);
protoOf($serializer_262).z1b = typeParametersSerializers;
initMetadataForObject($serializer_262, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GainUnknownArsenalCardEvent, 'GainUnknownArsenalCardEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_261});
initMetadataForCompanion(Companion_309);
protoOf($serializer_263).z1b = typeParametersSerializers;
initMetadataForObject($serializer_263, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GainGrudgesEvent, 'GainGrudgesEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_262});
initMetadataForCompanion(Companion_310);
protoOf($serializer_264).z1b = typeParametersSerializers;
initMetadataForObject($serializer_264, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AshRuinPositionChangeEvent).o37 = stateChanges_0;
initMetadataForClass(AshRuinPositionChangeEvent, 'AshRuinPositionChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_263});
initMetadataForCompanion(Companion_311);
protoOf($serializer_265).z1b = typeParametersSerializers;
initMetadataForObject($serializer_265, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AshRuinReplacementChangeEvent).o37 = stateChanges_0;
initMetadataForClass(AshRuinReplacementChangeEvent, 'AshRuinReplacementChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_264});
initMetadataForCompanion(Companion_312);
protoOf($serializer_266).z1b = typeParametersSerializers;
initMetadataForObject($serializer_266, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChargingUpgradeChangeEvent).o37 = stateChanges_0;
initMetadataForClass(ChargingUpgradeChangeEvent, 'ChargingUpgradeChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_265});
initMetadataForCompanion(Companion_313);
protoOf($serializer_267).z1b = typeParametersSerializers;
initMetadataForObject($serializer_267, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DraftStateEvent).o37 = stateChanges_0;
initMetadataForClass(DraftStateEvent, 'DraftStateEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_266});
initMetadataForCompanion(Companion_314);
protoOf($serializer_268).z1b = typeParametersSerializers;
initMetadataForObject($serializer_268, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DuplicateCardEffectChangeEvent).o37 = stateChanges_0;
initMetadataForClass(DuplicateCardEffectChangeEvent, 'DuplicateCardEffectChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_267});
initMetadataForCompanion(Companion_315);
protoOf($serializer_269).z1b = typeParametersSerializers;
initMetadataForObject($serializer_269, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RuinClaimedChangeEvent).o37 = stateChanges_0;
initMetadataForClass(RuinClaimedChangeEvent, 'RuinClaimedChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_268});
initMetadataForCompanion(Companion_316);
protoOf($serializer_270).z1b = typeParametersSerializers;
initMetadataForObject($serializer_270, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(GameWarningEvent).o37 = stateChanges;
initMetadataForClass(GameWarningEvent, 'GameWarningEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_269});
initMetadataForCompanion(Companion_317);
protoOf($serializer_271).z1b = typeParametersSerializers;
initMetadataForObject($serializer_271, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GeneralCardMoveEvent, 'GeneralCardMoveEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_270});
initMetadataForCompanion(Companion_318);
protoOf($serializer_272).z1b = typeParametersSerializers;
initMetadataForObject($serializer_272, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HealEvent, 'HealEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_271});
initMetadataForCompanion(Companion_319);
protoOf($serializer_273).z1b = typeParametersSerializers;
initMetadataForObject($serializer_273, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(InitGameStateEvent).o37 = stateChanges;
initMetadataForClass(InitGameStateEvent, 'InitGameStateEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_272});
initMetadataForCompanion(Companion_320);
protoOf($serializer_274).z1b = typeParametersSerializers;
initMetadataForObject($serializer_274, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MarkerGameStateEvent, 'MarkerGameStateEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: Companion_getInstance_353});
initMetadataForClass(AssignDamageEvent, 'AssignDamageEvent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_273});
initMetadataForCompanion(Companion_321);
protoOf($serializer_275).z1b = typeParametersSerializers;
initMetadataForObject($serializer_275, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CardWasResolvedEvent, 'CardWasResolvedEvent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_274});
initMetadataForCompanion(Companion_322);
protoOf($serializer_276).z1b = typeParametersSerializers;
initMetadataForObject($serializer_276, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DamageResolvedEvent, 'DamageResolvedEvent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_275});
initMetadataForCompanion(Companion_323);
protoOf($serializer_277).z1b = typeParametersSerializers;
initMetadataForObject($serializer_277, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EndPhaseEvent, 'EndPhaseEvent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_276});
initMetadataForCompanion(Companion_324);
protoOf($serializer_278).z1b = typeParametersSerializers;
initMetadataForObject($serializer_278, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameQuestionIsComingEvent, 'GameQuestionIsComingEvent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_277});
initMetadataForObject(NothingEvent, 'NothingEvent', VOID, VOID, [SerializerFactory], VOID, VOID, {0: NothingEvent_getInstance});
initMetadataForCompanion(Companion_325);
protoOf($serializer_279).z1b = typeParametersSerializers;
initMetadataForObject($serializer_279, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RewardAchieved, 'RewardAchieved', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_278});
initMetadataForCompanion(Companion_326);
protoOf($serializer_280).z1b = typeParametersSerializers;
initMetadataForObject($serializer_280, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SearchForBeastEvent, 'SearchForBeastEvent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_279});
initMetadataForCompanion(Companion_327);
protoOf($serializer_281).z1b = typeParametersSerializers;
initMetadataForObject($serializer_281, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ModifySubmittedDamageEvent, 'ModifySubmittedDamageEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_280});
initMetadataForCompanion(Companion_328);
protoOf($serializer_282).z1b = typeParametersSerializers;
initMetadataForObject($serializer_282, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MoveCardToDiscardEvent, 'MoveCardToDiscardEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_281});
initMetadataForCompanion(Companion_329);
protoOf($serializer_283).z1b = typeParametersSerializers;
initMetadataForObject($serializer_283, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MovementEvent, 'MovementEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_282});
initMetadataForCompanion(Companion_330);
protoOf($serializer_284).z1b = typeParametersSerializers;
initMetadataForObject($serializer_284, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(NewSimpleObjectEvent, 'NewSimpleObjectEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_283});
initMetadataForCompanion(Companion_331);
protoOf($serializer_285).z1b = typeParametersSerializers;
initMetadataForObject($serializer_285, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ObjectRemoveForReplacingEvent, 'ObjectRemoveForReplacingEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_284});
initMetadataForCompanion(Companion_332);
protoOf($serializer_286).z1b = typeParametersSerializers;
initMetadataForObject($serializer_286, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PickCardsFromDeadCharacterEvent, 'PickCardsFromDeadCharacterEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_285});
initMetadataForCompanion(Companion_333);
protoOf($serializer_287).z1b = typeParametersSerializers;
initMetadataForObject($serializer_287, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RemoveFirePositionsEvent, 'RemoveFirePositionsEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_286});
initMetadataForCompanion(Companion_334);
protoOf($serializer_288).z1b = typeParametersSerializers;
initMetadataForObject($serializer_288, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RemoveUpgradeEvent, 'RemoveUpgradeEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_287});
protoOf(ReplayIsFinishedEvent).o37 = stateChanges;
initMetadataForObject(ReplayIsFinishedEvent, 'ReplayIsFinishedEvent', VOID, VOID, [GameStateEvent, SerializerFactory], VOID, VOID, {0: ReplayIsFinishedEvent_getInstance});
initMetadataForCompanion(Companion_335);
protoOf($serializer_289).z1b = typeParametersSerializers;
initMetadataForObject($serializer_289, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ReplayNotificationEvent).o37 = stateChanges;
initMetadataForClass(ReplayNotificationEvent, 'ReplayNotificationEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_288});
initMetadataForObject(RestoreArsenalEvent, 'RestoreArsenalEvent', VOID, VOID, [GameStateEvent, SerializerFactory], VOID, VOID, {0: RestoreArsenalEvent_getInstance});
initMetadataForObject(RestoreStuffEvent, 'RestoreStuffEvent', VOID, VOID, [GameStateEvent, SerializerFactory], VOID, VOID, {0: RestoreStuffEvent_getInstance});
initMetadataForCompanion(Companion_336);
protoOf($serializer_290).z1b = typeParametersSerializers;
initMetadataForObject($serializer_290, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RestoringHunterAfterDeathEvent, 'RestoringHunterAfterDeathEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_289});
initMetadataForCompanion(Companion_337);
protoOf($serializer_291).z1b = typeParametersSerializers;
initMetadataForObject($serializer_291, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RetrieveCardEvent, 'RetrieveCardEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_290});
initMetadataForCompanion(Companion_338);
protoOf($serializer_292).z1b = typeParametersSerializers;
initMetadataForObject($serializer_292, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevealBeastEvent, 'RevealBeastEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_291});
initMetadataForCompanion(Companion_339);
protoOf($serializer_293).z1b = typeParametersSerializers;
initMetadataForObject($serializer_293, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevealLastMovementsEvent, 'RevealLastMovementsEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_292});
initMetadataForCompanion(Companion_340);
protoOf($serializer_294).z1b = typeParametersSerializers;
initMetadataForObject($serializer_294, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevealLeadsToLocationTypeEvent, 'RevealLeadsToLocationTypeEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_293});
initMetadataForCompanion(Companion_341);
protoOf($serializer_295).z1b = typeParametersSerializers;
initMetadataForObject($serializer_295, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevealMovementCardEvent, 'RevealMovementCardEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_294});
initMetadataForCompanion(Companion_342);
protoOf($serializer_296).z1b = typeParametersSerializers;
initMetadataForObject($serializer_296, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevertLastBeastMovementEvent$stateChanges$$inlined$groupingBy$1);
initMetadataForClass(RevertLastBeastMovementEvent, 'RevertLastBeastMovementEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_295});
initMetadataForCompanion(Companion_343);
protoOf($serializer_297).z1b = typeParametersSerializers;
initMetadataForObject($serializer_297, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SetTrapEvent, 'SetTrapEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_296});
initMetadataForCompanion(Companion_344);
protoOf($serializer_298).z1b = typeParametersSerializers;
initMetadataForObject($serializer_298, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SpendGrudgesEvent, 'SpendGrudgesEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_297});
initMetadataForCompanion(Companion_345);
protoOf($serializer_299).z1b = typeParametersSerializers;
initMetadataForObject($serializer_299, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(StartPhaseEvent, 'StartPhaseEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_298});
initMetadataForCompanion(Companion_346);
protoOf($serializer_300).z1b = typeParametersSerializers;
initMetadataForObject($serializer_300, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(StartResolveCardEvent, 'StartResolveCardEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_299});
initMetadataForCompanion(Companion_347);
protoOf($serializer_301).z1b = typeParametersSerializers;
initMetadataForObject($serializer_301, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SubmitDamageBlockChangeEvent, 'SubmitDamageBlockChangeEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_300});
initMetadataForCompanion(Companion_348);
protoOf($serializer_302).z1b = typeParametersSerializers;
initMetadataForObject($serializer_302, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SubmitDamageEvent, 'SubmitDamageEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_301});
initMetadataForCompanion(Companion_349);
protoOf($serializer_303).z1b = typeParametersSerializers;
initMetadataForObject($serializer_303, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TrailsRevealedEvent, 'TrailsRevealedEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_302});
initMetadataForCompanion(Companion_350);
protoOf($serializer_304).z1b = typeParametersSerializers;
initMetadataForObject($serializer_304, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TransformLocationsEvent, 'TransformLocationsEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_303});
initMetadataForCompanion(Companion_351);
protoOf($serializer_305).z1b = typeParametersSerializers;
initMetadataForObject($serializer_305, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UpgradeEvent, 'UpgradeEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_304});
initMetadataForCompanion(Companion_352, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_353, VOID, [SerializerFactory]);
initMetadataForInterface(ObjectMovement, 'ObjectMovement', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_354});
initMetadataForCompanion(Companion_354);
protoOf($serializer_306).z1b = typeParametersSerializers;
initMetadataForObject($serializer_306, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(OpenObjectMovement, 'OpenObjectMovement', VOID, VOID, [ObjectMovement], VOID, VOID, {0: $serializer_getInstance_305});
initMetadataForCompanion(Companion_355);
protoOf($serializer_307).z1b = typeParametersSerializers;
initMetadataForObject($serializer_307, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HiddenBeastMovement, 'HiddenBeastMovement', VOID, VOID, [ObjectMovement], VOID, VOID, {0: $serializer_getInstance_306});
initMetadataForCompanion(Companion_356, VOID, [SerializerFactory]);
initMetadataForInterface(ReplayNotificationInfo, 'ReplayNotificationInfo', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_357});
initMetadataForCompanion(Companion_357);
protoOf($serializer_308).z1b = typeParametersSerializers;
initMetadataForObject($serializer_308, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ReplayNotificationPlainText, 'ReplayNotificationPlainText', VOID, VOID, [ReplayNotificationInfo], VOID, VOID, {0: $serializer_getInstance_307});
initMetadataForCompanion(Companion_358, VOID, [SerializerFactory]);
initMetadataForObject(PrintingGameRuntimeDiagnostics, 'PrintingGameRuntimeDiagnostics');
initMetadataForClass(CombinedRuntime, 'CombinedRuntime', VOID, VOID, [GameState]);
initMetadataForCompanion(Companion_359);
protoOf($serializer_309).z1b = typeParametersSerializers;
initMetadataForObject($serializer_309, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GeneralObjectImpl, 'GeneralObjectImpl', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_308});
initMetadataForCompanion(Companion_360, VOID, [SerializerFactory]);
initMetadataForClass($serializer_310, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GeneralMapKey, 'GeneralMapKey', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_361});
initMetadataForCompanion(Companion_361);
protoOf($serializer_311).z1b = typeParametersSerializers;
initMetadataForObject($serializer_311, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BoardPositionSetWrapper, 'BoardPositionSetWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_309});
initMetadataForCompanion(Companion_362);
protoOf($serializer_312).z1b = typeParametersSerializers;
initMetadataForObject($serializer_312, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BooleanWrapper, 'BooleanWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_310});
initMetadataForCompanion(Companion_363);
protoOf($serializer_313).z1b = typeParametersSerializers;
initMetadataForObject($serializer_313, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ObjectOnBoardWrapper, 'ObjectOnBoardWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_311});
initMetadataForCompanion(Companion_364, VOID, [SerializerFactory]);
initMetadataForClass($serializer_314, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GeneralMapKeyAndInit, 'GeneralMapKeyAndInit', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_365});
initMetadataForCompanion(Companion_365);
protoOf($serializer_315).z1b = typeParametersSerializers;
initMetadataForObject($serializer_315, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BoardPositionWrapper, 'BoardPositionWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_312});
initMetadataForCompanion(Companion_366);
protoOf($serializer_316).z1b = typeParametersSerializers;
initMetadataForObject($serializer_316, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastPathStepListWrapper, 'BeastPathStepListWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_313});
initMetadataForCompanion(Companion_367);
protoOf($serializer_317).z1b = typeParametersSerializers;
initMetadataForObject($serializer_317, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MovementAndStateListWrapper, 'MovementAndStateListWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_314});
initMetadataForCompanion(Companion_368);
protoOf($serializer_318).z1b = typeParametersSerializers;
initMetadataForObject($serializer_318, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BoardPositionToIntMapWrapper, 'BoardPositionToIntMapWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_315});
initMetadataForCompanion(Companion_369, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_370);
protoOf($serializer_319).z1b = typeParametersSerializers;
initMetadataForObject($serializer_319, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IntWrapper, 'IntWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_316});
initMetadataForCompanion(Companion_371);
protoOf($serializer_320).z1b = typeParametersSerializers;
initMetadataForObject($serializer_320, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlayableCardSetWrapper, 'PlayableCardSetWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_317});
initMetadataForCompanion(Companion_372);
protoOf($serializer_321).z1b = typeParametersSerializers;
initMetadataForObject($serializer_321, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlayableCardToIntMapWrapper, 'PlayableCardToIntMapWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_318});
initMetadataForCompanion(Companion_373);
protoOf($serializer_322).z1b = typeParametersSerializers;
initMetadataForObject($serializer_322, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlayableCardToLocationTypeMapWrapper, 'PlayableCardToLocationTypeMapWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_319});
initMetadataForCompanion(Companion_374);
protoOf($serializer_323).z1b = typeParametersSerializers;
initMetadataForObject($serializer_323, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SnareTypeWrapper, 'SnareTypeWrapper', VOID, VOID, [GeneralObjectProperty], VOID, VOID, {0: $serializer_getInstance_320});
initMetadataForCompanion(Companion_375);
protoOf($serializer_324).z1b = typeParametersSerializers;
initMetadataForObject($serializer_324, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GreatCleansingContract, 'GreatCleansingContract', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_321});
initMetadataForObject(GreatCleansingInitialPhase, 'GreatCleansingInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: GreatCleansingInitialPhase_getInstance});
protoOf(Grimgeir).i3e = get_hunterCompanionType;
protoOf(Grimgeir).w36 = modificationNumber;
protoOf(Grimgeir).v36 = getInitList_0;
protoOf(Grimgeir).r36 = get_preferredLocation_1;
initMetadataForObject(Grimgeir, 'Grimgeir', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Grimgeir_getInstance});
protoOf(WatchtowerPassageUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(WatchtowerPassageUpgrade, 'WatchtowerPassageUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: WatchtowerPassageUpgrade_getInstance});
protoOf(RefugeUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(RefugeUpgrade, 'RefugeUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: RefugeUpgrade_getInstance});
protoOf(TownswatchUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(TownswatchUpgrade, 'TownswatchUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: TownswatchUpgrade_getInstance});
protoOf(DefenderUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DefenderUpgrade, 'DefenderUpgrade', VOID, VOID, [ChargingUpgrade, SerializerFactory], VOID, VOID, {0: DefenderUpgrade_getInstance});
initMetadataForCompanion(Companion_376);
protoOf($serializer_325).z1b = typeParametersSerializers;
initMetadataForObject($serializer_325, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DefenderWithChoiceAction).n2o = canBeApplied;
protoOf(DefenderWithChoiceAction).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(DefenderWithChoiceAction, 'DefenderWithChoiceAction', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_322});
initMetadataForCompanion(Companion_377);
protoOf($serializer_326).z1b = typeParametersSerializers;
initMetadataForObject($serializer_326, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RelocationToWatchtowerStatement).n2o = canBeApplied;
protoOf(RelocationToWatchtowerStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RelocationToWatchtowerStatement, 'RelocationToWatchtowerStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_323});
protoOf(CleaverCard).u37 = get_number;
initMetadataForObject(CleaverCard, 'CleaverCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: CleaverCard_getInstance});
protoOf(Helga).i3e = get_hunterCompanionType;
protoOf(Helga).w36 = modificationNumber;
protoOf(Helga).v36 = getInitList_0;
protoOf(Helga).r36 = get_preferredLocation_1;
initMetadataForObject(Helga, 'Helga', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Helga_getInstance});
protoOf(TormentingVisionsUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(TormentingVisionsUpgrade, 'TormentingVisionsUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: TormentingVisionsUpgrade_getInstance});
protoOf(SoothsayerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SoothsayerUpgrade, 'SoothsayerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SoothsayerUpgrade_getInstance});
protoOf(ClairvoyantUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ClairvoyantUpgrade, 'ClairvoyantUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ClairvoyantUpgrade_getInstance});
protoOf(AncientBondUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AncientBondUpgrade, 'AncientBondUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AncientBondUpgrade_getInstance});
protoOf(SeerCard).u37 = get_number;
initMetadataForObject(SeerCard, 'SeerCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SeerCard_getInstance});
protoOf(RampageousUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(RampageousUpgrade, 'RampageousUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: RampageousUpgrade_getInstance});
protoOf(InfernalTusksUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(InfernalTusksUpgrade, 'InfernalTusksUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: InfernalTusksUpgrade_getInstance});
protoOf(HordesMarchUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(HordesMarchUpgrade, 'HordesMarchUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: HordesMarchUpgrade_getInstance});
protoOf(WildOdeUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(WildOdeUpgrade, 'WildOdeUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: WildOdeUpgrade_getInstance});
protoOf(ChiefsCommandUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ChiefsCommandUpgrade, 'ChiefsCommandUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ChiefsCommandUpgrade_getInstance});
protoOf(PrimalInstinctsUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(PrimalInstinctsUpgrade, 'PrimalInstinctsUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: PrimalInstinctsUpgrade_getInstance});
protoOf(AmassUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AmassUpgrade, 'AmassUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AmassUpgrade_getInstance});
protoOf(Hogbad).t36 = get_summonTypes;
protoOf(Hogbad).q2s = get_activatableSummonsOnMap;
protoOf(Hogbad).v36 = getInitList_1;
protoOf(Hogbad).w36 = modificationNumber;
initMetadataForObject(Hogbad, 'Hogbad', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Hogbad_getInstance});
initMetadataForObject(BoarToTransformQuestionContext, 'BoarToTransformQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: BoarToTransformQuestionContext_getInstance});
initMetadataForCompanion(Companion_378);
protoOf($serializer_327).z1b = typeParametersSerializers;
initMetadataForObject($serializer_327, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AmassTransformationStatement).n2o = canBeApplied;
protoOf(AmassTransformationStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(AmassTransformationStatement, 'AmassTransformationStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_324});
protoOf(ChiefsCommandStatement).n2o = canBeApplied;
protoOf(ChiefsCommandStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(ChiefsCommandStatement, 'ChiefsCommandStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: ChiefsCommandStatement_getInstance});
protoOf(PrimalInstinctsStatement).n2o = canBeApplied;
protoOf(PrimalInstinctsStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(PrimalInstinctsStatement, 'PrimalInstinctsStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: PrimalInstinctsStatement_getInstance});
initMetadataForCompanion(Companion_379);
protoOf($serializer_328).z1b = typeParametersSerializers;
initMetadataForObject($serializer_328, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PushStatement).n2o = canBeApplied;
protoOf(PushStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PushStatement, 'PushStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_325});
protoOf(WarhogType).r36 = get_preferredLocation_0;
protoOf(WarhogType).n2z = get_maxHP;
protoOf(WarhogType).v36 = getInitList;
initMetadataForObject(WarhogType, 'WarhogType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: WarhogType_getInstance});
protoOf(RambleCard).u37 = get_number;
initMetadataForObject(RambleCard, 'RambleCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: RambleCard_getInstance});
protoOf(StampedeCard).u37 = get_number;
initMetadataForObject(StampedeCard, 'StampedeCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: StampedeCard_getInstance});
protoOf(SummonWarhogCard).u37 = get_number;
initMetadataForObject(SummonWarhogCard, 'SummonWarhogCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SummonWarhogCard_getInstance});
protoOf(TuskCard).u37 = get_number;
initMetadataForObject(TuskCard, 'TuskCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: TuskCard_getInstance});
initMetadataForCompanion(Companion_380, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_381);
protoOf($serializer_329).z1b = typeParametersSerializers;
initMetadataForObject($serializer_329, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(TrackCard).u37 = get_number;
initMetadataForClass(TrackCard, 'TrackCard', VOID, VOID, [PlayableInTurnCard, AbilityCard], VOID, VOID, {0: $serializer_getInstance_326});
initMetadataForCompanion(Companion_382);
protoOf($serializer_330).z1b = typeParametersSerializers;
initMetadataForObject($serializer_330, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(HuntCard).u37 = get_number;
initMetadataForClass(HuntCard, 'HuntCard', VOID, VOID, [PlayableInTurnCard, AbilityCard], VOID, VOID, {0: $serializer_getInstance_327});
initMetadataForCompanion(Companion_383, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_384);
protoOf($serializer_331).z1b = typeParametersSerializers;
initMetadataForObject($serializer_331, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(HunterItemCard, 'HunterItemCard', VOID, VOID, [ArsenalCard], VOID, VOID, {0: Companion_getInstance_389});
initMetadataForInterface(TrapCard, 'TrapCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard], VOID, VOID, {0: Companion_getInstance_400});
initMetadataForClass(ShriekerTrapCard, 'ShriekerTrapCard', VOID, VOID, [TrapCard, EffectSource], VOID, VOID, {0: $serializer_getInstance_328});
initMetadataForCompanion(Companion_385);
protoOf($serializer_332).z1b = typeParametersSerializers;
initMetadataForObject($serializer_332, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DreamerMaskCard, 'DreamerMaskCard', VOID, VOID, [HunterItemCard, PlayableCard], VOID, VOID, {0: $serializer_getInstance_329});
protoOf(EsmeriasStrandCard).u37 = get_number;
initMetadataForObject(EsmeriasStrandCard, 'EsmeriasStrandCard', VOID, VOID, [HunterItemCard, PlayableCard, SerializerFactory], VOID, VOID, {0: EsmeriasStrandCard_getInstance});
initMetadataForCompanion(Companion_386);
protoOf($serializer_333).z1b = typeParametersSerializers;
initMetadataForObject($serializer_333, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FlareCard, 'FlareCard', VOID, VOID, [HunterItemCard, PlayableCard], VOID, VOID, {0: $serializer_getInstance_330});
initMetadataForCompanion(Companion_387);
protoOf($serializer_334).z1b = typeParametersSerializers;
initMetadataForObject($serializer_334, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SmokeBombCard, 'SmokeBombCard', VOID, VOID, [HunterItemCard, PlayableCard], VOID, VOID, {0: $serializer_getInstance_331});
initMetadataForCompanion(Companion_388, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_389);
protoOf($serializer_335).z1b = typeParametersSerializers;
initMetadataForObject($serializer_335, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HexingTrapCard, 'HexingTrapCard', VOID, VOID, [TrapCard], VOID, VOID, {0: $serializer_getInstance_332});
initMetadataForCompanion(Companion_390);
protoOf($serializer_336).z1b = typeParametersSerializers;
initMetadataForObject($serializer_336, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FireTrapCard, 'FireTrapCard', VOID, VOID, [TrapCard], VOID, VOID, {0: $serializer_getInstance_333});
initMetadataForCompanion(Companion_391);
protoOf($serializer_337).z1b = typeParametersSerializers;
initMetadataForObject($serializer_337, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(OutpostCard, 'OutpostCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard], VOID, VOID, {0: $serializer_getInstance_334});
initMetadataForCompanion(Companion_392);
protoOf($serializer_338).z1b = typeParametersSerializers;
initMetadataForObject($serializer_338, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(WolfsbaneCard, 'WolfsbaneCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard], VOID, VOID, {0: $serializer_getInstance_335});
initMetadataForCompanion(Companion_393);
protoOf($serializer_339).z1b = typeParametersSerializers;
initMetadataForObject($serializer_339, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HuntersRestCard, 'HuntersRestCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard], VOID, VOID, {0: $serializer_getInstance_336});
initMetadataForCompanion(Companion_394);
protoOf($serializer_340).z1b = typeParametersSerializers;
initMetadataForObject($serializer_340, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HuntersBellCard, 'HuntersBellCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard], VOID, VOID, {0: $serializer_getInstance_337});
initMetadataForCompanion(Companion_395);
protoOf($serializer_341).z1b = typeParametersSerializers;
initMetadataForObject($serializer_341, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(HuntersPassageCard, 'HuntersPassageCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard], VOID, VOID, {0: $serializer_getInstance_338});
protoOf(GrapeshotCard).u37 = get_number;
initMetadataForObject(GrapeshotCard, 'GrapeshotCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard, SerializerFactory], VOID, VOID, {0: GrapeshotCard_getInstance});
protoOf(AurorasPassage).u37 = get_number;
initMetadataForObject(AurorasPassage, 'AurorasPassage', VOID, VOID, [PlayableInTurnCard, HunterItemCard, SerializerFactory], VOID, VOID, {0: AurorasPassage_getInstance});
protoOf(BladeOfValhCard).u37 = get_number;
initMetadataForObject(BladeOfValhCard, 'BladeOfValhCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard, SerializerFactory], VOID, VOID, {0: BladeOfValhCard_getInstance});
initMetadataForCompanion(Companion_396);
protoOf($serializer_342).z1b = typeParametersSerializers;
initMetadataForObject($serializer_342, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ExpeditionMapCard, 'ExpeditionMapCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard], VOID, VOID, {0: $serializer_getInstance_339});
initMetadataForCompanion(Companion_397);
protoOf($serializer_343).z1b = typeParametersSerializers;
initMetadataForObject($serializer_343, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RitualTrapCard, 'RitualTrapCard', VOID, VOID, [TrapCard], VOID, VOID, {0: $serializer_getInstance_340});
initMetadataForCompanion(Companion_398);
protoOf($serializer_344).z1b = typeParametersSerializers;
initMetadataForObject($serializer_344, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SacredRichesCard, 'SacredRichesCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard], VOID, VOID, {0: $serializer_getInstance_341});
protoOf(BansheesLureCard).u37 = get_number;
initMetadataForObject(BansheesLureCard, 'BansheesLureCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard, SerializerFactory], VOID, VOID, {0: BansheesLureCard_getInstance});
protoOf(ChainGrapnelCard).u37 = get_number;
initMetadataForObject(ChainGrapnelCard, 'ChainGrapnelCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard, SerializerFactory], VOID, VOID, {0: ChainGrapnelCard_getInstance});
protoOf(SpyglassCard).u37 = get_number;
initMetadataForObject(SpyglassCard, 'SpyglassCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard, SerializerFactory], VOID, VOID, {0: SpyglassCard_getInstance});
protoOf(WarhogsTuskCard).u37 = get_number;
initMetadataForObject(WarhogsTuskCard, 'WarhogsTuskCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard, SerializerFactory], VOID, VOID, {0: WarhogsTuskCard_getInstance});
initMetadataForCompanion(Companion_399, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_400);
protoOf($serializer_345).z1b = typeParametersSerializers;
initMetadataForObject($serializer_345, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlacedTrap, 'PlacedTrap', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_342});
initMetadataForCompanion(Companion_401);
protoOf($serializer_346).z1b = typeParametersSerializers;
initMetadataForObject($serializer_346, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UnknownHunterItemCard, 'UnknownHunterItemCard', VOID, VOID, [HunterItemCard, UnknownCard], VOID, VOID, {0: $serializer_getInstance_343});
protoOf(Iona).i3e = get_hunterCompanionType;
protoOf(Iona).w36 = modificationNumber;
protoOf(Iona).v36 = getInitList_0;
protoOf(Iona).r36 = get_preferredLocation_1;
initMetadataForObject(Iona, 'Iona', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Iona_getInstance});
protoOf(JointEffortUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(JointEffortUpgrade, 'JointEffortUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: JointEffortUpgrade_getInstance});
protoOf(BallistaUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BallistaUpgrade, 'BallistaUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BallistaUpgrade_getInstance});
protoOf(CrepuscularUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(CrepuscularUpgrade, 'CrepuscularUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: CrepuscularUpgrade_getInstance});
protoOf(AncientCallingUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AncientCallingUpgrade, 'AncientCallingUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AncientCallingUpgrade_getInstance});
protoOf(SilverArrowCard).u37 = get_number;
initMetadataForObject(SilverArrowCard, 'SilverArrowCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SilverArrowCard_getInstance});
initMetadataForObject(NearSummonsAndBeastAttackModifier, 'NearSummonsAndBeastAttackModifier', VOID, VOID, [AttackModifier, SerializerFactory], VOID, VOID, {0: NearSummonsAndBeastAttackModifier_getInstance});
protoOf(Krim).i3e = get_hunterCompanionType;
protoOf(Krim).w36 = modificationNumber;
protoOf(Krim).v36 = getInitList_0;
protoOf(Krim).r36 = get_preferredLocation_1;
initMetadataForObject(Krim, 'Krim', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Krim_getInstance});
protoOf(ScavengerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ScavengerUpgrade, 'ScavengerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ScavengerUpgrade_getInstance});
protoOf(TrapLauncherUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(TrapLauncherUpgrade, 'TrapLauncherUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: TrapLauncherUpgrade_getInstance});
protoOf(PortableWorkshopUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(PortableWorkshopUpgrade, 'PortableWorkshopUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: PortableWorkshopUpgrade_getInstance});
protoOf(ResourcefulnessUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ResourcefulnessUpgrade, 'ResourcefulnessUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ResourcefulnessUpgrade_getInstance});
initMetadataForObject(TrapToPlayForTrapmasterQuestionContext, 'TrapToPlayForTrapmasterQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: TrapToPlayForTrapmasterQuestionContext_getInstance});
protoOf(ResourcefulnessUpgradeStatement).n2o = canBeApplied;
protoOf(ResourcefulnessUpgradeStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(ResourcefulnessUpgradeStatement, 'ResourcefulnessUpgradeStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: ResourcefulnessUpgradeStatement_getInstance});
initMetadataForCompanion(Companion_402);
protoOf($serializer_347).z1b = typeParametersSerializers;
initMetadataForObject($serializer_347, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(TrapmasterStatement).n2o = canBeApplied;
protoOf(TrapmasterStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(TrapmasterStatement, 'TrapmasterStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_344});
protoOf(TrapmasterCard).u37 = get_number;
initMetadataForObject(TrapmasterCard, 'TrapmasterCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: TrapmasterCard_getInstance});
initMetadataForObject(LowerShatteredSettlements, 'LowerShatteredSettlements');
initMetadataForObject(LowerShatteredRuins, 'LowerShatteredRuins');
protoOf(BeyondTheVeilUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BeyondTheVeilUpgrade, 'BeyondTheVeilUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BeyondTheVeilUpgrade_getInstance});
protoOf(AbundanceUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AbundanceUpgrade, 'AbundanceUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AbundanceUpgrade_getInstance});
protoOf(ReuniteUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ReuniteUpgrade, 'ReuniteUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ReuniteUpgrade_getInstance});
protoOf(DoomCallUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DoomCallUpgrade, 'DoomCallUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DoomCallUpgrade_getInstance});
initMetadataForObject(FleshboundUpgrade, 'FleshboundUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: FleshboundUpgrade_getInstance});
initMetadataForObject(SpiritboundUpgrade, 'SpiritboundUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SpiritboundUpgrade_getInstance});
protoOf(Lydan).t36 = get_summonTypes;
protoOf(Lydan).q2s = get_activatableSummonsOnMap;
protoOf(Lydan).w36 = modificationNumber;
initMetadataForObject(Lydan, 'Lydan', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Lydan_getInstance});
initMetadataForObject(YeltrDeathDamageSource, 'YeltrDeathDamageSource', VOID, VOID, [DamageSource, SerializerFactory], VOID, VOID, {0: YeltrDeathDamageSource_getInstance});
initMetadataForObject(YeltrReapDamageSource, 'YeltrReapDamageSource', VOID, VOID, [DamageSource, SerializerFactory], VOID, VOID, {0: YeltrReapDamageSource_getInstance});
initMetadataForObject(LydanInitialHarvestEffectSource, 'LydanInitialHarvestEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: LydanInitialHarvestEffectSource_getInstance});
initMetadataForCompanion(Companion_403);
protoOf($serializer_348).z1b = typeParametersSerializers;
initMetadataForObject($serializer_348, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SpendLydanHarvestQuestion).s3o = get_variants;
protoOf(SpendLydanHarvestQuestion).t3o = get_questionContext;
initMetadataForClass(SpendLydanHarvestQuestion, 'SpendLydanHarvestQuestion', VOID, VOID, [BooleanGameQuestion], VOID, VOID, {0: $serializer_getInstance_345});
initMetadataForCompanion(Companion_404);
protoOf($serializer_349).z1b = typeParametersSerializers;
initMetadataForObject($serializer_349, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BeyondTheVeilPreventYeltrDamageStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BeyondTheVeilPreventYeltrDamageStatement, 'BeyondTheVeilPreventYeltrDamageStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_346});
initMetadataForCompanion(Companion_405);
protoOf($serializer_350).z1b = typeParametersSerializers;
initMetadataForObject($serializer_350, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BoltAndRecallStatement).n2o = canBeApplied;
protoOf(BoltAndRecallStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BoltAndRecallStatement, 'BoltAndRecallStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_347});
initMetadataForCompanion(Companion_406);
protoOf($serializer_351).z1b = typeParametersSerializers;
initMetadataForObject($serializer_351, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ReapStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ReapStatement, 'ReapStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_348});
initMetadataForCompanion(Companion_407);
protoOf($serializer_352).z1b = typeParametersSerializers;
initMetadataForObject($serializer_352, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SoulReapStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SoulReapStatement, 'SoulReapStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_349});
initMetadataForCompanion(Companion_408);
protoOf($serializer_353).z1b = typeParametersSerializers;
initMetadataForObject($serializer_353, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SummonYeltrStatement).n2o = canBeApplied;
protoOf(SummonYeltrStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SummonYeltrStatement, 'SummonYeltrStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_350});
initMetadataForCompanion(Companion_409);
protoOf($serializer_354).z1b = typeParametersSerializers;
initMetadataForObject($serializer_354, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ToothAndSeverStatement).n2o = canBeApplied;
protoOf(ToothAndSeverStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ToothAndSeverStatement, 'ToothAndSeverStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_351});
initMetadataForCompanion(Companion_410);
protoOf($serializer_355).z1b = typeParametersSerializers;
initMetadataForObject($serializer_355, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GainLydanHarvestEvent, 'GainLydanHarvestEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_352});
initMetadataForCompanion(Companion_411);
protoOf($serializer_356).z1b = typeParametersSerializers;
initMetadataForObject($serializer_356, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(LydanHarvestChangeEvent).o37 = stateChanges_0;
initMetadataForClass(LydanHarvestChangeEvent, 'LydanHarvestChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_353});
protoOf(YeltrType).r36 = get_preferredLocation_0;
protoOf(YeltrType).v36 = getInitList;
initMetadataForObject(YeltrType, 'YeltrType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: YeltrType_getInstance});
initMetadataForInterface(LydanCard, 'LydanCard', VOID, VOID, [PlayableInTurnCard, AbilityCard]);
protoOf(BoltAndRecallCard).t37 = get_character;
protoOf(BoltAndRecallCard).u37 = get_number;
initMetadataForObject(BoltAndRecallCard, 'BoltAndRecallCard', VOID, VOID, [LydanCard, SerializerFactory], VOID, VOID, {0: BoltAndRecallCard_getInstance});
protoOf(SoulReapCard).t37 = get_character;
protoOf(SoulReapCard).u37 = get_number;
initMetadataForObject(SoulReapCard, 'SoulReapCard', VOID, VOID, [LydanCard, SerializerFactory], VOID, VOID, {0: SoulReapCard_getInstance});
protoOf(SummonYeltrCard).t37 = get_character;
protoOf(SummonYeltrCard).u37 = get_number;
initMetadataForObject(SummonYeltrCard, 'SummonYeltrCard', VOID, VOID, [LydanCard, SerializerFactory], VOID, VOID, {0: SummonYeltrCard_getInstance});
protoOf(ToothAndSeverCard).t37 = get_character;
protoOf(ToothAndSeverCard).u37 = get_number;
initMetadataForObject(ToothAndSeverCard, 'ToothAndSeverCard', VOID, VOID, [LydanCard, SerializerFactory], VOID, VOID, {0: ToothAndSeverCard_getInstance});
protoOf(DeathsLamentUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DeathsLamentUpgrade, 'DeathsLamentUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DeathsLamentUpgrade_getInstance});
protoOf(SoulHarvestUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SoulHarvestUpgrade, 'SoulHarvestUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SoulHarvestUpgrade_getInstance});
protoOf(PandemoniumUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(PandemoniumUpgrade, 'PandemoniumUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: PandemoniumUpgrade_getInstance});
protoOf(SongOfTemptationUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SongOfTemptationUpgrade, 'SongOfTemptationUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SongOfTemptationUpgrade_getInstance});
protoOf(VanishUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(VanishUpgrade, 'VanishUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: VanishUpgrade_getInstance});
protoOf(VoidPresenceUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(VoidPresenceUpgrade, 'VoidPresenceUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: VoidPresenceUpgrade_getInstance});
protoOf(FearTheNightUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(FearTheNightUpgrade, 'FearTheNightUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: FearTheNightUpgrade_getInstance});
protoOf(Mara).t36 = get_summonTypes;
protoOf(Mara).u36 = get_summonLimit;
protoOf(Mara).q2s = get_activatableSummonsOnMap;
protoOf(Mara).v36 = getInitList_1;
protoOf(Mara).w36 = modificationNumber;
initMetadataForObject(Mara, 'Mara', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Mara_getInstance});
protoOf(FeedCard).u37 = get_number;
initMetadataForObject(FeedCard, 'FeedCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, EffectSource, SerializerFactory], VOID, VOID, {0: FeedCard_getInstance});
initMetadataForCompanion(Companion_412);
protoOf($serializer_357).z1b = typeParametersSerializers;
initMetadataForObject($serializer_357, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RelocateToBansheeAndRevealStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RelocateToBansheeAndRevealStatement, 'RelocateToBansheeAndRevealStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_354});
initMetadataForCompanion(Companion_413);
protoOf($serializer_358).z1b = typeParametersSerializers;
initMetadataForObject($serializer_358, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(VanishStatement).n2o = canBeApplied;
protoOf(VanishStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(VanishStatement, 'VanishStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_355});
protoOf(BansheeType).r36 = get_preferredLocation_0;
protoOf(BansheeType).n2z = get_maxHP;
protoOf(BansheeType).v36 = getInitList;
initMetadataForObject(BansheeType, 'BansheeType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: BansheeType_getInstance});
protoOf(FlickerCard).u37 = get_number;
initMetadataForObject(FlickerCard, 'FlickerCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: FlickerCard_getInstance});
protoOf(ObscureTalentCard).u37 = get_number;
initMetadataForObject(ObscureTalentCard, 'ObscureTalentCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: ObscureTalentCard_getInstance});
protoOf(ShadowStepCard).u37 = get_number;
initMetadataForObject(ShadowStepCard, 'ShadowStepCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: ShadowStepCard_getInstance});
protoOf(Nora).i3e = get_hunterCompanionType;
protoOf(Nora).w36 = modificationNumber;
protoOf(Nora).v36 = getInitList_0;
protoOf(Nora).r36 = get_preferredLocation_1;
initMetadataForObject(Nora, 'Nora', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Nora_getInstance});
protoOf(AwarenessUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AwarenessUpgrade, 'AwarenessUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AwarenessUpgrade_getInstance});
protoOf(RevengeOfTheSheepUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(RevengeOfTheSheepUpgrade, 'RevengeOfTheSheepUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: RevengeOfTheSheepUpgrade_getInstance});
protoOf(WildbondUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(WildbondUpgrade, 'WildbondUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: WildbondUpgrade_getInstance});
protoOf(BeastTongueUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BeastTongueUpgrade, 'BeastTongueUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BeastTongueUpgrade_getInstance});
initMetadataForObject(AnimalToSearchWithQuestionContext, 'AnimalToSearchWithQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: AnimalToSearchWithQuestionContext_getInstance});
initMetadataForObject(SheepForMoveAndAttackQuestionContext, 'SheepForMoveAndAttackQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SheepForMoveAndAttackQuestionContext_getInstance});
initMetadataForCompanion(Companion_414);
protoOf($serializer_359).z1b = typeParametersSerializers;
initMetadataForObject($serializer_359, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AttackBySheepStatement).n2o = canBeApplied;
protoOf(AttackBySheepStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(AttackBySheepStatement, 'AttackBySheepStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_356});
initMetadataForCompanion(Companion_415);
protoOf($serializer_360).z1b = typeParametersSerializers;
initMetadataForObject($serializer_360, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(HerdStatement).n2o = canBeApplied;
protoOf(HerdStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(HerdStatement, 'HerdStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_357});
initMetadataForCompanion(Companion_416);
protoOf($serializer_361).z1b = typeParametersSerializers;
initMetadataForObject($serializer_361, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(MountStatement).n2o = canBeApplied;
protoOf(MountStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(MountStatement, 'MountStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_358});
initMetadataForCompanion(Companion_417);
protoOf($serializer_362).z1b = typeParametersSerializers;
initMetadataForObject($serializer_362, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(MoveWithAnimalStatement).n2o = canBeApplied;
protoOf(MoveWithAnimalStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(MoveWithAnimalStatement, 'MoveWithAnimalStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_359});
initMetadataForCompanion(Companion_418);
protoOf($serializer_363).z1b = typeParametersSerializers;
initMetadataForObject($serializer_363, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RevengeOfTheSheepStatement).n2o = canBeApplied;
protoOf(RevengeOfTheSheepStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RevengeOfTheSheepStatement, 'RevengeOfTheSheepStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_360});
protoOf(HerdCard).u37 = get_number;
initMetadataForObject(HerdCard, 'HerdCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: HerdCard_getInstance});
protoOf(MountCard).u37 = get_number;
initMetadataForObject(MountCard, 'MountCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: MountCard_getInstance});
initMetadataForObject(NorthernNamedSettlements, 'NorthernNamedSettlements');
initMetadataForCompanion(Companion_419, VOID, [SerializerFactory]);
initMetadataForClass($serializer_364, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ObjectOnBoard, 'ObjectOnBoard', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_420});
initMetadataForCompanion(Companion_420, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_421, VOID, [SerializerFactory]);
initMetadataForInterface(AnimalType, 'AnimalType', VOID, VOID, [SimpleObjectType], VOID, VOID, {0: Companion_getInstance_426});
protoOf(SheepType).r36 = get_preferredLocation;
protoOf(SheepType).v36 = getInitList;
initMetadataForObject(SheepType, 'SheepType', VOID, VOID, [AnimalType, SerializerFactory], VOID, VOID, {0: SheepType_getInstance});
initMetadataForCompanion(Companion_422, VOID, [SerializerFactory]);
initMetadataForInterface(SettlerType, 'SettlerType', VOID, VOID, [SimpleObjectType, HumanKindType], VOID, VOID, {0: Companion_getInstance_423});
initMetadataForCompanion(Companion_423, VOID, [SerializerFactory]);
protoOf(NobleType).r36 = get_preferredLocation_1;
protoOf(NobleType).v36 = getInitList;
initMetadataForObject(NobleType, 'NobleType', VOID, VOID, [SettlerType, SerializerFactory], VOID, VOID, {0: NobleType_getInstance});
protoOf(FarmerType).r36 = get_preferredLocation_1;
protoOf(FarmerType).v36 = getInitList;
initMetadataForObject(FarmerType, 'FarmerType', VOID, VOID, [SettlerType, SerializerFactory], VOID, VOID, {0: FarmerType_getInstance});
protoOf(BoatType).r36 = get_preferredLocation;
protoOf(BoatType).v36 = getInitList;
initMetadataForObject(BoatType, 'BoatType', VOID, VOID, [SimpleObjectType, SerializerFactory], VOID, VOID, {0: BoatType_getInstance});
protoOf(BoarType).r36 = get_preferredLocation;
protoOf(BoarType).v36 = getInitList;
initMetadataForObject(BoarType, 'BoarType', VOID, VOID, [AnimalType, SerializerFactory], VOID, VOID, {0: BoarType_getInstance});
protoOf(TigerType).r36 = get_preferredLocation;
protoOf(TigerType).v36 = getInitList;
initMetadataForObject(TigerType, 'TigerType', VOID, VOID, [AnimalType, SerializerFactory], VOID, VOID, {0: TigerType_getInstance});
initMetadataForCompanion(Companion_424, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_425, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_426);
protoOf($serializer_365).z1b = typeParametersSerializers;
initMetadataForObject($serializer_365, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BarrierSideType).r36 = get_preferredLocation;
protoOf(BarrierSideType).v36 = getInitList;
initMetadataForClass(BarrierSideType, 'BarrierSideType', VOID, VOID, [SimpleObjectType], VOID, VOID, {0: $serializer_getInstance_361});
protoOf(WatchtowerType).r36 = get_preferredLocation;
protoOf(WatchtowerType).v36 = getInitList;
initMetadataForObject(WatchtowerType, 'WatchtowerType', VOID, VOID, [SimpleObjectType, SerializerFactory], VOID, VOID, {0: WatchtowerType_getInstance});
protoOf(BearType).r36 = get_preferredLocation;
protoOf(BearType).v36 = getInitList;
initMetadataForObject(BearType, 'BearType', VOID, VOID, [AnimalType, SerializerFactory], VOID, VOID, {0: BearType_getInstance});
protoOf(DistractionUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DistractionUpgrade, 'DistractionUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DistractionUpgrade_getInstance});
protoOf(DoubleUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DoubleUpgrade, 'DoubleUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DoubleUpgrade_getInstance});
protoOf(ThickMistUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ThickMistUpgrade, 'ThickMistUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ThickMistUpgrade_getInstance});
protoOf(NightbindUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(NightbindUpgrade, 'NightbindUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: NightbindUpgrade_getInstance});
protoOf(CursedLandUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(CursedLandUpgrade, 'CursedLandUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: CursedLandUpgrade_getInstance});
protoOf(Omma).t36 = get_summonTypes;
protoOf(Omma).u36 = get_summonLimit;
protoOf(Omma).q2s = get_activatableSummonsOnMap;
protoOf(Omma).w36 = modificationNumber;
initMetadataForObject(Omma, 'Omma', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Omma_getInstance});
initMetadataForObject(PossibleMistShroudEffectSource, 'PossibleMistShroudEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: PossibleMistShroudEffectSource_getInstance});
initMetadataForObject(PossibleSnareEffectSource, 'PossibleSnareEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: PossibleSnareEffectSource_getInstance});
initMetadataForCompanion(Companion_427);
protoOf($serializer_366).z1b = typeParametersSerializers;
initMetadataForObject($serializer_366, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SnareTypeQuestion).t3o = get_questionContext;
initMetadataForClass(SnareTypeQuestion, 'SnareTypeQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_362});
initMetadataForObject(HunterItemToDiscardFromArsenalQuestionContext, 'HunterItemToDiscardFromArsenalQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: HunterItemToDiscardFromArsenalQuestionContext_getInstance});
initMetadataForObject(SnareLocationQuestionContext, 'SnareLocationQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: SnareLocationQuestionContext_getInstance});
initMetadataForObject(SnareTrapLocationQuestionContext, 'SnareTrapLocationQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: SnareTrapLocationQuestionContext_getInstance});
initMetadataForObject(HunterTrappedBySnareQuestionContext, 'HunterTrappedBySnareQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HunterTrappedBySnareQuestionContext_getInstance});
initMetadataForObject(SnareToReplaceQuestionContext, 'SnareToReplaceQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SnareToReplaceQuestionContext_getInstance});
initMetadataForCompanion(Companion_428);
protoOf($serializer_367).z1b = typeParametersSerializers;
initMetadataForObject($serializer_367, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ActivateSnareStatement).n2o = canBeApplied;
protoOf(ActivateSnareStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ActivateSnareStatement, 'ActivateSnareStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_363});
initMetadataForCompanion(Companion_429);
protoOf($serializer_368).z1b = typeParametersSerializers;
initMetadataForObject($serializer_368, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(MistShroudReactionStatement).n2o = canBeApplied;
protoOf(MistShroudReactionStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(MistShroudReactionStatement, 'MistShroudReactionStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_364});
initMetadataForCompanion(Companion_430);
protoOf($serializer_369).z1b = typeParametersSerializers;
initMetadataForObject($serializer_369, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DiscardHunterItemFromArsenalStatement).n2o = canBeApplied;
initMetadataForClass(DiscardHunterItemFromArsenalStatement, 'DiscardHunterItemFromArsenalStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_365});
initMetadataForCompanion(Companion_431);
protoOf($serializer_370).z1b = typeParametersSerializers;
initMetadataForObject($serializer_370, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DismemberStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(DismemberStatement, 'DismemberStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_366});
initMetadataForCompanion(Companion_432);
protoOf($serializer_371).z1b = typeParametersSerializers;
initMetadataForObject($serializer_371, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(HazeStatement).n2o = canBeApplied;
protoOf(HazeStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(HazeStatement, 'HazeStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_367});
initMetadataForCompanion(Companion_433);
protoOf($serializer_372).z1b = typeParametersSerializers;
initMetadataForObject($serializer_372, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceSnareStatement).n2o = canBeApplied;
protoOf(PlaceSnareStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlaceSnareStatement, 'PlaceSnareStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_368});
protoOf(SnareTokenType).r36 = get_preferredLocation;
initMetadataForObject(SnareTokenType, 'SnareTokenType', VOID, VOID, [SimpleObjectType, SerializerFactory], VOID, VOID, {0: SnareTokenType_getInstance});
initMetadataForCompanion(Companion_434);
protoOf($serializer_373).z1b = typeParametersSerializers;
initMetadataForObject($serializer_373, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SetEyeHazeStatusChangeEvent).o37 = stateChanges_0;
initMetadataForClass(SetEyeHazeStatusChangeEvent, 'SetEyeHazeStatusChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_369});
initMetadataForCompanion(Companion_435);
protoOf($serializer_374).z1b = typeParametersSerializers;
initMetadataForObject($serializer_374, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SetSnareMetadataChangeEvent).o37 = stateChanges_0;
initMetadataForClass(SetSnareMetadataChangeEvent, 'SetSnareMetadataChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_370});
protoOf(EyeType).r36 = get_preferredLocation_0;
protoOf(EyeType).n2z = get_maxHP;
protoOf(EyeType).v36 = getInitList;
initMetadataForObject(EyeType, 'EyeType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: EyeType_getInstance});
protoOf(DismemberCard).u37 = get_number;
initMetadataForObject(DismemberCard, 'DismemberCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: DismemberCard_getInstance});
protoOf(SpookCard).u37 = get_number;
initMetadataForObject(SpookCard, 'SpookCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SpookCard_getInstance});
protoOf(SummonEyeCard).u37 = get_number;
initMetadataForObject(SummonEyeCard, 'SummonEyeCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SummonEyeCard_getInstance});
protoOf(MistShroudCard).u37 = get_number;
initMetadataForObject(MistShroudCard, 'MistShroudCard', VOID, VOID, [AbilityCard, PlayableCard, SerializerFactory], VOID, VOID, {0: MistShroudCard_getInstance});
initMetadataForCompanion(Companion_436, VOID, [SerializerFactory]);
initMetadataForClass(SnareType, 'SnareType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_437});
initMetadataForCompanion(Companion_437);
protoOf($serializer_375).z1b = typeParametersSerializers;
initMetadataForObject($serializer_375, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PactLongForgottenContract, 'PactLongForgottenContract', PactLongForgottenContract.l5w, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_371});
initMetadataForObject(PactLongForgottenInitialPhase, 'PactLongForgottenInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: PactLongForgottenInitialPhase_getInstance});
initMetadataForCompanion(Companion_438, VOID, [SerializerFactory]);
initMetadataForObject(Split, 'Split', VOID, VOID, [SerializerFactory], VOID, VOID, {0: Split_getInstance});
initMetadataForObject(Red, 'Red', VOID, VOID, [SerializerFactory], VOID, VOID, {0: Red_getInstance});
initMetadataForObject(Blue, 'Blue', VOID, VOID, [SerializerFactory], VOID, VOID, {0: Blue_getInstance});
initMetadataForCompanion(Companion_439, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_440, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_441, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_442, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_443, VOID, [SerializerFactory]);
protoOf(WrathOfEirtirUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(WrathOfEirtirUpgrade, 'WrathOfEirtirUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: WrathOfEirtirUpgrade_getInstance});
protoOf(LeviathanUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(LeviathanUpgrade, 'LeviathanUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: LeviathanUpgrade_getInstance});
protoOf(MendrsFuryUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(MendrsFuryUpgrade, 'MendrsFuryUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: MendrsFuryUpgrade_getInstance});
protoOf(DrownerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DrownerUpgrade, 'DrownerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DrownerUpgrade_getInstance});
protoOf(TorrentialUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(TorrentialUpgrade, 'TorrentialUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: TorrentialUpgrade_getInstance});
protoOf(DevourerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DevourerUpgrade, 'DevourerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DevourerUpgrade_getInstance});
protoOf(FatalGazeUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(FatalGazeUpgrade, 'FatalGazeUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: FatalGazeUpgrade_getInstance});
protoOf(Raaga).t36 = get_summonTypes;
protoOf(Raaga).u36 = get_summonLimit;
protoOf(Raaga).q2s = get_activatableSummonsOnMap;
protoOf(Raaga).v36 = getInitList_1;
protoOf(Raaga).w36 = modificationNumber;
initMetadataForObject(Raaga, 'Raaga', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Raaga_getInstance});
initMetadataForCompanion(Companion_444);
protoOf($serializer_376).z1b = typeParametersSerializers;
initMetadataForObject($serializer_376, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RaagaSlitherStatement, 'RaagaSlitherStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_372});
initMetadataForCompanion(Companion_445);
protoOf($serializer_377).z1b = typeParametersSerializers;
initMetadataForObject($serializer_377, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RaagaHydraStatement).n2o = canBeApplied;
protoOf(RaagaHydraStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RaagaHydraStatement, 'RaagaHydraStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_373});
protoOf(BasiliskType).r36 = get_preferredLocation_0;
protoOf(BasiliskType).n2z = get_maxHP;
protoOf(BasiliskType).v36 = getInitList;
initMetadataForObject(BasiliskType, 'BasiliskType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: BasiliskType_getInstance});
protoOf(FloodCard).u37 = get_number;
initMetadataForObject(FloodCard, 'FloodCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: FloodCard_getInstance});
protoOf(HydraCard).u37 = get_number;
initMetadataForObject(HydraCard, 'HydraCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: HydraCard_getInstance});
protoOf(SlitherCard).u37 = get_number;
initMetadataForObject(SlitherCard, 'SlitherCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SlitherCard_getInstance});
protoOf(SummonBasiliskCard).u37 = get_number;
initMetadataForObject(SummonBasiliskCard, 'SummonBasiliskCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SummonBasiliskCard_getInstance});
initMetadataForObject(PetrifyAttackModifier, 'PetrifyAttackModifier', VOID, VOID, [AttackModifier, SerializerFactory], VOID, VOID, {0: PetrifyAttackModifier_getInstance});
initMetadataForCompanion(Companion_446);
protoOf($serializer_378).z1b = typeParametersSerializers;
initMetadataForObject($serializer_378, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RecoveryTestContract, 'RecoveryTestContract', RecoveryTestContract.i5y, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_374});
initMetadataForCompanion(Companion_447);
protoOf($serializer_379).z1b = typeParametersSerializers;
initMetadataForObject($serializer_379, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RecoveryTestForEachHunterStatement, 'RecoveryTestForEachHunterStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_375});
initMetadataForCompanion(Companion_448);
protoOf($serializer_380).z1b = typeParametersSerializers;
initMetadataForObject($serializer_380, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RecoveryTestStatement).n2o = canBeApplied;
protoOf(RecoveryTestStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RecoveryTestStatement, 'RecoveryTestStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_376});
initMetadataForObject(RecoveryTestInitialPhase, 'RecoveryTestInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: RecoveryTestInitialPhase_getInstance});
initMetadataForCompanion(Companion_449);
protoOf($serializer_381).z1b = typeParametersSerializers;
initMetadataForObject($serializer_381, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RecoveryTestEvent, 'RecoveryTestEvent', VOID, VOID, [GameStateEvent], VOID, VOID, {0: $serializer_getInstance_377});
initMetadataForObject(RecoveryTestFailingEvent, 'RecoveryTestFailingEvent', VOID, VOID, [GameStateEvent, SerializerFactory], VOID, VOID, {0: RecoveryTestFailingEvent_getInstance});
initMetadataForCompanion(Companion_450);
protoOf($serializer_382).z1b = typeParametersSerializers;
initMetadataForObject($serializer_382, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(RecoveryTestCard, 'RecoveryTestCard', VOID, VOID, [ArsenalCard], VOID, VOID, {0: Companion_getInstance_454});
protoOf(RecoveryTestBeastCard).u37 = get_number;
initMetadataForClass(RecoveryTestBeastCard, 'RecoveryTestBeastCard', VOID, VOID, [PlayableInTurnCard, BeastlyTalentCard, RecoveryTestCard], VOID, VOID, {0: $serializer_getInstance_378});
protoOf(RecoveryTestBeastReaction).u37 = get_number;
initMetadataForObject(RecoveryTestBeastReaction, 'RecoveryTestBeastReaction', VOID, VOID, [BeastlyTalentCard, PlayableCard, SerializerFactory], VOID, VOID, {0: RecoveryTestBeastReaction_getInstance});
initMetadataForInterface(RecoveryTestConditionCard, 'RecoveryTestConditionCard', VOID, VOID, [BeastlyTalentCard], VOID, VOID, {0: Companion_getInstance_455});
protoOf(RecoveryTestNightlyRewardsFailureCard).u37 = get_number;
initMetadataForObject(RecoveryTestNightlyRewardsFailureCard, 'RecoveryTestNightlyRewardsFailureCard', VOID, VOID, [RecoveryTestConditionCard, SerializerFactory], VOID, VOID, {0: RecoveryTestNightlyRewardsFailureCard_getInstance});
protoOf(RecoveryTestPhaseFailureCard).u37 = get_number;
initMetadataForObject(RecoveryTestPhaseFailureCard, 'RecoveryTestPhaseFailureCard', VOID, VOID, [RecoveryTestConditionCard, SerializerFactory], VOID, VOID, {0: RecoveryTestPhaseFailureCard_getInstance});
protoOf(RecoveryTestTeamRewardFailureCard).u37 = get_number;
initMetadataForObject(RecoveryTestTeamRewardFailureCard, 'RecoveryTestTeamRewardFailureCard', VOID, VOID, [RecoveryTestConditionCard, SerializerFactory], VOID, VOID, {0: RecoveryTestTeamRewardFailureCard_getInstance});
initMetadataForCompanion(Companion_451);
protoOf($serializer_383).z1b = typeParametersSerializers;
initMetadataForObject($serializer_383, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RecoveryTestHunterCard).u37 = get_number;
initMetadataForClass(RecoveryTestHunterCard, 'RecoveryTestHunterCard', VOID, VOID, [PlayableInTurnCard, HunterItemCard, RecoveryTestCard], VOID, VOID, {0: $serializer_getInstance_379});
protoOf(RecoveryTestHunterReaction).u37 = get_number;
initMetadataForObject(RecoveryTestHunterReaction, 'RecoveryTestHunterReaction', VOID, VOID, [HunterItemCard, PlayableCard, SerializerFactory], VOID, VOID, {0: RecoveryTestHunterReaction_getInstance});
initMetadataForCompanion(Companion_452, VOID, [SerializerFactory]);
initMetadataForClass(RecoveryTestFailure, 'RecoveryTestFailure', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_453});
initMetadataForCompanion(Companion_453, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_454, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_455);
protoOf($serializer_384).z1b = typeParametersSerializers;
initMetadataForObject($serializer_384, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RegentOfRuinsContract, 'RegentOfRuinsContract', RegentOfRuinsContract.i60, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_380});
initMetadataForObject(RegentOfRuinsInitialPhase, 'RegentOfRuinsInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: RegentOfRuinsInitialPhase_getInstance});
initMetadataForCompanion(Companion_456);
protoOf($serializer_385).z1b = typeParametersSerializers;
initMetadataForObject($serializer_385, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RegentDominionChangeEvent).o37 = stateChanges_0;
initMetadataForClass(RegentDominionChangeEvent, 'RegentDominionChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_381});
protoOf(AbyssalHellFireUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AbyssalHellFireUpgrade, 'AbyssalHellFireUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AbyssalHellFireUpgrade_getInstance});
protoOf(BurnUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BurnUpgrade, 'BurnUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BurnUpgrade_getInstance});
protoOf(DraconicBondsUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DraconicBondsUpgrade, 'DraconicBondsUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DraconicBondsUpgrade_getInstance});
protoOf(AngerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(AngerUpgrade, 'AngerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: AngerUpgrade_getInstance});
initMetadataForCompanion(Companion_457, VOID, [SerializerFactory]);
initMetadataForInterface(RhagnerCard, 'RhagnerCard', VOID, VOID, [PlayableInTurnCard, AbilityCard], VOID, VOID, {0: Companion_getInstance_458});
protoOf(IncinerateCard).t37 = get_character_0;
protoOf(IncinerateCard).u37 = get_number;
initMetadataForObject(IncinerateCard, 'IncinerateCard', VOID, VOID, [RhagnerCard, SerializerFactory], VOID, VOID, {0: IncinerateCard_getInstance});
protoOf(RiseCard).t37 = get_character_0;
protoOf(RiseCard).u37 = get_number;
initMetadataForObject(RiseCard, 'RiseCard', VOID, VOID, [RhagnerCard, SerializerFactory], VOID, VOID, {0: RiseCard_getInstance});
protoOf(ScorchedEarthCard).t37 = get_character_0;
protoOf(ScorchedEarthCard).u37 = get_number;
initMetadataForObject(ScorchedEarthCard, 'ScorchedEarthCard', VOID, VOID, [RhagnerCard, SerializerFactory], VOID, VOID, {0: ScorchedEarthCard_getInstance});
protoOf(SummonLindwyrmCard).t37 = get_character_0;
protoOf(SummonLindwyrmCard).u37 = get_number;
initMetadataForObject(SummonLindwyrmCard, 'SummonLindwyrmCard', VOID, VOID, [RhagnerCard, SerializerFactory], VOID, VOID, {0: SummonLindwyrmCard_getInstance});
protoOf(Rhagner).t36 = get_summonTypes;
protoOf(Rhagner).q2s = get_activatableSummonsOnMap;
protoOf(Rhagner).w36 = modificationNumber;
initMetadataForObject(Rhagner, 'Rhagner', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Rhagner_getInstance});
initMetadataForObject(RhagnerGainHoardEffectSource, 'RhagnerGainHoardEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: RhagnerGainHoardEffectSource_getInstance});
initMetadataForObject(RhagnerReduceHoardEffectSource, 'RhagnerReduceHoardEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: RhagnerReduceHoardEffectSource_getInstance});
initMetadataForObject(RhagnerCardGainHoardQuestionContext, 'RhagnerCardGainHoardQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: RhagnerCardGainHoardQuestionContext_getInstance});
initMetadataForObject(RhagnerCardLoseHoardQuestionContext, 'RhagnerCardLoseHoardQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: RhagnerCardLoseHoardQuestionContext_getInstance});
initMetadataForObject(LocationForFireQuestionContext, 'LocationForFireQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: LocationForFireQuestionContext_getInstance});
initMetadataForObject(LocationToIncinerateQuestionContext, 'LocationToIncinerateQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: LocationToIncinerateQuestionContext_getInstance});
initMetadataForObject(LocationToTransformAndFireQuestionContext, 'LocationToTransformAndFireQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: LocationToTransformAndFireQuestionContext_getInstance});
initMetadataForObject(SummonToSacrificeQuestionContext, 'SummonToSacrificeQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: SummonToSacrificeQuestionContext_getInstance});
initMetadataForObject(TargetToRunFromFireQuestionContext, 'TargetToRunFromFireQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: TargetToRunFromFireQuestionContext_getInstance});
initMetadataForCompanion(Companion_458);
protoOf($serializer_386).z1b = typeParametersSerializers;
initMetadataForObject($serializer_386, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AbyssalHellFireStatement).n2o = canBeApplied;
protoOf(AbyssalHellFireStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(AbyssalHellFireStatement, 'AbyssalHellFireStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_382});
initMetadataForCompanion(Companion_459);
protoOf($serializer_387).z1b = typeParametersSerializers;
initMetadataForObject($serializer_387, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(IncinerateHoardStatement).n2o = canBeApplied;
protoOf(IncinerateHoardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(IncinerateHoardStatement, 'IncinerateHoardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_383});
initMetadataForCompanion(Companion_460);
protoOf($serializer_388).z1b = typeParametersSerializers;
initMetadataForObject($serializer_388, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(IncinerateStatement).n2o = canBeApplied;
protoOf(IncinerateStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(IncinerateStatement, 'IncinerateStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_384});
initMetadataForCompanion(Companion_461);
protoOf($serializer_389).z1b = typeParametersSerializers;
initMetadataForObject($serializer_389, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RunFromFireStatement, 'RunFromFireStatement', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_385});
initMetadataForCompanion(Companion_462);
protoOf($serializer_390).z1b = typeParametersSerializers;
initMetadataForObject($serializer_390, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceFireTokenOnNearbyStatement).n2o = canBeApplied;
initMetadataForClass(PlaceFireTokenOnNearbyStatement, 'PlaceFireTokenOnNearbyStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_386});
initMetadataForCompanion(Companion_463);
protoOf($serializer_391).z1b = typeParametersSerializers;
initMetadataForObject($serializer_391, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceFireTokensStatement).n2o = canBeApplied;
initMetadataForClass(PlaceFireTokensStatement, 'PlaceFireTokensStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_387});
initMetadataForCompanion(Companion_464);
protoOf($serializer_392).z1b = typeParametersSerializers;
initMetadataForObject($serializer_392, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RhagnerAdjustHoardStatement).n2o = canBeApplied;
protoOf(RhagnerAdjustHoardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RhagnerAdjustHoardStatement, 'RhagnerAdjustHoardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_388});
initMetadataForCompanion(Companion_465);
protoOf($serializer_393).z1b = typeParametersSerializers;
initMetadataForObject($serializer_393, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RiseHoardStatement).n2o = canBeApplied;
protoOf(RiseHoardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RiseHoardStatement, 'RiseHoardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_389});
initMetadataForCompanion(Companion_466);
protoOf($serializer_394).z1b = typeParametersSerializers;
initMetadataForObject($serializer_394, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RiseStatement).n2o = canBeApplied;
protoOf(RiseStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RiseStatement, 'RiseStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_390});
initMetadataForCompanion(Companion_467);
protoOf($serializer_395).z1b = typeParametersSerializers;
initMetadataForObject($serializer_395, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ScorchedEarthHoardStatement).n2o = canBeApplied;
protoOf(ScorchedEarthHoardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ScorchedEarthHoardStatement, 'ScorchedEarthHoardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_391});
initMetadataForCompanion(Companion_468);
protoOf($serializer_396).z1b = typeParametersSerializers;
initMetadataForObject($serializer_396, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ScorchedEarthStatement).n2o = canBeApplied;
protoOf(ScorchedEarthStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ScorchedEarthStatement, 'ScorchedEarthStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_392});
initMetadataForCompanion(Companion_469);
protoOf($serializer_397).z1b = typeParametersSerializers;
initMetadataForObject($serializer_397, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SummonLindwyrmHoardStatement).n2o = canBeApplied;
initMetadataForClass(SummonLindwyrmHoardStatement, 'SummonLindwyrmHoardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_393});
initMetadataForCompanion(Companion_470);
protoOf($serializer_398).z1b = typeParametersSerializers;
initMetadataForObject($serializer_398, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SummonLindwyrmStatement).n2o = canBeApplied;
protoOf(SummonLindwyrmStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SummonLindwyrmStatement, 'SummonLindwyrmStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_394});
initMetadataForCompanion(Companion_471);
protoOf($serializer_399).z1b = typeParametersSerializers;
initMetadataForObject($serializer_399, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RhagnerHoardChangeEvent).o37 = stateChanges_0;
initMetadataForClass(RhagnerHoardChangeEvent, 'RhagnerHoardChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_395});
protoOf(LindwyrmType).r36 = get_preferredLocation_0;
protoOf(LindwyrmType).n2z = get_maxHP;
protoOf(LindwyrmType).v36 = getInitList;
initMetadataForObject(LindwyrmType, 'LindwyrmType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: LindwyrmType_getInstance});
initMetadataForCompanion(Companion_472);
protoOf($serializer_400).z1b = typeParametersSerializers;
initMetadataForObject($serializer_400, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AngerIncinerateAttackModifier, 'AngerIncinerateAttackModifier', VOID, VOID, [AttackModifier], VOID, VOID, {0: $serializer_getInstance_396});
initMetadataForCompanion(Companion_473);
protoOf($serializer_401).z1b = typeParametersSerializers;
initMetadataForObject($serializer_401, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SecretsFromALostAgeContract, 'SecretsFromALostAgeContract', SecretsFromALostAgeContract.x64, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_397});
initMetadataForObject(SecretsFromALostAgeInitialPhase, 'SecretsFromALostAgeInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: SecretsFromALostAgeInitialPhase_getInstance});
initMetadataForCompanion(Companion_474);
protoOf($serializer_402).z1b = typeParametersSerializers;
initMetadataForObject($serializer_402, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ShipwreckContract, 'ShipwreckContract', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_398});
initMetadataForObject(ShipwreckRedDraftActionCardEffectSource, 'ShipwreckRedDraftActionCardEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: ShipwreckRedDraftActionCardEffectSource_getInstance});
protoOf(ShipwreckSettlerMovementStatement).n2o = canBeApplied;
protoOf(ShipwreckSettlerMovementStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(ShipwreckSettlerMovementStatement, 'ShipwreckSettlerMovementStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: ShipwreckSettlerMovementStatement_getInstance});
initMetadataForObject(ShipwreckInitialPhase, 'ShipwreckInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: ShipwreckInitialPhase_getInstance});
initMetadataForCompanion(Companion_475);
protoOf($serializer_403).z1b = typeParametersSerializers;
initMetadataForObject($serializer_403, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ChangeSettlersMovedStatusEvent).o37 = stateChanges_0;
initMetadataForClass(ChangeSettlersMovedStatusEvent, 'ChangeSettlersMovedStatusEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_399});
protoOf(Sigrid).w36 = modificationNumber;
protoOf(Sigrid).r36 = get_preferredLocation_1;
initMetadataForObject(Sigrid, 'Sigrid', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Sigrid_getInstance});
protoOf(EcholocationUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(EcholocationUpgrade, 'EcholocationUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: EcholocationUpgrade_getInstance});
protoOf(SwapUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SwapUpgrade, 'SwapUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SwapUpgrade_getInstance});
initMetadataForObject(PactReversalUpgrade, 'PactReversalUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: PactReversalUpgrade_getInstance});
initMetadataForObject(SigridCreatureDeathEffectSource, 'SigridCreatureDeathEffectSource', VOID, VOID, [DamageSource, EffectSource, SerializerFactory], VOID, VOID, {0: SigridCreatureDeathEffectSource_getInstance});
initMetadataForObject(SigridCreatureLungeEffectSource, 'SigridCreatureLungeEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: SigridCreatureLungeEffectSource_getInstance});
initMetadataForObject(SigridSummonCreatureEffectSource, 'SigridSummonCreatureEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: SigridSummonCreatureEffectSource_getInstance});
initMetadataForObject(SigridPactCardQuestionContext, 'SigridPactCardQuestionContext', VOID, VOID, [CardQuestionContext, SerializerFactory], VOID, VOID, {0: SigridPactCardQuestionContext_getInstance});
initMetadataForCompanion(Companion_476);
protoOf($serializer_404).z1b = typeParametersSerializers;
initMetadataForObject($serializer_404, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SigridAttackAllNearbyLocationsStatement).n2o = canBeApplied;
initMetadataForClass(SigridAttackAllNearbyLocationsStatement, 'SigridAttackAllNearbyLocationsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_400});
protoOf(SigridCreatureLungeStatement).n2o = canBeApplied;
initMetadataForObject(SigridCreatureLungeStatement, 'SigridCreatureLungeStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: SigridCreatureLungeStatement_getInstance});
protoOf(SigridPactReversalStatement).n2o = canBeApplied;
initMetadataForObject(SigridPactReversalStatement, 'SigridPactReversalStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: SigridPactReversalStatement_getInstance});
initMetadataForCompanion(Companion_477);
protoOf($serializer_405).z1b = typeParametersSerializers;
initMetadataForObject($serializer_405, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SigridSearchAllNearbyLocationsStatement).n2o = canBeApplied;
initMetadataForClass(SigridSearchAllNearbyLocationsStatement, 'SigridSearchAllNearbyLocationsStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_401});
protoOf(SummonCreatureStatement).n2o = canBeApplied;
protoOf(SummonCreatureStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(SummonCreatureStatement, 'SummonCreatureStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: SummonCreatureStatement_getInstance});
initMetadataForCompanion(Companion_478);
protoOf($serializer_406).z1b = typeParametersSerializers;
initMetadataForObject($serializer_406, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SigridPactChangeEvent).o37 = stateChanges_0;
initMetadataForClass(SigridPactChangeEvent, 'SigridPactChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_402});
initMetadataForCompanion(Companion_479);
protoOf($serializer_407).z1b = typeParametersSerializers;
initMetadataForObject($serializer_407, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SigridCreatureLungedStatusEvent).o37 = stateChanges_0;
initMetadataForClass(SigridCreatureLungedStatusEvent, 'SigridCreatureLungedStatusEvent', VOID, VOID, [TechnicalGameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_403});
initMetadataForObject(SigridCreatureLungedEvent, 'SigridCreatureLungedEvent', VOID, VOID, [SerializerFactory], VOID, VOID, {0: SigridCreatureLungedEvent_getInstance});
protoOf(CreatureType).n2z = get_maxHP_0;
protoOf(CreatureType).r36 = get_preferredLocation_1;
protoOf(CreatureType).v36 = getInitList;
initMetadataForObject(CreatureType, 'CreatureType', VOID, VOID, [HunterCompanionType, SerializerFactory], VOID, VOID, {0: CreatureType_getInstance});
initMetadataForInterface(SigridAbilityCard, 'SigridAbilityCard', VOID, VOID, [PlayableInTurnCard, AbilityCard], VOID, VOID, {0: Companion_getInstance_481});
protoOf(TraitorsHuntCard).t37 = get_character_1;
protoOf(TraitorsHuntCard).u37 = get_number;
initMetadataForObject(TraitorsHuntCard, 'TraitorsHuntCard', VOID, VOID, [SigridAbilityCard, PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: TraitorsHuntCard_getInstance});
protoOf(BondedTrackCard).t37 = get_character_1;
protoOf(BondedTrackCard).u37 = get_number;
initMetadataForObject(BondedTrackCard, 'BondedTrackCard', VOID, VOID, [SigridAbilityCard, PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: BondedTrackCard_getInstance});
protoOf(ScroungeCard).t37 = get_character_1;
protoOf(ScroungeCard).u37 = get_number;
initMetadataForObject(ScroungeCard, 'ScroungeCard', VOID, VOID, [SigridAbilityCard, SerializerFactory], VOID, VOID, {0: ScroungeCard_getInstance});
initMetadataForCompanion(Companion_480, VOID, [SerializerFactory]);
protoOf(CloudShiftUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(CloudShiftUpgrade, 'CloudShiftUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: CloudShiftUpgrade_getInstance});
protoOf(BehornedUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BehornedUpgrade, 'BehornedUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BehornedUpgrade_getInstance});
protoOf(StormBringerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(StormBringerUpgrade, 'StormBringerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: StormBringerUpgrade_getInstance});
protoOf(EruptionUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(EruptionUpgrade, 'EruptionUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: EruptionUpgrade_getInstance});
protoOf(SuddenShockUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SuddenShockUpgrade, 'SuddenShockUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SuddenShockUpgrade_getInstance});
protoOf(DischargeUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DischargeUpgrade, 'DischargeUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DischargeUpgrade_getInstance});
protoOf(StarFallUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(StarFallUpgrade, 'StarFallUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: StarFallUpgrade_getInstance});
protoOf(Thalduk).t36 = get_summonTypes;
protoOf(Thalduk).u36 = get_summonLimit;
protoOf(Thalduk).q2s = get_activatableSummonsOnMap;
protoOf(Thalduk).v36 = getInitList_1;
protoOf(Thalduk).w36 = modificationNumber;
initMetadataForObject(Thalduk, 'Thalduk', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Thalduk_getInstance});
initMetadataForObject(PossibleBleatEffectSource, 'PossibleBleatEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: PossibleBleatEffectSource_getInstance});
initMetadataForObject(ActorForRamQuestionContext, 'ActorForRamQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: ActorForRamQuestionContext_getInstance});
initMetadataForObject(TargetToRamQuestionContext, 'TargetToRamQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: TargetToRamQuestionContext_getInstance});
initMetadataForCompanion(Companion_481);
protoOf($serializer_408).z1b = typeParametersSerializers;
initMetadataForObject($serializer_408, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BleatCardTriggerStatement).n2o = canBeApplied;
protoOf(BleatCardTriggerStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BleatCardTriggerStatement, 'BleatCardTriggerStatement', VOID, VOID, [ApplyingReactionStatement], VOID, VOID, {0: $serializer_getInstance_404});
initMetadataForCompanion(Companion_482);
protoOf($serializer_409).z1b = typeParametersSerializers;
initMetadataForObject($serializer_409, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DischargeStatement).n2o = canBeApplied;
protoOf(DischargeStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(DischargeStatement, 'DischargeStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_405});
protoOf(EruptionEffectStatement).n2o = canBeApplied;
protoOf(EruptionEffectStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(EruptionEffectStatement, 'EruptionEffectStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: EruptionEffectStatement_getInstance});
initMetadataForCompanion(Companion_483);
protoOf($serializer_410).z1b = typeParametersSerializers;
initMetadataForObject($serializer_410, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RamAnotherTargetStatement).n2o = canBeApplied;
protoOf(RamAnotherTargetStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RamAnotherTargetStatement, 'RamAnotherTargetStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_406});
initMetadataForCompanion(Companion_484);
protoOf($serializer_411).z1b = typeParametersSerializers;
initMetadataForObject($serializer_411, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(RevealToMoveStatement).n2o = canBeApplied;
protoOf(RevealToMoveStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(RevealToMoveStatement, 'RevealToMoveStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_407});
initMetadataForCompanion(Companion_485);
protoOf($serializer_412).z1b = typeParametersSerializers;
initMetadataForObject($serializer_412, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SuddenShockStatement).n2o = canBeApplied;
initMetadataForClass(SuddenShockStatement, 'SuddenShockStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_408});
protoOf(YagiType).r36 = get_preferredLocation_0;
protoOf(YagiType).n2z = get_maxHP;
protoOf(YagiType).v36 = getInitList;
initMetadataForObject(YagiType, 'YagiType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: YagiType_getInstance});
protoOf(AcclivityCard).u37 = get_number;
initMetadataForObject(AcclivityCard, 'AcclivityCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: AcclivityCard_getInstance});
protoOf(OverloadedStormCard).u37 = get_number;
initMetadataForObject(OverloadedStormCard, 'OverloadedStormCard', VOID, VOID, [OverloadedCard, PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: OverloadedStormCard_getInstance});
protoOf(StormCard).u37 = get_number;
initMetadataForObject(StormCard, 'StormCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: StormCard_getInstance});
protoOf(SummonYagiCard).u37 = get_number;
initMetadataForObject(SummonYagiCard, 'SummonYagiCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: SummonYagiCard_getInstance});
protoOf(BleatCard).u37 = get_number;
initMetadataForObject(BleatCard, 'BleatCard', VOID, VOID, [AbilityCard, PlayableCard, SerializerFactory], VOID, VOID, {0: BleatCard_getInstance});
initMetadataForCompanion(Companion_486);
protoOf($serializer_413).z1b = typeParametersSerializers;
initMetadataForObject($serializer_413, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UnleashingTheAbyssContract, 'UnleashingTheAbyssContract', UnleashingTheAbyssContract.n69, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_409});
initMetadataForObject(UnleashingTheAbyssInitialPhase, 'UnleashingTheAbyssInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: UnleashingTheAbyssInitialPhase_getInstance});
initMetadataForCompanion(Companion_487);
protoOf($serializer_414).z1b = typeParametersSerializers;
initMetadataForObject($serializer_414, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UnlikelyAllianceContract, 'UnlikelyAllianceContract', UnlikelyAllianceContract.y69, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_410});
initMetadataForCompanion(Companion_488);
protoOf($serializer_415).z1b = typeParametersSerializers;
initMetadataForObject($serializer_415, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AttackOrSummonFromRuinStatement).n2o = canBeApplied;
protoOf(AttackOrSummonFromRuinStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(AttackOrSummonFromRuinStatement, 'AttackOrSummonFromRuinStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_411});
initMetadataForCompanion(Companion_489);
protoOf($serializer_416).z1b = typeParametersSerializers;
initMetadataForObject($serializer_416, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(EachBeastAndSummonMoves).n2o = canBeApplied;
protoOf(EachBeastAndSummonMoves).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(EachBeastAndSummonMoves, 'EachBeastAndSummonMoves', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_412});
initMetadataForObject(UnlikelyAllianceInitialPhase, 'UnlikelyAllianceInitialPhase', VOID, VOID, [ContractInitPhase, SerializerFactory], VOID, VOID, {0: UnlikelyAllianceInitialPhase_getInstance});
initMetadataForObject(UpperShatteredRuins, 'UpperShatteredRuins');
initMetadataForObject(UpperShatteredSettlements, 'UpperShatteredSettlements');
protoOf(BroodswellUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BroodswellUpgrade, 'BroodswellUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BroodswellUpgrade_getInstance});
protoOf(RuptureSeedsUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(RuptureSeedsUpgrade, 'RuptureSeedsUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: RuptureSeedsUpgrade_getInstance});
protoOf(InfestUrgullUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(InfestUrgullUpgrade, 'InfestUrgullUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: InfestUrgullUpgrade_getInstance});
protoOf(LairUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(LairUpgrade, 'LairUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: LairUpgrade_getInstance});
protoOf(Urgull).w36 = modificationNumber;
initMetadataForObject(Urgull, 'Urgull', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Urgull_getInstance});
initMetadataForObject(UrgullHatchDamageSource, 'UrgullHatchDamageSource', VOID, VOID, [DamageSource, EffectSource, SerializerFactory], VOID, VOID, {0: UrgullHatchDamageSource_getInstance});
initMetadataForObject(UrgullMoltRewardEffectSource, 'UrgullMoltRewardEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: UrgullMoltRewardEffectSource_getInstance});
protoOf(PlaceHatchlingWithInfestQuestion).s3o = get_variants;
protoOf(PlaceHatchlingWithInfestQuestion).t3o = get_questionContext;
initMetadataForObject(PlaceHatchlingWithInfestQuestion, 'PlaceHatchlingWithInfestQuestion', VOID, VOID, [BooleanGameQuestion, SerializerFactory], VOID, VOID, {0: PlaceHatchlingWithInfestQuestion_getInstance});
initMetadataForCompanion(Companion_490);
protoOf($serializer_417).z1b = typeParametersSerializers;
initMetadataForObject($serializer_417, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(UrgullMoltEggsToReturnQuestion).t3o = get_questionContext;
initMetadataForClass(UrgullMoltEggsToReturnQuestion, 'UrgullMoltEggsToReturnQuestion', VOID, VOID, [GameQuestion], VOID, VOID, {0: $serializer_getInstance_413});
initMetadataForObject(LocationForLivingWebQuestionContext, 'LocationForLivingWebQuestionContext', VOID, VOID, [LocationQuestionContext, SerializerFactory], VOID, VOID, {0: LocationForLivingWebQuestionContext_getInstance});
initMetadataForObject(EggToHatchQuestionContext, 'EggToHatchQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: EggToHatchQuestionContext_getInstance});
initMetadataForObject(EggToReturnToMoltQuestionContext, 'EggToReturnToMoltQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: EggToReturnToMoltQuestionContext_getInstance});
initMetadataForObject(HatchlingToReplaceQuestionContext, 'HatchlingToReplaceQuestionContext', VOID, VOID, [TargetQuestionContext, SerializerFactory], VOID, VOID, {0: HatchlingToReplaceQuestionContext_getInstance});
initMetadataForObject(UrgullMoltEggsToReturnQuestionContext, 'UrgullMoltEggsToReturnQuestionContext', VOID, VOID, [QuestionContext, SerializerFactory], VOID, VOID, {0: UrgullMoltEggsToReturnQuestionContext_getInstance});
initMetadataForCompanion(Companion_491);
protoOf($serializer_418).z1b = typeParametersSerializers;
initMetadataForObject($serializer_418, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BroodswellStatement).n2o = canBeApplied;
protoOf(BroodswellStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BroodswellStatement, 'BroodswellStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_414});
initMetadataForCompanion(Companion_492);
protoOf($serializer_419).z1b = typeParametersSerializers;
initMetadataForObject($serializer_419, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(HatchEggStatement).n2o = canBeApplied;
protoOf(HatchEggStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(HatchEggStatement, 'HatchEggStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_415});
initMetadataForCompanion(Companion_493);
protoOf($serializer_420).z1b = typeParametersSerializers;
initMetadataForObject($serializer_420, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(OvipunctureStatement).n2o = canBeApplied;
protoOf(OvipunctureStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(OvipunctureStatement, 'OvipunctureStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_416});
initMetadataForCompanion(Companion_494);
protoOf($serializer_421).z1b = typeParametersSerializers;
initMetadataForObject($serializer_421, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceHatchlingAfterEggStatement).n2o = canBeApplied;
protoOf(PlaceHatchlingAfterEggStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlaceHatchlingAfterEggStatement, 'PlaceHatchlingAfterEggStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_417});
initMetadataForCompanion(Companion_495);
protoOf($serializer_422).z1b = typeParametersSerializers;
initMetadataForObject($serializer_422, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceLivingWebNearbyStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlaceLivingWebNearbyStatement, 'PlaceLivingWebNearbyStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_418});
initMetadataForCompanion(Companion_496);
protoOf($serializer_423).z1b = typeParametersSerializers;
initMetadataForObject($serializer_423, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(PlaceUrgullEggOnOwnLocationStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(PlaceUrgullEggOnOwnLocationStatement, 'PlaceUrgullEggOnOwnLocationStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_419});
protoOf(EggType).r36 = get_preferredLocation_0;
protoOf(EggType).n2z = get_maxHP;
protoOf(EggType).v36 = getInitList;
initMetadataForObject(EggType, 'EggType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: EggType_getInstance});
protoOf(HatchlingType).r36 = get_preferredLocation_0;
protoOf(HatchlingType).n2z = get_maxHP;
protoOf(HatchlingType).v36 = getInitList;
initMetadataForObject(HatchlingType, 'HatchlingType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: HatchlingType_getInstance});
initMetadataForCompanion(Companion_497);
protoOf($serializer_424).z1b = typeParametersSerializers;
initMetadataForObject($serializer_424, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(UrgullMoltCounterChangeEvent).o37 = stateChanges_0;
initMetadataForClass(UrgullMoltCounterChangeEvent, 'UrgullMoltCounterChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_420});
initMetadataForInterface(UrgullCard, 'UrgullCard', VOID, VOID, [PlayableInTurnCard, AbilityCard]);
protoOf(NestCard).t37 = get_character_2;
protoOf(NestCard).u37 = get_number;
initMetadataForObject(NestCard, 'NestCard', VOID, VOID, [UrgullCard, SerializerFactory], VOID, VOID, {0: NestCard_getInstance});
protoOf(OverloadedNestCard).u37 = get_number;
protoOf(OverloadedNestCard).t37 = get_character_2;
initMetadataForObject(OverloadedNestCard, 'OverloadedNestCard', VOID, VOID, [OverloadedCard, UrgullCard, SerializerFactory], VOID, VOID, {0: OverloadedNestCard_getInstance});
protoOf(OvipunctureCard).t37 = get_character_2;
protoOf(OvipunctureCard).u37 = get_number;
initMetadataForObject(OvipunctureCard, 'OvipunctureCard', VOID, VOID, [UrgullCard, SerializerFactory], VOID, VOID, {0: OvipunctureCard_getInstance});
protoOf(SilkCard).t37 = get_character_2;
protoOf(SilkCard).u37 = get_number;
initMetadataForObject(SilkCard, 'SilkCard', VOID, VOID, [UrgullCard, SerializerFactory], VOID, VOID, {0: SilkCard_getInstance});
protoOf(SummonEggCard).t37 = get_character_2;
protoOf(SummonEggCard).u37 = get_number;
initMetadataForObject(SummonEggCard, 'SummonEggCard', VOID, VOID, [UrgullCard, SerializerFactory], VOID, VOID, {0: SummonEggCard_getInstance});
protoOf(MirrorBeastUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(MirrorBeastUpgrade, 'MirrorBeastUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: MirrorBeastUpgrade_getInstance});
protoOf(GoldenBeakUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(GoldenBeakUpgrade, 'GoldenBeakUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: GoldenBeakUpgrade_getInstance});
protoOf(SoulHarvestVackerUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SoulHarvestVackerUpgrade, 'SoulHarvestVackerUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SoulHarvestVackerUpgrade_getInstance});
protoOf(SwiftKillUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(SwiftKillUpgrade, 'SwiftKillUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: SwiftKillUpgrade_getInstance});
protoOf(EntrancingUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(EntrancingUpgrade, 'EntrancingUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: EntrancingUpgrade_getInstance});
protoOf(ReveranceUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ReveranceUpgrade, 'ReveranceUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ReveranceUpgrade_getInstance});
protoOf(Vacker).t36 = get_summonTypes;
protoOf(Vacker).u36 = get_summonLimit;
protoOf(Vacker).q2s = get_activatableSummonsOnMap;
protoOf(Vacker).w36 = modificationNumber;
initMetadataForObject(Vacker, 'Vacker', VOID, VOID, [BeastCharacter, SerializerFactory], VOID, VOID, {0: Vacker_getInstance});
initMetadataForObject(AllureSoulChangedDamageSource, 'AllureSoulChangedDamageSource', VOID, VOID, [DamageSource, SerializerFactory], VOID, VOID, {0: AllureSoulChangedDamageSource_getInstance});
initMetadataForObject(AllureKillEffectSource, 'AllureKillEffectSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: AllureKillEffectSource_getInstance});
initMetadataForObject(SoulsChangeSource, 'SoulsChangeSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: SoulsChangeSource_getInstance});
initMetadataForCompanion(Companion_498);
protoOf($serializer_425).z1b = typeParametersSerializers;
initMetadataForObject($serializer_425, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AllureKillSoulBonusStatement).n2o = canBeApplied;
protoOf(AllureKillSoulBonusStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(AllureKillSoulBonusStatement, 'AllureKillSoulBonusStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_421});
initMetadataForCompanion(Companion_499);
protoOf($serializer_426).z1b = typeParametersSerializers;
initMetadataForObject($serializer_426, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(AllureStatement).n2o = canBeApplied;
initMetadataForClass(AllureStatement, 'AllureStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_422});
initMetadataForCompanion(Companion_500);
protoOf($serializer_427).z1b = typeParametersSerializers;
initMetadataForObject($serializer_427, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BeholdStatement).n2o = canBeApplied;
protoOf(BeholdStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BeholdStatement, 'BeholdStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_423});
initMetadataForCompanion(Companion_501);
protoOf($serializer_428).z1b = typeParametersSerializers;
initMetadataForObject($serializer_428, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(EludeStatement).n2o = canBeApplied;
protoOf(EludeStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(EludeStatement, 'EludeStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_424});
initMetadataForCompanion(Companion_502);
protoOf($serializer_429).z1b = typeParametersSerializers;
initMetadataForObject($serializer_429, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SoulStealStatement).n2o = canBeApplied;
protoOf(SoulStealStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SoulStealStatement, 'SoulStealStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_425});
initMetadataForCompanion(Companion_503);
protoOf($serializer_430).z1b = typeParametersSerializers;
initMetadataForObject($serializer_430, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SummonAdmirerStatement).n2o = canBeApplied;
protoOf(SummonAdmirerStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(SummonAdmirerStatement, 'SummonAdmirerStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_426});
initMetadataForCompanion(Companion_504);
protoOf($serializer_431).z1b = typeParametersSerializers;
initMetadataForObject($serializer_431, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(DrainedSoulsChangeEvent).o37 = stateChanges_0;
initMetadataForClass(DrainedSoulsChangeEvent, 'DrainedSoulsChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_427});
protoOf(AdmirerType).r36 = get_preferredLocation_0;
protoOf(AdmirerType).n2z = get_maxHP;
protoOf(AdmirerType).v36 = getInitList;
initMetadataForObject(AdmirerType, 'AdmirerType', VOID, VOID, [SummonType, SerializerFactory], VOID, VOID, {0: AdmirerType_getInstance});
initMetadataForInterface(VackerCard, 'VackerCard', VOID, VOID, [PlayableInTurnCard, AbilityCard]);
protoOf(AllureCard).t37 = get_character_3;
protoOf(AllureCard).u37 = get_number;
initMetadataForObject(AllureCard, 'AllureCard', VOID, VOID, [VackerCard, SerializerFactory], VOID, VOID, {0: AllureCard_getInstance});
protoOf(BeholdCard).t37 = get_character_3;
protoOf(BeholdCard).u37 = get_number;
initMetadataForObject(BeholdCard, 'BeholdCard', VOID, VOID, [VackerCard, SerializerFactory], VOID, VOID, {0: BeholdCard_getInstance});
protoOf(EludeCard).t37 = get_character_3;
protoOf(EludeCard).u37 = get_number;
initMetadataForObject(EludeCard, 'EludeCard', VOID, VOID, [VackerCard, SerializerFactory], VOID, VOID, {0: EludeCard_getInstance});
protoOf(SummonAdmirerCard).t37 = get_character_3;
protoOf(SummonAdmirerCard).u37 = get_number;
initMetadataForObject(SummonAdmirerCard, 'SummonAdmirerCard', VOID, VOID, [VackerCard, SerializerFactory], VOID, VOID, {0: SummonAdmirerCard_getInstance});
protoOf(Valdi).i3e = get_hunterCompanionType;
protoOf(Valdi).w36 = modificationNumber;
protoOf(Valdi).r36 = get_preferredLocation_1;
initMetadataForObject(Valdi, 'Valdi', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Valdi_getInstance});
protoOf(InfusionUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(InfusionUpgrade, 'InfusionUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: InfusionUpgrade_getInstance});
protoOf(BloodCraftUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(BloodCraftUpgrade, 'BloodCraftUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: BloodCraftUpgrade_getInstance});
protoOf(DissectionUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(DissectionUpgrade, 'DissectionUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: DissectionUpgrade_getInstance});
protoOf(ExtractUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(ExtractUpgrade, 'ExtractUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: ExtractUpgrade_getInstance});
initMetadataForObject(ValdiBloodKillSource, 'ValdiBloodKillSource', VOID, VOID, [EffectSource, SerializerFactory], VOID, VOID, {0: ValdiBloodKillSource_getInstance});
initMetadataForCompanion(Companion_505);
protoOf($serializer_432).z1b = typeParametersSerializers;
initMetadataForObject($serializer_432, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(SpendValdiBloodQuestion).s3o = get_variants;
protoOf(SpendValdiBloodQuestion).t3o = get_questionContext;
initMetadataForClass(SpendValdiBloodQuestion, 'SpendValdiBloodQuestion', VOID, VOID, [BooleanGameQuestion], VOID, VOID, {0: $serializer_getInstance_428});
initMetadataForCompanion(Companion_506);
protoOf($serializer_433).z1b = typeParametersSerializers;
initMetadataForObject($serializer_433, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BloodHuntStatement).n2o = canBeApplied;
protoOf(BloodHuntStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BloodHuntStatement, 'BloodHuntStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_429});
initMetadataForCompanion(Companion_507);
protoOf($serializer_434).z1b = typeParametersSerializers;
initMetadataForObject($serializer_434, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(BloodTrackStatement).n2o = canBeApplied;
protoOf(BloodTrackStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(BloodTrackStatement, 'BloodTrackStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_430});
protoOf(ExtractStatement).n2o = canBeApplied;
protoOf(ExtractStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(ExtractStatement, 'ExtractStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: ExtractStatement_getInstance});
protoOf(InfusionUpgradeStatement).n2o = canBeApplied;
protoOf(InfusionUpgradeStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(InfusionUpgradeStatement, 'InfusionUpgradeStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: InfusionUpgradeStatement_getInstance});
initMetadataForCompanion(Companion_508);
protoOf($serializer_435).z1b = typeParametersSerializers;
initMetadataForObject($serializer_435, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(ValdiBloodChangeEvent).o37 = stateChanges_0;
initMetadataForClass(ValdiBloodChangeEvent, 'ValdiBloodChangeEvent', VOID, VOID, [GameStateChangeEvent], VOID, VOID, {0: $serializer_getInstance_431});
protoOf(BloodHuntCard).u37 = get_number;
initMetadataForObject(BloodHuntCard, 'BloodHuntCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: BloodHuntCard_getInstance});
protoOf(IncisionCard).u37 = get_number;
initMetadataForObject(IncisionCard, 'IncisionCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: IncisionCard_getInstance});
protoOf(BloodTrackCard).u37 = get_number;
initMetadataForObject(BloodTrackCard, 'BloodTrackCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: BloodTrackCard_getInstance});
initMetadataForCompanion(Companion_509);
protoOf($serializer_436).z1b = typeParametersSerializers;
initMetadataForObject($serializer_436, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SetValdiBloodEvent, 'SetValdiBloodEvent', VOID, VOID, [GameStateChange], VOID, VOID, {0: $serializer_getInstance_432});
initMetadataForObject(OnlyAnimalsAttackModifier, 'OnlyAnimalsAttackModifier', VOID, VOID, [AttackModifier, SerializerFactory], VOID, VOID, {0: OnlyAnimalsAttackModifier_getInstance});
protoOf(Varja).i3e = get_hunterCompanionType;
protoOf(Varja).v36 = getInitList_0;
protoOf(Varja).r36 = get_preferredLocation_1;
initMetadataForObject(Varja, 'Varja', VOID, VOID, [HunterCharacter, SerializerFactory], VOID, VOID, {0: Varja_getInstance});
protoOf(HornOfValhUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(HornOfValhUpgrade, 'HornOfValhUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: HornOfValhUpgrade_getInstance});
protoOf(HuntersBaneUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(HuntersBaneUpgrade, 'HuntersBaneUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: HuntersBaneUpgrade_getInstance});
protoOf(HeroicSpeechUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(HeroicSpeechUpgrade, 'HeroicSpeechUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: HeroicSpeechUpgrade_getInstance});
protoOf(TacticalManouverUpgrade).u35 = get_mayBeUpgraded;
initMetadataForObject(TacticalManouverUpgrade, 'TacticalManouverUpgrade', VOID, VOID, [CharacterUpgrade, SerializerFactory], VOID, VOID, {0: TacticalManouverUpgrade_getInstance});
protoOf(ChooseAndMoveByVarja).n2o = canBeApplied;
protoOf(ChooseAndMoveByVarja).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(ChooseAndMoveByVarja, 'ChooseAndMoveByVarja', VOID, VOID, [ActionStatement], VOID, VOID, {0: Companion_getInstance_512});
initMetadataForObject(MoveAllSettlersAndHuntersByVarja, 'MoveAllSettlersAndHuntersByVarja', VOID, VOID, [SerializerFactory], VOID, VOID, {0: MoveAllSettlersAndHuntersByVarja_getInstance});
initMetadataForCompanion(Companion_510);
protoOf($serializer_437).z1b = typeParametersSerializers;
initMetadataForObject($serializer_437, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(CommandCardStatement).n2o = canBeApplied;
protoOf(CommandCardStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForClass(CommandCardStatement, 'CommandCardStatement', VOID, VOID, [ActionStatement], VOID, VOID, {0: $serializer_getInstance_433});
protoOf(HeroicSpeechStatement).n2o = canBeApplied;
protoOf(HeroicSpeechStatement).o2o = canBeAppliedAndHaveEffect;
initMetadataForObject(HeroicSpeechStatement, 'HeroicSpeechStatement', VOID, VOID, [ActionStatement, SerializerFactory], VOID, VOID, {0: HeroicSpeechStatement_getInstance});
protoOf(CommandCard).u37 = get_number;
initMetadataForObject(CommandCard, 'CommandCard', VOID, VOID, [PlayableInTurnCard, AbilityCard, SerializerFactory], VOID, VOID, {0: CommandCard_getInstance});
initMetadataForCompanion(Companion_511, VOID, [SerializerFactory]);
initMetadataForInterface(CurrentAndOldStateHolder, 'CurrentAndOldStateHolder', VOID, VOID, VOID, [1, 3]);
protoOf(CurrentAndOldStateHolderSimple).z6h = applyGameStateChanges;
protoOf(CurrentAndOldStateHolderSimple).a6i = applyGameStateRevertChanges;
protoOf(CurrentAndOldStateHolderSimple).u6h = reportRevisionProblem;
initMetadataForClass(CurrentAndOldStateHolderSimple, 'CurrentAndOldStateHolderSimple', VOID, VOID, [CurrentAndOldStateHolder], [1, 3]);
initMetadataForCompanion(Companion_512, VOID, [SerializerFactory]);
initMetadataForClass(BeastClientFeature, 'BeastClientFeature', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_513});
initMetadataForCompanion(Companion_513);
protoOf($serializer_438).z1b = typeParametersSerializers;
initMetadataForObject($serializer_438, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastAuthenticationCapabilities, 'BeastAuthenticationCapabilities', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_434});
initMetadataForCompanion(Companion_514);
protoOf($serializer_439).z1b = typeParametersSerializers;
initMetadataForObject($serializer_439, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(BeastLoginResult, 'BeastLoginResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_516});
initMetadataForClass(Success, 'Success', VOID, VOID, [BeastLoginResult], VOID, VOID, {0: $serializer_getInstance_435});
initMetadataForObject(Failure, 'Failure', VOID, VOID, [BeastLoginResult, SerializerFactory], VOID, VOID, {0: Failure_getInstance});
initMetadataForCompanion(Companion_515, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_516);
protoOf($serializer_440).z1b = typeParametersSerializers;
initMetadataForObject($serializer_440, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(BeastSessionState, 'BeastSessionState', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_518});
initMetadataForClass(Authenticated, 'Authenticated', VOID, VOID, [BeastSessionState], VOID, VOID, {0: $serializer_getInstance_436});
initMetadataForObject(Unauthenticated, 'Unauthenticated', VOID, VOID, [BeastSessionState, SerializerFactory], VOID, VOID, {0: Unauthenticated_getInstance});
initMetadataForCompanion(Companion_517, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_518);
protoOf($serializer_441).z1b = typeParametersSerializers;
initMetadataForObject($serializer_441, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastClientConfiguration, 'BeastClientConfiguration', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_437});
initMetadataForCompanion(Companion_519);
protoOf($serializer_442).z1b = typeParametersSerializers;
initMetadataForObject($serializer_442, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastClientUser, 'BeastClientUser', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_438});
initMetadataForCompanion(Companion_520);
protoOf($serializer_443).z1b = typeParametersSerializers;
initMetadataForObject($serializer_443, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ClientLinks, 'ClientLinks', ClientLinks, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_439});
initMetadataForCompanion(Companion_521);
protoOf($serializer_444).z1b = typeParametersSerializers;
initMetadataForObject($serializer_444, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(InfoSourceCursor, 'InfoSourceCursor', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_440});
initMetadataForCompanion(Companion_522);
protoOf($serializer_445).z1b = typeParametersSerializers;
initMetadataForObject($serializer_445, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameCode, 'GameCode', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_441});
initMetadataForInterface(ServerDrivenConfiguration, 'ServerDrivenConfiguration', VOID, VOID, VOID, [0, 1, 3, 2]);
initMetadataForClass(RevertResult, 'RevertResult');
initMetadataForClass(ConnectionStatus, 'ConnectionStatus');
initMetadataForCompanion(Companion_523);
protoOf($serializer_446).z1b = typeParametersSerializers;
initMetadataForObject($serializer_446, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ActiveGameSessions, 'ActiveGameSessions', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_442});
initMetadataForCompanion(Companion_524);
protoOf($serializer_447).z1b = typeParametersSerializers;
initMetadataForObject($serializer_447, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LobbyList, 'LobbyList', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_443});
initMetadataForCompanion(Companion_525);
protoOf($serializer_448).z1b = typeParametersSerializers;
initMetadataForObject($serializer_448, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_526);
protoOf($serializer_449).z1b = typeParametersSerializers;
initMetadataForObject($serializer_449, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(ResumeDuelGameResult, 'ResumeDuelGameResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_528});
initMetadataForClass(Resumed, 'Resumed', VOID, VOID, [ResumeDuelGameResult], VOID, VOID, {0: $serializer_getInstance_444});
initMetadataForClass(Terminal, 'Terminal', VOID, VOID, [ResumeDuelGameResult], VOID, VOID, {0: $serializer_getInstance_445});
initMetadataForObject(NotFound, 'NotFound', VOID, VOID, [ResumeDuelGameResult, SerializerFactory], VOID, VOID, {0: NotFound_getInstance});
initMetadataForObject(Forbidden, 'Forbidden', VOID, VOID, [ResumeDuelGameResult, SerializerFactory], VOID, VOID, {0: Forbidden_getInstance});
initMetadataForCompanion(Companion_527, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_528);
protoOf($serializer_450).z1b = typeParametersSerializers;
initMetadataForObject($serializer_450, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CompletedGame, 'CompletedGame', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_446});
initMetadataForCompanion(Companion_529);
protoOf($serializer_451).z1b = typeParametersSerializers;
initMetadataForObject($serializer_451, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RetainedResourceHandoff, 'RetainedResourceHandoff', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_447});
initMetadataForCompanion(Companion_530);
protoOf($serializer_452).z1b = typeParametersSerializers;
initMetadataForObject($serializer_452, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastResourceLookupRequest, 'BeastResourceLookupRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_448});
initMetadataForCompanion(Companion_531, VOID, [SerializerFactory]);
initMetadataForClass(ReplaySharingStatus, 'ReplaySharingStatus', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_532});
initMetadataForCompanion(Companion_532);
protoOf($serializer_453).z1b = typeParametersSerializers;
initMetadataForObject($serializer_453, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PendingReplayConsent, 'PendingReplayConsent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_449});
initMetadataForCompanion(Companion_533);
protoOf($serializer_454).z1b = typeParametersSerializers;
initMetadataForObject($serializer_454, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_534);
protoOf($serializer_455).z1b = typeParametersSerializers;
initMetadataForObject($serializer_455, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(ReconnectSandboxResult, 'ReconnectSandboxResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_536});
initMetadataForObject(PermissionError, 'PermissionError', VOID, VOID, [ReconnectSandboxResult, SerializerFactory], VOID, VOID, {0: PermissionError_getInstance});
initMetadataForObject(SandboxGameWasNotFound, 'SandboxGameWasNotFound', VOID, VOID, [ReconnectSandboxResult, SerializerFactory], VOID, VOID, {0: SandboxGameWasNotFound_getInstance});
initMetadataForObject(SandboxGameWasCanceled, 'SandboxGameWasCanceled', VOID, VOID, [ReconnectSandboxResult, SerializerFactory], VOID, VOID, {0: SandboxGameWasCanceled_getInstance});
initMetadataForClass(ReconnectSandboxInit, 'ReconnectSandboxInit', VOID, VOID, [ReconnectSandboxResult], VOID, VOID, {0: $serializer_getInstance_450});
initMetadataForClass(ReconnectSandboxPlaying, 'ReconnectSandboxPlaying', VOID, VOID, [ReconnectSandboxResult], VOID, VOID, {0: $serializer_getInstance_451});
initMetadataForCompanion(Companion_535, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_536);
protoOf($serializer_456).z1b = typeParametersSerializers;
initMetadataForObject($serializer_456, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_537);
protoOf($serializer_457).z1b = typeParametersSerializers;
initMetadataForObject($serializer_457, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_538);
protoOf($serializer_458).z1b = typeParametersSerializers;
initMetadataForObject($serializer_458, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Duel, 'Duel', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_452});
initMetadataForClass(Sandbox, 'Sandbox', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_453});
initMetadataForClass(Replay, 'Replay', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_454});
initMetadataForCompanion(Companion_539, VOID, [SerializerFactory]);
initMetadataForInterface(PingElement, 'PingElement', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_540});
initMetadataForCompanion(Companion_540);
protoOf($serializer_459).z1b = typeParametersSerializers;
initMetadataForObject($serializer_459, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GamePresence, 'GamePresence', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_455});
initMetadataForCompanion(Companion_541);
protoOf($serializer_460).z1b = typeParametersSerializers;
initMetadataForObject($serializer_460, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(RequestRevertTurnResult, 'RequestRevertTurnResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_543});
initMetadataForObject(Success_0, 'Success', VOID, VOID, [RequestRevertTurnResult, SerializerFactory], VOID, VOID, {0: Success_getInstance});
initMetadataForClass(InternalRevertError, 'InternalRevertError', VOID, VOID, [RequestRevertTurnResult], VOID, VOID, {0: $serializer_getInstance_456});
initMetadataForCompanion(Companion_542, VOID, [SerializerFactory]);
initMetadataForClass(WhatWillBeReapply, 'WhatWillBeReapply');
initMetadataForClass(QuestionDataToRestore, 'QuestionDataToRestore');
initMetadataForCompanion(Companion_543);
protoOf($serializer_461).z1b = typeParametersSerializers;
initMetadataForObject($serializer_461, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ActiveDuelSession, 'ActiveDuelSession', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_457});
initMetadataForCompanion(Companion_544);
protoOf($serializer_462).z1b = typeParametersSerializers;
initMetadataForObject($serializer_462, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LobbyInfo, 'LobbyInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_458});
initMetadataForCompanion(Companion_545, VOID, [SerializerFactory]);
initMetadataForInterface(SetupUpdateFromServer, 'SetupUpdateFromServer', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_546});
initMetadataForCompanion(Companion_546);
protoOf($serializer_463).z1b = typeParametersSerializers;
initMetadataForObject($serializer_463, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ClientSetup, 'ClientSetup', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_459});
initMetadataForClass(GameStatus, 'GameStatus');
initMetadataForInterface(PingingSupport, 'PingingSupport', VOID, VOID, VOID, [1]);
initMetadataForInterface(RevertSupportingAgent, 'RevertSupportingAgent', VOID, VOID, VOID, [1, 3]);
initMetadataForInterface(MasterFixingSupportingAgent, 'MasterFixingSupportingAgent', VOID, VOID, VOID, [1]);
initMetadataForCompanion(Companion_547, VOID, [SerializerFactory]);
initMetadataForClass(BeastResourceKind, 'BeastResourceKind', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_548});
initMetadataForCompanion(Companion_548);
protoOf($serializer_464).z1b = typeParametersSerializers;
initMetadataForObject($serializer_464, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PingBoardPositionElement, 'PingBoardPositionElement', VOID, VOID, [PingElement], VOID, VOID, {0: $serializer_getInstance_460});
initMetadataForCompanion(Companion_549);
protoOf($serializer_465).z1b = typeParametersSerializers;
initMetadataForObject($serializer_465, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PingLocationTypeElement, 'PingLocationTypeElement', VOID, VOID, [PingElement], VOID, VOID, {0: $serializer_getInstance_461});
initMetadataForCompanion(Companion_550);
protoOf($serializer_466).z1b = typeParametersSerializers;
initMetadataForObject($serializer_466, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PingPlayableCardElement, 'PingPlayableCardElement', VOID, VOID, [PingElement], VOID, VOID, {0: $serializer_getInstance_462});
initMetadataForCompanion(Companion_551);
protoOf($serializer_467).z1b = typeParametersSerializers;
initMetadataForObject($serializer_467, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameRoleClient, 'GameRoleClient', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_463});
initMetadataForCompanion(Companion_552);
protoOf($serializer_468).z1b = typeParametersSerializers;
initMetadataForObject($serializer_468, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameStarted, 'GameStarted', VOID, VOID, [SetupUpdateFromServer], VOID, VOID, {0: $serializer_getInstance_464});
initMetadataForObject(NotFoundSetupSession, 'NotFoundSetupSession', VOID, VOID, [SetupUpdateFromServer, SerializerFactory], VOID, VOID, {0: NotFoundSetupSession_getInstance});
initMetadataForCompanion(Companion_553);
protoOf($serializer_469).z1b = typeParametersSerializers;
initMetadataForObject($serializer_469, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SetupEnded, 'SetupEnded', VOID, VOID, [SetupUpdateFromServer], VOID, VOID, {0: $serializer_getInstance_465});
initMetadataForCompanion(Companion_554);
protoOf($serializer_470).z1b = typeParametersSerializers;
initMetadataForObject($serializer_470, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SetupUpdate, 'SetupUpdate', VOID, VOID, [SetupUpdateFromServer], VOID, VOID, {0: $serializer_getInstance_466});
initMetadataForCompanion(Companion_555, VOID, [SerializerFactory]);
initMetadataForClass(SetupTerminalStatus, 'SetupTerminalStatus', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_556});
initMetadataForCompanion(Companion_556);
protoOf($serializer_471).z1b = typeParametersSerializers;
initMetadataForObject($serializer_471, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ServerDuelSetupGameData, 'ServerDuelSetupGameData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_467});
initMetadataForCompanion(Companion_557);
protoOf($serializer_472).z1b = typeParametersSerializers;
initMetadataForObject($serializer_472, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LobbyClient, 'LobbyClient', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_468});
initMetadataForCompanion(Companion_558);
protoOf($serializer_473).z1b = typeParametersSerializers;
initMetadataForObject($serializer_473, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DebugOutputSessionConfiguration, 'DebugOutputSessionConfiguration', DebugOutputSessionConfiguration, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_469});
initMetadataForInterface(ServerDrivenConfigurationTransparentException, 'ServerDrivenConfigurationTransparentException');
initMetadataForClass(GameSessionReloadRequiredException, 'GameSessionReloadRequiredException', GameSessionReloadRequiredException.j6t, VOID, [ServerDrivenConfigurationTransparentException]);
protoOf(SimpleReplayFullClientAgent).s6q = pingElement;
protoOf(SimpleReplayFullClientAgent).t6q = approveRevert;
protoOf(SimpleReplayFullClientAgent).u6q = revertEvent;
protoOf(SimpleReplayFullClientAgent).v6q = approveMasterFixing;
protoOf(SimpleReplayFullClientAgent).w6q = useMasterFixingEvents;
initMetadataForClass(SimpleReplayFullClientAgent, 'SimpleReplayFullClientAgent', VOID, VOID, [MasterFixingSupportingAgent, RevertSupportingAgent, PingingSupport], [3, 1, 0]);
initMetadataForObject(GameIsNotFound, 'GameIsNotFound');
initMetadataForClass(GameIsEnded, 'GameIsEnded');
initMetadataForObject(IncompleteGame, 'IncompleteGame');
initMetadataForClass(ExceptionInReplaying, 'ExceptionInReplaying');
initMetadataForCompanion(Companion_559);
protoOf($serializer_474).z1b = typeParametersSerializers;
initMetadataForObject($serializer_474, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_560);
protoOf($serializer_475).z1b = typeParametersSerializers;
initMetadataForObject($serializer_475, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(ServerMessage, 'ServerMessage', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_562});
initMetadataForClass(Announcement, 'Announcement', VOID, VOID, [ServerMessage], VOID, VOID, {0: $serializer_getInstance_470});
initMetadataForClass(Maintenance, 'Maintenance', VOID, VOID, [ServerMessage], VOID, VOID, {0: $serializer_getInstance_471});
initMetadataForCompanion(Companion_561, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_562);
protoOf($serializer_476).z1b = typeParametersSerializers;
initMetadataForObject($serializer_476, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastUserSettingValues, 'BeastUserSettingValues', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_472});
initMetadataForCompanion(Companion_563);
protoOf($serializer_477).z1b = typeParametersSerializers;
initMetadataForObject($serializer_477, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastUserSettingsPatch, 'BeastUserSettingsPatch', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_473});
initMetadataForCompanion(Companion_564);
protoOf($serializer_478).z1b = typeParametersSerializers;
initMetadataForObject($serializer_478, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BeastUserSettingId, 'BeastUserSettingId', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_474});
initMetadataForClass(UserSetting, 'UserSetting');
initMetadataForObject(BeastUserSettings, 'BeastUserSettings');
initMetadataForClass(ReplayTimeline, 'ReplayTimeline');
initMetadataForClass(ReplayTimelineDay, 'ReplayTimelineDay');
initMetadataForClass(ReplayTimelineTurn, 'ReplayTimelineTurn');
initMetadataForClass(ReplayTimelineCharacter, 'ReplayTimelineCharacter');
initMetadataForClass(Dawn, 'Dawn');
initMetadataForClass(Turn, 'Turn');
initMetadataForClass(Night, 'Night');
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(SandboxGameManager, 'SandboxGameManager', VOID, VOID, VOID, [1, 4, 9, 3]);
initMetadataForCompanion(Companion_565);
protoOf($serializer_479).z1b = typeParametersSerializers;
initMetadataForObject($serializer_479, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(InitSandboxResult, 'InitSandboxResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_475});
initMetadataForCompanion(Companion_566);
protoOf($serializer_480).z1b = typeParametersSerializers;
initMetadataForObject($serializer_480, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_567);
protoOf($serializer_481).z1b = typeParametersSerializers;
initMetadataForObject($serializer_481, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_568);
protoOf($serializer_482).z1b = typeParametersSerializers;
initMetadataForObject($serializer_482, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(SandboxInitApplyEventResult, 'SandboxInitApplyEventResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_570});
initMetadataForObject(SandboxInitWasNotFound, 'SandboxInitWasNotFound', VOID, VOID, [SandboxInitApplyEventResult, SerializerFactory], VOID, VOID, {0: SandboxInitWasNotFound_getInstance});
initMetadataForClass(InternalServerError, 'InternalServerError', VOID, VOID, [SandboxInitApplyEventResult], VOID, VOID, {0: $serializer_getInstance_476});
initMetadataForClass(SandboxInitMissedSomeEvents, 'SandboxInitMissedSomeEvents', VOID, VOID, [SandboxInitApplyEventResult], VOID, VOID, {0: $serializer_getInstance_477});
initMetadataForObject(SandboxInitInvalidCheckCodes, 'SandboxInitInvalidCheckCodes', VOID, VOID, [SandboxInitApplyEventResult, SerializerFactory], VOID, VOID, {0: SandboxInitInvalidCheckCodes_getInstance});
initMetadataForClass(SandboxInitApplyEventSuccessResult, 'SandboxInitApplyEventSuccessResult', VOID, VOID, [SandboxInitApplyEventResult], VOID, VOID, {0: $serializer_getInstance_478});
initMetadataForCompanion(Companion_569, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_570);
protoOf($serializer_483).z1b = typeParametersSerializers;
initMetadataForObject($serializer_483, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SandboxStartParams, 'SandboxStartParams', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_479});
initMetadataForCompanion(Companion_571);
protoOf($serializer_484).z1b = typeParametersSerializers;
initMetadataForObject($serializer_484, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(StartSandboxResult, 'StartSandboxResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_573});
initMetadataForClass(SandboxGameStarted, 'SandboxGameStarted', VOID, VOID, [StartSandboxResult], VOID, VOID, {0: $serializer_getInstance_480});
initMetadataForObject(SandboxInitInvalidCheckCodes_0, 'SandboxInitInvalidCheckCodes', VOID, VOID, [StartSandboxResult, SerializerFactory], VOID, VOID, {0: SandboxInitInvalidCheckCodes_getInstance_0});
initMetadataForObject(SandboxInitWasNotFound_0, 'SandboxInitWasNotFound', VOID, VOID, [StartSandboxResult, SerializerFactory], VOID, VOID, {0: SandboxInitWasNotFound_getInstance_0});
initMetadataForCompanion(Companion_572, VOID, [SerializerFactory]);
initMetadataForClass(AnotherAnswerReaction, 'AnotherAnswerReaction');
initMetadataForInterface(AnimationInsertion, 'AnimationInsertion');
initMetadataForClass(MapUiScalingAndPosition, 'MapUiScalingAndPosition', VOID, VOID, [AnimationInsertion]);
initMetadataForObject(PursuitHunterSearchAndAttackAnswer, 'PursuitHunterSearchAndAttackAnswer', VOID, VOID, [SerializerFactory], VOID, VOID, {0: PursuitHunterSearchAndAttackAnswer_getInstance});
initMetadataForObject(PursuitHunterGainItemAndAttackSummon, 'PursuitHunterGainItemAndAttackSummon', VOID, VOID, [SerializerFactory], VOID, VOID, {0: PursuitHunterGainItemAndAttackSummon_getInstance});
initMetadataForClass(AnimationInsertionType, 'AnimationInsertionType');
initMetadataForClass(SimpleSavedAnswersSource, 'SimpleSavedAnswersSource', SimpleSavedAnswersSource, VOID, VOID, [3]);
initMetadataForClass(LogicalAnimationInsertion, 'LogicalAnimationInsertion', VOID, VOID, [AnimationInsertion]);
initMetadataForClass(ShowLocationAnimation, 'ShowLocationAnimation');
initMetadataForClass(ShowFromPossibleAnswer, 'ShowFromPossibleAnswer');
initMetadataForClass(ShowFromDraft, 'ShowFromDraft');
initMetadataForInterface(AdjustedSavedAnswer, 'AdjustedSavedAnswer');
initMetadataForClass(StartPhaseMarker, 'StartPhaseMarker');
initMetadataForClass(StartTurnReplayMarker, 'StartTurnReplayMarker');
initMetadataForClass(BeastGameI18n, 'BeastGameI18n', BeastGameI18n);
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(DefaultAnswer, 'DefaultAnswer');
initMetadataForClass(CollectionOperation, 'CollectionOperation');
initMetadataForClass(WaitingIsCanceledException, 'WaitingIsCanceledException', WaitingIsCanceledException.m71);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_71 = new Companion_71();
Companion_instance_72 = new Companion_72();
Companion_instance_74 = new Companion_74();
Companion_instance_79 = new Companion_79();
Companion_instance_80 = new Companion_80();
Companion_instance_81 = new Companion_81();
Companion_instance_82 = new Companion_82();
Companion_instance_84 = new Companion_84();
Companion_instance_85 = new Companion_85();
Companion_instance_86 = new Companion_86();
Companion_instance_87 = new Companion_87();
Companion_instance_91 = new Companion_91();
Companion_instance_92 = new Companion_92();
Companion_instance_95 = new Companion_95();
Companion_instance_96 = new Companion_96();
Companion_instance_97 = new Companion_97();
Companion_instance_111 = new Companion_111();
Companion_instance_112 = new Companion_112();
Companion_instance_115 = new Companion_115();
Companion_instance_116 = new Companion_116();
Companion_instance_128 = new Companion_128();
Companion_instance_129 = new Companion_129();
Companion_instance_130 = new Companion_130();
Companion_instance_132 = new Companion_132();
Companion_instance_133 = new Companion_133();
Companion_instance_134 = new Companion_134();
Companion_instance_136 = new Companion_136();
Companion_instance_138 = new Companion_138();
Companion_instance_140 = new Companion_140();
Companion_instance_145 = new Companion_145();
Companion_instance_146 = new Companion_146();
Companion_instance_147 = new Companion_147();
Companion_instance_148 = new Companion_148();
Companion_instance_151 = new Companion_151();
Companion_instance_152 = new Companion_152();
Companion_instance_153 = new Companion_153();
Companion_instance_154 = new Companion_154();
Companion_instance_156 = new Companion_156();
Companion_instance_158 = new Companion_158();
Companion_instance_159 = new Companion_159();
Companion_instance_171 = new Companion_171();
Companion_instance_174 = new Companion_174();
Companion_instance_175 = new Companion_175();
Companion_instance_176 = new Companion_176();
Companion_instance_178 = new Companion_178();
Companion_instance_193 = new Companion_193();
Companion_instance_197 = new Companion_197();
Companion_instance_199 = new Companion_199();
Companion_instance_200 = new Companion_200();
Companion_instance_201 = new Companion_201();
Companion_instance_202 = new Companion_202();
Companion_instance_203 = new Companion_203();
Companion_instance_204 = new Companion_204();
Companion_instance_207 = new Companion_207();
Companion_instance_208 = new Companion_208();
Companion_instance_213 = new Companion_213();
Companion_instance_214 = new Companion_214();
Companion_instance_220 = new Companion_220();
Companion_instance_221 = new Companion_221();
Companion_instance_222 = new Companion_222();
Companion_instance_224 = new Companion_224();
Companion_instance_225 = new Companion_225();
Companion_instance_226 = new Companion_226();
Companion_instance_234 = new Companion_234();
Companion_instance_235 = new Companion_235();
Companion_instance_239 = new Companion_239();
Companion_instance_243 = new Companion_243();
Companion_instance_250 = new Companion_250();
Companion_instance_256 = new Companion_256();
Companion_instance_265 = new Companion_265();
Companion_instance_267 = new Companion_267();
Companion_instance_268 = new Companion_268();
Companion_instance_270 = new Companion_270();
Companion_instance_277 = new Companion_277();
Companion_instance_292 = new Companion_292();
Companion_instance_295 = new Companion_295();
Companion_instance_296 = new Companion_296();
Companion_instance_300 = new Companion_300();
Companion_instance_302 = new Companion_302();
Companion_instance_306 = new Companion_306();
Companion_instance_313 = new Companion_313();
Companion_instance_315 = new Companion_315();
Companion_instance_316 = new Companion_316();
Companion_instance_319 = new Companion_319();
Companion_instance_320 = new Companion_320();
Companion_instance_325 = new Companion_325();
Companion_instance_327 = new Companion_327();
Companion_instance_347 = new Companion_347();
Companion_instance_348 = new Companion_348();
Companion_instance_353 = new Companion_353();
Companion_instance_356 = new Companion_356();
Companion_instance_357 = new Companion_357();
Companion_instance_358 = new Companion_358();
PrintingGameRuntimeDiagnostics_instance = new PrintingGameRuntimeDiagnostics();
Companion_instance_360 = new Companion_360();
Companion_instance_362 = new Companion_362();
Companion_instance_363 = new Companion_363();
Companion_instance_365 = new Companion_365();
Companion_instance_369 = new Companion_369();
Companion_instance_370 = new Companion_370();
Companion_instance_375 = new Companion_375();
Companion_instance_380 = new Companion_380();
Companion_instance_383 = new Companion_383();
Companion_instance_384 = new Companion_384();
Companion_instance_385 = new Companion_385();
Companion_instance_386 = new Companion_386();
Companion_instance_387 = new Companion_387();
Companion_instance_388 = new Companion_388();
Companion_instance_389 = new Companion_389();
Companion_instance_390 = new Companion_390();
Companion_instance_397 = new Companion_397();
Companion_instance_399 = new Companion_399();
Companion_instance_401 = new Companion_401();
Companion_instance_403 = new Companion_403();
Companion_instance_410 = new Companion_410();
Companion_instance_411 = new Companion_411();
Companion_instance_420 = new Companion_420();
Companion_instance_421 = new Companion_421();
Companion_instance_422 = new Companion_422();
Companion_instance_423 = new Companion_423();
Companion_instance_424 = new Companion_424();
Companion_instance_425 = new Companion_425();
Companion_instance_426 = new Companion_426();
Companion_instance_437 = new Companion_437();
Companion_instance_438 = new Companion_438();
Companion_instance_439 = new Companion_439();
Companion_instance_440 = new Companion_440();
Companion_instance_441 = new Companion_441();
Companion_instance_442 = new Companion_442();
Companion_instance_443 = new Companion_443();
Companion_instance_446 = new Companion_446();
Companion_instance_453 = new Companion_453();
Companion_instance_454 = new Companion_454();
Companion_instance_455 = new Companion_455();
Companion_instance_456 = new Companion_456();
Companion_instance_457 = new Companion_457();
Companion_instance_464 = new Companion_464();
Companion_instance_472 = new Companion_472();
Companion_instance_473 = new Companion_473();
Companion_instance_474 = new Companion_474();
Companion_instance_479 = new Companion_479();
Companion_instance_480 = new Companion_480();
Companion_instance_486 = new Companion_486();
Companion_instance_487 = new Companion_487();
Companion_instance_488 = new Companion_488();
Companion_instance_489 = new Companion_489();
Companion_instance_490 = new Companion_490();
Companion_instance_494 = new Companion_494();
Companion_instance_497 = new Companion_497();
Companion_instance_504 = new Companion_504();
Companion_instance_505 = new Companion_505();
Companion_instance_508 = new Companion_508();
Companion_instance_514 = new Companion_514();
Companion_instance_515 = new Companion_515();
Companion_instance_516 = new Companion_516();
Companion_instance_517 = new Companion_517();
Companion_instance_519 = new Companion_519();
Companion_instance_520 = new Companion_520();
Companion_instance_521 = new Companion_521();
Companion_instance_522 = new Companion_522();
Companion_instance_525 = new Companion_525();
Companion_instance_527 = new Companion_527();
Companion_instance_529 = new Companion_529();
Companion_instance_532 = new Companion_532();
Companion_instance_533 = new Companion_533();
Companion_instance_535 = new Companion_535();
Companion_instance_536 = new Companion_536();
Companion_instance_537 = new Companion_537();
Companion_instance_538 = new Companion_538();
Companion_instance_539 = new Companion_539();
Companion_instance_541 = new Companion_541();
Companion_instance_542 = new Companion_542();
Companion_instance_545 = new Companion_545();
Companion_instance_548 = new Companion_548();
Companion_instance_551 = new Companion_551();
Companion_instance_552 = new Companion_552();
Companion_instance_554 = new Companion_554();
Companion_instance_557 = new Companion_557();
Companion_instance_558 = new Companion_558();
GameIsNotFound_instance = new GameIsNotFound();
IncompleteGame_instance = new IncompleteGame();
Companion_instance_559 = new Companion_559();
Companion_instance_560 = new Companion_560();
Companion_instance_561 = new Companion_561();
Companion_instance_564 = new Companion_564();
Companion_instance_565 = new Companion_565();
Companion_instance_566 = new Companion_566();
Companion_instance_567 = new Companion_567();
Companion_instance_568 = new Companion_568();
Companion_instance_569 = new Companion_569();
Companion_instance_571 = new Companion_571();
Companion_instance_572 = new Companion_572();
//endregion
//region block: exports
export {
  _BoardPosition___init__impl__1nizgq_0 as _BoardPosition___init__impl__1nizgq3b7o6zwawcqwa,
  BoardPosition__hashCode_impl_9dgqf7 as BoardPosition__hashCode_impl_9dgqf728yia8xgzt4tw,
  BoardPosition__toString_impl_v4mn82 as BoardPosition__toString_impl_v4mn8218g3ra1bvw0ej,
  _BoardPosition___get_x__impl__gyx07 as _BoardPosition___get_x__impl__gyx07381tpzaynedb,
  _BoardPosition___get_y__impl__tale2e as _BoardPosition___get_y__impl__tale2e17vnr4e3jxfsy,
  _EntityId___get_id__impl__v6colh as _EntityId___get_id__impl__v6colhj2j6e8vmtk5h,
  _GameTeam___init__impl__xtwsj2 as _GameTeam___init__impl__xtwsj231o4obpkk4kig,
  GameTeam__hashCode_impl_gu24w3 as GameTeam__hashCode_impl_gu24w33k0olxizuckp1,
  _GameTeam___get_teamId__impl__chxeb3 as _GameTeam___get_teamId__impl__chxeb33hu9tlgllqitv,
  GameTeam__toString_impl_wfw0a6 as GameTeam__toString_impl_wfw0a61jglj7o24etxt,
  Companion_getInstance_563 as Companion_getInstancekrqf3naab3jt,
  BeastUserSettings_getInstance as BeastUserSettings_getInstance3ofip79i65tbl,
  Failure_getInstance as Failure_getInstancel0d9s04nwytw,
  $serializer_getInstance_439 as $serializer_getInstance27hkret7vzdua,
  $serializer_getInstance_441 as $serializer_getInstance2yzdywy4f5ghd,
  $serializer_getInstance_440 as $serializer_getInstancen2q4l5h5oro1,
  Companion_instance_539 as Companion_instance34mqqcp3svcuw,
  GameIsNotFound_instance as GameIsNotFound_instance3st242a02waaj,
  IncompleteGame_instance as IncompleteGame_instance3c80wqcf225mu,
  Forbidden_getInstance as Forbidden_getInstance2861raorwliaj,
  NotFound_getInstance as NotFound_getInstance3eu74dij8p98e,
  AbruptAssembleUpgrade_getInstance as AbruptAssembleUpgrade_getInstance346t11xzy1dmx,
  AbundanceUpgrade_getInstance as AbundanceUpgrade_getInstance6m2cw5bz5g84,
  AbyssalBeastUpgrade_getInstance as AbyssalBeastUpgrade_getInstance1hc669c99ktee,
  AbyssalHellFireUpgrade_getInstance as AbyssalHellFireUpgrade_getInstance8jks2ef35bbr,
  AccursedWrathUpgrade_getInstance as AccursedWrathUpgrade_getInstance2lvzjm7qtjsw2,
  AmassUpgrade_getInstance as AmassUpgrade_getInstance1lglbend3dcs6,
  AncientBondUpgrade_getInstance as AncientBondUpgrade_getInstance1tiy9x1gwqxok,
  AncientCallingUpgrade_getInstance as AncientCallingUpgrade_getInstance1pft1zar3r8ic,
  $serializer_getInstance_152 as $serializer_getInstance2uw2ug8urikwh,
  AngerUpgrade_getInstance as AngerUpgrade_getInstance22p20ppoeheqs,
  ArsenalCardToGainQuestionContext_getInstance as ArsenalCardToGainQuestionContext_getInstance1cinbinh20wv6,
  Assar_getInstance as Assar_getInstancen2izszy6zzwz,
  AurorasPassage_getInstance as AurorasPassage_getInstance1iv95si3960n4,
  AwarenessUpgrade_getInstance as AwarenessUpgrade_getInstance23934seg03j50,
  BallistaUpgrade_getInstance as BallistaUpgrade_getInstance24ltlqkot0a91,
  $serializer_getInstance_110 as $serializer_getInstance1qqoh32x8kl1a,
  BearType_getInstance as BearType_getInstancejcggwf9elj4y,
  Companion_getInstance_217 as Companion_getInstance18elh27sqar33,
  $serializer_getInstance_153 as $serializer_getInstance2e2wi0y1bwmvv,
  BeastTongueUpgrade_getInstance as BeastTongueUpgrade_getInstance1rqvs5xut64kw,
  BeastlyTongueCard_getInstance as BeastlyTongueCard_getInstancet114a32976bo,
  BehornedUpgrade_getInstance as BehornedUpgrade_getInstance17amq8wb5hhnr,
  BeyondTheVeilUpgrade_getInstance as BeyondTheVeilUpgrade_getInstance3aisklc7asizr,
  BlackStarUpgrade_getInstance as BlackStarUpgrade_getInstancegzz3l653uy8o,
  BladeOfValhCard_getInstance as BladeOfValhCard_getInstance31t71anst074h,
  BlightUpgrade_getInstance as BlightUpgrade_getInstance11xwyn7uiptsy,
  BloodCraftUpgrade_getInstance as BloodCraftUpgrade_getInstance3tzjdxj354k14,
  BloodLustUpgrade_getInstance as BloodLustUpgrade_getInstance3gf04019jszwl,
  BloodlessFuryUpgrade_getInstance as BloodlessFuryUpgrade_getInstance2gp9hzz9ba9tf,
  BoarType_getInstance as BoarType_getInstancelj86bx70vwz2,
  BoatType_getInstance as BoatType_getInstance22oq9xcnlzgdx,
  Bolgin_getInstance as Bolgin_getInstance18yrqria3do4a,
  BolsterCard_getInstance as BolsterCard_getInstance2ki3w8dsghywt,
  Bram_getInstance as Bram_getInstancelahd0revfkbw,
  BroodswellUpgrade_getInstance as BroodswellUpgrade_getInstance4gxshv59qnrq,
  BurnUpgrade_getInstance as BurnUpgrade_getInstanceeyg7cccsefm8,
  CardPlayColorQuestion_getInstance as CardPlayColorQuestion_getInstance3ach19sphyo7c,
  CascadeUpgrade_getInstance as CascadeUpgrade_getInstance1rnasrmbf09r6,
  ChargeCard_getInstance as ChargeCard_getInstance32yjm1dm8ag1w,
  ChiefsCommandUpgrade_getInstance as ChiefsCommandUpgrade_getInstance2dxya4qj8ztm6,
  $serializer_getInstance_155 as $serializer_getInstance27d2dyrgjs6va,
  $serializer_getInstance_156 as $serializer_getInstance4kawrh7s0kng,
  $serializer_getInstance_157 as $serializer_getInstance1r78mhw99hua4,
  ClairvoyantUpgrade_getInstance as ClairvoyantUpgrade_getInstance13bjoijg14bu4,
  CloudShiftUpgrade_getInstance as CloudShiftUpgrade_getInstance2chygpwnezhfk,
  ComingArsenalPlace_getInstance as ComingArsenalPlace_getInstance2vl9crpg7k01w,
  CommandCard_getInstance as CommandCard_getInstance2g5w6pf0p5woa,
  ContinueAfterRecoveryQuestion_getInstance as ContinueAfterRecoveryQuestion_getInstance298fsbtle0scw,
  ControllingByNothing_getInstance as ControllingByNothing_getInstance2c4rzcwq95354,
  CrepuscularUpgrade_getInstance as CrepuscularUpgrade_getInstanceiffjqyc4w26t,
  CullingUpgrade_getInstance as CullingUpgrade_getInstance3i70g5l3yzfng,
  CursedLandUpgrade_getInstance as CursedLandUpgrade_getInstance15uz1ipykxatz,
  DarkFlameUpgrade_getInstance as DarkFlameUpgrade_getInstance1wzvod0iesvsv,
  DarkSpawnUpgrade_getInstance as DarkSpawnUpgrade_getInstance38lcsze0o5g0p,
  DeathsLamentUpgrade_getInstance as DeathsLamentUpgrade_getInstance2mjyldliozs6b,
  DefenderUpgrade_getInstance as DefenderUpgrade_getInstance10u5q98lbpze4,
  $serializer_getInstance_158 as $serializer_getInstance3ptg9vd9z065e,
  DevourerUpgrade_getInstance as DevourerUpgrade_getInstance11qreoglxcrn3,
  Companion_getInstance_114 as Companion_getInstance1fknlx0kyfzca,
  DisappearCard_getInstance as DisappearCard_getInstance1nwpvazmbkdv3,
  DischargeUpgrade_getInstance as DischargeUpgrade_getInstancej0tjvxw7ax3l,
  DissectionUpgrade_getInstance as DissectionUpgrade_getInstanceskly95zkyv7f,
  DistractionUpgrade_getInstance as DistractionUpgrade_getInstancesyc50p6dvf27,
  DoomCallUpgrade_getInstance as DoomCallUpgrade_getInstance1q8dbolddlnv9,
  DoubleUpgrade_getInstance as DoubleUpgrade_getInstance31zs7lhuj156b,
  DraconicBondsUpgrade_getInstance as DraconicBondsUpgrade_getInstanceo21ffcw9m5qr,
  Draug_getInstance as Draug_getInstance2hvbdj9fayw5u,
  DrownerUpgrade_getInstance as DrownerUpgrade_getInstance11l9zsho0vyqx,
  EchoUpgrade_getInstance as EchoUpgrade_getInstancefvvlof0n29pi,
  EcholocationUpgrade_getInstance as EcholocationUpgrade_getInstance2fhsds0a65bfw,
  EggType_getInstance as EggType_getInstance1xq9fa9c5vb0a,
  Eivind_getInstance as Eivind_getInstance2himpstzhncmh,
  EndlessDreamUpgrade_getInstance as EndlessDreamUpgrade_getInstance16kc49nmr6qw8,
  EndlessStruggleUpgrade_getInstance as EndlessStruggleUpgrade_getInstance3e5mbp8e0ck9d,
  EngorgeCard_getInstance as EngorgeCard_getInstance13d2ezow3zuya,
  EnragedUpgrade_getInstance as EnragedUpgrade_getInstance18e2yxqwr5rop,
  EnsnareCard_getInstance as EnsnareCard_getInstance37eqqzyvf3yl7,
  EntrancingUpgrade_getInstance as EntrancingUpgrade_getInstance1fg34bq2ch6cd,
  EruptionUpgrade_getInstance as EruptionUpgrade_getInstance263d2jis24mnw,
  EsmeriaHuntress_getInstance as EsmeriaHuntress_getInstancevxtyudowtt7n,
  EternityUpgrade_getInstance as EternityUpgrade_getInstance3b3forivta0sz,
  ExceptionalTrackerUpgrade_getInstance as ExceptionalTrackerUpgrade_getInstance22s1fq3jj09f9,
  ExpandTheMarshUpgrade_getInstance as ExpandTheMarshUpgrade_getInstance30knaujkdik0a,
  ExploreUpgrade_getInstance as ExploreUpgrade_getInstance2qmfu3qhretkg,
  ExtractUpgrade_getInstance as ExtractUpgrade_getInstance1xvp9dnzuxq36,
  Fara_getInstance as Fara_getInstancemdwtm6nnavzs,
  FarmerType_getInstance as FarmerType_getInstance14w50gs5cbmwd,
  FatalGazeUpgrade_getInstance as FatalGazeUpgrade_getInstance239xcg7obmdzt,
  FearTheNightUpgrade_getInstance as FearTheNightUpgrade_getInstance35v6gkg0dcuw8,
  FeatheredKing_getInstance as FeatheredKing_getInstancebsqevwcd17w0,
  FleshboundUpgrade_getInstance as FleshboundUpgrade_getInstance3l3n0qpgseoq6,
  FlingUpgrade_getInstance as FlingUpgrade_getInstance3h5hbx7jkdmoj,
  Companion_getInstance_220 as Companion_getInstance382hvo2hsz7qp,
  $serializer_getInstance_115 as $serializer_getInstanceat3nlk9a5n53,
  Companion_instance_256 as Companion_instance2xr03m2pafwy5,
  $serializer_getInstance_116 as $serializer_getInstancebm5ryeteqqrs,
  Companion_instance_295 as Companion_instance1bgxo4spj7zq8,
  $serializer_getInstance_183 as $serializer_getInstance20667iq8deuyb,
  GoldenBeakUpgrade_getInstance as GoldenBeakUpgrade_getInstanceep4gkqslzxck,
  $serializer_getInstance_159 as $serializer_getInstance134ob40ugu6yu,
  GreatHowlUpgrade_getInstance as GreatHowlUpgrade_getInstancegrbczsyeuir2,
  Grimgeir_getInstance as Grimgeir_getInstance2zodqxltkel1u,
  Helga_getInstance as Helga_getInstance3a4t2szsrwroo,
  HeroicSpeechUpgrade_getInstance as HeroicSpeechUpgrade_getInstancemgl1ytakjrzy,
  HordesMarchUpgrade_getInstance as HordesMarchUpgrade_getInstance26pw31qnofh8z,
  HornOfValhUpgrade_getInstance as HornOfValhUpgrade_getInstance3k2wwgy47v1fv,
  HuntersBaneUpgrade_getInstance as HuntersBaneUpgrade_getInstance25acd9c1yf2v,
  HuntingGroundsUpgrade_getInstance as HuntingGroundsUpgrade_getInstancehzfigy26gb14,
  HuntmasterUpgrade_getInstance as HuntmasterUpgrade_getInstancet08p1j8e8f15,
  IgniteUpgrade_getInstance as IgniteUpgrade_getInstance3ey0ws2n6t4j8,
  InPlayPlace_getInstance as InPlayPlace_getInstance2f5lcwhn2zg3y,
  IncinerateCard_getInstance as IncinerateCard_getInstance4d2fr3l5xny9,
  InciteCard_getInstance as InciteCard_getInstance1kcstun54fx9h,
  InfernalTusksUpgrade_getInstance as InfernalTusksUpgrade_getInstanceu0eoxm7jk7ly,
  InfestUrgullUpgrade_getInstance as InfestUrgullUpgrade_getInstance2ehxdvj17jw53,
  InfestationUpgrade_getInstance as InfestationUpgrade_getInstance3blcpcc0mlcbx,
  InfusionUpgrade_getInstance as InfusionUpgrade_getInstance3ka2tewp3jh69,
  Iona_getInstance as Iona_getInstance1jzicrvxoqh2j,
  JointEffortUpgrade_getInstance as JointEffortUpgrade_getInstance1qijcrl3s7f9m,
  KillingsSpreeUpgrade_getInstance as KillingsSpreeUpgrade_getInstance3um30ypdt52vx,
  KinsPursuitUpgrade_getInstance as KinsPursuitUpgrade_getInstance1rfbufk683z9w,
  Krim_getInstance as Krim_getInstance2389fdoqv8bcc,
  LairUpgrade_getInstance as LairUpgrade_getInstance22y5eznv50mci,
  LeapCard_getInstance as LeapCard_getInstanceznp92u5id8gd,
  LeviathanUpgrade_getInstance as LeviathanUpgrade_getInstanceytiw8l7ftv0s,
  LivingBlockadeUpgrade_getInstance as LivingBlockadeUpgrade_getInstancel1sxlgyni4em,
  $serializer_getInstance_160 as $serializer_getInstance15c1csd00l6s7,
  $serializer_getInstance_164 as $serializer_getInstancex8xdvn48hb2e,
  LowerShatteredRuins_getInstance as LowerShatteredRuins_getInstance1en5yqro19pzh,
  LurkingDeadUpgrade_getInstance as LurkingDeadUpgrade_getInstance1yt05hff6zhux,
  Lydan_getInstance as Lydan_getInstancef2ktq2h74zdo,
  MartyrUpgrade_getInstance as MartyrUpgrade_getInstance18fj834136pqm,
  MassProductionUpgrade_getInstance as MassProductionUpgrade_getInstance13wd8w11wgndw,
  MendrsFuryUpgrade_getInstance as MendrsFuryUpgrade_getInstance1somg3owwtysw,
  MesmeriseUpgrade_getInstance as MesmeriseUpgrade_getInstance2e9pao5yuxi3p,
  MirrorBeastUpgrade_getInstance as MirrorBeastUpgrade_getInstance1shruqdzgscbq,
  MistShroudCard_getInstance as MistShroudCard_getInstance3uv8n1crygurh,
  NaturalInstinctUpgrade_getInstance as NaturalInstinctUpgrade_getInstance2jhnvjsm07evu,
  NightPhase_getInstance as NightPhase_getInstance7ju3w96rz5,
  NightbindUpgrade_getInstance as NightbindUpgrade_getInstancega6p3vx44b2p,
  NoMovement_getInstance as NoMovement_getInstance1w2sjefrvmlkb,
  NobleType_getInstance as NobleType_getInstance1r6cwnd2g0702,
  NonePhase_getInstance as NonePhase_getInstance4bkyqrl7u9r4,
  Nora_getInstance as Nora_getInstanceld7hf8eu3opr,
  Omma_getInstance as Omma_getInstance2wma8u9a3daxi,
  OverlordUpgrade_getInstance as OverlordUpgrade_getInstance2yp8i65eq3nzj,
  PactReversalUpgrade_getInstance as PactReversalUpgrade_getInstancemaho3m9br6gn,
  PalebloodAxesUpgrade_getInstance as PalebloodAxesUpgrade_getInstance2yzo8bk78f9fm,
  PandemoniumUpgrade_getInstance as PandemoniumUpgrade_getInstance352dekrjnj6tj,
  PassVariant_getInstance as PassVariant_getInstance2kz950waz5v92,
  PendingTriggerPlace_getInstance as PendingTriggerPlace_getInstance651wnzyb3dh1,
  $serializer_getInstance_165 as $serializer_getInstancegh1c2gqi2r2a,
  PlaceHatchlingWithInfestQuestion_getInstance as PlaceHatchlingWithInfestQuestion_getInstance31ahka7m2vhps,
  $serializer_getInstance_161 as $serializer_getInstance3t0frlt0da3mw,
  $serializer_getInstance_166 as $serializer_getInstanceiqyd242eb9og,
  PlayOverloadedQuestion_getInstance as PlayOverloadedQuestion_getInstance1ujm5rvbvzag1,
  PortableWorkshopUpgrade_getInstance as PortableWorkshopUpgrade_getInstance3gt4n41q3pgeu,
  PreGamePhase_getInstance as PreGamePhase_getInstance32azpmvb01l0c,
  PredictUpgrade_getInstance as PredictUpgrade_getInstance34n1fame3n18m,
  PrimalInstinctsUpgrade_getInstance as PrimalInstinctsUpgrade_getInstance3jei4xwog5utn,
  PrintingGameRuntimeDiagnostics_instance as PrintingGameRuntimeDiagnostics_instanceknsic9pmcauw,
  ProminenceUpgrade_getInstance as ProminenceUpgrade_getInstance3vrfjxjwgpgdr,
  PursuitCard_getInstance as PursuitCard_getInstance3i4l9ond3aid0,
  RampageousUpgrade_getInstance as RampageousUpgrade_getInstance20qler45ed3tk,
  ReachUpgrade_getInstance as ReachUpgrade_getInstance2iocunj0ye5a9,
  RebirthByFireUpgrade_getInstance as RebirthByFireUpgrade_getInstance25hff0ava4wos,
  RefugeUpgrade_getInstance as RefugeUpgrade_getInstance1z3rfn400uwmj,
  RegalUpgrade_getInstance as RegalUpgrade_getInstanceyf181ww6r8q9,
  ResonanceUpgrade_getInstance as ResonanceUpgrade_getInstance39fv8swhbsu2f,
  ResourcefulnessUpgrade_getInstance as ResourcefulnessUpgrade_getInstance1jjl13y9wyedu,
  RestoreArsenalEvent_getInstance as RestoreArsenalEvent_getInstance1ivhs49gu01tz,
  ResurrectionUpgrade_getInstance as ResurrectionUpgrade_getInstancejhbmez0sdr8w,
  ReuniteUpgrade_getInstance as ReuniteUpgrade_getInstance29ix03is7iio6,
  RevealToMoveQuestion_getInstance as RevealToMoveQuestion_getInstance1nmmcl3l356x0,
  RevealedArsenalPlace_getInstance as RevealedArsenalPlace_getInstance3ex2xtf4e2o0l,
  RevengeOfTheSheepUpgrade_getInstance as RevengeOfTheSheepUpgrade_getInstance3iwfw82506tq,
  ReveranceUpgrade_getInstance as ReveranceUpgrade_getInstancesnpfe741c1op,
  RiseCard_getInstance as RiseCard_getInstance2wn892vq76rnr,
  RopePullUpgrade_getInstance as RopePullUpgrade_getInstance11um93z7jm6eq,
  RuptureSeedsUpgrade_getInstance as RuptureSeedsUpgrade_getInstance1nt6wi2ttwmgr,
  SandboxDamage_getInstance as SandboxDamage_getInstance3gn8f2i76f5yx,
  ScavengerUpgrade_getInstance as ScavengerUpgrade_getInstance3qjd3kscx0hmk,
  ScorchedEarthCard_getInstance as ScorchedEarthCard_getInstance90pb98bi1u1i,
  $serializer_getInstance_162 as $serializer_getInstance10kthw6ptdhfl,
  SeekerUpgrade_getInstance as SeekerUpgrade_getInstanceuydsse60349w,
  SeerCard_getInstance as SeerCard_getInstance7zjuuadxukfm,
  SharedMadnessUpgrade_getInstance as SharedMadnessUpgrade_getInstanceseip4v95lpx7,
  SheepType_getInstance as SheepType_getInstanceosw2mgv1ahze,
  Sigrid_getInstance as Sigrid_getInstance2l23mbv8bteb8,
  SilverArrowCard_getInstance as SilverArrowCard_getInstance2ujdtlcaf3usa,
  SinisterActUpgrade_getInstance as SinisterActUpgrade_getInstancedt5qprytadpo,
  SkyMasterUpgrade_getInstance as SkyMasterUpgrade_getInstanceyootg4ww9dyo,
  SnareTokenType_getInstance as SnareTokenType_getInstance257hn24f6c5bh,
  $serializer_getInstance_362 as $serializer_getInstance2aa7iz284rpp8,
  SongOfTemptationUpgrade_getInstance as SongOfTemptationUpgrade_getInstancezc5lwjxetfhp,
  SoothsayerUpgrade_getInstance as SoothsayerUpgrade_getInstance1xdqvxe7i19en,
  SoulCollectorUpgrade_getInstance as SoulCollectorUpgrade_getInstance1r4fldxurtugc,
  SoulHarvestUpgrade_getInstance as SoulHarvestUpgrade_getInstance1l4rsbsawdx1q,
  SoulHarvestVackerUpgrade_getInstance as SoulHarvestVackerUpgrade_getInstance38wps62shyf9,
  $serializer_getInstance_345 as $serializer_getInstancemd15awmf326k,
  $serializer_getInstance_428 as $serializer_getInstance3imr24z4qrf8t,
  SpiritboundUpgrade_getInstance as SpiritboundUpgrade_getInstance2grx91on64vgm,
  StarFallUpgrade_getInstance as StarFallUpgrade_getInstance3aqpg9j0iuxiv,
  StartOfDayPhase_getInstance as StartOfDayPhase_getInstance2cvqhztbl5ndi,
  $serializer_getInstance_167 as $serializer_getInstance14511g6nwgqjc,
  StormBringerUpgrade_getInstance as StormBringerUpgrade_getInstance3pokdtb8vvwpn,
  SuddenShockUpgrade_getInstance as SuddenShockUpgrade_getInstance1uw03c9hgdvlz,
  SummonLindwyrmCard_getInstance as SummonLindwyrmCard_getInstance3f2omsnl4r3hm,
  SummonPolypCard_getInstance as SummonPolypCard_getInstance1h86vkh8ulqlg,
  SwapUpgrade_getInstance as SwapUpgrade_getInstancenkv4gi8jncbk,
  SwiftKillUpgrade_getInstance as SwiftKillUpgrade_getInstance1xv48hy8o2ds1,
  TacticalInsightUpgrade_getInstance as TacticalInsightUpgrade_getInstance2sx4rrtn01sgs,
  TacticalManouverUpgrade_getInstance as TacticalManouverUpgrade_getInstance2h1m3vqxiaefk,
  ThickMistUpgrade_getInstance as ThickMistUpgrade_getInstance33c1kp4v8ooza,
  TormentingVisionsUpgrade_getInstance as TormentingVisionsUpgrade_getInstance7oijh7crpv2r,
  TorrentialUpgrade_getInstance as TorrentialUpgrade_getInstance1lhvskg9n62q2,
  TownswatchUpgrade_getInstance as TownswatchUpgrade_getInstance2rlzdrpzz39x6,
  $serializer_getInstance_163 as $serializer_getInstance2g7zr0qtvsn40,
  $serializer_getInstance_168 as $serializer_getInstance1g2qm0aggk6hs,
  TrapLauncherUpgrade_getInstance as TrapLauncherUpgrade_getInstancefwfmzpith2h8,
  $serializer_getInstance_169 as $serializer_getInstance3ugjj0khs6blm,
  TrueInstinctEsmeriaBeastUpgrade_getInstance as TrueInstinctEsmeriaBeastUpgrade_getInstance371p291rupbvu,
  TrueInstinctEsmeriaHuntressUpgrade_getInstance as TrueInstinctEsmeriaHuntressUpgrade_getInstance24eagk0u16y9i,
  UnendingHungerUpgrade_getInstance as UnendingHungerUpgrade_getInstance1epf05k4acriw,
  $serializer_getInstance_170 as $serializer_getInstanceby005w4fcfuh,
  UpperShatteredRuins_getInstance as UpperShatteredRuins_getInstancee0zhx2t8d1a5,
  $serializer_getInstance_413 as $serializer_getInstance3li35c2x8pes6,
  UrgullMoltEggsToReturnQuestionContext_getInstance as UrgullMoltEggsToReturnQuestionContext_getInstance3pclzjxi4gieg,
  Urgull_getInstance as Urgull_getInstance3a76hoxqtzui9,
  $serializer_getInstance_154 as $serializer_getInstancey79lt5yftlqd,
  Vacker_getInstance as Vacker_getInstance34go2d0btpfmm,
  Valdi_getInstance as Valdi_getInstance2kbkzzgcn4q7n,
  VanishUpgrade_getInstance as VanishUpgrade_getInstance1rd8tilpn88ax,
  Varja_getInstance as Varja_getInstanceczhyz7rvxazb,
  VoidCallUpgrade_getInstance as VoidCallUpgrade_getInstance3py8q7h5c5cmy,
  VoidPresenceUpgrade_getInstance as VoidPresenceUpgrade_getInstance3bvs07jkr4kvw,
  VoidStepUpgrade_getInstance as VoidStepUpgrade_getInstance1sc7gm2am3nty,
  WatchtowerPassageUpgrade_getInstance as WatchtowerPassageUpgrade_getInstance2d416h3uamtnl,
  WatchtowerType_getInstance as WatchtowerType_getInstance21xrgbyvptnnt,
  WildOdeUpgrade_getInstance as WildOdeUpgrade_getInstance3u97dbufeuewd,
  WildbondUpgrade_getInstance as WildbondUpgrade_getInstance2wydodpfmm9bj,
  WitheringMawUpgrade_getInstance as WitheringMawUpgrade_getInstance3mcgrufbw5wa3,
  WorshipUpgrade_getInstance as WorshipUpgrade_getInstance2f9n6yzjwu3bc,
  WrathOfEirtirUpgrade_getInstance as WrathOfEirtirUpgrade_getInstance1ukz51msowrjl,
  $serializer_getInstance_171 as $serializer_getInstancew57cfjnndkci,
  BeastClientFeature_NetworkPlay_getInstance as BeastClientFeature_NetworkPlay_getInstance1zx8ribqem7ec,
  BeastClientFeature_Sandbox_getInstance as BeastClientFeature_Sandbox_getInstance2c28w3ydqvi6k,
  BeastResourceKind_Game_getInstance as BeastResourceKind_Game_getInstance2dv9wvjfknbes,
  BeastResourceKind_Replay_getInstance as BeastResourceKind_Replay_getInstance2zdoghkni2ipv,
  ConnectionStatus_Connected_getInstance as ConnectionStatus_Connected_getInstanceirwnp475015r,
  ConnectionStatus_Disconnected_getInstance as ConnectionStatus_Disconnected_getInstance3iw8gizz4cthw,
  GameStatus_Active_getInstance as GameStatus_Active_getInstance3chctqjxg3jks,
  GameStatus_Canceled_getInstance as GameStatus_Canceled_getInstancea7e586cxedya,
  ReplaySharingStatus_Shared_getInstance as ReplaySharingStatus_Shared_getInstance1hble5m08dwr0,
  WhatWillBeReapply_GameNotification_getInstance as WhatWillBeReapply_GameNotification_getInstancegdd46s353szd,
  WhatWillBeReapply_GameQuestion_getInstance as WhatWillBeReapply_GameQuestion_getInstance3bzstdqe7zbi6,
  WhatWillBeReapply_InitialStateNotification_getInstance as WhatWillBeReapply_InitialStateNotification_getInstance3h7h3bfq48y51,
  WhatWillBeReapply_NoStateBefore_getInstance as WhatWillBeReapply_NoStateBefore_getInstance3uvn2i68us7s9,
  AnimationInsertionType_AfterAnswer_getInstance as AnimationInsertionType_AfterAnswer_getInstance34al2mxixyzul,
  AnimationInsertionType_BeforeAnswerDialog_getInstance as AnimationInsertionType_BeforeAnswerDialog_getInstance2hlw194dds2yn,
  AnimationInsertionType_JustBeforeAnswer_getInstance as AnimationInsertionType_JustBeforeAnswer_getInstancestoighh2durw,
  AnotherAnswerReaction_AllowOtherAnswers_getInstance as AnotherAnswerReaction_AllowOtherAnswers_getInstance1axe0kb0br3tx,
  AnotherAnswerReaction_ForbidOtherVariants_getInstance as AnotherAnswerReaction_ForbidOtherVariants_getInstancevc6cy4m8d97y,
  AnotherAnswerReaction_ReshowVariants_getInstance as AnotherAnswerReaction_ReshowVariants_getInstance2p4pnhj458ex,
  BeastBalanceVersion_OfficialV2_getInstance as BeastBalanceVersion_OfficialV2_getInstance17dyxpa9u5sup,
  BeastGameExpansions_Ashfall_getInstance as BeastGameExpansions_Ashfall_getInstance1yhnjjgaypnsy,
  BeastGameExpansions_ShatteredIsles_getInstance as BeastGameExpansions_ShatteredIsles_getInstance33verx6u4dl6s,
  BeastGameExpansions_TheGreatHunt_getInstance as BeastGameExpansions_TheGreatHunt_getInstance1uqkzoanwkf2v,
  DamageKind_Other_getInstance as DamageKind_Other_getInstance3uj3szrtilc3n,
  GameMapId_DrenchedLands_getInstance as GameMapId_DrenchedLands_getInstance3jqbk3r1gau8o,
  GameMapId_LowerShatteredIsles_getInstance as GameMapId_LowerShatteredIsles_getInstance3se76dqva57oi,
  GameMapId_NorthernExpanse_getInstance as GameMapId_NorthernExpanse_getInstanceja56uoofw23u,
  GameMapId_UpperShatteredIsles_getInstance as GameMapId_UpperShatteredIsles_getInstance3hab63460kmdv,
  LocationType_AbyssalForest_getInstance as LocationType_AbyssalForest_getInstance1ja42pe8bgojv,
  LocationType_AbyssalSwamp_getInstance as LocationType_AbyssalSwamp_getInstance17y2qx5p1qvct,
  LocationType_Cave_getInstance as LocationType_Cave_getInstance5qwid1edsoph,
  LocationType_Forest_getInstance as LocationType_Forest_getInstance1oasfju4nlnmj,
  LocationType_LivingWeb_getInstance as LocationType_LivingWeb_getInstancebbhunpk3v3ia,
  LocationType_Settlement_getInstance as LocationType_Settlement_getInstance2car1ynp5y6zn,
  LocationType_Swamp_getInstance as LocationType_Swamp_getInstance5r63dmfn758b,
  MovementType_AbyssalSwampRelocation_getInstance as MovementType_AbyssalSwampRelocation_getInstancews51g4r3b0b2,
  MovementType_SimpleMovement_getInstance as MovementType_SimpleMovement_getInstance1uz87gun0unmu,
  TwoPlayerDraftStage_Collecting_getInstance as TwoPlayerDraftStage_Collecting_getInstance7f6a3c5zapf0,
  Zone_Achur_getInstance as Zone_Achur_getInstance1b1y9e0oznx0u,
  Zone_Barum_getInstance as Zone_Barum_getInstance1a6gvpi0jgre1,
  Zone_Elysur_getInstance as Zone_Elysur_getInstance11z7eujtmcigp,
  Zone_Jarlland_getInstance as Zone_Jarlland_getInstance5fa3bdvcmi69,
  Zone_Myrna_getInstance as Zone_Myrna_getInstance3fi0m84elinzb,
  Zone_NewElda_getInstance as Zone_NewElda_getInstance2qydukshuw1zj,
  Zone_Thealis_getInstance as Zone_Thealis_getInstance1iiz35256er8h,
  Zone_Vildmark_getInstance as Zone_Vildmark_getInstance1gdneryyqfus0,
  applyGameStateChanges as applyGameStateChanges2qkrglekht180,
  applyGameStateRevertChanges_0 as applyGameStateRevertChanges3ubrnoso5bc81,
  applyGameStateRevertChanges as applyGameStateRevertChanges2cqxaiql63aht,
  reportRevisionProblem as reportRevisionProblemx3ecmwf56p42,
  approveMasterFixing as approveMasterFixing3bcyvp6ou6qqf,
  checkReplayFromServer as checkReplayFromServer25mn7g2penfi9,
  boundAwait as boundAwait1gsd6dbqqqgm5,
  installAnswer as installAnswer1autkomcz1d8r,
  waitWithPossibilityToCancel as waitWithPossibilityToCancel3i4azlg87zlwy,
  processClient$default as processClient$default2gs0pei275yae,
  reconnectGame$default as reconnectGame$default3pfi1zzg9pgpr,
  startSandboxGame$default as startSandboxGame$defaultg40zqjy04pe6,
  CurrentAndOldStateHolderSimple as CurrentAndOldStateHolderSimple1681ghu28vpum,
  CurrentAndOldStateHolder as CurrentAndOldStateHolder3bqy5ulcjm8zl,
  BeastUserSettingValues as BeastUserSettingValues1awalw0b537gv,
  BeastUserSettingsPatch as BeastUserSettingsPatch1azd66vd7ktrk,
  ActiveGameSessions as ActiveGameSessions34jfg96df0ktg,
  BeastAuthenticationCapabilities as BeastAuthenticationCapabilities2l6x7ao3b52st,
  BeastClientConfiguration as BeastClientConfiguration1q00ciajuydzi,
  get_entries_5 as get_entries3j5h5c2c0yh6t,
  Success as Success1uwr7ypqp5n7,
  BeastLoginResult as BeastLoginResultz38bkdv62i03,
  BeastResourceLookupRequest as BeastResourceLookupRequestvc1aq5f9azrx,
  Authenticated as Authenticated1k16izbzywuc1,
  BeastSessionState as BeastSessionState2lxyj6p35g097,
  ClientLinks as ClientLinksxthcu9kzrmk2,
  CompletedGame as CompletedGame24rbxwso5h9gw,
  GameCode as GameCodew6y6zhq2wcqb,
  GamePresence as GamePresence3mddfrxug64dh,
  GameSessionReloadRequiredException as GameSessionReloadRequiredExceptionrlm8v4elghny,
  GameStarted as GameStartedizt21rsqpez9,
  values_13 as values3mdu86jyfb86y,
  Duel as Duel1tcmns9b4sqco,
  Replay as Replay2zkg7vntz6tyx,
  Sandbox as Sandbox19coq947eyfc7,
  InfoSourceCursor as InfoSourceCursor2c5o44ahzccir,
  LobbyList as LobbyList3vahn6xsy63bi,
  MasterFixingSupportingAgent as MasterFixingSupportingAgent3u14yuiuqy94,
  NotFoundSetupSession as NotFoundSetupSession2fi0jcpix5z9h,
  PendingReplayConsent as PendingReplayConsentzqvvvfrqpye1,
  PingBoardPositionElement as PingBoardPositionElement3jp6ants0c1vo,
  PingElement as PingElement29w3g0l8uh6ka,
  PingLocationTypeElement as PingLocationTypeElementywjrplr6ot1s,
  PingPlayableCardElement as PingPlayableCardElement2tburza8qxuwr,
  PingingSupport as PingingSupportni7c00aatics,
  QuestionDataToRestore as QuestionDataToRestore7nu221sx1nm6,
  ReconnectSandboxInit as ReconnectSandboxInitlrmvjd4l15ek,
  ReconnectSandboxPlaying as ReconnectSandboxPlaying17178inq9l5qg,
  SandboxGameWasCanceled as SandboxGameWasCanceled2nl70tvde70p0,
  ReconnectSandboxResult as ReconnectSandboxResult2qqhhm1ubtikg,
  ExceptionInReplaying as ExceptionInReplaying14asrtiz93hs1,
  GameIsEnded as GameIsEnded2jecydki34mwe,
  ReplaySharingStatus as ReplaySharingStatus26nfriwmr9i87,
  InternalRevertError as InternalRevertError2kax2xf0fyfgs,
  RequestRevertTurnResult as RequestRevertTurnResult1tg782ml2y54i,
  Resumed as Resumed2m0t3m7h42101,
  Terminal as Terminal38l09gyco2ri1,
  ResumeDuelGameResult as ResumeDuelGameResult1wgqp1tw8w1yi,
  RetainedResourceHandoff as RetainedResourceHandoff3pll0b3rqi74p,
  RevertResult as RevertResult1o7bp0ynmtbw4,
  RevertSupportingAgent as RevertSupportingAgent2za8f9p9lpp6u,
  ServerDrivenConfigurationTransparentException as ServerDrivenConfigurationTransparentException1fdsqb7291ke7,
  ServerDrivenConfiguration as ServerDrivenConfiguration1321dh2c0itx2,
  ServerDuelSetupGameData as ServerDuelSetupGameData2xlhmtkxgqzhf,
  Maintenance as Maintenance1ei8arz2p2x9n,
  ServerMessage as ServerMessage2o1t59ukliaye,
  SetupEnded as SetupEnded27wh719dvkgtt,
  SetupUpdateFromServer as SetupUpdateFromServer12nxqfl8delrq,
  SetupUpdate as SetupUpdate31qygov2ekgx1,
  get_canBeUsedForResume as get_canBeUsedForResume1refd7w2k1te6,
  get_canceledSessionInfoSourceCursor as get_canceledSessionInfoSourceCursor1tdcqmn494m1b,
  get_clientSetupOrNull as get_clientSetupOrNull24ih5m60r311v,
  displayText as displayText10ak5kx15v05p,
  get_incorrectServerStateInfoSourceCursor as get_incorrectServerStateInfoSourceCursor1wqascr3wc9rm,
  get_onboardingReplayCode as get_onboardingReplayCode205sqpfv0ig6i,
  get_quixoteTournamentGames as get_quixoteTournamentGameskkrf2cv2rg4y,
  get_terminalInfoSourceCursor as get_terminalInfoSourceCursor8s5m3nezendz,
  AdjustedSavedAnswer as AdjustedSavedAnswer1193xhmb1myfp,
  AnimationInsertion as AnimationInsertionlscydg2wjcsr,
  InitSandboxResult as InitSandboxResult3vrtfstrzby3t,
  LogicalAnimationInsertion as LogicalAnimationInsertionkobo11jcfxo,
  MapUiScalingAndPosition as MapUiScalingAndPosition2k3s7s83zg6ay,
  Dawn as Dawn15251dwb1cvog,
  Night as Night1uaxo2yue9zq5,
  Turn as Turn1jw0phk9n3bzf,
  SandboxGameManager as SandboxGameManager1l0vg1l6g6n12,
  SandboxInitApplyEventSuccessResult as SandboxInitApplyEventSuccessResult2qcp21d5sdzi,
  SandboxInitApplyEventResult as SandboxInitApplyEventResult23wxz17np7x8k,
  SandboxStartParams as SandboxStartParams25sblc3uw8123,
  ShowFromDraft as ShowFromDraft1q47jdcfdvgaf,
  ShowFromPossibleAnswer as ShowFromPossibleAnswer26qvl7hbxc2l1,
  ShowLocationAnimation as ShowLocationAnimation8r0phb0sqqsc,
  SimpleSavedAnswersSource as SimpleSavedAnswersSource1q6p7wrygyrx6,
  SandboxGameStarted as SandboxGameStartedwoow2knuxnsj,
  StartSandboxResult as StartSandboxResult3exx6b2ecj4s3,
  replayTimelineFromSavedAnswers as replayTimelineFromSavedAnswers2b1z3180sw5jq,
  replayTimeline as replayTimeline2mije5qj967dw,
  get_theLastAppliedMapUiScalingAndPosition as get_theLastAppliedMapUiScalingAndPosition36tc7xj0jrpsc,
  BeastGameI18n as BeastGameI18n27oawf53dbph6,
  defaultAnswer as defaultAnswer34nzhbo7sipew,
  AbilityCard as AbilityCardhe2jylhd819j,
  ActionStatement as ActionStatement1cnx41a7x8ztj,
  ActivateSnareStatement as ActivateSnareStatement1wruo5nt9idp,
  ActivateSummonsStatement as ActivateSummonsStatement2coksmlkd9lq4,
  ActivateTrapStatement as ActivateTrapStatementc2tmhrxm1c7b,
  AddObjectChange as AddObjectChange278kvdy0l1oj8,
  Akkeron as Akkeronx0mr6kdyywai,
  AncientPowerNumberQuestion as AncientPowerNumberQuestion3cdrapqw1ph4u,
  AncientPowersChangeEvent as AncientPowersChangeEventg9y239jenjid,
  AnimalType as AnimalType22lyi8vxi27kq,
  ApplyDamageEvent as ApplyDamageEvent1ksol0gohmdlc,
  ApplyingReactionStatement as ApplyingReactionStatements4puuyqhz01m,
  ArrivalOfTheTitanContract as ArrivalOfTheTitanContract13gi06ak50pdw,
  ArsenalCard as ArsenalCard1dzcx66vhdy8c,
  get_entries_2 as get_entries31bl1p047haec,
  AshRuinCard as AshRuinCard1xlfygy61t7p0,
  AshRuin as AshRuin9af1oplpyi1v,
  AshfallUnlikelyAllianceContract as AshfallUnlikelyAllianceContractnqvskokvowm3,
  AssignDamageEvent as AssignDamageEventbd1j3fwefeyf,
  AttackOnTheNorthernSettlementsContract as AttackOnTheNorthernSettlementsContractnljrx0wqj9l3,
  AttackStatement as AttackStatement2n5hixt2vwt0t,
  BarrierConnectedLocationQuestion as BarrierConnectedLocationQuestion2mxsuoje65g5h,
  BarrierSideType as BarrierSideType2l2klrjsko47h,
  get_entries_1 as get_entriesmnvhd7ghbgdn,
  BeastCharacter as BeastCharacter1uqk4ouyve4z0,
  get_entries_0 as get_entries3qv2ciyxxgr7x,
  BeastMovementCardQuestion as BeastMovementCardQuestion1j0j9jcqebpmg,
  BeastMovementCardVariant as BeastMovementCardVariant1uhqn86k5upnb,
  BeastMovementInfoChange as BeastMovementInfoChange24yaol0g17fut,
  BeastMovementStatement as BeastMovementStatement10g5ibipn3yne,
  BeastPathStep as BeastPathStep2a73znugzotom,
  BeastlyTalentCard as BeastlyTalentCard2sm6mvj831dxe,
  BoardPosition as BoardPositionsitk1ym6dh2p,
  BoatType as BoatType28zpq43km2292,
  Bolgin as Bolgin2aemms6gmbcjq,
  BooleanGameQuestion as BooleanGameQuestion1x6xc30ycsl8k,
  Bram as Bramm1nwrg7wamy0,
  BurstStatement as BurstStatement3hv5c5jnu34bn,
  CardApplyingScope as CardApplyingScope11xap9foibge3,
  CardPlayColorQuestion as CardPlayColorQuestion1njsep2xnid70,
  CardResolvingScope as CardResolvingScopeo6edtcb2em1t,
  CardsMoveChange as CardsMoveChange319naf3gzozo9,
  ChangeFeatheredKingRebornStatusEvent as ChangeFeatheredKingRebornStatusEvent3quauhy48i2pi,
  Character as Character3krewb5f2wgpd,
  ChargingUpgradeChangeEvent as ChargingUpgradeChangeEvent2ay3u09ue8job,
  ChargingUpgrade as ChargingUpgrade2ater9ebzgtog,
  CheckForDestroyEvent as CheckForDestroyEvent3d9009ucbvqzf,
  ChooseCardOnDraftQuestion as ChooseCardOnDraftQuestion3dw7wif1c6a1e,
  ChooseCardsQuestion as ChooseCardsQuestion236iunubwe5yh,
  ChooseCharacterQuestion as ChooseCharacterQuestion15prhcvmg0xx6,
  ChooseOneOfStatement as ChooseOneOfStatementtgfmlmn00b3t,
  ChooseSettlerForFlareScope as ChooseSettlerForFlareScope2cnw1lqs9yl4s,
  ClaimRuinEffectSource as ClaimRuinEffectSourcej1lo46onr4b5,
  ClaimRuinStatement as ClaimRuinStatement185uv9kkqwsfh,
  ClassicGameRules as ClassicGameRules33zhcezp3h11r,
  ClearingAfterRevealChange as ClearingAfterRevealChange15mu5ijozlp03,
  ComingArsenalPlace as ComingArsenalPlace1rmt4yby3260a,
  ContinueAfterRecoveryQuestion as ContinueAfterRecoveryQuestioniefkyt7x2a8e,
  ContractInitPhase as ContractInitPhasebbm6nkk1m701,
  ControllingActorWithTeam as ControllingActorWithTeam37tsri2skoun6,
  ControllingByTeam as ControllingByTeam2zv2dp917uply,
  DamageResolvedEvent as DamageResolvedEvent2i6m6cxbjj8ye,
  DamageToTarget as DamageToTargetrk1vyhkkkcr1,
  DawnPhase as DawnPhase1gkmlp1a4ffp0,
  DealingDamage as DealingDamage39kbnhy54vbsh,
  DestinationQuestion as DestinationQuestion3h9r448czxeoe,
  DestroyedChange as DestroyedChange21pxfb6dpt14f,
  DiscardPlace as DiscardPlace37wz47wxt9u59,
  DiscardToMoveVariant as DiscardToMoveVariant2dn9qapt834sf,
  DiscardToUseBoatVariant as DiscardToUseBoatVariant2oye4xzerue9s,
  DisperseCard as DisperseCard2qepgz4kjbldw,
  DisturbanceOfTheNorthernGodsContract as DisturbanceOfTheNorthernGodsContract2d99s2shgl3us,
  DraftActionCard as DraftActionCard2p0whed2o3gux,
  DraftOfferPlace as DraftOfferPlace1a6vns5kmwnyz,
  DraftPickedPlace as DraftPickedPlace2pm40ebjh07tk,
  DraftRemovedPlace as DraftRemovedPlace262eblh5g0ymj,
  DraftResultEvent as DraftResultEventzgyj0pnd4ilk,
  DraftStateEvent as DraftStateEvent1fq4tkme4t2vi,
  DraugCorruptionChangeEvent as DraugCorruptionChangeEvent2chzjiqztj3vy,
  Draug as Draug3ng4a642yl4k6,
  EffectRecoveryScope as EffectRecoveryScopehc0528dsuwxx,
  EffectsAfterEventScope as EffectsAfterEventScope2316n42q54x3,
  EggType as EggType3070m439nl235,
  EndOfGameEvent as EndOfGameEvent1sosaowh7mxa2,
  EngorgeCard as EngorgeCard1kl6oz4cn8a4g,
  EsmeriaBeast as EsmeriaBeast260au4fsv2p4h,
  EventTriggeredByEffectSourceScope as EventTriggeredByEffectSourceScope8k4kzzzjpklm,
  Fangrir as Fangrir1ysz7v8x50mvh,
  FarmerType as FarmerType33h0bg4h185y3,
  FeatheredKing as FeatheredKinggsja93p8bm4d,
  FireTrapCard as FireTrapCard3jejuv4t1n1tt,
  FlareCard as FlareCard36tx25o1tara1,
  FlickerCard as FlickerCard3guwxqqx674ba,
  GainBeastlyTalentStatement as GainBeastlyTalentStatement3j7e8qwncf3jm,
  GainDraugCorruptionEvent as GainDraugCorruptionEvent142c76w3im5rg,
  GainGrudgesEvent as GainGrudgesEvent2f9md6n75zqvn,
  GainLydanHarvestEvent as GainLydanHarvestEvent31un4l003o7sw,
  GainOpenArsenalCardEvent as GainOpenArsenalCardEvent1wkypt3doegkq,
  GainUnknownArsenalCardEvent as GainUnknownArsenalCardEvent16knnvhqpv4q6,
  GameContentVersion as GameContentVersion2in87ovmr1f1t,
  GameMapImpl as GameMapImpl781em8e77vw5,
  GameNotification as GameNotification1mpvi762l5m54,
  GamePhase as GamePhase4nnhltrkwx9,
  GameQuestionIsComingEvent as GameQuestionIsComingEvent1d9w5034cvxfd,
  GameQuestion as GameQuestion1nmeqeqr9sno8,
  GameRules as GameRules28rlrtrb6hjnd,
  GameScopesChangeEvent as GameScopesChangeEvent3ju8pn6l9637u,
  GameSetupState as GameSetupStatech68jqj7snwm,
  GameStateCheckCode as GameStateCheckCode2c81inh90t5wq,
  GameStateEvent as GameStateEvent30j2xc3zcxtea,
  GameTeam as GameTeamukq9bbth76rc,
  GameWarningEvent as GameWarningEvent2zcfmcsaq1i2r,
  GeneralCardMoveEvent as GeneralCardMoveEventp0piwr0iypgm,
  GrapnelQuestion as GrapnelQuestion2ejkh7zbeaiey,
  GreatCleansingContract as GreatCleansingContract1ehz34qbzlcov,
  GrudgesChange as GrudgesChange1hwnzcjnj3ggw,
  HandPlace as HandPlace2nuj4crujja2o,
  HealEvent as HealEvent1sec7vk747aui,
  Helga as Helgapgiytndle9pb,
  HiddenBeastMovement as HiddenBeastMovement2joofxxwmdb06,
  Hogbad as Hogbad1eky9nlnf1e9v,
  HpChange as HpChange1pdyid6siekap,
  HuntCard as HuntCard15h4e8elykc4g,
  HunterCharacter as HunterCharacter38ygd0hbflv64,
  HunterCompanionType as HunterCompanionType1i9iozl89tih6,
  HunterItemCard as HunterItemCard2be7jfoohe5k1,
  InAnyOrderStatement as InAnyOrderStatement3nhelwgdl08bc,
  InPlayPlace as InPlayPlace2jwkgqes0qnwm,
  InitGameStateEvent as InitGameStateEvent3t2iihh898bro,
  InitialPhase as InitialPhase39dki7vc6ulgd,
  Iona as Ionapl84deju72tb,
  ItselfGameScope as ItselfGameScopeixkmiax6rfu6,
  KillingSettlersClassicGameRules as KillingSettlersClassicGameRules3dmq0tt3d68ga,
  KnownCardsInfoChangeEvent as KnownCardsInfoChangeEvent3sv94itf1uqqr,
  LocationQuestionBase as LocationQuestionBase36b8zbqeeqjum,
  LocationQuestion as LocationQuestion3nq53tkbsl0bw,
  get_entries as get_entries2eem4mm272l8m,
  LocationTypeQuestion as LocationTypeQuestion1z8yhezyamvr0,
  LocationType as LocationType1qb6l9yeqv2lm,
  LydanHarvestChangeEvent as LydanHarvestChangeEvent2wsgg1f93atl7,
  Lydan as Lydan1m39xongr8vnb,
  Mara as Mara3nuuraz5dqcns,
  MoveCardToDiscardEvent as MoveCardToDiscardEvent29og51w3k7qb3,
  MovementChange as MovementChange19pzlthnrwra6,
  MovementEvent_0 as MovementEvent3rq8oh2k4k02t,
  MovementEvent as MovementEvent2k96wxlpbvifd,
  MovementToLocation as MovementToLocation3b1yqnpsrv3zb,
  NewSimpleObjectEvent as NewSimpleObjectEvent2xofhungb2zip,
  NightPhase as NightPhase3kd1qmzjhtveh,
  NightlyRewardScope as NightlyRewardScopet0984yjfmx8d,
  NobleType as NobleTypezfpyd57afrmz,
  ObjectMovementStatement as ObjectMovementStatementj19wgjylk9qc,
  ObjectOnBoardType as ObjectOnBoardType251o7nzihiu95,
  ObjectOnBoard as ObjectOnBoard26086xcy6gjq7,
  ObjectRemoveForReplacingEvent as ObjectRemoveForReplacingEventzckex55rv9kr,
  $serializer_165 as $serializer1lf613kx9k3vi,
  ObjectsGameQuestion as ObjectsGameQuestion2boxyklmnsg55,
  Omma as Omma3br73yc1t9rjd,
  OutpostCard as OutpostCard1ffzsar9gm9bf,
  OverloadedCard as OverloadedCard189aar9snn659,
  PactLongForgottenContract as PactLongForgottenContract1h5yqqqzlt7ev,
  PassVariant as PassVariantdfzww27calua,
  PerformForEachHunter as PerformForEachHunter19ocvyousvwzh,
  PhaseRecoveryQuestion as PhaseRecoveryQuestiono68nj60zs5zl,
  PhaseRecoveryScope as PhaseRecoveryScope2rec0tb2zj111,
  PlaceHatchlingWithInfestQuestion as PlaceHatchlingWithInfestQuestion1hmc3ecm88cyr,
  PlaceNewObjectQuestion as PlaceNewObjectQuestion2hcww1pm3bmd7,
  PlaceNewSummonStatement as PlaceNewSummonStatementeosdppc20njc,
  PlayCardInTurnQuestion as PlayCardInTurnQuestion1hww2zcmfisni,
  PlayCardVariant as PlayCardVariant161wiv7hcla9a,
  PlayOverloadedQuestion as PlayOverloadedQuestion3v4ahyk6t5705,
  PlayableCard as PlayableCard3pprsf907u3gl,
  PlayableInTurnCard as PlayableInTurnCard42ypiyt9kpf0,
  PlayerTurnPhase as PlayerTurnPhase3jebsnvqgqk4f,
  PolypType as PolypType33r525labzybw,
  PossibleMistShroudEffectSource as PossibleMistShroudEffectSource3appntjopbvbn,
  PossibleSnareEffectSource as PossibleSnareEffectSourcetosaj8s8us9u,
  PossibleTrapEffectSource as PossibleTrapEffectSourceys7r185zm215,
  PreGamePhase as PreGamePhase1lpc1yt5gf143,
  Raaga as Raaga2g4ue0crvpgfn,
  RageCard as RageCard29alys0oanyxv,
  ReactionCardTriggerEffectSource as ReactionCardTriggerEffectSourcetvvfmrch2yox,
  ReceiveSelfDamageStatement as ReceiveSelfDamageStatement26hkqlh9lf3q7,
  RecoveryTestBeastReaction as RecoveryTestBeastReaction1kwagmpmijvbt,
  RecoveryTestCard as RecoveryTestCard2j29wtcvm3zds,
  RecoveryTestConditionCard as RecoveryTestConditionCard1elvimztihpyq,
  RecoveryTestContract as RecoveryTestContract28bbvevats5p6,
  RecoveryTestForEachHunterStatement as RecoveryTestForEachHunterStatement2sx4cffup3gnr,
  RecoveryTestHunterReaction as RecoveryTestHunterReaction3oodngygstxnn,
  RecoveryTestStatement as RecoveryTestStatementhvrsvmszxsi3,
  RegentOfRuinsContract as RegentOfRuinsContract2uh5qhq408jfw,
  RelocationStep as RelocationStep3vrq1u0j5f80t,
  RelocationToSettlementStatement as RelocationToSettlementStatement334b0gc15d23z,
  RemoveUpgradeEvent as RemoveUpgradeEventar63xzq5wtut,
  ReplayIsFinishedEvent as ReplayIsFinishedEvent2n430pt3g6q9k,
  ReplayNotificationEvent as ReplayNotificationEventyrin55udv7ge,
  ReplayNotificationPlainText as ReplayNotificationPlainText23jr293j6g42c,
  RestoreArsenalEvent as RestoreArsenalEvent5a9kgyvy1983,
  RestoreStuffEvent as RestoreStuffEventgfbvhbkq5mvx,
  RevealBeastEvent as RevealBeastEvent1j7ikciugv30k,
  RevealLastMovementsChange as RevealLastMovementsChangeaetbg9ekii3o,
  RevealLastMovementsEvent as RevealLastMovementsEvent30p82wxlim6r6,
  RevealToMoveQuestion as RevealToMoveQuestion3jejh8jnus19n,
  RevealedArsenalPlace as RevealedArsenalPlace39rhzo8riphf9,
  RhagnerCard as RhagnerCard3u0r0iubs9h6q,
  RhagnerHoardChangeEvent as RhagnerHoardChangeEvent15e727qzym1dl,
  Rhagner as Rhagner3ir3yf8tt0g9y,
  RuinClaimedChangeEvent as RuinClaimedChangeEvent35w18jwxo6a44,
  SearchForBeastStatement as SearchForBeastStatementoiylf8xsp03m,
  SearchLocationQuestion as SearchLocationQuestion2ib0yfp46z7bp,
  SecretsFromALostAgeContract as SecretsFromALostAgeContract2wlj6eon17pbp,
  SetSnareMetadataChangeEvent as SetSnareMetadataChangeEvent2nngfb98rf27m,
  SetTrapEvent as SetTrapEvent3jphfp2n6c124,
  SettlerType as SettlerType3458v8k9hj1ql,
  ShipwreckContract as ShipwreckContractvhcr0iaqf5qa,
  SigridAbilityCard as SigridAbilityCard2jewmoyuedyv2,
  SigridPactChangeEvent as SigridPactChangeEventnrcfurixoo80,
  Sigrid as Sigrid3d5n0kj6cswml,
  SimpleBeastMovementStatement as SimpleBeastMovementStatement3aqths0sbkqim,
  SimpleObjectType as SimpleObjectType2txv1j3swnokh,
  SmokeBombCard as SmokeBombCard3qyzfh70i7qlq,
  SnareTokenType as SnareTokenTypenh9kgwqcjez7,
  get_entries_3 as get_entries3qy97tw50smvt,
  SnareTypeQuestion as SnareTypeQuestion3gp1wpngxoqkh,
  SpendGrudgesEvent as SpendGrudgesEvent1jh4fpetxg74v,
  SpendLydanHarvestQuestion as SpendLydanHarvestQuestion1zfcwnkevgsnd,
  SpendValdiBloodQuestion as SpendValdiBloodQuestion200psr5oz6oqw,
  StartOfDayPhase as StartOfDayPhase1wag7duwxz8be,
  StartPhaseEvent as StartPhaseEvent16kv7wan6gsti,
  StartResolveCardEvent as StartResolveCardEvent204obdiuwrl30,
  StatementQuestion as StatementQuestion1lxt2f1cnz3ov,
  SubmitDamageEvent as SubmitDamageEventvqtjysdjmffa,
  SummonSignStatement as SummonSignStatement1zd9rsibb55e3,
  SummonType as SummonType2u4y5qg04ptyg,
  TechnicalGameStateChangeEvent as TechnicalGameStateChangeEventzmo2jun5l9vf,
  TextItselfGameScope as TextItselfGameScope3j2g5tkltixzt,
  Thalduk as Thalduk1o6n5dtg7k8w1,
  TrackCard as TrackCard1gemj30o7zpkp,
  TrailsRevealedChange as TrailsRevealedChange19a0704imq1zq,
  TrailsRevealedEvent as TrailsRevealedEvent119ggsxe5h312,
  TransformLocationQuestion as TransformLocationQuestion1tv0p4ejdq4vl,
  TransformLocationsChange as TransformLocationsChange2j3lp2mexkv5e,
  TransformLocationsEvent as TransformLocationsEvent1scwjttf6r1c6,
  TransformSimpleObjectChangeEvent as TransformSimpleObjectChangeEvent14cfif3i7bfn5,
  TrapByNumberQuestion as TrapByNumberQuestion2bnfeidyvay5a,
  TrapCard as TrapCard396b5rurkq1ij,
  TrapZonePlace as TrapZonePlace33435udmwai9n,
  TriggerOption as TriggerOption2pgl0oruzacgq,
  TriggersQuestion as TriggersQuestionesdw70q2hiv1,
  UnknownCard as UnknownCard2e53k57p6pyog,
  UnleashingTheAbyssContract as UnleashingTheAbyssContract2mi9ncftoxq8b,
  UnlikelyAllianceContract as UnlikelyAllianceContractmj9fxfufng2n,
  UnusedDraftActionCardPlace as UnusedDraftActionCardPlace3pw0vv13ylf81,
  UpgradeChange as UpgradeChange27frns3779qmd,
  UpgradeEvent as UpgradeEvent32qat54v0z8iw,
  UpgradeQuestion as UpgradeQuestion1yilwq9twob5k,
  UrgullMoltCounterChangeEvent as UrgullMoltCounterChangeEventxjeeomb22655,
  UrgullMoltEggsToReturnQuestion as UrgullMoltEggsToReturnQuestionn32b555is0iq,
  Urgull as Urgull14bymagpm5zhk,
  UseVackerSoulsQuestion as UseVackerSoulsQuestion3f8ph15lill3r,
  Vacker as Vacker2dbhyn0l3t8gh,
  ValdiBloodChangeEvent as ValdiBloodChangeEventcefi38h24p9e,
  Valdi as Valdip1yeojjk8cqk,
  Varja as Varja3v3kktzudcxc9,
  WatchtowerType as WatchtowerType3n9ika29zft6b,
  ZoneQuestion as ZoneQuestion1169zovvoqch5,
  get_activeRuinPositions as get_activeRuinPositions2ki1ytkqnd4d3,
  get_activeSouls as get_activeSouls2umaut8f7g41p,
  get_aliveBeasts as get_aliveBeastsjroki3mewg6w,
  get_aliveHunters as get_aliveHunters2br5806nqjy4d,
  get_allAliveAndDestroyedObjects as get_allAliveAndDestroyedObjectsjr32nk0g2rm3,
  get_allBoats as get_allBoats3s3ys2y5nhkd5,
  get_allHunters as get_allHunters6f2oagp44xgv,
  get_allSnaresOnMap as get_allSnaresOnMap1q4vx1fc5qdr1,
  get_allWatchtowers as get_allWatchtowers12ow0abuqxf59,
  get_ancientPowerNumber as get_ancientPowerNumber37fr4tjx316p1,
  get_anotherTeam as get_anotherTeamutq24fcfkdxz,
  anyAdjacentPositions as anyAdjacentPositions3dmbyldstbpd0,
  get_anyGameTeamMarker as get_anyGameTeamMarker2imsc9ntunywg,
  applyAllChanges as applyAllChanges38fbuwnf838ci,
  apply as applytwfxifc6ncun,
  get_armor as get_armor3nlhdsrxq6kko,
  get_arsenalType as get_arsenalType1qrfd4hudz0ix,
  availableBeasts as availableBeasts7ht1uscvapvp,
  availableHunters as availableHunters2hbxoiz7l702d,
  get_beastMovements as get_beastMovements2v63x4co93x8o,
  get_beastPath as get_beastPath1rk9ruz7s55jx,
  get_beastsGameTeam as get_beastsGameTeam1y1bdmzuny63m,
  get_bolginBeast as get_bolginBeast1wicfe2k50uar,
  calculateCheckCode as calculateCheckCode2pl8736fah0hq,
  get_charactersInOrder as get_charactersInOrder24hmg1035jqha,
  get_charged as get_chargedrtnmfyqtzipz,
  get_currentControllingActor as get_currentControllingActoroj43490lha6t,
  get_currentControllingTeam as get_currentControllingTeammrvmv09flsoh,
  get_currentDayNumber as get_currentDayNumber3ti9bsc9tdlne,
  get_currentTurnNumber as get_currentTurnNumberh1xt6wcogwmf,
  direction as direction28a381npiuq8u,
  get_discardedAbilityCards as get_discardedAbilityCards2lgm76btfolpt,
  get_draugCorruptionLevel as get_draugCorruptionLevel1xfp6vt0i1e2d,
  get_draugWillRespawn as get_draugWillRespawn36hp3zlssxv21,
  get_drenchedLandsMap as get_drenchedLandsMapoob5465oeezj,
  get_featheredKingBeast as get_featheredKingBeast3ds5cujqs9d2j,
  forBeast as forBeast2v94z7eg8vrvp,
  get_foundTrails as get_foundTrails39zuttqc7mve9,
  get_fullArsenalDeck as get_fullArsenalDeck1z5yb8ce5gwuf,
  get_fullObserverGameTeamMarker as get_fullObserverGameTeamMarker14m9rs3amysry,
  get_gameContentVersion as get_gameContentVersion1sb5b1ke1q3q5,
  get_gameRules as get_gameRules1liejcou7uyku,
  get_gameScopes as get_gameScopes2i9ao2ct38ate,
  get_gameTeam as get_gameTeam2n0lwzk003zju,
  getBeastTalentCardDeck as getBeastTalentCardDeck16ah5hukb8dpj,
  getDraftActionCardDeck as getDraftActionCardDeckru9elefunceo,
  getHunterItemCardDeck as getHunterItemCardDeck1n7thpi2l0ho,
  get_grudgesNumber as get_grudgesNumberemxuaukf6ake,
  get_hand as get_hand3l0uqiz1oyo3x,
  get_hazePositions as get_hazePositionsomol4lef56yz,
  get_helgaHunter as get_helgaHunter3o73ghj9up41g,
  hoardLevel as hoardLevel2yd0h3d12kz93,
  get_hp as get_hp5i5yy7amjofz,
  get_huntersGameTeam as get_huntersGameTeamiqiqxeugntgm,
  get_ionaHunter as get_ionaHunter1aexy6rx5u8b0,
  isActiveCharacter as isActiveCharacter1iqi5h29m2d7v,
  get_isAliveType as get_isAliveType7jtvbe6xddjq,
  get_isDead as get_isDead38rur7mguay67,
  get_isHidden as get_isHidden25d33ee7ol8iu,
  get_isObserver as get_isObserver1kfscec5yzvwu,
  get_isReborn as get_isRebornms8euzeh4o9v,
  get_isReplayOpenGame as get_isReplayOpenGame12931rjijwgm8,
  get_isRevealed as get_isRevealed1yvfqt0zljrxx,
  get_lastSeenPosition as get_lastSeenPosition1bmb9emrfxren,
  get_locationType as get_locationType1iwvq3c1f588i,
  get_lowerShatteredIslesMap as get_lowerShatteredIslesMap1edqmk7dc1qwc,
  get_lydanHarvest as get_lydanHarvest5icslm7ws8fu,
  get_maxTrapsInZone as get_maxTrapsInZonet3h7ldp564ls,
  get_mesmerizedHunter as get_mesmerizedHuntervr8fdrybqjgt,
  get_nearbyPositions as get_nearbyPositions3w7xiiozyhnb,
  get_northernExpanseMap as get_northernExpanseMap1aduyn0miqdi7,
  get_objectType as get_objectType3emg51nk00g59,
  objectsAt as objectsAt1wc3nedu6wl0q,
  get_observerGameTeamMarker as get_observerGameTeamMarker1qs5fpmrf9k41,
  outpostEvent as outpostEventsrrk6vtwwj2p,
  pactTerrain as pactTerrain1a6opylccrt4c,
  get_phase as get_phase19xfr6wqyjp6q,
  get_place as get_place1e3pq2ygsurlg,
  get_playedCardsNumber as get_playedCardsNumber1epqlr3nueavd,
  get_possibleTrailMaxCounts as get_possibleTrailMaxCounts28c1al5n7y681,
  get_primaryLocations as get_primaryLocations1gsr9lpfypqai,
  get_regentBeastDominion as get_regentBeastDominion2ddqq8n0pikrs,
  get_regentHunterDominion as get_regentHunterDominion2eyw5jcfvrosx,
  get_remainMoltEggsOnCounter as get_remainMoltEggsOnCounter1876m25lbah7q,
  reportWarning as reportWarning2za12zxcfzdkq,
  get_revision as get_revision1galai6fn5pio,
  get_rhagnerBeast as get_rhagnerBeast29f8i1pwhuu9c,
  get_rhagnerHoardLevels as get_rhagnerHoardLevels208363hg8hv74,
  get_sharedBeastWounds as get_sharedBeastWounds3obm55vwm9wbk,
  get_snareType as get_snareType1ik2geux83au9,
  summonsOnMap as summonsOnMap2jrlywmkxceyb,
  get_trapPositions as get_trapPositions2uuqt6g008o2u,
  get_upgraded as get_upgradedfcwwucgzg7oz,
  get_upperShatteredIslesMap as get_upperShatteredIslesMap25cel880pe8pl,
  get_urgullBeast as get_urgullBeastoxtbjmyn6c1z,
  get_valdiBlood as get_valdiBlood22b7tn918k79i,
  get_varjaHunter as get_varjaHunterobdiv7ofixj0,
  withDiagnostics as withDiagnostics2iqjuui3sgjwn,
  withGameContentVersion as withGameContentVersion96x7zrrhnbg7,
  withStateRuntime_0 as withStateRuntimew7ff1nikw1ne,
  withStateRuntime as withStateRuntime2d9i5e0jyf3jd,
  get_wounds as get_woundsy66mfxvlb27u,
  get_JsonFormat as get_JsonFormat2dpsvlhx9egj5,
  get as get12zahk941o61v,
  splitCamelCase as splitCamelCase139v8b5swfsah,
};
//endregion
